
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("jaOzc", function(module, exports) {

$parcel$export(module.exports, "Entity", () => Entity);
$parcel$export(module.exports, "cmp", () => cmp);
$parcel$export(module.exports, "PropModSymbol", () => PropModSymbol);
$parcel$export(module.exports, "PropModification", () => PropModification);
$parcel$export(module.exports, "Dexie", () => Dexie$1);
$parcel$export(module.exports, "RangeSet", () => RangeSet);
$parcel$export(module.exports, "mergeRanges", () => mergeRanges);
$parcel$export(module.exports, "rangesOverlap", () => rangesOverlap);
$parcel$export(module.exports, "liveQuery", () => liveQuery);
$parcel$export(module.exports, "add", () => add);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replacePrefix", () => replacePrefix);
$parcel$export(module.exports, "default", () => Dexie$1);
/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.0.10, Fri Nov 15 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var _global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var keys = Object.keys;
var isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !_global.Promise) _global.Promise = Promise;
function extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var getProto = Object.getPrototypeOf;
var _hasOwn = {}.hasOwnProperty;
function hasOwn(obj, prop) {
    return _hasOwn.call(obj, prop);
}
function props(proto, extension) {
    if (typeof extension === 'function') extension = extension(getProto(proto));
    (typeof Reflect === "undefined" ? keys : Reflect.ownKeys)(extension).forEach(function(key) {
        setProp(proto, key, extension[key]);
    });
}
var defineProperty = Object.defineProperty;
function setProp(obj, prop, functionOrGetSet, options) {
    defineProperty(obj, prop, extend(functionOrGetSet && hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            setProp(Child.prototype, "constructor", Child);
            return {
                extend: props.bind(null, Child.prototype)
            };
        }
    };
}
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function getPropertyDescriptor(obj, prop) {
    var pd = getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = getProto(obj)) && getPropertyDescriptor(proto, prop);
}
var _slice = [].slice;
function slice(args, start, end) {
    return _slice.call(args, start, end);
}
function override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function asap$1(fn) {
    if (_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if (isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if (isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        setByKeyPath(obj, kp, undefined);
    });
}
function shallowClone(obj) {
    var rv = {};
    for(var m in obj)if (hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var concat = [].concat;
function flatten(a) {
    return concat.apply([], a);
}
var intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat(flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return _global[t];
});
var intrinsicTypes = new Set(intrinsicTypeNames.map(function(t) {
    return _global[t];
}));
function cloneSimpleObjectTree(o) {
    var rv = {};
    for(var k in o)if (hasOwn(o, k)) {
        var v = o[k];
        rv[k] = !v || typeof v !== 'object' || intrinsicTypes.has(v.constructor) ? v : cloneSimpleObjectTree(v);
    }
    return rv;
}
function objectIsEmpty(o) {
    for(var k in o)if (hasOwn(o, k)) return false;
    return true;
}
var circularRefs = null;
function deepClone(any) {
    circularRefs = new WeakMap();
    var rv = innerDeepClone(any);
    circularRefs = null;
    return rv;
}
function innerDeepClone(x) {
    if (!x || typeof x !== 'object') return x;
    var rv = circularRefs.get(x);
    if (rv) return rv;
    if (isArray(x)) {
        rv = [];
        circularRefs.set(x, rv);
        for(var i = 0, l = x.length; i < l; ++i)rv.push(innerDeepClone(x[i]));
    } else if (intrinsicTypes.has(x.constructor)) rv = x;
    else {
        var proto = getProto(x);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        circularRefs.set(x, rv);
        for(var prop in x)if (hasOwn(x, prop)) rv[prop] = innerDeepClone(x[prop]);
    }
    return rv;
}
var toString = {}.toString;
function toStringTag(o) {
    return toString.call(o).slice(8, -1);
}
var iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var getIteratorOf = typeof iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
function delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
}
var NO_CHAR_ARRAY = {};
function getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if (isArray(arrayLike)) return arrayLike.slice();
        if (this === NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var isAsyncFunction = typeof Symbol !== 'undefined' ? function(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var errorList = dexieErrorNames.concat(idbDomErrorNames);
var defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function DexieError(name, msg) {
    this.name = name;
    this.message = msg;
}
derive(DexieError).from(Error).extend({
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = getMultiErrorMessage(msg, failures);
}
derive(ModifyError).from(DexieError);
function BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = getMultiErrorMessage(msg, this.failures);
}
derive(BulkError).from(DexieError);
var errnames = errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var BaseException = DexieError;
var exceptions = errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this.name = fullName;
        if (!msgOrInner) {
            this.message = defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "".concat(msgOrInner).concat(!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
            this.inner = msgOrInner;
        }
    }
    derive(DexieError).from(BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
exceptions.Syntax = SyntaxError;
exceptions.Type = TypeError;
exceptions.Range = RangeError;
var exceptionMap = idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = exceptions[name];
    return obj;
}, {});
function mapError(domError, message) {
    if (!domError || domError instanceof DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !exceptionMap[domError.name]) return domError;
    var rv = new exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var fullNameExceptions = errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = exceptions[name];
    return obj;
}, {});
fullNameExceptions.ModifyError = ModifyError;
fullNameExceptions.DexieError = DexieError;
fullNameExceptions.BulkError = BulkError;
function nop() {}
function mirror(val) {
    return val;
}
function pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function hookCreatingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function hookDeletingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    };
}
function hookUpdatingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : extend(res, res2);
    };
}
function reverseStoppableEventChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function promisableChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function setDebug(value, filter) {
    debug = value;
}
var INTERNAL = {};
var ZONE_ECHO_LIMIT = 100, _a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        getProto(nativeP),
        globalP
    ];
}(), resolvedNativePromise = _a$1[0], nativePromiseProto = _a$1[1], resolvedGlobalPromise = _a$1[2], nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
var NativePromise = resolvedNativePromise && resolvedNativePromise.constructor;
var patchGlobalPromise = !!resolvedGlobalPromise;
function schedulePhysicalTick() {
    queueMicrotask(physicalTick);
}
var asap = function(callback, args) {
    microtickQueue.push([
        callback,
        args
    ]);
    if (needsNewPhysicalTick) {
        schedulePhysicalTick();
        needsNewPhysicalTick = false;
    }
};
var isOutsideMicroTick = true, needsNewPhysicalTick = true, unhandledErrors = [], rejectingErrors = [], rejectionMapper = mirror;
var globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: nop,
    pgp: false,
    env: {},
    finalize: nop
};
var PSD = globalPSD;
var microtickQueue = [];
var numScheduledCalls = 0;
var tickFinalizers = [];
function DexiePromise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this._lib = false;
    var psd = this._PSD = PSD;
    if (typeof fn !== 'function') {
        if (fn !== INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    executePromiseTask(this, fn);
}
var thenProp = {
    get: function() {
        var psd = PSD, microTaskId = totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
            var cleanup = possibleAwait && !decrementExpectedAwaits();
            var rv = new DexiePromise(function(resolve, reject) {
                propagateToListener(_this, new Listener(nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            if (this._consoleTask) rv._consoleTask = this._consoleTask;
            return rv;
        }
        then.prototype = INTERNAL;
        return then;
    },
    set: function(value) {
        setProp(this, 'then', value && value.prototype === INTERNAL ? thenProp : {
            get: function() {
                return value;
            },
            set: thenProp.set
        });
    }
};
props(DexiePromise.prototype, {
    then: thenProp,
    _then: function(onFulfilled, onRejected) {
        propagateToListener(this, new Listener(null, null, onFulfilled, onRejected, PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            return DexiePromise.resolve(onFinally()).then(function() {
                return value;
            });
        }, function(err) {
            return DexiePromise.resolve(onFinally()).then(function() {
                return PromiseReject(err);
            });
        });
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) setProp(DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
globalPSD.env = snapShot();
function Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
props(DexiePromise, {
    all: function() {
        var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof DexiePromise) return value;
        if (value && typeof value.then === 'function') return new DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new DexiePromise(INTERNAL, true, value);
        return rv;
    },
    reject: PromiseReject,
    race: function() {
        var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return PSD;
        },
        set: function(value) {
            return PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return totalEchoes;
        }
    },
    newPSD: newScope,
    usePSD: usePSD,
    scheduler: {
        get: function() {
            return asap;
        },
        set: function(value) {
            asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return rejectionMapper;
        },
        set: function(value) {
            rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new DexiePromise(function(resolve, reject) {
            return newScope(function(resolve, reject) {
                var psd = PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = callBoth(function() {
                    var _this = this;
                    run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if (NativePromise) {
    if (NativePromise.allSettled) setProp(DexiePromise, "allSettled", function() {
        var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if (NativePromise.any && typeof AggregateError !== 'undefined') setProp(DexiePromise, "any", function() {
        var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
    if (NativePromise.withResolvers) DexiePromise.withResolvers = NativePromise.withResolvers;
}
function executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && beginMicroTickScope();
            if (value && typeof value.then === 'function') executePromiseTask(promise, function(resolve, reject) {
                value instanceof DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                propagateAllListeners(promise);
            }
            if (shouldExecuteTick) endMicroTickScope();
        }, handleRejection.bind(null, promise));
    } catch (ex) {
        handleRejection(promise, ex);
    }
}
function handleRejection(promise, reason) {
    rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && beginMicroTickScope();
    reason = rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    addPossiblyUnhandledError(promise);
    propagateAllListeners(promise);
    if (shouldExecuteTick) endMicroTickScope();
}
function propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if (numScheduledCalls === 0) {
        ++numScheduledCalls;
        asap(function() {
            if (--numScheduledCalls === 0) finalizePhysicalTick();
        }, []);
    }
}
function propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++numScheduledCalls;
    asap(callListener, [
        cb,
        promise,
        listener
    ]);
}
function callListener(cb, promise, listener) {
    try {
        var ret, value = promise._value;
        if (!promise._state && rejectingErrors.length) rejectingErrors = [];
        ret = debug && promise._consoleTask ? promise._consoleTask.run(function() {
            return cb(value);
        }) : cb(value);
        if (!promise._state && rejectingErrors.indexOf(value) === -1) markErrorAsHandled(promise);
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        if (--numScheduledCalls === 0) finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function physicalTick() {
    usePSD(globalPSD, function() {
        beginMicroTickScope() && endMicroTickScope();
    });
}
function beginMicroTickScope() {
    var wasRootExec = isOutsideMicroTick;
    isOutsideMicroTick = false;
    needsNewPhysicalTick = false;
    return wasRootExec;
}
function endMicroTickScope() {
    var callbacks, i, l;
    do while(microtickQueue.length > 0){
        callbacks = microtickQueue;
        microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while (microtickQueue.length > 0);
    isOutsideMicroTick = true;
    needsNewPhysicalTick = true;
}
function finalizePhysicalTick() {
    var unhandledErrs = unhandledErrors;
    unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
    }
    tickFinalizers.push(finalizer);
    ++numScheduledCalls;
    asap(function() {
        if (--numScheduledCalls === 0) finalizePhysicalTick();
    }, []);
}
function addPossiblyUnhandledError(promise) {
    if (!unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) unhandledErrors.push(promise);
}
function markErrorAsHandled(promise) {
    var i = unhandledErrors.length;
    while(i)if (unhandledErrors[--i]._value === promise._value) {
        unhandledErrors.splice(i, 1);
        return;
    }
}
function PromiseReject(reason) {
    return new DexiePromise(INTERNAL, false, reason);
}
function wrap(fn, errorCatcher) {
    var psd = PSD;
    return function() {
        var wasRootExec = beginMicroTickScope(), outerScope = PSD;
        try {
            switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            switchToZone(outerScope, false);
            if (wasRootExec) endMicroTickScope();
        }
    };
}
var task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var taskCounter = 0;
var zoneStack = [];
var zoneEchoes = 0;
var totalEchoes = 0;
var zone_id_counter = 0;
function newScope(fn, props, a1, a2) {
    var parent = PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++zone_id_counter;
    globalPSD.env;
    psd.env = patchGlobalPromise ? {
        Promise: DexiePromise,
        PromiseProp: {
            value: DexiePromise,
            configurable: true,
            writable: true
        },
        all: DexiePromise.all,
        race: DexiePromise.race,
        allSettled: DexiePromise.allSettled,
        any: DexiePromise.any,
        resolve: DexiePromise.resolve,
        reject: DexiePromise.reject
    } : {};
    if (props) extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function incrementExpectedAwaits() {
    if (!task.id) task.id = ++taskCounter;
    ++task.awaits;
    task.echoes += ZONE_ECHO_LIMIT;
    return task.id;
}
function decrementExpectedAwaits() {
    if (!task.awaits) return false;
    if (--task.awaits === 0) task.id = 0;
    task.echoes = task.awaits * ZONE_ECHO_LIMIT;
    return true;
}
if (('' + nativePromiseThen).indexOf('[native code]') === -1) incrementExpectedAwaits = decrementExpectedAwaits = nop;
function onPossibleParallellAsync(possiblePromise) {
    if (task.echoes && possiblePromise && possiblePromise.constructor === NativePromise) {
        incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            decrementExpectedAwaits();
            return x;
        }, function(e) {
            decrementExpectedAwaits();
            return rejection(e);
        });
    }
    return possiblePromise;
}
function zoneEnterEcho(targetZone) {
    ++totalEchoes;
    if (!task.echoes || --task.echoes === 0) task.echoes = task.awaits = task.id = 0;
    zoneStack.push(PSD);
    switchToZone(targetZone, true);
}
function zoneLeaveEcho() {
    var zone = zoneStack[zoneStack.length - 1];
    zoneStack.pop();
    switchToZone(zone, false);
}
function switchToZone(targetZone, bEnteringZone) {
    var currentZone = PSD;
    if (bEnteringZone ? task.echoes && (!zoneEchoes++ || targetZone !== PSD) : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)) queueMicrotask(bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho);
    if (targetZone === PSD) return;
    PSD = targetZone;
    if (currentZone === globalPSD) globalPSD.env = snapShot();
    if (patchGlobalPromise) {
        var GlobalPromise = globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty(_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise.any = targetEnv.any;
        }
    }
}
function snapShot() {
    var GlobalPromise = _global.Promise;
    return patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject
    } : {};
}
function usePSD(psd, fn, a1, a2, a3) {
    var outerScope = PSD;
    try {
        switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        switchToZone(outerScope, false);
    }
}
function nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = PSD;
        if (possibleAwait) incrementExpectedAwaits();
        switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            switchToZone(outerZone, false);
            if (cleanup) queueMicrotask(decrementExpectedAwaits);
        }
    };
}
function execInGlobalContext(cb) {
    if (Promise === NativePromise && task.echoes === 0) {
        if (zoneEchoes === 0) cb();
        else enqueueNativeMicroTask(cb);
    } else setTimeout(cb, 0);
}
var rejection = DexiePromise.reject;
function tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._state.autoOpen) return rejection(new exceptions.DatabaseClosed());
            db.open().catch(nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return tempTransaction(db, mode, storeNames, fn);
                });
            }
            return rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return newScope(function() {
                PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            if (mode === 'readwrite') try {
                trans.idbtrans.commit();
            } catch (_a) {}
            return mode === 'readonly' ? result : trans._completion.then(function() {
                return result;
            });
        });
    }
}
var DEXIE_VERSION = '4.0.10';
var maxString = String.fromCharCode(65535);
var minKey = -Infinity;
var INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var STRING_EXPECTED = "String expected.";
var connections = [];
var DBNAMES_DB = '__dbnames';
var READONLY = 'readonly';
var READWRITE = 'readwrite';
function combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
function Entity() {
    throw exceptions.Type();
}
function cmp(a, b) {
    try {
        var ta = type(a);
        var tb = type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return compareUint8Arrays(getUint8Array(a), getUint8Array(b));
            case 'Array':
                return compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function type(x) {
    var t = typeof x;
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || PSD.trans;
        var tableName = this.name;
        var task = debug && typeof console !== 'undefined' && console.createTask && console.createTask("Dexie: ".concat(mode === 'readonly' ? 'read' : 'write', " ").concat(this.name));
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = beginMicroTickScope();
        try {
            var p = trans && trans.db._novip === this.db._novip ? trans === PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: PSD.transless || PSD
            }) : tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
            if (task) {
                p._consoleTask = task;
                p = p.catch(function(err) {
                    console.trace(err);
                    return rejection(err);
                });
            }
            return p;
        } finally{
            if (wasRootExec) endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        if (keyOrCrit == null) return rejection(new exceptions.Type("Invalid argument to Table.get()"));
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if (isArray(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join('+'), "]"));
        var keyPaths = keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join('+'), "]"));
        var idxByName = this.schema.idxByName;
        function equals(a, b) {
            return cmp(a, b) === 0;
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = getByKeyPath(x, keyPath);
                    return isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, isArray(index) ? "[".concat(index.join('+'), "]") : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        var _a = this, db = _a.db, tableName = _a.name;
        this.schema.mappedClass = constructor;
        if (constructor.prototype instanceof Entity) constructor = function(_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(class_1.prototype, "db", {
                get: function() {
                    return db;
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.table = function() {
                return tableName;
            };
            return class_1;
        }(constructor);
        var inheritedProps = new Set();
        for(var proto = constructor.prototype; proto; proto = getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
            return inheritedProps.add(propName);
        });
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if (!inheritedProps.has(m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === 'object' && !isArray(keyOrObject)) {
            var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return rejection(new exceptions.InvalidArgument("Given object does not contain its primary key"));
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkUpdate = function(keysAndChanges) {
        var _this = this;
        var coreTable = this.core;
        var keys = keysAndChanges.map(function(entry) {
            return entry.key;
        });
        var changeSpecs = keysAndChanges.map(function(entry) {
            return entry.changes;
        });
        var offsetMap = [];
        return this._trans('readwrite', function(trans) {
            return coreTable.getMany({
                trans: trans,
                keys: keys,
                cache: 'clone'
            }).then(function(objs) {
                var resultKeys = [];
                var resultObjs = [];
                keysAndChanges.forEach(function(_a, idx) {
                    var key = _a.key, changes = _a.changes;
                    var obj = objs[idx];
                    if (obj) {
                        for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                            var keyPath = _b[_i];
                            var value = changes[keyPath];
                            if (keyPath === _this.schema.primKey.keyPath) {
                                if (cmp(value, key) !== 0) throw new exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                            } else setByKeyPath(obj, keyPath, value);
                        }
                        offsetMap.push(idx);
                        resultKeys.push(key);
                        resultObjs.push(obj);
                    }
                });
                var numEntries = resultKeys.length;
                return coreTable.mutate({
                    trans: trans,
                    type: 'put',
                    keys: resultKeys,
                    values: resultObjs,
                    updates: {
                        keys: keys,
                        changeSpecs: changeSpecs
                    }
                }).then(function(_a) {
                    var numFailures = _a.numFailures, failures = _a.failures;
                    if (numFailures === 0) return numEntries;
                    for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                        var offset = _b[_i];
                        var mappedOffset = offsetMap[Number(offset)];
                        if (mappedOffset != null) {
                            var failure = failures[offset];
                            delete failures[offset];
                            failures[mappedOffset] = failure;
                        }
                    }
                    throw new BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                });
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
        });
    };
    return Table;
}();
function Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if (isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function makeClassConstructor(prototype, constructor) {
    derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function createTableConstructor(db) {
    return makeClassConstructor(Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : Events(null, {
            "creating": [
                hookCreatingChain,
                nop
            ],
            "reading": [
                pureFunctionChain,
                mirror
            ],
            "updating": [
                hookUpdatingChain,
                nop
            ],
            "deleting": [
                hookDeletingChain,
                nop
            ]
        });
    });
}
function isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function addFilter(ctx, fn) {
    ctx.filter = combine(ctx.filter, fn);
}
function addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function addMatchFilter(ctx, fn) {
    ctx.isMatch = combine(ctx.isMatch, fn);
}
function getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function openCursor(ctx, coreTable, trans) {
    var index = getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return iterate(openCursor(ctx, coreTable, coreTrans), combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            iterate(openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = nop;
            }, function(e) {
                cursor.fail(e);
                c = nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
var PropModSymbol = Symbol();
var PropModification = function() {
    function PropModification(spec) {
        Object.assign(this, spec);
    }
    PropModification.prototype.execute = function(value) {
        var _a;
        if (this.add !== undefined) {
            var term = this.add;
            if (isArray(term)) return __spreadArray(__spreadArray([], isArray(value) ? value : [], true), term, true).sort();
            if (typeof term === 'number') return (Number(value) || 0) + term;
            if (typeof term === 'bigint') try {
                return BigInt(value) + term;
            } catch (_b) {
                return BigInt(0) + term;
            }
            throw new TypeError("Invalid term ".concat(term));
        }
        if (this.remove !== undefined) {
            var subtrahend_1 = this.remove;
            if (isArray(subtrahend_1)) return isArray(value) ? value.filter(function(item) {
                return !subtrahend_1.includes(item);
            }).sort() : [];
            if (typeof subtrahend_1 === 'number') return Number(value) - subtrahend_1;
            if (typeof subtrahend_1 === 'bigint') try {
                return BigInt(value) - subtrahend_1;
            } catch (_c) {
                return BigInt(0) - subtrahend_1;
            }
            throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
        }
        var prefixToReplace = (_a = this.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
        if (prefixToReplace && typeof value === 'string' && value.startsWith(prefixToReplace)) return this.replacePrefix[1] + value.substring(prefixToReplace.length);
        return value;
    };
    return PropModification;
}();
var Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if (isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return cmp(aVal, bVal) * order;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if (isPlainKeyRange(ctx)) addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else {
                var keyPaths = keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i];
                        var val = changes[keyPath];
                        var origVal = getByKeyPath(item, keyPath);
                        if (val instanceof PropModification) {
                            setByKeyPath(item, keyPath, val.execute(origVal));
                            anythingModified = true;
                        } else if (origVal !== val) {
                            setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = 200;
            var modifyChunkSize = _this.db._options.modifyChunkSize;
            if (modifyChunkSize) {
                if (typeof modifyChunkSize == 'object') limit = modifyChunkSize[coreTable.name] || modifyChunkSize['*'] || 200;
                else limit = modifyChunkSize;
            }
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var criteria = isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || changes === deleteCallback) && {
                    index: ctx.index,
                    range: ctx.range
                };
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if (isPlainKeyRange(ctx) && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify(deleteCallback);
    };
    return Collection;
}();
var deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function createCollectionConstructor(db) {
    return makeClassConstructor(Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== mirror ? readingHook : null
        };
    });
}
function simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return rangeEqual("");
    }).limit(0);
}
function upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return fail(whereClause, STRING_EXPECTED);
    function initDirection(dir) {
        upper = upperFactory(dir);
        lower = lowerFactory(dir);
        compare = dir === "next" ? simpleCompare : simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return emptyCollection(this);
            return new this.Collection(this, function() {
                return createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return fail(this, STRING_EXPECTED);
        return this.between(str, str + maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return emptyCollection(this);
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return emptyCollection(this);
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return emptyCollection(this);
        var c = new this.Collection(this, function() {
            return createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + maxString
            ];
        }));
    };
    return WhereClause;
}();
function createWhereClauseConstructor(db) {
    return makeClassConstructor(WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        this._cmp = this._ascending = cmp;
        this._descending = function(a, b) {
            return cmp(b, a);
        };
        this._max = function(a, b) {
            return cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new exceptions.MissingAPI();
    });
}
function eventRejectHandler(reject) {
    return wrap(function(event) {
        preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);
var Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        assert(!PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !PSD.global) PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        assert(!PSD.global);
        if (--this._reculock === 0) {
            if (!PSD.global) PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new exceptions.TransactionInactive();
        assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = wrap(function(ev) {
            preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = wrap(function(ev) {
            preventDefault(ev);
            _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return rejection(new exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return rejection(new exceptions.TransactionInactive());
        if (this._locked()) return new DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                PSD
            ]);
        });
        else if (bWriteLock) return newScope(function() {
            var p = new DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push(wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push(wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if (hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function createTransactionConstructor(db) {
    return makeClassConstructor(Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return rejection(e);
        });
    });
}
function createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + nameFromKeyPath(keyPath)
    };
}
function nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        getMaxKey = function() {
            return maxString;
        };
        return maxString;
    }
};
function getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return getByKeyPath(obj, keyPath);
    };
}
function getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return getByKeyPath(obj, keyPath);
    };
}
function arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var _id_counter = 0;
function getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[".concat(keyPath.join('+'), "]");
}
function createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: getKeyExtractor(keyPath)
                        },
                        indexes: arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = eventRejectHandler(reject);
                req.onsuccess = wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = wrap(resolveIteration);
                            req.onerror = eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '".concat(name, "' not found"));
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return __assign(__assign({}, down), create(down));
    }, stackImpl);
}
function createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = createMiddlewareStack(createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function removeTablesApi(db, objs) {
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (idbUpgradeTrans.objectStoreNames.contains('$meta') && !globalSchema.$meta) {
        globalSchema.$meta = createTableSchema("$meta", parseIndexSyntax("")[0], []);
        db._storeNames.push('$meta');
    }
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = PSD.transless || PSD;
    newScope(function() {
        PSD.trans = trans;
        PSD.transless = transless;
        if (oldVersion === 0) {
            keys(globalSchema).forEach(function(tableName) {
                createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            generateMiddlewareStacks(db, idbUpgradeTrans);
            DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else {
            generateMiddlewareStacks(db, idbUpgradeTrans);
            return getExistingVersion(db, trans, oldVersion).then(function(oldVersion) {
                return updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans);
            }).catch(rejectTransaction);
        }
    });
}
function patchCurrentVersion(db, idbUpgradeTrans) {
    createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains('$meta')) idbUpgradeTrans.db.createObjectStore('$meta').add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), 'version');
    var globalSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function(tableChange) {
        if (tableChange.change.length || tableChange.recreate) {
            console.warn("Unable to patch indexes of table ".concat(tableChange.name, " because it has changes on the type of index or primary key."));
            return {
                value: void 0
            };
        }
        var store = idbUpgradeTrans.objectStore(tableChange.name);
        tableChange.add.forEach(function(idx) {
            if (debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange.name, ".").concat(idx.src));
            addIndex(store, idx);
        });
    };
    for(var _i = 0, _a = diff.change; _i < _a.length; _i++){
        var tableChange = _a[_i];
        var state_1 = _loop_1(tableChange);
        if (typeof state_1 === "object") return state_1.value;
    }
}
function getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes('$meta')) return trans.table('$meta').get('version').then(function(metaVersion) {
        return metaVersion != null ? metaVersion : oldVersion;
    });
    else return DexiePromise.resolve(oldVersion);
}
function updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) return DexiePromise.resolve();
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                var upgradeSchema_1 = shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                setApiOnPlace(db, [
                    db.Transaction.prototype
                ], keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            var newSchema = version._cfg.dbschema;
            deleteRemovedTables(newSchema, idbtrans);
            removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
        queue.push(function(idbtrans) {
            if (db.idbdb.objectStoreNames.contains('$meta')) {
                if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
                    db.idbdb.deleteObjectStore('$meta');
                    delete db._dbSchema.$meta;
                    db._storeNames = db._storeNames.filter(function(name) {
                        return name !== '$meta';
                    });
                } else idbtrans.objectStore('$meta').put(version._cfg.version, 'version');
            }
        });
    });
    function runQueue() {
        return queue.length ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : DexiePromise.resolve();
    }
    return runQueue().then(function() {
        createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return addIndex(store, idx);
    });
    return store;
}
function createMissingTables(newSchema, idbtrans) {
    keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) {
            if (debug) console.debug('Dexie: Creating missing table', tableName);
            createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        }
    });
}
function deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = createIndexSpec(nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = slice(idbdb.objectStoreNames, 0);
    setApiOnPlace(db, [
        db._allTables
    ], keys(globalSchema), globalSchema);
}
function verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && _global.WorkerGlobalScope && _global instanceof _global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), isArray(keyPath), indexNum === 0);
    });
}
var Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                primKey.unique = true;
                if (primKey.multi) throw new exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], keys(dbschema), dbschema);
        db._storeNames = keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = promisableChain(this._cfg.contentUpgrade || nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function createVersionConstructor(db) {
    return makeClassConstructor(Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== DBNAMES_DB;
        });
    }) : getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function _onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !hasDatabasesNative(indexedDB1) && name !== DBNAMES_DB && getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch(nop);
}
function _onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !hasDatabasesNative(indexedDB1) && name !== DBNAMES_DB && getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch(nop);
}
function vip(fn) {
    return newScope(function() {
        PSD.letThrough = true;
        return fn();
    });
}
function idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var _a;
function isEmptyRange(node) {
    return !("from" in node);
}
var RangeSet = function(fromOrTree, to) {
    if (this) extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new RangeSet();
        if (fromOrTree && "d" in fromOrTree) extend(rv, fromOrTree);
        return rv;
    }
};
props(RangeSet.prototype, (_a = {
    add: function(rangeSet) {
        mergeRanges(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return addRange(_this, key, key);
        });
        return this;
    },
    hasKey: function(key) {
        var node = getRangeSetIterator(this).next(key).value;
        return node && cmp(node.from, key) <= 0 && cmp(node.to, key) >= 0;
    }
}, _a[iteratorSymbol] = function() {
    return getRangeSetIterator(this);
}, _a));
function addRange(target, from, to) {
    var diff = cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if (isEmptyRange(target)) return extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if (cmp(to, target.from) < 0) {
        left ? addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return rebalance(target);
    }
    if (cmp(from, target.to) > 0) {
        right ? addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return rebalance(target);
    }
    if (cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if (cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) mergeRanges(target, left);
    if (right && rightWasCutOff) mergeRanges(target, right);
}
function mergeRanges(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function rangesOverlap(rangeSet1, rangeSet2) {
    var i1 = getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if (cmp(b.from, a.to) <= 0 && cmp(b.to, a.from) >= 0) return true;
        cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function getRangeSetIterator(node) {
    var state = isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = __assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = computeDepth(rootClone);
    }
    target.d = computeDepth(target);
}
function computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
function extendObservabilitySet(target, newSet) {
    keys(newSet).forEach(function(part) {
        if (target[part]) mergeRanges(target[part], newSet[part]);
        else target[part] = cloneSimpleObjectTree(newSet[part]);
    });
    return target;
}
function obsSetsOverlap(os1, os2) {
    return os1.all || os2.all || Object.keys(os1).some(function(key) {
        return os2[key] && rangesOverlap(os2[key], os1[key]);
    });
}
var cache = {};
var unsignaledParts = {};
var isTaskEnqueued = false;
function signalSubscribersLazily(part, optimistic) {
    extendObservabilitySet(unsignaledParts, part);
    if (!isTaskEnqueued) {
        isTaskEnqueued = true;
        setTimeout(function() {
            isTaskEnqueued = false;
            var parts = unsignaledParts;
            unsignaledParts = {};
            signalSubscribersNow(parts, false);
        }, 0);
    }
}
function signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
    var queriesToSignal = new Set();
    if (updatedParts.all) for(var _i = 0, _a = Object.values(cache); _i < _a.length; _i++){
        var tblCache = _a[_i];
        collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
    }
    else for(var key in updatedParts){
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
            var dbName = parts[1], tableName = parts[2];
            var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
            if (tblCache) collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
        }
    }
    queriesToSignal.forEach(function(requery) {
        return requery();
    });
}
function collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
    var updatedEntryLists = [];
    for(var _i = 0, _a = Object.entries(tblCache.queries.query); _i < _a.length; _i++){
        var _b = _a[_i], indexName = _b[0], entries = _b[1];
        var filteredEntries = [];
        for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
            var entry = entries_1[_c];
            if (obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                return outQueriesToSignal.add(requery);
            });
            else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
        }
        if (deleteAffectedCacheEntries) updatedEntryLists.push([
            indexName,
            filteredEntries
        ]);
    }
    if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
        var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
    }
}
function dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? rejection(state.dbOpenError) : db;
    });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema || !nativeVerToOpen ? indexedDB1.open(dbName) : indexedDB1.open(dbName, nativeVerToOpen);
            if (!req) throw new exceptions.MissingAPI();
            req.onerror = eventRejectHandler(reject);
            req.onblocked = wrap(db._fireOnBlocked);
            req.onupgradeneeded = wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = wrap(function() {
                        reject(new exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                    });
                } else {
                    upgradeTransaction.onerror = eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db.idbdb = req.result;
                    if (schemaPatchMode) patchCurrentVersion(db, upgradeTransaction);
                    runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = wrap(function() {
                upgradeTransaction = null;
                var idbdb = db.idbdb = req.result;
                var objectStoreNames = slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction(safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                            console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                            idbdb.close();
                            nativeVerToOpen = idbdb.version + 1;
                            schemaPatchMode = true;
                            return resolve(tryOpenDB());
                        }
                    }
                    generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                connections.push(db);
                idbdb.onversionchange = wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) _onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            switch(err === null || err === void 0 ? void 0 : err.name){
                case "UnknownError":
                    if (state.PR1398_maxLoop > 0) {
                        state.PR1398_maxLoop--;
                        console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                        return tryOpenDB();
                    }
                    break;
                case "VersionError":
                    if (nativeVerToOpen > 0) {
                        nativeVerToOpen = 0;
                        return tryOpenDB();
                    }
                    break;
            }
            return DexiePromise.reject(err);
        });
    };
    return DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? DexiePromise.resolve() : idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return DexiePromise.resolve(vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce(promisableChain, nop);
                state.onReadyBeingFired = [];
                return DexiePromise.resolve(vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        if (state.openCanceller === openCanceller) {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    }).then(function() {
        if (wasCreated) {
            var everything_1 = {};
            db.tables.forEach(function(table) {
                table.schema.indexes.forEach(function(idx) {
                    if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new RangeSet(-Infinity, [
                        [
                            []
                        ]
                    ]);
                });
                everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new RangeSet(-Infinity, [
                    [
                        []
                    ]
                ]);
            });
            globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
            signalSubscribersNow(everything_1, true);
        }
        return db;
    });
}
function awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return DexiePromise.resolve().then(function() {
        var transless = PSD.transless || PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        trans.explicit = true;
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            trans.idbtrans._explicit = true;
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return rejection(ex);
        }
        var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return rejection(e);
        });
    });
}
function pad(a, value, count) {
    var result = isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function createVirtualIndexMiddleware(down) {
    return __assign(__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = __assign(__assign({}, lowLevelIndex), {
                    name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                    lowLevelIndex: lowLevelIndex,
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? __assign(__assign({}, req), {
                    query: {
                        index: index.lowLevelIndex,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = __assign(__assign({}, table), {
                schema: __assign(__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue(pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey(pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: createVirtualIndexMiddleware
};
function getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    keys(a).forEach(function(prop) {
        if (!hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                var apTypeName = toStringTag(ap);
                var bpTypeName = toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    keys(b).forEach(function(prop) {
        if (!hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return __assign(__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = __assign(__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === nop && updating.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = PSD.trans;
                            var keys = req.keys || getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? __assign(__assign({}, req), {
                                keys: keys
                            }) : __assign({}, req);
                            if (req.type !== 'delete') req.values = __spreadArray([], req.values, true);
                            if (req.keys) req.keys = __spreadArray([], req.keys, true);
                            return getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if (hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, __assign(__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if (cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return __assign(__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
function isCachableContext(ctx, table) {
    return ctx.trans.mode === 'readonly' && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== 'disabled' && !table.schema.primaryKey.outbound;
}
function isCachableRequest(type, req) {
    switch(type){
        case 'query':
            return req.values && !req.unique;
        case 'get':
            return false;
        case 'getMany':
            return false;
        case 'count':
            return false;
        case 'openCursor':
            return false;
    }
}
var observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new RangeSet(core.MIN_KEY, core.MAX_KEY);
        return __assign(__assign({}, core), {
            transaction: function(stores, mode, options) {
                if (PSD.subscr && mode !== 'readonly') throw new exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat(PSD.querier));
                return core.transaction(stores, mode, options);
            },
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey, indexes = schema.indexes;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                    return index.compound && index.keyPath.includes(primaryKey.keyPath);
                });
                var tableClone = __assign(__assign({}, table), {
                    mutate: function(req) {
                        var _a, _b;
                        var trans = req.trans;
                        var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                            return mutatedParts[part] || (mutatedParts[part] = new RangeSet());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _c = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            getEffectiveKeys(primaryKey, req).filter(function(id) {
                                return id;
                            }),
                            req.values
                        ] : [], keys = _c[0], newObjs = _c[1];
                        var oldCache = req.trans["_cache"];
                        if (isArray(keys)) {
                            pkRangeSet.addKeys(keys);
                            var oldObjs = type === 'delete' || keys.length === newObjs.length ? getFromTransactionCache(keys, oldCache) : null;
                            if (!oldObjs) delsRangeSet.addKeys(keys);
                            if (oldObjs || newObjs) trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                        } else if (keys) {
                            var range = {
                                from: (_a = keys.lower) !== null && _a !== void 0 ? _a : core.MIN_KEY,
                                to: (_b = keys.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                            };
                            delsRangeSet.add(range);
                            pkRangeSet.add(range);
                        } else {
                            pkRangeSet.add(FULL_RANGE);
                            delsRangeSet.add(FULL_RANGE);
                            schema.indexes.forEach(function(idx) {
                                return getRangeSet(idx.name).add(FULL_RANGE);
                            });
                        }
                        return table.mutate(req).then(function(res) {
                            if (keys && (req.type === 'add' || req.type === 'put')) {
                                pkRangeSet.addKeys(res.results);
                                if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                    var idxVals = req.values.map(function(v) {
                                        return idx.extractKey(v);
                                    });
                                    var pkPos = idx.keyPath.findIndex(function(prop) {
                                        return prop === primaryKey.keyPath;
                                    });
                                    for(var i = 0, len = res.results.length; i < len; ++i)idxVals[i][pkPos] = res.results[i];
                                    getRangeSet(idx.name).addKeys(idxVals);
                                });
                            }
                            trans.mutatedParts = extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new RangeSet((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new RangeSet(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new RangeSet().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = PSD.subscr;
                        var isLiveQuery = !!subscr;
                        var cachable = isCachableContext(PSD, table) && isCachableRequest(method, req);
                        var obsSet = cachable ? req.obsSet = {} : subscr;
                        if (isLiveQuery) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                return obsSet[part] || (obsSet[part] = new RangeSet());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            if (method === 'query' && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                            else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query(__assign(__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if (cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
function adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === 'deleteRange') return null;
    var numBulkOps = req.keys ? req.keys.length : 'values' in req && req.values ? req.values.length : 1;
    if (res.numFailures === numBulkOps) return null;
    var clone = __assign({}, req);
    if (isArray(clone.keys)) clone.keys = clone.keys.filter(function(_, i) {
        return !(i in res.failures);
    });
    if ('values' in clone && isArray(clone.values)) clone.values = clone.values.filter(function(_, i) {
        return !(i in res.failures);
    });
    return clone;
}
function isAboveLower(key, range) {
    return range.lower === undefined ? true : range.lowerOpen ? cmp(key, range.lower) > 0 : cmp(key, range.lower) >= 0;
}
function isBelowUpper(key, range) {
    return range.upper === undefined ? true : range.upperOpen ? cmp(key, range.upper) < 0 : cmp(key, range.upper) <= 0;
}
function isWithinRange(key, range) {
    return isAboveLower(key, range) && isBelowUpper(key, range);
}
function applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function(result, op) {
        var modifedResult = result;
        var includedValues = [];
        if (op.type === 'add' || op.type === 'put') {
            var includedPKs = new RangeSet();
            for(var i = op.values.length - 1; i >= 0; --i){
                var value = op.values[i];
                var pk = extractPrimKey(value);
                if (includedPKs.hasKey(pk)) continue;
                var key = extractIndex(value);
                if (multiEntry && isArray(key) ? key.some(function(k) {
                    return isWithinRange(k, queryRange);
                }) : isWithinRange(key, queryRange)) {
                    includedPKs.addKey(pk);
                    includedValues.push(value);
                }
            }
        }
        switch(op.type){
            case 'add':
                var existingKeys_1 = new RangeSet().addKeys(req.values ? result.map(function(v) {
                    return extractPrimKey(v);
                }) : result);
                modifedResult = result.concat(req.values ? includedValues.filter(function(v) {
                    var key = extractPrimKey(v);
                    if (existingKeys_1.hasKey(key)) return false;
                    existingKeys_1.addKey(key);
                    return true;
                }) : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }).filter(function(k) {
                    if (existingKeys_1.hasKey(k)) return false;
                    existingKeys_1.addKey(k);
                    return true;
                }));
                break;
            case 'put':
                var keySet_1 = new RangeSet().addKeys(op.values.map(function(v) {
                    return extractPrimKey(v);
                }));
                modifedResult = result.filter(function(item) {
                    return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                }).concat(req.values ? includedValues : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }));
                break;
            case 'delete':
                var keysToDelete_1 = new RangeSet().addKeys(op.keys);
                modifedResult = result.filter(function(item) {
                    return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                });
                break;
            case 'deleteRange':
                var range_1 = op.range;
                modifedResult = result.filter(function(item) {
                    return !isWithinRange(extractPrimKey(item), range_1);
                });
                break;
        }
        return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function(a, b) {
        return cmp(extractLowLevelIndex(a), extractLowLevelIndex(b)) || cmp(extractPrimKey(a), extractPrimKey(b));
    });
    if (req.limit && req.limit < Infinity) {
        if (finalResult.length > req.limit) finalResult.length = req.limit;
        else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
}
function areRangesEqual(r1, r2) {
    return cmp(r1.lower, r2.lower) === 0 && cmp(r1.upper, r2.upper) === 0 && !!r1.lowerOpen === !!r2.lowerOpen && !!r1.upperOpen === !!r2.upperOpen;
}
function compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = cmp(lower1, lower2);
    if (c === 0) {
        if (lowerOpen1 && lowerOpen2) return 0;
        if (lowerOpen1) return 1;
        if (lowerOpen2) return -1;
    }
    return c;
}
function compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = cmp(upper1, upper2);
    if (c === 0) {
        if (upperOpen1 && upperOpen2) return 0;
        if (upperOpen1) return -1;
        if (upperOpen2) return 1;
    }
    return c;
}
function isSuperRange(r1, r2) {
    return compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 && compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0;
}
function findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [
        null,
        false,
        tblCache,
        null
    ];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ''];
    if (!entries) return [
        null,
        false,
        tblCache,
        null
    ];
    switch(type){
        case 'query':
            var equalEntry = entries.find(function(entry) {
                return entry.req.limit === req.limit && entry.req.values === req.values && areRangesEqual(entry.req.query.range, req.query.range);
            });
            if (equalEntry) return [
                equalEntry,
                true,
                tblCache,
                entries
            ];
            var superEntry = entries.find(function(entry) {
                var limit = 'limit' in entry.req ? entry.req.limit : Infinity;
                return limit >= req.limit && (req.values ? entry.req.values : true) && isSuperRange(entry.req.query.range, req.query.range);
            });
            return [
                superEntry,
                false,
                tblCache,
                entries
            ];
        case 'count':
            var countQuery = entries.find(function(entry) {
                return areRangesEqual(entry.req.query.range, req.query.range);
            });
            return [
                countQuery,
                !!countQuery,
                tblCache,
                entries
            ];
    }
}
function subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function() {
        cacheEntry.subscribers.delete(requery);
        if (cacheEntry.subscribers.size === 0) enqueForDeletion(cacheEntry, container);
    });
}
function enqueForDeletion(cacheEntry, container) {
    setTimeout(function() {
        if (cacheEntry.subscribers.size === 0) delArrayItem(container, cacheEntry);
    }, 3000);
}
var cacheMiddleware = {
    stack: 'dbcore',
    level: 0,
    name: 'Cache',
    create: function(core) {
        var dbName = core.schema.name;
        var coreMW = __assign(__assign({}, core), {
            transaction: function(stores, mode, options) {
                var idbtrans = core.transaction(stores, mode, options);
                if (mode === 'readwrite') {
                    var ac_1 = new AbortController();
                    var signal = ac_1.signal;
                    var endTransaction = function(wasCommitted) {
                        return function() {
                            ac_1.abort();
                            if (mode === 'readwrite') {
                                var affectedSubscribers_1 = new Set();
                                for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                    var storeName = stores_1[_i];
                                    var tblCache = cache["idb://".concat(dbName, "/").concat(storeName)];
                                    if (tblCache) {
                                        var table = core.table(storeName);
                                        var ops = tblCache.optimisticOps.filter(function(op) {
                                            return op.trans === idbtrans;
                                        });
                                        if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a = 0, _b = Object.values(tblCache.queries.query); _a < _b.length; _a++){
                                            var entries = _b[_a];
                                            for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                var entry = _d[_c];
                                                if (obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                    delArrayItem(entries, entry);
                                                    entry.subscribers.forEach(function(requery) {
                                                        return affectedSubscribers_1.add(requery);
                                                    });
                                                }
                                            }
                                        }
                                        else if (ops.length > 0) {
                                            tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                return op.trans !== idbtrans;
                                            });
                                            for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                var entries = _f[_e];
                                                for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                    var entry = _h[_g];
                                                    if (entry.res != null && idbtrans.mutatedParts) {
                                                        if (wasCommitted && !entry.dirty) {
                                                            var freezeResults = Object.isFrozen(entry.res);
                                                            var modRes = applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                            if (entry.dirty) {
                                                                delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            } else if (modRes !== entry.res) {
                                                                entry.res = modRes;
                                                                entry.promise = DexiePromise.resolve({
                                                                    result: modRes
                                                                });
                                                            }
                                                        } else {
                                                            if (entry.dirty) delArrayItem(entries, entry);
                                                            entry.subscribers.forEach(function(requery) {
                                                                return affectedSubscribers_1.add(requery);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                affectedSubscribers_1.forEach(function(requery) {
                                    return requery();
                                });
                            }
                        };
                    };
                    idbtrans.addEventListener('abort', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('error', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('complete', endTransaction(true), {
                        signal: signal
                    });
                }
                return idbtrans;
            },
            table: function(tableName) {
                var downTable = core.table(tableName);
                var primKey = downTable.schema.primaryKey;
                var tableMW = __assign(__assign({}, downTable), {
                    mutate: function(req) {
                        var trans = PSD.trans;
                        if (primKey.outbound || trans.db._options.cache === 'disabled' || trans.explicit || trans.idbtrans.mode !== 'readwrite') return downTable.mutate(req);
                        var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
                        if (!tblCache) return downTable.mutate(req);
                        var promise = downTable.mutate(req);
                        if ((req.type === 'add' || req.type === 'put') && (req.values.length >= 50 || getEffectiveKeys(primKey, req).some(function(key) {
                            return key == null;
                        }))) promise.then(function(res) {
                            var reqWithResolvedKeys = __assign(__assign({}, req), {
                                values: req.values.map(function(value, i) {
                                    var _a;
                                    if (res.failures[i]) return value;
                                    var valueWithKey = ((_a = primKey.keyPath) === null || _a === void 0 ? void 0 : _a.includes('.')) ? deepClone(value) : __assign({}, value);
                                    setByKeyPath(valueWithKey, primKey.keyPath, res.results[i]);
                                    return valueWithKey;
                                })
                            });
                            var adjustedReq = adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                            tblCache.optimisticOps.push(adjustedReq);
                            queueMicrotask(function() {
                                return req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                            });
                        });
                        else {
                            tblCache.optimisticOps.push(req);
                            req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                            promise.then(function(res) {
                                if (res.numFailures > 0) {
                                    delArrayItem(tblCache.optimisticOps, req);
                                    var adjustedReq = adjustOptimisticFromFailures(tblCache, req, res);
                                    if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                    req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                                }
                            });
                            promise.catch(function() {
                                delArrayItem(tblCache.optimisticOps, req);
                                req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                            });
                        }
                        return promise;
                    },
                    query: function(req) {
                        var _a;
                        if (!isCachableContext(PSD, downTable) || !isCachableRequest("query", req)) return downTable.query(req);
                        var freezeResults = ((_a = PSD.trans) === null || _a === void 0 ? void 0 : _a.db._options.cache) === 'immutable';
                        var _b = PSD, requery = _b.requery, signal = _b.signal;
                        var _c = findCompatibleQuery(dbName, tableName, 'query', req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                        if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                        else {
                            var promise = downTable.query(req).then(function(res) {
                                var result = res.result;
                                if (cacheEntry) cacheEntry.res = result;
                                if (freezeResults) {
                                    for(var i = 0, l = result.length; i < l; ++i)Object.freeze(result[i]);
                                    Object.freeze(result);
                                } else res.result = deepClone(result);
                                return res;
                            }).catch(function(error) {
                                if (container && cacheEntry) delArrayItem(container, cacheEntry);
                                return Promise.reject(error);
                            });
                            cacheEntry = {
                                obsSet: req.obsSet,
                                promise: promise,
                                subscribers: new Set(),
                                type: 'query',
                                req: req,
                                dirty: false
                            };
                            if (container) container.push(cacheEntry);
                            else {
                                container = [
                                    cacheEntry
                                ];
                                if (!tblCache) tblCache = cache["idb://".concat(dbName, "/").concat(tableName)] = {
                                    queries: {
                                        query: {},
                                        count: {}
                                    },
                                    objs: new Map(),
                                    optimisticOps: [],
                                    unsignaledParts: {}
                                };
                                tblCache.queries.query[req.query.index.name || ''] = container;
                            }
                        }
                        subscribeToCacheEntry(cacheEntry, container, requery, signal);
                        return cacheEntry.promise.then(function(res) {
                            return {
                                result: applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                            };
                        });
                    }
                });
                return tableMW;
            }
        });
        return coreMW;
    }
};
function vipify(target, vipDb) {
    return new Proxy(target, {
        get: function(target, prop, receiver) {
            if (prop === 'db') return vipDb;
            return Reflect.get(target, prop, receiver);
        }
    });
}
var Dexie$1 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = __assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange,
            cache: 'cloned'
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: nop,
            dbReadyPromise: null,
            cancelOpen: nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3,
            autoOpen: options.autoOpen
        };
        state.dbReadyPromise = new DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                promisableChain,
                nop
            ]
        });
        this.on.ready.subscribe = override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = createCollectionConstructor(this);
        this.Table = createTableConstructor(this);
        this.Transaction = createTransactionConstructor(this);
        this.Version = createVersionConstructor(this);
        this.WhereClause = createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
            else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
            _this.close({
                disableAutoOpen: false
            });
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
            else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
        });
        this._maxKey = getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use(cacheExistingValuesMiddleware);
        this.use(cacheMiddleware);
        this.use(observabilityMiddleware);
        this.use(virtualIndexMiddleware);
        this.use(hooksMiddleware);
        var vipDB = new Proxy(this, {
            get: function(_, prop, receiver) {
                if (prop === '_vip') return true;
                if (prop === 'table') return function(tableName) {
                    return vipify(_this.table(tableName), vipDB);
                };
                var rv = Reflect.get(_, prop, receiver);
                if (rv instanceof Table) return vipify(rv, vipDB);
                if (prop === 'tables') return rv.map(function(t) {
                    return vipify(t, vipDB);
                });
                if (prop === '_createTransaction') return function() {
                    var tx = rv.apply(this, arguments);
                    return vipify(tx, vipDB);
                };
                return rv;
            }
        });
        this.vip = vipDB;
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort(lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || PSD.letThrough || this._vip) ? fn() : new DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._state.autoOpen) {
                    reject(new exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch(nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        var _this = this;
        return usePSD(globalPSD, function() {
            return dexieOpen(_this);
        });
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = connections.indexOf(this);
        if (idx >= 0) connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        if (!state.isBeingOpened) {
            state.dbReadyPromise = new DexiePromise(function(resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new DexiePromise(function(_, reject) {
                state.cancelOpen = reject;
            });
        }
    };
    Dexie.prototype.close = function(_a) {
        var _b = _a === void 0 ? {
            disableAutoOpen: true
        } : _a, disableAutoOpen = _b.disableAutoOpen;
        var state = this._state;
        if (disableAutoOpen) {
            if (state.isBeingOpened) state.cancelOpen(new exceptions.DatabaseClosed());
            this._close();
            state.autoOpen = false;
            state.dbOpenError = new exceptions.DatabaseClosed();
        } else {
            this._close();
            state.autoOpen = this._options.autoOpen || state.isBeingOpened;
            state.openComplete = false;
            state.dbOpenError = null;
        }
    };
    Dexie.prototype.delete = function(closeOptions) {
        var _this = this;
        if (closeOptions === void 0) closeOptions = {
            disableAutoOpen: true
        };
        var hasInvalidArguments = arguments.length > 0 && typeof arguments[0] !== 'object';
        var state = this._state;
        return new DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close(closeOptions);
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = wrap(function() {
                    _onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasInvalidArguments) throw new exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === READONLY) idbMode = READONLY;
            else if (mode == "rw" || mode == READWRITE) idbMode = READWRITE;
            else throw new exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : rejection(e);
        }
        var enterTransaction = enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : PSD.trans ? usePSD(PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!hasOwn(this._allTables, tableName)) throw new exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
        return this._allTables[tableName];
    };
    return Dexie;
}();
var symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
var domDeps;
try {
    domDeps = {
        indexedDB: _global.indexedDB || _global.mozIndexedDB || _global.webkitIndexedDB || _global.msIndexedDB,
        IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange
    };
} catch (e) {
    domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
function liveQuery(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new Observable(function(observer) {
        var scopeFuncIsAsync = isAsyncFunction(querier);
        function execute(ctx) {
            var wasRootExec = beginMicroTickScope();
            try {
                if (scopeFuncIsAsync) incrementExpectedAwaits();
                var rv = newScope(querier, ctx);
                if (scopeFuncIsAsync) rv = rv.finally(decrementExpectedAwaits);
                return rv;
            } finally{
                wasRootExec && endMicroTickScope();
            }
        }
        var closed = false;
        var abortController;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                if (closed) return;
                closed = true;
                if (abortController) abortController.abort();
                if (startedListening) globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var startedListening = false;
        var doQuery = function() {
            return execInGlobalContext(_doQuery);
        };
        function shouldNotify() {
            return obsSetsOverlap(currentObs, accumMuts);
        }
        var mutationListener = function(parts) {
            extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var _doQuery = function() {
            if (closed || !domDeps.indexedDB) return;
            accumMuts = {};
            var subscr = {};
            if (abortController) abortController.abort();
            abortController = new AbortController();
            var ctx = {
                subscr: subscr,
                signal: abortController.signal,
                requery: doQuery,
                querier: querier,
                trans: null
            };
            var ret = execute(ctx);
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                if (closed || ctx.signal.aborted) return;
                accumMuts = {};
                currentObs = subscr;
                if (!objectIsEmpty(currentObs) && !startedListening) {
                    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                execInGlobalContext(function() {
                    return !closed && observer.next && observer.next(result);
                });
            }, function(err) {
                hasValue = false;
                if (![
                    'DatabaseClosedError',
                    'AbortError'
                ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                    if (!closed) execInGlobalContext(function() {
                        if (closed) return;
                        observer.error && observer.error(err);
                    });
                }
            });
        };
        setTimeout(doQuery, 0);
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var Dexie = Dexie$1;
props(Dexie, __assign(__assign({}, fullNameExceptions), {
    delete: function(databaseName) {
        var db = new Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return getDatabaseNames(Dexie.dependencies).then(cb);
        } catch (_a) {
            return rejection(new exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return PSD.trans ? usePSD(PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = DexiePromise.resolve(typeof promiseOrFunction === 'function' ? Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return PSD.trans ? PSD.trans.waitFor(promise) : promise;
    },
    Promise: DexiePromise,
    debug: {
        get: function() {
            return debug;
        },
        set: function(value) {
            setDebug(value);
        }
    },
    derive: derive,
    extend: extend,
    props: props,
    override: override,
    Events: Events,
    on: globalEvents,
    liveQuery: liveQuery,
    extendObservabilitySet: extendObservabilitySet,
    getByKeyPath: getByKeyPath,
    setByKeyPath: setByKeyPath,
    delByKeyPath: delByKeyPath,
    shallowClone: shallowClone,
    deepClone: deepClone,
    getObjectDiff: getObjectDiff,
    cmp: cmp,
    asap: asap$1,
    minKey: minKey,
    addons: [],
    connections: connections,
    errnames: errnames,
    dependencies: domDeps,
    cache: cache,
    semVer: DEXIE_VERSION,
    version: DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
Dexie.maxKey = getMaxKey(Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!propagatingLocally) {
            var event_1;
            event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            propagatingLocally = true;
            dispatchEvent(event_1);
            propagatingLocally = false;
        }
    });
    addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!propagatingLocally) propagateLocally(detail);
    });
}
function propagateLocally(updateParts) {
    var wasMe = propagatingLocally;
    try {
        propagatingLocally = true;
        globalEvents.storagemutated.fire(updateParts);
        signalSubscribersNow(updateParts, true);
    } finally{
        propagatingLocally = wasMe;
    }
}
var propagatingLocally = false;
var bc;
var createBC = function() {};
if (typeof BroadcastChannel !== 'undefined') {
    createBC = function() {
        bc = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
        bc.onmessage = function(ev) {
            return ev.data && propagateLocally(ev.data);
        };
    };
    createBC();
    if (typeof bc.unref === 'function') bc.unref();
    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!propagatingLocally) bc.postMessage(changedParts);
    });
}
if (typeof addEventListener !== 'undefined') {
    addEventListener('pagehide', function(event) {
        if (!Dexie$1.disableBfCache && event.persisted) {
            if (debug) console.debug('Dexie: handling persisted pagehide');
            bc === null || bc === void 0 || bc.close();
            for(var _i = 0, connections_1 = connections; _i < connections_1.length; _i++){
                var db = connections_1[_i];
                db.close({
                    disableAutoOpen: false
                });
            }
        }
    });
    addEventListener('pageshow', function(event) {
        if (!Dexie$1.disableBfCache && event.persisted) {
            if (debug) console.debug('Dexie: handling persisted pageshow');
            createBC();
            propagateLocally({
                all: new RangeSet(-Infinity, [
                    []
                ])
            });
        }
    });
}
function add(value) {
    return new PropModification({
        add: value
    });
}
function remove(value) {
    return new PropModification({
        remove: value
    });
}
function replacePrefix(a, b) {
    return new PropModification({
        replacePrefix: [
            a,
            b
        ]
    });
}
DexiePromise.rejectionMapper = mapError;
setDebug(debug);

});

var $22affbde6edd8513$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1LzKV\",\"index.3cdbb939.js\",\"cT2zm\",\"buddha.25346a7e.webp\",\"77GZU\",\"trophy.65fb719c.svg\",\"cVqOh\",\"buddha.93bb0cbc.png\",\"a4dsv\",\"siliconwat.2042ef2b.svg\",\"nguOd\",\"default.947f6a58.png\",\"5dxh3\",\"siliconwat.d7b5f302.png\",\"idv0d\",\"buddha.dd1e8c85.mp4\",\"l2EKq\",\"poster.afa248fd.png\",\"7aqlM\",\"front.755d97ef.png\",\"h6n4v\",\"back.b693badc.png\",\"9Jghx\",\"heartbank.542aebb2.png\",\"dBu7f\",\"sw.js\",\"5h9CN\",\"index.121f7148.css\"]"));

//import { register } from "@parcel/service-worker"; // doesn't exist
//import { Dictionaries } from "./managers/Dictionaries.ts";
//import Bowser from "bowser";
/*! (c) Andrea Giammarchi @webreflection ISC */ (function() {
    'use strict';
    var attributesObserver = function(whenDefined, MutationObserver1) {
        var attributeChanged = function attributeChanged(records) {
            for(var i = 0, length = records.length; i < length; i++)dispatch(records[i]);
        };
        var dispatch = function dispatch(_ref) {
            var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue;
            target.attributeChangedCallback(attributeName, oldValue, target.getAttribute(attributeName));
        };
        return function(target, is) {
            var attributeFilter = target.constructor.observedAttributes;
            if (attributeFilter) whenDefined(is).then(function() {
                new MutationObserver1(attributeChanged).observe(target, {
                    attributes: true,
                    attributeOldValue: true,
                    attributeFilter: attributeFilter
                });
                for(var i = 0, length = attributeFilter.length; i < length; i++)if (target.hasAttribute(attributeFilter[i])) dispatch({
                    target: target,
                    attributeName: attributeFilter[i],
                    oldValue: null
                });
            });
            return target;
        };
    };
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function() {};
                return {
                    s: F,
                    n: function() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function() {
                it = it.call(o);
            },
            n: function() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function(e) {
                didErr = true;
                err = e;
            },
            f: function() {
                try {
                    if (!normalCompletion && it.return != null) it.return();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    /*! (c) Andrea Giammarchi - ISC */ var TRUE = true, FALSE = false, QSA$1 = 'querySelectorAll';
    /**
   * Start observing a generic document or root element.
   * @param {(node:Element, connected:boolean) => void} callback triggered per each dis/connected element
   * @param {Document|Element} [root=document] by default, the global document to observe
   * @param {Function} [MO=MutationObserver] by default, the global MutationObserver
   * @param {string[]} [query=['*']] the selectors to use within nodes
   * @returns {MutationObserver}
   */ var notify = function notify(callback) {
        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
        var MO = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MutationObserver;
        var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [
            '*'
        ];
        var loop = function loop(nodes, selectors, added, removed, connected, pass) {
            var _iterator = _createForOfIteratorHelper(nodes), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var node = _step.value;
                    if (pass || QSA$1 in node) {
                        if (connected) {
                            if (!added.has(node)) {
                                added.add(node);
                                removed["delete"](node);
                                callback(node, connected);
                            }
                        } else if (!removed.has(node)) {
                            removed.add(node);
                            added["delete"](node);
                            callback(node, connected);
                        }
                        if (!pass) loop(node[QSA$1](selectors), selectors, added, removed, connected, TRUE);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        };
        var mo = new MO(function(records) {
            if (query.length) {
                var selectors = query.join(',');
                var added = new Set(), removed = new Set();
                var _iterator2 = _createForOfIteratorHelper(records), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = _step2.value, addedNodes = _step2$value.addedNodes, removedNodes = _step2$value.removedNodes;
                        loop(removedNodes, selectors, added, removed, FALSE, FALSE);
                        loop(addedNodes, selectors, added, removed, TRUE, FALSE);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
        });
        var observe = mo.observe;
        (mo.observe = function(node) {
            return observe.call(mo, node, {
                subtree: TRUE,
                childList: TRUE
            });
        })(root);
        return mo;
    };
    var QSA = 'querySelectorAll';
    var _self$1 = self, document$2 = _self$1.document, Element$1 = _self$1.Element, MutationObserver$2 = _self$1.MutationObserver, Set$2 = _self$1.Set, WeakMap$1 = _self$1.WeakMap;
    var elements = function elements(element) {
        return QSA in element;
    };
    var filter = [].filter;
    var qsaObserver = function(options) {
        var live = new WeakMap$1();
        var drop = function drop(elements) {
            for(var i = 0, length = elements.length; i < length; i++)live["delete"](elements[i]);
        };
        var flush = function flush() {
            var records = observer.takeRecords();
            for(var i = 0, length = records.length; i < length; i++){
                parse(filter.call(records[i].removedNodes, elements), false);
                parse(filter.call(records[i].addedNodes, elements), true);
            }
        };
        var matches = function matches(element) {
            return element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
        };
        var notifier = function notifier(element, connected) {
            var selectors;
            if (connected) {
                for(var q, m = matches(element), i = 0, length = query.length; i < length; i++)if (m.call(element, q = query[i])) {
                    if (!live.has(element)) live.set(element, new Set$2());
                    selectors = live.get(element);
                    if (!selectors.has(q)) {
                        selectors.add(q);
                        options.handle(element, connected, q);
                    }
                }
            } else if (live.has(element)) {
                selectors = live.get(element);
                live["delete"](element);
                selectors.forEach(function(q) {
                    options.handle(element, connected, q);
                });
            }
        };
        var parse = function parse(elements) {
            var connected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            for(var i = 0, length = elements.length; i < length; i++)notifier(elements[i], connected);
        };
        var query = options.query;
        var root = options.root || document$2;
        var observer = notify(notifier, root, MutationObserver$2, query);
        var attachShadow = Element$1.prototype.attachShadow;
        if (attachShadow) Element$1.prototype.attachShadow = function(init) {
            var shadowRoot = attachShadow.call(this, init);
            observer.observe(shadowRoot);
            return shadowRoot;
        };
        if (query.length) parse(root[QSA](query));
        return {
            drop: drop,
            flush: flush,
            observer: observer,
            parse: parse
        };
    };
    var _self = self, document$1 = _self.document, Map = _self.Map, MutationObserver$1 = _self.MutationObserver, Object$1 = _self.Object, Set$1 = _self.Set, WeakMap = _self.WeakMap, Element = _self.Element, HTMLElement = _self.HTMLElement, Node = _self.Node, Error = _self.Error, TypeError$1 = _self.TypeError, Reflect = _self.Reflect;
    var defineProperty = Object$1.defineProperty, keys = Object$1.keys, getOwnPropertyNames = Object$1.getOwnPropertyNames, setPrototypeOf = Object$1.setPrototypeOf;
    var legacy = !self.customElements;
    var expando = function expando(element) {
        var key = keys(element);
        var value = [];
        var ignore = new Set$1();
        var length = key.length;
        for(var i = 0; i < length; i++){
            value[i] = element[key[i]];
            try {
                delete element[key[i]];
            } catch (SafariTP) {
                ignore.add(i);
            }
        }
        return function() {
            for(var _i = 0; _i < length; _i++)ignore.has(_i) || (element[key[_i]] = value[_i]);
        };
    };
    if (legacy) {
        var HTMLBuiltIn = function HTMLBuiltIn() {
            var constructor = this.constructor;
            if (!classes.has(constructor)) throw new TypeError$1('Illegal constructor');
            var is = classes.get(constructor);
            if (override) return augment(override, is);
            var element = createElement.call(document$1, is);
            return augment(setPrototypeOf(element, constructor.prototype), is);
        };
        var createElement = document$1.createElement;
        var classes = new Map();
        var defined = new Map();
        var prototypes = new Map();
        var registry = new Map();
        var query = [];
        var handle = function handle(element, connected, selector) {
            var proto = prototypes.get(selector);
            if (connected && !proto.isPrototypeOf(element)) {
                var redefine = expando(element);
                override = setPrototypeOf(element, proto);
                try {
                    new proto.constructor();
                } finally{
                    override = null;
                    redefine();
                }
            }
            var method = "".concat(connected ? '' : 'dis', "connectedCallback");
            if (method in proto) element[method]();
        };
        var _qsaObserver = qsaObserver({
            query: query,
            handle: handle
        }), parse = _qsaObserver.parse;
        var override = null;
        var whenDefined = function whenDefined(name) {
            if (!defined.has(name)) {
                var _, $ = new Promise(function($) {
                    _ = $;
                });
                defined.set(name, {
                    $: $,
                    _: _
                });
            }
            return defined.get(name).$;
        };
        var augment = attributesObserver(whenDefined, MutationObserver$1);
        self.customElements = {
            define: function define(is, Class) {
                if (registry.has(is)) throw new Error("the name \"".concat(is, "\" has already been used with this registry"));
                classes.set(Class, is);
                prototypes.set(is, Class.prototype);
                registry.set(is, Class);
                query.push(is);
                whenDefined(is).then(function() {
                    parse(document$1.querySelectorAll(is));
                });
                defined.get(is)._(Class);
            },
            get: function get(is) {
                return registry.get(is);
            },
            whenDefined: whenDefined
        };
        defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, 'constructor', {
            value: HTMLBuiltIn
        });
        self.HTMLElement = HTMLBuiltIn;
        document$1.createElement = function(name, options) {
            var is = options && options.is;
            var Class = is ? registry.get(is) : registry.get(name);
            return Class ? new Class() : createElement.call(document$1, name);
        };
        // in case ShadowDOM is used through a polyfill, to avoid issues
        // with builtin extends within shadow roots
        if (!('isConnected' in Node.prototype)) defineProperty(Node.prototype, 'isConnected', {
            configurable: true,
            get: function get() {
                return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
            }
        });
    } else {
        legacy = !self.customElements.get('extends-br');
        if (legacy) try {
            var BR = function BR() {
                return self.Reflect.construct(HTMLBRElement, [], BR);
            };
            BR.prototype = HTMLLIElement.prototype;
            var is = 'extends-br';
            self.customElements.define('extends-br', BR, {
                'extends': 'br'
            });
            legacy = document$1.createElement('br', {
                is: is
            }).outerHTML.indexOf(is) < 0;
            var _self$customElements = self.customElements, get = _self$customElements.get, _whenDefined = _self$customElements.whenDefined;
            self.customElements.whenDefined = function(is) {
                var _this = this;
                return _whenDefined.call(this, is).then(function(Class) {
                    return Class || get.call(_this, is);
                });
            };
        } catch (o_O) {}
    }
    if (legacy) {
        var _parseShadow = function _parseShadow(element) {
            var root = shadowRoots.get(element);
            _parse(root.querySelectorAll(this), element.isConnected);
        };
        var customElements = self.customElements;
        var _createElement = document$1.createElement;
        var define = customElements.define, _get = customElements.get, upgrade = customElements.upgrade;
        var _ref = Reflect || {
            construct: function construct(HTMLElement) {
                return HTMLElement.call(this);
            }
        }, construct = _ref.construct;
        var shadowRoots = new WeakMap();
        var shadows = new Set$1();
        var _classes = new Map();
        var _defined = new Map();
        var _prototypes = new Map();
        var _registry = new Map();
        var shadowed = [];
        var _query = [];
        var getCE = function getCE(is) {
            return _registry.get(is) || _get.call(customElements, is);
        };
        var _handle = function _handle(element, connected, selector) {
            var proto = _prototypes.get(selector);
            if (connected && !proto.isPrototypeOf(element)) {
                var redefine = expando(element);
                _override = setPrototypeOf(element, proto);
                try {
                    new proto.constructor();
                } finally{
                    _override = null;
                    redefine();
                }
            }
            var method = "".concat(connected ? '' : 'dis', "connectedCallback");
            if (method in proto) element[method]();
        };
        var _qsaObserver2 = qsaObserver({
            query: _query,
            handle: _handle
        }), _parse = _qsaObserver2.parse;
        var _qsaObserver3 = qsaObserver({
            query: shadowed,
            handle: function handle(element, connected) {
                if (shadowRoots.has(element)) {
                    if (connected) shadows.add(element);
                    else shadows["delete"](element);
                    if (_query.length) _parseShadow.call(_query, element);
                }
            }
        }), parseShadowed = _qsaObserver3.parse;
        // qsaObserver also patches attachShadow
        // be sure this runs *after* that
        var attachShadow = Element.prototype.attachShadow;
        if (attachShadow) Element.prototype.attachShadow = function(init) {
            var root = attachShadow.call(this, init);
            shadowRoots.set(this, root);
            return root;
        };
        var _whenDefined2 = function _whenDefined2(name) {
            if (!_defined.has(name)) {
                var _, $ = new Promise(function($) {
                    _ = $;
                });
                _defined.set(name, {
                    $: $,
                    _: _
                });
            }
            return _defined.get(name).$;
        };
        var _augment = attributesObserver(_whenDefined2, MutationObserver$1);
        var _override = null;
        getOwnPropertyNames(self).filter(function(k) {
            return /^HTML.*Element$/.test(k);
        }).forEach(function(k) {
            var HTMLElement = self[k];
            function HTMLBuiltIn() {
                var constructor = this.constructor;
                if (!_classes.has(constructor)) throw new TypeError$1('Illegal constructor');
                var _classes$get = _classes.get(constructor), is = _classes$get.is, tag = _classes$get.tag;
                if (is) {
                    if (_override) return _augment(_override, is);
                    var element = _createElement.call(document$1, tag);
                    element.setAttribute('is', is);
                    return _augment(setPrototypeOf(element, constructor.prototype), is);
                } else return construct.call(this, HTMLElement, [], constructor);
            }
            defineProperty(HTMLBuiltIn.prototype = HTMLElement.prototype, 'constructor', {
                value: HTMLBuiltIn
            });
            defineProperty(self, k, {
                value: HTMLBuiltIn
            });
        });
        document$1.createElement = function(name, options) {
            var is = options && options.is;
            if (is) {
                var Class = _registry.get(is);
                if (Class && _classes.get(Class).tag === name) return new Class();
            }
            var element = _createElement.call(document$1, name);
            if (is) element.setAttribute('is', is);
            return element;
        };
        customElements.get = getCE;
        customElements.whenDefined = _whenDefined2;
        customElements.upgrade = function(element) {
            var is = element.getAttribute('is');
            if (is) {
                var _constructor = _registry.get(is);
                if (_constructor) {
                    _augment(setPrototypeOf(element, _constructor.prototype), is);
                    // apparently unnecessary because this is handled by qsa observer
                    // if (element.isConnected && element.connectedCallback)
                    //   element.connectedCallback();
                    return;
                }
            }
            upgrade.call(customElements, element);
        };
        customElements.define = function(is, Class, options) {
            if (getCE(is)) throw new Error("'".concat(is, "' has already been defined as a custom element"));
            var selector;
            var tag = options && options["extends"];
            _classes.set(Class, tag ? {
                is: is,
                tag: tag
            } : {
                is: '',
                tag: is
            });
            if (tag) {
                selector = "".concat(tag, "[is=\"").concat(is, "\"]");
                _prototypes.set(selector, Class.prototype);
                _registry.set(is, Class);
                _query.push(selector);
            } else {
                define.apply(customElements, arguments);
                shadowed.push(selector = is);
            }
            _whenDefined2(is).then(function() {
                if (tag) {
                    _parse(document$1.querySelectorAll(selector));
                    shadows.forEach(_parseShadow, [
                        selector
                    ]);
                } else parseShadowed(document$1.querySelectorAll(selector));
            });
            _defined.get(is)._(Class);
        };
    }
})();


const $a7f559d5d89c892f$export$6d3c090e66a883b1 = ()=>undefined;


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c38e0f42709c826a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $c38e0f42709c826a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$getDefaultsFromGlobal = ()=>$c38e0f42709c826a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $c38e0f42709c826a$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $cfae44f0dfdf62c0$exports === 'undefined' || typeof $cfae44f0dfdf62c0$exports.env === 'undefined') return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $c38e0f42709c826a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $c38e0f42709c826a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $c38e0f42709c826a$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $a7f559d5d89c892f$export$6d3c090e66a883b1)() || $c38e0f42709c826a$var$getDefaultsFromGlobal() || $c38e0f42709c826a$var$getDefaultsFromEnvVariable() || $c38e0f42709c826a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $c38e0f42709c826a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $c38e0f42709c826a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $c38e0f42709c826a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $c38e0f42709c826a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $c38e0f42709c826a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $c38e0f42709c826a$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $c38e0f42709c826a$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $c38e0f42709c826a$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || '');
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c38e0f42709c826a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $c38e0f42709c826a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    'debug': $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    'verbose': $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    'info': $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    'warn': $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    'error': $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    'silent': $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: 'info',
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: 'warn',
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $57d436074e210fb5$var$name$q = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.11.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/app');
const $57d436074e210fb5$var$name$p = "@firebase/app-compat";
const $57d436074e210fb5$var$name$o = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$n = "@firebase/analytics";
const $57d436074e210fb5$var$name$m = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$l = "@firebase/app-check";
const $57d436074e210fb5$var$name$k = "@firebase/auth";
const $57d436074e210fb5$var$name$j = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$i = "@firebase/database";
const $57d436074e210fb5$var$name$h = "@firebase/data-connect";
const $57d436074e210fb5$var$name$g = "@firebase/database-compat";
const $57d436074e210fb5$var$name$f = "@firebase/functions";
const $57d436074e210fb5$var$name$e = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$d = "@firebase/installations";
const $57d436074e210fb5$var$name$c = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$b = "@firebase/messaging";
const $57d436074e210fb5$var$name$a = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$9 = "@firebase/performance";
const $57d436074e210fb5$var$name$8 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$7 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$5 = "@firebase/storage";
const $57d436074e210fb5$var$name$4 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$3 = "@firebase/firestore";
const $57d436074e210fb5$var$name$2 = "@firebase/vertexai";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "11.5.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = '[DEFAULT]';
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$q]: 'fire-core',
    [$57d436074e210fb5$var$name$p]: 'fire-core-compat',
    [$57d436074e210fb5$var$name$n]: 'fire-analytics',
    [$57d436074e210fb5$var$name$o]: 'fire-analytics-compat',
    [$57d436074e210fb5$var$name$l]: 'fire-app-check',
    [$57d436074e210fb5$var$name$m]: 'fire-app-check-compat',
    [$57d436074e210fb5$var$name$k]: 'fire-auth',
    [$57d436074e210fb5$var$name$j]: 'fire-auth-compat',
    [$57d436074e210fb5$var$name$i]: 'fire-rtdb',
    [$57d436074e210fb5$var$name$h]: 'fire-data-connect',
    [$57d436074e210fb5$var$name$g]: 'fire-rtdb-compat',
    [$57d436074e210fb5$var$name$f]: 'fire-fn',
    [$57d436074e210fb5$var$name$e]: 'fire-fn-compat',
    [$57d436074e210fb5$var$name$d]: 'fire-iid',
    [$57d436074e210fb5$var$name$c]: 'fire-iid-compat',
    [$57d436074e210fb5$var$name$b]: 'fire-fcm',
    [$57d436074e210fb5$var$name$a]: 'fire-fcm-compat',
    [$57d436074e210fb5$var$name$9]: 'fire-perf',
    [$57d436074e210fb5$var$name$8]: 'fire-perf-compat',
    [$57d436074e210fb5$var$name$7]: 'fire-rc',
    [$57d436074e210fb5$var$name$6]: 'fire-rc-compat',
    [$57d436074e210fb5$var$name$5]: 'fire-gcs',
    [$57d436074e210fb5$var$name$4]: 'fire-gcs-compat',
    [$57d436074e210fb5$var$name$3]: 'fire-fst',
    [$57d436074e210fb5$var$name$1]: 'fire-fst-compat',
    [$57d436074e210fb5$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$57d436074e210fb5$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $57d436074e210fb5$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $57d436074e210fb5$export$fb03ad8d3d5c5f76.values())$57d436074e210fb5$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $57d436074e210fb5$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $57d436074e210fb5$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('app', 'Firebase', $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $57d436074e210fb5$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $c38e0f42709c826a$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $57d436074e210fb5$var$FirebaseServerAppImpl extends $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $57d436074e210fb5$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $57d436074e210fb5$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$q, $57d436074e210fb5$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $57d436074e210fb5$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $c38e0f42709c826a$export$3dfb6827a9f89756)());
    if (!options) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $57d436074e210fb5$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $c38e0f42709c826a$export$4e09c449d6c407f7)() && !(0, $c38e0f42709c826a$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($57d436074e210fb5$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $57d436074e210fb5$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $57d436074e210fb5$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(nameString);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $57d436074e210fb5$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $57d436074e210fb5$export$9f30fa0c10967f7f && (0, $c38e0f42709c826a$export$3dfb6827a9f89756)()) return $57d436074e210fb5$export$c55cfd413944906d();
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
    } else if ($57d436074e210fb5$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $57d436074e210fb5$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(' '));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = 'firebase-heartbeat-database';
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = 'firebase-heartbeat-store';
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME);
        const result = await tx.objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
const $57d436074e210fb5$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $57d436074e210fb5$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $57d436074e210fb5$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $57d436074e210fb5$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $57d436074e210fb5$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $57d436074e210fb5$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $c38e0f42709c826a$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $57d436074e210fb5$var$logger.warn(e);
            return '';
        }
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
        else return (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $c38e0f42709c826a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $57d436074e210fb5$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('platform-logger', (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('heartbeat', (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$q, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$q, $57d436074e210fb5$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents('');




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $fce0788c2e4d699f$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $fce0788c2e4d699f$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $fce0788c2e4d699f$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $fce0788c2e4d699f$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $fce0788c2e4d699f$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $fce0788c2e4d699f$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $fce0788c2e4d699f$export$2329c99376c9d0a4 = $fce0788c2e4d699f$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $fce0788c2e4d699f$export$7f8ddf7c7c20b3cd = $fce0788c2e4d699f$var$_prodErrorMap;
const $fce0788c2e4d699f$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $fce0788c2e4d699f$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $fce0788c2e4d699f$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/auth');
function $fce0788c2e4d699f$var$_logWarn(msg, ...args) {
    if ($fce0788c2e4d699f$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) $fce0788c2e4d699f$var$logClient.warn(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $fce0788c2e4d699f$var$_logError(msg, ...args) {
    if ($fce0788c2e4d699f$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) $fce0788c2e4d699f$var$logClient.error(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $fce0788c2e4d699f$var$createErrorInternal(authOrCode, ...rest);
}
function $fce0788c2e4d699f$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $fce0788c2e4d699f$var$createErrorInternal(authOrCode, ...rest);
}
function $fce0788c2e4d699f$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $fce0788c2e4d699f$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $fce0788c2e4d699f$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $fce0788c2e4d699f$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $fce0788c2e4d699f$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $fce0788c2e4d699f$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $fce0788c2e4d699f$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $fce0788c2e4d699f$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $fce0788c2e4d699f$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $fce0788c2e4d699f$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $fce0788c2e4d699f$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $fce0788c2e4d699f$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $fce0788c2e4d699f$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $fce0788c2e4d699f$var$_isHttpOrHttps() {
    return $fce0788c2e4d699f$var$_getCurrentScheme() === 'http:' || $fce0788c2e4d699f$var$_getCurrentScheme() === 'https:';
}
function $fce0788c2e4d699f$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $fce0788c2e4d699f$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($fce0788c2e4d699f$var$_isHttpOrHttps() || (0, $c38e0f42709c826a$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $fce0788c2e4d699f$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $fce0788c2e4d699f$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $fce0788c2e4d699f$export$1fbe638ecf81657e(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $c38e0f42709c826a$export$872f8323f01d7ae0)() || (0, $c38e0f42709c826a$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$fce0788c2e4d699f$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$_emulatorUrl(config, path) {
    $fce0788c2e4d699f$export$1fbe638ecf81657e(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $fce0788c2e4d699f$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $fce0788c2e4d699f$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $fce0788c2e4d699f$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $fce0788c2e4d699f$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$DEFAULT_API_TIMEOUT_MS = new $fce0788c2e4d699f$var$Delay(30000, 60000);
function $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $fce0788c2e4d699f$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $fce0788c2e4d699f$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $c38e0f42709c826a$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $c38e0f42709c826a$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        return $fce0788c2e4d699f$export$2ed0fc6709e59212.fetch()($fce0788c2e4d699f$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $fce0788c2e4d699f$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $fce0788c2e4d699f$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $fce0788c2e4d699f$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $fce0788c2e4d699f$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $fce0788c2e4d699f$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $fce0788c2e4d699f$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $fce0788c2e4d699f$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $fce0788c2e4d699f$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $fce0788c2e4d699f$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $fce0788c2e4d699f$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $fce0788c2e4d699f$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $fce0788c2e4d699f$var$_emulatorUrl(auth.config, base);
}
function $fce0788c2e4d699f$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $fce0788c2e4d699f$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($fce0788c2e4d699f$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $fce0788c2e4d699f$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $fce0788c2e4d699f$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $fce0788c2e4d699f$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $fce0788c2e4d699f$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $fce0788c2e4d699f$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $fce0788c2e4d699f$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$getRecaptchaParams(auth) {
    return (await $fce0788c2e4d699f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $fce0788c2e4d699f$var$getRecaptchaConfig(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$deleteAccount(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $fce0788c2e4d699f$var$deleteLinkedAccounts(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $fce0788c2e4d699f$var$getAccountInfo(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $fce0788c2e4d699f$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $fce0788c2e4d699f$var$_parseToken(token);
    $fce0788c2e4d699f$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $fce0788c2e4d699f$var$utcTimestampToDateString($fce0788c2e4d699f$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $fce0788c2e4d699f$var$utcTimestampToDateString($fce0788c2e4d699f$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $fce0788c2e4d699f$var$utcTimestampToDateString($fce0788c2e4d699f$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $fce0788c2e4d699f$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $fce0788c2e4d699f$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $fce0788c2e4d699f$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $c38e0f42709c826a$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $fce0788c2e4d699f$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $fce0788c2e4d699f$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $fce0788c2e4d699f$var$_tokenExpiresIn(token) {
    const parsedToken = $fce0788c2e4d699f$var$_parseToken(token);
    $fce0788c2e4d699f$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $fce0788c2e4d699f$export$890c4ad488842ce7(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $fce0788c2e4d699f$export$890c4ad488842ce7(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && $fce0788c2e4d699f$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $fce0788c2e4d699f$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $fce0788c2e4d699f$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $fce0788c2e4d699f$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $fce0788c2e4d699f$var$_logoutIfInvalidated(user, $fce0788c2e4d699f$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $fce0788c2e4d699f$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $fce0788c2e4d699f$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $fce0788c2e4d699f$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $fce0788c2e4d699f$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$d24c54395ce0c509(user) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $fce0788c2e4d699f$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $fce0788c2e4d699f$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $fce0788c2e4d699f$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$requestStsToken(auth, refreshToken) {
    const response = await $fce0788c2e4d699f$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $c38e0f42709c826a$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $fce0788c2e4d699f$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        return $fce0788c2e4d699f$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $fce0788c2e4d699f$var$revokeToken(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $fce0788c2e4d699f$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $fce0788c2e4d699f$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $fce0788c2e4d699f$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $fce0788c2e4d699f$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $fce0788c2e4d699f$var$StsTokenManager();
        if (refreshToken) {
            $fce0788c2e4d699f$export$890c4ad488842ce7(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $fce0788c2e4d699f$export$890c4ad488842ce7(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $fce0788c2e4d699f$export$890c4ad488842ce7(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $fce0788c2e4d699f$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $fce0788c2e4d699f$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$assertStringOrUndefined(assertion, appName) {
    $fce0788c2e4d699f$export$890c4ad488842ce7(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $fce0788c2e4d699f$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $fce0788c2e4d699f$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $fce0788c2e4d699f$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $fce0788c2e4d699f$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $fce0788c2e4d699f$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $fce0788c2e4d699f$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $fce0788c2e4d699f$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $fce0788c2e4d699f$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $fce0788c2e4d699f$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $fce0788c2e4d699f$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $fce0788c2e4d699f$var$_logoutIfInvalidated(this, $fce0788c2e4d699f$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $fce0788c2e4d699f$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $fce0788c2e4d699f$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $fce0788c2e4d699f$var$assertStringOrUndefined(displayName, auth.name);
        $fce0788c2e4d699f$var$assertStringOrUndefined(email, auth.name);
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $fce0788c2e4d699f$var$assertStringOrUndefined(phoneNumber, auth.name);
        $fce0788c2e4d699f$var$assertStringOrUndefined(photoURL, auth.name);
        $fce0788c2e4d699f$var$assertStringOrUndefined(tenantId, auth.name);
        $fce0788c2e4d699f$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $fce0788c2e4d699f$var$assertStringOrUndefined(createdAt, auth.name);
        $fce0788c2e4d699f$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $fce0788c2e4d699f$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $fce0788c2e4d699f$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $fce0788c2e4d699f$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $fce0788c2e4d699f$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $fce0788c2e4d699f$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $fce0788c2e4d699f$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $fce0788c2e4d699f$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $fce0788c2e4d699f$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $fce0788c2e4d699f$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$instanceCache = new Map();
function $fce0788c2e4d699f$export$158acd800e1ef08b(cls) {
    $fce0788c2e4d699f$export$1fbe638ecf81657e(cls instanceof Function, 'Expected a class definition');
    let instance = $fce0788c2e4d699f$var$instanceCache.get(cls);
    if (instance) {
        $fce0788c2e4d699f$export$1fbe638ecf81657e(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $fce0788c2e4d699f$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$fce0788c2e4d699f$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $fce0788c2e4d699f$export$3a6d5c9ae78a2c08 = $fce0788c2e4d699f$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $fce0788c2e4d699f$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $fce0788c2e4d699f$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $fce0788c2e4d699f$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $fce0788c2e4d699f$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $fce0788c2e4d699f$var$PersistenceUserManager($fce0788c2e4d699f$export$158acd800e1ef08b($fce0788c2e4d699f$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $fce0788c2e4d699f$export$158acd800e1ef08b($fce0788c2e4d699f$export$3a6d5c9ae78a2c08);
        const key = $fce0788c2e4d699f$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $fce0788c2e4d699f$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $fce0788c2e4d699f$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $fce0788c2e4d699f$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $fce0788c2e4d699f$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($fce0788c2e4d699f$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($fce0788c2e4d699f$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($fce0788c2e4d699f$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($fce0788c2e4d699f$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($fce0788c2e4d699f$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $fce0788c2e4d699f$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($fce0788c2e4d699f$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $fce0788c2e4d699f$var$_isFirefox(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $fce0788c2e4d699f$var$_isSafari(userAgent = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $fce0788c2e4d699f$var$_isChromeIOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $fce0788c2e4d699f$var$_isIEMobile(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $fce0788c2e4d699f$export$92108d983e8ee699(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $fce0788c2e4d699f$var$_isBlackBerry(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $fce0788c2e4d699f$var$_isWebOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $fce0788c2e4d699f$export$d66dc83d8cfc8dd(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $fce0788c2e4d699f$export$91c6e00c14e7e6fd(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $fce0788c2e4d699f$var$_isIOSStandalone(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    var _a;
    return $fce0788c2e4d699f$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $fce0788c2e4d699f$var$_isIE10() {
    return (0, $c38e0f42709c826a$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $fce0788c2e4d699f$var$_isMobileBrowser(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $fce0788c2e4d699f$export$d66dc83d8cfc8dd(ua) || $fce0788c2e4d699f$export$92108d983e8ee699(ua) || $fce0788c2e4d699f$var$_isWebOS(ua) || $fce0788c2e4d699f$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $fce0788c2e4d699f$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $fce0788c2e4d699f$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $fce0788c2e4d699f$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$fce0788c2e4d699f$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $57d436074e210fb5$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $fce0788c2e4d699f$var$_getPasswordPolicy(auth, request = {}) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $fce0788c2e4d699f$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $fce0788c2e4d699f$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $fce0788c2e4d699f$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $fce0788c2e4d699f$var$Subscription(this);
        this.idTokenSubscription = new $fce0788c2e4d699f$var$Subscription(this);
        this.beforeStateQueue = new $fce0788c2e4d699f$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $fce0788c2e4d699f$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $fce0788c2e4d699f$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $fce0788c2e4d699f$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $fce0788c2e4d699f$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $fce0788c2e4d699f$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $fce0788c2e4d699f$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $fce0788c2e4d699f$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $fce0788c2e4d699f$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $fce0788c2e4d699f$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $fce0788c2e4d699f$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($fce0788c2e4d699f$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $fce0788c2e4d699f$var$_getPasswordPolicy(this);
        const passwordPolicy = new $fce0788c2e4d699f$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $fce0788c2e4d699f$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $fce0788c2e4d699f$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $fce0788c2e4d699f$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $fce0788c2e4d699f$var$PersistenceUserManager.create(this, [
                $fce0788c2e4d699f$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $fce0788c2e4d699f$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $fce0788c2e4d699f$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $fce0788c2e4d699f$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $fce0788c2e4d699f$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $c38e0f42709c826a$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $fce0788c2e4d699f$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $fce0788c2e4d699f$var$_setExternalJSProvider(p) {
    $fce0788c2e4d699f$var$externalJSProvider = p;
}
function $fce0788c2e4d699f$var$_loadJS(url) {
    return $fce0788c2e4d699f$var$externalJSProvider.loadJS(url);
}
function $fce0788c2e4d699f$var$_recaptchaV2ScriptUrl() {
    return $fce0788c2e4d699f$var$externalJSProvider.recaptchaV2Script;
}
function $fce0788c2e4d699f$var$_recaptchaEnterpriseScriptUrl() {
    return $fce0788c2e4d699f$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $fce0788c2e4d699f$var$_gapiScriptUrl() {
    return $fce0788c2e4d699f$var$externalJSProvider.gapiScript;
}
function $fce0788c2e4d699f$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$_SOLVE_TIME_MS = 500;
const $fce0788c2e4d699f$var$_EXPIRATION_TIME_MS = 60000;
const $fce0788c2e4d699f$var$_WIDGET_ID_START = 1000000000000;
class $fce0788c2e4d699f$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $fce0788c2e4d699f$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $fce0788c2e4d699f$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $fce0788c2e4d699f$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $fce0788c2e4d699f$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $fce0788c2e4d699f$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $fce0788c2e4d699f$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $fce0788c2e4d699f$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $fce0788c2e4d699f$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $fce0788c2e4d699f$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $fce0788c2e4d699f$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $fce0788c2e4d699f$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $fce0788c2e4d699f$var$_EXPIRATION_TIME_MS);
        }, $fce0788c2e4d699f$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $fce0788c2e4d699f$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $fce0788c2e4d699f$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $fce0788c2e4d699f$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $fce0788c2e4d699f$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $fce0788c2e4d699f$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $fce0788c2e4d699f$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $fce0788c2e4d699f$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $fce0788c2e4d699f$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($fce0788c2e4d699f$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($fce0788c2e4d699f$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $fce0788c2e4d699f$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $fce0788c2e4d699f$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $fce0788c2e4d699f$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $fce0788c2e4d699f$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $fce0788c2e4d699f$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $fce0788c2e4d699f$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $fce0788c2e4d699f$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $fce0788c2e4d699f$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    var _a, _b;
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $fce0788c2e4d699f$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $fce0788c2e4d699f$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if ((_b = authInstance._getRecaptchaConfig()) === null || _b === void 0 ? void 0 : _b.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $fce0788c2e4d699f$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                var _a;
                if (((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $fce0788c2e4d699f$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $fce0788c2e4d699f$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $fce0788c2e4d699f$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const response = await $fce0788c2e4d699f$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $fce0788c2e4d699f$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $fce0788c2e4d699f$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $fce0788c2e4d699f$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $fce0788c2e4d699f$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($fce0788c2e4d699f$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $fce0788c2e4d699f$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    $fce0788c2e4d699f$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $fce0788c2e4d699f$var$extractProtocol(url);
    const { host: host, port: port } = $fce0788c2e4d699f$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $fce0788c2e4d699f$export$890c4ad488842ce7(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $fce0788c2e4d699f$export$890c4ad488842ce7((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    if (!disableWarnings) $fce0788c2e4d699f$var$emitEmulatorWarning();
}
function $fce0788c2e4d699f$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $fce0788c2e4d699f$var$extractHostAndPort(url) {
    const protocol = $fce0788c2e4d699f$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $fce0788c2e4d699f$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $fce0788c2e4d699f$var$parsePort(port)
        };
    }
}
function $fce0788c2e4d699f$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $fce0788c2e4d699f$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $fce0788c2e4d699f$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $fce0788c2e4d699f$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $fce0788c2e4d699f$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $fce0788c2e4d699f$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $fce0788c2e4d699f$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$resetPassword(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
async function $fce0788c2e4d699f$var$updateEmailPassword(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $fce0788c2e4d699f$var$linkEmailPassword(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $fce0788c2e4d699f$var$applyActionCode$1(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$signInWithPassword(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
async function $fce0788c2e4d699f$var$sendOobCode(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
async function $fce0788c2e4d699f$var$sendEmailVerification$1(auth, request) {
    return $fce0788c2e4d699f$var$sendOobCode(auth, request);
}
async function $fce0788c2e4d699f$var$sendPasswordResetEmail$1(auth, request) {
    return $fce0788c2e4d699f$var$sendOobCode(auth, request);
}
async function $fce0788c2e4d699f$var$sendSignInLinkToEmail$1(auth, request) {
    return $fce0788c2e4d699f$var$sendOobCode(auth, request);
}
async function $fce0788c2e4d699f$var$verifyAndChangeEmail(auth, request) {
    return $fce0788c2e4d699f$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$signInWithEmailLink$1(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
async function $fce0788c2e4d699f$var$signInWithEmailLinkForLinking(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $fce0788c2e4d699f$export$3a1a48c8f6ef640e extends $fce0788c2e4d699f$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $fce0788c2e4d699f$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $fce0788c2e4d699f$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $fce0788c2e4d699f$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $fce0788c2e4d699f$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $fce0788c2e4d699f$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $fce0788c2e4d699f$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $fce0788c2e4d699f$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $fce0788c2e4d699f$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$signInWithIdp(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $fce0788c2e4d699f$export$a07804094c3ecf2d extends $fce0788c2e4d699f$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $fce0788c2e4d699f$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $fce0788c2e4d699f$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $fce0788c2e4d699f$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $fce0788c2e4d699f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $fce0788c2e4d699f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $fce0788c2e4d699f$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $fce0788c2e4d699f$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $c38e0f42709c826a$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$sendPhoneVerificationCode(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
async function $fce0788c2e4d699f$var$signInWithPhoneNumber$1(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
async function $fce0788c2e4d699f$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $fce0788c2e4d699f$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $fce0788c2e4d699f$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $fce0788c2e4d699f$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, apiRequest), $fce0788c2e4d699f$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $fce0788c2e4d699f$export$3722cfe417b6ed86 extends $fce0788c2e4d699f$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $fce0788c2e4d699f$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $fce0788c2e4d699f$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $fce0788c2e4d699f$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $fce0788c2e4d699f$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $fce0788c2e4d699f$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $fce0788c2e4d699f$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $fce0788c2e4d699f$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $fce0788c2e4d699f$var$parseDeepLink(url) {
    const link = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $fce0788c2e4d699f$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $fce0788c2e4d699f$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $fce0788c2e4d699f$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $fce0788c2e4d699f$var$parseDeepLink(link);
        try {
            return new $fce0788c2e4d699f$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $fce0788c2e4d699f$export$3b513254972cfc9c(link) {
    return $fce0788c2e4d699f$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $fce0788c2e4d699f$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $fce0788c2e4d699f$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $fce0788c2e4d699f$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $fce0788c2e4d699f$export$f38c853ae54ed474.parseLink(emailLink);
        $fce0788c2e4d699f$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $fce0788c2e4d699f$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $fce0788c2e4d699f$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $fce0788c2e4d699f$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $fce0788c2e4d699f$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $fce0788c2e4d699f$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $fce0788c2e4d699f$var$BaseOAuthProvider extends $fce0788c2e4d699f$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $fce0788c2e4d699f$export$dc98b0b04f4c7758 extends $fce0788c2e4d699f$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $fce0788c2e4d699f$export$890c4ad488842ce7('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $fce0788c2e4d699f$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $fce0788c2e4d699f$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $fce0788c2e4d699f$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $fce0788c2e4d699f$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $fce0788c2e4d699f$export$71cec2538cb2c617 extends $fce0788c2e4d699f$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $fce0788c2e4d699f$export$a07804094c3ecf2d._fromParams({
            providerId: $fce0788c2e4d699f$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $fce0788c2e4d699f$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $fce0788c2e4d699f$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $fce0788c2e4d699f$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $fce0788c2e4d699f$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $fce0788c2e4d699f$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $fce0788c2e4d699f$export$78acf4525d8a74c4 extends $fce0788c2e4d699f$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $fce0788c2e4d699f$export$a07804094c3ecf2d._fromParams({
            providerId: $fce0788c2e4d699f$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $fce0788c2e4d699f$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $fce0788c2e4d699f$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $fce0788c2e4d699f$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $fce0788c2e4d699f$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $fce0788c2e4d699f$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $fce0788c2e4d699f$export$8743009a87fcb00f extends $fce0788c2e4d699f$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $fce0788c2e4d699f$export$a07804094c3ecf2d._fromParams({
            providerId: $fce0788c2e4d699f$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $fce0788c2e4d699f$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $fce0788c2e4d699f$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $fce0788c2e4d699f$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $fce0788c2e4d699f$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $fce0788c2e4d699f$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $fce0788c2e4d699f$export$f96d196f7728bb5 extends $fce0788c2e4d699f$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $fce0788c2e4d699f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $fce0788c2e4d699f$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $fce0788c2e4d699f$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $fce0788c2e4d699f$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $fce0788c2e4d699f$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $fce0788c2e4d699f$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $fce0788c2e4d699f$export$71511d61b312f219 extends $fce0788c2e4d699f$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $fce0788c2e4d699f$export$890c4ad488842ce7(providerId.startsWith($fce0788c2e4d699f$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $fce0788c2e4d699f$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $fce0788c2e4d699f$export$f96d196f7728bb5.fromJSON(json);
        $fce0788c2e4d699f$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $fce0788c2e4d699f$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $fce0788c2e4d699f$export$3d8c2f653ac9d0b9 extends $fce0788c2e4d699f$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $fce0788c2e4d699f$export$a07804094c3ecf2d._fromParams({
            providerId: $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $fce0788c2e4d699f$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$signUp(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $fce0788c2e4d699f$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $fce0788c2e4d699f$var$providerIdForResponse(idTokenResponse);
        const userCred = new $fce0788c2e4d699f$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $fce0788c2e4d699f$var$providerIdForResponse(response);
        return new $fce0788c2e4d699f$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $fce0788c2e4d699f$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $fce0788c2e4d699f$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $fce0788c2e4d699f$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $fce0788c2e4d699f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$MultiFactorError extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $fce0788c2e4d699f$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $fce0788c2e4d699f$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $fce0788c2e4d699f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $fce0788c2e4d699f$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $fce0788c2e4d699f$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $fce0788c2e4d699f$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $fce0788c2e4d699f$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $fce0788c2e4d699f$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $fce0788c2e4d699f$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $fce0788c2e4d699f$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $fce0788c2e4d699f$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $fce0788c2e4d699f$var$_assertLinkedStatus(expected, user, provider) {
    await $fce0788c2e4d699f$var$_reloadWithoutSaving(user);
    const providerIds = $fce0788c2e4d699f$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $fce0788c2e4d699f$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $fce0788c2e4d699f$var$_logoutIfInvalidated(user, $fce0788c2e4d699f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $fce0788c2e4d699f$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $fce0788c2e4d699f$var$_parseToken(response.idToken);
        $fce0788c2e4d699f$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $fce0788c2e4d699f$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $fce0788c2e4d699f$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $fce0788c2e4d699f$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $fce0788c2e4d699f$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$3c2fa207a37baaea(auth, credential) {
    return $fce0788c2e4d699f$var$_signInWithCredential($fce0788c2e4d699f$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $fce0788c2e4d699f$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $fce0788c2e4d699f$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$6559d589eb85fbb6(user, credential) {
    return $fce0788c2e4d699f$var$_reauthenticate((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$signInWithCustomToken$1(auth, request) {
    return $fce0788c2e4d699f$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const response = await $fce0788c2e4d699f$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $fce0788c2e4d699f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $fce0788c2e4d699f$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $fce0788c2e4d699f$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $fce0788c2e4d699f$var$PhoneMultiFactorInfoImpl extends $fce0788c2e4d699f$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $fce0788c2e4d699f$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $fce0788c2e4d699f$var$TotpMultiFactorInfoImpl extends $fce0788c2e4d699f$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $fce0788c2e4d699f$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $fce0788c2e4d699f$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $fce0788c2e4d699f$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $fce0788c2e4d699f$export$890c4ad488842ce7(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $fce0788c2e4d699f$var$recachePasswordPolicy(auth) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $fce0788c2e4d699f$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $fce0788c2e4d699f$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $fce0788c2e4d699f$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $fce0788c2e4d699f$var$resetPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $fce0788c2e4d699f$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$a93c5207d687da10(auth, oobCode) {
    await $fce0788c2e4d699f$var$applyActionCode$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const response = await $fce0788c2e4d699f$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $fce0788c2e4d699f$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $fce0788c2e4d699f$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $fce0788c2e4d699f$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $fce0788c2e4d699f$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $fce0788c2e4d699f$var$MultiFactorInfoImpl._fromServerResponse($fce0788c2e4d699f$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $fce0788c2e4d699f$export$c3950d9923825c02((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $fce0788c2e4d699f$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $fce0788c2e4d699f$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $fce0788c2e4d699f$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $fce0788c2e4d699f$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $fce0788c2e4d699f$export$555508cbc6add439(auth, email, password) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $fce0788c2e4d699f$export$3c2fa207a37baaea((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), $fce0788c2e4d699f$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $fce0788c2e4d699f$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $fce0788c2e4d699f$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $fce0788c2e4d699f$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $fce0788c2e4d699f$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $fce0788c2e4d699f$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $fce0788c2e4d699f$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const credential = $fce0788c2e4d699f$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $fce0788c2e4d699f$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $fce0788c2e4d699f$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $fce0788c2e4d699f$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$createAuthUri(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $fce0788c2e4d699f$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $fce0788c2e4d699f$var$_isHttpOrHttps() ? $fce0788c2e4d699f$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $fce0788c2e4d699f$var$createAuthUri((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $fce0788c2e4d699f$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $fce0788c2e4d699f$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $fce0788c2e4d699f$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $fce0788c2e4d699f$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$var$updateProfile$1(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $fce0788c2e4d699f$var$_logoutIfInvalidated(userInternal, $fce0788c2e4d699f$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $fce0788c2e4d699f$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $fce0788c2e4d699f$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $fce0788c2e4d699f$export$1a82df3d29112e01(user, newPassword) {
    return $fce0788c2e4d699f$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $fce0788c2e4d699f$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $fce0788c2e4d699f$var$_logoutIfInvalidated(user, $fce0788c2e4d699f$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $fce0788c2e4d699f$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $fce0788c2e4d699f$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $fce0788c2e4d699f$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $fce0788c2e4d699f$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $fce0788c2e4d699f$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $fce0788c2e4d699f$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $fce0788c2e4d699f$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $fce0788c2e4d699f$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $fce0788c2e4d699f$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $fce0788c2e4d699f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $fce0788c2e4d699f$var$FederatedAdditionalUserInfoWithUsername extends $fce0788c2e4d699f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $fce0788c2e4d699f$var$FacebookAdditionalUserInfo extends $fce0788c2e4d699f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $fce0788c2e4d699f$var$GithubAdditionalUserInfo extends $fce0788c2e4d699f$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $fce0788c2e4d699f$var$GoogleAdditionalUserInfo extends $fce0788c2e4d699f$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $fce0788c2e4d699f$var$TwitterAdditionalUserInfo extends $fce0788c2e4d699f$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $fce0788c2e4d699f$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $fce0788c2e4d699f$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $fce0788c2e4d699f$export$9e5f44173e64f162(auth, persistence) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $fce0788c2e4d699f$export$625550452a3fa3ec(auth) {
    return $fce0788c2e4d699f$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$90a7f3efeed30595(auth, password) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $fce0788c2e4d699f$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $fce0788c2e4d699f$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $fce0788c2e4d699f$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $fce0788c2e4d699f$export$df995fae86a55f06(auth) {
    (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $fce0788c2e4d699f$export$ef35774e6d314e91(auth, user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $fce0788c2e4d699f$export$e7094788287c5e9b(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $fce0788c2e4d699f$export$96f57966bedc81b4(auth, token) {
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$a9c23c6ac3fc3eca(user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $fce0788c2e4d699f$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $fce0788c2e4d699f$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $fce0788c2e4d699f$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $fce0788c2e4d699f$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $fce0788c2e4d699f$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$fce0788c2e4d699f$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $fce0788c2e4d699f$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $fce0788c2e4d699f$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $fce0788c2e4d699f$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $fce0788c2e4d699f$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $fce0788c2e4d699f$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $fce0788c2e4d699f$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $fce0788c2e4d699f$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $fce0788c2e4d699f$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $fce0788c2e4d699f$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $fce0788c2e4d699f$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$startEnrollPhoneMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
function $fce0788c2e4d699f$var$finalizeEnrollPhoneMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
function $fce0788c2e4d699f$var$startEnrollTotpMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
function $fce0788c2e4d699f$var$finalizeEnrollTotpMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
function $fce0788c2e4d699f$var$withdrawMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
class $fce0788c2e4d699f$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$fce0788c2e4d699f$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $fce0788c2e4d699f$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $fce0788c2e4d699f$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $fce0788c2e4d699f$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $fce0788c2e4d699f$var$_logoutIfInvalidated(this.user, $fce0788c2e4d699f$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $fce0788c2e4d699f$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $fce0788c2e4d699f$export$493d36ec626b6698(user) {
    const userModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if (!$fce0788c2e4d699f$var$multiFactorUserCache.has(userModular)) $fce0788c2e4d699f$var$multiFactorUserCache.set(userModular, $fce0788c2e4d699f$var$MultiFactorUserImpl._fromUser(userModular));
    return $fce0788c2e4d699f$var$multiFactorUserCache.get(userModular);
}
const $fce0788c2e4d699f$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $fce0788c2e4d699f$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($fce0788c2e4d699f$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($fce0788c2e4d699f$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $fce0788c2e4d699f$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $fce0788c2e4d699f$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $fce0788c2e4d699f$var$BrowserLocalPersistence extends $fce0788c2e4d699f$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $fce0788c2e4d699f$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($fce0788c2e4d699f$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $fce0788c2e4d699f$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $fce0788c2e4d699f$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$fce0788c2e4d699f$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $fce0788c2e4d699f$export$8b22cf2602fb60ce = $fce0788c2e4d699f$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$BrowserSessionPersistence extends $fce0788c2e4d699f$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$fce0788c2e4d699f$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $fce0788c2e4d699f$export$407448d2b89b1813 = $fce0788c2e4d699f$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $fce0788c2e4d699f$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $fce0788c2e4d699f$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $fce0788c2e4d699f$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $fce0788c2e4d699f$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$fce0788c2e4d699f$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$export$faec65b429be379(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $fce0788c2e4d699f$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $fce0788c2e4d699f$export$faec65b429be379('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $fce0788c2e4d699f$var$_window() {
    return window;
}
function $fce0788c2e4d699f$var$_setWindowLocation(url) {
    $fce0788c2e4d699f$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$_isWorker() {
    return typeof $fce0788c2e4d699f$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $fce0788c2e4d699f$var$_window()['importScripts'] === 'function';
}
async function $fce0788c2e4d699f$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $fce0788c2e4d699f$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $fce0788c2e4d699f$var$_getWorkerGlobalScope() {
    return $fce0788c2e4d699f$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$DB_NAME = 'firebaseLocalStorageDb';
const $fce0788c2e4d699f$var$DB_VERSION = 1;
const $fce0788c2e4d699f$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $fce0788c2e4d699f$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $fce0788c2e4d699f$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $fce0788c2e4d699f$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $fce0788c2e4d699f$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($fce0788c2e4d699f$var$DB_OBJECTSTORE_NAME);
}
function $fce0788c2e4d699f$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($fce0788c2e4d699f$var$DB_NAME);
    return new $fce0788c2e4d699f$var$DBPromise(request).toPromise();
}
function $fce0788c2e4d699f$var$_openDatabase() {
    const request = indexedDB.open($fce0788c2e4d699f$var$DB_NAME, $fce0788c2e4d699f$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($fce0788c2e4d699f$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $fce0788c2e4d699f$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($fce0788c2e4d699f$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $fce0788c2e4d699f$var$_deleteDatabase();
                resolve(await $fce0788c2e4d699f$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $fce0788c2e4d699f$var$_putObject(db, key, value) {
    const request = $fce0788c2e4d699f$var$getObjectStore(db, true).put({
        [$fce0788c2e4d699f$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $fce0788c2e4d699f$var$DBPromise(request).toPromise();
}
async function $fce0788c2e4d699f$var$getObject(db, key) {
    const request = $fce0788c2e4d699f$var$getObjectStore(db, false).get(key);
    const data = await new $fce0788c2e4d699f$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $fce0788c2e4d699f$var$_deleteObject(db, key) {
    const request = $fce0788c2e4d699f$var$getObjectStore(db, true).delete(key);
    return new $fce0788c2e4d699f$var$DBPromise(request).toPromise();
}
const $fce0788c2e4d699f$var$_POLLING_INTERVAL_MS = 800;
const $fce0788c2e4d699f$var$_TRANSACTION_RETRY_COUNT = 3;
class $fce0788c2e4d699f$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $fce0788c2e4d699f$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $fce0788c2e4d699f$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $fce0788c2e4d699f$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $fce0788c2e4d699f$var$Receiver._getInstance($fce0788c2e4d699f$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $fce0788c2e4d699f$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $fce0788c2e4d699f$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $fce0788c2e4d699f$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $fce0788c2e4d699f$var$_openDatabase();
            await $fce0788c2e4d699f$var$_putObject(db, $fce0788c2e4d699f$var$STORAGE_AVAILABLE_KEY, '1');
            await $fce0788c2e4d699f$var$_deleteObject(db, $fce0788c2e4d699f$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$fce0788c2e4d699f$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$fce0788c2e4d699f$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$fce0788c2e4d699f$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $fce0788c2e4d699f$var$getObjectStore(db, false).getAll();
            return new $fce0788c2e4d699f$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $fce0788c2e4d699f$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$fce0788c2e4d699f$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $fce0788c2e4d699f$export$23f2a1d2818174ef = $fce0788c2e4d699f$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$startSignInPhoneMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
function $fce0788c2e4d699f$var$finalizeSignInPhoneMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
function $fce0788c2e4d699f$var$finalizeSignInTotpMfa(auth, request) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $fce0788c2e4d699f$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $fce0788c2e4d699f$var$_JSLOAD_CALLBACK = $fce0788c2e4d699f$var$_generateCallbackName('rcb');
const $fce0788c2e4d699f$var$NETWORK_TIMEOUT_DELAY = new $fce0788c2e4d699f$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $fce0788c2e4d699f$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $fce0788c2e4d699f$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $fce0788c2e4d699f$export$890c4ad488842ce7($fce0788c2e4d699f$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $fce0788c2e4d699f$var$isV2($fce0788c2e4d699f$var$_window().grecaptcha)) return Promise.resolve($fce0788c2e4d699f$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $fce0788c2e4d699f$var$_window().setTimeout(()=>{
                reject($fce0788c2e4d699f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $fce0788c2e4d699f$var$NETWORK_TIMEOUT_DELAY.get());
            $fce0788c2e4d699f$var$_window()[$fce0788c2e4d699f$var$_JSLOAD_CALLBACK] = ()=>{
                $fce0788c2e4d699f$var$_window().clearTimeout(networkTimeout);
                delete $fce0788c2e4d699f$var$_window()[$fce0788c2e4d699f$var$_JSLOAD_CALLBACK];
                const recaptcha = $fce0788c2e4d699f$var$_window().grecaptcha;
                if (!recaptcha || !$fce0788c2e4d699f$var$isV2(recaptcha)) {
                    reject($fce0788c2e4d699f$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$fce0788c2e4d699f$var$_recaptchaV2ScriptUrl()}?${(0, $c38e0f42709c826a$export$ac4103b836844853)({
                onload: $fce0788c2e4d699f$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $fce0788c2e4d699f$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($fce0788c2e4d699f$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $fce0788c2e4d699f$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $fce0788c2e4d699f$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $fce0788c2e4d699f$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $fce0788c2e4d699f$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $fce0788c2e4d699f$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $fce0788c2e4d699f$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $fce0788c2e4d699f$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $fce0788c2e4d699f$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $fce0788c2e4d699f$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $fce0788c2e4d699f$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $fce0788c2e4d699f$var$MockReCaptchaLoaderImpl() : new $fce0788c2e4d699f$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $fce0788c2e4d699f$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $fce0788c2e4d699f$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $fce0788c2e4d699f$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $fce0788c2e4d699f$export$890c4ad488842ce7($fce0788c2e4d699f$var$_isHttpOrHttps() && !$fce0788c2e4d699f$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $fce0788c2e4d699f$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $fce0788c2e4d699f$var$getRecaptchaParams(this.auth);
        $fce0788c2e4d699f$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $fce0788c2e4d699f$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $fce0788c2e4d699f$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const verificationId = await $fce0788c2e4d699f$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $fce0788c2e4d699f$var$ConfirmationResultImpl(verificationId, (cred)=>$fce0788c2e4d699f$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $fce0788c2e4d699f$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $fce0788c2e4d699f$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $fce0788c2e4d699f$var$ConfirmationResultImpl(verificationId, (cred)=>$fce0788c2e4d699f$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $fce0788c2e4d699f$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $fce0788c2e4d699f$var$ConfirmationResultImpl(verificationId, (cred)=>$fce0788c2e4d699f$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $fce0788c2e4d699f$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    if (!auth._getRecaptchaConfig()) try {
        await $fce0788c2e4d699f$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $fce0788c2e4d699f$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $fce0788c2e4d699f$var$FAKE_TOKEN) {
                        $fce0788c2e4d699f$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $fce0788c2e4d699f$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $fce0788c2e4d699f$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $fce0788c2e4d699f$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $fce0788c2e4d699f$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $fce0788c2e4d699f$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $fce0788c2e4d699f$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $fce0788c2e4d699f$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $fce0788c2e4d699f$var$FAKE_TOKEN) {
                        $fce0788c2e4d699f$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $fce0788c2e4d699f$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $fce0788c2e4d699f$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $fce0788c2e4d699f$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $fce0788c2e4d699f$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $fce0788c2e4d699f$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $fce0788c2e4d699f$var$FAKE_TOKEN) {
                    $fce0788c2e4d699f$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $fce0788c2e4d699f$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $fce0788c2e4d699f$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $fce0788c2e4d699f$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $fce0788c2e4d699f$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $fce0788c2e4d699f$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier === null || verifier === void 0 || verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $fce0788c2e4d699f$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $fce0788c2e4d699f$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $fce0788c2e4d699f$export$890c4ad488842ce7(recaptchaV2Verifier.type === $fce0788c2e4d699f$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $fce0788c2e4d699f$export$890c4ad488842ce7(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = Object.assign({}, request);
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $fce0788c2e4d699f$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $fce0788c2e4d699f$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $fce0788c2e4d699f$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $fce0788c2e4d699f$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $fce0788c2e4d699f$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $fce0788c2e4d699f$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $fce0788c2e4d699f$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $fce0788c2e4d699f$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $fce0788c2e4d699f$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $fce0788c2e4d699f$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $fce0788c2e4d699f$export$158acd800e1ef08b(resolverOverride);
    $fce0788c2e4d699f$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$IdpCredential extends $fce0788c2e4d699f$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $fce0788c2e4d699f$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $fce0788c2e4d699f$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $fce0788c2e4d699f$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $fce0788c2e4d699f$var$_signIn(params) {
    return $fce0788c2e4d699f$var$_signInWithCredential(params.auth, new $fce0788c2e4d699f$var$IdpCredential(params), params.bypassAuthState);
}
function $fce0788c2e4d699f$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $fce0788c2e4d699f$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $fce0788c2e4d699f$var$_reauthenticate(user, new $fce0788c2e4d699f$var$IdpCredential(params), params.bypassAuthState);
}
async function $fce0788c2e4d699f$var$_link(params) {
    const { auth: auth, user: user } = params;
    $fce0788c2e4d699f$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $fce0788c2e4d699f$var$_link$1(user, new $fce0788c2e4d699f$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $fce0788c2e4d699f$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $fce0788c2e4d699f$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $fce0788c2e4d699f$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $fce0788c2e4d699f$var$_reauth;
            default:
                $fce0788c2e4d699f$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $fce0788c2e4d699f$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $fce0788c2e4d699f$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $fce0788c2e4d699f$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    $fce0788c2e4d699f$var$_assertInstanceOf(auth, provider, $fce0788c2e4d699f$var$FederatedAuthProvider);
    const resolverInternal = $fce0788c2e4d699f$var$_withDefaultResolver(authInternal, resolver);
    const action = new $fce0788c2e4d699f$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($fce0788c2e4d699f$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $fce0788c2e4d699f$var$_assertInstanceOf(userInternal.auth, provider, $fce0788c2e4d699f$var$FederatedAuthProvider);
    const resolverInternal = $fce0788c2e4d699f$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $fce0788c2e4d699f$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $fce0788c2e4d699f$var$_assertInstanceOf(userInternal.auth, provider, $fce0788c2e4d699f$var$FederatedAuthProvider);
    const resolverInternal = $fce0788c2e4d699f$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $fce0788c2e4d699f$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $fce0788c2e4d699f$var$PopupOperation extends $fce0788c2e4d699f$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($fce0788c2e4d699f$var$PopupOperation.currentPopupAction) $fce0788c2e4d699f$var$PopupOperation.currentPopupAction.cancel();
        $fce0788c2e4d699f$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $fce0788c2e4d699f$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $fce0788c2e4d699f$export$1fbe638ecf81657e(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $fce0788c2e4d699f$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($fce0788c2e4d699f$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($fce0788c2e4d699f$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $fce0788c2e4d699f$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($fce0788c2e4d699f$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $fce0788c2e4d699f$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$fce0788c2e4d699f$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $fce0788c2e4d699f$var$redirectOutcomeMap = new Map();
class $fce0788c2e4d699f$var$RedirectAction extends $fce0788c2e4d699f$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $fce0788c2e4d699f$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $fce0788c2e4d699f$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $fce0788c2e4d699f$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $fce0788c2e4d699f$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $fce0788c2e4d699f$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $fce0788c2e4d699f$var$pendingRedirectKey(auth);
    const persistence = $fce0788c2e4d699f$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $fce0788c2e4d699f$var$_setPendingRedirectStatus(resolver, auth) {
    return $fce0788c2e4d699f$var$resolverPersistence(resolver)._set($fce0788c2e4d699f$var$pendingRedirectKey(auth), 'true');
}
function $fce0788c2e4d699f$export$b9a6b53f9be3734() {
    $fce0788c2e4d699f$var$redirectOutcomeMap.clear();
}
function $fce0788c2e4d699f$export$a33b77bbdbb8366c(auth, result) {
    $fce0788c2e4d699f$var$redirectOutcomeMap.set(auth._key(), result);
}
function $fce0788c2e4d699f$var$resolverPersistence(resolver) {
    return $fce0788c2e4d699f$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $fce0788c2e4d699f$var$pendingRedirectKey(auth) {
    return $fce0788c2e4d699f$export$cf2f7c5792f80b46($fce0788c2e4d699f$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $fce0788c2e4d699f$export$2d1720544b23b823(auth, provider, resolver) {
    return $fce0788c2e4d699f$var$_signInWithRedirect(auth, provider, resolver);
}
async function $fce0788c2e4d699f$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    $fce0788c2e4d699f$var$_assertInstanceOf(auth, provider, $fce0788c2e4d699f$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $fce0788c2e4d699f$var$_withDefaultResolver(authInternal, resolver);
    await $fce0788c2e4d699f$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $fce0788c2e4d699f$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $fce0788c2e4d699f$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $fce0788c2e4d699f$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $fce0788c2e4d699f$var$_assertInstanceOf(userInternal.auth, provider, $fce0788c2e4d699f$var$FederatedAuthProvider);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $fce0788c2e4d699f$var$_withDefaultResolver(userInternal.auth, resolver);
    await $fce0788c2e4d699f$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $fce0788c2e4d699f$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $fce0788c2e4d699f$export$39b482c5e57630a8(user, provider, resolver) {
    return $fce0788c2e4d699f$var$_linkWithRedirect(user, provider, resolver);
}
async function $fce0788c2e4d699f$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $fce0788c2e4d699f$var$_assertInstanceOf(userInternal.auth, provider, $fce0788c2e4d699f$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $fce0788c2e4d699f$var$_withDefaultResolver(userInternal.auth, resolver);
    await $fce0788c2e4d699f$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $fce0788c2e4d699f$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $fce0788c2e4d699f$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $fce0788c2e4d699f$export$35e795649ee09318(auth, resolver) {
    await $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $fce0788c2e4d699f$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $fce0788c2e4d699f$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($fce0788c2e4d699f$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $fce0788c2e4d699f$export$a05254e7c3aeba6e(auth);
    const resolver = $fce0788c2e4d699f$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $fce0788c2e4d699f$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $fce0788c2e4d699f$var$prepareUserForRedirect(user) {
    const eventId = $fce0788c2e4d699f$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $fce0788c2e4d699f$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $fce0788c2e4d699f$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$fce0788c2e4d699f$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$fce0788c2e4d699f$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($fce0788c2e4d699f$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $fce0788c2e4d699f$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($fce0788c2e4d699f$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($fce0788c2e4d699f$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $fce0788c2e4d699f$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $fce0788c2e4d699f$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $fce0788c2e4d699f$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $fce0788c2e4d699f$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $fce0788c2e4d699f$export$3d12bd131bb975d1(auth, request = {}) {
    return $fce0788c2e4d699f$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $fce0788c2e4d699f$var$HTTP_REGEX = /^https?/;
async function $fce0788c2e4d699f$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $fce0788c2e4d699f$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($fce0788c2e4d699f$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $fce0788c2e4d699f$var$matchDomain(expected) {
    const currentUrl = $fce0788c2e4d699f$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$fce0788c2e4d699f$var$HTTP_REGEX.test(protocol)) return false;
    if ($fce0788c2e4d699f$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$NETWORK_TIMEOUT = new $fce0788c2e4d699f$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $fce0788c2e4d699f$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $fce0788c2e4d699f$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $fce0788c2e4d699f$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $fce0788c2e4d699f$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $fce0788c2e4d699f$var$resetUnloadedGapiModules();
                    reject($fce0788c2e4d699f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $fce0788c2e4d699f$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $fce0788c2e4d699f$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $fce0788c2e4d699f$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $fce0788c2e4d699f$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $fce0788c2e4d699f$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($fce0788c2e4d699f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $fce0788c2e4d699f$var$_loadJS(`${$fce0788c2e4d699f$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $fce0788c2e4d699f$var$cachedGApiLoader = null;
        throw error;
    });
}
let $fce0788c2e4d699f$var$cachedGApiLoader = null;
function $fce0788c2e4d699f$var$_loadGapi(auth) {
    $fce0788c2e4d699f$var$cachedGApiLoader = $fce0788c2e4d699f$var$cachedGApiLoader || $fce0788c2e4d699f$var$loadGapi(auth);
    return $fce0788c2e4d699f$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$PING_TIMEOUT = new $fce0788c2e4d699f$var$Delay(5000, 15000);
const $fce0788c2e4d699f$var$IFRAME_PATH = '__/auth/iframe';
const $fce0788c2e4d699f$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $fce0788c2e4d699f$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $fce0788c2e4d699f$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $fce0788c2e4d699f$var$getIframeUrl(auth) {
    const config = auth.config;
    $fce0788c2e4d699f$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $fce0788c2e4d699f$var$_emulatorUrl(config, $fce0788c2e4d699f$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$fce0788c2e4d699f$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c)
    };
    const eid = $fce0788c2e4d699f$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(params).slice(1)}`;
}
async function $fce0788c2e4d699f$var$_openIframe(auth) {
    const context = await $fce0788c2e4d699f$var$_loadGapi(auth);
    const gapi1 = $fce0788c2e4d699f$var$_window().gapi;
    $fce0788c2e4d699f$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $fce0788c2e4d699f$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $fce0788c2e4d699f$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $fce0788c2e4d699f$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $fce0788c2e4d699f$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $fce0788c2e4d699f$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $fce0788c2e4d699f$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $fce0788c2e4d699f$var$DEFAULT_WIDTH = 500;
const $fce0788c2e4d699f$var$DEFAULT_HEIGHT = 600;
const $fce0788c2e4d699f$var$TARGET_BLANK = '_blank';
const $fce0788c2e4d699f$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $fce0788c2e4d699f$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $fce0788c2e4d699f$var$_open(auth, url, name, width = $fce0788c2e4d699f$var$DEFAULT_WIDTH, height = $fce0788c2e4d699f$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $fce0788c2e4d699f$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $fce0788c2e4d699f$var$_isChromeIOS(ua) ? $fce0788c2e4d699f$var$TARGET_BLANK : name;
    if ($fce0788c2e4d699f$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $fce0788c2e4d699f$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($fce0788c2e4d699f$var$_isIOSStandalone(ua) && target !== '_self') {
        $fce0788c2e4d699f$var$openAsNewWindowIOS(url || '', target);
        return new $fce0788c2e4d699f$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $fce0788c2e4d699f$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $fce0788c2e4d699f$export$c03999cb2f36933f(newWin);
}
function $fce0788c2e4d699f$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $fce0788c2e4d699f$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $fce0788c2e4d699f$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $fce0788c2e4d699f$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $fce0788c2e4d699f$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $fce0788c2e4d699f$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $fce0788c2e4d699f$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $fce0788c2e4d699f$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $fce0788c2e4d699f$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$fce0788c2e4d699f$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$fce0788c2e4d699f$var$getHandlerBase(auth)}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $fce0788c2e4d699f$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$fce0788c2e4d699f$var$WIDGET_PATH}`;
    return $fce0788c2e4d699f$var$_emulatorUrl(config, $fce0788c2e4d699f$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $fce0788c2e4d699f$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $fce0788c2e4d699f$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $fce0788c2e4d699f$export$407448d2b89b1813;
        this._completeRedirectFn = $fce0788c2e4d699f$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $fce0788c2e4d699f$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $fce0788c2e4d699f$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $fce0788c2e4d699f$export$28f7fcd39efa255(auth, provider, authType, $fce0788c2e4d699f$var$_getCurrentUrl(), eventId);
        return $fce0788c2e4d699f$var$_open(auth, url, $fce0788c2e4d699f$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $fce0788c2e4d699f$export$28f7fcd39efa255(auth, provider, authType, $fce0788c2e4d699f$var$_getCurrentUrl(), eventId);
        $fce0788c2e4d699f$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $fce0788c2e4d699f$export$1fbe638ecf81657e(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $fce0788c2e4d699f$var$_openIframe(auth);
        const manager = new $fce0788c2e4d699f$export$24baa2b76016ce0e(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $fce0788c2e4d699f$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($fce0788c2e4d699f$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $fce0788c2e4d699f$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$fce0788c2e4d699f$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $fce0788c2e4d699f$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $fce0788c2e4d699f$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $fce0788c2e4d699f$var$_isMobileBrowser() || $fce0788c2e4d699f$var$_isSafari() || $fce0788c2e4d699f$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $fce0788c2e4d699f$export$342063e11d6c3cad = $fce0788c2e4d699f$var$BrowserPopupRedirectResolver;
class $fce0788c2e4d699f$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $fce0788c2e4d699f$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $fce0788c2e4d699f$var$PhoneMultiFactorAssertionImpl extends $fce0788c2e4d699f$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $fce0788c2e4d699f$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $fce0788c2e4d699f$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $fce0788c2e4d699f$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $fce0788c2e4d699f$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $fce0788c2e4d699f$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $fce0788c2e4d699f$export$953cecd6e717a553.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $fce0788c2e4d699f$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $fce0788c2e4d699f$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $fce0788c2e4d699f$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $fce0788c2e4d699f$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $fce0788c2e4d699f$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $fce0788c2e4d699f$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $fce0788c2e4d699f$var$TotpMultiFactorAssertionImpl extends $fce0788c2e4d699f$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $fce0788c2e4d699f$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $fce0788c2e4d699f$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $fce0788c2e4d699f$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $fce0788c2e4d699f$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $fce0788c2e4d699f$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $fce0788c2e4d699f$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($fce0788c2e4d699f$var$_isEmptyString(accountName) || $fce0788c2e4d699f$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($fce0788c2e4d699f$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($fce0788c2e4d699f$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $fce0788c2e4d699f$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $fce0788c2e4d699f$var$name = "@firebase/auth";
var $fce0788c2e4d699f$var$version = "1.9.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $fce0788c2e4d699f$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $fce0788c2e4d699f$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $fce0788c2e4d699f$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $fce0788c2e4d699f$var$registerAuth(clientPlatform) {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $fce0788c2e4d699f$export$890c4ad488842ce7(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $fce0788c2e4d699f$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $fce0788c2e4d699f$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $fce0788c2e4d699f$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $fce0788c2e4d699f$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $fce0788c2e4d699f$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($fce0788c2e4d699f$var$name, $fce0788c2e4d699f$var$version, $fce0788c2e4d699f$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($fce0788c2e4d699f$var$name, $fce0788c2e4d699f$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fce0788c2e4d699f$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $fce0788c2e4d699f$var$authIdTokenMaxAge = (0, $c38e0f42709c826a$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $fce0788c2e4d699f$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $fce0788c2e4d699f$var$lastPostedIdToken = null;
const $fce0788c2e4d699f$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $fce0788c2e4d699f$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($fce0788c2e4d699f$var$lastPostedIdToken === idToken) return;
        $fce0788c2e4d699f$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $fce0788c2e4d699f$export$ae1af26003f05816(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $fce0788c2e4d699f$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $fce0788c2e4d699f$export$342063e11d6c3cad,
        persistence: [
            $fce0788c2e4d699f$export$23f2a1d2818174ef,
            $fce0788c2e4d699f$export$8b22cf2602fb60ce,
            $fce0788c2e4d699f$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $c38e0f42709c826a$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $fce0788c2e4d699f$var$mintCookieFactory(authTokenSyncUrl.toString());
            $fce0788c2e4d699f$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $fce0788c2e4d699f$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $c38e0f42709c826a$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $fce0788c2e4d699f$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $fce0788c2e4d699f$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$fce0788c2e4d699f$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $fce0788c2e4d699f$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $fce0788c2e4d699f$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$fce0788c2e4d699f$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );















var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== 'undefined' ? $906344b47e605252$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = mb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== 'undefined' ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $70fd6868680e912c$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $70fd6868680e912c$var$S = "@firebase/firestore", $70fd6868680e912c$var$b = "4.7.10";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $70fd6868680e912c$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $70fd6868680e912c$var$User.UNAUTHENTICATED = new $70fd6868680e912c$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$70fd6868680e912c$var$User.GOOGLE_CREDENTIALS = new $70fd6868680e912c$var$User("google-credentials-uid"), $70fd6868680e912c$var$User.FIRST_PARTY = new $70fd6868680e912c$var$User("first-party-uid"), $70fd6868680e912c$var$User.MOCK_USER = new $70fd6868680e912c$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $70fd6868680e912c$var$D = "11.5.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$v = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $70fd6868680e912c$var$__PRIVATE_getLogLevel() {
    return $70fd6868680e912c$var$v.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $70fd6868680e912c$export$c622e99c0ce7b1c9(e) {
    $70fd6868680e912c$var$v.setLogLevel(e);
}
function $70fd6868680e912c$var$__PRIVATE_logDebug(e, ...t) {
    if ($70fd6868680e912c$var$v.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$v.debug(`Firestore (${$70fd6868680e912c$var$D}): ${e}`, ...n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_logError(e, ...t) {
    if ($70fd6868680e912c$var$v.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$v.error(`Firestore (${$70fd6868680e912c$var$D}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $70fd6868680e912c$export$86cd73f49cc6e0bb(e, ...t) {
    if ($70fd6868680e912c$var$v.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$v.warn(`Firestore (${$70fd6868680e912c$var$D}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $70fd6868680e912c$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $70fd6868680e912c$var$fail(e = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const t = `FIRESTORE (${$70fd6868680e912c$var$D}) INTERNAL ASSERTION FAILED: ` + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $70fd6868680e912c$var$__PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $70fd6868680e912c$var$__PRIVATE_hardAssert(e, t) {
    e || $70fd6868680e912c$var$fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $70fd6868680e912c$export$1d2b90eea9bba017(e, t) {
    e || $70fd6868680e912c$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $70fd6868680e912c$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$C = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $70fd6868680e912c$export$8fada0bf726bf278 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($70fd6868680e912c$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $70fd6868680e912c$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $70fd6868680e912c$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === this.o);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $70fd6868680e912c$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $70fd6868680e912c$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($70fd6868680e912c$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $70fd6868680e912c$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(null === e || "string" == typeof e), new $70fd6868680e912c$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $70fd6868680e912c$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = $70fd6868680e912c$var$User.FIRST_PARTY, this.T = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ I() {
        return this.P ? this.P() : null;
    }
    get headers() {
        this.T.set("X-Goog-AuthUser", this.l);
        // Use array notation to prevent minification
        const e = this.I();
        return e && this.T.set("Authorization", e), this.h && this.T.set("X-Goog-Iam-Authorization-Token", this.h), this.T;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $70fd6868680e912c$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n;
    }
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$__PRIVATE_FirstPartyToken(this.l, this.h, this.P));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($70fd6868680e912c$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $70fd6868680e912c$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $70fd6868680e912c$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(t, n){
        this.A = n, this.forceRefresh = !1, this.appCheck = null, this.R = null, this.V = null, (0, $57d436074e210fb5$export$643c8bc6c389f34e)(t) && t.settings.appCheckToken && (this.V = t.settings.appCheckToken);
    }
    start(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === this.o);
        const onTokenChanged = (e)=>{
            null != e.error && $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.R;
            return this.R = e.token, $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.A.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.A.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.V) return Promise.resolve(new $70fd6868680e912c$var$AppCheckToken(this.V));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($70fd6868680e912c$var$__PRIVATE_hardAssert("string" == typeof e.token), this.R = e.token, new $70fd6868680e912c$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $70fd6868680e912c$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $70fd6868680e912c$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $70fd6868680e912c$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(e, t) {
    let n = 0;
    for(; n < e.length && n < t.length;){
        const r = e.codePointAt(n), i = t.codePointAt(n);
        if (r !== i) {
            if (r < 128 && i < 128) // ASCII comparison
            return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r, i);
            {
                // Lazy instantiate TextEncoder
                const s = $70fd6868680e912c$var$__PRIVATE_newTextEncoder(), o = $70fd6868680e912c$var$__PRIVATE_compareByteArrays$1(s.encode($70fd6868680e912c$var$__PRIVATE_getUtf8SafeSubstring(e, n)), s.encode($70fd6868680e912c$var$__PRIVATE_getUtf8SafeSubstring(t, n)));
                // UTF-8 encode the character at index i for byte comparison.
                return 0 !== o ? o : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r, i);
            }
        }
        // Increment by 2 for surrogate pairs, 1 otherwise
        n += r > 65535 ? 2 : 1;
    }
    // Compare lengths if all characters are equal
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
function $70fd6868680e912c$var$__PRIVATE_getUtf8SafeSubstring(e, t) {
    return e.codePointAt(t) > 65535 ? e.substring(t, t + 2) : e.substring(t, t + 1);
}
function $70fd6868680e912c$var$__PRIVATE_compareByteArrays$1(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n)if (e[n] !== t[n]) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e[n], t[n]);
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
/** Helper to compare arrays using isEqual(). */ function $70fd6868680e912c$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $70fd6868680e912c$var$F = -62135596800, $70fd6868680e912c$var$M = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $70fd6868680e912c$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $70fd6868680e912c$var$M);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $70fd6868680e912c$var$F) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $70fd6868680e912c$var$M;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $70fd6868680e912c$var$F;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $70fd6868680e912c$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $70fd6868680e912c$var$SnapshotVersion(e);
    }
    static min() {
        return new $70fd6868680e912c$var$SnapshotVersion(new $70fd6868680e912c$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $70fd6868680e912c$var$SnapshotVersion(new $70fd6868680e912c$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$x = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $70fd6868680e912c$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $70fd6868680e912c$var$fail(), void 0 === n ? n = e.length - t : n > e.length - t && $70fd6868680e912c$var$fail(), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $70fd6868680e912c$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $70fd6868680e912c$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $70fd6868680e912c$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $70fd6868680e912c$var$BasePath.isNumericId(e), r = $70fd6868680e912c$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $70fd6868680e912c$var$BasePath.extractNumericId(e).compare($70fd6868680e912c$var$BasePath.extractNumericId(t)) : $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $906344b47e605252$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $70fd6868680e912c$var$ResourcePath extends $70fd6868680e912c$var$BasePath {
    construct(e, t, n) {
        return new $70fd6868680e912c$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $70fd6868680e912c$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $70fd6868680e912c$var$ResourcePath([]);
    }
}
const $70fd6868680e912c$var$O = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $70fd6868680e912c$export$b7871852b967eaf1 extends $70fd6868680e912c$var$BasePath {
    construct(e, t, n) {
        return new $70fd6868680e912c$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $70fd6868680e912c$var$O.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $70fd6868680e912c$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $70fd6868680e912c$var$x;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([
            $70fd6868680e912c$var$x
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $70fd6868680e912c$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $70fd6868680e912c$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $70fd6868680e912c$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $70fd6868680e912c$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $70fd6868680e912c$var$N = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $70fd6868680e912c$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $70fd6868680e912c$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $70fd6868680e912c$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $70fd6868680e912c$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $70fd6868680e912c$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $70fd6868680e912c$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $70fd6868680e912c$var$IndexState(0, $70fd6868680e912c$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $70fd6868680e912c$export$d9bcbd5e1ff81430(n + 1, 0) : new $70fd6868680e912c$export$d9bcbd5e1ff81430(n, r));
    return new $70fd6868680e912c$var$IndexOffset(i, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $70fd6868680e912c$var$IndexOffset(e.readTime, e.key, $70fd6868680e912c$var$N);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $70fd6868680e912c$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), $70fd6868680e912c$var$N);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$SnapshotVersion.max(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), $70fd6868680e912c$var$N);
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$B = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $70fd6868680e912c$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $70fd6868680e912c$var$C.FAILED_PRECONDITION || e.message !== $70fd6868680e912c$var$B) throw e;
    $70fd6868680e912c$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $70fd6868680e912c$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $70fd6868680e912c$var$fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $70fd6868680e912c$var$PersistencePromise ? t : $70fd6868680e912c$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $70fd6868680e912c$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $70fd6868680e912c$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $70fd6868680e912c$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $70fd6868680e912c$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $70fd6868680e912c$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ const $70fd6868680e912c$var$L = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.m = new $70fd6868680e912c$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.m.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.m.reject(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.m.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.m.reject(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get p() {
        return this.m.promise;
    }
    abort(e) {
        e && this.m.reject(e), this.aborted || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    S() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $70fd6868680e912c$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "Removing database:", e), $70fd6868680e912c$var$__PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static D() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return !1;
        if ($70fd6868680e912c$var$__PRIVATE_SimpleDb.v()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $c38e0f42709c826a$export$c36915b22ce77c19)(), t = $70fd6868680e912c$var$__PRIVATE_SimpleDb.C(e), n = 0 < t && t < 10, r = $70fd6868680e912c$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static v() {
        var e;
        return "undefined" != typeof $cfae44f0dfdf62c0$exports && "YES" === (null === (e = $cfae44f0dfdf62c0$exports.__PRIVATE_env) || void 0 === e ? void 0 : e.F);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static M(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static C(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.O = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $70fd6868680e912c$var$__PRIVATE_SimpleDb.C((0, $c38e0f42709c826a$export$c36915b22ce77c19)()) && $70fd6868680e912c$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async N(e) {
        return this.db || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.O.B(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.L && (this.db.onversionchange = (e)=>this.L(e)), this.db;
    }
    k(e) {
        this.L = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.N(e);
                const t = $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.S(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $70fd6868680e912c$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.p, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $70fd6868680e912c$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $70fd6868680e912c$var$__PRIVATE_IterationController {
    constructor(e){
        this.q = e, this.$ = !1, this.U = null;
    }
    get isDone() {
        return this.$;
    }
    get K() {
        return this.U;
    }
    set cursor(e) {
        this.q = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.$ = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ W(e) {
        this.U = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.q.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError extends $70fd6868680e912c$export$8fada0bf726bf278 {
    constructor(e, t){
        super($70fd6868680e912c$var$C.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $70fd6868680e912c$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "ADD", this.store.name, e, e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "DELETE", this.store.name, e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "COUNT", this.store.name);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.count());
    }
    G(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.j(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ H(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $70fd6868680e912c$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    J(e, t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$L, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Y = !1;
        const r = this.cursor(n);
        return this.j(r, (e, t, n)=>n.delete());
    }
    Z(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.j(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ X(e) {
        const t = this.cursor({});
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    j(e, t) {
        const n = [];
        return new $70fd6868680e912c$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $70fd6868680e912c$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $70fd6868680e912c$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $70fd6868680e912c$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.K ? i.continue() : i.continue(s.K);
            };
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Y ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $70fd6868680e912c$var$__PRIVATE_wrapRequest(e) {
    return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $70fd6868680e912c$var$k = !1;
function $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_SimpleDb.C((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $70fd6868680e912c$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $70fd6868680e912c$var$k || ($70fd6868680e912c$var$k = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $70fd6868680e912c$var$q = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $70fd6868680e912c$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ee = t, this.task = null;
    }
    start() {
        this.te(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    te(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$q, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ee.ne();
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$q, `Documents written: ${e}`);
            } catch (e) {
                $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$q, "Ignoring IndexedDB error during index backfill: ", e) : await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.te(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $70fd6868680e912c$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ne(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.re(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ re(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $70fd6868680e912c$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$q, `Processing collection: ${t}`), this.ie(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ ie(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.se(r, n)).next((n)=>($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$q, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ se(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $70fd6868680e912c$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $70fd6868680e912c$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.oe(e), this._e = (e)=>t.writeSequenceNumber(e));
    }
    oe(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this._e && this._e(e), e;
    }
}
$70fd6868680e912c$var$__PRIVATE_ListenSequence.ae = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $70fd6868680e912c$var$Q = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $70fd6868680e912c$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $70fd6868680e912c$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$70fd6868680e912c$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$$ = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $70fd6868680e912c$var$__PRIVATE_encodeSeparator(t)), t = $70fd6868680e912c$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $70fd6868680e912c$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $70fd6868680e912c$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $70fd6868680e912c$var$$:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $70fd6868680e912c$var$__PRIVATE_encodeSeparator(e) {
    return e + $70fd6868680e912c$var$$ + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(t >= 2), 2 === t) return $70fd6868680e912c$var$__PRIVATE_hardAssert(e.charAt(0) === $70fd6868680e912c$var$$ && "" === e.charAt(1)), $70fd6868680e912c$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($70fd6868680e912c$var$$, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $70fd6868680e912c$var$fail();
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $70fd6868680e912c$var$fail();
        }
        i = t + 2;
    }
    return new $70fd6868680e912c$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$U = "remoteDocuments", $70fd6868680e912c$var$K = "owner", $70fd6868680e912c$var$W = "owner", $70fd6868680e912c$var$G = "mutationQueues", $70fd6868680e912c$var$z = "userId", $70fd6868680e912c$var$j = "mutations", $70fd6868680e912c$var$H = "batchId", $70fd6868680e912c$var$J = "userMutationsIndex", $70fd6868680e912c$var$Y = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $70fd6868680e912c$var$Z = {}, $70fd6868680e912c$var$X = "documentMutations", $70fd6868680e912c$var$ee = "remoteDocumentsV14", $70fd6868680e912c$var$te = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $70fd6868680e912c$var$ne = "documentKeyIndex", $70fd6868680e912c$var$re = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $70fd6868680e912c$var$ie = "collectionGroupIndex", $70fd6868680e912c$var$se = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $70fd6868680e912c$var$oe = "remoteDocumentGlobal", $70fd6868680e912c$var$_e = "remoteDocumentGlobalKey", $70fd6868680e912c$var$ae = "targets", $70fd6868680e912c$var$ue = "queryTargetsIndex", $70fd6868680e912c$var$ce = [
    "canonicalId",
    "targetId"
], $70fd6868680e912c$var$le = "targetDocuments", $70fd6868680e912c$var$he = [
    "targetId",
    "path"
], $70fd6868680e912c$var$Pe = "documentTargetsIndex", $70fd6868680e912c$var$Te = [
    "path",
    "targetId"
], $70fd6868680e912c$var$Ie = "targetGlobalKey", $70fd6868680e912c$var$Ee = "targetGlobal", $70fd6868680e912c$var$de = "collectionParents", $70fd6868680e912c$var$Ae = [
    "collectionId",
    "parent"
], $70fd6868680e912c$var$Re = "clientMetadata", $70fd6868680e912c$var$Ve = "clientId", $70fd6868680e912c$var$me = "bundles", $70fd6868680e912c$var$fe = "bundleId", $70fd6868680e912c$var$ge = "namedQueries", $70fd6868680e912c$var$pe = "name", $70fd6868680e912c$var$ye = "indexConfiguration", $70fd6868680e912c$var$we = "indexId", $70fd6868680e912c$var$Se = "collectionGroupIndex", $70fd6868680e912c$var$be = "collectionGroup", $70fd6868680e912c$var$De = "indexState", $70fd6868680e912c$var$ve = [
    "indexId",
    "uid"
], $70fd6868680e912c$var$Ce = "sequenceNumberIndex", $70fd6868680e912c$var$Fe = [
    "uid",
    "sequenceNumber"
], $70fd6868680e912c$var$Me = "indexEntries", $70fd6868680e912c$var$xe = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $70fd6868680e912c$var$Oe = "documentKeyIndex", $70fd6868680e912c$var$Ne = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $70fd6868680e912c$var$Be = "documentOverlays", $70fd6868680e912c$var$Le = [
    "userId",
    "collectionPath",
    "documentId"
], $70fd6868680e912c$var$ke = "collectionPathOverlayIndex", $70fd6868680e912c$var$qe = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $70fd6868680e912c$var$Qe = "collectionGroupOverlayIndex", $70fd6868680e912c$var$$e = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $70fd6868680e912c$var$Ue = "globals", $70fd6868680e912c$var$Ke = "name", $70fd6868680e912c$var$We = [
    $70fd6868680e912c$var$G,
    $70fd6868680e912c$var$j,
    $70fd6868680e912c$var$X,
    $70fd6868680e912c$var$U,
    $70fd6868680e912c$var$ae,
    $70fd6868680e912c$var$K,
    $70fd6868680e912c$var$Ee,
    $70fd6868680e912c$var$le,
    $70fd6868680e912c$var$Re,
    $70fd6868680e912c$var$oe,
    $70fd6868680e912c$var$de,
    $70fd6868680e912c$var$me,
    $70fd6868680e912c$var$ge
], $70fd6868680e912c$var$Ge = [
    ...$70fd6868680e912c$var$We,
    $70fd6868680e912c$var$Be
], $70fd6868680e912c$var$ze = [
    $70fd6868680e912c$var$G,
    $70fd6868680e912c$var$j,
    $70fd6868680e912c$var$X,
    $70fd6868680e912c$var$ee,
    $70fd6868680e912c$var$ae,
    $70fd6868680e912c$var$K,
    $70fd6868680e912c$var$Ee,
    $70fd6868680e912c$var$le,
    $70fd6868680e912c$var$Re,
    $70fd6868680e912c$var$oe,
    $70fd6868680e912c$var$de,
    $70fd6868680e912c$var$me,
    $70fd6868680e912c$var$ge,
    $70fd6868680e912c$var$Be
], $70fd6868680e912c$var$je = $70fd6868680e912c$var$ze, $70fd6868680e912c$var$He = [
    ...$70fd6868680e912c$var$je,
    $70fd6868680e912c$var$ye,
    $70fd6868680e912c$var$De,
    $70fd6868680e912c$var$Me
], $70fd6868680e912c$var$Je = $70fd6868680e912c$var$He, $70fd6868680e912c$var$Ye = [
    ...$70fd6868680e912c$var$He,
    $70fd6868680e912c$var$Ue
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction extends $70fd6868680e912c$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.ue = e, this.currentSequenceNumber = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_getStore(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return $70fd6868680e912c$var$__PRIVATE_SimpleDb.M(n.ue, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $70fd6868680e912c$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $70fd6868680e912c$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $70fd6868680e912c$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $70fd6868680e912c$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $70fd6868680e912c$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $70fd6868680e912c$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $70fd6868680e912c$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $70fd6868680e912c$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $70fd6868680e912c$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $70fd6868680e912c$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $70fd6868680e912c$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $70fd6868680e912c$var$LLRBNode.RED, this.left = null != r ? r : $70fd6868680e912c$var$LLRBNode.EMPTY, this.right = null != i ? i : $70fd6868680e912c$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $70fd6868680e912c$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $70fd6868680e912c$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $70fd6868680e912c$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $70fd6868680e912c$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $70fd6868680e912c$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $70fd6868680e912c$var$fail();
        if (this.right.isRed()) throw $70fd6868680e912c$var$fail();
        const e = this.left.check();
        if (e !== this.right.check()) throw $70fd6868680e912c$var$fail();
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$70fd6868680e912c$var$LLRBNode.EMPTY = null, $70fd6868680e912c$var$LLRBNode.RED = !0, $70fd6868680e912c$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$70fd6868680e912c$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $70fd6868680e912c$var$fail();
    }
    get value() {
        throw $70fd6868680e912c$var$fail();
    }
    get color() {
        throw $70fd6868680e912c$var$fail();
    }
    get left() {
        throw $70fd6868680e912c$var$fail();
    }
    get right() {
        throw $70fd6868680e912c$var$fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $70fd6868680e912c$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $70fd6868680e912c$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $70fd6868680e912c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $70fd6868680e912c$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $70fd6868680e912c$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $70fd6868680e912c$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $70fd6868680e912c$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $70fd6868680e912c$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $70fd6868680e912c$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($70fd6868680e912c$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $70fd6868680e912c$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $70fd6868680e912c$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $70fd6868680e912c$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $70fd6868680e912c$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $70fd6868680e912c$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $70fd6868680e912c$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $70fd6868680e912c$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $70fd6868680e912c$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $70fd6868680e912c$export$67460cdabfa21253("");
const $70fd6868680e912c$var$Ze = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $70fd6868680e912c$var$Ze.exec(e);
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e) : $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $70fd6868680e912c$var$Xe = "server_timestamp", $70fd6868680e912c$var$et = "__type__", $70fd6868680e912c$var$tt = "__previous_value__", $70fd6868680e912c$var$nt = "__local_write_time__";
function $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {})[$70fd6868680e912c$var$et]) || void 0 === n ? void 0 : n.stringValue) === $70fd6868680e912c$var$Xe;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$70fd6868680e912c$var$tt];
    return $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(t) ? $70fd6868680e912c$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$70fd6868680e912c$var$nt].timestampValue);
    return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
    }
}
/** The default database name for a project. */ const $70fd6868680e912c$var$rt = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $70fd6868680e912c$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || $70fd6868680e912c$var$rt;
    }
    static empty() {
        return new $70fd6868680e912c$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return this.database === $70fd6868680e912c$var$rt;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$it = "__type__", $70fd6868680e912c$var$st = "__max__", $70fd6868680e912c$var$ot = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $70fd6868680e912c$var$st
            }
        }
    }
}, $70fd6868680e912c$var$_t = "__vector__", $70fd6868680e912c$var$at = "value", $70fd6868680e912c$var$ut = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $70fd6868680e912c$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $70fd6868680e912c$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $70fd6868680e912c$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $70fd6868680e912c$var$__PRIVATE_typeOrder(e);
    if (n !== $70fd6868680e912c$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e).isEqual($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($70fd6868680e912c$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $70fd6868680e912c$var$__PRIVATE_isNegativeZero(n) === $70fd6868680e912c$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $70fd6868680e912c$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($70fd6868680e912c$var$__PRIVATE_objectSize(n) !== $70fd6868680e912c$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$70fd6868680e912c$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $70fd6868680e912c$var$fail();
    }
}
function $70fd6868680e912c$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t));
}
function $70fd6868680e912c$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $70fd6868680e912c$var$__PRIVATE_typeOrder(e), r = $70fd6868680e912c$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareTimestamps($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e), $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e), r = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_primitiveComparator($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.latitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.longitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                var n, r, i, s;
                const o = e.fields || {}, _ = t.fields || {}, a = null === (n = o[$70fd6868680e912c$var$at]) || void 0 === n ? void 0 : n.arrayValue, u = null === (r = _[$70fd6868680e912c$var$at]) || void 0 === r ? void 0 : r.arrayValue, c = $70fd6868680e912c$var$__PRIVATE_primitiveComparator((null === (i = null == a ? void 0 : a.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == u ? void 0 : u.values) || void 0 === s ? void 0 : s.length) || 0);
                if (0 !== c) return c;
                return $70fd6868680e912c$var$__PRIVATE_compareArrays(a, u);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $70fd6868680e912c$var$ot.mapValue && t === $70fd6868680e912c$var$ot.mapValue) return 0;
                if (e === $70fd6868680e912c$var$ot.mapValue) return 1;
                if (t === $70fd6868680e912c$var$ot.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $70fd6868680e912c$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $70fd6868680e912c$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $70fd6868680e912c$var$fail();
    }
}
function $70fd6868680e912c$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, t);
    const n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e), r = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(t), i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $70fd6868680e912c$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $70fd6868680e912c$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $70fd6868680e912c$var$canonicalId(e) {
    return $70fd6868680e912c$var$__PRIVATE_canonifyValue(e);
}
function $70fd6868680e912c$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $70fd6868680e912c$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $70fd6868680e912c$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$70fd6868680e912c$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_estimateByteSize(e) {
    switch($70fd6868680e912c$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $70fd6868680e912c$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $70fd6868680e912c$var$fail();
    }
}
function $70fd6868680e912c$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $70fd6868680e912c$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $70fd6868680e912c$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $70fd6868680e912c$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $70fd6868680e912c$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $70fd6868680e912c$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) {
    var t, n;
    return (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {})[$70fd6868680e912c$var$it]) || void 0 === n ? void 0 : n.stringValue) === $70fd6868680e912c$var$_t;
}
/** Creates a deep copy of `source`. */ function $70fd6868680e912c$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $70fd6868680e912c$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $70fd6868680e912c$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $70fd6868680e912c$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $70fd6868680e912c$var$st;
}
const $70fd6868680e912c$var$ct = {
    mapValue: {
        fields: {
            [$70fd6868680e912c$var$it]: {
                stringValue: $70fd6868680e912c$var$_t
            },
            [$70fd6868680e912c$var$at]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $70fd6868680e912c$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $70fd6868680e912c$var$ut : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $70fd6868680e912c$var$__PRIVATE_refValue($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? $70fd6868680e912c$var$ct : {
        mapValue: {}
    } : $70fd6868680e912c$var$fail();
}
/** Returns the largest value for the given value type (exclusive). */ function $70fd6868680e912c$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $70fd6868680e912c$var$__PRIVATE_refValue($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $70fd6868680e912c$var$ct : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $70fd6868680e912c$var$ot : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $70fd6868680e912c$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $70fd6868680e912c$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $70fd6868680e912c$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$70fd6868680e912c$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $70fd6868680e912c$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $70fd6868680e912c$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $70fd6868680e912c$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $70fd6868680e912c$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $70fd6868680e912c$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $70fd6868680e912c$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $70fd6868680e912c$var$ObjectValue($70fd6868680e912c$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $70fd6868680e912c$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $70fd6868680e912c$var$forEach(e.fields, (e, n)=>{
        const r = new $70fd6868680e912c$export$b7871852b967eaf1([
            e
        ]);
        if ($70fd6868680e912c$var$__PRIVATE_isMapValue(n)) {
            const e = $70fd6868680e912c$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $70fd6868680e912c$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $70fd6868680e912c$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $70fd6868680e912c$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $70fd6868680e912c$var$SnapshotVersion.min(), /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $70fd6868680e912c$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $70fd6868680e912c$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $70fd6868680e912c$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $70fd6868680e912c$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $70fd6868680e912c$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $70fd6868680e912c$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $70fd6868680e912c$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $70fd6868680e912c$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $70fd6868680e912c$export$afc2e57c475b7810.comparator($70fd6868680e912c$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $70fd6868680e912c$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $70fd6868680e912c$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$70fd6868680e912c$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $70fd6868680e912c$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Filter {
}
class $70fd6868680e912c$var$FieldFilter extends $70fd6868680e912c$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $70fd6868680e912c$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $70fd6868680e912c$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $70fd6868680e912c$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $70fd6868680e912c$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_KeyFieldInFilter(e, n) : new $70fd6868680e912c$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison($70fd6868680e912c$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $70fd6868680e912c$var$__PRIVATE_typeOrder(this.value) === $70fd6868680e912c$var$__PRIVATE_typeOrder(t) && this.matchesComparison($70fd6868680e912c$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $70fd6868680e912c$var$fail();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $70fd6868680e912c$var$CompositeFilter extends $70fd6868680e912c$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.ce = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $70fd6868680e912c$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.ce || (this.ce = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.ce;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e) && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $70fd6868680e912c$var$CompositeFilter) return !1;
    return !0;
}
function $70fd6868680e912c$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $70fd6868680e912c$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $70fd6868680e912c$var$canonicalId(e.value);
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $70fd6868680e912c$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $70fd6868680e912c$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $70fd6868680e912c$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $70fd6868680e912c$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $70fd6868680e912c$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $70fd6868680e912c$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $70fd6868680e912c$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$70fd6868680e912c$var$canonicalId(e.value)}`;
    }(e) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($70fd6868680e912c$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $70fd6868680e912c$var$__PRIVATE_KeyFieldFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $70fd6868680e912c$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $70fd6868680e912c$var$__PRIVATE_KeyFieldInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $70fd6868680e912c$var$__PRIVATE_KeyFieldNotInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$70fd6868680e912c$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $70fd6868680e912c$var$__PRIVATE_ArrayContainsFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $70fd6868680e912c$var$isArray(t) && $70fd6868680e912c$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $70fd6868680e912c$var$__PRIVATE_InFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $70fd6868680e912c$var$__PRIVATE_NotInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && !$70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $70fd6868680e912c$var$__PRIVATE_ArrayContainsAnyFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$70fd6868680e912c$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.le = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $70fd6868680e912c$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $70fd6868680e912c$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $70fd6868680e912c$var$__PRIVATE_canonifyTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (null === t.le) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), t.le = e;
    }
    return t.le;
}
function $70fd6868680e912c$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$70fd6868680e912c$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$70fd6868680e912c$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$70fd6868680e912c$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $70fd6868680e912c$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $70fd6868680e912c$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $70fd6868680e912c$var$ut, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $70fd6868680e912c$var$ut, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $70fd6868680e912c$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $70fd6868680e912c$var$ut;
        }
        $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $70fd6868680e912c$var$ot, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $70fd6868680e912c$var$ot, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $70fd6868680e912c$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $70fd6868680e912c$var$ot;
        }
        $70fd6868680e912c$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $70fd6868680e912c$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.he = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Pe = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.Te = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $70fd6868680e912c$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $70fd6868680e912c$var$__PRIVATE_newQueryForPath(e) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (null === t.he) {
        t.he = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.he.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.he.push(new $70fd6868680e912c$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($70fd6868680e912c$export$b7871852b967eaf1.keyField().canonicalString()) || t.he.push(new $70fd6868680e912c$var$OrderBy($70fd6868680e912c$export$b7871852b967eaf1.keyField(), n));
    }
    return t.he;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $70fd6868680e912c$var$__PRIVATE_queryToTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.Pe || (t.Pe = $70fd6868680e912c$var$__PRIVATE__queryToTarget(t, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))), t.Pe;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.Te || // Do not include implicit order-bys for aggregate queries.
    (t.Te = $70fd6868680e912c$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.Te;
}
function $70fd6868680e912c$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $70fd6868680e912c$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $70fd6868680e912c$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $70fd6868680e912c$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_queryEquals(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_targetEquals($70fd6868680e912c$var$__PRIVATE_queryToTarget(e), $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $70fd6868680e912c$var$__PRIVATE_canonifyQuery(e) {
    return `${$70fd6868680e912c$var$__PRIVATE_canonifyTarget($70fd6868680e912c$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $70fd6868680e912c$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($70fd6868680e912c$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $70fd6868680e912c$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $70fd6868680e912c$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $70fd6868680e912c$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $70fd6868680e912c$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $70fd6868680e912c$var$__PRIVATE_valueCompare(r, i) : $70fd6868680e912c$var$fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $70fd6868680e912c$var$fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $70fd6868680e912c$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $70fd6868680e912c$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $70fd6868680e912c$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$lt = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap() {
    return $70fd6868680e912c$var$lt;
}
const $70fd6868680e912c$var$ht = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$documentMap(...e) {
    let t = $70fd6868680e912c$var$ht;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $70fd6868680e912c$var$ht;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $70fd6868680e912c$var$__PRIVATE_newOverlayMap() {
    return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
}
function $70fd6868680e912c$var$__PRIVATE_newMutationMap() {
    return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
}
function $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap() {
    return new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $70fd6868680e912c$var$Pt = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
const $70fd6868680e912c$var$Tt = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$__PRIVATE_documentKeySet(...e) {
    let t = $70fd6868680e912c$var$Tt;
    for (const n of e)t = t.add(n);
    return t;
}
const $70fd6868680e912c$var$It = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
function $70fd6868680e912c$var$__PRIVATE_targetIdSet() {
    return $70fd6868680e912c$var$It;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $70fd6868680e912c$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $70fd6868680e912c$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $70fd6868680e912c$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $70fd6868680e912c$var$toNumber(e, t) {
    return $70fd6868680e912c$var$isSafeInteger(t) ? $70fd6868680e912c$var$__PRIVATE_toInteger(t) : $70fd6868680e912c$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $70fd6868680e912c$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$70fd6868680e912c$var$et]: {
                    stringValue: $70fd6868680e912c$var$Xe
                },
                [$70fd6868680e912c$var$nt]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(t) && (t = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$70fd6868680e912c$var$tt] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $70fd6868680e912c$var$asNumber(n) + $70fd6868680e912c$var$asNumber(e.Ie);
        return $70fd6868680e912c$var$isInteger(n) && $70fd6868680e912c$var$isInteger(e.Ie) ? $70fd6868680e912c$var$__PRIVATE_toInteger(r) : $70fd6868680e912c$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $70fd6868680e912c$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform extends $70fd6868680e912c$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ie = t;
    }
}
function $70fd6868680e912c$var$asNumber(e) {
    return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $70fd6868680e912c$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $70fd6868680e912c$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_arrayEquals(e.elements, t.elements, $70fd6868680e912c$var$__PRIVATE_valueEquals) : e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation ? $70fd6868680e912c$var$__PRIVATE_valueEquals(e.Ie, t.Ie) : e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform && t instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $70fd6868680e912c$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $70fd6868680e912c$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $70fd6868680e912c$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $70fd6868680e912c$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $70fd6868680e912c$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $70fd6868680e912c$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e.key, $70fd6868680e912c$var$Precondition.none()) : new $70fd6868680e912c$var$__PRIVATE_SetMutation(e.key, e.data, $70fd6868680e912c$var$Precondition.none());
    {
        const n = e.data, r = $70fd6868680e912c$var$ObjectValue.empty();
        let i = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e.key, r, new $70fd6868680e912c$var$FieldMask(i.toArray()), $70fd6868680e912c$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($70fd6868680e912c$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $70fd6868680e912c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $70fd6868680e912c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($70fd6868680e912c$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $70fd6868680e912c$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $70fd6868680e912c$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$70fd6868680e912c$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $70fd6868680e912c$var$__PRIVATE_SetMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_PatchMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $70fd6868680e912c$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $70fd6868680e912c$var$__PRIVATE_hardAssert(e.length === n.length);
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $70fd6868680e912c$var$__PRIVATE_DeleteMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_VerifyMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $70fd6868680e912c$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $70fd6868680e912c$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $70fd6868680e912c$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($70fd6868680e912c$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t)) && $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $70fd6868680e912c$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(e.mutations.length === n.length);
        let r = function __PRIVATE_documentVersionMap() {
            return $70fd6868680e912c$var$Pt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $70fd6868680e912c$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $70fd6868680e912c$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $70fd6868680e912c$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $70fd6868680e912c$var$Et, $70fd6868680e912c$var$dt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $70fd6868680e912c$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $70fd6868680e912c$var$C.OK:
            return $70fd6868680e912c$var$fail();
        case $70fd6868680e912c$var$C.CANCELLED:
        case $70fd6868680e912c$var$C.UNKNOWN:
        case $70fd6868680e912c$var$C.DEADLINE_EXCEEDED:
        case $70fd6868680e912c$var$C.RESOURCE_EXHAUSTED:
        case $70fd6868680e912c$var$C.INTERNAL:
        case $70fd6868680e912c$var$C.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $70fd6868680e912c$var$C.UNAUTHENTICATED:
            return !1;
        case $70fd6868680e912c$var$C.INVALID_ARGUMENT:
        case $70fd6868680e912c$var$C.NOT_FOUND:
        case $70fd6868680e912c$var$C.ALREADY_EXISTS:
        case $70fd6868680e912c$var$C.PERMISSION_DENIED:
        case $70fd6868680e912c$var$C.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $70fd6868680e912c$var$C.ABORTED:
        case $70fd6868680e912c$var$C.OUT_OF_RANGE:
        case $70fd6868680e912c$var$C.UNIMPLEMENTED:
        case $70fd6868680e912c$var$C.DATA_LOSS:
            return !0;
        default:
            return $70fd6868680e912c$var$fail();
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $70fd6868680e912c$var$__PRIVATE_logError("GRPC error has no .code"), $70fd6868680e912c$var$C.UNKNOWN;
    switch(e){
        case $70fd6868680e912c$var$Et.OK:
            return $70fd6868680e912c$var$C.OK;
        case $70fd6868680e912c$var$Et.CANCELLED:
            return $70fd6868680e912c$var$C.CANCELLED;
        case $70fd6868680e912c$var$Et.UNKNOWN:
            return $70fd6868680e912c$var$C.UNKNOWN;
        case $70fd6868680e912c$var$Et.DEADLINE_EXCEEDED:
            return $70fd6868680e912c$var$C.DEADLINE_EXCEEDED;
        case $70fd6868680e912c$var$Et.RESOURCE_EXHAUSTED:
            return $70fd6868680e912c$var$C.RESOURCE_EXHAUSTED;
        case $70fd6868680e912c$var$Et.INTERNAL:
            return $70fd6868680e912c$var$C.INTERNAL;
        case $70fd6868680e912c$var$Et.UNAVAILABLE:
            return $70fd6868680e912c$var$C.UNAVAILABLE;
        case $70fd6868680e912c$var$Et.UNAUTHENTICATED:
            return $70fd6868680e912c$var$C.UNAUTHENTICATED;
        case $70fd6868680e912c$var$Et.INVALID_ARGUMENT:
            return $70fd6868680e912c$var$C.INVALID_ARGUMENT;
        case $70fd6868680e912c$var$Et.NOT_FOUND:
            return $70fd6868680e912c$var$C.NOT_FOUND;
        case $70fd6868680e912c$var$Et.ALREADY_EXISTS:
            return $70fd6868680e912c$var$C.ALREADY_EXISTS;
        case $70fd6868680e912c$var$Et.PERMISSION_DENIED:
            return $70fd6868680e912c$var$C.PERMISSION_DENIED;
        case $70fd6868680e912c$var$Et.FAILED_PRECONDITION:
            return $70fd6868680e912c$var$C.FAILED_PRECONDITION;
        case $70fd6868680e912c$var$Et.ABORTED:
            return $70fd6868680e912c$var$C.ABORTED;
        case $70fd6868680e912c$var$Et.OUT_OF_RANGE:
            return $70fd6868680e912c$var$C.OUT_OF_RANGE;
        case $70fd6868680e912c$var$Et.UNIMPLEMENTED:
            return $70fd6868680e912c$var$C.UNIMPLEMENTED;
        case $70fd6868680e912c$var$Et.DATA_LOSS:
            return $70fd6868680e912c$var$C.DATA_LOSS;
        default:
            return $70fd6868680e912c$var$fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($70fd6868680e912c$var$dt = $70fd6868680e912c$var$Et || ($70fd6868680e912c$var$Et = {}))[$70fd6868680e912c$var$dt.OK = 0] = "OK", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.CANCELLED = 1] = "CANCELLED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.UNKNOWN = 2] = "UNKNOWN", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.NOT_FOUND = 5] = "NOT_FOUND", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.ABORTED = 10] = "ABORTED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.INTERNAL = 13] = "INTERNAL", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.UNAVAILABLE = 14] = "UNAVAILABLE", $70fd6868680e912c$var$dt[$70fd6868680e912c$var$dt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $70fd6868680e912c$var$At = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Rt = new (0, $906344b47e605252$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $906344b47e605252$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $70fd6868680e912c$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $70fd6868680e912c$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.Ee = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.de = (0, $906344b47e605252$export$70ffa26850098d01).fromNumber(this.Ee);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Ae(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $906344b47e605252$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($70fd6868680e912c$var$Rt) && (r = new (0, $906344b47e605252$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.de).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    Re(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.Ee) return !1;
        const t = $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $70fd6868680e912c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ae(n, r, e);
            if (!this.Re(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $70fd6868680e912c$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.Ee) return;
        const t = $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $70fd6868680e912c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ae(n, r, e);
            this.Ve(t);
        }
    }
    Ve(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $70fd6868680e912c$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $70fd6868680e912c$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $70fd6868680e912c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $70fd6868680e912c$var$RemoteEvent($70fd6868680e912c$var$SnapshotVersion.min(), r, new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $70fd6868680e912c$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $70fd6868680e912c$var$TargetChange(n, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet(), $70fd6868680e912c$var$__PRIVATE_documentKeySet(), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.me = e, this.removedTargetIds = t, this.key = n, this.fe = r;
    }
}
class $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.ge = t;
    }
}
class $70fd6868680e912c$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $70fd6868680e912c$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.pe = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.ye = $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.we = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.Se = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.be = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Se;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.we;
    }
    /** Whether this target has pending target adds or target removes. */ get De() {
        return 0 !== this.pe;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get ve() {
        return this.be;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Ce(e) {
        e.approximateByteSize() > 0 && (this.be = !0, this.we = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Fe() {
        let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), t = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), n = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.ye.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $70fd6868680e912c$var$fail();
            }
        }), new $70fd6868680e912c$var$TargetChange(this.we, this.Se, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Me() {
        this.be = !1, this.ye = $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap();
    }
    xe(e, t) {
        this.be = !0, this.ye = this.ye.insert(e, t);
    }
    Oe(e) {
        this.be = !0, this.ye = this.ye.remove(e);
    }
    Ne() {
        this.pe += 1;
    }
    Be() {
        this.pe -= 1, $70fd6868680e912c$var$__PRIVATE_hardAssert(this.pe >= 0);
    }
    Le() {
        this.be = !0, this.Se = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $70fd6868680e912c$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.ke = e, /** The internal state of all tracked targets. */ this.qe = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.Qe = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), this.$e = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.Ue = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ke = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ We(e) {
        for (const t of e.me)e.fe && e.fe.isFoundDocument() ? this.Ge(t, e.fe) : this.ze(t, e.key, e.fe);
        for (const t of e.removedTargetIds)this.ze(t, e.key, e.fe);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ je(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.He(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.Je(t) && n.Ce(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Be(), n.De || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Me(), n.Ce(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Be(), n.De || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.Je(t) && (n.Le(), n.Ce(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.Je(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.Ye(t), n.Ce(e.resumeToken));
                    break;
                default:
                    $70fd6868680e912c$var$fail();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.qe.forEach((e, n)=>{
            this.Je(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ Ze(e) {
        const t = e.targetId, n = e.ge.count, r = this.Xe(t);
        if (r) {
            const i = r.target;
            if ($70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $70fd6868680e912c$export$afc2e57c475b7810(i.path);
                    this.ze(t, e, $70fd6868680e912c$var$MutableDocument.newNoDocument(e, $70fd6868680e912c$var$SnapshotVersion.min()));
                } else $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === n);
            } else {
                const r = this.et(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.tt(e), i = n ? this.nt(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.Ye(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ke = this.Ke.insert(t, e);
                    }
                    null == $70fd6868680e912c$var$At || $70fd6868680e912c$var$At.rt(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: (e)=>{
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }(r, e.ge, this.ke.it(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ tt(e) {
        const t = e.ge.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $70fd6868680e912c$var$__PRIVATE_Base64DecodeError) return $70fd6868680e912c$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $70fd6868680e912c$var$BloomFilter(s, r, i);
        } catch (e) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb(e instanceof $70fd6868680e912c$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.Ee ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ nt(e, t, n) {
        return t.ge.count === n - this.st(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ st(e, t) {
        const n = this.ke.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.ke.it(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.ze(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ ot(e) {
        const t = new Map;
        this.qe.forEach((n, r)=>{
            const i = this.Xe(r);
            if (i) {
                if (n.current && $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $70fd6868680e912c$export$afc2e57c475b7810(i.target.path);
                    this._t(t).has(r) || this.ut(r, t) || this.ze(r, t, $70fd6868680e912c$var$MutableDocument.newNoDocument(t, e));
                }
                n.ve && (t.set(r, n.Fe()), n.Me());
            }
        });
        let n = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Ue.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.Xe(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.Qe.forEach((t, n)=>n.setReadTime(e));
        const r = new $70fd6868680e912c$var$RemoteEvent(e, t, this.Ke, this.Qe, n);
        return this.Qe = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), this.$e = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), this.Ue = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), this.Ke = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ge(e, t) {
        if (!this.Je(e)) return;
        const n = this.ut(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.He(e).xe(t.key, n), this.Qe = this.Qe.insert(t.key, t), this.$e = this.$e.insert(t.key, this._t(t.key).add(e)), this.Ue = this.Ue.insert(t.key, this.ct(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    ze(e, t, n) {
        if (!this.Je(e)) return;
        const r = this.He(e);
        this.ut(e, t) ? r.xe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Oe(t), this.Ue = this.Ue.insert(t, this.ct(t).delete(e)), this.Ue = this.Ue.insert(t, this.ct(t).add(e)), n && (this.Qe = this.Qe.insert(t, n));
    }
    removeTarget(e) {
        this.qe.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ et(e) {
        const t = this.He(e).Fe();
        return this.ke.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ Ne(e) {
        this.He(e).Ne();
    }
    He(e) {
        let t = this.qe.get(e);
        return t || (t = new $70fd6868680e912c$var$__PRIVATE_TargetState, this.qe.set(e, t)), t;
    }
    ct(e) {
        let t = this.Ue.get(e);
        return t || (t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.Ue = this.Ue.insert(e, t)), t;
    }
    _t(e) {
        let t = this.$e.get(e);
        return t || (t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.$e = this.$e.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ Je(e) {
        const t = null !== this.Xe(e);
        return t || $70fd6868680e912c$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Xe(e) {
        const t = this.qe.get(e);
        return t && t.De ? null : this.ke.lt(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ Ye(e) {
        this.qe.set(e, new $70fd6868680e912c$var$__PRIVATE_TargetState);
        this.ke.getRemoteKeysForTarget(e).forEach((t)=>{
            this.ze(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ ut(e, t) {
        return this.ke.getRemoteKeysForTarget(e).has(t);
    }
}
function $70fd6868680e912c$var$__PRIVATE_documentTargetMap() {
    return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
function $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap() {
    return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
const $70fd6868680e912c$var$Vt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $70fd6868680e912c$var$mt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $70fd6868680e912c$var$ft = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $70fd6868680e912c$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $70fd6868680e912c$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $70fd6868680e912c$var$__PRIVATE_toVersion(e, t) {
    return $70fd6868680e912c$var$toTimestamp(e, t.toTimestamp());
}
function $70fd6868680e912c$var$__PRIVATE_fromVersion(e) {
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e), $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $70fd6868680e912c$var$__PRIVATE_toResourceName(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $70fd6868680e912c$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $70fd6868680e912c$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $70fd6868680e912c$var$__PRIVATE_fromResourceName(e) {
    const t = $70fd6868680e912c$var$ResourcePath.fromString(e);
    return $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isValidResourceName(t)), t;
}
function $70fd6868680e912c$var$__PRIVATE_toName(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $70fd6868680e912c$var$fromName(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $70fd6868680e912c$var$__PRIVATE_fromQueryPath(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $70fd6868680e912c$var$ResourcePath.emptyPath() : $70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $70fd6868680e912c$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $70fd6868680e912c$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $70fd6868680e912c$var$fromName(e, t.name), i = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), o = new $70fd6868680e912c$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $70fd6868680e912c$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $70fd6868680e912c$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        const n = $70fd6868680e912c$var$fromName(e, t.found.name), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.found.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), s = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $70fd6868680e912c$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.missing), $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.readTime);
        const n = $70fd6868680e912c$var$fromName(e, t.missing), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime);
        return $70fd6868680e912c$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $70fd6868680e912c$var$fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(t || "")) : ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $70fd6868680e912c$require$Buffer || t instanceof Uint8Array), $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $70fd6868680e912c$var$C.UNKNOWN : $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $70fd6868680e912c$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $70fd6868680e912c$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $70fd6868680e912c$var$fromName(e, r.document.name), s = $70fd6868680e912c$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(r.document.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), _ = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $70fd6868680e912c$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $70fd6868680e912c$var$fromName(e, r.document), s = r.readTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(r.readTime) : $70fd6868680e912c$var$SnapshotVersion.min(), o = $70fd6868680e912c$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $70fd6868680e912c$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $70fd6868680e912c$var$fail();
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $70fd6868680e912c$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $70fd6868680e912c$var$toMutation(e, t) {
    let n;
    if (t instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation) n = {
        update: $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_DeleteMutation) n = {
        delete: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation) n = {
        update: $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $70fd6868680e912c$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $70fd6868680e912c$var$__PRIVATE_VerifyMutation)) return $70fd6868680e912c$var$fail();
        n = {
            verify: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ie
            };
            throw $70fd6868680e912c$var$fail();
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $70fd6868680e912c$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $70fd6868680e912c$var$fail();
    }(e, t.precondition)), n;
}
function $70fd6868680e912c$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $70fd6868680e912c$var$Precondition.updateTime($70fd6868680e912c$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $70fd6868680e912c$var$Precondition.exists(e.exists) : $70fd6868680e912c$var$Precondition.none();
    }(t.currentDocument) : $70fd6868680e912c$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $70fd6868680e912c$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $70fd6868680e912c$var$fail();
            const r = $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $70fd6868680e912c$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $70fd6868680e912c$var$fromName(e, t.update.name), s = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $70fd6868680e912c$var$FieldMask(t.map((e)=>$70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $70fd6868680e912c$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $70fd6868680e912c$var$fromName(e, t.delete);
        return new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $70fd6868680e912c$var$fromName(e, t.verify);
        return new $70fd6868680e912c$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 !== t), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(e.updateTime) : $70fd6868680e912c$var$__PRIVATE_fromVersion(t);
            return n.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $70fd6868680e912c$var$__PRIVATE_fromVersion(t)), new $70fd6868680e912c$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $70fd6868680e912c$var$__PRIVATE_toFilter($70fd6868680e912c$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $70fd6868680e912c$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ht: n,
        parent: i
    };
}
function $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { ht: i, parent: s } = $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        Pt: o,
        parent: s
    };
}
function $70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $70fd6868680e912c$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === r);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_fromFilter(e);
        if (t instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $70fd6868680e912c$var$OrderBy($70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $70fd6868680e912c$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $70fd6868680e912c$var$Bound(n, t);
    }(n.endAt)), $70fd6868680e912c$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $70fd6868680e912c$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $70fd6868680e912c$var$fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $70fd6868680e912c$var$fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $70fd6868680e912c$var$FieldFilter.create($70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $70fd6868680e912c$var$fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $70fd6868680e912c$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $70fd6868680e912c$var$fail();
            }
        }(e.compositeFilter.op));
    }(e) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_toDirection(e) {
    return $70fd6868680e912c$var$Vt[e];
}
function $70fd6868680e912c$var$__PRIVATE_toOperatorName(e) {
    return $70fd6868680e912c$var$mt[e];
}
function $70fd6868680e912c$var$__PRIVATE_toCompositeOperatorName(e) {
    return $70fd6868680e912c$var$ft[e];
}
function $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e) {
    return $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $70fd6868680e912c$var$__PRIVATE_toFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($70fd6868680e912c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($70fd6868680e912c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($70fd6868680e912c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($70fd6868680e912c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                op: $70fd6868680e912c$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$70fd6868680e912c$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $70fd6868680e912c$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $70fd6868680e912c$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $70fd6868680e912c$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $70fd6868680e912c$var$SnapshotVersion.min(), s = $70fd6868680e912c$var$SnapshotVersion.min(), o = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $70fd6868680e912c$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.Tt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $70fd6868680e912c$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $70fd6868680e912c$var$__PRIVATE_fromDocument(e.Tt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $70fd6868680e912c$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $70fd6868680e912c$var$fail();
        {
            const e = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $70fd6868680e912c$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $70fd6868680e912c$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $70fd6868680e912c$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.Tt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $70fd6868680e912c$var$fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$70fd6868680e912c$var$__PRIVATE_fromMutation(e.Tt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$70fd6868680e912c$var$__PRIVATE_fromMutation(e.Tt, t)), i = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $70fd6868680e912c$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $70fd6868680e912c$var$__PRIVATE_fromDbTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $70fd6868680e912c$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === e.documents.length), $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath($70fd6868680e912c$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $70fd6868680e912c$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $70fd6868680e912c$var$__PRIVATE_toDbTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e.Tt, t.target) : $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e.Tt, t.target).ht;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $70fd6868680e912c$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $70fd6868680e912c$var$Overlay(t.largestBatchId, $70fd6868680e912c$var$__PRIVATE_fromMutation(e.Tt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $70fd6868680e912c$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp($70fd6868680e912c$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp($70fd6868680e912c$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $70fd6868680e912c$var$__PRIVATE_bundlesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$me);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$ge);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static It(e, t) {
        const n = t.uid || "";
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).get($70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $70fd6868680e912c$var$Overlay(t, i);
            r.push(this.Et(e, s));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).J($70fd6868680e912c$var$ke, r));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).G($70fd6868680e912c$var$ke, s).next((e)=>{
            for (const t of e){
                const e = $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).Z({
            index: $70fd6868680e912c$var$Qe,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    Et(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $70fd6868680e912c$var$toMutation(e.Tt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Be);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbGlobalsCache {
    dt(e) {
        return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Ue);
    }
    getSessionToken(e) {
        return this.dt(e).get("sessionToken").next((e)=>{
            const t = null == e ? void 0 : e.value;
            return t ? $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(t) : $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.dt(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ At(e, t) {
        this.Rt(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.Vt();
    }
    Rt(e, t) {
        if ("nullValue" in e) this.ft(t, 5);
        else if ("booleanValue" in e) this.ft(t, 10), t.gt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.ft(t, 15), t.gt($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.ft(t, 13) : (this.ft(t, 15), $70fd6868680e912c$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.gt(0) : t.gt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.ft(t, 20), "string" == typeof n && (n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(n)), t.yt(`${n.seconds || ""}`), t.gt(n.nanos || 0);
        } else if ("stringValue" in e) this.wt(e.stringValue, t), this.St(t);
        else if ("bytesValue" in e) this.ft(t, 30), t.bt($70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.St(t);
        else if ("referenceValue" in e) this.Dt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.ft(t, 45), t.gt(n.latitude || 0), t.gt(n.longitude || 0);
        } else "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) ? this.ft(t, Number.MAX_SAFE_INTEGER) : $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? this.vt(e.mapValue, t) : (this.Ct(e.mapValue, t), this.St(t)) : "arrayValue" in e ? (this.Ft(e.arrayValue, t), this.St(t)) : $70fd6868680e912c$var$fail();
    }
    wt(e, t) {
        this.ft(t, 25), this.Mt(e, t);
    }
    Mt(e, t) {
        t.yt(e);
    }
    Ct(e, t) {
        const n = e.fields || {};
        this.ft(t, 55);
        for (const e of Object.keys(n))this.wt(e, t), this.Rt(n[e], t);
    }
    vt(e, t) {
        var n, r;
        const i = e.fields || {};
        this.ft(t, 53);
        // Vectors sort first by length
        const s = $70fd6868680e912c$var$at, o = (null === (r = null === (n = i[s].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
        this.ft(t, 15), t.gt($70fd6868680e912c$var$__PRIVATE_normalizeNumber(o)), // Vectors then sort by position value
        this.wt(s, t), this.Rt(i[s], t);
    }
    Ft(e, t) {
        const n = e.values || [];
        this.ft(t, 50);
        for (const e of n)this.Rt(e, t);
    }
    Dt(e, t) {
        this.ft(t, 37);
        $70fd6868680e912c$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.ft(t, 60), this.Mt(e, t);
        });
    }
    ft(e, t) {
        e.gt(t);
    }
    St(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.gt(2);
    }
}
$70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.xt = new $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $70fd6868680e912c$var$gt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $70fd6868680e912c$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $70fd6868680e912c$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Ot(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Nt(n.value), n = t.next();
        this.Bt();
    }
    Lt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.kt(n.value), n = t.next();
        this.qt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Qt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Nt(e);
            else if (e < 2048) this.Nt(960 | e >>> 6), this.Nt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Nt(480 | e >>> 12), this.Nt(128 | 63 & e >>> 6), this.Nt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Nt(240 | e >>> 18), this.Nt(128 | 63 & e >>> 12), this.Nt(128 | 63 & e >>> 6), this.Nt(128 | 63 & e);
            }
        }
        this.Bt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ $t(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.kt(e);
            else if (e < 2048) this.kt(960 | e >>> 6), this.kt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.kt(480 | e >>> 12), this.kt(128 | 63 & e >>> 6), this.kt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.kt(240 | e >>> 18), this.kt(128 | 63 & e >>> 12), this.kt(128 | 63 & e >>> 6), this.kt(128 | 63 & e);
            }
        }
        this.qt();
    }
    Ut(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Kt(e), n = $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(t);
        this.Wt(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    Gt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Kt(e), n = $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(t);
        this.Wt(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ zt() {
        this.jt($70fd6868680e912c$var$gt), this.jt(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Ht() {
        this.Jt($70fd6868680e912c$var$gt), this.Jt(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.Wt(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Yt() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Kt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Nt(e) {
        const t = 255 & e;
        0 === t ? (this.jt(0), this.jt(255)) : t === $70fd6868680e912c$var$gt ? (this.jt($70fd6868680e912c$var$gt), this.jt(0)) : this.jt(t);
    }
    /** Writes a single byte descending to the buffer.  */ kt(e) {
        const t = 255 & e;
        0 === t ? (this.Jt(0), this.Jt(255)) : t === $70fd6868680e912c$var$gt ? (this.Jt($70fd6868680e912c$var$gt), this.Jt(0)) : this.Jt(e);
    }
    Bt() {
        this.jt(0), this.jt(1);
    }
    qt() {
        this.Jt(0), this.Jt(1);
    }
    jt(e) {
        this.Wt(1), this.buffer[this.position++] = e;
    }
    Jt(e) {
        this.Wt(1), this.buffer[this.position++] = ~e;
    }
    Wt(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $70fd6868680e912c$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.Zt = e;
    }
    bt(e) {
        this.Zt.Ot(e);
    }
    yt(e) {
        this.Zt.Qt(e);
    }
    gt(e) {
        this.Zt.Ut(e);
    }
    Vt() {
        this.Zt.zt();
    }
}
class $70fd6868680e912c$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.Zt = e;
    }
    bt(e) {
        this.Zt.Lt(e);
    }
    yt(e) {
        this.Zt.$t(e);
    }
    gt(e) {
        this.Zt.Gt(e);
    }
    Vt() {
        this.Zt.Ht();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.Zt = new $70fd6868680e912c$var$__PRIVATE_OrderedCodeWriter, this.Xt = new $70fd6868680e912c$var$__PRIVATE_AscendingIndexByteEncoder(this.Zt), this.en = new $70fd6868680e912c$var$__PRIVATE_DescendingIndexByteEncoder(this.Zt);
    }
    seed(e) {
        this.Zt.seed(e);
    }
    tn(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.Xt : this.en;
    }
    Yt() {
        return this.Zt.Yt();
    }
    reset() {
        this.Zt.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $70fd6868680e912c$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ nn() {
        const e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.directionalValue, 0), t !== e ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $70fd6868680e912c$var$__PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey)));
}
function $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.rn = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.sn = e.orderBy, this._n = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.rn = this.rn.add(e) : this._n.push(e);
        }
    }
    get an() {
        return this.rn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ un(e) {
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId), this.an) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.cn(t)) return !1;
        const n = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.cn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.rn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.rn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.ln(e, t) || !this.hn(this.sn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.sn.length || !this.hn(this.sn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ Pn() {
        if (this.an) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this._n){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $70fd6868680e912c$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $70fd6868680e912c$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.sn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $70fd6868680e912c$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $70fd6868680e912c$var$FieldIndex($70fd6868680e912c$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $70fd6868680e912c$var$IndexState.empty());
    }
    cn(e) {
        for (const t of this._n)if (this.ln(t, e)) return !0;
        return !1;
    }
    ln(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    hn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $70fd6868680e912c$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), e instanceof $70fd6868680e912c$var$FieldFilter) {
        if (e instanceof $70fd6868680e912c$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$70fd6868680e912c$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $70fd6868680e912c$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_computeInExpansion(e));
    return $70fd6868680e912c$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $70fd6868680e912c$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm($70fd6868680e912c$var$__PRIVATE_computeInExpansion(e));
    return $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(t)), $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(t) || $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(e) || $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(t) && !$70fd6868680e912c$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), e instanceof $70fd6868680e912c$var$FieldFilter) return e;
    if (1 === e.filters.length) return $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $70fd6868680e912c$var$CompositeFilter.create(t, e.op);
    return n = $70fd6868680e912c$var$__PRIVATE_applyAssociation(n), $70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($70fd6868680e912c$var$__PRIVATE_hardAssert(n instanceof $70fd6868680e912c$var$CompositeFilter), $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(n)), $70fd6868680e912c$var$__PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce((e, t)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t)));
}
function $70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), $70fd6868680e912c$var$__PRIVATE_hardAssert(t instanceof $70fd6868680e912c$var$FieldFilter || t instanceof $70fd6868680e912c$var$CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof $70fd6868680e912c$var$FieldFilter ? t instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $70fd6868680e912c$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $70fd6868680e912c$var$FieldFilter ? $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e) && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(t)) return $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, r));
        return $70fd6868680e912c$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $70fd6868680e912c$var$__PRIVATE_applyAssociation(n);
}
function $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t));
        return $70fd6868680e912c$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $70fd6868680e912c$var$__PRIVATE_applyAssociation(e) {
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), e instanceof $70fd6868680e912c$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $70fd6868680e912c$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$70fd6868680e912c$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $70fd6868680e912c$var$FieldFilter ? r.push(t) : t instanceof $70fd6868680e912c$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $70fd6868680e912c$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Tn = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Tn.add(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Tn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$pt = "IndexedDbIndexManager", $70fd6868680e912c$var$yt = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.In = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.En = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), (e, t)=>$70fd6868680e912c$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.In.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.In.add(t);
            });
            const i = {
                collectionId: n,
                parent: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r)
            };
            return $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e).G(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($70fd6868680e912c$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e), i = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), n = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return t.J().next(()=>n.J()).next(()=>r.J());
    }
    createTargetIndexes(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.dn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher(t).Pn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.dn(t), (t)=>this.An(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                const r = [];
                return $70fd6868680e912c$var$PersistencePromise.forEach(i, (i, s)=>{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$pt, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$70fd6868680e912c$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $70fd6868680e912c$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $70fd6868680e912c$var$Bound(n, r);
                    }(s, i), c = this.Rn(i, s, a), l = this.Rn(i, s, u), h = this.Vn(i, s, _), P = this.mn(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $70fd6868680e912c$var$PersistencePromise.forEach(P, (i)=>n.H(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $70fd6868680e912c$var$PersistencePromise.resolve(null);
        });
    }
    dn(e) {
        let t = this.En.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $70fd6868680e912c$var$__PRIVATE_getDnfTerms($70fd6868680e912c$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.En.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ mn(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.fn(t[c / a]) : $70fd6868680e912c$var$yt, l = this.gn(e, _, n[c % a], r), h = this.pn(e, _, i[c % a], s), P = o.map((t)=>this.gn(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ gn(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_IndexEntry(e, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.nn();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ pn(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_IndexEntry(e, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.nn() : i;
    }
    An(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.un(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.dn(t);
        return $70fd6868680e912c$var$PersistencePromise.forEach(r, (t)=>this.An(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ yn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        for (const r of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.tn(r.kind);
            $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.xt.At(e, i);
        }
        return n.Yt();
    }
    /** Encodes a single value to the ascending index format. */ fn(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        return $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.xt.At(e, t.tn(0 /* IndexKind.ASCENDING */ )), t.Yt();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ wn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        return $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.xt.At($70fd6868680e912c$var$__PRIVATE_refValue(this.databaseId, t), n.tn(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Yt();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ Vn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.Sn(t, s.fieldPath) && $70fd6868680e912c$var$isArray(e)) r = this.bn(r, s, e);
            else {
                const t = n.tn(s.kind);
                $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.xt.At(e, t);
            }
        }
        return this.Dn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ Rn(e, t, n) {
        return this.Vn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ Dn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Yt();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ bn(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.Yt()), $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.xt.At(e, r.tn(t.kind)), i.push(r);
        }
        return i;
    }
    Sn(e, t) {
        return !!e.filters.find((e)=>e instanceof $70fd6868680e912c$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return (t ? n.G($70fd6868680e912c$var$Se, IDBKeyRange.bound(t, t)) : n.G()).next((e)=>{
            const t = [];
            return $70fd6868680e912c$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $70fd6868680e912c$var$IndexState(t.sequenceNumber, new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.readTime), new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $70fd6868680e912c$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $70fd6868680e912c$var$IndexSegment($70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $70fd6868680e912c$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), i = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return this.vn(e).next((e)=>r.G($70fd6868680e912c$var$Se, IDBKeyRange.bound(t, t)).next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>i.put($70fd6868680e912c$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $70fd6868680e912c$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $70fd6868680e912c$var$PersistencePromise.forEach(i, (n)=>this.Cn(e, t, n).next((t)=>{
                        const i = this.Fn(r, n);
                        return t.isEqual(i) ? $70fd6868680e912c$var$PersistencePromise.resolve() : this.Mn(e, r, n, t, i);
                    }))));
        });
    }
    xn(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e).put({
            indexId: r.indexId,
            uid: this.uid,
            arrayValue: r.arrayValue,
            directionalValue: r.directionalValue,
            orderedDocumentKey: this.wn(n, t.key),
            documentKey: t.key.path.toArray()
        });
    }
    On(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e).delete([
            r.indexId,
            this.uid,
            r.arrayValue,
            r.directionalValue,
            this.wn(n, t.key),
            t.key.path.toArray()
        ]);
    }
    Cn(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        let i = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_indexEntryComparator);
        return r.Z({
            index: $70fd6868680e912c$var$Oe,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.wn(n, t)
            ])
        }, (e, r)=>{
            i = i.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Fn(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_indexEntryComparator);
        const r = this.yn(t, e);
        if (null == r) return n;
        const i = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($70fd6868680e912c$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.fn(i), r));
        } else n = n.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(t.indexId, e.key, $70fd6868680e912c$var$yt, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ Mn(e, t, n, r, i) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$pt, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s)) : (_ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $70fd6868680e912c$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.xn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.On(e, t, n, r));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(s);
    }
    vn(e) {
        let t = 1;
        return $70fd6868680e912c$var$__PRIVATE_indexStateStore(e).Z({
            index: $70fd6868680e912c$var$Ce,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(i, e), s = $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.nn();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.nn());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Nn(r[e], r[e + 1])) return [];
            const t = [
                r[e].indexId,
                this.uid,
                r[e].arrayValue,
                r[e].directionalValue,
                $70fd6868680e912c$var$yt,
                []
            ], n = [
                r[e + 1].indexId,
                this.uid,
                r[e + 1].arrayValue,
                r[e + 1].directionalValue,
                $70fd6868680e912c$var$yt,
                []
            ];
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Nn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.mapArray(this.dn(t), (t)=>this.An(e, t).next((e)=>e || $70fd6868680e912c$var$fail())).next($70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$de);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Me);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$ye);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexStateStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$De);
}
function $70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $70fd6868680e912c$var$__PRIVATE_hardAssert(0 !== e.length);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $70fd6868680e912c$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$wt = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $70fd6868680e912c$var$St = 41943040;
class $70fd6868680e912c$var$LruParams {
    static withCacheSize(e) {
        return new $70fd6868680e912c$var$LruParams(e, $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $70fd6868680e912c$var$removeMutationBatch(e, t, n) {
    const r = e.store($70fd6868680e912c$var$j), i = e.store($70fd6868680e912c$var$X), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.Z({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === _);
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $70fd6868680e912c$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $70fd6868680e912c$var$fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $70fd6868680e912c$var$LruParams.DEFAULT = new $70fd6868680e912c$var$LruParams($70fd6868680e912c$var$St, $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $70fd6868680e912c$var$LruParams.DISABLED = new $70fd6868680e912c$var$LruParams(-1, 0, 0);
class $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Bn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static It(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $70fd6868680e912c$var$__PRIVATE_hardAssert("" !== e.uid);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).Z({
            index: $70fd6868680e912c$var$J,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e), s = $70fd6868680e912c$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $70fd6868680e912c$var$__PRIVATE_hardAssert("number" == typeof o);
            const _ = new $70fd6868680e912c$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$70fd6868680e912c$var$toMutation(e.Tt, t)), i = n.mutations.map((t)=>$70fd6868680e912c$var$toMutation(e.Tt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $70fd6868680e912c$var$Z));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Bn[o] = _.keys();
            }), $70fd6868680e912c$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId), $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Ln(e, t) {
        return this.Bn[t] ? $70fd6868680e912c$var$PersistencePromise.resolve(this.Bn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Bn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).Z({
            index: $70fd6868680e912c$var$J,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($70fd6868680e912c$var$__PRIVATE_hardAssert(t.batchId >= n), i = $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $70fd6868680e912c$var$Q;
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).Z({
            index: $70fd6868680e912c$var$J,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $70fd6868680e912c$var$Q
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).G($70fd6868680e912c$var$J, t).next((e)=>e.map((e)=>$70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).Z({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $70fd6868680e912c$var$fail();
                $70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId), i.push($70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).Z({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r).next(()=>this.kn(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).Z({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.kn(e, o));
    }
    kn(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $70fd6868680e912c$var$fail();
                $70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId), n.push($70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $70fd6868680e912c$var$removeMutationBatch(e.ue, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.qn(t.batchId);
            }), $70fd6868680e912c$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    qn(e) {
        delete this.Bn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $70fd6868680e912c$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).Z({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $70fd6868680e912c$var$__PRIVATE_hardAssert(0 === r.length);
            });
        });
    }
    containsKey(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Qn(e) {
        return $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $70fd6868680e912c$var$Q,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).Z({
        range: s,
        Y: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$j);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$X);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$G);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.$n = e;
    }
    next() {
        return this.$n += 2, this.$n;
    }
    static Un() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(0);
    }
    static Kn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Wn(e).next((t)=>{
            const n = new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.Gn(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Wn(e).next((e)=>$70fd6868680e912c$var$SnapshotVersion.fromTimestamp(new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.Wn(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.Wn(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.Gn(e, r)));
    }
    addTargetData(e, t) {
        return this.zn(e, t).next(()=>this.Wn(e).next((n)=>(n.targetCount += 1, this.jn(t, n), this.Gn(e, n))));
    }
    updateTargetData(e, t) {
        return this.zn(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$70fd6868680e912c$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.Wn(e)).next((t)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, this.Gn(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).Z((s, o)=>{
            const _ = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).Z((e, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    Wn(e) {
        return $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e).get($70fd6868680e912c$var$Ie).next((e)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(null !== e), e));
    }
    Gn(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e).put($70fd6868680e912c$var$Ie, t);
    }
    zn(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).put($70fd6868680e912c$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ jn(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.Wn(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $70fd6868680e912c$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).Z({
            range: r,
            index: $70fd6868680e912c$var$ue
        }, (e, n, r)=>{
            const s = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $70fd6868680e912c$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>{
            const i = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path);
            return $70fd6868680e912c$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        let i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return r.Z({
            range: n,
            Y: !0
        }, (e, t, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e[1]), s = new $70fd6868680e912c$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).Z({
            index: $70fd6868680e912c$var$Pe,
            Y: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    lt(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $70fd6868680e912c$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $70fd6868680e912c$var$__PRIVATE_targetsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$ae);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Ee);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$le);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$bt = "LruGarbageCollector", $70fd6868680e912c$var$Dt = 1048576;
function $70fd6868680e912c$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $70fd6868680e912c$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $70fd6868680e912c$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Hn = e, this.buffer = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_bufferEntryComparator), this.Jn = 0;
    }
    Yn() {
        return ++this.Jn;
    }
    Zn(e) {
        const t = [
            e,
            this.Yn()
        ];
        if (this.buffer.size < this.Hn) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $70fd6868680e912c$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $70fd6868680e912c$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Xn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.er(6e4);
    }
    stop() {
        this.Xn && (this.Xn.cancel(), this.Xn = null);
    }
    get started() {
        return null !== this.Xn;
    }
    er(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$bt, `Garbage collection scheduled in ${e}ms`), this.Xn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Xn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$bt, "Ignoring IndexedDB error during garbage collection: ", e) : await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.er(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $70fd6868680e912c$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.tr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.tr.nr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$__PRIVATE_ListenSequence.ae);
        const n = new $70fd6868680e912c$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.tr.forEachTarget(e, (e)=>n.Zn(e.sequenceNumber)).next(()=>this.tr.rr(e, (e)=>n.Zn(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.tr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.tr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$wt)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $70fd6868680e912c$var$wt) : this.ir(e, t));
    }
    getCacheSize(e) {
        return this.tr.getCacheSize(e);
    }
    ir(e, t) {
        let n, r, i, s, o, _, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) $70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - _) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $70fd6868680e912c$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $70fd6868680e912c$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    nr(e) {
        const t = this.sr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    sr(e) {
        let t = 0;
        return this.rr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    rr(e, t) {
        return this._r(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ ar(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e).X((r)=>$70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $70fd6868680e912c$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this._r(e, (s, o)=>{
            if (o <= t) {
                const t = this.ar(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $70fd6868680e912c$var$SnapshotVersion.min()), $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ _r(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        let r, i = $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae;
        return n.Z({
            index: $70fd6868680e912c$var$Pe
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae && t(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae && t(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $70fd6868680e912c$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.ur(e, n)));
    }
    getEntry(e, t) {
        let n = $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t);
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: $70fd6868680e912c$var$ne,
            range: IDBKeyRange.only($70fd6868680e912c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.cr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ lr(e, t) {
        let n = {
            size: 0,
            document: $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t)
        };
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: $70fd6868680e912c$var$ne,
            range: IDBKeyRange.only($70fd6868680e912c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.cr(t, r),
                size: $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return this.hr(e, t, (e, t)=>{
            const r = this.cr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Pr(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), r = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        return this.hr(e, t, (e, t)=>{
            const i = this.cr(e, t);
            n = n.insert(e, i), r = r.insert(e, $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Tr: r
            }));
    }
    hr(e, t, n) {
        if (t.isEmpty()) return $70fd6868680e912c$var$PersistencePromise.resolve();
        let r = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($70fd6868680e912c$var$__PRIVATE_dbKey(r.first()), $70fd6868680e912c$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: $70fd6868680e912c$var$ne,
            range: i
        }, (e, t, r)=>{
            const i = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $70fd6868680e912c$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.W($70fd6868680e912c$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).G(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            null == i || i.incrementDocumentReadCount(e.length);
            let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.cr($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($70fd6868680e912c$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        const s = $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(t, $70fd6868680e912c$var$IndexOffset.max());
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: $70fd6868680e912c$var$ie,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.cr($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e).get($70fd6868680e912c$var$_e).next((e)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(!!e), e));
    }
    ur(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e).put($70fd6868680e912c$var$_e, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ cr(e, t) {
        if (t) {
            const e = $70fd6868680e912c$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($70fd6868680e912c$var$SnapshotVersion.min()))) return e;
        }
        return $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Ir = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Er = new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Er.get(i);
            if (t.push(this.Ir.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(this.Ir.serializer, s);
                r = r.add(i.path.popLast());
                const a = $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Ir.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(this.Ir.serializer, s.convertToNoDocument($70fd6868680e912c$var$SnapshotVersion.min()));
                t.push(this.Ir.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Ir.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Ir.updateMetadata(e, n)), $70fd6868680e912c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Ir.lr(e, t).next((e)=>(this.Er.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Ir.Pr(e, t).next(({ documents: e, Tr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Er.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$oe);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$ee);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $70fd6868680e912c$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $70fd6868680e912c$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $70fd6868680e912c$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $70fd6868680e912c$var$FieldMask.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $70fd6868680e912c$var$__PRIVATE_documentKeySet()) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $70fd6868680e912c$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $70fd6868680e912c$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        const s = $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $70fd6868680e912c$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $70fd6868680e912c$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $70fd6868680e912c$var$SortedMap((e, t)=>e - t), i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $70fd6868680e912c$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $70fd6868680e912c$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $70fd6868680e912c$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $70fd6868680e912c$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $70fd6868680e912c$var$N, _ = i;
            return s.next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $70fd6868680e912c$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $70fd6868680e912c$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $70fd6868680e912c$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $70fd6868680e912c$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$70fd6868680e912c$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $70fd6868680e912c$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $70fd6868680e912c$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $70fd6868680e912c$var$FieldMask.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $70fd6868680e912c$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.dr = new Map, this.Ar = new Map;
    }
    getBundleMetadata(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.dr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.dr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $70fd6868680e912c$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Ar.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Ar.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $70fd6868680e912c$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator), this.Rr = new Map;
    }
    getOverlay(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.Et(e, t, r);
        }), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Rr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Rr.delete(n)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $70fd6868680e912c$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $70fd6868680e912c$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(o);
    }
    Et(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Rr.get(r.largestBatchId).delete(n.key);
            this.Rr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $70fd6868680e912c$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Rr.get(t);
        void 0 === i && (i = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.Rr.set(t, i)), this.Rr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $70fd6868680e912c$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Vr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.mr), // A set of outstanding references to a document sorted by target id.
        this.gr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.pr);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Vr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, t);
        this.Vr = this.Vr.add(n), this.gr = this.gr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ yr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.wr(new $70fd6868680e912c$var$__PRIVATE_DocReference(e, t));
    }
    Sr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ br(e) {
        const t = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath([])), n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.gr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.wr(e), i.push(e.key);
        }), i;
    }
    Dr() {
        this.Vr.forEach((e)=>this.wr(e));
    }
    wr(e) {
        this.Vr = this.Vr.delete(e), this.gr = this.gr.delete(e);
    }
    vr(e) {
        const t = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath([])), n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e + 1);
        let i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.gr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, 0), n = this.Vr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $70fd6868680e912c$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Cr = t;
    }
    /** Compare by key then by ID */ static mr(e, t) {
        return $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key) || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.Cr, t.Cr);
    }
    /** Compare by ID then by key */ static pr(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.Cr, t.Cr) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Fr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Mr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.mr);
    }
    checkEmpty(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Fr;
        this.Fr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $70fd6868680e912c$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Mr = this.Mr.add(new $70fd6868680e912c$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $70fd6868680e912c$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Or(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Nr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $70fd6868680e912c$var$Q : this.Fr - 1);
    }
    getAllMutationBatches(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, 0), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Mr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Or(e.Cr);
            i.push(t);
        }), $70fd6868680e912c$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, 0), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Mr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Cr);
            });
        }), $70fd6868680e912c$var$PersistencePromise.resolve(this.Br(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $70fd6868680e912c$var$__PRIVATE_DocReference(new $70fd6868680e912c$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return this.Mr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Cr)), !0);
        }, s), $70fd6868680e912c$var$PersistencePromise.resolve(this.Br(o));
    }
    Br(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Or(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(0 === this.Lr(t.batchId, "removed")), this.mutationQueue.shift();
        let n = this.Mr;
        return $70fd6868680e912c$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $70fd6868680e912c$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Mr = n;
        });
    }
    qn(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, 0), r = this.Mr.firstAfterOrEqual(n);
        return $70fd6868680e912c$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ Lr(e, t) {
        return this.Nr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Nr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Or(e) {
        const t = this.Nr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.kr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.kr(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $70fd6868680e912c$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e));
        }), $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $70fd6868680e912c$export$afc2e57c475b7810(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator($70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $70fd6868680e912c$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $70fd6868680e912c$var$fail();
    }
    qr(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Ir = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Ir.addEntry(e, r)) : this.Ir.removeEntry(n);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Ir.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Ir.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Qr = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), $70fd6868680e912c$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $70fd6868680e912c$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.$r = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.Ur = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.Kr = $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator.Un();
    }
    forEachTarget(e, t) {
        return this.Qr.forEach((e, n)=>t(n)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.$r);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.Kr.next(), $70fd6868680e912c$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.$r && (this.$r = t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    zn(e) {
        this.Qr.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.Kr = new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.$r && (this.$r = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.zn(t), this.targetCount += 1, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.zn(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.Qr.delete(t.target), this.Ur.br(t.targetId), this.targetCount -= 1, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.Qr.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.Qr.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.Qr.get(t) || null;
        return $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.Ur.yr(t, n), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.Ur.Sr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.Ur.br(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.Ur.vr(t);
        return $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Ur.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.Wr = {}, this.overlays = {}, this.Gr = new $70fd6868680e912c$var$__PRIVATE_ListenSequence(0), this.zr = !1, this.zr = !0, this.jr = new $70fd6868680e912c$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.Hr = new $70fd6868680e912c$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $70fd6868680e912c$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.Jr(e)), this.serializer = new $70fd6868680e912c$var$__PRIVATE_LocalSerializer(t), this.Yr = new $70fd6868680e912c$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.zr = !1, Promise.resolve();
    }
    get started() {
        return this.zr;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $70fd6868680e912c$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.Wr[e.toKey()];
        return n || (n = new $70fd6868680e912c$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.Wr[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.jr;
    }
    getTargetCache() {
        return this.Hr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Yr;
    }
    runTransaction(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $70fd6868680e912c$var$__PRIVATE_MemoryTransaction(this.Gr.next());
        return this.referenceDelegate.Zr(), n(r).next((e)=>this.referenceDelegate.Xr(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    ei(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.or(Object.values(this.Wr).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryTransaction extends $70fd6868680e912c$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.ti = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.ni = null;
    }
    static ri(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get ii() {
        if (this.ni) return this.ni;
        throw $70fd6868680e912c$var$fail();
    }
    addReference(e, t, n) {
        return this.ti.addReference(n, t), this.ii.delete(n.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.ti.removeReference(n, t), this.ii.add(n.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.ii.add(t.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.ti.br(t.targetId).forEach((e)=>this.ii.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.ii.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Zr() {
        this.ni = new Set;
    }
    Xr(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.ii, (n)=>{
            const r = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(n);
            return this.si(e, r).next((e)=>{
                e || t.removeEntry(r, $70fd6868680e912c$var$SnapshotVersion.min());
            });
        }).next(()=>(this.ni = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.si(e, t).next((e)=>{
            e ? this.ii.delete(t.toString()) : this.ii.add(t.toString());
        });
    }
    Jr(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    si(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.or([
            ()=>$70fd6868680e912c$var$PersistencePromise.resolve(this.ti.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.ei(e, t)
        ]);
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.oi = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static ri(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Zr() {}
    Xr(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    nr(e) {
        const t = this.sr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    sr(e) {
        let t = 0;
        return this.rr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    rr(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.oi, (n, r)=>this.ar(e, n, r).next((e)=>e ? $70fd6868680e912c$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.qr(e, (r)=>this.ar(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $70fd6868680e912c$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.oi.set(t, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.oi.set(n, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.oi.set(n, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.oi.set(t, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    Jr(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $70fd6868680e912c$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    ar(e, t, n) {
        return $70fd6868680e912c$var$PersistencePromise.or([
            ()=>this.persistence.ei(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.oi.get(t);
                return $70fd6868680e912c$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $70fd6868680e912c$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ B(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($70fd6868680e912c$var$K);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($70fd6868680e912c$var$G, {
                keyPath: $70fd6868680e912c$var$z
            });
            const t = e.createObjectStore($70fd6868680e912c$var$j, {
                keyPath: $70fd6868680e912c$var$H,
                autoIncrement: !0
            });
            t.createIndex($70fd6868680e912c$var$J, $70fd6868680e912c$var$Y, {
                unique: !0
            }), e.createObjectStore($70fd6868680e912c$var$X);
        }(e), $70fd6868680e912c$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($70fd6868680e912c$var$U);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $70fd6868680e912c$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($70fd6868680e912c$var$le), e.deleteObjectStore($70fd6868680e912c$var$ae), e.deleteObjectStore($70fd6868680e912c$var$Ee);
        }(e), $70fd6868680e912c$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($70fd6868680e912c$var$Ee), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $70fd6868680e912c$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($70fd6868680e912c$var$Ie, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($70fd6868680e912c$var$j);
                return n.G().next((n)=>{
                    e.deleteObjectStore($70fd6868680e912c$var$j);
                    e.createObjectStore($70fd6868680e912c$var$j, {
                        keyPath: $70fd6868680e912c$var$H,
                        autoIncrement: !0
                    }).createIndex($70fd6868680e912c$var$J, $70fd6868680e912c$var$Y, {
                        unique: !0
                    });
                    const r = t.store($70fd6868680e912c$var$j), i = n.map((e)=>r.put(e));
                    return $70fd6868680e912c$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($70fd6868680e912c$var$Re, {
                    keyPath: $70fd6868680e912c$var$Ve
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this._i(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($70fd6868680e912c$var$oe);
            })(e), this.ai(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.ui(i))), n < 8 && r >= 8 && (s = s.next(()=>this.ci(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.li(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($70fd6868680e912c$var$me, {
                    keyPath: $70fd6868680e912c$var$fe
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($70fd6868680e912c$var$ge, {
                    keyPath: $70fd6868680e912c$var$pe
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($70fd6868680e912c$var$Be, {
                    keyPath: $70fd6868680e912c$var$Le
                });
                t.createIndex($70fd6868680e912c$var$ke, $70fd6868680e912c$var$qe, {
                    unique: !1
                }), t.createIndex($70fd6868680e912c$var$Qe, $70fd6868680e912c$var$$e, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($70fd6868680e912c$var$ee, {
                    keyPath: $70fd6868680e912c$var$te
                });
                t.createIndex($70fd6868680e912c$var$ne, $70fd6868680e912c$var$re), t.createIndex($70fd6868680e912c$var$ie, $70fd6868680e912c$var$se);
            })(e)).next(()=>this.hi(e, i)).next(()=>e.deleteObjectStore($70fd6868680e912c$var$U))), n < 14 && r >= 14 && (s = s.next(()=>this.Pi(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($70fd6868680e912c$var$ye, {
                    keyPath: $70fd6868680e912c$var$we,
                    autoIncrement: !0
                });
                t.createIndex($70fd6868680e912c$var$Se, $70fd6868680e912c$var$be, {
                    unique: !1
                });
                const n = e.createObjectStore($70fd6868680e912c$var$De, {
                    keyPath: $70fd6868680e912c$var$ve
                });
                n.createIndex($70fd6868680e912c$var$Ce, $70fd6868680e912c$var$Fe, {
                    unique: !1
                });
                const r = e.createObjectStore($70fd6868680e912c$var$Me, {
                    keyPath: $70fd6868680e912c$var$xe
                });
                r.createIndex($70fd6868680e912c$var$Oe, $70fd6868680e912c$var$Ne, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($70fd6868680e912c$var$De).clear();
        }).next(()=>{
            t.objectStore($70fd6868680e912c$var$Me).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($70fd6868680e912c$var$Ue, {
                    keyPath: $70fd6868680e912c$var$Ke
                });
            }(e);
        })), s;
    }
    ai(e) {
        let t = 0;
        return e.store($70fd6868680e912c$var$U).Z((e, n)=>{
            t += $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($70fd6868680e912c$var$oe).put($70fd6868680e912c$var$_e, n);
        });
    }
    _i(e) {
        const t = e.store($70fd6868680e912c$var$G), n = e.store($70fd6868680e912c$var$j);
        return t.G().next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $70fd6868680e912c$var$Q
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.G($70fd6868680e912c$var$J, r).next((n)=>$70fd6868680e912c$var$PersistencePromise.forEach(n, (n)=>{
                        $70fd6868680e912c$var$__PRIVATE_hardAssert(n.userId === t.userId);
                        const r = $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $70fd6868680e912c$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ ui(e) {
        const t = e.store($70fd6868680e912c$var$le), n = e.store($70fd6868680e912c$var$U);
        return e.store($70fd6868680e912c$var$Ee).get($70fd6868680e912c$var$Ie).next((e)=>{
            const r = [];
            return n.Z((n, i)=>{
                const s = new $70fd6868680e912c$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $70fd6868680e912c$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r));
        });
    }
    ci(e, t) {
        // Create the index.
        e.createObjectStore($70fd6868680e912c$var$de, {
            keyPath: $70fd6868680e912c$var$Ae
        });
        const n = t.store($70fd6868680e912c$var$de), r = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($70fd6868680e912c$var$U).Z({
            Y: !0
        }, (e, t)=>{
            const n = new $70fd6868680e912c$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($70fd6868680e912c$var$X).Z({
                Y: !0
            }, ([e, t, n], r)=>{
                const i = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    li(e) {
        const t = e.store($70fd6868680e912c$var$ae);
        return t.Z((e, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n), i = $70fd6868680e912c$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    hi(e, t) {
        const n = t.store($70fd6868680e912c$var$U), r = [];
        return n.Z((e, n)=>{
            const i = t.store($70fd6868680e912c$var$ee), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $70fd6868680e912c$var$fail();
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r));
    }
    Pi(e, t) {
        const n = t.store($70fd6868680e912c$var$j), r = $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence($70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate.ri, this.serializer.Tt);
        return n.G().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $70fd6868680e912c$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $70fd6868680e912c$var$User(n), o = $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache.It(this.serializer, s), _ = i.getIndexManager(s), a = $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue.It(s, this.serializer, _, i.referenceDelegate);
                return new $70fd6868680e912c$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(t, $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae), e).next();
            });
        });
    }
}
function $70fd6868680e912c$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($70fd6868680e912c$var$le, {
        keyPath: $70fd6868680e912c$var$he
    }).createIndex($70fd6868680e912c$var$Pe, $70fd6868680e912c$var$Te, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($70fd6868680e912c$var$ae, {
        keyPath: "targetId"
    }).createIndex($70fd6868680e912c$var$ue, $70fd6868680e912c$var$ce, {
        unique: !0
    }), e.createObjectStore($70fd6868680e912c$var$Ee);
}
const $70fd6868680e912c$var$vt = "IndexedDbPersistence", $70fd6868680e912c$var$Ct = 18e5, $70fd6868680e912c$var$Ft = 5e3, $70fd6868680e912c$var$Mt = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $70fd6868680e912c$var$xt = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 17){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Ti = i, this.window = s, this.document = o, this.Ii = a, this.Ei = u, this.di = c, this.Gr = null, this.zr = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Ai = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ri = null, /** The client metadata refresh task. */ this.Vi = null, /** The last time we garbage collected the client metadata object store. */ this.mi = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.fi = (e)=>Promise.resolve(), !$70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence.D()) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $70fd6868680e912c$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.gi = t + $70fd6868680e912c$var$xt, this.serializer = new $70fd6868680e912c$var$__PRIVATE_LocalSerializer(_), this.pi = new $70fd6868680e912c$var$__PRIVATE_SimpleDb(this.gi, this.di, new $70fd6868680e912c$var$__PRIVATE_SchemaConverter(this.serializer)), this.jr = new $70fd6868680e912c$var$__PRIVATE_IndexedDbGlobalsCache, this.Hr = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Yr = new $70fd6868680e912c$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.yi = this.window.localStorage : (this.yi = null, !1 === u && $70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$vt, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.wi().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, $70fd6868680e912c$var$Mt);
            return this.Si(), this.bi(), this.Di(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.Hr.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.Gr = new $70fd6868680e912c$var$__PRIVATE_ListenSequence(e, this.Ii);
        }).then(()=>{
            this.zr = !0;
        }).catch((e)=>(this.pi && this.pi.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ci(e) {
        return this.fi = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.pi.k(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Ti.enqueueAndForget(async ()=>{
            this.started && await this.wi();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ wi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.Fi(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Ti.enqueueRetryable(()=>this.fi(!1)));
                });
            }).next(()=>this.Mi(e)).next((t)=>this.isPrimary && !t ? this.xi(e).next(()=>!1) : !!t && this.Oi(e).next(()=>!0))).catch((e)=>{
            if ($70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Ti.enqueueRetryable(()=>this.fi(e)), this.isPrimary = e;
        });
    }
    Fi(e) {
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get($70fd6868680e912c$var$W).next((e)=>$70fd6868680e912c$var$PersistencePromise.resolve(this.Ni(e)));
    }
    Bi(e) {
        return $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async Li() {
        if (this.isPrimary && !this.ki(this.mi, $70fd6868680e912c$var$Ct)) {
            this.mi = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Re);
                return t.G().next((e)=>{
                    const n = this.qi(e, $70fd6868680e912c$var$Ct), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $70fd6868680e912c$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.yi) for (const t of e)this.yi.removeItem(this.Qi(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ Di() {
        this.Vi = this.Ti.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.wi().then(()=>this.Li()).then(()=>this.Di()));
    }
    /** Checks whether `client` is the local client. */ Ni(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Mi(e) {
        if (this.Ei) return $70fd6868680e912c$var$PersistencePromise.resolve(!0);
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get($70fd6868680e912c$var$W).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ki(t.leaseTimestampMs, $70fd6868680e912c$var$Ft) && !this.$i(t.ownerId)) {
                if (this.Ni(t) && this.networkEnabled) return !0;
                if (!this.Ni(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, $70fd6868680e912c$var$Mt);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).G().next((e)=>void 0 === this.qi(e, $70fd6868680e912c$var$Ft).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.zr = !1, this.Ui(), this.Vi && (this.Vi.cancel(), this.Vi = null), this.Ki(), this.Wi(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.pi.runTransaction("shutdown", "readwrite", [
            $70fd6868680e912c$var$K,
            $70fd6868680e912c$var$Re
        ], (e)=>{
            const t = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(e, $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae);
            return this.xi(t).next(()=>this.Bi(t));
        }), this.pi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Gi();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ qi(e, t) {
        return e.filter((e)=>this.ki(e.updateTimeMs, t) && !this.$i(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ zi() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).G().next((e)=>this.qi(e, $70fd6868680e912c$var$Ct).map((e)=>e.clientId)));
    }
    get started() {
        return this.zr;
    }
    getGlobalsCache() {
        return this.jr;
    }
    getMutationQueue(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue.It(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Hr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.Tt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache.It(this.serializer, e);
    }
    getBundleCache() {
        return this.Yr;
    }
    runTransaction(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 17 === e ? $70fd6868680e912c$var$Ye : 16 === e ? $70fd6868680e912c$var$Je : 15 === e ? $70fd6868680e912c$var$He : 14 === e ? $70fd6868680e912c$var$je : 13 === e ? $70fd6868680e912c$var$ze : 12 === e ? $70fd6868680e912c$var$Ge : 11 === e ? $70fd6868680e912c$var$We : void $70fd6868680e912c$var$fail();
        }(this.di);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.pi.runTransaction(e, r, i, (r)=>(s = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(r, this.Gr ? this.Gr.next() : $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae), "readwrite-primary" === t ? this.Fi(s).next((e)=>!!e || this.Mi(s)).next((t)=>{
                if (!t) throw $70fd6868680e912c$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Ti.enqueueRetryable(()=>this.fi(!1)), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, $70fd6868680e912c$var$B);
                return n(s);
            }).next((e)=>this.Oi(s).next(()=>e)) : this.ji(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    ji(e) {
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get($70fd6868680e912c$var$W).next((e)=>{
            if (null !== e && this.ki(e.leaseTimestampMs, $70fd6868680e912c$var$Ft) && !this.$i(e.ownerId) && !this.Ni(e) && !(this.Ei || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, $70fd6868680e912c$var$Mt);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Oi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).put($70fd6868680e912c$var$W, t);
    }
    static D() {
        return $70fd6868680e912c$var$__PRIVATE_SimpleDb.D();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ xi(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e);
        return t.get($70fd6868680e912c$var$W).next((e)=>this.Ni(e) ? ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, "Releasing primary lease."), t.delete($70fd6868680e912c$var$W)) : $70fd6868680e912c$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ki(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($70fd6868680e912c$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Si() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ri = ()=>{
            this.Ti.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.wi()));
        }, this.document.addEventListener("visibilitychange", this.Ri), this.inForeground = "visible" === this.document.visibilityState);
    }
    Ki() {
        this.Ri && (this.document.removeEventListener("visibilitychange", this.Ri), this.Ri = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ bi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.Ai = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Ui();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $c38e0f42709c826a$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Ti.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Ti.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Ai));
    }
    Wi() {
        this.Ai && (this.window.removeEventListener("pagehide", this.Ai), this.Ai = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ $i(e) {
        var t;
        try {
            const n = null !== (null === (t = this.yi) || void 0 === t ? void 0 : t.getItem(this.Qi(e)));
            return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$vt, `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$vt, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Ui() {
        if (this.yi) try {
            this.yi.setItem(this.Qi(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $70fd6868680e912c$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ Gi() {
        if (this.yi) try {
            this.yi.removeItem(this.Qi(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    Qi(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$K);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, $70fd6868680e912c$var$Re);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $70fd6868680e912c$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Hi = n, this.Ji = r;
    }
    static Yi(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), r = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $70fd6868680e912c$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $70fd6868680e912c$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Zi = !1, this.Xi = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.es = 100, this.ts = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $c38e0f42709c826a$export$95df08bae54cb4df)() ? 8 : $70fd6868680e912c$var$__PRIVATE_getAndroidVersion((0, $c38e0f42709c826a$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.ns = e, this.indexManager = t, this.Zi = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.rs(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ss(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $70fd6868680e912c$var$QueryContext;
            return this._s(e, t, n).next((r)=>{
                if (i.result = r, this.Xi) return this.us(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    us(e, t, n, r) {
        return n.documentReadCount < this.es ? ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.es, "documents"), $70fd6868680e912c$var$PersistencePromise.resolve()) : ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.ts * r ? ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t))) : $70fd6868680e912c$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ rs(e, t) {
        if ($70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
        let n = $70fd6868680e912c$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $70fd6868680e912c$var$__PRIVATE_documentKeySet(...r);
                return this.ns.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.cs(t, r);
                        return this.ls(t, s, i, n.readTime) ? this.rs(e, $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.hs(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ss(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? $70fd6868680e912c$var$PersistencePromise.resolve(null) : this.ns.getDocuments(e, n).next((i)=>{
            const s = this.cs(t, i);
            return this.ls(t, s, n, r) ? $70fd6868680e912c$var$PersistencePromise.resolve(null) : ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t)), this.hs(e, s, t, $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $70fd6868680e912c$var$N)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ cs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $70fd6868680e912c$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ ls(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    _s(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t)), this.ns.getDocumentsMatchingQuery(e, t, $70fd6868680e912c$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ hs(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.ns.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Ot = "LocalStore", $70fd6868680e912c$var$Nt = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Ps = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Ts = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Is = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), $70fd6868680e912c$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Es = new Map, this.ds = e.getRemoteDocumentCache(), this.Hr = e.getTargetCache(), this.Yr = e.getBundleCache(), this.As(n);
    }
    As(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $70fd6868680e912c$var$LocalDocumentsView(this.ds, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.ds.setIndexManager(this.indexManager), this.Ps.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.Ts));
    }
}
function $70fd6868680e912c$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $70fd6868680e912c$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.As(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Rs: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.ds.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $70fd6868680e912c$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $70fd6868680e912c$var$__PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.Hr.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.Ts;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.ds.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Ts;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Hr.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.Hr.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, $70fd6868680e912c$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($70fd6868680e912c$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $70fd6868680e912c$var$Nt) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.Hr.updateTargetData(e, u));
        });
        let _ = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), a = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Vs, a = e.fs;
        })), !r.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) {
            const t = n.Hr.getLastRemoteSnapshotVersion(e).next((t)=>n.Hr.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $70fd6868680e912c$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.Ts = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Ot, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Vs: r,
            fs: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $70fd6868680e912c$var$Q), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.Hr.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $70fd6868680e912c$var$PersistencePromise.resolve(r)) : n.Hr.allocateTargetId(e).next((i)=>(r = new $70fd6868680e912c$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Hr.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.Ts.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.Ts = n.Ts.insert(e.targetId, e), n.Is.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.Ts.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Ot, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.Ts = r.Ts.remove(t), r.Is.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let i = $70fd6868680e912c$var$SnapshotVersion.min(), s = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.Is.get(n);
            return void 0 !== i ? $70fd6868680e912c$var$PersistencePromise.resolve(r.Ts.get(i)) : r.Hr.getTargetData(t, n);
        })(r, e, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Hr.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Ps.getDocumentsMatchingQuery(e, t, n ? i : $70fd6868680e912c$var$SnapshotVersion.min(), n ? s : $70fd6868680e912c$var$__PRIVATE_documentKeySet())).next((e)=>($70fd6868680e912c$var$__PRIVATE_setMaxReadTime(r, $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                gs: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_debugCast(n.Hr), i = n.Ts.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.lt(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.Es.get(t) || $70fd6868680e912c$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.ds.getAllFromCollectionGroup(e, t, $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $70fd6868680e912c$var$N), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($70fd6868680e912c$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.Es.get(t) || $70fd6868680e912c$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.Es.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $70fd6868680e912c$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let s = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), o = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.ps(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.ys(e);
        r.setReadTime(t.ws(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.ds.newChangeBuffer({
        trackRemovals: !0
    }), a = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath($70fd6868680e912c$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.Hr.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.Hr.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Vs, t.fs)).next(()=>t.Vs)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $70fd6868680e912c$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $70fd6868680e912c$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e, $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Yr.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.Ts = i.Ts.insert(o.targetId, o), i.Hr.updateTargetData(e, o).next(()=>i.Hr.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.Hr.addMatchingKeys(e, n, r.targetId)).next(()=>i.Yr.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $70fd6868680e912c$var$Bt = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $70fd6868680e912c$var$createWebStorageClientStateKey(e, t) {
    return `${$70fd6868680e912c$var$Bt}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $70fd6868680e912c$var$Lt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $70fd6868680e912c$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$70fd6868680e912c$var$Lt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $70fd6868680e912c$var$kt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$70fd6868680e912c$var$kt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$qt = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ss(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $70fd6868680e912c$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $70fd6868680e912c$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$qt, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    bs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ss(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $70fd6868680e912c$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$qt, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    bs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $70fd6868680e912c$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ss(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $70fd6868680e912c$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $70fd6868680e912c$var$__PRIVATE_RemoteClientState(e, i) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$qt, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $70fd6868680e912c$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ss(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $70fd6868680e912c$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$qt, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $70fd6868680e912c$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
    }
    Ds(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    vs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ bs() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Ti = t, this.persistenceKey = n, this.Cs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Fs = this.Ms.bind(this), this.xs = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Os = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Ns = $70fd6868680e912c$var$createWebStorageClientStateKey(this.persistenceKey, this.Cs), this.Bs = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.xs = this.xs.insert(this.Cs, new $70fd6868680e912c$var$__PRIVATE_LocalClientState), this.Ls = new RegExp(`^${$70fd6868680e912c$var$Bt}_${s}_([^_]*)$`), this.ks = new RegExp(`^${$70fd6868680e912c$var$Lt}_${s}_(\\d+)(?:_(.*))?$`), this.qs = new RegExp(`^${$70fd6868680e912c$var$kt}_${s}_(\\d+)$`), this.Qs = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.$s = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Fs);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static D(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.zi();
        for (const t of e){
            if (t === this.Cs) continue;
            const e = this.getItem($70fd6868680e912c$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $70fd6868680e912c$var$__PRIVATE_RemoteClientState.Ss(t, e);
                n && (this.xs = this.xs.insert(n.clientId, n));
            }
        }
        this.Us();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.Qs);
        if (t) {
            const e = this.Ks(t);
            e && this.Ws(e);
        }
        for (const e of this.Os)this.Ms(e);
        this.Os = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Bs, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.Gs(this.xs);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.xs.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.zs(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.zs(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.js(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata.Ss(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.Hs.Ds(e), this.Us(), n;
    }
    removeLocalQueryTarget(e) {
        this.Hs.vs(e), this.Us();
    }
    isLocalQueryTarget(e) {
        return this.Hs.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Js(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.js(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Ys(e);
    }
    notifyBundleLoaded(e) {
        this.Zs(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Fs), this.removeItem(this.Ns), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$qt, "READ", e, t), t;
    }
    setItem(e, t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$qt, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$qt, "REMOVE", e), this.storage.removeItem(e);
    }
    Ms(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$qt, "EVENT", t.key, t.newValue), t.key === this.Ns) return void $70fd6868680e912c$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Ti.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.Ls.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Xs(t.key);
                                return this.eo(e, null);
                            }
                            {
                                const e = this.no(t.key, t.newValue);
                                if (e) return this.eo(e.clientId, e);
                            }
                        } else if (this.ks.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.ro(t.key, t.newValue);
                                if (e) return this.io(e);
                            }
                        } else if (this.qs.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.so(t.key, t.newValue);
                                if (e) return this.oo(e);
                            }
                        } else if (t.key === this.Qs) {
                            if (null !== t.newValue) {
                                const e = this.Ks(t.newValue);
                                if (e) return this.Ws(e);
                            }
                        } else if (t.key === this.Bs) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $70fd6868680e912c$var$__PRIVATE_hardAssert("number" == typeof n), t = n;
                                } catch (e) {
                                    $70fd6868680e912c$var$__PRIVATE_logError($70fd6868680e912c$var$qt, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae && this.sequenceNumberHandler(e);
                        } else if (t.key === this.$s) {
                            const e = this._o(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.ao(e)));
                        }
                    }
                } else this.Os.push(t);
            });
        }
    }
    get Hs() {
        return this.xs.get(this.Cs);
    }
    Us() {
        this.setItem(this.Ns, this.Hs.bs());
    }
    zs(e, t, n) {
        const r = new $70fd6868680e912c$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $70fd6868680e912c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.bs());
    }
    js(e) {
        const t = $70fd6868680e912c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Ys(e) {
        const t = {
            clientId: this.Cs,
            onlineState: e
        };
        this.storage.setItem(this.Qs, JSON.stringify(t));
    }
    Js(e, t, n) {
        const r = $70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.bs());
    }
    Zs(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.$s, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Xs(e) {
        const t = this.Ls.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ no(e, t) {
        const n = this.Xs(e);
        return $70fd6868680e912c$var$__PRIVATE_RemoteClientState.Ss(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ ro(e, t) {
        const n = this.ks.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $70fd6868680e912c$var$__PRIVATE_MutationMetadata.Ss(new $70fd6868680e912c$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ so(e, t) {
        const n = this.qs.exec(e), r = Number(n[1]);
        return $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata.Ss(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ks(e) {
        return $70fd6868680e912c$var$__PRIVATE_SharedOnlineState.Ss(e);
    }
    _o(e) {
        return JSON.parse(e);
    }
    async io(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.uo(e.batchId, e.state, e.error);
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$qt, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    oo(e) {
        return this.syncEngine.co(e.targetId, e.state, e.error);
    }
    eo(e, t) {
        const n = t ? this.xs.insert(e, t) : this.xs.remove(e), r = this.Gs(this.xs), i = this.Gs(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.lo(s, o).then(()=>{
            this.xs = n;
        });
    }
    Ws(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.xs.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    Gs(e) {
        let t = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.ho = new $70fd6868680e912c$var$__PRIVATE_LocalClientState, this.Po = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.ho.Ds(e), this.Po[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Po[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.ho.vs(e);
    }
    isLocalQueryTarget(e) {
        return this.ho.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Po[e];
    }
    getAllActiveQueryTargets() {
        return this.ho.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.ho.activeTargetIds.has(e);
    }
    start() {
        return this.ho = new $70fd6868680e912c$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_NoopConnectivityMonitor {
    To(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $70fd6868680e912c$var$Qt = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.Io = ()=>this.Eo(), this.Ao = ()=>this.Ro(), this.Vo = [], this.mo();
    }
    To(e) {
        this.Vo.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.Io), window.removeEventListener("offline", this.Ao);
    }
    mo() {
        window.addEventListener("online", this.Io), window.addEventListener("offline", this.Ao);
    }
    Eo() {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Qt, "Network connectivity changed: AVAILABLE");
        for (const e of this.Vo)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Ro() {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Qt, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.Vo)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static D() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $70fd6868680e912c$var$$t = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId() {
    return null === $70fd6868680e912c$var$$t ? $70fd6868680e912c$var$$t = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $70fd6868680e912c$var$$t++, "0x" + $70fd6868680e912c$var$$t.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Ut = "RestConnection", $70fd6868680e912c$var$Kt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $70fd6868680e912c$var$__PRIVATE_RestConnection {
    get fo() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.po = t + "://" + e.host, this.yo = `projects/${n}/databases/${r}`, this.wo = this.databaseId.database === $70fd6868680e912c$var$rt ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    So(e, t, n, r, i) {
        const s = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId(), o = this.bo(e, t.toUriEncodedString());
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Ut, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.yo,
            "x-goog-request-params": this.wo
        };
        return this.Do(_, r, i), this.vo(e, o, _, n).then((t)=>($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Ut, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$Ut, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    Co(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.So(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Do(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $70fd6868680e912c$var$D;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    bo(e, t) {
        const n = $70fd6868680e912c$var$Kt[e];
        return `${this.po}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $70fd6868680e912c$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Fo = e.Fo, this.Mo = e.Mo;
    }
    xo(e) {
        this.Oo = e;
    }
    No(e) {
        this.Bo = e;
    }
    Lo(e) {
        this.ko = e;
    }
    onMessage(e) {
        this.qo = e;
    }
    close() {
        this.Mo();
    }
    send(e) {
        this.Fo(e);
    }
    Qo() {
        this.Oo();
    }
    $o() {
        this.Bo();
    }
    Uo(e) {
        this.ko(e);
    }
    Ko(e) {
        this.qo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Wt = "WebChannelConnection";
class $70fd6868680e912c$var$__PRIVATE_WebChannelConnection extends $70fd6868680e912c$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    vo(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((s, o)=>{
            const _ = new (0, $33cb313d667e3306$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $33cb313d667e3306$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), s(t);
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' ${i} timed out`), o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' ${i} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($70fd6868680e912c$var$C).indexOf(t) >= 0 ? t : $70fd6868680e912c$var$C.UNKNOWN;
                                    }(t.status);
                                    o(new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message));
                                } else o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $70fd6868680e912c$var$fail();
                    }
                } finally{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' ${i} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' ${i} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    Wo(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.po,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $33cb313d667e3306$export$66869136fc133c3a)(), o = (0, $33cb313d667e3306$export$888d0d9ab79d08fc)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.Do(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $70fd6868680e912c$var$__PRIVATE_StreamBridge({
            Fo: (t)=>{
                h ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            Mo: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} transport opened.`), P.Qo());
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} transport closed`), P.Uo());
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} transport errored:`, t), P.Uo(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $70fd6868680e912c$var$__PRIVATE_hardAssert(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = (null == s ? void 0 : s.error) || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $70fd6868680e912c$var$Et[e];
                        if (void 0 !== t) return $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $70fd6868680e912c$var$C.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.Uo(new $70fd6868680e912c$export$8fada0bf726bf278(n, i)), c.close();
                } else $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} received:`, i), P.Ko(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $33cb313d667e3306$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).PROXY ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).NOPROXY && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Wt, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.$o();
        }, 0), P;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $70fd6868680e912c$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $70fd6868680e912c$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_newSerializer(e) {
    return new $70fd6868680e912c$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Ti = e, this.timerId = t, this.Go = n, this.zo = r, this.jo = i, this.Ho = 0, this.Jo = null, /** The last backoff attempt, as epoch milliseconds. */ this.Yo = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.Ho = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ Zo() {
        this.Ho = this.jo;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ Xo(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.Ho + this.e_()), n = Math.max(0, Date.now() - this.Yo), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $70fd6868680e912c$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Ho} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.Jo = this.Ti.enqueueAfterDelay(this.timerId, r, ()=>(this.Yo = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.Ho *= this.zo, this.Ho < this.Go && (this.Ho = this.Go), this.Ho > this.jo && (this.Ho = this.jo);
    }
    t_() {
        null !== this.Jo && (this.Jo.skipDelay(), this.Jo = null);
    }
    cancel() {
        null !== this.Jo && (this.Jo.cancel(), this.Jo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ e_() {
        return (Math.random() - .5) * this.Ho;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Gt = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Ti = e, this.n_ = n, this.r_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.i_ = 0, this.s_ = null, this.o_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.__ = 0, this.a_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ u_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.c_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ c_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.__ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.l_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.u_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ h_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.a_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ P_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.c_() && null === this.s_ && (this.s_ = this.Ti.enqueueAfterDelay(this.n_, 6e4, ()=>this.T_()));
    }
    /** Sends a message to the underlying stream. */ I_(e) {
        this.E_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async T_() {
        if (this.c_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ E_() {
        this.s_ && (this.s_.cancel(), this.s_ = null);
    }
    /** Cancels the health check delayed operation. */ d_() {
        this.o_ && (this.o_.cancel(), this.o_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.E_(), this.d_(), this.a_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.i_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.a_.reset() : t && t.code === $70fd6868680e912c$var$C.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($70fd6868680e912c$var$__PRIVATE_logError(t.toString()), $70fd6868680e912c$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.a_.Zo()) : t && t.code === $70fd6868680e912c$var$C.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.A_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.Lo(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ A_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.R_(this.i_), t = this.i_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.i_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.V_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.m_(e);
            });
        });
    }
    V_(e, t) {
        const n = this.R_(this.i_);
        this.stream = this.f_(e, t), this.stream.xo(()=>{
            n(()=>this.listener.xo());
        }), this.stream.No(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.o_ = this.Ti.enqueueAfterDelay(this.r_, 1e4, ()=>(this.c_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.No()));
        }), this.stream.Lo((e)=>{
            n(()=>this.m_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.__ ? this.g_(e) : this.onNext(e));
        });
    }
    l_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.a_.Xo(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    m_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ R_(e) {
        return (t)=>{
            this.Ti.enqueueAndForget(()=>this.i_ === e ? t() : ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Gt, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentListenStream extends $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    f_(e, t) {
        return this.connection.Wo("Listen", e, t);
    }
    g_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.a_.reset();
        const t = $70fd6868680e912c$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $70fd6868680e912c$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $70fd6868680e912c$var$SnapshotVersion.min() : t.readTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime) : $70fd6868680e912c$var$SnapshotVersion.min();
        }(e);
        return this.listener.p_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ y_(e) {
        const t = {};
        t.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, r).ht
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $70fd6868680e912c$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($70fd6868680e912c$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $70fd6868680e912c$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $70fd6868680e912c$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.I_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ w_(e) {
        const t = {};
        t.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.I_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentWriteStream extends $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get S_() {
        return this.__ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    A_() {
        this.S_ && this.b_([]);
    }
    f_(e, t) {
        return this.connection.Wo("Write", e, t);
    }
    g_(e) {
        // Always capture the last stream token.
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.listener.D_();
    }
    onNext(e) {
        // Always capture the last stream token.
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.a_.reset();
        const t = $70fd6868680e912c$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $70fd6868680e912c$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.v_(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ C_() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.I_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ b_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$70fd6868680e912c$var$toMutation(this.serializer, e))
        };
        this.I_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $70fd6868680e912c$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $70fd6868680e912c$var$__PRIVATE_DatastoreImpl extends $70fd6868680e912c$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.F_ = !1;
    }
    M_() {
        if (this.F_) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ So(e, t, n, r) {
        return this.M_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.So(e, $70fd6868680e912c$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $70fd6868680e912c$var$C.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ Co(e, t, n, r, i) {
        return this.M_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.Co(e, $70fd6868680e912c$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $70fd6868680e912c$var$C.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.F_ = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $70fd6868680e912c$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.x_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.O_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.N_ = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ B_() {
        0 === this.x_ && (this.L_("Unknown" /* OnlineState.Unknown */ ), this.O_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.O_ = null, this.k_("Backend didn't respond within 10 seconds."), this.L_("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ q_(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.L_("Unknown" /* OnlineState.Unknown */ ) : (this.x_++, this.x_ >= 1 && (this.Q_(), this.k_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.L_("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.Q_(), this.x_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.N_ = !1), this.L_(e);
    }
    L_(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    k_(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.N_ ? ($70fd6868680e912c$var$__PRIVATE_logError(t), this.N_ = !1) : $70fd6868680e912c$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    Q_() {
        null !== this.O_ && (this.O_.cancel(), this.O_ = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$zt = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $70fd6868680e912c$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.U_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.K_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.W_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.G_ = [], this.z_ = i, this.z_.To((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $70fd6868680e912c$var$__PRIVATE_canUseNetwork(this) && ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                    t.W_.add(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), t.j_.set("Unknown" /* OnlineState.Unknown */ ), t.W_.delete(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.j_ = new $70fd6868680e912c$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(e) {
    if ($70fd6868680e912c$var$__PRIVATE_canUseNetwork(e)) for (const t of e.G_)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.G_)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    n.K_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.K_.set(t.targetId, t), $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $70fd6868680e912c$var$__PRIVATE_startWatchStream(n) : $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(n).c_() && $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(n);
    n.K_.delete(t), r.c_() && $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.K_.size && (r.c_() ? r.P_() : $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.j_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.H_.Ne(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($70fd6868680e912c$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).y_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.H_.Ne(t), $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).w_(t);
}
function $70fd6868680e912c$var$__PRIVATE_startWatchStream(e) {
    e.H_ = new $70fd6868680e912c$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        lt: (t)=>e.K_.get(t) || null,
        it: ()=>e.datastore.serializer.databaseId
    }), $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).start(), e.j_.B_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && !$70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).u_() && e.K_.size > 0;
}
function $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $70fd6868680e912c$var$__PRIVATE_debugCast(e).W_.size;
}
function $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.H_ = void 0;
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.j_.set("Online" /* OnlineState.Online */ );
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamOpen(e) {
    e.K_.forEach((t, n)=>{
        $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamClose(e, t) {
    $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) ? (e.j_.q_(t), $70fd6868680e912c$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.j_.set("Unknown" /* OnlineState.Unknown */ );
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.j_.set("Online" /* OnlineState.Online */ ), t instanceof $70fd6868680e912c$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.K_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.K_.delete(r), e.H_.removeTarget(r));
        }(e, t);
    } catch (n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange ? e.H_.We(t) : t instanceof $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange ? e.H_.Ze(t) : e.H_.je(t), !n.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) try {
        const t = await $70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.H_.ot(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.K_.get(r);
                    // A watched target might have been removed already.
                    i && e.K_.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.K_.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.K_.set(t, r.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $70fd6868680e912c$var$TargetData(r.target, t, n, r.sequenceNumber);
                $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "Failed to raise snapshot:", t), await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.W_.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(e), e.j_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "Retrying IndexedDB access"), await n(), e.W_.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e), n = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(t);
    let r = t.U_.length > 0 ? t.U_[t.U_.length - 1].batchId : $70fd6868680e912c$var$Q;
    for(; $70fd6868680e912c$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.U_.length && n.P_();
            break;
        }
        r = e.batchId, $70fd6868680e912c$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(t) && $70fd6868680e912c$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $70fd6868680e912c$var$__PRIVATE_canAddToWritePipeline(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && e.U_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $70fd6868680e912c$var$__PRIVATE_addToWritePipeline(e, t) {
    e.U_.push(t);
    const n = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e);
    n.c_() && n.S_ && n.b_(t.mutations);
}
function $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && !$70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).u_() && e.U_.length > 0;
}
function $70fd6868680e912c$var$__PRIVATE_startWriteStream(e) {
    $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteStreamOpen(e) {
    $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).C_();
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.U_)t.b_(n.mutations);
}
async function $70fd6868680e912c$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.U_.shift(), i = $70fd6868680e912c$var$MutationBatchResult.from(r, t, n);
    await $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e);
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).S_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $70fd6868680e912c$var$__PRIVATE_isPermanentError(e) && e !== $70fd6868680e912c$var$C.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.U_.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).h_(), await $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(e) && $70fd6868680e912c$var$__PRIVATE_startWriteStream(e);
}
async function $70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "RemoteStore received new credentials");
    const r = $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.W_.add(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.j_.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.W_.delete(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    t ? (n.W_.delete(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.W_.add(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(n), n.j_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e) {
    return e.J_ || // Create stream (but note that it is not started yet).
    (e.J_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        return r.M_(), new $70fd6868680e912c$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        xo: $70fd6868680e912c$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        No: $70fd6868680e912c$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        Lo: $70fd6868680e912c$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        p_: $70fd6868680e912c$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.G_.push(async (t)=>{
        t ? (e.J_.h_(), $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) ? $70fd6868680e912c$var$__PRIVATE_startWatchStream(e) : e.j_.set("Unknown" /* OnlineState.Unknown */ )) : (await e.J_.stop(), $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.J_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e) {
    return e.Y_ || // Create stream (but note that it is not started yet).
    (e.Y_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        return r.M_(), new $70fd6868680e912c$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        xo: ()=>Promise.resolve(),
        No: $70fd6868680e912c$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        Lo: $70fd6868680e912c$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        D_: $70fd6868680e912c$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        v_: $70fd6868680e912c$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.G_.push(async (t)=>{
        t ? (e.Y_.h_(), // This will start the write stream if necessary.
        await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e)) : (await e.Y_.stop(), e.U_.length > 0 && ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, `Stopping write stream with ${e.U_.length} pending writes`), e.U_ = []));
    })), e.Y_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $70fd6868680e912c$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $70fd6868680e912c$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $70fd6868680e912c$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($70fd6868680e912c$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $70fd6868680e912c$var$DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $70fd6868680e912c$var$DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $70fd6868680e912c$var$documentMap(), this.sortedSet = new $70fd6868680e912c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $70fd6868680e912c$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $70fd6868680e912c$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.Z_ = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.Z_.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.Z_ = this.Z_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.Z_ = this.Z_.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.Z_ = this.Z_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.Z_ = this.Z_.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.Z_ = this.Z_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.Z_ = this.Z_.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.Z_ = this.Z_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $70fd6868680e912c$var$fail() : this.Z_ = this.Z_.insert(t, e);
    }
    X_() {
        const e = [];
        return this.Z_.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $70fd6868680e912c$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $70fd6868680e912c$var$ViewSnapshot(e, t, $70fd6868680e912c$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $70fd6868680e912c$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.ea = void 0, this.ta = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    na() {
        return this.ta.some((e)=>e.ra());
    }
}
class $70fd6868680e912c$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.ia = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.ta)e.onError(t);
            });
        }(this, new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.ABORTED, "Firestore shutting down"));
    }
}
function $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap() {
    return new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyQuery(e), $70fd6868680e912c$var$__PRIVATE_queryEquals);
}
async function $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.na() && t.ra() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $70fd6868680e912c$var$__PRIVATE_QueryListenersInfo, r = t.ra() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.ea = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.ea = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$70fd6868680e912c$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.ta.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.sa(n.onlineState), s.ea) t.oa(s.ea) && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.ta.indexOf(t);
        e >= 0 && (s.ta.splice(e, 1), 0 === s.ta.length ? i = t.ra() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.na() && t.ra() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.ta)t.oa(e) && (r = !0);
            i.ea = e;
        }
    }
    r && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.ta)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.ia.forEach((e)=>{
        e.next();
    });
}
var $70fd6868680e912c$var$jt, $70fd6868680e912c$var$Ht;
/** Listen to both cache and server changes */ ($70fd6868680e912c$var$Ht = $70fd6868680e912c$var$jt || ($70fd6868680e912c$var$jt = {}))._a = "default", /** Listen to changes in cache only */ $70fd6868680e912c$var$Ht.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.aa = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.ua = !1, this.ca = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ oa(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $70fd6868680e912c$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.ua ? this.la(e) && (this.aa.next(e), t = !0) : this.ha(e, this.onlineState) && (this.Pa(e), t = !0), this.ca = e, t;
    }
    onError(e) {
        this.aa.error(e);
    }
    /** Returns whether a snapshot was raised. */ sa(e) {
        this.onlineState = e;
        let t = !1;
        return this.ca && !this.ua && this.ha(this.ca, e) && (this.Pa(this.ca), t = !0), t;
    }
    ha(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.ra()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Ta || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    la(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.ca && this.ca.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    Pa(e) {
        e = $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.ua = !0, this.aa.next(e);
    }
    ra() {
        return this.options.source !== $70fd6868680e912c$var$jt.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $70fd6868680e912c$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.Ia = e, this.byteLength = t;
    }
    Ea() {
        return "metadata" in this.Ia;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    ps(e) {
        return $70fd6868680e912c$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ ys(e) {
        return e.metadata.exists ? $70fd6868680e912c$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $70fd6868680e912c$var$MutableDocument.newNoDocument(this.ps(e.metadata.name), this.ws(e.metadata.readTime));
    }
    ws(e) {
        return $70fd6868680e912c$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleLoader {
    constructor(e, t, n){
        this.da = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Aa(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.Ia.namedQuery) this.queries.push(e.Ia.namedQuery);
        else if (e.Ia.documentMetadata) {
            this.documents.push({
                metadata: e.Ia.documentMetadata
            }), e.Ia.documentMetadata.exists || ++t;
            const n = $70fd6868680e912c$var$ResourcePath.fromString(e.Ia.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.Ia.document && (this.documents[this.documents.length - 1].document = e.Ia.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    Ra(e) {
        const t = new Map, n = new $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.ps(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $70fd6868680e912c$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreApplyBundledDocuments(this.localStore, new $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl(this.serializer), this.documents, this.da.id), t = this.Ra(this.documents);
        for (const e of this.queries)await $70fd6868680e912c$var$__PRIVATE_localStoreSaveNamedQuery(this.localStore, e, t.get(e.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Va: this.collectionGroups,
            ma: e
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $70fd6868680e912c$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.fa = t, this.ga = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.pa = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.ya = $70fd6868680e912c$var$__PRIVATE_newQueryComparator(e), this.wa = new $70fd6868680e912c$var$DocumentSet(this.ya);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get Sa() {
        return this.fa;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ba(e, t) {
        const n = t ? t.Da : new $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet, r = t ? t.wa : this.wa;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $70fd6868680e912c$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.va(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.ya(c, _) > 0 || a && this.ya(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            wa: s,
            Da: n,
            ls: o,
            mutatedKeys: i
        };
    }
    va(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.wa;
        this.wa = e.wa, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.Da.X_();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $70fd6868680e912c$var$fail();
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.ya(e.doc, t.doc)), this.Ca(n), r = null != r && r;
        const o = t && !r ? this.Fa() : [], _ = 0 === this.pa.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.ga;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.ga = _, 0 !== s.length || a) return {
            snapshot: new $70fd6868680e912c$var$ViewSnapshot(this.query, e.wa, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            Ma: o
        };
        // no changes
        return {
            Ma: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ sa(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            wa: this.wa,
            Da: new $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            ls: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            Ma: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ xa(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.fa.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.wa.has(e) && !this.wa.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ Ca(e) {
        e && (e.addedDocuments.forEach((e)=>this.fa = this.fa.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.fa = this.fa.delete(e)), this.current = e.current);
    }
    Fa() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.pa;
        this.pa = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.wa.forEach((e)=>{
            this.xa(e.key) && (this.pa = this.pa.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.pa.has(e) || t.push(new $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.pa.forEach((n)=>{
            e.has(n) || t.push(new $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    Oa(e) {
        this.fa = e.gs, this.pa = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        const t = this.ba(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Na() {
        return $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(this.query, this.wa, this.mutatedKeys, 0 /* SyncState.Local */  === this.ga, this.hasCachedResults);
    }
}
const $70fd6868680e912c$var$Jt = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $70fd6868680e912c$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Ba = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.La = {}, this.ka = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyQuery(e), $70fd6868680e912c$var$__PRIVATE_queryEquals), this.qa = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Qa = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.$a = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Ua = new Map, this.Ka = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Wa = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Ga = new Map, this.za = $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator.Kn(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.ja = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.ja;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.ka.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Na()) : i = await $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    await $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.Ha = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ba(n);
            i.ls && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ba(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.Ma), _.snapshot;
        })(e, t, n, r);
    const s = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $70fd6868680e912c$var$__PRIVATE_View(t, s.gs), _ = o.ba(s.documents), a = $70fd6868680e912c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, n, u.Ma);
    const c = new $70fd6868680e912c$var$__PRIVATE_QueryView(t, n, o);
    return e.ka.set(t, c), e.qa.has(n) ? e.qa.get(n).push(t) : e.qa.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.ka.get(t), s = r.qa.get(i.targetId);
    if (s.length > 1) return r.qa.set(i.targetId, s.filter((e)=>!$70fd6868680e912c$var$__PRIVATE_queryEquals(e, t))), void r.ka.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.ka.get(t), i = n.qa.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), a = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                return n.ds.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $70fd6868680e912c$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e.key, t, $70fd6868680e912c$var$__PRIVATE_extractFieldMask(t.value.mapValue), $70fd6868680e912c$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.Wa[e.currentUser.toKey()];
            r || (r = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.Wa[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Ua.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.Ba = !0 : e.modifiedDocuments.size > 0 ? $70fd6868680e912c$var$__PRIVATE_hardAssert(r.Ba) : e.removedDocuments.size > 0 && ($70fd6868680e912c$var$__PRIVATE_hardAssert(r.Ba), r.Ba = !1));
        }), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.ka.forEach((n, r)=>{
            const i = r.view.sa(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.ta)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.sa(t) && (r = !0);
            }), r && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.La.p_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Ua.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $70fd6868680e912c$var$MutableDocument.newNoDocument(s, $70fd6868680e912c$var$SnapshotVersion.min()));
        const n = $70fd6868680e912c$var$__PRIVATE_documentKeySet().add(s), i = new $70fd6868680e912c$var$RemoteEvent($70fd6868680e912c$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), e, n);
        await $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.$a = r.$a.remove(s), r.Ua.delete(t), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $70fd6868680e912c$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(null !== t), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $70fd6868680e912c$var$__PRIVATE_processUserCallback(r, t, n), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n.remoteStore) || $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $70fd6868680e912c$var$Q) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.Ga.get(e) || [];
        r.push(t), n.Ga.set(e, r);
    } catch (e) {
        const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Ga.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.Ga.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $70fd6868680e912c$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let i = r.Wa[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Wa[r.currentUser.toKey()] = i;
    }
}
function $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.qa.get(t))e.ka.delete(r), n && e.La.Ja(r, n);
    if (e.qa.delete(t), e.isPrimaryClient) e.Ka.br(t).forEach((t)=>{
        e.Ka.containsKey(t) || // We removed the last reference for this key
        $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Qa.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.$a.get(t);
    null !== n && ($70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.$a = e.$a.remove(t), e.Ua.delete(n), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument) e.Ka.addReference(r.key, t), $70fd6868680e912c$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "Document no longer in limbo: " + r.key), e.Ka.removeReference(r.key, t);
        e.Ka.containsKey(r.key) || // We removed the last reference for this key
        $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.$a.get(n) || e.Qa.has(r) || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "New document in limbo: " + n), e.Qa.add(r), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Qa.size > 0 && e.$a.size < e.maxConcurrentLimboResolutions;){
        const t = e.Qa.values().next().value;
        e.Qa.delete(t);
        const n = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(t)), r = e.za.next();
        e.Ua.set(r, new $70fd6868680e912c$var$LimboResolution(n)), e.$a = e.$a.insert(n, r), $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $70fd6868680e912c$var$TargetData($70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $70fd6868680e912c$var$__PRIVATE_ListenSequence.ae));
    }
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.ka.isEmpty() || (r.ka.forEach((e, _)=>{
        o.push(r.Ha(_, t, n).then((e)=>{
            var t;
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const i = e ? !e.fromCache : null === (t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === t ? void 0 : t.current;
                r.sharedClientState.updateQueryState(_.targetId, i ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $70fd6868680e912c$var$__PRIVATE_LocalViewChanges.Yi(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.La.p_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t.Hi, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$70fd6868680e912c$var$PersistencePromise.forEach(t.Ji, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Ot, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.Ts.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.Ts = n.Ts.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "User change. New user:", t.toKey());
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.Ga.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.CANCELLED, t));
                });
            }), e.Ga.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Rs);
    }
}
function $70fd6868680e912c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.Ua.get(t);
    if (r && r.Ba) return $70fd6868680e912c$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        const r = n.qa.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.ka.get(t);
            e = e.unionWith(r.view.Sa);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $70fd6868680e912c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.Oa(r);
    return n.isPrimaryClient && $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.Ma), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Ln(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $70fd6868680e912c$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($70fd6868680e912c$var$__PRIVATE_processUserCallback(i, t, r || null), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $70fd6868680e912c$var$__PRIVATE_debugCast($70fd6868680e912c$var$__PRIVATE_debugCast(e).mutationQueue).qn(t);
    }(i.localStore, t)) : $70fd6868680e912c$var$fail(), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if ($70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(n), $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.ja) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.ja = !0, await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$70fd6868680e912c$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.ja) {
        const e = [];
        let t = Promise.resolve();
        n.qa.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(n, i), $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            t.Ua.forEach((e, n)=>{
                $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Ka.Dr(), t.Ua = new Map, t.$a = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(n), n.ja = !1, await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.qa.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $70fd6868680e912c$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.ka.get(e), n = await $70fd6868680e912c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.La.p_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $70fd6868680e912c$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $70fd6868680e912c$var$__PRIVATE_debugCast($70fd6868680e912c$var$__PRIVATE_debugCast(e).persistence).zi();
    }($70fd6868680e912c$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (i.ja) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "Ignoring unexpected query state notification.");
    const s = i.qa.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(s[0])), r = $70fd6868680e912c$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $70fd6868680e912c$var$fail();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.ja) {
        for (const e of t){
            if (r.qa.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Jt, "Adding an already active target " + e);
                continue;
            }
            const t = await $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.qa.has(e) && // Release queries that are still active.
        await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $70fd6868680e912c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $70fd6868680e912c$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.La.p_ = $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.La.Ja = $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $70fd6868680e912c$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $70fd6868680e912c$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $70fd6868680e912c$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Yr.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $70fd6868680e912c$var$__PRIVATE_BundleLoader(r, e.localStore, t.serializer);
            let s = await t.Ya();
            for(; s;){
                const e = await i.Aa(s);
                e && n._updateProgress(e), s = await t.Ya();
            }
            const o = await i.complete();
            return await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.ma, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Yr.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Va);
        } catch (e) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$Jt, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $70fd6868680e912c$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.Za(e), this.persistence = this.Xa(e), await this.persistence.start(), this.localStore = this.eu(e), this.gcScheduler = this.tu(e, this.localStore), this.indexBackfillerScheduler = this.nu(e, this.localStore);
    }
    tu(e, t) {
        return null;
    }
    nu(e, t) {
        return null;
    }
    eu(e) {
        return $70fd6868680e912c$var$__PRIVATE_newLocalStore(this.persistence, new $70fd6868680e912c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Xa(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence($70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate.ri, this.serializer);
    }
    Za(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider
};
class $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    tu(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Xa(e) {
        const t = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$LruParams.DEFAULT;
        return new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence((e)=>$70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate.ri(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.ru = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.ru.initialize(this, e), // Enqueue writes from a previous session
        await $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.ru.syncEngine), await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(this.ru.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ci(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    eu(e) {
        return $70fd6868680e912c$var$__PRIVATE_newLocalStore(this.persistence, new $70fd6868680e912c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    tu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    nu(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $70fd6868680e912c$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Xa(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$LruParams.DEFAULT;
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $70fd6868680e912c$var$__PRIVATE_getWindow(), $70fd6868680e912c$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Za(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.ru = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.ru.syncEngine;
        this.sharedClientState instanceof $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            uo: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            co: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            lo: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            zi: $70fd6868680e912c$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            ao: $70fd6868680e912c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ci(async (e)=>{
            await $70fd6868680e912c$var$__PRIVATE_syncEngineApplyPrimaryState(this.ru.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Za(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_getWindow();
        if (!$70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState.D(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $70fd6868680e912c$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $70fd6868680e912c$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $70fd6868680e912c$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $70fd6868680e912c$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $70fd6868680e912c$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $70fd6868680e912c$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor.D() ? new $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor : new $70fd6868680e912c$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $70fd6868680e912c$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.ja = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e, t;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$zt, "RemoteStore shutting down."), t.W_.add(5 /* OfflineCause.Shutdown */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), t.z_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.j_.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate(), null === (t = this.eventManager) || void 0 === t || t.terminate();
    }
}
$70fd6868680e912c$var$OnlineComponentProvider.provider = {
    build: ()=>new $70fd6868680e912c$var$OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $70fd6868680e912c$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.iu(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.iu(this.observer.error, e) : $70fd6868680e912c$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    su() {
        this.muted = !0;
    }
    iu(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.ou = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $70fd6868680e912c$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this._u = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.au().then((e)=>{
            e && e.Ea() ? this.metadata.resolve(e.Ia.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.Ia)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.ou.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Ya() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.au();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async au() {
        const e = await this.uu();
        if (null === e) return null;
        const t = this._u.decode(e), n = Number(t);
        isNaN(n) && this.cu(`length string (${t}) is not valid number`);
        const r = await this.lu(n);
        return new $70fd6868680e912c$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ hu() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async uu() {
        for(; this.hu() < 0;){
            if (await this.Pu()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.hu();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.cu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async lu(e) {
        for(; this.buffer.length < e;)await this.Pu() && this.cu("Reached the end of bundle when more is expected.");
        const t = this._u.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    cu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.ou.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Pu() {
        const e = await this.ou.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $70fd6868680e912c$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$70fd6868680e912c$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.Co("BatchGetDocuments", n.serializer.databaseId, $70fd6868680e912c$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $70fd6868680e912c$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$70fd6868680e912c$var$toMutation(n.serializer, e))
            };
            await n.So("Commit", n.serializer.databaseId, $70fd6868680e912c$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $70fd6868680e912c$var$fail();
            // Represent a deleted doc using SnapshotVersion.min().
            t = $70fd6868680e912c$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? $70fd6868680e912c$var$Precondition.exists(!1) : $70fd6868680e912c$var$Precondition.updateTime(t) : $70fd6868680e912c$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $70fd6868680e912c$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $70fd6868680e912c$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $70fd6868680e912c$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Tu = n.maxAttempts, this.a_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Iu() {
        this.Tu -= 1, this.Eu();
    }
    Eu() {
        this.a_.Xo(async ()=>{
            const e = new $70fd6868680e912c$var$Transaction$2(this.datastore), t = this.du(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Au(e);
                    }));
            }).catch((e)=>{
                this.Au(e);
            });
        });
    }
    du(e) {
        try {
            const t = this.updateFunction(e);
            return !$70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Au(e) {
        this.Tu > 0 && this.Ru(e) ? (this.Tu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Eu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Ru(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$70fd6868680e912c$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Yt = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $70fd6868680e912c$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $70fd6868680e912c$var$User.UNAUTHENTICATED, this.clientId = $70fd6868680e912c$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e);
    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Using user provided OfflineComponentProvider");
            try {
                await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $70fd6868680e912c$var$C.FAILED_PRECONDITION || e.code === $70fd6868680e912c$var$C.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $70fd6868680e912c$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, new $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider);
            }
        } else $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Using default OfflineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Using user provided OnlineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$Yt, "Using default OnlineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, new $70fd6868680e912c$var$OnlineComponentProvider))), e._onlineComponents;
}
function $70fd6868680e912c$var$__PRIVATE_getPersistence(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $70fd6868680e912c$var$__PRIVATE_getLocalStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $70fd6868680e912c$var$__PRIVATE_getDatastore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $70fd6868680e912c$var$__PRIVATE_getEventManager(e) {
    const t = await $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $70fd6868680e912c$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $70fd6868680e912c$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $70fd6868680e912c$var$__PRIVATE_getPersistence(e), n = await $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return t.W_.delete(0 /* OfflineCause.UserDisabled */ ), $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $70fd6868680e912c$var$__PRIVATE_getPersistence(e), n = await $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            t.W_.add(0 /* OfflineCause.UserDisabled */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.j_.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.su(), t.enqueueAndForget(()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $70fd6868680e912c$var$__PRIVATE_QueryListener($70fd6868680e912c$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                Ta: !0
            });
            return $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $70fd6868680e912c$var$__PRIVATE_View(t, r.gs), s = i.ba(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.su(), t.enqueueAndForget(()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $70fd6868680e912c$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                Ta: !0
            });
            return $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $70fd6868680e912c$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e), { request: s, Pt: o, parent: _ } = $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(i.serializer, $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(t), n);
                i.connection.fo || delete s.parent;
                const a = (await i.Co("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === a.length);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $70fd6868680e912c$var$__PRIVATE_debugCast(e).ia.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.su(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $70fd6868680e912c$var$__PRIVATE_debugCast(e).ia.delete(t);
            })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $70fd6868680e912c$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $70fd6868680e912c$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $70fd6868680e912c$var$__PRIVATE_syncEngineLoadBundle(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Yr.getNamedQuery(e, t));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $70fd6868680e912c$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(i)));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $70fd6868680e912c$var$__PRIVATE_debugCast(e).Ps.Xi = t;
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Zt = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $70fd6868680e912c$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(e) {
    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(e) {
    if ($70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $70fd6868680e912c$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $70fd6868680e912c$var$__PRIVATE_valueDescription(e);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $70fd6868680e912c$var$Xt = "firestore.googleapis.com", $70fd6868680e912c$var$en = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $70fd6868680e912c$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $70fd6868680e912c$var$Xt, this.ssl = $70fd6868680e912c$var$en;
        } else this.host = e.host, this.ssl = null !== (t = e.ssl) && void 0 !== t ? t : $70fd6868680e912c$var$en;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $70fd6868680e912c$var$St;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $70fd6868680e912c$var$Dt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $70fd6868680e912c$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $70fd6868680e912c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $70fd6868680e912c$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $70fd6868680e912c$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $70fd6868680e912c$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $70fd6868680e912c$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $70fd6868680e912c$var$Zt.get(e);
            t && ($70fd6868680e912c$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $70fd6868680e912c$var$Zt.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $70fd6868680e912c$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    const s = (e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$var$Firestore$1))._getSettings(), o = Object.assign(Object.assign({}, s), {
        emulatorOptions: e._getEmulatorOptions()
    }), _ = `${t}:${n}`;
    s.host !== $70fd6868680e912c$var$Xt && s.host !== _ && $70fd6868680e912c$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const a = Object.assign(Object.assign({}, s), {
        host: _,
        ssl: !1,
        emulatorOptions: r
    });
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(a, o) && (e._setSettings(a), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $70fd6868680e912c$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $c38e0f42709c826a$export$367bf224123348f1)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $70fd6868680e912c$var$User(s);
        }
        e._authCredentials = new $70fd6868680e912c$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $70fd6868680e912c$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $70fd6868680e912c$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $70fd6868680e912c$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, e, this._key);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $70fd6868680e912c$export$ab5a1a47940a200e extends $70fd6868680e912c$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $70fd6868680e912c$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $70fd6868680e912c$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $70fd6868680e912c$var$Firestore$1) {
        const r = $70fd6868680e912c$var$ResourcePath.fromString(t, ...n);
        return $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(r), new $70fd6868680e912c$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($70fd6868680e912c$var$ResourcePath.fromString(t, ...n));
        return $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(r), new $70fd6868680e912c$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $70fd6868680e912c$export$473d82a73f88c107(e, t) {
    if (e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$var$Firestore$1), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $70fd6868680e912c$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $70fd6868680e912c$var$__PRIVATE_QueryImpl($70fd6868680e912c$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $70fd6868680e912c$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $70fd6868680e912c$export$253bcaa5572dcc83.newId()), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $70fd6868680e912c$var$Firestore$1) {
        const r = $70fd6868680e912c$var$ResourcePath.fromString(t, ...n);
        return $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(r), new $70fd6868680e912c$export$6be62b059fb12175(e, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($70fd6868680e912c$var$ResourcePath.fromString(t, ...n));
        return $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(r), new $70fd6868680e912c$export$6be62b059fb12175(e.firestore, e instanceof $70fd6868680e912c$export$ab5a1a47940a200e ? e.converter : null, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$62a32f2da6187d11(e, t) {
    return e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), (e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && (t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e instanceof $70fd6868680e912c$export$62297b13309008b2 && t instanceof $70fd6868680e912c$export$62297b13309008b2 && e.firestore === t.firestore && $70fd6868680e912c$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$tn = "AsyncQueue";
class $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Vu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.mu = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.fu = [], // visible for testing
        this.gu = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.pu = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.yu = !1, // List of TimerIds to fast-forward delays for.
        this.wu = [], // Backoff timer used to schedule retries for retryable operations
        this.a_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Su = ()=>{
            const e = $70fd6868680e912c$var$getDocument();
            e && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$tn, "Visibility state changed to " + e.visibilityState), this.a_.t_();
        }, this.bu = e;
        const t = $70fd6868680e912c$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Su);
    }
    get isShuttingDown() {
        return this.mu;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.Du(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.vu(e);
    }
    enterRestrictedMode(e) {
        if (!this.mu) {
            this.mu = !0, this.yu = e || !1;
            const t = $70fd6868680e912c$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.Su);
        }
    }
    enqueue(e) {
        if (this.Du(), this.mu) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return this.vu(()=>this.mu && this.yu ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Vu.push(e), this.Cu()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async Cu() {
        if (0 !== this.Vu.length) {
            try {
                await this.Vu[0](), this.Vu.shift(), this.a_.reset();
            } catch (e) {
                if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$tn, "Operation failed with retryable error: " + e);
            }
            this.Vu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.a_.Xo(()=>this.Cu());
        }
    }
    vu(e) {
        const t = this.bu.then(()=>(this.pu = !0, e().catch((e)=>{
                this.gu = e, this.pu = !1;
                const t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                    let t = e.message || "";
                    e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                    return t;
                }(e);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $70fd6868680e912c$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
            }).then((e)=>(this.pu = !1, e))));
        return this.bu = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.Du(), // Fast-forward delays for timerIds that have been overridden.
        this.wu.indexOf(e) > -1 && (t = 0);
        const r = $70fd6868680e912c$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.Fu(e));
        return this.fu.push(r), r;
    }
    Du() {
        this.gu && $70fd6868680e912c$var$fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Mu() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.bu, await e;
        while (e !== this.bu);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ xu(e) {
        for (const t of this.fu)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ou(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Mu().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.fu.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.fu)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Mu();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Nu(e) {
        this.wu.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ Fu(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.fu.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.fu.splice(t, 1);
    }
}
function $70fd6868680e912c$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $70fd6868680e912c$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $70fd6868680e912c$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $70fd6868680e912c$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $70fd6868680e912c$export$d0e2b3272814ce82 extends $70fd6868680e912c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $70fd6868680e912c$export$9061557f3e3b42f9(e, t, n) {
    n || (n = $70fd6868680e912c$var$rt);
    const r = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $70fd6868680e912c$var$Dt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $70fd6868680e912c$export$f06a05d14c3a6678(e, n) {
    const r = "object" == typeof e ? e : (0, $57d436074e210fb5$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || $70fd6868680e912c$var$rt, s = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)("firestore");
        e && $70fd6868680e912c$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $70fd6868680e912c$export$8da5fbea04405656(e) {
    if (e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $70fd6868680e912c$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $70fd6868680e912c$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $70fd6868680e912c$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._componentsProvider || (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._componentsProvider = {
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    }), e._firestoreClient = new $70fd6868680e912c$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = null == e ? void 0 : e._online.build();
        return {
            _offline: null == e ? void 0 : e._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $70fd6868680e912c$export$cebe3b626a79c5f3(e, t) {
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, $70fd6868680e912c$var$OnlineComponentProvider.provider, {
        build: (e)=>new $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, null == t ? void 0 : t.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $70fd6868680e912c$export$6d4c055e91302ab9(e) {
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, $70fd6868680e912c$var$OnlineComponentProvider.provider, {
        build: (e)=>new $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82))._firestoreClient || e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $70fd6868680e912c$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $70fd6868680e912c$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$70fd6868680e912c$var$__PRIVATE_SimpleDb.D()) return Promise.resolve();
                const t = e + $70fd6868680e912c$var$xt;
                await $70fd6868680e912c$var$__PRIVATE_SimpleDb.delete(t);
            }($70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $70fd6868680e912c$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $70fd6868680e912c$export$ee6bdee8287ecc5f(e) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientEnableNetwork($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $70fd6868680e912c$export$f35b708ad73d52eb(e) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientDisableNetwork($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $70fd6868680e912c$export$9aff22d1ec357a14(e) {
    return (0, $57d436074e210fb5$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $70fd6868680e912c$export$4b8b93c690c9810b(e, t) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), r = new $70fd6868680e912c$export$6cac12425252ec14;
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $70fd6868680e912c$export$169d2c6fe0f7f4ea(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetNamedQuery($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), t).then((t)=>t ? new $70fd6868680e912c$export$62297b13309008b2(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $70fd6868680e912c$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $70fd6868680e912c$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $70fd6868680e912c$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $70fd6868680e912c$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $70fd6868680e912c$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $70fd6868680e912c$export$bf6e62266977b8eb() {
    return new $70fd6868680e912c$export$a1a8fea822d17659($70fd6868680e912c$var$x);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $70fd6868680e912c$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $70fd6868680e912c$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 *
 * @class VectorValue
 */ class $70fd6868680e912c$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$rn = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $70fd6868680e912c$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $70fd6868680e912c$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $70fd6868680e912c$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $70fd6868680e912c$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $70fd6868680e912c$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ class $70fd6868680e912c$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Bu(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Lu() {
        return this.settings.Lu;
    }
    /** Returns a new context with the specified settings overwritten. */ ku(e) {
        return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    qu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.ku({
            path: n,
            Qu: !1
        });
        return r.$u(e), r;
    }
    Uu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.ku({
            path: n,
            Qu: !1
        });
        return r.Bu(), r;
    }
    Ku(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.ku({
            path: void 0,
            Qu: !0
        });
    }
    Wu(e) {
        return $70fd6868680e912c$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.Gu || !1, this.path, this.settings.zu);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    Bu() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.$u(this.path.get(e));
    }
    $u(e) {
        if (0 === e.length) throw this.Wu("Document fields must not be empty");
        if ($70fd6868680e912c$var$__PRIVATE_isWrite(this.Lu) && $70fd6868680e912c$var$rn.test(e)) throw this.Wu('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $70fd6868680e912c$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $70fd6868680e912c$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ ju(e, t, n, r = !1) {
        return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl({
            Lu: e,
            methodName: t,
            zu: n,
            path: $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(),
            Qu: !1,
            Gu: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $70fd6868680e912c$var$__PRIVATE_newSerializer(e._databaseId);
    return new $70fd6868680e912c$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $70fd6868680e912c$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.ju(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $70fd6868680e912c$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $70fd6868680e912c$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $70fd6868680e912c$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $70fd6868680e912c$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $70fd6868680e912c$var$ParsedSetData(new $70fd6868680e912c$var$ObjectValue(_), a, u);
}
class $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.Lu) throw 1 /* UserDataSource.Update */  === e.Lu ? e.Wu(`${this._methodName}() can only appear at the top level of your update data`) : e.Wu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl({
        Lu: 3 /* UserDataSource.Argument */ ,
        zu: t.settings.zu,
        methodName: e._methodName,
        Qu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $70fd6868680e912c$var$FieldTransform(e.path, new $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Hu = t;
    }
    _toFieldTransform(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Hu.map((e)=>$70fd6868680e912c$var$__PRIVATE_parseData(e, t)), r = new $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $70fd6868680e912c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(this.Hu, e.Hu);
    }
}
class $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Hu = t;
    }
    _toFieldTransform(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Hu.map((e)=>$70fd6868680e912c$var$__PRIVATE_parseData(e, t)), r = new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $70fd6868680e912c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(this.Hu, e.Hu);
    }
}
class $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Ju = t;
    }
    _toFieldTransform(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $70fd6868680e912c$var$toNumber(e.serializer, this.Ju));
        return new $70fd6868680e912c$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Ju === e.Ju;
    }
}
/** Parse update data from an update() call. */ function $70fd6868680e912c$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.ju(1 /* UserDataSource.Update */ , t, n);
    $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $70fd6868680e912c$var$ObjectValue.empty();
    $70fd6868680e912c$var$forEach(r, (e, r)=>{
        const _ = $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(r);
        const a = i.Uu(_);
        if (r instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $70fd6868680e912c$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $70fd6868680e912c$var$FieldMask(s);
    return new $70fd6868680e912c$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.ju(1 /* UserDataSource.Update */ , t, n), _ = [
        $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $70fd6868680e912c$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$70fd6868680e912c$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n);
        const r = o.Uu(t);
        if (n instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $70fd6868680e912c$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $70fd6868680e912c$var$FieldMask(u);
    return new $70fd6868680e912c$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $70fd6868680e912c$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $70fd6868680e912c$var$__PRIVATE_parseData(n, e.ju(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $70fd6868680e912c$var$__PRIVATE_parseData(e, t) {
    if ($70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e))) return $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $70fd6868680e912c$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$70fd6868680e912c$var$__PRIVATE_isWrite(t.Lu)) throw t.Wu(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.Wu(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.Qu && 4 /* UserDataSource.ArrayArgument */  !== t.Lu) throw t.Wu("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $70fd6868680e912c$var$__PRIVATE_parseData(i, t.Ku(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $70fd6868680e912c$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $70fd6868680e912c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $70fd6868680e912c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $70fd6868680e912c$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $70fd6868680e912c$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $70fd6868680e912c$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.Wu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $70fd6868680e912c$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $70fd6868680e912c$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = {
                fields: {
                    [$70fd6868680e912c$var$it]: {
                        stringValue: $70fd6868680e912c$var$_t
                    },
                    [$70fd6868680e912c$var$at]: {
                        arrayValue: {
                            values: e.toArray().map((e)=>{
                                if ("number" != typeof e) throw t.Wu("VectorValues must only contain numeric values.");
                                return $70fd6868680e912c$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: n
            };
        }(e, t);
        throw t.Wu(`Unsupported field value: ${$70fd6868680e912c$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $70fd6868680e912c$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $70fd6868680e912c$var$forEach(e, (e, r)=>{
        const i = $70fd6868680e912c$var$__PRIVATE_parseData(r, t.qu(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430 || e instanceof $70fd6868680e912c$export$f9f719d1b6419c4 || e instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1 || e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d || e instanceof $70fd6868680e912c$export$994bb3d317350b37);
}
function $70fd6868680e912c$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        const r = $70fd6868680e912c$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.Wu(e + " a custom object") : t.Wu(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) instanceof $70fd6868680e912c$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $70fd6868680e912c$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $70fd6868680e912c$var$sn = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($70fd6868680e912c$var$sn) >= 0) throw $70fd6868680e912c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $70fd6868680e912c$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $70fd6868680e912c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $70fd6868680e912c$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $70fd6868680e912c$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $70fd6868680e912c$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$var$QueryDocumentSnapshot$1 extends $70fd6868680e912c$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $70fd6868680e912c$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $70fd6868680e912c$export$b0e86f2c7431df4e extends $70fd6868680e912c$var$AppliableConstraint {
}
function $70fd6868680e912c$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $70fd6868680e912c$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $70fd6868680e912c$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $70fd6868680e912c$export$f765fc5789dfd439 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $70fd6868680e912c$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            const a = $70fd6868680e912c$var$FieldFilter.create(i, s, _);
            return a;
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $70fd6868680e912c$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $70fd6868680e912c$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $70fd6868680e912c$export$6bbc7aef0717f3d2 extends $70fd6868680e912c$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $70fd6868680e912c$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $70fd6868680e912c$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(n, e), n = $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $70fd6868680e912c$export$65a9ba8bbd6ed9e3 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $70fd6868680e912c$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new $70fd6868680e912c$var$OrderBy(t, n);
            return r;
        }(e._query, this._field, this._direction);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $70fd6868680e912c$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $70fd6868680e912c$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $70fd6868680e912c$export$49bb5356ca788047 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$ee37e834aaad6f7e(e) {
    return $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber("limit", e), $70fd6868680e912c$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$f823b3589f69d3b8(e) {
    return $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $70fd6868680e912c$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $70fd6868680e912c$export$d92e2830aca1d816 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $70fd6868680e912c$export$859941c5fc8eba6b(...e) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $70fd6868680e912c$export$dd8dee5f7b804673(...e) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $70fd6868680e912c$export$fd1782fd870d1e06 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $70fd6868680e912c$export$57203950645b8b11(...e) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $70fd6868680e912c$export$28ec54a8428bdb3f(...e) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $70fd6868680e912c$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($70fd6868680e912c$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $70fd6868680e912c$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($70fd6868680e912c$var$ResourcePath.fromString(a));
                    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(n)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $70fd6868680e912c$export$afc2e57c475b7810(n);
                    _.push($70fd6868680e912c$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $70fd6868680e912c$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $70fd6868680e912c$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($70fd6868680e912c$var$ResourcePath.fromString(n));
        if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(r)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $70fd6868680e912c$var$__PRIVATE_refValue(e, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
    if (n instanceof $70fd6868680e912c$export$6be62b059fb12175) return $70fd6868680e912c$var$__PRIVATE_refValue(e, n._key);
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$70fd6868680e912c$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $70fd6868680e912c$export$f765fc5789dfd439 || t instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($70fd6868680e912c$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $70fd6868680e912c$var$fail();
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $70fd6868680e912c$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        var t, n, r;
        const i = null === (r = null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t[$70fd6868680e912c$var$at].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.map((e)=>$70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $70fd6868680e912c$export$994bb3d317350b37(i);
    }
    convertGeoPoint(e) {
        return new $70fd6868680e912c$export$f9f719d1b6419c4($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.latitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $70fd6868680e912c$var$ResourcePath.fromString(e);
        $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isValidResourceName(n));
        const r = new $70fd6868680e912c$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $70fd6868680e912c$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $70fd6868680e912c$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $70fd6868680e912c$export$8a63f25cc62965f1(e) {
    return new $70fd6868680e912c$export$fada2345be8928cf("sum", $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $70fd6868680e912c$export$cc6710ee5f037d57(e) {
    return new $70fd6868680e912c$export$fada2345be8928cf("avg", $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $70fd6868680e912c$export$85b9a36db797e02b() {
    return new $70fd6868680e912c$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $70fd6868680e912c$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $70fd6868680e912c$export$fada2345be8928cf && t instanceof $70fd6868680e912c$export$fada2345be8928cf && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $70fd6868680e912c$export$104f59389a332076(e, t) {
    return $70fd6868680e912c$export$49b1d0de6ba30f41(e.query, t.query) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $70fd6868680e912c$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$export$acab0e6ef25eb301 extends $70fd6868680e912c$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$export$6d4d04e42af6b03c extends $70fd6868680e912c$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $70fd6868680e912c$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $70fd6868680e912c$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $70fd6868680e912c$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $70fd6868680e912c$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $70fd6868680e912c$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $70fd6868680e912c$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $70fd6868680e912c$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $70fd6868680e912c$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
}
function $70fd6868680e912c$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $70fd6868680e912c$var$fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $70fd6868680e912c$export$f243a5d948512846(e, t) {
    return e instanceof $70fd6868680e912c$export$acab0e6ef25eb301 && t instanceof $70fd6868680e912c$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $70fd6868680e912c$export$8f21149d8133945c && t instanceof $70fd6868680e912c$export$8f21149d8133945c && e._firestore === t._firestore && $70fd6868680e912c$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$11eb3b5ef9574821(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($70fd6868680e912c$export$8da5fbea04405656(t), e._key).then((n)=>$70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
class $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$a58bd92642f7fb58(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $70fd6868680e912c$export$acab0e6ef25eb301(t, r, e._key, n, new $70fd6868680e912c$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$35dd759aed9686b4(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($70fd6868680e912c$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$81d3477bd73c86ef(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$3fd010f18eac1dd(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$ec7d9e44f349c77b(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
function $70fd6868680e912c$export$5ff77ddaff3c9e12(e, t, n) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const r = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $70fd6868680e912c$export$1945f8fec9dda613(r, [
        $70fd6868680e912c$var$__PRIVATE_parseSetData($70fd6868680e912c$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $70fd6868680e912c$var$Precondition.none())
    ]);
}
function $70fd6868680e912c$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const i = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $70fd6868680e912c$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $70fd6868680e912c$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a4f20481fae8f78b(e) {
    return $70fd6868680e912c$export$1945f8fec9dda613($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), [
        new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e._key, $70fd6868680e912c$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a13890143fb1c2dd(e, t) {
    const n = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$export$2a111da947c407d2(e), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $70fd6868680e912c$export$1945f8fec9dda613(n, [
        $70fd6868680e912c$var$__PRIVATE_parseSetData($70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $70fd6868680e912c$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $70fd6868680e912c$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || $70fd6868680e912c$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if ($70fd6868680e912c$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $70fd6868680e912c$export$6be62b059fb12175) u = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), c = $70fd6868680e912c$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
        u = $70fd6868680e912c$export$572106fb5803752c(n.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), c = n._query;
        const r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $70fd6868680e912c$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver(r), s = new $70fd6868680e912c$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_eventManagerListen(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.su(), e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), s));
        };
    }($70fd6868680e912c$export$8da5fbea04405656(u), c, _, a);
}
function $70fd6868680e912c$export$9dff4f5aba83e348(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), $70fd6868680e912c$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $70fd6868680e912c$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_syncEngineWrite(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(e);
    return new $70fd6868680e912c$export$acab0e6ef25eb301(e, i, t._key, r, new $70fd6868680e912c$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $70fd6868680e912c$export$b1de1b12889d0afb(e) {
    return $70fd6868680e912c$export$a51511de2fae49b3(e, {
        count: $70fd6868680e912c$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $70fd6868680e912c$export$a51511de2fae49b3(e, t) {
    const n = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$export$8da5fbea04405656(n), i = $70fd6868680e912c$var$__PRIVATE_mapToArray(t, (e, t)=>new $70fd6868680e912c$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(e), i = new $70fd6868680e912c$export$40257fef64be808b(t, r, n);
            return i;
        })(n, e, t));
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = {
            build: ()=>new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $70fd6868680e912c$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $70fd6868680e912c$export$574728f3be606189() {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $70fd6868680e912c$export$2340f88905cc0c23(e) {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryLruGarbageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $70fd6868680e912c$export$72ef71adb739a32c(e) {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $70fd6868680e912c$export$51b321e43d5331d5(e) {
    return new $70fd6868680e912c$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $70fd6868680e912c$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $70fd6868680e912c$export$d5f96a3c009e86ac(e) {
    return new $70fd6868680e912c$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $70fd6868680e912c$export$57e9d290b0b4dc04() {
    return new $70fd6868680e912c$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$on = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $70fd6868680e912c$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $70fd6868680e912c$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $70fd6868680e912c$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $70fd6868680e912c$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(t._key, $70fd6868680e912c$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $70fd6868680e912c$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$var$Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), n = new $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $70fd6868680e912c$var$fail();
            const r = e[0];
            if (r.isFoundDocument()) return new $70fd6868680e912c$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $70fd6868680e912c$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $70fd6868680e912c$var$fail();
        });
    }
    set(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $70fd6868680e912c$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$export$febc5573c75cefb0 extends $70fd6868680e912c$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), n = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $70fd6868680e912c$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $70fd6868680e912c$export$3c54e006bf9c93b7(e, t, n) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $70fd6868680e912c$var$on), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $70fd6868680e912c$var$__PRIVATE_getDatastore(e);
            new $70fd6868680e912c$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Iu();
        }), r.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e), (n)=>t(new $70fd6868680e912c$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $70fd6868680e912c$export$2bbad96c62fdba3e() {
    return new $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $70fd6868680e912c$export$3ff8e7e00c3264b7() {
    return new $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $70fd6868680e912c$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$a2647aa13413c947(e) {
    return new $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $70fd6868680e912c$export$6074e20ba5c64bef(e) {
    return new $70fd6868680e912c$export$994bb3d317350b37(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $70fd6868680e912c$export$44cd1c9d57edd9b1(e) {
    return $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), new $70fd6868680e912c$export$d94ed661b1cfd435(e, (t)=>$70fd6868680e912c$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$export$ff1663c0c1304f1a(e, t) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $70fd6868680e912c$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $70fd6868680e912c$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $70fd6868680e912c$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $70fd6868680e912c$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $70fd6868680e912c$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $70fd6868680e912c$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $70fd6868680e912c$var$FieldIndex($70fd6868680e912c$var$FieldIndex.UNKNOWN_ID, t, r, $70fd6868680e912c$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}
function $70fd6868680e912c$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $70fd6868680e912c$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $70fd6868680e912c$export$61c6347b57bdfa06(e) {
    var t;
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82);
    const n = $70fd6868680e912c$var$_n.get(e);
    if (n) return n;
    if ("persistent" !== (null === (t = $70fd6868680e912c$export$8da5fbea04405656(e)._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offline.kind)) return null;
    const r = new $70fd6868680e912c$export$cf4db3c220e88bd8(e);
    return $70fd6868680e912c$var$_n.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $70fd6868680e912c$export$9b2c0a7aacbcd151(e) {
    $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $70fd6868680e912c$export$5b460d5f48076743(e) {
    $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $70fd6868680e912c$export$72809fc2fc5083d5(e) {
    $70fd6868680e912c$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes($70fd6868680e912c$export$8da5fbea04405656(e._firestore)).then((e)=>$70fd6868680e912c$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$70fd6868680e912c$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    $70fd6868680e912c$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled($70fd6868680e912c$export$8da5fbea04405656(e._firestore), t).then((e)=>$70fd6868680e912c$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$70fd6868680e912c$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $70fd6868680e912c$var$_n = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70fd6868680e912c$export$b22c6725d8899bb4(e) {
    var t;
    const n = null === (t = $70fd6868680e912c$export$8da5fbea04405656($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : $70fd6868680e912c$var$__PRIVATE_toQueryTarget(n, $70fd6868680e912c$var$__PRIVATE_queryToTarget(e._query)).ht;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $70fd6868680e912c$export$5bcaa7c32a88925e(e, t) {
    var n;
    const r = $70fd6868680e912c$var$__PRIVATE_mapToArray(t, (e, t)=>new $70fd6868680e912c$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), i = null === (n = $70fd6868680e912c$export$8da5fbea04405656($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(i, $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $70fd6868680e912c$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Yu = new Map;
    }
    static get instance() {
        return $70fd6868680e912c$var$an || ($70fd6868680e912c$var$an = new $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($70fd6868680e912c$var$At) throw new Error("a TestingHooksSpi instance is already set");
            $70fd6868680e912c$var$At = e;
        }($70fd6868680e912c$var$an)), $70fd6868680e912c$var$an;
    }
    rt(e) {
        this.Yu.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Yu;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $70fd6868680e912c$var$an = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $70fd6868680e912c$var$D = e;
    }((0, $57d436074e210fb5$export$31499a9cd224b78c)), (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $70fd6868680e912c$export$d0e2b3272814ce82(new $70fd6868680e912c$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $70fd6868680e912c$var$__PRIVATE_FirebaseAppCheckTokenProvider(i, e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$C.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $70fd6868680e912c$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$S, $70fd6868680e912c$var$b, e), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$S, $70fd6868680e912c$var$b, "esm2017");
}();







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $03ee16a658161e2a$var$LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
const $03ee16a658161e2a$var$UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function $03ee16a658161e2a$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $03ee16a658161e2a$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === 'number' && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === '[object String]') return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$03ee16a658161e2a$var$encode(x));
    if (typeof data === 'function' || typeof data === 'object') return $03ee16a658161e2a$var$mapValues(data, (x)=>$03ee16a658161e2a$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error('Data cannot be encoded in JSON: ' + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $03ee16a658161e2a$var$decode(json) {
    if (json == null) return json;
    if (json['@type']) switch(json['@type']){
        case $03ee16a658161e2a$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $03ee16a658161e2a$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json['value']);
                if (isNaN(value)) throw new Error('Data cannot be decoded from JSON: ' + json);
                return value;
            }
        default:
            throw new Error('Data cannot be decoded from JSON: ' + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$03ee16a658161e2a$var$decode(x));
    if (typeof json === 'function' || typeof json === 'object') return $03ee16a658161e2a$var$mapValues(json, (x)=>$03ee16a658161e2a$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $03ee16a658161e2a$var$FUNCTIONS_TYPE = 'functions';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $03ee16a658161e2a$var$errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An error returned by the Firebase Functions client SDK.
 *
 * See {@link FunctionsErrorCode} for full documentation of codes.
 *
 * @public
 */ class $03ee16a658161e2a$export$738689d52335bb3c extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /**
     * Constructs a new instance of the `FunctionsError` class.
     */ constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Additional details to be converted to JSON and included in the error response.
     */ details){
        super(`${$03ee16a658161e2a$var$FUNCTIONS_TYPE}/${code}`, message || '');
        this.details = details;
        // Since the FirebaseError constructor sets the prototype of `this` to FirebaseError.prototype,
        // we also have to do it in all subclasses to allow for correct `instanceof` checks.
        Object.setPrototypeOf(this, $03ee16a658161e2a$export$738689d52335bb3c.prototype);
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $03ee16a658161e2a$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return 'ok';
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
    }
    return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $03ee16a658161e2a$var$_errorForResponse(status, bodyJSON) {
    let code = $03ee16a658161e2a$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === 'string') {
                if (!$03ee16a658161e2a$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $03ee16a658161e2a$export$738689d52335bb3c('internal', 'internal');
                code = $03ee16a658161e2a$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === 'string') description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $03ee16a658161e2a$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $03ee16a658161e2a$export$738689d52335bb3c(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $03ee16a658161e2a$var$ContextProvider {
    constructor(app, authProvider, messagingProvider, appCheckProvider){
        this.app = app;
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.serverAppAppCheckToken = null;
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(app) && app.settings.appCheckToken) this.serverAppAppCheckToken = app.settings.appCheckToken;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token === null || token === void 0 ? void 0 : token.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !('Notification' in self) || Notification.permission !== 'granted') return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken(limitedUseAppCheckTokens) {
        if (this.serverAppAppCheckToken) return this.serverAppAppCheckToken;
        if (this.appCheck) {
            const result = limitedUseAppCheckTokens ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext(limitedUseAppCheckTokens) {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $03ee16a658161e2a$var$DEFAULT_REGION = 'us-central1';
const $03ee16a658161e2a$var$responseLineRE = /^data: (.*?)(?:\n|$)/;
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $03ee16a658161e2a$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $03ee16a658161e2a$export$738689d52335bb3c('deadline-exceeded', 'deadline-exceeded'));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $03ee16a658161e2a$var$FunctionsService {
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $03ee16a658161e2a$var$DEFAULT_REGION, fetchImpl = (...args)=>fetch(...args)){
        this.app = app;
        this.fetchImpl = fetchImpl;
        this.emulatorOrigin = null;
        this.contextProvider = new $03ee16a658161e2a$var$ContextProvider(app, authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin + (url.pathname === '/' ? '' : url.pathname);
            this.region = $03ee16a658161e2a$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $03ee16a658161e2a$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    functionsInstance.emulatorOrigin = `http://${host}:${port}`;
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $03ee16a658161e2a$var$httpsCallable$1(functionsInstance, name, options) {
    const callable = (data)=>{
        return $03ee16a658161e2a$var$call(functionsInstance, name, data, options || {});
    };
    callable.stream = (data, options)=>{
        return $03ee16a658161e2a$var$stream(functionsInstance, name, data, options);
    };
    return callable;
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $03ee16a658161e2a$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    const callable = (data)=>{
        return $03ee16a658161e2a$var$callAtURL(functionsInstance, url, data, options || {});
    };
    callable.stream = (data, options)=>{
        return $03ee16a658161e2a$var$streamAtURL(functionsInstance, url, data, options || {});
    };
    return callable;
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @return A Promise that will succeed when the request finishes.
 */ async function $03ee16a658161e2a$var$postJSON(url, body, headers, fetchImpl) {
    headers['Content-Type'] = 'application/json';
    let response;
    try {
        response = await fetchImpl(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: headers
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Creates authorization headers for Firebase Functions requests.
 * @param functionsInstance The Firebase Functions service instance.
 * @param options Options for the callable function, including AppCheck token settings.
 * @return A Promise that resolves a headers map to include in outgoing fetch request.
 */ async function $03ee16a658161e2a$var$makeAuthHeaders(functionsInstance, options) {
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext(options.limitedUseAppCheckTokens);
    if (context.authToken) headers['Authorization'] = 'Bearer ' + context.authToken;
    if (context.messagingToken) headers['Firebase-Instance-ID-Token'] = context.messagingToken;
    if (context.appCheckToken !== null) headers['X-Firebase-AppCheck'] = context.appCheckToken;
    return headers;
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.
 */ function $03ee16a658161e2a$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $03ee16a658161e2a$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.
 */ async function $03ee16a658161e2a$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $03ee16a658161e2a$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = await $03ee16a658161e2a$var$makeAuthHeaders(functionsInstance, options);
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $03ee16a658161e2a$var$failAfter(timeout);
    const response = await Promise.race([
        $03ee16a658161e2a$var$postJSON(url, body, headers, functionsInstance.fetchImpl),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $03ee16a658161e2a$export$738689d52335bb3c('cancelled', 'Firebase Functions instance was deleted.');
    // Check for an error status, regardless of http status.
    const error = $03ee16a658161e2a$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $03ee16a658161e2a$export$738689d52335bb3c('internal', 'Response is not valid JSON object.');
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === 'undefined') responseData = response.json.result;
    if (typeof responseData === 'undefined') // Consider the response malformed.
    throw new $03ee16a658161e2a$export$738689d52335bb3c('internal', 'Response is missing data field.');
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $03ee16a658161e2a$var$decode(responseData);
    return {
        data: decodedData
    };
}
/**
 * Calls a callable function asynchronously and returns a streaming result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.
 * @param options Streaming request options.
 */ function $03ee16a658161e2a$var$stream(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $03ee16a658161e2a$var$streamAtURL(functionsInstance, url, data, options || {});
}
/**
 * Calls a callable function asynchronously and return a streaming result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.
 * @param options Streaming request options.
 */ async function $03ee16a658161e2a$var$streamAtURL(functionsInstance, url, data, options) {
    var _a;
    // Encode any special types, such as dates, in the input data.
    data = $03ee16a658161e2a$var$encode(data);
    const body = {
        data: data
    };
    //
    // Add a header for the authToken.
    const headers = await $03ee16a658161e2a$var$makeAuthHeaders(functionsInstance, options);
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'text/event-stream';
    let response;
    try {
        response = await functionsInstance.fetchImpl(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: headers,
            signal: options === null || options === void 0 ? void 0 : options.signal
        });
    } catch (e) {
        if (e instanceof Error && e.name === 'AbortError') {
            const error = new $03ee16a658161e2a$export$738689d52335bb3c('cancelled', 'Request was cancelled.');
            return {
                data: Promise.reject(error),
                stream: {
                    [Symbol.asyncIterator] () {
                        return {
                            next () {
                                return Promise.reject(error);
                            }
                        };
                    }
                }
            };
        }
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        const error = $03ee16a658161e2a$var$_errorForResponse(0, null);
        return {
            data: Promise.reject(error),
            // Return an empty async iterator
            stream: {
                [Symbol.asyncIterator] () {
                    return {
                        next () {
                            return Promise.reject(error);
                        }
                    };
                }
            }
        };
    }
    let resultResolver;
    let resultRejecter;
    const resultPromise = new Promise((resolve, reject)=>{
        resultResolver = resolve;
        resultRejecter = reject;
    });
    (_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 || _a.addEventListener('abort', ()=>{
        const error = new $03ee16a658161e2a$export$738689d52335bb3c('cancelled', 'Request was cancelled.');
        resultRejecter(error);
    });
    const reader = response.body.getReader();
    const rstream = $03ee16a658161e2a$var$createResponseStream(reader, resultResolver, resultRejecter, options === null || options === void 0 ? void 0 : options.signal);
    return {
        stream: {
            [Symbol.asyncIterator] () {
                const rreader = rstream.getReader();
                return {
                    async next () {
                        const { value: value, done: done } = await rreader.read();
                        return {
                            value: value,
                            done: done
                        };
                    },
                    async return () {
                        await rreader.cancel();
                        return {
                            done: true,
                            value: undefined
                        };
                    }
                };
            }
        },
        data: resultPromise
    };
}
/**
 * Creates a ReadableStream that processes a streaming response from a streaming
 * callable function that returns data in server-sent event format.
 *
 * @param reader The underlying reader providing raw response data
 * @param resultResolver Callback to resolve the final result when received
 * @param resultRejecter Callback to reject with an error if encountered
 * @param signal Optional AbortSignal to cancel the stream processing
 * @returns A ReadableStream that emits decoded messages from the response
 *
 * The returned ReadableStream:
 *   1. Emits individual messages when "message" data is received
 *   2. Resolves with the final result when a "result" message is received
 *   3. Rejects with an error if an "error" message is received
 */ function $03ee16a658161e2a$var$createResponseStream(reader, resultResolver, resultRejecter, signal) {
    const processLine = (line, controller)=>{
        const match = line.match($03ee16a658161e2a$var$responseLineRE);
        // ignore all other lines (newline, comments, etc.)
        if (!match) return;
        const data = match[1];
        try {
            const jsonData = JSON.parse(data);
            if ('result' in jsonData) {
                resultResolver($03ee16a658161e2a$var$decode(jsonData.result));
                return;
            }
            if ('message' in jsonData) {
                controller.enqueue($03ee16a658161e2a$var$decode(jsonData.message));
                return;
            }
            if ('error' in jsonData) {
                const error = $03ee16a658161e2a$var$_errorForResponse(0, jsonData);
                controller.error(error);
                resultRejecter(error);
                return;
            }
        } catch (error) {
            if (error instanceof $03ee16a658161e2a$export$738689d52335bb3c) {
                controller.error(error);
                resultRejecter(error);
                return;
            }
        // ignore other parsing errors
        }
    };
    const decoder = new TextDecoder();
    return new ReadableStream({
        start (controller) {
            let currentText = '';
            return pump();
            async function pump() {
                if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                    const error = new $03ee16a658161e2a$export$738689d52335bb3c('cancelled', 'Request was cancelled');
                    controller.error(error);
                    resultRejecter(error);
                    return Promise.resolve();
                }
                try {
                    const { value: value, done: done } = await reader.read();
                    if (done) {
                        if (currentText.trim()) processLine(currentText.trim(), controller);
                        controller.close();
                        return;
                    }
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                        const error = new $03ee16a658161e2a$export$738689d52335bb3c('cancelled', 'Request was cancelled');
                        controller.error(error);
                        resultRejecter(error);
                        await reader.cancel();
                        return;
                    }
                    currentText += decoder.decode(value, {
                        stream: true
                    });
                    const lines = currentText.split('\n');
                    currentText = lines.pop() || '';
                    for (const line of lines)if (line.trim()) processLine(line.trim(), controller);
                    return pump();
                } catch (error) {
                    const functionsError = error instanceof $03ee16a658161e2a$export$738689d52335bb3c ? error : $03ee16a658161e2a$var$_errorForResponse(0, null);
                    controller.error(functionsError);
                    resultRejecter(functionsError);
                }
            }
        },
        cancel () {
            return reader.cancel();
        }
    });
}
const $03ee16a658161e2a$var$name = "@firebase/functions";
const $03ee16a658161e2a$var$version = "0.12.3";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $03ee16a658161e2a$var$AUTH_INTERNAL_NAME = 'auth-internal';
const $03ee16a658161e2a$var$APP_CHECK_INTERNAL_NAME = 'app-check-internal';
const $03ee16a658161e2a$var$MESSAGING_INTERNAL_NAME = 'messaging-internal';
function $03ee16a658161e2a$var$registerFunctions(variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider($03ee16a658161e2a$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($03ee16a658161e2a$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($03ee16a658161e2a$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $03ee16a658161e2a$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain);
    };
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($03ee16a658161e2a$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($03ee16a658161e2a$var$name, $03ee16a658161e2a$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($03ee16a658161e2a$var$name, $03ee16a658161e2a$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $03ee16a658161e2a$export$7d4c14593b8a2193(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), regionOrCustomDomain = $03ee16a658161e2a$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app), $03ee16a658161e2a$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    const emulator = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)('functions');
    if (emulator) $03ee16a658161e2a$export$472343ee9d485d97(functionsInstance, ...emulator);
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $03ee16a658161e2a$export$472343ee9d485d97(functionsInstance, host, port) {
    $03ee16a658161e2a$var$connectFunctionsEmulator$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $03ee16a658161e2a$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $03ee16a658161e2a$var$httpsCallable$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $03ee16a658161e2a$export$486b60b301a0b194(functionsInstance, url, options) {
    return $03ee16a658161e2a$var$httpsCallableFromURL$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $03ee16a658161e2a$var$registerFunctions();




// Import the functions you need from the SDKs you need

var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "11.5.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');










const $da38ac6aa733c404$var$name = "@firebase/database";
const $da38ac6aa733c404$var$version = "1.0.14";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $da38ac6aa733c404$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $da38ac6aa733c404$export$c9fb972242fcb3c4(version) {
    $da38ac6aa733c404$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $da38ac6aa733c404$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $c38e0f42709c826a$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $da38ac6aa733c404$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $c38e0f42709c826a$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $da38ac6aa733c404$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $da38ac6aa733c404$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $da38ac6aa733c404$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $da38ac6aa733c404$var$PersistentStorage = $da38ac6aa733c404$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $da38ac6aa733c404$var$SessionStorage = $da38ac6aa733c404$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $da38ac6aa733c404$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $da38ac6aa733c404$var$sha1 = function(str) {
    const utf8Bytes = (0, $c38e0f42709c826a$export$655666783217a925)(str);
    const sha1 = new (0, $c38e0f42709c826a$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $c38e0f42709c826a$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $da38ac6aa733c404$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $da38ac6aa733c404$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $c38e0f42709c826a$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $da38ac6aa733c404$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $da38ac6aa733c404$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $da38ac6aa733c404$var$enableLogging$1 = function(logger_, persistent) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $da38ac6aa733c404$var$logClient.logLevel = (0, $45b460d9de9b230f$export$243e62d78d3b544d).VERBOSE;
        $da38ac6aa733c404$var$logger = $da38ac6aa733c404$var$logClient.log.bind($da38ac6aa733c404$var$logClient);
        if (persistent) $da38ac6aa733c404$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $da38ac6aa733c404$var$logger = logger_;
    else {
        $da38ac6aa733c404$var$logger = null;
        $da38ac6aa733c404$var$SessionStorage.remove('logging_enabled');
    }
};
const $da38ac6aa733c404$var$log = function(...varArgs) {
    if ($da38ac6aa733c404$var$firstLog_ === true) {
        $da38ac6aa733c404$var$firstLog_ = false;
        if ($da38ac6aa733c404$var$logger === null && $da38ac6aa733c404$var$SessionStorage.get('logging_enabled') === true) $da38ac6aa733c404$var$enableLogging$1(true);
    }
    if ($da38ac6aa733c404$var$logger) {
        const message = $da38ac6aa733c404$var$buildLogMessage_.apply(null, varArgs);
        $da38ac6aa733c404$var$logger(message);
    }
};
const $da38ac6aa733c404$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $da38ac6aa733c404$var$log(prefix, ...varArgs);
    };
};
const $da38ac6aa733c404$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $da38ac6aa733c404$var$buildLogMessage_(...varArgs);
    $da38ac6aa733c404$var$logClient.error(message);
};
const $da38ac6aa733c404$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$da38ac6aa733c404$var$buildLogMessage_(...varArgs)}`;
    $da38ac6aa733c404$var$logClient.error(message);
    throw new Error(message);
};
const $da38ac6aa733c404$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $da38ac6aa733c404$var$buildLogMessage_(...varArgs);
    $da38ac6aa733c404$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $da38ac6aa733c404$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $da38ac6aa733c404$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $da38ac6aa733c404$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $da38ac6aa733c404$var$executeWhenDOMReady = function(fn) {
    if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $da38ac6aa733c404$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $da38ac6aa733c404$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $da38ac6aa733c404$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $da38ac6aa733c404$var$MIN_NAME || b === $da38ac6aa733c404$var$MAX_NAME) return -1;
    else if (b === $da38ac6aa733c404$var$MIN_NAME || a === $da38ac6aa733c404$var$MAX_NAME) return 1;
    else {
        const aAsInt = $da38ac6aa733c404$var$tryParseInt(a), bAsInt = $da38ac6aa733c404$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $da38ac6aa733c404$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $da38ac6aa733c404$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(obj));
};
const $da38ac6aa733c404$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $c38e0f42709c826a$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $c38e0f42709c826a$export$fac44ee5b035f737)(keys[i]);
        key += ':';
        key += $da38ac6aa733c404$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $da38ac6aa733c404$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $da38ac6aa733c404$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $da38ac6aa733c404$var$doubleToIEEE754String = function(v) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $da38ac6aa733c404$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $da38ac6aa733c404$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $da38ac6aa733c404$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $da38ac6aa733c404$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $da38ac6aa733c404$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $da38ac6aa733c404$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $da38ac6aa733c404$var$tryParseInt = function(str) {
    if ($da38ac6aa733c404$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $da38ac6aa733c404$var$INTEGER_32_MIN && intVal <= $da38ac6aa733c404$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $da38ac6aa733c404$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $da38ac6aa733c404$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $da38ac6aa733c404$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $da38ac6aa733c404$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $da38ac6aa733c404$var$AppCheckTokenProvider {
    constructor(app, appCheckProvider){
        this.appCheckProvider = appCheckProvider;
        this.appName = app.name;
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(app) && app.settings.appCheckToken) this.serverAppAppCheckToken = app.settings.appCheckToken;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (this.serverAppAppCheckToken) {
            if (forceRefresh) throw new Error('Attempted reuse of `FirebaseServerApp.appCheckToken` after previous usage failed.');
            return Promise.resolve({
                token: this.serverAppAppCheckToken
            });
        }
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $da38ac6aa733c404$var$warn(`Provided AppCheck credentials for the app named "${this.appName}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $da38ac6aa733c404$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $da38ac6aa733c404$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $da38ac6aa733c404$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $da38ac6aa733c404$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $da38ac6aa733c404$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$PROTOCOL_VERSION = '5';
const $da38ac6aa733c404$var$VERSION_PARAM = 'v';
const $da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM = 's';
const $da38ac6aa733c404$var$REFERER_PARAM = 'r';
const $da38ac6aa733c404$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $da38ac6aa733c404$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $da38ac6aa733c404$var$LAST_SESSION_PARAM = 'ls';
const $da38ac6aa733c404$var$APPLICATION_ID_PARAM = 'p';
const $da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $da38ac6aa733c404$var$WEBSOCKET = 'websocket';
const $da38ac6aa733c404$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $da38ac6aa733c404$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false, emulatorOptions = null){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this.emulatorOptions = emulatorOptions;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $da38ac6aa733c404$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $da38ac6aa733c404$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $da38ac6aa733c404$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof type === 'string', 'typeof type must == string');
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $da38ac6aa733c404$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $da38ac6aa733c404$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($da38ac6aa733c404$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $da38ac6aa733c404$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $da38ac6aa733c404$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $c38e0f42709c826a$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $c38e0f42709c826a$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$collections = {};
const $da38ac6aa733c404$var$reporters = {};
function $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$da38ac6aa733c404$var$collections[hashString]) $da38ac6aa733c404$var$collections[hashString] = new $da38ac6aa733c404$var$StatsCollection();
    return $da38ac6aa733c404$var$collections[hashString];
}
function $da38ac6aa733c404$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$da38ac6aa733c404$var$reporters[hashString]) $da38ac6aa733c404$var$reporters[hashString] = creatorFunction();
    return $da38ac6aa733c404$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $da38ac6aa733c404$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $da38ac6aa733c404$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $da38ac6aa733c404$var$MAX_URL_DATA_SIZE = 1870;
const $da38ac6aa733c404$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $da38ac6aa733c404$var$MAX_PAYLOAD_SIZE = $da38ac6aa733c404$var$MAX_URL_DATA_SIZE - $da38ac6aa733c404$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $da38ac6aa733c404$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $da38ac6aa733c404$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $da38ac6aa733c404$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $da38ac6aa733c404$var$logWrapper(connId);
        this.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, $da38ac6aa733c404$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $da38ac6aa733c404$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($da38ac6aa733c404$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $da38ac6aa733c404$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $da38ac6aa733c404$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$da38ac6aa733c404$var$VERSION_PARAM] = $da38ac6aa733c404$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$da38ac6aa733c404$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$da38ac6aa733c404$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $da38ac6aa733c404$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$da38ac6aa733c404$var$REFERER_PARAM] = $da38ac6aa733c404$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $da38ac6aa733c404$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $da38ac6aa733c404$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) return false;
        else if ($da38ac6aa733c404$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$da38ac6aa733c404$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$da38ac6aa733c404$var$isChromeExtensionContentScript() && !$da38ac6aa733c404$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $c38e0f42709c826a$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $da38ac6aa733c404$var$splitStringBySize(base64data, $da38ac6aa733c404$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $da38ac6aa733c404$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $da38ac6aa733c404$var$LUIDGenerator();
            window[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $da38ac6aa733c404$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $da38ac6aa733c404$var$log('frame writing exception');
                if (e.stack) $da38ac6aa733c404$var$log(e.stack);
                $da38ac6aa733c404$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $da38ac6aa733c404$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $da38ac6aa733c404$var$SEG_HEADER_SIZE + curDataString.length <= $da38ac6aa733c404$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($da38ac6aa733c404$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $da38ac6aa733c404$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $da38ac6aa733c404$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $da38ac6aa733c404$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $da38ac6aa733c404$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $da38ac6aa733c404$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $da38ac6aa733c404$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $da38ac6aa733c404$var$logWrapper(this.connId);
        this.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo);
        this.connURL = $da38ac6aa733c404$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$da38ac6aa733c404$var$VERSION_PARAM] = $da38ac6aa733c404$var$PROTOCOL_VERSION;
        if (!(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)() && typeof location !== 'undefined' && location.hostname && $da38ac6aa733c404$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$da38ac6aa733c404$var$REFERER_PARAM] = $da38ac6aa733c404$var$FORGE_REF;
        if (transportSessionId) urlParams[$da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$da38ac6aa733c404$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$da38ac6aa733c404$var$APPLICATION_ID_PARAM] = applicationId;
        return $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, $da38ac6aa733c404$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $da38ac6aa733c404$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$da38ac6aa733c404$var$PROTOCOL_VERSION}/${$da38ac6aa733c404$var$SDK_VERSION}/${$cfae44f0dfdf62c0$exports.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $da38ac6aa733c404$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $da38ac6aa733c404$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $da38ac6aa733c404$var$WebSocketImpl !== null && !$da38ac6aa733c404$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $da38ac6aa733c404$var$PersistentStorage.isInMemoryStorage || $da38ac6aa733c404$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $da38ac6aa733c404$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $da38ac6aa733c404$var$splitStringBySize(dataStr, $da38ac6aa733c404$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($da38ac6aa733c404$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $da38ac6aa733c404$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $da38ac6aa733c404$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $da38ac6aa733c404$var$TransportManager {
    static get ALL_TRANSPORTS() {
        return [
            $da38ac6aa733c404$var$BrowserPollConnection,
            $da38ac6aa733c404$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $da38ac6aa733c404$var$WebSocketConnection && $da38ac6aa733c404$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$da38ac6aa733c404$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $da38ac6aa733c404$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $da38ac6aa733c404$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $da38ac6aa733c404$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $da38ac6aa733c404$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$da38ac6aa733c404$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $da38ac6aa733c404$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $da38ac6aa733c404$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $da38ac6aa733c404$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $da38ac6aa733c404$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $da38ac6aa733c404$var$MESSAGE_TYPE = 't';
const $da38ac6aa733c404$var$MESSAGE_DATA = 'd';
const $da38ac6aa733c404$var$CONTROL_SHUTDOWN = 's';
const $da38ac6aa733c404$var$CONTROL_RESET = 'r';
const $da38ac6aa733c404$var$CONTROL_ERROR = 'e';
const $da38ac6aa733c404$var$CONTROL_PONG = 'o';
const $da38ac6aa733c404$var$SWITCH_ACK = 'a';
const $da38ac6aa733c404$var$END_TRANSMISSION = 'n';
const $da38ac6aa733c404$var$PING = 'p';
const $da38ac6aa733c404$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $da38ac6aa733c404$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $da38ac6aa733c404$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $da38ac6aa733c404$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $da38ac6aa733c404$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $da38ac6aa733c404$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($da38ac6aa733c404$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$da38ac6aa733c404$var$MESSAGE_TYPE];
            if (cmd === $da38ac6aa733c404$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $da38ac6aa733c404$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $da38ac6aa733c404$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $da38ac6aa733c404$var$requireKey('t', parsedData);
        const data = $da38ac6aa733c404$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $da38ac6aa733c404$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $da38ac6aa733c404$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $da38ac6aa733c404$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $da38ac6aa733c404$var$requireKey('t', parsedData);
        const data = $da38ac6aa733c404$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $da38ac6aa733c404$var$requireKey($da38ac6aa733c404$var$MESSAGE_TYPE, controlData);
        if ($da38ac6aa733c404$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$da38ac6aa733c404$var$MESSAGE_DATA];
            if (cmd === $da38ac6aa733c404$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $da38ac6aa733c404$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $da38ac6aa733c404$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_ERROR) $da38ac6aa733c404$var$error('Server Error: ' + payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $da38ac6aa733c404$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($da38ac6aa733c404$var$PROTOCOL_VERSION !== version) $da38ac6aa733c404$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($da38ac6aa733c404$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($da38ac6aa733c404$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $da38ac6aa733c404$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $da38ac6aa733c404$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $da38ac6aa733c404$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $da38ac6aa733c404$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $da38ac6aa733c404$var$OnlineMonitor extends $da38ac6aa733c404$var$EventEmitter {
    static getInstance() {
        return new $da38ac6aa733c404$var$OnlineMonitor();
    }
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $c38e0f42709c826a$export$872f8323f01d7ae0)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    getInitialEvent(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $da38ac6aa733c404$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $da38ac6aa733c404$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $da38ac6aa733c404$var$newEmptyPath() {
    return new $da38ac6aa733c404$var$Path('');
}
function $da38ac6aa733c404$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $da38ac6aa733c404$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $da38ac6aa733c404$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $da38ac6aa733c404$var$Path(path.pieces_, pieceNum);
}
function $da38ac6aa733c404$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $da38ac6aa733c404$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $da38ac6aa733c404$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $da38ac6aa733c404$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $da38ac6aa733c404$var$Path(pieces, 0);
}
function $da38ac6aa733c404$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $da38ac6aa733c404$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $da38ac6aa733c404$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $da38ac6aa733c404$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $da38ac6aa733c404$var$newRelativePath(outerPath, innerPath) {
    const outer = $da38ac6aa733c404$var$pathGetFront(outerPath), inner = $da38ac6aa733c404$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $da38ac6aa733c404$var$newRelativePath($da38ac6aa733c404$var$pathPopFront(outerPath), $da38ac6aa733c404$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $da38ac6aa733c404$var$pathCompare(left, right) {
    const leftKeys = $da38ac6aa733c404$var$pathSlice(left, 0);
    const rightKeys = $da38ac6aa733c404$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $da38ac6aa733c404$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $da38ac6aa733c404$var$pathEquals(path, other) {
    if ($da38ac6aa733c404$var$pathGetLength(path) !== $da38ac6aa733c404$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $da38ac6aa733c404$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($da38ac6aa733c404$var$pathGetLength(path) > $da38ac6aa733c404$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $da38ac6aa733c404$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $da38ac6aa733c404$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(this.parts_[i]);
        $da38ac6aa733c404$var$validationPathCheckValid(this);
    }
}
function $da38ac6aa733c404$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(child);
    $da38ac6aa733c404$var$validationPathCheckValid(validationPath);
}
function $da38ac6aa733c404$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $da38ac6aa733c404$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $da38ac6aa733c404$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $da38ac6aa733c404$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $da38ac6aa733c404$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $da38ac6aa733c404$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$VisibilityMonitor extends $da38ac6aa733c404$var$EventEmitter {
    static getInstance() {
        return new $da38ac6aa733c404$var$VisibilityMonitor();
    }
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    getInitialEvent(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$RECONNECT_MIN_DELAY = 1000;
const $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $da38ac6aa733c404$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $da38ac6aa733c404$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $da38ac6aa733c404$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $da38ac6aa733c404$var$PersistentConnection extends $da38ac6aa733c404$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $da38ac6aa733c404$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $da38ac6aa733c404$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $da38ac6aa733c404$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $da38ac6aa733c404$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $c38e0f42709c826a$export$fac44ee5b035f737)(msg));
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $da38ac6aa733c404$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $c38e0f42709c826a$export$2344b14b097df817)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $da38ac6aa733c404$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $c38e0f42709c826a$export$fc970ed23da99565)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $c38e0f42709c826a$export$9565ca3d387f8aa0)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $da38ac6aa733c404$var$error('Unrecognized action received from server: ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $da38ac6aa733c404$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = Math.max(0, new Date().getTime() - this.lastConnectionAttemptTime_);
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $da38ac6aa733c404$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $da38ac6aa733c404$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $da38ac6aa733c404$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $da38ac6aa733c404$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $da38ac6aa733c404$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($da38ac6aa733c404$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $da38ac6aa733c404$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $da38ac6aa733c404$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $da38ac6aa733c404$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $da38ac6aa733c404$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$da38ac6aa733c404$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $da38ac6aa733c404$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $da38ac6aa733c404$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $da38ac6aa733c404$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $da38ac6aa733c404$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $c38e0f42709c826a$export$872f8323f01d7ae0)()) stats['framework.cordova'] = 1;
        else if ((0, $c38e0f42709c826a$export$f7a1e23e542d38e3)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $da38ac6aa733c404$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$da38ac6aa733c404$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $da38ac6aa733c404$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $da38ac6aa733c404$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, oldNode);
        const newWrapped = new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$__EMPTY_NODE;
class $da38ac6aa733c404$var$KeyIndex extends $da38ac6aa733c404$var$Index {
    static get __EMPTY_NODE() {
        return $da38ac6aa733c404$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $da38ac6aa733c404$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, $da38ac6aa733c404$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $da38ac6aa733c404$var$NamedNode(indexValue, $da38ac6aa733c404$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $da38ac6aa733c404$var$KEY_INDEX = new $da38ac6aa733c404$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $da38ac6aa733c404$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $da38ac6aa733c404$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $da38ac6aa733c404$var$LLRBNode.RED;
        this.left = left != null ? left : $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $da38ac6aa733c404$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $da38ac6aa733c404$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $da38ac6aa733c404$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$da38ac6aa733c404$var$LLRBNode.RED = true;
$da38ac6aa733c404$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $da38ac6aa733c404$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $da38ac6aa733c404$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $da38ac6aa733c404$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $da38ac6aa733c404$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $da38ac6aa733c404$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $da38ac6aa733c404$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $da38ac6aa733c404$var$SortedMap.EMPTY_NODE = new $da38ac6aa733c404$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$NAME_ONLY_COMPARATOR(left, right) {
    return $da38ac6aa733c404$var$nameCompare(left.name, right.name);
}
function $da38ac6aa733c404$var$NAME_COMPARATOR(left, right) {
    return $da38ac6aa733c404$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$MAX_NODE$2;
function $da38ac6aa733c404$var$setMaxNode$1(val) {
    $da38ac6aa733c404$var$MAX_NODE$2 = val;
}
const $da38ac6aa733c404$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $da38ac6aa733c404$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $da38ac6aa733c404$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $c38e0f42709c826a$export$2344b14b097df817)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $c38e0f42709c826a$export$a7a9523472993e97)(priorityNode === $da38ac6aa733c404$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(priorityNode === $da38ac6aa733c404$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $da38ac6aa733c404$var$LeafNode {
    static set __childrenNodeConstructor(val) {
        $da38ac6aa733c404$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $da38ac6aa733c404$var$__childrenNodeConstructor;
    }
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $da38ac6aa733c404$var$validatePriorityNode(this.priorityNode_);
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $da38ac6aa733c404$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($da38ac6aa733c404$var$pathIsEmpty(path)) return this;
        else if ($da38ac6aa733c404$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(front !== '.priority' || $da38ac6aa733c404$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($da38ac6aa733c404$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $da38ac6aa733c404$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $da38ac6aa733c404$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $da38ac6aa733c404$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$nodeFromJSON$1;
let $da38ac6aa733c404$var$MAX_NODE$1;
function $da38ac6aa733c404$var$setNodeFromJSON(val) {
    $da38ac6aa733c404$var$nodeFromJSON$1 = val;
}
function $da38ac6aa733c404$var$setMaxNode(val) {
    $da38ac6aa733c404$var$MAX_NODE$1 = val;
}
class $da38ac6aa733c404$var$PriorityIndex extends $da38ac6aa733c404$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, new $da38ac6aa733c404$var$LeafNode('[PRIORITY-POST]', $da38ac6aa733c404$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $da38ac6aa733c404$var$nodeFromJSON$1(indexValue);
        return new $da38ac6aa733c404$var$NamedNode(name, new $da38ac6aa733c404$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $da38ac6aa733c404$var$PRIORITY_INDEX = new $da38ac6aa733c404$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$LOG_2 = Math.log(2);
class $da38ac6aa733c404$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $da38ac6aa733c404$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $da38ac6aa733c404$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, $da38ac6aa733c404$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $da38ac6aa733c404$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $da38ac6aa733c404$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$_defaultIndexMap;
const $da38ac6aa733c404$var$fallbackObject = {};
class $da38ac6aa733c404$var$IndexMap {
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$fallbackObject && $da38ac6aa733c404$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $da38ac6aa733c404$var$_defaultIndexMap = $da38ac6aa733c404$var$_defaultIndexMap || new $da38ac6aa733c404$var$IndexMap({
            '.priority': $da38ac6aa733c404$var$fallbackObject
        }, {
            '.priority': $da38ac6aa733c404$var$PRIORITY_INDEX
        });
        return $da38ac6aa733c404$var$_defaultIndexMap;
    }
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    get(indexKey) {
        const sortedMap = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $da38ac6aa733c404$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $c38e0f42709c826a$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(indexDefinition !== $da38ac6aa733c404$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($da38ac6aa733c404$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $da38ac6aa733c404$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $da38ac6aa733c404$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $da38ac6aa733c404$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($da38ac6aa733c404$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $da38ac6aa733c404$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $da38ac6aa733c404$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $da38ac6aa733c404$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $da38ac6aa733c404$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $da38ac6aa733c404$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $da38ac6aa733c404$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $da38ac6aa733c404$var$ChildrenNode {
    static get EMPTY_NODE() {
        return $da38ac6aa733c404$var$EMPTY_NODE || ($da38ac6aa733c404$var$EMPTY_NODE = new $da38ac6aa733c404$var$ChildrenNode(new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$NAME_COMPARATOR), null, $da38ac6aa733c404$var$IndexMap.Default));
    }
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $da38ac6aa733c404$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $da38ac6aa733c404$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $da38ac6aa733c404$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $da38ac6aa733c404$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($da38ac6aa733c404$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $da38ac6aa733c404$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $da38ac6aa733c404$var$EMPTY_NODE : this.priorityNode_;
            return new $da38ac6aa733c404$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(path) !== '.priority' || $da38ac6aa733c404$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($da38ac6aa733c404$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $da38ac6aa733c404$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $da38ac6aa733c404$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $da38ac6aa733c404$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $da38ac6aa733c404$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $da38ac6aa733c404$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $da38ac6aa733c404$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $da38ac6aa733c404$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $da38ac6aa733c404$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $da38ac6aa733c404$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $da38ac6aa733c404$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $da38ac6aa733c404$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $da38ac6aa733c404$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($da38ac6aa733c404$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($da38ac6aa733c404$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $da38ac6aa733c404$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$da38ac6aa733c404$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $da38ac6aa733c404$var$MaxNode extends $da38ac6aa733c404$var$ChildrenNode {
    constructor(){
        super(new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$NAME_COMPARATOR), $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, $da38ac6aa733c404$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $da38ac6aa733c404$var$MAX_NODE = new $da38ac6aa733c404$var$MaxNode();
Object.defineProperties($da38ac6aa733c404$var$NamedNode, {
    MIN: {
        value: new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, $da38ac6aa733c404$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $da38ac6aa733c404$var$KeyIndex.__EMPTY_NODE = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
$da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor = $da38ac6aa733c404$var$ChildrenNode;
$da38ac6aa733c404$var$setMaxNode$1($da38ac6aa733c404$var$MAX_NODE);
$da38ac6aa733c404$var$setMaxNode($da38ac6aa733c404$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $da38ac6aa733c404$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $da38ac6aa733c404$var$LeafNode(jsonLeaf, $da38ac6aa733c404$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $da38ac6aa733c404$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $da38ac6aa733c404$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $da38ac6aa733c404$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $da38ac6aa733c404$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        const childSet = $da38ac6aa733c404$var$buildChildSet(children, $da38ac6aa733c404$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $da38ac6aa733c404$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $da38ac6aa733c404$var$buildChildSet(children, $da38ac6aa733c404$var$PRIORITY_INDEX.getCompare());
            return new $da38ac6aa733c404$var$ChildrenNode(childSet, $da38ac6aa733c404$var$nodeFromJSON(priority), new $da38ac6aa733c404$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $da38ac6aa733c404$var$PRIORITY_INDEX
            }));
        } else return new $da38ac6aa733c404$var$ChildrenNode(childSet, $da38ac6aa733c404$var$nodeFromJSON(priority), $da38ac6aa733c404$var$IndexMap.Default);
    } else {
        let node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        $da38ac6aa733c404$var$each(json, (key, childData)=>{
            if ((0, $c38e0f42709c826a$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $da38ac6aa733c404$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($da38ac6aa733c404$var$nodeFromJSON(priority));
    }
}
$da38ac6aa733c404$var$setNodeFromJSON($da38ac6aa733c404$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$PathIndex extends $da38ac6aa733c404$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$pathIsEmpty(indexPath_) && $da38ac6aa733c404$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $da38ac6aa733c404$var$nodeFromJSON(indexValue);
        const node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $da38ac6aa733c404$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $da38ac6aa733c404$var$MAX_NODE);
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, node);
    }
    toString() {
        return $da38ac6aa733c404$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ValueIndex extends $da38ac6aa733c404$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $da38ac6aa733c404$var$nodeFromJSON(indexValue);
        return new $da38ac6aa733c404$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $da38ac6aa733c404$var$VALUE_INDEX = new $da38ac6aa733c404$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $da38ac6aa733c404$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $da38ac6aa733c404$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $da38ac6aa733c404$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $da38ac6aa733c404$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $da38ac6aa733c404$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(key, oldChild));
                else (0, $c38e0f42709c826a$export$a7a9523472993e97)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $da38ac6aa733c404$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $da38ac6aa733c404$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $da38ac6aa733c404$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $da38ac6aa733c404$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $da38ac6aa733c404$var$NamedNode(key, newChild))) newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $da38ac6aa733c404$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $da38ac6aa733c404$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $da38ac6aa733c404$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $da38ac6aa733c404$var$NamedNode(key, newChild))) newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $da38ac6aa733c404$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $da38ac6aa733c404$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $da38ac6aa733c404$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $da38ac6aa733c404$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $da38ac6aa733c404$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $da38ac6aa733c404$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $da38ac6aa733c404$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $da38ac6aa733c404$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $da38ac6aa733c404$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $da38ac6aa733c404$var$LimitedFilter(queryParams);
    else return new $da38ac6aa733c404$var$RangedFilter(queryParams);
}
function $da38ac6aa733c404$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX || !!key) params = $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, $da38ac6aa733c404$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX || !!key) params = $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, $da38ac6aa733c404$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $da38ac6aa733c404$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $da38ac6aa733c404$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $da38ac6aa733c404$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(queryParams.index_ instanceof $da38ac6aa733c404$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $da38ac6aa733c404$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $da38ac6aa733c404$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $da38ac6aa733c404$var$ReadonlyRestClient extends $da38ac6aa733c404$var$ServerActions {
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $da38ac6aa733c404$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $da38ac6aa733c404$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $da38ac6aa733c404$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $c38e0f42709c826a$export$ac4103b836844853)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $da38ac6aa733c404$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $da38ac6aa733c404$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $da38ac6aa733c404$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $da38ac6aa733c404$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        $da38ac6aa733c404$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, tree)=>{
                    $da38ac6aa733c404$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $da38ac6aa733c404$var$Path(key), tree);
                });
                return $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $da38ac6aa733c404$var$pathGetFront(path);
            path = $da38ac6aa733c404$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $da38ac6aa733c404$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $da38ac6aa733c404$var$Path(prefixPath.toString() + '/' + key);
        $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $da38ac6aa733c404$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $da38ac6aa733c404$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME = 10000;
const $da38ac6aa733c404$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $da38ac6aa733c404$var$REPORT_STATS_INTERVAL = 300000;
class $da38ac6aa733c404$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $da38ac6aa733c404$var$StatsListener(collection);
        const timeout = $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME + ($da38ac6aa733c404$var$FIRST_STATS_MAX_TIME - $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME) * Math.random();
        $da38ac6aa733c404$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $da38ac6aa733c404$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $c38e0f42709c826a$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $da38ac6aa733c404$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $da38ac6aa733c404$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $da38ac6aa733c404$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($da38ac6aa733c404$var$OperationType || ($da38ac6aa733c404$var$OperationType = {}));
function $da38ac6aa733c404$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $da38ac6aa733c404$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $da38ac6aa733c404$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$da38ac6aa733c404$var$pathIsEmpty(this.path)) {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $da38ac6aa733c404$var$AckUserWrite($da38ac6aa733c404$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $da38ac6aa733c404$var$Path(childName));
            return new $da38ac6aa733c404$var$AckUserWrite($da38ac6aa733c404$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) return new $da38ac6aa733c404$var$ListenComplete(this.source, $da38ac6aa733c404$var$newEmptyPath());
        else return new $da38ac6aa733c404$var$ListenComplete(this.source, $da38ac6aa733c404$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $da38ac6aa733c404$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $da38ac6aa733c404$var$Merge(this.source, $da38ac6aa733c404$var$newEmptyPath(), childTree);
        } else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $da38ac6aa733c404$var$Merge(this.source, $da38ac6aa733c404$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $da38ac6aa733c404$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($da38ac6aa733c404$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $da38ac6aa733c404$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $da38ac6aa733c404$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $da38ac6aa733c404$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($da38ac6aa733c404$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$da38ac6aa733c404$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $da38ac6aa733c404$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $da38ac6aa733c404$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $da38ac6aa733c404$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('Should only compare child_ events.');
    const aWrapped = new $da38ac6aa733c404$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $da38ac6aa733c404$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $da38ac6aa733c404$var$newViewCache(new $da38ac6aa733c404$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $da38ac6aa733c404$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $da38ac6aa733c404$var$newViewCache(viewCache.eventCache, new $da38ac6aa733c404$var$CacheNode(serverSnap, complete, filtered));
}
function $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $da38ac6aa733c404$var$EmptyChildren = ()=>{
    if (!$da38ac6aa733c404$var$emptyChildrenSingleton) $da38ac6aa733c404$var$emptyChildrenSingleton = new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$stringCompare);
    return $da38ac6aa733c404$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $da38ac6aa733c404$var$ImmutableTree {
    static fromObject(obj) {
        let tree = new $da38ac6aa733c404$var$ImmutableTree(null);
        $da38ac6aa733c404$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $da38ac6aa733c404$var$Path(childPath), childSnap);
        });
        return tree;
    }
    constructor(value, children = $da38ac6aa733c404$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $da38ac6aa733c404$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($da38ac6aa733c404$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $da38ac6aa733c404$var$pathChild(new $da38ac6aa733c404$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($da38ac6aa733c404$var$pathPopFront(relativePath));
            else return new $da38ac6aa733c404$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return new $da38ac6aa733c404$var$ImmutableTree(toSet, this.children);
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $da38ac6aa733c404$var$ImmutableTree(null);
            const newChild = child.set($da38ac6aa733c404$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $da38ac6aa733c404$var$ImmutableTree(null);
            else return new $da38ac6aa733c404$var$ImmutableTree(null, this.children);
        } else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($da38ac6aa733c404$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $da38ac6aa733c404$var$ImmutableTree(null);
                else return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($da38ac6aa733c404$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $da38ac6aa733c404$var$ImmutableTree(null);
            const newChild = child.setTree($da38ac6aa733c404$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($da38ac6aa733c404$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($da38ac6aa733c404$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $da38ac6aa733c404$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($da38ac6aa733c404$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $da38ac6aa733c404$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($da38ac6aa733c404$var$pathPopFront(pathToFollow), $da38ac6aa733c404$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $da38ac6aa733c404$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($da38ac6aa733c404$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $da38ac6aa733c404$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($da38ac6aa733c404$var$pathPopFront(pathToFollow), $da38ac6aa733c404$var$pathChild(currentRelativePath, front), f);
            else return new $da38ac6aa733c404$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($da38ac6aa733c404$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($da38ac6aa733c404$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $da38ac6aa733c404$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(null));
    }
}
function $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $da38ac6aa733c404$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $da38ac6aa733c404$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $da38ac6aa733c404$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $da38ac6aa733c404$var$CompoundWrite(newWriteTree);
        }
    }
}
function $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $da38ac6aa733c404$var$each(updates, (childKey, node)=>{
        newWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(newWrite, $da38ac6aa733c404$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $da38ac6aa733c404$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return $da38ac6aa733c404$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $da38ac6aa733c404$var$ImmutableTree(null));
        return new $da38ac6aa733c404$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $da38ac6aa733c404$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($da38ac6aa733c404$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $da38ac6aa733c404$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $da38ac6aa733c404$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(shadowingNode));
        else return new $da38ac6aa733c404$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $da38ac6aa733c404$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $da38ac6aa733c404$var$compoundWriteApply(compoundWrite, node) {
    return $da38ac6aa733c404$var$applySubtreeWrite($da38ac6aa733c404$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $da38ac6aa733c404$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $da38ac6aa733c404$var$applySubtreeWrite($da38ac6aa733c404$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($da38ac6aa733c404$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $da38ac6aa733c404$var$writeTreeChildWrites(writeTree, path) {
    return $da38ac6aa733c404$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $da38ac6aa733c404$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $da38ac6aa733c404$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $da38ac6aa733c404$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $da38ac6aa733c404$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $da38ac6aa733c404$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($da38ac6aa733c404$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $da38ac6aa733c404$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $da38ac6aa733c404$var$each(children, (childName)=>{
                writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $da38ac6aa733c404$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $da38ac6aa733c404$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $da38ac6aa733c404$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $da38ac6aa733c404$var$pathContains($da38ac6aa733c404$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $da38ac6aa733c404$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $da38ac6aa733c404$var$writeTreeLayerTree_(writeTree.allWrites, $da38ac6aa733c404$var$writeTreeDefaultFilter_, $da38ac6aa733c404$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $da38ac6aa733c404$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $da38ac6aa733c404$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $da38ac6aa733c404$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($da38ac6aa733c404$var$pathContains(treeRoot, writePath)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($da38ac6aa733c404$var$pathContains(writePath, treeRoot)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($da38ac6aa733c404$var$pathContains(treeRoot, writePath)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($da38ac6aa733c404$var$pathContains(writePath, treeRoot)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(writePath, treeRoot);
                    if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(write.children, $da38ac6aa733c404$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($da38ac6aa733c404$var$pathPopFront(relativePath));
                            compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($da38ac6aa733c404$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$da38ac6aa733c404$var$compoundWriteHasCompleteWrite(subMerge, $da38ac6aa733c404$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                return $da38ac6aa733c404$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $da38ac6aa733c404$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$da38ac6aa733c404$var$compoundWriteHasCompleteWrite(merge, $da38ac6aa733c404$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($da38ac6aa733c404$var$pathContains(write.path, treePath) || $da38ac6aa733c404$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $da38ac6aa733c404$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                return $da38ac6aa733c404$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $da38ac6aa733c404$var$compoundWriteApply($da38ac6aa733c404$var$compoundWriteChildCompoundWrite(merge, new $da38ac6aa733c404$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $da38ac6aa733c404$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $da38ac6aa733c404$var$pathChild(treePath, childPath);
    if ($da38ac6aa733c404$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($da38ac6aa733c404$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $da38ac6aa733c404$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $da38ac6aa733c404$var$pathChild(treePath, childKey);
    const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $da38ac6aa733c404$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $da38ac6aa733c404$var$writeTreeShadowingWrite(writeTree, path) {
    return $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $da38ac6aa733c404$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(merge, $da38ac6aa733c404$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $da38ac6aa733c404$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $da38ac6aa733c404$var$newWriteTree() {
    return {
        visibleWrites: $da38ac6aa733c404$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $da38ac6aa733c404$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $da38ac6aa733c404$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $da38ac6aa733c404$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $da38ac6aa733c404$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $da38ac6aa733c404$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $da38ac6aa733c404$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $da38ac6aa733c404$var$writeTreeRefChild(writeTreeRef, childName) {
    return $da38ac6aa733c404$var$newWriteTreeRef($da38ac6aa733c404$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $da38ac6aa733c404$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $da38ac6aa733c404$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE = new $da38ac6aa733c404$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $da38ac6aa733c404$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $da38ac6aa733c404$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $da38ac6aa733c404$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $da38ac6aa733c404$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $da38ac6aa733c404$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $da38ac6aa733c404$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $da38ac6aa733c404$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$da38ac6aa733c404$var$pathIsEmpty(overwrite.path);
            newViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $da38ac6aa733c404$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $da38ac6aa733c404$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.LISTEN_COMPLETE) newViewCache = $da38ac6aa733c404$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $da38ac6aa733c404$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $da38ac6aa733c404$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($da38ac6aa733c404$var$changeValue($da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $da38ac6aa733c404$var$ChildrenNode ? serverCache : $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $da38ac6aa733c404$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $da38ac6aa733c404$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($da38ac6aa733c404$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($da38ac6aa733c404$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($da38ac6aa733c404$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $da38ac6aa733c404$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $da38ac6aa733c404$var$pathChild(path, relativePath);
        if ($da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, $da38ac6aa733c404$var$pathGetFront(writePath))) curViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $da38ac6aa733c404$var$pathChild(path, relativePath);
        if (!$da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, $da38ac6aa733c404$var$pathGetFront(writePath))) curViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $da38ac6aa733c404$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $da38ac6aa733c404$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $da38ac6aa733c404$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $da38ac6aa733c404$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($da38ac6aa733c404$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($da38ac6aa733c404$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $da38ac6aa733c404$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($da38ac6aa733c404$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $da38ac6aa733c404$var$Path(name), node);
            });
            return $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $da38ac6aa733c404$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $da38ac6aa733c404$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $da38ac6aa733c404$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $da38ac6aa733c404$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $da38ac6aa733c404$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($da38ac6aa733c404$var$pathIsEmpty(path) || $da38ac6aa733c404$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(serverChildren instanceof $da38ac6aa733c404$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $da38ac6aa733c404$var$pathGetFront(path);
            let newChild = $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $da38ac6aa733c404$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, $da38ac6aa733c404$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, $da38ac6aa733c404$var$newEmptyPath()) != null;
        return $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $da38ac6aa733c404$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $da38ac6aa733c404$var$IndexedFilter(params.getIndex());
        const filter = $da38ac6aa733c404$var$queryParamsGetNodeFilter(params);
        this.processor_ = $da38ac6aa733c404$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $da38ac6aa733c404$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $da38ac6aa733c404$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $da38ac6aa733c404$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $da38ac6aa733c404$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $da38ac6aa733c404$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $da38ac6aa733c404$var$viewGetCompleteNode(view) {
    return $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $da38ac6aa733c404$var$viewGetCompleteServerCache(view, path) {
    const cache = $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$da38ac6aa733c404$var$pathIsEmpty(path) && !cache.getImmediateChild($da38ac6aa733c404$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $da38ac6aa733c404$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $da38ac6aa733c404$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $da38ac6aa733c404$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $da38ac6aa733c404$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $da38ac6aa733c404$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $da38ac6aa733c404$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($da38ac6aa733c404$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($da38ac6aa733c404$var$changeValue(eventSnap.getNode()));
    return $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $da38ac6aa733c404$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $da38ac6aa733c404$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $da38ac6aa733c404$var$syncPointSetReferenceConstructor(val) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $da38ac6aa733c404$var$referenceConstructor$1 = val;
}
function $da38ac6aa733c404$var$syncPointGetReferenceConstructor() {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $da38ac6aa733c404$var$referenceConstructor$1;
}
function $da38ac6aa733c404$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $da38ac6aa733c404$var$ChildrenNode) {
            eventCache = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $da38ac6aa733c404$var$newViewCache(new $da38ac6aa733c404$var$CacheNode(eventCache, eventCacheComplete, false), new $da38ac6aa733c404$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $da38ac6aa733c404$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $da38ac6aa733c404$var$viewAddEventRegistration(view, eventRegistration);
    return $da38ac6aa733c404$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $da38ac6aa733c404$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($da38ac6aa733c404$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($da38ac6aa733c404$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($da38ac6aa733c404$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $da38ac6aa733c404$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $da38ac6aa733c404$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $da38ac6aa733c404$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint) {
    return $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint) != null;
}
function $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$referenceConstructor;
function $da38ac6aa733c404$var$syncTreeSetReferenceConstructor(val) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$referenceConstructor, '__referenceConstructor has already been defined');
    $da38ac6aa733c404$var$referenceConstructor = val;
}
function $da38ac6aa733c404$var$syncTreeGetReferenceConstructor() {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $da38ac6aa733c404$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $da38ac6aa733c404$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $da38ac6aa733c404$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $da38ac6aa733c404$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $da38ac6aa733c404$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $da38ac6aa733c404$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $da38ac6aa733c404$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $da38ac6aa733c404$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $da38ac6aa733c404$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $da38ac6aa733c404$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($da38ac6aa733c404$var$newEmptyPath(), true);
        else $da38ac6aa733c404$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $da38ac6aa733c404$var$Path(pathString), true);
        });
        return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyListenComplete(syncTree, path) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$ListenComplete($da38ac6aa733c404$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const op = new $da38ac6aa733c404$var$ListenComplete($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $da38ac6aa733c404$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $da38ac6aa733c404$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($da38ac6aa733c404$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$da38ac6aa733c404$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $da38ac6aa733c404$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($da38ac6aa733c404$var$syncTreeQueryForListening_(newQuery), $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($da38ac6aa733c404$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $da38ac6aa733c404$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const op = new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
        const op = new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $da38ac6aa733c404$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $da38ac6aa733c404$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(childSyncPoint, $da38ac6aa733c404$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $da38ac6aa733c404$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $da38ac6aa733c404$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $da38ac6aa733c404$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($da38ac6aa733c404$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathSoFar, path);
        const serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $da38ac6aa733c404$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $da38ac6aa733c404$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $da38ac6aa733c404$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $da38ac6aa733c404$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $da38ac6aa733c404$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($da38ac6aa733c404$var$pathIsEmpty(operation.path)) return $da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($da38ac6aa733c404$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
        let events = [];
        const childName = $da38ac6aa733c404$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $da38ac6aa733c404$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($da38ac6aa733c404$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($da38ac6aa733c404$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $da38ac6aa733c404$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $da38ac6aa733c404$var$viewGetServerCache(view) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $da38ac6aa733c404$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $da38ac6aa733c404$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $da38ac6aa733c404$var$errorForServerCode(status, query);
                return $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $da38ac6aa733c404$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $da38ac6aa733c404$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $da38ac6aa733c404$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $da38ac6aa733c404$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $da38ac6aa733c404$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $da38ac6aa733c404$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $da38ac6aa733c404$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($da38ac6aa733c404$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $da38ac6aa733c404$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $da38ac6aa733c404$var$syncTreeGetNextQueryTag_() {
    return $da38ac6aa733c404$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $da38ac6aa733c404$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, query);
    const listener = $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($da38ac6aa733c404$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$da38ac6aa733c404$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $da38ac6aa733c404$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $da38ac6aa733c404$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($da38ac6aa733c404$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $da38ac6aa733c404$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(queryToStop), $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $da38ac6aa733c404$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $da38ac6aa733c404$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $da38ac6aa733c404$var$pathChild(this.path_, childName);
        return new $da38ac6aa733c404$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $da38ac6aa733c404$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $da38ac6aa733c404$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $c38e0f42709c826a$export$a7a9523472993e97)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $da38ac6aa733c404$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $da38ac6aa733c404$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $da38ac6aa733c404$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected server value: ' + op);
    }
};
const $da38ac6aa733c404$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $da38ac6aa733c404$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $da38ac6aa733c404$var$resolveDeferredValue(node, new $da38ac6aa733c404$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $da38ac6aa733c404$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $da38ac6aa733c404$var$resolveDeferredValue(node, new $da38ac6aa733c404$var$ExistingValueProvider(existing), serverValues);
};
function $da38ac6aa733c404$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $da38ac6aa733c404$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $da38ac6aa733c404$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $da38ac6aa733c404$var$LeafNode(value, $da38ac6aa733c404$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $da38ac6aa733c404$var$LeafNode(priority));
        childrenNode.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $da38ac6aa733c404$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $da38ac6aa733c404$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $da38ac6aa733c404$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $da38ac6aa733c404$var$Path ? pathObj : new $da38ac6aa733c404$var$Path(pathObj);
    let child = tree, next = $da38ac6aa733c404$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $da38ac6aa733c404$var$Tree(next, child, childNode);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        next = $da38ac6aa733c404$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $da38ac6aa733c404$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $da38ac6aa733c404$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $da38ac6aa733c404$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $da38ac6aa733c404$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $da38ac6aa733c404$var$treeIsEmpty(tree) {
    return $da38ac6aa733c404$var$treeGetValue(tree) === undefined && !$da38ac6aa733c404$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $da38ac6aa733c404$var$treeForEachChild(tree, action) {
    $da38ac6aa733c404$var$each(tree.node.children, (child, childTree)=>{
        action(new $da38ac6aa733c404$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $da38ac6aa733c404$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $da38ac6aa733c404$var$treeForEachChild(tree, (child)=>{
        $da38ac6aa733c404$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $da38ac6aa733c404$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $da38ac6aa733c404$var$treeGetPath(tree) {
    return new $da38ac6aa733c404$var$Path(tree.parent === null ? tree.name : $da38ac6aa733c404$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $da38ac6aa733c404$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $da38ac6aa733c404$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $da38ac6aa733c404$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $da38ac6aa733c404$var$treeIsEmpty(child);
    const childExists = (0, $c38e0f42709c826a$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $da38ac6aa733c404$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $da38ac6aa733c404$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $da38ac6aa733c404$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $da38ac6aa733c404$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $da38ac6aa733c404$var$MAX_LEAF_SIZE_ = 10485760;
const $da38ac6aa733c404$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$da38ac6aa733c404$var$INVALID_KEY_REGEX_.test(key);
};
const $da38ac6aa733c404$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$da38ac6aa733c404$var$INVALID_PATH_REGEX_.test(pathString);
};
const $da38ac6aa733c404$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $da38ac6aa733c404$var$isValidPathString(pathString);
};
const $da38ac6aa733c404$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$da38ac6aa733c404$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $c38e0f42709c826a$export$2344b14b097df817)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $da38ac6aa733c404$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $da38ac6aa733c404$var$validateFirebaseData((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $da38ac6aa733c404$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $da38ac6aa733c404$var$Path ? new $da38ac6aa733c404$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $da38ac6aa733c404$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($da38ac6aa733c404$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $da38ac6aa733c404$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $da38ac6aa733c404$var$MAX_LEAF_SIZE_ / 3 && (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(data) > $da38ac6aa733c404$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $da38ac6aa733c404$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $da38ac6aa733c404$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$da38ac6aa733c404$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $da38ac6aa733c404$var$validationPathPush(path, key);
            $da38ac6aa733c404$var$validateFirebaseData(errorPrefix, value, path);
            $da38ac6aa733c404$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $da38ac6aa733c404$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $da38ac6aa733c404$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$da38ac6aa733c404$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($da38ac6aa733c404$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $da38ac6aa733c404$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $da38ac6aa733c404$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $da38ac6aa733c404$var$each(data, (key, value)=>{
        const curPath = new $da38ac6aa733c404$var$Path(key);
        $da38ac6aa733c404$var$validateFirebaseData(errorPrefix$1, value, $da38ac6aa733c404$var$pathChild(path, curPath));
        if ($da38ac6aa733c404$var$pathGetBack(curPath) === '.priority') {
            if (!$da38ac6aa733c404$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $da38ac6aa733c404$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $da38ac6aa733c404$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($da38ac6aa733c404$var$isInvalidJSONNumber(priority)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$da38ac6aa733c404$var$isValidPriority(priority)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $da38ac6aa733c404$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$da38ac6aa733c404$var$isValidKey(key)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $da38ac6aa733c404$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$da38ac6aa733c404$var$isValidPathString(pathString)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $da38ac6aa733c404$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $da38ac6aa733c404$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $da38ac6aa733c404$export$8d83036122ae444e = function(fnName, path) {
    if ($da38ac6aa733c404$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $da38ac6aa733c404$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$da38ac6aa733c404$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$da38ac6aa733c404$var$isValidRootPathString(pathString)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $da38ac6aa733c404$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$da38ac6aa733c404$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$da38ac6aa733c404$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$da38ac6aa733c404$var$pathContains(eventPath, changedPath) || $da38ac6aa733c404$var$pathContains(changedPath, eventPath));
}
function $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $da38ac6aa733c404$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $da38ac6aa733c404$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($da38ac6aa733c404$var$logger) $da38ac6aa733c404$var$log('event: ' + eventData.toString());
            $da38ac6aa733c404$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $da38ac6aa733c404$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $da38ac6aa733c404$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $da38ac6aa733c404$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $da38ac6aa733c404$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $da38ac6aa733c404$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $da38ac6aa733c404$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $da38ac6aa733c404$var$beingCrawled()) {
        repo.server_ = new $da38ac6aa733c404$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$da38ac6aa733c404$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $c38e0f42709c826a$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $da38ac6aa733c404$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $da38ac6aa733c404$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $da38ac6aa733c404$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $da38ac6aa733c404$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $da38ac6aa733c404$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $da38ac6aa733c404$var$SnapshotHolder();
    repo.infoSyncTree_ = new $da38ac6aa733c404$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $da38ac6aa733c404$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $da38ac6aa733c404$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $da38ac6aa733c404$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $da38ac6aa733c404$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $da38ac6aa733c404$var$repoGenerateServerValues(repo) {
    return $da38ac6aa733c404$var$generateWithValues({
        timestamp: $da38ac6aa733c404$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $da38ac6aa733c404$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(data, (raw)=>$da38ac6aa733c404$var$nodeFromJSON(raw));
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $da38ac6aa733c404$var$nodeFromJSON(data);
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(data, (raw)=>$da38ac6aa733c404$var$nodeFromJSON(raw));
        events = $da38ac6aa733c404$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $da38ac6aa733c404$var$nodeFromJSON(data);
        events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $da38ac6aa733c404$var$repoRerunTransactions(repo, path);
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $da38ac6aa733c404$var$repoOnConnectStatus(repo, connectStatus) {
    $da38ac6aa733c404$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $da38ac6aa733c404$var$repoRunOnDisconnectEvents(repo);
}
function $da38ac6aa733c404$var$repoOnServerInfoUpdate(repo, updates) {
    $da38ac6aa733c404$var$each(updates, (key, value)=>{
        $da38ac6aa733c404$var$repoUpdateInfo(repo, key, value);
    });
}
function $da38ac6aa733c404$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $da38ac6aa733c404$var$Path('/.info/' + pathString);
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $da38ac6aa733c404$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $da38ac6aa733c404$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $da38ac6aa733c404$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $da38ac6aa733c404$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $da38ac6aa733c404$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $da38ac6aa733c404$var$repoLog(repo, 'get for query ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $da38ac6aa733c404$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $da38ac6aa733c404$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $da38ac6aa733c404$var$nodeFromJSON(newVal, newPriority);
    const existing = $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
    const events = $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $da38ac6aa733c404$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $da38ac6aa733c404$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, path);
    $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $da38ac6aa733c404$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $da38ac6aa733c404$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $da38ac6aa733c404$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $da38ac6aa733c404$var$resolveDeferredValueTree($da38ac6aa733c404$var$pathChild(path, changedKey), $da38ac6aa733c404$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
        const events = $da38ac6aa733c404$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $da38ac6aa733c404$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $da38ac6aa733c404$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $da38ac6aa733c404$var$repoRerunTransactions(repo, path) : path;
            $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $da38ac6aa733c404$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, $da38ac6aa733c404$var$pathChild(path, changedPath));
            $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $da38ac6aa733c404$var$log("update() called with empty data.  Don't do anything.");
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $da38ac6aa733c404$var$repoRunOnDisconnectEvents(repo) {
    $da38ac6aa733c404$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $da38ac6aa733c404$var$newSparseSnapshotTree();
    $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $da38ac6aa733c404$var$newEmptyPath(), (path, node)=>{
        const resolved = $da38ac6aa733c404$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $da38ac6aa733c404$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $da38ac6aa733c404$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, path);
        $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $da38ac6aa733c404$var$newSparseSnapshotTree();
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $da38ac6aa733c404$var$newEmptyPath(), events);
}
function $da38ac6aa733c404$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $da38ac6aa733c404$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $da38ac6aa733c404$var$nodeFromJSON(childNode);
            $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $da38ac6aa733c404$var$pathChild(path, childName), newChildNode);
        });
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($da38ac6aa733c404$var$pathGetFront(query._path) === '.info') events = $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($da38ac6aa733c404$var$pathGetFront(query._path) === '.info') events = $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $da38ac6aa733c404$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($da38ac6aa733c404$var$INTERRUPT_REASON);
}
function $da38ac6aa733c404$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($da38ac6aa733c404$var$INTERRUPT_REASON);
}
function $da38ac6aa733c404$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $da38ac6aa733c404$var$log(prefix, ...varArgs);
}
function $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $da38ac6aa733c404$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $da38ac6aa733c404$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $da38ac6aa733c404$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $da38ac6aa733c404$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $da38ac6aa733c404$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $da38ac6aa733c404$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $da38ac6aa733c404$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $da38ac6aa733c404$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $c38e0f42709c826a$export$2344b14b097df817)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(newVal, '.priority');
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $da38ac6aa733c404$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
        const events = $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $da38ac6aa733c404$var$repoGetLatestState(repo, path, excludeSets) {
    return $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $da38ac6aa733c404$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($da38ac6aa733c404$var$treeGetValue(node)) {
        const queue = $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, node);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $da38ac6aa733c404$var$repoSendTransactionQueue(repo, $da38ac6aa733c404$var$treeGetPath(node), queue);
    } else if ($da38ac6aa733c404$var$treeHasChildren(node)) $da38ac6aa733c404$var$treeForEachChild(node, (childNode)=>{
        $da38ac6aa733c404$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $da38ac6aa733c404$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $da38ac6aa733c404$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $da38ac6aa733c404$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $da38ac6aa733c404$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $da38ac6aa733c404$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $da38ac6aa733c404$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $da38ac6aa733c404$var$treeGetPath(rootMostTransactionNode);
    const queue = $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $da38ac6aa733c404$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $da38ac6aa733c404$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $da38ac6aa733c404$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $da38ac6aa733c404$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $da38ac6aa733c404$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $da38ac6aa733c404$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $da38ac6aa733c404$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $c38e0f42709c826a$export$2344b14b097df817)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $da38ac6aa733c404$var$pathGetFront(path);
    while(front !== null && $da38ac6aa733c404$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $da38ac6aa733c404$var$treeSubTree(transactionNode, front);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        front = $da38ac6aa733c404$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $da38ac6aa733c404$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $da38ac6aa733c404$var$treeForEachChild(node, (child)=>{
        $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $da38ac6aa733c404$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $da38ac6aa733c404$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $da38ac6aa733c404$var$treeForEachChild(node, (childNode)=>{
        $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $da38ac6aa733c404$var$repoAbortTransactions(repo, path) {
    const affectedPath = $da38ac6aa733c404$var$treeGetPath($da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path);
    $da38ac6aa733c404$var$treeForEachAncestor(transactionNode, (node)=>{
        $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node);
    });
    $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $da38ac6aa733c404$var$treeForEachDescendant(transactionNode, (node)=>{
        $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $da38ac6aa733c404$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $da38ac6aa733c404$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $da38ac6aa733c404$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $da38ac6aa733c404$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $da38ac6aa733c404$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $da38ac6aa733c404$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $da38ac6aa733c404$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $da38ac6aa733c404$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $da38ac6aa733c404$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $da38ac6aa733c404$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $da38ac6aa733c404$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $da38ac6aa733c404$var$Path(parsedUrl.pathString)
    };
};
const $da38ac6aa733c404$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $da38ac6aa733c404$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $da38ac6aa733c404$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $da38ac6aa733c404$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $da38ac6aa733c404$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $da38ac6aa733c404$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $da38ac6aa733c404$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $da38ac6aa733c404$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $da38ac6aa733c404$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $da38ac6aa733c404$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $da38ac6aa733c404$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $da38ac6aa733c404$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $da38ac6aa733c404$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $da38ac6aa733c404$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $da38ac6aa733c404$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $da38ac6aa733c404$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($da38ac6aa733c404$var$pathIsEmpty(this._path)) return null;
        else return $da38ac6aa733c404$var$pathGetBack(this._path);
    }
    get ref() {
        return new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $da38ac6aa733c404$var$queryParamsGetQueryObject(this._queryParams);
        const id = $da38ac6aa733c404$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $da38ac6aa733c404$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $da38ac6aa733c404$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $da38ac6aa733c404$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $da38ac6aa733c404$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $da38ac6aa733c404$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $da38ac6aa733c404$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $da38ac6aa733c404$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $da38ac6aa733c404$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $da38ac6aa733c404$var$PRIORITY_INDEX) {
        if (startNode != null && !$da38ac6aa733c404$var$isValidPriority(startNode) || endNode != null && !$da38ac6aa733c404$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(params.getIndex() instanceof $da38ac6aa733c404$var$PathIndex || params.getIndex() === $da38ac6aa733c404$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $da38ac6aa733c404$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $da38ac6aa733c404$export$35c3a5e7c9d1033c extends $da38ac6aa733c404$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $da38ac6aa733c404$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $da38ac6aa733c404$var$pathParent(this._path);
        return parentPath === null ? null : new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $da38ac6aa733c404$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $da38ac6aa733c404$var$Path(path);
        const childRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(this.ref, path);
        return new $da38ac6aa733c404$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $da38ac6aa733c404$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $da38ac6aa733c404$export$80b98bcbc246c942(node, $da38ac6aa733c404$export$f9574b70e1d95d9d(this.ref, key), $da38ac6aa733c404$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $da38ac6aa733c404$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $da38ac6aa733c404$export$eff4d24c3ff7876e(db, path) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $da38ac6aa733c404$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $da38ac6aa733c404$export$291fc3c05735451(db, url) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $da38ac6aa733c404$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $da38ac6aa733c404$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $da38ac6aa733c404$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $da38ac6aa733c404$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(parent);
    if ($da38ac6aa733c404$var$pathGetFront(parent._path) === null) $da38ac6aa733c404$var$validateRootPathString('child', 'path', path, false);
    else $da38ac6aa733c404$export$8637b026ace8abb1('child', 'path', path, false);
    return new $da38ac6aa733c404$export$35c3a5e7c9d1033c(parent._repo, $da38ac6aa733c404$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $da38ac6aa733c404$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return new $da38ac6aa733c404$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $da38ac6aa733c404$export$4cbf152802aa238(parent, value) {
    parent = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(parent);
    $da38ac6aa733c404$export$8d83036122ae444e('push', parent._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $da38ac6aa733c404$var$repoServerTime(parent._repo);
    const name = $da38ac6aa733c404$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $da38ac6aa733c404$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $da38ac6aa733c404$export$cd7f480d6b8286c3(ref) {
    $da38ac6aa733c404$export$8d83036122ae444e('remove', ref._path);
    return $da38ac6aa733c404$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e('set', ref._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e('setPriority', ref._path);
    $da38ac6aa733c404$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, $da38ac6aa733c404$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$1fa5d5bf488088f3(ref, value, priority) {
    $da38ac6aa733c404$export$8d83036122ae444e('setWithPriority', ref._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $da38ac6aa733c404$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $da38ac6aa733c404$export$722fbec263ad908a(ref, values) {
    $da38ac6aa733c404$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $da38ac6aa733c404$export$3988ae62b71be9a3(query) {
    query = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $da38ac6aa733c404$var$CallbackContext(()=>{});
    const container = new $da38ac6aa733c404$var$ValueEventRegistration(callbackContext);
    return $da38ac6aa733c404$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $da38ac6aa733c404$export$80b98bcbc246c942(node, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $da38ac6aa733c404$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $da38ac6aa733c404$var$DataEvent('value', this, new $da38ac6aa733c404$export$80b98bcbc246c942(change.snapshotNode, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $da38ac6aa733c404$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $da38ac6aa733c404$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $da38ac6aa733c404$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $da38ac6aa733c404$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(change.childName != null, 'Child events should have a childName.');
        const childRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $da38ac6aa733c404$var$DataEvent(change.type, this, new $da38ac6aa733c404$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $da38ac6aa733c404$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $da38ac6aa733c404$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $da38ac6aa733c404$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $da38ac6aa733c404$var$ValueEventRegistration(callbackContext) : new $da38ac6aa733c404$var$ChildEventRegistration(eventType, callbackContext);
    $da38ac6aa733c404$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $da38ac6aa733c404$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $da38ac6aa733c404$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $da38ac6aa733c404$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $da38ac6aa733c404$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $da38ac6aa733c404$var$ChildEventRegistration(eventType, expCallback);
    $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $da38ac6aa733c404$export$b0e86f2c7431df4e {
}
class $da38ac6aa733c404$var$QueryEndAtConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $da38ac6aa733c404$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $da38ac6aa733c404$export$28ec54a8428bdb3f(value, key) {
    $da38ac6aa733c404$var$validateKey('endAt', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryEndAtConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryEndBeforeConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $da38ac6aa733c404$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $da38ac6aa733c404$export$57203950645b8b11(value, key) {
    $da38ac6aa733c404$var$validateKey('endBefore', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryEndBeforeConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryStartAtConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $da38ac6aa733c404$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $da38ac6aa733c404$export$859941c5fc8eba6b(value = null, key) {
    $da38ac6aa733c404$var$validateKey('startAt', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryStartAtConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryStartAfterConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $da38ac6aa733c404$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $da38ac6aa733c404$export$dd8dee5f7b804673(value, key) {
    $da38ac6aa733c404$var$validateKey('startAfter', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryStartAfterConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryLimitToFirstConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, $da38ac6aa733c404$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $da38ac6aa733c404$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $da38ac6aa733c404$var$QueryLimitToFirstConstraint(limit);
}
class $da38ac6aa733c404$var$QueryLimitToLastConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, $da38ac6aa733c404$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $da38ac6aa733c404$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $da38ac6aa733c404$var$QueryLimitToLastConstraint(limit);
}
class $da38ac6aa733c404$var$QueryOrderByChildConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $da38ac6aa733c404$var$Path(this._path);
        if ($da38ac6aa733c404$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $da38ac6aa733c404$var$PathIndex(parsedPath);
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, index);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $da38ac6aa733c404$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $da38ac6aa733c404$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $da38ac6aa733c404$var$QueryOrderByChildConstraint(path);
}
class $da38ac6aa733c404$var$QueryOrderByKeyConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$KEY_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $da38ac6aa733c404$export$d5ab8b3bbd8afbf8() {
    return new $da38ac6aa733c404$var$QueryOrderByKeyConstraint();
}
class $da38ac6aa733c404$var$QueryOrderByPriorityConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$PRIORITY_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $da38ac6aa733c404$export$19e8ae5500cf2e55() {
    return new $da38ac6aa733c404$var$QueryOrderByPriorityConstraint();
}
class $da38ac6aa733c404$var$QueryOrderByValueConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$VALUE_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $da38ac6aa733c404$export$7f2f62793c39d0c0() {
    return new $da38ac6aa733c404$var$QueryOrderByValueConstraint();
}
class $da38ac6aa733c404$var$QueryEqualToValueConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $da38ac6aa733c404$var$QueryEndAtConstraint(this._value, this._key)._apply(new $da38ac6aa733c404$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $da38ac6aa733c404$export$bdcdec1f91f16dff(value, key) {
    $da38ac6aa733c404$var$validateKey('equalTo', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $da38ac6aa733c404$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $da38ac6aa733c404$var$syncPointSetReferenceConstructor($da38ac6aa733c404$export$35c3a5e7c9d1033c);
$da38ac6aa733c404$var$syncTreeSetReferenceConstructor($da38ac6aa733c404$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $da38ac6aa733c404$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $da38ac6aa733c404$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $da38ac6aa733c404$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $da38ac6aa733c404$var$repoManagerApplyEmulatorSettings(repo, hostAndPort, emulatorOptions, tokenProvider) {
    repo.repoInfo_ = new $da38ac6aa733c404$var$RepoInfo(hostAndPort, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true, emulatorOptions);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $da38ac6aa733c404$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $da38ac6aa733c404$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $da38ac6aa733c404$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $cfae44f0dfdf62c0$exports !== 'undefined' && $cfae44f0dfdf62c0$exports.env) dbEmulatorHost = $cfae44f0dfdf62c0$exports.env[$da38ac6aa733c404$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $da38ac6aa733c404$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $da38ac6aa733c404$var$EmulatorTokenProvider($da38ac6aa733c404$var$EmulatorTokenProvider.OWNER) : new $da38ac6aa733c404$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $da38ac6aa733c404$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$da38ac6aa733c404$var$pathIsEmpty(parsedUrl.path)) $da38ac6aa733c404$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $da38ac6aa733c404$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $da38ac6aa733c404$var$AppCheckTokenProvider(app, appCheckProvider));
    return new $da38ac6aa733c404$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $da38ac6aa733c404$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $da38ac6aa733c404$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $da38ac6aa733c404$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $da38ac6aa733c404$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $da38ac6aa733c404$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $da38ac6aa733c404$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $da38ac6aa733c404$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $da38ac6aa733c404$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $da38ac6aa733c404$var$Repo(repoInfo, $da38ac6aa733c404$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $da38ac6aa733c404$var$repoManagerForceRestClient(forceRestClient) {
    $da38ac6aa733c404$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $da38ac6aa733c404$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $da38ac6aa733c404$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, $da38ac6aa733c404$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $da38ac6aa733c404$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $da38ac6aa733c404$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $da38ac6aa733c404$var$checkTransportInit() {
    if ($da38ac6aa733c404$var$TransportManager.IS_TRANSPORT_INITIALIZED) $da38ac6aa733c404$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $da38ac6aa733c404$export$752b38c15a5377b6() {
    $da38ac6aa733c404$var$checkTransportInit();
    $da38ac6aa733c404$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $da38ac6aa733c404$export$387cff57f2608869() {
    $da38ac6aa733c404$var$checkTransportInit();
    $da38ac6aa733c404$var$WebSocketConnection.forceDisallow();
    $da38ac6aa733c404$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $da38ac6aa733c404$export$d0dd861204d0bf72(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), url) {
    const db = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)('database');
        if (emulator) $da38ac6aa733c404$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $da38ac6aa733c404$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('useEmulator');
    const hostAndPort = `${host}:${port}`;
    const repo = db._repoInternal;
    if (db._instanceStarted) {
        // If the instance has already been started, then silenty fail if this function is called again
        // with the same parameters. If the parameters differ then assert.
        if (hostAndPort === db._repoInternal.repoInfo_.host && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, repo.repoInfo_.emulatorOptions)) return;
        $da38ac6aa733c404$var$fatal('connectDatabaseEmulator() cannot initialize or alter the emulator configuration after the database instance has started.');
    }
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $da38ac6aa733c404$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $da38ac6aa733c404$var$EmulatorTokenProvider($da38ac6aa733c404$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $c38e0f42709c826a$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $da38ac6aa733c404$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $da38ac6aa733c404$var$repoManagerApplyEmulatorSettings(repo, hostAndPort, options, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $da38ac6aa733c404$export$bee838355d017f0a(db) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOffline');
    $da38ac6aa733c404$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $da38ac6aa733c404$export$e0eecaabee32dd(db) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOnline');
    $da38ac6aa733c404$var$repoResume(db._repo);
}
function $da38ac6aa733c404$export$4e1d237eb9e560af(logger, persistent) {
    $da38ac6aa733c404$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$registerDatabase(variant) {
    $da38ac6aa733c404$export$c9fb972242fcb3c4((0, $57d436074e210fb5$export$31499a9cd224b78c));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($da38ac6aa733c404$var$name, $da38ac6aa733c404$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($da38ac6aa733c404$var$name, $da38ac6aa733c404$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $da38ac6aa733c404$export$3ff8e7e00c3264b7() {
    return $da38ac6aa733c404$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $da38ac6aa733c404$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $da38ac6aa733c404$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $da38ac6aa733c404$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $da38ac6aa733c404$export$80b98bcbc246c942(node, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(ref._repo, ref._path), $da38ac6aa733c404$var$PRIORITY_INDEX);
            deferred.resolve(new $da38ac6aa733c404$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $da38ac6aa733c404$export$ad30f661f41f4d90(ref, ()=>{});
    $da38ac6aa733c404$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $da38ac6aa733c404$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$da38ac6aa733c404$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$da38ac6aa733c404$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$da38ac6aa733c404$var$Connection;
/**
 * @internal
 */ const $da38ac6aa733c404$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $da38ac6aa733c404$var$PersistentConnection.prototype.put;
    $da38ac6aa733c404$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $da38ac6aa733c404$var$PersistentConnection.prototype.put = oldPut;
    };
};
$da38ac6aa733c404$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $da38ac6aa733c404$export$868c9f20a76f0839 = function(forceRestClient) {
    $da38ac6aa733c404$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $da38ac6aa733c404$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $da38ac6aa733c404$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)('database-standalone');
    const authProvider = new (0, $a83e7ccd68ca8d4e$export$2881499e37b75b9a)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $a83e7ccd68ca8d4e$export$2881499e37b75b9a)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $da38ac6aa733c404$var$registerDatabase();







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $df9a6d7fd06616c9$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $df9a6d7fd06616c9$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $df9a6d7fd06616c9$export$697502632950e9d3 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($df9a6d7fd06616c9$var$prependCode(code), `Firebase Storage: ${message} (${$df9a6d7fd06616c9$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $df9a6d7fd06616c9$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $df9a6d7fd06616c9$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $df9a6d7fd06616c9$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($df9a6d7fd06616c9$export$54592d666d6ce114 || ($df9a6d7fd06616c9$export$54592d666d6ce114 = {}));
function $df9a6d7fd06616c9$var$prependCode(code) {
    return 'storage/' + code;
}
function $df9a6d7fd06616c9$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNKNOWN, message);
}
function $df9a6d7fd06616c9$var$objectNotFound(path) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $df9a6d7fd06616c9$var$quotaExceeded(bucket) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $df9a6d7fd06616c9$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $df9a6d7fd06616c9$var$unauthorizedApp() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $df9a6d7fd06616c9$var$unauthorized(path) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $df9a6d7fd06616c9$var$retryLimitExceeded() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $df9a6d7fd06616c9$var$canceled() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $df9a6d7fd06616c9$var$invalidUrl(url) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $df9a6d7fd06616c9$var$invalidDefaultBucket(bucket) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $df9a6d7fd06616c9$var$noDefaultBucket() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $df9a6d7fd06616c9$var$cannotSliceBlob() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $df9a6d7fd06616c9$var$serverFileWrongSize() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $df9a6d7fd06616c9$var$noDownloadURL() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $df9a6d7fd06616c9$var$missingPolyFill(polyFill) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$8f74d9881d1936fd(message) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $df9a6d7fd06616c9$var$appDeleted() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $df9a6d7fd06616c9$export$61f54cdc36500ad(name) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $df9a6d7fd06616c9$var$invalidFormat(format, message) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $df9a6d7fd06616c9$var$internalError(message) {
    throw new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $df9a6d7fd06616c9$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $df9a6d7fd06616c9$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $df9a6d7fd06616c9$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $df9a6d7fd06616c9$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $df9a6d7fd06616c9$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $df9a6d7fd06616c9$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $df9a6d7fd06616c9$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $df9a6d7fd06616c9$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$isFunction(p) {
    return typeof p === 'function';
}
function $df9a6d7fd06616c9$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $df9a6d7fd06616c9$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $df9a6d7fd06616c9$var$isNativeBlob(p) {
    return $df9a6d7fd06616c9$var$isNativeBlobDefined() && p instanceof Blob;
}
function $df9a6d7fd06616c9$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $df9a6d7fd06616c9$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $df9a6d7fd06616c9$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $df9a6d7fd06616c9$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($df9a6d7fd06616c9$var$ErrorCode || ($df9a6d7fd06616c9$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $df9a6d7fd06616c9$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $df9a6d7fd06616c9$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $df9a6d7fd06616c9$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                    backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $df9a6d7fd06616c9$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($df9a6d7fd06616c9$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $df9a6d7fd06616c9$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $df9a6d7fd06616c9$var$appDeleted() : $df9a6d7fd06616c9$var$canceled();
                    reject(err);
                } else {
                    const err = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $df9a6d7fd06616c9$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $df9a6d7fd06616c9$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $df9a6d7fd06616c9$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : 'AppManager');
}
function $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $df9a6d7fd06616c9$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $df9a6d7fd06616c9$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId);
    $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken);
    $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion);
    $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken);
    return new $df9a6d7fd06616c9$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $df9a6d7fd06616c9$var$getBlob$1(...args) {
    const BlobBuilder1 = $df9a6d7fd06616c9$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $df9a6d7fd06616c9$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $df9a6d7fd06616c9$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $df9a6d7fd06616c9$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $df9a6d7fd06616c9$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $df9a6d7fd06616c9$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$utf8Bytes_(stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$base64Bytes_(format, stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$dataURLBytes_(stringData), $df9a6d7fd06616c9$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $df9a6d7fd06616c9$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $df9a6d7fd06616c9$var$utf8Bytes_(decoded);
}
function $df9a6d7fd06616c9$var$base64Bytes_(format, value) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $df9a6d7fd06616c9$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $df9a6d7fd06616c9$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $df9a6d7fd06616c9$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $df9a6d7fd06616c9$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $df9a6d7fd06616c9$var$dataURLBytes_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    if (parts.base64) return $df9a6d7fd06616c9$var$base64Bytes_($df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $df9a6d7fd06616c9$var$percentEncodedBytes_(parts.rest);
}
function $df9a6d7fd06616c9$var$dataURLContentType_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $df9a6d7fd06616c9$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($df9a6d7fd06616c9$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($df9a6d7fd06616c9$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $df9a6d7fd06616c9$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $df9a6d7fd06616c9$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7($df9a6d7fd06616c9$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($df9a6d7fd06616c9$var$isString(val)) return $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0($df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $df9a6d7fd06616c9$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($df9a6d7fd06616c9$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $df9a6d7fd06616c9$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $df9a6d7fd06616c9$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $df9a6d7fd06616c9$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$noXform_(metadata, value) {
    return value;
}
class $df9a6d7fd06616c9$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $df9a6d7fd06616c9$var$noXform_;
    }
}
let $df9a6d7fd06616c9$var$mappings_ = null;
function $df9a6d7fd06616c9$var$xformPath(fullPath) {
    if (!$df9a6d7fd06616c9$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $df9a6d7fd06616c9$var$lastComponent(fullPath);
}
function $df9a6d7fd06616c9$var$getMappings() {
    if ($df9a6d7fd06616c9$var$mappings_) return $df9a6d7fd06616c9$var$mappings_;
    const mappings = [];
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('bucket'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('generation'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('metageneration'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $df9a6d7fd06616c9$var$xformPath(fullPath);
    }
    const nameMapping = new $df9a6d7fd06616c9$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $df9a6d7fd06616c9$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('timeCreated'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('updated'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('md5Hash', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('cacheControl', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentDisposition', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentEncoding', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentLanguage', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentType', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('metadata', 'customMetadata', true));
    $df9a6d7fd06616c9$var$mappings_ = mappings;
    return $df9a6d7fd06616c9$var$mappings_;
}
function $df9a6d7fd06616c9$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $df9a6d7fd06616c9$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $df9a6d7fd06616c9$var$addRef(metadata, service);
    return metadata;
}
function $df9a6d7fd06616c9$var$fromResourceString(service, resourceString, mappings) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromResource(service, resource, mappings);
}
function $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$df9a6d7fd06616c9$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol);
        const queryString = $df9a6d7fd06616c9$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $df9a6d7fd06616c9$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $df9a6d7fd06616c9$var$PREFIXES_KEY = 'prefixes';
const $df9a6d7fd06616c9$var$ITEMS_KEY = 'items';
function $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]) for (const path of resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$df9a6d7fd06616c9$var$ITEMS_KEY]) for (const item of resource[$df9a6d7fd06616c9$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $df9a6d7fd06616c9$var$fromResponseString(service, bucket, resourceString) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $df9a6d7fd06616c9$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $df9a6d7fd06616c9$var$handlerCheck(cndn) {
    if (!cndn) throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $df9a6d7fd06616c9$var$fromResponseString(service, bucket, text);
        $df9a6d7fd06616c9$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $df9a6d7fd06616c9$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $df9a6d7fd06616c9$var$unauthorizedApp();
            else newErr = $df9a6d7fd06616c9$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $df9a6d7fd06616c9$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $df9a6d7fd06616c9$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$objectErrorHandler(location) {
    const shared = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $df9a6d7fd06616c9$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $df9a6d7fd06616c9$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $df9a6d7fd06616c9$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $df9a6d7fd06616c9$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $df9a6d7fd06616c9$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $df9a6d7fd06616c9$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $df9a6d7fd06616c9$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $df9a6d7fd06616c9$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $df9a6d7fd06616c9$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $df9a6d7fd06616c9$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $df9a6d7fd06616c9$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $df9a6d7fd06616c9$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        $df9a6d7fd06616c9$var$handlerCheck($df9a6d7fd06616c9$var$isString(url));
        return url;
    }
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $df9a6d7fd06616c9$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $df9a6d7fd06616c9$var$handlerCheck(false);
        const size = Number(sizeString);
        $df9a6d7fd06616c9$var$handlerCheck(!isNaN(size));
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $df9a6d7fd06616c9$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $df9a6d7fd06616c9$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $df9a6d7fd06616c9$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $df9a6d7fd06616c9$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $df9a6d7fd06616c9$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $df9a6d7fd06616c9$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $df9a6d7fd06616c9$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $df9a6d7fd06616c9$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $df9a6d7fd06616c9$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $df9a6d7fd06616c9$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .send() more than once');
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $df9a6d7fd06616c9$var$XhrTextConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $df9a6d7fd06616c9$var$newTextConnection() {
    return $df9a6d7fd06616c9$var$textFactoryOverride ? $df9a6d7fd06616c9$var$textFactoryOverride() : new $df9a6d7fd06616c9$var$XhrTextConnection();
}
class $df9a6d7fd06616c9$var$XhrBytesConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $df9a6d7fd06616c9$var$newBytesConnection() {
    return new $df9a6d7fd06616c9$var$XhrBytesConnection();
}
class $df9a6d7fd06616c9$var$XhrBlobConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $df9a6d7fd06616c9$var$newBlobConnection() {
    return new $df9a6d7fd06616c9$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $df9a6d7fd06616c9$export$86a2a9b92406a048 {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $df9a6d7fd06616c9$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($df9a6d7fd06616c9$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $df9a6d7fd06616c9$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $df9a6d7fd06616c9$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $df9a6d7fd06616c9$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $df9a6d7fd06616c9$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $df9a6d7fd06616c9$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state)){
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                    $df9a6d7fd06616c9$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $df9a6d7fd06616c9$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $df9a6d7fd06616c9$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $df9a6d7fd06616c9$var$async(observer.complete.bind(observer))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $df9a6d7fd06616c9$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $df9a6d7fd06616c9$export$adb98fff6714334) this._location = location;
        else this._location = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $df9a6d7fd06616c9$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $df9a6d7fd06616c9$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $df9a6d7fd06616c9$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, newPath);
        return new $df9a6d7fd06616c9$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $df9a6d7fd06616c9$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings(), new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $df9a6d7fd06616c9$export$86a2a9b92406a048(ref, new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadString$1(ref, value, format = $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $df9a6d7fd06616c9$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $df9a6d7fd06616c9$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $df9a6d7fd06616c9$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $df9a6d7fd06616c9$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $df9a6d7fd06616c9$var$updateMetadata$2(ref.storage, ref._location, metadata, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $df9a6d7fd06616c9$var$getDownloadUrl(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((url)=>{
        if (url === null) throw $df9a6d7fd06616c9$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $df9a6d7fd06616c9$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $df9a6d7fd06616c9$var$_getChild$1(ref, childPath) {
    const newPath = $df9a6d7fd06616c9$var$child(ref._location.path, childPath);
    const location = new $df9a6d7fd06616c9$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $df9a6d7fd06616c9$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $df9a6d7fd06616c9$var$refFromURL(service, url) {
    return new $df9a6d7fd06616c9$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $df9a6d7fd06616c9$var$refFromPath(ref, path) {
    if (ref instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $df9a6d7fd06616c9$var$noDefaultBucket();
        const reference = new $df9a6d7fd06616c9$var$Reference(service, service._bucket);
        if (path != null) return $df9a6d7fd06616c9$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $df9a6d7fd06616c9$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $df9a6d7fd06616c9$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) return $df9a6d7fd06616c9$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $df9a6d7fd06616c9$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $df9a6d7fd06616c9$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $df9a6d7fd06616c9$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $c38e0f42709c826a$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $df9a6d7fd06616c9$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $df9a6d7fd06616c9$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $df9a6d7fd06616c9$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $df9a6d7fd06616c9$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $df9a6d7fd06616c9$var$FailRequest($df9a6d7fd06616c9$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $df9a6d7fd06616c9$var$name = "@firebase/storage";
const $df9a6d7fd06616c9$var$version = "0.13.7";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $df9a6d7fd06616c9$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $df9a6d7fd06616c9$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $df9a6d7fd06616c9$export$8548546c0aa631e6(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $df9a6d7fd06616c9$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$export$8837f4fc672e936d(ref, options) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$export$6a265a7d315dec03(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$export$39c5ed4ec960eade(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$deleteObject$1(ref);
}
function $df9a6d7fd06616c9$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(serviceOrRef);
    return $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$9acd24c0fce96a85(ref, childPath) {
    return $df9a6d7fd06616c9$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $df9a6d7fd06616c9$export$fbd9b57a66480737(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $df9a6d7fd06616c9$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $df9a6d7fd06616c9$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $df9a6d7fd06616c9$export$9850e656f954b889(storage, host, port, options = {}) {
    $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $df9a6d7fd06616c9$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $df9a6d7fd06616c9$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $df9a6d7fd06616c9$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $df9a6d7fd06616c9$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $57d436074e210fb5$export$31499a9cd224b78c));
}
function $df9a6d7fd06616c9$var$registerStorage() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($df9a6d7fd06616c9$var$STORAGE_TYPE, $df9a6d7fd06616c9$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, '');
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, 'esm2017');
}
$df9a6d7fd06616c9$var$registerStorage();








const $1ee9b91e988771f9$var$name = "@firebase/installations";
const $1ee9b91e988771f9$var$version = "0.6.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS = 10000;
const $1ee9b91e988771f9$var$PACKAGE_VERSION = `w:${$1ee9b91e988771f9$var$version}`;
const $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $1ee9b91e988771f9$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $1ee9b91e988771f9$var$SERVICE = 'installations';
const $1ee9b91e988771f9$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $1ee9b91e988771f9$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)($1ee9b91e988771f9$var$SERVICE, $1ee9b91e988771f9$var$SERVICE_NAME, $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $1ee9b91e988771f9$var$isServerError(error) {
    return error instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$1ee9b91e988771f9$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $1ee9b91e988771f9$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $1ee9b91e988771f9$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    headers.append('Authorization', $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $1ee9b91e988771f9$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken) {
    return `${$1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig);
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $1ee9b91e988771f9$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $1ee9b91e988771f9$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $1ee9b91e988771f9$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $1ee9b91e988771f9$var$encode(fidByteArray);
        return $1ee9b91e988771f9$var$VALID_FID_PATTERN.test(fid) ? fid : $1ee9b91e988771f9$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $1ee9b91e988771f9$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $1ee9b91e988771f9$var$encode(fidByteArray) {
    const b64String = $1ee9b91e988771f9$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $1ee9b91e988771f9$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $1ee9b91e988771f9$var$fidChanged(appConfig, fid) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid);
    $1ee9b91e988771f9$var$broadcastFidChange(key, fid);
}
function $1ee9b91e988771f9$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $1ee9b91e988771f9$var$getBroadcastChannel();
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    let callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $1ee9b91e988771f9$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $1ee9b91e988771f9$var$removeCallback(appConfig, callback) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $1ee9b91e988771f9$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
function $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $1ee9b91e988771f9$var$broadcastFidChange(key, fid) {
    const channel = $1ee9b91e988771f9$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
let $1ee9b91e988771f9$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $1ee9b91e988771f9$var$getBroadcastChannel() {
    if (!$1ee9b91e988771f9$var$broadcastChannel && 'BroadcastChannel' in self) {
        $1ee9b91e988771f9$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $1ee9b91e988771f9$var$broadcastChannel.onmessage = (e)=>{
            $1ee9b91e988771f9$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $1ee9b91e988771f9$var$broadcastChannel;
}
function $1ee9b91e988771f9$var$closeBroadcastChannel() {
    if ($1ee9b91e988771f9$var$fidChangeCallbacks.size === 0 && $1ee9b91e988771f9$var$broadcastChannel) {
        $1ee9b91e988771f9$var$broadcastChannel.close();
        $1ee9b91e988771f9$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$DATABASE_NAME = 'firebase-installations-database';
const $1ee9b91e988771f9$var$DATABASE_VERSION = 1;
const $1ee9b91e988771f9$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $1ee9b91e988771f9$var$dbPromise = null;
function $1ee9b91e988771f9$var$getDbPromise() {
    if (!$1ee9b91e988771f9$var$dbPromise) $1ee9b91e988771f9$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($1ee9b91e988771f9$var$DATABASE_NAME, $1ee9b91e988771f9$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $1ee9b91e988771f9$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $1ee9b91e988771f9$var$set(appConfig, value) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $1ee9b91e988771f9$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $1ee9b91e988771f9$var$remove(appConfig) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $1ee9b91e988771f9$var$update(appConfig, updateFn) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $1ee9b91e988771f9$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $1ee9b91e988771f9$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $1ee9b91e988771f9$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $1ee9b91e988771f9$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $1ee9b91e988771f9$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $1ee9b91e988771f9$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $1ee9b91e988771f9$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $1ee9b91e988771f9$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $1ee9b91e988771f9$var$createInstallationRequest(installations, installationEntry);
        return $1ee9b91e988771f9$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $1ee9b91e988771f9$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $1ee9b91e988771f9$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateInstallationRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $1ee9b91e988771f9$var$clearTimedOutRequest(oldEntry);
    });
}
function $1ee9b91e988771f9$var$clearTimedOutRequest(entry) {
    if ($1ee9b91e988771f9$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $1ee9b91e988771f9$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse('Generate Auth Token', response);
}
function $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $1ee9b91e988771f9$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateAuthTokenRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $1ee9b91e988771f9$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $1ee9b91e988771f9$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $1ee9b91e988771f9$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$1ee9b91e988771f9$var$isAuthTokenExpired(authToken);
}
function $1ee9b91e988771f9$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $1ee9b91e988771f9$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $1ee9b91e988771f9$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $1ee9b91e988771f9$var$getErrorFromResponse('Delete Installation', response);
}
function $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, entry);
                await $1ee9b91e988771f9$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $1ee9b91e988771f9$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $1ee9b91e988771f9$var$addCallback(appConfig, callback);
    return ()=>{
        $1ee9b91e988771f9$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $1ee9b91e988771f9$export$9bfc115e43431ff5(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$extractAppConfig(app) {
    if (!app || !app.options) throw $1ee9b91e988771f9$var$getMissingValueError('App Configuration');
    if (!app.name) throw $1ee9b91e988771f9$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $1ee9b91e988771f9$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $1ee9b91e988771f9$var$getMissingValueError(valueName) {
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$INSTALLATIONS_NAME = 'installations';
const $1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $1ee9b91e988771f9$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $1ee9b91e988771f9$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $1ee9b91e988771f9$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $1ee9b91e988771f9$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$1ee9b91e988771f9$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $1ee9b91e988771f9$var$registerInstallations() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($1ee9b91e988771f9$var$INSTALLATIONS_NAME, $1ee9b91e988771f9$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL, $1ee9b91e988771f9$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $1ee9b91e988771f9$var$registerInstallations();
(0, $57d436074e210fb5$export$d29d5299a7137abc)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0, $57d436074e210fb5$export$d29d5299a7137abc)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version, 'esm2017');






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const $97b6afad2c5c80cd$var$DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const $97b6afad2c5c80cd$var$ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */ const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
const $97b6afad2c5c80cd$var$DEFAULT_REGISTRATION_TIMEOUT = 10000;
var $97b6afad2c5c80cd$var$MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})($97b6afad2c5c80cd$var$MessageType$1 || ($97b6afad2c5c80cd$var$MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $97b6afad2c5c80cd$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})($97b6afad2c5c80cd$var$MessageType || ($97b6afad2c5c80cd$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $97b6afad2c5c80cd$var$base64ToArray(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const $97b6afad2c5c80cd$var$OLD_DB_VERSION = 5;
const $97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function $97b6afad2c5c80cd$var$migrateOldDatabase(senderId) {
    if ('databases' in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes($97b6afad2c5c80cd$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($97b6afad2c5c80cd$var$OLD_DB_NAME, $97b6afad2c5c80cd$var$OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            var _a;
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains($97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore($97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index('fcmSenderId').get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === 'string' ? oldDetails.vapidKey : $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.auth),
                        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.auth),
                        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, $da032767b57a4aa4$export$9d6df0ac66a98bb2)($97b6afad2c5c80cd$var$OLD_DB_NAME);
    await (0, $da032767b57a4aa4$export$9d6df0ac66a98bb2)('fcm_vapid_details_db');
    await (0, $da032767b57a4aa4$export$9d6df0ac66a98bb2)('undefined');
    return $97b6afad2c5c80cd$var$checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function $97b6afad2c5c80cd$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions: subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === 'number' && tokenDetails.createTime > 0 && typeof tokenDetails.token === 'string' && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === 'string' && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === 'string' && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === 'string' && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === 'string' && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === 'string' && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Exported for tests.
const $97b6afad2c5c80cd$var$DATABASE_NAME = 'firebase-messaging-database';
const $97b6afad2c5c80cd$var$DATABASE_VERSION = 1;
const $97b6afad2c5c80cd$var$OBJECT_STORE_NAME = 'firebase-messaging-store';
let $97b6afad2c5c80cd$var$dbPromise = null;
function $97b6afad2c5c80cd$var$getDbPromise() {
    if (!$97b6afad2c5c80cd$var$dbPromise) $97b6afad2c5c80cd$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($97b6afad2c5c80cd$var$DATABASE_NAME, $97b6afad2c5c80cd$var$DATABASE_VERSION, {
        upgrade: (upgradeDb, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    upgradeDb.createObjectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $97b6afad2c5c80cd$var$dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */ async function $97b6afad2c5c80cd$var$dbGet(firebaseDependencies) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tokenDetails = await db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await $97b6afad2c5c80cd$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, tokenDetails) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tx = db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $97b6afad2c5c80cd$var$dbRemove(firebaseDependencies) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tx = db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function $97b6afad2c5c80cd$var$getKey({ appConfig: appConfig }) {
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: 'This method is available in a Window context.',
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: 'This method is available in a service worker context.',
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: 'The notification permission was not granted and dismissed instead.',
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: 'The notification permission was not granted and blocked instead.',
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: 'We are unable to register the default service worker. {$browserErrorMessage}',
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: 'FCM returned no token when subscribing the user to push.',
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: 'FCM returned no token when updating the user to push.',
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: 'The input to setBackgroundMessageHandler() must be a function.',
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: 'The public VAPID key must be a string.',
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
};
const $97b6afad2c5c80cd$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('messaging', 'Messaging', $97b6afad2c5c80cd$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const body = $97b6afad2c5c80cd$var$getBody(subscriptionOptions);
    const subscribeOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch($97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function $97b6afad2c5c80cd$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const body = $97b6afad2c5c80cd$var$getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${$97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function $97b6afad2c5c80cd$var$requestDeleteToken(firebaseDependencies, token) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: 'DELETE',
        headers: headers
    };
    try {
        const response = await fetch(`${$97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function $97b6afad2c5c80cd$var$getEndpoint({ projectId: projectId }) {
    return `${$97b6afad2c5c80cd$var$ENDPOINT}/projects/${projectId}/registrations`;
}
async function $97b6afad2c5c80cd$var$getHeaders({ appConfig: appConfig, installations: installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': appConfig.apiKey,
        'x-goog-firebase-installations-auth': `FIS ${authToken}`
    });
}
function $97b6afad2c5c80cd$var$getBody({ p256dh: p256dh, auth: auth, endpoint: endpoint, vapidKey: vapidKey }) {
    const body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const $97b6afad2c5c80cd$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function $97b6afad2c5c80cd$var$getTokenInternal(messaging) {
    const pushSubscription = await $97b6afad2c5c80cd$var$getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $97b6afad2c5c80cd$var$arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const tokenDetails = await $97b6afad2c5c80cd$var$dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return $97b6afad2c5c80cd$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!$97b6afad2c5c80cd$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await $97b6afad2c5c80cd$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return $97b6afad2c5c80cd$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + $97b6afad2c5c80cd$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
    return $97b6afad2c5c80cd$var$updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */ async function $97b6afad2c5c80cd$var$deleteTokenInternal(messaging) {
    const tokenDetails = await $97b6afad2c5c80cd$var$dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await $97b6afad2c5c80cd$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await $97b6afad2c5c80cd$var$dbRemove(messaging.firebaseDependencies);
    }
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function $97b6afad2c5c80cd$var$updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await $97b6afad2c5c80cd$var$requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
            token: updatedToken,
            createTime: Date.now()
        });
        await $97b6afad2c5c80cd$var$dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        throw e;
    }
}
async function $97b6afad2c5c80cd$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await $97b6afad2c5c80cd$var$requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function $97b6afad2c5c80cd$var$getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: $97b6afad2c5c80cd$var$base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $97b6afad2c5c80cd$var$isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    $97b6afad2c5c80cd$var$propagateNotificationPayload(payload, internalPayload);
    $97b6afad2c5c80cd$var$propagateDataPayload(payload, internalPayload);
    $97b6afad2c5c80cd$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $97b6afad2c5c80cd$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function $97b6afad2c5c80cd$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $97b6afad2c5c80cd$var$propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) return;
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $97b6afad2c5c80cd$var$_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function $97b6afad2c5c80cd$var$_mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join('');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$extractAppConfig(app) {
    if (!app || !app.options) throw $97b6afad2c5c80cd$var$getMissingValueError('App Configuration Object');
    if (!app.name) throw $97b6afad2c5c80cd$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    const { options: options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw $97b6afad2c5c80cd$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $97b6afad2c5c80cd$var$getMissingValueError(valueName) {
    return $97b6afad2c5c80cd$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $97b6afad2c5c80cd$var$MessagingService {
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = $97b6afad2c5c80cd$var$extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register($97b6afad2c5c80cd$var$DEFAULT_SW_PATH, {
            scope: $97b6afad2c5c80cd$var$DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
        await $97b6afad2c5c80cd$var$waitForRegistrationActive(messaging.swRegistration);
    } catch (e) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
/**
 * Waits for registration to become active. MDN documentation claims that
 * a service worker registration should be ready to use after awaiting
 * navigator.serviceWorker.register() but that doesn't seem to be the case in
 * practice, causing the SDK to throw errors when calling
 * swRegistration.pushManager.subscribe() too soon after register(). The only
 * solution seems to be waiting for the service worker registration `state`
 * to become "active".
 */ async function $97b6afad2c5c80cd$var$waitForRegistrationActive(registration) {
    return new Promise((resolve, reject)=>{
        const rejectTimeout = setTimeout(()=>reject(new Error(`Service worker not registered after ${$97b6afad2c5c80cd$var$DEFAULT_REGISTRATION_TIMEOUT} ms`)), $97b6afad2c5c80cd$var$DEFAULT_REGISTRATION_TIMEOUT);
        const incomingSw = registration.installing || registration.waiting;
        if (registration.active) {
            clearTimeout(rejectTimeout);
            resolve();
        } else if (incomingSw) incomingSw.onstatechange = (ev)=>{
            var _a;
            if (((_a = ev.target) === null || _a === void 0 ? void 0 : _a.state) === 'activated') {
                incomingSw.onstatechange = null;
                clearTimeout(rejectTimeout);
                resolve();
            }
        };
        else {
            clearTimeout(rejectTimeout);
            reject(new Error('No incoming service worker found.'));
        }
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await $97b6afad2c5c80cd$var$registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$getToken$1(messaging, options) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await $97b6afad2c5c80cd$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $97b6afad2c5c80cd$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return $97b6afad2c5c80cd$var$getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$logToScion(messaging, messageType, data) {
    const eventType = $97b6afad2c5c80cd$var$getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID],
        message_name: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_NAME],
        message_time: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function $97b6afad2c5c80cd$var$getEventType(messageType) {
    switch(messageType){
        case $97b6afad2c5c80cd$var$MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case $97b6afad2c5c80cd$var$MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === $97b6afad2c5c80cd$var$MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === 'function') messaging.onMessageHandler($97b6afad2c5c80cd$var$externalizePayload(internalPayload));
        else messaging.onMessageHandler.next($97b6afad2c5c80cd$var$externalizePayload(internalPayload));
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if ($97b6afad2c5c80cd$var$isConsoleMessage(dataPayload) && dataPayload[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') await $97b6afad2c5c80cd$var$logToScion(messaging, internalPayload.messageType, dataPayload);
}
const $97b6afad2c5c80cd$var$name = "@firebase/messaging";
const $97b6afad2c5c80cd$var$version = "0.12.17";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$WindowMessagingFactory = (container)=>{
    const messaging = new $97b6afad2c5c80cd$var$MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
    navigator.serviceWorker.addEventListener('message', (e)=>$97b6afad2c5c80cd$var$messageEventListener(messaging, e));
    return messaging;
};
const $97b6afad2c5c80cd$var$WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider('messaging').getImmediate();
    const messagingInternal = {
        getToken: (options)=>$97b6afad2c5c80cd$var$getToken$1(messaging, options)
    };
    return messagingInternal;
};
function $97b6afad2c5c80cd$var$registerMessagingInWindow() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('messaging', $97b6afad2c5c80cd$var$WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('messaging-internal', $97b6afad2c5c80cd$var$WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($97b6afad2c5c80cd$var$name, $97b6afad2c5c80cd$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($97b6afad2c5c80cd$var$name, $97b6afad2c5c80cd$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function $97b6afad2c5c80cd$export$48c17662a6902497() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== 'undefined' && (0, $c38e0f42709c826a$export$3865db50535c2055)() && (0, $c38e0f42709c826a$export$f172b7eb6cf60599)() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$deleteToken$1(messaging) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await $97b6afad2c5c80cd$var$registerDefaultSw(messaging);
    return $97b6afad2c5c80cd$var$deleteTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$f74c3c76482a8451(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    $97b6afad2c5c80cd$export$48c17662a6902497().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, $57d436074e210fb5$export$fa0d6da0f5838f50)((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */ async function $97b6afad2c5c80cd$export$257b2d10b709d8ef(messaging, options) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$95d23a5f596fdc8e(messaging) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$7275a8dcb77dc20d(messaging, nextOrObserver) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$onMessage$1(messaging, nextOrObserver);
}
/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $97b6afad2c5c80cd$var$registerMessagingInWindow();









/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $0d15f034d14801d0$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $0d15f034d14801d0$var$GA_FID_KEY = 'firebase_id';
const $0d15f034d14801d0$var$ORIGIN_KEY = 'origin';
const $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS = 60000;
const $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $0d15f034d14801d0$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $0d15f034d14801d0$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('analytics', 'Analytics', $0d15f034d14801d0$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($0d15f034d14801d0$var$GTAG_URL)) {
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $0d15f034d14801d0$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $0d15f034d14801d0$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $0d15f034d14801d0$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$0d15f034d14801d0$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $0d15f034d14801d0$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $0d15f034d14801d0$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $0d15f034d14801d0$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $0d15f034d14801d0$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($0d15f034d14801d0$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $0d15f034d14801d0$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $0d15f034d14801d0$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $0d15f034d14801d0$var$defaultRetryData = new $0d15f034d14801d0$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $0d15f034d14801d0$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $0d15f034d14801d0$var$getHeaders(apiKey)
    };
    const appUrl = $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $0d15f034d14801d0$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $0d15f034d14801d0$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS);
    return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $0d15f034d14801d0$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $0d15f034d14801d0$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $0d15f034d14801d0$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$0d15f034d14801d0$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $0d15f034d14801d0$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $c38e0f42709c826a$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $0d15f034d14801d0$var$LONG_RETRY_FACTOR) : (0, $c38e0f42709c826a$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $0d15f034d14801d0$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($0d15f034d14801d0$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $0d15f034d14801d0$var$isRetriableError(e) {
    if (!(e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $0d15f034d14801d0$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $0d15f034d14801d0$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $0d15f034d14801d0$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $0d15f034d14801d0$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $0d15f034d14801d0$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $0d15f034d14801d0$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($0d15f034d14801d0$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $0d15f034d14801d0$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings) {
    $0d15f034d14801d0$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams) {
    $0d15f034d14801d0$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0d15f034d14801d0$var$validateIndexedDB() {
    if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
    } catch (e) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $0d15f034d14801d0$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $0d15f034d14801d0$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName)) $0d15f034d14801d0$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($0d15f034d14801d0$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $0d15f034d14801d0$var$defaultConsentSettingsForInit);
        $0d15f034d14801d0$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$0d15f034d14801d0$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$0d15f034d14801d0$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($0d15f034d14801d0$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $0d15f034d14801d0$var$defaultEventParametersForInit);
        $0d15f034d14801d0$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $0d15f034d14801d0$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $0d15f034d14801d0$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $0d15f034d14801d0$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $0d15f034d14801d0$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $0d15f034d14801d0$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $0d15f034d14801d0$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $0d15f034d14801d0$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $0d15f034d14801d0$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $0d15f034d14801d0$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $0d15f034d14801d0$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $0d15f034d14801d0$export$a5a6e0b888b2c992(options) {
    if ($0d15f034d14801d0$var$globalInitDone) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $0d15f034d14801d0$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $0d15f034d14801d0$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $0d15f034d14801d0$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $c38e0f42709c826a$export$caa8774a9107a58e)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $c38e0f42709c826a$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $0d15f034d14801d0$var$factory(app, installations, options) {
    $0d15f034d14801d0$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($0d15f034d14801d0$var$initializationPromisesMap[appId] != null) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$0d15f034d14801d0$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $0d15f034d14801d0$var$getOrCreateDataLayer($0d15f034d14801d0$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $0d15f034d14801d0$var$wrapOrCreateGtag($0d15f034d14801d0$var$initializationPromisesMap, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, $0d15f034d14801d0$var$dataLayerName, $0d15f034d14801d0$var$gtagName);
        $0d15f034d14801d0$var$wrappedGtagFunction = wrappedGtag;
        $0d15f034d14801d0$var$gtagCoreFunction = gtagCore;
        $0d15f034d14801d0$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $0d15f034d14801d0$var$initializationPromisesMap[appId] = $0d15f034d14801d0$var$_initializeAnalytics(app, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, installations, $0d15f034d14801d0$var$gtagCoreFunction, $0d15f034d14801d0$var$dataLayerName, options);
    const analyticsInstance = new $0d15f034d14801d0$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$b0297573c90085aa(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $0d15f034d14801d0$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $0d15f034d14801d0$export$48c17662a6902497() {
    if ((0, $c38e0f42709c826a$export$caa8774a9107a58e)()) return false;
    if (!(0, $c38e0f42709c826a$export$f172b7eb6cf60599)()) return false;
    if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $0d15f034d14801d0$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setCurrentScreen$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $0d15f034d14801d0$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    return $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $0d15f034d14801d0$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setUserId$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $0d15f034d14801d0$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setUserProperties$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $0d15f034d14801d0$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1($0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $0d15f034d14801d0$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(analyticsInstance);
    $0d15f034d14801d0$var$logEvent$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings);
}
const $0d15f034d14801d0$var$name = "@firebase/analytics";
const $0d15f034d14801d0$var$version = "0.10.12";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $0d15f034d14801d0$var$registerAnalytics() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($0d15f034d14801d0$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $0d15f034d14801d0$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($0d15f034d14801d0$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$0d15f034d14801d0$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $0d15f034d14801d0$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$0d15f034d14801d0$var$registerAnalytics();






/*
 Copyright 2022 Google LLC
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ // Creates the `web-vitals/attribution` import in node-based bundlers.
// This will not be needed when export maps are widely supported.
var $76927d7fef3655e9$var$t, $76927d7fef3655e9$var$e, $76927d7fef3655e9$var$n = function() {
    var t = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, $76927d7fef3655e9$var$r = function(t) {
    if ("loading" === document.readyState) return "loading";
    var e = $76927d7fef3655e9$var$n();
    if (e) {
        if (t < e.domInteractive) return "loading";
        if (0 === e.domContentLoadedEventStart || t < e.domContentLoadedEventStart) return "dom-interactive";
        if (0 === e.domComplete || t < e.domComplete) return "dom-content-loaded";
    }
    return "complete";
}, $76927d7fef3655e9$var$i = function(t) {
    var e = t.nodeName;
    return 1 === t.nodeType ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
}, $76927d7fef3655e9$var$a = function(t, e) {
    var n = "";
    try {
        for(; t && 9 !== t.nodeType;){
            var r = t, a = r.id ? "#" + r.id : $76927d7fef3655e9$var$i(r) + (r.classList && r.classList.value && r.classList.value.trim() && r.classList.value.trim().length ? "." + r.classList.value.trim().replace(/\s+/g, ".") : "");
            if (n.length + a.length > (e || 100) - 1) return n || a;
            if (n = n ? a + ">" + n : a, r.id) break;
            t = r.parentNode;
        }
    } catch (t) {}
    return n;
}, $76927d7fef3655e9$var$o = -1, $76927d7fef3655e9$var$c = function() {
    return $76927d7fef3655e9$var$o;
}, $76927d7fef3655e9$var$u = function(t) {
    addEventListener("pageshow", function(e) {
        e.persisted && ($76927d7fef3655e9$var$o = e.timeStamp, t(e));
    }, !0);
}, $76927d7fef3655e9$var$s = function() {
    var t = $76927d7fef3655e9$var$n();
    return t && t.activationStart || 0;
}, $76927d7fef3655e9$var$f = function(t, e) {
    var r = $76927d7fef3655e9$var$n(), i = "navigate";
    $76927d7fef3655e9$var$c() >= 0 ? i = "back-forward-cache" : r && (document.prerendering || $76927d7fef3655e9$var$s() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : r.type && (i = r.type.replace(/_/g, "-")));
    return {
        name: t,
        value: void 0 === e ? -1 : e,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: i
    };
}, $76927d7fef3655e9$var$d = function(t, e, n) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
            var r = new PerformanceObserver(function(t) {
                Promise.resolve().then(function() {
                    e(t.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: t,
                buffered: !0
            }, n || {})), r;
        }
    } catch (t) {}
}, $76927d7fef3655e9$var$l = function(t, e, n, r) {
    var i, a;
    return function(o) {
        e.value >= 0 && (o || r) && ((a = e.value - (i || 0)) || void 0 === i) && (i = e.value, e.delta = a, e.rating = function(t, e) {
            return t > e[1] ? "poor" : t > e[0] ? "needs-improvement" : "good";
        }(e.value, n), t(e));
    };
}, $76927d7fef3655e9$var$m = function(t) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return t();
        });
    });
}, $76927d7fef3655e9$var$p = function(t) {
    document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && t();
    });
}, $76927d7fef3655e9$var$v = function(t) {
    var e = !1;
    return function() {
        e || (t(), e = !0);
    };
}, $76927d7fef3655e9$var$g = -1, $76927d7fef3655e9$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $76927d7fef3655e9$var$T = function(t) {
    "hidden" === document.visibilityState && $76927d7fef3655e9$var$g > -1 && ($76927d7fef3655e9$var$g = "visibilitychange" === t.type ? t.timeStamp : 0, $76927d7fef3655e9$var$E());
}, $76927d7fef3655e9$var$y = function() {
    addEventListener("visibilitychange", $76927d7fef3655e9$var$T, !0), addEventListener("prerenderingchange", $76927d7fef3655e9$var$T, !0);
}, $76927d7fef3655e9$var$E = function() {
    removeEventListener("visibilitychange", $76927d7fef3655e9$var$T, !0), removeEventListener("prerenderingchange", $76927d7fef3655e9$var$T, !0);
}, $76927d7fef3655e9$var$S = function() {
    return $76927d7fef3655e9$var$g < 0 && ($76927d7fef3655e9$var$g = $76927d7fef3655e9$var$h(), $76927d7fef3655e9$var$y(), $76927d7fef3655e9$var$u(function() {
        setTimeout(function() {
            $76927d7fef3655e9$var$g = $76927d7fef3655e9$var$h(), $76927d7fef3655e9$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $76927d7fef3655e9$var$g;
        }
    };
}, $76927d7fef3655e9$var$b = function(t) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return t();
    }, !0) : t();
}, $76927d7fef3655e9$export$e610c735b5510cec = [
    1800,
    3e3
], $76927d7fef3655e9$var$C = function(t, e) {
    e = e || {}, $76927d7fef3655e9$var$b(function() {
        var n, r = $76927d7fef3655e9$var$S(), i = $76927d7fef3655e9$var$f("FCP"), a = $76927d7fef3655e9$var$d("paint", function(t) {
            t.forEach(function(t) {
                "first-contentful-paint" === t.name && (a.disconnect(), t.startTime < r.firstHiddenTime && (i.value = Math.max(t.startTime - $76927d7fef3655e9$var$s(), 0), i.entries.push(t), n(!0)));
            });
        });
        a && (n = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$e610c735b5510cec, e.reportAllChanges), $76927d7fef3655e9$var$u(function(r) {
            i = $76927d7fef3655e9$var$f("FCP"), n = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$e610c735b5510cec, e.reportAllChanges), $76927d7fef3655e9$var$m(function() {
                i.value = performance.now() - r.timeStamp, n(!0);
            });
        }));
    });
}, $76927d7fef3655e9$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $76927d7fef3655e9$export$a7873055838e5ad8 = function(t, e) {
    !function(t, e) {
        e = e || {}, $76927d7fef3655e9$var$C($76927d7fef3655e9$var$v(function() {
            var n, r = $76927d7fef3655e9$var$f("CLS", 0), i = 0, a = [], o = function(t) {
                t.forEach(function(t) {
                    if (!t.hadRecentInput) {
                        var e = a[0], n = a[a.length - 1];
                        i && t.startTime - n.startTime < 1e3 && t.startTime - e.startTime < 5e3 ? (i += t.value, a.push(t)) : (i = t.value, a = [
                            t
                        ]);
                    }
                }), i > r.value && (r.value = i, r.entries = a, n());
            }, c = $76927d7fef3655e9$var$d("layout-shift", o);
            c && (n = $76927d7fef3655e9$var$l(t, r, $76927d7fef3655e9$export$3f20d8e089ac35b2, e.reportAllChanges), $76927d7fef3655e9$var$p(function() {
                o(c.takeRecords()), n(!0);
            }), $76927d7fef3655e9$var$u(function() {
                i = 0, r = $76927d7fef3655e9$var$f("CLS", 0), n = $76927d7fef3655e9$var$l(t, r, $76927d7fef3655e9$export$3f20d8e089ac35b2, e.reportAllChanges), $76927d7fef3655e9$var$m(function() {
                    return n();
                });
            }), setTimeout(n, 0));
        }));
    }(function(e) {
        var n = function(t) {
            var e, n = {};
            if (t.entries.length) {
                var i = t.entries.reduce(function(t, e) {
                    return t && t.value > e.value ? t : e;
                });
                if (i && i.sources && i.sources.length) {
                    var o = (e = i.sources).find(function(t) {
                        return t.node && 1 === t.node.nodeType;
                    }) || e[0];
                    o && (n = {
                        largestShiftTarget: $76927d7fef3655e9$var$a(o.node),
                        largestShiftTime: i.startTime,
                        largestShiftValue: i.value,
                        largestShiftSource: o,
                        largestShiftEntry: i,
                        loadState: $76927d7fef3655e9$var$r(i.startTime)
                    });
                }
            }
            return Object.assign(t, {
                attribution: n
            });
        }(e);
        t(n);
    }, e);
}, $76927d7fef3655e9$export$fe3c86b74e15d5de = function(t, e) {
    $76927d7fef3655e9$var$C(function(e) {
        var i = function(t) {
            var e = {
                timeToFirstByte: 0,
                firstByteToFCP: t.value,
                loadState: $76927d7fef3655e9$var$r($76927d7fef3655e9$var$c())
            };
            if (t.entries.length) {
                var i = $76927d7fef3655e9$var$n(), a = t.entries[t.entries.length - 1];
                if (i) {
                    var o = i.activationStart || 0, u = Math.max(0, i.responseStart - o);
                    e = {
                        timeToFirstByte: u,
                        firstByteToFCP: t.value - u,
                        loadState: $76927d7fef3655e9$var$r(t.entries[0].startTime),
                        navigationEntry: i,
                        fcpEntry: a
                    };
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(i);
    }, e);
}, $76927d7fef3655e9$var$x = 0, $76927d7fef3655e9$var$I = 1 / 0, $76927d7fef3655e9$var$k = 0, $76927d7fef3655e9$var$A = function(t) {
    t.forEach(function(t) {
        t.interactionId && ($76927d7fef3655e9$var$I = Math.min($76927d7fef3655e9$var$I, t.interactionId), $76927d7fef3655e9$var$k = Math.max($76927d7fef3655e9$var$k, t.interactionId), $76927d7fef3655e9$var$x = $76927d7fef3655e9$var$k ? ($76927d7fef3655e9$var$k - $76927d7fef3655e9$var$I) / 7 + 1 : 0);
    });
}, $76927d7fef3655e9$var$F = function() {
    return $76927d7fef3655e9$var$t ? $76927d7fef3655e9$var$x : performance.interactionCount || 0;
}, $76927d7fef3655e9$var$P = function() {
    "interactionCount" in performance || $76927d7fef3655e9$var$t || ($76927d7fef3655e9$var$t = $76927d7fef3655e9$var$d("event", $76927d7fef3655e9$var$A, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $76927d7fef3655e9$var$B = [], $76927d7fef3655e9$var$O = new Map, $76927d7fef3655e9$var$R = 0, $76927d7fef3655e9$var$j = function() {
    var t = Math.min($76927d7fef3655e9$var$B.length - 1, Math.floor(($76927d7fef3655e9$var$F() - $76927d7fef3655e9$var$R) / 50));
    return $76927d7fef3655e9$var$B[t];
}, $76927d7fef3655e9$var$q = [], $76927d7fef3655e9$var$H = function(t) {
    if ($76927d7fef3655e9$var$q.forEach(function(e) {
        return e(t);
    }), t.interactionId || "first-input" === t.entryType) {
        var e = $76927d7fef3655e9$var$B[$76927d7fef3655e9$var$B.length - 1], n = $76927d7fef3655e9$var$O.get(t.interactionId);
        if (n || $76927d7fef3655e9$var$B.length < 10 || t.duration > e.latency) {
            if (n) t.duration > n.latency ? (n.entries = [
                t
            ], n.latency = t.duration) : t.duration === n.latency && t.startTime === n.entries[0].startTime && n.entries.push(t);
            else {
                var r = {
                    id: t.interactionId,
                    latency: t.duration,
                    entries: [
                        t
                    ]
                };
                $76927d7fef3655e9$var$O.set(r.id, r), $76927d7fef3655e9$var$B.push(r);
            }
            $76927d7fef3655e9$var$B.sort(function(t, e) {
                return e.latency - t.latency;
            }), $76927d7fef3655e9$var$B.length > 10 && $76927d7fef3655e9$var$B.splice(10).forEach(function(t) {
                return $76927d7fef3655e9$var$O.delete(t.id);
            });
        }
    }
}, $76927d7fef3655e9$var$N = function(t) {
    var e = self.requestIdleCallback || self.setTimeout, n = -1;
    return t = $76927d7fef3655e9$var$v(t), "hidden" === document.visibilityState ? t() : (n = e(t), $76927d7fef3655e9$var$p(t)), n;
}, $76927d7fef3655e9$export$7f4cb060ded9173c = [
    200,
    500
], $76927d7fef3655e9$var$z = function(t, e) {
    "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (e = e || {}, $76927d7fef3655e9$var$b(function() {
        var n;
        $76927d7fef3655e9$var$P();
        var r, i = $76927d7fef3655e9$var$f("INP"), a = function(t) {
            $76927d7fef3655e9$var$N(function() {
                t.forEach($76927d7fef3655e9$var$H);
                var e = $76927d7fef3655e9$var$j();
                e && e.latency !== i.value && (i.value = e.latency, i.entries = e.entries, r());
            });
        }, o = $76927d7fef3655e9$var$d("event", a, {
            durationThreshold: null !== (n = e.durationThreshold) && void 0 !== n ? n : 40
        });
        r = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$7f4cb060ded9173c, e.reportAllChanges), o && (o.observe({
            type: "first-input",
            buffered: !0
        }), $76927d7fef3655e9$var$p(function() {
            a(o.takeRecords()), r(!0);
        }), $76927d7fef3655e9$var$u(function() {
            $76927d7fef3655e9$var$R = $76927d7fef3655e9$var$F(), $76927d7fef3655e9$var$B.length = 0, $76927d7fef3655e9$var$O.clear(), i = $76927d7fef3655e9$var$f("INP"), r = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$7f4cb060ded9173c, e.reportAllChanges);
        }));
    }));
}, $76927d7fef3655e9$var$U = [], $76927d7fef3655e9$var$V = [], $76927d7fef3655e9$var$_ = 0, $76927d7fef3655e9$var$G = new WeakMap, $76927d7fef3655e9$var$J = new Map, $76927d7fef3655e9$var$K = -1, $76927d7fef3655e9$var$Q = function(t) {
    $76927d7fef3655e9$var$U = $76927d7fef3655e9$var$U.concat(t), $76927d7fef3655e9$var$X();
}, $76927d7fef3655e9$var$X = function() {
    $76927d7fef3655e9$var$K < 0 && ($76927d7fef3655e9$var$K = $76927d7fef3655e9$var$N($76927d7fef3655e9$var$Y));
}, $76927d7fef3655e9$var$Y = function() {
    $76927d7fef3655e9$var$J.size > 10 && $76927d7fef3655e9$var$J.forEach(function(t, e) {
        $76927d7fef3655e9$var$O.has(e) || $76927d7fef3655e9$var$J.delete(e);
    });
    var t = $76927d7fef3655e9$var$B.map(function(t) {
        return $76927d7fef3655e9$var$G.get(t.entries[0]);
    }), e = $76927d7fef3655e9$var$V.length - 50;
    $76927d7fef3655e9$var$V = $76927d7fef3655e9$var$V.filter(function(n, r) {
        return r >= e || t.includes(n);
    });
    for(var n = new Set, r = 0; r < $76927d7fef3655e9$var$V.length; r++){
        var i = $76927d7fef3655e9$var$V[r];
        $76927d7fef3655e9$var$nt(i.startTime, i.processingEnd).forEach(function(t) {
            n.add(t);
        });
    }
    var a = $76927d7fef3655e9$var$U.length - 1 - 50;
    $76927d7fef3655e9$var$U = $76927d7fef3655e9$var$U.filter(function(t, e) {
        return t.startTime > $76927d7fef3655e9$var$_ && e > a || n.has(t);
    }), $76927d7fef3655e9$var$K = -1;
};
$76927d7fef3655e9$var$q.push(function(t) {
    t.interactionId && t.target && !$76927d7fef3655e9$var$J.has(t.interactionId) && $76927d7fef3655e9$var$J.set(t.interactionId, t.target);
}, function(t) {
    var e, n = t.startTime + t.duration;
    $76927d7fef3655e9$var$_ = Math.max($76927d7fef3655e9$var$_, t.processingEnd);
    for(var r = $76927d7fef3655e9$var$V.length - 1; r >= 0; r--){
        var i = $76927d7fef3655e9$var$V[r];
        if (Math.abs(n - i.renderTime) <= 8) {
            (e = i).startTime = Math.min(t.startTime, e.startTime), e.processingStart = Math.min(t.processingStart, e.processingStart), e.processingEnd = Math.max(t.processingEnd, e.processingEnd), e.entries.push(t);
            break;
        }
    }
    e || (e = {
        startTime: t.startTime,
        processingStart: t.processingStart,
        processingEnd: t.processingEnd,
        renderTime: n,
        entries: [
            t
        ]
    }, $76927d7fef3655e9$var$V.push(e)), (t.interactionId || "first-input" === t.entryType) && $76927d7fef3655e9$var$G.set(t, e), $76927d7fef3655e9$var$X();
});
var $76927d7fef3655e9$var$Z, $76927d7fef3655e9$var$$, $76927d7fef3655e9$var$tt, $76927d7fef3655e9$var$et, $76927d7fef3655e9$var$nt = function(t, e) {
    for(var n, r = [], i = 0; n = $76927d7fef3655e9$var$U[i]; i++)if (!(n.startTime + n.duration < t)) {
        if (n.startTime > e) break;
        r.push(n);
    }
    return r;
}, $76927d7fef3655e9$export$7df4b36ecaed99e1 = function(t, n) {
    $76927d7fef3655e9$var$e || ($76927d7fef3655e9$var$e = $76927d7fef3655e9$var$d("long-animation-frame", $76927d7fef3655e9$var$Q)), $76927d7fef3655e9$var$z(function(e) {
        var n = function(t) {
            var e = t.entries[0], n = $76927d7fef3655e9$var$G.get(e), i = e.processingStart, o = n.processingEnd, c = n.entries.sort(function(t, e) {
                return t.processingStart - e.processingStart;
            }), u = $76927d7fef3655e9$var$nt(e.startTime, o), s = t.entries.find(function(t) {
                return t.target;
            }), f = s && s.target || $76927d7fef3655e9$var$J.get(e.interactionId), d = [
                e.startTime + e.duration,
                o
            ].concat(u.map(function(t) {
                return t.startTime + t.duration;
            })), l = Math.max.apply(Math, d), m = {
                interactionTarget: $76927d7fef3655e9$var$a(f),
                interactionTargetElement: f,
                interactionType: e.name.startsWith("key") ? "keyboard" : "pointer",
                interactionTime: e.startTime,
                nextPaintTime: l,
                processedEventEntries: c,
                longAnimationFrameEntries: u,
                inputDelay: i - e.startTime,
                processingDuration: o - i,
                presentationDelay: Math.max(l - o, 0),
                loadState: $76927d7fef3655e9$var$r(e.startTime)
            };
            return Object.assign(t, {
                attribution: m
            });
        }(e);
        t(n);
    }, n);
}, $76927d7fef3655e9$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $76927d7fef3655e9$var$at = {}, $76927d7fef3655e9$export$947b1626ab8d5632 = function(t, e) {
    !function(t, e) {
        e = e || {}, $76927d7fef3655e9$var$b(function() {
            var n, r = $76927d7fef3655e9$var$S(), i = $76927d7fef3655e9$var$f("LCP"), a = function(t) {
                e.reportAllChanges || (t = t.slice(-1)), t.forEach(function(t) {
                    t.startTime < r.firstHiddenTime && (i.value = Math.max(t.startTime - $76927d7fef3655e9$var$s(), 0), i.entries = [
                        t
                    ], n());
                });
            }, o = $76927d7fef3655e9$var$d("largest-contentful-paint", a);
            if (o) {
                n = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$948521ca5b0e1b17, e.reportAllChanges);
                var c = $76927d7fef3655e9$var$v(function() {
                    $76927d7fef3655e9$var$at[i.id] || (a(o.takeRecords()), o.disconnect(), $76927d7fef3655e9$var$at[i.id] = !0, n(!0));
                });
                [
                    "keydown",
                    "click"
                ].forEach(function(t) {
                    addEventListener(t, function() {
                        return $76927d7fef3655e9$var$N(c);
                    }, {
                        once: !0,
                        capture: !0
                    });
                }), $76927d7fef3655e9$var$p(c), $76927d7fef3655e9$var$u(function(r) {
                    i = $76927d7fef3655e9$var$f("LCP"), n = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$948521ca5b0e1b17, e.reportAllChanges), $76927d7fef3655e9$var$m(function() {
                        i.value = performance.now() - r.timeStamp, $76927d7fef3655e9$var$at[i.id] = !0, n(!0);
                    });
                });
            }
        });
    }(function(e) {
        var r = function(t) {
            var e = {
                timeToFirstByte: 0,
                resourceLoadDelay: 0,
                resourceLoadDuration: 0,
                elementRenderDelay: t.value
            };
            if (t.entries.length) {
                var r = $76927d7fef3655e9$var$n();
                if (r) {
                    var i = r.activationStart || 0, o = t.entries[t.entries.length - 1], c = o.url && performance.getEntriesByType("resource").filter(function(t) {
                        return t.name === o.url;
                    })[0], u = Math.max(0, r.responseStart - i), s = Math.max(u, c ? (c.requestStart || c.startTime) - i : 0), f = Math.max(s, c ? c.responseEnd - i : 0), d = Math.max(f, o.startTime - i);
                    e = {
                        element: $76927d7fef3655e9$var$a(o.element),
                        timeToFirstByte: u,
                        resourceLoadDelay: s - u,
                        resourceLoadDuration: f - s,
                        elementRenderDelay: d - f,
                        navigationEntry: r,
                        lcpEntry: o
                    }, o.url && (e.url = o.url), c && (e.lcpResourceEntry = c);
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(r);
    }, e);
}, $76927d7fef3655e9$export$65c59ea8064668fc = [
    800,
    1800
], $76927d7fef3655e9$var$ut = function t(e) {
    document.prerendering ? $76927d7fef3655e9$var$b(function() {
        return t(e);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return t(e);
    }, !0) : setTimeout(e, 0);
}, $76927d7fef3655e9$var$st = function(t, e) {
    e = e || {};
    var r = $76927d7fef3655e9$var$f("TTFB"), i = $76927d7fef3655e9$var$l(t, r, $76927d7fef3655e9$export$65c59ea8064668fc, e.reportAllChanges);
    $76927d7fef3655e9$var$ut(function() {
        var a = $76927d7fef3655e9$var$n();
        a && (r.value = Math.max(a.responseStart - $76927d7fef3655e9$var$s(), 0), r.entries = [
            a
        ], i(!0), $76927d7fef3655e9$var$u(function() {
            r = $76927d7fef3655e9$var$f("TTFB", 0), (i = $76927d7fef3655e9$var$l(t, r, $76927d7fef3655e9$export$65c59ea8064668fc, e.reportAllChanges))(!0);
        }));
    });
}, $76927d7fef3655e9$export$33a01e6c5f2c7e33 = function(t, e) {
    $76927d7fef3655e9$var$st(function(e) {
        var n = function(t) {
            var e = {
                waitingDuration: 0,
                cacheDuration: 0,
                dnsDuration: 0,
                connectionDuration: 0,
                requestDuration: 0
            };
            if (t.entries.length) {
                var n = t.entries[0], r = n.activationStart || 0, i = Math.max((n.workerStart || n.fetchStart) - r, 0), a = Math.max(n.domainLookupStart - r, 0), o = Math.max(n.connectStart - r, 0), c = Math.max(n.connectEnd - r, 0);
                e = {
                    waitingDuration: i,
                    cacheDuration: a - i,
                    dnsDuration: o - a,
                    connectionDuration: c - o,
                    requestDuration: t.value - c,
                    navigationEntry: n
                };
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(n);
    }, e);
}, $76927d7fef3655e9$var$dt = {
    passive: !0,
    capture: !0
}, $76927d7fef3655e9$var$lt = new Date, $76927d7fef3655e9$var$mt = function(t, e) {
    $76927d7fef3655e9$var$Z || ($76927d7fef3655e9$var$Z = e, $76927d7fef3655e9$var$$ = t, $76927d7fef3655e9$var$tt = new Date, $76927d7fef3655e9$var$gt(removeEventListener), $76927d7fef3655e9$var$pt());
}, $76927d7fef3655e9$var$pt = function() {
    if ($76927d7fef3655e9$var$$ >= 0 && $76927d7fef3655e9$var$$ < $76927d7fef3655e9$var$tt - $76927d7fef3655e9$var$lt) {
        var t = {
            entryType: "first-input",
            name: $76927d7fef3655e9$var$Z.type,
            target: $76927d7fef3655e9$var$Z.target,
            cancelable: $76927d7fef3655e9$var$Z.cancelable,
            startTime: $76927d7fef3655e9$var$Z.timeStamp,
            processingStart: $76927d7fef3655e9$var$Z.timeStamp + $76927d7fef3655e9$var$$
        };
        $76927d7fef3655e9$var$et.forEach(function(e) {
            e(t);
        }), $76927d7fef3655e9$var$et = [];
    }
}, $76927d7fef3655e9$var$vt = function(t) {
    if (t.cancelable) {
        var e = (t.timeStamp > 1e12 ? new Date : performance.now()) - t.timeStamp;
        "pointerdown" == t.type ? function(t, e) {
            var n = function() {
                $76927d7fef3655e9$var$mt(t, e), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", n, $76927d7fef3655e9$var$dt), removeEventListener("pointercancel", r, $76927d7fef3655e9$var$dt);
            };
            addEventListener("pointerup", n, $76927d7fef3655e9$var$dt), addEventListener("pointercancel", r, $76927d7fef3655e9$var$dt);
        }(e, t) : $76927d7fef3655e9$var$mt(e, t);
    }
}, $76927d7fef3655e9$var$gt = function(t) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(e) {
        return t(e, $76927d7fef3655e9$var$vt, $76927d7fef3655e9$var$dt);
    });
}, $76927d7fef3655e9$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $76927d7fef3655e9$var$Tt = function(t, e) {
    e = e || {}, $76927d7fef3655e9$var$b(function() {
        var n, r = $76927d7fef3655e9$var$S(), i = $76927d7fef3655e9$var$f("FID"), a = function(t) {
            t.startTime < r.firstHiddenTime && (i.value = t.processingStart - t.startTime, i.entries.push(t), n(!0));
        }, o = function(t) {
            t.forEach(a);
        }, c = $76927d7fef3655e9$var$d("first-input", o);
        n = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$8f7f3c48ca6fbe34, e.reportAllChanges), c && ($76927d7fef3655e9$var$p($76927d7fef3655e9$var$v(function() {
            o(c.takeRecords()), c.disconnect();
        })), $76927d7fef3655e9$var$u(function() {
            var r;
            i = $76927d7fef3655e9$var$f("FID"), n = $76927d7fef3655e9$var$l(t, i, $76927d7fef3655e9$export$8f7f3c48ca6fbe34, e.reportAllChanges), $76927d7fef3655e9$var$et = [], $76927d7fef3655e9$var$$ = -1, $76927d7fef3655e9$var$Z = null, $76927d7fef3655e9$var$gt(addEventListener), r = a, $76927d7fef3655e9$var$et.push(r), $76927d7fef3655e9$var$pt();
        }));
    });
}, $76927d7fef3655e9$export$39705a25c49af873 = function(t, e) {
    $76927d7fef3655e9$var$Tt(function(e) {
        var n = function(t) {
            var e = t.entries[0], n = {
                eventTarget: $76927d7fef3655e9$var$a(e.target),
                eventType: e.name,
                eventTime: e.startTime,
                eventEntry: e,
                loadState: $76927d7fef3655e9$var$r(e.startTime)
            };
            return Object.assign(t, {
                attribution: n
            });
        }(e);
        t(n);
    }, e);
};







const $5d460bce9481376e$var$name = "@firebase/performance";
const $5d460bce9481376e$var$version = "0.7.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5d460bce9481376e$var$SDK_VERSION = $5d460bce9481376e$var$version;
/** The prefix for start User Timing marks used for creating Traces. */ const $5d460bce9481376e$var$TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
/** The prefix for stop User Timing marks used for creating Traces. */ const $5d460bce9481376e$var$TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
/** The prefix for User Timing measure used for creating Traces. */ const $5d460bce9481376e$var$TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
/** The prefix for out of the box page load Trace name. */ const $5d460bce9481376e$var$OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
const $5d460bce9481376e$var$FIRST_PAINT_COUNTER_NAME = '_fp';
const $5d460bce9481376e$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
const $5d460bce9481376e$var$FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
const $5d460bce9481376e$var$LARGEST_CONTENTFUL_PAINT_METRIC_NAME = '_lcp';
const $5d460bce9481376e$var$LARGEST_CONTENTFUL_PAINT_ATTRIBUTE_NAME = 'lcp_element';
const $5d460bce9481376e$var$INTERACTION_TO_NEXT_PAINT_METRIC_NAME = '_inp';
const $5d460bce9481376e$var$INTERACTION_TO_NEXT_PAINT_ATTRIBUTE_NAME = 'inp_interactionTarget';
const $5d460bce9481376e$var$CUMULATIVE_LAYOUT_SHIFT_METRIC_NAME = '_cls';
const $5d460bce9481376e$var$CUMULATIVE_LAYOUT_SHIFT_ATTRIBUTE_NAME = 'cls_largestShiftTarget';
const $5d460bce9481376e$var$CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
const $5d460bce9481376e$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
const $5d460bce9481376e$var$SERVICE = 'performance';
const $5d460bce9481376e$var$SERVICE_NAME = 'Performance';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5d460bce9481376e$var$ERROR_DESCRIPTION_MAP = {
    ["trace started" /* ErrorCode.TRACE_STARTED_BEFORE */ ]: 'Trace {$traceName} was started before.',
    ["trace stopped" /* ErrorCode.TRACE_STOPPED_BEFORE */ ]: 'Trace {$traceName} is not running.',
    ["nonpositive trace startTime" /* ErrorCode.NONPOSITIVE_TRACE_START_TIME */ ]: 'Trace {$traceName} startTime should be positive.',
    ["nonpositive trace duration" /* ErrorCode.NONPOSITIVE_TRACE_DURATION */ ]: 'Trace {$traceName} duration should be positive.',
    ["no window" /* ErrorCode.NO_WINDOW */ ]: 'Window is not available.',
    ["no app id" /* ErrorCode.NO_APP_ID */ ]: 'App id is not available.',
    ["no project id" /* ErrorCode.NO_PROJECT_ID */ ]: 'Project id is not available.',
    ["no api key" /* ErrorCode.NO_API_KEY */ ]: 'Api key is not available.',
    ["invalid cc log" /* ErrorCode.INVALID_CC_LOG */ ]: 'Attempted to queue invalid cc event',
    ["FB not default" /* ErrorCode.FB_NOT_DEFAULT */ ]: 'Performance can only start when Firebase app instance is the default one.',
    ["RC response not ok" /* ErrorCode.RC_NOT_OK */ ]: 'RC response is not ok',
    ["invalid attribute name" /* ErrorCode.INVALID_ATTRIBUTE_NAME */ ]: 'Attribute name {$attributeName} is invalid.',
    ["invalid attribute value" /* ErrorCode.INVALID_ATTRIBUTE_VALUE */ ]: 'Attribute value {$attributeValue} is invalid.',
    ["invalid custom metric name" /* ErrorCode.INVALID_CUSTOM_METRIC_NAME */ ]: 'Custom metric name {$customMetricName} is invalid',
    ["invalid String merger input" /* ErrorCode.INVALID_STRING_MERGER_PARAMETER */ ]: 'Input for String merger is invalid, contact support team to resolve.',
    ["already initialized" /* ErrorCode.ALREADY_INITIALIZED */ ]: "initializePerformance() has already been called with different options. To avoid this error, call initializePerformance() with the same options as when it was originally called, or call getPerformance() to return the already initialized instance."
};
const $5d460bce9481376e$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)($5d460bce9481376e$var$SERVICE, $5d460bce9481376e$var$SERVICE_NAME, $5d460bce9481376e$var$ERROR_DESCRIPTION_MAP);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5d460bce9481376e$var$consoleLogger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)($5d460bce9481376e$var$SERVICE_NAME);
$5d460bce9481376e$var$consoleLogger.logLevel = (0, $45b460d9de9b230f$export$243e62d78d3b544d).INFO;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5d460bce9481376e$var$apiInstance;
let $5d460bce9481376e$var$windowInstance;
/**
 * This class holds a reference to various browser related objects injected by
 * set methods.
 */ class $5d460bce9481376e$var$Api {
    constructor(window1){
        this.window = window1;
        if (!window1) throw $5d460bce9481376e$var$ERROR_FACTORY.create("no window" /* ErrorCode.NO_WINDOW */ );
        this.performance = window1.performance;
        this.PerformanceObserver = window1.PerformanceObserver;
        this.windowLocation = window1.location;
        this.navigator = window1.navigator;
        this.document = window1.document;
        if (this.navigator && this.navigator.cookieEnabled) // If user blocks cookies on the browser, accessing localStorage will
        // throw an exception.
        this.localStorage = window1.localStorage;
        if (window1.perfMetrics && window1.perfMetrics.onFirstInputDelay) this.onFirstInputDelay = window1.perfMetrics.onFirstInputDelay;
        this.onLCP = (0, $76927d7fef3655e9$export$947b1626ab8d5632);
        this.onINP = (0, $76927d7fef3655e9$export$7df4b36ecaed99e1);
        this.onCLS = (0, $76927d7fef3655e9$export$a7873055838e5ad8);
    }
    getUrl() {
        // Do not capture the string query part of url.
        return this.windowLocation.href.split('?')[0];
    }
    mark(name) {
        if (!this.performance || !this.performance.mark) return;
        this.performance.mark(name);
    }
    measure(measureName, mark1, mark2) {
        if (!this.performance || !this.performance.measure) return;
        this.performance.measure(measureName, mark1, mark2);
    }
    getEntriesByType(type) {
        if (!this.performance || !this.performance.getEntriesByType) return [];
        return this.performance.getEntriesByType(type);
    }
    getEntriesByName(name) {
        if (!this.performance || !this.performance.getEntriesByName) return [];
        return this.performance.getEntriesByName(name);
    }
    getTimeOrigin() {
        // Polyfill the time origin with performance.timing.navigationStart.
        return this.performance && (this.performance.timeOrigin || this.performance.timing.navigationStart);
    }
    requiredApisAvailable() {
        if (!fetch || !Promise || !(0, $c38e0f42709c826a$export$f172b7eb6cf60599)()) {
            $5d460bce9481376e$var$consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
            return false;
        }
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) {
            $5d460bce9481376e$var$consoleLogger.info('IndexedDB is not supported by current browser');
            return false;
        }
        return true;
    }
    setupObserver(entryType, callback) {
        if (!this.PerformanceObserver) return;
        const observer = new this.PerformanceObserver((list)=>{
            for (const entry of list.getEntries())// `entry` is a PerformanceEntry instance.
            callback(entry);
        });
        // Start observing the entry types you care about.
        observer.observe({
            entryTypes: [
                entryType
            ]
        });
    }
    static getInstance() {
        if ($5d460bce9481376e$var$apiInstance === undefined) $5d460bce9481376e$var$apiInstance = new $5d460bce9481376e$var$Api($5d460bce9481376e$var$windowInstance);
        return $5d460bce9481376e$var$apiInstance;
    }
}
function $5d460bce9481376e$var$setupApi(window1) {
    $5d460bce9481376e$var$windowInstance = window1;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5d460bce9481376e$var$iid;
function $5d460bce9481376e$var$getIidPromise(installationsService) {
    const iidPromise = installationsService.getId();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    iidPromise.then((iidVal)=>{
        $5d460bce9481376e$var$iid = iidVal;
    });
    return iidPromise;
}
// This method should be used after the iid is retrieved by getIidPromise method.
function $5d460bce9481376e$var$getIid() {
    return $5d460bce9481376e$var$iid;
}
function $5d460bce9481376e$var$getAuthTokenPromise(installationsService) {
    const authTokenPromise = installationsService.getToken();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authTokenPromise.then((authTokenVal)=>{});
    return authTokenPromise;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5d460bce9481376e$var$mergeStrings(part1, part2) {
    const sizeDiff = part1.length - part2.length;
    if (sizeDiff < 0 || sizeDiff > 1) throw $5d460bce9481376e$var$ERROR_FACTORY.create("invalid String merger input" /* ErrorCode.INVALID_STRING_MERGER_PARAMETER */ );
    const resultArray = [];
    for(let i = 0; i < part1.length; i++){
        resultArray.push(part1.charAt(i));
        if (part2.length > i) resultArray.push(part2.charAt(i));
    }
    return resultArray.join('');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5d460bce9481376e$var$settingsServiceInstance;
class $5d460bce9481376e$var$SettingsService {
    constructor(){
        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
        this.instrumentationEnabled = true;
        // The variable which controls logging of custom traces.
        this.dataCollectionEnabled = true;
        // Configuration flags set through remote config.
        this.loggingEnabled = false;
        // Sampling rate between 0 and 1.
        this.tracesSamplingRate = 1;
        this.networkRequestsSamplingRate = 1;
        // Address of logging service.
        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
        // Performance event transport endpoint URL which should be compatible with proto3.
        // New Address for transport service, not configurable via Remote Config.
        this.flTransportEndpointUrl = $5d460bce9481376e$var$mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
        this.transportKey = $5d460bce9481376e$var$mergeStrings('AzSC8r6ReiGqFMyfvgow', 'Iayx0u-XT3vksVM-pIV');
        // Source type for performance event logs.
        this.logSource = 462;
        // Flags which control per session logging of traces and network requests.
        this.logTraceAfterSampling = false;
        this.logNetworkAfterSampling = false;
        // TTL of config retrieved from remote config in hours.
        this.configTimeToLive = 12;
    }
    getFlTransportFullUrl() {
        return this.flTransportEndpointUrl.concat('?key=', this.transportKey);
    }
    static getInstance() {
        if ($5d460bce9481376e$var$settingsServiceInstance === undefined) $5d460bce9481376e$var$settingsServiceInstance = new $5d460bce9481376e$var$SettingsService();
        return $5d460bce9481376e$var$settingsServiceInstance;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5d460bce9481376e$var$VisibilityState;
(function(VisibilityState) {
    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
})($5d460bce9481376e$var$VisibilityState || ($5d460bce9481376e$var$VisibilityState = {}));
const $5d460bce9481376e$var$RESERVED_ATTRIBUTE_PREFIXES = [
    'firebase_',
    'google_',
    'ga_'
];
const $5d460bce9481376e$var$ATTRIBUTE_FORMAT_REGEX = new RegExp('^[a-zA-Z]\\w*$');
const $5d460bce9481376e$var$MAX_ATTRIBUTE_NAME_LENGTH = 40;
const $5d460bce9481376e$var$MAX_ATTRIBUTE_VALUE_LENGTH = 100;
function $5d460bce9481376e$var$getServiceWorkerStatus() {
    const navigator1 = $5d460bce9481376e$var$Api.getInstance().navigator;
    if (navigator1 === null || navigator1 === void 0 ? void 0 : navigator1.serviceWorker) {
        if (navigator1.serviceWorker.controller) return 2 /* ServiceWorkerStatus.CONTROLLED */ ;
        else return 3 /* ServiceWorkerStatus.UNCONTROLLED */ ;
    } else return 1 /* ServiceWorkerStatus.UNSUPPORTED */ ;
}
function $5d460bce9481376e$var$getVisibilityState() {
    const document = $5d460bce9481376e$var$Api.getInstance().document;
    const visibilityState = document.visibilityState;
    switch(visibilityState){
        case 'visible':
            return $5d460bce9481376e$var$VisibilityState.VISIBLE;
        case 'hidden':
            return $5d460bce9481376e$var$VisibilityState.HIDDEN;
        default:
            return $5d460bce9481376e$var$VisibilityState.UNKNOWN;
    }
}
function $5d460bce9481376e$var$getEffectiveConnectionType() {
    const navigator1 = $5d460bce9481376e$var$Api.getInstance().navigator;
    const navigatorConnection = navigator1.connection;
    const effectiveType = navigatorConnection && navigatorConnection.effectiveType;
    switch(effectiveType){
        case 'slow-2g':
            return 1 /* EffectiveConnectionType.CONNECTION_SLOW_2G */ ;
        case '2g':
            return 2 /* EffectiveConnectionType.CONNECTION_2G */ ;
        case '3g':
            return 3 /* EffectiveConnectionType.CONNECTION_3G */ ;
        case '4g':
            return 4 /* EffectiveConnectionType.CONNECTION_4G */ ;
        default:
            return 0 /* EffectiveConnectionType.UNKNOWN */ ;
    }
}
function $5d460bce9481376e$var$isValidCustomAttributeName(name) {
    if (name.length === 0 || name.length > $5d460bce9481376e$var$MAX_ATTRIBUTE_NAME_LENGTH) return false;
    const matchesReservedPrefix = $5d460bce9481376e$var$RESERVED_ATTRIBUTE_PREFIXES.some((prefix)=>name.startsWith(prefix));
    return !matchesReservedPrefix && !!name.match($5d460bce9481376e$var$ATTRIBUTE_FORMAT_REGEX);
}
function $5d460bce9481376e$var$isValidCustomAttributeValue(value) {
    return value.length !== 0 && value.length <= $5d460bce9481376e$var$MAX_ATTRIBUTE_VALUE_LENGTH;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5d460bce9481376e$var$getAppId(firebaseApp) {
    var _a;
    const appId = (_a = firebaseApp.options) === null || _a === void 0 ? void 0 : _a.appId;
    if (!appId) throw $5d460bce9481376e$var$ERROR_FACTORY.create("no app id" /* ErrorCode.NO_APP_ID */ );
    return appId;
}
function $5d460bce9481376e$var$getProjectId(firebaseApp) {
    var _a;
    const projectId = (_a = firebaseApp.options) === null || _a === void 0 ? void 0 : _a.projectId;
    if (!projectId) throw $5d460bce9481376e$var$ERROR_FACTORY.create("no project id" /* ErrorCode.NO_PROJECT_ID */ );
    return projectId;
}
function $5d460bce9481376e$var$getApiKey(firebaseApp) {
    var _a;
    const apiKey = (_a = firebaseApp.options) === null || _a === void 0 ? void 0 : _a.apiKey;
    if (!apiKey) throw $5d460bce9481376e$var$ERROR_FACTORY.create("no api key" /* ErrorCode.NO_API_KEY */ );
    return apiKey;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5d460bce9481376e$var$REMOTE_CONFIG_SDK_VERSION = '0.0.1';
// These values will be used if the remote config object is successfully
// retrieved, but the template does not have these fields.
const $5d460bce9481376e$var$DEFAULT_CONFIGS = {
    loggingEnabled: true
};
const $5d460bce9481376e$var$FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
function $5d460bce9481376e$var$getConfig(performanceController, iid) {
    const config = $5d460bce9481376e$var$getStoredConfig();
    if (config) {
        $5d460bce9481376e$var$processConfig(config);
        return Promise.resolve();
    }
    return $5d460bce9481376e$var$getRemoteConfig(performanceController, iid).then($5d460bce9481376e$var$processConfig).then((config)=>$5d460bce9481376e$var$storeConfig(config), /** Do nothing for error, use defaults set in settings service. */ ()=>{});
}
function $5d460bce9481376e$var$getStoredConfig() {
    const localStorage = $5d460bce9481376e$var$Api.getInstance().localStorage;
    if (!localStorage) return;
    const expiryString = localStorage.getItem($5d460bce9481376e$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
    if (!expiryString || !$5d460bce9481376e$var$configValid(expiryString)) return;
    const configStringified = localStorage.getItem($5d460bce9481376e$var$CONFIG_LOCAL_STORAGE_KEY);
    if (!configStringified) return;
    try {
        const configResponse = JSON.parse(configStringified);
        return configResponse;
    } catch (_a) {
        return;
    }
}
function $5d460bce9481376e$var$storeConfig(config) {
    const localStorage = $5d460bce9481376e$var$Api.getInstance().localStorage;
    if (!config || !localStorage) return;
    localStorage.setItem($5d460bce9481376e$var$CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
    localStorage.setItem($5d460bce9481376e$var$CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() + $5d460bce9481376e$var$SettingsService.getInstance().configTimeToLive * 3600000));
}
const $5d460bce9481376e$var$COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
function $5d460bce9481376e$var$getRemoteConfig(performanceController, iid) {
    // Perf needs auth token only to retrieve remote config.
    return $5d460bce9481376e$var$getAuthTokenPromise(performanceController.installations).then((authToken)=>{
        const projectId = $5d460bce9481376e$var$getProjectId(performanceController.app);
        const apiKey = $5d460bce9481376e$var$getApiKey(performanceController.app);
        const configEndPoint = `https://firebaseremoteconfig.googleapis.com/v1/projects/${projectId}/namespaces/fireperf:fetch?key=${apiKey}`;
        const request = new Request(configEndPoint, {
            method: 'POST',
            headers: {
                Authorization: `${$5d460bce9481376e$var$FIS_AUTH_PREFIX} ${authToken}`
            },
            /* eslint-disable camelcase */ body: JSON.stringify({
                app_instance_id: iid,
                app_instance_id_token: authToken,
                app_id: $5d460bce9481376e$var$getAppId(performanceController.app),
                app_version: $5d460bce9481376e$var$SDK_VERSION,
                sdk_version: $5d460bce9481376e$var$REMOTE_CONFIG_SDK_VERSION
            })
        });
        return fetch(request).then((response)=>{
            if (response.ok) return response.json();
            // In case response is not ok. This will be caught by catch.
            throw $5d460bce9481376e$var$ERROR_FACTORY.create("RC response not ok" /* ErrorCode.RC_NOT_OK */ );
        });
    }).catch(()=>{
        $5d460bce9481376e$var$consoleLogger.info($5d460bce9481376e$var$COULD_NOT_GET_CONFIG_MSG);
        return undefined;
    });
}
/**
 * Processes config coming either from calling RC or from local storage.
 * This method only runs if call is successful or config in storage
 * is valid.
 */ function $5d460bce9481376e$var$processConfig(config) {
    if (!config) return config;
    const settingsServiceInstance = $5d460bce9481376e$var$SettingsService.getInstance();
    const entries = config.entries || {};
    if (entries.fpr_enabled !== undefined) // TODO: Change the assignment of loggingEnabled once the received type is
    // known.
    settingsServiceInstance.loggingEnabled = String(entries.fpr_enabled) === 'true';
    else // Config retrieved successfully, but there is no fpr_enabled in template.
    // Use secondary configs value.
    settingsServiceInstance.loggingEnabled = $5d460bce9481376e$var$DEFAULT_CONFIGS.loggingEnabled;
    if (entries.fpr_log_source) settingsServiceInstance.logSource = Number(entries.fpr_log_source);
    else if ($5d460bce9481376e$var$DEFAULT_CONFIGS.logSource) settingsServiceInstance.logSource = $5d460bce9481376e$var$DEFAULT_CONFIGS.logSource;
    if (entries.fpr_log_endpoint_url) settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
    else if ($5d460bce9481376e$var$DEFAULT_CONFIGS.logEndPointUrl) settingsServiceInstance.logEndPointUrl = $5d460bce9481376e$var$DEFAULT_CONFIGS.logEndPointUrl;
    // Key from Remote Config has to be non-empty string, otherwise use local value.
    if (entries.fpr_log_transport_key) settingsServiceInstance.transportKey = entries.fpr_log_transport_key;
    else if ($5d460bce9481376e$var$DEFAULT_CONFIGS.transportKey) settingsServiceInstance.transportKey = $5d460bce9481376e$var$DEFAULT_CONFIGS.transportKey;
    if (entries.fpr_vc_network_request_sampling_rate !== undefined) settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
    else if ($5d460bce9481376e$var$DEFAULT_CONFIGS.networkRequestsSamplingRate !== undefined) settingsServiceInstance.networkRequestsSamplingRate = $5d460bce9481376e$var$DEFAULT_CONFIGS.networkRequestsSamplingRate;
    if (entries.fpr_vc_trace_sampling_rate !== undefined) settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
    else if ($5d460bce9481376e$var$DEFAULT_CONFIGS.tracesSamplingRate !== undefined) settingsServiceInstance.tracesSamplingRate = $5d460bce9481376e$var$DEFAULT_CONFIGS.tracesSamplingRate;
    // Set the per session trace and network logging flags.
    settingsServiceInstance.logTraceAfterSampling = $5d460bce9481376e$var$shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
    settingsServiceInstance.logNetworkAfterSampling = $5d460bce9481376e$var$shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
    return config;
}
function $5d460bce9481376e$var$configValid(expiry) {
    return Number(expiry) > Date.now();
}
function $5d460bce9481376e$var$shouldLogAfterSampling(samplingRate) {
    return Math.random() <= samplingRate;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5d460bce9481376e$var$initializationStatus = 1 /* InitializationStatus.notInitialized */ ;
let $5d460bce9481376e$var$initializationPromise;
function $5d460bce9481376e$var$getInitializationPromise(performanceController) {
    $5d460bce9481376e$var$initializationStatus = 2 /* InitializationStatus.initializationPending */ ;
    $5d460bce9481376e$var$initializationPromise = $5d460bce9481376e$var$initializationPromise || $5d460bce9481376e$var$initializePerf(performanceController);
    return $5d460bce9481376e$var$initializationPromise;
}
function $5d460bce9481376e$var$isPerfInitialized() {
    return $5d460bce9481376e$var$initializationStatus === 3 /* InitializationStatus.initialized */ ;
}
function $5d460bce9481376e$var$initializePerf(performanceController) {
    return $5d460bce9481376e$var$getDocumentReadyComplete().then(()=>$5d460bce9481376e$var$getIidPromise(performanceController.installations)).then((iid)=>$5d460bce9481376e$var$getConfig(performanceController, iid)).then(()=>$5d460bce9481376e$var$changeInitializationStatus(), ()=>$5d460bce9481376e$var$changeInitializationStatus());
}
/**
 * Returns a promise which resolves whenever the document readystate is complete or
 * immediately if it is called after page load complete.
 */ function $5d460bce9481376e$var$getDocumentReadyComplete() {
    const document = $5d460bce9481376e$var$Api.getInstance().document;
    return new Promise((resolve)=>{
        if (document && document.readyState !== 'complete') {
            const handler = ()=>{
                if (document.readyState === 'complete') {
                    document.removeEventListener('readystatechange', handler);
                    resolve();
                }
            };
            document.addEventListener('readystatechange', handler);
        } else resolve();
    });
}
function $5d460bce9481376e$var$changeInitializationStatus() {
    $5d460bce9481376e$var$initializationStatus = 3 /* InitializationStatus.initialized */ ;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5d460bce9481376e$var$DEFAULT_SEND_INTERVAL_MS = 10000;
const $5d460bce9481376e$var$INITIAL_SEND_TIME_DELAY_MS = 5500;
const $5d460bce9481376e$var$MAX_EVENT_COUNT_PER_REQUEST = 1000;
const $5d460bce9481376e$var$DEFAULT_REMAINING_TRIES = 3;
let $5d460bce9481376e$var$remainingTries = $5d460bce9481376e$var$DEFAULT_REMAINING_TRIES;
/* eslint-enable camelcase */ let $5d460bce9481376e$var$queue = [];
let $5d460bce9481376e$var$isTransportSetup = false;
function $5d460bce9481376e$var$setupTransportService() {
    if (!$5d460bce9481376e$var$isTransportSetup) {
        $5d460bce9481376e$var$processQueue($5d460bce9481376e$var$INITIAL_SEND_TIME_DELAY_MS);
        $5d460bce9481376e$var$isTransportSetup = true;
    }
}
function $5d460bce9481376e$var$processQueue(timeOffset) {
    setTimeout(()=>{
        // If there is no remainingTries left, stop retrying.
        if ($5d460bce9481376e$var$remainingTries <= 0) return;
        if ($5d460bce9481376e$var$queue.length > 0) $5d460bce9481376e$var$dispatchQueueEvents();
        $5d460bce9481376e$var$processQueue($5d460bce9481376e$var$DEFAULT_SEND_INTERVAL_MS);
    }, timeOffset);
}
function $5d460bce9481376e$var$dispatchQueueEvents() {
    // Extract events up to the maximum cap of single logRequest from top of "official queue".
    // The staged events will be used for current logRequest attempt, remaining events will be kept
    // for next attempt.
    const staged = $5d460bce9481376e$var$queue.splice(0, $5d460bce9481376e$var$MAX_EVENT_COUNT_PER_REQUEST);
    /* eslint-disable camelcase */ // We will pass the JSON serialized event to the backend.
    const log_event = staged.map((evt)=>({
            source_extension_json_proto3: evt.message,
            event_time_ms: String(evt.eventTime)
        }));
    const data = {
        request_time_ms: String(Date.now()),
        client_info: {
            client_type: 1,
            js_client_info: {}
        },
        log_source: $5d460bce9481376e$var$SettingsService.getInstance().logSource,
        log_event: log_event
    };
    /* eslint-enable camelcase */ $5d460bce9481376e$var$postToFlEndpoint(data).then(()=>{
        $5d460bce9481376e$var$remainingTries = $5d460bce9481376e$var$DEFAULT_REMAINING_TRIES;
    }).catch(()=>{
        // If the request fails for some reason, add the events that were attempted
        // back to the primary queue to retry later.
        $5d460bce9481376e$var$queue = [
            ...staged,
            ...$5d460bce9481376e$var$queue
        ];
        $5d460bce9481376e$var$remainingTries--;
        $5d460bce9481376e$var$consoleLogger.info(`Tries left: ${$5d460bce9481376e$var$remainingTries}.`);
        $5d460bce9481376e$var$processQueue($5d460bce9481376e$var$DEFAULT_SEND_INTERVAL_MS);
    });
}
function $5d460bce9481376e$var$postToFlEndpoint(data) {
    const flTransportFullUrl = $5d460bce9481376e$var$SettingsService.getInstance().getFlTransportFullUrl();
    const body = JSON.stringify(data);
    return navigator.sendBeacon && navigator.sendBeacon(flTransportFullUrl, body) ? Promise.resolve() : fetch(flTransportFullUrl, {
        method: 'POST',
        body: body,
        keepalive: true
    }).then();
}
function $5d460bce9481376e$var$addToQueue(evt) {
    if (!evt.eventTime || !evt.message) throw $5d460bce9481376e$var$ERROR_FACTORY.create("invalid cc log" /* ErrorCode.INVALID_CC_LOG */ );
    // Add the new event to the queue.
    $5d460bce9481376e$var$queue = [
        ...$5d460bce9481376e$var$queue,
        evt
    ];
}
/** Log handler for cc service to send the performance logs to the server. */ function $5d460bce9481376e$var$transportHandler(// eslint-disable-next-line @typescript-eslint/no-explicit-any
serializer) {
    return (...args)=>{
        const message = serializer(...args);
        $5d460bce9481376e$var$addToQueue({
            message: message,
            eventTime: Date.now()
        });
    };
}
/**
 * Force flush the queued events. Useful at page unload time to ensure all
 * events are uploaded.
 */ function $5d460bce9481376e$var$flushQueuedEvents() {
    while($5d460bce9481376e$var$queue.length > 0)$5d460bce9481376e$var$dispatchQueueEvents();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5d460bce9481376e$var$logger;
//
// This method is not called before initialization.
function $5d460bce9481376e$var$sendLog(resource, resourceType) {
    if (!$5d460bce9481376e$var$logger) $5d460bce9481376e$var$logger = {
        send: $5d460bce9481376e$var$transportHandler($5d460bce9481376e$var$serializer),
        flush: $5d460bce9481376e$var$flushQueuedEvents
    };
    $5d460bce9481376e$var$logger.send(resource, resourceType);
}
function $5d460bce9481376e$var$logTrace(trace) {
    const settingsService = $5d460bce9481376e$var$SettingsService.getInstance();
    // Do not log if trace is auto generated and instrumentation is disabled.
    if (!settingsService.instrumentationEnabled && trace.isAuto) return;
    // Do not log if trace is custom and data collection is disabled.
    if (!settingsService.dataCollectionEnabled && !trace.isAuto) return;
    // Do not log if required apis are not available.
    if (!$5d460bce9481376e$var$Api.getInstance().requiredApisAvailable()) return;
    if ($5d460bce9481376e$var$isPerfInitialized()) $5d460bce9481376e$var$sendTraceLog(trace);
    else // Custom traces can be used before the initialization but logging
    // should wait until after.
    $5d460bce9481376e$var$getInitializationPromise(trace.performanceController).then(()=>$5d460bce9481376e$var$sendTraceLog(trace), ()=>$5d460bce9481376e$var$sendTraceLog(trace));
}
function $5d460bce9481376e$var$flushLogs() {
    if ($5d460bce9481376e$var$logger) $5d460bce9481376e$var$logger.flush();
}
function $5d460bce9481376e$var$sendTraceLog(trace) {
    if (!$5d460bce9481376e$var$getIid()) return;
    const settingsService = $5d460bce9481376e$var$SettingsService.getInstance();
    if (!settingsService.loggingEnabled || !settingsService.logTraceAfterSampling) return;
    $5d460bce9481376e$var$sendLog(trace, 1 /* ResourceType.Trace */ );
}
function $5d460bce9481376e$var$logNetworkRequest(networkRequest) {
    const settingsService = $5d460bce9481376e$var$SettingsService.getInstance();
    // Do not log network requests if instrumentation is disabled.
    if (!settingsService.instrumentationEnabled) return;
    // Do not log the js sdk's call to transport service domain to avoid unnecessary cycle.
    // Need to blacklist both old and new endpoints to avoid migration gap.
    const networkRequestUrl = networkRequest.url;
    // Blacklist old log endpoint and new transport endpoint.
    // Because Performance SDK doesn't instrument requests sent from SDK itself.
    const logEndpointUrl = settingsService.logEndPointUrl.split('?')[0];
    const flEndpointUrl = settingsService.flTransportEndpointUrl.split('?')[0];
    if (networkRequestUrl === logEndpointUrl || networkRequestUrl === flEndpointUrl) return;
    if (!settingsService.loggingEnabled || !settingsService.logNetworkAfterSampling) return;
    $5d460bce9481376e$var$sendLog(networkRequest, 0 /* ResourceType.NetworkRequest */ );
}
function $5d460bce9481376e$var$serializer(resource, resourceType) {
    if (resourceType === 0 /* ResourceType.NetworkRequest */ ) return $5d460bce9481376e$var$serializeNetworkRequest(resource);
    return $5d460bce9481376e$var$serializeTrace(resource);
}
function $5d460bce9481376e$var$serializeNetworkRequest(networkRequest) {
    const networkRequestMetric = {
        url: networkRequest.url,
        http_method: networkRequest.httpMethod || 0,
        http_response_code: 200,
        response_payload_bytes: networkRequest.responsePayloadBytes,
        client_start_time_us: networkRequest.startTimeUs,
        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
    };
    const perfMetric = {
        application_info: $5d460bce9481376e$var$getApplicationInfo(networkRequest.performanceController.app),
        network_request_metric: networkRequestMetric
    };
    return JSON.stringify(perfMetric);
}
function $5d460bce9481376e$var$serializeTrace(trace) {
    const traceMetric = {
        name: trace.name,
        is_auto: trace.isAuto,
        client_start_time_us: trace.startTimeUs,
        duration_us: trace.durationUs
    };
    if (Object.keys(trace.counters).length !== 0) traceMetric.counters = trace.counters;
    const customAttributes = trace.getAttributes();
    if (Object.keys(customAttributes).length !== 0) traceMetric.custom_attributes = customAttributes;
    const perfMetric = {
        application_info: $5d460bce9481376e$var$getApplicationInfo(trace.performanceController.app),
        trace_metric: traceMetric
    };
    return JSON.stringify(perfMetric);
}
function $5d460bce9481376e$var$getApplicationInfo(firebaseApp) {
    return {
        google_app_id: $5d460bce9481376e$var$getAppId(firebaseApp),
        app_instance_id: $5d460bce9481376e$var$getIid(),
        web_app_info: {
            sdk_version: $5d460bce9481376e$var$SDK_VERSION,
            page_url: $5d460bce9481376e$var$Api.getInstance().getUrl(),
            service_worker_status: $5d460bce9481376e$var$getServiceWorkerStatus(),
            visibility_state: $5d460bce9481376e$var$getVisibilityState(),
            effective_connection_type: $5d460bce9481376e$var$getEffectiveConnectionType()
        },
        application_process_state: 0
    };
}
/* eslint-enable camelcase */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5d460bce9481376e$var$createNetworkRequestEntry(performanceController, entry) {
    const performanceEntry = entry;
    if (!performanceEntry || performanceEntry.responseStart === undefined) return;
    const timeOrigin = $5d460bce9481376e$var$Api.getInstance().getTimeOrigin();
    const startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
    const timeToResponseInitiatedUs = performanceEntry.responseStart ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000) : undefined;
    const timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
    // Remove the query params from logged network request url.
    const url = performanceEntry.name && performanceEntry.name.split('?')[0];
    const networkRequest = {
        performanceController: performanceController,
        url: url,
        responsePayloadBytes: performanceEntry.transferSize,
        startTimeUs: startTimeUs,
        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
        timeToResponseCompletedUs: timeToResponseCompletedUs
    };
    $5d460bce9481376e$var$logNetworkRequest(networkRequest);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5d460bce9481376e$var$MAX_METRIC_NAME_LENGTH = 100;
const $5d460bce9481376e$var$RESERVED_AUTO_PREFIX = '_';
const $5d460bce9481376e$var$oobMetrics = [
    $5d460bce9481376e$var$FIRST_PAINT_COUNTER_NAME,
    $5d460bce9481376e$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
    $5d460bce9481376e$var$FIRST_INPUT_DELAY_COUNTER_NAME,
    $5d460bce9481376e$var$LARGEST_CONTENTFUL_PAINT_METRIC_NAME,
    $5d460bce9481376e$var$CUMULATIVE_LAYOUT_SHIFT_METRIC_NAME,
    $5d460bce9481376e$var$INTERACTION_TO_NEXT_PAINT_METRIC_NAME
];
/**
 * Returns true if the metric is custom and does not start with reserved prefix, or if
 * the metric is one of out of the box page load trace metrics.
 */ function $5d460bce9481376e$var$isValidMetricName(name, traceName) {
    if (name.length === 0 || name.length > $5d460bce9481376e$var$MAX_METRIC_NAME_LENGTH) return false;
    return traceName && traceName.startsWith($5d460bce9481376e$var$OOB_TRACE_PAGE_LOAD_PREFIX) && $5d460bce9481376e$var$oobMetrics.indexOf(name) > -1 || !name.startsWith($5d460bce9481376e$var$RESERVED_AUTO_PREFIX);
}
/**
 * Converts the provided value to an integer value to be used in case of a metric.
 * @param providedValue Provided number value of the metric that needs to be converted to an integer.
 *
 * @returns Converted integer number to be set for the metric.
 */ function $5d460bce9481376e$var$convertMetricValueToInteger(providedValue) {
    const valueAsInteger = Math.floor(providedValue);
    if (valueAsInteger < providedValue) $5d460bce9481376e$var$consoleLogger.info(`Metric value should be an Integer, setting the value as : ${valueAsInteger}.`);
    return valueAsInteger;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5d460bce9481376e$var$Trace {
    /**
     * @param performanceController The performance controller running.
     * @param name The name of the trace.
     * @param isAuto If the trace is auto-instrumented.
     * @param traceMeasureName The name of the measure marker in user timing specification. This field
     * is only set when the trace is built for logging when the user directly uses the user timing
     * api (performance.mark and performance.measure).
     */ constructor(performanceController, name, isAuto = false, traceMeasureName){
        this.performanceController = performanceController;
        this.name = name;
        this.isAuto = isAuto;
        this.state = 1 /* TraceState.UNINITIALIZED */ ;
        this.customAttributes = {};
        this.counters = {};
        this.api = $5d460bce9481376e$var$Api.getInstance();
        this.randomId = Math.floor(Math.random() * 1000000);
        if (!this.isAuto) {
            this.traceStartMark = `${$5d460bce9481376e$var$TRACE_START_MARK_PREFIX}-${this.randomId}-${this.name}`;
            this.traceStopMark = `${$5d460bce9481376e$var$TRACE_STOP_MARK_PREFIX}-${this.randomId}-${this.name}`;
            this.traceMeasure = traceMeasureName || `${$5d460bce9481376e$var$TRACE_MEASURE_PREFIX}-${this.randomId}-${this.name}`;
            if (traceMeasureName) // For the case of direct user timing traces, no start stop will happen. The measure object
            // is already available.
            this.calculateTraceMetrics();
        }
    }
    /**
     * Starts a trace. The measurement of the duration starts at this point.
     */ start() {
        if (this.state !== 1 /* TraceState.UNINITIALIZED */ ) throw $5d460bce9481376e$var$ERROR_FACTORY.create("trace started" /* ErrorCode.TRACE_STARTED_BEFORE */ , {
            traceName: this.name
        });
        this.api.mark(this.traceStartMark);
        this.state = 2 /* TraceState.RUNNING */ ;
    }
    /**
     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
     * is logged.
     */ stop() {
        if (this.state !== 2 /* TraceState.RUNNING */ ) throw $5d460bce9481376e$var$ERROR_FACTORY.create("trace stopped" /* ErrorCode.TRACE_STOPPED_BEFORE */ , {
            traceName: this.name
        });
        this.state = 3 /* TraceState.TERMINATED */ ;
        this.api.mark(this.traceStopMark);
        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
        this.calculateTraceMetrics();
        $5d460bce9481376e$var$logTrace(this);
    }
    /**
     * Records a trace with predetermined values. If this method is used a trace is created and logged
     * directly. No need to use start and stop methods.
     * @param startTime Trace start time since epoch in millisec
     * @param duration The duration of the trace in millisec
     * @param options An object which can optionally hold maps of custom metrics and custom attributes
     */ record(startTime, duration, options) {
        if (startTime <= 0) throw $5d460bce9481376e$var$ERROR_FACTORY.create("nonpositive trace startTime" /* ErrorCode.NONPOSITIVE_TRACE_START_TIME */ , {
            traceName: this.name
        });
        if (duration <= 0) throw $5d460bce9481376e$var$ERROR_FACTORY.create("nonpositive trace duration" /* ErrorCode.NONPOSITIVE_TRACE_DURATION */ , {
            traceName: this.name
        });
        this.durationUs = Math.floor(duration * 1000);
        this.startTimeUs = Math.floor(startTime * 1000);
        if (options && options.attributes) this.customAttributes = Object.assign({}, options.attributes);
        if (options && options.metrics) {
            for (const metricName of Object.keys(options.metrics))if (!isNaN(Number(options.metrics[metricName]))) this.counters[metricName] = Math.floor(Number(options.metrics[metricName]));
        }
        $5d460bce9481376e$var$logTrace(this);
    }
    /**
     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
     * custom metric if one with the given name does not exist. The value will be floored down to an
     * integer.
     * @param counter Name of the custom metric
     * @param numAsInteger Increment by value
     */ incrementMetric(counter, numAsInteger = 1) {
        if (this.counters[counter] === undefined) this.putMetric(counter, numAsInteger);
        else this.putMetric(counter, this.counters[counter] + numAsInteger);
    }
    /**
     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
     * given name does not exist. The value will be floored down to an integer.
     * @param counter Name of the custom metric
     * @param numAsInteger Set custom metric to this value
     */ putMetric(counter, numAsInteger) {
        if ($5d460bce9481376e$var$isValidMetricName(counter, this.name)) this.counters[counter] = $5d460bce9481376e$var$convertMetricValueToInteger(numAsInteger !== null && numAsInteger !== void 0 ? numAsInteger : 0);
        else throw $5d460bce9481376e$var$ERROR_FACTORY.create("invalid custom metric name" /* ErrorCode.INVALID_CUSTOM_METRIC_NAME */ , {
            customMetricName: counter
        });
    }
    /**
     * Returns the value of the custom metric by that name. If a custom metric with that name does
     * not exist will return zero.
     * @param counter
     */ getMetric(counter) {
        return this.counters[counter] || 0;
    }
    /**
     * Sets a custom attribute of a trace to a certain value.
     * @param attr
     * @param value
     */ putAttribute(attr, value) {
        const isValidName = $5d460bce9481376e$var$isValidCustomAttributeName(attr);
        const isValidValue = $5d460bce9481376e$var$isValidCustomAttributeValue(value);
        if (isValidName && isValidValue) {
            this.customAttributes[attr] = value;
            return;
        }
        // Throw appropriate error when the attribute name or value is invalid.
        if (!isValidName) throw $5d460bce9481376e$var$ERROR_FACTORY.create("invalid attribute name" /* ErrorCode.INVALID_ATTRIBUTE_NAME */ , {
            attributeName: attr
        });
        if (!isValidValue) throw $5d460bce9481376e$var$ERROR_FACTORY.create("invalid attribute value" /* ErrorCode.INVALID_ATTRIBUTE_VALUE */ , {
            attributeValue: value
        });
    }
    /**
     * Retrieves the value a custom attribute of a trace is set to.
     * @param attr
     */ getAttribute(attr) {
        return this.customAttributes[attr];
    }
    removeAttribute(attr) {
        if (this.customAttributes[attr] === undefined) return;
        delete this.customAttributes[attr];
    }
    getAttributes() {
        return Object.assign({}, this.customAttributes);
    }
    setStartTime(startTime) {
        this.startTimeUs = startTime;
    }
    setDuration(duration) {
        this.durationUs = duration;
    }
    /**
     * Calculates and assigns the duration and start time of the trace using the measure performance
     * entry.
     */ calculateTraceMetrics() {
        const perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
        const perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
        if (perfMeasureEntry) {
            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
        }
    }
    /**
     * @param navigationTimings A single element array which contains the navigationTIming object of
     * the page load
     * @param paintTimings A array which contains paintTiming object of the page load
     * @param firstInputDelay First input delay in millisec
     */ static createOobTrace(performanceController, navigationTimings, paintTimings, webVitalMetrics, firstInputDelay) {
        const route = $5d460bce9481376e$var$Api.getInstance().getUrl();
        if (!route) return;
        const trace = new $5d460bce9481376e$var$Trace(performanceController, $5d460bce9481376e$var$OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
        const timeOriginUs = Math.floor($5d460bce9481376e$var$Api.getInstance().getTimeOrigin() * 1000);
        trace.setStartTime(timeOriginUs);
        // navigationTimings includes only one element.
        if (navigationTimings && navigationTimings[0]) {
            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
            trace.putMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
            trace.putMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
            trace.putMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
        }
        const FIRST_PAINT = 'first-paint';
        const FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
        if (paintTimings) {
            const firstPaint = paintTimings.find((paintObject)=>paintObject.name === FIRST_PAINT);
            if (firstPaint && firstPaint.startTime) trace.putMetric($5d460bce9481376e$var$FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
            const firstContentfulPaint = paintTimings.find((paintObject)=>paintObject.name === FIRST_CONTENTFUL_PAINT);
            if (firstContentfulPaint && firstContentfulPaint.startTime) trace.putMetric($5d460bce9481376e$var$FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
            if (firstInputDelay) trace.putMetric($5d460bce9481376e$var$FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
        }
        this.addWebVitalMetric(trace, $5d460bce9481376e$var$LARGEST_CONTENTFUL_PAINT_METRIC_NAME, $5d460bce9481376e$var$LARGEST_CONTENTFUL_PAINT_ATTRIBUTE_NAME, webVitalMetrics.lcp);
        this.addWebVitalMetric(trace, $5d460bce9481376e$var$CUMULATIVE_LAYOUT_SHIFT_METRIC_NAME, $5d460bce9481376e$var$CUMULATIVE_LAYOUT_SHIFT_ATTRIBUTE_NAME, webVitalMetrics.cls);
        this.addWebVitalMetric(trace, $5d460bce9481376e$var$INTERACTION_TO_NEXT_PAINT_METRIC_NAME, $5d460bce9481376e$var$INTERACTION_TO_NEXT_PAINT_ATTRIBUTE_NAME, webVitalMetrics.inp);
        // Page load logs are sent at unload time and so should be logged and
        // flushed immediately.
        $5d460bce9481376e$var$logTrace(trace);
        $5d460bce9481376e$var$flushLogs();
    }
    static addWebVitalMetric(trace, metricKey, attributeKey, metric) {
        if (metric) {
            trace.putMetric(metricKey, Math.floor(metric.value * 1000));
            if (metric.elementAttribution) trace.putAttribute(attributeKey, metric.elementAttribution);
        }
    }
    static createUserTimingTrace(performanceController, measureName) {
        const trace = new $5d460bce9481376e$var$Trace(performanceController, measureName, false, measureName);
        $5d460bce9481376e$var$logTrace(trace);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $5d460bce9481376e$var$webVitalMetrics = {};
let $5d460bce9481376e$var$sentPageLoadTrace = false;
let $5d460bce9481376e$var$firstInputDelay;
function $5d460bce9481376e$var$setupOobResources(performanceController) {
    // Do not initialize unless iid is available.
    if (!$5d460bce9481376e$var$getIid()) return;
    // The load event might not have fired yet, and that means performance
    // navigation timing object has a duration of 0. The setup should run after
    // all current tasks in js queue.
    setTimeout(()=>$5d460bce9481376e$var$setupOobTraces(performanceController), 0);
    setTimeout(()=>$5d460bce9481376e$var$setupNetworkRequests(performanceController), 0);
    setTimeout(()=>$5d460bce9481376e$var$setupUserTimingTraces(performanceController), 0);
}
function $5d460bce9481376e$var$setupNetworkRequests(performanceController) {
    const api = $5d460bce9481376e$var$Api.getInstance();
    const resources = api.getEntriesByType('resource');
    for (const resource of resources)$5d460bce9481376e$var$createNetworkRequestEntry(performanceController, resource);
    api.setupObserver('resource', (entry)=>$5d460bce9481376e$var$createNetworkRequestEntry(performanceController, entry));
}
function $5d460bce9481376e$var$setupOobTraces(performanceController) {
    const api = $5d460bce9481376e$var$Api.getInstance();
    // Better support for Safari
    if ('onpagehide' in window) api.document.addEventListener('pagehide', ()=>$5d460bce9481376e$var$sendOobTrace(performanceController));
    else api.document.addEventListener('unload', ()=>$5d460bce9481376e$var$sendOobTrace(performanceController));
    api.document.addEventListener('visibilitychange', ()=>{
        if (api.document.visibilityState === 'hidden') $5d460bce9481376e$var$sendOobTrace(performanceController);
    });
    if (api.onFirstInputDelay) api.onFirstInputDelay((fid)=>{
        $5d460bce9481376e$var$firstInputDelay = fid;
    });
    api.onLCP((metric)=>{
        var _a;
        $5d460bce9481376e$var$webVitalMetrics.lcp = {
            value: metric.value,
            elementAttribution: (_a = metric.attribution) === null || _a === void 0 ? void 0 : _a.element
        };
    });
    api.onCLS((metric)=>{
        var _a;
        $5d460bce9481376e$var$webVitalMetrics.cls = {
            value: metric.value,
            elementAttribution: (_a = metric.attribution) === null || _a === void 0 ? void 0 : _a.largestShiftTarget
        };
    });
    api.onINP((metric)=>{
        var _a;
        $5d460bce9481376e$var$webVitalMetrics.inp = {
            value: metric.value,
            elementAttribution: (_a = metric.attribution) === null || _a === void 0 ? void 0 : _a.interactionTarget
        };
    });
}
function $5d460bce9481376e$var$setupUserTimingTraces(performanceController) {
    const api = $5d460bce9481376e$var$Api.getInstance();
    // Run through the measure performance entries collected up to this point.
    const measures = api.getEntriesByType('measure');
    for (const measure of measures)$5d460bce9481376e$var$createUserTimingTrace(performanceController, measure);
    // Setup an observer to capture the measures from this point on.
    api.setupObserver('measure', (entry)=>$5d460bce9481376e$var$createUserTimingTrace(performanceController, entry));
}
function $5d460bce9481376e$var$createUserTimingTrace(performanceController, measure) {
    const measureName = measure.name;
    // Do not create a trace, if the user timing marks and measures are created by
    // the sdk itself.
    if (measureName.substring(0, $5d460bce9481376e$var$TRACE_MEASURE_PREFIX.length) === $5d460bce9481376e$var$TRACE_MEASURE_PREFIX) return;
    $5d460bce9481376e$var$Trace.createUserTimingTrace(performanceController, measureName);
}
function $5d460bce9481376e$var$sendOobTrace(performanceController) {
    if (!$5d460bce9481376e$var$sentPageLoadTrace) {
        $5d460bce9481376e$var$sentPageLoadTrace = true;
        const api = $5d460bce9481376e$var$Api.getInstance();
        const navigationTimings = api.getEntriesByType('navigation');
        const paintTimings = api.getEntriesByType('paint');
        // On page unload web vitals may be updated so queue the oob trace creation
        // so that these updates have time to be included.
        setTimeout(()=>{
            $5d460bce9481376e$var$Trace.createOobTrace(performanceController, navigationTimings, paintTimings, $5d460bce9481376e$var$webVitalMetrics, $5d460bce9481376e$var$firstInputDelay);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5d460bce9481376e$var$PerformanceController {
    constructor(app, installations){
        this.app = app;
        this.installations = installations;
        this.initialized = false;
    }
    /**
     * This method *must* be called internally as part of creating a
     * PerformanceController instance.
     *
     * Currently it's not possible to pass the settings object through the
     * constructor using Components, so this method exists to be called with the
     * desired settings, to ensure nothing is collected without the user's
     * consent.
     */ _init(settings) {
        if (this.initialized) return;
        if ((settings === null || settings === void 0 ? void 0 : settings.dataCollectionEnabled) !== undefined) this.dataCollectionEnabled = settings.dataCollectionEnabled;
        if ((settings === null || settings === void 0 ? void 0 : settings.instrumentationEnabled) !== undefined) this.instrumentationEnabled = settings.instrumentationEnabled;
        if ($5d460bce9481376e$var$Api.getInstance().requiredApisAvailable()) (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then((isAvailable)=>{
            if (isAvailable) {
                $5d460bce9481376e$var$setupTransportService();
                $5d460bce9481376e$var$getInitializationPromise(this).then(()=>$5d460bce9481376e$var$setupOobResources(this), ()=>$5d460bce9481376e$var$setupOobResources(this));
                this.initialized = true;
            }
        }).catch((error)=>{
            $5d460bce9481376e$var$consoleLogger.info(`Environment doesn't support IndexedDB: ${error}`);
        });
        else $5d460bce9481376e$var$consoleLogger.info('Firebase Performance cannot start if the browser does not support "Fetch" and "Promise", or cookies are disabled.');
    }
    set instrumentationEnabled(val) {
        $5d460bce9481376e$var$SettingsService.getInstance().instrumentationEnabled = val;
    }
    get instrumentationEnabled() {
        return $5d460bce9481376e$var$SettingsService.getInstance().instrumentationEnabled;
    }
    set dataCollectionEnabled(val) {
        $5d460bce9481376e$var$SettingsService.getInstance().dataCollectionEnabled = val;
    }
    get dataCollectionEnabled() {
        return $5d460bce9481376e$var$SettingsService.getInstance().dataCollectionEnabled;
    }
}
/**
 * The Firebase Performance Monitoring Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ const $5d460bce9481376e$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * Returns a {@link FirebasePerformance} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @public
 */ function $5d460bce9481376e$export$28a0276e10aa78d7(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'performance');
    const perfInstance = provider.getImmediate();
    return perfInstance;
}
/**
 * Returns a {@link FirebasePerformance} instance for the given app. Can only be called once.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param settings - Optional settings for the {@link FirebasePerformance} instance.
 * @public
 */ function $5d460bce9481376e$export$ac14c8f53249566c(app, settings) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'performance');
    // throw if an instance was already created.
    // It could happen if initializePerformance() is called more than once, or getPerformance() is called first.
    if (provider.isInitialized()) {
        const existingInstance = provider.getImmediate();
        const initialSettings = provider.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(initialSettings, settings !== null && settings !== void 0 ? settings : {})) return existingInstance;
        else throw $5d460bce9481376e$var$ERROR_FACTORY.create("already initialized" /* ErrorCode.ALREADY_INITIALIZED */ );
    }
    const perfInstance = provider.initialize({
        options: settings
    });
    return perfInstance;
}
/**
 * Returns a new `PerformanceTrace` instance.
 * @param performance - The {@link FirebasePerformance} instance to use.
 * @param name - The name of the trace.
 * @public
 */ function $5d460bce9481376e$export$357889f174732d38(performance, name) {
    performance = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(performance);
    return new $5d460bce9481376e$var$Trace(performance, name);
}
const $5d460bce9481376e$var$factory = (container, { options: settings })=>{
    // Dependencies
    const app = container.getProvider('app').getImmediate();
    const installations = container.getProvider('installations-internal').getImmediate();
    if (app.name !== $5d460bce9481376e$var$DEFAULT_ENTRY_NAME) throw $5d460bce9481376e$var$ERROR_FACTORY.create("FB not default" /* ErrorCode.FB_NOT_DEFAULT */ );
    if (typeof window === 'undefined') throw $5d460bce9481376e$var$ERROR_FACTORY.create("no window" /* ErrorCode.NO_WINDOW */ );
    $5d460bce9481376e$var$setupApi(window);
    const perfInstance = new $5d460bce9481376e$var$PerformanceController(app, installations);
    perfInstance._init(settings);
    return perfInstance;
};
function $5d460bce9481376e$var$registerPerformance() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('performance', $5d460bce9481376e$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($5d460bce9481376e$var$name, $5d460bce9481376e$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($5d460bce9481376e$var$name, $5d460bce9481376e$var$version, 'esm2017');
}
$5d460bce9481376e$var$registerPerformance();




// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// import { Loader } from "@googlemaps/js-api-loader";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const $9d0840e0f81e5cfa$var$firebaseConfig1 = {
    apiKey: "AIzaSyCq_AYmrbkB4VromUVhAnqXkuY7iAQD9Fs",
    authDomain: "me-heartbank.firebaseapp.com",
    projectId: "me-heartbank",
    databaseURL: "https://me-heartbank-default-rtdb.firebaseio.com",
    storageBucket: "me-heartbank.firebasestorage.app",
    messagingSenderId: "591045513975",
    appId: "1:591045513975:web:499f8abf6df451e596b9f2",
    measurementId: "G-ZX72NBZLPT"
};
const $9d0840e0f81e5cfa$var$firebaseConfig2 = {
    apiKey: "AIzaSyDPRrfmOI1mL7lQOpjO68lViV1X2WRjAIY",
    authDomain: "siliconwat.firebaseapp.com",
    projectId: "siliconwat",
    databaseURL: "https://siliconwat.firebaseio.com",
    storageBucket: "siliconwat.appspot.com",
    messagingSenderId: "140538393451",
    appId: "1:140538393451:web:9c142134efdc0ecba4122e",
    measurementId: "G-1PQ2MKK8GM"
};
// let heartbank: FirebaseApp, siliconwat: FirebaseApp;
// switch (getApps().length) {
//     case 2:
//         siliconwat = getApps()[0]; // TODO: check if this is always config1
//         heartbank = getApps()[1];
//         break;
//     case 1:
//         siliconwat = getApps()[0];
//         heartbank = initializeApp(firebaseConfig2, "siliconwat");
//         break;
//     default:
//         siliconwat = initializeApp(firebaseConfig1);
//         heartbank = initializeApp(firebaseConfig2, "siliconwat");
// }
//console.log("Project 1 App:", heartbank.name); // Should log: [DEFAULT]
//console.log("Project 2 App:", siliconwat.name); // Should log: secondary
const $9d0840e0f81e5cfa$var$app = (0, $57d436074e210fb5$export$c55cfd413944906d)($9d0840e0f81e5cfa$var$firebaseConfig2);
const $9d0840e0f81e5cfa$var$heartbank = (0, $57d436074e210fb5$export$c55cfd413944906d)($9d0840e0f81e5cfa$var$firebaseConfig1, "HeartBank");
const $9d0840e0f81e5cfa$export$35c0ced600f1fa26 = (0, $fce0788c2e4d699f$export$ae1af26003f05816)($9d0840e0f81e5cfa$var$heartbank);
const $9d0840e0f81e5cfa$export$fbdfe04acc811eed = (0, $70fd6868680e912c$export$f06a05d14c3a6678)($9d0840e0f81e5cfa$var$heartbank);
const $9d0840e0f81e5cfa$export$73693bad9f5880b0 = (0, $fce0788c2e4d699f$export$ae1af26003f05816)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$69c37fe6a10b78d4 = (0, $70fd6868680e912c$export$f06a05d14c3a6678)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$f932f06c7eb6abeb = (0, $da38ac6aa733c404$export$d0dd861204d0bf72)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$ddcffe0146c8f882 = (0, $df9a6d7fd06616c9$export$fbd9b57a66480737)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$18af1f934c132a41 = (0, $03ee16a658161e2a$export$7d4c14593b8a2193)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$a95634e919edb5c1 = (0, $97b6afad2c5c80cd$export$f74c3c76482a8451)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$71a493436f9bccb6 = (0, $0d15f034d14801d0$export$b0297573c90085aa)($9d0840e0f81e5cfa$var$app);
const $9d0840e0f81e5cfa$export$f2d2284f5fec51f8 = (0, $5d460bce9481376e$export$28a0276e10aa78d7)($9d0840e0f81e5cfa$var$app);
(0, $97b6afad2c5c80cd$export$7275a8dcb77dc20d)($9d0840e0f81e5cfa$export$a95634e919edb5c1, (payload)=>{
    //console.log("Message received in foreground: ", payload);
    // if (isDesktop) // Browsers won't show a banner, so you have to trigger one manually:
    new Notification(payload.data?.title || "New Reader!", {
        body: payload.data?.body || "Earth",
        icon: payload.data?.image || payload.data?.icon || "https://raw.githubusercontent.com/siliconwat/bedok.siliconwat.dev/main/siliconwat.png"
    });
});



var $03dc96944173e4d6$exports = {};
!function(e, t) {
    $03dc96944173e4d6$exports = t();
}($03dc96944173e4d6$exports, function() {
    return function(e) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var n = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, i) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(i, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return i;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = r(18), n = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, i) {
                    void 0 === i && (i = !1);
                    var n = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(n, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), i = t + new Array(r + 1).join(".0");
                        return e.map(i.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(i && (o = a - Math.min(n, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, i = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
                    return i;
                }, e.find = function(e, t) {
                    var r, i;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, i = e.length; r < i; r += 1){
                        var n = e[r];
                        if (t(n, r)) return n;
                    }
                }, e.assign = function(e) {
                    for(var t, r, i = e, n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            i[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return i.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return i.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = n, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                "Pale Moon": "pale_moon",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                pale_moon: "Pale Moon",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv",
                bot: "bot"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(91)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var i = t[r];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
            }
            var o = function() {
                function e() {}
                var t, r, i;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new n.default(e, t);
                }, e.parse = function(e) {
                    return new n.default(e).getResult();
                }, t = e, i = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, i && a(t, i), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = u(r(92)), n = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, i = 0, n = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (n[t] = a, s += 1) : "object" == typeof a && (r[t] = a, i += 1);
                    }), i > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(n), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(n[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = o.default.getBrowserTypeByAlias(i);
                    return t && n && (i = n.toLowerCase()), i === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, i = !1, n = this.getBrowserVersion();
                    if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(n, r, i)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /PaleMoon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Pale Moon"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: n.default.getFirstMatch(t, e),
                            version: n.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = n.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = n.default.getMacOSVersionName(t), i = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = n.default.getAndroidVersionName(t), i = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.bot,
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /Nokia/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e), r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nokia"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


String.prototype.capitalize = function() {
    if (!this) return "";
    return this.charAt(0).toUpperCase() + this.slice(1);
};
String.prototype.titleCase = function() {
    return this.toLowerCase().split(" ").map((word)=>word.capitalize()).join(" ");
};
Number.prototype.toKhmer = function(language) {
    if (language === "khmer") {
        const khmerDigits = [
            "\u17E0",
            "\u17E1",
            "\u17E2",
            "\u17E3",
            "\u17E4",
            "\u17E5",
            "\u17E6",
            "\u17E7",
            "\u17E8",
            "\u17E9"
        ];
        return this.toString().split("").map((digit)=>{
            const digitNumber = parseInt(digit, 10);
            if (isNaN(digitNumber)) throw new Error("Input must be a valid number");
            return khmerDigits[digitNumber];
        }).join("");
    } else return this.toString();
};
Location.prototype.setHash = function(book, page) {
    this.hash = `/book/${book}/page/${page}`; // does not push to history: maybe TODO: later
};
function $eba1d7d434ec7c0e$var$replaceMonthWithKhmer(date) {
    const monthMap = {
        January: "\u1798\u1780\u179A\u17B6",
        February: "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        March: "\u1798\u17B8\u1793\u17B6",
        April: "\u1798\u17C1\u179F\u17B6",
        May: "\u17A7\u179F\u1797\u17B6",
        June: "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        July: "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        August: "\u179F\u17B8\u17A0\u17B6",
        September: "\u1780\u1789\u17D2\u1789\u17B6",
        October: "\u178F\u17BB\u179B\u17B6",
        November: "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        December: "\u1792\u17D2\u1793\u17BC"
    };
    for (const [en, kh] of Object.entries(monthMap)){
        // Replace only the month (word boundary to avoid partial matches)
        const regex = new RegExp(`\\b${en}\\b`, "g");
        date = date.replace(regex, kh);
    }
    return date;
}
Date.prototype.formatDate = function() {
    const languages = $eba1d7d434ec7c0e$export$a24496dc2b29f9aa === "khmer" ? [
        "km-KH",
        "en-US"
    ] : [
        "en-US",
        "km-KH"
    ];
    const options = {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: localStorage.getItem("timezone") || ($eba1d7d434ec7c0e$export$a24496dc2b29f9aa === "khmer" ? "Asia/Phnom_Penh" : "America/Los_Angeles"),
        timeZoneName: "shortGeneric"
    };
    const formatted = this.toLocaleString(languages, options);
    if ($eba1d7d434ec7c0e$export$a24496dc2b29f9aa === "khmer") return $eba1d7d434ec7c0e$var$replaceMonthWithKhmer(formatted.replace("\u1793\u17C5\u200B", "\u179C\u17C1\u179B\u17B6").replace("at", "\u1793\u17C5\u1798\u17C9\u17C4\u1784").replace("AM", "\u1796\u17D2\u179A\u17B9\u1780").replace("PM", "\u1799\u1794\u17CB").replace("Cambodia Time", ""));
    return formatted;
};
const $eba1d7d434ec7c0e$export$f15d00aa73aafac4 = true;
const $eba1d7d434ec7c0e$export$501a7fac1df67a49 = new Date(parseInt("1787701200") * 1000);
const $eba1d7d434ec7c0e$export$76f2fb31d8fa450a = $eba1d7d434ec7c0e$export$f15d00aa73aafac4 ? "https://vault.333.eco" : "http://localhost:1234";
const $eba1d7d434ec7c0e$export$eb9b3c606836bffa = $eba1d7d434ec7c0e$export$f15d00aa73aafac4 ? "https://heartbank.org" // thank.hb.org
 : "http://localhost:61282";
const $eba1d7d434ec7c0e$export$3e78737c19d741c0 = $eba1d7d434ec7c0e$export$f15d00aa73aafac4 ? "https://bedok.siliconwat.com" : "http://localhost:8787";
const $eba1d7d434ec7c0e$export$590b38c2043cf80f = $eba1d7d434ec7c0e$export$f15d00aa73aafac4 ? "https://us-central1-siliconwat.cloudfunctions.net" : "http://127.0.0.1:5004/siliconwat/us-central1";
const $eba1d7d434ec7c0e$export$a24496dc2b29f9aa = localStorage.getItem("language") ?? "khmer"; // can use ||
const $eba1d7d434ec7c0e$export$5714e40777c1bcc2 = "orange"; // deprecated #ffa500 TODO: get from :root via computed style; see map app // move to tailwind css class???
const $eba1d7d434ec7c0e$export$ce970371e0e850bc = "leaderboard";
function $eba1d7d434ec7c0e$export$c0bb0b647f701bb5(strings, ...values) {
    // Combine the strings and interpolated values into a single string
    return strings.reduce((result, str, i)=>result + str + (values[i] || ""), "");
}
const $eba1d7d434ec7c0e$var$browser = (0, (/*@__PURE__*/$parcel$interopDefault($03dc96944173e4d6$exports))).getParser(window.navigator.userAgent);
const $eba1d7d434ec7c0e$var$platform = $eba1d7d434ec7c0e$var$browser.getPlatform();
const $eba1d7d434ec7c0e$export$3c6d453abf5a879b = $eba1d7d434ec7c0e$var$platform.vendor && $eba1d7d434ec7c0e$var$platform.model ? `${$eba1d7d434ec7c0e$var$platform.vendor} ${$eba1d7d434ec7c0e$var$platform.model}` : $eba1d7d434ec7c0e$var$platform.model || $eba1d7d434ec7c0e$var$platform.vendor || "Unknown Device";
const $eba1d7d434ec7c0e$export$ee7d1a69487f78e9 = $eba1d7d434ec7c0e$var$platform.type?.capitalize() || "Unknown Type"; // desktop or mobile or tablet
const $eba1d7d434ec7c0e$export$5b033c7e05fcfcc2 = $eba1d7d434ec7c0e$var$browser.getOSName() || "Unknown OS";
const $eba1d7d434ec7c0e$export$a3833c15d023303d = $eba1d7d434ec7c0e$var$browser.getOSVersion() || "Unknown Version";
const $eba1d7d434ec7c0e$export$89ca9f8ca1a50fd5 = $eba1d7d434ec7c0e$var$browser.getBrowserName() || "Unknown Browser";
const $eba1d7d434ec7c0e$export$61e3782b541bd28e = $eba1d7d434ec7c0e$var$browser.getBrowserVersion() || "Unknown Version";
const $eba1d7d434ec7c0e$export$5231b1f790f5c149 = [
    "iOS",
    "macOS",
    "watchOS",
    "tvOS"
].includes($eba1d7d434ec7c0e$export$5b033c7e05fcfcc2);
const $eba1d7d434ec7c0e$export$95df08bae54cb4df = $eba1d7d434ec7c0e$export$89ca9f8ca1a50fd5 === "Safari";
const $eba1d7d434ec7c0e$export$d0a8044dce8ff2fc = $eba1d7d434ec7c0e$export$ee7d1a69487f78e9 === "Mobile";
const $eba1d7d434ec7c0e$export$1e4fed98bcaa1d82 = $eba1d7d434ec7c0e$export$ee7d1a69487f78e9 === "Desktop";
const $eba1d7d434ec7c0e$var$isStandalone = window.matchMedia("(display-mode: standalone)").matches;
const $eba1d7d434ec7c0e$var$isIOSStandalone = navigator.standalone === true; // iOS-specific
const $eba1d7d434ec7c0e$export$3b31a91e69d9331 = $eba1d7d434ec7c0e$var$isStandalone || $eba1d7d434ec7c0e$var$isIOSStandalone;
// TODO: don't cache ip bc user can change location ?? in memory might be ok // service worker caches already
// must be on client bc don't want server ip
let $eba1d7d434ec7c0e$var$IP = "";
async function $eba1d7d434ec7c0e$export$67218453e01a0be8() {
    try {
        if (!$eba1d7d434ec7c0e$var$IP) {
            const res = await fetch("https://api.ipify.org?format=json");
            const { ip: ip } = await res.json();
            $eba1d7d434ec7c0e$var$IP = ip;
        }
    } catch (error) {
        console.error(error);
    } finally{
        //console.log(IP);
        return $eba1d7d434ec7c0e$var$IP;
    }
}
// TODO: move to server?
let $eba1d7d434ec7c0e$var$location = {};
async function $eba1d7d434ec7c0e$export$e7fd20fad3cf4b5f(ip) {
    try {
        if ($eba1d7d434ec7c0e$var$location.ip !== ip) {
            const geoRes = await fetch(`https://ipapi.co/${ip}/json/`);
            $eba1d7d434ec7c0e$var$location = await geoRes.json();
        }
    } catch (error) {
        console.error(error);
    } finally{
        $eba1d7d434ec7c0e$var$location.ip = ip;
        //console.log(location);
        localStorage.setItem("timezone", $eba1d7d434ec7c0e$var$location.timezone || ""); //TODO: later get user's selected timezone instead
        return $eba1d7d434ec7c0e$var$location;
    }
}
async function $eba1d7d434ec7c0e$export$8eb12969473b192a(options) {
    const files = options ? await $eba1d7d434ec7c0e$export$39f8f0f68a475e91(options) : await $eba1d7d434ec7c0e$export$39f8f0f68a475e91();
    return files[0];
}
async function $eba1d7d434ec7c0e$export$39f8f0f68a475e91(options) {
    return new Promise((resolve, reject)=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = options?.accept || "image/*";
        input.style.display = "none"; // Hide the input
        if (options?.capture) input.setAttribute("capture", options.capture);
        if (options?.multiple) input.multiple = true;
        document.body.appendChild(input);
        const cleanup = ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener("focus", onFocus);
            document.body.removeChild(input);
        };
        input.addEventListener("change", ()=>{
            cleanup();
            if (input.files && input.files.length > 0) resolve(Array.from(input.files));
            else reject(new Error("No file selected"));
        });
        const onFocus = ()=>{
            setTimeout(()=>{
                if (!input.files || input.files.length === 0) {
                    cleanup();
                    reject(new Error("cancelled"));
                }
            }, 500);
        };
        window.addEventListener("focus", onFocus);
        const timeoutId = setTimeout(()=>{
            cleanup();
            reject(new Error("File selection timed out"));
        }, 60000); // 60 seconds
        input.click();
    });
}
// not used bc most websites deny iframe
window.openPage = function(src) {
    if ($eba1d7d434ec7c0e$export$3b31a91e69d9331) window.open(src, "_blank");
    else {
        const popup = document.querySelector("sw-popup");
        popup?.show(src);
    }
};


var $cf95765ca3532985$exports = {};
$cf95765ca3532985$exports = JSON.parse('{"language":{"khmer":"km","english":"en"},"region":{"khmer":"KH","english":"US"},"khmer":{"khmer":"\u1781\u17D2\u1798\u17C2\u179A","english":"Khmer"},"english":{"khmer":"\u17A2\u1784\u17CB\u1782\u17D2\u179B\u17C1\u179F","english":"English"},"title":{"khmer":"\u1782\u1798\u17D2\u1796\u17B8\u179A\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780","english":"Bedok AI"},"title0":{"khmer":"\u1782\u1798\u17D2\u1796\u17B8\u179A\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 <span class=\'arial font-black\'>AI</span>","english":"Bedok AI"},"title2":{"khmer":"\u1782\u1798\u17D2\u1796\u17B8\u179A\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780","english":"Bedok AI"},"title2o":{"khmer":"\u1782\u1798\u17D2\u1796\u17B8\u179A\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 AI","english":"Bedok AI"},"book":{"khmer":"\u1797\u17B6\u1782\u1791\u17B8\u200B","english":"Volume"},"baskets":{"khmer":["\u1796\u17D2\u179A\u17C7\u179C\u17B7\u1793\u17D0\u1799 \u1798\u17B6\u1793 \u17E1\u17E3 \u1797\u17B6\u1782","\u1796\u17D2\u179A\u17C7\u179F\u17BB\u178F\u17D2\u178F\u1793\u17D2\u178F \u1798\u17B6\u1793 \u17E6\u17E4 \u1797\u17B6\u1782","\u1796\u17D2\u179A\u17C7\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798 \u1798\u17B6\u1793 \u17E3\u17E3 \u1797\u17B6\u1782"],"english":["Vinaya Pitaka","Suttanta Pitaka","Abhidhamma Pitaka"],"colors":["basket1","basket2","basket3"],"colors2":["fill-yellow-400","fill-orange-400","fill-red-700"]},"baskets2":{"khmer":["\u1796\u17D2\u179A\u17C7\u179C\u17B7\u1793\u17D0\u1799 \u1797\u17B6\u1782\u1791\u17B8","\u1796\u17D2\u179A\u17C7\u179F\u17BB\u178F\u17D2\u178F\u1793\u17D2\u178F \u1797\u17B6\u1782\u1791\u17B8","\u1796\u17D2\u179A\u17C7\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798 \u1797\u17B6\u1782\u1791\u17B8"],"english":["Vinaya","Suttanta","Abhidhamma"]},"baskets3":{"khmer":["\u1796\u17D2\u179A\u17C7\u179C\u17B7\u1793\u17D0\u1799 \u1794\u17B7\u178A\u1780 \u1797\u17B6\u1782\u1791\u17B8","\u1796\u17D2\u179A\u17C7\u179F\u17BB\u178F\u17D2\u178F\u1793\u17D2\u178F \u1794\u17B7\u178A\u1780 \u1797\u17B6\u1782\u1791\u17B8","\u1796\u17D2\u179A\u17C7\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798 \u1794\u17B7\u178A\u1780 \u1797\u17B6\u1782\u1791\u17B8"],"english":["Bedok Vinaya Volume","Bedok Suttanta Volume","Bedok Abhidhamma Volume"]},"commentariesKhmer":{"khmer":"\u1796\u17D2\u179A\u17C7\u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6\u200B\u200B \u1781\u17D2\u1798\u17C2\u179A","english":"Commentaries (Khmer)"},"commentariesPali":{"khmer":"\u1796\u17D2\u179A\u17C7\u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6\u200B \u1794\u17B6\u179B\u17B8","english":"Commentaries (Pali)"},"notifications":{"khmer":"\u1780\u17B6\u179A\u1787\u17BC\u1793\u178A\u17C6\u178E\u17B9\u1784","english":"Notifications"},"notifications1":{"khmer":"\u179F\u17BC\u1798\u1794\u1793\u17D2\u1790\u17C2\u1798\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u1793\u17C1\u17C7\u1791\u17C5\u1780\u17B6\u1793\u17CB\u17A2\u17C1\u1780\u17D2\u179A\u1784\u17CB\u178A\u17BE\u1798 (Home Screen) \u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780 \u1793\u17B7\u1784\u17A2\u1793\u17BB\u1789\u17D2\u1789\u17B6\u178F\u1780\u17B6\u179A\u1787\u17BC\u1793\u178A\u17C6\u178E\u17B9\u1784 (Push Notifications) \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1791\u1791\u17BD\u179B\u1794\u17B6\u1793\u1780\u17B6\u179A\u179A\u17C6\u179B\u17B9\u1780\u17A2\u17C6\u1796\u17B8\u1790\u17D2\u1784\u17C3\u179F\u17B8\u179B \u1793\u17B7\u1784\u1794\u17BB\u178E\u17D2\u1799\u1791\u17B6\u1793\u1795\u17D2\u179F\u17C1\u1784\u17D7!","khmer2":"\u179F\u17BC\u1798\u178A\u17C6\u17A1\u17BE\u1784\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u1793\u17C1\u17C7\u179B\u17BE\u17A2\u17C1\u1780\u17D2\u179A\u1784\u17CB\u178A\u17BE\u1798 \u1793\u17B7\u1784\u1794\u17BE\u1780\u1780\u17B6\u179A\u1787\u17BC\u1793\u178A\u17C6\u178E\u17B9\u1784 \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1791\u1791\u17BD\u179B\u1794\u17B6\u1793\u1796\u17D0\u178F\u17CC\u1798\u17B6\u1793\u179A\u17C6\u179B\u17B9\u1780\u17A2\u17C6\u1796\u17B8\u1796\u17B7\u1792\u17B8\u1794\u17BB\u178E\u17D2\u1799\u179F\u17B6\u179F\u1793\u17B6\u1795\u17D2\u179F\u17C1\u1784\u17D7\u17D4","english":"Please add this app to your Home Screen and allow Push Notifications to receive reminders of Buddhist holidays!"},"notifications2":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u1791\u1791\u17BD\u179B\u1794\u17B6\u1793\u1780\u17B6\u179A\u179A\u17C6\u179B\u17B9\u1780\u17A2\u17C6\u1796\u17B8\u1790\u17D2\u1784\u17C3\u179F\u17B8\u179B \u1793\u17B7\u1784\u1794\u17BB\u178E\u17D2\u1799\u1791\u17B6\u1793\u1795\u17D2\u179F\u17C1\u1784\u17D7\u178A\u17C2\u179A\u17AC\u1791\u17C1?","english":"Would you like to receive reminders of Buddhist holidays?"},"notifications3":{"khmer":"\u17A2\u17D2\u1793\u1780\u1793\u17B9\u1784\u1791\u1791\u17BD\u179B\u1794\u17B6\u1793\u1780\u17B6\u179A\u179A\u17C6\u179B\u17B9\u1780\u17A2\u17C6\u1796\u17B8\u1790\u17D2\u1784\u17C3\u179F\u17B8\u179B \u1793\u17B7\u1784\u1794\u17BB\u178E\u17D2\u1799\u1791\u17B6\u1793\u1795\u17D2\u179F\u17C1\u1784\u17D7\u1785\u17B6\u1794\u17CB\u1796\u17B8\u1796\u17C1\u179B\u1793\u17C1\u17C7\u178F\u1791\u17C5!","khmer2":"\u1780\u17B6\u179A\u179A\u17C6\u179B\u17B9\u1780\u17A2\u17C6\u1796\u17B8\u1790\u17D2\u1784\u17C3\u179F\u17B8\u179B\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1794\u17BE\u1780\u1787\u17C4\u1782\u1787\u17D0\u1799!","english":"You will now receive reminders of Buddhist holidays!"},"hero":{"khmer":"\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 \u1794\u17B6\u179B\u17B8 \u1794\u17D2\u179A\u17C2\u1787\u17B6\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","english":"Bedok AI from Pali to Khmer"},"hero0":{"khmer":"\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 <span class=\'arial font-black\'>AI</span> \u1794\u17B6\u179B\u17B8 \u1794\u17D2\u179A\u17C2\u1787\u17B6\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A","english":"Bedok AI from Pali to Khmer"},"subtitle":{"khmer":"\u1797\u17B6\u1782 \u17E1 \u178A\u179B\u17CB\u1797\u17B6\u1782 \u17E1\u17E1\u17E0","english":"Complete Collection"},"hero2":{"khmer":"\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 \u1794\u17B6\u179B\u17B8 \u1794\u17D2\u179A\u17C2\u1787\u17B6\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A: \u1797\u17B6\u1782 \u17E1 \u178A\u179B\u17CB\u1797\u17B6\u1782 \u17E1\u17E1\u17E0","english":"Bedok AI from Pali to Khmer: Complete Collection"},"hero2o":{"khmer":"\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 AI \u1794\u17B6\u179B\u17B8 \u1794\u17D2\u179A\u17C2\u1787\u17B6\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A: \u1797\u17B6\u1782 \u17E1 \u178A\u179B\u17CB\u1797\u17B6\u1782 \u17E1\u17E1\u17E0","english":"Bedok AI from Pali to Khmer: Complete Collection"},"movie":{"khmer":"\u179F\u17BC\u1798\u1785\u17BB\u1785\u1793\u17C5\u1791\u17B8\u1793\u17C1\u17C7\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u179C\u17B8\u178A\u17C1\u17A2\u17BC \u179A\u17BF\u1784\u1796\u17D2\u179A\u17C7\u1796\u17BB\u1791\u17D2\u1792","english":"Tap Here to Watch Movie about Buddha"},"youtube":{"khmer":"\u1780\u17B6\u179A\u178E\u17C2\u1793\u17B6\u17C6\u1794\u17D2\u179A\u17BE\u1794\u17D2\u179A\u17B6\u179F\u178F\u17B6\u1798\u179A\u1799\u17C8\u179C\u17B7\u178A\u17C1\u17A2\u17BC","english":"Instruction Videos"},"ai":{"khmer":"\u178F\u1798\u17D2\u179B\u17BE\u1784\u1796\u17D2\u179A\u17C7\u1796\u17BB\u1791\u17D2\u1792 <span class=\'arial font-black\'>AI</span>","english":"Install Buddha AI"},"sw":{"khmer":"\u178A\u17C6\u17A1\u17BE\u1784 <span class=\'arial font-black\'>Silicon Wat</span>","english":"Install Silicon Wat"},"tuktuk":{"khmer":"\u178F\u17BB\u1780\u178F\u17BB\u1780 333","english":"333 Tuk Tuk"},"soon":{"khmer":"\u1793\u17B9\u1784\u1785\u17C1\u1789\u17B2\u17D2\u1799\u1794\u17D2\u179A\u17BE\u1794\u17D2\u179A\u17B6\u179F\u17CB\u1786\u17B6\u1794\u17CB\u17D7","english":"Coming soon..."},"download":{"khmer":"\u1791\u17B6\u1789\u1799\u1780\u1797\u17B6\u1782\u1791\u17B6\u17C6\u1784\u1798\u17BC\u179B\u1793\u17C1\u17C7\u178A\u17BE\u1798\u17D2\u1794\u17B8\u17A2\u17B6\u1793\u1780\u17D2\u179A\u17C5\u1794\u178E\u17D2\u178F\u17B6\u1789","english":"Download this entire volume to read offline"},"join":{"khmer":"\u1780\u17D2\u179A\u17BB\u1798\u200B\u1794\u17D2\u179A\u17B9\u1780\u17D2\u179F\u17B6\u200B\u1797\u17B7\u1794\u17B6\u179B\u200B <span class=\'arial font-black\'>AI</span>","english":"AI Buddhist Council"},"toc":{"khmer":"\u1796\u17D2\u179A\u17C7\u1796\u17BB\u1791\u17D2\u1792 <span class=\'arial font-black\'>AI</span>","english":"Buddha AI"},"ama":{"khmer":"\u179F\u17BC\u1798\u179F\u17BD\u179A\u1781\u17D2\u1789\u17BB\u17C6\u1793\u17BC\u179C\u17A2\u17D2\u179C\u17B8\u1780\u17CF\u1794\u17B6\u1793\\n\u1796\u17C1\u179B\u1794\u17D2\u179A\u17A2\u1794\u17CB\u1798\u17BD\u1799\u1794\u17BE\u1780\u17A1\u17BE\u1784\u200B\\n\u179F\u17BC\u1798\u200B\u1785\u1798\u17D2\u179B\u1784\u178A\u17B6\u1780\u17CB\u200B \u179A\u17BD\u1785\u1785\u17BB\u1785\u1794\u1789\u17D2\u1787\u17BC\u1793","english":"Ask me anything\\n\\nNote: Paste this prompt into Gemini AI"},"paste":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u1794\u17B7\u1791\u1797\u17D2\u1787\u17B6\u1794\u17CB\u179C\u17B6\u178A\u17C2\u179A\u17AC\u1791\u17C1?","english":"Would you like to paste?"},"trash":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u179B\u17BB\u1794\u179C\u17B6\u178A\u17C2\u179A\u17AC\u1791\u17C1?","english":"Would you like to delete?"},"qrcode":{"khmer":"\u1785\u17BB\u1785\u179B\u17BE\u179C\u17B8\u178A\u17C1\u17A2\u17BC\u1781\u17B6\u1784\u179B\u17BE\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u1780\u17BC\u178A QR \u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780\u179B\u17BE\u1794\u178E\u17D2\u178A\u17B6\u1789\u179F\u1784\u17D2\u1782\u1798\u17D4","english":"\uD83D\uDC46 Tap on the video above to see the QR Code for sharing on social media."},"scan":{"khmer":"\u1794\u17D2\u179A\u17BE\u1780\u17B6\u1798\u17C1\u179A\u17C9\u17B6\u1791\u17BC\u179A\u179F\u17D0\u1796\u17D2\u1791\u1790\u178F\u1780\u17BC\u178A\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1791\u17B6\u1789\u1799\u1780\u1782\u1798\u17D2\u1796\u17B8\u179A\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780\u1798\u17BE\u179B","english":"Share this Bedok AI with others by telling them to scan this QR Code using their phone camera."},"gift":{"khmer":"\u1791\u17B6\u1793\u200B\u178A\u17CF\u200B\u1794\u17D2\u179A\u179F\u17BE\u179A\u200B \u1782\u17BA\u200B\u1792\u1798\u17D2\u1798\u1791\u17B6\u1793","english":"The Greatest Gift is the Gift of Dharma."},"copy":{"khmer":"\u1785\u17BB\u1785\u179B\u17BE\u1780\u17BC\u178A\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1785\u1798\u17D2\u179B\u1784\u1780\u17B6\u179A\u1794\u17D2\u179A\u17BE\u1794\u17D2\u179A\u17B6\u179F\u1795\u17D2\u179F\u1796\u17D2\u179C\u1795\u17D2\u179F\u17B6\u1799\u178F\u17B6\u1798\u178E\u17D2\u178F\u17B6\u1789\u179F\u1784\u17D2\u1782\u1798","english":"Tap on the QR Code to copy the link to share on social media."},"copied":{"khmer":"\u1780\u17B6\u179A\u1790\u178F\u1785\u1798\u17D2\u179B\u1784\u1794\u17B6\u1793\u1790\u178F\u179A\u17BD\u1785\u179A\u17B6\u179B\u17CB","english":"The link to this Bedok AI has been copied!"},"copied2":{"khmer":"\u17A2\u178F\u17D2\u1790\u1794\u1791\u1791\u17B6\u17C6\u1784\u1798\u17BC\u179B\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u17A0\u17BE\u1799!","english":"The entire text has been copied!"},"copied3":{"khmer":"\u179F\u17C6\u178E\u17C1\u179A\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u1791\u17BB\u1780\u17A0\u17BE\u1799!","english":"Your prompt has been copied!"},"page":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A","english":"Page"},"total":{"khmer":"\u179F\u179A\u17BB\u1794","english":"Total"},"previous":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A\u1798\u17BB\u1793","english":"Previous Page"},"next":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB","english":"Next Page"},"bookmark":{"khmer":"\u179F\u1789\u17D2\u1789\u17B6\u179F\u17C6\u1782\u17B6\u179B\u17CB\u1791\u17C6\u1796\u17D0\u179A\u17A2\u17B6\u1793\u17A0\u17BE\u1799","english":"Bookmark Page"},"saved":{"khmer":"\u179F\u1789\u17D2\u1789\u17B6\u179F\u17C6\u1782\u17B6\u179B\u17CB\u1791\u17C6\u1796\u179A\u17D0\u179F\u17C0\u179C\u1797\u17C5\u1794\u17B6\u1793\u17A2\u17B6\u1793\u179A\u17BD\u1785","english":"This page has been bookmarked for this volume."},"removed":{"khmer":"\u179F\u1789\u17D2\u1789\u17B6\u179F\u17C6\u1782\u17B6\u179B\u17CB\u1791\u17C6\u1796\u179A\u17D0\u179F\u17C0\u179C\u1797\u17C5\u1794\u17B6\u1793\u1799\u1780\u1785\u17C1\u1789","english":"The bookmark for this page has been removed."},"khmer2":{"khmer":"\u1794\u17B7\u178A\u1780\u1781\u17D2\u1798\u17C2\u179A <span class=\'arial\'>AI</span>","english":"Khmer Bedok AI"},"dict":{"khmer":"\u1787\u17BD\u1793 \u178E\u17B6\u178F","english":"Chuon Nath"},"map":{"khmer":"\u1785\u17C6\u1793\u17BD\u1793\u200B\u17A2\u17D2\u1793\u1780\u200B\u17A2\u17B6\u1793\u200B","english":"Readership"},"pali2":{"khmer":"\u1794\u17B7\u178A\u1780\u1794\u17B6\u179B\u17B8 <span class=\'arial\'>AI</span>","english":"Pali Bedok AI"},"read":{"khmer":"\u17A2\u17B6\u1793\u1794\u17B7\u178A\u1780","english":"Read Bedok"},"learn":{"khmer":"\u179A\u17C0\u1793\u1794\u17B7\u178A\u1780","english":"Learn Bedok"},"share":{"khmer":"\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780","english":"Share"},"now":{"khmer":"\u17A5\u17A1\u17BC\u179C\u1793\u17C1\u17C7","english":"Now"},"leaderboard":{"khmer":"\u17A2\u17D2\u1793\u1780\u179F\u1780\u1798\u17D2\u1798","english":"Leaderboard"},"today":{"khmer":"\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7","english":"Today"},"history":{"khmer2":"\u1782\u17D2\u179A\u1794\u17CB\u1796\u17C1\u179B","english":"All Time","khmer":"\u1790\u17D2\u1784\u17C3\u1798\u17BB\u1793","english2":"History"},"speak":{"khmer":"\u1793\u17B7\u1799\u17B6\u1799","english":"Speak"},"stop":{"khmer":"\u1788\u1794\u17CB","english":"Stop"},"tipitaka":{"khmer":"\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780","english":"Tipitaka"},"buddha":{"khmer":"\u1794\u17B7\u178A\u1780 <span class=\'arial\'>AI</span>","english":"Bedok AI"},"light":{"khmer":"\u1796\u1793\u17D2\u179B\u17BA\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3","english":"Light Mode"},"dark":{"khmer":"\u1796\u1793\u17D2\u179B\u17BA\u1796\u17C1\u179B\u1799\u1794\u17CB","english":"Dark Mode"},"auto":{"khmer":"\u1796\u1793\u17D2\u179B\u17BA\u179F\u17D2\u179C\u17D0\u1799\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7","english":"Auto Mode"},"automatic":{"khmer":"\u1796\u1793\u17D2\u179B\u17BA\u1793\u17B9\u1784\u1795\u17D2\u179B\u17B6\u179F\u17CB\u1794\u17D2\u178F\u17BC\u179A\u1796\u17C1\u179B\u1799\u1794\u17CB\u1793\u17B7\u1784\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u1781\u17D2\u179B\u17BD\u1793\u17AF\u1784","english":"The color scheme will now adjust automatically."},"online":{"khmer":"\u17A2\u17D2\u1793\u1780\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1797\u17D2\u1787\u17B6\u1794\u17CB\u1791\u17C5\u17A2\u17CA\u17B8\u1793\u1792\u17BA\u178E\u17B7\u178F\u17A0\u17BE\u1799","english":"You\'re back online!"},"offline":{"khmer":"\u17A2\u17D2\u1793\u1780\u1798\u17B7\u1793\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1797\u17D2\u1787\u17B6\u1794\u17CB\u1791\u17C5\u17A2\u17CA\u17B8\u1793\u1792\u17BA\u178E\u17B7\u178F\u17A1\u17BE\u1799","english":"Please connect to the internet."},"refresh":{"khmer":"\u179F\u17BC\u1798\u1791\u17B6\u1789\u1799\u1780\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u200B\u1790\u17D2\u1798\u17B8","english":"A new version is available. Refresh to update?"},"updated":{"khmer":"\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u1790\u17D2\u1798\u17B8 \u1792\u17D2\u179C\u17BE\u1793\u17C5\u1790\u17D2\u1784\u17C3\u1791\u17B8\u200B\u200B","english":"Last updated on"},"donate":{"khmer":"\u1794\u17D2\u179A\u17BE HeartBank<sup class=\'mr-1\'>\xae</sup> \u179F\u17C6\u179A\u17B6\u1794\u17CB\u17A2\u179A\u1782\u17BB\u178E","english":"Thank with HeartBank<sup>\xae</sup>","khmer2":"\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782","english2":"Donate"},"donate1":{"khmer":"\u1780\u17B6\u178F\u17A5\u178E\u1791\u17B6\u1793","khmer2":"\u17A2\u179A\u1782\u17BB\u178E\u1780\u17B6\u178F","english":"Thank with Card"},"donate2":{"khmer":"\u1794\u17D2\u179A\u17B6\u1780\u17CB\u179F\u17BB\u1791\u17D2\u1792","khmer2":"\u17A2\u179A\u1782\u17BB\u178E\u1794\u17D2\u179A\u17B6\u1780\u17CB","english":"Thank with Cash"},"donateNow":{"khmer":"\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782\u17A5\u17A1\u17BC\u179C\u1793\u17C1\u17C7","english":"Donate Now"},"donateTitle":{"khmer":"\u1780\u17B6\u179A\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782\u1782\u17B6\u17C6\u1791\u17D2\u179A\u1782\u17C6\u179A\u17C4\u1784\u1794\u1784\u17D2\u1780\u17BE\u178F\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780\u17A2\u17C1\u17A2\u17B6\u1799","english":"Support the Development of Bedok AI"},"donateBody":{"khmer":"<p>\u1799\u17BE\u1784\u1781\u17D2\u1789\u17BB\u17C6\u179F\u17BC\u1798\u17A2\u17C6\u1796\u17B6\u179C\u1793\u17B6\u179C\u178A\u179B\u17CB\u179F\u1794\u17D2\u1794\u17BB\u179A\u179F\u1787\u1793\u1782\u17D2\u179A\u1794\u17CB\u179B\u17C6\u178A\u17B6\u1794\u17CB\u1790\u17D2\u1793\u17B6\u1780\u17CB \u1798\u17C1\u178F\u17D2\u178F\u17B6\u1787\u17BD\u1799\u1782\u17B6\u17C6\u1791\u17D2\u179A\u1782\u17C6\u179A\u17C4\u1784\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780\u17A2\u17C1\u17A2\u17B6\u1799\u17A2\u1793\u17A1\u17B6\u1789\u17B2\u17D2\u1799\u1798\u17B6\u1793\u1782\u17BB\u178E\u1797\u17B6\u1796 \u1793\u17B7\u1784\u1794\u17D2\u179A\u179F\u17B7\u1791\u17D2\u1792\u17B7\u1797\u17B6\u1796\u1781\u17D2\u1796\u179F\u17CB \u178A\u17C4\u1799\u1795\u17D2\u178F\u179B\u17CB\u1793\u17BC\u179C\u1780\u17B6\u179A\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782\u17A7\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797 \u178A\u179B\u17CB\u1780\u17D2\u179A\u17BB\u1798\u1799\u17BE\u1784\u1781\u17D2\u1789\u17BB\u17C6\u178F\u17B6\u1798\u1780\u1798\u17D2\u179B\u17B6\u17C6\u1784 \u1793\u17B7\u1784\u179F\u1791\u17D2\u1792\u17B6\u17D4</p><p>\u1780\u17B6\u179A\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782\u17A7\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780 \u1782\u17BA\u1787\u17B6\u1780\u17B6\u179A\u1787\u17BD\u1799\u1792\u17D2\u179C\u17BE\u17B2\u17D2\u1799\u1795\u17D2\u1793\u17C2\u1780\u1796\u17D2\u179A\u17C7\u1796\u17BB\u1791\u17D2\u1792\u179F\u17B6\u179F\u1793\u17B6\u1798\u17B6\u1793\u1780\u17B6\u179A\u1795\u17D2\u179F\u1796\u17D2\u179C\u1795\u17D2\u179F\u17B6\u1799\u1791\u17BC\u179B\u17C6\u1791\u17BC\u179B\u17B6\u1799 \u1791\u17C5\u178A\u179B\u17CB\u1796\u17BB\u1791\u17D2\u1792\u179F\u17B6\u179F\u1793\u17B7\u1780\u1793\u17C5\u1780\u17D2\u1793\u17BB\u1784\u1796\u17D2\u179A\u17C7\u179A\u17B6\u1787\u17B6\u178E\u17B6\u1785\u1780\u17D2\u179A\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6 \u1793\u17B7\u1784\u1794\u179A\u1791\u17C1\u179F \u17D4 \u1798\u17B7\u1793\u178F\u17D2\u179A\u17B9\u1798\u1794\u17C9\u17BB\u178E\u17D2\u178E\u17C4\u17C7\u1791\u17C1 \u1790\u17C2\u1798\u1791\u17B6\u17C6\u1784\u1787\u17BD\u1799\u1780\u17B6\u179A\u17A2\u1797\u17B7\u179C\u178C\u17D2\u178D\u1793\u17CD\u178F\u17B6\u1798\u1794\u178E\u17D2\u178F\u17B6\u1789\u200B\u17A2\u17C1\u17A2\u17B6\u1799\u200B\u17A2\u200B\u1793\u17A1\u17B6\u1793\u17B2\u17D2\u1799\u179B\u17D2\u17A2\u1794\u17D2\u179A\u179F\u17BE\u179A \u1793\u17B7\u1784\u1787\u17BD\u1799\u17B2\u17D2\u1799\u1780\u17D2\u179A\u17BB\u1798\u1799\u17BE\u1784\u1781\u17D2\u1789\u17BB\u17C6 \u1798\u17B6\u1793\u1780\u1798\u17D2\u179B\u17B6\u17C6\u1785\u17B7\u178F\u17D2\u178F \u1793\u17B7\u1784\u179B\u1791\u17D2\u1792\u1797\u17B6\u1796\u17A2\u17B6\u1785\u1791\u17B7\u1789\u17A7\u1794\u1780\u179A\u178E\u17CD\u1794\u1785\u17D2\u1785\u17C1\u1780\u179C\u17B7\u1791\u17D2\u1799\u17B6\u17A2\u17C1\u17A1\u17B7\u1785\u178F\u17D2\u179A\u17BC\u1793\u17B7\u1785\u1795\u17D2\u179F\u17C1\u1784\u17D7 \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1799\u1780\u1798\u1780\u1794\u17D2\u179A\u17BE\u1794\u17D2\u179A\u17B6\u179F\u1780\u17D2\u1793\u17BB\u1784\u1782\u17C6\u179A\u17C4\u1784\u200B\u200B\u17B2\u17D2\u1799\u200B\u1780\u17B6\u1793\u17CB\u178F\u17C2\u179B\u17D2\u17A2\u200B\u200B\u1791\u17C6\u1793\u17BE\u1794\u200B\u1793\u17B7\u1784\u200B\u1791\u17B6\u1793\u17CB\u200B\u179F\u1798\u17D0\u1799\u1787\u17B6\u1784\u200B\u1798\u17BB\u1793\u200B\u17D4</p><p>\u1780\u17B6\u179A\u1785\u17BC\u179B\u179A\u17BD\u1798\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780 \u1782\u17BA\u1787\u17B6\u1792\u1798\u17D2\u1798\u1791\u17B6\u1793\u178A\u17CF\u179B\u17D2\u17A2\u1794\u17C6\u1795\u17BB\u178F \u1793\u17B7\u1784\u1787\u17B6\u1791\u17B6\u1793\u1788\u17D2\u1793\u17C7\u17A2\u179F\u17CB\u1791\u17B6\u1793\u1791\u17B6\u17C6\u1784\u1796\u17BD\u1784 \u1796\u17D2\u179A\u17C4\u17C7\u1780\u17B6\u179A\u1785\u17BC\u179B\u179A\u17BD\u1798\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u200B\u1787\u17B6\u1780\u17B6\u179A\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780\u1796\u17D2\u179A\u17C7\u1792\u1798\u17CC\u178A\u17C2\u179B\u1796\u17D2\u179A\u17C7\u179F\u1798\u17D2\u1798\u17B6\u179F\u1798\u17D2\u1796\u17BB\u1791\u17D2\u1792\u1794\u17B6\u1793\u179F\u1798\u17D2\u178F\u17C2\u1784 \u178A\u179B\u17CB\u17A2\u17D2\u1793\u1780\u1780\u17C6\u1796\u17BB\u1784\u1785\u1784\u17CB\u178A\u17B9\u1784 \u1785\u1784\u17CB\u1785\u17C1\u17C7 \u1793\u17B7\u1784\u1785\u1784\u17CB\u1799\u179B\u17CB\u1796\u17B8\u1792\u1798\u17CC\u17D4</p><p>\u1780\u17D2\u179A\u17BB\u1798\u1799\u17BE\u1784\u1781\u17D2\u1789\u17BB\u17C6 \u179F\u17BC\u1798\u1790\u17D2\u179B\u17C2\u1784\u17A2\u17C6\u178E\u179A\u1782\u17BB\u178E\u178A\u17CF\u1787\u17D2\u179A\u17B6\u179B\u1787\u17D2\u179A\u17C5\u1794\u17C6\u1795\u17BB\u178F \u178A\u179B\u17CB\u1780\u17B6\u179A\u1785\u17BC\u179B\u179A\u17BD\u1798\u1785\u17C6\u178E\u17C2\u1780 \u1780\u17D2\u1793\u17BB\u1784\u1780\u17B6\u179A\u1792\u17D2\u179C\u17BE\u17B2\u17D2\u1799\u1782\u17C6\u179A\u17C4\u1784\u17A2\u17C1\u17A2\u17B6\u1799\u17A2\u1793\u17A1\u17B6\u1789\u1793\u17C1\u17C7 \u1791\u1791\u17BD\u179B\u1794\u17B6\u1793\u1787\u17C4\u1782\u1787\u17D0\u1799\u17D4</p>","english":"<p>We sincerely appeal to all generous individuals to support our online AI Tipitaka project in improving its quality and effectiveness by providing donations to our team according to your means and faith.</p><p>Your contributions will not only help enhance the development of our online platform but also empower our team with the resources and ability to acquire advanced technological equipment to implement and operate the project more effectively and in line with modern digital AI advancements.</p><p>Your participation in this donation is the most virtuous act of giving and the ultimate form of generosity, as it reflects the sharing of the Dhamma that the Buddha has taught to those seeking knowledge and understanding of the truth.</p><p>Our team would like to express our deepest gratitude for your participation in making this online AI project a success.</p>","english2":"<p>We invite kind-hearted individuals like you to make a meaningful impact by supporting our mission to enhance the <strong>Online Tripeitaka Project</strong>. Your generosity will directly contribute to improving the quality and effectiveness of this important initiative.</p><h2>Why Your Support Matters:</h2><p><strong>Empowering Progress:</strong> Your donation enables us to invest in advanced technology and tools, ensuring the project operates smoothly and stays up-to-date in today\u2019s digital world.</p><p><strong>Inspiring Impact:</strong> Your contribution fuels our team\u2019s dedication to preserving and modernizing this invaluable resource for everyone.</p><p>No matter the size, every donation counts. Together, we can make a difference in elevating this project to new heights. Join us in this meaningful journey by donating today and being a part of something truly impactful.</p><p>Thank you in advanxe for your kindness and support!</p>"},"speak2":{"khmer":"\u17A2\u17B6\u1793\u1787\u17B6\u179F\u17C6\u17A1\u17C1\u1784","english":"Read Aloud"},"stop2":{"khmer":"\u1794\u1789\u17D2\u1788\u1794\u17CB\u17A2\u17B6\u1793","english":"Stop Reading"},"tutor":{"khmer":"\u1782\u17D2\u179A\u17BC <span class=\'arial\'>AI</span>","english":"AI Tutor"},"tutor2":{"khmer":"\u1794\u17D2\u179A\u179F\u17B6\u179F\u1793\u17CD\u179A\u1794\u179F\u17CB\u1782\u17D2\u179A\u17BC\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u179A\u17BD\u1785\u17A0\u17BE\u1799!","english":"The tutor prompt has been copied!"},"tutor3":{"khmer":"\u179F\u17BC\u1798\u1796\u1793\u17D2\u1799\u179B\u17CB\u17A2\u17C6\u1796\u17B8\u1791\u17C6\u1796\u17D0\u179A\u1781\u17B6\u1784\u1780\u17D2\u179A\u17C4\u1798\u1796\u17B8\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780\u1787\u17B6\u1791\u17D2\u179A\u1784\u17CB\u1791\u17D2\u179A\u17B6\u1799\u1787\u17B6\u179C\u17B6\u1780\u17D2\u1799\u17D7\u1787\u17B6\u1794\u1793\u17D2\u178F\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB\u1787\u17B6\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A\u17D4: \\n\\n","english":"Translate and explain the following page from the Tipitaka line by line in English: \\n\\n"},"tutor4":{"khmer":"\u1794\u17D2\u179A\u179F\u17B6\u179F\u1793\u17CD\u179A\u1794\u179F\u17CB\u1782\u17D2\u179A\u17BC\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u179A\u17BD\u1785\u17A0\u17BE\u1799!","english":"Detailed analysis in English: "},"quiz":{"khmer":"\u179F\u17B7\u179F\u17D2\u179F <span class=\'arial\'>AI</span>","english":"AI Quiz"},"quiz2":{"khmer":"\u1794\u17D2\u179A\u1792\u17B6\u1793\u1794\u1791\u179F\u17C6\u178E\u17BD\u179A\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u179A\u17BD\u1785\u17A0\u17BE\u1799!","english":"The quiz prompt has been copied!"},"quiz3":{"khmer":"\u1794\u1784\u17D2\u1780\u17BE\u178F\u179B\u17D2\u1794\u17C2\u1784\u179F\u17C6\u178E\u17BD\u179A\u1796\u17B7\u178F\u17AC\u1798\u17B7\u1793\u1796\u17B7\u178F\u1787\u17B6\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A \u1787\u17B6\u179B\u17D2\u1794\u17C2\u1784\u179F\u1798\u17D2\u178A\u17C2\u1784\u1791\u17C5\u179C\u17B7\u1789\u1791\u17C5\u1798\u1780\u179A\u179C\u17B6\u1784\u17A2\u17D2\u1793\u1780\u1793\u17B7\u1784\u1781\u17D2\u1789\u17BB\u17C6 \u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u1791\u17C6\u1796\u17D0\u179A\u1781\u17B6\u1784\u1780\u17D2\u179A\u17C4\u1798\u1796\u17B8\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780\u17D4: \\n\\n","english":"Create a true or false quiz in English as a back and forth game between you and me for the following page from the Tipitaka: \\n\\n"},"pali3":{"khmer":"\u1790\u178F\u1785\u1798\u17D2\u179B\u1784\u1796\u17B6\u1780\u17D2\u1799\u1794\u17B6\u179B\u17B8","english":"Pali Transcription"},"khmer3":{"khmer":"\u1790\u178F\u1785\u1798\u17D2\u179B\u1784\u1796\u17B6\u1780\u17D2\u1799\u1781\u17D2\u1798\u17C2\u179A","english":"Khmer Transcription"},"copyall":{"khmer":"\u1790\u178F\u1785\u1798\u17D2\u179B\u1784","english":"Copy Text"},"open":{"khmer":"\u1794\u17BE\u1780","english":"Open"},"close":{"khmer":"\u1794\u17B7\u1791","english":"Close"},"clear":{"khmer":"\u179F\u1798\u17D2\u17A2\u17B6\u178F","english":"Clear"},"copyError":{"khmer":"\u179F\u17BC\u1798\u17A2\u1797\u17D0\u1799\u1791\u17C4\u179F \u1782\u17D2\u1798\u17B6\u1793\u17A2\u17D2\u179C\u17B8\u178F\u17D2\u179A\u17BC\u179C\u1785\u1798\u17D2\u179B\u1784\u1791\u17C1","english":"Sorry, there is nothing to copy."},"cover":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A\u1782\u1798\u17D2\u179A\u1794","english":"Cover Page"},"shareError":{"khmer":"\u179F\u17BC\u1798\u17A2\u1797\u17D0\u1799\u1791\u17C4\u179F \u179F\u17BC\u1798\u1796\u17D2\u1799\u17B6\u1799\u17B6\u1798\u1798\u17D2\u178F\u1784\u1791\u17C0\u178F","english":"Sorry, please try again."},"dict2":{"khmer":"\u179C\u1785\u1793\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798 \u179F\u1798\u17D2\u178F\u17C1\u1785 \u1787\u17BC\u1793 \u178E\u17B6\u178F","english":"Chuon Nath Dictionary"},"dict3":{"khmer":"\u179C\u1785\u1793\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798\u200B","english":"Dictionary"},"search":{"khmer":"\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780","english":"Search"},"search2":{"khmer":"\u1794\u1789\u17D2\u1785\u17BC\u179B\u1796\u17B6\u1780\u17D2\u1799\u178A\u17BE\u1798\u17D2\u1794\u17B8\u179A\u1780\u1793\u17B7\u1799\u1798\u1793\u17D0\u1799","english":"Enter word to look up the definition."},"search3":{"khmer":"\u1798\u17B7\u1793\u1798\u17B6\u1793\u179B\u1791\u17D2\u1792\u1795\u179B\u1791\u17C1","english":"There are no suggestions."},"search4":{"khmer":"\u1798\u17B7\u1793\u1798\u17B6\u1793\u1793\u17B7\u1799\u1798\u1793\u17D0\u1799\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u1796\u17B6\u1780\u17D2\u1799\u1793\u17C4\u17C7\u1791\u17C1","english":"There is no definition for that word."},"back":{"khmer":"\u1796\u17B6\u1780\u17D2\u1799\u1798\u17BB\u1793","english":"Go Back"},"loading":{"khmer":"\u1780\u17C6\u1796\u17BB\u1784\u1795\u17D2\u1791\u17BB\u1780...","english":"Loading..."},"transcribe1":{"khmer":"\u17A5\u178F\u1798\u17B6\u1793\u1796\u17B6\u1780\u17D2\u1799\u17A2\u17D2\u179C\u17B8\u178F\u17D2\u179A\u17BC\u179C\u1790\u178F\u1785\u1798\u17D2\u179B\u1784\u1791\u17C1","english":"There\'s no text in the image."},"transcribe2":{"khmer":"\u1798\u17B6\u1793\u1794\u1789\u17D2\u17A0\u17B6\u1794\u1785\u17D2\u1785\u1780\u1791\u17C1\u179F\u1780\u17D2\u1793\u17BB\u1784\u1780\u17B6\u179A\u1790\u178F\u1785\u1798\u17D2\u179B","english":"Sorry, there was an error transcribing."},"transcribe3":{"khmer":"\u179A\u1780\u1796\u17B6\u1780\u17D2\u1799\u1790\u178F\u1785\u1798\u17D2\u179B\u1784\u1798\u17B7\u1793\u1783\u17BE\u1789","english":"No text was found."},"transcribe4":{"khmer":"\u1780\u17C6\u1796\u17BB\u1784\u178A\u17C6\u178E\u17BE\u179A\u1780\u17B6\u179A","english":"Transcribing in progress"},"feedback":{"khmer":"\u1795\u17D2\u178F\u179B\u17CB\u1798\u178F\u17B7\u1799\u17C4\u1794\u179B\u17CB","english":"Give Feedback"},"feedback1":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u17BC\u179B\u1785\u17B7\u178F\u17D2\u178F\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u1793\u17C1\u17C7\u17AC\u1791\u17C1?","english":"Do you like this app?"},"feedback2":{"khmer":"\u178F\u17BE\u1799\u17BE\u1784\u17A2\u17B6\u1785\u1792\u17D2\u179C\u17BE\u17B1\u17D2\u1799\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u1793\u17C1\u17C7\u1794\u17D2\u179A\u179F\u17BE\u179A\u17A1\u17BE\u1784\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u17A2\u17D2\u1793\u1780\u178A\u17BC\u1785\u1798\u17D2\u178F\u17C1\u1785\u1794\u17B6\u1793\u1781\u17D2\u179B\u17C7?","english":"How can we improve this app for you?"},"feedback3":{"khmer":"\u1794\u1789\u17D2\u1785\u17BC\u179B\u1782\u178E\u1793\u17B8","english":"Login to Submit"},"feedback4":{"khmer":"\u1794\u1789\u17D2\u1787\u17BC\u1793\u200B","english":"Submit"},"feedback5":{"khmer":"\u1785\u17B6\u1780\u1785\u17C1\u1789\u200B","english":"Logout"},"feedback6":{"khmer":"\u1791\u1791\u17BD\u179B\u1794\u17B6\u1793\u1780\u17B6\u179A\u1794\u1789\u17D2\u1785\u17BB\u17C7\u178F\u1798\u17D2\u179B\u17C3\u1793\u17C5 333 Tuk Tuk \u1793\u17C5\u1796\u17C1\u179B\u17A2\u17D2\u1793\u1780\u1794\u1789\u17D2\u1785\u1794\u17CB\u1780\u17B6\u179A\u1795\u17D2\u178F\u179B\u17CB\u1798\u178F\u17B7\u1799\u17C4\u1794\u179B\u17CB!","english":"Receive a discount at 333 Tuk Tuk when you complete a feedback!"},"feedback7":{"khmer":"\u179F\u17BC\u1798\u17A2\u1793\u17BB\u1789\u17D2\u1789\u17B6\u178F\u17B2\u17D2\u1799\u1794\u1784\u17D2\u17A2\u17BD\u1785\u179B\u17C1\u1785\u17A1\u17BE\u1784 \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1785\u17BC\u179B\u1794\u17D2\u179A\u17BE HeartBank\xae Vault \u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17D4","english":"Please allow popup to access your HeartBank\xae Vault"},"feedback8":{"khmer":"\u179F\u17BC\u1798\u17A2\u179A\u1782\u17BB\u178E\u1785\u17C6\u1796\u17C4\u17C7\u1780\u17B6\u179A\u1795\u17D2\u178F\u179B\u17CB\u1798\u178F\u17B7\u1799\u17C4\u1794\u179B\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780!","english":"Thanks so much for giving us a feedback!"},"feedback9":{"khmer":"\u179F\u17BC\u1798\u17A2\u179A\u1782\u17BB\u178E\u1785\u17C6\u1796\u17C4\u17C7\u1780\u17B6\u179A\u1795\u17D2\u178F\u179B\u17CB\u1798\u178F\u17B7\u1799\u17C4\u1794\u179B\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780! \u1780\u17BC\u178A\u1794\u1789\u17D2\u1785\u17BB\u17C7\u178F\u1798\u17D2\u179B\u17C3\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB 333 Tuk Tuk \u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u1782\u17BA 333\u17D4","english":"Thanks so much for giving us a feedback! Your 333 Tuk Tuk discount code is 333."},"feedback10":{"khmer":"\u1785\u17BC\u179B\u178A\u17C4\u1799\u1794\u17D2\u179A\u17BE HeartBank\xae \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1792\u17D2\u179C\u17BE\u179F\u1798\u1780\u17B6\u179B\u1780\u1798\u17D2\u1798\u1785\u17C6\u178E\u17B6\u17C6\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u1793\u17C5\u179B\u17BE\u17A7\u1794\u1780\u179A\u178E\u17CD\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17D4","english":"Login with HeartBank\xae to sync your bookmarks across your devices."},"feedback11":{"khmer":"\u1785\u17BC\u179B\u1794\u17D2\u179A\u17BE","english":"Login"},"feedback12":{"khmer":"\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u1785\u17C1\u1789\u1796\u17B8 Silicon Wat \u178A\u17C4\u1799\u1787\u17C4\u1782\u1787\u17D0\u1799\u17A0\u17BE\u1799\u17D4 \u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u1785\u17C1\u1789\u1796\u17B8 HeartBank\xae Vault \u1795\u1784\u178A\u17C2\u179A\u200B\u17AC\u1791\u17C1?","english":"You have successfully logged out of Silicon Wat. Would you like to log out of HeartBank\xae Vault, too?"},"feedback13":{"khmer":"\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u1785\u17C1\u1789\u1796\u17B8 HeartBank\xae Vault \u1793\u17B7\u1784 Silicon Wat \u178A\u17C4\u1799\u1787\u17C4\u1782\u1787\u17D0\u1799\u17A0\u17BE\u1799\u17D4","english":"You have successfully logged out of HeartBank\xae Vault and Silicon Wat."},"feedback14":{"khmer":"\u1793\u17C5\u1796\u17C1\u179B\u178A\u17C2\u179B\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u1785\u17BC\u179B\u1794\u17D2\u179A\u17BE \u1794\u17CA\u17BB\u1780\u1798\u17C9\u17B6\u1791\u17B6\u17C6\u1784\u17A2\u179F\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u1793\u17B9\u1784\u178F\u17D2\u179A\u17BC\u179C\u179F\u1798\u17D2\u179A\u1794\u179F\u1798\u17D2\u179A\u17BD\u179B\u1787\u17B6\u1798\u17BD\u1799\u17A7\u1794\u1780\u179A\u178E\u17CD\u1791\u17B6\u17C6\u1784\u17A2\u179F\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17D4","english":"When you\'re logged in, your bookmarks are synced across your devices."},"feedback15":{"khmer":"\u179F\u17BD\u179F\u17D2\u178F\u17B8!","english":"Hello!"},"feedback16":{"khmer":"\u179F\u17BD\u179F\u17D2\u178F\u17B8, ","english":"Hi, "},"feedback17":{"khmer":"\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u1785\u17BC\u179B\u1794\u17D2\u179A\u17BE\u1794\u17D2\u179A\u17B6\u179F\u17CB HeartBank\xae Vault \u1793\u17B7\u1784 Silicon Wat \u1794\u17B6\u1793\u1787\u17C4\u1782\u1787\u17D0\u1799\u17D4","english":"You have successfully logged into HeartBank\xae Vault and Silicon Wat."},"editor":{"khmer":"\u17A2\u17D2\u1793\u1780\u1793\u17B7\u1796\u1793\u17D2\u1792","english":"Editor"},"editor2":{"khmer":"\u1782\u17D2\u1798\u17B6\u1793","english":"None"},"editor3":{"khmer":"\u1795\u17D2\u179F\u1796\u17D2\u179C\u1795\u17D2\u179F\u17B6\u1799","english":"Publish"},"editor4":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u1795\u17D2\u179F\u17B6\u1799\u1795\u17D2\u179F\u17C6\u17AC\u1791\u17C1?","english":"Would you like to publish?"},"editor5":{"khmer":"\u179F\u17C1\u1785\u1780\u17D2\u178A\u17B8\u1796\u17D2\u179A\u17B6\u1784\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u179A\u1780\u17D2\u179F\u17B6\u1791\u17BB\u1780\u1793\u17C5\u179B\u17BE\u17A7\u1794\u1780\u179A\u178E\u17CD\u1793\u17C1\u17C7\u17D4","english":"Your draft has been saved on this device"},"editor6":{"khmer":"\u1780\u17B6\u179A\u1794\u17D2\u179A\u17C2\u1787\u17B6\u1797\u17B6\u179F\u17B6\u17A2\u1784\u17CB\u1782\u17D2\u179B\u17C1\u179F\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1792\u17D2\u179C\u17BE\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u1797\u17B6\u1796\u17A0\u17BE\u1799\u17D4","english":"English translation has been updated"},"editor7":{"khmer":"\u1794\u1784\u17D2\u17A0\u17C4\u17C7\u1780\u17B6\u179A\u17A2\u17B6\u1793\u17A2\u17BC\u178C\u17B8\u1799\u17C9\u17BC","english":"Upload Audio Reading"},"editor8":{"khmer":"\u1792\u17D2\u179C\u17BE\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u1797\u17B6\u1796\u1780\u17B6\u179A\u1794\u1780\u1794\u17D2\u179A\u17C2\u1797\u17B6\u179F\u17B6\u17A2\u1784\u17CB\u1782\u17D2\u179B\u17C1\u179F","english":"Update English Translation"},"audio":{"khmer":"\u179F\u17BC\u1798\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u17AF\u1780\u179F\u17B6\u179A MP3 \u1798\u17BD\u1799","english":"Please select an MP3 file"},"audio2":{"khmer":"\u17A2\u17B6\u1785\u1794\u17D2\u179A\u17BE\u1794\u17B6\u1793\u178F\u17C2\u17AF\u1780\u179F\u17B6\u179A MP3 \u1798\u17BD\u1799\u1794\u17C9\u17BB\u178E\u17D2\u178E\u17C4\u17C7","english":"Only one MP3 file is allowed"},"audio3":{"khmer":"\u1780\u17C6\u1796\u17BB\u1784\u1795\u17D2\u1791\u17BB\u1780\u17A1\u17BE\u1784...","english":"Uploading..."},"audio4":{"khmer":"\u1795\u17D2\u1791\u17BB\u1780\u17A1\u17BE\u1784\u178A\u17C4\u1799\u1787\u17C4\u1782\u1787\u17D0\u1799!","english":"Upload successful!"},"map1":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780\u1791\u17B8\u178F\u17B6\u17C6\u1784\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780 \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793\u1795\u17D2\u179F\u17C1\u1784\u1791\u17C0\u178F\u17AC\u1791\u17C1?","english":"Would you like to share your location to see other readers?"},"map2":{"khmer":"\u179F\u17BC\u1798\u1794\u17BE\u1780\u1798\u17BB\u1781\u1784\u17B6\u179A geolocation \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793\u1795\u17D2\u179F\u17C1\u1784\u1791\u17C0\u178F","english":"Please enable geolocation to see other readers"},"map3":{"khmer":"\u1785\u17B6\u17C6\u1794\u17B6\u1785\u17CB\u178F\u17D2\u179A\u17BC\u179C\u1780\u17B6\u179A\u1798\u17BB\u1781\u1784\u17B6\u179A geolocation \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793\u1795\u17D2\u179F\u17C1\u1784\u1791\u17C0\u178F\u17D4","english":"Geolocation is required to see other readers"},"map4":{"khmer":"\u179F\u17BC\u1798\u17A2\u1797\u17D0\u1799\u1791\u17C4\u179F \u179F\u17BC\u1798\u179F\u17B6\u1780\u179B\u17D2\u1794\u1784\u1798\u17D2\u178A\u1784\u1791\u17C0\u178F\u1780\u17D2\u179A\u17C4\u1799\u1798\u1780\u17D4","english":"Sorry, please try again later"},"map5":{"khmer":"\u1785\u17BC\u179B\u1782\u178E\u1793\u17B8","english":"Login"},"map6":{"khmer":"333 \u17A1\u17B6\u1793\u1780\u17D2\u179A\u17BB\u1784","english":"Bus 333"},"map16":{"khmer":"\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7\u200B\u1781\u17D2\u1789\u17BB\u17C6","english":"Profile"},"map7":{"khmer":"\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780","english":"Bedok Reader"},"map8":{"khmer":"\u17A2\u17B6\u1793\u1794\u17B6\u1793","english":"Hours Read"},"map8b":{"khmer":"\u1798\u17C9\u17C4\u1784","english":""},"map14":{"khmer":"\u17A2\u17B6\u1793\u1794\u17B6\u1793","english":"Pages Read"},"map14b":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A","english":""},"map18":{"khmer":"\u1791\u179F\u17D2\u179F\u1780\u17B7\u1785\u17D2\u1785\u1796\u17BB\u1791\u17D2\u1792\u17B6\u179A\u17B6\u1798","english":"Temple Visits"},"map18b":{"khmer":"\u178A\u1784","english":""},"map9":{"khmer":"\u179F\u179A\u17BB\u1794\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793","english":"Total Readers"},"map9b":{"khmer":"\u1793\u17B6\u1780\u17CB","english":""},"map42":{"khmer":"\u1796\u17D2\u179A\u17C7\u179F\u1784\u17D2\u1783\u179F\u179A\u17BB\u1794","english":"Total Monks"},"map42b":{"khmer":"\u1793\u17B6\u1780\u17CB","english":""},"map43":{"khmer":"\u1795\u17D2\u1791\u17C7\u179F\u179A\u17BB\u1794","english":"Total Homes"},"map43b":{"khmer":"\u1793\u17B6\u1780\u17CB","english":""},"map44":{"khmer":"\u179C\u178F\u17D2\u178F\u17A2\u17B6\u179A\u17B6\u1798\u179F\u179A\u17BB\u1794","english":"Total Temples"},"map44b":{"khmer":"\u1793\u17B6\u1780\u17CB","english":""},"map10":{"khmer":"\u179F\u179A\u17BB\u1794","english":"Total Hours"},"map10b":{"khmer":"\u1798\u17C9\u17C4\u1784","english":""},"map13":{"khmer":"\u179F\u179A\u17BB\u1794\u1794\u17B6\u1793\u17A2\u17B6\u1793","english":"Total Pages"},"map13b":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A","english":""},"map11":{"khmer":"\u179F\u179A\u17BB\u1794\u1796\u17B6\u1780\u17D2\u1799\u17A2\u179A\u1782\u17BB\u178E","english":"Total Thanks"},"map11b":{"khmer":"\u1793\u17B6\u1780\u17CB","english":""},"map12":{"khmer":"\u1780\u17B6\u179A\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782\u179F\u179A\u17BB\u1794","english":"Total Donations"},"map15":{"khmer":"wat","english":"wat"},"map17":{"khmer":"\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6","english":"Cambodia"},"map17b":{"khmer":"\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6","english":"United States of America"},"map17c":{"khmer":"\u1794\u17D2\u179A\u1791\u17C1\u179F\u1794\u17B6\u179A\u17B6\u17C6\u1784","english":"France"},"map17d":{"khmer":"\u17A2\u17BC\u179F\u17D2\u178F\u17D2\u179A\u17B6\u179B\u17B8","english":"Australia"},"map19":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1794\u17D2\u179A\u17B6\u1780\u178A\u1790\u17B6\u1785\u1784\u17CB\u1785\u17C1\u1789\u1796\u17B8 HeartBank\xae \u1798\u17C2\u1793\u1791\u17C1?","english":"Are you sure you want to log out of HeartBank\xae?"},"map20":{"khmer":"\u1781\u17D2\u1789\u17BB\u17C6","english":"My Profile"},"map21":{"khmer":"\u17A2\u17D2\u1793\u1780\u1791\u179F\u17D2\u179F\u1793\u17B6\u178A\u17C2\u179B\u1794\u17B6\u1793\u1785\u17BB\u17C7\u1788\u17D2\u1798\u17C4\u17C7","english":"Checked-In Visitors"},"map22":{"khmer":"\u1780\u17B6\u179A\u1780\u17C6\u178E\u178F\u17CB","english":"Settings"},"map23":{"khmer":"\u179B\u17C1\u1781\u179F\u1798\u17D2\u1784\u17B6\u178F\u17CB","english":"Passkeys"},"map24":{"khmer":"\u1785\u17BB\u17C7\u1788\u17D2\u1798\u17C4\u17C7\u1785\u17BC\u179B","english":"Check-In"},"map25":{"khmer":"\u1780\u17D2\u179B\u17B9\u1794\u179F\u17C0\u179C\u1797\u17C5","english":"Book Club"},"map26":{"khmer":"\u17A2\u179A\u1782\u17BB\u178E\u17A2\u17D2\u1793\u1780","english":"Thank Me"},"map27":{"khmer":"\u179B\u17C6\u178A\u17B6\u1794\u17CB\u1790\u17D2\u1793\u17B6\u1780\u17CB\u1791\u17B8 ","english":"Rank"},"map28":{"khmer":"\u179F\u17BC\u1798\u17A2\u17B6\u1793\u179A\u1784\u17D2\u179C\u17B6\u1793\u17CB\u179B\u17BE\u1780\u1791\u17B9\u1780\u1785\u17B7\u178F\u17D2\u178F","english":"Encouragement Reward"},"map28b":{"khmer":"\u179F\u17BC\u1798\u200B\u17A2\u17D2\u1793\u1780\u200B\u1794\u1789\u17D2\u1785\u17BC\u179B\u200B QR Code / \u179B\u17C1\u1781\u1782\u178E\u1793\u17B8 \u1793\u17C3\u200B\u1792\u1793\u17B6\u1782\u17B6\u179A\u200B ABA \u179A\u1794\u179F\u17CB\u200B\u17A2\u17D2\u1793\u1780\u1793\u17C5\u200B\u1791\u17B8\u1793\u17C1\u17C7\u200B \u178A\u17C1\u17B8\u1798\u17D2\u1794\u17B8\u200B\u1784\u17B6\u1799\u200B\u179F\u17D2\u179A\u17BD\u179B\u1791\u1791\u17BD\u179B\u1794\u17D2\u179A\u17B6\u1780\u17CB","english":"What\\\\\'s your ABA account number?"},"map29":{"khmer":"\u1787\u17BC\u1793\u179A\u1784\u17D2\u179C\u17B6\u1793\u17CB\u179B\u17BE\u1780\u1791\u17B9\u1780\u1785\u17B7\u178F\u17D2\u178F\u17A2\u17D2\u1793\u1780","english":"Reward Me"},"map30":{"khmer":"\u1794\u17B7\u1791\u1794\u17BE\u1780 \u1793\u17B7\u1784\u1794\u17B7\u1791","english":"Toggle On and Off"},"map31":{"khmer":"\u1794\u17D2\u179A\u17BE HeartBank\xae \u179F\u17C6\u179A\u17B6\u1794\u17CB\u17A2\u179A\u1782\u17BB\u178E","english":"Thank with HeartBank\xae"},"map32":{"khmer":"\u1792\u17D2\u179C\u17BE\u1791\u17B6\u1793\u178F\u17B6\u1798\u179A\u1799\u17C8\u1781\u17D2\u1789\u17BB\u17C6","english":"The Gift of Giving"},"map32b":{"khmer":"\u179F\u17BC\u1798\u200B\u17A2\u17D2\u1793\u1780\u200B\u1794\u1789\u17D2\u1785\u17BC\u179B\u200B QR Code / \u179B\u17C1\u1781\u1782\u178E\u1793\u17B8 \u1793\u17C3\u200B\u1792\u1793\u17B6\u1782\u17B6\u179A\u200B ABA \u179A\u1794\u179F\u17CB\u200B\u17A2\u17D2\u1793\u1780\u1793\u17C5\u200B\u1791\u17B8\u1793\u17C1\u17C7\u200B \u178A\u17C1\u17B8\u1798\u17D2\u1794\u17B8\u200B\u1784\u17B6\u1799\u200B\u179F\u17D2\u179A\u17BD\u179B\u1791\u1791\u17BD\u179B\u1794\u17D2\u179A\u17B6\u1780\u17CB","english":"What\\\\\'s your ABA account number?"},"map33":{"khmer":"\u1792\u17D2\u179C\u17BE\u1791\u17B6\u1793\u178F\u17B6\u1798\u179A\u1799\u17C8\u17A2\u17D2\u1793\u1780","english":"Sponsor Me"},"map33b":{"khmer":"\u1782\u17C4\u179B\u1794\u17C6\u178E\u1784\u179A\u1794\u179F\u17CB\u1791\u17B6\u1793","english":"How should I donate on your behalf?"},"map34":{"khmer":"\u1796\u17BD\u1780\u1799\u17BE\u1784\u200B\u179F\u17BC\u1798\u200B\u1790\u17D2\u179B\u17C2\u1784\u200B\u17A2\u17C6\u178E\u179A\u1782\u17BB\u178E\u200B\u178A\u179B\u17CB\u200B\u17A2\u17D2\u1793\u1780\u200B \u178A\u17C2\u179B\u200B\u1794\u17B6\u1793\u200B\u1796\u17D2\u1799\u17B6\u1799\u17B6\u1798\u200B \u17A2\u17B6\u1793\u200B\u1782\u1798\u17D2\u1796\u17B8\u179A\u200B\u1796\u17D2\u179A\u17C7\u200B\u178F\u17D2\u179A\u17C3\u200B\u1794\u17B7\u178A\u1780\u200B \u1794\u17B6\u1793\u200B \u17E5\u17E0\u200B \u1798\u17C9\u17C4\u1784\u200B \u1780\u17D2\u1793\u17BB\u1784\u200B\u1781\u17C2\u200B\u1793\u17C1\u17C7\u200B\u17D4 \u178A\u17BC\u1785\u17D2\u1793\u17C1\u17C7\u1796\u17BD\u1780\u1799\u17BE\u1784 \u200B\u179F\u17BC\u1798\u200B\u1785\u17BC\u179B\u200B\u179A\u17BD\u1798\u200B\u1787\u17B6\u200B\u17A2\u17C6\u178E\u17C4\u1799\u200B\u179B\u17C1\u17B8\u1780\u200B\u1791\u17B9\u1780\u200B\u1785\u17B7\u178F\u17D2\u178F\u200B\u1785\u17C6\u1793\u17BD\u1793\u200B \u17E4\u17E0\u17E0\u17E0\u200B \u179A\u17C0\u179B\u200B \u178A\u179B\u17CB\u200B\u1780\u17B6\u179A\u200B\u17A2\u17B6\u1793\u200B \u178A\u17BE\u1798\u17D2\u1794\u17B8\u200B\u1794\u1784\u17D2\u1780\u17BE\u1793\u200B\u1780\u17B6\u179A\u200B\u1799\u179B\u17CB\u178A\u17B9\u1784\u200B\u1780\u17D2\u1793\u17BB\u1784\u200B\u1791\u17D2\u179A\u17B9\u179F\u17D2\u178F\u17B8\u200B\u179A\u1794\u179F\u17CB\u200B\u1796\u17D2\u179A\u17C7\u200B\u179F\u1798\u17D2\u1798\u17B6\u179F\u1798\u17D2\u1796\u17BB\u1791\u17D2\u1792\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17D4","english":"We would like to express our gratitude to those who have read the Tipitaka (Bedok) for 60 hours this month. We would like to contribute 4,000 riels in monetary and spiritual contributions to the reading and increasing understanding of the Buddha."},"map35":{"khmer":"\u179B\u17BB\u1794\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u17A2\u17B6\u1793","english":"Delete Reader"},"map35b":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1796\u17B7\u178F\u1787\u17B6\u1785\u1784\u17CB\u179B\u17BB\u1794\u1780\u1798\u17D2\u1798\u179C\u17B7\u1792\u17B8\u17A2\u17B6\u1793\u1793\u17C1\u17C7\u1798\u17C2\u1793\u1791\u17C1?","english":"Are you sure you want to delete this reader?"},"map36":{"khmer":"\u179F\u17BC\u1798\u179A\u1784\u17CB\u1785\u17B6\u17C6...","english":"Please wait..."},"map37":{"khmer":"\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u179B\u17BE\u179F\u1780\u17BC\u178F\u17B6\u17A5\u178F\u1782\u17B7\u178F\u1790\u17D2\u179B\u17C3\u17A0\u17BE\u1799\u17D4 \u179F\u17BC\u1798\u179A\u1784\u17CB\u1785\u17B6\u17C6\u179A\u17A0\u17BC\u178F\u178A\u179B\u17CB\u1781\u17C2\u1780\u17D2\u179A\u17C4\u1799\u17D4","english":"You have exceeded the free quota. Please wait until next month."},"map38":{"khmer":"\u1794\u1784\u17D2\u17A0\u17B6\u1789 \u17AC\u179B\u17B6\u1780\u17CB\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791","english":"Show or hide temples"},"map39":{"khmer":"\u1794\u1784\u17D2\u17A0\u17B6\u1789 \u17AC\u179B\u17B6\u1780\u17CB\u1796\u17D2\u179A\u17C7\u179F\u1784\u17D2\u1783","english":"Show or hide monks"},"map40":{"khmer":"\u1794\u1784\u17D2\u17A0\u17B6\u1789 \u17AC\u179B\u17B6\u1780\u17CB\u1795\u17D2\u1791\u17C7","english":"Show or hide homes"},"map41":{"khmer":"\u1794\u1784\u17D2\u17A0\u17B6\u1789 \u17AC\u179B\u17B6\u1780\u17CB\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793","english":"Show or hide readers"},"map45":{"khmer":"\u1794\u17C9\u17C7\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1794\u17BE\u1780\u1791\u17B8\u178F\u17B6\u17C6\u1784\u1793\u17C1\u17C7\u1793\u17C5\u1780\u17D2\u1793\u17BB\u1784 Google \u1795\u17C2\u1793\u1791\u17B8","english":"Tap to open this location in Google Maps"},"map46":{"khmer":"\u178F\u17BE\u200B\u179C\u178F\u17D2\u178F\u200B\u1790\u17D2\u1798\u17B8\u200B\u1793\u17C1\u17C7\u200B\u1798\u17B6\u1793\u200B\u1788\u17D2\u1798\u17C4\u17C7\u200B\u17A2\u17D2\u179C\u17B8?","english":"What\'s the new name for this temple?"},"map46b":{"khmer":"\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1780\u17C2\u179F\u1798\u17D2\u179A\u17BD\u179B\u1788\u17D2\u1798\u17C4\u17C7\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7","english":"Tap to edit the name of this temple"},"map47":{"khmer":"\u178F\u17BE\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793\u1790\u17D2\u1798\u17B8\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7\u1787\u17B6\u17A2\u17D2\u179C\u17B8?","english":"What\'s the new address for this temple?"},"map47b":{"khmer":"\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1780\u17C2\u179F\u1798\u17D2\u179A\u17BD\u179B\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793\u1793\u17C3\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7","english":"Tap to edit the address of this temple"},"map48":{"khmer":"\u178F\u17BE\u200B\u17A2\u17D2\u179C\u17B8\u200B\u1791\u17C5\u200B\u1787\u17B6\u200B\u178F\u17C6\u178E\u200B\u1797\u17D2\u1787\u17B6\u1794\u17CB\u200B\u1790\u17D2\u1798\u17B8\u200B\u1791\u17C5\u200B\u1780\u17B6\u1793\u17CB\u200B\u179C\u178F\u17D2\u178F\u200B\u1793\u17C1\u17C7?","english":"What\'s the new link to this temple?"},"map48b":{"khmer":"\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1780\u17C2\u179F\u1798\u17D2\u179A\u17BD\u179B\u178F\u17C6\u178E\u1797\u17D2\u1787\u17B6\u1794\u17CB\u1791\u17C5\u1780\u17B6\u1793\u17CB\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7","english":"Tap to edit the link to this temple"},"map49b":{"khmer":"\u1794\u17C4\u17C7\u1796\u17BB\u1798\u17D2\u1796\u1795\u17D2\u179F\u17B6\u1799\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791","english":"Publish Temple"},"map49":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1796\u17B7\u178F\u1787\u17B6\u1785\u1784\u17CB\u1794\u17C4\u17C7\u1796\u17BB\u1798\u17D2\u1796\u1795\u17D2\u179F\u17B6\u1799\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7\u1798\u17C2\u1793\u1791\u17C1?","english":"Are you sure you want to publish this temple?"},"map50b":{"khmer":"\u1788\u1794\u17CB\u1794\u17C4\u17C7\u1796\u17BB\u1798\u17D2\u1796\u1795\u17D2\u179F\u17B6\u1799\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791","english":"Unpublish Temple"},"map50":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1796\u17B7\u178F\u1787\u17B6\u1785\u1784\u17CB\u1788\u1794\u17CB\u1794\u17C4\u17C7\u1796\u17BB\u1798\u17D2\u1796\u1795\u17D2\u179F\u17B6\u1799\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791\u1793\u17C1\u17C7\u1798\u17C2\u1793\u1791\u17C1?","english":"Are you sure you want to unpublish this temple?"},"map51b":{"khmer":"\u179B\u17BB\u1794\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791","english":"Delete Temple"},"map51":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1796\u17B7\u178F\u1787\u17B6\u1785\u1784\u17CB\u179B\u17BB\u1794\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7\u1798\u17C2\u1793\u1791\u17C1?","english":"Are you sure you want to delete this temple?"},"map52":{"khmer":"\u178F\u17BE\u179C\u178F\u17D2\u178F\u1793\u17C1\u17C7\u1798\u17B6\u1793\u1788\u17D2\u1798\u17C4\u17C7\u17A2\u17D2\u179C\u17B8?","english":"What\'s the name of this temple?"},"map53":{"khmer":"\u1794\u1793\u17D2\u1790\u17C2\u1798\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791","english":"Add Temple"},"map54":{"khmer":"\u179F\u17BC\u1798\u17A2\u1797\u17D0\u1799\u1791\u17C4\u179F \u1791\u17B8\u178F\u17B6\u17C6\u1784\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17C1","english":"Sorry, your current location is not available"},"map55":{"khmer":"\u1794\u17C9\u17C7\u178A\u17BE\u1798\u17D2\u1794\u17B8\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780\u1791\u17B8\u1780\u17D2\u179A\u17BB\u1784 \u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1793 \u1796\u17D2\u179A\u17C7\u179F\u1784\u17D2\u1783 \u1795\u17D2\u1791\u17C7 \u17AC\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791","english":"Tap to search for city, reader, monk, home, or temple"},"map56":{"khmer":"\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1794\u1793\u17D2\u1790\u17C2\u1798\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791\u1791\u17C5\u1791\u17B8\u178F\u17B6\u17C6\u1784\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780","english":"Tap to add a temple to your current location"},"map57":{"khmer":"\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1794\u1793\u17D2\u1790\u17C2\u1798\u1795\u17D2\u1791\u17C7\u1791\u17C5\u1791\u17B8\u178F\u17B6\u17C6\u1784\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780","english":"Tap to add a home to your current location"},"map58":{"khmer":"\u1794\u17C9\u17C7\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1794\u17BE\u1780 \u17AC\u1794\u17B7\u1791\u179F\u17C6\u17A1\u17C1\u1784","english":"Tap to turn the sound on or off"},"map59":{"khmer":"\u178F\u17BE\u200B\u1780\u17BC\u17A2\u179A\u178A\u17C4\u1793\u17C1 GPS \u179A\u1794\u179F\u17CB\u200B\u179C\u178F\u17D2\u178F\u200B\u1793\u17C1\u17C7\u200B\u179F\u17D2\u1790\u17B7\u178F\u200B\u1793\u17C5\u200B\u178F\u17D2\u179A\u1784\u17CB\u200B\u178E\u17B6?","english":"What\'s the GPS coordinate of this temple?"},"map60":{"khmer":"\u1791\u17BB\u1780\u200B\u17B2\u17D2\u1799\u200B\u1791\u1791\u17C1\u200B\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB\u200B\u1791\u17B8\u178F\u17B6\u17C6\u1784\u200B\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u200B\u179A\u1794\u179F\u17CB\u200B\u17A2\u17D2\u1793\u1780","english":"Leave blank for your current location"},"movie1":{"khmer":"\u1797\u17B6\u1782 1","english":"Part 1"},"movie2":{"khmer":"\u1797\u17B6\u1782 2","english":"Part 2"},"movie3":{"khmer":"\u1797\u17B6\u1782 3","english":"Part 3"},"movie4":{"khmer":"\u1797\u17B6\u1782 4","english":"Part 4"},"movie5":{"khmer":"\u1797\u17B6\u1782 5","english":"Part 5"},"movie6":{"khmer":"\u179A\u17BF\u1784\u1796\u17D2\u179A\u17C7\u1796\u17BB\u1791\u17D2\u1792","english":"Buddha Movie"},"movie7":{"khmer":"\u1791\u17B6\u1789\u1799\u1780\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u1780\u17D2\u179A\u17C5\u1794\u178E\u17D2\u178F\u17B6\u1789","english":"Download movie to watch offline"},"movie8":{"khmer":"1 \u1785\u1794\u17CB","english":"Next"},"movie9":{"khmer":"1 \u1785\u1794\u17CB","english":"Part 1"},"movie10":{"khmer":"\u179F\u17BC\u1798\u17A2\u1797\u17D0\u1799\u1791\u17C4\u179F \u1780\u17B6\u179A\u1791\u17B6\u1789\u1799\u1780\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F\u1794\u17B6\u1793\u1794\u179A\u17B6\u1787\u17D0\u1799\u17D4 \u179F\u17BC\u1798\u179B\u17BB\u1794\u179C\u17B6\u1785\u17C4\u179B \u17A0\u17BE\u1799\u1796\u17D2\u1799\u17B6\u1799\u17B6\u1798\u1798\u17D2\u178F\u1784\u1791\u17C0\u178F\u17D4","english":"Sorry, movie download failed. Please delete and try again."},"movie11":{"khmer":"\u1795\u17D2\u17A2\u17B6\u1780\u1780\u17B6\u179A\u1791\u17B6\u1789\u1799\u1780\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F","english":"Pause movie download"},"movie12":{"khmer":"\u179B\u17BB\u1794\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F\u1785\u17C1\u1789\u1796\u17B8\u17A7\u1794\u1780\u179A\u178E\u17CD\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780","english":"Delete movie from your device"},"movie13":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1794\u17D2\u179A\u17B6\u1780\u178A\u1790\u17B6\u1785\u1784\u17CB\u179B\u17BB\u1794\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F\u1793\u17C1\u17C7\u1785\u17C1\u1789\u1796\u17B8\u17A7\u1794\u1780\u179A\u178E\u17CD\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u1798\u17C2\u1793\u1791\u17C1?","english":"Are you sure you want to delete this movie from your device?"},"movie14":{"khmer":"\u1791\u17B6\u1789\u1799\u1780\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F\u1794\u1793\u17D2\u178F","english":"Resume movie download"},"movie15":{"khmer":"\u2705 \u1797\u17B6\u1796\u1799\u1793\u17D2\u178F\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1791\u17B6\u1789\u1799\u1780\u178A\u17C4\u1799\u1787\u17C4\u1782\u1787\u17D0\u1799\u1791\u17C5\u1780\u17D2\u1793\u17BB\u1784\u17A7\u1794\u1780\u179A\u178E\u17CD\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17D4 \u17A5\u17A1\u17BC\u179C\u1793\u17C1\u17C7\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1785\u1798\u17BE\u179B\u179C\u17B6\u1794\u17B6\u1793\u1796\u17C1\u179B\u1782\u17D2\u1798\u17B6\u1793\u17A2\u17CA\u17B8\u1793\u1792\u17BA\u178E\u17B7\u178F\u17D4","english":"\u2705 Your movie has successfully downloaded to your device. You can now watch it while offline."},"movie16":{"khmer":"\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1793\u179B\u17BE\u179F\u1785\u17C6\u1793\u17BD\u1793\u1780\u17C6\u178E\u178F\u17CB\u17A5\u178F\u1782\u17B7\u178F\u1790\u17D2\u179B\u17C3\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17D4 \u179F\u17BC\u1798\u1796\u17D2\u1799\u17B6\u1799\u17B6\u1798\u1798\u17D2\u178F\u1784\u1791\u17C0\u178F\u1793\u17C5\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u17D4","english":"You have exceeded your free quota. Please try again tomorrow."},"movie17":{"khmer":"\u1794\u17C9\u17C7\u179C\u17B8\u178A\u17C1\u17A2\u17BC\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1785\u17B6\u1780\u17CB","english":"Tap video to play"},"code":{"khmer":"\u178F\u17C6\u178E\u1797\u17D2\u1787\u17B6\u1794\u17CB\u1797\u17D2\u1793\u17B6\u1780\u17CB\u1784\u17B6\u179A\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u1791\u17C5\u1780\u17D2\u178A\u17B6\u179A\u178F\u1798\u17D2\u1794\u17C0\u178F\u1781\u17D2\u1791\u17B6\u179F\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17A0\u17BE\u1799!","english":"Your Agent Link has been copied to your clipboard!"},"code2":{"khmer":"\u1785\u17BB\u1785\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1785\u1798\u17D2\u179B\u1784\u178F\u17C6\u178E\u1797\u17D2\u1787\u17B6\u1794\u17CB\u1797\u17D2\u1793\u17B6\u1780\u17CB\u1784\u17B6\u179A\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780 \u178A\u17BE\u1798\u17D2\u1794\u17B8\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780","english":"Tap to copy your HeartBank\xae Agent Link to share"},"chatgpt":{"khmer":"Chat GPT","english":"Chat GPT"},"deepseek":{"khmer":"Deep Seek","english":"Deep Seek"},"google":{"khmer":"\u17A2\u17D2\u1793\u1780\u1794\u1780\u1794\u17D2\u179A\u17C2","english":"Translator"},"gemini":{"khmer":"Gemini <span class=\'arial ml-1.5\'>AI</span>","english":"Gemini AI"},"meta":{"khmer":"Meta <span class=\'arial\'>AI</span>","english":"Meta AI"},"other":{"khmer":"Other <span class=\'arial\'>AI</span>","english":"Other AI"},"grok":{"khmer":"Grok <span class=\'arial\'>AI</span>","english":"Grok AI"},"select":{"khmer":"\u17A2\u17D2\u1793\u1780\u17A2\u17B6\u1785\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u1796\u17B6\u1780\u17D2\u1799\u178E\u17B6\u1798\u17BD\u1799\u17AC\u179F\u179A\u179F\u17C1\u179A\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780","english":"You can write or select any passage of text to share"},"select2":{"khmer":"\u1791\u17C6\u1796\u17D0\u179A\u1793\u17C1\u17C7\u178F\u17D2\u179A\u17BC\u179C\u1794\u17B6\u1793\u1785\u1798\u17D2\u179B\u1784\u1791\u17C5\u1780\u17B6\u1793\u17CB\u1780\u17D2\u178A\u17B6\u179A\u178F\u1798\u17D2\u1794\u17C0\u178F\u1781\u17D2\u1791\u1784\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u17A0\u17BE\u1799!","english":"This page has been copied to your clipboard!"},"select3":{"khmer":"\u1785\u17C2\u1780\u179A\u17C6\u179B\u17C2\u1780","english":"Share"},"select4":{"khmer":"\u1785\u1798\u17D2\u179B\u1784","english":"Copy"},"select8":{"khmer":"\u1794\u17B7\u1791\u1797\u17D2\u1787\u17B6\u1794\u17CB","english":"Paste"},"select5":{"khmer":"\u1794\u17C4\u17C7\u1794\u1784\u17CB","english":"Cancel"},"select6":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u1785\u17B6\u1794\u17CB\u1795\u17D2\u178A\u17BE\u1798\u1798\u17D2\u178A\u1784\u1791\u17C0\u178F\u178A\u17C2\u179A\u17AC\u1791\u17C1?","english":"Would you like to start over?"},"select7":{"khmer":"\u178F\u17BE\u17A2\u17D2\u1793\u1780\u1785\u1784\u17CB\u178A\u17B6\u1780\u17CB\u1796\u17B6\u1780\u17D2\u1799\u1785\u1798\u17D2\u179B\u1784\u1793\u17C5\u1791\u17B8\u1793\u17C1\u17C7\u17AC\u1791\u17C1?","english":"Would you like to paste?"},"typo":{"khmer":"\u1780\u1793\u17D2\u179B\u17C2\u1784\u1795\u17D2\u178F\u179B\u17CB\u1799\u17C4\u1794\u179B\u17CB\u1780\u17C2\u179B\u17C6\u17A2\u1780\u17B6\u179A\u1781\u17D2\u179C\u17C7\u1781\u17B6\u178F","english":"Found a mistake?"},"typo2":{"khmer":"\u179F\u17BC\u1798\u179F\u179A\u179F\u17C1\u179A\u1799\u17C4\u1794\u179B\u17CB\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u1793\u17C5\u1780\u17D2\u1793\u17BB\u1784\u1794\u17D2\u179A\u17A2\u1794\u17CB\u1781\u17B6\u1784\u1780\u17D2\u179A\u17C4\u1798","english":"How can we make this page better?"},"story":{"khmer":"\u1785\u17BB\u1785\u1791\u17B8\u1793\u17C1\u17C7\u178A\u17BE\u1798\u17D2\u1794\u17B8\u1798\u17BE\u179B\u1780\u17B6\u179A\u1794\u17D2\u179A\u1787\u17BB\u17C6\u1793\u17C1\u17C7\u1793\u17C5\u179B\u17BE YouTube","english":"Tap here to watch this sermon on YouTube"},"buddha2":{"khmer":"\u1785\u17B7\u178F\u17D2\u178F\u1782\u17BA\u1787\u17B6\u1791\u17B6\u17C6\u1784\u17A2\u179F\u17CB\u17D4 \u17A2\u17D2\u179C\u17B8\u178A\u17C2\u179B\u17A2\u17D2\u1793\u1780\u1782\u17B7\u178F \u17A2\u17D2\u1793\u1780\u1793\u17B9\u1784\u1780\u17D2\u179B\u17B6\u1799\u1791\u17C5\u1787\u17B6\u179C\u17B6\u17D4 \u1785\u17B7\u1789\u17D2\u1785\u17B9\u1798\u1785\u17B7\u178F\u17D2\u178F\u179A\u1794\u179F\u17CB\u17A2\u17D2\u1793\u1780\u178A\u17C4\u1799\u1780\u17B6\u179A\u179A\u17C0\u1793\u179F\u17BC\u178F\u17D2\u179A \u1793\u17B7\u1784\u1780\u17B6\u179A\u1799\u179B\u17CB\u178A\u17B9\u1784\u17D4","english":"The mind is everything. What you think you become. Cultivate your mind through learning and understanding."}}');




class $dcb5b0b92549b428$export$df935bc2312a795f {
    constructor(){
        this.isRealTime = false;
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "readers");
    }
    stop() {
        this.isRealTime = false;
        if (this.unsubscribe) this.unsubscribe();
    }
    async getUser(uid) {
        if (uid) {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$fbdfe04acc811eed), "users", uid);
            const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
            return docSnap.exists() ? docSnap.data() : {}; // should always exist
        } else return {};
    }
    async count() {
        const snapshot = await (0, $70fd6868680e912c$export$b1de1b12889d0afb)(this.collection);
        return snapshot.data().count;
    }
    // device id
    async get(id) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "readers", id);
        const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        return docSnap.exists() ? docSnap.data() : null;
    }
    // deprecated
    async get2(did) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("did", "==", did), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1));
        const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            return {
                id: doc.id,
                ...doc.data()
            };
        }
        return null;
    }
    // deprecated
    async get3(uid) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1));
        const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            return {
                id: doc.id,
                ...doc.data()
            };
        }
        return null;
    }
    // logged in = public; logged out = anonymous
    async update(visitor) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "readers", visitor.id);
            const reader = await this.get(visitor.id);
            reader ? await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                lastActive: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                pages: (0, $70fd6868680e912c$export$a2647aa13413c947)(1),
                uid: visitor.uid,
                user: visitor.user,
                address: visitor.address,
                latitude: visitor.latitude,
                longitude: visitor.longitude
            }) : await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(docRef, {
                date: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                lastActive: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                pages: (0, $70fd6868680e912c$export$a2647aa13413c947)(1),
                ...visitor // causes duplicate id with doc id
            });
            const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
            const data = docSnap.data();
            visitor.date = data.date;
            visitor.lastActive = data.lastActive;
            visitor.pages = data.pages;
            return {
                status: "success",
                reader: {
                    id: docRef.id,
                    ...visitor
                }
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // deprecated
    async update2(visitor) {
        try {
            const reader = visitor.uid ? await this.get3(visitor.uid) : await this.get2(visitor.id); //did
            if (reader && reader.id) {
                const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "readers", reader.id);
                await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                    lastActive: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                    pages: (0, $70fd6868680e912c$export$a2647aa13413c947)(1),
                    user: visitor.user,
                    address: visitor.address,
                    latitude: visitor.latitude,
                    longitude: visitor.longitude
                });
                //const docSnap = await getDoc(docRef);
                return {
                    status: "success",
                    reader: reader // missing updated stuff but not needed
                };
            } else {
                const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, {
                    date: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                    lastActive: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                    pages: (0, $70fd6868680e912c$export$a2647aa13413c947)(1),
                    ...visitor
                });
                //const docSnap = await getDoc(docRef);
                return {
                    status: "success",
                    reader: {
                        id: docRef.id,
                        ...visitor // missing updated stuff but not needed
                    }
                };
            }
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // realtime
    async now(callback) {
        // one year for now: later 1 month, 1 week, 1 day
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        // index not needed
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("lastActive", ">", (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).fromDate(oneYearAgo)), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("lastActive", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(100));
        this.stop();
        this.isRealTime = true;
        this.unsubscribe = (0, $70fd6868680e912c$export$d36370812fb26935)(q, (snapshot)=>{
            // if snapshot.empty
            const readers = snapshot.docs.map((doc, index)=>({
                    id: doc.id,
                    rank: index + 1,
                    ...doc.data()
                }));
            // Optional: handle per-change updates
            const changes = [];
            snapshot.docChanges().map((change)=>{
                if (change.type === "added") //console.log("Added:", change.doc.data());
                changes.push({
                    id: change.doc.id,
                    ...change.doc.data()
                });
            // if (change.type === "modified")
            //     console.log("Modified:", change.doc.data());
            // if (change.type === "removed")
            //     console.log("Removed:", change.doc.data());
            });
            // readers.reverse()
            // oldest → newest
            readers.sort((a, b)=>a.lastActive.nanoseconds - b.lastActive.nanoseconds);
            if (this.isRealTime) callback(readers, changes);
        }, (error)=>{
            console.error("Error listening to document: ", error.message);
        });
    }
    async leaderboard() {
        this.stop();
        // index needed bc compound
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("pages", "desc"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("lastActive", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(50));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const readers = querySnapshot.docs.map((doc, index)=>({
                id: doc.id,
                rank: index + 1,
                ...doc.data()
            }));
        // oldest → newest
        readers.sort((a, b)=>a.lastActive.nanoseconds - b.lastActive.nanoseconds);
        return readers; //.reverse();
    // let readers: Reader[] = [];
    // if (!querySnapshot.empty) {
    //     readers = querySnapshot.docs.map(
    //         (doc, index) =>
    //             ({
    //                 id: doc.id,
    //                 rank: index + 1,
    //                 ...doc.data()
    //             } as Reader)
    //     );
    // }
    }
    // not used for now: fake data now
    async history() {
        this.stop();
        // index not needed
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "asc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1000));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const readers = querySnapshot.docs.map((doc, index)=>({
                id: doc.id,
                rank: index + 1,
                ...doc.data()
            }));
        // oldest → newest
        readers.sort((a, b)=>a.lastActive.nanoseconds - b.lastActive.nanoseconds);
        return readers; //.reverse();
    // let readers: Reader[] = [];
    // if (!querySnapshot.empty) {
    //     readers = querySnapshot.docs.map(
    //         (doc) =>
    //             ({
    //                 id: doc.id,
    //                 ...doc.data()
    //             } as Reader)
    //     );
    // }
    }
}


const $ccee3b3c3507a45f$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $ccee3b3c3507a45f$export$cbd2b34bff1227b0 {
    constructor(){
        this.readers = new (0, $dcb5b0b92549b428$export$df935bc2312a795f)();
        //private ip = ""; // also in localstorage??
        //private location: any = {};
        this.hasAlertedAdmin = false // one time per refresh
        ;
        //opener: Window | null = window.opener;
        this.hero = null;
        this.user = null;
        this.admins = [
            "thonly@heartbank.ceo",
            "sely0928@gmail.com"
        ];
        this.admins2 = [
            "thonly@heartbank.ceo",
            "thonly@siliconwat.com" // for testing as user as khmer; light mode
        ];
        this.admins3 = [
            "sely0928@gmail.com",
            "andrewly1962@gmail.com",
            "sengsovann@gmail.com",
            "thonly@heartbank.ceo",
            "thonly@siliconwat.com" // for testing as user as khmer; light mode
        ];
        (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26), async (hero)=>this.hero = hero);
        (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0), async (user)=>this.user = user);
    }
    async saveTokenToFirestore() {
        try {
            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                alert($ccee3b3c3507a45f$var$strings["notifications1"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                return;
            }
            const registration = await navigator.serviceWorker.ready;
            //const registration = await navigator.serviceWorker.getRegistration("/");
            const currentToken = await (0, $97b6afad2c5c80cd$export$257b2d10b709d8ef)((0, $9d0840e0f81e5cfa$export$a95634e919edb5c1), {
                vapidKey: "BEc2kjaZKLwN7uafN-r4eMyTDtkRx3q7bAx-LrYmB1AlNhBTRuuFCyoF0QFo1PyOOnwvGbhG-LtSKLtu8OiltnM",
                serviceWorkerRegistration: registration
            });
            if (currentToken) {
                const userRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "readers", this.getDeviceID());
                await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(userRef, {
                    fcmTokens: [
                        currentToken
                    ],
                    lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now()
                }, {
                    merge: true
                });
                console.log("Token saved to Firestore successfully");
            }
        } catch (error) {
            console.error("Error saving token:", error);
        }
    }
    isLoggedIn() {
        return !!(this.user && this.hero);
    }
    addAuthStateListener(callback) {
        return (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26), callback); // returns unsubscribe function;
    }
    addAuthStateListener2(callback) {
        return (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0), callback); // returns unsubscribe function;
    }
    addAuthStateListener3(callback) {
        (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26), (hero)=>{
            if (hero && this.user) callback(hero, this.user);
            else callback(null, null);
        });
        (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0), (user)=>{
            if (this.hero && user) callback(this.hero, user);
            else callback(null, null);
        });
    }
    waitForAuth() {
        return new Promise((resolve)=>{
            const unsubscribe = (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26), (hero)=>{
                unsubscribe();
                resolve(hero);
            });
        });
    }
    waitForAuth2() {
        return new Promise((resolve)=>{
            const unsubscribe = (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0), (user)=>{
                unsubscribe();
                resolve(user);
            });
        });
    }
    //TODO: later how to fix when user token expires but hero is still on ??
    async getUser() {
        const users = await this.getUsers();
        if (users.user) {
            if (users.hero) return this.hero;
            else {
                await this.signOut();
                return null;
            }
        } else if (users.hero) {
            const status = await this.signInWithIdToken(await users.hero.getIdToken());
            if (status.type === "success") return this.hero;
            else {
                await this.signOut();
                return null;
            }
        } else {
            await this.signOut();
            return null;
        }
    }
    getUsers() {
        return new Promise((resolve)=>{
            // Monitor auth state for Project 1
            const unsubscribe1 = (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26), (hero)=>{
                this.hero = hero;
                checkAndResolve();
            });
            // Monitor auth state for Project 2
            const unsubscribe2 = (0, $fce0788c2e4d699f$export$4a5767248b18ef41)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0), (user)=>{
                this.user = user;
                checkAndResolve();
            });
            // Check if both users are signed in
            const checkAndResolve = ()=>{
                if (this.hero !== null && this.user !== null) {
                    resolve({
                        hero: this.hero,
                        user: this.hero
                    });
                    unsubscribe1();
                    unsubscribe2();
                }
            };
        });
    }
    // TODO: later maybe get id token from user (if exists) then call cloud function to get custom token; this will bypass vault login
    async signIn(token) {
        try {
            const heartbank = await (0, $fce0788c2e4d699f$export$efca4cbe5dd06740)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26), token);
            this.hero = heartbank.user;
            if (this.user) return {
                text: $ccee3b3c3507a45f$var$strings["feedback17"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                type: "success",
                user: this.user
            };
            else return this.signIn2();
        } catch (error) {
            return {
                text: `Error signing in with custom token: ${error.message}`,
                type: "error"
            };
        }
    }
    // TODO: maybe later: allow logout of user only and login to user via passkey?
    async signIn2() {
        try {
            const idToken = await this.hero.getIdToken();
            return await this.signInWithIdToken(idToken);
        } catch (error) {
            return {
                text: `Error signing in with id token: ${error.message}`,
                type: "error"
            };
        }
    }
    async signInWithIdToken(idToken) {
        try {
            const generateLoginToken = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)((0, $9d0840e0f81e5cfa$export$18af1f934c132a41), "generateLoginToken", {
                limitedUseAppCheckTokens: true
            });
            const result = await generateLoginToken({
                idToken: idToken
            });
            const customToken = result.data.customToken;
            const heartbank = await (0, $fce0788c2e4d699f$export$efca4cbe5dd06740)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0), customToken);
            this.user = heartbank.user;
            return {
                text: $ccee3b3c3507a45f$var$strings["feedback17"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                type: "success",
                user: this.user
            };
        } catch (error) {
            return {
                text: `Error signing in with id token: ${error.message}`,
                type: "error"
            };
        }
    }
    async signOut() {
        if (this.hero) try {
            await (0, $fce0788c2e4d699f$export$e7094788287c5e9b)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26));
            this.hero = null; // TODO: keep tracking user ??
            return {
                text: $ccee3b3c3507a45f$var$strings.feedback13[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                type: "success"
            };
        } catch (error) {
            return {
                text: error.message,
                type: "error"
            };
        }
        else return {
            text: $ccee3b3c3507a45f$var$strings.feedback13[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            type: "success"
        };
    }
    async signOut2() {
        if (this.user) try {
            await (0, $fce0788c2e4d699f$export$e7094788287c5e9b)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0));
            this.user = null; // TODO: keep tracking user ??
            return {
                text: $ccee3b3c3507a45f$var$strings.feedback12[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                type: "success"
            };
        } catch (error) {
            return {
                text: error.message,
                type: "error"
            };
        }
        else return {
            text: $ccee3b3c3507a45f$var$strings.feedback12[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            type: "success"
        };
    }
    async signOut3() {
        if (this.hero && this.user) try {
            await (0, $fce0788c2e4d699f$export$e7094788287c5e9b)((0, $9d0840e0f81e5cfa$export$35c0ced600f1fa26));
            await (0, $fce0788c2e4d699f$export$e7094788287c5e9b)((0, $9d0840e0f81e5cfa$export$73693bad9f5880b0));
            this.hero = null; // TODO: keep tracking user ??
            this.user = null;
            return {
                text: $ccee3b3c3507a45f$var$strings.feedback12[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                type: "success"
            };
        } catch (error) {
            return {
                text: error.message,
                type: "error"
            };
        }
        else if (this.hero) return this.signOut();
        else if (this.user) return this.signOut2();
        else return {
            text: $ccee3b3c3507a45f$var$strings.feedback12[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            type: "success"
        };
    }
    isRunningAsPWA() {
        const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
        const isIOSStandalone = navigator.standalone === true; // iOS-specific
        return isStandalone || isIOSStandalone;
    }
    isSuperAdmin() {
        return this.isAdmin(this.admins2);
    }
    isAdmin(admins = this.admins) {
        if (!this.user) return false;
        if (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) return !!(this.hero?.email && admins.includes(this.hero.email));
        else return this.hero !== null;
    }
    async alertAdmin(action, value = null) {
        if (!navigator.onLine) return;
        const device = `${(0, $eba1d7d434ec7c0e$export$3c6d453abf5a879b)} ${(0, $eba1d7d434ec7c0e$export$5b033c7e05fcfcc2)} ${(0, $eba1d7d434ec7c0e$export$a3833c15d023303d)} (${(0, $eba1d7d434ec7c0e$export$ee7d1a69487f78e9)})`;
        const browser = `${(0, $eba1d7d434ec7c0e$export$89ca9f8ca1a50fd5)} ${(0, $eba1d7d434ec7c0e$export$61e3782b541bd28e)} (${(0, $eba1d7d434ec7c0e$export$3b31a91e69d9331) ? "PWA" : "Browser"})`;
        const ip = await (0, $eba1d7d434ec7c0e$export$67218453e01a0be8)();
        // if (!this.ip) {
        //     const res = await fetch("https://api.ipify.org?format=json"); // must be on client bc don't want server ip
        //     const { ip } = await res.json();
        //     this.ip = ip;
        // }
        const location = await (0, $eba1d7d434ec7c0e$export$e7fd20fad3cf4b5f)(ip);
        // if (this.location.ip !== this.ip) {
        //     const geoRes = await fetch(`https://ipapi.co/${this.ip}/json/`);
        //     this.location = await geoRes.json();
        //     this.location.ip = this.ip;
        //     //console.log(this.location);
        // }
        const map = await this.getMap(location);
        const colorScheme = document.documentElement.classList.contains("dark") ? "Dark Mode" : "Light Mode";
        const data = {
            id: this.getDeviceID(),
            url: window.location.href,
            action: value ? action + value : action,
            map: map,
            location: location,
            agent: navigator.userAgent,
            device: device,
            browser: browser,
            version: (0, $eba1d7d434ec7c0e$export$501a7fac1df67a49).formatDate(),
            colorScheme: colorScheme
        };
        const alertAdmin = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)((0, $9d0840e0f81e5cfa$export$18af1f934c132a41), "alertAdmin", {
            limitedUseAppCheckTokens: true
        });
        await this.updateReader(device, browser, location, map);
        console.info(data); // weird bug: need to be here before alertadmin
        if (this.isAdmin(this.admins3)) {
            if (!this.hasAlertedAdmin) {
                this.hasAlertedAdmin = true; // isProduction;
                await alertAdmin(data);
            }
        } else await alertAdmin(data);
    }
    // Anroid 9 supports web crypto
    getDeviceID() {
        let deviceID = localStorage.getItem("device");
        if (!deviceID) {
            deviceID = window.crypto.randomUUID();
            localStorage.setItem("device", deviceID);
        }
        return deviceID;
    }
    async getMap(location) {
        const component = document.querySelector("sw-map");
        const newLocation = await component.getLocation();
        const storedLocation = localStorage.getItem("location");
        if (newLocation) return newLocation;
        else if (storedLocation) return JSON.parse(storedLocation);
        else return {};
    // return Object.assign(
    //     {},
    //     location,
    //     (await component.getLocation()) ||
    //         JSON.parse(localStorage.getItem("location") || "{}")
    // );
    }
    async updateReader(device, browser, location, map) {
        const defaultLocation = {
            lat: location.latitude,
            lng: location.longitude,
            formatted_address: location.city + (location.region === location.city ? "" : " " + location.region) + " " + location.country_name
        };
        // same as cloud function
        // const user =
        //     this.location.ip +
        //     " " +
        //     this.getDevice() +
        //     " " +
        //     this.location.city +
        //     (this.location.region === this.location.city
        //         ? ""
        //         : " " + this.location.region) +
        //     " " +
        //     this.location.country_name;
        const user = `${this.getDeviceID()} | ${device} | ${browser}`;
        localStorage.setItem("user", user);
        const reader = await this.readers.update({
            id: this.getDeviceID(),
            uid: this.user?.uid || "",
            user: user,
            address: map.formatted_address || defaultLocation.formatted_address,
            latitude: map.lat || defaultLocation.lat,
            longitude: map.lng || defaultLocation.lng
        });
        if (reader.status === "error") console.error(reader);
    }
}










var $2517ebbe139f796a$var$Events = /** @class */ function() {
    function Events(eventType, eventFunctions) {
        if (eventFunctions === void 0) eventFunctions = [];
        this._eventType = eventType;
        this._eventFunctions = eventFunctions;
    }
    Events.prototype.init = function() {
        var _this = this;
        this._eventFunctions.forEach(function(eventFunction) {
            if (typeof window !== 'undefined') window.addEventListener(_this._eventType, eventFunction);
        });
    };
    return Events;
}();
var $2517ebbe139f796a$export$2e2bcd8739ae039 = $2517ebbe139f796a$var$Events;


var $9e599e545d4197d0$var$Instances = /** @class */ function() {
    function Instances() {
        this._instances = {
            Accordion: {},
            Carousel: {},
            Collapse: {},
            Dial: {},
            Dismiss: {},
            Drawer: {},
            Dropdown: {},
            Modal: {},
            Popover: {},
            Tabs: {},
            Tooltip: {},
            InputCounter: {},
            CopyClipboard: {},
            Datepicker: {}
        };
    }
    Instances.prototype.addInstance = function(component, instance, id, override) {
        if (override === void 0) override = false;
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (this._instances[component][id] && !override) {
            console.warn("Flowbite: Instance with ID ".concat(id, " already exists."));
            return;
        }
        if (override && this._instances[component][id]) this._instances[component][id].destroyAndRemoveInstance();
        this._instances[component][id ? id : this._generateRandomId()] = instance;
    };
    Instances.prototype.getAllInstances = function() {
        return this._instances;
    };
    Instances.prototype.getInstances = function(component) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        return this._instances[component];
    };
    Instances.prototype.getInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return;
        }
        return this._instances[component][id];
    };
    Instances.prototype.destroyAndRemoveInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this.destroyInstanceObject(component, id);
        this.removeInstance(component, id);
    };
    Instances.prototype.removeInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        delete this._instances[component][id];
    };
    Instances.prototype.destroyInstanceObject = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this._instances[component][id].destroy();
    };
    Instances.prototype.instanceExists = function(component, id) {
        if (!this._instances[component]) return false;
        if (!this._instances[component][id]) return false;
        return true;
    };
    Instances.prototype._generateRandomId = function() {
        return Math.random().toString(36).substr(2, 9);
    };
    Instances.prototype._componentAndInstanceCheck = function(component, id) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return false;
        }
        return true;
    };
    return Instances;
}();
var $9e599e545d4197d0$var$instances = new $9e599e545d4197d0$var$Instances();
var $9e599e545d4197d0$export$2e2bcd8739ae039 = $9e599e545d4197d0$var$instances;
if (typeof window !== 'undefined') window.FlowbiteInstances = $9e599e545d4197d0$var$instances;


var $c48fec59664056e4$var$__assign = undefined && undefined.__assign || function() {
    $c48fec59664056e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c48fec59664056e4$var$__assign.apply(this, arguments);
};
var $c48fec59664056e4$var$Default = {
    alwaysOpen: false,
    activeClasses: 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white',
    inactiveClasses: 'text-gray-500 dark:text-gray-400',
    onOpen: function() {},
    onClose: function() {},
    onToggle: function() {}
};
var $c48fec59664056e4$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $c48fec59664056e4$var$Accordion = /** @class */ function() {
    function Accordion(accordionEl, items, options, instanceOptions) {
        if (accordionEl === void 0) accordionEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $c48fec59664056e4$var$Default;
        if (instanceOptions === void 0) instanceOptions = $c48fec59664056e4$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : accordionEl.id;
        this._accordionEl = accordionEl;
        this._items = items;
        this._options = $c48fec59664056e4$var$__assign($c48fec59664056e4$var$__assign({}, $c48fec59664056e4$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Accordion', this, this._instanceId, instanceOptions.override);
    }
    Accordion.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // show accordion item based on click
            this._items.forEach(function(item) {
                if (item.active) _this.open(item.id);
                var clickHandler = function() {
                    _this.toggle(item.id);
                };
                item.triggerEl.addEventListener('click', clickHandler);
                // Store the clickHandler in a property of the item for removal later
                item.clickHandler = clickHandler;
            });
            this._initialized = true;
        }
    };
    Accordion.prototype.destroy = function() {
        if (this._items.length && this._initialized) {
            this._items.forEach(function(item) {
                item.triggerEl.removeEventListener('click', item.clickHandler);
                // Clean up by deleting the clickHandler property from the item
                delete item.clickHandler;
            });
            this._initialized = false;
        }
    };
    Accordion.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Accordion', this._instanceId);
    };
    Accordion.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Accordion.prototype.getItem = function(id) {
        return this._items.filter(function(item) {
            return item.id === id;
        })[0];
    };
    Accordion.prototype.open = function(id) {
        var _a, _b;
        var _this = this;
        var item = this.getItem(id);
        // don't hide other accordions if always open
        if (!this._options.alwaysOpen) this._items.map(function(i) {
            var _a, _b;
            if (i !== item) {
                (_a = i.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(' '));
                (_b = i.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(' '));
                i.targetEl.classList.add('hidden');
                i.triggerEl.setAttribute('aria-expanded', 'false');
                i.active = false;
                // rotate icon if set
                if (i.iconEl) i.iconEl.classList.add('rotate-180');
            }
        });
        // show active item
        (_a = item.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(' '));
        (_b = item.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(' '));
        item.triggerEl.setAttribute('aria-expanded', 'true');
        item.targetEl.classList.remove('hidden');
        item.active = true;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.remove('rotate-180');
        // callback function
        this._options.onOpen(this, item);
    };
    Accordion.prototype.toggle = function(id) {
        var item = this.getItem(id);
        if (item.active) this.close(id);
        else this.open(id);
        // callback function
        this._options.onToggle(this, item);
    };
    Accordion.prototype.close = function(id) {
        var _a, _b;
        var item = this.getItem(id);
        (_a = item.triggerEl.classList).remove.apply(_a, this._options.activeClasses.split(' '));
        (_b = item.triggerEl.classList).add.apply(_b, this._options.inactiveClasses.split(' '));
        item.targetEl.classList.add('hidden');
        item.triggerEl.setAttribute('aria-expanded', 'false');
        item.active = false;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.add('rotate-180');
        // callback function
        this._options.onClose(this, item);
    };
    Accordion.prototype.updateOnOpen = function(callback) {
        this._options.onOpen = callback;
    };
    Accordion.prototype.updateOnClose = function(callback) {
        this._options.onClose = callback;
    };
    Accordion.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Accordion;
}();
function $c48fec59664056e4$export$226c1dc98323ee4d() {
    document.querySelectorAll('[data-accordion]').forEach(function($accordionEl) {
        var alwaysOpen = $accordionEl.getAttribute('data-accordion');
        var activeClasses = $accordionEl.getAttribute('data-active-classes');
        var inactiveClasses = $accordionEl.getAttribute('data-inactive-classes');
        var items = [];
        $accordionEl.querySelectorAll('[data-accordion-target]').forEach(function($triggerEl) {
            // Consider only items that directly belong to $accordionEl
            // (to make nested accordions work).
            if ($triggerEl.closest('[data-accordion]') === $accordionEl) {
                var item = {
                    id: $triggerEl.getAttribute('data-accordion-target'),
                    triggerEl: $triggerEl,
                    targetEl: document.querySelector($triggerEl.getAttribute('data-accordion-target')),
                    iconEl: $triggerEl.querySelector('[data-accordion-icon]'),
                    active: $triggerEl.getAttribute('aria-expanded') === 'true' ? true : false
                };
                items.push(item);
            }
        });
        new $c48fec59664056e4$var$Accordion($accordionEl, items, {
            alwaysOpen: alwaysOpen === 'open' ? true : false,
            activeClasses: activeClasses ? activeClasses : $c48fec59664056e4$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $c48fec59664056e4$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== 'undefined') {
    window.Accordion = $c48fec59664056e4$var$Accordion;
    window.initAccordions = $c48fec59664056e4$export$226c1dc98323ee4d;
}
var $c48fec59664056e4$export$2e2bcd8739ae039 = $c48fec59664056e4$var$Accordion;



var $bb9acaac13d1970e$var$__assign = undefined && undefined.__assign || function() {
    $bb9acaac13d1970e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb9acaac13d1970e$var$__assign.apply(this, arguments);
};
var $bb9acaac13d1970e$var$Default = {
    onCollapse: function() {},
    onExpand: function() {},
    onToggle: function() {}
};
var $bb9acaac13d1970e$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $bb9acaac13d1970e$var$Collapse = /** @class */ function() {
    function Collapse(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $bb9acaac13d1970e$var$Default;
        if (instanceOptions === void 0) instanceOptions = $bb9acaac13d1970e$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $bb9acaac13d1970e$var$__assign($bb9acaac13d1970e$var$__assign({}, $bb9acaac13d1970e$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Collapse', this, this._instanceId, instanceOptions.override);
    }
    Collapse.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            if (this._triggerEl.hasAttribute('aria-expanded')) this._visible = this._triggerEl.getAttribute('aria-expanded') === 'true';
            else // fix until v2 not to break previous single collapses which became dismiss
            this._visible = !this._targetEl.classList.contains('hidden');
            this._clickHandler = function() {
                _this.toggle();
            };
            this._triggerEl.addEventListener('click', this._clickHandler);
            this._initialized = true;
        }
    };
    Collapse.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener('click', this._clickHandler);
            this._initialized = false;
        }
    };
    Collapse.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Collapse', this._instanceId);
    };
    Collapse.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Collapse.prototype.collapse = function() {
        this._targetEl.classList.add('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'false');
        this._visible = false;
        // callback function
        this._options.onCollapse(this);
    };
    Collapse.prototype.expand = function() {
        this._targetEl.classList.remove('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'true');
        this._visible = true;
        // callback function
        this._options.onExpand(this);
    };
    Collapse.prototype.toggle = function() {
        if (this._visible) this.collapse();
        else this.expand();
        // callback function
        this._options.onToggle(this);
    };
    Collapse.prototype.updateOnCollapse = function(callback) {
        this._options.onCollapse = callback;
    };
    Collapse.prototype.updateOnExpand = function(callback) {
        this._options.onExpand = callback;
    };
    Collapse.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Collapse;
}();
function $bb9acaac13d1970e$export$355ba5a528b4009a() {
    document.querySelectorAll('[data-collapse-toggle]').forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute('data-collapse-toggle');
        var $targetEl = document.getElementById(targetId);
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $9e599e545d4197d0$export$2e2bcd8739ae039).instanceExists('Collapse', $targetEl.getAttribute('id'))) new $bb9acaac13d1970e$var$Collapse($targetEl, $triggerEl);
            else // if instance exists already for the same target element then create a new one with a different trigger element
            new $bb9acaac13d1970e$var$Collapse($targetEl, $triggerEl, {}, {
                id: $targetEl.getAttribute('id') + '_' + (0, $9e599e545d4197d0$export$2e2bcd8739ae039)._generateRandomId()
            });
        } else console.error("The target element with id \"".concat(targetId, "\" does not exist. Please check the data-collapse-toggle attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Collapse = $bb9acaac13d1970e$var$Collapse;
    window.initCollapses = $bb9acaac13d1970e$export$355ba5a528b4009a;
}
var $bb9acaac13d1970e$export$2e2bcd8739ae039 = $bb9acaac13d1970e$var$Collapse;



var $ed7202bee3ce6cfe$var$__assign = undefined && undefined.__assign || function() {
    $ed7202bee3ce6cfe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed7202bee3ce6cfe$var$__assign.apply(this, arguments);
};
var $ed7202bee3ce6cfe$var$Default = {
    defaultPosition: 0,
    indicators: {
        items: [],
        activeClasses: 'bg-white dark:bg-gray-800',
        inactiveClasses: 'bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800'
    },
    interval: 3000,
    onNext: function() {},
    onPrev: function() {},
    onChange: function() {}
};
var $ed7202bee3ce6cfe$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $ed7202bee3ce6cfe$var$Carousel = /** @class */ function() {
    function Carousel(carouselEl, items, options, instanceOptions) {
        if (carouselEl === void 0) carouselEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $ed7202bee3ce6cfe$var$Default;
        if (instanceOptions === void 0) instanceOptions = $ed7202bee3ce6cfe$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : carouselEl.id;
        this._carouselEl = carouselEl;
        this._items = items;
        this._options = $ed7202bee3ce6cfe$var$__assign($ed7202bee3ce6cfe$var$__assign($ed7202bee3ce6cfe$var$__assign({}, $ed7202bee3ce6cfe$var$Default), options), {
            indicators: $ed7202bee3ce6cfe$var$__assign($ed7202bee3ce6cfe$var$__assign({}, $ed7202bee3ce6cfe$var$Default.indicators), options.indicators)
        });
        this._activeItem = this.getItem(this._options.defaultPosition);
        this._indicators = this._options.indicators.items;
        this._intervalDuration = this._options.interval;
        this._intervalInstance = null;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Carousel', this, this._instanceId, instanceOptions.override);
    }
    /**
     * initialize carousel and items based on active one
     */ Carousel.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            this._items.map(function(item) {
                item.el.classList.add('absolute', 'inset-0', 'transition-transform', 'transform');
            });
            // if no active item is set then first position is default
            if (this.getActiveItem()) this.slideTo(this.getActiveItem().position);
            else this.slideTo(0);
            this._indicators.map(function(indicator, position) {
                indicator.el.addEventListener('click', function() {
                    _this.slideTo(position);
                });
            });
            this._initialized = true;
        }
    };
    Carousel.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Carousel.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Carousel', this._instanceId);
    };
    Carousel.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Carousel.prototype.getItem = function(position) {
        return this._items[position];
    };
    /**
     * Slide to the element based on id
     * @param {*} position
     */ Carousel.prototype.slideTo = function(position) {
        var nextItem = this._items[position];
        var rotationItems = {
            left: nextItem.position === 0 ? this._items[this._items.length - 1] : this._items[nextItem.position - 1],
            middle: nextItem,
            right: nextItem.position === this._items.length - 1 ? this._items[0] : this._items[nextItem.position + 1]
        };
        this._rotate(rotationItems);
        this._setActiveItem(nextItem);
        if (this._intervalInstance) {
            this.pause();
            this.cycle();
        }
        this._options.onChange(this);
    };
    /**
     * Based on the currently active item it will go to the next position
     */ Carousel.prototype.next = function() {
        var activeItem = this.getActiveItem();
        var nextItem = null;
        // check if last item
        if (activeItem.position === this._items.length - 1) nextItem = this._items[0];
        else nextItem = this._items[activeItem.position + 1];
        this.slideTo(nextItem.position);
        // callback function
        this._options.onNext(this);
    };
    /**
     * Based on the currently active item it will go to the previous position
     */ Carousel.prototype.prev = function() {
        var activeItem = this.getActiveItem();
        var prevItem = null;
        // check if first item
        if (activeItem.position === 0) prevItem = this._items[this._items.length - 1];
        else prevItem = this._items[activeItem.position - 1];
        this.slideTo(prevItem.position);
        // callback function
        this._options.onPrev(this);
    };
    /**
     * This method applies the transform classes based on the left, middle, and right rotation carousel items
     * @param {*} rotationItems
     */ Carousel.prototype._rotate = function(rotationItems) {
        // reset
        this._items.map(function(item) {
            item.el.classList.add('hidden');
        });
        // Handling the case when there is only one item
        if (this._items.length === 1) {
            rotationItems.middle.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-10');
            rotationItems.middle.el.classList.add('translate-x-0', 'z-20');
            return;
        }
        // left item (previously active)
        rotationItems.left.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-20');
        rotationItems.left.el.classList.add('-translate-x-full', 'z-10');
        // currently active item
        rotationItems.middle.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-10');
        rotationItems.middle.el.classList.add('translate-x-0', 'z-30');
        // right item (upcoming active)
        rotationItems.right.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-30');
        rotationItems.right.el.classList.add('translate-x-full', 'z-20');
    };
    /**
     * Set an interval to cycle through the carousel items
     */ Carousel.prototype.cycle = function() {
        var _this = this;
        if (typeof window !== 'undefined') this._intervalInstance = window.setInterval(function() {
            _this.next();
        }, this._intervalDuration);
    };
    /**
     * Clears the cycling interval
     */ Carousel.prototype.pause = function() {
        clearInterval(this._intervalInstance);
    };
    /**
     * Get the currently active item
     */ Carousel.prototype.getActiveItem = function() {
        return this._activeItem;
    };
    /**
     * Set the currently active item and data attribute
     * @param {*} position
     */ Carousel.prototype._setActiveItem = function(item) {
        var _a, _b;
        var _this = this;
        this._activeItem = item;
        var position = item.position;
        // update the indicators if available
        if (this._indicators.length) {
            this._indicators.map(function(indicator) {
                var _a, _b;
                indicator.el.setAttribute('aria-current', 'false');
                (_a = indicator.el.classList).remove.apply(_a, _this._options.indicators.activeClasses.split(' '));
                (_b = indicator.el.classList).add.apply(_b, _this._options.indicators.inactiveClasses.split(' '));
            });
            (_a = this._indicators[position].el.classList).add.apply(_a, this._options.indicators.activeClasses.split(' '));
            (_b = this._indicators[position].el.classList).remove.apply(_b, this._options.indicators.inactiveClasses.split(' '));
            this._indicators[position].el.setAttribute('aria-current', 'true');
        }
    };
    Carousel.prototype.updateOnNext = function(callback) {
        this._options.onNext = callback;
    };
    Carousel.prototype.updateOnPrev = function(callback) {
        this._options.onPrev = callback;
    };
    Carousel.prototype.updateOnChange = function(callback) {
        this._options.onChange = callback;
    };
    return Carousel;
}();
function $ed7202bee3ce6cfe$export$3ab77386b16b9e58() {
    document.querySelectorAll('[data-carousel]').forEach(function($carouselEl) {
        var interval = $carouselEl.getAttribute('data-carousel-interval');
        var slide = $carouselEl.getAttribute('data-carousel') === 'slide' ? true : false;
        var items = [];
        var defaultPosition = 0;
        if ($carouselEl.querySelectorAll('[data-carousel-item]').length) Array.from($carouselEl.querySelectorAll('[data-carousel-item]')).map(function($carouselItemEl, position) {
            items.push({
                position: position,
                el: $carouselItemEl
            });
            if ($carouselItemEl.getAttribute('data-carousel-item') === 'active') defaultPosition = position;
        });
        var indicators = [];
        if ($carouselEl.querySelectorAll('[data-carousel-slide-to]').length) Array.from($carouselEl.querySelectorAll('[data-carousel-slide-to]')).map(function($indicatorEl) {
            indicators.push({
                position: parseInt($indicatorEl.getAttribute('data-carousel-slide-to')),
                el: $indicatorEl
            });
        });
        var carousel = new $ed7202bee3ce6cfe$var$Carousel($carouselEl, items, {
            defaultPosition: defaultPosition,
            indicators: {
                items: indicators
            },
            interval: interval ? interval : $ed7202bee3ce6cfe$var$Default.interval
        });
        if (slide) carousel.cycle();
        // check for controls
        var carouselNextEl = $carouselEl.querySelector('[data-carousel-next]');
        var carouselPrevEl = $carouselEl.querySelector('[data-carousel-prev]');
        if (carouselNextEl) carouselNextEl.addEventListener('click', function() {
            carousel.next();
        });
        if (carouselPrevEl) carouselPrevEl.addEventListener('click', function() {
            carousel.prev();
        });
    });
}
if (typeof window !== 'undefined') {
    window.Carousel = $ed7202bee3ce6cfe$var$Carousel;
    window.initCarousels = $ed7202bee3ce6cfe$export$3ab77386b16b9e58;
}
var $ed7202bee3ce6cfe$export$2e2bcd8739ae039 = $ed7202bee3ce6cfe$var$Carousel;



var $71fa26dd9880ee1d$var$__assign = undefined && undefined.__assign || function() {
    $71fa26dd9880ee1d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71fa26dd9880ee1d$var$__assign.apply(this, arguments);
};
var $71fa26dd9880ee1d$var$Default = {
    transition: 'transition-opacity',
    duration: 300,
    timing: 'ease-out',
    onHide: function() {}
};
var $71fa26dd9880ee1d$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $71fa26dd9880ee1d$var$Dismiss = /** @class */ function() {
    function Dismiss(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $71fa26dd9880ee1d$var$Default;
        if (instanceOptions === void 0) instanceOptions = $71fa26dd9880ee1d$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $71fa26dd9880ee1d$var$__assign($71fa26dd9880ee1d$var$__assign({}, $71fa26dd9880ee1d$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Dismiss', this, this._instanceId, instanceOptions.override);
    }
    Dismiss.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._clickHandler = function() {
                _this.hide();
            };
            this._triggerEl.addEventListener('click', this._clickHandler);
            this._initialized = true;
        }
    };
    Dismiss.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener('click', this._clickHandler);
            this._initialized = false;
        }
    };
    Dismiss.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Dismiss', this._instanceId);
    };
    Dismiss.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dismiss.prototype.hide = function() {
        var _this = this;
        this._targetEl.classList.add(this._options.transition, "duration-".concat(this._options.duration), this._options.timing, 'opacity-0');
        setTimeout(function() {
            _this._targetEl.classList.add('hidden');
        }, this._options.duration);
        // callback function
        this._options.onHide(this, this._targetEl);
    };
    Dismiss.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Dismiss;
}();
function $71fa26dd9880ee1d$export$69c84787a503daef() {
    document.querySelectorAll('[data-dismiss-target]').forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute('data-dismiss-target');
        var $dismissEl = document.querySelector(targetId);
        if ($dismissEl) new $71fa26dd9880ee1d$var$Dismiss($dismissEl, $triggerEl);
        else console.error("The dismiss element with id \"".concat(targetId, "\" does not exist. Please check the data-dismiss-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Dismiss = $71fa26dd9880ee1d$var$Dismiss;
    window.initDismisses = $71fa26dd9880ee1d$export$69c84787a503daef;
}
var $71fa26dd9880ee1d$export$2e2bcd8739ae039 = $71fa26dd9880ee1d$var$Dismiss;


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $56e861d2255aee7e$var$__assign = undefined && undefined.__assign || function() {
    $56e861d2255aee7e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $56e861d2255aee7e$var$__assign.apply(this, arguments);
};
var $56e861d2255aee7e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $56e861d2255aee7e$var$Default = {
    placement: 'bottom',
    triggerType: 'click',
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300,
    ignoreClickOutsideClass: false,
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $56e861d2255aee7e$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $56e861d2255aee7e$var$Dropdown = /** @class */ function() {
    function Dropdown(targetElement, triggerElement, options, instanceOptions) {
        if (targetElement === void 0) targetElement = null;
        if (triggerElement === void 0) triggerElement = null;
        if (options === void 0) options = $56e861d2255aee7e$var$Default;
        if (instanceOptions === void 0) instanceOptions = $56e861d2255aee7e$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetElement.id;
        this._targetEl = targetElement;
        this._triggerEl = triggerElement;
        this._options = $56e861d2255aee7e$var$__assign($56e861d2255aee7e$var$__assign({}, $56e861d2255aee7e$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Dropdown', this, this._instanceId, instanceOptions.override);
    }
    Dropdown.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._popperInstance = this._createPopperInstance();
            this._setupEventListeners();
            this._initialized = true;
        }
    };
    Dropdown.prototype.destroy = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        // Remove click event listeners for trigger element
        if (this._options.triggerType === 'click') triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.removeEventListener(ev, _this._clickHandler);
        });
        // Remove hover event listeners for trigger and target elements
        if (this._options.triggerType === 'hover') {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverHideHandler);
            });
        }
        this._popperInstance.destroy();
        this._initialized = false;
    };
    Dropdown.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Dropdown', this._instanceId);
    };
    Dropdown.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dropdown.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._clickHandler = function() {
            _this.toggle();
        };
        // click event handling for trigger element
        if (this._options.triggerType === 'click') triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._clickHandler);
        });
        this._hoverShowTriggerElHandler = function(ev) {
            if (ev.type === 'click') _this.toggle();
            else setTimeout(function() {
                _this.show();
            }, _this._options.delay);
        };
        this._hoverShowTargetElHandler = function() {
            _this.show();
        };
        this._hoverHideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(':hover')) _this.hide();
            }, _this._options.delay);
        };
        // hover event handling for trigger element
        if (this._options.triggerType === 'hover') {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.addEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.addEventListener(ev, _this._hoverHideHandler);
            });
        }
    };
    Dropdown.prototype._createPopperInstance = function() {
        return (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            this._options.offsetSkidding,
                            this._options.offsetDistance
                        ]
                    }
                }
            ]
        });
    };
    Dropdown.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener('click', this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener('click', this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        // Ignore clicks on the trigger element (ie. a datepicker input)
        var ignoreClickOutsideClass = this._options.ignoreClickOutsideClass;
        var isIgnored = false;
        if (ignoreClickOutsideClass) {
            var ignoredClickOutsideEls = document.querySelectorAll(".".concat(ignoreClickOutsideClass));
            ignoredClickOutsideEls.forEach(function(el) {
                if (el.contains(clickedEl)) {
                    isIgnored = true;
                    return;
                }
            });
        }
        // Ignore clicks on the target element (ie. dropdown itself)
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && !isIgnored && this.isVisible()) this.hide();
    };
    Dropdown.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'click'
                    ],
                    hideEvents: [
                        'mouseleave'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click'
                    ],
                    hideEvents: []
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'click'
                    ],
                    hideEvents: []
                };
        }
    };
    Dropdown.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Dropdown.prototype.isVisible = function() {
        return this._visible;
    };
    Dropdown.prototype.show = function() {
        this._targetEl.classList.remove('hidden');
        this._targetEl.classList.add('block');
        this._targetEl.removeAttribute('aria-hidden');
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $56e861d2255aee7e$var$__assign($56e861d2255aee7e$var$__assign({}, options), {
                modifiers: $56e861d2255aee7e$var$__spreadArray($56e861d2255aee7e$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ], false)
            });
        });
        this._setupClickOutsideListener();
        // Update its position
        this._popperInstance.update();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dropdown.prototype.hide = function() {
        this._targetEl.classList.remove('block');
        this._targetEl.classList.add('hidden');
        this._targetEl.setAttribute('aria-hidden', 'true');
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $56e861d2255aee7e$var$__assign($56e861d2255aee7e$var$__assign({}, options), {
                modifiers: $56e861d2255aee7e$var$__spreadArray($56e861d2255aee7e$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ], false)
            });
        });
        this._visible = false;
        this._removeClickOutsideListener();
        // callback function
        this._options.onHide(this);
    };
    Dropdown.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dropdown.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dropdown.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dropdown;
}();
function $56e861d2255aee7e$export$8cb65a02593bf108() {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(function($triggerEl) {
        var dropdownId = $triggerEl.getAttribute('data-dropdown-toggle');
        var $dropdownEl = document.getElementById(dropdownId);
        if ($dropdownEl) {
            var placement = $triggerEl.getAttribute('data-dropdown-placement');
            var offsetSkidding = $triggerEl.getAttribute('data-dropdown-offset-skidding');
            var offsetDistance = $triggerEl.getAttribute('data-dropdown-offset-distance');
            var triggerType = $triggerEl.getAttribute('data-dropdown-trigger');
            var delay = $triggerEl.getAttribute('data-dropdown-delay');
            var ignoreClickOutsideClass = $triggerEl.getAttribute('data-dropdown-ignore-click-outside-class');
            new $56e861d2255aee7e$var$Dropdown($dropdownEl, $triggerEl, {
                placement: placement ? placement : $56e861d2255aee7e$var$Default.placement,
                triggerType: triggerType ? triggerType : $56e861d2255aee7e$var$Default.triggerType,
                offsetSkidding: offsetSkidding ? parseInt(offsetSkidding) : $56e861d2255aee7e$var$Default.offsetSkidding,
                offsetDistance: offsetDistance ? parseInt(offsetDistance) : $56e861d2255aee7e$var$Default.offsetDistance,
                delay: delay ? parseInt(delay) : $56e861d2255aee7e$var$Default.delay,
                ignoreClickOutsideClass: ignoreClickOutsideClass ? ignoreClickOutsideClass : $56e861d2255aee7e$var$Default.ignoreClickOutsideClass
            });
        } else console.error("The dropdown element with id \"".concat(dropdownId, "\" does not exist. Please check the data-dropdown-toggle attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Dropdown = $56e861d2255aee7e$var$Dropdown;
    window.initDropdowns = $56e861d2255aee7e$export$8cb65a02593bf108;
}
var $56e861d2255aee7e$export$2e2bcd8739ae039 = $56e861d2255aee7e$var$Dropdown;



var $e50395cbfc69fa09$var$__assign = undefined && undefined.__assign || function() {
    $e50395cbfc69fa09$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e50395cbfc69fa09$var$__assign.apply(this, arguments);
};
var $e50395cbfc69fa09$var$Default = {
    placement: 'center',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
    backdrop: 'dynamic',
    closable: true,
    onHide: function() {},
    onShow: function() {},
    onToggle: function() {}
};
var $e50395cbfc69fa09$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $e50395cbfc69fa09$var$Modal = /** @class */ function() {
    function Modal(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $e50395cbfc69fa09$var$Default;
        if (instanceOptions === void 0) instanceOptions = $e50395cbfc69fa09$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $e50395cbfc69fa09$var$__assign($e50395cbfc69fa09$var$__assign({}, $e50395cbfc69fa09$var$Default), options);
        this._isHidden = true;
        this._backdropEl = null;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Modal', this, this._instanceId, instanceOptions.override);
    }
    Modal.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._getPlacementClasses().map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._initialized = true;
        }
    };
    Modal.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            this._initialized = false;
        }
    };
    Modal.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Modal', this._instanceId);
    };
    Modal.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Modal.prototype._createBackdrop = function() {
        var _a;
        if (this._isHidden) {
            var backdropEl = document.createElement('div');
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(' '));
            document.querySelector('body').append(backdropEl);
            this._backdropEl = backdropEl;
        }
    };
    Modal.prototype._destroyBackdropEl = function() {
        if (!this._isHidden && this._backdropEl) {
            this._backdropEl.remove();
            this._backdropEl = null;
        }
    };
    Modal.prototype._setupModalCloseEventListeners = function() {
        var _this = this;
        if (this._options.backdrop === 'dynamic') {
            this._clickOutsideEventListener = function(ev) {
                _this._handleOutsideClick(ev.target);
            };
            this._targetEl.addEventListener('click', this._clickOutsideEventListener, true);
        }
        this._keydownEventListener = function(ev) {
            if (ev.key === 'Escape') _this.hide();
        };
        document.body.addEventListener('keydown', this._keydownEventListener, true);
    };
    Modal.prototype._removeModalCloseEventListeners = function() {
        if (this._options.backdrop === 'dynamic') this._targetEl.removeEventListener('click', this._clickOutsideEventListener, true);
        document.body.removeEventListener('keydown', this._keydownEventListener, true);
    };
    Modal.prototype._handleOutsideClick = function(target) {
        if (target === this._targetEl || target === this._backdropEl && this.isVisible()) this.hide();
    };
    Modal.prototype._getPlacementClasses = function() {
        switch(this._options.placement){
            // top
            case 'top-left':
                return [
                    'justify-start',
                    'items-start'
                ];
            case 'top-center':
                return [
                    'justify-center',
                    'items-start'
                ];
            case 'top-right':
                return [
                    'justify-end',
                    'items-start'
                ];
            // center
            case 'center-left':
                return [
                    'justify-start',
                    'items-center'
                ];
            case 'center':
                return [
                    'justify-center',
                    'items-center'
                ];
            case 'center-right':
                return [
                    'justify-end',
                    'items-center'
                ];
            // bottom
            case 'bottom-left':
                return [
                    'justify-start',
                    'items-end'
                ];
            case 'bottom-center':
                return [
                    'justify-center',
                    'items-end'
                ];
            case 'bottom-right':
                return [
                    'justify-end',
                    'items-end'
                ];
            default:
                return [
                    'justify-center',
                    'items-center'
                ];
        }
    };
    Modal.prototype.toggle = function() {
        if (this._isHidden) this.show();
        else this.hide();
        // callback function
        this._options.onToggle(this);
    };
    Modal.prototype.show = function() {
        if (this.isHidden) {
            this._targetEl.classList.add('flex');
            this._targetEl.classList.remove('hidden');
            this._targetEl.setAttribute('aria-modal', 'true');
            this._targetEl.setAttribute('role', 'dialog');
            this._targetEl.removeAttribute('aria-hidden');
            this._createBackdrop();
            this._isHidden = false;
            // Add keyboard event listener to the document
            if (this._options.closable) this._setupModalCloseEventListeners();
            // prevent body scroll
            document.body.classList.add('overflow-hidden');
            // callback function
            this._options.onShow(this);
        }
    };
    Modal.prototype.hide = function() {
        if (this.isVisible) {
            this._targetEl.classList.add('hidden');
            this._targetEl.classList.remove('flex');
            this._targetEl.setAttribute('aria-hidden', 'true');
            this._targetEl.removeAttribute('aria-modal');
            this._targetEl.removeAttribute('role');
            this._destroyBackdropEl();
            this._isHidden = true;
            // re-apply body scroll
            document.body.classList.remove('overflow-hidden');
            if (this._options.closable) this._removeModalCloseEventListeners();
            // callback function
            this._options.onHide(this);
        }
    };
    Modal.prototype.isVisible = function() {
        return !this._isHidden;
    };
    Modal.prototype.isHidden = function() {
        return this._isHidden;
    };
    Modal.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Modal.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Modal.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Modal.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Modal.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Modal.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Modal;
}();
function $e50395cbfc69fa09$export$e14d3bc873a8b9b1() {
    // initiate modal based on data-modal-target
    document.querySelectorAll('[data-modal-target]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-target');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var placement = $modalEl.getAttribute('data-modal-placement');
            var backdrop = $modalEl.getAttribute('data-modal-backdrop');
            new $e50395cbfc69fa09$var$Modal($modalEl, {
                placement: placement ? placement : $e50395cbfc69fa09$var$Default.placement,
                backdrop: backdrop ? backdrop : $e50395cbfc69fa09$var$Default.backdrop
            });
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-target attribute points to the correct modal id?."));
    });
    // toggle modal visibility
    document.querySelectorAll('[data-modal-toggle]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-toggle');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_1 = (0, $9e599e545d4197d0$export$2e2bcd8739ae039).getInstance('Modal', modalId);
            if (modal_1) {
                var toggleModal = function() {
                    modal_1.toggle();
                };
                $triggerEl.addEventListener('click', toggleModal);
                modal_1.addEventListenerInstance($triggerEl, 'click', toggleModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-toggle attribute points to the correct modal id?"));
    });
    // show modal on click if exists based on id
    document.querySelectorAll('[data-modal-show]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-show');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_2 = (0, $9e599e545d4197d0$export$2e2bcd8739ae039).getInstance('Modal', modalId);
            if (modal_2) {
                var showModal = function() {
                    modal_2.show();
                };
                $triggerEl.addEventListener('click', showModal);
                modal_2.addEventListenerInstance($triggerEl, 'click', showModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-show attribute points to the correct modal id?"));
    });
    // hide modal on click if exists based on id
    document.querySelectorAll('[data-modal-hide]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-hide');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_3 = (0, $9e599e545d4197d0$export$2e2bcd8739ae039).getInstance('Modal', modalId);
            if (modal_3) {
                var hideModal = function() {
                    modal_3.hide();
                };
                $triggerEl.addEventListener('click', hideModal);
                modal_3.addEventListenerInstance($triggerEl, 'click', hideModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-hide attribute points to the correct modal id?"));
    });
}
if (typeof window !== 'undefined') {
    window.Modal = $e50395cbfc69fa09$var$Modal;
    window.initModals = $e50395cbfc69fa09$export$e14d3bc873a8b9b1;
}
var $e50395cbfc69fa09$export$2e2bcd8739ae039 = $e50395cbfc69fa09$var$Modal;



var $4d66f8052cdbfb83$var$__assign = undefined && undefined.__assign || function() {
    $4d66f8052cdbfb83$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4d66f8052cdbfb83$var$__assign.apply(this, arguments);
};
var $4d66f8052cdbfb83$var$Default = {
    placement: 'left',
    bodyScrolling: false,
    backdrop: true,
    edge: false,
    edgeOffset: 'bottom-[60px]',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $4d66f8052cdbfb83$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $4d66f8052cdbfb83$var$Drawer = /** @class */ function() {
    function Drawer(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $4d66f8052cdbfb83$var$Default;
        if (instanceOptions === void 0) instanceOptions = $4d66f8052cdbfb83$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $4d66f8052cdbfb83$var$__assign($4d66f8052cdbfb83$var$__assign({}, $4d66f8052cdbfb83$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Drawer', this, this._instanceId, instanceOptions.override);
    }
    Drawer.prototype.init = function() {
        var _this = this;
        // set initial accessibility attributes
        if (this._targetEl && !this._initialized) {
            this._targetEl.setAttribute('aria-hidden', 'true');
            this._targetEl.classList.add('transition-transform');
            // set base placement classes
            this._getPlacementClasses(this._options.placement).base.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._handleEscapeKey = function(event) {
                if (event.key === 'Escape') // if 'Escape' key is pressed
                {
                    if (_this.isVisible()) // if the Drawer is visible
                    _this.hide(); // hide the Drawer
                }
            };
            // add keyboard event listener to document
            document.addEventListener('keydown', this._handleEscapeKey);
            this._initialized = true;
        }
    };
    Drawer.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            // Remove the keyboard event listener
            document.removeEventListener('keydown', this._handleEscapeKey);
            this._initialized = false;
        }
    };
    Drawer.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Drawer', this._instanceId);
    };
    Drawer.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Drawer.prototype.hide = function() {
        var _this = this;
        // based on the edge option show placement classes
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + '-edge').active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement + '-edge').inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute('aria-hidden', 'true');
        this._targetEl.removeAttribute('aria-modal');
        this._targetEl.removeAttribute('role');
        // enable body scroll
        if (!this._options.bodyScrolling) document.body.classList.remove('overflow-hidden');
        // destroy backdrop
        if (this._options.backdrop) this._destroyBackdropEl();
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Drawer.prototype.show = function() {
        var _this = this;
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + '-edge').active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement + '-edge').inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute('aria-modal', 'true');
        this._targetEl.setAttribute('role', 'dialog');
        this._targetEl.removeAttribute('aria-hidden');
        // disable body scroll
        if (!this._options.bodyScrolling) document.body.classList.add('overflow-hidden');
        // show backdrop
        if (this._options.backdrop) this._createBackdrop();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Drawer.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Drawer.prototype._createBackdrop = function() {
        var _a;
        var _this = this;
        if (!this._visible) {
            var backdropEl = document.createElement('div');
            backdropEl.setAttribute('drawer-backdrop', '');
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(' '));
            document.querySelector('body').append(backdropEl);
            backdropEl.addEventListener('click', function() {
                _this.hide();
            });
        }
    };
    Drawer.prototype._destroyBackdropEl = function() {
        if (this._visible && document.querySelector('[drawer-backdrop]') !== null) document.querySelector('[drawer-backdrop]').remove();
    };
    Drawer.prototype._getPlacementClasses = function(placement) {
        switch(placement){
            case 'top':
                return {
                    base: [
                        'top-0',
                        'left-0',
                        'right-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        '-translate-y-full'
                    ]
                };
            case 'right':
                return {
                    base: [
                        'right-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        'translate-x-full'
                    ]
                };
            case 'bottom':
                return {
                    base: [
                        'bottom-0',
                        'left-0',
                        'right-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        'translate-y-full'
                    ]
                };
            case 'left':
                return {
                    base: [
                        'left-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        '-translate-x-full'
                    ]
                };
            case 'bottom-edge':
                return {
                    base: [
                        'left-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        'translate-y-full',
                        this._options.edgeOffset
                    ]
                };
            default:
                return {
                    base: [
                        'left-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        '-translate-x-full'
                    ]
                };
        }
    };
    Drawer.prototype.isHidden = function() {
        return !this._visible;
    };
    Drawer.prototype.isVisible = function() {
        return this._visible;
    };
    Drawer.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Drawer.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Drawer.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Drawer.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Drawer.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Drawer.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Drawer;
}();
function $4d66f8052cdbfb83$export$319df2b10e87c8ec() {
    document.querySelectorAll('[data-drawer-target]').forEach(function($triggerEl) {
        // mandatory
        var drawerId = $triggerEl.getAttribute('data-drawer-target');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var placement = $triggerEl.getAttribute('data-drawer-placement');
            var bodyScrolling = $triggerEl.getAttribute('data-drawer-body-scrolling');
            var backdrop = $triggerEl.getAttribute('data-drawer-backdrop');
            var edge = $triggerEl.getAttribute('data-drawer-edge');
            var edgeOffset = $triggerEl.getAttribute('data-drawer-edge-offset');
            new $4d66f8052cdbfb83$var$Drawer($drawerEl, {
                placement: placement ? placement : $4d66f8052cdbfb83$var$Default.placement,
                bodyScrolling: bodyScrolling ? bodyScrolling === 'true' ? true : false : $4d66f8052cdbfb83$var$Default.bodyScrolling,
                backdrop: backdrop ? backdrop === 'true' ? true : false : $4d66f8052cdbfb83$var$Default.backdrop,
                edge: edge ? edge === 'true' ? true : false : $4d66f8052cdbfb83$var$Default.edge,
                edgeOffset: edgeOffset ? edgeOffset : $4d66f8052cdbfb83$var$Default.edgeOffset
            });
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll('[data-drawer-toggle]').forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute('data-drawer-toggle');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_1 = (0, $9e599e545d4197d0$export$2e2bcd8739ae039).getInstance('Drawer', drawerId);
            if (drawer_1) {
                var toggleDrawer = function() {
                    drawer_1.toggle();
                };
                $triggerEl.addEventListener('click', toggleDrawer);
                drawer_1.addEventListenerInstance($triggerEl, 'click', toggleDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll('[data-drawer-dismiss], [data-drawer-hide]').forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute('data-drawer-dismiss') ? $triggerEl.getAttribute('data-drawer-dismiss') : $triggerEl.getAttribute('data-drawer-hide');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_2 = (0, $9e599e545d4197d0$export$2e2bcd8739ae039).getInstance('Drawer', drawerId);
            if (drawer_2) {
                var hideDrawer = function() {
                    drawer_2.hide();
                };
                $triggerEl.addEventListener('click', hideDrawer);
                drawer_2.addEventListenerInstance($triggerEl, 'click', hideDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id"));
    });
    document.querySelectorAll('[data-drawer-show]').forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute('data-drawer-show');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_3 = (0, $9e599e545d4197d0$export$2e2bcd8739ae039).getInstance('Drawer', drawerId);
            if (drawer_3) {
                var showDrawer = function() {
                    drawer_3.show();
                };
                $triggerEl.addEventListener('click', showDrawer);
                drawer_3.addEventListenerInstance($triggerEl, 'click', showDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
}
if (typeof window !== 'undefined') {
    window.Drawer = $4d66f8052cdbfb83$var$Drawer;
    window.initDrawers = $4d66f8052cdbfb83$export$319df2b10e87c8ec;
}
var $4d66f8052cdbfb83$export$2e2bcd8739ae039 = $4d66f8052cdbfb83$var$Drawer;



var $43463cdeacf1e0fa$var$__assign = undefined && undefined.__assign || function() {
    $43463cdeacf1e0fa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $43463cdeacf1e0fa$var$__assign.apply(this, arguments);
};
var $43463cdeacf1e0fa$var$Default = {
    defaultTabId: null,
    activeClasses: 'text-blue-600 hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 border-blue-600 dark:border-blue-500',
    inactiveClasses: 'dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300',
    onShow: function() {}
};
var $43463cdeacf1e0fa$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $43463cdeacf1e0fa$var$Tabs = /** @class */ function() {
    function Tabs(tabsEl, items, options, instanceOptions) {
        if (tabsEl === void 0) tabsEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $43463cdeacf1e0fa$var$Default;
        if (instanceOptions === void 0) instanceOptions = $43463cdeacf1e0fa$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : tabsEl.id;
        this._tabsEl = tabsEl;
        this._items = items;
        this._activeTab = options ? this.getTab(options.defaultTabId) : null;
        this._options = $43463cdeacf1e0fa$var$__assign($43463cdeacf1e0fa$var$__assign({}, $43463cdeacf1e0fa$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Tabs', this, this._instanceId, instanceOptions.override);
    }
    Tabs.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) this.setActiveTab(this._items[0]);
            // force show the first default tab
            this.show(this._activeTab.id, true);
            // show tab content based on click
            this._items.map(function(tab) {
                tab.triggerEl.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this.show(tab.id);
                });
            });
        }
    };
    Tabs.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Tabs.prototype.removeInstance = function() {
        this.destroy();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Tabs', this._instanceId);
    };
    Tabs.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tabs.prototype.getActiveTab = function() {
        return this._activeTab;
    };
    Tabs.prototype.setActiveTab = function(tab) {
        this._activeTab = tab;
    };
    Tabs.prototype.getTab = function(id) {
        return this._items.filter(function(t) {
            return t.id === id;
        })[0];
    };
    Tabs.prototype.show = function(id, forceShow) {
        var _a, _b;
        var _this = this;
        if (forceShow === void 0) forceShow = false;
        var tab = this.getTab(id);
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) return;
        // hide other tabs
        this._items.map(function(t) {
            var _a, _b;
            if (t !== tab) {
                (_a = t.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(' '));
                (_b = t.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(' '));
                t.targetEl.classList.add('hidden');
                t.triggerEl.setAttribute('aria-selected', 'false');
            }
        });
        // show active tab
        (_a = tab.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(' '));
        (_b = tab.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(' '));
        tab.triggerEl.setAttribute('aria-selected', 'true');
        tab.targetEl.classList.remove('hidden');
        this.setActiveTab(tab);
        // callback function
        this._options.onShow(this, tab);
    };
    Tabs.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    return Tabs;
}();
function $43463cdeacf1e0fa$export$c92e8f569ad2976f() {
    document.querySelectorAll('[data-tabs-toggle]').forEach(function($parentEl) {
        var tabItems = [];
        var activeClasses = $parentEl.getAttribute('data-tabs-active-classes');
        var inactiveClasses = $parentEl.getAttribute('data-tabs-inactive-classes');
        var defaultTabId = null;
        $parentEl.querySelectorAll('[role="tab"]').forEach(function($triggerEl) {
            var isActive = $triggerEl.getAttribute('aria-selected') === 'true';
            var tab = {
                id: $triggerEl.getAttribute('data-tabs-target'),
                triggerEl: $triggerEl,
                targetEl: document.querySelector($triggerEl.getAttribute('data-tabs-target'))
            };
            tabItems.push(tab);
            if (isActive) defaultTabId = tab.id;
        });
        new $43463cdeacf1e0fa$var$Tabs($parentEl, tabItems, {
            defaultTabId: defaultTabId,
            activeClasses: activeClasses ? activeClasses : $43463cdeacf1e0fa$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $43463cdeacf1e0fa$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== 'undefined') {
    window.Tabs = $43463cdeacf1e0fa$var$Tabs;
    window.initTabs = $43463cdeacf1e0fa$export$c92e8f569ad2976f;
}
var $43463cdeacf1e0fa$export$2e2bcd8739ae039 = $43463cdeacf1e0fa$var$Tabs;




var $0da394db4be38aaa$var$__assign = undefined && undefined.__assign || function() {
    $0da394db4be38aaa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0da394db4be38aaa$var$__assign.apply(this, arguments);
};
var $0da394db4be38aaa$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0da394db4be38aaa$var$Default = {
    placement: 'top',
    triggerType: 'hover',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $0da394db4be38aaa$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $0da394db4be38aaa$var$Tooltip = /** @class */ function() {
    function Tooltip(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $0da394db4be38aaa$var$Default;
        if (instanceOptions === void 0) instanceOptions = $0da394db4be38aaa$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $0da394db4be38aaa$var$__assign($0da394db4be38aaa$var$__assign({}, $0da394db4be38aaa$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Tooltip', this, this._instanceId, instanceOptions.override);
    }
    Tooltip.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Tooltip.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Tooltip.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Tooltip', this._instanceId);
    };
    Tooltip.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tooltip.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            _this.hide();
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Tooltip.prototype._createPopperInstance = function() {
        return (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                }
            ]
        });
    };
    Tooltip.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click',
                        'focus'
                    ],
                    hideEvents: [
                        'focusout',
                        'blur'
                    ]
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
        }
    };
    Tooltip.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === 'Escape') _this.hide();
        };
        document.body.addEventListener('keydown', this._keydownEventListener, true);
    };
    Tooltip.prototype._removeKeydownListener = function() {
        document.body.removeEventListener('keydown', this._keydownEventListener, true);
    };
    Tooltip.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener('click', this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener('click', this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Tooltip.prototype.isVisible = function() {
        return this._visible;
    };
    Tooltip.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Tooltip.prototype.show = function() {
        this._targetEl.classList.remove('opacity-0', 'invisible');
        this._targetEl.classList.add('opacity-100', 'visible');
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $0da394db4be38aaa$var$__assign($0da394db4be38aaa$var$__assign({}, options), {
                modifiers: $0da394db4be38aaa$var$__spreadArray($0da394db4be38aaa$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Tooltip.prototype.hide = function() {
        this._targetEl.classList.remove('opacity-100', 'visible');
        this._targetEl.classList.add('opacity-0', 'invisible');
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $0da394db4be38aaa$var$__assign($0da394db4be38aaa$var$__assign({}, options), {
                modifiers: $0da394db4be38aaa$var$__spreadArray($0da394db4be38aaa$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Tooltip.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Tooltip.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Tooltip.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Tooltip;
}();
function $0da394db4be38aaa$export$8f2a38c1f9d9dc3e() {
    document.querySelectorAll('[data-tooltip-target]').forEach(function($triggerEl) {
        var tooltipId = $triggerEl.getAttribute('data-tooltip-target');
        var $tooltipEl = document.getElementById(tooltipId);
        if ($tooltipEl) {
            var triggerType = $triggerEl.getAttribute('data-tooltip-trigger');
            var placement = $triggerEl.getAttribute('data-tooltip-placement');
            new $0da394db4be38aaa$var$Tooltip($tooltipEl, $triggerEl, {
                placement: placement ? placement : $0da394db4be38aaa$var$Default.placement,
                triggerType: triggerType ? triggerType : $0da394db4be38aaa$var$Default.triggerType
            });
        } else console.error("The tooltip element with id \"".concat(tooltipId, "\" does not exist. Please check the data-tooltip-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Tooltip = $0da394db4be38aaa$var$Tooltip;
    window.initTooltips = $0da394db4be38aaa$export$8f2a38c1f9d9dc3e;
}
var $0da394db4be38aaa$export$2e2bcd8739ae039 = $0da394db4be38aaa$var$Tooltip;




var $f8e681bd2d19b9c0$var$__assign = undefined && undefined.__assign || function() {
    $f8e681bd2d19b9c0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f8e681bd2d19b9c0$var$__assign.apply(this, arguments);
};
var $f8e681bd2d19b9c0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f8e681bd2d19b9c0$var$Default = {
    placement: 'top',
    offset: 10,
    triggerType: 'hover',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $f8e681bd2d19b9c0$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $f8e681bd2d19b9c0$var$Popover = /** @class */ function() {
    function Popover(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $f8e681bd2d19b9c0$var$Default;
        if (instanceOptions === void 0) instanceOptions = $f8e681bd2d19b9c0$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $f8e681bd2d19b9c0$var$__assign($f8e681bd2d19b9c0$var$__assign({}, $f8e681bd2d19b9c0$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Popover', this, instanceOptions.id ? instanceOptions.id : this._targetEl.id, instanceOptions.override);
    }
    Popover.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Popover.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element and target element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
                _this._targetEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
                _this._targetEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Popover.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Popover', this._instanceId);
    };
    Popover.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Popover.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(':hover')) _this.hide();
            }, 100);
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
            _this._targetEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
            _this._targetEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Popover.prototype._createPopperInstance = function() {
        return (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            this._options.offset
                        ]
                    }
                }
            ]
        });
    };
    Popover.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click',
                        'focus'
                    ],
                    hideEvents: [
                        'focusout',
                        'blur'
                    ]
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
        }
    };
    Popover.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === 'Escape') _this.hide();
        };
        document.body.addEventListener('keydown', this._keydownEventListener, true);
    };
    Popover.prototype._removeKeydownListener = function() {
        document.body.removeEventListener('keydown', this._keydownEventListener, true);
    };
    Popover.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener('click', this._clickOutsideEventListener, true);
    };
    Popover.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener('click', this._clickOutsideEventListener, true);
    };
    Popover.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Popover.prototype.isVisible = function() {
        return this._visible;
    };
    Popover.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Popover.prototype.show = function() {
        this._targetEl.classList.remove('opacity-0', 'invisible');
        this._targetEl.classList.add('opacity-100', 'visible');
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $f8e681bd2d19b9c0$var$__assign($f8e681bd2d19b9c0$var$__assign({}, options), {
                modifiers: $f8e681bd2d19b9c0$var$__spreadArray($f8e681bd2d19b9c0$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility to true
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Popover.prototype.hide = function() {
        this._targetEl.classList.remove('opacity-100', 'visible');
        this._targetEl.classList.add('opacity-0', 'invisible');
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $f8e681bd2d19b9c0$var$__assign($f8e681bd2d19b9c0$var$__assign({}, options), {
                modifiers: $f8e681bd2d19b9c0$var$__spreadArray($f8e681bd2d19b9c0$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility to false
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Popover.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Popover.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Popover.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Popover;
}();
function $f8e681bd2d19b9c0$export$200409e83b2a0dd4() {
    document.querySelectorAll('[data-popover-target]').forEach(function($triggerEl) {
        var popoverID = $triggerEl.getAttribute('data-popover-target');
        var $popoverEl = document.getElementById(popoverID);
        if ($popoverEl) {
            var triggerType = $triggerEl.getAttribute('data-popover-trigger');
            var placement = $triggerEl.getAttribute('data-popover-placement');
            var offset = $triggerEl.getAttribute('data-popover-offset');
            new $f8e681bd2d19b9c0$var$Popover($popoverEl, $triggerEl, {
                placement: placement ? placement : $f8e681bd2d19b9c0$var$Default.placement,
                offset: offset ? parseInt(offset) : $f8e681bd2d19b9c0$var$Default.offset,
                triggerType: triggerType ? triggerType : $f8e681bd2d19b9c0$var$Default.triggerType
            });
        } else console.error("The popover element with id \"".concat(popoverID, "\" does not exist. Please check the data-popover-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Popover = $f8e681bd2d19b9c0$var$Popover;
    window.initPopovers = $f8e681bd2d19b9c0$export$200409e83b2a0dd4;
}
var $f8e681bd2d19b9c0$export$2e2bcd8739ae039 = $f8e681bd2d19b9c0$var$Popover;



var $24d88d1ae14e4d54$var$__assign = undefined && undefined.__assign || function() {
    $24d88d1ae14e4d54$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $24d88d1ae14e4d54$var$__assign.apply(this, arguments);
};
var $24d88d1ae14e4d54$var$Default = {
    triggerType: 'hover',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $24d88d1ae14e4d54$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $24d88d1ae14e4d54$var$Dial = /** @class */ function() {
    function Dial(parentEl, triggerEl, targetEl, options, instanceOptions) {
        if (parentEl === void 0) parentEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $24d88d1ae14e4d54$var$Default;
        if (instanceOptions === void 0) instanceOptions = $24d88d1ae14e4d54$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._parentEl = parentEl;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $24d88d1ae14e4d54$var$__assign($24d88d1ae14e4d54$var$__assign({}, $24d88d1ae14e4d54$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Dial', this, this._instanceId, instanceOptions.override);
    }
    Dial.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            this._showEventHandler = function() {
                _this.show();
            };
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._showEventHandler);
                _this._targetEl.addEventListener(ev, _this._showEventHandler);
            });
            this._hideEventHandler = function() {
                if (!_this._parentEl.matches(':hover')) _this.hide();
            };
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.addEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = true;
        }
    };
    Dial.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showEventHandler);
                _this._targetEl.removeEventListener(ev, _this._showEventHandler);
            });
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.removeEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = false;
        }
    };
    Dial.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Dial', this._instanceId);
    };
    Dial.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dial.prototype.hide = function() {
        this._targetEl.classList.add('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'false');
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Dial.prototype.show = function() {
        this._targetEl.classList.remove('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'true');
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dial.prototype.toggle = function() {
        if (this._visible) this.hide();
        else this.show();
    };
    Dial.prototype.isHidden = function() {
        return !this._visible;
    };
    Dial.prototype.isVisible = function() {
        return this._visible;
    };
    Dial.prototype._getTriggerEventTypes = function(triggerType) {
        switch(triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click',
                        'focus'
                    ],
                    hideEvents: [
                        'focusout',
                        'blur'
                    ]
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
        }
    };
    Dial.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dial.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dial.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dial;
}();
function $24d88d1ae14e4d54$export$33aa68e0bfaa065d() {
    document.querySelectorAll('[data-dial-init]').forEach(function($parentEl) {
        var $triggerEl = $parentEl.querySelector('[data-dial-toggle]');
        if ($triggerEl) {
            var dialId = $triggerEl.getAttribute('data-dial-toggle');
            var $dialEl = document.getElementById(dialId);
            if ($dialEl) {
                var triggerType = $triggerEl.getAttribute('data-dial-trigger');
                new $24d88d1ae14e4d54$var$Dial($parentEl, $triggerEl, $dialEl, {
                    triggerType: triggerType ? triggerType : $24d88d1ae14e4d54$var$Default.triggerType
                });
            } else console.error("Dial with id ".concat(dialId, " does not exist. Are you sure that the data-dial-toggle attribute points to the correct modal id?"));
        } else console.error("Dial with id ".concat($parentEl.id, " does not have a trigger element. Are you sure that the data-dial-toggle attribute exists?"));
    });
}
if (typeof window !== 'undefined') {
    window.Dial = $24d88d1ae14e4d54$var$Dial;
    window.initDials = $24d88d1ae14e4d54$export$33aa68e0bfaa065d;
}
var $24d88d1ae14e4d54$export$2e2bcd8739ae039 = $24d88d1ae14e4d54$var$Dial;



var $1c5fe2354b7370dd$var$__assign = undefined && undefined.__assign || function() {
    $1c5fe2354b7370dd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c5fe2354b7370dd$var$__assign.apply(this, arguments);
};
var $1c5fe2354b7370dd$var$Default = {
    minValue: null,
    maxValue: null,
    onIncrement: function() {},
    onDecrement: function() {}
};
var $1c5fe2354b7370dd$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $1c5fe2354b7370dd$var$InputCounter = /** @class */ function() {
    function InputCounter(targetEl, incrementEl, decrementEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (incrementEl === void 0) incrementEl = null;
        if (decrementEl === void 0) decrementEl = null;
        if (options === void 0) options = $1c5fe2354b7370dd$var$Default;
        if (instanceOptions === void 0) instanceOptions = $1c5fe2354b7370dd$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._incrementEl = incrementEl;
        this._decrementEl = decrementEl;
        this._options = $1c5fe2354b7370dd$var$__assign($1c5fe2354b7370dd$var$__assign({}, $1c5fe2354b7370dd$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('InputCounter', this, this._instanceId, instanceOptions.override);
    }
    InputCounter.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._inputHandler = function(event) {
                var target = event.target;
                // check if the value is numeric
                if (!/^\d*$/.test(target.value)) // Regex to check if the value is numeric
                target.value = target.value.replace(/[^\d]/g, ''); // Remove non-numeric characters
                // check for max value
                if (_this._options.maxValue !== null && parseInt(target.value) > _this._options.maxValue) target.value = _this._options.maxValue.toString();
                // check for min value
                if (_this._options.minValue !== null && parseInt(target.value) < _this._options.minValue) target.value = _this._options.minValue.toString();
            };
            this._incrementClickHandler = function() {
                _this.increment();
            };
            this._decrementClickHandler = function() {
                _this.decrement();
            };
            // Add event listener to restrict input to numeric values only
            this._targetEl.addEventListener('input', this._inputHandler);
            if (this._incrementEl) this._incrementEl.addEventListener('click', this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.addEventListener('click', this._decrementClickHandler);
            this._initialized = true;
        }
    };
    InputCounter.prototype.destroy = function() {
        if (this._targetEl && this._initialized) {
            this._targetEl.removeEventListener('input', this._inputHandler);
            if (this._incrementEl) this._incrementEl.removeEventListener('click', this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.removeEventListener('click', this._decrementClickHandler);
            this._initialized = false;
        }
    };
    InputCounter.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('InputCounter', this._instanceId);
    };
    InputCounter.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    InputCounter.prototype.getCurrentValue = function() {
        return parseInt(this._targetEl.value) || 0;
    };
    InputCounter.prototype.increment = function() {
        // don't increment if the value is already at the maximum value
        if (this._options.maxValue !== null && this.getCurrentValue() >= this._options.maxValue) return;
        this._targetEl.value = (this.getCurrentValue() + 1).toString();
        this._options.onIncrement(this);
    };
    InputCounter.prototype.decrement = function() {
        // don't decrement if the value is already at the minimum value
        if (this._options.minValue !== null && this.getCurrentValue() <= this._options.minValue) return;
        this._targetEl.value = (this.getCurrentValue() - 1).toString();
        this._options.onDecrement(this);
    };
    InputCounter.prototype.updateOnIncrement = function(callback) {
        this._options.onIncrement = callback;
    };
    InputCounter.prototype.updateOnDecrement = function(callback) {
        this._options.onDecrement = callback;
    };
    return InputCounter;
}();
function $1c5fe2354b7370dd$export$4352dd3b7a1676ab() {
    document.querySelectorAll('[data-input-counter]').forEach(function($targetEl) {
        var targetId = $targetEl.id;
        var $incrementEl = document.querySelector('[data-input-counter-increment="' + targetId + '"]');
        var $decrementEl = document.querySelector('[data-input-counter-decrement="' + targetId + '"]');
        var minValue = $targetEl.getAttribute('data-input-counter-min');
        var maxValue = $targetEl.getAttribute('data-input-counter-max');
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $9e599e545d4197d0$export$2e2bcd8739ae039).instanceExists('InputCounter', $targetEl.getAttribute('id'))) new $1c5fe2354b7370dd$var$InputCounter($targetEl, $incrementEl ? $incrementEl : null, $decrementEl ? $decrementEl : null, {
                minValue: minValue ? parseInt(minValue) : null,
                maxValue: maxValue ? parseInt(maxValue) : null
            });
        } else console.error("The target element with id \"".concat(targetId, "\" does not exist. Please check the data-input-counter attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.InputCounter = $1c5fe2354b7370dd$var$InputCounter;
    window.initInputCounters = $1c5fe2354b7370dd$export$4352dd3b7a1676ab;
}
var $1c5fe2354b7370dd$export$2e2bcd8739ae039 = $1c5fe2354b7370dd$var$InputCounter;



var $0259e20e6a846074$var$__assign = undefined && undefined.__assign || function() {
    $0259e20e6a846074$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0259e20e6a846074$var$__assign.apply(this, arguments);
};
var $0259e20e6a846074$var$Default = {
    htmlEntities: false,
    contentType: 'input',
    onCopy: function() {}
};
var $0259e20e6a846074$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $0259e20e6a846074$var$CopyClipboard = /** @class */ function() {
    function CopyClipboard(triggerEl, targetEl, options, instanceOptions) {
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $0259e20e6a846074$var$Default;
        if (instanceOptions === void 0) instanceOptions = $0259e20e6a846074$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $0259e20e6a846074$var$__assign($0259e20e6a846074$var$__assign({}, $0259e20e6a846074$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('CopyClipboard', this, this._instanceId, instanceOptions.override);
    }
    CopyClipboard.prototype.init = function() {
        var _this = this;
        if (this._targetEl && this._triggerEl && !this._initialized) {
            this._triggerElClickHandler = function() {
                _this.copy();
            };
            // clicking on the trigger element should copy the value of the target element
            if (this._triggerEl) this._triggerEl.addEventListener('click', this._triggerElClickHandler);
            this._initialized = true;
        }
    };
    CopyClipboard.prototype.destroy = function() {
        if (this._triggerEl && this._targetEl && this._initialized) {
            if (this._triggerEl) this._triggerEl.removeEventListener('click', this._triggerElClickHandler);
            this._initialized = false;
        }
    };
    CopyClipboard.prototype.removeInstance = function() {
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('CopyClipboard', this._instanceId);
    };
    CopyClipboard.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    CopyClipboard.prototype.getTargetValue = function() {
        if (this._options.contentType === 'input') return this._targetEl.value;
        if (this._options.contentType === 'innerHTML') return this._targetEl.innerHTML;
        if (this._options.contentType === 'textContent') return this._targetEl.textContent.replace(/\s+/g, ' ').trim();
    };
    CopyClipboard.prototype.copy = function() {
        var textToCopy = this.getTargetValue();
        // Check if HTMLEntities option is enabled
        if (this._options.htmlEntities) // Encode the text using HTML entities
        textToCopy = this.decodeHTML(textToCopy);
        // Create a temporary textarea element
        var tempTextArea = document.createElement('textarea');
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);
        // Select the text inside the textarea and copy it to the clipboard
        tempTextArea.select();
        document.execCommand('copy');
        // Remove the temporary textarea
        document.body.removeChild(tempTextArea);
        // Callback function
        this._options.onCopy(this);
        return textToCopy;
    };
    // Function to encode text into HTML entities
    CopyClipboard.prototype.decodeHTML = function(html) {
        var textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.textContent;
    };
    CopyClipboard.prototype.updateOnCopyCallback = function(callback) {
        this._options.onCopy = callback;
    };
    return CopyClipboard;
}();
function $0259e20e6a846074$export$ad4117886fd6cf74() {
    document.querySelectorAll('[data-copy-to-clipboard-target]').forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute('data-copy-to-clipboard-target');
        var $targetEl = document.getElementById(targetId);
        var contentType = $triggerEl.getAttribute('data-copy-to-clipboard-content-type');
        var htmlEntities = $triggerEl.getAttribute('data-copy-to-clipboard-html-entities');
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $9e599e545d4197d0$export$2e2bcd8739ae039).instanceExists('CopyClipboard', $targetEl.getAttribute('id'))) new $0259e20e6a846074$var$CopyClipboard($triggerEl, $targetEl, {
                htmlEntities: htmlEntities && htmlEntities === 'true' ? true : $0259e20e6a846074$var$Default.htmlEntities,
                contentType: contentType ? contentType : $0259e20e6a846074$var$Default.contentType
            });
        } else console.error("The target element with id \"".concat(targetId, "\" does not exist. Please check the data-copy-to-clipboard-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.CopyClipboard = $0259e20e6a846074$var$CopyClipboard;
    window.initClipboards = $0259e20e6a846074$export$ad4117886fd6cf74;
}
var $0259e20e6a846074$export$2e2bcd8739ae039 = $0259e20e6a846074$var$CopyClipboard;



function $61b869fc2909ad8f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $61b869fc2909ad8f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $61b869fc2909ad8f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $61b869fc2909ad8f$var$_arrayLikeToArray(r);
}
function $61b869fc2909ad8f$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $61b869fc2909ad8f$var$_callSuper(t, o, e) {
    return o = $61b869fc2909ad8f$var$_getPrototypeOf(o), $61b869fc2909ad8f$var$_possibleConstructorReturn(t, $61b869fc2909ad8f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $61b869fc2909ad8f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $61b869fc2909ad8f$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $61b869fc2909ad8f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $61b869fc2909ad8f$var$_toPropertyKey(o.key), o);
    }
}
function $61b869fc2909ad8f$var$_createClass(e, r, t) {
    return r && $61b869fc2909ad8f$var$_defineProperties(e.prototype, r), t && $61b869fc2909ad8f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $61b869fc2909ad8f$var$_get() {
    return $61b869fc2909ad8f$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $61b869fc2909ad8f$var$_superPropBase(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $61b869fc2909ad8f$var$_get.apply(null, arguments);
}
function $61b869fc2909ad8f$var$_getPrototypeOf(t) {
    return $61b869fc2909ad8f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $61b869fc2909ad8f$var$_getPrototypeOf(t);
}
function $61b869fc2909ad8f$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $61b869fc2909ad8f$var$_setPrototypeOf(t, e);
}
function $61b869fc2909ad8f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($61b869fc2909ad8f$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $61b869fc2909ad8f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $61b869fc2909ad8f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $61b869fc2909ad8f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $61b869fc2909ad8f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $61b869fc2909ad8f$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $61b869fc2909ad8f$var$_assertThisInitialized(t);
}
function $61b869fc2909ad8f$var$_setPrototypeOf(t, e) {
    return $61b869fc2909ad8f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $61b869fc2909ad8f$var$_setPrototypeOf(t, e);
}
function $61b869fc2909ad8f$var$_slicedToArray(r, e) {
    return $61b869fc2909ad8f$var$_arrayWithHoles(r) || $61b869fc2909ad8f$var$_iterableToArrayLimit(r, e) || $61b869fc2909ad8f$var$_unsupportedIterableToArray(r, e) || $61b869fc2909ad8f$var$_nonIterableRest();
}
function $61b869fc2909ad8f$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $61b869fc2909ad8f$var$_getPrototypeOf(t)););
    return t;
}
function $61b869fc2909ad8f$var$_toConsumableArray(r) {
    return $61b869fc2909ad8f$var$_arrayWithoutHoles(r) || $61b869fc2909ad8f$var$_iterableToArray(r) || $61b869fc2909ad8f$var$_unsupportedIterableToArray(r) || $61b869fc2909ad8f$var$_nonIterableSpread();
}
function $61b869fc2909ad8f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $61b869fc2909ad8f$var$_toPropertyKey(t) {
    var i = $61b869fc2909ad8f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $61b869fc2909ad8f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $61b869fc2909ad8f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61b869fc2909ad8f$var$_typeof(o);
}
function $61b869fc2909ad8f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $61b869fc2909ad8f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $61b869fc2909ad8f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $61b869fc2909ad8f$var$hasProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $61b869fc2909ad8f$var$lastItemOf(arr) {
    return arr[arr.length - 1];
}
// push only the items not included in the array
function $61b869fc2909ad8f$var$pushUnique(arr) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)items[_key - 1] = arguments[_key];
    items.forEach(function(item) {
        if (arr.includes(item)) return;
        arr.push(item);
    });
    return arr;
}
function $61b869fc2909ad8f$var$stringToArray(str, separator) {
    // convert empty string to an empty array
    return str ? str.split(separator) : [];
}
function $61b869fc2909ad8f$var$isInRange(testVal, min, max) {
    var minOK = min === undefined || testVal >= min;
    var maxOK = max === undefined || testVal <= max;
    return minOK && maxOK;
}
function $61b869fc2909ad8f$var$limitToRange(val, min, max) {
    if (val < min) return min;
    if (val > max) return max;
    return val;
}
function $61b869fc2909ad8f$var$createTagRepeat(tagName, repeat) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var html = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var openTagSrc = Object.keys(attributes).reduce(function(src, attr) {
        var val = attributes[attr];
        if (typeof val === 'function') val = val(index);
        return "".concat(src, " ").concat(attr, "=\"").concat(val, "\"");
    }, tagName);
    html += "<".concat(openTagSrc, "></").concat(tagName, ">");
    var next = index + 1;
    return next < repeat ? $61b869fc2909ad8f$var$createTagRepeat(tagName, repeat, attributes, next, html) : html;
}
// Remove the spacing surrounding tags for HTML parser not to create text nodes
// before/after elements
function $61b869fc2909ad8f$var$optimizeTemplateHTML(html) {
    return html.replace(/>\s+/g, '>').replace(/\s+</, '<');
}
function $61b869fc2909ad8f$var$stripTime(timeValue) {
    return new Date(timeValue).setHours(0, 0, 0, 0);
}
function $61b869fc2909ad8f$var$today() {
    return new Date().setHours(0, 0, 0, 0);
}
// Get the time value of the start of given date or year, month and day
function $61b869fc2909ad8f$var$dateValue() {
    switch(arguments.length){
        case 0:
            return $61b869fc2909ad8f$var$today();
        case 1:
            return $61b869fc2909ad8f$var$stripTime(arguments.length <= 0 ? undefined : arguments[0]);
    }
    // use setFullYear() to keep 2-digit year from being mapped to 1900-1999
    var newDate = new Date(0);
    newDate.setFullYear.apply(newDate, arguments);
    return newDate.setHours(0, 0, 0, 0);
}
function $61b869fc2909ad8f$var$addDays(date, amount) {
    var newDate = new Date(date);
    return newDate.setDate(newDate.getDate() + amount);
}
function $61b869fc2909ad8f$var$addWeeks(date, amount) {
    return $61b869fc2909ad8f$var$addDays(date, amount * 7);
}
function $61b869fc2909ad8f$var$addMonths(date, amount) {
    // If the day of the date is not in the new month, the last day of the new
    // month will be returned. e.g. Jan 31 + 1 month → Feb 28 (not Mar 03)
    var newDate = new Date(date);
    var monthsToSet = newDate.getMonth() + amount;
    var expectedMonth = monthsToSet % 12;
    if (expectedMonth < 0) expectedMonth += 12;
    var time = newDate.setMonth(monthsToSet);
    return newDate.getMonth() !== expectedMonth ? newDate.setDate(0) : time;
}
function $61b869fc2909ad8f$var$addYears(date, amount) {
    // If the date is Feb 29 and the new year is not a leap year, Feb 28 of the
    // new year will be returned.
    var newDate = new Date(date);
    var expectedMonth = newDate.getMonth();
    var time = newDate.setFullYear(newDate.getFullYear() + amount);
    return expectedMonth === 1 && newDate.getMonth() === 2 ? newDate.setDate(0) : time;
}
// Calculate the distance bettwen 2 days of the week
function $61b869fc2909ad8f$var$dayDiff(day, from) {
    return (day - from + 7) % 7;
}
// Get the date of the specified day of the week of given base date
function $61b869fc2909ad8f$var$dayOfTheWeekOf(baseDate, dayOfWeek) {
    var weekStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var baseDay = new Date(baseDate).getDay();
    return $61b869fc2909ad8f$var$addDays(baseDate, $61b869fc2909ad8f$var$dayDiff(dayOfWeek, weekStart) - $61b869fc2909ad8f$var$dayDiff(baseDay, weekStart));
}
// Get the ISO week of a date
function $61b869fc2909ad8f$var$getWeek(date) {
    // start of ISO week is Monday
    var thuOfTheWeek = $61b869fc2909ad8f$var$dayOfTheWeekOf(date, 4, 1);
    // 1st week == the week where the 4th of January is in
    var firstThu = $61b869fc2909ad8f$var$dayOfTheWeekOf(new Date(thuOfTheWeek).setMonth(0, 4), 4, 1);
    return Math.round((thuOfTheWeek - firstThu) / 604800000) + 1;
}
// Get the start year of the period of years that includes given date
// years: length of the year period
function $61b869fc2909ad8f$var$startOfYearPeriod(date, years) {
    /* @see https://en.wikipedia.org/wiki/Year_zero#ISO_8601 */ var year = new Date(date).getFullYear();
    return Math.floor(year / years) * years;
}
// pattern for format parts
var $61b869fc2909ad8f$var$reFormatTokens = /dd?|DD?|mm?|MM?|yy?(?:yy)?/;
// pattern for non date parts
var $61b869fc2909ad8f$var$reNonDateParts = /[\s!-/:-@[-`{-~年月日]+/;
// cache for persed formats
var $61b869fc2909ad8f$var$knownFormats = {};
// parse funtions for date parts
var $61b869fc2909ad8f$var$parseFns = {
    y: function y(date, year) {
        return new Date(date).setFullYear(parseInt(year, 10));
    },
    m: function m(date, month, locale) {
        var newDate = new Date(date);
        var monthIndex = parseInt(month, 10) - 1;
        if (isNaN(monthIndex)) {
            if (!month) return NaN;
            var monthName = month.toLowerCase();
            var compareNames = function compareNames(name) {
                return name.toLowerCase().startsWith(monthName);
            };
            // compare with both short and full names because some locales have periods
            // in the short names (not equal to the first X letters of the full names)
            monthIndex = locale.monthsShort.findIndex(compareNames);
            if (monthIndex < 0) monthIndex = locale.months.findIndex(compareNames);
            if (monthIndex < 0) return NaN;
        }
        newDate.setMonth(monthIndex);
        return newDate.getMonth() !== $61b869fc2909ad8f$var$normalizeMonth(monthIndex) ? newDate.setDate(0) : newDate.getTime();
    },
    d: function d(date, day) {
        return new Date(date).setDate(parseInt(day, 10));
    }
};
// format functions for date parts
var $61b869fc2909ad8f$var$formatFns = {
    d: function d(date) {
        return date.getDate();
    },
    dd: function dd(date) {
        return $61b869fc2909ad8f$var$padZero(date.getDate(), 2);
    },
    D: function D(date, locale) {
        return locale.daysShort[date.getDay()];
    },
    DD: function DD(date, locale) {
        return locale.days[date.getDay()];
    },
    m: function m(date) {
        return date.getMonth() + 1;
    },
    mm: function mm(date) {
        return $61b869fc2909ad8f$var$padZero(date.getMonth() + 1, 2);
    },
    M: function M(date, locale) {
        return locale.monthsShort[date.getMonth()];
    },
    MM: function MM(date, locale) {
        return locale.months[date.getMonth()];
    },
    y: function y(date) {
        return date.getFullYear();
    },
    yy: function yy(date) {
        return $61b869fc2909ad8f$var$padZero(date.getFullYear(), 2).slice(-2);
    },
    yyyy: function yyyy(date) {
        return $61b869fc2909ad8f$var$padZero(date.getFullYear(), 4);
    }
};
// get month index in normal range (0 - 11) from any number
function $61b869fc2909ad8f$var$normalizeMonth(monthIndex) {
    return monthIndex > -1 ? monthIndex % 12 : $61b869fc2909ad8f$var$normalizeMonth(monthIndex + 12);
}
function $61b869fc2909ad8f$var$padZero(num, length) {
    return num.toString().padStart(length, '0');
}
function $61b869fc2909ad8f$var$parseFormatString(format) {
    if (typeof format !== 'string') throw new Error("Invalid date format.");
    if (format in $61b869fc2909ad8f$var$knownFormats) return $61b869fc2909ad8f$var$knownFormats[format];
    // sprit the format string into parts and seprators
    var separators = format.split($61b869fc2909ad8f$var$reFormatTokens);
    var parts = format.match(new RegExp($61b869fc2909ad8f$var$reFormatTokens, 'g'));
    if (separators.length === 0 || !parts) throw new Error("Invalid date format.");
    // collect format functions used in the format
    var partFormatters = parts.map(function(token) {
        return $61b869fc2909ad8f$var$formatFns[token];
    });
    // collect parse function keys used in the format
    // iterate over parseFns' keys in order to keep the order of the keys.
    var partParserKeys = Object.keys($61b869fc2909ad8f$var$parseFns).reduce(function(keys, key) {
        var token = parts.find(function(part) {
            return part[0] !== 'D' && part[0].toLowerCase() === key;
        });
        if (token) keys.push(key);
        return keys;
    }, []);
    return $61b869fc2909ad8f$var$knownFormats[format] = {
        parser: function parser(dateStr, locale) {
            var dateParts = dateStr.split($61b869fc2909ad8f$var$reNonDateParts).reduce(function(dtParts, part, index) {
                if (part.length > 0 && parts[index]) {
                    var token = parts[index][0];
                    if (token === 'M') dtParts.m = part;
                    else if (token !== 'D') dtParts[token] = part;
                }
                return dtParts;
            }, {});
            // iterate over partParserkeys so that the parsing is made in the oder
            // of year, month and day to prevent the day parser from correcting last
            // day of month wrongly
            return partParserKeys.reduce(function(origDate, key) {
                var newDate = $61b869fc2909ad8f$var$parseFns[key](origDate, dateParts[key], locale);
                // ingnore the part failed to parse
                return isNaN(newDate) ? origDate : newDate;
            }, $61b869fc2909ad8f$var$today());
        },
        formatter: function formatter(date, locale) {
            var dateStr = partFormatters.reduce(function(str, fn, index) {
                return str += "".concat(separators[index]).concat(fn(date, locale));
            }, '');
            // separators' length is always parts' length + 1,
            return dateStr += $61b869fc2909ad8f$var$lastItemOf(separators);
        }
    };
}
function $61b869fc2909ad8f$var$parseDate(dateStr, format, locale) {
    if (dateStr instanceof Date || typeof dateStr === 'number') {
        var date = $61b869fc2909ad8f$var$stripTime(dateStr);
        return isNaN(date) ? undefined : date;
    }
    if (!dateStr) return undefined;
    if (dateStr === 'today') return $61b869fc2909ad8f$var$today();
    if (format && format.toValue) {
        var _date = format.toValue(dateStr, format, locale);
        return isNaN(_date) ? undefined : $61b869fc2909ad8f$var$stripTime(_date);
    }
    return $61b869fc2909ad8f$var$parseFormatString(format).parser(dateStr, locale);
}
function $61b869fc2909ad8f$var$formatDate(date, format, locale) {
    if (isNaN(date) || !date && date !== 0) return '';
    var dateObj = typeof date === 'number' ? new Date(date) : date;
    if (format.toDisplay) return format.toDisplay(dateObj, format, locale);
    return $61b869fc2909ad8f$var$parseFormatString(format).formatter(dateObj, locale);
}
var $61b869fc2909ad8f$var$listenerRegistry = new WeakMap();
var $61b869fc2909ad8f$var$_EventTarget$prototyp = EventTarget.prototype, $61b869fc2909ad8f$var$addEventListener = $61b869fc2909ad8f$var$_EventTarget$prototyp.addEventListener, $61b869fc2909ad8f$var$removeEventListener = $61b869fc2909ad8f$var$_EventTarget$prototyp.removeEventListener;
// Register event listeners to a key object
// listeners: array of listener definitions;
//   - each definition must be a flat array of event target and the arguments
//     used to call addEventListener() on the target
function $61b869fc2909ad8f$var$registerListeners(keyObj, listeners) {
    var registered = $61b869fc2909ad8f$var$listenerRegistry.get(keyObj);
    if (!registered) {
        registered = [];
        $61b869fc2909ad8f$var$listenerRegistry.set(keyObj, registered);
    }
    listeners.forEach(function(listener) {
        $61b869fc2909ad8f$var$addEventListener.call.apply($61b869fc2909ad8f$var$addEventListener, $61b869fc2909ad8f$var$_toConsumableArray(listener));
        registered.push(listener);
    });
}
function $61b869fc2909ad8f$var$unregisterListeners(keyObj) {
    var listeners = $61b869fc2909ad8f$var$listenerRegistry.get(keyObj);
    if (!listeners) return;
    listeners.forEach(function(listener) {
        $61b869fc2909ad8f$var$removeEventListener.call.apply($61b869fc2909ad8f$var$removeEventListener, $61b869fc2909ad8f$var$_toConsumableArray(listener));
    });
    $61b869fc2909ad8f$var$listenerRegistry["delete"](keyObj);
}
// Event.composedPath() polyfill for Edge
// based on https://gist.github.com/kleinfreund/e9787d73776c0e3750dcfcdc89f100ec
if (!Event.prototype.composedPath) {
    var $61b869fc2909ad8f$var$getComposedPath = function getComposedPath(node) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        path.push(node);
        var parent;
        if (node.parentNode) parent = node.parentNode;
        else if (node.host) // ShadowRoot
        parent = node.host;
        else if (node.defaultView) // Document
        parent = node.defaultView;
        return parent ? getComposedPath(parent, path) : path;
    };
    Event.prototype.composedPath = function() {
        return $61b869fc2909ad8f$var$getComposedPath(this.target);
    };
}
function $61b869fc2909ad8f$var$findFromPath(path, criteria, currentTarget) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var el = path[index];
    if (criteria(el)) return el;
    else if (el === currentTarget || !el.parentElement) // stop when reaching currentTarget or <html>
    return;
    return $61b869fc2909ad8f$var$findFromPath(path, criteria, currentTarget, index + 1);
}
// Search for the actual target of a delegated event
function $61b869fc2909ad8f$var$findElementInEventPath(ev, selector) {
    var criteria = typeof selector === 'function' ? selector : function(el) {
        return el.matches(selector);
    };
    return $61b869fc2909ad8f$var$findFromPath(ev.composedPath(), criteria, ev.currentTarget);
}
// default locales
var $61b869fc2909ad8f$var$locales = {
    en: {
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        daysShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        daysMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        today: "Today",
        clear: "Clear",
        titleFormat: "MM y"
    }
};
// config options updatable by setOptions() and their default values
var $61b869fc2909ad8f$var$defaultOptions = {
    autohide: false,
    beforeShowDay: null,
    beforeShowDecade: null,
    beforeShowMonth: null,
    beforeShowYear: null,
    calendarWeeks: false,
    clearBtn: false,
    dateDelimiter: ',',
    datesDisabled: [],
    daysOfWeekDisabled: [],
    daysOfWeekHighlighted: [],
    defaultViewDate: undefined,
    // placeholder, defaults to today() by the program
    disableTouchKeyboard: false,
    format: 'mm/dd/yyyy',
    language: 'en',
    maxDate: null,
    maxNumberOfDates: 1,
    maxView: 3,
    minDate: null,
    nextArrow: '<svg class="w-4 h-4 rtl:rotate-180 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/></svg>',
    orientation: 'auto',
    pickLevel: 0,
    prevArrow: '<svg class="w-4 h-4 rtl:rotate-180 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4"/></svg>',
    showDaysOfWeek: true,
    showOnClick: true,
    showOnFocus: true,
    startView: 0,
    title: '',
    todayBtn: false,
    todayBtnMode: 0,
    todayHighlight: false,
    updateOnBlur: true,
    weekStart: 0
};
var $61b869fc2909ad8f$var$range = null;
function $61b869fc2909ad8f$var$parseHTML(html) {
    if ($61b869fc2909ad8f$var$range == null) $61b869fc2909ad8f$var$range = document.createRange();
    return $61b869fc2909ad8f$var$range.createContextualFragment(html);
}
function $61b869fc2909ad8f$var$hideElement(el) {
    if (el.style.display === 'none') return;
    // back up the existing display setting in data-style-display
    if (el.style.display) el.dataset.styleDisplay = el.style.display;
    el.style.display = 'none';
}
function $61b869fc2909ad8f$var$showElement(el) {
    if (el.style.display !== 'none') return;
    if (el.dataset.styleDisplay) {
        // restore backed-up dispay property
        el.style.display = el.dataset.styleDisplay;
        delete el.dataset.styleDisplay;
    } else el.style.display = '';
}
function $61b869fc2909ad8f$var$emptyChildNodes(el) {
    if (el.firstChild) {
        el.removeChild(el.firstChild);
        $61b869fc2909ad8f$var$emptyChildNodes(el);
    }
}
function $61b869fc2909ad8f$var$replaceChildNodes(el, newChildNodes) {
    $61b869fc2909ad8f$var$emptyChildNodes(el);
    if (newChildNodes instanceof DocumentFragment) el.appendChild(newChildNodes);
    else if (typeof newChildNodes === 'string') el.appendChild($61b869fc2909ad8f$var$parseHTML(newChildNodes));
    else if (typeof newChildNodes.forEach === 'function') newChildNodes.forEach(function(node) {
        el.appendChild(node);
    });
}
var $61b869fc2909ad8f$var$defaultLang = $61b869fc2909ad8f$var$defaultOptions.language, $61b869fc2909ad8f$var$defaultFormat = $61b869fc2909ad8f$var$defaultOptions.format, $61b869fc2909ad8f$var$defaultWeekStart = $61b869fc2909ad8f$var$defaultOptions.weekStart;
// Reducer function to filter out invalid day-of-week from the input
function $61b869fc2909ad8f$var$sanitizeDOW(dow, day) {
    return dow.length < 6 && day >= 0 && day < 7 ? $61b869fc2909ad8f$var$pushUnique(dow, day) : dow;
}
function $61b869fc2909ad8f$var$calcEndOfWeek(startOfWeek) {
    return (startOfWeek + 6) % 7;
}
// validate input date. if invalid, fallback to the original value
function $61b869fc2909ad8f$var$validateDate(value, format, locale, origValue) {
    var date = $61b869fc2909ad8f$var$parseDate(value, format, locale);
    return date !== undefined ? date : origValue;
}
// Validate viewId. if invalid, fallback to the original value
function $61b869fc2909ad8f$var$validateViewId(value, origValue) {
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var viewId = parseInt(value, 10);
    return viewId >= 0 && viewId <= max ? viewId : origValue;
}
// Create Datepicker configuration to set
function $61b869fc2909ad8f$var$processOptions(options, datepicker) {
    var inOpts = Object.assign({}, options);
    var config = {};
    var locales = datepicker.constructor.locales;
    var _ref = datepicker.config || {}, format = _ref.format, language = _ref.language, locale = _ref.locale, maxDate = _ref.maxDate, maxView = _ref.maxView, minDate = _ref.minDate, pickLevel = _ref.pickLevel, startView = _ref.startView, weekStart = _ref.weekStart;
    if (inOpts.language) {
        var lang;
        if (inOpts.language !== language) {
            if (locales[inOpts.language]) lang = inOpts.language;
            else {
                // Check if langauge + region tag can fallback to the one without
                // region (e.g. fr-CA → fr)
                lang = inOpts.language.split('-')[0];
                if (locales[lang] === undefined) lang = false;
            }
        }
        delete inOpts.language;
        if (lang) {
            language = config.language = lang;
            // update locale as well when updating language
            var origLocale = locale || locales[$61b869fc2909ad8f$var$defaultLang];
            // use default language's properties for the fallback
            locale = Object.assign({
                format: $61b869fc2909ad8f$var$defaultFormat,
                weekStart: $61b869fc2909ad8f$var$defaultWeekStart
            }, locales[$61b869fc2909ad8f$var$defaultLang]);
            if (language !== $61b869fc2909ad8f$var$defaultLang) Object.assign(locale, locales[language]);
            config.locale = locale;
            // if format and/or weekStart are the same as old locale's defaults,
            // update them to new locale's defaults
            if (format === origLocale.format) format = config.format = locale.format;
            if (weekStart === origLocale.weekStart) {
                weekStart = config.weekStart = locale.weekStart;
                config.weekEnd = $61b869fc2909ad8f$var$calcEndOfWeek(locale.weekStart);
            }
        }
    }
    if (inOpts.format) {
        var hasToDisplay = typeof inOpts.format.toDisplay === 'function';
        var hasToValue = typeof inOpts.format.toValue === 'function';
        var validFormatString = $61b869fc2909ad8f$var$reFormatTokens.test(inOpts.format);
        if (hasToDisplay && hasToValue || validFormatString) format = config.format = inOpts.format;
        delete inOpts.format;
    }
    //*** dates ***//
    // while min and maxDate for "no limit" in the options are better to be null
    // (especially when updating), the ones in the config have to be undefined
    // because null is treated as 0 (= unix epoch) when comparing with time value
    var minDt = minDate;
    var maxDt = maxDate;
    if (inOpts.minDate !== undefined) {
        minDt = inOpts.minDate === null ? $61b869fc2909ad8f$var$dateValue(0, 0, 1) // set 0000-01-01 to prevent negative values for year
         : $61b869fc2909ad8f$var$validateDate(inOpts.minDate, format, locale, minDt);
        delete inOpts.minDate;
    }
    if (inOpts.maxDate !== undefined) {
        maxDt = inOpts.maxDate === null ? undefined : $61b869fc2909ad8f$var$validateDate(inOpts.maxDate, format, locale, maxDt);
        delete inOpts.maxDate;
    }
    if (maxDt < minDt) {
        minDate = config.minDate = maxDt;
        maxDate = config.maxDate = minDt;
    } else {
        if (minDate !== minDt) minDate = config.minDate = minDt;
        if (maxDate !== maxDt) maxDate = config.maxDate = maxDt;
    }
    if (inOpts.datesDisabled) {
        config.datesDisabled = inOpts.datesDisabled.reduce(function(dates, dt) {
            var date = $61b869fc2909ad8f$var$parseDate(dt, format, locale);
            return date !== undefined ? $61b869fc2909ad8f$var$pushUnique(dates, date) : dates;
        }, []);
        delete inOpts.datesDisabled;
    }
    if (inOpts.defaultViewDate !== undefined) {
        var viewDate = $61b869fc2909ad8f$var$parseDate(inOpts.defaultViewDate, format, locale);
        if (viewDate !== undefined) config.defaultViewDate = viewDate;
        delete inOpts.defaultViewDate;
    }
    //*** days of week ***//
    if (inOpts.weekStart !== undefined) {
        var wkStart = Number(inOpts.weekStart) % 7;
        if (!isNaN(wkStart)) {
            weekStart = config.weekStart = wkStart;
            config.weekEnd = $61b869fc2909ad8f$var$calcEndOfWeek(wkStart);
        }
        delete inOpts.weekStart;
    }
    if (inOpts.daysOfWeekDisabled) {
        config.daysOfWeekDisabled = inOpts.daysOfWeekDisabled.reduce($61b869fc2909ad8f$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekDisabled;
    }
    if (inOpts.daysOfWeekHighlighted) {
        config.daysOfWeekHighlighted = inOpts.daysOfWeekHighlighted.reduce($61b869fc2909ad8f$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekHighlighted;
    }
    //*** multi date ***//
    if (inOpts.maxNumberOfDates !== undefined) {
        var maxNumberOfDates = parseInt(inOpts.maxNumberOfDates, 10);
        if (maxNumberOfDates >= 0) {
            config.maxNumberOfDates = maxNumberOfDates;
            config.multidate = maxNumberOfDates !== 1;
        }
        delete inOpts.maxNumberOfDates;
    }
    if (inOpts.dateDelimiter) {
        config.dateDelimiter = String(inOpts.dateDelimiter);
        delete inOpts.dateDelimiter;
    }
    //*** pick level & view ***//
    var newPickLevel = pickLevel;
    if (inOpts.pickLevel !== undefined) {
        newPickLevel = $61b869fc2909ad8f$var$validateViewId(inOpts.pickLevel, 2);
        delete inOpts.pickLevel;
    }
    if (newPickLevel !== pickLevel) pickLevel = config.pickLevel = newPickLevel;
    var newMaxView = maxView;
    if (inOpts.maxView !== undefined) {
        newMaxView = $61b869fc2909ad8f$var$validateViewId(inOpts.maxView, maxView);
        delete inOpts.maxView;
    }
    // ensure max view >= pick level
    newMaxView = pickLevel > newMaxView ? pickLevel : newMaxView;
    if (newMaxView !== maxView) maxView = config.maxView = newMaxView;
    var newStartView = startView;
    if (inOpts.startView !== undefined) {
        newStartView = $61b869fc2909ad8f$var$validateViewId(inOpts.startView, newStartView);
        delete inOpts.startView;
    }
    // ensure pick level <= start view <= max view
    if (newStartView < pickLevel) newStartView = pickLevel;
    else if (newStartView > maxView) newStartView = maxView;
    if (newStartView !== startView) config.startView = newStartView;
    //*** template ***//
    if (inOpts.prevArrow) {
        var prevArrow = $61b869fc2909ad8f$var$parseHTML(inOpts.prevArrow);
        if (prevArrow.childNodes.length > 0) config.prevArrow = prevArrow.childNodes;
        delete inOpts.prevArrow;
    }
    if (inOpts.nextArrow) {
        var nextArrow = $61b869fc2909ad8f$var$parseHTML(inOpts.nextArrow);
        if (nextArrow.childNodes.length > 0) config.nextArrow = nextArrow.childNodes;
        delete inOpts.nextArrow;
    }
    //*** misc ***//
    if (inOpts.disableTouchKeyboard !== undefined) {
        config.disableTouchKeyboard = 'ontouchstart' in document && !!inOpts.disableTouchKeyboard;
        delete inOpts.disableTouchKeyboard;
    }
    if (inOpts.orientation) {
        var orientation = inOpts.orientation.toLowerCase().split(/\s+/g);
        config.orientation = {
            x: orientation.find(function(x) {
                return x === 'left' || x === 'right';
            }) || 'auto',
            y: orientation.find(function(y) {
                return y === 'top' || y === 'bottom';
            }) || 'auto'
        };
        delete inOpts.orientation;
    }
    if (inOpts.todayBtnMode !== undefined) {
        switch(inOpts.todayBtnMode){
            case 0:
            case 1:
                config.todayBtnMode = inOpts.todayBtnMode;
        }
        delete inOpts.todayBtnMode;
    }
    //*** copy the rest ***//
    Object.keys(inOpts).forEach(function(key) {
        if (inOpts[key] !== undefined && $61b869fc2909ad8f$var$hasProperty($61b869fc2909ad8f$var$defaultOptions, key)) config[key] = inOpts[key];
    });
    return config;
}
var $61b869fc2909ad8f$var$pickerTemplate = $61b869fc2909ad8f$var$optimizeTemplateHTML("<div class=\"datepicker hidden\">\n  <div class=\"datepicker-picker inline-block rounded-lg bg-white dark:bg-gray-700 shadow-lg p-4\">\n    <div class=\"datepicker-header\">\n      <div class=\"datepicker-title bg-white dark:bg-gray-700 dark:text-white px-2 py-3 text-center font-semibold\"></div>\n      <div class=\"datepicker-controls flex justify-between mb-2\">\n        <button type=\"button\" class=\"bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 prev-btn\"></button>\n        <button type=\"button\" class=\"text-sm rounded-lg text-gray-900 dark:text-white bg-white dark:bg-gray-700 font-semibold py-2.5 px-5 hover:bg-gray-100 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-200 view-switch\"></button>\n        <button type=\"button\" class=\"bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 next-btn\"></button>\n      </div>\n    </div>\n    <div class=\"datepicker-main p-1\"></div>\n    <div class=\"datepicker-footer\">\n      <div class=\"datepicker-controls flex space-x-2 rtl:space-x-reverse mt-2\">\n        <button type=\"button\" class=\"%buttonClass% today-btn text-white bg-blue-700 !bg-primary-700 dark:bg-blue-600 dark:!bg-primary-600 hover:bg-blue-800 hover:!bg-primary-800 dark:hover:bg-blue-700 dark:hover:!bg-primary-700 focus:ring-4 focus:ring-blue-300 focus:!ring-primary-300 font-medium rounded-lg text-sm px-5 py-2 text-center w-1/2\"></button>\n        <button type=\"button\" class=\"%buttonClass% clear-btn text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 focus:!ring-primary-300 font-medium rounded-lg text-sm px-5 py-2 text-center w-1/2\"></button>\n      </div>\n    </div>\n  </div>\n</div>");
var $61b869fc2909ad8f$var$daysTemplate = $61b869fc2909ad8f$var$optimizeTemplateHTML("<div class=\"days\">\n  <div class=\"days-of-week grid grid-cols-7 mb-1\">".concat($61b869fc2909ad8f$var$createTagRepeat('span', 7, {
    "class": 'dow block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm'
}), "</div>\n  <div class=\"datepicker-grid w-64 grid grid-cols-7\">").concat($61b869fc2909ad8f$var$createTagRepeat('span', 42, {
    "class": 'block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400'
}), "</div>\n</div>"));
var $61b869fc2909ad8f$var$calendarWeeksTemplate = $61b869fc2909ad8f$var$optimizeTemplateHTML("<div class=\"calendar-weeks\">\n  <div class=\"days-of-week flex\"><span class=\"dow h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400\"></span></div>\n  <div class=\"weeks\">".concat($61b869fc2909ad8f$var$createTagRepeat('span', 6, {
    "class": 'week block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm'
}), "</div>\n</div>"));
// Base class of the view classes
var $61b869fc2909ad8f$var$View = /*#__PURE__*/ function() {
    function View(picker, config) {
        $61b869fc2909ad8f$var$_classCallCheck(this, View);
        Object.assign(this, config, {
            picker: picker,
            element: $61b869fc2909ad8f$var$parseHTML("<div class=\"datepicker-view flex\"></div>").firstChild,
            selected: []
        });
        this.init(this.picker.datepicker.config);
    }
    return $61b869fc2909ad8f$var$_createClass(View, [
        {
            key: "init",
            value: function init(options) {
                if (options.pickLevel !== undefined) this.isMinView = this.id === options.pickLevel;
                this.setOptions(options);
                this.updateFocus();
                this.updateSelection();
            }
        },
        {
            key: "performBeforeHook",
            value: function performBeforeHook(el, current, timeValue) {
                var result = this.beforeShow(new Date(timeValue));
                switch($61b869fc2909ad8f$var$_typeof(result)){
                    case 'boolean':
                        result = {
                            enabled: result
                        };
                        break;
                    case 'string':
                        result = {
                            classes: result
                        };
                }
                if (result) {
                    if (result.enabled === false) {
                        el.classList.add('disabled');
                        $61b869fc2909ad8f$var$pushUnique(this.disabled, current);
                    }
                    if (result.classes) {
                        var _el$classList;
                        var extraClasses = result.classes.split(/\s+/);
                        (_el$classList = el.classList).add.apply(_el$classList, $61b869fc2909ad8f$var$_toConsumableArray(extraClasses));
                        if (extraClasses.includes('disabled')) $61b869fc2909ad8f$var$pushUnique(this.disabled, current);
                    }
                    if (result.content) $61b869fc2909ad8f$var$replaceChildNodes(el, result.content);
                }
            }
        }
    ]);
}();
var $61b869fc2909ad8f$var$DaysView = /*#__PURE__*/ function(_View) {
    function DaysView(picker) {
        $61b869fc2909ad8f$var$_classCallCheck(this, DaysView);
        return $61b869fc2909ad8f$var$_callSuper(this, DaysView, [
            picker,
            {
                id: 0,
                name: 'days',
                cellClass: 'day'
            }
        ]);
    }
    $61b869fc2909ad8f$var$_inherits(DaysView, _View);
    return $61b869fc2909ad8f$var$_createClass(DaysView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    var inner = $61b869fc2909ad8f$var$parseHTML($61b869fc2909ad8f$var$daysTemplate).firstChild;
                    this.dow = inner.firstChild;
                    this.grid = inner.lastChild;
                    this.element.appendChild(inner);
                }
                $61b869fc2909ad8f$var$_get($61b869fc2909ad8f$var$_getPrototypeOf(DaysView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _this = this;
                var updateDOW;
                if ($61b869fc2909ad8f$var$hasProperty(options, 'minDate')) this.minDate = options.minDate;
                if ($61b869fc2909ad8f$var$hasProperty(options, 'maxDate')) this.maxDate = options.maxDate;
                if (options.datesDisabled) this.datesDisabled = options.datesDisabled;
                if (options.daysOfWeekDisabled) {
                    this.daysOfWeekDisabled = options.daysOfWeekDisabled;
                    updateDOW = true;
                }
                if (options.daysOfWeekHighlighted) this.daysOfWeekHighlighted = options.daysOfWeekHighlighted;
                if (options.todayHighlight !== undefined) this.todayHighlight = options.todayHighlight;
                if (options.weekStart !== undefined) {
                    this.weekStart = options.weekStart;
                    this.weekEnd = options.weekEnd;
                    updateDOW = true;
                }
                if (options.locale) {
                    var locale = this.locale = options.locale;
                    this.dayNames = locale.daysMin;
                    this.switchLabelFormat = locale.titleFormat;
                    updateDOW = true;
                }
                if (options.beforeShowDay !== undefined) this.beforeShow = typeof options.beforeShowDay === 'function' ? options.beforeShowDay : undefined;
                if (options.calendarWeeks !== undefined) {
                    if (options.calendarWeeks && !this.calendarWeeks) {
                        var weeksElem = $61b869fc2909ad8f$var$parseHTML($61b869fc2909ad8f$var$calendarWeeksTemplate).firstChild;
                        this.calendarWeeks = {
                            element: weeksElem,
                            dow: weeksElem.firstChild,
                            weeks: weeksElem.lastChild
                        };
                        this.element.insertBefore(weeksElem, this.element.firstChild);
                    } else if (this.calendarWeeks && !options.calendarWeeks) {
                        this.element.removeChild(this.calendarWeeks.element);
                        this.calendarWeeks = null;
                    }
                }
                if (options.showDaysOfWeek !== undefined) {
                    if (options.showDaysOfWeek) {
                        $61b869fc2909ad8f$var$showElement(this.dow);
                        if (this.calendarWeeks) $61b869fc2909ad8f$var$showElement(this.calendarWeeks.dow);
                    } else {
                        $61b869fc2909ad8f$var$hideElement(this.dow);
                        if (this.calendarWeeks) $61b869fc2909ad8f$var$hideElement(this.calendarWeeks.dow);
                    }
                }
                // update days-of-week when locale, daysOfweekDisabled or weekStart is changed
                if (updateDOW) Array.from(this.dow.children).forEach(function(el, index) {
                    var dow = (_this.weekStart + index) % 7;
                    el.textContent = _this.dayNames[dow];
                    el.className = _this.daysOfWeekDisabled.includes(dow) ? 'dow disabled text-center h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400 cursor-not-allowed' : 'dow text-center h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400';
                });
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                var viewYear = viewDate.getFullYear();
                var viewMonth = viewDate.getMonth();
                var firstOfMonth = $61b869fc2909ad8f$var$dateValue(viewYear, viewMonth, 1);
                var start = $61b869fc2909ad8f$var$dayOfTheWeekOf(firstOfMonth, this.weekStart, this.weekStart);
                this.first = firstOfMonth;
                this.last = $61b869fc2909ad8f$var$dateValue(viewYear, viewMonth + 1, 0);
                this.start = start;
                this.focused = this.picker.viewDate;
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates;
                if (rangepicker) this.range = rangepicker.dates;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // update today marker on ever render
                this.today = this.todayHighlight ? $61b869fc2909ad8f$var$today() : undefined;
                // refresh disabled dates on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = $61b869fc2909ad8f$var$_toConsumableArray(this.datesDisabled);
                var switchLabel = $61b869fc2909ad8f$var$formatDate(this.focused, this.switchLabelFormat, this.locale);
                this.picker.setViewSwitchLabel(switchLabel);
                this.picker.setPrevBtnDisabled(this.first <= this.minDate);
                this.picker.setNextBtnDisabled(this.last >= this.maxDate);
                if (this.calendarWeeks) {
                    // start of the UTC week (Monday) of the 1st of the month
                    var startOfWeek = $61b869fc2909ad8f$var$dayOfTheWeekOf(this.first, 1, 1);
                    Array.from(this.calendarWeeks.weeks.children).forEach(function(el, index) {
                        el.textContent = $61b869fc2909ad8f$var$getWeek($61b869fc2909ad8f$var$addWeeks(startOfWeek, index));
                    });
                }
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var current = $61b869fc2909ad8f$var$addDays(_this2.start, index);
                    var date = new Date(current);
                    var day = date.getDay();
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this2.cellClass);
                    el.dataset.date = current;
                    el.textContent = date.getDate();
                    if (current < _this2.first) classList.add('prev', 'text-gray-500', 'dark:text-white');
                    else if (current > _this2.last) classList.add('next', 'text-gray-500', 'dark:text-white');
                    if (_this2.today === current) classList.add('today', 'bg-gray-100', 'dark:bg-gray-600');
                    if (current < _this2.minDate || current > _this2.maxDate || _this2.disabled.includes(current)) {
                        classList.add('disabled', 'cursor-not-allowed', 'text-gray-400', 'dark:text-gray-500');
                        classList.remove('hover:bg-gray-100', 'dark:hover:bg-gray-600', 'text-gray-900', 'dark:text-white', 'cursor-pointer');
                    }
                    if (_this2.daysOfWeekDisabled.includes(day)) {
                        classList.add('disabled', 'cursor-not-allowed', 'text-gray-400', 'dark:text-gray-500');
                        classList.remove('hover:bg-gray-100', 'dark:hover:bg-gray-600', 'text-gray-900', 'dark:text-white', 'cursor-pointer');
                        $61b869fc2909ad8f$var$pushUnique(_this2.disabled, current);
                    }
                    if (_this2.daysOfWeekHighlighted.includes(day)) classList.add('highlighted');
                    if (_this2.range) {
                        var _this2$range = $61b869fc2909ad8f$var$_slicedToArray(_this2.range, 2), rangeStart = _this2$range[0], rangeEnd = _this2$range[1];
                        if (current > rangeStart && current < rangeEnd) {
                            classList.add('range', 'bg-gray-200', 'dark:bg-gray-600');
                            classList.remove('rounded-lg', 'rounded-l-lg', 'rounded-r-lg');
                        }
                        if (current === rangeStart) {
                            classList.add('range-start', 'bg-gray-100', 'dark:bg-gray-600', 'rounded-l-lg');
                            classList.remove('rounded-lg', 'rounded-r-lg');
                        }
                        if (current === rangeEnd) {
                            classList.add('range-end', 'bg-gray-100', 'dark:bg-gray-600', 'rounded-r-lg');
                            classList.remove('rounded-lg', 'rounded-l-lg');
                        }
                    }
                    if (_this2.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'text-gray-500', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600', 'dark:bg-gray-600', 'bg-gray-100', 'bg-gray-200');
                    }
                    if (current === _this2.focused) classList.add('focused');
                    if (_this2.beforeShow) _this2.performBeforeHook(el, current, current);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var _ref = this.range || [], _ref2 = $61b869fc2909ad8f$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll('.range, .range-start, .range-end, .selected, .focused').forEach(function(el) {
                    el.classList.remove('range', 'range-start', 'range-end', 'selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white', 'focused');
                    el.classList.add('text-gray-900', 'rounded-lg', 'dark:text-white');
                });
                Array.from(this.grid.children).forEach(function(el) {
                    var current = Number(el.dataset.date);
                    var classList = el.classList;
                    classList.remove('bg-gray-200', 'dark:bg-gray-600', 'rounded-l-lg', 'rounded-r-lg');
                    if (current > rangeStart && current < rangeEnd) {
                        classList.add('range', 'bg-gray-200', 'dark:bg-gray-600');
                        classList.remove('rounded-lg');
                    }
                    if (current === rangeStart) {
                        classList.add('range-start', 'bg-gray-200', 'dark:bg-gray-600', 'rounded-l-lg');
                        classList.remove('rounded-lg');
                    }
                    if (current === rangeEnd) {
                        classList.add('range-end', 'bg-gray-200', 'dark:bg-gray-600', 'rounded-r-lg');
                        classList.remove('rounded-lg');
                    }
                    if (_this3.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600', 'bg-gray-100', 'bg-gray-200', 'dark:bg-gray-600');
                    }
                    if (current === _this3.focused) classList.add('focused');
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                var index = Math.round((this.focused - this.start) / 86400000);
                this.grid.querySelectorAll('.focused').forEach(function(el) {
                    el.classList.remove('focused');
                });
                this.grid.children[index].classList.add('focused');
            }
        }
    ]);
}($61b869fc2909ad8f$var$View);
function $61b869fc2909ad8f$var$computeMonthRange(range, thisYear) {
    if (!range || !range[0] || !range[1]) return;
    var _range = $61b869fc2909ad8f$var$_slicedToArray(range, 2), _range$ = $61b869fc2909ad8f$var$_slicedToArray(_range[0], 2), startY = _range$[0], startM = _range$[1], _range$2 = $61b869fc2909ad8f$var$_slicedToArray(_range[1], 2), endY = _range$2[0], endM = _range$2[1];
    if (startY > thisYear || endY < thisYear) return;
    return [
        startY === thisYear ? startM : -1,
        endY === thisYear ? endM : 12
    ];
}
var $61b869fc2909ad8f$var$MonthsView = /*#__PURE__*/ function(_View) {
    function MonthsView(picker) {
        $61b869fc2909ad8f$var$_classCallCheck(this, MonthsView);
        return $61b869fc2909ad8f$var$_callSuper(this, MonthsView, [
            picker,
            {
                id: 1,
                name: 'months',
                cellClass: 'month'
            }
        ]);
    }
    $61b869fc2909ad8f$var$_inherits(MonthsView, _View);
    return $61b869fc2909ad8f$var$_createClass(MonthsView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    this.grid = this.element;
                    this.element.classList.add('months', 'datepicker-grid', 'w-64', 'grid', 'grid-cols-4');
                    this.grid.appendChild($61b869fc2909ad8f$var$parseHTML($61b869fc2909ad8f$var$createTagRepeat('span', 12, {
                        'data-month': function dataMonth(ix) {
                            return ix;
                        }
                    })));
                }
                $61b869fc2909ad8f$var$_get($61b869fc2909ad8f$var$_getPrototypeOf(MonthsView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options.locale) this.monthNames = options.locale.monthsShort;
                if ($61b869fc2909ad8f$var$hasProperty(options, 'minDate')) {
                    if (options.minDate === undefined) this.minYear = this.minMonth = this.minDate = undefined;
                    else {
                        var minDateObj = new Date(options.minDate);
                        this.minYear = minDateObj.getFullYear();
                        this.minMonth = minDateObj.getMonth();
                        this.minDate = minDateObj.setDate(1);
                    }
                }
                if ($61b869fc2909ad8f$var$hasProperty(options, 'maxDate')) {
                    if (options.maxDate === undefined) this.maxYear = this.maxMonth = this.maxDate = undefined;
                    else {
                        var maxDateObj = new Date(options.maxDate);
                        this.maxYear = maxDateObj.getFullYear();
                        this.maxMonth = maxDateObj.getMonth();
                        this.maxDate = $61b869fc2909ad8f$var$dateValue(this.maxYear, this.maxMonth + 1, 0);
                    }
                }
                if (options.beforeShowMonth !== undefined) this.beforeShow = typeof options.beforeShowMonth === 'function' ? options.beforeShowMonth : undefined;
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                this.year = viewDate.getFullYear();
                this.focused = viewDate.getMonth();
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates.reduce(function(selected, timeValue) {
                    var date = new Date(timeValue);
                    var year = date.getFullYear();
                    var month = date.getMonth();
                    if (selected[year] === undefined) selected[year] = [
                        month
                    ];
                    else $61b869fc2909ad8f$var$pushUnique(selected[year], month);
                    return selected;
                }, {});
                if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map(function(timeValue) {
                    var date = new Date(timeValue);
                    return isNaN(date) ? undefined : [
                        date.getFullYear(),
                        date.getMonth()
                    ];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                // refresh disabled months on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = [];
                this.picker.setViewSwitchLabel(this.year);
                this.picker.setPrevBtnDisabled(this.year <= this.minYear);
                this.picker.setNextBtnDisabled(this.year >= this.maxYear);
                var selected = this.selected[this.year] || [];
                var yrOutOfRange = this.year < this.minYear || this.year > this.maxYear;
                var isMinYear = this.year === this.minYear;
                var isMaxYear = this.year === this.maxYear;
                var range = $61b869fc2909ad8f$var$computeMonthRange(this.range, this.year);
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var date = $61b869fc2909ad8f$var$dateValue(_this.year, index, 1);
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this.cellClass);
                    if (_this.isMinView) el.dataset.date = date;
                    // reset text on every render to clear the custom content set
                    // by beforeShow hook at previous render
                    el.textContent = _this.monthNames[index];
                    if (yrOutOfRange || isMinYear && index < _this.minMonth || isMaxYear && index > _this.maxMonth) classList.add('disabled');
                    if (range) {
                        var _range2 = $61b869fc2909ad8f$var$_slicedToArray(range, 2), rangeStart = _range2[0], rangeEnd = _range2[1];
                        if (index > rangeStart && index < rangeEnd) classList.add('range');
                        if (index === rangeStart) classList.add('range-start');
                        if (index === rangeEnd) classList.add('range-end');
                    }
                    if (selected.includes(index)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (index === _this.focused) classList.add('focused');
                    if (_this.beforeShow) _this.performBeforeHook(el, index, date);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this2 = this;
                var selected = this.selected[this.year] || [];
                var _ref = $61b869fc2909ad8f$var$computeMonthRange(this.range, this.year) || [], _ref2 = $61b869fc2909ad8f$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll('.range, .range-start, .range-end, .selected, .focused').forEach(function(el) {
                    el.classList.remove('range', 'range-start', 'range-end', 'selected', 'bg-blue-700', '!bg-primary-700', 'dark:bg-blue-600', 'dark:!bg-primary-700', 'dark:text-white', 'text-white', 'focused');
                    el.classList.add('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                });
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    if (index > rangeStart && index < rangeEnd) classList.add('range');
                    if (index === rangeStart) classList.add('range-start');
                    if (index === rangeEnd) classList.add('range-end');
                    if (selected.includes(index)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (index === _this2.focused) classList.add('focused');
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                this.grid.querySelectorAll('.focused').forEach(function(el) {
                    el.classList.remove('focused');
                });
                this.grid.children[this.focused].classList.add('focused');
            }
        }
    ]);
}($61b869fc2909ad8f$var$View);
function $61b869fc2909ad8f$var$toTitleCase(word) {
    return $61b869fc2909ad8f$var$_toConsumableArray(word).reduce(function(str, ch, ix) {
        return str += ix ? ch : ch.toUpperCase();
    }, '');
}
// Class representing the years and decades view elements
var $61b869fc2909ad8f$var$YearsView = /*#__PURE__*/ function(_View) {
    function YearsView(picker, config) {
        $61b869fc2909ad8f$var$_classCallCheck(this, YearsView);
        return $61b869fc2909ad8f$var$_callSuper(this, YearsView, [
            picker,
            config
        ]);
    }
    $61b869fc2909ad8f$var$_inherits(YearsView, _View);
    return $61b869fc2909ad8f$var$_createClass(YearsView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    this.navStep = this.step * 10;
                    this.beforeShowOption = "beforeShow".concat($61b869fc2909ad8f$var$toTitleCase(this.cellClass));
                    this.grid = this.element;
                    this.element.classList.add(this.name, 'datepicker-grid', 'w-64', 'grid', 'grid-cols-4');
                    this.grid.appendChild($61b869fc2909ad8f$var$parseHTML($61b869fc2909ad8f$var$createTagRepeat('span', 12)));
                }
                $61b869fc2909ad8f$var$_get($61b869fc2909ad8f$var$_getPrototypeOf(YearsView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if ($61b869fc2909ad8f$var$hasProperty(options, 'minDate')) {
                    if (options.minDate === undefined) this.minYear = this.minDate = undefined;
                    else {
                        this.minYear = $61b869fc2909ad8f$var$startOfYearPeriod(options.minDate, this.step);
                        this.minDate = $61b869fc2909ad8f$var$dateValue(this.minYear, 0, 1);
                    }
                }
                if ($61b869fc2909ad8f$var$hasProperty(options, 'maxDate')) {
                    if (options.maxDate === undefined) this.maxYear = this.maxDate = undefined;
                    else {
                        this.maxYear = $61b869fc2909ad8f$var$startOfYearPeriod(options.maxDate, this.step);
                        this.maxDate = $61b869fc2909ad8f$var$dateValue(this.maxYear, 11, 31);
                    }
                }
                if (options[this.beforeShowOption] !== undefined) {
                    var beforeShow = options[this.beforeShowOption];
                    this.beforeShow = typeof beforeShow === 'function' ? beforeShow : undefined;
                }
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                var first = $61b869fc2909ad8f$var$startOfYearPeriod(viewDate, this.navStep);
                var last = first + 9 * this.step;
                this.first = first;
                this.last = last;
                this.start = first - this.step;
                this.focused = $61b869fc2909ad8f$var$startOfYearPeriod(viewDate, this.step);
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this = this;
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates.reduce(function(years, timeValue) {
                    return $61b869fc2909ad8f$var$pushUnique(years, $61b869fc2909ad8f$var$startOfYearPeriod(timeValue, _this.step));
                }, []);
                if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map(function(timeValue) {
                    if (timeValue !== undefined) return $61b869fc2909ad8f$var$startOfYearPeriod(timeValue, _this.step);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // refresh disabled years on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = [];
                this.picker.setViewSwitchLabel("".concat(this.first, "-").concat(this.last));
                this.picker.setPrevBtnDisabled(this.first <= this.minYear);
                this.picker.setNextBtnDisabled(this.last >= this.maxYear);
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var current = _this2.start + index * _this2.step;
                    var date = $61b869fc2909ad8f$var$dateValue(current, 0, 1);
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this2.cellClass);
                    if (_this2.isMinView) el.dataset.date = date;
                    el.textContent = el.dataset.year = current;
                    if (index === 0) classList.add('prev');
                    else if (index === 11) classList.add('next');
                    if (current < _this2.minYear || current > _this2.maxYear) classList.add('disabled');
                    if (_this2.range) {
                        var _this2$range = $61b869fc2909ad8f$var$_slicedToArray(_this2.range, 2), rangeStart = _this2$range[0], rangeEnd = _this2$range[1];
                        if (current > rangeStart && current < rangeEnd) classList.add('range');
                        if (current === rangeStart) classList.add('range-start');
                        if (current === rangeEnd) classList.add('range-end');
                    }
                    if (_this2.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (current === _this2.focused) classList.add('focused');
                    if (_this2.beforeShow) _this2.performBeforeHook(el, current, date);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var _ref = this.range || [], _ref2 = $61b869fc2909ad8f$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll('.range, .range-start, .range-end, .selected, .focused').forEach(function(el) {
                    el.classList.remove('range', 'range-start', 'range-end', 'selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark!bg-primary-600', 'dark:text-white', 'focused');
                });
                Array.from(this.grid.children).forEach(function(el) {
                    var current = Number(el.textContent);
                    var classList = el.classList;
                    if (current > rangeStart && current < rangeEnd) classList.add('range');
                    if (current === rangeStart) classList.add('range-start');
                    if (current === rangeEnd) classList.add('range-end');
                    if (_this3.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (current === _this3.focused) classList.add('focused');
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                var index = Math.round((this.focused - this.start) / this.step);
                this.grid.querySelectorAll('.focused').forEach(function(el) {
                    el.classList.remove('focused');
                });
                this.grid.children[index].classList.add('focused');
            }
        }
    ]);
}($61b869fc2909ad8f$var$View);
function $61b869fc2909ad8f$var$triggerDatepickerEvent(datepicker, type) {
    var detail = {
        date: datepicker.getDate(),
        viewDate: new Date(datepicker.picker.viewDate),
        viewId: datepicker.picker.currentView.id,
        datepicker: datepicker
    };
    datepicker.element.dispatchEvent(new CustomEvent(type, {
        detail: detail
    }));
}
// direction: -1 (to previous), 1 (to next)
function $61b869fc2909ad8f$var$goToPrevOrNext(datepicker, direction) {
    var _datepicker$config = datepicker.config, minDate = _datepicker$config.minDate, maxDate = _datepicker$config.maxDate;
    var _datepicker$picker = datepicker.picker, currentView = _datepicker$picker.currentView, viewDate = _datepicker$picker.viewDate;
    var newViewDate;
    switch(currentView.id){
        case 0:
            newViewDate = $61b869fc2909ad8f$var$addMonths(viewDate, direction);
            break;
        case 1:
            newViewDate = $61b869fc2909ad8f$var$addYears(viewDate, direction);
            break;
        default:
            newViewDate = $61b869fc2909ad8f$var$addYears(viewDate, direction * currentView.navStep);
    }
    newViewDate = $61b869fc2909ad8f$var$limitToRange(newViewDate, minDate, maxDate);
    datepicker.picker.changeFocus(newViewDate).render();
}
function $61b869fc2909ad8f$var$switchView(datepicker) {
    var viewId = datepicker.picker.currentView.id;
    if (viewId === datepicker.config.maxView) return;
    datepicker.picker.changeView(viewId + 1).render();
}
function $61b869fc2909ad8f$var$unfocus(datepicker) {
    if (datepicker.config.updateOnBlur) datepicker.update({
        autohide: true
    });
    else {
        datepicker.refresh('input');
        datepicker.hide();
    }
}
function $61b869fc2909ad8f$var$goToSelectedMonthOrYear(datepicker, selection) {
    var picker = datepicker.picker;
    var viewDate = new Date(picker.viewDate);
    var viewId = picker.currentView.id;
    var newDate = viewId === 1 ? $61b869fc2909ad8f$var$addMonths(viewDate, selection - viewDate.getMonth()) : $61b869fc2909ad8f$var$addYears(viewDate, selection - viewDate.getFullYear());
    picker.changeFocus(newDate).changeView(viewId - 1).render();
}
function $61b869fc2909ad8f$var$onClickTodayBtn(datepicker) {
    var picker = datepicker.picker;
    var currentDate = $61b869fc2909ad8f$var$today();
    if (datepicker.config.todayBtnMode === 1) {
        if (datepicker.config.autohide) {
            datepicker.setDate(currentDate);
            return;
        }
        datepicker.setDate(currentDate, {
            render: false
        });
        picker.update();
    }
    if (picker.viewDate !== currentDate) picker.changeFocus(currentDate);
    picker.changeView(0).render();
}
function $61b869fc2909ad8f$var$onClickClearBtn(datepicker) {
    datepicker.setDate({
        clear: true
    });
}
function $61b869fc2909ad8f$var$onClickViewSwitch(datepicker) {
    $61b869fc2909ad8f$var$switchView(datepicker);
}
function $61b869fc2909ad8f$var$onClickPrevBtn(datepicker) {
    $61b869fc2909ad8f$var$goToPrevOrNext(datepicker, -1);
}
function $61b869fc2909ad8f$var$onClickNextBtn(datepicker) {
    $61b869fc2909ad8f$var$goToPrevOrNext(datepicker, 1);
}
// For the picker's main block to delegete the events from `datepicker-cell`s
function $61b869fc2909ad8f$var$onClickView(datepicker, ev) {
    var target = $61b869fc2909ad8f$var$findElementInEventPath(ev, '.datepicker-cell');
    if (!target || target.classList.contains('disabled')) return;
    var _datepicker$picker$cu = datepicker.picker.currentView, id = _datepicker$picker$cu.id, isMinView = _datepicker$picker$cu.isMinView;
    if (isMinView) datepicker.setDate(Number(target.dataset.date));
    else if (id === 1) $61b869fc2909ad8f$var$goToSelectedMonthOrYear(datepicker, Number(target.dataset.month));
    else $61b869fc2909ad8f$var$goToSelectedMonthOrYear(datepicker, Number(target.dataset.year));
}
function $61b869fc2909ad8f$var$onClickPicker(datepicker) {
    if (!datepicker.inline && !datepicker.config.disableTouchKeyboard) datepicker.inputField.focus();
}
function $61b869fc2909ad8f$var$processPickerOptions(picker, options) {
    if (options.title !== undefined) {
        if (options.title) {
            picker.controls.title.textContent = options.title;
            $61b869fc2909ad8f$var$showElement(picker.controls.title);
        } else {
            picker.controls.title.textContent = '';
            $61b869fc2909ad8f$var$hideElement(picker.controls.title);
        }
    }
    if (options.prevArrow) {
        var prevBtn = picker.controls.prevBtn;
        $61b869fc2909ad8f$var$emptyChildNodes(prevBtn);
        options.prevArrow.forEach(function(node) {
            prevBtn.appendChild(node.cloneNode(true));
        });
    }
    if (options.nextArrow) {
        var nextBtn = picker.controls.nextBtn;
        $61b869fc2909ad8f$var$emptyChildNodes(nextBtn);
        options.nextArrow.forEach(function(node) {
            nextBtn.appendChild(node.cloneNode(true));
        });
    }
    if (options.locale) {
        picker.controls.todayBtn.textContent = options.locale.today;
        picker.controls.clearBtn.textContent = options.locale.clear;
    }
    if (options.todayBtn !== undefined) {
        if (options.todayBtn) $61b869fc2909ad8f$var$showElement(picker.controls.todayBtn);
        else $61b869fc2909ad8f$var$hideElement(picker.controls.todayBtn);
    }
    if ($61b869fc2909ad8f$var$hasProperty(options, 'minDate') || $61b869fc2909ad8f$var$hasProperty(options, 'maxDate')) {
        var _picker$datepicker$co = picker.datepicker.config, minDate = _picker$datepicker$co.minDate, maxDate = _picker$datepicker$co.maxDate;
        picker.controls.todayBtn.disabled = !$61b869fc2909ad8f$var$isInRange($61b869fc2909ad8f$var$today(), minDate, maxDate);
    }
    if (options.clearBtn !== undefined) {
        if (options.clearBtn) $61b869fc2909ad8f$var$showElement(picker.controls.clearBtn);
        else $61b869fc2909ad8f$var$hideElement(picker.controls.clearBtn);
    }
}
// Compute view date to reset, which will be...
// - the last item of the selected dates or defaultViewDate if no selection
// - limitted to minDate or maxDate if it exceeds the range
function $61b869fc2909ad8f$var$computeResetViewDate(datepicker) {
    var dates = datepicker.dates, config = datepicker.config;
    var viewDate = dates.length > 0 ? $61b869fc2909ad8f$var$lastItemOf(dates) : config.defaultViewDate;
    return $61b869fc2909ad8f$var$limitToRange(viewDate, config.minDate, config.maxDate);
}
// Change current view's view date
function $61b869fc2909ad8f$var$setViewDate(picker, newDate) {
    var oldViewDate = new Date(picker.viewDate);
    var newViewDate = new Date(newDate);
    var _picker$currentView = picker.currentView, id = _picker$currentView.id, year = _picker$currentView.year, first = _picker$currentView.first, last = _picker$currentView.last;
    var viewYear = newViewDate.getFullYear();
    picker.viewDate = newDate;
    if (viewYear !== oldViewDate.getFullYear()) $61b869fc2909ad8f$var$triggerDatepickerEvent(picker.datepicker, 'changeYear');
    if (newViewDate.getMonth() !== oldViewDate.getMonth()) $61b869fc2909ad8f$var$triggerDatepickerEvent(picker.datepicker, 'changeMonth');
    // return whether the new date is in different period on time from the one
    // displayed in the current view
    // when true, the view needs to be re-rendered on the next UI refresh.
    switch(id){
        case 0:
            return newDate < first || newDate > last;
        case 1:
            return viewYear !== year;
        default:
            return viewYear < first || viewYear > last;
    }
}
function $61b869fc2909ad8f$var$getTextDirection(el) {
    return window.getComputedStyle(el).direction;
}
// Class representing the picker UI
var $61b869fc2909ad8f$var$Picker = /*#__PURE__*/ function() {
    function Picker(datepicker) {
        $61b869fc2909ad8f$var$_classCallCheck(this, Picker);
        this.datepicker = datepicker;
        var template = $61b869fc2909ad8f$var$pickerTemplate.replace(/%buttonClass%/g, datepicker.config.buttonClass);
        var element = this.element = $61b869fc2909ad8f$var$parseHTML(template).firstChild;
        var _element$firstChild$c = $61b869fc2909ad8f$var$_slicedToArray(element.firstChild.children, 3), header = _element$firstChild$c[0], main = _element$firstChild$c[1], footer = _element$firstChild$c[2];
        var title = header.firstElementChild;
        var _header$lastElementCh = $61b869fc2909ad8f$var$_slicedToArray(header.lastElementChild.children, 3), prevBtn = _header$lastElementCh[0], viewSwitch = _header$lastElementCh[1], nextBtn = _header$lastElementCh[2];
        var _footer$firstChild$ch = $61b869fc2909ad8f$var$_slicedToArray(footer.firstChild.children, 2), todayBtn = _footer$firstChild$ch[0], clearBtn = _footer$firstChild$ch[1];
        var controls = {
            title: title,
            prevBtn: prevBtn,
            viewSwitch: viewSwitch,
            nextBtn: nextBtn,
            todayBtn: todayBtn,
            clearBtn: clearBtn
        };
        this.main = main;
        this.controls = controls;
        var elementClass = datepicker.inline ? 'inline' : 'dropdown';
        element.classList.add("datepicker-".concat(elementClass));
        elementClass === 'dropdown' && element.classList.add('dropdown', 'absolute', 'top-0', 'left-0', 'z-50', 'pt-2');
        $61b869fc2909ad8f$var$processPickerOptions(this, datepicker.config);
        this.viewDate = $61b869fc2909ad8f$var$computeResetViewDate(datepicker);
        // set up event listeners
        $61b869fc2909ad8f$var$registerListeners(datepicker, [
            [
                element,
                'click',
                $61b869fc2909ad8f$var$onClickPicker.bind(null, datepicker),
                {
                    capture: true
                }
            ],
            [
                main,
                'click',
                $61b869fc2909ad8f$var$onClickView.bind(null, datepicker)
            ],
            [
                controls.viewSwitch,
                'click',
                $61b869fc2909ad8f$var$onClickViewSwitch.bind(null, datepicker)
            ],
            [
                controls.prevBtn,
                'click',
                $61b869fc2909ad8f$var$onClickPrevBtn.bind(null, datepicker)
            ],
            [
                controls.nextBtn,
                'click',
                $61b869fc2909ad8f$var$onClickNextBtn.bind(null, datepicker)
            ],
            [
                controls.todayBtn,
                'click',
                $61b869fc2909ad8f$var$onClickTodayBtn.bind(null, datepicker)
            ],
            [
                controls.clearBtn,
                'click',
                $61b869fc2909ad8f$var$onClickClearBtn.bind(null, datepicker)
            ]
        ]);
        // set up views
        this.views = [
            new $61b869fc2909ad8f$var$DaysView(this),
            new $61b869fc2909ad8f$var$MonthsView(this),
            new $61b869fc2909ad8f$var$YearsView(this, {
                id: 2,
                name: 'years',
                cellClass: 'year',
                step: 1
            }),
            new $61b869fc2909ad8f$var$YearsView(this, {
                id: 3,
                name: 'decades',
                cellClass: 'decade',
                step: 10
            })
        ];
        this.currentView = this.views[datepicker.config.startView];
        this.currentView.render();
        this.main.appendChild(this.currentView.element);
        datepicker.config.container.appendChild(this.element);
    }
    return $61b869fc2909ad8f$var$_createClass(Picker, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                $61b869fc2909ad8f$var$processPickerOptions(this, options);
                this.views.forEach(function(view) {
                    view.init(options, false);
                });
                this.currentView.render();
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.datepicker.config.container.removeChild(this.element);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.active) return;
                this.element.classList.add('active', 'block');
                this.element.classList.remove('hidden');
                this.active = true;
                var datepicker = this.datepicker;
                if (!datepicker.inline) {
                    // ensure picker's direction matches input's
                    var inputDirection = $61b869fc2909ad8f$var$getTextDirection(datepicker.inputField);
                    if (inputDirection !== $61b869fc2909ad8f$var$getTextDirection(datepicker.config.container)) this.element.dir = inputDirection;
                    else if (this.element.dir) this.element.removeAttribute('dir');
                    this.place();
                    if (datepicker.config.disableTouchKeyboard) datepicker.inputField.blur();
                }
                $61b869fc2909ad8f$var$triggerDatepickerEvent(datepicker, 'show');
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (!this.active) return;
                this.datepicker.exitEditMode();
                this.element.classList.remove('active', 'block');
                this.element.classList.add('active', 'block', 'hidden');
                this.active = false;
                $61b869fc2909ad8f$var$triggerDatepickerEvent(this.datepicker, 'hide');
            }
        },
        {
            key: "place",
            value: function place() {
                var _this$element = this.element, classList = _this$element.classList, style = _this$element.style;
                var _this$datepicker = this.datepicker, config = _this$datepicker.config, inputField = _this$datepicker.inputField;
                var container = config.container;
                var _this$element$getBoun = this.element.getBoundingClientRect(), calendarWidth = _this$element$getBoun.width, calendarHeight = _this$element$getBoun.height;
                var _container$getBoundin = container.getBoundingClientRect(), containerLeft = _container$getBoundin.left, containerTop = _container$getBoundin.top, containerWidth = _container$getBoundin.width;
                var _inputField$getBoundi = inputField.getBoundingClientRect(), inputLeft = _inputField$getBoundi.left, inputTop = _inputField$getBoundi.top, inputWidth = _inputField$getBoundi.width, inputHeight = _inputField$getBoundi.height;
                var _config$orientation = config.orientation, orientX = _config$orientation.x, orientY = _config$orientation.y;
                var scrollTop;
                var left;
                var top;
                if (container === document.body) {
                    scrollTop = window.scrollY;
                    left = inputLeft + window.scrollX;
                    top = inputTop + scrollTop;
                } else {
                    scrollTop = container.scrollTop;
                    left = inputLeft - containerLeft;
                    top = inputTop - containerTop + scrollTop;
                }
                if (orientX === 'auto') {
                    if (left < 0) {
                        // align to the left and move into visible area if input's left edge < window's
                        orientX = 'left';
                        left = 10;
                    } else if (left + calendarWidth > containerWidth) // align to the right if canlendar's right edge > container's
                    orientX = 'right';
                    else orientX = $61b869fc2909ad8f$var$getTextDirection(inputField) === 'rtl' ? 'right' : 'left';
                }
                if (orientX === 'right') left -= calendarWidth - inputWidth;
                if (orientY === 'auto') orientY = top - calendarHeight < scrollTop ? 'bottom' : 'top';
                if (orientY === 'top') top -= calendarHeight;
                else top += inputHeight;
                classList.remove('datepicker-orient-top', 'datepicker-orient-bottom', 'datepicker-orient-right', 'datepicker-orient-left');
                classList.add("datepicker-orient-".concat(orientY), "datepicker-orient-".concat(orientX));
                style.top = top ? "".concat(top, "px") : top;
                style.left = left ? "".concat(left, "px") : left;
            }
        },
        {
            key: "setViewSwitchLabel",
            value: function setViewSwitchLabel(labelText) {
                this.controls.viewSwitch.textContent = labelText;
            }
        },
        {
            key: "setPrevBtnDisabled",
            value: function setPrevBtnDisabled(disabled) {
                this.controls.prevBtn.disabled = disabled;
            }
        },
        {
            key: "setNextBtnDisabled",
            value: function setNextBtnDisabled(disabled) {
                this.controls.nextBtn.disabled = disabled;
            }
        },
        {
            key: "changeView",
            value: function changeView(viewId) {
                var oldView = this.currentView;
                var newView = this.views[viewId];
                if (newView.id !== oldView.id) {
                    this.currentView = newView;
                    this._renderMethod = 'render';
                    $61b869fc2909ad8f$var$triggerDatepickerEvent(this.datepicker, 'changeView');
                    this.main.replaceChild(newView.element, oldView.element);
                }
                return this;
            }
        },
        {
            key: "changeFocus",
            value: function changeFocus(newViewDate) {
                this._renderMethod = $61b869fc2909ad8f$var$setViewDate(this, newViewDate) ? 'render' : 'refreshFocus';
                this.views.forEach(function(view) {
                    view.updateFocus();
                });
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var newViewDate = $61b869fc2909ad8f$var$computeResetViewDate(this.datepicker);
                this._renderMethod = $61b869fc2909ad8f$var$setViewDate(this, newViewDate) ? 'render' : 'refresh';
                this.views.forEach(function(view) {
                    view.updateFocus();
                    view.updateSelection();
                });
                return this;
            }
        },
        {
            key: "render",
            value: function render() {
                var quickRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var renderMethod = quickRender && this._renderMethod || 'render';
                delete this._renderMethod;
                this.currentView[renderMethod]();
            }
        }
    ]);
}();
// Find the closest date that doesn't meet the condition for unavailable date
// Returns undefined if no available date is found
// addFn: function to calculate the next date
//   - args: time value, amount
// increase: amount to pass to addFn
// testFn: function to test the unavailablity of the date
//   - args: time value; retun: true if unavailable
function $61b869fc2909ad8f$var$findNextAvailableOne(date, addFn, increase, testFn, min, max) {
    if (!$61b869fc2909ad8f$var$isInRange(date, min, max)) return;
    if (testFn(date)) {
        var newDate = addFn(date, increase);
        return $61b869fc2909ad8f$var$findNextAvailableOne(newDate, addFn, increase, testFn, min, max);
    }
    return date;
}
// direction: -1 (left/up), 1 (right/down)
// vertical: true for up/down, false for left/right
function $61b869fc2909ad8f$var$moveByArrowKey(datepicker, ev, direction, vertical) {
    var picker = datepicker.picker;
    var currentView = picker.currentView;
    var step = currentView.step || 1;
    var viewDate = picker.viewDate;
    var addFn;
    var testFn;
    switch(currentView.id){
        case 0:
            if (vertical) viewDate = $61b869fc2909ad8f$var$addDays(viewDate, direction * 7);
            else if (ev.ctrlKey || ev.metaKey) viewDate = $61b869fc2909ad8f$var$addYears(viewDate, direction);
            else viewDate = $61b869fc2909ad8f$var$addDays(viewDate, direction);
            addFn = $61b869fc2909ad8f$var$addDays;
            testFn = function testFn(date) {
                return currentView.disabled.includes(date);
            };
            break;
        case 1:
            viewDate = $61b869fc2909ad8f$var$addMonths(viewDate, vertical ? direction * 4 : direction);
            addFn = $61b869fc2909ad8f$var$addMonths;
            testFn = function testFn(date) {
                var dt = new Date(date);
                var year = currentView.year, disabled = currentView.disabled;
                return dt.getFullYear() === year && disabled.includes(dt.getMonth());
            };
            break;
        default:
            viewDate = $61b869fc2909ad8f$var$addYears(viewDate, direction * (vertical ? 4 : 1) * step);
            addFn = $61b869fc2909ad8f$var$addYears;
            testFn = function testFn(date) {
                return currentView.disabled.includes($61b869fc2909ad8f$var$startOfYearPeriod(date, step));
            };
    }
    viewDate = $61b869fc2909ad8f$var$findNextAvailableOne(viewDate, addFn, direction < 0 ? -step : step, testFn, currentView.minDate, currentView.maxDate);
    if (viewDate !== undefined) picker.changeFocus(viewDate).render();
}
function $61b869fc2909ad8f$var$onKeydown(datepicker, ev) {
    if (ev.key === 'Tab') {
        $61b869fc2909ad8f$var$unfocus(datepicker);
        return;
    }
    var picker = datepicker.picker;
    var _picker$currentView = picker.currentView, id = _picker$currentView.id, isMinView = _picker$currentView.isMinView;
    if (!picker.active) switch(ev.key){
        case 'ArrowDown':
        case 'Escape':
            picker.show();
            break;
        case 'Enter':
            datepicker.update();
            break;
        default:
            return;
    }
    else if (datepicker.editMode) switch(ev.key){
        case 'Escape':
            picker.hide();
            break;
        case 'Enter':
            datepicker.exitEditMode({
                update: true,
                autohide: datepicker.config.autohide
            });
            break;
        default:
            return;
    }
    else switch(ev.key){
        case 'Escape':
            picker.hide();
            break;
        case 'ArrowLeft':
            if (ev.ctrlKey || ev.metaKey) $61b869fc2909ad8f$var$goToPrevOrNext(datepicker, -1);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $61b869fc2909ad8f$var$moveByArrowKey(datepicker, ev, -1, false);
            break;
        case 'ArrowRight':
            if (ev.ctrlKey || ev.metaKey) $61b869fc2909ad8f$var$goToPrevOrNext(datepicker, 1);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $61b869fc2909ad8f$var$moveByArrowKey(datepicker, ev, 1, false);
            break;
        case 'ArrowUp':
            if (ev.ctrlKey || ev.metaKey) $61b869fc2909ad8f$var$switchView(datepicker);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $61b869fc2909ad8f$var$moveByArrowKey(datepicker, ev, -1, true);
            break;
        case 'ArrowDown':
            if (ev.shiftKey && !ev.ctrlKey && !ev.metaKey) {
                datepicker.enterEditMode();
                return;
            }
            $61b869fc2909ad8f$var$moveByArrowKey(datepicker, ev, 1, true);
            break;
        case 'Enter':
            if (isMinView) datepicker.setDate(picker.viewDate);
            else picker.changeView(id - 1).render();
            break;
        case 'Backspace':
        case 'Delete':
            datepicker.enterEditMode();
            return;
        default:
            if (ev.key.length === 1 && !ev.ctrlKey && !ev.metaKey) datepicker.enterEditMode();
            return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
function $61b869fc2909ad8f$var$onFocus(datepicker) {
    if (datepicker.config.showOnFocus && !datepicker._showing) datepicker.show();
}
// for the prevention for entering edit mode while getting focus on click
function $61b869fc2909ad8f$var$onMousedown(datepicker, ev) {
    var el = ev.target;
    if (datepicker.picker.active || datepicker.config.showOnClick) {
        el._active = el === document.activeElement;
        el._clicking = setTimeout(function() {
            delete el._active;
            delete el._clicking;
        }, 2000);
    }
}
function $61b869fc2909ad8f$var$onClickInput(datepicker, ev) {
    var el = ev.target;
    if (!el._clicking) return;
    clearTimeout(el._clicking);
    delete el._clicking;
    if (el._active) datepicker.enterEditMode();
    delete el._active;
    if (datepicker.config.showOnClick) datepicker.show();
}
function $61b869fc2909ad8f$var$onPaste(datepicker, ev) {
    if (ev.clipboardData.types.includes('text/plain')) datepicker.enterEditMode();
}
// for the `document` to delegate the events from outside the picker/input field
function $61b869fc2909ad8f$var$onClickOutside(datepicker, ev) {
    var element = datepicker.element;
    if (element !== document.activeElement) return;
    var pickerElem = datepicker.picker.element;
    if ($61b869fc2909ad8f$var$findElementInEventPath(ev, function(el) {
        return el === element || el === pickerElem;
    })) return;
    $61b869fc2909ad8f$var$unfocus(datepicker);
}
function $61b869fc2909ad8f$var$stringifyDates(dates, config) {
    return dates.map(function(dt) {
        return $61b869fc2909ad8f$var$formatDate(dt, config.format, config.locale);
    }).join(config.dateDelimiter);
}
// parse input dates and create an array of time values for selection
// returns undefined if there are no valid dates in inputDates
// when origDates (current selection) is passed, the function works to mix
// the input dates into the current selection
function $61b869fc2909ad8f$var$processInputDates(datepicker, inputDates) {
    var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var config = datepicker.config, origDates = datepicker.dates, rangepicker = datepicker.rangepicker;
    if (inputDates.length === 0) // empty input is considered valid unless origiDates is passed
    return clear ? [] : undefined;
    var rangeEnd = rangepicker && datepicker === rangepicker.datepickers[1];
    var newDates = inputDates.reduce(function(dates, dt) {
        var date = $61b869fc2909ad8f$var$parseDate(dt, config.format, config.locale);
        if (date === undefined) return dates;
        if (config.pickLevel > 0) {
            // adjust to 1st of the month/Jan 1st of the year
            // or to the last day of the monh/Dec 31st of the year if the datepicker
            // is the range-end picker of a rangepicker
            var _dt = new Date(date);
            if (config.pickLevel === 1) date = rangeEnd ? _dt.setMonth(_dt.getMonth() + 1, 0) : _dt.setDate(1);
            else date = rangeEnd ? _dt.setFullYear(_dt.getFullYear() + 1, 0, 0) : _dt.setMonth(0, 1);
        }
        if ($61b869fc2909ad8f$var$isInRange(date, config.minDate, config.maxDate) && !dates.includes(date) && !config.datesDisabled.includes(date) && !config.daysOfWeekDisabled.includes(new Date(date).getDay())) dates.push(date);
        return dates;
    }, []);
    if (newDates.length === 0) return;
    if (config.multidate && !clear) // get the synmetric difference between origDates and newDates
    newDates = newDates.reduce(function(dates, date) {
        if (!origDates.includes(date)) dates.push(date);
        return dates;
    }, origDates.filter(function(date) {
        return !newDates.includes(date);
    }));
    // do length check always because user can input multiple dates regardless of the mode
    return config.maxNumberOfDates && newDates.length > config.maxNumberOfDates ? newDates.slice(config.maxNumberOfDates * -1) : newDates;
}
// refresh the UI elements
// modes: 1: input only, 2, picker only, 3 both
function $61b869fc2909ad8f$var$refreshUI(datepicker) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var quickRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var config = datepicker.config, picker = datepicker.picker, inputField = datepicker.inputField;
    if (mode & 2) {
        var newView = picker.active ? config.pickLevel : config.startView;
        picker.update().changeView(newView).render(quickRender);
    }
    if (mode & 1 && inputField) inputField.value = $61b869fc2909ad8f$var$stringifyDates(datepicker.dates, config);
}
function $61b869fc2909ad8f$var$_setDate(datepicker, inputDates, options) {
    var clear = options.clear, render = options.render, autohide = options.autohide;
    if (render === undefined) render = true;
    if (!render) autohide = false;
    else if (autohide === undefined) autohide = datepicker.config.autohide;
    var newDates = $61b869fc2909ad8f$var$processInputDates(datepicker, inputDates, clear);
    if (!newDates) return;
    if (newDates.toString() !== datepicker.dates.toString()) {
        datepicker.dates = newDates;
        $61b869fc2909ad8f$var$refreshUI(datepicker, render ? 3 : 1);
        $61b869fc2909ad8f$var$triggerDatepickerEvent(datepicker, 'changeDate');
    } else $61b869fc2909ad8f$var$refreshUI(datepicker, 1);
    if (autohide) datepicker.hide();
}
/**
 * Class representing a date picker
 */ var $61b869fc2909ad8f$export$7235422eca03ec90 = /*#__PURE__*/ function() {
    /**
   * Create a date picker
   * @param  {Element} element - element to bind a date picker
   * @param  {Object} [options] - config options
   * @param  {DateRangePicker} [rangepicker] - DateRangePicker instance the
   * date picker belongs to. Use this only when creating date picker as a part
   * of date range picker
   */ function Datepicker(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var rangepicker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        $61b869fc2909ad8f$var$_classCallCheck(this, Datepicker);
        element.datepicker = this;
        this.element = element;
        // set up config
        var config = this.config = Object.assign({
            buttonClass: options.buttonClass && String(options.buttonClass) || 'button',
            container: document.body,
            defaultViewDate: $61b869fc2909ad8f$var$today(),
            maxDate: undefined,
            minDate: undefined
        }, $61b869fc2909ad8f$var$processOptions($61b869fc2909ad8f$var$defaultOptions, this));
        this._options = options;
        Object.assign(config, $61b869fc2909ad8f$var$processOptions(options, this));
        // configure by type
        var inline = this.inline = element.tagName !== 'INPUT';
        var inputField;
        var initialDates;
        if (inline) {
            config.container = element;
            initialDates = $61b869fc2909ad8f$var$stringToArray(element.dataset.date, config.dateDelimiter);
            delete element.dataset.date;
        } else {
            var container = options.container ? document.querySelector(options.container) : null;
            if (container) config.container = container;
            inputField = this.inputField = element;
            inputField.classList.add('datepicker-input');
            initialDates = $61b869fc2909ad8f$var$stringToArray(inputField.value, config.dateDelimiter);
        }
        if (rangepicker) {
            // check validiry
            var index = rangepicker.inputs.indexOf(inputField);
            var datepickers = rangepicker.datepickers;
            if (index < 0 || index > 1 || !Array.isArray(datepickers)) throw Error('Invalid rangepicker object.');
            // attach itaelf to the rangepicker here so that processInputDates() can
            // determine if this is the range-end picker of the rangepicker while
            // setting inital values when pickLevel > 0
            datepickers[index] = this;
            // add getter for rangepicker
            Object.defineProperty(this, 'rangepicker', {
                get: function get() {
                    return rangepicker;
                }
            });
        }
        // set initial dates
        this.dates = [];
        // process initial value
        var inputDateValues = $61b869fc2909ad8f$var$processInputDates(this, initialDates);
        if (inputDateValues && inputDateValues.length > 0) this.dates = inputDateValues;
        if (inputField) inputField.value = $61b869fc2909ad8f$var$stringifyDates(this.dates, config);
        var picker = this.picker = new $61b869fc2909ad8f$var$Picker(this);
        if (inline) this.show();
        else {
            // set up event listeners in other modes
            var onMousedownDocument = $61b869fc2909ad8f$var$onClickOutside.bind(null, this);
            var listeners = [
                [
                    inputField,
                    'keydown',
                    $61b869fc2909ad8f$var$onKeydown.bind(null, this)
                ],
                [
                    inputField,
                    'focus',
                    $61b869fc2909ad8f$var$onFocus.bind(null, this)
                ],
                [
                    inputField,
                    'mousedown',
                    $61b869fc2909ad8f$var$onMousedown.bind(null, this)
                ],
                [
                    inputField,
                    'click',
                    $61b869fc2909ad8f$var$onClickInput.bind(null, this)
                ],
                [
                    inputField,
                    'paste',
                    $61b869fc2909ad8f$var$onPaste.bind(null, this)
                ],
                [
                    document,
                    'mousedown',
                    onMousedownDocument
                ],
                [
                    document,
                    'touchstart',
                    onMousedownDocument
                ],
                [
                    window,
                    'resize',
                    picker.place.bind(picker)
                ]
            ];
            $61b869fc2909ad8f$var$registerListeners(this, listeners);
        }
    }
    /**
   * Format Date object or time value in given format and language
   * @param  {Date|Number} date - date or time value to format
   * @param  {String|Object} format - format string or object that contains
   * toDisplay() custom formatter, whose signature is
   * - args:
   *   - date: {Date} - Date instance of the date passed to the method
   *   - format: {Object} - the format object passed to the method
   *   - locale: {Object} - locale for the language specified by `lang`
   * - return:
   *     {String} formatted date
   * @param  {String} [lang=en] - language code for the locale to use
   * @return {String} formatted date
   */ return $61b869fc2909ad8f$var$_createClass(Datepicker, [
        {
            key: "active",
            get: /**
     * @type {Boolean} - Whether the picker element is shown. `true` whne shown
     */ function get() {
                return !!(this.picker && this.picker.active);
            }
        },
        {
            key: "pickerElement",
            get: function get() {
                return this.picker ? this.picker.element : undefined;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var picker = this.picker;
                var newOptions = $61b869fc2909ad8f$var$processOptions(options, this);
                Object.assign(this._options, options);
                Object.assign(this.config, newOptions);
                picker.setOptions(newOptions);
                $61b869fc2909ad8f$var$refreshUI(this, 3);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.inputField) {
                    if (this.inputField.disabled) return;
                    if (this.inputField !== document.activeElement) {
                        this._showing = true;
                        this.inputField.focus();
                        delete this._showing;
                    }
                }
                this.picker.show();
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.inline) return;
                this.picker.hide();
                this.picker.update().changeView(this.config.startView).render();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.hide();
                $61b869fc2909ad8f$var$unregisterListeners(this);
                this.picker.detach();
                if (!this.inline) this.inputField.classList.remove('datepicker-input');
                delete this.element.datepicker;
                return this;
            }
        },
        {
            key: "getDate",
            value: function getDate() {
                var _this = this;
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var callback = format ? function(date) {
                    return $61b869fc2909ad8f$var$formatDate(date, format, _this.config.locale);
                } : function(date) {
                    return new Date(date);
                };
                if (this.config.multidate) return this.dates.map(callback);
                if (this.dates.length > 0) return callback(this.dates[0]);
            }
        },
        {
            key: "setDate",
            value: function setDate() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var dates = [].concat(args);
                var opts = {};
                var lastArg = $61b869fc2909ad8f$var$lastItemOf(args);
                if ($61b869fc2909ad8f$var$_typeof(lastArg) === 'object' && !Array.isArray(lastArg) && !(lastArg instanceof Date) && lastArg) Object.assign(opts, dates.pop());
                var inputDates = Array.isArray(dates[0]) ? dates[0] : dates;
                $61b869fc2909ad8f$var$_setDate(this, inputDates, opts);
            }
        },
        {
            key: "update",
            value: function update() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                if (this.inline) return;
                var opts = {
                    clear: true,
                    autohide: !!(options && options.autohide)
                };
                var inputDates = $61b869fc2909ad8f$var$stringToArray(this.inputField.value, this.config.dateDelimiter);
                $61b869fc2909ad8f$var$_setDate(this, inputDates, opts);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var forceRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (target && typeof target !== 'string') {
                    forceRender = target;
                    target = undefined;
                }
                var mode;
                if (target === 'picker') mode = 2;
                else if (target === 'input') mode = 1;
                else mode = 3;
                $61b869fc2909ad8f$var$refreshUI(this, mode, !forceRender);
            }
        },
        {
            key: "enterEditMode",
            value: function enterEditMode() {
                if (this.inline || !this.picker.active || this.editMode) return;
                this.editMode = true;
                this.inputField.classList.add('in-edit', 'border-blue-700', '!border-primary-700');
            }
        },
        {
            key: "exitEditMode",
            value: function exitEditMode() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                if (this.inline || !this.editMode) return;
                var opts = Object.assign({
                    update: false
                }, options);
                delete this.editMode;
                this.inputField.classList.remove('in-edit', 'border-blue-700', '!border-primary-700');
                if (opts.update) this.update(opts);
            }
        }
    ], [
        {
            key: "formatDate",
            value: function formatDate$1(date, format, lang) {
                return $61b869fc2909ad8f$var$formatDate(date, format, lang && $61b869fc2909ad8f$var$locales[lang] || $61b869fc2909ad8f$var$locales.en);
            }
        },
        {
            key: "parseDate",
            value: function parseDate$1(dateStr, format, lang) {
                return $61b869fc2909ad8f$var$parseDate(dateStr, format, lang && $61b869fc2909ad8f$var$locales[lang] || $61b869fc2909ad8f$var$locales.en);
            }
        },
        {
            key: "locales",
            get: function get() {
                return $61b869fc2909ad8f$var$locales;
            }
        }
    ]);
}();
// filter out the config options inapproprite to pass to Datepicker
function $61b869fc2909ad8f$var$filterOptions(options) {
    var newOpts = Object.assign({}, options);
    delete newOpts.inputs;
    delete newOpts.allowOneSidedRange;
    delete newOpts.maxNumberOfDates; // to ensure each datepicker handles a single date
    return newOpts;
}
function $61b869fc2909ad8f$var$setupDatepicker(rangepicker, changeDateListener, el, options) {
    $61b869fc2909ad8f$var$registerListeners(rangepicker, [
        [
            el,
            'changeDate',
            changeDateListener
        ]
    ]);
    new $61b869fc2909ad8f$export$7235422eca03ec90(el, options, rangepicker);
}
function $61b869fc2909ad8f$var$onChangeDate(rangepicker, ev) {
    // to prevent both datepickers trigger the other side's update each other
    if (rangepicker._updating) return;
    rangepicker._updating = true;
    var target = ev.target;
    if (target.datepicker === undefined) return;
    var datepickers = rangepicker.datepickers;
    var setDateOptions = {
        render: false
    };
    var changedSide = rangepicker.inputs.indexOf(target);
    var otherSide = changedSide === 0 ? 1 : 0;
    var changedDate = datepickers[changedSide].dates[0];
    var otherDate = datepickers[otherSide].dates[0];
    if (changedDate !== undefined && otherDate !== undefined) {
        // if the start of the range > the end, swap them
        if (changedSide === 0 && changedDate > otherDate) {
            datepickers[0].setDate(otherDate, setDateOptions);
            datepickers[1].setDate(changedDate, setDateOptions);
        } else if (changedSide === 1 && changedDate < otherDate) {
            datepickers[0].setDate(changedDate, setDateOptions);
            datepickers[1].setDate(otherDate, setDateOptions);
        }
    } else if (!rangepicker.allowOneSidedRange) // to prevent the range from becoming one-sided, copy changed side's
    // selection (no matter if it's empty) to the other side
    {
        if (changedDate !== undefined || otherDate !== undefined) {
            setDateOptions.clear = true;
            datepickers[otherSide].setDate(datepickers[changedSide].dates, setDateOptions);
        }
    }
    datepickers[0].picker.update().render();
    datepickers[1].picker.update().render();
    delete rangepicker._updating;
}
/**
 * Class representing a date range picker
 */ var $61b869fc2909ad8f$export$17334619f3ac2224 = /*#__PURE__*/ function() {
    /**
   * Create a date range picker
   * @param  {Element} element - element to bind a date range picker
   * @param  {Object} [options] - config options
   */ function DateRangePicker(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $61b869fc2909ad8f$var$_classCallCheck(this, DateRangePicker);
        var inputs = Array.isArray(options.inputs) ? options.inputs : Array.from(element.querySelectorAll('input'));
        if (inputs.length < 2) return;
        element.rangepicker = this;
        this.element = element;
        this.inputs = inputs.slice(0, 2);
        this.allowOneSidedRange = !!options.allowOneSidedRange;
        var changeDateListener = $61b869fc2909ad8f$var$onChangeDate.bind(null, this);
        var cleanOptions = $61b869fc2909ad8f$var$filterOptions(options);
        // in order for initial date setup to work right when pcicLvel > 0,
        // let Datepicker constructor add the instance to the rangepicker
        var datepickers = [];
        Object.defineProperty(this, 'datepickers', {
            get: function get() {
                return datepickers;
            }
        });
        $61b869fc2909ad8f$var$setupDatepicker(this, changeDateListener, this.inputs[0], cleanOptions);
        $61b869fc2909ad8f$var$setupDatepicker(this, changeDateListener, this.inputs[1], cleanOptions);
        Object.freeze(datepickers);
        // normalize the range if inital dates are given
        if (datepickers[0].dates.length > 0) $61b869fc2909ad8f$var$onChangeDate(this, {
            target: this.inputs[0]
        });
        else if (datepickers[1].dates.length > 0) $61b869fc2909ad8f$var$onChangeDate(this, {
            target: this.inputs[1]
        });
    }
    /**
   * @type {Array} - selected date of the linked date pickers
   */ return $61b869fc2909ad8f$var$_createClass(DateRangePicker, [
        {
            key: "dates",
            get: function get() {
                return this.datepickers.length === 2 ? [
                    this.datepickers[0].dates[0],
                    this.datepickers[1].dates[0]
                ] : undefined;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.allowOneSidedRange = !!options.allowOneSidedRange;
                var cleanOptions = $61b869fc2909ad8f$var$filterOptions(options);
                this.datepickers[0].setOptions(cleanOptions);
                this.datepickers[1].setOptions(cleanOptions);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.datepickers[0].destroy();
                this.datepickers[1].destroy();
                $61b869fc2909ad8f$var$unregisterListeners(this);
                delete this.element.rangepicker;
            }
        },
        {
            key: "getDates",
            value: function getDates() {
                var _this = this;
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var callback = format ? function(date) {
                    return $61b869fc2909ad8f$var$formatDate(date, format, _this.datepickers[0].config.locale);
                } : function(date) {
                    return new Date(date);
                };
                return this.dates.map(function(date) {
                    return date === undefined ? date : callback(date);
                });
            }
        },
        {
            key: "setDates",
            value: function setDates(rangeStart, rangeEnd) {
                var _this$datepickers = $61b869fc2909ad8f$var$_slicedToArray(this.datepickers, 2), datepicker0 = _this$datepickers[0], datepicker1 = _this$datepickers[1];
                var origDates = this.dates;
                // If range normalization runs on every change, we can't set a new range
                // that starts after the end of the current range correctly because the
                // normalization process swaps start↔︎end right after setting the new start
                // date. To prevent this, the normalization process needs to run once after
                // both of the new dates are set.
                this._updating = true;
                datepicker0.setDate(rangeStart);
                datepicker1.setDate(rangeEnd);
                delete this._updating;
                if (datepicker1.dates[0] !== origDates[1]) $61b869fc2909ad8f$var$onChangeDate(this, {
                    target: this.inputs[1]
                });
                else if (datepicker0.dates[0] !== origDates[0]) $61b869fc2909ad8f$var$onChangeDate(this, {
                    target: this.inputs[0]
                });
            }
        }
    ]);
}();


var $5aa066c79178a832$var$__assign = undefined && undefined.__assign || function() {
    $5aa066c79178a832$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5aa066c79178a832$var$__assign.apply(this, arguments);
};
var $5aa066c79178a832$var$Default = {
    defaultDatepickerId: null,
    autohide: false,
    format: 'mm/dd/yyyy',
    maxDate: null,
    minDate: null,
    orientation: 'bottom',
    buttons: false,
    autoSelectToday: 0,
    title: null,
    language: 'en',
    rangePicker: false,
    onShow: function() {},
    onHide: function() {}
};
var $5aa066c79178a832$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $5aa066c79178a832$var$Datepicker = /** @class */ function() {
    function Datepicker(datepickerEl, options, instanceOptions) {
        if (datepickerEl === void 0) datepickerEl = null;
        if (options === void 0) options = $5aa066c79178a832$var$Default;
        if (instanceOptions === void 0) instanceOptions = $5aa066c79178a832$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : datepickerEl.id;
        this._datepickerEl = datepickerEl;
        this._datepickerInstance = null;
        this._options = $5aa066c79178a832$var$__assign($5aa066c79178a832$var$__assign({}, $5aa066c79178a832$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).addInstance('Datepicker', this, this._instanceId, instanceOptions.override);
    }
    Datepicker.prototype.init = function() {
        if (this._datepickerEl && !this._initialized) {
            if (this._options.rangePicker) this._datepickerInstance = new (0, $61b869fc2909ad8f$export$17334619f3ac2224)(this._datepickerEl, this._getDatepickerOptions(this._options));
            else this._datepickerInstance = new (0, $61b869fc2909ad8f$export$7235422eca03ec90)(this._datepickerEl, this._getDatepickerOptions(this._options));
            this._initialized = true;
        }
    };
    Datepicker.prototype.destroy = function() {
        if (this._initialized) {
            this._initialized = false;
            this._datepickerInstance.destroy();
        }
    };
    Datepicker.prototype.removeInstance = function() {
        this.destroy();
        (0, $9e599e545d4197d0$export$2e2bcd8739ae039).removeInstance('Datepicker', this._instanceId);
    };
    Datepicker.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Datepicker.prototype.getDatepickerInstance = function() {
        return this._datepickerInstance;
    };
    Datepicker.prototype.getDate = function() {
        if (this._options.rangePicker && this._datepickerInstance instanceof (0, $61b869fc2909ad8f$export$17334619f3ac2224)) return this._datepickerInstance.getDates();
        if (!this._options.rangePicker && this._datepickerInstance instanceof (0, $61b869fc2909ad8f$export$7235422eca03ec90)) return this._datepickerInstance.getDate();
    };
    Datepicker.prototype.setDate = function(date) {
        if (this._options.rangePicker && this._datepickerInstance instanceof (0, $61b869fc2909ad8f$export$17334619f3ac2224)) return this._datepickerInstance.setDates(date);
        if (!this._options.rangePicker && this._datepickerInstance instanceof (0, $61b869fc2909ad8f$export$7235422eca03ec90)) return this._datepickerInstance.setDate(date);
    };
    Datepicker.prototype.show = function() {
        this._datepickerInstance.show();
        this._options.onShow(this);
    };
    Datepicker.prototype.hide = function() {
        this._datepickerInstance.hide();
        this._options.onHide(this);
    };
    Datepicker.prototype._getDatepickerOptions = function(options) {
        var datepickerOptions = {};
        if (options.buttons) {
            datepickerOptions.todayBtn = true;
            datepickerOptions.clearBtn = true;
            if (options.autoSelectToday) datepickerOptions.todayBtnMode = 1;
        }
        if (options.autohide) datepickerOptions.autohide = true;
        if (options.format) datepickerOptions.format = options.format;
        if (options.maxDate) datepickerOptions.maxDate = options.maxDate;
        if (options.minDate) datepickerOptions.minDate = options.minDate;
        if (options.orientation) datepickerOptions.orientation = options.orientation;
        if (options.title) datepickerOptions.title = options.title;
        if (options.language) datepickerOptions.language = options.language;
        return datepickerOptions;
    };
    Datepicker.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Datepicker.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Datepicker;
}();
function $5aa066c79178a832$export$81c9f52a292162ae() {
    document.querySelectorAll('[datepicker], [inline-datepicker], [date-rangepicker]').forEach(function($datepickerEl) {
        if ($datepickerEl) {
            var buttons = $datepickerEl.hasAttribute('datepicker-buttons');
            var autoselectToday = $datepickerEl.hasAttribute('datepicker-autoselect-today');
            var autohide = $datepickerEl.hasAttribute('datepicker-autohide');
            var format = $datepickerEl.getAttribute('datepicker-format');
            var maxDate = $datepickerEl.getAttribute('datepicker-max-date');
            var minDate = $datepickerEl.getAttribute('datepicker-min-date');
            var orientation_1 = $datepickerEl.getAttribute('datepicker-orientation');
            var title = $datepickerEl.getAttribute('datepicker-title');
            var language = $datepickerEl.getAttribute('datepicker-language');
            var rangePicker = $datepickerEl.hasAttribute('date-rangepicker');
            new $5aa066c79178a832$var$Datepicker($datepickerEl, {
                buttons: buttons ? buttons : $5aa066c79178a832$var$Default.buttons,
                autoSelectToday: autoselectToday ? autoselectToday : $5aa066c79178a832$var$Default.autoSelectToday,
                autohide: autohide ? autohide : $5aa066c79178a832$var$Default.autohide,
                format: format ? format : $5aa066c79178a832$var$Default.format,
                maxDate: maxDate ? maxDate : $5aa066c79178a832$var$Default.maxDate,
                minDate: minDate ? minDate : $5aa066c79178a832$var$Default.minDate,
                orientation: orientation_1 ? orientation_1 : $5aa066c79178a832$var$Default.orientation,
                title: title ? title : $5aa066c79178a832$var$Default.title,
                language: language ? language : $5aa066c79178a832$var$Default.language,
                rangePicker: rangePicker ? rangePicker : $5aa066c79178a832$var$Default.rangePicker
            });
        } else console.error("The datepicker element does not exist. Please check the datepicker attribute.");
    });
}
if (typeof window !== 'undefined') {
    window.Datepicker = $5aa066c79178a832$var$Datepicker;
    window.initDatepickers = $5aa066c79178a832$export$81c9f52a292162ae;
}
var $5aa066c79178a832$export$2e2bcd8739ae039 = $5aa066c79178a832$var$Datepicker;
















function $6634584ec8613a9f$export$4cd50b9c69a85fd5() {
    (0, $c48fec59664056e4$export$226c1dc98323ee4d)();
    (0, $bb9acaac13d1970e$export$355ba5a528b4009a)();
    (0, $ed7202bee3ce6cfe$export$3ab77386b16b9e58)();
    (0, $71fa26dd9880ee1d$export$69c84787a503daef)();
    (0, $56e861d2255aee7e$export$8cb65a02593bf108)();
    (0, $e50395cbfc69fa09$export$e14d3bc873a8b9b1)();
    (0, $4d66f8052cdbfb83$export$319df2b10e87c8ec)();
    (0, $43463cdeacf1e0fa$export$c92e8f569ad2976f)();
    (0, $0da394db4be38aaa$export$8f2a38c1f9d9dc3e)();
    (0, $f8e681bd2d19b9c0$export$200409e83b2a0dd4)();
    (0, $24d88d1ae14e4d54$export$33aa68e0bfaa065d)();
    (0, $1c5fe2354b7370dd$export$4352dd3b7a1676ab)();
    (0, $0259e20e6a846074$export$ad4117886fd6cf74)();
    (0, $5aa066c79178a832$export$81c9f52a292162ae)();
}
if (typeof window !== 'undefined') window.initFlowbite = $6634584ec8613a9f$export$4cd50b9c69a85fd5;






























































// setup events for data attributes
var $4714c50421590160$var$events = new (0, $2517ebbe139f796a$export$2e2bcd8739ae039)('load', [
    (0, $c48fec59664056e4$export$226c1dc98323ee4d),
    (0, $bb9acaac13d1970e$export$355ba5a528b4009a),
    (0, $ed7202bee3ce6cfe$export$3ab77386b16b9e58),
    (0, $71fa26dd9880ee1d$export$69c84787a503daef),
    (0, $56e861d2255aee7e$export$8cb65a02593bf108),
    (0, $e50395cbfc69fa09$export$e14d3bc873a8b9b1),
    (0, $4d66f8052cdbfb83$export$319df2b10e87c8ec),
    (0, $43463cdeacf1e0fa$export$c92e8f569ad2976f),
    (0, $0da394db4be38aaa$export$8f2a38c1f9d9dc3e),
    (0, $f8e681bd2d19b9c0$export$200409e83b2a0dd4),
    (0, $24d88d1ae14e4d54$export$33aa68e0bfaa065d),
    (0, $1c5fe2354b7370dd$export$4352dd3b7a1676ab),
    (0, $0259e20e6a846074$export$ad4117886fd6cf74),
    (0, $5aa066c79178a832$export$81c9f52a292162ae)
]);
$4714c50421590160$var$events.init();



var $jaOzc = parcelRequire("jaOzc");
var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse('{"name":"bedok.siliconwat.org","version":"6","scripts":{"dev":"rm -rf .parcel-cache dist && parcel src/index.html --port 61995","build":"PARCEL_COMMIT_TIMESTAMP=$(git log -1 --format=%ct) PARCEL_COMMIT_HASH=$(git rev-parse --short HEAD) parcel build src/index.html","test":"echo \\"Error: no test specified\\" && exit 1","serve":"firebase emulators:start --only auth,firestore,storage,functions,hosting,database","fs":"firebase deploy --only firestore:rules","indexes":"firebase deploy --only firestore:indexes","storage":"firebase deploy --only storage","db":"firebase deploy --only database","ports":"sudo ./close-ports.sh"},"keywords":["bedok"],"author":"Thon Ly","license":"Silicon Wat, Inc","description":"Thank with HeartBank\xae","devDependencies":{"@parcel/packager-raw-url":"^2.13.3","@parcel/service-worker":"^2.13.3","@parcel/transformer-jsonld":"^2.13.3","@parcel/transformer-raw":"^2.13.3","@parcel/transformer-webmanifest":"^2.13.3","@types/bowser":"^1.0.31","@types/google.maps":"^3.58.1","@types/hammerjs":"^2.0.46","@types/qrcode":"^1.5.5","@types/serviceworker":"^0.0.111","@types/sql.js":"^1.4.9","@types/youtube":"^0.1.2","autoprefixer":"^10.4.20","buffer":"^6.0.3","flowbite":"^3.0.0","parcel":"^2.13.2","postcss":"^8.4.49","svgo":"^3.3.2","tailwindcss":"^3.4.16","typescript":"^5.7.2"},"dependencies":{"@googlemaps/js-api-loader":"^1.16.8","@ungap/custom-elements":"^1.3.0","bowser":"^2.12.1","dexie":"^4.0.10","firebase":"^11.5.0","hammerjs":"^2.0.8","lit-html":"^3.3.0","process":"^0.11.10","qrcode":"^1.5.4","tesseract.js":"^6.0.0","xxhash-wasm":"^1.1.0"}}');


var $510aee62d64df3d9$exports = {};
$510aee62d64df3d9$exports = JSON.parse('{"khmer":{"books":[762,749,775,1033,870,900,777,767,923,774,879,929,907,627,581,725,793,605,733,940,532,837,849,1053,626,861,481,798,724,637,643,632,723,545,935,889,691,767,701,468,994,728,579,527,599,685,547,755,465,925,720,732,335,775,405,524,509,542,634,561,438,439,443,707,640,722,693,779,619,828,725,646,529,576,861,509,647,684,620,562,694,749,792,598,880,556,868,524,646,473,385,662,551,601,822,511,790,654,585,739,544,496,520,498,598,562,591,449,679,610],"baskets":[12,76,109],"commentaries":[8,63,82],"commentaries2":[],"pdfs":["https://www.dropbox.com/scl/fi/q9d3br5zgg6mr731ic2jz/Bedok-No.001.pdf?rlkey=myk74ujm8msxtd1odlj1njlt3&st=8h299399&raw=1","https://www.dropbox.com/scl/fi/13xjsd7xb56dqp2z9p6ac/Bedok-No.002.pdf?rlkey=hyg3hes6w3y4q6la12ypwyik3&st=eif3lz27&raw=1","https://www.dropbox.com/scl/fi/7nbh18fs3791iafosq9rr/Bedok-No.003.pdf?rlkey=7pydf9bhvlt5316ar4cfya9vy&st=a2uofmy0&raw=1","https://www.dropbox.com/scl/fi/zgjvn1sckjst3fa8wdszh/Bedok-No.004.pdf?rlkey=tos6kqohpp0bxavm3hes28cm6&st=342py8b5&raw=1","https://www.dropbox.com/scl/fi/4drx6i2j1whqu21tcip05/Bedok-No.005.pdf?rlkey=iejlmd5nr0lf4thi6jxdcls7i&st=pxjj0190&raw=1","https://www.dropbox.com/scl/fi/8a019axiasraco3myxgzf/Bedok-No.006.pdf?rlkey=bgb79i5d1qketgmc0srmsac7s&st=kksvw0iw&raw=1","https://www.dropbox.com/scl/fi/6n7lfkz2hc0ynmv0zn0tt/Bedok-No.007.pdf?rlkey=cdmvdwyubmctz4lqbks473pow&st=tm6uyum9&raw=1","https://www.dropbox.com/scl/fi/dx5cecne1ladlhb14es86/Bedok-No.008.pdf?rlkey=u54j3wr7x8zoxy28ybfw09jmk&st=sgrsaj9s&raw=1","https://www.dropbox.com/scl/fi/ymatmik7i7s9wgsb65ed6/Bedok-No.009.pdf?rlkey=eqmz0elwcb9gn9dge0vm4tm3l&st=1ekgg4e8&raw=1","https://www.dropbox.com/scl/fi/r983pmagb1sh2jr1fbdv9/Bedok-No.010.pdf?rlkey=oqty084z1qm2auk914jp0rkeq&st=3fd0z0vs&raw=1","https://www.dropbox.com/scl/fi/wfidinh2c7vk4nu890fq6/Bedok-No.011.pdf?rlkey=0bq0nmn5o7fxh39uqnp4p92jp&st=jed4pu6h&raw=1","https://www.dropbox.com/scl/fi/87qdrjho6xkk9givagrgu/Bedok-No.012.pdf?rlkey=5ot1cqjjua13rxsbzc7534rtx&st=zs44n3lu&raw=1","https://www.dropbox.com/scl/fi/e29dypn4b8dumcpft07t9/Bedok-No.013.pdf?rlkey=urbynmwvr16357rv8iv6aajkm&st=xa8sogwm&raw=1","https://www.dropbox.com/scl/fi/yhfsa9z0yc98jhtiw1zyj/Bedok-No.014.pdf?rlkey=vzmot08kkel9hlp05wtn28yiy&st=5gy6zc7z&raw=1","https://www.dropbox.com/scl/fi/5ofw8c7ywotihbkuvb9mt/Bedok-No.015.pdf?rlkey=wpee4v78dwcu99h8kvowugo51&st=zkygdk43&raw=1","https://www.dropbox.com/scl/fi/rgs7ui8kxzgozjdp878e3/Bedok-No.016.pdf?rlkey=nm7503w88asrjau2eilo2ejjb&st=1vd1n0iq&raw=1","https://www.dropbox.com/scl/fi/bs8s6wfxlo9bty07xgiwt/Bedok-No.017.pdf?rlkey=kusjrugn6nhwvbco1dcpeviyv&st=50h41n6q&raw=1","https://www.dropbox.com/scl/fi/dqo9e61sevlzkw0iwwzrh/Bedok-No.018.pdf?rlkey=hg8tkyy808cnbc0oy9phxne14&st=vx0xbdk9&raw=1","https://www.dropbox.com/scl/fi/7xy6c9g15oj7t84sp2t6p/Bedok-No.019.pdf?rlkey=vtc75h2b19ym8ysvnesay1kzl&st=15b054lw&raw=1","https://www.dropbox.com/scl/fi/qh9q5dhn7r3ylik4tnwfn/Bedok-No.020.pdf?rlkey=rkdinnapjql0k7q9vipvr0v9z&st=uh74vl64&raw=1","https://www.dropbox.com/scl/fi/l37n4yul3fry371do28vu/Bedok-No.021.pdf?rlkey=qntuow5z2zdpqx6tblqs66rh8&st=82exia43&raw=1","https://www.dropbox.com/scl/fi/se9u4nwg2cogkz9may4a5/Bedok-No.022.pdf?rlkey=rngsfpffv3vncned0riywwoy3&st=b2zgwjl0&raw=1","https://www.dropbox.com/scl/fi/7799e4zr2zv42cbpt1lhq/Bedok-No.023.pdf?rlkey=eypbmcr1mlr6ezscc33ro7996&st=au93xb2s&raw=1","https://www.dropbox.com/scl/fi/uexrb5sd4slcxia3mr1sl/Bedok-No.024.pdf?rlkey=04tb0lv6fekdfbix8n015da3f&st=2c4awzmn&raw=1","https://www.dropbox.com/scl/fi/9iqbw521bhr71nnmqosyj/Bedok-No.025.pdf?rlkey=6c5r7nt2fdvpnyz4o5xhxoqqd&st=tn0cril6&raw=1","https://www.dropbox.com/scl/fi/7x2y28yg09r5gdnvcqzes/Bedok-No.026.pdf?rlkey=xirfxy45xgpgekrmoxoomb1dn&st=r9zzd383&raw=1","https://www.dropbox.com/scl/fi/idqvbzwvlo9lxsybs3mj5/Bedok-No.027.pdf?rlkey=vmupbumaurt4f01b3x5ey7pk7&st=1i391m68&raw=1","https://www.dropbox.com/scl/fi/t9wwsv14aubv6d084rrif/Bedok-No.028.pdf?rlkey=ip618xiqepzvireozyua3sfn6&st=7y1h0a4u&raw=1","https://www.dropbox.com/scl/fi/zhq1nr1wsx08orcy3sh29/Bedok-No.029.pdf?rlkey=7sqwnpvsgzvzcp0snv14lcqia&st=4bo6n8jf&raw=1","https://www.dropbox.com/scl/fi/po3b22fezusmafzsifnmc/Bedok-No.030.pdf?rlkey=3mupmc7xeois5zc0ftm12v24p&st=ybbgn9mk&raw=1","https://www.dropbox.com/scl/fi/50ydb12t5vlulx5oz75tt/Bedok-No.031.pdf?rlkey=m8nv56w0caj3ix6cfenhq52bt&st=8ujx4e8f&raw=1","https://www.dropbox.com/scl/fi/038yidoxooxf8w9dwh4he/Bedok-No.032.pdf?rlkey=1b6fqvbley0z7azslnlgo9ljl&st=isl3dom4&raw=1","https://www.dropbox.com/scl/fi/to840b3l3y725kymgobbl/Bedok-No.033.pdf?rlkey=ie2e4r2mz8f2nn5ll6fl4ttp5&st=4tf1ulku&raw=1","https://www.dropbox.com/scl/fi/e9q5lqeptkr2krvf7vl5c/Bedok-No.034.pdf?rlkey=ms2dsmhwfevic9noasw0mk8yx&st=08zc93ch&raw=1","https://www.dropbox.com/scl/fi/me0xwoofz04syf8hv2viq/Bedok-No.035.pdf?rlkey=kgqa57pulybb75knwg6381wvu&st=tkl7jnkh&raw=1","https://www.dropbox.com/scl/fi/98rzxfvziwpcjvo9j6lb2/Bedok-No.036.pdf?rlkey=hztkhee7boziwpn951d06629g&st=siipg7zv&raw=1","https://www.dropbox.com/scl/fi/52n3vgvj3wm1cnbpzgnxk/Bedok-No.037.pdf?rlkey=ig32x0ov9bo6o1s5agxhfw5pa&st=8dezjnf7&raw=1","https://www.dropbox.com/scl/fi/zmkbmesm2qn1ojq7wxkbz/Bedok-No.038.pdf?rlkey=i9hl2kizhcugnzlkyxs4sr9sr&st=gr2ric4z&raw=1","https://www.dropbox.com/scl/fi/nh0cgxq7zatfsfycu36bq/Bedok-No.039.pdf?rlkey=10epu479u3h8h7s6xfyvssfec&st=92rm9zrf&raw=1","https://www.dropbox.com/scl/fi/oi8msmzh8tha5ocqkrxgo/Bedok-No.040.pdf?rlkey=2kvzybg46n5xzn5fswulynqq0&st=gaw4r5fv&raw=1","https://www.dropbox.com/scl/fi/mjop924mmku9uvevg3gb9/Bedok-No.041.pdf?rlkey=8zwmrkkrzfqb1mlld7zkjo5io&st=yp0r10l7&raw=1","https://www.dropbox.com/scl/fi/pie1o11h6il51xmardgj9/Bedok-No.042.pdf?rlkey=uyolvzos3cjk35dkfv044z5o1&st=h1tdr67e&raw=1","https://www.dropbox.com/scl/fi/dl9jpcmapxxle79srjxdb/Bedok-No.043.pdf?rlkey=af0flrq4ie2w8h3fc43gtg3p1&st=w06yx7fb&raw=1","https://www.dropbox.com/scl/fi/enegodujvftsbnnfswqny/Bedok-No.044.pdf?rlkey=hr54xgf0xdm0uy7oh5jaqtz7l&st=exnki0ab&raw=1","https://www.dropbox.com/scl/fi/svfwv4hdut6wx3s7ws9y5/Bedok-No.045.pdf?rlkey=g38a85re5lly7t2i060lncrx3&st=ftrumybf&raw=1","https://www.dropbox.com/scl/fi/2buhkyg6jvzh20q7rzx4w/Bedok-No.046.pdf?rlkey=5t9gm6hrvgy5emevtxmp0wh2y&st=0h11kf5x&raw=1","https://www.dropbox.com/scl/fi/e4xblt1ovsxusaxsvg5yb/Bedok-No.047.pdf?rlkey=cg0njowoip5ma58a6hnrqq5pv&st=uuihv4hf&raw=1","https://www.dropbox.com/scl/fi/qougpzyk0dlpkeesc6t65/Bedok-No.048.pdf?rlkey=ufwl6r3xb9zbfw3f7ijf9ju6q&st=uuc72xf3&raw=1","https://www.dropbox.com/scl/fi/a9b6vh2giezez5xbnqj1d/Bedok-No.049.pdf?rlkey=engjsko3jbkatifo1r1om2od1&st=lu2l1fea&raw=1","https://www.dropbox.com/scl/fi/h25sxlb8pmnlxvk8wf3ui/Bedok-No.050.pdf?rlkey=xkelasehag2s1imv4f9ovgonv&st=p8jb9ff7&raw=1","https://www.dropbox.com/scl/fi/raipcsn876nccfy4g93u4/Bedok-No.051.pdf?rlkey=fnfnyxv9rp6l6ai3fs93ujwdg&st=cz1ffm0f&raw=1","https://www.dropbox.com/scl/fi/3vfk21cp7xj4jre0c0svl/Bedok-No.052.pdf?rlkey=z7pifh1gy4w04m3l9zvzi0ohv&st=8k09parb&raw=1","https://www.dropbox.com/scl/fi/lflz1ympvj13wsj2k6y2e/Bedok-No.053.pdf?rlkey=mvkqxyzp35al3o0wyjetxje4g&st=8zouyspb&raw=1","https://www.dropbox.com/scl/fi/jss6h3p8jggncgewpebtm/Bedok-No.054.pdf?rlkey=x5wj1uzh01u73vw5xy8o7yw30&st=acozsus9&raw=1","https://www.dropbox.com/scl/fi/336ljo3ongf682sr12k78/Bedok-No.055.pdf?rlkey=e8o1xpzzgm7n52mt9uorwfzrz&st=zc4as286&raw=1","https://www.dropbox.com/scl/fi/5t05hrz7bvrfj3fm6u3ij/Bedok-No.056.pdf?rlkey=svt0e6eyg6b04v2hat6vgi2b4&st=lakq5sq1&raw=1","https://www.dropbox.com/scl/fi/e5mhgtk1p4xq7i62aukzw/Bedok-No.057.pdf?rlkey=78btviyd8zw1cf55kceniwy5g&st=nvnk31vy&raw=1","https://www.dropbox.com/scl/fi/0xw1g8mop7zlq1fwpvytb/Bedok-No.058.pdf?rlkey=5te7po76uslx7gzqt2o7teap1&st=qiyezceg&raw=1","https://www.dropbox.com/scl/fi/p6oaflrw5ecnb8bou5w2p/Bedok-No.059.pdf?rlkey=otldqqxsa3owgqrq3s3gqoaup&st=vqaqh91j&raw=1","https://www.dropbox.com/scl/fi/jtmqi16gtrsm5ly1sedb8/Bedok-No.060.pdf?rlkey=oghhtdv7115qh4sus7b3gf6yj&st=2hiaolg5&raw=1","https://www.dropbox.com/scl/fi/5oi8zcegqhmd8xiafkbrw/Bedok-No.061.pdf?rlkey=u4t5s2g0zfu922w4swvpjt4x9&st=vtxdkfje&raw=1","https://www.dropbox.com/scl/fi/9ojvbpwd6l3qg0vmspmka/Bedok-No.062.pdf?rlkey=205vutw8ff316k81ts5933nta&st=gj0f4713&raw=1","https://www.dropbox.com/scl/fi/no4qy3lcsp4kyeck5o8c8/Bedok-No.063.pdf?rlkey=t9r2umh6789mfqtmvlsl41mfo&st=hpr5ug7p&raw=1","https://www.dropbox.com/scl/fi/9utqcj0uk71l67b0gez7s/Bedok-No.064.pdf?rlkey=k1br61o2zs2oat9qxu4bdv7zc&st=xqzo5rf7&raw=1","https://www.dropbox.com/scl/fi/tz80fthbve3au9fmrtptw/Bedok-No.065.pdf?rlkey=8mgmayas8kbmofjtnd606ny2a&st=n2h53pnx&raw=1","https://www.dropbox.com/scl/fi/iewr7xlpoosongkrktwio/Bedok-No.066.pdf?rlkey=l7diptdnx19k4hxg5lqdphpga&st=h3v5xomg&raw=1","https://www.dropbox.com/scl/fi/nr5m05pi3tjqjr5k9l4nq/Bedok-No.067.pdf?rlkey=7q36esbjdzx4felykqhflcf43&st=hd0jsa6v&raw=1","https://www.dropbox.com/scl/fi/xstgybxgvpmltnxyvm1p1/Bedok-No.068.pdf?rlkey=bckcx5o2fxfo9szg77i4ryvcq&st=07yutzuk&raw=1","https://www.dropbox.com/scl/fi/p7vc6pgotb0wrm3p8nzmg/Bedok-No.069.pdf?rlkey=q2rsws2a93gv4mg60idktw9jx&st=yg34b1bf&raw=1","https://www.dropbox.com/scl/fi/e2asz7k6vqtarkodigs6i/Bedok-No.070.pdf?rlkey=hsuozqbzuwoqw1p52ubtaqkkm&st=tg4a9it7&raw=1","https://www.dropbox.com/scl/fi/4hgtry71ry72fibjgw6n2/Bedok-No.071.pdf?rlkey=73xm3rqivrv9i9gnrjq6fp7u8&st=h6fe558x&raw=1","https://www.dropbox.com/scl/fi/a5o6p1saejm82mvpsvbja/Bedok-No.072.pdf?rlkey=gjgsrbagay9qesz74w8iquk02&st=jrno1ya5&raw=1","https://www.dropbox.com/scl/fi/h3xm9tpbrgc1hfd5cxmvr/Bedok-No.073.pdf?rlkey=3k4zqy97kjjsbjoy8ncqps7z0&st=mvso3v6f&raw=1","https://www.dropbox.com/scl/fi/9c5eguds3ccntsp4p830h/Bedok-No.074.pdf?rlkey=u4gei47brba9x1voo14its0lv&st=6vmmoqdj&raw=1","https://www.dropbox.com/scl/fi/m49b5lak7p6cc0rb7ibgb/Bedok-No.075.pdf?rlkey=2vaaq5zisbvqscwxja9vm3qtg&st=mxgl320h&raw=1","https://www.dropbox.com/scl/fi/q8hrdygyikd5pfrkg9fx2/Bedok-No.076.pdf?rlkey=etz1zpmukq3sw614bo4anjv6l&st=ngl9t23e&raw=1","https://www.dropbox.com/scl/fi/dgkt5113zpmavet6z6ibv/Bedok-No.077.pdf?rlkey=fcbh2u7q2bkfyacmbm4y35cmj&st=iyjhisg6&raw=1","https://www.dropbox.com/scl/fi/1b485p7y2z5r65sldboz4/Bedok-No.078.pdf?rlkey=3xt9spjp9kd7uechncts4y6va&st=88460yoa&raw=1","https://www.dropbox.com/scl/fi/7wrrvavss7j9flmyncn2e/Bedok-No.079.pdf?rlkey=3jvrmnb1dh4hnibxyre9ug4hw&st=to6cpaav&raw=1","https://www.dropbox.com/scl/fi/6byiqj2guaimgo9zqebbw/Bedok-No.080.pdf?rlkey=dtdhcn1a2c6eny953hyz0wyrw&st=kkevp88s&raw=1","https://www.dropbox.com/scl/fi/eqk60atywkuzvps9cvajw/Bedok-No.081.pdf?rlkey=hmf9u5u8y0vzx1nsf5ttmt45s&st=5kog2fl4&raw=1","https://www.dropbox.com/scl/fi/pj7zy84bz6wtwizzzzb4s/Bedok-No.082.pdf?rlkey=hh2l0ondvosb77ihdpapt11o5&st=wjfz89k9&raw=1","https://www.dropbox.com/scl/fi/839pconehytukzyz47xgs/Bedok-No.083.pdf?rlkey=x2f7aerjhzzdlizlmklgv7ui5&st=wdyz4sei&raw=1","https://www.dropbox.com/scl/fi/wzerszewh7ali9cxer4uv/Bedok-No.084.pdf?rlkey=v55rsippcxhtxs6yf71wllhvk&st=19o9s2ls&raw=1","https://www.dropbox.com/scl/fi/38ccmhlymgaceff0ryeqs/Bedok-No.085.pdf?rlkey=83syasflm02ruochwynounjc0&st=9yl3bcym&raw=1","https://www.dropbox.com/scl/fi/4ox8luegl02gy8na97nyw/Bedok-No.086.pdf?rlkey=7949a8axlzz999i2jdgw1tvs5&st=gm1zqxli&raw=1","https://www.dropbox.com/scl/fi/a84ra0c53kqzwxguwyaku/Bedok-No.087.pdf?rlkey=x1jn9b6z5cycbhx6pgjlh2ibw&st=840f2aec&raw=1","https://www.dropbox.com/scl/fi/lov51regja9zuhlp5w24n/Bedok-No.088.pdf?rlkey=m1is3had9upjex0qw8ar9j6l5&st=0j3xsj0y&raw=1","https://www.dropbox.com/scl/fi/drlk92hqo3vw6xxqxbgsu/Bedok-No.089.pdf?rlkey=7bbbuzmdf72do10dz6y4isto9&st=mcrlhncq&raw=1","https://www.dropbox.com/scl/fi/xke9ryd010q3bf18k0vsu/Bedok-No.090.pdf?rlkey=kpo38ksxytmzqwdkptcdfcq2j&st=fxa7skrs&raw=1","https://www.dropbox.com/scl/fi/ezp07qojopaqffwvskbra/Bedok-No.091.pdf?rlkey=8peun7jjopykoo7ooro33y9n7&st=vuwy8vvd&raw=1","https://www.dropbox.com/scl/fi/y4a926t0pnev34ea636q6/Bedok-No.092.pdf?rlkey=3nklrrm0dr3m9xkjr2w8wmzja&st=byfq8q61&raw=1","https://www.dropbox.com/scl/fi/othaim1jrj18p63g6fx6h/Bedok-No.093.pdf?rlkey=vm5h8tq5lagj9hcajo50rmwyu&st=nvgk10z1&raw=1","https://www.dropbox.com/scl/fi/3qzriju4hp8jv7dymv81y/Bedok-No.094.pdf?rlkey=cqbo5l9p1bh3kiv6hmgt3kuq1&st=ugpeppmf&raw=1","https://www.dropbox.com/scl/fi/za31eyvgm9ckzyfvyxs2i/Bedok-No.095.pdf?rlkey=f5d4bhyailpjdnypm3jome85n&st=aibe02in&raw=1","https://www.dropbox.com/scl/fi/vysezjp4vttxai5ni26os/Bedok-No.096.pdf?rlkey=isc5vn1bcnm0zy3m7gl3kny8k&st=vrrhn34o&raw=1","https://www.dropbox.com/scl/fi/0zmytlxxegrvvzr90yajz/Bedok-No.097.pdf?rlkey=j3jpgik7ge46d6nzxiiaiinpr&st=mc754l0w&raw=1","https://www.dropbox.com/scl/fi/t7169usp234zwow1rk1y9/Bedok-No.098.pdf?rlkey=xz77xjust4qjpffyifbknddsf&st=y7t9rygg&raw=1","https://www.dropbox.com/scl/fi/kscqb6o3dtgh2l2hnm7l3/Bedok-No.099.pdf?rlkey=g8wzyrikaep9go4q9ngqlvo7l&st=4f7g6e2y&raw=1","https://www.dropbox.com/scl/fi/qzzpfsw9vcitm2md9mhtb/Bedok-No.100.pdf?rlkey=j8p7ixue3fsir38prdle44uam&st=zlqeg4fp&raw=1","https://www.dropbox.com/scl/fi/5gmk8ijqbk97i3z6if9xk/Bedok-No.101.pdf?rlkey=noxfmt78bkyxgrq2cfssk3996&st=96i0046f&raw=1","https://www.dropbox.com/scl/fi/xjq4l8firia76sdhr15g6/Bedok-No.102.pdf?rlkey=pzhsako9qu37jty6s90zxv1fy&st=nsqyewdu&raw=1","https://www.dropbox.com/scl/fi/iln2fue7x73mkemcdi8np/Bedok-No.103.pdf?rlkey=3q3r1pw8xr241fos0kbgatdnq&st=yabyxrcf&raw=1","https://www.dropbox.com/scl/fi/wq53az279kx36wh8vb7bc/Bedok-No.104.pdf?rlkey=uq56v43kp3ee0ayo3qn1beshr&st=8tyd6qrn&raw=1","https://www.dropbox.com/scl/fi/0070paefnycgrz1uatqnh/Bedok-No.105.pdf?rlkey=3o2bpgvz15tesb7wf7nskkil3&st=no206x2u&raw=1","https://www.dropbox.com/scl/fi/kruezug63183ebzpqrhdh/Bedok-No.106.pdf?rlkey=ups6pm7xkvv9607ik4dmfsad7&st=azfg2fuj&raw=1","https://www.dropbox.com/scl/fi/ef8mur3914objka6xd5kk/Bedok-No.107.pdf?rlkey=p3nhj9m670nddpq5lfcrj63ml&st=v9kledrv&raw=1","https://www.dropbox.com/scl/fi/9in89dtuto12hkgiv8fp5/Bedok-No.108.pdf?rlkey=hx7gctfcp6e7x1j0y57banexy&st=zla29dvr&raw=1","https://www.dropbox.com/scl/fi/o2zvhznytv75vgkb5b10g/Bedok-No.109.pdf?rlkey=vlg8h1e882mawph8ghc7l1y36&st=1pfqpy3c&raw=1","https://www.dropbox.com/scl/fi/kgkspn0kngfvximuz4fkv/Bedok-No.110.pdf?rlkey=1spp9m0dvjbi77juahh2mzio0&st=3d6e9qi5&raw=1"]},"pali":{"commentaries":[5,44,47],"commentariesBooks":["\u1794\u17B6\u179A\u17B6\u1787\u17B7\u1780\u1780\u178E\u17D2\u178C\u200B \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u17B6\u1785\u17B7\u178F\u17D2\u178F\u17B7\u1799 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u17A0\u17B6\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1785\u17BC\u17A1\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u179A\u17B7\u179C\u17B6\u179A \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u17B8\u179B\u1780\u17D2\u1781\u1793\u17D2\u1792\u179C\u1782\u17D2\u1782\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u17A0\u17B6\u179C\u1782\u17D2\u1782\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u17B6\u1790\u17B7\u1780\u179C\u1782\u17D2\u1782\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u17BC\u179B\u1794\u178E\u17D2\u178E\u17B6\u179F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u1787\u17D2\u1788\u17B7\u1798\u1794\u178E\u17D2\u178E\u17B6\u179F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u17A7\u1794\u179A\u17B7\u1794\u178E\u17D2\u178E\u17B6\u179F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u1782\u17B6\u1790\u17B6\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1793\u17B7\u1791\u17B6\u1793\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1781\u1793\u17D2\u1792\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u17A1\u17B6\u1799\u178F\u1793\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u17A0\u17B6\u179C\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 2","\u17AF\u1780\u1780\u1793\u17B7\u1794\u17B6\u178F\u200B \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1791\u17BB\u1780\u178F\u17B7\u1780\u1785\u178F\u17BB\u1780\u17D2\u1780\u1793\u17B7\u1794\u17B6\u178F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u1789\u17D2\u1785\u1780\u1786\u1780\u17D2\u1780\u179F\u178F\u17D2\u178F\u1780\u1793\u17B7\u1794\u17B6\u178F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u17A2\u178A\u17D2\u178B\u1780\u17B6\u1791\u17B7\u1793\u17B7\u1794\u17B6\u178F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1781\u17BB\u1791\u17D2\u1791\u1780\u1794\u17B6\u178B \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1792\u1798\u17D2\u1798\u1794\u1791 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u17A7\u1791\u17B6\u1793 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u17A5\u178F\u17B7\u179C\u17BB\u178F\u17D2\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u17BB\u178F\u17D2\u178F\u1793\u17B7\u1794\u17B6\u178F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1798\u17B6\u1793\u179C\u178F\u17D2\u1790\u17BB \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u17C1\u178F\u179C\u178F\u17D2\u1790\u17BB \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1790\u17C1\u179A\u1782\u17B6\u1790\u17B6 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E1","\u1790\u17C1\u179A\u1782\u17B6\u1790\u17B6 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E2","\u1790\u17C1\u179A\u17B8\u1782\u17B6\u1790\u17B6 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u17A2\u1794\u1791\u17B6\u1793 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1796\u17BB\u1791\u17D2\u1792\u179C\u17C6\u179F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1785\u179A\u17B7\u1799\u17B6\u1794\u17B7\u178A\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E1","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E2","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E3","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E4","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E5","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E6","\u1787\u17B6\u178F\u1780 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8 \u17E7","\u1798\u17A0\u17B6\u1793\u17B7\u1791\u17D2\u1791\u17C1\u179F\u200B \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1785\u17BC\u17A1\u1793\u17B7\u1791\u17D2\u1791\u17C1\u179F \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u178A\u17B7\u179F\u1798\u17D2\u1797\u17B7\u1791\u17B6\u1798\u1782\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1793\u17C1\u178F\u17D2\u178F\u17B7\u1794\u17D2\u1794\u1780\u179A\u178E \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1792\u1798\u17D2\u1798\u179F\u1784\u17D2\u1782\u178E\u17B8 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1797\u1784\u17D2\u1782 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u1789\u17D2\u1785\u1794\u1780\u179A\u178E \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8"],"commentaries2":[13,32,41],"commentariesBooks2":["\u179F\u17B6\u179A\u178F\u17D2\u1790\u1791\u17B8\u1794\u1793\u17B8 \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8 \u17E1","\u179F\u17B6\u179A\u178F\u17D2\u1790\u1791\u17B8\u1794\u1793\u17B8 \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8 \u17E2","\u179F\u17B6\u179A\u178F\u17D2\u1790\u1791\u17B8\u1794\u1793\u17B8 \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8 \u17E3","\u1791\u17D2\u179C\u17C1\u1798\u17B6\u178F\u17B7\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1793\u1799\u179F\u1784\u17D2\u1782\u17A0 \u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u1787\u17B7\u179A\u1796\u17BB\u1791\u17D2\u1792\u17B7 \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1798\u178F\u17B7\u179C\u17B7\u1793\u17C4\u1791\u1793\u17B8 \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1793\u1799\u17B6\u179B\u1784\u17D2\u1780\u17B6\u179A \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1780\u1784\u17D2\u1781\u17B6\u179C\u17B7\u178F\u179A\u178E\u17B8 \u1794\u17BB\u179A\u17B6\u178E\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1793\u1799\u179C\u17B7\u1793\u17B7\u1785\u17D2\u1786\u1799 \u17A7\u178F\u17D2\u178F\u179A\u179C\u17B7\u1793\u17B7\u1785\u17D2\u1786\u1799 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1793\u1799\u179C\u17B7\u1793\u17B7\u1785\u17D2\u1786\u1799 \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u17B6\u1785\u17B7\u178F\u17D2\u1799\u17B6\u1791\u17B7\u1799\u17C4\u1787\u1793\u17B6 \u1794\u17B6\u179B\u17B8","\u1781\u17BB\u1791\u17D2\u1791\u179F\u17B7\u1780\u17D2\u1781\u17B6 \u1798\u17BC\u179B\u179F\u17B7\u1780\u17D2\u1781\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u17B8\u179B\u1780\u17D2\u1781\u1793\u17D2\u1792\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u17A0\u17B6\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u17B6\u1790\u17B7\u1780\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u17B8\u179B\u1780\u17D2\u1781\u1793\u17D2\u1792\u179C\u1782\u17D2\u1782\u17A2\u1797\u17B7\u1793\u179C\u178A\u17B8\u1780\u17B6  \u1794\u17B6\u179B\u17B8 \u17E1","\u179F\u17B8\u179B\u1780\u17D2\u1781\u1793\u17D2\u1792\u179C\u1782\u17D2\u1782\u17A2\u1797\u17B7\u1793\u179C\u178A\u17B8\u1780\u17B6  \u1794\u17B6\u179B\u17B8 \u17E2","\u1798\u17BC\u179B\u1794\u178E\u17D2\u178E\u17B6\u179F\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u1787\u17D2\u1788\u17B7\u1798\u1794\u178E\u17D2\u178E\u17B6\u179F\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u17A7\u1794\u179A\u17B7\u1794\u178E\u17D2\u178E\u17B6\u179F\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u1782\u17B6\u1790\u17B6\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1793\u17B7\u1791\u17B6\u1793\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1781\u1793\u17D2\u1792\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179F\u17A1\u17B6\u1799\u178F\u1793\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1798\u17A0\u17B6\u179C\u1782\u17D2\u1782\u178A\u17B8\u1780\u17B6","\u17AF\u1780\u1780\u1793\u17B7\u1794\u17B6\u178F \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1791\u17BB\u1780\u178F\u17B7\u1780\u1785\u178F\u17BB\u1780\u17D2\u1780\u1793\u17B7\u1794\u17B6\u178F \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u1789\u17D2\u1785\u1780\u1786\u1780\u17D2\u1780\u179F\u178F\u17D2\u178F\u1780\u1793\u17B7\u1794\u17B6\u178F \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u17A2\u178A\u17D2\u178B\u1780\u17B6\u1791\u17B7\u1793\u17B7\u1794\u17B6\u178F \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1793\u17C1\u178F\u17D2\u178F\u17B7\u1794\u17D2\u1794\u1780\u179A\u178E \u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1793\u17C1\u178F\u17D2\u178F\u17B7\u179C\u17B7\u1797\u17B6\u179C\u17B7\u1793\u17B8 \u1794\u17B6\u179B\u17B8","\u1792\u1798\u17D2\u1798\u179F\u1784\u17D2\u1782\u178E\u17B8 \u1798\u17BC\u179B\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u179C\u17B7\u1797\u1784\u17D2\u1782 \u1798\u17BC\u179B\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1794\u1789\u17D2\u1785\u1794\u1780\u179A\u178E \u1798\u17BC\u179B\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1792\u1798\u17D2\u1798\u179F\u1784\u17D2\u1782\u178E\u17B8 \u17A2\u1793\u17BB\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u1792\u17B6\u178F\u17BB\u1780\u1790\u17B6 \u1794\u1789\u17D2\u1785\u1794\u1780\u179A\u178E \u17A2\u1793\u17BB\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798\u17B6\u179C\u178F\u17B6\u179A\u17C4 \u1793\u17B6\u1798\u179A\u17BC\u1794\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791\u17C4 \u1794\u179A\u1798\u178F\u17D2\u1790\u179C\u17B7\u1793\u17B7\u1785\u17D2\u1786\u1799\u17C4 \u179F\u1785\u17D2\u1785\u179F\u1784\u17D2\u1781\u17C1\u1794\u17C4 \u1794\u17B6\u179B\u17B8","\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798\u178F\u17D2\u1790\u179F\u1784\u17D2\u1782\u17A0\u17C4 \u1794\u17B6\u179B\u17B8","\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798\u17B6\u179C\u178F\u17B6\u179A\u200B \u1794\u17BB\u179A\u17B6\u178E\u178A\u17B8\u1780\u17B6 \u1794\u17B6\u179B\u17B8","\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798\u1798\u17B6\u178F\u17B7\u1780\u17B6 \u1794\u17B6\u179B\u17B8"]}}');


const $643ca2f9ceb5ab8e$var$bedok = (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)));
class $643ca2f9ceb5ab8e$export$5654cbf08d7911f3 extends (0, $jaOzc.default) {
    constructor(){
        super("Books"), this.language = "khmer";
        this.version(parseInt((0, $8f13b60c0ee5b277$exports.version))).stores({
            books: "++id, book, language"
        }).upgrade((tx)=>{
        // TODO: later delete old version of dexie
        // return tx
        //     .table("books")
        //     .toCollection()
        //     .modify((book) => {});
        });
        this.books = this.table("books");
    }
    async get(book) {
        const item = await this.books.where("book").equals(book).first();
        return item ? item.language : null;
    }
    async update(book, language) {
        const item = await this.books.where("book").equals(book).first();
        if (item) {
            item.language = language;
            return this.books.update(item.id, item);
        } else return this.books.add({
            book: book,
            language: language
        });
    }
    async remove(book) {
        const item = await this.books.where("book").equals(book).first();
        return this.books.delete(item.id);
    }
    ///
    getBasket(book) {
        for(let index = 0; index < $643ca2f9ceb5ab8e$var$bedok[this.language].baskets.length; index++){
            const basket = $643ca2f9ceb5ab8e$var$bedok[this.language].baskets[index];
            if (book <= basket + 1) return index;
        }
        return -1; // Return a default value if no basket is found
    }
}






const $a8f85081255e9993$var$template = document.createElement("template");
$a8f85081255e9993$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <div
        id="sw-footer"
        class="fixed z-40 w-full overflow-y-auto bg-white border-t border-gray-200 rounded-t-lg dark:border-gray-700 dark:bg-gray-800 transition-transform left-0 right-0 translate-y-full bottom-[70px]"
        tabindex="-1"
        aria-labelledby="sw-footer-label">
        <div
            class="text-center pt-7 p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700"
            onclick="heartbank.alertAdmin('footer/click/toggle')"
            data-drawer-hide2="sw-menu"
            data-drawer-hide="sw-toc"
            data-drawer-toggle="sw-footer">
            <span
                class="absolute w-8 h-1 -translate-x-1/2 bg-gray-300 rounded-lg top-3 left-1/2 dark:bg-gray-600"></span>
            <aside class="flex flex-row justify-around items-center">
                <svg
                    class="w-7 h-7 fill-theme"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512">
                    <path
                        d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                </svg>
                <span
                    id="sw-footer-label"
                    class="moul text-base font-semibold text-gray-500 dark:text-gray-400"
                    >Silicon Wat
                </span>
                <svg
                    class="w-7 h-7 fill-theme"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512">
                    <path
                        d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                </svg>
            </aside>
        </div>
        <div
            class="text-base font-medium grid grid-cols-3 gap-4 p-4 lg:grid-cols-3">
            <button
                id="sw-footer-read"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.read)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M256 152a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm0 298.7l0-149.3c16.3-6.8 32.9-13.7 49.7-20.7 39-16.2 80.8-24.6 123.1-24.6l19.2 0 0 160-19.2 0c-59.1 0-117.7 11.7-172.3 34.5l-.5 .2zM256 232l-25.1-10.5C184.1 202 133.9 192 83.2 192L48 192c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l35.2 0c50.7 0 100.9 10 147.7 29.5l12.8 5.3c7.9 3.3 16.7 3.3 24.6 0l12.8-5.3c46.8-19.5 97-29.5 147.7-29.5l35.2 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-35.2 0c-50.7 0-100.9 10-147.7 29.5L256 232z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.read)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="sw-footer-readership"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.map)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1C172.7 359 160 337 160 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zM96 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 240l0 32c0 32.5 12.1 62.1 32 84.7l0 75.3c0 1.2 0 2.5 .1 3.7-8.5 7.6-19.7 12.3-32.1 12.3l-32 0c-26.5 0-48-21.5-48-48l0-56.6C12.9 364.4 0 343.7 0 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1zM368 464l0-75.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 56.6c0 26.5-21.5 48-48 48l-32 0c-12.3 0-23.6-4.6-32.1-12.3 0-1.2 .1-2.5 .1-3.7zM416 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.map)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="sw-footer-learn"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.learn)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 448 512">
                        <path
                            d="M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48L96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32zM310.6 208L279 208c-1.4 23.1-6 44.2-12.6 61.2 22.7-12.5 39.4-34.8 44.2-61.2zm-173.1 0c4.8 26.4 21.5 48.7 44.2 61.2-6.7-17-11.2-38-12.6-61.2l-31.6 0zm76.4 55c4.5 9.6 8.2 13.8 10.2 15.5 2-1.7 5.7-5.8 10.2-15.5 6.2-13.4 11.1-32.5 12.7-55l-45.8 0c1.6 22.5 6.5 41.6 12.7 55zm-12.7-87l45.8 0c-1.6-22.5-6.5-41.6-12.7-55-4.5-9.6-8.2-13.8-10.2-15.5-2 1.7-5.7 5.8-10.2 15.5-6.2 13.4-11.1 32.5-12.7 55zm109.5 0c-4.8-26.4-21.5-48.7-44.2-61.2 6.7 17 11.2 38 12.6 61.2l31.6 0zM169 176c1.4-23.1 6-44.2 12.6-61.2-22.7 12.5-39.4 34.8-44.2 61.2l31.6 0zM96 192a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.learn)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="sw-footer-share"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.share)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.share)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="pali"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.pali2)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 576 512">
                        <path
                            d="M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5l0-377.4c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8L0 454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5l0-370.3c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11L304 456c0 11.4 11.7 19.3 22.4 15.5z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.pali2)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="map"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.map)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1C172.7 359 160 337 160 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zM96 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 240l0 32c0 32.5 12.1 62.1 32 84.7l0 75.3c0 1.2 0 2.5 .1 3.7-8.5 7.6-19.7 12.3-32.1 12.3l-32 0c-26.5 0-48-21.5-48-48l0-56.6C12.9 364.4 0 343.7 0 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1zM368 464l0-75.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 56.6c0 26.5-21.5 48-48 48l-32 0c-12.3 0-23.6-4.6-32.1-12.3 0-1.2 .1-2.5 .1-3.7zM416 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.map)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="khmer"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.khmer2)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 576 512">
                        <path
                            d="M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5l0-377.4c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8L0 454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5l0-370.3c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11L304 456c0 11.4 11.7 19.3 22.4 15.5z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.khmer2)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="sw-footer-history"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.history)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 576 512">
                        <path
                            d="M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.history)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="sw-footer-leaderboard"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.leaderboard)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 576 512">
                        <path
                            d="M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152l0 270.8c0 9.8-6 18.6-15.1 22.3L416 503l0-302.6zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6l0 251.4L32.9 502.7C17.1 509 0 497.4 0 480.4L0 209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77l0 249.3L192 449.4 192 255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.leaderboard)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="sw-footer-now"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.now)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 384 512">
                        <path
                            d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.now)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="dark"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.dark)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 384 512">
                        <path
                            d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.dark)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="auto"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.auto)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.auto)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="light"
                onclick="heartbank.alertAdmin('footer/click/${(0, $cf95765ca3532985$exports.light)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                class="p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 512 512">
                        <path
                            d="M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.light)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="previous"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 448 512">
                        <path
                            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.previous)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="bookmark"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 384 512">
                        <path
                            d="M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.bookmark)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
            <button
                id="next"
                class="hidden p-4 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:hover:bg-gray-600 dark:bg-gray-700">
                <div
                    class="flex justify-center items-center p-2 mx-auto mb-2 bg-gray-200 dark:bg-gray-600 rounded-full w-[48px] h-[48px] max-w-[48px] max-h-[48px]">
                    <svg
                        class="inline w-5 h-5 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 448 512">
                        <path
                            d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                    </svg>
                </div>
                <div class="text-center text-gray-500 dark:text-gray-400">
                    ${(0, $cf95765ca3532985$exports.next)[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </div>
            </button>
        </div>
    </div>
    <audio class="hidden"></audio>
`;
var $a8f85081255e9993$export$2e2bcd8739ae039 = $a8f85081255e9993$var$template;




const $329112fc103c3dc3$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $329112fc103c3dc3$export$ed61263647200ec7 extends HTMLElement {
    constructor(){
        super(), this.books = new (0, $643ca2f9ceb5ab8e$export$5654cbf08d7911f3)(), this.header = document.querySelector("sw-header"), this.page = document.querySelector("sw-page"), this.swKhmer = document.querySelector("sw-reader[lang=khmer]"), this.swPali = document.querySelector("sw-reader[lang=pali]");
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-footer");
        this.componentTrace.start();
        this.appendChild((0, $a8f85081255e9993$export$2e2bcd8739ae039).content.cloneNode(true));
        this.tabBar = this.querySelector("#sw-footer");
        this.pali = this.querySelector("#pali");
        this.map = this.querySelector("#map");
        this.khmer = this.querySelector("#khmer");
        this.read = this.querySelector("#sw-footer-read");
        this.readership = this.querySelector("#sw-footer-readership");
        this.share = this.querySelector("#sw-footer-share");
        this.learn = this.querySelector("#sw-footer-learn");
        this.history = this.querySelector("#sw-footer-history");
        this.leaderboard = this.querySelector("#sw-footer-leaderboard");
        this.now = this.querySelector("#sw-footer-now");
        this.light = this.querySelector("#light");
        this.dark = this.querySelector("#dark");
        this.auto = this.querySelector("#auto");
        this.previous = this.querySelector("#previous");
        this.next = this.querySelector("#next");
        this.bookmark = this.querySelector("#bookmark");
        this.audio = this.querySelector("audio");
        const options = {
            placement: "bottom",
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: "bottom-[100px]",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
            onHide: ()=>{
                this.tabBar.classList.replace("bottom-0", "bottom-[70px]");
            },
            onShow: ()=>{
                this.tabBar.classList.replace("bottom-[70px]", "bottom-0");
            },
            onToggle: ()=>{}
        };
        // instance options object
        const instanceOptions = {
            id: "sw-footer",
            override: true
        };
        this.drawer = new (0, $4d66f8052cdbfb83$export$2e2bcd8739ae039)(this.tabBar, options, instanceOptions);
    }
    connectedCallback() {
        this.render();
        this.addHomeListeners();
        this.addPageListeners();
        this.addMapListeners();
        this.addPagingListeners();
        this.addColorSchemeListeners();
        this.addNetworkListeners();
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    show() {
        this.classList.remove("hidden");
    }
    hide() {
        this.classList.add("hidden");
    }
    showHome() {
        this.read.classList.remove("hidden");
        this.readership.classList.remove("hidden");
        this.learn.classList.remove("hidden");
        //this.share.classList.remove("hidden");
        this.pali.classList.add("hidden");
        this.map.classList.add("hidden");
        this.khmer.classList.add("hidden");
        this.history.classList.add("hidden");
        this.leaderboard.classList.add("hidden");
        this.now.classList.add("hidden");
    }
    showPage() {
        this.read.classList.add("hidden");
        this.readership.classList.add("hidden");
        this.learn.classList.add("hidden");
        //this.share.classList.add("hidden");
        this.pali.classList.remove("hidden");
        this.map.classList.remove("hidden");
        this.khmer.classList.remove("hidden");
        this.history.classList.add("hidden");
        this.leaderboard.classList.add("hidden");
        this.now.classList.add("hidden");
    }
    showMap() {
        this.read.classList.add("hidden");
        this.readership.classList.add("hidden");
        this.learn.classList.add("hidden");
        //this.share.classList.add("hidden");
        this.pali.classList.add("hidden");
        this.map.classList.add("hidden");
        this.khmer.classList.add("hidden");
        this.history.classList.remove("hidden");
        this.leaderboard.classList.remove("hidden");
        this.now.classList.remove("hidden");
    }
    render() {
        if (localStorage.colorScheme === "dark") document.documentElement.classList.add("dark");
        else if (localStorage.colorScheme === "light") document.documentElement.classList.remove("dark");
        else if (window.matchMedia("(prefers-color-scheme: dark)").matches) document.documentElement.classList.add("dark");
        else document.documentElement.classList.remove("dark");
    }
    addHomeListeners() {
        this.read.addEventListener("click", async ()=>{
            this.drawer.hide();
            window.location.hash = "#bookmark";
        });
        this.readership.addEventListener("click", ()=>{
            this.drawer.hide();
            window.location.hash = "#readership";
        });
        this.learn.addEventListener("click", ()=>{
            const toc = document.querySelector("sw-toc");
            toc.show("pali", 1, 1);
            this.drawer.hide();
        });
        this.share.addEventListener("click", async ()=>{
            const code = document.querySelector("#qr_code").parentElement;
            code.click();
        });
    }
    addPageListeners() {
        this.pali.addEventListener("click", async ()=>{
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            await this.books.update(book, "pali");
            this.page.goTo(book, page);
            //const pali = document.getElementById("sw-pali-body") as HTMLElement;
            //navigator.clipboard.writeText(pali.innerText);
            this.swPali.show();
        });
        this.map.addEventListener("click", ()=>{
            this.drawer.hide();
            window.location.hash = "#readership";
        });
        this.khmer.addEventListener("click", async ()=>{
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            await this.books.update(book, "khmer");
            this.page.goTo(book, page);
            // const khmer = document.getElementById(
            //     "sw-khmer-body"
            // ) as HTMLElement;
            //navigator.clipboard.writeText(khmer.innerText);
            this.swKhmer.show();
        });
    }
    addMapListeners() {
        const map = document.querySelector("sw-map");
        this.now.addEventListener("click", ()=>{
            this.header.showMap("now");
            map.show("now");
            this.drawer.hide();
        });
        this.leaderboard.addEventListener("click", ()=>{
            this.header.showMap("leaderboard");
            map.show("leaderboard");
            this.drawer.hide();
        });
        this.history.addEventListener("click", ()=>{
            this.header.showMap("history");
            map.show("history");
            this.drawer.hide();
        });
    }
    //deprecated: safari does not allow
    async checkClipboardPermission() {
        try {
            const result = await navigator.permissions.query({
                name: "clipboard-read"
            });
            return result.state === "granted" || result.state === "prompt";
        } catch (err) {
            console.warn("Clipboard permission check failed: ", err);
            return false;
        }
    }
    // deprecated
    isAudioPlaying() {
        return !this.audio.paused && !this.audio.ended && this.audio.currentTime > 0;
    }
    // deprecated
    // private addAiListeners() {
    //     this.speak.addEventListener("click", async () => {
    //         //TODO: later use api? or better ai model?
    //         // if (this.isAudioPlaying()) {
    //         //     this.audio.pause();
    //         // } else {
    //         //     const text = await navigator.clipboard.readText();
    //         //     const baseUrl = "https://translate.google.com/translate_tts";
    //         //     const params = new URLSearchParams({
    //         //         ie: "UTF-8",
    //         //         tl: "km",
    //         //         q: text,
    //         //         client: "tw-ob"
    //         //     });
    //         //     this.audio.src = `${baseUrl}?${params.toString()}`;
    //         //     this.audio.play();
    //         // }
    //         let text;
    //         try {
    //             text = await navigator.clipboard.readText();
    //         } catch {
    //             text = "";
    //         }
    //         const encodedText = encodeURIComponent(text);
    //         const translateUrl = `https://translate.google.com/?sl=auto&tl=${strings.language[LANGUAGE]}&text=${encodedText}&op=translate`;
    //         window.open(translateUrl, "_blank");
    //     });
    //     this.tipitaka.addEventListener("click", () => {
    //         //window.open("https://tipitaka.org/khmr/", "_blank");
    //         this.dispatchEvent(
    //             new CustomEvent<{ info: string }>("sw-banner", {
    //                 bubbles: true,
    //                 detail: {
    //                     info: strings.soon[LANGUAGE]
    //                 }
    //             })
    //         );
    //     });
    //     this.buddha.addEventListener("click", async () => {
    //         let text;
    //         try {
    //             text = await navigator.clipboard.readText();
    //         } catch {
    //             text = "";
    //         }
    //         const baseUrl = "https://gemini.google.com/";
    //         const encodedPrompt = encodeURIComponent(text);
    //         const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
    //         window.open(url, "_blank");
    //     });
    // }
    // deprecated
    addPagingListeners() {
        this.previous.addEventListener("click", ()=>{
            this.page.pageTo2(false);
            this.drawer.hide();
        //logEvent(analytics, "page", { to: "previous" });
        });
        this.next.addEventListener("click", ()=>{
            this.page.pageTo2(true);
            this.drawer.hide();
        //logEvent(analytics, "page", { to: "next" });
        });
        this.bookmark.addEventListener("click", (event)=>{
            this.header.updateBookmark(true);
            this.drawer.hide();
        //logEvent(analytics, "bookmark", { at: "top" });
        });
    }
    addColorSchemeListeners() {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (event)=>{
            this.render();
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "color", {
                scheme: "dark"
            });
        });
        this.light.addEventListener("click", (event)=>{
            //localStorage.colorScheme = "light";
            localStorage.setItem("colorScheme", "light");
            this.render();
            this.drawer.hide();
            this.dispatchColorSchemeEvent("light");
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "color", {
                scheme: "light"
            });
        });
        this.dark.addEventListener("click", (event)=>{
            //localStorage.colorScheme = "dark";
            localStorage.setItem("colorScheme", "dark");
            this.render();
            this.drawer.hide();
            this.dispatchColorSchemeEvent("dark");
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "color", {
                scheme: "dark"
            });
        });
        this.auto.addEventListener("click", (event)=>{
            //localStorage.colorScheme = "system";
            localStorage.setItem("colorScheme", "system");
            this.render();
            this.drawer.hide();
            this.dispatchEvent(new CustomEvent("sw-alert", {
                bubbles: true,
                detail: {
                    info: $329112fc103c3dc3$var$strings.automatic[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
                }
            }));
            this.dispatchColorSchemeEvent("system");
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "color", {
                scheme: "auto"
            });
        });
    }
    addNetworkListeners() {
        if (!navigator.onLine) this.showNetwork(false);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "network", {
            status: navigator.onLine
        });
        window.addEventListener("offline", (event)=>this.showNetwork(false));
        window.addEventListener("online", (event)=>this.showNetwork(true));
    }
    showNetwork(isOnline) {
        this.dispatchEvent(new CustomEvent("sw-alert", {
            bubbles: true,
            detail: {
                info: isOnline ? $329112fc103c3dc3$var$strings.online[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] : $329112fc103c3dc3$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                reload: false //isOnline
            }
        }));
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "network", {
            status: isOnline
        });
    }
    dispatchColorSchemeEvent(colorScheme) {
        this.dispatchEvent(new CustomEvent("sw-color-scheme", {
            bubbles: true,
            detail: {
                colorScheme: colorScheme
            }
        }));
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "color", {
            scheme: colorScheme
        });
    }
}









const $4f76a599599b7129$var$template = document.createElement("template");
$4f76a599599b7129$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <div
        id="sw-alert"
        onclick="heartbank.alertAdmin('footer/hide/alert')"
        tabindex="-1"
        class="transform translate-y-full transition-all duration-500 ease-out fixed bottom-0 start-0 z-[999] flex justify-between w-full p-4 border-t border-gray-200 dark:border-gray-600 bg-green-200">
        <div class="flex items-center mx-auto">
            <p
                id="sw-alert-info"
                class="flex items-center text-lg font-normal text-gray-500 dark:text-gray-400"></p>
        </div>
        <div class="flex items-center">
            <button
                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                id="sw-alert-hide"
                data-dismiss-target2="#sw-alert"
                type="button"
                class="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 dark:hover:bg-gray-600 dark:hover:text-white">
                <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14">
                    <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
                <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
            </button>
        </div>
    </div>
`;
var $4f76a599599b7129$export$2e2bcd8739ae039 = $4f76a599599b7129$var$template;


class $baf38953c49a7eef$export$f3ec452615fb1571 extends HTMLElement {
    //private hide: HTMLElement;
    constructor(){
        super(), this.timer = 0;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-alert");
        this.componentTrace.start();
        this.appendChild((0, $4f76a599599b7129$export$2e2bcd8739ae039).content.cloneNode(true));
        this.banner = this.querySelector("#sw-alert");
        this.info = this.querySelector("#sw-alert-info");
    //this.hide = this.querySelector("#sw-alert-hide")!;
    }
    connectedCallback() {
        this.addEventListener("click", (event)=>this.hideBanner(0));
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    showBanner(info, reload = false) {
        this.info.textContent = info;
        clearTimeout(this.timer);
        this.timer = window.setTimeout(()=>{
            this.banner.classList.remove("translate-y-full");
            this.hideBanner(10000, reload);
        }, 500);
    }
    // reload needed for the browser to clear the default cache for images
    hideBanner(duration, reload = false) {
        clearTimeout(this.timer);
        this.timer = window.setTimeout(()=>{
            if (reload) window.location.reload();
            else this.banner.classList.add("translate-y-full");
        }, duration);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "close", {
            banner: "bottom"
        });
    }
}







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$y(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$P(t, i) {
    if (!$e5ed8027d647799b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$V(t, s);
        if (this.el = $e5ed8027d647799b$var$N.createElement(f, n), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$H : "?" === e[1] ? $e5ed8027d647799b$var$I : "@" === e[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$C.currentNode = e;
        let h = $e5ed8027d647799b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$C.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.O($e5ed8027d647799b$var$l()), this.O($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$S(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$S(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$S(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$e,
    P: $e5ed8027d647799b$var$h,
    A: $e5ed8027d647799b$var$o,
    C: 1,
    L: $e5ed8027d647799b$var$V,
    R: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$k,
    N: $e5ed8027d647799b$var$I,
    U: $e5ed8027d647799b$var$L,
    B: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$j?.($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.3.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




var $db4e1edfbfae27ad$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-donate"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-base md:text-xl font-semibold text-theme">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).donateTitle[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </h3>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-donate">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    class="p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    ${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<p>
                                  យើងខ្ញុំសូមអំពាវនាវដល់សប្បុរសជនគ្រប់លំដាប់ថ្នាក់
                                  មេត្តាជួយគាំទ្រគំរោងព្រះត្រៃបិដកអេអាយអនឡាញឲ្យមានគុណភាព
                                  និងប្រសិទ្ធិភាពខ្ពស់
                                  ដោយផ្តល់នូវការបរិច្ចាគឧបត្ថម្ភ
                                  ដល់ក្រុមយើងខ្ញុំតាមកម្លាំង និងសទ្ធា។
                              </p>
                              <p>
                                  ការបរិច្ចាគឧបត្ថម្ភរបស់អ្នក
                                  គឺជាការជួយធ្វើឲ្យផ្នែកព្រះពុទ្ធសាសនាមានការផ្សព្វផ្សាយទូលំទូលាយ
                                  ទៅដល់ពុទ្ធសាសនិកនៅក្នុងព្រះរាជាណាចក្រកម្ពុជា
                                  និងបរទេស ។ មិនត្រឹមប៉ុណ្ណោះទេ
                                  ថែមទាំងជួយការអភិវឌ្ឍន៍តាមបណ្តាញ​អេអាយ​អ​នឡានឲ្យល្អប្រសើរ
                                  និងជួយឲ្យក្រុមយើងខ្ញុំ មានកម្លាំចិត្ត
                                  និងលទ្ធភាពអាចទិញឧបករណ៍បច្ចេកវិទ្យាអេឡិចត្រូនិចផ្សេងៗ
                                  ដើម្បីយកមកប្រើប្រាសក្នុងគំរោង​​ឲ្យ​កាន់តែល្អ​​ទំនើប​និង​ទាន់​សម័យជាង​មុន​។
                              </p>
                              <p>
                                  ការចូលរួមបរិច្ចាគរបស់អ្នក
                                  គឺជាធម្មទានដ៏ល្អបំផុត
                                  និងជាទានឈ្នះអស់ទានទាំងពួង
                                  ព្រោះការចូលរួមរបស់អ្នក​ជាការចែករំលែកព្រះធម៌ដែលព្រះសម្មាសម្ពុទ្ធបានសម្តែង
                                  ដល់អ្នកកំពុងចង់ដឹង ចង់ចេះ និងចង់យល់ពីធម៌។
                              </p>
                              <p>
                                  ក្រុមយើងខ្ញុំ សូមថ្លែងអំណរគុណដ៏ជ្រាលជ្រៅបំផុត
                                  ដល់ការចូលរួមចំណែក
                                  ក្នុងការធ្វើឲ្យគំរោងអេអាយអនឡាញនេះ
                                  ទទួលបានជោគជ័យ។
                              </p>` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<p>
                                  We sincerely appeal to all generous
                                  individuals to support our online AI Tipitaka
                                  project in improving its quality and
                                  effectiveness by providing donations to our
                                  team according to your means and faith.
                              </p>
                              <p>
                                  Your contributions will not only help enhance
                                  the development of our online platform but
                                  also empower our team with the resources and
                                  ability to acquire advanced technological
                                  equipment to implement and operate the project
                                  more effectively and in line with modern
                                  digital AI advancements.
                              </p>
                              <p>
                                  Your participation in this donation is the
                                  most virtuous act of giving and the ultimate
                                  form of generosity, as it reflects the sharing
                                  of the Dhamma that the Buddha has taught to
                                  those seeking knowledge and understanding of
                                  the truth.
                              </p>
                              <p>
                                  Our team would like to express our deepest
                                  gratitude for your participation in making
                                  this online AI project a success.
                              </p>`}
                </div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        onclick="heartbank.alertAdmin('donate/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).donate2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        id="sw-donate-cash"
                        type="button"
                        class="text-white w-32 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).donate2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <a
                        onclick="heartbank.alertAdmin('donate/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).donate1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        href="https://donate.stripe.com/aEU4h37GsfgufBK6oo?locale=km&prefilled_promo_code=333&client_reference_id=${user ? user.uid : ""}&prefilled_email=${user ? encodeURIComponent(user.email) : ""}"
                        target="_blank"
                        data-modal-hide2="sw-donate"
                        type="button"
                        class="text-white w-32 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).donate1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </a>
                    <button
                        data-modal-hide="sw-donate"
                        type="button"
                        class="hidden text-white w-24 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
                <section
                    class="w-full my-3 pb-2 inline-flex items-center justify-center">
                    <aside
                        id="sw-donate-hb"
                        onclick="heartbank.alertAdmin('donate/click/heartbank')"
                        class="cursor-pointer moul self-end text-base font-extralight whitespace-nowrap text-gray-500 dark:text-gray-400">
                        Heart
                        <svg
                            class="mt-[-4px] ml-[-8px] mr-[-4px] inline fill-hb"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="25"
                            height="25">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank<sup>®</sup>
                    </aside>
                </section>
            </div>
        </div>
    </div>
`;





const $bcab9eb2e463f54c$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $bcab9eb2e463f54c$export$fb80907d5f96b687 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.popup = document.querySelector("sw-popup"), this.code = document.querySelector("sw-code");
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-donate");
        this.componentTrace.start();
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $db4e1edfbfae27ad$export$2e2bcd8739ae039)(null), this);
        this.cash = this.querySelector("#sw-donate-cash");
        this.hb = this.querySelector("#sw-donate-hb");
    }
    connectedCallback() {
        this.cash.addEventListener("click", ()=>{
            alert($bcab9eb2e463f54c$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        //this.popup.openHB.bind(this, "", false); //TODO: add sw thank link
        });
        this.hb.addEventListener("click", ()=>{
            this.popup.openHB("", true); //TODO: add sw org link
        //this.code.show("donate");
        });
        this.heartbank.addAuthStateListener3((hero)=>{
            (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $db4e1edfbfae27ad$export$2e2bcd8739ae039)(hero), this);
        });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    // TODO: ?
    async handleMessageFromPopup(data) {
        data.action;
    }
}





class $f76271ebfe467595$export$2ddb2ffa4475b711 {
    constructor(firestore = null){
        this.fs = firestore || (0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4);
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(this.fs, "feedbacks");
    }
    async count() {
        const snapshot = await (0, $70fd6868680e912c$export$b1de1b12889d0afb)(this.collection);
        return snapshot.data().count;
    }
    // CREATE - Add new feedback
    async createFeedback(feedback) {
        try {
            const feedbackData = {
                createdAt: new Date(),
                ...feedback
            };
            const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, feedbackData);
            const newFeedback = {
                id: docRef.id,
                ...feedbackData
            };
            return {
                status: "success",
                feedback: newFeedback
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // READ - Get a single feedback by ID
    async getFeedback(id) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.fs, "feedbacks", id);
            const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
            if (docSnap.exists()) return {
                status: "success",
                feedback: {
                    id: docSnap.id,
                    ...docSnap.data()
                }
            };
            return {
                status: "success"
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // READ - Get all feedbacks
    async getAllFeedbacks() {
        try {
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(this.collection);
            const feedbacks = [];
            querySnapshot.forEach((doc)=>{
                feedbacks.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return {
                status: "success",
                feedbacks: feedbacks
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // READ - Get feedbacks by user ID
    async getFeedbacksByUser(userId) {
        try {
            const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("userId", "==", userId));
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            const feedbacks = [];
            querySnapshot.forEach((doc)=>{
                feedbacks.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return {
                status: "success",
                feedbacks: feedbacks
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // READ - Get feedbacks by rating
    async getFeedbacksByRating(rating) {
        try {
            const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("rating", "==", rating));
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            const feedbacks = [];
            querySnapshot.forEach((doc)=>{
                feedbacks.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            return {
                status: "success",
                feedbacks: feedbacks
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // UPDATE - Update feedback
    async updateFeedback(id, updates) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.fs, "feedbacks", id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, updates);
            return {
                status: "success"
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
    // DELETE - Delete feedback
    async deleteFeedback(id) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(this.fs, "feedbacks", id);
            await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(docRef);
            return {
                status: "success"
            };
        } catch (error) {
            return {
                status: "error",
                message: error.message
            };
        }
    }
} // Example usage:
 // async function example() {
 //     const db = {} as Firestore; // Replace with your Firestore instance
 //     const feedbackService = new FeedbackService(db);
 //     try {
 //         // Assuming you have a logged-in user with an ID
 //         const userId = "user123";
 //         // Create
 //         const newFeedback = await feedbackService.createFeedback(userId, {
 //             rating: 4,
 //             message: "Great experience!"
 //         });
 //         console.log("Created:", newFeedback);
 //         // Read single
 //         const feedback = await feedbackService.getFeedback(newFeedback.id!);
 //         console.log("Single feedback:", feedback);
 //         // Read all
 //         const allFeedbacks = await feedbackService.getAllFeedbacks();
 //         console.log("All feedbacks:", allFeedbacks);
 //         // Read by user
 //         const userFeedbacks = await feedbackService.getFeedbacksByUser(userId);
 //         console.log("User feedbacks:", userFeedbacks);
 //         // Read by rating
 //         const fourStarFeedbacks = await feedbackService.getFeedbacksByRating(4);
 //         console.log("4-star feedbacks:", fourStarFeedbacks);
 //         // Update
 //         await feedbackService.updateFeedback(newFeedback.id!, {
 //             rating: 5,
 //             message: "Updated: Excellent experience!"
 //         });
 //         console.log("Updated feedback");
 //         // Delete
 //         await feedbackService.deleteFeedback(newFeedback.id!);
 //         console.log("Deleted feedback");
 //     } catch (error) {
 //         console.error("Error in example:", error);
 //     }
 // }











var $02dc22ea9501c9ef$export$2e2bcd8739ae039 = (hero)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-feedback"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-lg max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-2xl font-semibold text-theme">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </h3>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-feedback">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form class="p-4 md:p-5">
                    <div class="grid gap-4 mb-4 grid-cols-2">
                        <div
                            class="my-5 col-span-2 flex items-center justify-center">
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/1')"
                                id="sw-star-1"
                                class="star w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/2')"
                                id="sw-star-2"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/3')"
                                id="sw-star-3"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/4')"
                                id="sw-star-4"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                            <svg
                                onclick="heartbank.alertAdmin('feedback/click/stars/5')"
                                id="sw-star-5"
                                class="w-8 h-8 ms-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20">
                                <path
                                    d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                            </svg>
                        </div>
                        <div class="col-span-2">
                            <section class="flex justify-between">
                                <label
                                    for="sw-feedback-input"
                                    class="mb-2 text-xl font-bold text-gray-900 dark:text-white"
                                    >${hero ? hero.displayName ? (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback16[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + hero.displayName : (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback16[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + hero.email : (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback15[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</label
                                >
                                <aside>
                                    <span
                                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map23[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                        id="sw-feedback-passkeys"
                                        class="${hero ? "" : "hidden"} mr-1 cursor-pointer text-2xl">
                                        🔑
                                    </span>
                                    <span
                                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map22[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                        id="sw-feedback-settings"
                                        class="${hero ? "" : "hidden"} cursor-pointer text-2xl">
                                        ⚙️
                                    </span>
                                </aside>
                            </section>
                            <textarea
                                id="sw-feedback-input"
                                onblur="heartbank.alertAdmin('feedback/type/', this.value)"
                                rows="4"
                                class="block p-2.5 w-full h-60 text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                required></textarea>
                        </div>
                    </div>
                    <p
                        id="sw-feedback-message"
                        class="text-sm font-medium mt-5 text-orange-600 dark:text-orange-500"></p>
                    <section
                        class="w-full mt-5 inline-flex items-center justify-around">
                        <button
                            type="submit"
                            onclick="heartbank.alertAdmin('feedback/click/submit')"
                            class="text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </button>
                        <button
                            id="sw-login"
                            onclick="heartbank.alertAdmin('feedback/click/login')"
                            type="button"
                            class="${hero ? "hidden" : ""} text-white w-32 bg-hb hover:bg-hb/25 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-hb dark:hover:bg-hb/50 dark:focus:ring-hb/10">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback11[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </button>
                        <button
                            id="sw-logout"
                            onclick="heartbank.alertAdmin('feedback/click/logout')"
                            type="button"
                            class="${hero ? "" : "hidden"} text-white w-32 bg-orange-500 hover:bg-orange-500 focus:ring-4 focus:outline-none focus:ring-orange-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-orange-500 dark:hover:bg-orange-500 dark:focus:ring-orange-500">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback5[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </button>
                        <button
                            data-modal-hide="sw-feedback"
                            type="button"
                            class="hidden text-white w-24 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </button>
                    </section>
                </form>
                <section
                    class="w-full my-3 pb-3 inline-flex items-center justify-center">
                    <aside
                        id="sw-feedback-hb"
                        onclick="heartbank.alertAdmin('feedback/click/heartbank')"
                        class="cursor-pointer moul self-end text-base font-extralight whitespace-nowrap text-gray-500 dark:text-gray-400">
                        Heart
                        <svg
                            class="mt-[-4px] ml-[-8px] mr-[-4px] inline fill-hb"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="25"
                            height="25">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank<sup>®</sup>
                    </aside>
                </section>
            </div>
        </div>
    </div>
`;




const $536d7d7d446657e2$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $536d7d7d446657e2$export$2c79bf125ef15ed1 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.manager = new (0, $f76271ebfe467595$export$2ddb2ffa4475b711)(), this.code = document.querySelector("sw-code"), this.popup = document.querySelector("sw-popup"), this.rating = 0;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-feedback");
        this.componentTrace.start();
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $02dc22ea9501c9ef$export$2e2bcd8739ae039)(null), this);
        this.feedback = this.querySelector("#sw-feedback");
        this.form = this.querySelector("form");
        this.input = this.querySelector("#sw-feedback-input");
        this.loginBtn = this.querySelector("#sw-login");
        this.logoutBtn = this.querySelector("#sw-logout");
        this.message = this.querySelector("#sw-feedback-message");
        this.passkeys = this.querySelector("#sw-feedback-passkeys");
        this.settings = this.querySelector("#sw-feedback-settings");
        this.hb = this.querySelector("#sw-feedback-hb");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: ()=>{
            //window.location.hash = "#";
            },
            onShow: ()=>{
                //this.message.textContent = strings.feedback6[LANGUAGE];
                this.message.style.color = "";
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-feedback",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.feedback, modalOptions, instanceOptions);
    }
    show() {
        this.modal.show();
    }
    hide() {
        this.modal.hide();
    }
    connectedCallback() {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.loginBtn.addEventListener("click", this.handleLogin.bind(this));
        this.logoutBtn.addEventListener("click", this.handleLogout.bind(this));
        this.settings.addEventListener("click", this.popup.openVault.bind(this, "humanity", false) // humanity/silver
        );
        this.passkeys.addEventListener("click", this.popup.openVault.bind(this, "lockbox", false));
        this.hb.addEventListener("click", ()=>{
            this.popup.openHB("", true); //TODO: add sw org link
        //this.code.show();
        });
        this.addStarListeners();
        window.addEventListener("message", (event)=>{
            if (event.origin === (0, $eba1d7d434ec7c0e$export$76f2fb31d8fa450a)) this.handleMessageFromPopup(event.data);
        });
        this.heartbank.addAuthStateListener3((hero)=>{
            //console.log(this.isConnected);
            this.message.textContent = hero ? "" : $536d7d7d446657e2$var$strings.feedback10[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "";
            (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $02dc22ea9501c9ef$export$2e2bcd8739ae039)(hero), this);
        });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    addStarListeners() {
        this.form.querySelectorAll("svg").forEach((star, index, stars)=>{
            // star.addEventListener("mouseenter", () => {
            //     if (this.rating === 0) {
            //         for (let i = 0; i <= index; i++) {
            //             stars[i].style.fill = "yellow";
            //         }
            //     }
            // });
            // star.addEventListener("mouseleave", () => {
            //     if (this.rating === 0) {
            //         for (let i = 0; i <= index; i++) {
            //             stars[i].style.fill = "gray";
            //         }
            //     }
            // });
            //TODO: weird bug sometimes 5 stars don't get registered...
            star.addEventListener("click", (event)=>{
                const svg = event.target.parentElement;
                if (svg.tagName === "svg") {
                    this.rating = parseInt(svg.id.split("-")[2]);
                    stars.forEach((s, i)=>s.style.fill = i < this.rating ? "yellow" : "gray");
                }
            });
        });
    }
    async handleLogin() {
        if (!navigator.onLine) {
            alert($536d7d7d446657e2$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        if (this.heartbank.hero) {
            const status = await this.heartbank.signIn2();
            this.message.textContent = status.text;
            this.message.style.color = status.type === "success" ? "green" : "red";
        } else this.popup.openVault("login");
    }
    async handleLogout() {
        if (!navigator.onLine) {
            alert($536d7d7d446657e2$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        this.popup.openVault("logout");
    // const status = await this.heartbank.signOut2();
    // if (status.type === "success") {
    //     this.popup.openVault("logout");
    //     //this.hide();
    //     const logout = confirm(status.text);
    //     if (logout) {
    //         this.popup.openVault("logout");
    //     } else {
    //         //window.location.hash = "#/";
    //         //window.location.reload();
    //     }
    // } else {
    //     //alert(status.text);
    // }
    }
    //TODO: later add rate limit by creating this.counter = 0; // not super effective
    // store ip address and user agent for anonymous user
    async handleSubmit(event) {
        if (!navigator.onLine) {
            alert($536d7d7d446657e2$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        event.preventDefault();
        const feedback = await this.manager.createFeedback({
            deviceId: this.heartbank.getDeviceID(),
            userId: this.heartbank.user ? this.heartbank.user.uid : "",
            user: localStorage.getItem("user") || "Unknown User",
            rating: this.rating,
            message: this.input.value,
            language: $536d7d7d446657e2$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
        });
        if (feedback.status === "success") {
            this.message.textContent = $536d7d7d446657e2$var$strings.feedback8[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "green";
            alert($536d7d7d446657e2$var$strings.feedback8[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            this.rating = 0;
            this.form.querySelectorAll("svg").forEach((s, i)=>s.style.fill = "gray");
            this.form.reset();
            this.modal.hide();
            const donate = document.querySelector("#sw-menu-feedback"); //TODO: redo as flowbite component
            donate.click();
        } else {
            // alert(response.message);
            this.message.textContent = feedback.message ?? "";
            this.message.style.color = "red";
        }
    }
    async handleMessageFromPopup(data) {
        let status;
        switch(data.action){
            case "success":
                status = await this.heartbank.signIn(data.token);
                // if (status.type === "success") {
                //     //window.location.hash = "#/account";
                //     // re-render? should be automatic
                //     //window.location.reload();
                // } else {
                //     //window.location.hash = "#";
                //     //alert(status.text);
                // }
                this.message.textContent = status.text;
                this.message.style.color = status.type === "success" ? "green" : "red";
                break;
            case "logout":
                //alert(strings.feedback13[LANGUAGE]);
                status = await this.heartbank.signOut3();
                this.message.textContent = status.text;
                this.message.style.color = status.type === "success" ? "green" : "red";
                break;
        }
    }
}








var $98dc7beabfe94433$exports = {};
$98dc7beabfe94433$exports = new URL("buddha.25346a7e.webp", import.meta.url).toString();


const $fb795d8c1d4436df$var$BUDDHA = new URL($98dc7beabfe94433$exports).href;
var $fb795d8c1d4436df$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-movie"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        id="sw-movie-title"
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]} -
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </h3>
                    <div>
                        <button
                            onclick="heartbank.alertAdmin('movie/click/download')"
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-movie-download"
                            class="hidden mr-2 text-lg">
                            📥
                        </button>
                        <button
                            onclick="heartbank.alertAdmin('movie/click/pause')"
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie11[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-movie-pause"
                            class="hidden mr-2 text-lg">
                            ⏸️
                        </button>
                        <button
                            onclick="heartbank.alertAdmin('movie/click/trash')"
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie12[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-movie-trash"
                            class="hidden ml-2 mr-2 text-lg">
                            🗑️
                        </button>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            type="button"
                            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="sw-movie">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only"
                                >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span
                            >
                        </button>
                    </div>
                </div>
                <!-- Modal body -->
                <div>
                    <aside id="sw-movie-status" class="hidden relative w-full">
                        <progress
                            id="sw-movie-bar"
                            value="0"
                            max="100"
                            class="w-full h-5"></progress>
                        <p
                            id="sw-movie-progress"
                            class="absolute w-full text-center mt-[-2px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-base font-bold text-white dark:text-white">
                            0%
                        </p>
                    </aside>
                    <video
                        controls
                        playsinline
                        poster="${$fb795d8c1d4436df$var$BUDDHA}"
                        id="sw-movie-video"
                        class="w-full"></video>
                    <section id="sw-movie-container" class="hidden">
                        <div
                            id="sw-movie-iframe"
                            class="border-none w-full"
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen></div>
                    </section>
                </div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        onclick2="heartbank.alertAdmin('movie/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).previous[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        id="sw-movie-prev"
                        type="button"
                        class="hidden text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ← ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        onclick2="heartbank.alertAdmin('movie/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).next[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        id="sw-movie-next"
                        type="button"
                        class="hidden text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]} →
                    </button>
                </div>
            </div>
        </div>
    </div>
`;




var $b76bc420003ae4d2$exports = {};
$b76bc420003ae4d2$exports = JSON.parse("{\"buddha\":{\"playlist\":\"PLgQIYTIJXpzbk3yXKEhePNfxRsU7wvmOw\",\"youtube\":[\"https://www.youtube.com/embed/UseFVmrX1z0?si=n58IPMi3uzIcLXpr&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1\",\"https://www.youtube.com/embed/xJJjXgtYmeo?si=l3zMjSF54pfbsDkn&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1\",\"https://www.youtube.com/embed/iiYy4Afc-Pk?si=gaX06QUB03h4hNSf&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1\",\"https://www.youtube.com/embed/TvlNK5ZaFCw?si=e630SrSv4X3HPh4K&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1\",\"https://www.youtube.com/embed/-ozOCVqUHHk?si=nXXt3EH8UDZy3TNM&enablejsapi=1&controls=1&modestbranding=1&rel=0&showinfo=0&autoplay=1\"],\"dropbox\":[\"https://dl.dropboxusercontent.com/scl/fi/fzb6vpouosg7i7fgxqjvo/FINALBUDDA1.mp4?rlkey=qr18bc6qsqz06m47wh9okbb8r&st=6iiy98d1&raw=1\",\"https://dl.dropboxusercontent.com/scl/fi/imkpoagi4sx4n2ksrdvcs/FINALBUDDA2.mp4?rlkey=4morlebuup680my5r4xfogo41&st=r80uptr6&raw=1\",\"https://dl.dropboxusercontent.com/scl/fi/m8q3jo1xse5wbljj9r6rh/FINALBUDDA3.mp4?rlkey=ue7xeq92y6dmr6i4j9dyipu56&st=yqdmaxs3&raw=1\",\"https://dl.dropboxusercontent.com/scl/fi/r3xled0zw45r6hq9b1kkh/FINALBUDDA4.mp4?rlkey=8ymvh04t9ou44dqbcnb5diyxo&st=mazkz2nt&raw=1\",\"https://dl.dropboxusercontent.com/scl/fi/jnks7j4quuqn4k6527fvq/FINALBUDDA5.mp4?rlkey=9sqxhz3ih7w010zuforgazrqe&st=ikoowulc&raw=1\"],\"checksum\":[\"894fc0c8b9533d66\",\"3b5243f541f14de2\",\"af5b26ce37938d5d\",\"34be5314d59f9cb9\",\"e6bc2f56ef861090\"],\"checksum2\":[\"34b57e6829d85b367516bd3328034462c809c04eab42835ac99865be8cec5ff1\",\"d314d4d960d74a28787b6d5605197d97a239630b096c830c8783b4995f04ca67\",\"cba6dd205d07569083c5e41a4ef9ac0484587c5708dc9cfb4821b3b1bcf59b0f\",\"5a48015e3610ff45d0a4a34334fe63ce714acd643306dd228c1a6742638c0f65\",\"80338c97e0e01d4ad0b7de0b5a8469667079f37ca2ae53c07f2a11557a2a560a\"]}}");


// --- START OF FILE Movies.ts ---

var $jaOzc = parcelRequire("jaOzc");

const $fd2514be10e3d744$var$t = new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    48,
    8,
    96,
    3,
    127,
    127,
    127,
    1,
    127,
    96,
    3,
    127,
    127,
    127,
    0,
    96,
    2,
    127,
    127,
    0,
    96,
    1,
    127,
    1,
    127,
    96,
    3,
    127,
    127,
    126,
    1,
    126,
    96,
    3,
    126,
    127,
    127,
    1,
    126,
    96,
    2,
    127,
    126,
    0,
    96,
    1,
    127,
    1,
    126,
    3,
    11,
    10,
    0,
    0,
    2,
    1,
    3,
    4,
    5,
    6,
    1,
    7,
    5,
    3,
    1,
    0,
    1,
    7,
    85,
    9,
    3,
    109,
    101,
    109,
    2,
    0,
    5,
    120,
    120,
    104,
    51,
    50,
    0,
    0,
    6,
    105,
    110,
    105,
    116,
    51,
    50,
    0,
    2,
    8,
    117,
    112,
    100,
    97,
    116,
    101,
    51,
    50,
    0,
    3,
    8,
    100,
    105,
    103,
    101,
    115,
    116,
    51,
    50,
    0,
    4,
    5,
    120,
    120,
    104,
    54,
    52,
    0,
    5,
    6,
    105,
    110,
    105,
    116,
    54,
    52,
    0,
    7,
    8,
    117,
    112,
    100,
    97,
    116,
    101,
    54,
    52,
    0,
    8,
    8,
    100,
    105,
    103,
    101,
    115,
    116,
    54,
    52,
    0,
    9,
    10,
    251,
    22,
    10,
    242,
    1,
    1,
    4,
    127,
    32,
    0,
    32,
    1,
    106,
    33,
    3,
    32,
    1,
    65,
    16,
    79,
    4,
    127,
    32,
    3,
    65,
    16,
    107,
    33,
    6,
    32,
    2,
    65,
    168,
    136,
    141,
    161,
    2,
    106,
    33,
    3,
    32,
    2,
    65,
    137,
    235,
    208,
    208,
    7,
    107,
    33,
    4,
    32,
    2,
    65,
    207,
    140,
    162,
    142,
    6,
    106,
    33,
    5,
    3,
    64,
    32,
    3,
    32,
    0,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    3,
    32,
    4,
    32,
    0,
    65,
    4,
    106,
    34,
    0,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    4,
    32,
    2,
    32,
    0,
    65,
    4,
    106,
    34,
    0,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    2,
    32,
    5,
    32,
    0,
    65,
    4,
    106,
    34,
    0,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    5,
    32,
    6,
    32,
    0,
    65,
    4,
    106,
    34,
    0,
    79,
    13,
    0,
    11,
    32,
    2,
    65,
    12,
    119,
    32,
    5,
    65,
    18,
    119,
    106,
    32,
    4,
    65,
    7,
    119,
    106,
    32,
    3,
    65,
    1,
    119,
    106,
    5,
    32,
    2,
    65,
    177,
    207,
    217,
    178,
    1,
    106,
    11,
    32,
    1,
    106,
    32,
    0,
    32,
    1,
    65,
    15,
    113,
    16,
    1,
    11,
    146,
    1,
    0,
    32,
    1,
    32,
    2,
    106,
    33,
    2,
    3,
    64,
    32,
    1,
    65,
    4,
    106,
    32,
    2,
    75,
    69,
    4,
    64,
    32,
    0,
    32,
    1,
    40,
    2,
    0,
    65,
    189,
    220,
    202,
    149,
    124,
    108,
    106,
    65,
    17,
    119,
    65,
    175,
    214,
    211,
    190,
    2,
    108,
    33,
    0,
    32,
    1,
    65,
    4,
    106,
    33,
    1,
    12,
    1,
    11,
    11,
    3,
    64,
    32,
    1,
    32,
    2,
    79,
    69,
    4,
    64,
    32,
    0,
    32,
    1,
    45,
    0,
    0,
    65,
    177,
    207,
    217,
    178,
    1,
    108,
    106,
    65,
    11,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    0,
    32,
    1,
    65,
    1,
    106,
    33,
    1,
    12,
    1,
    11,
    11,
    32,
    0,
    32,
    0,
    65,
    15,
    118,
    115,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    34,
    0,
    65,
    13,
    118,
    32,
    0,
    115,
    65,
    189,
    220,
    202,
    149,
    124,
    108,
    34,
    0,
    65,
    16,
    118,
    32,
    0,
    115,
    11,
    63,
    0,
    32,
    0,
    65,
    8,
    106,
    32,
    1,
    65,
    168,
    136,
    141,
    161,
    2,
    106,
    54,
    2,
    0,
    32,
    0,
    65,
    12,
    106,
    32,
    1,
    65,
    137,
    235,
    208,
    208,
    7,
    107,
    54,
    2,
    0,
    32,
    0,
    65,
    16,
    106,
    32,
    1,
    54,
    2,
    0,
    32,
    0,
    65,
    20,
    106,
    32,
    1,
    65,
    207,
    140,
    162,
    142,
    6,
    106,
    54,
    2,
    0,
    11,
    195,
    4,
    1,
    6,
    127,
    32,
    1,
    32,
    2,
    106,
    33,
    6,
    32,
    0,
    65,
    24,
    106,
    33,
    4,
    32,
    0,
    65,
    40,
    106,
    40,
    2,
    0,
    33,
    3,
    32,
    0,
    32,
    0,
    40,
    2,
    0,
    32,
    2,
    106,
    54,
    2,
    0,
    32,
    0,
    65,
    4,
    106,
    34,
    5,
    32,
    5,
    40,
    2,
    0,
    32,
    2,
    65,
    16,
    79,
    32,
    0,
    40,
    2,
    0,
    65,
    16,
    79,
    114,
    114,
    54,
    2,
    0,
    32,
    2,
    32,
    3,
    106,
    65,
    16,
    73,
    4,
    64,
    32,
    3,
    32,
    4,
    106,
    32,
    1,
    32,
    2,
    252,
    10,
    0,
    0,
    32,
    0,
    65,
    40,
    106,
    32,
    2,
    32,
    3,
    106,
    54,
    2,
    0,
    15,
    11,
    32,
    3,
    4,
    64,
    32,
    3,
    32,
    4,
    106,
    32,
    1,
    65,
    16,
    32,
    3,
    107,
    34,
    2,
    252,
    10,
    0,
    0,
    32,
    0,
    65,
    8,
    106,
    34,
    3,
    32,
    3,
    40,
    2,
    0,
    32,
    4,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    54,
    2,
    0,
    32,
    0,
    65,
    12,
    106,
    34,
    3,
    32,
    3,
    40,
    2,
    0,
    32,
    4,
    65,
    4,
    106,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    54,
    2,
    0,
    32,
    0,
    65,
    16,
    106,
    34,
    3,
    32,
    3,
    40,
    2,
    0,
    32,
    4,
    65,
    8,
    106,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    54,
    2,
    0,
    32,
    0,
    65,
    20,
    106,
    34,
    3,
    32,
    3,
    40,
    2,
    0,
    32,
    4,
    65,
    12,
    106,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    54,
    2,
    0,
    32,
    0,
    65,
    40,
    106,
    65,
    0,
    54,
    2,
    0,
    32,
    1,
    32,
    2,
    106,
    33,
    1,
    11,
    32,
    1,
    32,
    6,
    65,
    16,
    107,
    77,
    4,
    64,
    32,
    6,
    65,
    16,
    107,
    33,
    8,
    32,
    0,
    65,
    8,
    106,
    40,
    2,
    0,
    33,
    2,
    32,
    0,
    65,
    12,
    106,
    40,
    2,
    0,
    33,
    3,
    32,
    0,
    65,
    16,
    106,
    40,
    2,
    0,
    33,
    5,
    32,
    0,
    65,
    20,
    106,
    40,
    2,
    0,
    33,
    7,
    3,
    64,
    32,
    2,
    32,
    1,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    2,
    32,
    3,
    32,
    1,
    65,
    4,
    106,
    34,
    1,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    3,
    32,
    5,
    32,
    1,
    65,
    4,
    106,
    34,
    1,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    5,
    32,
    7,
    32,
    1,
    65,
    4,
    106,
    34,
    1,
    40,
    2,
    0,
    65,
    247,
    148,
    175,
    175,
    120,
    108,
    106,
    65,
    13,
    119,
    65,
    177,
    243,
    221,
    241,
    121,
    108,
    33,
    7,
    32,
    8,
    32,
    1,
    65,
    4,
    106,
    34,
    1,
    79,
    13,
    0,
    11,
    32,
    0,
    65,
    8,
    106,
    32,
    2,
    54,
    2,
    0,
    32,
    0,
    65,
    12,
    106,
    32,
    3,
    54,
    2,
    0,
    32,
    0,
    65,
    16,
    106,
    32,
    5,
    54,
    2,
    0,
    32,
    0,
    65,
    20,
    106,
    32,
    7,
    54,
    2,
    0,
    11,
    32,
    1,
    32,
    6,
    73,
    4,
    64,
    32,
    4,
    32,
    1,
    32,
    6,
    32,
    1,
    107,
    34,
    1,
    252,
    10,
    0,
    0,
    32,
    0,
    65,
    40,
    106,
    32,
    1,
    54,
    2,
    0,
    11,
    11,
    97,
    1,
    1,
    127,
    32,
    0,
    65,
    16,
    106,
    40,
    2,
    0,
    33,
    1,
    32,
    0,
    65,
    4,
    106,
    40,
    2,
    0,
    4,
    127,
    32,
    1,
    65,
    12,
    119,
    32,
    0,
    65,
    20,
    106,
    40,
    2,
    0,
    65,
    18,
    119,
    106,
    32,
    0,
    65,
    12,
    106,
    40,
    2,
    0,
    65,
    7,
    119,
    106,
    32,
    0,
    65,
    8,
    106,
    40,
    2,
    0,
    65,
    1,
    119,
    106,
    5,
    32,
    1,
    65,
    177,
    207,
    217,
    178,
    1,
    106,
    11,
    32,
    0,
    40,
    2,
    0,
    106,
    32,
    0,
    65,
    24,
    106,
    32,
    0,
    65,
    40,
    106,
    40,
    2,
    0,
    16,
    1,
    11,
    255,
    3,
    2,
    3,
    126,
    1,
    127,
    32,
    0,
    32,
    1,
    106,
    33,
    6,
    32,
    1,
    65,
    32,
    79,
    4,
    126,
    32,
    6,
    65,
    32,
    107,
    33,
    6,
    32,
    2,
    66,
    214,
    235,
    130,
    238,
    234,
    253,
    137,
    245,
    224,
    0,
    124,
    33,
    3,
    32,
    2,
    66,
    177,
    169,
    172,
    193,
    173,
    184,
    212,
    166,
    61,
    125,
    33,
    4,
    32,
    2,
    66,
    249,
    234,
    208,
    208,
    231,
    201,
    161,
    228,
    225,
    0,
    124,
    33,
    5,
    3,
    64,
    32,
    3,
    32,
    0,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    3,
    32,
    4,
    32,
    0,
    65,
    8,
    106,
    34,
    0,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    4,
    32,
    2,
    32,
    0,
    65,
    8,
    106,
    34,
    0,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    2,
    32,
    5,
    32,
    0,
    65,
    8,
    106,
    34,
    0,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    5,
    32,
    6,
    32,
    0,
    65,
    8,
    106,
    34,
    0,
    79,
    13,
    0,
    11,
    32,
    2,
    66,
    12,
    137,
    32,
    5,
    66,
    18,
    137,
    124,
    32,
    4,
    66,
    7,
    137,
    124,
    32,
    3,
    66,
    1,
    137,
    124,
    32,
    3,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    32,
    4,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    32,
    2,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    32,
    5,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    5,
    32,
    2,
    66,
    197,
    207,
    217,
    178,
    241,
    229,
    186,
    234,
    39,
    124,
    11,
    32,
    1,
    173,
    124,
    32,
    0,
    32,
    1,
    65,
    31,
    113,
    16,
    6,
    11,
    134,
    2,
    0,
    32,
    1,
    32,
    2,
    106,
    33,
    2,
    3,
    64,
    32,
    2,
    32,
    1,
    65,
    8,
    106,
    79,
    4,
    64,
    32,
    1,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    32,
    0,
    133,
    66,
    27,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    33,
    0,
    32,
    1,
    65,
    8,
    106,
    33,
    1,
    12,
    1,
    11,
    11,
    32,
    1,
    65,
    4,
    106,
    32,
    2,
    77,
    4,
    64,
    32,
    0,
    32,
    1,
    53,
    2,
    0,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    23,
    137,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    249,
    243,
    221,
    241,
    153,
    246,
    153,
    171,
    22,
    124,
    33,
    0,
    32,
    1,
    65,
    4,
    106,
    33,
    1,
    11,
    3,
    64,
    32,
    1,
    32,
    2,
    73,
    4,
    64,
    32,
    0,
    32,
    1,
    49,
    0,
    0,
    66,
    197,
    207,
    217,
    178,
    241,
    229,
    186,
    234,
    39,
    126,
    133,
    66,
    11,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    0,
    32,
    1,
    65,
    1,
    106,
    33,
    1,
    12,
    1,
    11,
    11,
    32,
    0,
    32,
    0,
    66,
    33,
    136,
    133,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    34,
    0,
    32,
    0,
    66,
    29,
    136,
    133,
    66,
    249,
    243,
    221,
    241,
    153,
    246,
    153,
    171,
    22,
    126,
    34,
    0,
    32,
    0,
    66,
    32,
    136,
    133,
    11,
    77,
    0,
    32,
    0,
    65,
    8,
    106,
    32,
    1,
    66,
    214,
    235,
    130,
    238,
    234,
    253,
    137,
    245,
    224,
    0,
    124,
    55,
    3,
    0,
    32,
    0,
    65,
    16,
    106,
    32,
    1,
    66,
    177,
    169,
    172,
    193,
    173,
    184,
    212,
    166,
    61,
    125,
    55,
    3,
    0,
    32,
    0,
    65,
    24,
    106,
    32,
    1,
    55,
    3,
    0,
    32,
    0,
    65,
    32,
    106,
    32,
    1,
    66,
    249,
    234,
    208,
    208,
    231,
    201,
    161,
    228,
    225,
    0,
    124,
    55,
    3,
    0,
    11,
    244,
    4,
    2,
    3,
    127,
    4,
    126,
    32,
    1,
    32,
    2,
    106,
    33,
    5,
    32,
    0,
    65,
    40,
    106,
    33,
    4,
    32,
    0,
    65,
    200,
    0,
    106,
    40,
    2,
    0,
    33,
    3,
    32,
    0,
    32,
    0,
    41,
    3,
    0,
    32,
    2,
    173,
    124,
    55,
    3,
    0,
    32,
    2,
    32,
    3,
    106,
    65,
    32,
    73,
    4,
    64,
    32,
    3,
    32,
    4,
    106,
    32,
    1,
    32,
    2,
    252,
    10,
    0,
    0,
    32,
    0,
    65,
    200,
    0,
    106,
    32,
    2,
    32,
    3,
    106,
    54,
    2,
    0,
    15,
    11,
    32,
    3,
    4,
    64,
    32,
    3,
    32,
    4,
    106,
    32,
    1,
    65,
    32,
    32,
    3,
    107,
    34,
    2,
    252,
    10,
    0,
    0,
    32,
    0,
    65,
    8,
    106,
    34,
    3,
    32,
    3,
    41,
    3,
    0,
    32,
    4,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    55,
    3,
    0,
    32,
    0,
    65,
    16,
    106,
    34,
    3,
    32,
    3,
    41,
    3,
    0,
    32,
    4,
    65,
    8,
    106,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    55,
    3,
    0,
    32,
    0,
    65,
    24,
    106,
    34,
    3,
    32,
    3,
    41,
    3,
    0,
    32,
    4,
    65,
    16,
    106,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    55,
    3,
    0,
    32,
    0,
    65,
    32,
    106,
    34,
    3,
    32,
    3,
    41,
    3,
    0,
    32,
    4,
    65,
    24,
    106,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    55,
    3,
    0,
    32,
    0,
    65,
    200,
    0,
    106,
    65,
    0,
    54,
    2,
    0,
    32,
    1,
    32,
    2,
    106,
    33,
    1,
    11,
    32,
    1,
    65,
    32,
    106,
    32,
    5,
    77,
    4,
    64,
    32,
    5,
    65,
    32,
    107,
    33,
    2,
    32,
    0,
    65,
    8,
    106,
    41,
    3,
    0,
    33,
    6,
    32,
    0,
    65,
    16,
    106,
    41,
    3,
    0,
    33,
    7,
    32,
    0,
    65,
    24,
    106,
    41,
    3,
    0,
    33,
    8,
    32,
    0,
    65,
    32,
    106,
    41,
    3,
    0,
    33,
    9,
    3,
    64,
    32,
    6,
    32,
    1,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    6,
    32,
    7,
    32,
    1,
    65,
    8,
    106,
    34,
    1,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    7,
    32,
    8,
    32,
    1,
    65,
    8,
    106,
    34,
    1,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    8,
    32,
    9,
    32,
    1,
    65,
    8,
    106,
    34,
    1,
    41,
    3,
    0,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    124,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    33,
    9,
    32,
    2,
    32,
    1,
    65,
    8,
    106,
    34,
    1,
    79,
    13,
    0,
    11,
    32,
    0,
    65,
    8,
    106,
    32,
    6,
    55,
    3,
    0,
    32,
    0,
    65,
    16,
    106,
    32,
    7,
    55,
    3,
    0,
    32,
    0,
    65,
    24,
    106,
    32,
    8,
    55,
    3,
    0,
    32,
    0,
    65,
    32,
    106,
    32,
    9,
    55,
    3,
    0,
    11,
    32,
    1,
    32,
    5,
    73,
    4,
    64,
    32,
    4,
    32,
    1,
    32,
    5,
    32,
    1,
    107,
    34,
    1,
    252,
    10,
    0,
    0,
    32,
    0,
    65,
    200,
    0,
    106,
    32,
    1,
    54,
    2,
    0,
    11,
    11,
    188,
    2,
    1,
    5,
    126,
    32,
    0,
    65,
    24,
    106,
    41,
    3,
    0,
    33,
    1,
    32,
    0,
    41,
    3,
    0,
    34,
    2,
    66,
    32,
    90,
    4,
    126,
    32,
    0,
    65,
    8,
    106,
    41,
    3,
    0,
    34,
    3,
    66,
    1,
    137,
    32,
    0,
    65,
    16,
    106,
    41,
    3,
    0,
    34,
    4,
    66,
    7,
    137,
    124,
    32,
    1,
    66,
    12,
    137,
    32,
    0,
    65,
    32,
    106,
    41,
    3,
    0,
    34,
    5,
    66,
    18,
    137,
    124,
    124,
    32,
    3,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    32,
    4,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    32,
    1,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    32,
    5,
    66,
    207,
    214,
    211,
    190,
    210,
    199,
    171,
    217,
    66,
    126,
    66,
    31,
    137,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    133,
    66,
    135,
    149,
    175,
    175,
    152,
    182,
    222,
    155,
    158,
    127,
    126,
    66,
    157,
    163,
    181,
    234,
    131,
    177,
    141,
    138,
    250,
    0,
    125,
    5,
    32,
    1,
    66,
    197,
    207,
    217,
    178,
    241,
    229,
    186,
    234,
    39,
    124,
    11,
    32,
    2,
    124,
    32,
    0,
    65,
    40,
    106,
    32,
    2,
    66,
    31,
    131,
    167,
    16,
    6,
    11
]);
async function $fd2514be10e3d744$export$2e2bcd8739ae039() {
    return function(t) {
        const { exports: { mem: e, xxh32: n, xxh64: r, init32: i, update32: a, digest32: o, init64: s, update64: u, digest64: c } } = t;
        let h = new Uint8Array(e.buffer);
        function g(t, n) {
            if (e.buffer.byteLength < t + n) {
                const r = Math.ceil((t + n - e.buffer.byteLength) / 65536);
                e.grow(r), h = new Uint8Array(e.buffer);
            }
        }
        function f(t, e, n, r, i, a) {
            g(t);
            const o = new Uint8Array(t);
            return h.set(o), n(0, e), o.set(h.subarray(0, t)), {
                update (e) {
                    let n;
                    return h.set(o), "string" == typeof e ? (g(3 * e.length, t), n = w.encodeInto(e, h.subarray(t)).written) : (g(e.byteLength, t), h.set(e, t), n = e.byteLength), r(0, t, n), o.set(h.subarray(0, t)), this;
                },
                digest: ()=>(h.set(o), a(i(0)))
            };
        }
        function y(t) {
            return t >>> 0;
        }
        const b = 2n ** 64n - 1n;
        function d(t) {
            return t & b;
        }
        const w = new TextEncoder, l = 0, p = 0n;
        function x(t, e = l) {
            return g(3 * t.length, 0), y(n(0, w.encodeInto(t, h).written, e));
        }
        function L(t, e = p) {
            return g(3 * t.length, 0), d(r(0, w.encodeInto(t, h).written, e));
        }
        return {
            h32: x,
            h32ToString: (t, e = l)=>x(t, e).toString(16).padStart(8, "0"),
            h32Raw: (t, e = l)=>(g(t.byteLength, 0), h.set(t), y(n(0, t.byteLength, e))),
            create32: (t = l)=>f(48, t, i, a, o, y),
            h64: L,
            h64ToString: (t, e = p)=>L(t, e).toString(16).padStart(16, "0"),
            h64Raw: (t, e = p)=>(g(t.byteLength, 0), h.set(t), d(r(0, t.byteLength, e))),
            create64: (t = p)=>f(88, t, s, u, c, d)
        };
    }((await WebAssembly.instantiate($fd2514be10e3d744$var$t)).instance);
}


class $416fea5951cf9330$export$b89db09a01235f6f extends (0, $jaOzc.default) {
    constructor(){
        super("Movies"), this.activeDownloads = new Map();
        // --- SCHEMA CHANGE ---
        // Version bumped to 2 to reflect the new logic of storing the final blob
        // in the 'movies' table after a successful download.
        this.version(2).stores({
            movies: "id, status",
            movie_chunks: "[movieId+order]"
        });
        this.movies = this.table("movies");
        this.chunks = this.table("movie_chunks");
    }
    // --- Helper methods (getUrl, getChecksum) are unchanged ---
    getUrl(id) {
        const movie = id.split("-");
        const title = movie[0];
        const episode = parseInt(movie[1]) - 1;
        const collection = (0, (/*@__PURE__*/$parcel$interopDefault($b76bc420003ae4d2$exports)));
        return collection[title].dropbox[episode];
    }
    getChecksum(id) {
        const movie = id.split("-");
        const title = movie[0];
        const episode = parseInt(movie[1]) - 1;
        const collection = (0, (/*@__PURE__*/$parcel$interopDefault($b76bc420003ae4d2$exports)));
        return collection[title].checksum[episode];
    }
    // --- Public API methods ---
    async get(id) {
        const movie = await this.movies.get(id);
        if (movie) return movie;
        else {
            const newMovie = {
                id: id,
                time: 0,
                downloaded: 0
            };
            await this.movies.put(newMovie);
            return newMovie;
        }
    }
    async getAllStarted() {
        return this.movies.filter((movie)=>movie.status === "started").toArray();
    }
    async getTime(id) {
        const movie = await this.get(id);
        return movie.time;
    }
    async setTime(id, time) {
        await this.movies.update(id, {
            time: time
        });
    }
    async remove(id) {
        // Use a transaction to ensure both metadata and any leftover chunks are deleted
        await this.transaction("rw", this.movies, this.chunks, async ()=>{
            await this.movies.delete(id);
            await this.chunks.where({
                movieId: id
            }).delete();
        });
        console.log(`\u{1F5D1}\u{FE0F} Deleted ${id} and all its data.`);
    }
    pause(id) {
        const controller = this.activeDownloads.get(id);
        if (controller) {
            console.log(`\u{23F8}\u{FE0F} Pausing download for ${id}...`);
            controller.abort();
        } else console.warn(`No active download found for ${id} to pause.`);
    //this.movies.update(id, { status: "paused" }); already done in download
    }
    /**
     * Downloads a movie by streaming chunks to IndexedDB, then finalizes the download
     * by assembling the chunks, verifying, and storing the final Blob.
     */ async download(id, onProgress) {
        if (this.activeDownloads.has(id)) {
            console.warn(`${id} download already in progress`);
            return;
        }
        let movie = await this.get(id);
        if (movie.status === "completed") {
            console.log(`\u{1F44D} ${id} is already fully downloaded.`);
            if (movie.totalSize) onProgress?.(id, 100, movie.totalSize, movie.totalSize);
            return;
        }
        const controller = new AbortController();
        this.activeDownloads.set(id, controller);
        try {
            // --- The download-to-chunks part is largely the same ---
            movie.downloaded = movie.downloaded || 0;
            const headers = {
                Range: `bytes=${movie.downloaded}-`
            };
            const response = await fetch(this.getUrl(id), {
                headers: headers,
                signal: controller.signal
            });
            if (!response.ok || !response.body) {
                if (response.status === 416) {
                    // This can happen if the 'downloaded' value is incorrect. Let's try to finalize.
                    console.log(`\u{1F44D} ${id} seems to be fully downloaded (server returned 416). Attempting to finalize...`);
                    await this._finalizeDownload(id, onProgress);
                }
                if (response.status === 404) await this.movies.update(id, {
                    status: "paused"
                });
                return;
            // throw new Error(
            //     `${id} download failed: ${response.statusText}`
            // );
            }
            let received = movie.downloaded;
            if (response.status !== 206) {
                await this.chunks.where({
                    movieId: id
                }).delete();
                received = 0;
                movie.downloaded = 0;
            }
            await this.movies.update(id, {
                status: "started"
            });
            if (!movie.totalSize) {
                const contentRange = response.headers.get("Content-Range");
                const totalStr = contentRange ? contentRange.split("/")[1] : "0";
                const contentLength = Number(response.headers.get("Content-Length")) || 0;
                movie.totalSize = parseInt(totalStr, 10) || received + contentLength;
                await this.movies.update(id, {
                    totalSize: movie.totalSize
                });
            }
            const totalBytes = movie.totalSize || 0;
            const reader = response.body.getReader();
            const lastChunk = await this.chunks.where({
                movieId: id
            }).last();
            let chunkOrder = lastChunk ? lastChunk.order + 1 : 0;
            const CHUNK_BUFFER_SIZE = 5242880;
            let buffer = [];
            let bufferSize = 0;
            let lastProgressUpdate = performance.now();
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                if (value) {
                    buffer.push(value);
                    bufferSize += value.length;
                    received += value.length;
                    if (bufferSize >= CHUNK_BUFFER_SIZE) {
                        const blobChunk = new Blob(buffer);
                        await this.chunks.put({
                            movieId: id,
                            order: chunkOrder++,
                            data: blobChunk
                        });
                        await this.movies.update(id, {
                            downloaded: received
                        });
                        buffer = [];
                        bufferSize = 0;
                    }
                    const now = performance.now();
                    if (onProgress && now - lastProgressUpdate > 250) {
                        const percent = totalBytes ? Math.min(100, Math.round(received / totalBytes * 100)) : 0;
                        onProgress(id, percent, received, totalBytes);
                        lastProgressUpdate = now;
                    }
                }
            }
            if (buffer.length > 0) {
                const blobChunk = new Blob(buffer);
                await this.chunks.put({
                    movieId: id,
                    order: chunkOrder++,
                    data: blobChunk
                });
            }
            await this.movies.update(id, {
                downloaded: received
            });
            // --- NEW: Finalization Step ---
            // All bytes are received. Now assemble, verify, and clean up.
            await this._finalizeDownload(id, onProgress);
        } catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") {
                // This is a manual pause, not a network error.
                console.log(`Download for ${id} was paused manually.`);
                await this.movies.update(id, {
                    status: "paused"
                });
            } else if (error instanceof TypeError && error.message === "Load failed") // A TypeError during fetch while the browser is offline is a strong
            // indicator of a network connection loss.
            console.warn(`Network connection lost for ${id}. Pausing download.`);
            else {
                // For all other errors, mark as failed.
                await this.movies.update(id, {
                    status: "failed"
                });
                console.error(`Download for ${id} failed:`, error);
            //alert(error);
            }
        } finally{
            this.activeDownloads.delete(id);
        }
    }
    // --- Private Helper Methods ---
    /**
     * Assembles chunks from the database into a single Blob.
     * This is a memory-intensive operation.
     */ async _getBlobFromChunks(id) {
        const movieChunks = await this.chunks.where({
            movieId: id
        }).sortBy("order");
        if (movieChunks.length === 0) return null;
        const blobParts = movieChunks.map((chunk)=>chunk.data);
        return new Blob(blobParts, {
            type: "video/mp4"
        });
    }
    /**
     * The final step after all bytes are downloaded. Assembles the chunks,
     * verifies the checksum, saves the final blob, and cleans up the chunks table.
     */ async _finalizeDownload(id, onProgress) {
        console.log(`Finalizing download for ${id}. Assembling chunks...`);
        let fullBlob = await this._getBlobFromChunks(id);
        if (!fullBlob) throw new Error("Finalization failed: Could not assemble blob from chunks.");
        //if (isDesktop) {
        console.log(`Verifying checksum for ${id}...`);
        const checksum = await this.streamingXXH3(fullBlob); //this._computeSHA256(fullBlob);
        const expectedChecksum = this.getChecksum(id);
        if (checksum !== expectedChecksum) {
            console.error(`\u{274C} ${id} checksum mismatch! Download is corrupted.`);
            console.error(`   Expected: ${expectedChecksum}`);
            console.error(`   Actual:   ${checksum}`);
            //await this.movies.update(id, { status: "failed" }); // already done in catch
            // Optionally, clear the bad chunks
            // await this.chunks.where({ movieId: id }).delete();
            throw new Error("Checksum verification failed.");
        }
        console.log(`\u{2705} ${id} checksum verified. Saving final blob and cleaning up chunks.`);
        //}
        // if (isDesktop) {
        //     // --- ⬇️ THE NEW, MORE POWERFUL DEEP COPY METHOD ⬇️ ---
        //     //
        //     // To defeat Safari's persistent resource caching, we force a full deep copy
        //     // by converting the blob to an ArrayBuffer and then creating a new blob.
        //     // This guarantees a new, untainted resource in memory.
        //     //
        //     console.log(
        //         `Performing deep copy of blob via ArrayBuffer for Safari...`
        //     );
        //     const buffer = await fullBlob.arrayBuffer();
        //     fullBlob = new Blob([buffer], { type: fullBlob.type });
        //     //console.log(`Deep copy complete. New blob size: ${finalBlob.size}`);
        //     // --- ⬆️ END OF THE NEW METHOD ⬆️ ---
        // }
        // Use a transaction to make the final update atomic
        await this.transaction("rw", this.movies, this.chunks, async ()=>{
            // 1. Update the movie record with the final blob and completed status
            await this.movies.put({
                id: id,
                blob: fullBlob,
                status: "completed",
                size: fullBlob.size,
                totalSize: fullBlob.size,
                downloaded: fullBlob.size,
                time: (await this.get(id)).time // Preserve existing time
            });
            // 2. Delete all chunks for this movie
            await this.chunks.where({
                movieId: id
            }).delete();
        });
        console.info(`\u{2705} ${id} successfully completed and finalized.`);
        onProgress?.(id, 100, fullBlob.size, fullBlob.size);
    }
    /**
     * Computes the XXH3 (64-bit) hash of a Blob in a streaming fashion.
     * This is memory-efficient for large blobs (e.g., GB-scale files) as it processes chunks without loading the entire content.
     *
     * @param blob The Blob to hash (e.g., from a file input).
     * @param chunkSize Optional chunk size in bytes (default: 64MB for balance between memory and performance). Note: This param is not directly used here as Blob.stream() handles chunking internally, but included for consistency with prior examples.
     * @returns A promise resolving to the 16-character hex string of the XXH3 hash (lowercase, zero-padded if needed).
     *
     * Requirements:
     * - Install via: npm install xxhash-wasm
     * - Works in browser or Node.js (with Blob polyfill if needed).
     *
     * Example usage:
     * const fileInput = document.querySelector('input[type="file"]');
     * fileInput.addEventListener('change', async (e) => {
     *   const blob = e.target.files[0];
     *   const hash = await streamingXXH3(blob);
     *   console.log(hash); // e.g., '502b0c5fc4a5704c'
     * });
     */ async streamingXXH3(blob, chunkSize = 67108864) {
        // Load XXHash WASM module (async init, can be cached globally if called often)
        const { create64: create64 } = await (0, $fd2514be10e3d744$export$2e2bcd8739ae039)();
        // Create a 64-bit XXH3 streaming hasher
        const hasher = create64();
        // Get a readable stream from the Blob
        const stream = blob.stream();
        // Create a reader for the stream
        const reader = stream.getReader();
        try {
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                // Update the hasher with the chunk (Uint8Array)
                hasher.update(value);
            }
            // Compute the digest as bigint and convert to 16-char hex string (lowercase, zero-padded)
            const digestBigInt = hasher.digest();
            return digestBigInt.toString(16).padStart(16, "0");
        } finally{
            // Release the reader to free resources
            reader.releaseLock();
        }
    }
}




const $4499829d9d33c525$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
const $4499829d9d33c525$var$collection = (0, (/*@__PURE__*/$parcel$interopDefault($b76bc420003ae4d2$exports)));
class $4499829d9d33c525$export$595d4e8fc120612e extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.movies = new (0, $416fea5951cf9330$export$b89db09a01235f6f)(), this.youtube = null, this.youTubeTimer = null, this.videoTimer = null, this.duration = 1000 * ((0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? 1 : 1) // 1 second // faster causes lagging
        , this.hasSeeked = false, // defaults
        this.movieTitle = "buddha", this.collection = {
            buddha: {
                episode: 1,
                times: [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            }
        }, this.handleProgress = (id, p, bytes, total)=>{
            if (this.isOnPage(id)) {
                this.bar.value = p;
                this.progress.textContent = `${$4499829d9d33c525$var$strings["movie" + this.getEpisode()][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}: ${p}% - ${(bytes / 1000000).toFixed(0)} / ${(total / 1000000).toFixed(0)} MB`;
            }
        };
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $fb795d8c1d4436df$export$2e2bcd8739ae039)(null), this);
        this.movie = this.querySelector("#sw-movie");
        this.heading = this.querySelector("#sw-movie-title");
        this.iframe = this.querySelector("#sw-movie-container");
        this.video = this.querySelector("#sw-movie-video");
        this.download = this.querySelector("#sw-movie-download");
        this.pause = this.querySelector("#sw-movie-pause");
        this.trash = this.querySelector("#sw-movie-trash");
        this.status = this.querySelector("#sw-movie-status");
        this.bar = this.querySelector("#sw-movie-bar");
        this.progress = this.querySelector("#sw-movie-progress");
        this.prev = this.querySelector("#sw-movie-prev");
        this.next = this.querySelector("#sw-movie-next");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/95 dark:bg-gray-900/95 fixed inset-0 z-40",
            closable: false,
            onHide: ()=>{
                this.youtube?.pauseVideo();
                this.video.pause();
            //window.location.hash = "#";
            },
            onShow: ()=>{
                this.movie.style.zIndex = "70";
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-movie",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.movie, modalOptions, instanceOptions);
    }
    getCollection() {
        const storedCollection = localStorage.getItem("collection");
        return storedCollection ? JSON.parse(storedCollection) : this.collection;
    }
    getEpisode(id = null) {
        if (id) return parseInt(id.split("-")[1]);
        else {
            const storedCollection = this.getCollection();
            return storedCollection[this.movieTitle].episode;
        }
    }
    setEpisode(episode) {
        const storedCollection = this.getCollection();
        storedCollection[this.movieTitle].episode = episode;
        localStorage.setItem("collection", JSON.stringify(storedCollection));
    }
    getTime(episode) {
        const storedCollection = this.getCollection();
        return storedCollection[this.movieTitle].times[episode - 1];
    }
    setTime(episode, time) {
        const storedCollection = this.getCollection();
        storedCollection[this.movieTitle].times[episode - 1] = time;
        localStorage.setItem("collection", JSON.stringify(storedCollection));
    }
    getMovieId(episode = 0) {
        return this.movieTitle + "-" + (episode || this.getEpisode());
    }
    isOnPage(id) {
        return this.modal.isVisible() && this.getEpisode() === this.getEpisode(id);
    }
    videoStart() {
        this.youtube?.pauseVideo(); // need to be here
        this.youtubeStop();
        if (!this.videoTimer) this.videoTimer = window.setInterval(()=>this.setTime(this.getEpisode(), this.video.currentTime), this.duration);
    }
    youtubeStart() {
        this.video.pause(); // need to be here
        this.videoStop();
        if (!this.youTubeTimer) this.youTubeTimer = window.setInterval(()=>this.setTime(this.getEpisode(), this.youtube?.getCurrentTime() || 0), this.duration);
    }
    videoStop() {
        if (this.videoTimer) {
            clearInterval(this.videoTimer);
            this.videoTimer = null;
        }
    }
    youtubeStop() {
        if (this.youTubeTimer) {
            clearInterval(this.youTubeTimer);
            this.youTubeTimer = null;
        }
    }
    connectedCallback() {
        this.loadYouTubeAPI();
        this.resume();
        this.prev.addEventListener("click", this.goTo.bind(this, false));
        this.next.addEventListener("click", this.goTo.bind(this, true));
        //this.video.addEventListener("play", () => console.log("play() called"));
        this.video.addEventListener("playing", this.videoStart.bind(this));
        this.video.addEventListener("pause", ()=>{
            this.videoStop();
            this.heartbank.alertAdmin(`video/pause/episode/${this.getEpisode()}/${this.video.currentTime}`);
        });
        this.video.addEventListener("ended", ()=>{
            this.videoStop();
            this.goTo(true);
            this.heartbank.alertAdmin(`video/end/episode/${this.getEpisode()}/${this.video.currentTime}`);
        });
        // 🔹 Listen for time updates (fires ~4 times per second) // causes lagging
        // this.video.addEventListener(
        //     "timeupdate",
        //     () => this.setTime(this.getEpisode(), this.video.currentTime)
        //     //this.movies.setTime(this.getMovieId(), this.video.currentTime)
        // );
        // handle safari error
        this.video.addEventListener("error", (event)=>{
            const target = event.currentTarget;
            const error = target.error;
            if (error) switch(error.code){
                case MediaError.MEDIA_ERR_ABORTED:
                    console.error("Video loading aborted.");
                    break;
                case MediaError.MEDIA_ERR_NETWORK:
                    console.error("Network error while loading video.");
                    break;
                case MediaError.MEDIA_ERR_DECODE:
                    console.error("Video decoding error.");
                    break;
                case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
                    //console.error("Video source not supported or missing.");
                    if (target.dataset.id && this.isOnPage(target.dataset.id)) alert($4499829d9d33c525$var$strings.movie17[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]); // this will loop until successful: another way is to ask user to confrim reload page
                    break;
                default:
                    console.error("An unknown video error occurred.");
                    break;
            }
            else console.error("Unknown video error (no MediaError).");
        });
        this.video.addEventListener("click", async ()=>{
            if (this.video.dataset.id && this.video.error) {
                const movie = await this.movies.get(this.video.dataset.id);
                if (movie.status === "completed" && movie.blob) {
                    this.video.src = URL.createObjectURL(movie.blob);
                    this.video.currentTime = this.getTime(this.getEpisode(movie.id)); // movie.time;
                    this.video.play(); //await
                }
            }
        });
        // start or resume
        this.download.addEventListener("click", ()=>{
            if (!navigator.onLine) {
                alert($4499829d9d33c525$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                return;
            }
            const id = this.getMovieId();
            this.renderStatus(id, "started");
            this.movies.download(id, this.handleProgress).then(()=>this.handleFinish(id)).catch(console.error);
        });
        this.pause.addEventListener("click", ()=>{
            const id = this.getMovieId();
            this.renderStatus(id, "paused");
            this.movies.pause(id);
        });
        this.trash.addEventListener("click", async ()=>{
            if (confirm($4499829d9d33c525$var$strings.movie13[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                const id = this.getMovieId();
                await this.movies.remove(id);
                this.renderMovie(this.getEpisode());
            }
        });
        window.addEventListener("online", ()=>{
            console.log("\u2705 You are back online");
            this.resume();
        });
        window.addEventListener("offline", async ()=>{
            console.log("\u26A0\uFE0F You are offline");
            const movies = await this.movies.getAllStarted();
            for (const movie of movies)this.renderStatus(movie.id, "paused");
        });
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") {
                console.log("App is going to background");
                this.pauseAll();
            } else console.log("App is foregrounded again");
        });
        window.addEventListener("pagehide", ()=>{
            console.log("Page hidden (might be closing)");
            this.pauseAll();
        });
        window.addEventListener("beforeunload", ()=>{
            this.pauseAll();
        });
    }
    pauseAll() {
        this.video.pause();
        this.youtube?.pauseVideo();
    // Use navigator.sendBeacon() or fetch(..., { keepalive: true })
    }
    // resume any unfinished downloads
    async resume() {
        if (!navigator.onLine) //alert(strings.offline[LANGUAGE]);
        return;
        const movies = await this.movies.getAllStarted();
        for (const movie of movies){
            this.renderStatus(movie.id, "started");
            this.movies.download(movie.id, this.handleProgress).then(()=>this.handleFinish(movie.id)).catch(console.error);
        }
    }
    async handleFinish(id) {
        const movie = await this.movies.get(id);
        switch(movie.status){
            case "completed":
                this.heartbank.alertAdmin("video/download/completed: ", id);
                if (this.isOnPage(id)) await this.renderMovie(this.getEpisode(id));
                alert($4499829d9d33c525$var$strings.movie15[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                break;
            // case "paused":
            //     alert(strings.movie16[LANGUAGE]);
            //     this.renderStatus(id, "paused");
            //     break;
            case "failed":
                this.heartbank.alertAdmin("video/download/failed: ", id);
                alert($4499829d9d33c525$var$strings.movie16[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]); //movie10
                this.renderStatus(id, "failed");
                break;
        }
    // const status = await this.movies.verify(id);
    // switch (status) {
    //     case "incomplete":
    //         // user pauses download
    //         break;
    //     case "failed":
    //         alert(strings.movie10[LANGUAGE]);
    //         this.renderStatus(id, "failed");
    //         break;
    //     case "verified":
    //         if (this.isOnPage(id))
    //             await this.renderMovie(this.getEpisode(id));
    //         alert(strings.movie15[LANGUAGE]);
    //         break;
    // }
    }
    // private handleError(id: string, error: Error) {
    //     console.error(error);
    //     alert(strings.movie10[LANGUAGE]);
    //     this.renderStatus(id, "failed");
    // }
    async renderStatus(id, status) {
        if (this.isOnPage(id)) switch(status){
            case "started":
                this.status.classList.remove("hidden");
                this.download.classList.add("hidden");
                this.pause.classList.remove("hidden");
                this.trash.classList.add("hidden");
                break;
            case "paused":
                this.status.classList.add("hidden");
                this.download.classList.remove("hidden");
                this.pause.classList.add("hidden");
                this.trash.classList.remove("hidden");
                break;
            case "failed":
            case "completed":
                this.status.classList.add("hidden");
                this.download.classList.add("hidden");
                this.pause.classList.add("hidden");
                this.trash.classList.remove("hidden");
                break;
            default:
                this.status.classList.add("hidden");
                this.download.classList.remove("hidden");
                this.pause.classList.add("hidden");
                this.trash.classList.add("hidden");
        }
    }
    async show() {
        this.modal.show(); // order first bc loading below can take awhile on slow phone
        await this.loadYouTubeAPI();
        if (navigator.onLine) this.youtube = await this.initializeYouTube();
        this.renderMovie(); //await
    }
    hide() {
        this.modal.hide();
    }
    goTo(action) {
        const episode = this.getEpisode();
        let part;
        if (episode === 1) part = action ? 2 : 5;
        else if (episode === 5) part = action ? 1 : 4;
        else part = episode + (action ? 1 : -1);
        this.renderMovie(part);
    }
    // isPlay = false => for youtube paging
    async renderMovie(episode = 0, isPlay = true) {
        episode = episode || this.getEpisode();
        const movie = await this.movies.get(this.getMovieId(episode));
        this.heading.textContent = `${$4499829d9d33c525$var$strings.movie6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]} - ${$4499829d9d33c525$var$strings["movie" + episode][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}`;
        this.setEpisode(episode);
        if (isPlay) {
            if (movie.status === "completed" && movie.blob) {
                this.iframe.classList.add("hidden");
                this.youtube?.pauseVideo();
                this.video.classList.remove("hidden");
                this.video.dataset.id = movie.id;
                this.video.src = URL.createObjectURL(movie.blob);
                this.video.currentTime = this.getTime(episode); // movie.time;
                this.video.play(); //await
            } else {
                this.iframe.classList.toggle("hidden", !this.youtube);
                this.youtube?.playVideoAt(episode - 1); //await
                //this.iframe.src = collection[this.movieTitle].youtube[episode - 1];
                this.video.classList.toggle("hidden", !!this.youtube);
                this.video.removeAttribute("src");
                this.video.load(); // needed to stop previous playing and show poster // // doesn't work on safari
            //this.video.pause();
            }
        }
        this.renderStatus(movie.id, movie.status);
        if (episode === 1) {
            this.prev.textContent = "\u2190 " + $4499829d9d33c525$var$strings["movie5"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.next.textContent = $4499829d9d33c525$var$strings["movie2"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + " \u2192";
            this.prev.classList.add("hidden");
            this.next.classList.remove("hidden");
        } else if (episode === 5) {
            this.prev.textContent = "\u2190 " + $4499829d9d33c525$var$strings["movie4"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.next.textContent = $4499829d9d33c525$var$strings["movie1"][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + " \u2192";
            this.prev.classList.remove("hidden");
            this.next.classList.add("hidden");
        } else {
            this.prev.textContent = "\u2190 " + $4499829d9d33c525$var$strings["movie" + (episode - 1)][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.next.textContent = $4499829d9d33c525$var$strings["movie" + (episode + 1)][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + " \u2192";
            this.prev.classList.remove("hidden");
            this.next.classList.remove("hidden");
        }
    }
    // will only load one time
    loadYouTubeAPI() {
        return new Promise((resolve, reject)=>{
            if (!navigator.onLine || window.YT?.Player) resolve();
            const script = document.createElement("script");
            script.src = "https://www.youtube.com/iframe_api";
            script.async = true;
            script.onload = ()=>{
                window.onYouTubeIframeAPIReady = ()=>{
                    resolve();
                };
            };
            script.onerror = ()=>{
                reject(new Error("Failed to load YouTube IFrame API"));
            };
            document.head.appendChild(script);
        });
    }
    // will only load one time
    initializeYouTube() {
        return new Promise((resolve, reject)=>{
            if (this.youtube) resolve(this.youtube);
            else new YT.Player("sw-movie-iframe", {
                host: "https://www.youtube.com",
                //videoId,
                //height: "315",
                //width: "560",
                playerVars: {
                    listType: "playlist",
                    list: $4499829d9d33c525$var$collection[this.movieTitle].playlist,
                    controls: 1,
                    autoplay: 0,
                    mute: 0,
                    modestbranding: 1,
                    rel: 0,
                    showinfo: 0,
                    playsinline: 1,
                    origin: window.location.origin
                },
                events: {
                    onReady: (event)=>{
                        //console.log("YouTube Player is ready");
                        resolve(event.target);
                    },
                    onStateChange: async (event)=>{
                        const episode = this.getEpisode();
                        //const id = this.getMovieId();
                        const time = this.getTime(episode); //await this.movies.getTime(id);
                        switch(event.data){
                            case YT.PlayerState.UNSTARTED:
                                this.hasSeeked = false;
                                break;
                            case YT.PlayerState.CUED:
                                this.hasSeeked = false;
                                break;
                            case YT.PlayerState.BUFFERING:
                                this.youtubeStop();
                                break;
                            case YT.PlayerState.PLAYING:
                                this.youtubeStart();
                                if (!this.hasSeeked) {
                                    this.youtube?.seekTo(time, true);
                                    this.hasSeeked = true;
                                    this.heartbank.alertAdmin(`youtube/watch/episode/${episode}/${time}`);
                                } else this.renderMovie(event.target.getPlaylistIndex() + 1, false);
                                break;
                            case YT.PlayerState.PAUSED:
                                this.youtubeStop();
                                this.heartbank.alertAdmin(`youtube/pause/episode/${episode}/${time}`);
                                break;
                            case YT.PlayerState.ENDED:
                                this.youtubeStop();
                                this.goTo(true);
                                this.heartbank.alertAdmin(`youtube/end/episode/${episode}/${time}`);
                                break;
                        }
                    },
                    onError: (event)=>{
                        //console.error("YouTube Player Error: ", event.data);
                        reject(new Error(`YouTube Player Error: ${event.data}`));
                    }
                }
            });
        });
    }
}








var $40f2b2a9fde1eb7d$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-popup"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        HeartBank®
                    </h3>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-popup">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <iframe
                    id="sw-popup-iframe"
                    class="border-none w-full h-96"></iframe>
                <!-- Modal footer -->
                <div
                    class="hidden items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-popup-btn"
                        type="button"
                        class="text-white w-32 bg-logo hover:bg-logo/25 focus:ring-4 focus:outline-none focus:ring-logo/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-logo-dark dark:hover:bg-logo-dark/50 dark:focus:ring-logo-dark/10">
                        Continue
                    </button>
                    <button
                        data-modal-hide="sw-popup"
                        type="button"
                        class="text-white w-32 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
`;






const $87798d7d101b1927$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $87798d7d101b1927$export$66fda3396a23c781 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.opener = null;
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $40f2b2a9fde1eb7d$export$2e2bcd8739ae039)(null), this);
        this.popup = this.querySelector("#sw-popup");
        this.iframe = this.querySelector("#sw-popup-iframe");
        this.btn = this.querySelector("#sw-popup-btn");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: ()=>{
            //window.location.hash = "#";
            },
            onShow: ()=>{
                this.popup.style.zIndex = "70";
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-popup",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.popup, modalOptions, instanceOptions);
    }
    connectedCallback() {
        window.addEventListener("message", (event)=>{
            if (event.origin === (0, $eba1d7d434ec7c0e$export$76f2fb31d8fa450a)) this.handleMessageFromPopup(event.data);
        });
    }
    show(src) {
        this.iframe.src = src;
        this.modal.show();
    }
    hide() {
        this.modal.hide();
    }
    // browser only allows popups to be opened in response to a user action unless user specifically allows
    // TODO: when account is updated => postMessage to opener => re-render // display name
    openVault(page, showIframe = false) {
        const url = (0, $eba1d7d434ec7c0e$export$76f2fb31d8fa450a) + `/?lang=${$87798d7d101b1927$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}&origin=${this.heartbank.isRunningAsPWA() ? "pwa" : "web"}#/${page}`;
        this.opener = window.open(url, "HeartBank\xae Vault", "width=500,height=500");
        if (!this.opener) {
            if (showIframe) this.show(url);
            else alert($87798d7d101b1927$var$strings.feedback7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]); // iframe does not store login state
        }
    }
    openHB(page, showIframe = false) {
        const url = (0, $eba1d7d434ec7c0e$export$eb9b3c606836bffa) + `/?lang=${$87798d7d101b1927$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}&origin=${this.heartbank.isRunningAsPWA() ? "pwa" : "web"}#/${page}`;
        this.opener = window.open(url, "HeartBank\xae Vault", "width=500,height=500");
        if (!this.opener) {
            if (showIframe) this.show(url);
            else alert($87798d7d101b1927$var$strings.feedback7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]); // iframe does not store login state
        }
    }
    async handleMessageFromPopup(data) {
        switch(data.action){
            case "success":
                this.opener?.close();
                this.hide();
                break;
            case "logout":
                this.opener?.close();
                this.hide();
                break;
            case "error":
                this.opener?.close();
                this.hide();
                //window.location.hash = "#";
                alert(data.text);
                break;
            default:
        }
    }
    sendMessageToPopup(data) {
        this.opener?.postMessage(data, (0, $eba1d7d434ec7c0e$export$76f2fb31d8fa450a));
    }
}











var $84bf34fab6ddac64$exports = {};
$84bf34fab6ddac64$exports = new URL("trophy.65fb719c.svg", import.meta.url).toString();


const $98f387e058d92b67$var$TROPHY = new URL($84bf34fab6ddac64$exports).href;
const $98f387e058d92b67$var$template = document.createElement("template");
$98f387e058d92b67$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <nav
        class="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
        <div
            class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
            <aside class="flex items-center space-x-3 rtl:space-x-reverse">
                <button
                    data-drawer-target="sw-menu"
                    data-drawer-show="sw-menu"
                    onclick="heartbank.alertAdmin('header/click/menu')"
                    type="button"
                    class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    aria-controls="navbar-default"
                    aria-expanded="false">
                    <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).open[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    <svg
                        class="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 17 14">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 1h15M1 7h15M1 13h15" />
                    </svg>
                </button>
                <div id="title-home" class="hidden">
                    <button
                        data-modal-show="sw-feedback"
                        onclick="heartbank.alertAdmin('header/home/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).title2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        class="moul self-center ${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "text-xl" : "text-3xl"} font-semibold whitespace-nowrap text-theme">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).title[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
                <div id="title-page" class="hidden">
                    <button
                        onclick="heartbank.alertAdmin('header/page/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).book[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        class="moul self-center text-xl md:text-2xl font-semibold whitespace-nowrap">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).book[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <span
                        class="moul ms-2 bg-blue-100 text-blue-800 text-lg md:text-2xl font-black me-2 px-2 md:px-4 py-0 rounded dark:bg-blue-900 dark:text-blue-300"></span>
                </div>
                <div id="title-map" class="hidden">
                    <button
                        data-modal-show="sw-feedback"
                        onclick="heartbank.alertAdmin('header/map/click/title')"
                        class="moul self-center text-2xl font-semibold whitespace-nowrap text-theme"></button>
                </div>
            </aside>
            <div
                class="hidden"
                id="sw-header-home"
                class="flex items-center md:order-2 space-x-1 md:space-x-0 rtl:space-x-reverse">
                <button
                    type="button"
                    onclick="heartbank.alertAdmin('header/home/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)))[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                    data-dropdown-toggle="language-dropdown-menu"
                    class="inline-flex items-center font-medium justify-center px-4 py-2 text-sm text-gray-500 dark:text-gray-300 rounded-lg cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
                    <svg
                        class="w-5 h-5 rounded-full me-3"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        fill="currentColor"
                        width="20"
                        viewBox="0 0 512 512">
                        <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                        <path
                            d="${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9l2.3 0c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z" : "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"}" />
                    </svg>
                    ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)))[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </button>
                <!-- Dropdown -->
                <div
                    class="z-50 hidden my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700"
                    id="language-dropdown-menu">
                    <ul class="py-2 font-medium" role="none">
                        <li
                            id="khmer"
                            onclick="heartbank.alertAdmin('header/home/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).khmer[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                            role="menuitem">
                            <button class="inline-flex items-center">
                                <span class="text-base me-3">🇰🇭</span>
                                ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).khmer[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                            </button>
                        </li>
                        <li
                            id="english"
                            onclick="heartbank.alertAdmin('header/home/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).english[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white"
                            role="menuitem">
                            <button class="inline-flex items-center">
                                <span class="text-base me-3">🇺🇸</span>
                                <!--<svg
                                    class="h-3.5 w-3.5 me-2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 36.1-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3l0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1l0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3l0 33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-70.5 0-32.7 0-63.3 0-32.7 0-63.3 0-32.7L0 64 0 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z" />
                                </svg>-->
                                ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).english[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="sw-header-page" class="hidden cursor-pointer">
                <button id="book-marked" class="hidden">
                    <svg
                        class="w-7 h-10"
                        onclick="heartbank.alertAdmin('header/page/remove/bookmark')"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512">
                        <path
                            fill="red"
                            d="M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z" />
                    </svg>
                </button>
                <button id="book-mark" class="hidden">
                    <svg
                        class="w-7 h-10"
                        onclick="heartbank.alertAdmin('header/page/add/bookmark')"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512">
                        <path
                            fill="blueviolet"
                            d="M0 96C0 43 43 0 96 0l96 0 0 190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5L352 0l32 0 32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32z" />
                    </svg>
                </button>
            </div>
            <div
                id="sw-header-map"
                class="hidden rounded-md shadow-xs"
                role="group">
                <img
                    id="sw-header-map-prize"
                    onclick="heartbank.alertAdmin('header/map/click/prize');prompt('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map34[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}','${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                    src="${$98f387e058d92b67$var$TROPHY}"
                    width="35"
                    height="35"
                    class="me-3 cursor-pointer" />
                <div
                    id="sw-header-map-calendar"
                    onclick="heartbank.alertAdmin('header/map/click/calendar')"
                    inline-datepicker
                    data-date="09/28/2026"
                    class="hidden absolute top-32 left-1/2 transform -translate-x-1/2"></div>
                <button
                    id="sw-header-map-me"
                    onclick="heartbank.alertAdmin('header/map/click/me')"
                    type="button"
                    class="text-white bg-hb hover:bg-hb/50 focus:ring-4 focus:outline-none focus:ring-hb/25 font-medium rounded-lg text-sm px-3 py-2 text-center">
                    ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map16[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </button>
                <button
                    id="sw-header-map-heartbank"
                    onclick="heartbank.alertAdmin('header/map/click/heartbank')"
                    type="button"
                    class="hidden text-white bg-hb hover:bg-hb/50 focus:ring-4 focus:outline-none focus:ring-hb/25 font-medium rounded-lg text-sm px-3 py-2 text-center">
                    ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map5[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </button>
                <button
                    id="sw-header-map-feedback"
                    onclick="heartbank.alertAdmin('header/map/click/feedback')"
                    type="button"
                    class="hidden pl-4 pr-2 py-2 text-white bg-hb hover:bg-hb/50 focus:ring-4 focus:outline-none focus:ring-hb/25 font-medium rounded-lg text-sm text-center">
                    <aside id="sw-donate-hb">
                        Heart
                        <svg
                            class="mt-[-1px] ml-[-6px] mr-[-4px] inline fill-white"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="19"
                            height="19">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ank<sup>®</sup>
                    </aside>
                </button>
            </div>
        </div>
    </nav>
`;
var $98f387e058d92b67$export$2e2bcd8739ae039 = $98f387e058d92b67$var$template;



var $jaOzc = parcelRequire("jaOzc");




class $d181ac6e59b5bb21$export$8c14ec2509ec1ea5 extends (0, $jaOzc.default) {
    constructor(){
        super("Bookmarks"), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)();
        this.version(parseInt((0, $8f13b60c0ee5b277$exports.version))).stores({
            bookmarks: "++id, date, book, page, [book+page]"
        }).upgrade((tx)=>{
        // TODO: later delete old version of dexie
        // return tx
        //     .table("bookmarks")
        //     .toCollection()
        //     .modify((bookmark) => {
        //         bookmark.date = new Date();
        //     });
        });
        this.bookmarks = this.table("bookmarks");
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "bookmarks");
    }
    async getRecent() {
        const user = await this.heartbank.waitForAuth2();
        return user ? this.getRecentBookmark(user.uid) : this.getRecent2();
    }
    async get(book) {
        const user = await this.heartbank.waitForAuth2();
        return user ? this.getBookmark(user.uid, book) : this.get2(book);
    }
    async update(book, page) {
        const user = await this.heartbank.waitForAuth2();
        return user ? this.updateBookmark(user.uid, book, page) : this.update2(book, page);
    }
    async remove(book, page) {
        const user = await this.heartbank.waitForAuth2();
        return user ? this.removeBookmark(user.uid, book, page) : this.remove2(book, page);
    }
    // dexie
    async getRecent2() {
        const bookmark = await this.bookmarks.orderBy("date").last();
        return bookmark ? {
            book: bookmark.book,
            page: bookmark.page
        } : null;
    }
    async get2(book) {
        const bookmark = await this.bookmarks.where("book").equals(book).first();
        return bookmark ? bookmark.page : null;
    }
    async update2(book, page) {
        const bookmark = await this.bookmarks.where("book").equals(book).first();
        if (bookmark) {
            bookmark.date = new Date();
            bookmark.page = page;
            return this.bookmarks.update(bookmark.id, bookmark);
        } else return this.bookmarks.add({
            date: new Date(),
            book: book,
            page: page
        });
    }
    async remove2(book, page) {
        const bookmark = await this.bookmarks.where("[book+page]").equals([
            book,
            page
        ]).first();
        return this.bookmarks.delete(bookmark.id);
    }
    // firestore
    async getRecentBookmark(uid) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const bookmark = querySnapshot.docs[0]?.data();
        return bookmark ? {
            book: bookmark.book,
            page: bookmark.page
        } : null;
    }
    async getBookmark(uid, book) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("book", "==", book));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const bookmark = querySnapshot.docs[0]?.data();
        return bookmark?.page ?? null;
    }
    async updateBookmark(uid, book, page) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("book", "==", book));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (querySnapshot.empty) {
            const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, {
                uid: uid,
                date: new Date(),
                book: book,
                page: page
            });
            return docRef.id;
        } else {
            const docSnap = querySnapshot.docs[0];
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "bookmarks", docSnap.id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                date: new Date(),
                page: page
            });
            return docSnap.id;
        }
    }
    async removeBookmark(uid, book, page) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("book", "==", book), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("page", "==", page));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const docSnap = querySnapshot.docs[0];
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "bookmarks", docSnap.id);
        await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(docRef);
    }
    async setupRealtimeListener(uid, book, callback) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("book", "==", book));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "bookmarks", docSnap.id);
            if (this.unsubscribe) this.unsubscribe();
            const unsubscribe = (0, $70fd6868680e912c$export$d36370812fb26935)(docRef, (docSnap)=>{
                if (docSnap.exists()) {
                    const bookmark = {
                        uid: docSnap.id,
                        ...docSnap.data()
                    };
                    callback(bookmark.page);
                }
            }, (error)=>{
                console.error("Error listening to document: ", error.message);
            });
            this.unsubscribe = unsubscribe;
        }
    }
}






var $jaOzc = parcelRequire("jaOzc");



class $d0e8a14726007347$export$22bbd736cbae49dc extends (0, $jaOzc.default) {
    constructor(){
        super("Transcriptions");
        this.version(parseInt((0, $8f13b60c0ee5b277$exports.version))).stores({
            transcriptions: "++id, id2, book, page, language, [book+page+language]"
        }).upgrade((tx)=>{
            // Access the 'transcriptions' table
            const transcriptionsTable = tx.table("transcriptions");
        // Example 1: Delete a specific record by primary key (id)
        //return transcriptionsTable.delete(1); // Deletes the record with id = 1
        // Example 2: Delete records matching a condition
        // return transcriptionsTable
        //     .where('book')
        //     .equals('someBook')
        //     .delete(); // Deletes all records where book = 'someBook'
        // Example 3: Clear the entire table
        //return transcriptionsTable.clear(); // Deletes all records in the table
        });
        this.transcriptions = this.table("transcriptions");
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "transcriptions");
    }
    // can also update by dexie id ??
    async getByID(id) {
        return await this.transcriptions.where("id2").equals(id).first() || null;
    }
    // deprecated
    //TODO: always call firestore so dexie becomes obsolete! // do as drafts instead!
    // later: just get metadata like updateTime via cloud function; maybe cheaper than firestore reads?
    async checkForUpdate(id) {
        const transcription = await this.getByID(id);
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "transcriptions", id);
        const docSnapshot = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        const exists = docSnapshot.exists(); // deleted ?
        const data = {
            id: id,
            ...docSnapshot.data()
        };
        if (data.editedDate !== transcription.date) {
            this.update(id, data.editedDate, data.book, data.page, data.language, data.transcript, data.translation);
            return data;
        } else return null;
    }
    // deprecated
    async get(book, page, language) {
        const transcription = await this.transcriptions.where("[book+page+language]").equals([
            book,
            page,
            language
        ]).first();
        if (transcription) {
            const transcription2 = this.checkForUpdate(transcription.id2);
            if (transcription2) return transcription2;
            else return {
                id: transcription.id2,
                uid: null,
                editedDate: transcription.date,
                book: transcription.book,
                page: transcription.page,
                language: transcription.language,
                transcript: transcription.transcript,
                translation: transcription.translation,
                audio: null
            };
        } else return null;
    }
    async update(id, date, book, page, language, transcript, translation) {
        const transcription = await this.getByID(id);
        if (transcription) {
            transcription.date = date;
            if (transcript) transcription.transcript = transcript;
            if (translation) transcription.translation = translation;
            return this.transcriptions.update(transcription.id, transcription);
        } else return this.transcriptions.add({
            id2: id,
            date: date,
            book: book,
            page: page,
            language: language,
            transcript: transcript,
            translation: translation
        });
    }
    // returns number of deleted items = should be 2
    async remove(book, page) {
        return this.transcriptions.where("[book+page]").equals([
            book,
            page
        ]).delete();
    }
    // firestore
    // weird bug: double entry: one with editedDate null and one without... could be related to past refactor...
    async getTranscription(book, page, language) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("book", "==", book), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("page", "==", page), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("language", "==", language));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            const docData = docSnap.data();
            return {
                id: docSnap.id,
                ...docData
            };
        } else return null; //TODO: create new doc ??? maybe // can bypass cloud function; but need to update firestore rule // if running out of quota for cloud function
    }
    async updateTranscript(id, uid, transcript) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "transcriptions", id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                transcript: transcript,
                editedDate: new Date()
            });
            return "success";
        } catch (error) {
            console.error("Error updating document: ", error.message);
            return "error";
        }
    }
    async updateTranslation(id, uid, translation) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "transcriptions", id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                translation: translation,
                editedDate: new Date()
            });
            return "success";
        } catch (error) {
            console.error("Error updating document: ", error.message);
            return "error";
        }
    }
    async updateAudio(id, uid, audio) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "transcriptions", id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                audio: audio
            });
            return "success";
        } catch (error) {
            console.error("Error updating audio: ", error.message);
            return "error";
        }
    }
    setupRealtimeListener(element, id, language, callback) {
        // Reference to single document
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "transcriptions", id);
        // Clean up existing listener if it exists
        if (element === "pali") {
            if (this.unsubscribePali) this.unsubscribePali();
        } else if (this.unsubscribeKhmer) this.unsubscribeKhmer();
        // Listen to single document changes
        const unsubscribe = (0, $70fd6868680e912c$export$d36370812fb26935)(docRef, (docSnap)=>{
            if (docSnap.exists()) {
                const transcription = {
                    id: docSnap.id,
                    ...docSnap.data()
                };
                // this.update(
                //     transcription.id,
                //     transcription.editedDate,
                //     transcription.book,
                //     transcription.page,
                //     transcription.language,
                //     transcription.transcript || "",
                //     transcription.translation || ""
                // );
                callback(element, transcription.id, transcription.editedDate, transcription.transcript, language === "khmer" ? transcription.transcript : transcription.translation, !!transcription.transcript, transcription.audio);
            // (document.querySelector("sw-khmer") as any).render(
            //     language === "khmer"
            //         ? transcription.transcript
            //         : transcription.translation
            // );
            }
        }, (error)=>{
            console.error("Error listening to document: ", error.message);
        });
        if (element === "pali") this.unsubscribePali = unsubscribe;
        else this.unsubscribeKhmer = unsubscribe;
    }
}


const $731ff9b2771f6dab$var$LANGUAGE2 = "khmer";
const $731ff9b2771f6dab$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
const $731ff9b2771f6dab$var$bedok = (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)));
class $731ff9b2771f6dab$export$3135a074e4cf1c06 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.transcriptions = new (0, $d0e8a14726007347$export$22bbd736cbae49dc)(), this.bookmarks = new (0, $d181ac6e59b5bb21$export$8c14ec2509ec1ea5)(), this.feedback = document.querySelector("sw-feedback"), this.popup2 = document.querySelector("sw-popup"), this.toc = document.querySelector("sw-toc"), this.popup = null, this.hasShownFeedback = false;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-header");
        this.componentTrace.start();
        this.appendChild((0, $98f387e058d92b67$export$2e2bcd8739ae039).content.cloneNode(true));
        this.titleHome = this.querySelector("#title-home");
        this.home = this.querySelector("#sw-header-home");
        this.khmer = this.querySelector("#khmer");
        this.english = this.querySelector("#english");
        this.titlePage = this.querySelector("#title-page");
        this.basket = this.titlePage.firstElementChild;
        this.number = this.titlePage.lastElementChild;
        this.page = this.querySelector("#sw-header-page");
        this.bookmark = this.querySelector("#book-mark");
        this.bookmarked = this.querySelector("#book-marked");
        this.titleMap = this.querySelector("#title-map");
        this.mapName = this.titleMap.firstElementChild;
        this.map = this.querySelector("#sw-header-map");
        this.mapMe = this.querySelector("#sw-header-map-me");
        this.prize = this.querySelector("#sw-header-map-prize");
        this.calendar = this.querySelector("#sw-header-map-calendar");
        this.hbBtn = this.querySelector("#sw-header-map-heartbank");
        this.fbBtn = this.querySelector("#sw-header-map-feedback");
    }
    connectedCallback() {
        this.khmer.addEventListener("click", (event)=>this.changeLanguage("khmer"));
        this.english.addEventListener("click", (event)=>this.changeLanguage("english"));
        this.bookmark.addEventListener("click", async ()=>{
            this.bookmark.disabled = true;
            await this.updateBookmark(true);
            if (!this.hasShownFeedback && !this.heartbank.isLoggedIn) {
                this.feedback.show();
                this.hasShownFeedback = true;
                alert($731ff9b2771f6dab$var$strings.feedback14[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            }
            this.bookmark.disabled = false;
        });
        this.bookmarked.addEventListener("click", async ()=>{
            this.bookmarked.disabled = true;
            await this.updateBookmark(false);
            this.bookmarked.disabled = false;
        });
        this.number.addEventListener("click", this.downloadPDF.bind(this));
        this.prize.addEventListener("click", ()=>this.calendar.classList.toggle("hidden"));
        this.calendar.addEventListener("click", ()=>this.calendar.classList.toggle("hidden"));
        this.hbBtn.addEventListener("click", this.feedback.show.bind(this.feedback));
        this.fbBtn.addEventListener("click", this.feedback.show.bind(this.feedback));
        this.mapName.addEventListener("click", ()=>{
        //document.location.hash = "#bookmark";
        //window.history.back();
        });
        this.mapMe.addEventListener("click", ()=>{
            const map = document.querySelector("sw-map");
            map.panToUser();
        });
        this.heartbank.addAuthStateListener3((hero, user)=>{
            const paths = window.location.hash.split("/");
            if (paths[2] !== undefined && paths[4] !== undefined) {
                const book = parseInt(paths[2]);
                const page = parseInt(paths[4]);
                this.renderBookmark(book, page);
                if (user) this.bookmarks.setupRealtimeListener(user.uid, book, (page)=>this.renderBookmark(book, page));
            }
        // name might be too long
        // this.mapMe.textContent =
        //     hero?.displayName || strings.map16[LANGUAGE];
        // if (user) {
        //     this.hbBtn.classList.replace("inline-flex", "hidden");
        //     this.fbBtn.classList.replace("hidden", "inline-flex");
        // } else {
        //     this.fbBtn.classList.replace("inline-flex", "hidden");
        //     this.hbBtn.classList.replace("hidden", "inline-flex");
        // }
        });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    show() {
        this.classList.remove("hidden");
    }
    hide() {
        this.classList.add("hidden");
    }
    showHome() {
        this.titleHome.classList.remove("hidden");
        this.titlePage.classList.add("hidden");
        this.titleMap.classList.add("hidden");
        this.home.classList.remove("hidden");
        this.page.classList.remove("inline-flex");
        this.page.classList.add("hidden");
        this.map.classList.replace("inline-flex", "hidden");
    }
    showPage() {
        this.titlePage.classList.remove("hidden");
        this.titleHome.classList.add("hidden");
        this.titleMap.classList.add("hidden");
        this.page.classList.add("inline-flex");
        this.page.classList.remove("hidden");
        this.home.classList.add("hidden");
        this.map.classList.replace("inline-flex", "hidden");
        this.render();
    }
    showMap(page = (0, $eba1d7d434ec7c0e$export$ce970371e0e850bc)) {
        this.titleMap.classList.remove("hidden");
        this.titlePage.classList.add("hidden");
        this.titleHome.classList.add("hidden");
        this.map.classList.replace("hidden", "inline-flex");
        this.page.classList.remove("inline-flex");
        this.page.classList.add("hidden");
        this.home.classList.add("hidden");
        switch(page){
            case "leaderboard":
                this.mapName.textContent = $731ff9b2771f6dab$var$strings.leaderboard[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                break;
            case "now":
                this.mapName.textContent = $731ff9b2771f6dab$var$strings.now[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                break;
            case "history":
                this.mapName.textContent = $731ff9b2771f6dab$var$strings.history[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                break;
        }
    }
    async render() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);
        const basket = this.getBasket(book);
        this.basket.classList.remove(...$731ff9b2771f6dab$var$strings.baskets.colors);
        this.basket.classList.add($731ff9b2771f6dab$var$strings.baskets.colors[basket]);
        this.basket.textContent = $731ff9b2771f6dab$var$strings.baskets2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][basket];
        this.basket.addEventListener("click", this.toc.show.bind(this.toc, "pali", 1, 1));
        //await this.heartbank.waitForAuth();
        this.heartbank.addAuthStateListener3(()=>{
            if (this.heartbank.isAdmin()) {
                this.number.classList.remove("cursor-pointer");
                this.number.classList.remove("cursor-progress");
                this.number.classList.add("cursor-crosshair");
            } else {
                this.number.classList.remove("cursor-progress");
                this.number.classList.remove("cursor-crosshair");
                this.number.classList.add("cursor-pointer");
            }
        });
        //this.number.target = "_blank";
        //this.number.href = Bedok["khmer"].pdfs[book - 1];
        this.number.textContent = book.toKhmer((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa));
        this.renderBookmark(book, page);
    }
    // TODO: deprecate use Books.ts
    getBasket(book) {
        for(let index = 0; index < $731ff9b2771f6dab$var$bedok[$731ff9b2771f6dab$var$LANGUAGE2].baskets.length; index++){
            const basket = $731ff9b2771f6dab$var$bedok[$731ff9b2771f6dab$var$LANGUAGE2].baskets[index];
            if (book <= basket + 1) return index;
        }
        return -1; // Return a default value if no basket is found
    }
    async updateBookmark(task) {
        if (this.heartbank.hero && !navigator.onLine) {
            alert($731ff9b2771f6dab$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);
        if (task) await this.bookmarks.update(book, page);
        else await this.bookmarks.remove(book, page);
        this.renderBookmark(book, page);
        // this.dispatchEvent(
        //     new CustomEvent<{ info: string }>("sw-banner", {
        //         bubbles: true,
        //         detail: {
        //             info: task
        //                 ? strings.saved[LANGUAGE]
        //                 : strings.removed[LANGUAGE]
        //         }
        //     })
        // );
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "bookmark", {
            task: task,
            book: book,
            page: page
        });
    }
    async renderBookmark(book, page) {
        const bookmark = await this.bookmarks.get(book);
        if (bookmark === page) {
            this.bookmark.classList.add("hidden");
            this.bookmarked.classList.remove("hidden");
        } else {
            this.bookmark.classList.remove("hidden");
            this.bookmarked.classList.add("hidden");
        }
    }
    changeLanguage(language) {
        localStorage.setItem("language", language);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "language", {
            language: language
        });
        window.location.reload();
    }
    async downloadPDF(event) {
        if (!navigator.onLine) {
            alert($731ff9b2771f6dab$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        //event.preventDefault();
        const a = document.createElement("a");
        if (this.heartbank.isAdmin()) {
            this.number.classList.replace("cursor-crosshair", "cursor-progress");
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const getBookPages = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)((0, $9d0840e0f81e5cfa$export$18af1f934c132a41), "getBookPages", {
                limitedUseAppCheckTokens: true
            });
            const result = await getBookPages({
                book: book
            });
            const { khmer: khmer, pali: pali, english: english } = result.data;
            a.href = `data:application/pdf;base64,${khmer}`;
            a.download = "Book " + book;
            // a.target = "_blank";
            // a.rel = "noopener"; // optional for security
            this.number.classList.replace("cursor-progress", "cursor-crosshair");
        } else this.toc.show("khmer", 1, 1);
        a.click();
    }
}









var $bd94f549c2d2c641$exports = {};
$bd94f549c2d2c641$exports = new URL("buddha.93bb0cbc.png", import.meta.url).toString();


const $a71c3d20e61d67c8$var$BUDDHA = new URL($bd94f549c2d2c641$exports).href;
const $a71c3d20e61d67c8$var$template = document.createElement("template");
$a71c3d20e61d67c8$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <div
        id="sw-banner"
        onclick="heartbank.alertAdmin('header/hide/banner')"
        tabindex="-1"
        class="transform -translate-y-full transition-all duration-500 ease-out fixed top-0 start-0 z-[999] flex justify-between w-full p-4 border-b border-gray-200 dark:border-gray-600 bg-purple-200">
        <div class="flex items-center mx-auto">
            <p
                id="sw-banner-info"
                class="flex items-center text-lg font-normal text-gray-500 dark:text-gray-400"></p>
        </div>
        <div class="flex items-center">
            <button
                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                data-dismiss-target2="#sw-banner"
                type="button"
                class="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 dark:hover:bg-gray-600 dark:hover:text-white">
                <svg
                    class="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14">
                    <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
                <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
            </button>
        </div>
        <picture class="w-full h-full hidden">
            <img src="${$a71c3d20e61d67c8$var$BUDDHA}" class="rounded-lg" />
        </picture>
    </div>
`;
var $a71c3d20e61d67c8$export$2e2bcd8739ae039 = $a71c3d20e61d67c8$var$template;


class $5eca04e5eacb5938$export$71e4acf879c0e3dd extends HTMLElement {
    constructor(){
        super(), this.timer = 0;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-banner");
        this.componentTrace.start();
        this.appendChild((0, $a71c3d20e61d67c8$export$2e2bcd8739ae039).content.cloneNode(true));
        this.banner = this.querySelector("#sw-banner");
        this.info = this.querySelector("#sw-banner-info");
        this.buddha = this.querySelector("picture");
    }
    connectedCallback() {
        this.addEventListener("click", (event)=>this.hideBanner(0));
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    showBanner(info, reload = false) {
        this.info.textContent = info;
        if (window.location.hash === "#ai") this.buddha.classList.remove("hidden");
        else this.buddha.classList.add("hidden");
        clearTimeout(this.timer);
        this.timer = window.setTimeout(()=>{
            this.banner.classList.remove("-translate-y-full");
            this.hideBanner(10000, reload);
        }, 500);
    }
    hideBanner(duration, reload = false) {
        clearTimeout(this.timer);
        this.timer = window.setTimeout(()=>{
            if (reload) window.location.reload();
            else this.banner.classList.add("-translate-y-full");
        }, duration);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "close", {
            banner: "top"
        });
    }
}















var $19eb2238ec22bbb9$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-editor"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-3xl font-semibold text-theme">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).editor[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </h3>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-editor">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form class="p-4 md:p-5">
                    <section
                        class="text-2xl font-medium w-full inline-flex items-center justify-between">
                        <label
                            for="sw-editor-input"
                            class="mb-2 text-gray-900 dark:text-white"></label>
                        <aside>
                            <input
                                class="hidden"
                                type="file"
                                id="sw-editor-mp3"
                                accept=".mp3" />
                            <button
                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).editor7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                type="button"
                                id="sw-editor-upload"
                                class="mr-2">
                                🔈
                            </button>
                            <button
                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).editor8[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                type="button"
                                id="sw-editor-translate">
                                📑
                            </button>
                        </aside>
                    </section>
                    <textarea
                        id="sw-editor-input"
                        rows="4"
                        class="leading-[2.2] block p-2.5 w-full h-96 text-base md:text-xl text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-400 dark:placeholder-gray-400"
                        placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).editor2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        required></textarea>
                    <section class="text-sm font-medium mt-5">
                        <progress
                            class="text-orange-500 w-full hidden"
                            value="0"
                            max="100"></progress>
                        <p
                            id="sw-editor-message"
                            class="text-green-500 dark:text-green-300"></p>
                    </section>
                    <section
                        class="w-full mt-5 inline-flex items-center justify-around">
                        <button
                            onclick="heartbank.alertAdmin('editor/click/submit')"
                            type="submit"
                            class="text-white w-28 disabled:opacity-50 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).editor3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </button>
                        <button
                            data-modal-hide="sw-editor"
                            type="button"
                            class="text-white w-28 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </button>
                    </section>
                </form>
            </div>
        </div>
    </div>
`;




const $41778cbaafe474f6$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $41778cbaafe474f6$export$e3fc611701aa4042 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.transcriptions = new (0, $d0e8a14726007347$export$22bbd736cbae49dc)() // manager
        , this.transcription = null // ID
        , this.language = null // reader lang attribute; useful? deprecate?
        , this.text = "", this.SwReader = null;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-editor");
        this.componentTrace.start();
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $19eb2238ec22bbb9$export$2e2bcd8739ae039)(null), this);
        this.editor = this.querySelector("#sw-editor");
        this.form = this.querySelector("form");
        this.input = this.querySelector("#sw-editor-input");
        this.message = this.querySelector("#sw-editor-message");
        this.submitBtn = this.querySelector("button[type=submit]");
        this.mp3Input = this.querySelector("#sw-editor-mp3");
        this.mp3Btn = this.querySelector("#sw-editor-upload");
        this.translateBtn = this.querySelector("#sw-editor-translate");
        this.progress = this.querySelector("progress");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: false,
            onHide: async ()=>{
                if (this.input.value.trim() && this.input.value.trim() !== this.text.trim()) {
                    if (navigator.onLine) {
                        const answer = confirm($41778cbaafe474f6$var$strings.editor4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                        if (answer) this.handleSubmit();
                    } else alert($41778cbaafe474f6$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                }
                this.SwReader?.show();
                this.message.innerText = "";
            //window.location.hash = "#";
            },
            onShow: ()=>{
                this.editor.style.zIndex = "70";
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-editor",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.editor, modalOptions, instanceOptions);
    }
    connectedCallback() {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        //TODO: later v2 use pickFile instead
        this.mp3Btn.addEventListener("click", ()=>{
            this.mp3Input.click();
        });
        this.translateBtn.addEventListener("click", this.translateToEnglish.bind(this));
        this.mp3Input.addEventListener("change", this.uploadMp3.bind(this));
        this.input.addEventListener("input", async (event)=>{
            // save draft
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            this.transcriptions.update(this.transcription, new Date(), book, page, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa), (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? this.input.value.trim() : "", (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "" : this.input.value.trim());
            this.message.innerText = $41778cbaafe474f6$var$strings.editor5[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "pink";
            clearTimeout(this.timer);
            this.timer = setTimeout(()=>this.message.innerHTML = "", 3000);
            this.submitBtn.disabled = !(navigator.onLine && this.input.value.trim() && this.input.value.trim() !== this.text.trim());
        });
        window.addEventListener("offline", (event)=>this.submitBtn.disabled = true);
        window.addEventListener("online", (event)=>this.submitBtn.disabled = false);
        // this.heartbank.addAuthStateListener3((hero, user) => {
        //     render(template(user), this);
        // });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    async show(id, language, text, modal) {
        this.transcription = id;
        this.language = language;
        this.text = text || "";
        this.SwReader = modal;
        const label = this.querySelector("label");
        label.innerHTML = language === "khmer" ? $41778cbaafe474f6$var$strings.khmer2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] : $41778cbaafe474f6$var$strings.pali2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        if (language === "khmer") {
            //this.input.classList.replace("moulpali", "battambang");
            this.input.classList.add("battambang");
            this.input.classList.remove("moulpali");
        } else {
            //this.input.classList.replace("battambang", "moulpali");
            this.input.classList.remove("battambang");
            this.input.classList.add("moulpali");
        }
        // get draft
        // const draft = await this.transcriptions.getByID(this.transcription);
        // this.input.value =
        //     (LANGUAGE === "khmer" ? draft?.transcript : draft?.translation) ??
        //     this.text;
        // temp for dad
        this.input.value = await navigator.clipboard.readText();
        this.submitBtn.disabled = !(navigator.onLine && this.input.value.trim() && this.input.value.trim() !== this.text.trim());
        this.modal.show();
        this.input.focus();
    }
    hide() {
        this.modal.hide();
    }
    async handleSubmit(event = null) {
        event?.preventDefault();
        if (navigator.onLine) {
            const text = this.input.value.trim();
            const response = (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? await this.transcriptions.updateTranscript(this.transcription, this.heartbank.user.uid, text) : await this.transcriptions.updateTranslation(this.transcription, this.heartbank.user.uid, text);
            if (response === "success") {
                this.text = text;
                this.modal.hide();
            //this.form.reset();
            } else {
                this.message.innerText = `Error updating ${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "transcript" : "translation"}.`;
                this.message.style.color = "red";
                if (!event) alert(this.message.innerText);
            }
        } else {
            this.message.innerText = $41778cbaafe474f6$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "orange";
            if (!event) alert(this.message.innerText);
        }
    }
    uploadMp3(event) {
        if (!navigator.onLine) {
            alert($41778cbaafe474f6$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        const file = this.mp3Input.files?.[0];
        if (!file) {
            this.message.innerText = $41778cbaafe474f6$var$strings.audio[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "orange";
            return;
        }
        if (file.type !== "audio/mpeg") {
            this.message.innerText = $41778cbaafe474f6$var$strings.audio2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "red";
            return;
        }
        this.progress.classList.remove("hidden");
        this.progress.value = 0;
        this.mp3Btn.disabled = true;
        this.message.innerHTML = $41778cbaafe474f6$var$strings.audio3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        this.message.style.color = "orange";
        try {
            // Store files under user-specific path: uid/audio/khmer/book/1/page/3
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            const fileName = file.name.replace(/\s+/g, "_"); // same filename will be replaced
            const filePath = `${this.heartbank.user.uid}/audio/khmer/${book}/${page}`;
            const metadata = {
                customMetadata: {
                    fileName: fileName
                }
            };
            const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)((0, $9d0840e0f81e5cfa$export$ddcffe0146c8f882), filePath);
            const uploadTask = (0, $df9a6d7fd06616c9$export$3895d39eb7ac9b25)(storageRef, file, metadata);
            uploadTask.on("state_changed", (snapshot)=>{
                this.progress.value = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            }, (error)=>{
                this.message.innerText = `Upload failed: ${error.message}`;
                this.message.style.color = "red";
                this.mp3Btn.disabled = false;
                this.progress.classList.add("hidden");
                this.mp3Input.value = "";
            //this.progress.value = 0;
            //this.mp3Input.files = null;
            }, async ()=>{
                const downloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(uploadTask.snapshot.ref);
                await this.transcriptions.updateAudio(this.transcription, this.heartbank.user.uid, downloadURL);
                this.message.innerText = $41778cbaafe474f6$var$strings.audio4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                this.message.style.color = "green";
                this.mp3Btn.disabled = false;
                this.progress.classList.add("hidden");
                this.mp3Input.value = "";
            });
        } catch (error) {
            this.message.innerText = `Upload error: ${error.message}`;
            this.message.style.color = "red";
            this.mp3Btn.disabled = false;
            this.progress.classList.add("hidden");
            this.mp3Input.value = "";
        }
    }
    async translateToEnglish() {
        if (!navigator.onLine) {
            alert($41778cbaafe474f6$var$strings.offline[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        this.translateBtn.classList.add("cursor-progress");
        try {
            const updateTranslation = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)((0, $9d0840e0f81e5cfa$export$18af1f934c132a41), "updateTranslation", {
                limitedUseAppCheckTokens: true
            });
            await updateTranslation({
                transcriptionId: this.transcription
            });
            this.message.innerText = $41778cbaafe474f6$var$strings.editor6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.message.style.color = "green";
        } catch (error) {
            this.message.innerText = `Translation error: ${error.message}`;
            this.message.style.color = "red";
        }
        this.translateBtn.classList.remove("cursor-progress");
    }
}






var $jaOzc = parcelRequire("jaOzc");




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $0c76f114343011b1$export$3bebd1f0e3943985 extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $e5ed8027d647799b$export$45b790e32b2810ee), i.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $e5ed8027d647799b$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $e5ed8027d647799b$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$0c76f114343011b1$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $0c76f114343011b1$export$3bebd1f0e3943985.resultType = 1;
const $0c76f114343011b1$export$b6e69390c23686fb = (0, $3baabda811939da5$export$99b43ad1ed32e735)($0c76f114343011b1$export$3bebd1f0e3943985);





var $3df65fd550558fb7$exports = {};
$3df65fd550558fb7$exports = new URL("siliconwat.2042ef2b.svg", import.meta.url).toString();


//import LOTUS from "../../../public/lotus.webp";
const $ea5ded9f75b27c11$var$SW = new URL($3df65fd550558fb7$exports).href;

const $ea5ded9f75b27c11$var$BUDDHA = new URL($bd94f549c2d2c641$exports).href;
function $ea5ded9f75b27c11$var$groupBooks() {
    let groupedBooks = [];
    let startIndex = 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))["khmer"].baskets.forEach((count)=>{
        groupedBooks.push({
            startIndex: startIndex,
            books: (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))["khmer"].books.slice(startIndex, ++count)
        });
        startIndex = count;
    });
    return groupedBooks;
}
// TODO: hide
function $ea5ded9f75b27c11$var$downloadBook(event, book) {
    event.preventDefault();
    window.open((0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))["khmer"].pdfs[book], "_blank");
}
var $ea5ded9f75b27c11$export$2e2bcd8739ae039 = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-menu"
        class="h-screen md:h-full w-70 md:w-100 lg:w-120 fixed top-0 left-0 z-50 p-4 overflow-hidden transition-transform -translate-x-full bg-white dark:bg-gray-800"
        tabindex="-1"
        aria-labelledby="sw-menu-label">
        <a
            href="#heartbank"
            onclick="heartbank.alertAdmin('menu/click/title')"
            id="sw-menu-label"
            class="moul self-center text-xl font-semibold whitespace-nowrap text-theme">
            <!--<svg
                class="inline w-8 h-8 fill-theme"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512">
                <path
                    d="M120 0c13.3 0 24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 64c17.7 0 32 14.3 32 32l0 64c17.7 0 32 14.3 32 32l0 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-96c0-17.7 14.3-32 32-32l0-64c0-17.7 14.3-32 32-32l0-64 0-32 0-8c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z" />
            </svg>-->
            <img src="${$ea5ded9f75b27c11$var$SW}" width="50" height="50" class="inline mt-[-10px]" />
            <span class="ml-3">Silicon Wat</span>
            <!--Heart
            <svg
                class="mt-[-3px] ml-[-10px] mr-[-6px] inline fill-hb"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="30"
                height="30">
                <path
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                    transform="rotate(45 12 12)" />
            </svg>
            ank<sup>®</sup>-->
        </a>
        <button
            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
            id="sw-menu-hide"
            type="button"
            data-drawer-hide="sw-menu"
            aria-controls="sw-menu"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
            <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
        </button>
        <div
            class="h-full py-4 mt-3 font-medium text-xs md:text-sm overflow-y-auto overflow-x-hidden flex flex-col items-left justify-between">
            <ul class="space-y-2">
                <li class="opacity-100">
                    <a
                        onclick="heartbank.alertAdmin('menu/click/notifications')"
                        id="sw-menu-notifications"
                        href2="#/notifications"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="skyblue"
                            viewBox="0 0 448 512">
                            <path
                                d="M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
                        </svg>
                        <span
                            class="text-base moul flex-1 ms-3 whitespace-nowrap">
                            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).notifications[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </span>
                        <span
                            class="inline-flex font-[arial] items-center justify-center w-3 h-3 p-3 ms-3 text-sm font-medium text-yellow-800 bg-yellow-100 rounded-full dark:bg-yellow-900 dark:text-yellow-300">
                            0
                        </span>
                    </a>
                </li>
                ${$ea5ded9f75b27c11$var$groupBooks().map((group, basket)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                        <li class="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets["colors"][basket]}">
                            <button
                                id="sw-menu-basketBtn-${basket}"
                                type="button"
                                onclick="heartbank.alertAdmin('menu/click/basket/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][basket]}')"
                                class="flex items-center w-full p-2 text-base transition duration-75 rounded-lg group hover:bg-gray-100 dark:hover:bg-gray-700"
                                aria-controls="sw-menu-basket-${basket}"
                                data-collapse-toggle="sw-menu-basket-${basket}">
                                <svg
                                    class="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets["colors2"][basket]} flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="14"
                                    width="12.25"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                                </svg>
                                <span
                                    class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                                    >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][basket]}</span
                                >
                                <svg
                                    class="w-3 h-3 text-gray-500 dark:text-gray-400"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="m1 1 4 4 4-4" />
                                </svg>
                            </button>
                            <ul
                                id="sw-menu-basket-${basket}"
                                class="hidden py-2 space-y-2">
                                ${group.books.map((pages, book)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                        <li
                                            @contextmenu=${(event)=>$ea5ded9f75b27c11$var$downloadBook(event, group.startIndex + book)}>
                                            <div
                                                class="text-sm flex items-center w-full p-2 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100 dark:hover:bg-gray-700">
                                                <a
                                                    onclick="heartbank.alertAdmin('menu/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).book[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}/${group.startIndex + book + 1}')"
                                                    href="#/book/${group.startIndex + book + 1}">
                                                    ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).book[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                                                    <span
                                                        class="ms-2 bg-blue-100 text-blue-800 me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                                        ${(group.startIndex + book + 1).toKhmer((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                                                    </span>
                                                </a>
                                                <button
                                                    class="ml-24"
                                                    title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).download[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                                    onclick="heartbank.alertAdmin('menu/click/download/${group.startIndex + book + 1}');alert('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                                                    <svg
                                                        class="w-5 h-5 fill-gray-700 dark:fill-gray-400"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 448 512">
                                                        <path
                                                            d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </li>
                                    `)}
                            </ul>
                        </li>
                    `)}
            </ul>
            <ul class="moul text-white my-10 px-5">
                <li class="">
                    <a
                        href="#readership"
                        onclick="heartbank.alertAdmin('menu/click/readership')"
                        class="w-60 bg-teal-500 hover:bg-teal-500/80 focus:ring-4 focus:outline-none focus:ring-teal-500/50 font-medium rounded-lg text-base px-5 py-2.5 inline-flex items-center justify-center dark:hover:bg-teal-500/80 dark:focus:ring-teal-500/40 me-5">
                        <svg
                            class="me-4 w-6 h-6 mt-0 ml-[-10px]"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            fill="currentColor">
                            <path
                                d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1C172.7 359 160 337 160 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zM96 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 240l0 32c0 32.5 12.1 62.1 32 84.7l0 75.3c0 1.2 0 2.5 .1 3.7-8.5 7.6-19.7 12.3-32.1 12.3l-32 0c-26.5 0-48-21.5-48-48l0-56.6C12.9 364.4 0 343.7 0 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1zM368 464l0-75.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 56.6c0 26.5-21.5 48-48 48l-32 0c-12.3 0-23.6-4.6-32.1-12.3 0-1.2 .1-2.5 .1-3.7zM416 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" />
                        </svg>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </a>
                </li>
                <li class="cursor-pointer">
                    <img
                        id="sw-menu-monk"
                        onclick="heartbank.alertAdmin('menu/click/robot-monk')"
                        src="${$ea5ded9f75b27c11$var$BUDDHA}"
                        alt="robot monk"
                        class="w-60 my-5 rounded-lg" />
                </li>
                <li class="">
                    <button
                        id="sw-menu-donate"
                        onclick="heartbank.alertAdmin('menu/click/thank')"
                        type="button"
                        data-modal-show="sw-feedback"
                        class="${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "text-[11px]" : "text-xs"} w-60 bg-hb hover:bg-hb/80 focus:ring-4 focus:outline-none focus:ring-hb/50 font-medium rounded-lg px-5 py-2.5 inline-flex items-center justify-center dark:hover:bg-hb/80 dark:focus:ring-hb/40 me-5">
                        <svg
                            class="${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "me-2" : "me-3"} w-6 h-6 mt-0 ml-[-10px]"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        ${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).donate[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])}
                    </button>
                </li>
                <li
                    class="hidden"
                    data-modal-target="sw-donate"
                    data-modal-show="sw-donate"></li>
            </ul>
            <ul class="my-2">
                <li class="moul">
                    <a
                        id="sw-menu-youtube"
                        onclick="heartbank.alertAdmin('menu/click/youtube')"
                        href="https://www.facebook.com/siliconwat"
                        href2="https://www.youtube.com/@SiliconWat"
                        target="_blank"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="red"
                            height="14"
                            width="10.5"
                            viewBox="0 0 576 512">
                            <path
                                d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                        </svg>
                        <span
                            class="${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "text-xs md:text-sm" : "text-base md:text-base"} flex-1 ms-3 whitespace-nowrap"
                            >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).youtube[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span
                        >
                    </a>
                </li>
                <li class="moul">
                    <a
                        target="_blank"
                        onclick="heartbank.alertAdmin('menu/click/install-silicon-wat');alert('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        href2="#333"
                        href3="https://gemini.google.com"
                        href="https://siliconwat.com"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="fill-green-500 flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill2="green"
                            height="14"
                            width="10.5"
                            viewBox="0 0 384 512">
                            <path
                                d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z" />
                        </svg>
                        <span
                            class="text-base text-gray-700 dark:text-gray-300 flex-1 ms-3 whitespace-nowrap"
                            >${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).sw[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])}</span
                        >
                    </a>
                </li>
                <li class="moul">
                    <a
                        href2="#ai"
                        href3="${(0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? "https://translate.google.com/?sl=${Strings.language[LANGUAGE]}&tl=en&op=translate" : "https://grok.com"}"
                        href4="https://grok.com"
                        href="https://siliconwat.org"
                        target="_blank"
                        onclick="heartbank.alertAdmin('menu/click/install-buddha-ai');alert('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="fill-green-500 flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill2="green"
                            height="14"
                            width="10.5"
                            viewBox="0 0 384 512">
                            <path
                                d="M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64L80 64l0 320 224 0 0-320z" />
                        </svg>
                        <span
                            class="text-base text-gray-700 dark:text-gray-300 flex-1 ms-3 whitespace-nowrap"
                            >${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).ai[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])}</span
                        >
                    </a>
                </li>
                <li class="moul">
                    <a
                        target="_blank"
                        onclick="heartbank.alertAdmin('menu/click/join-ai-board')"
                        href="https://www.facebook.com/siliconwat"
                        class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                        <svg
                            class="fill-orange-600 flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill2="orangered"
                            height="14"
                            width="10.5"
                            viewBox="0 0 512 512">
                            <path
                                d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                        </svg>
                        <span
                            class="text-base text-gray-700 dark:text-gray-300 flex-1 ms-3 whitespace-nowrap">
                            ${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).join[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])}
                        </span>
                    </a>
                </li>
                <li class="moul mb-3 mt-8">
                    <a
                        href="https://thonly.org"
                        onclick="heartbank.alertAdmin('menu/click/thonly')"
                        target="_blank"
                        class="text-sm text-gray-500 dark:text-gray-400"
                        >THonly™ © USA 2025</a
                    >
                </li>
                <li class="mb-9">
                    <a
                        id="sw-menu-reset"
                        onclick="heartbank.alertAdmin('menu/click/reset')"
                        class="text-xs cursor-pointer font-thin text-gray-500 dark:text-gray-400">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).updated[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]} ${(0, $eba1d7d434ec7c0e$export$501a7fac1df67a49).formatDate()}
                    </a>
                </li>
            </ul>
        </div>
    </div>
`;





let $59e9af023252b064$export$e538f94cc8cf4db8 = [];
let $59e9af023252b064$export$83d89fbfd8236492 = '';
function $59e9af023252b064$export$c208e1278d7beb2(m, v) {
    $59e9af023252b064$export$e538f94cc8cf4db8 = m;
    $59e9af023252b064$export$83d89fbfd8236492 = v;
}



const $0469388547a65161$export$12f929bcf20d6190 = "6f0004e"; // 2025-11-11 // this will always trigger cache update on refresh ??
const $0469388547a65161$export$9f11e88aded5171c = "MAJOR_VERSION-" + (0, $8f13b60c0ee5b277$exports.version); // TODO: update version when need to redo; will also update dexie db
// Install event: Cache essential assets
self.addEventListener("install", (event)=>{
    event.waitUntil(caches.open($0469388547a65161$export$12f929bcf20d6190).then((cache)=>{
        //manifest.push(defaultImg); // error bc duplicate add with jpg cach
        //const files = Array.from(new Set(manifest)); // ensure no duplicates bc of importing
        console.log("Caching files: ", (0, $59e9af023252b064$export$e538f94cc8cf4db8).join(", "));
        cache.addAll((0, $59e9af023252b064$export$e538f94cc8cf4db8));
    }).then(()=>self.skipWaiting()).finally(()=>{
        console.log("Service Worker installed: ", $0469388547a65161$export$12f929bcf20d6190);
    }));
// event.waitUntil(
//     Promise.all([
//         caches.open(MINOR_VERSION).then((cache) => {
//             //manifest.push(defaultImg); // error bc duplicate add with jpg cach
//             //const files = Array.from(new Set(manifest)); // ensure no duplicates bc of importing
//             console.log("Caching files: ", manifest.join(", "));
//             return cache.addAll(manifest);
//         }),
//         self.skipWaiting() // to activate right away
//     ]).finally(() => {
//         console.log("Service Worker installed: ", MINOR_VERSION);
//     })
// );
});
// self.addEventListener("activate", (event: ExtendableEvent) => {
//     event.waitUntil(
//         (async () => {
//             const cacheNames = await caches.keys();
//             await Promise.all(
//                 cacheNames.map((cache) => {
//                     if (cache !== MINOR_VERSION && cache !== MAJOR_VERSION) {
//                         return caches.delete(cache);
//                     }
//                 })
//             );
//             await self.clients.claim();
//             const clients = await self.clients.matchAll({ type: "window" });
//             for (const client of clients) {
//                 client.postMessage({ version: MINOR_VERSION });
//                 // 🔹 Optional auto reload once to ensure cached files load right away
//                 client.navigate(client.url);
//             }
//             console.log("Service Worker activated:", MINOR_VERSION);
//         })()
//     );
// });
// Activate event: Cleanup old caches
self.addEventListener("activate", (event)=>{
    event.waitUntil(Promise.all([
        // Handle cache deletion
        caches.keys().then((cacheNames)=>Promise.all(cacheNames.map((cache)=>{
                if (cache !== $0469388547a65161$export$12f929bcf20d6190 && cache !== $0469388547a65161$export$9f11e88aded5171c) {
                    console.log("Deleting old cache: ", cache);
                    return caches.delete(cache);
                }
            }))),
        // to take control right away
        self.clients.claim().then(()=>{
            self.clients.matchAll({
                type: "window"
            }).then((clients)=>{
                clients.forEach((client)=>{
                    client.postMessage({
                        version: $0469388547a65161$export$12f929bcf20d6190
                    });
                });
            });
        })
    ]).finally(()=>{
        console.log("Service Worker activated");
    }));
});
self.addEventListener("fetch", (event)=>{
    event.respondWith(caches.match(event.request).then((cachedResponse)=>{
        if (cachedResponse) {
            console.log("Serving from cache: ", event.request.url);
            return cachedResponse;
        } else {
            const start = performance.now();
            return fetch(event.request).then((networkResponse)=>{
                if (networkResponse.status === 200 && event.request.method === "GET") return caches.open(event.request.url.endsWith(".jpg") || event.request.url.endsWith("json") ? $0469388547a65161$export$9f11e88aded5171c : $0469388547a65161$export$12f929bcf20d6190).then((cache)=>{
                    cache.put(event.request, networkResponse.clone());
                    return networkResponse;
                }).finally(()=>{
                    if (event.request.url.endsWith(".jpg")) console.log("Caching new jpg: ", event.request.url);
                    else if (event.request.url.endsWith("json")) console.log("Caching new json: ", event.request.url);
                    else console.log("Caching new url: ", event.request.url);
                });
                else return networkResponse;
            }).catch((error)=>{
                if (event.request.mode === "navigate") return caches.match("/index.html").then(async (response)=>{
                    return new Response(await response?.blob() ?? "Please connect to the internet. Then refresh page.", {
                        status: 200,
                        statusText: "No internet. Serving from cache: " + event.request.url,
                        headers: {
                            "Content-Type": "text/html"
                        }
                    });
                }).finally(()=>{
                    console.warn("No internet. Serving from cache: ", error.message);
                });
                else // Let non-navigation requests fail naturally (browser offline behavior)
                throw error;
            }).finally(()=>{
                const end = performance.now();
                console.info(`Fetch duration: ${end - start} ms for ${event.request.url}`);
            });
        }
    }));
}); // cache first strategy // network second
 // Fetch event: Serve cached assets or fallback to network and cache it // image files at github!
 // self.addEventListener("fetch", (event: FetchEvent) => {
 //     event.respondWith(
 //         caches.match(event.request).then((cachedResponse) => {
 //             if (cachedResponse) {
 //                 console.log("Serving from cache: ", event.request.url);
 //                 return cachedResponse;
 //             } else {
 //                 const start = performance.now();
 //                 return fetch(event.request)
 //                     .then((networkResponse) => {
 //                         if (
 //                             networkResponse.status === 200 &&
 //                             event.request.method === "GET" // cannot cache videos or post requests
 //                         ) {
 //                             return caches
 //                                 .open(
 //                                     event.request.url.endsWith(".jpg") ||
 //                                         event.request.url.endsWith("json")
 //                                         ? MAJOR_VERSION
 //                                         : MINOR_VERSION
 //                                 )
 //                                 .then((cache) => {
 //                                     cache.put(
 //                                         event.request,
 //                                         networkResponse.clone()
 //                                     );
 //                                     return networkResponse;
 //                                 })
 //                                 .finally(() => {
 //                                     if (event.request.url.endsWith(".jpg")) {
 //                                         console.log(
 //                                             "Caching new jpg: ",
 //                                             event.request.url
 //                                         );
 //                                     } else if (
 //                                         event.request.url.endsWith("json")
 //                                     ) {
 //                                         console.log(
 //                                             "Caching new json: ",
 //                                             event.request.url
 //                                         );
 //                                     } else {
 //                                         console.log(
 //                                             "Caching new url: ",
 //                                             event.request.url
 //                                         );
 //                                     }
 //                                 });
 //                         } else {
 //                             return networkResponse;
 //                         }
 //                     })
 //                     .catch((error) => {
 //                         return caches
 //                             .match("/index.html")
 //                             .then(async (response) => {
 //                                 return new Response(
 //                                     (await response?.blob()) ??
 //                                         "Please connect to the internet. Then refresh page.",
 //                                     {
 //                                         status: 200,
 //                                         statusText:
 //                                             "No internet. Serving from cache: " +
 //                                             event.request.url,
 //                                         headers: {
 //                                             "Content-Type": "text/html"
 //                                         }
 //                                     }
 //                                 );
 //                             })
 //                             .finally(() => {
 //                                 console.warn(
 //                                     "No internet. Serving from cache: ",
 //                                     error.message
 //                                 );
 //                             });
 //                     })
 //                     .finally(() => {
 //                         const end = performance.now();
 //                         console.info(
 //                             `Fetch duration: ${end - start} ms for ${
 //                                 event.request.url
 //                             }`
 //                         );
 //                     });
 //             }
 //         })
 //     );
 // });
 // Optional: Background sync event
 // self.addEventListener("sync", (event: SyncEvent) => {
 //     if (event.tag === "sync-data") {
 //         console.log("Syncing data...");
 //         event.waitUntil(
 //             // Perform background sync tasks here
 //             fetch("/update-data-endpoint").then((response) => {
 //                 console.log("Data synced successfully!", response);
 //             })
 //         );
 //     }
 // });
 // Optional: Push notification event
 // self.addEventListener("push", (event: PushEvent) => {
 //     const data = event.data?.json();
 //     if (data) {
 //         self.registration.showNotification(data.title, {
 //             body: data.message,
 //             icon: "/icons/icon-192x192.png"
 //         });
 //     }
 // });



const $4764227dda88382b$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $4764227dda88382b$export$7ca2f8a6c7ce8f25 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.basket1 = false, this.basket2 = false, this.basket3 = false;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-menu");
        this.componentTrace.start();
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $ea5ded9f75b27c11$export$2e2bcd8739ae039), this);
        this.drawer = this.querySelector("#sw-menu-hide");
        this.donate = this.querySelector("#sw-menu-donate");
        this.monk = this.querySelector("#sw-menu-monk");
        this.reset = this.querySelector("#sw-menu-reset");
        this.notifications = this.querySelector("#sw-menu-notifications");
        this.button1 = this.querySelector("#sw-menu-basketBtn-0");
        this.button2 = this.querySelector("#sw-menu-basketBtn-1");
        this.button3 = this.querySelector("#sw-menu-basketBtn-2");
    }
    connectedCallback() {
        //this.youtube();
        this.notifications.addEventListener("click", async ()=>{
            if (confirm($4764227dda88382b$var$strings.notifications2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                await this.heartbank.saveTokenToFirestore();
                alert($4764227dda88382b$var$strings.notifications3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                this.heartbank.alertAdmin("notifications/yes");
            }
        });
        this.button1.addEventListener("click", ()=>{
            const svg = this.button1.lastElementChild;
            if (this.basket1) {
                svg.classList.remove("rotate-180");
                this.basket1 = false;
            } else {
                svg.classList.add("rotate-180");
                this.basket1 = true;
            }
        });
        this.button2.addEventListener("click", ()=>{
            const svg = this.button2.lastElementChild;
            if (this.basket2) {
                svg.classList.remove("rotate-180");
                this.basket2 = false;
            } else {
                svg.classList.add("rotate-180");
                this.basket2 = true;
            }
        });
        this.button3.addEventListener("click", ()=>{
            const svg = this.button3.lastElementChild;
            if (this.basket3) {
                svg.classList.remove("rotate-180");
                this.basket3 = false;
            } else {
                svg.classList.add("rotate-180");
                this.basket3 = true;
            }
        });
        this.donate.addEventListener("click", ()=>this.drawer.click());
        this.monk.addEventListener("click", ()=>{
            document.location.hash = "#bookmark";
            const toc = document.querySelector("sw-toc");
            toc.show("pali", 1, 1);
            this.drawer.click();
        });
        this.reset.addEventListener("click", this.showUpdatePrompt.bind(this));
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    youtube() {
        const a = this.querySelector("#sw-menu-youtube");
        a.href = (0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? "https://www.youtube.com/playlist?list=PLgQIYTIJXpzYIw-cqKczJqEu3WPQ6Pw-3" : "https://www.youtube.com/playlist?list=PLgQIYTIJXpzaotVkaGL05TyT_loSdtX2W";
    }
    async showUpdatePrompt() {
        const userResponse = confirm($4764227dda88382b$var$strings.refresh[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        if (userResponse) {
            document.body.style.visibility = "invisible";
            this.drawer.click();
            this.clearStorage();
        }
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "update", {
            response: userResponse
        });
    }
    async clearStorage(all = false) {
        if (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) {
            await this.unregisterAllServiceWorkers();
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "cache", {
                task: "update"
            });
            window.location.reload(); //TODO: check bc might be redundant bc browser auto refresh ?
        } else {
            if (all) localStorage.clear();
            await this.unregisterAllServiceWorkers();
            await this.clearCaches(true);
            await this.clearAllDatabases();
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "cache", {
                task: "reset"
            });
            console.warn("Local storage deleted.");
            window.location.reload(); // doesn't work after clear indexed; don't know wny
        }
    }
    // TODO: refactor as extension to serviceWorker?? bc duplicate code with menu.ts
    async unregisterAllServiceWorkers() {
        if ("serviceWorker" in navigator) try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (const registration of registrations){
                const success = await registration.unregister();
                if (success) console.warn("Service worker unregistered.");
                else console.error("Failed to unregister the service worker.");
            }
        } catch (error) {
            console.error("Error fetching service worker registrations: ", error);
        }
        else console.warn("Service workers are not supported in this browser.");
    }
    async clearCaches(all = false) {
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames){
            if (all) await caches.delete(cacheName);
            else if (cacheName !== (0, $0469388547a65161$export$9f11e88aded5171c)) await caches.delete(cacheName);
        }
        console.warn("Caches deleted.");
    }
    async clearAllDatabases(all = false) {
        try {
            // Get all database names
            const dbNames = all ? await (0, $jaOzc.default).getDatabaseNames() : [];
            // [
            //     "Bookmarks",
            //     "Books",
            //     "Dictionaries",
            //     "Transcriptions"
            // ]
            // Delete each database
            for (const dbName of dbNames){
                await (0, $jaOzc.default).delete(dbName);
                console.warn(`Deleted database: ${dbName}`);
            }
            console.log("All databases have been cleared.");
        } catch (error) {
            console.error("Error clearing databases: ", error.message);
        }
    }
    // deprecated
    async clearAllIndexedDB() {
        try {
            const databases = await (indexedDB.databases ? indexedDB.databases() : Promise.resolve([]));
            if (databases.length === 0) {
                console.warn("No IndexedDB databases found.");
                return;
            }
            for (const dbInfo of databases)if (dbInfo.name) {
                const deleteRequest = indexedDB.deleteDatabase(dbInfo.name);
                await new Promise((resolve, reject)=>{
                    deleteRequest.onsuccess = ()=>{
                        console.warn(`Database "${dbInfo.name}" deleted.`);
                        resolve();
                    };
                    deleteRequest.onerror = (event)=>{
                        console.error(`Failed to delete database "${dbInfo.name}": `, event);
                        reject(event);
                    };
                });
            }
        } catch (error) {
            console.error("Error clearing IndexedDB databases: ", error);
        }
    }
}










const $8ccdccdeb362df9b$var$BUDDHA = new URL($bd94f549c2d2c641$exports).href;
function $8ccdccdeb362df9b$var$getCommentaries(language, book, isColor) {
    const parts = (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))[language]["commentaries"];
    if (0 < book && book <= parts[0]) return isColor ? (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets["colors"][0] : (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][0];
    else if (parts[0] < book && book <= parts[1]) return isColor ? (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets["colors"][1] : (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][1];
    else return isColor ? (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets["colors"][2] : (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).baskets2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][2];
}
var $8ccdccdeb362df9b$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-toc"
        class="fixed top-0 right-0 z-50 max-h-screen w-80 md:w-100 lg:w-120 p-4 overflow-y-auto transition-transform translate-x-full bg-white dark:bg-gray-800"
        tabindex="-1"
        aria-labelledby="sw-toc-label">
        <a
            target="_blank"
            href="https://siliconwat.dev"
            data-drawer-hide2="sw-toc"
            href2="#heartbank"
            onclick="heartbank.alertAdmin('toc/click/title')"
            id="sw-toc-label"
            class="moul self-center text-2xl font-semibold whitespace-nowrap text-theme">
            <img
                src="${$8ccdccdeb362df9b$var$BUDDHA}"
                width="50"
                height="50"
                class="inline rounded-full" />
            <span class="ml-3">${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).toc[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])}</span>
        </a>
        <button
            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
            type="button"
            data-drawer-hide="sw-toc"
            aria-controls="sw-toc"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
            <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
        </button>
        <div
            class="h-full py-4 mt-3 font-medium text-xs md:text-sm overflow-y-auto overflow-x-hidden flex flex-col items-left justify-between">
            <form>
                <div
                    class="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
                    <div
                        class="px-4 py-2 bg-white rounded-t-lg dark:bg-gray-800">
                        <label for="sw-toc-prompt" class="sr-only"
                            >Prompt</label
                        >
                        <textarea
                            id="sw-toc-prompt"
                            rows="4"
                            class="battambang w-full px-0 text-base placeholder:text-gray-300 text-gray-900 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400"
                            placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).ama[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            required></textarea>
                    </div>
                    <div
                        class="flex items-center justify-between px-3 py-2 border-t dark:border-gray-600 border-gray-200">
                        <button
                            id="sw-toc-submit"
                            type="button"
                            class="inline-flex items-center py-1 px-4 text-base font-medium text-center text-white bg-orange-500 rounded-lg focus:ring-4 focus:ring-orange-200 dark:focus:ring-orange-900 hover:bg-orange-800">
                            ${(0, $0c76f114343011b1$export$b6e69390c23686fb)((0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).gemini[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])}
                        </button>
                        <div
                            class="flex ps-0 space-x-1 rtl:space-x-reverse sm:ps-2">
                            <button
                                id="sw-toc-global"
                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 512 512">
                                    <path
                                        d="M50 284.8c4.2 2.1 9 3.2 14 3.2l50.7 0c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4l18.7 0c17.7 0 32-14.3 32-32l0-40c0-13.3 10.7-24 24-24s24-10.7 24-24l0-42.7c0-8.5 3.4-16.6 9.4-22.6l13.3-13.3c6-6 9.4-14.1 9.4-22.6L304 57c0-1.2-.1-2.3-.2-3.5-15.4-3.6-31.4-5.5-47.8-5.5-114.9 0-208 93.1-208 208 0 9.8 .7 19.4 2 28.8zm403.3 37.3c-3.2-1.4-6.7-2.1-10.5-2.1L432 320c-8.8 0-16-7.2-16-16s-7.2-16-16-16l-34.7 0c-8.5 0-16.6 3.4-22.6 9.4l-45.3 45.3c-6 6-9.4 14.1-9.4 22.6l0 18.7c0 17.7 14.3 32 32 32l18.7 0c8.5 0 16.6 3.4 22.6 9.4 2.2 2.2 4.7 4.1 7.3 5.5 39.3-25.4 69.5-63.6 84.6-108.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM128 368c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM272 256c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm48-112l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z" />
                                </svg>
                                <span class="sr-only">Global</span>
                            </button>
                            <button
                                id="sw-toc-copy"
                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l58.5 58.5c3 3 4.7 7.1 4.7 11.3L400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-197.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-48 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l16 0 0-48-16 0z" />
                                </svg>
                                <span class="sr-only">Copy</span>
                            </button>
                            <button
                                id="sw-toc-paste"
                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select8[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 384 512">
                                    <path
                                        d="M232 96l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm0 48c37.1 0 67.6-28 71.6-64L320 80c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l16.4 0c4 36 34.5 64 71.6 64l80 0zM291.9 32C279 12.7 257 0 232 0L152 0c-25 0-47 12.7-59.9 32L64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-28.1 0z" />
                                </svg>
                                <span class="sr-only">Paste</span>
                            </button>
                            <button
                                id="sw-toc-clear"
                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).clear[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z" />
                                </svg>
                                <span class="sr-only">Clear</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <ul
                id="sw-toc-history"
                class="battambang text-sm text-gray-600 dark:text-gray-300 mt-4 mb-8 px-1 space-y-3"></ul>
            <hr class="border-gray-300 dark:border-gray-700" />
            <ul class="space-y-2 mt-7 tb-3">
                <li class="moul">
                    <button
                        id="sw-toc-commentaries-khmer-btn"
                        onclick="heartbank.alertAdmin('menu/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesKhmer[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        type="button"
                        class="flex items-center w-full p-2 text-base text-amber-700 transition duration-75 rounded-lg group hover:bg-gray-100 dark:hover:bg-gray-700"
                        aria-controls="sw-toc-commentaries-khmer"
                        data-collapse-toggle="sw-toc-commentaries-khmer">
                        <svg
                            class="shrink-0 w-5 h-5 text-amber-700 transition duration-75"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 448 512">
                            <path
                                d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                        </svg>
                        <span
                            class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                            >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesKhmer[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span
                        >
                        <svg
                            class="w-3 h-3 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 10 6">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 4 4 4-4" />
                        </svg>
                    </button>
                    <ul
                        id="sw-toc-commentaries-khmer"
                        class="hidden py-2 space-y-2">
                        ${Array((0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))["khmer"].commentaries[2]).fill(0).map((_, book)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                    <li>
                                        <div
                                            class="text-sm flex items-center w-full p-2 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100 dark:hover:bg-gray-700">
                                            <a
                                                onclick="heartbank.alertAdmin('menu/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesKhmer[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}/${book + 1}')"
                                                href="https://bedok.siliconwat.dev/tipitaka/cambodia/${encodeURIComponent("\u1796\u17D2\u179A\u17C7\u178F\u17D2\u179A\u17C3\u1794\u17B7\u178A\u1780 \u1794\u17D2\u179A\u17C2\u179A\u17BD\u1798\u1793\u17B9\u1784\u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6 \u1797\u17B6\u1782" + (book + 1).toKhmer("khmer"))}.pdf"
                                                target="_blank"
                                                class="${$8ccdccdeb362df9b$var$getCommentaries("khmer", book + 1, true)}">
                                                ${$8ccdccdeb362df9b$var$getCommentaries("khmer", book + 1, false)}
                                                <span
                                                    class="ms-2 bg-blue-100 text-blue-800 me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                                    ${(book + 1).toKhmer((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                                                </span>
                                            </a>
                                            <button
                                                class="ml-5"
                                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).download[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                                onclick="heartbank.alertAdmin('menu/click/download/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesKhmer[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}/${book + 1}');alert('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                                                <svg
                                                    class="w-5 h-5 fill-gray-700 dark:fill-gray-400"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 448 512">
                                                    <path
                                                        d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </li>
                                `)}
                    </ul>
                </li>
                <li class="moul">
                    <button
                        id="sw-toc-commentaries-pali-btn"
                        onclick="heartbank.alertAdmin('menu/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesPali[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        type="button"
                        class="flex items-center w-full p-2 text-base text-amber-700 transition duration-75 rounded-lg group hover:bg-gray-100 dark:hover:bg-gray-700"
                        aria-controls="sw-toc-commentaries-pali"
                        data-collapse-toggle="sw-toc-commentaries-pali">
                        <svg
                            class="shrink-0 w-5 h-5 text-amber-700 transition duration-75"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 448 512">
                            <path
                                d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                        </svg>
                        <span
                            class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                            >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesPali[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span
                        >
                        <svg
                            class="w-3 h-3 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 10 6">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 4 4 4-4" />
                        </svg>
                    </button>
                    <ul
                        id="sw-toc-commentaries-pali"
                        class="hidden py-2 space-y-2">
                        ${Array((0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))["pali"].commentaries[2]).fill(0).map((_, book)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                    <li>
                                        <div
                                            class="text-sm flex items-center w-full p-2 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100 dark:hover:bg-gray-700">
                                            <a
                                                onclick="heartbank.alertAdmin('menu/click/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesPali[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}/${book + 1}')"
                                                href="https://bedok.siliconwat.dev/commentaries/pali/${encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)))["pali"].commentariesBooks[book])}.pdf"
                                                target="_blank"
                                                class="${$8ccdccdeb362df9b$var$getCommentaries("pali", book + 1, true)}">
                                                ${$8ccdccdeb362df9b$var$getCommentaries("pali", book + 1, false)}
                                                <span
                                                    class="ms-2 bg-blue-100 text-blue-800 me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                                    ${(book + 1).toKhmer((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                                                </span>
                                            </a>
                                            <button
                                                class="ml-5"
                                                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).download[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                                                onclick="heartbank.alertAdmin('menu/click/download/${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).commentariesPali[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}/${book + 1}');alert('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                                                <svg
                                                    class="w-5 h-5 fill-gray-700 dark:fill-gray-400"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 448 512">
                                                    <path
                                                        d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </li>
                                `)}
                    </ul>
                </li>
            </ul>
        </div>
    </div>
`;






class $39d1f6aafecf9a50$export$d1609d6291f3d60d {
    constructor(){
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "prompts");
    }
    async count() {
        const snapshot = await (0, $70fd6868680e912c$export$b1de1b12889d0afb)(this.collection);
        return snapshot.data().count;
    }
    // user
    async add(prompt) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, prompt.uid ? (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", prompt.uid) : (0, $70fd6868680e912c$export$9c59b80dda569a6e)("did", "==", prompt.did), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("prompt", "==", prompt.prompt), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1));
        await this.add2(prompt.prompt.toLowerCase());
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (querySnapshot.empty) {
            const data = {
                date: new Date(),
                ...prompt
            };
            const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, data);
            return {
                id: docRef.id,
                ...data
            };
        } else {
            const snap = querySnapshot.docs[0];
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "prompts", snap.id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                date: new Date(),
                count: (0, $70fd6868680e912c$export$a2647aa13413c947)(1)
            });
            return {
                id: snap.id,
                ...snap.data() // count = count + 1
            };
        }
    }
    // global
    async add2(prompt) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("did", "==", ""), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("prompt", "==", prompt), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (querySnapshot.empty) {
            const data = {
                date: new Date(),
                did: "",
                uid: "",
                prompt: prompt,
                count: 1
            };
            const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, data);
            return {
                id: docRef.id,
                ...data
            };
        } else {
            const snap = querySnapshot.docs[0];
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "prompts", snap.id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                date: new Date(),
                count: (0, $70fd6868680e912c$export$a2647aa13413c947)(1)
            });
            return {
                id: snap.id,
                ...snap.data() // count = count + 1
            };
        }
    }
    async get(did, uid, prompt, isGlobal = true) {
        const q = isGlobal ? (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("did", "==", ""), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("count", "desc"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "desc")) : (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, uid ? (0, $70fd6868680e912c$export$9c59b80dda569a6e)("uid", "==", uid) : (0, $70fd6868680e912c$export$9c59b80dda569a6e)("did", "==", did), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "desc"));
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const prompts = [];
        let count = 0;
        querySnapshot.forEach((doc)=>{
            const data = {
                id: doc.id,
                ...doc.data()
            };
            if (count < 10 && (!prompt || data.prompt.toLowerCase().includes(prompt.toLowerCase()))) {
                prompts.push(data);
                count++;
            }
        });
        return prompts;
    }
    async remove(id) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "prompts", id);
        await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(docRef);
    }
}





const $b77c0c788573c6f1$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $b77c0c788573c6f1$export$d2ec588b75840eb2 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.prompts = new (0, $39d1f6aafecf9a50$export$d1609d6291f3d60d)(), this.basket4 = false, this.basket5 = false;
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $8ccdccdeb362df9b$export$2e2bcd8739ae039)(null), this);
        this.toc = this.querySelector("#sw-toc");
        this.prompt = this.querySelector("#sw-toc-prompt");
        this.global = this.querySelector("#sw-toc-global");
        this.submit = this.querySelector("#sw-toc-submit");
        this.copy = this.querySelector("#sw-toc-copy");
        this.paste = this.querySelector("#sw-toc-paste");
        this.clear = this.querySelector("#sw-toc-clear");
        this.history = this.querySelector("#sw-toc-history");
        this.button4 = this.querySelector("#sw-toc-commentaries-khmer-btn");
        this.button5 = this.querySelector("#sw-toc-commentaries-pali-btn");
        // options with default values
        const options = {
            placement: "right",
            backdrop: true,
            bodyScrolling: false,
            edge: false,
            edgeOffset: "",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
            onHide: ()=>{
            //console.log("drawer is hidden");
            },
            onShow: ()=>{
            //console.log("drawer is shown");
            },
            onToggle: ()=>{
            //console.log("drawer has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-toc",
            override: true
        };
        /*
         * $targetEl (required)
         * options (optional)
         * instanceOptions (optional)
         */ this.drawer = new (0, $4d66f8052cdbfb83$export$2e2bcd8739ae039)(this.toc, options, instanceOptions);
    }
    isGlobal() {
        return this.heartbank.user ? localStorage.getItem("global") === "1" : localStorage.getItem("global") !== "0";
    }
    renderGlobal() {
        const svg = this.global.querySelector("svg");
        svg.setAttribute("fill", this.isGlobal() ? "skyblue" : "currentColor");
    // doesn't work
    // this.global.classList.toggle("text-gray-500", !isGlobal);
    // this.global.classList.toggle("dark:text-gray-400", !isGlobal);
    // this.global.classList.toggle("text-orange-500", isGlobal);
    // this.global.classList.toggle("dark:text-orange-400", isGlobal);
    }
    connectedCallback() {
        this.render();
        this.renderGlobal();
        this.prompt.addEventListener("keyup", ()=>this.render(this.prompt.value.trim()));
        this.submit.addEventListener("click", async ()=>{
            const prompt = this.prompt.value.trim();
            if (prompt) {
                this.submit.disabled = true;
                this.copy.click(); // order is important
                // need to allow popup
                setTimeout(()=>window.open("https://gemini.google.com", "_blank"), 1500);
                await this.prompts.add({
                    did: this.heartbank.getDeviceID(),
                    uid: this.heartbank.user?.uid || "",
                    prompt: prompt,
                    count: 1
                });
                this.prompt.value = "";
                await this.render();
                this.submit.disabled = false;
                this.heartbank.alertAdmin(`toc/submit/`, prompt);
            }
        });
        this.global.addEventListener("click", async ()=>{
            this.global.disabled = true;
            localStorage.setItem("global", this.isGlobal() ? "0" : "1");
            this.renderGlobal();
            await this.render();
            this.heartbank.alertAdmin(`toc/global/`, this.isGlobal().toString());
            this.global.disabled = false;
        });
        this.copy.addEventListener("click", async ()=>{
            const prompt = this.prompt.value.trim();
            if (prompt) {
                await navigator.clipboard.writeText(prompt);
                this.dispatchEvent(new CustomEvent("sw-banner", {
                    bubbles: true,
                    detail: {
                        info: $b77c0c788573c6f1$var$strings.copied3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
                    }
                }));
                this.heartbank.alertAdmin(`toc/copy/`, prompt);
            }
        });
        this.paste.addEventListener("click", async ()=>{
            const prompt = this.prompt.value.trim();
            if (!prompt || confirm($b77c0c788573c6f1$var$strings.paste[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                this.prompt.value = await navigator.clipboard.readText();
                //this.render();
                this.prompt.focus();
                this.heartbank.alertAdmin(`toc/paste/`, this.prompt.value);
            }
        });
        this.clear.addEventListener("click", async ()=>{
            this.heartbank.alertAdmin(`toc/clear/`, this.prompt.value);
            this.prompt.value = "";
            this.render();
            this.prompt.focus();
        });
        this.button4.addEventListener("click", ()=>{
            const svg = this.button4.lastElementChild;
            if (this.basket4) {
                svg.classList.remove("rotate-180");
                this.basket4 = false;
            } else {
                svg.classList.add("rotate-180");
                this.basket4 = true;
            }
        });
        this.button5.addEventListener("click", ()=>{
            const svg = this.button5.lastElementChild;
            if (this.basket5) {
                svg.classList.remove("rotate-180");
                this.basket5 = false;
            } else {
                svg.classList.add("rotate-180");
                this.basket5 = true;
            }
        });
    }
    async render(prompt = "") {
        this.history.innerHTML = "";
        const prompts = await this.prompts.get(this.heartbank.getDeviceID(), this.heartbank.user?.uid || "", prompt, this.isGlobal());
        for (const prompt of prompts){
            const li = document.createElement("li");
            li.className = "flex justify-between";
            const span = document.createElement("span");
            span.className = "mr-2";
            span.textContent = "\uD83D\uDD56";
            const p = document.createElement("button");
            p.type = "button";
            p.title = prompt.prompt;
            p.append(span, this.truncate(prompt.prompt, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? 35 : 35));
            p.onclick = ()=>{
                this.prompt.value = prompt.prompt;
            //this.render();
            };
            const button = document.createElement("button");
            button.type = "button";
            button.textContent = prompt.did === "" ? (prompt.count || 1).toString() : "\uD83D\uDDD1\uFE0F";
            if (this.heartbank.isAdmin() || prompt.did !== "") button.onclick = async ()=>{
                button.disabled = true;
                li.classList.add("opacity-50");
                if (confirm($b77c0c788573c6f1$var$strings.trash[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                    await this.prompts.remove(prompt.id);
                    //this.render();
                    li.remove();
                } else {
                    button.disabled = false;
                    li.classList.remove("opacity-50");
                }
            };
            li.append(p, button);
            this.history.appendChild(li);
        }
    }
    show(lang, book, page) {
        this.drawer.show();
        this.prompt.focus();
    }
    hide() {
        this.drawer.hide();
    }
    truncate(text, maxLength) {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength).trimEnd() + "...";
    }
}




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $2611977388863fc8$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $2611977388863fc8$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
// do not edit .js files directly - edit src/index.jst
var $2611977388863fc8$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $2611977388863fc8$var$isEqual = /*@__PURE__*/ $2611977388863fc8$var$getDefaultExportFromCjs($2611977388863fc8$var$fastDeepEqual);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2611977388863fc8$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $2611977388863fc8$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($2611977388863fc8$export$406cfe323c8bb8e4 || ($2611977388863fc8$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $2611977388863fc8$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $2611977388863fc8$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $2611977388863fc8$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($2611977388863fc8$export$3b0d6d7590275603.instance) {
            if (!$2611977388863fc8$var$isEqual(this.options, $2611977388863fc8$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($2611977388863fc8$export$3b0d6d7590275603.instance.options)}`);
            return $2611977388863fc8$export$3b0d6d7590275603.instance;
        }
        $2611977388863fc8$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $2611977388863fc8$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $2611977388863fc8$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $2611977388863fc8$export$406cfe323c8bb8e4.LOADING;
        return $2611977388863fc8$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback&loading=async`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$2611977388863fc8$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.loading) // do nothing but wait
        return;
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            this.loading = true;
            this.setScript();
        }
    }
}






class $c1b7cc755c0d15d3$export$4a0a69082ccdb997 {
    // 5K per month free
    // 3.2 cents afterwards // $32 per 1K calls
    constructor(){
        this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)();
        this.dynamicmaps = 9000;
        // 10K per month free
        // 0.7 cent afterwards
        this.geocoding = 9000;
        // 10K per month free
        // 0.5 cent afterwards
        this.places2 = 4000 // API Text Search Pro
        ;
        // 5K per month free
        // 3.2 cents afterwards
        this.places1 = 4000 // Nearby Search
        ;
        this.db = (0, $da38ac6aa733c404$export$eff4d24c3ff7876e)((0, $9d0840e0f81e5cfa$export$f932f06c7eb6abeb));
    }
    /**
     * Atomically increments the counter for a specific API in the Firebase Realtime Database.
     * @param api The name of the API to track ('geocoder' or 'places').
     */ async increment(api) {
        //console.log(`Incrementing counter for ${api} API...`);
        // We use `update` to modify multiple locations at once.
        // This is how we can update the count and a 'lastUpdated' timestamp together.
        const updates = {};
        // Define the paths and the values to write
        // Path: /quotas/[api]/count
        // Value: A special server value that increments the current number by 1
        updates[`/quotas/${api}/count`] = (0, $da38ac6aa733c404$export$a2647aa13413c947)(1);
        // Path: /quotas/[api]/lastUpdated
        // Value: A special server value for the current server timestamp
        updates[`/quotas/${api}/lastUpdated`] = (0, $da38ac6aa733c404$export$3ff8e7e00c3264b7)();
        try {
            await (0, $da38ac6aa733c404$export$722fbec263ad908a)(this.db, updates);
        //console.log(`Successfully incremented ${api} counter.`);
        } catch (error) {
            console.error(`Failed to increment ${api} counter:`, error);
        // You might want to handle this error, e.g., by logging it to a monitoring service
        }
    }
    /**
     * Retrieves the current count for a specific API from the Firebase Realtime Database.
     * @param api The name of the API to get the count for.
     * @returns A promise that resolves to the current count, or 0 if it doesn't exist or an error occurs.
     */ async getCount(api) {
        //console.log(`Getting count for ${api} API...`);
        try {
            const snapshot = await (0, $da38ac6aa733c404$export$3988ae62b71be9a3)((0, $da38ac6aa733c404$export$f9574b70e1d95d9d)(this.db, `quotas/${api}/count`));
            if (snapshot.exists()) {
                const count = snapshot.val();
                console.log(`Current count for ${api} is:`, count);
                return count;
            } else {
                // If the node doesn't exist, it means the count is effectively 0
                console.log(`No count found for ${api}, assuming 0`);
                return 0;
            }
        } catch (error) {
            console.error(`Failed to get ${api} counter:`, error);
            // Return 0 as a safe default in case of a read failure
            return -1;
        }
    }
    async isFree(api) {
        const count = await this.getCount(api);
        if (count === -1) return false; // error: skip and try again
        let isFree, isAlertAdmin;
        switch(api){
            case "dynamicmaps":
                isFree = (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? count < this.dynamicmaps : true;
                isAlertAdmin = count === this.dynamicmaps;
                break;
            case "geocoding":
                isFree = (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? count < this.geocoding : true;
                isAlertAdmin = count === this.geocoding;
                break;
            case "places1":
                isFree = (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? count < this.places1 : true;
                isAlertAdmin = count === this.places1;
                break;
            case "places2":
                isFree = (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? count < this.places2 : true;
                isAlertAdmin = count === this.places2;
                break;
        }
        await this.increment(api);
        if (!isFree) console.warn(`Exceeded free quota for ${api}:`, count);
        if (isAlertAdmin) this.heartbank.alertAdmin(`quotas/${api}/${count}`);
        return isFree; // always true when local
    }
}






class $0f70913938cf6fe3$export$717dc719c0afad28 {
    constructor(){
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples");
    }
    async count() {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"));
        const snapshot = await (0, $70fd6868680e912c$export$b1de1b12889d0afb)(q);
        return snapshot.data().count;
    }
    async exists(pid) {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("pid", "==", pid));
        const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        return !snapshot.empty;
    }
    async add(pid, name, latitude, longitude, address) {
        const temple = {
            date: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
            status: "init",
            pid: pid,
            name: name,
            latitude: latitude,
            longitude: longitude,
            address: address
        };
        const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, temple);
        return {
            id: docRef.id,
            ...temple
        };
    }
    async adminAdd(name, latitude, longitude, address) {
        const temple = {
            date: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
            status: "inactive",
            name: name,
            latitude: latitude,
            longitude: longitude,
            address: address || "" // admin can add later
        };
        const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, temple);
        return {
            id: docRef.id,
            ...temple
        };
    }
    // keep deleted temples for now for archive
    async remove(id, pid) {
        console.log(pid); // TODO: check if undefined
        if (pid === "undefined") {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                status: "deleted"
            });
        // const docRef = doc(fs, "temples", id);
        // await deleteDoc(docRef);
        } else {
            const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("pid", "==", pid), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(1));
            const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            const docRef = snapshot.docs[0].ref;
            await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                status: "deleted"
            });
        }
    }
    async updateStatus(id, status) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
        await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
            status: status ? "active" : "inactive"
        });
    }
    // TODO: 2 separate calls: later try to update local copy instead to save money
    async updateLink(id, link) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
        await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
            link: link
        });
        const temple = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        return {
            id: temple.id,
            ...temple.data()
        };
    }
    // TODO: 2 separate calls: later try to update local copy instead to save money
    async updateName(id, name) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
        await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
            name: name
        });
        const temple = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        return {
            id: temple.id,
            ...temple.data()
        };
    }
    // TODO: 2 separate calls: later try to update local copy instead to save money
    async updateAddress(id, address) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
        await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
            address: address
        });
        const temple = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        return {
            id: temple.id,
            ...temple.data()
        };
    }
    // upload image bc google map user can remove their photo; also google prevents using their image link
    // TODO: 2 separate calls: later try to update local copy instead to save money
    async updatePhoto(id, progressCallback, useCamera = false) {
        const file = await (0, $eba1d7d434ec7c0e$export$8eb12969473b192a)({
            capture: useCamera ? "camera" : undefined,
            accept: ".jpg,.png,.webp,.jpeg,.svg,.gif"
        });
        if (file) try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
            const temple = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
            if (temple.exists()) {
                const url = await this.savePhoto(temple.id, file, progressCallback);
                return {
                    id: temple.id,
                    ...temple.data(),
                    photo: url
                };
            } else return null;
        } catch (error) {
            console.error(error);
            return null;
        }
        else return null;
    }
    savePhoto(id, file, progressCallback) {
        return new Promise((resolve, reject)=>{
            const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)((0, $9d0840e0f81e5cfa$export$ddcffe0146c8f882), `temples/${id}/photo`); // to replace old one // ${file.name}
            const uploadTask = (0, $df9a6d7fd06616c9$export$3895d39eb7ac9b25)(storageRef, file, {
                customMetadata: {} //TODO: store profs in metadata?
            });
            // 2. Register the event listener
            uploadTask.on("state_changed", // Observer for progress
            (snapshot)=>{
                const progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                //console.log("Upload is " + progress + "% done");
                // Call the progress callback if it exists
                if (progressCallback) progressCallback(progress);
            }, // Observer for errors
            (error)=>{
                // Handle unsuccessful uploads and reject the promise
                //console.error("Upload failed:", error);
                reject(error);
            }, // Observer for completion
            async ()=>{
                try {
                    // Handle successful uploads on complete
                    //console.log("Upload complete, getting download URL...");
                    const downloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(uploadTask.snapshot.ref);
                    const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "temples", id);
                    await (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(docRef, {
                        photo: downloadURL
                    });
                    // Resolve the promise with the download URL
                    resolve(downloadURL);
                } catch (error) {
                    // If getting the URL fails, reject the promise
                    //console.error("Failed to get download URL:", error);
                    reject(error);
                }
            });
        });
    }
    async get(status = null) {
        const q = status ? (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", status), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "asc") // or desc
        ) : (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "!=", "deleted"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "asc") // or desc
        );
        const results = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const temples = [];
        results.docs.forEach((doc, i)=>{
            const temple = doc.data();
            temples.push({
                id: doc.id,
                status: temple.status,
                rank: i + 1,
                pid: temple.pid,
                name: temple.name,
                latitude: temple.latitude,
                longitude: temple.longitude,
                address: temple.address,
                photo: temple.photo,
                link: temple.link
            });
        });
        return temples;
    }
}




/**
 * Convert numbers (0 .. 1_000_000_000) to Khmer words and Khmer digits.
 *
 * - numberToKhmerWords(n) -> spelled-out Khmer (script)
 * - numberToKhmerDigits(n) -> Khmer digits (០-៩)
 *
 * Notes:
 * - 1,000,000 = "មួយលាន"
 * - 1,000,000,000 = "មួយពាន់លាន" (one thousand million / one billion)
 *
 * Sources for khmer words/units: MSU Basic Khmer, Wikipedia Khmer numerals.
 * (Used to choose terms like ពាន់, ម៉ឺន, សែន, លាន, ពាន់លាន, ដប់, ម្ភៃ, រយ.)
 */ const $b348546b86779519$var$ONES = {
    0: "\u179F\u17BC\u1793\u17D2\u1799",
    1: "\u1798\u17BD\u1799",
    2: "\u1796\u17B8\u179A",
    3: "\u1794\u17B8",
    4: "\u1794\u17BD\u1793",
    5: "\u1794\u17D2\u179A\u17B6\u17C6",
    6: "\u1794\u17D2\u179A\u17B6\u17C6\u1798\u17BD\u1799",
    7: "\u1794\u17D2\u179A\u17B6\u17C6\u1796\u17B8\u179A",
    8: "\u1794\u17D2\u179A\u17B6\u17C6\u1794\u17B8",
    9: "\u1794\u17D2\u179A\u17B6\u17C6\u1794\u17BD\u1793"
};
const $b348546b86779519$var$TENS_SPECIAL = {
    10: "\u178A\u1794\u17CB",
    20: "\u1798\u17D2\u1797\u17C3"
};
const $b348546b86779519$var$KHMER_DIGITS2 = /[\u17E0-\u17E9]/g;
const $b348546b86779519$var$KHMER_MAP = {
    "\u17E0": "0",
    "\u17E1": "1",
    "\u17E2": "2",
    "\u17E3": "3",
    "\u17E4": "4",
    "\u17E5": "5",
    "\u17E6": "6",
    "\u17E7": "7",
    "\u17E8": "8",
    "\u17E9": "9"
};
function $b348546b86779519$export$12f43d294de01a8a(input, max) {
    const normalized = input// Convert Khmer digits to English
    .replace(/[០-៩]/g, (d)=>$b348546b86779519$var$KHMER_MAP[d])// Remove anything that is not 0-9
    .replace(/[^0-9]/g, "");
    return normalized ? Math.min(max, parseInt(normalized)) : 0;
}
/**
 * A Type Guard to check if a string contains any Khmer numerals.
 */ function $b348546b86779519$var$hasKhmerNumerals(input) {
    return /[\u17E0-\u17E9]/.test(input);
}
// --- Practical Usage ---
// const mixedData = "Order #102: ចំនួន ១៥ គ្រឿង";
// if (hasKhmerNumerals(mixedData)) {
//     const cleanData = normalizeNumerals(mixedData);
//     console.log(cleanData); // "Order #102: ចំនួន 15 គ្រឿង"
// }
function $b348546b86779519$var$threeDigitToKhmerWords(n) {
    // Convert 0..999 to Khmer words
    if (n === 0) return "";
    const parts = [];
    const hundreds = Math.floor(n / 100);
    const rest = n % 100;
    if (hundreds > 0) {
        // e.g., 1 -> "មួយរយ", 2 -> "ពីររយ"
        const hWord = $b348546b86779519$var$ONES[hundreds] ?? "";
        parts.push(hWord + "\u179A\u1799");
    }
    if (rest > 0) {
        if (rest < 10) parts.push($b348546b86779519$var$ONES[rest]);
        else if (rest === 10) parts.push($b348546b86779519$var$TENS_SPECIAL[10]);
        else if (rest < 20) {
            // 11..19 = "ដប់" + ones (ដប់មួយ, ដប់ពីរ, ...)
            const ones = rest - 10;
            parts.push($b348546b86779519$var$TENS_SPECIAL[10] + (ones ? $b348546b86779519$var$ONES[ones] : ""));
        } else // 20..99
        if (rest >= 20 && rest < 30) {
            // 20..29: use ម្ភៃ optionally + ones
            const ones = rest - 20;
            const tensWord = $b348546b86779519$var$TENS_SPECIAL[20]; // ម្ភៃ
            parts.push(tensWord + (ones ? $b348546b86779519$var$ONES[ones] : ""));
        } else {
            // For 30,40,... we construct as tensDigit + "ម្ភៃ" is not used beyond 20 in common speech.
            // We'll approximate using digit words + "ម៉ឺន"/..." but correct generic approach:
            // fallback: treat as (tensDigit*10) by composing tensDigit + "ដប់"
            // e.g. 30 -> "បីដប់", 40 -> "បួនដប់"
            const tensDigit = Math.floor(rest / 10);
            const ones = rest % 10;
            const tensWord = ($b348546b86779519$var$ONES[tensDigit] ?? "") + "\u178A\u1794\u17CB"; // e.g., "បីដប់"
            parts.push(tensWord + (ones ? $b348546b86779519$var$ONES[ones] : ""));
        }
    }
    return parts.join("");
}
const $b348546b86779519$var$TYPE = "digit";
function $b348546b86779519$export$eab19c48dcb6310d(min, max, language) {
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
    return $b348546b86779519$export$1f66d962712fe46f(number, language);
}
function $b348546b86779519$export$f7b4d751913301f6(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $b348546b86779519$export$1f66d962712fe46f(n, language) {
    if (language === "english" || $b348546b86779519$var$TYPE === "english") return n.toString();
    else if ($b348546b86779519$var$TYPE === "digit") return $b348546b86779519$export$727094f2f0d91c75(n);
    if (!Number.isFinite(n) || n < 0 || n > 1000000000 || Math.floor(n) !== n) throw new RangeError("number must be an integer between 0 and 1,000,000,000");
    if (n === 0) return $b348546b86779519$var$ONES[0];
    // Break into parts using Khmer scale: លាន (1,000,000), ពាន់ (1,000), remainder
    // We'll also support grouping for thousands of millions (១,០០០,០០០,០០០) as "ពាន់លាន" for 1,000,000,000.
    const parts = [];
    // Billions (1,000,000,000) -> "មួយពាន់លាន"
    if (n >= 1000000000) {
        const billions = Math.floor(n / 1000000000); // should be 1 at most here
        parts.push(($b348546b86779519$var$ONES[billions] ?? `${billions}`) + "\u1796\u17B6\u1793\u17CB\u179B\u17B6\u1793");
        n = n % 1000000000;
    }
    // Millions (លាន)
    if (n >= 1000000) {
        const millions = Math.floor(n / 1000000);
        // e.g., 1 -> "មួយលាន", 2 -> "ពីរលាន", etc.
        parts.push((millions === 1 ? "\u1798\u17BD\u1799" : $b348546b86779519$var$ONES[millions] ?? $b348546b86779519$var$threeDigitToKhmerWords(millions)) + "\u179B\u17B6\u1793");
        n = n % 1000000;
    }
    // Hundreds of thousands / ten-thousands use "សែន" (100k) and "ម៉ឺន" (10k) if needed.
    if (n >= 100000) {
        const hundredsOfThousands = Math.floor(n / 100000);
        parts.push((hundredsOfThousands === 1 ? "\u1798\u17BD\u1799" : $b348546b86779519$var$ONES[hundredsOfThousands] ?? $b348546b86779519$var$threeDigitToKhmerWords(hundredsOfThousands)) + "\u179F\u17C2\u1793");
        n = n % 100000;
    }
    if (n >= 10000) {
        const tenThousands = Math.floor(n / 10000);
        parts.push((tenThousands === 1 ? "\u1798\u17BD\u1799" : $b348546b86779519$var$ONES[tenThousands] ?? $b348546b86779519$var$threeDigitToKhmerWords(tenThousands)) + "\u1798\u17C9\u17BA\u1793");
        n = n % 10000;
    }
    // Thousands
    if (n >= 1000) {
        const thousands = Math.floor(n / 1000);
        parts.push((thousands === 1 ? "\u1798\u17BD\u1799" : $b348546b86779519$var$ONES[thousands] ?? $b348546b86779519$var$threeDigitToKhmerWords(thousands)) + "\u1796\u17B6\u1793\u17CB");
        n = n % 1000;
    }
    // Remainder < 1000
    if (n > 0) parts.push($b348546b86779519$var$threeDigitToKhmerWords(n));
    // Join and return. Remove empty segments.
    return parts.filter(Boolean).join("");
}
/**
 * Convert to Khmer digits (០ ១ ២ ... ៩)
 */ const $b348546b86779519$var$KHMER_DIGITS = [
    "\u17E0",
    "\u17E1",
    "\u17E2",
    "\u17E3",
    "\u17E4",
    "\u17E5",
    "\u17E6",
    "\u17E7",
    "\u17E8",
    "\u17E9"
];
function $b348546b86779519$export$727094f2f0d91c75(n) {
    if (!Number.isFinite(n) || n < 0 || n > 1000000000 || Math.floor(n) !== n) throw new RangeError("number must be an integer between 0 and 1,000,000,000");
    return String(n).split("").map((ch)=>{
        if (ch === "-") return ch;
        if (ch === ",") return ch;
        const d = parseInt(ch, 10);
        return isNaN(d) ? ch : $b348546b86779519$var$KHMER_DIGITS[d];
    }).join("");
} /* Quick examples:
console.log(numberToKhmerDigits(12345)); // "១២៣៤៥"
console.log(numberToKhmerWords(0)); // "សូន្យ"
console.log(numberToKhmerWords(5)); // "ប្រាំ"
console.log(numberToKhmerWords(16)); // "ដប់ប្រាំមួយ" (constructed as ដប់ + ប្រាំមួយ)
console.log(numberToKhmerWords(1234567)); // "មួយលានពីរម៉ឺន..." (approx)
*/ 


class $2ad39f356e19a7c9$export$cf8fb0d5572f2359 {
    constructor(){
        this.collection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "buddhists");
    }
    async count() {
        const snapshot = await (0, $70fd6868680e912c$export$b1de1b12889d0afb)(this.collection);
        return snapshot.data().count;
    }
    async add(latitude, longitude, address) {
        const buddhist = {
            date: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
            latitude: latitude,
            longitude: longitude,
            address: address
        };
        const docRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(this.collection, buddhist);
        return {
            id: docRef.id,
            ...buddhist
        };
    }
    async remove(id) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $9d0840e0f81e5cfa$export$69c37fe6a10b78d4), "buddhists", id);
        await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(docRef);
    }
    async get() {
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(this.collection, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("date", "asc") // or desc
        );
        const buddhists = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        const readers = [];
        buddhists.docs.forEach((doc, i)=>{
            const reader = doc.data();
            readers.push({
                id: doc.id,
                uid: "",
                user: "HeartBank\xae",
                address: reader.address,
                latitude: reader.latitude,
                longitude: reader.longitude,
                lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
                pages: (0, $b348546b86779519$export$f7b4d751913301f6)(100, 2000),
                rank: i + 1
            });
        });
        return readers;
    }
}












const $f5f869da7e03d9d4$var$template = document.createElement("template");
$f5f869da7e03d9d4$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <div id="sw-map" class="w-full h-full"></div>
    <button
        id="sw-map-search"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map55[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed top-3 left-5 flex items-center justify-center opacity-90 text-white bg-purple-500 rounded-full w-10 h-10 hover:bg-purple-500 dark:bg-purple-500 dark:hover:bg-purple-500 focus:ring-4 focus:ring-purple-500 focus:outline-none dark:focus:ring-purple-500">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor">
            <path
                d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6 6 7.3 16.8 7.3 22.7 0 22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
        </svg>
    </button>
    <button
        id="sw-map-sound"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map58[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed top-3 right-5 flex items-center justify-center opacity-90 text-white bg-blue-600 rounded-full w-10 h-10 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-600 focus:ring-4 focus:ring-blue-600 focus:outline-none dark:focus:ring-blue-600">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            fill="currentColor">
            <path
                d="M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256S598.5 85.2 533.6 32.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM80 352l48 0 134.1 119.2c6.4 5.7 14.6 8.8 23.1 8.8 19.2 0 34.8-15.6 34.8-34.8l0-378.4c0-19.2-15.6-34.8-34.8-34.8-8.5 0-16.7 3.1-23.1 8.8L128 160 80 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48z" />
        </svg>
    </button>
    <button
        id="sw-map-temples-add"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map56[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed top-3 right-5 flex items-center justify-center opacity-90 text-white bg-orange-500 rounded-full w-10 h-10 hover:bg-orange-500 dark:bg-orange-500 dark:hover:bg-orange-500 focus:ring-4 focus:ring-orange-500 focus:outline-none dark:focus:ring-orange-500">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor">
            <path
                d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
        </svg>
    </button>
    <button
        id="sw-map-homes-add"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map57[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed top-3 right-5 flex items-center justify-center opacity-90 text-white bg-green-600 rounded-full w-10 h-10 hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-600 focus:ring-4 focus:ring-green-600 focus:outline-none dark:focus:ring-green-600">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor">
            <path
                d="M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM240 320c-26.5 0-48 21.5-48 48l0 96 128 0 0-96c0-26.5-21.5-48-48-48l-32 0z" />
        </svg>
    </button>
    <button
        id="sw-map-temples-toggle"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map38[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed bottom-7 left-5 flex items-center justify-center opacity-90 text-white bg-orange-500 rounded-full w-10 h-10 hover:bg-orange-500 dark:bg-orange-500 dark:hover:bg-orange-500 focus:ring-4 focus:ring-orange-500 focus:outline-none dark:focus:ring-orange-500">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor">
            <path
                d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
        </svg>
    </button>
    <button
        id="sw-map-monks-toggle"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map39[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed bottom-7 left-20 flex items-center justify-center opacity-90 text-white bg-yellow-400 rounded-full w-10 h-10 hover:bg-yellow-400 dark:bg-yellow-400 dark:hover:bg-yellow-400 focus:ring-4 focus:ring-yellow-400 focus:outline-none dark:focus:ring-yellow-400">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            fill="currentColor">
            <path
                d="M224 296c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112.6 88.2-119.7c13.1-17.8 9.3-42.8-8.5-55.9s-42.8-9.3-55.9 8.5L106.5 142.9C89.3 166.2 80 194.5 80 223.6l0 110.7-58.1 19.4C8.8 358 0 370.2 0 384l0 96c0 10 4.7 19.5 12.7 25.5s18.4 8 28.1 5.2l154.4-44.1c55-15.7 92.8-65.9 92.8-123.1L288 224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 72zm192 0l0-72c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 119.6c0 57.2 37.9 107.4 92.8 123.1l154.4 44.1c9.7 2.8 20 .8 28.1-5.2S640 490 640 480l0-96c0-13.8-8.8-26-21.9-30.4l-58.1-19.4 0-110.7c0-29-9.3-57.3-26.5-80.7L440.2 16.3C427.1-1.5 402.1-5.3 384.3 7.8s-21.6 38.1-8.5 55.9L464 183.4 464 296c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
        </svg>
    </button>
    <button
        id="sw-map-homes-toggle"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map40[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed bottom-7 right-20 flex items-center justify-center opacity-90 text-white bg-green-600 rounded-full w-10 h-10 hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-600 focus:ring-4 focus:ring-green-600 focus:outline-none dark:focus:ring-green-600">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor">
            <path
                d="M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM240 320c-26.5 0-48 21.5-48 48l0 96 128 0 0-96c0-26.5-21.5-48-48-48l-32 0z" />
        </svg>
    </button>
    <button
        id="sw-map-readers-toggle"
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map41[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        class="fixed bottom-7 right-5 flex items-center justify-center opacity-90 text-white bg-blue-600 rounded-full w-10 h-10 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-600 focus:ring-4 focus:ring-blue-600 focus:outline-none dark:focus:ring-blue-600">
        <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="currentColor">
            <path
                d="M256 152a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm0 298.7l0-149.3c16.3-6.8 32.9-13.7 49.7-20.7 39-16.2 80.8-24.6 123.1-24.6l19.2 0 0 160-19.2 0c-59.1 0-117.7 11.7-172.3 34.5l-.5 .2zM256 232l-25.1-10.5C184.1 202 133.9 192 83.2 192L48 192c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l35.2 0c50.7 0 100.9 10 147.7 29.5l12.8 5.3c7.9 3.3 16.7 3.3 24.6 0l12.8-5.3c46.8-19.5 97-29.5 147.7-29.5l35.2 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-35.2 0c-50.7 0-100.9 10-147.7 29.5L256 232z" />
        </svg>
    </button>
    <div
        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map30[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
        data-dial-init2
        class="fixed bottom-24 right-5 group">
        <div
            id="sw-map-view"
            class="hidden flex-col justify-end py-1 mb-4 space-y-2 bg-white border border-gray-100 rounded-lg shadow-xs dark:bg-gray-700 dark:border-gray-600">
            <ul class="text-sm text-gray-500 dark:text-gray-300">
                <li
                    class="flex items-center px-5 py-2 border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-5 h-5 me-2 ms-[-5px]"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="blueviolet">
                        <path
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                            transform="rotate(45 12 12)" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map11[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-thanks" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(25, 50, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map11b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="flex items-center px-5 py-2 border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="dodgerblue"
                        viewBox="0 0 512 512">
                        <path
                            d="M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152l0 264-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427L0 224c0-17.7 14.3-32 32-32l30.3 0c63.6 0 125.6 19.6 177.7 56zm32 264l0-264c52.1-36.4 114.1-56 177.7-56l30.3 0c17.7 0 32 14.3 32 32l0 203c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map9[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <!--${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? "&zwnj;" : ""}-->
                        <span id="sw-map-readers" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map9b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="flex items-center px-5 py-2 border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="green"
                        viewBox="0 0 512 512">
                        <path
                            d="M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM240 320c-26.5 0-48 21.5-48 48l0 96 128 0 0-96c0-26.5-21.5-48-48-48l-32 0z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map43[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-homes" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map43b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="flex items-center px-5 py-2 border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="orange"
                        viewBox="0 0 640 512">
                        <path
                            d="M224 296c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112.6 88.2-119.7c13.1-17.8 9.3-42.8-8.5-55.9s-42.8-9.3-55.9 8.5L106.5 142.9C89.3 166.2 80 194.5 80 223.6l0 110.7-58.1 19.4C8.8 358 0 370.2 0 384l0 96c0 10 4.7 19.5 12.7 25.5s18.4 8 28.1 5.2l154.4-44.1c55-15.7 92.8-65.9 92.8-123.1L288 224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 72zm192 0l0-72c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 119.6c0 57.2 37.9 107.4 92.8 123.1l154.4 44.1c9.7 2.8 20 .8 28.1-5.2S640 490 640 480l0-96c0-13.8-8.8-26-21.9-30.4l-58.1-19.4 0-110.7c0-29-9.3-57.3-26.5-80.7L440.2 16.3C427.1-1.5 402.1-5.3 384.3 7.8s-21.6 38.1-8.5 55.9L464 183.4 464 296c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map42[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-monks" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map42b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="flex items-center px-5 py-2 border-0 border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="orangered"
                        viewBox="0 0 512 512">
                        <path
                            d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map44[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-temples" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map44b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="hidden items-center px-5 py-2 border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="gold"
                        viewBox="0 0 512 512">
                        <path
                            d="M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map10[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-hours" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(1000, 10000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map10b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="hidden items-center px-5 py-2 border-b border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="orange"
                        viewBox="0 0 512 512">
                        <path
                            d="M256 141.3l0 309.3 .5-.2C311.1 427.7 369.7 416 428.8 416l19.2 0 0-320-19.2 0c-42.2 0-84.1 8.4-123.1 24.6-16.8 7-33.4 13.9-49.7 20.7zM230.9 61.5L256 72 281.1 61.5C327.9 42 378.1 32 428.8 32L464 32c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-35.2 0c-50.7 0-100.9 10-147.7 29.5l-12.8 5.3c-7.9 3.3-16.7 3.3-24.6 0l-12.8-5.3C184.1 490 133.9 480 83.2 480L48 480c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l35.2 0c50.7 0 100.9 10 147.7 29.5z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map13[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-pages" class="text-green-400">
                            ${(0, $b348546b86779519$export$eab19c48dcb6310d)(100, 1000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                        </span>
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map13b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </span>
                </li>
                <li
                    class="hidden items-center px-5 py-2 border-0 border-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white dark:border-gray-600">
                    <svg
                        class="w-3.5 h-3.5 me-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="red"
                        viewBox="0 0 576 512">
                        <path
                            d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                    </svg>
                    <span class="text-sm font-medium">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map12[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        <span id="sw-map-tips" class="text-green-400">
                            $${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}K
                        </span>
                    </span>
                </li>
            </ul>
        </div>
        <button
            id="sw-map-stats"
            type="button"
            onclick="heartbank.alertAdmin('map/click/stats')"
            data-dial-toggle2="sw-map-view"
            aria-controls="sw-map-view"
            aria-expanded="false"
            class="flex items-center justify-center ml-auto opacity-90 bg-hb rounded-full w-14 h-14 ring-orange-500 focus:outline-none">
            <svg
                class="w-10 h-10 me-1 mt-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="white">
                <path
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                    transform="rotate(45 12 12)" />
            </svg>
            <!--<svg
                class="w-6 h-6"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 448 512">
                <path
                    d="M160 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352zM0 272c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 272zM368 96l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48z" />
            </svg>-->
            <span class="sr-only">Open actions menu</span>
        </button>
    </div>
`;
var $f5f869da7e03d9d4$export$2e2bcd8739ae039 = $f5f869da7e03d9d4$var$template;




var $48b654dc7c8a49e3$exports = {};
$48b654dc7c8a49e3$exports = new URL("default.947f6a58.png", import.meta.url).toString();


var $46353713039eb022$exports = {};
$46353713039eb022$exports = new URL("siliconwat.d7b5f302.png", import.meta.url).toString();


const $72bce429f9a506ac$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $72bce429f9a506ac$export$5cbcce5f0320f87 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.temples = new (0, $0f70913938cf6fe3$export$717dc719c0afad28)(), this.buddhists = new (0, $2ad39f356e19a7c9$export$cf8fb0d5572f2359)(), this.readers = new (0, $dcb5b0b92549b428$export$df935bc2312a795f)(), this.feedbacks = new (0, $f76271ebfe467595$export$2ddb2ffa4475b711)(), this.quotas = new (0, $c1b7cc755c0d15d3$export$4a0a69082ccdb997)(), this.header = document.querySelector("sw-header"), this.footer = document.querySelector("sw-footer"), this.loader = null, this.map = null, this.location = null, this.infoWindow = null, this.marker = null // user reader
        , this.templeMarkers = [], this.monkMarkers = [], this.homeMarkers = [], this.readerMarkers = [], this.watchId = null, this.isGranted = false // one time per reload
        , this.isPrompted = false // one time per reload
        , this.isPrompted2 = false // one time per reload
        , this.page = (0, $eba1d7d434ec7c0e$export$ce970371e0e850bc), this.showReaders = true, this.showHomes = true, this.showMonks = true, this.showTemples = true, this.isInfoWindowOpen = false, this.isFullMap = false, this.size = 50 // random readers
        , this.userSize = 2.0, this.readerSize = 1.0, this.homeSize = 1.0, this.monkSize = 1.5, this.templeSize = 1.5, this.addressMiles = 5 // miles to cache
        , this.addressCache = new Map(), // TODO: later: store addresses in firestore to save money ??
        this.maxTemples = 30 // same cost for any amount: double check this
        , this.templeMiles = 5 // miles to cache
        , this.templeCache = new Map() //google.maps.places.Place[]
        , this.templeSearchDebounceTimeout = null, this.phnomPenh = {
            lat: 11.5564,
            lng: 104.9282
        }, this.longBeach = {
            lat: 33.7701,
            lng: -118.1937
        } // { lat: 33.77005, lng: -118.193741 }
        , this.USA = {
            lat: 39.8283,
            lng: -98.5795
        } // continental center
        , // Cambodia's approximate bounding box
        this.cambodiaBounds = {
            minLat: 10.4,
            maxLat: 14.7,
            minLng: 102.3,
            maxLng: 107.6 // Eastern extent
        }, this.cambodiaBounds2 = {
            // Original values were: min: 10.4, max: 14.7
            minLat: 9.5,
            maxLat: 15.5,
            // Original values were: min: 102.3, max: 107.6
            minLng: 102.3,
            maxLng: 108.5 // Extended east to include Vietnam's Mekong Delta
        }, this.cambodiaBounds3 = {
            minLat: 9.0,
            maxLat: 16.0,
            minLng: 101.0,
            maxLng: 109.0
        }, // California's approximate bounding box
        this.californiaBounds = {
            minLat: 32.5,
            maxLat: 42.0,
            minLng: -124.4,
            maxLng: -114.1 // Eastern extent
        }, // continentalUSBounds
        this.californiaBounds2 = {
            minLat: 24.5,
            maxLat: 49.5,
            minLng: -125,
            maxLng: -66.9 // Eastern extent: West Quoddy Head, ME (~66.9° W)
        }, this.franceBounds = {
            minLat: 41.3,
            maxLat: 51.1,
            minLng: -5.2,
            maxLng: 9.6 // Easternmost point of Corsica
        }, this.franceBounds2 = {
            minLat: 41.0,
            maxLat: 51.5,
            minLng: -6,
            maxLng: 10.0
        }, this.australiaBounds = {
            minLat: -38,
            maxLat: -12,
            minLng: 113.5,
            maxLng: 153.0 // Moves west, trimming the eastern bulge
        }, this.australiaBounds2 = {
            minLat: -39.2,
            maxLat: -10.6,
            minLng: 112.9,
            maxLng: 153.7 // Easternmost point: Cape Byron, NSW
        }, this.australiaBounds3 = {
            minLat: -44,
            maxLat: -9,
            minLng: 112.0,
            maxLng: 154.0 // Easternmost point (Cape Byron)
        };
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-map");
        this.componentTrace.start();
        this.appendChild((0, $f5f869da7e03d9d4$export$2e2bcd8739ae039).content.cloneNode(true));
        this.container = this.querySelector("#sw-map");
        this.view = this.querySelector("#sw-map-view");
        this.statsBtn = this.querySelector("#sw-map-stats");
        this.mapSearch = this.querySelector("#sw-map-search");
        this.mapSound = this.querySelector("#sw-map-sound");
        this.templesAdd = this.querySelector("#sw-map-temples-add");
        this.homesAdd = this.querySelector("#sw-map-homes-add");
        this.templesBtn = this.querySelector("#sw-map-temples-toggle");
        this.monksBtn = this.querySelector("#sw-map-monks-toggle");
        this.homesBtn = this.querySelector("#sw-map-homes-toggle");
        this.readersBtn = this.querySelector("#sw-map-readers-toggle");
        this.thanks = this.querySelector("#sw-map-thanks");
        this.students = this.querySelector("#sw-map-readers");
        this.homes = this.querySelector("#sw-map-homes");
        this.monks = this.querySelector("#sw-map-monks");
        this.wats = this.querySelector("#sw-map-temples");
        this.hours = this.querySelector("#sw-map-hours");
        this.pages = this.querySelector("#sw-map-pages");
        this.tips = this.querySelector("#sw-map-tips");
        this.debouncedFindTemples = this.debounceTemples(()=>{
            if (!this.isInfoWindowOpen && this.isAdminTemples()) this.findAndDisplayTemples();
        }, 1000); // 750ms delay is a good starting point
        window.removeReader = async (id)=>{
            if (this.isAdminReaders() && confirm($72bce429f9a506ac$var$strings.map35b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                await this.buddhists.remove(id);
                this.show(this.page);
                this.heartbank.alertAdmin("map/reader/remove/", id);
            }
        };
        window.publishTemple = async (id)=>{
            if (this.isAdminTemples() && confirm($72bce429f9a506ac$var$strings.map49[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                await this.temples.updateStatus(id, true);
                await this.renderTemples();
                this.heartbank.alertAdmin("map/temple/edit/status/active");
            }
        };
        window.unpublishTemple = async (id)=>{
            if (this.isAdminTemples() && confirm($72bce429f9a506ac$var$strings.map50[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                await this.temples.updateStatus(id, false);
                await this.renderTemples();
                this.heartbank.alertAdmin("map/temple/edit/status/inactive");
            }
        };
        // not used bc reloading user info window is too complex right now
        window.addTemple = async (latitude, longitude, address)=>{
            if (this.isAdminTemples()) {
                const coordinate = prompt($72bce429f9a506ac$var$strings.map59[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], $72bce429f9a506ac$var$strings.map60[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                if (coordinate !== null) {
                    if (coordinate === "" || coordinate === $72bce429f9a506ac$var$strings.map60[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]) ;
                    else {
                        const position = coordinate.split(",");
                        latitude = parseFloat(position[0]);
                        longitude = parseFloat(position[1]);
                    }
                    const name = prompt($72bce429f9a506ac$var$strings.map52[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                    if (name) {
                        await this.temples.adminAdd(name, latitude, longitude, address);
                        await this.show(this.page); // needed bc counter has changed
                        //this.map?.panTo({ lat: latitude, lng: longitude });
                        this.heartbank.alertAdmin(`map/user/add/temple/${name}: `, address);
                    }
                }
            }
        };
        window.removeTemple = async (id, pid)=>{
            if (this.isAdminTemples() && confirm($72bce429f9a506ac$var$strings.map51[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) {
                await this.temples.remove(id, pid);
                await this.renderTemples();
                this.heartbank.alertAdmin(`map/temple/remove/${id}/`, pid);
            }
        };
        window.editTempleName = async (id, name)=>{
            if (this.isAdminTemples()) {
                const newName = prompt($72bce429f9a506ac$var$strings.map46[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], name);
                if (newName) {
                    const temple = await this.temples.updateName(id, newName);
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(`map/temple/edit/name: ${name} => ${newName}`);
                }
            }
        };
        window.editTempleAddress = async (id, address)=>{
            if (this.isAdminTemples()) {
                const newAddress = prompt($72bce429f9a506ac$var$strings.map47[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], address);
                if (newAddress) {
                    const temple = await this.temples.updateAddress(id, newAddress);
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(`map/temple/edit/address: ${address} => ${newAddress}`);
                }
            }
        };
        window.editTempleLink = async (id, link)=>{
            if (this.isAdminTemples()) {
                const newLink = prompt($72bce429f9a506ac$var$strings.map48[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], link);
                if (newLink) {
                    const temple = await this.temples.updateLink(id, newLink);
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(`map/temple/edit/link: ${link} => ${newLink}`);
                }
            }
        };
        window.editTemplePhoto = async (id)=>{
            if (this.isAdminTemples()) {
                const temple = await this.temples.updatePhoto(id, (progress)=>{
                    console.info("Upload is " + progress + "% done");
                // or: sw-banner // can't use bc fullscreen mode hides it
                // this.dispatchEvent(
                //     new CustomEvent<{ info: string }>("sw-alert", {
                //         bubbles: true,
                //         detail: {
                //             info: strings.map36[LANGUAGE]
                //         }
                //     })
                // );
                });
                if (temple) {
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin("map/temple/edit/photo: ", temple.photo);
                } // else alert();
            }
        };
    }
    debounceTemples(func, delay) {
        return ()=>{
            if (this.templeSearchDebounceTimeout) clearTimeout(this.templeSearchDebounceTimeout);
            this.templeSearchDebounceTimeout = window.setTimeout(func, delay);
        };
    }
    // also mobile biz
    isAdminReaders() {
        return this.page === "history" && !this.isFullMap && this.heartbank.isAdmin();
    }
    // also home biz
    isAdminHomes() {
        return this.page === "history" && this.isFullMap && this.heartbank.isAdmin();
    }
    isAdminMonks() {
        return this.page === "leaderboard" && !this.isFullMap && this.heartbank.isAdmin();
    }
    isAdminTemples() {
        return this.page === "leaderboard" && this.isFullMap && this.heartbank.isAdmin();
    }
    connectedCallback() {
        this.readers.stop();
        this.renderTotalThanks();
        //this.getCurrentLocation();
        this.mapSearch.addEventListener("click", ()=>{
            if (!this.heartbank.isAdmin()) alert($72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            this.panToHome();
        });
        this.mapSound.addEventListener("click", ()=>{
            alert($72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        });
        this.templesAdd.addEventListener("click", async ()=>{
            if (this.isAdminTemples()) {
                const coordinate = prompt($72bce429f9a506ac$var$strings.map59[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], $72bce429f9a506ac$var$strings.map60[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                if (coordinate !== null) {
                    let latitude = this.location?.lat;
                    let longitude = this.location?.lng;
                    if (coordinate === "" || coordinate === $72bce429f9a506ac$var$strings.map60[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]) ;
                    else {
                        const position = coordinate.split(",");
                        latitude = parseFloat(position[0] || "0");
                        longitude = parseFloat(position[1] || "0");
                    }
                    if (latitude && longitude) {
                        const name = prompt($72bce429f9a506ac$var$strings.map52[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                        if (name) {
                            await this.temples.adminAdd(name, latitude, longitude);
                            await this.show(this.page); // needed bc counter has changed
                            this.map?.panTo({
                                lat: latitude,
                                lng: longitude
                            });
                            this.heartbank.alertAdmin(`map/user/add/temple/${name}: `, `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${latitude},${longitude}`);
                        }
                    } else alert($72bce429f9a506ac$var$strings.map54[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                }
            }
        });
        this.homesAdd.addEventListener("click", ()=>{
            alert($72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        });
        this.statsBtn.addEventListener("click", async ()=>{
            if (this.isFullMap) {
                this.header.show();
                this.footer.show();
                this.view.classList.add("hidden");
                this.statsBtn.classList.remove("ring-4");
                this.isFullMap = false;
            } else {
                this.header.hide();
                this.footer.hide();
                this.view.classList.remove("hidden");
                this.statsBtn.classList.add("ring-4");
                this.isFullMap = true;
            }
            this.mapSound.classList.toggle("hidden", this.isAdminTemples() || this.isAdminHomes());
            this.templesAdd.classList.toggle("hidden", !this.isAdminTemples());
            this.homesAdd.classList.toggle("hidden", !this.isAdminHomes());
            this.renderTemples();
        });
        this.templesBtn.addEventListener("click", ()=>{
            if (this.showTemples) {
                this.templesBtn.style.opacity = "0.5";
                this.showTemples = false;
            } else {
                this.templesBtn.style.opacity = "";
                this.showTemples = true;
            }
            this.renderTemples();
        });
        this.monksBtn.addEventListener("click", ()=>{
            if (this.showMonks) {
                this.monksBtn.style.opacity = "0.5";
                this.showMonks = false;
            } else {
                this.monksBtn.style.opacity = "";
                this.showMonks = true;
            }
        });
        this.homesBtn.addEventListener("click", ()=>{
            if (this.showHomes) {
                this.homesBtn.style.opacity = "0.5";
                this.showHomes = false;
            } else {
                this.homesBtn.style.opacity = "";
                this.showHomes = true;
            }
        });
        this.readersBtn.addEventListener("click", ()=>{
            if (this.showReaders) {
                this.readersBtn.style.opacity = "0.5";
                this.showReaders = false;
            } else {
                this.readersBtn.style.opacity = "";
                this.showReaders = true;
            }
            this.renderReaderMarkers();
        });
        // this.heartbank.addAuthStateListener3((hero) => {
        //     if (window.location.hash === "#readership") this.show(this.page);
        // });
        this.addListeners();
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    renderReaderMarkers() {
        if (this.showReaders) this.readerMarkers.forEach((marker)=>marker.map = this.map);
        else this.readerMarkers.forEach((marker)=>marker.map = null);
    }
    async initMap() {
        // Initialize Google Maps Loader
        this.loader = new (0, $2611977388863fc8$export$3b0d6d7590275603)({
            apiKey: "AIzaSyBK85eUHtSPtDwlBmf3mB_6Y_E1J1X8xA4",
            version: "weekly",
            libraries: [
                "maps",
                "marker",
                "places",
                "geometry"
            ],
            language: $72bce429f9a506ac$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            region: $72bce429f9a506ac$var$strings.region[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] // 👈 optional, helps with regional context (Cambodia)
        });
        try {
            // Load the required libraries
            const [libraries] = await Promise.all([
                this.loader.importLibrary("core"),
                this.loader.importLibrary("maps"),
                this.loader.importLibrary("marker"),
                this.loader.importLibrary("places"),
                this.loader.importLibrary("geometry")
            ]);
            // https://developers.google.com/maps/documentation/javascript/maps-app-check
            // const settings = google.maps.Settings.getInstance() as any;
            //temp
            // settings.fetchAppCheckToken = () =>
            //     getToken(appCheck, /* forceRefresh = */ false);
            // Initialize the map after libraries are loaded
            await this.renderMap();
        } catch (error) {
            //console.error("Failed to load Google Maps: ", error.message);
            if (navigator.onLine) alert($72bce429f9a506ac$var$strings.map4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        }
    }
    async renderMap(color = null) {
        if (!await this.quotas.isFree("dynamicmaps")) {
            alert($72bce429f9a506ac$var$strings.map37[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            return;
        }
        const scheme = color || localStorage.getItem("colorScheme");
        let colorScheme;
        switch(scheme){
            case "light":
                colorScheme = google.maps.ColorScheme.LIGHT;
                break;
            case "dark":
                colorScheme = google.maps.ColorScheme.DARK;
                break;
            case "system":
                colorScheme = google.maps.ColorScheme.FOLLOW_SYSTEM;
                break;
        }
        const ip = await (0, $eba1d7d434ec7c0e$export$67218453e01a0be8)();
        const location = await (0, $eba1d7d434ec7c0e$export$e7fd20fad3cf4b5f)(ip);
        const coordinate = location.latitude && location.longitude ? {
            lat: location.latitude,
            lng: location.longitude
        } : null;
        if (!this.location) this.location = coordinate || this.longBeach;
        // Initialize map with user's location
        this.map = new google.maps.Map(this.container, {
            center: this.location,
            zoom: 1.5,
            mapId: "9311f726d06a3b44",
            colorScheme: colorScheme,
            // --- Set Default Map Type to Terrain ---
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            // --- Enable Tilt (45 degrees) ---
            tilt: 45,
            // Enable the controls you want to position
            //scaleControl: false, // doesn't exist
            zoomControl: false,
            fullscreenControl: false,
            disableDefaultUI: true,
            mapTypeControl: true,
            streetViewControl: true,
            // --- Configure Control Positions ---
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControlOptions: {
                //style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR, // Optional: change style
                position: google.maps.ControlPosition.TOP_CENTER
            },
            streetViewControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_CENTER
            },
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_LEFT
            }
        });
        // // Add listener to search for temples when the map view is idle
        // this.map.addListener("idle", () => {
        //     //console.log(this.map!.getZoom());
        //     if (this.showTemples && !this.isInfoWindowOpen)
        //         this.findAndDisplayTemples();
        // });
        this.map.addListener("idle", this.debouncedFindTemples);
        // Add a listener for map clicks
        this.map.addListener("click", this.handleMapClick.bind(this));
        this.infoWindow = new google.maps.InfoWindow();
        this.infoWindow.addListener("closeclick", ()=>{
            this.isInfoWindowOpen = false;
            this.readers.isRealTime = true;
        });
    // Listen for the 'domready' event to fire when the InfoWindow is ready.
    // google.maps.event.addListener(this.infoWindow, "domready", () => {
    //     const mode = document.documentElement.classList.contains("dark")
    //         ? "dark"
    //         : "light";
    //     const iwBackgroundColor = mode === "dark" ? "#2c3e50" : "white";
    //     // 1. Target the main content container
    //     const iwOuter =
    //         document.querySelector<HTMLElement>(".gm-style-iw-c");
    //     if (iwOuter) {
    //         iwOuter.style.backgroundColor = iwBackgroundColor; // A dark blue
    //         //iwOuter.style.padding = "0"; // Remove default padding if needed
    //     }
    //     // 2. Target the content div to change text color
    //     const iwContent =
    //         document.querySelector<HTMLElement>(".gm-style-iw-d");
    //     if (iwContent) {
    //         iwContent.style.color = "#ecf0f1"; // A light grey/white
    //     }
    //     // 3. Target the close button
    //     const closeButton = document.querySelector<HTMLElement>(
    //         ".gm-ui-hover-effect"
    //     );
    //     if (closeButton) {
    //         // SVG close buttons are tricky. Let's change its color via filter.
    //         // For a simple background change: closeButton.style.backgroundColor = 'red';
    //         (closeButton.firstElementChild as HTMLElement).style.filter =
    //             mode === "dark" ? "invert(1)" : "";
    //     }
    //     // // 4. Target the arrow "tip" // doesn't work
    //     // // The tip is made of two divs, one for the outer border and one for the inner fill.
    //     // const iwTipOuter = document.querySelector<HTMLElement>(
    //     //     ".gm-style-iw-t > div > div:last-child"
    //     // );
    //     // if (iwTipOuter) {
    //     //     iwTipOuter.style.backgroundColor = iwBackgroundColor;
    //     // }
    //     // const iwTipInner = document.querySelector<HTMLElement>(
    //     //     ".gm-style-iw-t > div > div:first-child"
    //     // );
    //     // if (iwTipInner) {
    //     //     iwTipInner.style.boxShadow = "none"; // Optional: remove the default shadow
    //     // }
    // });
    }
    async addListeners() {
        // this.heartbank.addAuthStateListener3(() => {
        //     if (this.heartbank.isAdmin()) {
        //         this.pages.classList.add(
        //             "border-b",
        //             "border-gray-200",
        //             "dark:border-gray-600"
        //         );
        //         this.thanks.classList.replace("hidden", "flex");
        //         this.tips.classList.replace("hidden", "flex");
        //     } else {
        //         this.pages.classList.remove(
        //             "border-b",
        //             "border-gray-200",
        //             "dark:border-gray-600"
        //         );
        //         this.thanks.classList.replace("flex", "hidden");
        //         this.tips.classList.replace("flex", "hidden");
        //     }
        // });
        //TODO: listen for tailwind html tag color scheme change instead ??
        document.body.addEventListener("sw-color-scheme", async (event)=>{
            const customEvent = event;
            const colorScheme = customEvent.detail.colorScheme;
            if (this.loader) {
                await this.renderMap(colorScheme);
                await this.render();
                this.getCurrentLocation(); // needed for markers to show
            }
        });
    }
    async show(page = (0, $eba1d7d434ec7c0e$export$ce970371e0e850bc)) {
        this.page = page;
        this.classList.remove("hidden");
        const B = this.statsBtn.firstElementChild;
        if (page === "now") {
            B.classList.add("animate-heartbeat");
            this.readers.now(async (readers, changes)=>{
                //console.log(readers, changes);
                if (readers.length > 0) {
                    if (!this.loader) await this.initMap();
                    await this.render(readers);
                    this.getCurrentLocation(); // needed for markers to show
                }
            });
        } else {
            B.classList.remove("animate-heartbeat");
            if (!this.loader) await this.initMap();
            await this.render();
            this.getCurrentLocation(); // needed for markers to show
        }
    }
    hide() {
        this.readers.stop();
        this.classList.add("hidden");
    }
    //// render
    async render(readers = []) {
        // reset
        this.readerMarkers.forEach((marker)=>{
            marker.map = null;
        //google.maps.event.clearInstanceListeners(marker); // weird bug
        });
        this.readerMarkers = [];
        this.bounds = new google.maps.LatLngBounds();
        // dummy
        if (this.page !== "now") await this.renderReaders();
        switch(this.page){
            case "leaderboard":
                const readers2 = await this.readers.leaderboard();
                await this.renderReader(this.getRank(readers2));
                await this.renderLeaderboard(readers2);
                this.renderTotalReaders(await this.buddhists.count());
                //this.renderTotalReaders(getRandomNumber2(100, 1000));
                this.renderPages(readers, true);
                break;
            case "now":
                await this.renderReader(this.getRank(readers), true);
                await this.renderNow(readers);
                this.renderTotalReaders();
                this.renderPages(readers);
                break;
            case "history":
                const readers3 = await this.readers.history();
                await this.renderReader(this.getRank(readers3));
                await this.renderHistory(readers3);
                this.renderTotalReaders(await this.buddhists.count());
                //this.renderTotalReaders(getRandomNumber2(100, 1000));
                this.renderPages(readers, true);
                break;
        }
        // order is important for pin sizes overlap
        await this.renderTemples(); //if (this.templeMarkers.length === 0)
        this.renderReaderMarkers();
        if (this.page === "now") this.panToHome();
        else if (!this.bounds.isEmpty()) {
            // Only fit bounds if there are markers to show
            this.map.fitBounds(this.bounds); // Adjust map to fit all markers
            this.map.panToBounds(this.bounds, 50); // Optional: Add padding (in pixels) to ensure markers aren't at the edge
        }
    }
    getRank(readers) {
        const reader = readers.find((reader)=>reader.id === this.heartbank.getDeviceID());
        return reader?.rank || 0;
    }
    async renderTotalThanks() {
        const total = await this.feedbacks.count();
        this.thanks.textContent = (0, $b348546b86779519$export$1f66d962712fe46f)(total, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa));
    }
    async renderTotalReaders(count = 0) {
        const total = count + await this.readers.count();
        this.students.textContent = (0, $b348546b86779519$export$1f66d962712fe46f)(total, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa));
    }
    renderTotalHomes() {}
    renderTotalMonks() {}
    async renderTotalTemples(count = null) {
        const total = count || await this.temples.count();
        this.wats.textContent = (0, $b348546b86779519$export$1f66d962712fe46f)(total, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa));
    }
    //TODO: v2 use real time database to get all
    renderPages(readers, isDummy = false) {
        const total = readers.reduce((sum, reader)=>sum + (reader.pages ?? 0), 0);
        this.pages.textContent = isDummy ? (0, $b348546b86779519$export$eab19c48dcb6310d)(1000, 10000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa)) : (0, $b348546b86779519$export$1f66d962712fe46f)(total, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa));
    }
    async renderNow(readers) {
        for (const reader of readers){
            this.extendBounds(reader);
            await this.addReader(reader, this.readerSize);
        }
    }
    async renderLeaderboard(readers) {
        for (const reader of readers){
            if (!this.heartbank.isAdmin()) this.extendBounds(reader);
            await this.addReader(reader, this.readerSize);
        }
    }
    async renderHistory(readers) {
        for (const reader of readers){
            if (!this.heartbank.isAdmin()) this.extendBounds(reader);
            await this.addReader(reader, this.readerSize);
        }
    }
    async renderReaders() {
        const readers = await this.buddhists.get();
        const total = await this.readers.count();
        for (const reader of readers){
            reader.rank = total + reader.rank;
            await this.addReader(reader, this.readerSize);
        }
    }
    /**
     * Handles a click event on the map. It performs a reverse geocode lookup
     * for the clicked coordinates and dispatches a 'sw-map-click' custom event
     * with the location details.
     * @param event The Google Maps mouse event from the click.
     */ async handleMapClick(event) {
        if (!(this.isAdminReaders() || this.isAdminHomes() || this.isAdminMonks() || this.isAdminTemples())) return;
        if (!event.latLng) {
            console.warn("Map click event did not have LatLng information.");
            return;
        }
        const position = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        };
        const location = await this.geocode(position);
        if (location) {
            const pin = new google.maps.marker.PinElement({
                background: "skyblue",
                borderColor: "blue",
                glyph: "\u23F3",
                glyphColor: "white",
                scale: this.userSize
            });
            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: position,
                map: null,
                content: pin.element,
                title: $72bce429f9a506ac$var$strings.map36[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
            });
            if (this.isAdminReaders()) {
                //marker.map = this.map;
                //this.readerMarkers.push(marker);
                await this.buddhists.add(location.lat, location.lng, location.formatted_address);
                marker.map = this.map;
                this.readerMarkers.push(marker);
                this.renderTotalReaders(await this.buddhists.count());
                //await this.show(this.page);
                //this.map?.panTo(location);
                this.heartbank.alertAdmin("map/reader/add/", location.formatted_address);
            }
            this.isAdminHomes();
            this.isAdminMonks();
            if (this.isAdminTemples()) {
                const name = prompt($72bce429f9a506ac$var$strings.map52[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                if (name) {
                    marker.map = this.map;
                    this.templeMarkers.push(marker);
                    await this.temples.adminAdd(name, location.lat, location.lng, location.formatted_address);
                    await this.show(this.page); // needed to show real marker
                    this.map?.panTo(location);
                    this.heartbank.alertAdmin(`map/temple/add/${name}: `, location.formatted_address);
                }
            }
        } else alert($72bce429f9a506ac$var$strings.map37[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]); // alert admin quota has exceeded
    // let address: string | null = null;
    // try {
    //     const geocoder = new google.maps.Geocoder();
    //     const request: google.maps.GeocoderRequest = {
    //         location: clickedLatLng,
    //         language: strings.language[LANGUAGE]
    //     };
    //     const response = await geocoder.geocode(request);
    //     if (response.results && response.results.length > 0) {
    //         address = response.results[0].formatted_address;
    //         await this.buddhists.add(
    //             clickedLatLng.lat,
    //             clickedLatLng.lng,
    //             address
    //         );
    //         this.show(this.page);
    //         this.heartbank.alertAdmin("map/reader/add/", address);
    //     } else {
    //         console.warn(
    //             "Reverse geocoding failed: No results found for the clicked location.",
    //             clickedLatLng
    //         );
    //     }
    // } catch (error) {
    //     console.error("Reverse geocoding API call failed:", error);
    // } finally {
    //     // Dispatch the event regardless of geocoding success
    //     const mapClickEvent = new CustomEvent("sw-map-click", {
    //         detail: {
    //             coordinate: clickedLatLng,
    //             formatted_address: address
    //         },
    //         bubbles: true, // Allows the event to bubble up through the DOM
    //         composed: true // Allows the event to cross shadow DOM boundaries
    //     });
    //     this.dispatchEvent(mapClickEvent);
    // }
    }
    getAnonReader(id) {
        return {
            id: id,
            uid: "",
            user: "HeartBank\xae",
            address: $72bce429f9a506ac$var$strings.map17[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            latitude: (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? this.phnomPenh.lat : this.longBeach.lat,
            longitude: (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? this.phnomPenh.lng : this.longBeach.lng,
            lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
            pages: 0,
            rank: 0
        };
    }
    // user: render and add
    async renderReader(rank, extendBounds = false) {
        const id = this.heartbank.getDeviceID();
        const reader = await this.readers.get(id) || this.getAnonReader(id);
        const user = await this.readers.getUser(this.heartbank.user?.uid || reader.uid || "");
        const name = user.displayName || user.email || $72bce429f9a506ac$var$strings.map20[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        //const mapURL = `https://www.google.com/maps/search/?api=1&query=${reader.latitude},${reader.longitude}`;
        const mapURL = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${this.location?.lat ?? reader.latitude},${this.location?.lng ?? reader.longitude}`;
        //const mapURL = `https://www.google.com/maps?layer=c&cbll=${reader.latitude},${reader.longitude}&cbp=12,0,0,0,0`;
        // TODO: later: show hb aura, username, etc
        const content = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<div
            class="max-w-[300] text-black dark:text-white pb-3">
            <aside
                class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                ${$72bce429f9a506ac$var$strings.map27[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <span class="text-teal-300">
                    ${(0, $b348546b86779519$export$1f66d962712fe46f)(rank, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </span>
            </aside>
            <p class="font-bold text-2xl">
                <span
                    class="hidden w-3 h-3 me-1 ${this.getStatus(reader.lastActive?.toDate() || new Date())} rounded-full"></span>
                ${name}
            </p>
            <br />
            <div class="inline-flex rounded-md shadow-xs" role="group">
                <button
                    title="${$72bce429f9a506ac$var$strings.map6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                    onclick="heartbank.alertAdmin('map/profile/click/333');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                    type="button"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="gold"
                        viewBox="0 0 576 512">
                        <path
                            d="M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                    </svg>
                </button>
                <button
                    title="${$72bce429f9a506ac$var$strings.map5[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                    onclick="vault('login')"
                    type="button"
                    class="${this.heartbank.user ? "hidden" : "rounded-e-lg"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-r border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="orange"
                        viewBox="0 0 512 512">
                        <path
                            d="M345 273c9.4-9.4 9.4-24.6 0-33.9L201 95c-6.9-6.9-17.2-8.9-26.2-5.2S160 102.3 160 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L345 273zm7 143c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0z" />
                    </svg>
                </button>
                <button
                    title="${$72bce429f9a506ac$var$strings.feedback5[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                    onclick="vault('logout')"
                    type="button"
                    class="${this.heartbank.user ? "" : "hidden"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-r border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="red"
                        viewBox="0 0 512 512">
                        <path
                            d="M505 273c9.4-9.4 9.4-24.6 0-33.9L361 95c-6.9-6.9-17.2-8.9-26.2-5.2S320 102.3 320 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L505 273zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z" />
                    </svg>
                </button>
                <button
                    title="${$72bce429f9a506ac$var$strings.map22[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                    onclick="vault('humanity')"
                    type="button"
                    class="${this.heartbank.user ? "" : "hidden"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="teal"
                        viewBox="0 0 512 512">
                        <path
                            d="M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z" />
                    </svg>
                </button>
                <button
                    title="${$72bce429f9a506ac$var$strings.map23[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                    onclick="vault('passkeys')"
                    type="button"
                    class="${this.heartbank.user ? "" : "hidden"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="green"
                        viewBox="0 0 512 512">
                        <path
                            d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                    </svg>
                </button>
            </div>
            <br />
            <br />
            <p class="text-base">
                ${$72bce429f9a506ac$var$strings.map8[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <strong class="font-black text-orange-400">
                    ${(0, $b348546b86779519$export$eab19c48dcb6310d)(100, 1000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </strong>
                ${$72bce429f9a506ac$var$strings.map8b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
            <p class="text-base">
                ${$72bce429f9a506ac$var$strings.map14[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <strong class="font-black text-orange-400">
                    ${(0, $b348546b86779519$export$1f66d962712fe46f)(reader.pages || 0, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </strong>
                ${$72bce429f9a506ac$var$strings.map14b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
            <p class="text-base">
                ${$72bce429f9a506ac$var$strings.map18[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <strong class="font-black text-orange-400">
                    ${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </strong>
                ${$72bce429f9a506ac$var$strings.map18b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
            <br />
            <br />
            <img
                onclick="heartbank.alertAdmin('map/profile/click/avatar');
                alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                src="${user.photoURL || (0, (/*@__PURE__*/$parcel$interopDefault($48b654dc7c8a49e3$exports)))}"
                alt="${name}"
                class="w-3/4 object-cover rounded-full" />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/profile/click/reward');prompt('${$72bce429f9a506ac$var$strings.map28b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}','${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                <svg
                    class="inline-flex w-7 h-7 me-1 text-green-600 dark:text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M328 112l-144 0-37.3-74.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L342.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6L328 112zM169.6 160l172.8 0 48.7 40.6C457.6 256 496 338 496 424.5 496 472.8 456.8 512 408.5 512l-305.1 0C55.2 512 16 472.8 16 424.5 16 338 54.4 256 120.9 200.6L169.6 160zM260 224c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L216 384c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z" />
                </svg>
                <span
                    class="font-black text-sm text-green-600 dark:text-green-500">
                    ${$72bce429f9a506ac$var$strings.map28[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/profile/click/sponsor');prompt('${$72bce429f9a506ac$var$strings.map32b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}','${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                <svg
                    class="inline-flex w-7 h-7 me-1 text-pink-500 dark:text-pink-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M288-16c-13.3 0-24 10.7-24 24l0 12-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2L240 180c-15.5 0-28 12.5-28 28s12.5 28 28 28l24 0 0 12c0 13.3 10.7 24 24 24s24-10.7 24-24l0-12 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2L328 76c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0 0-12c0-13.3-10.7-24-24-24zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z" />
                </svg>
                <span
                    class="font-black text-sm text-pink-600 dark:text-pink-500">
                    ${$72bce429f9a506ac$var$strings.map32[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/profile/click/thank');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                <svg
                    class="inline-flex w-7 h-7 me-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="orangered">
                    <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        transform="rotate(45 12 12)" />
                </svg>
                <span class="font-black text-sm text-[orangered]">
                    ${$72bce429f9a506ac$var$strings.map31[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </span>
            </button>
            <br />
            <br />
            <br />
            <a
                title="${$72bce429f9a506ac$var$strings.map45[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                href="${mapURL}"
                target="_blank"
                onclick="heartbank.alertAdmin('map/click/user/${name}: ${mapURL}')">
                <p class="font-bold text-sm">
                    ${reader.lastActive?.toDate().formatDate()}
                </p>
                <br />
                <p class="block text-sm underline text-blue-600">
                    ${reader.address}
                </p>
                <br />
                <p class="italic text-xs">${reader.user}</p>
            </a>
            <!--<button
                onclick="window.addTemple(${this.location?.lat ?? reader.latitude}, ${this.location?.lng ?? reader.longitude}, '${reader.address}')"
                class="${this.isAdminTemples() ? "" : "hidden"} text-2xl mt-5 text-green-500">
                ☸️ ${$72bce429f9a506ac$var$strings.map53[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </button>-->
        </div>`;
        if (this.marker) {
            this.marker.position = this.location;
            this.marker.title = `${name} | ${reader.address}`;
            this.infoWindow.setContent(content);
        } else {
            const pin = new google.maps.marker.PinElement({
                background: "#8B008B",
                borderColor: "#4B0082",
                glyph: "\u2764",
                glyphColor: "white",
                scale: this.userSize
            });
            this.marker = new google.maps.marker.AdvancedMarkerElement({
                position: this.location,
                map: this.map,
                content: pin.element,
                title: `${name} | ${reader.address}`
            });
            this.marker.addListener("gmp-click", ()=>{
                this.zoom();
                //this.bounds.extend(marker.position);
                this.isInfoWindowOpen = true;
                this.infoWindow.setContent(content);
                this.infoWindow.open(this.map, this.marker);
                this.readers.isRealTime = false;
                this.heartbank.alertAdmin(`map/click/user/${name}: `, reader.address);
            });
        }
        if (extendBounds) this.bounds.extend(this.location);
    }
    async addReader(reader, scale) {
        const user = await this.readers.getUser(reader.uid);
        // Create info window
        // https://developers.google.com/maps/documentation/javascript/infowindows
        // const infoWindow = new google.maps.InfoWindow({
        //     content: `<div class="min-w-[200]"><p class="font-bold text-lg">${
        //         strings.map7[LANGUAGE]
        //     } ${reader}</p><p class="text-base">${getRandomNumber(50, 100)} ${
        //         strings.map14[LANGUAGE]
        //     }</p></div>`
        // });
        // const infoWindow = new google.maps.InfoWindow({
        //     content: `<div class="min-w-[200]">
        //         <p class="font-bold text-lg underline">
        //             ${
        //                 user.displayName ||
        //                 strings.map7[LANGUAGE] + " #" + reader.rank
        //             }
        //         </p>
        //         <br>
        //         <p class="text-base">
        //             <strong class="font-black">
        //                 ${reader.pages}
        //             </strong> ${strings.map14[LANGUAGE]}
        //         </p>
        //         <br>
        //         <p class="font-bold text-sm">
        //             ${reader.lastActive?.toDate().formatDate()}
        //         </p>
        //         <br>
        //         <p class="text-sm">
        //             ${reader.address}
        //         </p>
        //         <br>
        //         <p class="italic text-xs">
        //             ${reader.user}
        //         </p>
        //     </div>`
        // });
        const name = user.displayName || $72bce429f9a506ac$var$strings.map7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        //const mapURL = `https://www.google.com/maps/search/?api=1&query=${reader.latitude},${reader.longitude}`; //(${encodeURIComponent(reader.user)})
        const mapURL = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${reader.latitude},${reader.longitude}`;
        // TODO: later: show hb aura, username, etc
        const content = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<div
            class="max-w-[300] text-black dark:text-white pb-3">
            <aside
                class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                ${$72bce429f9a506ac$var$strings.map27[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <span class="text-teal-300">
                    ${(0, $b348546b86779519$export$1f66d962712fe46f)(reader.rank || 0, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </span>
            </aside>
            <p class="font-bold text-2xl">
                <span
                    class="inline-flex w-3 h-3 me-1 ${this.getStatus(reader.lastActive?.toDate() || new Date())} rounded-full"></span>
                ${name}
            </p>
            <br />
            <p class="text-base">
                ${$72bce429f9a506ac$var$strings.map8[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <strong class="font-black text-orange-400">
                    ${(0, $b348546b86779519$export$eab19c48dcb6310d)(100, 1000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </strong>
                ${$72bce429f9a506ac$var$strings.map8b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
            <p class="text-base">
                ${$72bce429f9a506ac$var$strings.map14[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <strong class="font-black text-orange-400">
                    ${(0, $b348546b86779519$export$1f66d962712fe46f)(reader.pages || 0, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </strong>
                ${$72bce429f9a506ac$var$strings.map14b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
            <p class="text-base">
                ${$72bce429f9a506ac$var$strings.map18[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                <strong class="font-black text-orange-400">
                    ${(0, $b348546b86779519$export$eab19c48dcb6310d)(50, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                </strong>
                ${$72bce429f9a506ac$var$strings.map18b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
            <br />
            <br />
            <img
                onclick="heartbank.alertAdmin('map/reader/click/avatar');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                src="${user.photoURL || this.getRandomAvatarUrl()}"
                alt="${name}"
                class="w-3/4 object-cover rounded-full" />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/reader/click/reward');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                <svg
                    class="inline-flex w-7 h-7 me-2 text-green-600 dark:text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M328 112l-144 0-37.3-74.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L342.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6L328 112zM169.6 160l172.8 0 48.7 40.6C457.6 256 496 338 496 424.5 496 472.8 456.8 512 408.5 512l-305.1 0C55.2 512 16 472.8 16 424.5 16 338 54.4 256 120.9 200.6L169.6 160zM260 224c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L216 384c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z" />
                </svg>
                <span
                    class="font-black text-lg text-green-600 dark:text-green-500">
                    ${$72bce429f9a506ac$var$strings.map29[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/reader/click/sponsor');prompt('${$72bce429f9a506ac$var$strings.map33b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}','${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                <svg
                    class="inline-flex w-7 h-7 me-2 text-pink-500 dark:text-pink-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M288-16c-13.3 0-24 10.7-24 24l0 12-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2L240 180c-15.5 0-28 12.5-28 28s12.5 28 28 28l24 0 0 12c0 13.3 10.7 24 24 24s24-10.7 24-24l0-12 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2L328 76c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0 0-12c0-13.3-10.7-24-24-24zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z" />
                </svg>
                <span
                    class="font-black text-lg text-pink-600 dark:text-pink-500">
                    ${$72bce429f9a506ac$var$strings.map33[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/reader/click/thank');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')">
                <svg
                    class="inline-flex w-7 h-7 me-2"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="orangered">
                    <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        transform="rotate(45 12 12)" />
                </svg>
                <span class="font-black text-lg text-[orangered]">
                    ${$72bce429f9a506ac$var$strings.map26[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                </span>
            </button>
            <br />
            <br />
            <br />
            <a
                title="${$72bce429f9a506ac$var$strings.map45[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                href="${mapURL}"
                target="_blank"
                onclick="heartbank.alertAdmin('map/click/reader/${name}: ${mapURL}')">
                <p class="font-bold text-sm">
                    ${reader.lastActive?.toDate().formatDate()}
                </p>
                <br />
                <p class="text-sm underline text-blue-600">${reader.address}</p>
            </a>
            <br />
            ${reader.user === "HeartBank\xae" && this.isAdminReaders() ? (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<button
                      onclick="window.removeReader('${reader.id}')"
                      class="text-2xl mt-5 text-red-600">
                      🗑️ ${$72bce429f9a506ac$var$strings.map35[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                  </button>` : (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<p class="italic text-xs">${reader.user}</p>`}
        </div>`; // bug: remove button is also shown in fullscreen bc need reload
        const pin = new google.maps.marker.PinElement({
            // background: '#FFA500', // Hex code for orange
            background: reader.id ? "dodgerblue" : "dodgerblue",
            borderColor: "blue",
            glyph: "\u263B",
            glyphColor: "white",
            scale: scale // Adjust size (1.0 is default)
        });
        const position = {
            lat: reader.latitude,
            lng: reader.longitude
        };
        // Create Advanced Marker
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: position,
            map: null,
            content: pin.element,
            title: `${name} | ${reader.address}` //strings.map7[LANGUAGE] + " " + reader
        });
        // Add click listener to marker
        marker.addListener("gmp-click", ()=>{
            this.zoom();
            //this.bounds.extend(marker.position);
            this.isInfoWindowOpen = true;
            this.infoWindow.setContent(content);
            this.infoWindow.open(this.map, marker);
            //infoWindow!.open(this.map, marker);
            //this.animateToMarker(position);
            // const markerBounds = new google.maps.LatLngBounds();
            // // Create bounds around the marker (0.1 degrees ~ 11km)
            // markerBounds.extend({
            //     lat: position.lat - 1.5,
            //     lng: position.lng - 1.5
            // });
            // markerBounds.extend({
            //     lat: position.lat + 1.5,
            //     lng: position.lng + 1.5
            // });
            // this.map!.fitBounds(markerBounds); // Smoothly pans and zooms
            this.readers.isRealTime = false;
            this.heartbank.alertAdmin(`map/click/reader/${name}: `, reader.address);
        });
        this.readerMarkers.push(marker);
    }
    getStatus(date) {
        const now = Date.now();
        const diffMs = now - date.getTime();
        const oneHour = 3600000;
        const oneDay = 24 * oneHour;
        const oneWeek = 7 * oneDay;
        const oneMonth = 4 * oneWeek;
        if (diffMs <= oneDay) return "bg-green-500";
        else if (diffMs <= oneWeek) return "bg-yellow-300";
        else if (diffMs <= oneMonth) return "bg-orange-300";
        else return "bg-red-600";
    }
    getRandomAvatarUrl() {
        return `https://raw.githubusercontent.com/SiliconWat/avatar.siliconwat.dev/main/id/AV${(0, $b348546b86779519$export$f7b4d751913301f6)(1, 120)}.png`;
    }
    // deprecated bc too slow bc of service worker cache; also pro no cdn
    getRandomAvatarUrl2() {
        const base = "https://avatar.iran.liara.run/public";
        const cacheBuster = `?t=${Math.random().toString(36).slice(2)}`;
        return `${base}${cacheBuster}`;
    }
    getPhoto(base) {
        const cacheBuster = `&t=${Math.random().toString(36).slice(2)}`;
        return `${base}${cacheBuster}`;
    }
    // temples
    async findAndDisplayTemples(reload = false) {
        if (!this.map || !google.maps.places) return;
        // --- Start of Changes ---
        const center = this.map.getCenter();
        const bounds = this.map.getBounds();
        // Guard against calling the API with an undefined center or bounds
        if (!center || !bounds) {
            console.warn("Map center or bounds not available yet. Skipping temple search.");
            return;
        }
        // --- End of Changes ---
        //console.log(center.lat(), center.lng());
        // +++ ADD CACHING LOGIC +++
        // Create a unique key for the current map view
        //const cacheKey = bounds.toUrlValue(6); // 6 decimal places of precision
        // --- START OF NEW GRID CACHING LOGIC ---
        // 1. Define the size of our grid cell in degrees. (1 miles)
        const gridSizeDegrees = 0.0144 * this.templeMiles; // 10 miles
        // 2. "Snap" the map's center coordinates to our grid.
        const gridLat = Math.round(center.lat() / gridSizeDegrees) * gridSizeDegrees;
        const gridLng = Math.round(center.lng() / gridSizeDegrees) * gridSizeDegrees;
        // 3. Create a stable cache key based on the grid cell, not the exact bounds.
        // We round to a few decimal places to avoid floating point inaccuracies.
        const cacheKey = `grid_${gridLat.toFixed(4)}_${gridLng.toFixed(4)}`;
        if (this.templeCache.has(cacheKey)) {
            console.log("Using cached temple data...");
            if (reload) await this.renderTemples2(this.templeCache.get(cacheKey));
            return; // Exit the function, no API call needed
        }
        // +++ END CACHING LOGIC +++
        // need to be after cache
        if (await this.quotas.isFree("places2")) await this.queryPlaces2(cacheKey, center, bounds);
        else if (await this.quotas.isFree("places1")) await this.queryPlaces1(cacheKey, bounds);
        else await this.renderTemples2();
    }
    /**
     * Searches for Buddhist temples using the new Places API and displays them as markers.
     */ async queryPlaces2(cacheKey, center, bounds) {
        // CORRECTED: Use searchText for text queries.
        const request = {
            fields: [
                "id",
                "displayName",
                "location",
                "formattedAddress" // Basic Data
            ],
            textQuery: $72bce429f9a506ac$var$strings.map15[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            // Use locationBias to prefer results in the current map view
            locationBias: {
                center: this.getNormalizedCenter(center),
                radius: this.calculateMapRadius(bounds)
            },
            maxResultCount: this.maxTemples,
            language: $72bce429f9a506ac$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
        };
        try {
            // CORRECTED: Call the searchText method instead of searchNearby
            const { places: places } = await google.maps.places.Place.searchByText(request);
            const places2 = places.map((place)=>({
                    id: place.id,
                    displayName: place.displayName ?? "",
                    formattedAddress: place.formattedAddress ?? "",
                    lat: place.location?.lat() ?? 0,
                    lng: place.location?.lng() ?? 0
                }));
            // +++ STORE RESULTS IN CACHE +++
            this.templeCache.set(cacheKey, places2);
            if (places2.length) this.renderTemples2(places2);
            else console.log("No temples found in the current map view.");
        } catch (error) {
            console.error("Places v2 search failed: ", error);
        }
    }
    /**
     * Searches for Buddhist temples within the current map view and displays them as markers.
     * This method can be triggered by a UI button or an event listener.
     */ async queryPlaces1(cacheKey, bounds) {
        const service = new google.maps.places.PlacesService(this.map);
        const request = {
            bounds: bounds,
            keyword: $72bce429f9a506ac$var$strings.map15[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
        };
        try {
            service.nearbySearch(request, (results, status)=>{
                if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                    // Convert old Places API results to our new custom Place style objects
                    const places = results.map((place)=>({
                            id: place.place_id ?? "",
                            displayName: place.name ?? "",
                            formattedAddress: place.formatted_address ?? place.plus_code?.compound_code ?? "",
                            lat: place.geometry?.location?.lat() ?? 0,
                            lng: place.geometry?.location?.lng() ?? 0
                        }));
                    //console.log(results);
                    this.templeCache.set(cacheKey, places);
                    this.renderTemples2(places);
                } else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) console.log("No temples found in the current map view.");
                else console.error("Places search failed with status: ", status);
            });
        } catch (error) {
            console.error("Places v1 search failed: ", error);
        }
    }
    async renderTemples() {
        // Clear previous temple markers to avoid duplicates
        this.hideTempleMarkers();
        this.templeMarkers = [];
        if (this.showTemples) {
            if (this.isAdminTemples()) this.findAndDisplayTemples(true);
            else {
                const temples = await this.temples.get("active");
                temples.forEach((temple)=>this.addTemple(temple));
                this.renderTotalTemples(temples.length);
            }
        }
    }
    // for admin
    async renderTemples2(places = []) {
        // Clear previous temple markers to avoid duplicates
        this.hideTempleMarkers();
        this.templeMarkers = [];
        //places.forEach((place) => this.addTemple(place));
        for (const place of places)if (!await this.temples.exists(place.id)) this.temples.add(place.id, place.displayName, place.lat, place.lng, place.formattedAddress);
        const temples = await this.temples.get();
        temples.forEach((temple)=>this.addTemple(temple));
    }
    /**
     * Creates a single marker on the map for a given place.
     * @param place The Google Place object for the temple.
     */ addTemple(temple, reload = false) {
        if (!this.map) return;
        // const infoWindow = new google.maps.InfoWindow({
        //     content: `<div>
        //         <p class="font-bold text-lg">
        //             ${place.displayName}
        //         </p>
        //         ${photoHtml}
        //         <br>
        //         <p class="text-sm">
        //             ${place.formattedAddress}
        //         </p>
        //     </div>`
        // });
        // const mapURL =
        //     deviceType === "Mobile"
        //         ? `https://www.google.com/maps/search/?api=1&query_place_id=${
        //               place.id
        //           }&query=${place.location.lat()},${place.location.lng()}(${encodeURIComponent(
        //               place.displayName!
        //           )})`
        //         : `https://www.google.com/maps/place/?q=place_id:${place.id}`;
        // const mapURL = `https://www.google.com/maps/search/?api=1&query_place_id=${
        //     place.id
        // }&query=${place.location.lat()},${place.location.lng()}`;
        const photo = reload && temple.photo ? this.getPhoto(temple.photo) : temple.photo || (0, (/*@__PURE__*/$parcel$interopDefault($46353713039eb022$exports)));
        const mapURL = temple.link || `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${temple.latitude},${temple.longitude}`;
        const content = this.isAdminTemples() ? (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<div class="max-w-[300] text-black dark:text-white pb-3">
                  <button
                      title="${$72bce429f9a506ac$var$strings.map48b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                      onclick="window.editTempleLink('${temple.id}', '${mapURL}')"
                      class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                      ${$72bce429f9a506ac$var$strings.map27[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                      <span class="text-teal-300">
                          ${(0, $b348546b86779519$export$eab19c48dcb6310d)(1, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                      </span>
                      <span>✏️</span>
                  </button>
                  <button
                      title="${$72bce429f9a506ac$var$strings.map46b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                      class="font-bold text-2xl"
                      onclick="window.editTempleName('${temple.id}', '${temple.name}')">
                      ${temple.name}
                      <span>✏️</span>
                  </button>
                  <br />
                  <br />
                  <div class="inline-flex rounded-md shadow-xs" role="group">
                      <button
                          title="${$72bce429f9a506ac$var$strings.map6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/333');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="gold"
                              viewBox="0 0 576 512">
                              <path
                                  d="M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                          </svg>
                      </button>
                      <button
                          title="${$72bce429f9a506ac$var$strings.map24[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/checkin');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-r border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="blueviolet"
                              viewBox="0 0 512 512">
                              <path
                                  d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 160l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5l-11.1-99.5-1.8 0c-17.7 0-32-14.3-32-32l0-48c0-35.3 28.7-64 64-64zM412.4 400.2c-16.1-4.2-34.8-7.6-55.4-10.2l5.3-47.7c22.7 2.9 43.7 6.7 62.1 11.5 22.4 5.8 42.6 13.3 57.8 23.3 14.7 9.6 29.8 24.9 29.8 47s-15.1 37.4-29.8 47c-15.2 9.9-35.5 17.5-57.8 23.3-45.1 11.7-105.3 17.8-168.4 17.8s-123.3-6.1-168.4-17.8C65.2 488.4 45 480.9 29.8 471 15.1 461.4 0 446.1 0 424s15.1-37.4 29.8-47c15.2-9.9 35.5-17.5 57.8-23.3 18.5-4.8 39.5-8.6 62.1-11.5L155 390c-20.6 2.6-39.3 6.1-55.4 10.2-56.6 14.6-56.6 32.9 0 47.5 39.9 10.3 95.8 16.2 156.4 16.2s116.5-5.9 156.4-16.2c56.6-14.6 56.6-32.9 0-47.5z" />
                          </svg>
                      </button>
                      <button
                          title="${$72bce429f9a506ac$var$strings.map25[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/study');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orange"
                              viewBox="0 0 576 512">
                              <path
                                  d="M302.3-12.6c-9-4.5-19.6-4.5-28.6 0l-256 128C1.9 123.3-4.5 142.5 3.4 158.3s27.1 22.2 42.9 14.3L288 51.8 529.7 172.6c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-256-128zM288 272a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-53 0-96 43-96 96l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-53-43-96-96-96zM160 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm352 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 336c-44.2 0-80 35.8-80 80l0 33.1c0 17 13.8 30.9 30.9 30.9l87.8 0c-4.3-9.8-6.7-20.6-6.7-32l0-48c0-18.4 3.5-36 9.8-52.2-12.2-7.5-26.5-11.8-41.8-11.8zM425.4 480l87.8 0c17 0 30.9-13.8 30.9-30.9l0-33.1c0-44.2-35.8-80-80-80-15.3 0-29.6 4.3-41.8 11.8 6.3 16.2 9.8 33.8 9.8 52.2l0 48c0 11.4-2.4 22.2-6.7 32z" />
                          </svg>
                      </button>
                      <button
                          title="${$72bce429f9a506ac$var$strings.map26[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/thank');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-6 h-6 me-1 mt-1"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orangered"
                              viewBox="0 0 24 24">
                              <path
                                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                  transform="rotate(45 12 12)" />
                          </svg>
                      </button>
                  </div>
                  <br />
                  <br />
                  <button
                      title="${$72bce429f9a506ac$var$strings.map45[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                      class="text-base"
                      onclick="window.open('${mapURL}', '_blank');heartbank.alertAdmin('map/click/temple/${temple.name}: ${mapURL}')">
                      ${$72bce429f9a506ac$var$strings.map21[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                      <strong class="font-black text-orange-400">
                          ${(0, $b348546b86779519$export$eab19c48dcb6310d)(1000, 10000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                      </strong>
                      <span>🗺️</span>
                  </button>
                  <br />
                  <br />
                  <button
                      title="${$72bce429f9a506ac$var$strings.map48b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                      onclick="this.style.opacity=0.1;window.editTemplePhoto('${temple.id}')">
                      <img
                          src="${photo}"
                          alt="${temple.name}"
                          class="${(0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? "" : "pr-5"} w-full object-cover rounded-lg" />
                      <br />
                  </button>
                  <br />
                  <button
                      title="${$72bce429f9a506ac$var$strings.map47b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                      class="underline text-sm text-blue-600"
                      onclick="window.editTempleAddress('${temple.id}', '${temple.address}')">
                      ${temple.address || "Unknown Address"}
                      <span>✏️</span>
                  </button>
                  <br />
                  <button
                      onclick="${temple.status === "active" ? `window.unpublishTemple('${temple.id}')` : `window.publishTemple('${temple.id}')`}"
                      class="text-2xl mt-5 text-green-500">
                      ${temple.status === "active" ? "\uD83C\uDF10" : "\uD83C\uDF10"}
                      ${temple.status === "active" ? $72bce429f9a506ac$var$strings.map50b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] : $72bce429f9a506ac$var$strings.map49b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                  </button>
                  <button
                      onclick="window.removeTemple('${temple.id}', '${temple.pid}')"
                      class="text-2xl mt-5 text-red-600">
                      🗑️ ${$72bce429f9a506ac$var$strings.map51b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                  </button>
              </div>` : (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<div class="max-w-[300] text-black dark:text-white pb-3">
                  <aside
                      class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                      ${$72bce429f9a506ac$var$strings.map27[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                      <span class="text-teal-300">
                          ${(0, $b348546b86779519$export$eab19c48dcb6310d)(1, 100, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                      </span>
                  </aside>
                  <p class="font-bold text-2xl">${temple.name}</p>
                  <br />
                  <div class="inline-flex rounded-md shadow-xs" role="group">
                      <button
                          title="${$72bce429f9a506ac$var$strings.map6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/333');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="gold"
                              viewBox="0 0 576 512">
                              <path
                                  d="M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                          </svg>
                      </button>
                      <button
                          title="${$72bce429f9a506ac$var$strings.map24[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/checkin');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-r border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="blueviolet"
                              viewBox="0 0 512 512">
                              <path
                                  d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 160l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5l-11.1-99.5-1.8 0c-17.7 0-32-14.3-32-32l0-48c0-35.3 28.7-64 64-64zM412.4 400.2c-16.1-4.2-34.8-7.6-55.4-10.2l5.3-47.7c22.7 2.9 43.7 6.7 62.1 11.5 22.4 5.8 42.6 13.3 57.8 23.3 14.7 9.6 29.8 24.9 29.8 47s-15.1 37.4-29.8 47c-15.2 9.9-35.5 17.5-57.8 23.3-45.1 11.7-105.3 17.8-168.4 17.8s-123.3-6.1-168.4-17.8C65.2 488.4 45 480.9 29.8 471 15.1 461.4 0 446.1 0 424s15.1-37.4 29.8-47c15.2-9.9 35.5-17.5 57.8-23.3 18.5-4.8 39.5-8.6 62.1-11.5L155 390c-20.6 2.6-39.3 6.1-55.4 10.2-56.6 14.6-56.6 32.9 0 47.5 39.9 10.3 95.8 16.2 156.4 16.2s116.5-5.9 156.4-16.2c56.6-14.6 56.6-32.9 0-47.5z" />
                          </svg>
                      </button>
                      <button
                          title="${$72bce429f9a506ac$var$strings.map25[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/study');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orange"
                              viewBox="0 0 576 512">
                              <path
                                  d="M302.3-12.6c-9-4.5-19.6-4.5-28.6 0l-256 128C1.9 123.3-4.5 142.5 3.4 158.3s27.1 22.2 42.9 14.3L288 51.8 529.7 172.6c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-256-128zM288 272a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-53 0-96 43-96 96l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-53-43-96-96-96zM160 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm352 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 336c-44.2 0-80 35.8-80 80l0 33.1c0 17 13.8 30.9 30.9 30.9l87.8 0c-4.3-9.8-6.7-20.6-6.7-32l0-48c0-18.4 3.5-36 9.8-52.2-12.2-7.5-26.5-11.8-41.8-11.8zM425.4 480l87.8 0c17 0 30.9-13.8 30.9-30.9l0-33.1c0-44.2-35.8-80-80-80-15.3 0-29.6 4.3-41.8 11.8 6.3 16.2 9.8 33.8 9.8 52.2l0 48c0 11.4-2.4 22.2-6.7 32z" />
                          </svg>
                      </button>
                      <button
                          title="${$72bce429f9a506ac$var$strings.map26[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          onclick="heartbank.alertAdmin('map/temple/click/thank');alert('${$72bce429f9a506ac$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-6 h-6 me-1 mt-1"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orangered"
                              viewBox="0 0 24 24">
                              <path
                                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                  transform="rotate(45 12 12)" />
                          </svg>
                      </button>
                  </div>
                  <br />
                  <br />
                  <p class="text-base">
                      ${$72bce429f9a506ac$var$strings.map21[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                      <strong class="font-black text-orange-400">
                          ${(0, $b348546b86779519$export$eab19c48dcb6310d)(1000, 10000, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}
                      </strong>
                  </p>
                  <br />
                  <a
                      title="${$72bce429f9a506ac$var$strings.map45[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                      href="${mapURL}"
                      target="_blank"
                      onclick="heartbank.alertAdmin('map/click/temple/${temple.name}: ${mapURL}')">
                      <img
                          src="${photo}"
                          alt="${temple.name}"
                          class="${(0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? "" : "pr-5"} w-full object-cover rounded-lg" />
                      <br />
                      <p
                          title="${$72bce429f9a506ac$var$strings.map45[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                          class="underline text-sm text-blue-600">
                          ${temple.address || "Unknown Address"}
                      </p>
                  </a>
              </div>`;
        if (reload) this.infoWindow.setContent(content);
        else {
            const pin = new google.maps.marker.PinElement({
                background: temple.status === "init" ? "orange" : temple.status === "active" ? "orangered" : "silver",
                borderColor: "red",
                glyph: "\u2638",
                glyphColor: "white",
                scale: this.templeSize
            });
            const position = {
                lat: temple.latitude,
                lng: temple.longitude
            };
            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                position: position,
                content: pin.element,
                title: `${temple.name} | ${temple.address}`
            });
            marker.addListener("gmp-click", async ()=>{
                this.zoom();
                //this.bounds.extend(marker.position);
                this.readers.isRealTime = false;
                this.isInfoWindowOpen = true;
                this.infoWindow.setContent(content);
                this.infoWindow.open(this.map, marker);
                //infoWindow.open(this.map, marker);
                this.heartbank.alertAdmin(`map/click/temple/${temple.name}: `, temple.address);
            });
            this.templeMarkers.push(marker);
        }
    }
    showTempleMarkers() {
        this.templeMarkers.forEach((marker)=>marker.map = this.map);
    }
    hideTempleMarkers() {
        this.templeMarkers.forEach((marker)=>marker.map = null);
    }
    /**
     * Returns a normalized center point of the given Google Map.
     * Ensures latitude ∈ [-90, 90] and longitude ∈ [-180, 180].
     */ getNormalizedCenter(center) {
        //if (!center) throw new Error("Map center is undefined");
        const rawLat = center.lat();
        const rawLng = center.lng();
        // Clamp latitude to [-90, 90]
        const lat = Math.max(-90, Math.min(90, rawLat));
        // Wrap longitude to [-180, 180]
        const lng = ((rawLng + 180) % 360 + 360) % 360 - 180;
        return {
            lat: lat,
            lng: lng
        };
    }
    /**
     * Calculates the radius of the current map view in meters, capped at the API's maximum.
     * @param bounds The current LatLngBounds of the map.
     * @returns The radius in meters, never exceeding 50000.
     */ calculateMapRadius(bounds) {
        // const center = bounds.getCenter();
        // const northEast = bounds.getNorthEast();
        // const distance = google.maps.geometry.spherical.computeDistanceBetween(
        //     center,
        //     northEast
        // );
        // return Math.min(distance, 50000); // Cap the radius to the API's maximum
        return 50000; // about 30 miles
    }
    // deprecated: old places api
    /**
     * Creates a single marker on the map for a given place.
     * @param place - The Google PlaceResult object for the temple.
     */ addTemple2(place) {
        if (!place.geometry?.location || !this.map) return;
        const pin = new google.maps.marker.PinElement({
            background: "orangered",
            borderColor: "#A0522D",
            glyph: "\u2638",
            glyphColor: "white",
            scale: 1.5
        });
        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: place.geometry.location,
            content: pin.element,
            title: place.name
        });
        const infoWindow = new google.maps.InfoWindow({
            content: `<div class="font-bold text-lg">${place.name}</div><p class="text-sm">${place.vicinity}</p>`
        });
        marker.addListener("gmp-click", ()=>{
            this.bounds.extend(marker.position);
            this.isInfoWindowOpen = true;
            infoWindow.open(this.map, marker);
        });
        this.templeMarkers.push(marker);
    }
    // helpers
    zoom() {
        //this.map!.panTo(position);
        const level = this.map.getZoom();
        if (level > 4 && level < 8) this.map.setZoom(8); // does not animate // smaller zoom level = more zoomed out
    }
    extendBounds(reader) {
        const position = {
            lat: reader.latitude,
            lng: reader.longitude
        };
        const isInCambodia = position.lat < this.cambodiaBounds.maxLat && position.lat > this.cambodiaBounds.minLat && position.lng < this.cambodiaBounds.maxLng && position.lng > this.cambodiaBounds.minLng;
        //TODO: later when have more readers
        // if (LANGUAGE === "khmer") {
        //     if (isInCambodia) this.bounds.extend(position);
        // } else this.bounds.extend(position);
        this.bounds.extend(position);
    }
    panToUser() {
        this.bounds.extend(this.location);
        this.map.panTo(this.location);
        if (this.map.getZoom() < 8) this.map.setZoom(12);
        google.maps.event.trigger(this.marker, "gmp-click");
    }
    panToHome() {
        this.map.panTo((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? this.phnomPenh : this.USA);
        this.map.setZoom((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? 6.5 : 3.0);
    }
    // not used
    animateToMarker(position) {
        // Smooth pan to the marker position
        //this.map!.panTo(position);
        // Animate zoom to target level (12)
        const targetZoom = 12;
        const currentZoom = this.map.getZoom();
        const steps = 20; // Number of animation steps
        const zoomStep = (targetZoom - currentZoom) / steps;
        let step = 0;
        const animateZoom = ()=>{
            if (step < steps) {
                const newZoom = currentZoom + zoomStep * step;
                this.map.setZoom(newZoom);
                step++;
                requestAnimationFrame(animateZoom);
            } else this.map.setZoom(targetZoom); // Ensure final zoom is exact
        };
        animateZoom(); // Start zoom animation
    }
    showMarkers() {
        if (this.showTemples) this.showTempleMarkers();
        if (this.showMonks) this.monkMarkers.forEach((marker)=>marker.map = this.map);
        if (this.showHomes) this.homeMarkers.forEach((marker)=>marker.map = this.map);
        if (this.showReaders) this.readerMarkers.forEach((marker)=>marker.map = this.map);
        this.watchCurrentPosition();
    }
    hideMarkers() {
        // this.hideTempleMarkers();
        // this.monkMarkers.forEach((marker) => (marker.map = null));
        // this.homeMarkers.forEach((marker) => (marker.map = null));
        // this.readerMarkers.forEach((marker) => (marker.map = null));
        if (this.watchId) navigator.geolocation.clearWatch(this.watchId);
    }
    //// geolocation
    // initial location is IP then accurate
    async getLocation() {
        if (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) {
            if (!this.loader) await this.initMap();
            await this.getCurrentLocation();
            if (!this.location) return null;
            const location = await this.geocode(this.location);
            if (location) localStorage.setItem("location", JSON.stringify(location));
            return location;
        } else return null;
    }
    // debounce not needed; just cache is enough
    async geocode(coordinate) {
        const gridSizeDegrees = 0.0144 * this.addressMiles; // 5 miles
        const gridLat = Math.round(coordinate.lat / gridSizeDegrees) * gridSizeDegrees;
        const gridLng = Math.round(coordinate.lng / gridSizeDegrees) * gridSizeDegrees;
        const cacheKey = `grid_${gridLat.toFixed(4)}_${gridLng.toFixed(4)}`;
        if (this.addressCache.has(cacheKey)) {
            const cachedLocation = this.addressCache.get(cacheKey);
            cachedLocation.lat = coordinate.lat;
            cachedLocation.lng = coordinate.lng;
            console.log("Using cached location address...", cachedLocation);
            return cachedLocation;
        }
        if (!await this.quotas.isFree("geocoding")) {
            // dummy location
            const location = {
                place_id: "0",
                formatted_address: "USA",
                lat: coordinate.lat,
                lng: coordinate.lng
            };
            return (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? null : location;
        }
        try {
            const geocoder = new google.maps.Geocoder();
            const request = {
                location: coordinate,
                language: $72bce429f9a506ac$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
            };
            const response = await geocoder.geocode(request);
            if (response.results && response.results.length > 0) {
                // Use the first, most specific result
                const result = response.results[0];
                //console.log(result);
                const location = {
                    place_id: result.place_id,
                    formatted_address: result.formatted_address,
                    lat: coordinate.lat,
                    lng: coordinate.lng //result.geometry.location.lng()
                };
                this.addressCache.set(cacheKey, location);
                return location;
            } else {
                console.warn("Geocoding failed: No results found for the location.", coordinate);
                return null;
            }
        } catch (error) {
            console.error("Geocoding API call failed:", error);
            return null;
        }
    }
    // not used
    async searchLocation2() {
        // 1. Check if location data is available
        if (!this.location) {
            console.error("Current location is not available to geocode.");
            return null;
        }
        // 2. Ensure Google Maps API and the Geocoder are loaded
        if (typeof google === "undefined" || !google.maps?.Geocoder) {
            console.error("Google Maps API or Geocoder not loaded.");
            return null;
        }
        const geocoder = new google.maps.Geocoder();
        const request = {
            location: this.location,
            language: $72bce429f9a506ac$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
        };
        try {
            const response = await geocoder.geocode(request);
            if (response.results && response.results.length > 0) {
                // Use the first, most specific result
                const result = response.results[0];
                let city = null;
                let country = null;
                //console.log(result);
                // Iterate through the address components to find the city and country
                for (const component of result.address_components){
                    if (component.types.includes("locality")) city = component.long_name;
                    if (component.types.includes("country")) country = component.long_name;
                }
                // If city is still not found, check other administrative levels as a fallback
                if (!city) {
                    const adminArea = result.address_components.find((c)=>c.types.includes("administrative_area_level_1"));
                    if (adminArea) city = adminArea.long_name;
                }
                if (city && country) return {
                    city: city,
                    country: country
                };
                else {
                    console.warn("Could not find city or country in geocoding response.", result);
                    return null;
                }
            } else {
                console.warn("Geocoding failed: No results found for the location.", this.location);
                return null;
            }
        } catch (error) {
            console.error("Geocoding API call failed:", error);
            return null;
        }
    }
    async getCurrentLocation() {
        if ("geolocation" in navigator) {
            const geolocation = await navigator.permissions.query({
                name: "geolocation"
            });
            this.handleGeolocation(geolocation);
            geolocation.onchange = ()=>this.handleGeolocation(geolocation); // does not work on ios
        } else {
            this.hideMarkers();
            if (window.location.hash === "#readership") alert($72bce429f9a506ac$var$strings.map3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        }
    }
    // chrome
    handleGeolocation(geolocation) {
        switch(geolocation.state){
            case "prompt":
                if (localStorage.getItem("isGranted") === "true" || this.isPrompted) this.getCurrentPosition();
                else {
                    this.isPrompted = true;
                    this.isGranted = navigator.onLine ? confirm($72bce429f9a506ac$var$strings.map1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]) : false;
                    if (this.isGranted) this.getCurrentPosition();
                // else if (window.location.hash === "#readership")
                //     window.location.hash = "#";
                }
                break;
            case "granted":
                if (localStorage.getItem("isGranted") !== "true" && window.location.hash !== "#readership") window.location.hash = "#readership";
                localStorage.setItem("isGranted", "true");
                this.showMarkers();
                break;
            case "denied":
                localStorage.setItem("isGranted", "false");
                this.hideMarkers();
                break;
            default:
                localStorage.setItem("isGranted", "false");
                this.hideMarkers();
        }
    }
    // safari
    handleGeolocation2(isGranted) {
        if (0, $eba1d7d434ec7c0e$export$95df08bae54cb4df) {
            if (isGranted) {
                if (localStorage.getItem("isGranted") !== "true" && window.location.hash !== "#readership") window.location.hash = "#readership";
                localStorage.setItem("isGranted", "true");
                this.showMarkers();
            } else {
                localStorage.setItem("isGranted", "false");
                this.hideMarkers();
                if (this.isGranted && !this.isPrompted2) {
                    this.isPrompted2 = true;
                    if (navigator.onLine) alert($72bce429f9a506ac$var$strings.map2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
                }
            }
        }
    }
    getCurrentPosition() {
        navigator.geolocation.getCurrentPosition((position)=>{
            this.location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            //this.map!.setCenter(this.location);
            //this.map!.setZoom(12);
            this.handleGeolocation2(true);
        }, (error)=>{
            this.handleGeolocation2(false);
        // if (error.code === error.PERMISSION_DENIED) {
        // } else {
        //     console.error("Geolocation error: ", error.message);
        // }
        });
    }
    watchCurrentPosition() {
        if (!this.watchId) this.watchId = navigator.geolocation.watchPosition((position)=>{
            //const { latitude, longitude } = position.coords;
            this.location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        }, (error)=>{
            this.handleGeolocation2(false);
        // if (error.code === error.PERMISSION_DENIED) {
        // } else {
        //     console.error("Error watching position: ", error.message);
        // }
        }, {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: Infinity // optional: no timeout
        });
    }
    // not used
    debounce(fn, delay) {
        let timer;
        return (...args)=>{
            return new Promise((resolve)=>{
                if (timer) clearTimeout(timer);
                timer = setTimeout(()=>{
                    const result = fn(...args);
                    resolve(result);
                }, delay);
            });
        };
    }
    // deprecated
    async renderReaders2() {
        // Cambodia
        for(let i = 0; i < this.size; i++){
            const randomLat = Math.random() * (this.cambodiaBounds2.maxLat - this.cambodiaBounds2.minLat) + this.cambodiaBounds2.minLat;
            const randomLng = Math.random() * (this.cambodiaBounds2.maxLng - this.cambodiaBounds2.minLng) + this.cambodiaBounds2.minLng;
            const position = {
                lat: randomLat,
                lng: randomLng
            };
            const reader = {
                id: "",
                uid: "",
                user: "HeartBank\xae",
                address: $72bce429f9a506ac$var$strings.map17[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
                pages: (0, $b348546b86779519$export$f7b4d751913301f6)(100, 2000),
                rank: i + 1
            };
            // Extend bounds to include this marker's position
            if ((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer") this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }
        // USA
        for(let i = 0; i < this.size; i++){
            const randomLat = Math.random() * (this.californiaBounds2.maxLat - this.californiaBounds2.minLat) + this.californiaBounds2.minLat;
            const randomLng = Math.random() * (this.californiaBounds2.maxLng - this.californiaBounds2.minLng) + this.californiaBounds2.minLng;
            const position = {
                lat: randomLat,
                lng: randomLng
            };
            const reader = {
                id: "",
                uid: "",
                user: "HeartBank\xae",
                address: $72bce429f9a506ac$var$strings.map17b[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
                pages: (0, $b348546b86779519$export$f7b4d751913301f6)(100, 1000),
                rank: i + 1
            };
            // Extend bounds to include this marker's position
            //if (window.innerWidth > 768) this.bounds.extend(position); // mobile device: You can adjust the breakpoint as needed
            if ((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "english") this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }
        // France
        for(let i = 0; i < this.size; i++){
            const randomLat = Math.random() * (this.franceBounds.maxLat - this.franceBounds.minLat) + this.franceBounds.minLat;
            const randomLng = Math.random() * (this.franceBounds.maxLng - this.franceBounds.minLng) + this.franceBounds.minLng;
            const position = {
                lat: randomLat,
                lng: randomLng
            };
            const reader = {
                id: "",
                uid: "",
                user: "HeartBank\xae",
                address: $72bce429f9a506ac$var$strings.map17c[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
                pages: (0, $b348546b86779519$export$f7b4d751913301f6)(100, 1000),
                rank: i + 1
            };
            // Extend bounds to include this marker's position
            //if (window.innerWidth > 768) this.bounds.extend(position); // mobile device: You can adjust the breakpoint as needed
            //this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }
        // Australia
        for(let i = 0; i < this.size; i++){
            const randomLat = Math.random() * (this.australiaBounds.maxLat - this.australiaBounds.minLat) + this.australiaBounds.minLat;
            const randomLng = Math.random() * (this.australiaBounds.maxLng - this.australiaBounds.minLng) + this.australiaBounds.minLng;
            const position = {
                lat: randomLat,
                lng: randomLng
            };
            const reader = {
                id: "",
                uid: "",
                user: "HeartBank\xae",
                address: $72bce429f9a506ac$var$strings.map17d[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: (0, $70fd6868680e912c$export$d9bcbd5e1ff81430).now(),
                pages: (0, $b348546b86779519$export$f7b4d751913301f6)(100, 1000),
                rank: i + 1
            };
            // Extend bounds to include this marker's position
            //if (window.innerWidth > 768) this.bounds.extend(position); // mobile device: You can adjust the breakpoint as needed
            //this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }
    }
}










var $c1f48898d47dafe3$exports = {};
$c1f48898d47dafe3$exports = new URL("buddha.dd1e8c85.mp4", import.meta.url).toString();



const $5ff75edc385e6000$var$template = document.createElement("template");
$5ff75edc385e6000$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <header>
        <h1
            class="moul py-5 text-center text-lg font-extrabold leading-none tracking-tight text-gray-900 md:text-3xl lg:text-4xl dark:text-white">
            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).hero[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
        </h1>
        <h2
            class="moul pb-2 text-center text-base font-bold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-3xl dark:text-white">
            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).subtitle[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
        </h2>
    </header>
    <main>
        <div class="relative cursor-pointer">
            <video
                onclick="heartbank.alertAdmin('home/click/buddha')"
                class="px-7 pt-1"
                src="${0, (/*@__PURE__*/$parcel$interopDefault($c1f48898d47dafe3$exports))}"
                poster="${0, (/*@__PURE__*/$parcel$interopDefault($98dc7beabfe94433$exports))}"
                playsinline
                loop
                autoplay
                muted>
                <!--<img class="p-7 mt-[-20px]" src="${0, (/*@__PURE__*/$parcel$interopDefault($98dc7beabfe94433$exports))}" />-->
            </video>
            <p
                class="absolute text-center text-sm text-yellow-100 moul bottom-1 left-1/2 transform -translate-x-1/2">
                ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).movie[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
        </div>
        <p
            class="hidden text-center px-5 text-sm md:text-base text-gray-500 dark:text-gray-400">
            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).qrcode[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
        </p>
        <a href="#share">
            <p
                id="scroll-to-here"
                class="text-center px-5 pt-5 text-sm md:text-base text-gray-500 dark:text-gray-400">
                ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).gift[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]} ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).copy[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
        </a>
        <picture
            onclick="heartbank.alertAdmin('home/click/qr-code')"
            class="relative cursor-pointer ml-[-10%] mb-[-19%] mt-[3%] inline-block w-full">
            <svg
                class="block fill-hb"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24">
                <path
                    d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                    transform="rotate(45 12 12)" />
            </svg>
            <img
                id="qr_code"
                alt="qr code"
                class="absolute w-[43%] ml-[-3%] mt-[3%] top-1/2 left-1/2 -rotate-90x transform -translate-x-1/2 -translate-y-1/2" />
        </picture>
        <p
            class="text-center px-5 pt-0 pb-0 text-sm md:text-base text-gray-500 dark:text-gray-400">
            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).scan[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
        </p>
        <!--<img id="qr_code" class="block md:hidden" />
        <img id="buddha_image src="${0, (/*@__PURE__*/$parcel$interopDefault($c1f48898d47dafe3$exports))}" class="hidden md:block p-5" />-->
    </main>
    <footer id="sw-home-footer">
        <section
            class="m-5 block w-fit p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            ${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<h5
                          class="mb-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          ព្រះត្រៃបិដក ដែលជាគម្ពីរសំខាន់នៃព្រះពុទ្ធសាសនា
                          មានបីផ្នែកគឺ ព្រះវិន័យ ព្រះសុត្តន្ត និង ព្រះអភិធម្ម
                          ដែលនីមួយៗមានគោលបំណងផ្សេងគ្នា ដូចខាងក្រោម៖
                      </h5>
                      <ol
                          class="text-base font-normal text-gray-700 dark:text-gray-400">
                          <li>
                              <h6>១. ព្រះវិន័យ</h6>
                              <p>
                                  គោលបំណង: ផ្តល់ច្បាប់ និងវិន័យសម្រាប់សង្ឃ
                                  និងសាមណេរ ដើម្បីគ្រប់គ្រងជីវិតសាសនា
                                  និងរក្សាសណ្តាប់ធ្នាប់ក្នុងសង្ឃសហគមន៍។
                              </p>
                              <p>
                                  ខ្លឹមសារ: ការកំណត់សីល វិន័យ
                                  និងក្រមសីលធម៌សម្រាប់ភិក្ខុ ភិក្ខុនី
                                  និងការដោះស្រាយទំនាស់ក្នុងសហគមន៍។
                                  វាជួយឱ្យសង្ឃរស់នៅប្រកបដោយសន្តិភាព
                                  និងផ្តោតលើការអនុវត្តធម៌។
                              </p>
                          </li>
                          <li>
                              <h6>២. ព្រះសុត្តន្ត</h6>
                              <p>
                                  គោលបំណង: បង្រៀនធម៌ និងការអនុវត្តផ្លូវអរិយមគ្គ
                                  ដើម្បីឈានទៅដល់ការត្រាស់ដឹង ឬនិព្វាន។
                              </p>
                              <p>
                                  ខ្លឹមសារ:
                                  ផ្ទុកនូវព្រះធម្មទេសនារបស់ព្រះសម្មាសម្ពុទ្ធ
                                  ដែលផ្តល់ការណែនាំអំពីសីល សមាធិ និងបញ្ញា
                                  ព្រមទាំងរឿងរ៉ាវជាតក និងការបង្រៀនសម្រាប់គ្រហស្ថ
                                  និងបព្វជិត។
                              </p>
                          </li>
                          <li>
                              <h6>៣. ព្រះអភិធម្ម</h6>
                              <p>
                                  គោលបំណង: វិភាគ និងពន្យល់យ៉ាងស៊ីជម្រៅអំពីធម៌
                                  ទាក់ទងនឹងចិត្ត ចេតសិក និងសភាពនៃអត្ថិភាព
                                  ដើម្បីជួយអ្នកសិក្សាយល់ច្បាស់អំពីសច្ចធម៌។
                              </p>
                              <p>
                                  ខ្លឹមសារ: ផ្តោតលើទស្សនវិជ្ជា
                                  និងចិត្តវិទ្យាពុទ្ធសាសនា ដោយបែងចែកចិត្ត
                                  សភាពធម៌ និងការពន្យល់អំពីបុគ្គលិកលក្ខណៈ
                                  និងកម្ម។
                              </p>
                              <p>
                                  សង្ខេប: ព្រះវិន័យ ផ្តោតលើសីល
                                  និងការគ្រប់គ្រងសង្ឃ។ ព្រះសុត្តន្ត
                                  បង្រៀនផ្លូវអនុវត្តធម៌ជាក់ស្តែង។ ព្រះអភិធម្ម
                                  ពន្យល់អំពីធម៌ជាទស្សនវិជ្ជា
                                  និងវិទ្យាសាស្ត្រនៃចិត្ត។
                              </p>
                              <!--<p class="indent-5">
                                  ព្រះវិន័យ ផ្តោតលើសីល និងការគ្រប់គ្រងសង្ឃ។
                              </p>
                              <p class="indent-5">
                                  ព្រះសុត្តន្ត បង្រៀនផ្លូវអនុវត្តធម៌ជាក់ស្តែង។
                              </p>
                              <p class="indent-5">
                                  ព្រះអភិធម្ម ពន្យល់អំពីធម៌ជាទស្សនវិជ្ជា
                                  និងវិទ្យាសាស្ត្រនៃចិត្ត។
                              </p>-->
                          </li>
                      </ol>
                      <h5
                          class="mt-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          ទាំងបីផ្នែកនេះបំពេញគ្នាទៅវិញទៅមក
                          ដើម្បីណែនាំមនុស្សឆ្ពោះទៅរកការរំដោះចេញពីទុក្ខ។
                      </h5> ` : (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`<h5
                          class="mb-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          The <strong>Pali-Khmer Tipiṭaka</strong>, translated
                          by the
                          <strong>Buddhist Institute of Cambodia</strong>, is
                          the Khmer-language version of the
                          <em>Theravāda Buddhist Canon</em>, composed of three
                          main collections:
                      </h5>
                      <ol
                          class="text-base font-normal text-gray-700 dark:text-gray-400">
                          <li>
                              <h6>1. Vinaya Piṭaka (Discipline Basket)</h6>
                              <p>
                                  Contains rules for monks and nuns, ethical
                                  conduct, and procedures to maintain harmony in
                                  the monastic community.
                              </p>
                              <p class="hidden">
                                  <strong>Key texts:</strong> Pārājika,
                                  Pācittiya, Mahāvagga, Cullavagga.
                              </p>
                          </li>
                          <li>
                              <h6>2. Suttanta Piṭaka (Discourse Basket)</h6>
                              <p>
                                  A large collection of the Buddha's teachings
                                  and stories, intended for both monks and lay
                                  followers.
                              </p>
                              <p class="hidden">
                                  <strong>Main sections:</strong> Dīgha Nikāya,
                                  Majjhima Nikāya, Saṃyutta Nikāya, Aṅguttara
                                  Nikāya, Khuddaka Nikāya (including Dhammapada,
                                  Jātaka tales).
                              </p>
                          </li>
                          <li>
                              <h6>
                                  3. Abhidhamma Piṭaka (Higher Teaching Basket)
                              </h6>
                              <p>
                                  A detailed scholastic analysis of the mind,
                                  matter, and mental phenomena, emphasizing
                                  systematic interpretation of reality.
                              </p>
                          </li>
                      </ol>
                      <h5
                          class="mt-5 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
                          The Khmer translation was initiated in the 1920s by
                          Cambodian monks and scholars. The project produced
                          <strong>110 volumes</strong>, preserving authenticity
                          while using accessible, elegant Khmer for Cambodian
                          readers.
                      </h5>`}
        </section>
        <blockquote
            class="hidden p-4 my-4 border-s-4 border-gray-300 bg-gray-50 dark:border-gray-500 dark:bg-gray-800">
            <p
                id="buddha-quote"
                class="text-xl italic font-medium leading-relaxed text-gray-900 dark:text-white">
                ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).buddha[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </p>
        </blockquote>
        <p
            class="text-lg arial text-center font-light leading-relaxed text-gray-900 dark:text-white">
            bedok.siliconwat.org
        </p>
    </footer>
`;
var $5ff75edc385e6000$export$2e2bcd8739ae039 = $5ff75edc385e6000$var$template;


var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== 'undefined';
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $d22956012916b666$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $d22956012916b666$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = '[0-9]+';
const $d479c387334094fb$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, '\\u');
const $d479c387334094fb$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $d479c387334094fb$var$kanji + ')(?:.|[\r\n]))+';
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, 'g');
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, 'g');
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, 'g');
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, 'g');
const $d479c387334094fb$var$TEST_KANJI = new RegExp('^' + $d479c387334094fb$var$kanji + '$');
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp('^' + $d479c387334094fb$var$numeric + '$');
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case 'alphanumeric':
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case 'kanji':
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case 'byte':
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};

function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd('M', col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $3112213e4acbe245$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});




var $35ab0cb5a2d404f0$exports = {};
$35ab0cb5a2d404f0$exports = new URL("poster.afa248fd.png", import.meta.url).toString();


var $39440ea75c54b933$exports = {};
$39440ea75c54b933$exports = new URL("front.755d97ef.png", import.meta.url).toString();


var $52b7dbe93f0ea310$exports = {};
$52b7dbe93f0ea310$exports = new URL("back.b693badc.png", import.meta.url).toString();


var $763957524203e0b9$exports = {};
$763957524203e0b9$exports = new URL("heartbank.542aebb2.png", import.meta.url).toString();


const $c06dc2a2e0117a65$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $c06dc2a2e0117a65$export$4e7696eb07d1630e extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.movie = document.querySelector("sw-movie"), this.poster = null, this.front = null, this.back = null, this.qr = null, this.link = "https://bedok.siliconwat.org";
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-home");
        this.componentTrace.start();
        this.appendChild((0, $5ff75edc385e6000$export$2e2bcd8739ae039).content.cloneNode(true));
        this.buddha = this.querySelector("video");
        this.code = this.querySelector("#qr_code");
    }
    connectedCallback() {
        // this.link =
        //     HB_VAULT +
        //     `/carnelian/1?lang=${strings.language[LANGUAGE]}&origin=${
        //         this.heartbank.isRunningAsPWA() ? "pwa" : "web"
        //     }&o=1&a=0`;
        this.share();
        this.getFiles(); // cache files early
        this.buddha.parentElement.addEventListener("click", (event)=>{
            // if (this.buddha.paused) this.buddha.play();
            // else this.buddha.pause();
            this.movie.show();
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "buddha");
        });
        setInterval(()=>{
            if (this.buddha.paused) this.buddha.play();
        }, 60000); // 1 minute
        const b = this.code.parentElement;
        b.addEventListener("click", async (event)=>{
            await navigator.clipboard.writeText(this.link);
            this.dispatchEvent(new CustomEvent("sw-banner", {
                bubbles: true,
                detail: {
                    info: $c06dc2a2e0117a65$var$strings.copied[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
                }
            }));
            try {
                const text = `${$c06dc2a2e0117a65$var$strings.gift[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}\n\n${$c06dc2a2e0117a65$var$strings.hero2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}\n`;
                await this.getFiles();
                await navigator.share({
                    title: $c06dc2a2e0117a65$var$strings.title2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                    text: text,
                    url: "https://bedok.siliconwat.org",
                    files: (0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? [
                        this.poster,
                        this.front,
                        this.back,
                        this.qr
                    ] : [] // for andoid, show file but won't show text or url
                });
            } catch  {
            // ignore errors
            }
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "copy", {
                link: this.link
            });
        });
        // this.querySelectorAll("img").forEach((element: HTMLImageElement) => {
        //     element.addEventListener("click", async (event: Event) => {
        //         const link = "https://bedok.siliconwat.org";
        //         await navigator.clipboard.writeText(link);
        //         this.dispatchEvent(
        //             new CustomEvent<{ info: string }>("sw-banner", {
        //                 bubbles: true,
        //                 detail: {
        //                     info: strings.copied[LANGUAGE]
        //                 }
        //             })
        //         );
        //         logEvent(analytics, "copy", { link });
        //     });
        // });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    show() {
        this.classList.remove("hidden");
    }
    hide() {
        this.classList.add("hidden");
    }
    play() {
        if (this.buddha.paused) this.buddha.play();
    }
    pause() {
        if (!this.buddha.paused) this.buddha.pause();
    }
    share() {
        (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toDataURL(this.link, {
            width: 1000,
            errorCorrectionLevel: "L",
            type: "image/png",
            margin: 0,
            color: {
                dark: "#fff",
                light: "#0000"
            }
        }, (error, url)=>{
            if (error) console.error("Error generating QR Code:", error);
            else this.code.src = url;
        });
    }
    async getFiles() {
        if (!this.poster) {
            const response = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($35ab0cb5a2d404f0$exports))), {
                mode: "cors"
            });
            const poster = await response.blob();
            this.poster = new File([
                poster
            ], "Bedok.AI.poster.png", {
                type: "image/png"
            });
        }
        if (!this.front) {
            const response = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($39440ea75c54b933$exports))), {
                mode: "cors"
            });
            const front = await response.blob();
            this.front = new File([
                front
            ], "Bedok.AI.frontcard.png", {
                type: "image/png"
            });
        }
        if (!this.back) {
            const response = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($52b7dbe93f0ea310$exports))), {
                mode: "cors"
            });
            const back = await response.blob();
            this.back = new File([
                back
            ], "Bedok.AI.backcard.png", {
                type: "image/png"
            });
        }
        if (!this.qr) {
            const response = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($763957524203e0b9$exports))), {
                mode: "cors"
            });
            const qr = await response.blob();
            this.qr = new File([
                qr
            ], "Bedok.AI.qrcode.png", {
                type: "image/png"
            });
        }
    }
}









var $cebfe6726e901212$exports = {};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    'use strict';
    var VENDOR_PREFIXES = [
        '',
        'webkit',
        'Moz',
        'MS',
        'ms',
        'o'
    ];
    var TEST_ELEMENT = document1.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
        return function() {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== 'function') assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = 'ontouchstart' in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        'x',
        'y'
    ];
    var PROPS_CLIENT_XY = [
        'clientX',
        'clientY'
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId');
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), 'identifier', true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(' '));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            'auto',
            'manipulation',
            'pan-y',
            'pan-x',
            'pan-x pan-y',
            'none'
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return 'cancel';
        else if (state & STATE_ENDED) return 'end';
        else if (state & STATE_CHANGED) return 'move';
        else if (state & STATE_BEGAN) return 'start';
        return '';
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return 'down';
        else if (direction == DIRECTION_UP) return 'up';
        else if (direction == DIRECTION_LEFT) return 'left';
        else if (direction == DIRECTION_RIGHT) return 'right';
        return '';
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'pinch',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + 'up', input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: 'rotate',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = '2.0.7';
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    'rotate'
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    'swipe'
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: 'doubletap',
                    taps: 2
                },
                [
                    'tap'
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: 'none',
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: 'none',
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: 'none',
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: 'none',
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: 'none',
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: 'rgba(0,0,0,0)'
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, 'add', this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, 'remove', this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || '';
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent('Event');
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== 'undefined' ? window1 : typeof self !== 'undefined' ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === 'function' && define.amd) define(function() {
        return Hammer;
    });
    else if (0, $cebfe6726e901212$exports) $cebfe6726e901212$exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, 'Hammer');






const $83e76416e487fab2$var$template = document.createElement("template");
$83e76416e487fab2$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <header class="battambang">
        <label
            for="page-number"
            class="hidden mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >Choose quantity:</label
        >
        <div id="sw-pager" class="relative mt-0 flex items-center max-w-44">
            <button
                id="sw-page-search"
                onclick="heartbank.alertAdmin('page/click/search')"
                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map55[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                class="absolute top-0 right-1/2 -translate-x-28 flex items-center justify-center opacity-90 text-white bg-blue-500 rounded-full w-10 h-10 hover:bg-blue-500 dark:bg-blue-500 dark:hover:bg-blue-500 focus:ring-4 focus:ring-blue-500 focus:outline-none dark:focus:ring-blue-500">
                <svg
                    class="w-5 h-5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill="currentColor">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                </svg>
            </button>
            <button
                type="button"
                id="decrement-button"
                onclick="heartbank.alertAdmin('page/click/previous-page')"
                data-input-counter-decrement="page-number"
                class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                <svg
                    class="text-gray-900 dark:text-white"
                    aria-hidden="true"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    height="14"
                    width="12.25"
                    viewBox="0 0 448 512">
                    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                    <path
                        d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                </svg>
            </button>
            <input
                inputmode="numeric"
                id="page-number"
                onblur="heartbank.alertAdmin('page/type/', this.value)"
                type="text"
                data-input-counter2
                data-input-counter-min2="0"
                data-input-counter-max2=""
                aria-describedby="helper-text-explanation"
                class="bg-gray-50 border-x-0 border-gray-300 h-11 font-medium text-center text-gray-900 text-lg outline-none focus:ring-0 focus:border-none focus:ring-blue-500 focus:border-blue-500 block w-full pb-6 dark:bg-gray-700 dark:border-gray-600 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).page[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                value="0" />
            <div
                id="page-total"
                class="absolute bottom-1 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 flex items-center text-xs text-gray-400 space-x-1 rtl:space-x-reverse">
                1 ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).total[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
            </div>
            <button
                type="button"
                id="increment-button"
                onclick="heartbank.alertAdmin('page/click/next-page')"
                data-input-counter-increment="page-number"
                class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                <svg
                    class="text-gray-900 dark:text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    fill="currentColor"
                    height="14"
                    width="12.25"
                    viewBox="0 0 448 512">
                    <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                    <path
                        d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                </svg>
            </button>
            <button
                id="sw-page-share"
                onclick="heartbank.alertAdmin('page/click/share')"
                title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).map58[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                class="absolute top-0 left-1/2 translate-x-28 flex items-center justify-center opacity-90 text-white bg-green-500 rounded-full w-10 h-10 hover:bg-green-500 dark:bg-green-500 dark:hover:bg-green-500 focus:ring-4 focus:ring-5reen-600 focus:outline-none dark:focus:ring-green-500">
                <svg
                    class="w-5 h-5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill="currentColor">
                    <path
                        d="M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z" />
                </svg>
            </button>
        </div>
    </header>
    <main>
        <img
            id="sw-bedok-front"
            alt="Bedok"
            class="hidden cursor-pointer m-0 p-0 object-contain w-full h-full transition-opacity duration-500 opacity-0" />
        <img
            id="sw-bedok-back"
            alt="Bedok"
            class="hidden cursor-pointer m-0 p-0 object-contain w-full h-full transition-opacity duration-500 opacity-0" />
    </main>
    <footer>
        <a
            href="https://youtube.com/@SiliconWat"
            target="_blank"
            class="hidden text-center p-4 text-sm text-gray-500 dark:text-gray-400">
            ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).story[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
        </a>
        <div
            id="spinner"
            role="status"
            class="hidden absolute z-[1000] -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
            <svg
                aria-hidden="true"
                class="w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
            <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).loading[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
        </div>
    </footer>
`;
var $83e76416e487fab2$export$2e2bcd8739ae039 = $83e76416e487fab2$var$template;







const $b03e5dce378954b0$var$LANGUAGE2 = "khmer";
const $b03e5dce378954b0$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
const $b03e5dce378954b0$var$bedok = (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)));
class $b03e5dce378954b0$export$6443b622435b2ace extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.books = new (0, $643ca2f9ceb5ab8e$export$5654cbf08d7911f3)(), this.transcriptions = new (0, $d0e8a14726007347$export$22bbd736cbae49dc)() // manager
        , this.hammer = new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports)))(this, {
            touchAction: "pinch-zoom"
        }), this.timer = 0, this.header = document.querySelector("sw-header"), this.main = document.querySelector("sw-main"), this.footer = document.querySelector("sw-footer"), this.pali = document.querySelector("sw-reader[lang=pali]"), this.khmer = document.querySelector("sw-reader[lang=khmer]"), this.shareComponent = document.querySelector("sw-share"), this.maxPage = 0;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-page");
        this.componentTrace.start();
        this.appendChild((0, $83e76416e487fab2$export$2e2bcd8739ae039).content.cloneNode(true));
        this.spinner = this.querySelector("#spinner");
        this.front = this.querySelector("#sw-bedok-front");
        this.back = this.querySelector("#sw-bedok-back");
        this.search = this.querySelector("#sw-page-search");
        this.share = this.querySelector("#sw-page-share");
        this.pageHeader = this.querySelector("header");
        this.pager = this.querySelector("#sw-pager");
        this.page = this.querySelector("#page-number");
        this.total = this.querySelector("#page-total");
        this.increment = this.querySelector("#increment-button");
        this.decrement = this.querySelector("#decrement-button");
    }
    show() {
        this.classList.remove("hidden");
    }
    hide() {
        this.classList.add("hidden");
    }
    renderFullScreen() {
        const paths = window.location.hash.split("/");
        if (paths[1] === "book") {
            if (localStorage.getItem("bars") === "false") {
                this.header.hide();
                //this.footer.hide(); // race condition
                this.footer.classList.add("hidden");
                this.classList.remove("py-[72px]");
            } else {
                this.header.show();
                //this.footer.show(); // race condition
                this.footer.classList.remove("hidden");
                this.classList.add("py-[72px]");
            }
            if (localStorage.getItem("pager") === "false") this.pageHeader.classList.add("hidden");
            else this.pageHeader.classList.remove("hidden");
            this.toggleButtons();
            this.togglePage();
        }
    }
    togglePage() {
        if (localStorage.getItem("bars") === "false" && localStorage.getItem("pager") === "false") {
            this.front.classList.remove("object-contain");
            this.front.classList.replace("w-full", "w-auto");
            this.front.classList.replace("h-full", "h-screen");
            this.back.classList.remove("object-contain");
            this.back.classList.replace("w-full", "w-auto");
            this.back.classList.replace("h-full", "h-screen");
        } else {
            this.front.classList.add("object-contain");
            this.front.classList.replace("w-auto", "w-full");
            this.front.classList.replace("h-screen", "h-full");
            this.back.classList.add("object-contain");
            this.back.classList.replace("w-auto", "w-full");
            this.back.classList.replace("h-screen", "h-full");
        }
    }
    connectedCallback() {
        this.renderFullScreen();
        this.hammer.on("tap", async (event)=>{
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            //TODO: add page flip animation
            switch(event.target.id){
                case "sw-bedok-front":
                    if (page !== this.getTotal(book) || this.hasLastTwoPages(book)) {
                        this.front.classList.add("hidden");
                        this.back.classList.remove("hidden", "opacity-0");
                        this.books.update(book, "khmer");
                    }
                    this.heartbank.alertAdmin("page/flip/to-back");
                    break;
                case "sw-bedok-back":
                    this.front.classList.remove("hidden", "opacity-0");
                    this.back.classList.add("hidden");
                    this.books.update(book, "pali");
                    this.heartbank.alertAdmin("page/flip/to-front");
                    break;
            }
        });
        // mobile = 2-finger zooming and panning; desktop = long press or double click
        this.hammer.get("press").set({
            time: 500,
            threshold: 9,
            pointers: 1
        });
        this.hammer.on("press", this.openPage.bind(this));
        this.hammer.on("doubletap", this.openPage2.bind(this)); // deprecated
        this.hammer.get("swipe").set({
            direction: (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).DIRECTION_ALL
        });
        this.hammer.on("swipeleft", ()=>this.pageTo(true));
        this.hammer.on("swiperight", ()=>this.pageTo(false));
        this.hammer.on("swipeup", this.toggleBars.bind(this));
        this.hammer.on("swipedown", this.togglePager.bind(this));
        this.page.addEventListener("keyup", this.userInput2.bind(this)); // keydown = character not yet detected // keypress is deprecated
        this.page.addEventListener("change", this.processInput.bind(this));
        // TODO: later fix: for mobile pinch zooming: 2-finger panning okay, but 1 finger does not work
        // window.addEventListener("resize", () => {
        //     this.hammer.set({
        //         touchAction:
        //             window.visualViewport?.scale !== 1 ? "auto" : "pinch-zoom"
        //     });
        //     if (window.visualViewport?.scale !== 1) {
        //         this.classList.remove("touch-zoom");
        //     } else {
        //         this.classList.add("touch-zoom");
        //     }
        // });
        // deprecated
        // for desktop wheel zooming
        // window.addEventListener("wheel", (event) => {
        //     if (event.ctrlKey) {
        //         if (this.isZoomed()) {
        //             this.hammer.set({ touchAction: "auto" });
        //             this.classList.remove(
        //                 "overflow-x-hidden",
        //                 "overflow-y-hidden"
        //             );
        //             this.header.classList.add("hidden");
        //             this.footer.classList.add("hidden");
        //             this.pager.classList.add("hidden");
        //             this.front.classList.remove("h-full");
        //             this.back.classList.remove("h-full");
        //             this.front.classList.add("h-auto");
        //             this.back.classList.add("h-auto");
        //             this.classList.remove(
        //                 "w-screen",
        //                 "h-[80vh]",
        //                 "md:h-[90vh]",
        //                 "lg:h-[85vh]"
        //             );
        //             this.classList.add("w-auto", "h-auto");
        //         } else {
        //             this.hammer.set({ touchAction: "pinch-zoom" });
        //             this.classList.add(
        //                 "overflow-x-hidden",
        //                 "overflow-y-hidden"
        //             );
        //             this.header.classList.remove("hidden");
        //             this.footer.classList.remove("hidden");
        //             this.pager.classList.remove("hidden");
        //             this.front.classList.add("h-full");
        //             this.back.classList.add("h-full");
        //             this.front.classList.remove("h-auto");
        //             this.back.classList.remove("h-auto");
        //             this.classList.add(
        //                 "w-screen",
        //                 "h-[80vh]",
        //                 "md:h-[90vh]",
        //                 "lg:h-[85vh]"
        //             );
        //             this.classList.remove("w-auto", "h-auto");
        //         }
        //     }
        // });
        // deprecated: weird BUG when light mode is on
        this.increment.addEventListener("click", (event)=>this.pageTo(true));
        this.decrement.addEventListener("click", (event)=>this.pageTo(false));
        this.search.addEventListener("click", ()=>{
            alert($b03e5dce378954b0$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        });
        //TODO: v2 put pali or khmer in url
        this.share.addEventListener("click", async ()=>{
            this.share.disabled = true;
            this.share.classList.add("opacity-50");
            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            const basket = this.books.getBasket(book);
            const language = this.front.classList.contains("hidden") ? "khmer" : "pali";
            const transcript = await this.transcriptions.getTranscription(book, page, language);
            let files = [];
            if (this.heartbank.isSuperAdmin()) {
                const url = this.getPage(book, page, language);
                const response = await fetch(url, {
                    mode: "cors"
                });
                const blob = await response.blob();
                const file = new File([
                    blob
                ], `bedok-ai-${book}-${page}-${language}.silicon.wat.jpeg`, {
                    type: "image/jpeg"
                });
                files = [
                    file
                ];
            }
            const title = `${$b03e5dce378954b0$var$strings.baskets3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][basket]}: ${book.toKhmer((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}`;
            const text = transcript?.transcript ? `${$b03e5dce378954b0$var$strings.page[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}: ${transcript.transcript}` : `${$b03e5dce378954b0$var$strings.cover[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}`;
            const link = `${(0, $eba1d7d434ec7c0e$export$3e78737c19d741c0)}/book/${book}/page/${page}?language=${(0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa)}&version=${language}`; //window.location.href
            this.shareComponent.show(title, text, link, files);
            this.share.disabled = false;
            this.share.classList.remove("opacity-50");
        });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    async openPage() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const language = await this.books.get(book);
        const src = language === "khmer" ? this.back.src : this.front.src;
        if (0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) window.open(src, "_blank");
        else window.location.href = src;
        this.heartbank.alertAdmin("page/long-press/open-page");
    }
    async openPage2() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const language = await this.books.get(book);
        const src = language === "khmer" ? this.front.src : this.back.src;
        window.open(src, "_blank");
        this.heartbank.alertAdmin("page/double-tap/open-page");
    }
    toggleButtons() {
    // if (
    //     localStorage.getItem("bars") === "true" &&
    //     localStorage.getItem("pager") === "true"
    // ) {
    //     this.search.classList.remove("hidden");
    //     this.share.classList.remove("hidden");
    // } else {
    //     this.search.classList.add("hidden");
    //     this.share.classList.add("hidden");
    // }
    }
    toggleBars() {
        if (localStorage.getItem("bars") === "false") {
            this.header.show();
            this.footer.show();
            this.classList.add("py-[72px]");
            localStorage.setItem("bars", "true");
            this.heartbank.alertAdmin("page/swipe-up/show-bars");
        } else {
            this.header.hide();
            this.footer.hide();
            this.classList.remove("py-[72px]");
            localStorage.setItem("bars", "false");
            this.heartbank.alertAdmin("page/swipe-up/hide-bars");
        }
        this.toggleButtons();
        this.togglePage();
    }
    togglePager() {
        if (localStorage.getItem("pager") === "false") {
            this.pageHeader.classList.remove("hidden");
            localStorage.setItem("pager", "true");
            this.heartbank.alertAdmin("page/swipe-down/show-pager");
        } else {
            this.pageHeader.classList.add("hidden");
            localStorage.setItem("pager", "false");
            this.heartbank.alertAdmin("page/swipe-down/hide-pager");
        }
        this.toggleButtons();
        this.togglePage();
    }
    // for desktop
    // private isZoomed(): boolean {
    //     return (
    //         Math.round((window.innerWidth / window.outerWidth) * 100) !== 100
    //     );
    // }
    // type = tel // weird redirect bug !!!
    userInput(event) {
        window.clearInterval(this.timer);
        this.timer = window.setInterval(this.processInput.bind(this), 1500);
    }
    // type = number
    userInput2(event) {
        this.page.value = (0, $b348546b86779519$export$12f43d294de01a8a)(this.page.value, this.maxPage).toString();
        //console.log(this.page.value);
        if (event.key === "Enter") this.processInput();
    }
    // type = number
    processInput() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(this.page.value);
        //window.location.hash = `/book/${book}/page/${isNaN(page) ? 1 : page}`;
        window.location.setHash(book, isNaN(page) ? 0 : page);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "page", {
            at: "input",
            book: book,
            page: page
        });
    }
    getTotal(book) {
        return Math.ceil($b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1] / 2) - 1;
    }
    hasLastTwoPages(book) {
        return $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1] % 2 === 0;
    }
    imagePromise(img) {
        return img.complete ? Promise.resolve() : new Promise((resolve, reject)=>{
            img.addEventListener("load", ()=>resolve());
            img.addEventListener("error", ()=>reject(`Failed to load: ${img.src}`));
        });
    }
    // same as goTo
    getPage(book, page, language) {
        const front = page * 2 + 1; // pali
        const back = front + 1; // khmer
        // 0 => 1, 2
        // 1 => 3, 4
        // 2 => 5, 6
        let repo;
        if (book <= 22) repo = 1;
        else if (book <= 44) repo = 2;
        else if (book <= 66) repo = 3;
        else if (book <= 88) repo = 4;
        else repo = 5;
        const pali = `https://raw.githubusercontent.com/SiliconWat/bedok${repo}.siliconwat.dev/main/khmer/book-${book}/page-${front}.jpg`;
        const khmer = page !== this.getTotal(book) || this.hasLastTwoPages(book) ? `https://raw.githubusercontent.com/SiliconWat/bedok${repo}.siliconwat.dev/main/khmer/book-${book}/page-${back}.jpg` : (0, (/*@__PURE__*/$parcel$interopDefault($35ab0cb5a2d404f0$exports)));
        return language === "pali" ? pali : khmer;
    }
    //async
    goTo(book, page) {
        const fetchPage = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "fetchPage");
        fetchPage.start();
        if (navigator.onLine) this.pager.classList.add("hidden");
        this.front.classList.add("hidden", "opacity-0");
        this.back.classList.add("hidden", "opacity-0");
        if (navigator.onLine) this.spinner.classList.remove("hidden");
        const front = page * 2 + 1; // pali
        const back = front + 1; // khmer
        // 0 => 1, 2
        // 1 => 3, 4
        // 2 => 5, 6
        let repo;
        if (book <= 22) repo = 1;
        else if (book <= 44) repo = 2;
        else if (book <= 66) repo = 3;
        else if (book <= 88) repo = 4;
        else repo = 5;
        this.front.src = `https://raw.githubusercontent.com/SiliconWat/bedok${repo}.siliconwat.dev/main/khmer/book-${book}/page-${front}.jpg`;
        if (page !== this.getTotal(book) || this.hasLastTwoPages(book)) this.back.src = `https://raw.githubusercontent.com/SiliconWat/bedok${repo}.siliconwat.dev/main/khmer/book-${book}/page-${back}.jpg`;
        this.front.style.filter = document.documentElement.classList.contains("dark") && front !== 1 && front !== $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1] ? "invert(1)" : "invert(0)";
        this.back.style.filter = document.documentElement.classList.contains("dark") && (!this.hasLastTwoPages(book) || this.hasLastTwoPages(book) && back !== $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1]) ? "invert(1)" : "invert(0)";
        // weird bug: can't load image when changing to dark mode!! maybe has to do with html canvas...
        // BENEFIT: actual image that user can saved to phone!
        // const src = `https://raw.githubusercontent.com/SiliconWat/bedok${repo}.siliconwat.dev/main/khmer/book-${book}/page-${page}.jpg`;
        // this.img.src =
        //     document.documentElement.classList.contains("dark") &&
        //     page !== 1 &&
        //     page !== bedok[LANGUAGE2].books[book - 1]
        //         ? await this.invertImage(src)
        //         : src;
        fetchPage.putAttribute("front", this.front.src);
        fetchPage.putAttribute("back", this.back.src || "null");
        fetchPage.incrementMetric("count", 1);
        //await
        Promise.all([
            this.books.get(book),
            this.imagePromise(this.front),
            this.imagePromise(this.back)
        ]).then((items)=>{
            if (items[0] === "khmer") {
                if (front === $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1]) this.front.classList.remove("hidden", "opacity-0");
                else this.back.classList.remove("hidden", "opacity-0");
            } else if (items[0] === "pali") this.front.classList.remove("hidden", "opacity-0");
            else {
                const url = new URL(window.location.href);
                const language = url.searchParams.get("version") || "khmer"; // default = khmer // good for page 0 bc not good cover art
                if (language === "khmer") this.back.classList.remove("hidden", "opacity-0");
                else this.front.classList.remove("hidden", "opacity-0"); // default = pali bc need show correct page 0
            }
        }).finally(()=>{
            this.render();
            this.pager.classList.remove("hidden");
            this.spinner.classList.add("hidden");
            fetchPage.stop();
        });
        if (front !== 1 && front !== $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1]) //await
        this.getText(book, page, "pali", this.front.src).then((response)=>{
            this.pali.render("pali", response.id, response.date, response.transcript, response.text, response.hasText, response.audio);
        }).catch((error)=>{
            console.error(error.message);
            this.pali.render("pali", null, null, null, $b03e5dce378954b0$var$strings.transcribe2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], false, null);
            //alert(error.message);
            this.transcriptions.remove(book, page);
        });
        else this.pali.render("pali", null, null, null, $b03e5dce378954b0$var$strings.transcribe1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], false, null);
        if (!this.hasLastTwoPages(book) && front !== $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1] || this.hasLastTwoPages(book) && back !== $b03e5dce378954b0$var$bedok[$b03e5dce378954b0$var$LANGUAGE2].books[book - 1]) //await
        this.getText(book, page, "khmer", this.back.src).then((response)=>{
            this.khmer.render("khmer", response.id, response.date, response.transcript, response.text, response.hasText, response.audio);
        }).catch((error)=>{
            console.error(error.message);
            this.khmer.render("khmer", null, null, null, $b03e5dce378954b0$var$strings.transcribe2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], false, null);
            //alert(error.message);
            this.transcriptions.remove(book, page);
        });
        else this.khmer.render("khmer", null, null, null, $b03e5dce378954b0$var$strings.transcribe1[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa], false, null);
    // TODO: weird loading bug when opening reader
    //this.spinner.classList.add("hidden");
    //fetchPage.stop();
    }
    // TODO: later convert firestore collection documents as github files
    // order: cache, github file // no dexie bc sw cache
    async getText2(book, page, language) {
        const github = await fetch(`https://raw.githubusercontent.com/SiliconWat/bedok.siliconwat.dev/main/book-${book}/page-${page}/${language}.json`);
        const transcription = await github.json();
        const text = (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? transcription.transcript : transcription.translation;
        return {
            id: null,
            date: transcription.editedDate,
            transcript: transcription.transcript,
            text: text,
            hasText: Boolean(text),
            audio: transcription.audio
        };
    }
    setupRealtimeListener(id, language) {
        if (language === "khmer") this.transcriptions.setupRealtimeListener("khmer", id, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa), this.khmer.render.bind(this.khmer));
        if (language === "pali") this.transcriptions.setupRealtimeListener("pali", id, (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa), this.pali.render.bind(this.pali));
    }
    // order: dexie//NO, firestore, cloud function, Tesseract
    async getText(book, page, language, imageUrl) {
        // dexie
        // const transcription = await this.transcriptions.get(
        //     book,
        //     page,
        //     language
        // );
        // if (transcription) {
        //     this.setupRealtimeListener(transcription.id, language);
        //     const text =
        //         LANGUAGE === "khmer"
        //             ? transcription.transcript
        //             : transcription.translation;
        //     return {
        //         id: transcription.id,
        //         date: transcription.editedDate,
        //         transcript: transcription.transcript,
        //         text: text || strings.transcribe3[LANGUAGE]
        //     };
        // } else {
        // firestore
        const transcription = await this.transcriptions.getTranscription(book, page, language);
        if (transcription) {
            this.setupRealtimeListener(transcription.id, language);
            const text = (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? transcription.transcript : transcription.translation;
            return {
                id: transcription.id,
                date: transcription.editedDate,
                transcript: transcription.transcript,
                text: text || $b03e5dce378954b0$var$strings.transcribe3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                hasText: Boolean(text),
                audio: transcription.audio
            };
        } else {
            // cloud function: deprecated // will never reach here if refactor
            const transcription = await this.recognizeTextFromURL(book, page, language, imageUrl);
            if (transcription) {
                this.setupRealtimeListener(transcription.id, language);
                const text = (0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa) === "khmer" ? transcription.transcript : transcription.translation;
                return {
                    id: transcription.id,
                    date: transcription.editedDate,
                    transcript: transcription.transcript,
                    text: text || $b03e5dce378954b0$var$strings.transcribe3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                    hasText: Boolean(text),
                    audio: transcription.audio
                };
            } else return await this.recognizeTextFromURL2(imageUrl); // no english translation
        }
    //}
    }
    // deprecated bc showing: "currenly transcribing"
    async recognizeTextFromURL(book, page, language, imageUrl) {
        if (!navigator.onLine) //alert(strings.offline[LANGUAGE]);
        return null;
        try {
            const ocrText = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)((0, $9d0840e0f81e5cfa$export$18af1f934c132a41), "ocrText", {
                limitedUseAppCheckTokens: true
            });
            const result = await ocrText({
                book: book,
                page: page,
                language: language,
                imageUrl: imageUrl
            });
            // dexie
            const transcription = result.data;
            await this.transcriptions.update(transcription.id, transcription.editedDate, transcription.book, transcription.page, transcription.language, transcription.transcript || "", transcription.translation || "");
            return transcription;
        } catch (error) {
            console.error(error.message);
            return null;
        }
    }
    // Tesseract: deprecated
    async recognizeTextFromURL2(imageUrl) {
        // const response = await fetch(imageUrl);
        // const blob = await response.blob();
        // const objectURL = URL.createObjectURL(blob);
        // const {
        //     data: { text }
        // } = await Tesseract.recognize(objectURL, "khm");
        // URL.revokeObjectURL(objectURL);
        const text = null;
        return {
            id: null,
            date: null,
            transcript: text || $b03e5dce378954b0$var$strings.transcribe3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            text: text || $b03e5dce378954b0$var$strings.transcribe3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
            hasText: Boolean(text),
            audio: null
        };
    }
    render() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);
        this.page.value = page.toString();
        //this.page.dataset.inputCounterMax = this.getTotal(book).toString();
        this.total.textContent = this.getTotal(book) + " " + $b03e5dce378954b0$var$strings.total[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        const options = {
            minValue: 0,
            maxValue: this.getTotal(book),
            onIncrement: ()=>{
                this.pageTo(true);
            },
            onDecrement: ()=>{
                this.pageTo(false);
            }
        };
        // const counterInput: InputCounterInterface = new InputCounter(
        //     this.page,
        //     this.increment,
        //     this.decrement,
        //     options
        // );
        this.maxPage = this.getTotal(book);
    }
    // swiping can go to end and beginning of book; but flowbite pager cannot
    pageTo(direction) {
        const paths = window.location.hash.split("/");
        let book = parseInt(paths[2]);
        let page = parseInt(paths[4]);
        if (direction) page = page === this.getTotal(book) ? 0 : page + 1;
        else page = page === 0 ? this.getTotal(book) : page - 1;
        //window.location.hash = `/book/${book}/page/${page}`;
        window.location.setHash(book, page);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "page", {
            direction: direction,
            book: book,
            page: page
        });
        this.heartbank.alertAdmin(`page/swipe/${direction ? "left" : "right"}`);
    }
    // deprecated
    pageTo2(direction) {
        const paths = window.location.hash.split("/");
        let book, page;
        if (paths[2] !== undefined && paths[4] !== undefined) {
            book = parseInt(paths[2]);
            page = parseInt(paths[4]);
            if (direction) page = page === this.getTotal(book) ? 0 : page + 1;
            else page = page === 1 ? this.getTotal(book) : page - 1;
        } else {
            book = paths[2] !== undefined ? parseInt(paths[2]) : 0;
            if (direction) page = 0;
            else page = this.getTotal(book);
        }
        //window.location.hash = `/book/${book}/page/${page}`;
        window.location.setHash(book, page);
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "page", {
            direction: direction,
            book: book,
            page: page
        });
    }
    // deprecated
    async invertImage(src) {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.crossOrigin = "anonymous"; // To handle cross-origin issues
            img.src = src;
            img.onload = ()=>{
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                if (ctx) {
                    // Set canvas dimensions to match the image
                    canvas.width = img.width;
                    canvas.height = img.height;
                    // Draw the image on the canvas
                    ctx.drawImage(img, 0, 0);
                    // Get image data
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const data = imageData.data;
                    // Invert colors
                    for(let i = 0; i < data.length; i += 4){
                        data[i] = 255 - data[i]; // Red
                        data[i + 1] = 255 - data[i + 1]; // Green
                        data[i + 2] = 255 - data[i + 2]; // Blue
                    // Alpha (data[i + 3]) remains the same
                    }
                    // Put the modified image data back onto the canvas
                    ctx.putImageData(imageData, 0, 0);
                    // Export the canvas as a Data URL
                    resolve(canvas.toDataURL());
                } else {
                    console.error("Failed to get canvas context");
                    reject();
                }
            };
        });
    }
}









//import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
const $d5973e26da617390$var$template = document.createElement("template");
$d5973e26da617390$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <div
        id="sw-reader"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        onclick="heartbank.alertAdmin('reader/click/editor')"
                        class="text-xl md:text-2xl font-semibold text-theme">
                        <button
                            class="hidden mr-2"
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).editor[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}">
                            📝
                        </button>
                        <span id="sw-reader-title"></span>
                    </h3>
                    <section>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).speak2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-reader-speak"
                            ontouchstart=""
                            onclick="heartbank.alertAdmin('reader/click/speak')"
                            type="button"
                            class="text-xl md:text-2xl mr-3 md:mr-5">
                            🔈
                        </button>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).dict2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-reader-dict2"
                            ontouchstart=""
                            onclick="heartbank.alertAdmin('reader/render/dictionary')"
                            type="button"
                            class="text-xl md:text-2xl mr-3 md:mr-5">
                            📖
                        </button>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).copyall[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-reader-copy"
                            ontouchstart=""
                            onclick="heartbank.alertAdmin('reader/render/copy-all')"
                            type="button"
                            class="text-xl md:text-2xl mr-3 md:mr-5">
                            📑
                        </button>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            id="sw-reader-close2"
                            ontouchstart=""
                            type="button"
                            class="text-xl md:text-2xl">
                            ❌
                        </button>
                    </section>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        id="sw-reader-close3"
                        type="button"
                        class="hidden text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    class="battambang p-4 md:p-5 space-y-4 leading-[2] text-gray-900 dark:text-white">
                    <div id="sw-reader-body">
                        <p class="text-xl break-words break-keep2"></p>
                        <p class="text-2xl break-words break-keep2"></p>
                    </div>
                    <div
                        id="sw-reader-pager"
                        class="relative pt-5 flex items-center max-w-44 mx-auto">
                        <button
                            type="button"
                            id="sw-reader-pager-decrement"
                            onclick="heartbank.alertAdmin('reader/click/previous-page')"
                            data-input-counter-decrement="page-number"
                            class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                            <svg
                                class="text-gray-900 dark:text-white"
                                aria-hidden="true"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                                height="14"
                                width="12.25"
                                viewBox="0 0 448 512">
                                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                            </svg>
                        </button>
                        <input
                            inputmode="numeric"
                            id="sw-reader-pager-number"
                            onblur="heartbank.alertAdmin('reader/type/', this.value)"
                            type="text"
                            data-input-counter2
                            data-input-counter-min2="0"
                            data-input-counter-max2=""
                            aria-describedby="helper-text-explanation"
                            class="bg-gray-50 border-x-0 border-gray-300 h-11 font-medium text-center text-gray-900 text-lg outline-none focus:ring-0 focus:border-none focus:ring-blue-500 focus:border-blue-500 block w-full pb-6 dark:bg-gray-700 dark:border-gray-600 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).page[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            value="0" />
                        <div
                            id="sw-reader-pager-total"
                            class="absolute bottom-1 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 flex items-center text-xs text-gray-400 space-x-1 rtl:space-x-reverse">
                            1 ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).total[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                        </div>
                        <button
                            type="button"
                            id="sw-reader-pager-increment"
                            onclick="heartbank.alertAdmin('reader/click/next-page')"
                            data-input-counter-increment="page-number"
                            class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                            <svg
                                class="text-gray-900 dark:text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                fill="currentColor"
                                height="14"
                                width="12.25"
                                viewBox="0 0 448 512">
                                <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                            </svg>
                        </button>
                    </div>
                    <p
                        onclick="heartbank.alertAdmin('reader/click/feedback');prompt('${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).typo2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}','${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}')"
                        class="font-thin text-sm text-gray-500 dark:text-gray-400 text-center italic underline cursor-pointer">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).typo[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </p>
                </div>
                <!-- Modal footer -->
                <div
                    class="hidden items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-reader-tutor"
                        ontouchstart=""
                        onclick="heartbank.alertAdmin('reader/click/tutor')"
                        type="button"
                        class="w-24 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).tutor[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-quiz"
                        ontouchstart=""
                        onclick="heartbank.alertAdmin('reader/click/quiz')"
                        type="button"
                        class="w-24 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).quiz[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-google"
                        onclick="heartbank.alertAdmin('reader/click/google-translate')"
                        type="button"
                        class="${(0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? "hidden" : "hidden"} w-24 text-white bg-basket2 hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket2 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).google[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-other"
                        onclick="heartbank.alertAdmin('reader/click/other-ai')"
                        type="button"
                        class="hidden w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).other[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-close"
                        type="button"
                        class="hidden w-24 text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-reader-gemini"
                        onclick="heartbank.alertAdmin('reader/click/gemini-ai')"
                        type="button"
                        class="w-24 text-white bg-basket2 hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket2 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).gemini[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-dict"
                        onclick="heartbank.alertAdmin('reader/click/dictionary')"
                        type="button"
                        class="w-24 text-white bg-basket1 hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket1 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).dict[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-grok"
                        onclick="heartbank.alertAdmin('reader/click/grok-ai')"
                        type="button"
                        class="w-24 text-white bg-basket2 hover:bg-orange-800 focus:ring-4 focus:outline-none focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket2 dark:hover:bg-orange-700 dark:focus:ring-orange-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).grok[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
                <div
                    id="sw-reader-admin"
                    class="hidden items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-reader-deepseek"
                        onclick="heartbank.alertAdmin('reader/click/deepseek-ai')"
                        type="button"
                        class="w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).deepseek[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-meta"
                        onclick="heartbank.alertAdmin('reader/click/meta-ai')"
                        type="button"
                        class="w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).meta[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        id="sw-reader-chatgpt"
                        onclick="heartbank.alertAdmin('reader/click/chat-gpt')"
                        type="button"
                        class="w-24 text-white bg-basket3 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-basket3 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).chatgpt[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
var $d5973e26da617390$export$2e2bcd8739ae039 = $d5973e26da617390$var$template;









var $44e2ba6da71a247a$exports = {};
$44e2ba6da71a247a$exports = JSON.parse('[{"id":1,"word":"\u1780"},{"id":2,"word":"\u1780\u17CF"},{"id":3,"word":"\u1780\u1780"},{"id":4,"word":"\u1780\u1780\u17CB"},{"id":5,"word":"\u1780\u1780\u17D2\u1780\u178A"},{"id":6,"word":"\u1780\u1780\u179A"},{"id":7,"word":"\u1780\u1780\u17B6\u178F"},{"id":8,"word":"\u1780\u1780\u17B6\u1799"},{"id":9,"word":"\u1780\u1780\u17B7\u1785\u1780\u1780\u17BB\u1785"},{"id":10,"word":"\u1780\u1780\u17B7\u178F"},{"id":11,"word":"\u1780\u1780\u17B7\u179B"},{"id":12,"word":"\u1780\u1780\u17BC\u179A"},{"id":13,"word":"\u1780\u1780\u17C1\u1794\u1780\u1780\u17B6\u1794"},{"id":14,"word":"\u1780\u1780\u17C1\u179A"},{"id":15,"word":"\u1780\u1780\u17C1\u17C7"},{"id":16,"word":"\u1780\u1780\u17C2\u1780\u1780\u179A"},{"id":17,"word":"\u1780\u1780\u17C2\u1780\u1780\u1780\u17C4\u1780"},{"id":18,"word":"\u1780\u1780\u17C2\u1784\u1780\u1780\u17C4\u1784"},{"id":19,"word":"\u1780\u1780\u17C2\u1794"},{"id":20,"word":"\u1780\u1780\u17C4\u1780"},{"id":21,"word":"\u1780\u1780\u17C4\u179F"},{"id":22,"word":"\u1780\u1780\u17C4\u17C7"},{"id":23,"word":"\u1780\u1780\u17D2\u179A\u17B7\u178F"},{"id":24,"word":"\u1780\u1780\u17D2\u179A\u17BE\u1780"},{"id":25,"word":"\u1780\u1780\u17D2\u179A\u17C4\u17C7"},{"id":26,"word":"\u1780\u1780\u17D2\u179B\u17B6\u1780\u17CB"},{"id":27,"word":"\u1780\u1780\u17D2\u17A2\u17B6\u1780"},{"id":28,"word":"\u1780\u1780\u17D2\u17A2\u17B6\u1799"},{"id":29,"word":"\u1780\u1780\u17D2\u17A2\u17B7\u1785"},{"id":30,"word":"\u1780\u1780\u17D2\u17A2\u17B7\u179B"},{"id":31,"word":"\u1780\u1780\u17D2\u17A2\u17B9\u1780"},{"id":32,"word":"\u1780\u1780\u17D2\u17A2\u17C0\u1780"},{"id":33,"word":"\u1780\u1780\u17D2\u17A2\u17C0\u1785"},{"id":34,"word":"\u1780\u1781\u17B7\u1780\u1780\u1781\u1780\u17CB"},{"id":35,"word":"\u1780\u1781\u17B7\u1794\u1780\u1781\u17BB\u1794"},{"id":36,"word":"\u1780\u1781\u17B9\u1780"},{"id":37,"word":"\u1780\u1781\u17BB\u1794"},{"id":38,"word":"\u1780\u1781\u17D2\u179C\u1780\u17CB"},{"id":39,"word":"\u1780\u1781\u17D2\u179C\u17B7\u1780"},{"id":40,"word":"\u1780\u1781\u17D2\u179C\u17C1\u179F\u1780\u1781\u17D2\u179C\u17B6\u179F"},{"id":41,"word":"\u1780\u1784"},{"id":42,"word":"\u1780\u1784\u1798\u17B6\u179F"},{"id":43,"word":"\u1780\u1784\u17CB"},{"id":44,"word":"\u1780\u1784\u17D2\u1780\u17BB\u1789"},{"id":45,"word":"\u1780\u1784\u17D2\u1780\u17BD\u1785"},{"id":46,"word":"\u1780\u1784\u17D2\u1780\u17BD\u1789"},{"id":47,"word":"\u1780\u1784\u17D2\u1780\u17C2\u1794"},{"id":48,"word":"\u1780\u1784\u17D2\u1780\u17C2\u1794\u1780\u17BC\u1794"},{"id":49,"word":"\u1780\u1784\u17D2\u1780\u17C2\u1794\u1794\u17D2\u179A\u17BB\u1799"},{"id":50,"word":"\u1780\u1784\u17D2\u1780\u17C2\u1794\u17A2\u17B6\u1785\u1798\u17CD\u1782\u17C4"},{"id":51,"word":"\u1780\u1784\u17D2\u1781\u17B6"},{"id":52,"word":"\u1780\u1784\u17D2\u1781\u17BE\u1789"},{"id":53,"word":"\u1780\u1784\u17D2\u179C\u179B\u17CB"},{"id":54,"word":"\u1780\u1784\u17D2\u179C\u17B6\u179A"},{"id":55,"word":"\u1780\u1784\u17D2\u179C\u17C1\u179A"},{"id":56,"word":"\u1780\u1784\u17D2\u17A0\u17B6\u179A"},{"id":57,"word":"\u1780\u1784\u17D2\u17A0\u17B7\u1785"},{"id":58,"word":"\u1780\u1784\u17D2\u17A0\u17C2\u1793"},{"id":59,"word":"\u1780\u1784\u1780\u17C1\u1784"},{"id":60,"word":"\u1780\u1784\u1785\u17C5"},{"id":61,"word":"\u1780\u1784\u1796\u17D0\u1793\u17D2\u1792"},{"id":62,"word":"\u1780\u1784\u179F\u17C4\u1799"},{"id":63,"word":"\u1780\u1785\u17D2\u1785\u17B6\u1799\u1793\u17C8"},{"id":64,"word":"\u1780\u1785\u17D2\u1785\u17B6\u1799\u1793\u17BC\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u1780\u17C8"},{"id":65,"word":"\u1780\u1789\u17D2\u1785\u1780"},{"id":66,"word":"\u1780\u1789\u17D2\u1785\u1780\u17CB"},{"id":67,"word":"\u1780\u1789\u17D2\u1785\u1794\u17CB"},{"id":68,"word":"\u1780\u1789\u17D2\u1785\u1794\u17CB\u1780\u1789\u17D2\u1785\u17BC\u179C"},{"id":69,"word":"\u1780\u1789\u17D2\u1785\u17B6\u1789\u17CB\u1785\u17C1\u1780"},{"id":70,"word":"\u1780\u1789\u17D2\u1785\u17B6\u1789\u17CB\u1785\u17D2\u179A\u17B6\u179F"},{"id":71,"word":"\u1780\u1789\u17D2\u1785\u17B6\u1798"},{"id":72,"word":"\u1780\u1789\u17D2\u1785\u17B6\u179F\u17CB"},{"id":73,"word":"\u1780\u1789\u17D2\u1785\u17B9\u1784\u1780"},{"id":74,"word":"\u1780\u1789\u17D2\u1785\u17BB\u17C7"},{"id":75,"word":"\u1780\u1789\u17D2\u1785\u17C2"},{"id":76,"word":"\u1780\u1789\u17D2\u1785\u17C4\u1784"},{"id":77,"word":"\u1780\u1789\u17D2\u1785\u17C4\u178F"},{"id":78,"word":"\u1780\u1789\u17D2\u1785\u17C4\u1794"},{"id":79,"word":"\u1780\u1789\u17D2\u1785\u17BB\u17C6"},{"id":80,"word":"\u1780\u1789\u17D2\u1785\u17B6\u17C6\u1784"},{"id":81,"word":"\u1780\u1789\u17D2\u1785\u17D2\u179A\u1784\u17CB"},{"id":82,"word":"\u1780\u1789\u17D2\u1785\u17D2\u179A\u17B9\u1780"},{"id":83,"word":"\u1780\u1789\u17D2\u1785\u17D2\u179A\u17BA\u1794"},{"id":84,"word":"\u1780\u1789\u17D2\u1785\u17D2\u179A\u17C2\u1784"},{"id":85,"word":"\u1780\u1789\u17D2\u1786\u1780\u17CB"},{"id":86,"word":"\u1780\u1789\u17D2\u1786\u1780\u17CB\u1780\u1789\u17D2\u1786\u17C2\u1784"},{"id":87,"word":"\u1780\u1789\u17D2\u1786\u178F"},{"id":88,"word":"\u1780\u1789\u17D2\u1786\u179B"},{"id":89,"word":"\u1780\u1789\u17D2\u1786\u17B6"},{"id":90,"word":"\u1780\u1789\u17D2\u1786\u17B6\u178F\u17CB"},{"id":91,"word":"\u1780\u1789\u17D2\u1786\u17B7\u178F"},{"id":92,"word":"\u1780\u1789\u17D2\u1786\u17B7\u179B"},{"id":93,"word":"\u1780\u1789\u17D2\u1786\u17B9\u1798"},{"id":94,"word":"\u1780\u1789\u17D2\u1786\u17BD\u1784"},{"id":95,"word":"\u1780\u1789\u17D2\u1786\u17BE\u1789"},{"id":96,"word":"\u1780\u1789\u17D2\u1786\u17C0\u179C"},{"id":97,"word":"\u1780\u1789\u17D2\u1786\u17C1\u1784"},{"id":98,"word":"\u1780\u1789\u17D2\u1786\u17C2\u178F"},{"id":99,"word":"\u1780\u1789\u17D2\u1786\u17C2\u179C"},{"id":100,"word":"\u1780\u1789\u17D2\u1786\u17C4\u178F"},{"id":101,"word":"\u1780\u1789\u17D2\u1787\u1784\u17CB"},{"id":102,"word":"\u1780\u1789\u17D2\u1787\u1793\u1787\u17C3"},{"id":103,"word":"\u1780\u1789\u17D2\u1787\u1794\u17CB"},{"id":104,"word":"\u1780\u1789\u17D2\u1787\u179A"},{"id":105,"word":"\u1780\u1789\u17D2\u1787\u17B6\u1780\u17CB"},{"id":106,"word":"\u1780\u1789\u17D2\u1787\u17B6\u1780\u17CB\u179F\u17D2\u179B\u17B6"},{"id":107,"word":"\u1780\u1789\u17D2\u1787\u17B6\u178F"},{"id":108,"word":"\u1780\u1789\u17D2\u1787\u17BB\u179F\u1798\u17B6\u1793\u17CB"},{"id":109,"word":"\u1780\u1789\u17D2\u1787\u17BD"},{"id":110,"word":"\u1780\u1789\u17D2\u1787\u17BE"},{"id":111,"word":"\u1780\u1789\u17D2\u1787\u17BE\u1787\u17C6\u1796\u17C4\u17C7"},{"id":112,"word":"\u1780\u1789\u17D2\u1787\u17BE\u1794\u17B6\u1799\u178A\u17B6\u1785"},{"id":113,"word":"\u1780\u1789\u17D2\u1787\u17C2\u17C7"},{"id":114,"word":"\u1780\u1789\u17D2\u1787\u17C7"},{"id":115,"word":"\u1780\u1789\u17D2\u1787\u17C7\u1780\u1789\u17D2\u1787\u17B6\u1799"},{"id":116,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u1780\u17CB"},{"id":117,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u1798"},{"id":118,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17B9\u179B"},{"id":119,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17BC\u1780"},{"id":120,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C0\u1785"},{"id":121,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C0\u1794"},{"id":122,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C0\u179C"},{"id":123,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C4\u1780"},{"id":124,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C4\u1780\u1794\u17C4\u1780\u1794\u17B6\u1785"},{"id":125,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C4\u1784"},{"id":126,"word":"\u1780\u1789\u17D2\u1787\u17D2\u179A\u17C4\u179B"},{"id":127,"word":"\u1780\u1789\u17D2\u1788\u17BC\u179F"},{"id":128,"word":"\u1780\u1789\u17D2\u1789\u17B6"},{"id":129,"word":"\u1780\u1789\u17D2\u1789\u17B6\u1780\u17B7\u178F\u17D2\u178F\u17B7\u1799\u179F"},{"id":130,"word":"\u1780\u178A\u1794"},{"id":131,"word":"\u1780\u178A\u17D2\u178B\u1782\u17D2\u1782\u17B7"},{"id":132,"word":"\u1780\u178B\u17B7\u1793"},{"id":133,"word":"\u1780\u178E\u17B7\u1780\u17B6\u179A"},{"id":134,"word":"\u1780\u178E\u17D2\u178A\u1780\u17CB"},{"id":135,"word":"\u1780\u178E\u17D2\u178A\u1780\u17CB\u179F\u1789\u17D2\u1789\u17B6"},{"id":136,"word":"\u1780\u178E\u17D2\u178A\u1794"},{"id":137,"word":"\u1780\u178E\u17D2\u178A\u17B6\u1785"},{"id":138,"word":"\u1780\u178E\u17D2\u178A\u17B6\u1785\u17CB"},{"id":139,"word":"\u1780\u178E\u17D2\u178A\u17B6\u1789\u17CB"},{"id":140,"word":"\u1780\u178E\u17D2\u178A\u17B6\u1794\u17CB"},{"id":141,"word":"\u1780\u178E\u17D2\u178A\u17B6\u1794\u17CB\u1785\u1784\u17D2\u17A2\u17C1\u179A"},{"id":142,"word":"\u1780\u178E\u17D2\u178A\u17B6\u1794\u17CB\u178A\u17C3"},{"id":143,"word":"\u1780\u178E\u17D2\u178A\u17B6\u179A"},{"id":144,"word":"\u1780\u178E\u17D2\u178A\u17B6\u179B"},{"id":145,"word":"\u1780\u178E\u17D2\u178A\u17B6\u179B\u179F\u17D2\u1791\u17B9\u1784"},{"id":146,"word":"\u1780\u178E\u17D2\u178A\u17B6\u179F\u17CB"},{"id":147,"word":"\u1780\u178E\u17D2\u178A\u17B9\u1784"},{"id":148,"word":"\u1780\u178E\u17D2\u178A\u17B9\u1784\u1782\u17C4"},{"id":149,"word":"\u1780\u178E\u17D2\u178A\u17B9\u1798\u1786\u17C2\u1794!"},{"id":150,"word":"\u1780\u178E\u17D2\u178A\u17BB\u1780"},{"id":151,"word":"\u1780\u178E\u17D2\u178A\u17BB\u179A"},{"id":152,"word":"\u1780\u178E\u17D2\u178A\u17BC\u1784"},{"id":153,"word":"\u1780\u178E\u17D2\u178A\u17BC\u1794"},{"id":154,"word":"\u1780\u178E\u17D2\u178A\u17BD\u1799"},{"id":155,"word":"\u1780\u178E\u17D2\u178A\u17C0\u1781\u17D2\u1798\u17BC\u178F"},{"id":156,"word":"\u1780\u178E\u17D2\u178A\u17C0\u1784"},{"id":157,"word":"\u1780\u178E\u17D2\u178A\u17C0\u178F"},{"id":158,"word":"\u1780\u178E\u17D2\u178A\u17C0\u178F\u1780\u17D2\u17A2\u1798"},{"id":159,"word":"\u1780\u178E\u17D2\u178A\u17C0\u1791\u17C0"},{"id":160,"word":"\u1780\u178E\u17D2\u178A\u17C0\u1793"},{"id":161,"word":"\u1780\u178E\u17D2\u178A\u17C0\u179A"},{"id":162,"word":"\u1780\u178E\u17D2\u178A\u17C0\u179C"},{"id":163,"word":"\u1780\u178E\u17D2\u178A\u17C1\u1784"},{"id":164,"word":"\u1780\u178E\u17D2\u178A\u17C2\u1784\u1780\u178E\u17D2\u178A\u17C4\u1785"},{"id":165,"word":"\u1780\u178E\u17D2\u178A\u17C4\u1785"},{"id":166,"word":"\u1780\u178E\u17D2\u178A\u17C4\u179B"},{"id":167,"word":"\u1780\u178E\u17D2\u178A\u17C4\u179B\u1794\u17B6\u178F"},{"id":168,"word":"\u1780\u178E\u17D2\u178C"},{"id":169,"word":"\u1780\u178E\u17D2\u17A0\u17B6\u1787\u17B7\u1793\u17B6"},{"id":170,"word":"\u1780\u178F\u17CB"},{"id":171,"word":"\u1780\u178F\u1789\u17D2\u1789\u17BB\u178F\u17B6"},{"id":172,"word":"\u1780\u178F\u1789\u17D2\u1789\u17BC"},{"id":173,"word":"\u1780\u178F\u179C\u17C1\u1791\u17B7\u178F\u17B6"},{"id":174,"word":"\u1780\u178F\u179C\u17C1\u1791\u17B8"},{"id":175,"word":"\u1780\u178F\u17B7\u1780\u17B6"},{"id":176,"word":"\u1780\u178F\u17BC\u1794\u1780\u17B6\u179A\u17C8"},{"id":177,"word":"\u1780\u178F\u17D2\u178F\u17B6"},{"id":178,"word":"\u1780\u178F\u17D2\u178F\u17B7\u1780"},{"id":179,"word":"\u1780\u178F\u17D2\u178F\u17BB\u179C\u17B6\u1785\u1780"},{"id":180,"word":"\u1780\u1790\u17B6"},{"id":181,"word":"\u1780\u1790\u17B7\u1793"},{"id":182,"word":"\u1780\u1793"},{"id":183,"word":"\u1780\u1793\u17B7\u178A\u17D2\u178B\u17B6"},{"id":184,"word":"\u1780\u1793\u17D2\u178F\u179A\u17C9"},{"id":185,"word":"\u1780\u1793\u17D2\u178A\u17B6\u1789"},{"id":186,"word":"\u1780\u1793\u17D2\u178A\u17B6\u179A"},{"id":187,"word":"\u1780\u1793\u17D2\u178F\u17B6\u179C\u179A\u17C9\u17B6\u179C"},{"id":188,"word":"\u1780\u1793\u17D2\u178F\u17B7\u1789\u1780\u1793\u17D2\u178F\u17BB\u1789"},{"id":189,"word":"\u1780\u1793\u17D2\u178F\u17B7\u179B"},{"id":190,"word":"\u1780\u1793\u17D2\u178F\u17B9\u1794"},{"id":191,"word":"\u1780\u1793\u17D2\u178F\u17B9\u1798"},{"id":192,"word":"\u1780\u1793\u17D2\u178F\u17BB\u1789"},{"id":193,"word":"\u1780\u1793\u17D2\u178F\u17BB\u1794"},{"id":194,"word":"\u1780\u1793\u17D2\u178F\u17BB\u179B"},{"id":195,"word":"\u1780\u1793\u17D2\u178A\u17BB\u179B\u17AA"},{"id":196,"word":"\u1780\u1793\u17D2\u178F\u17BC"},{"id":197,"word":"\u1780\u1793\u17D2\u178F\u17BC\u17A1\u17C1\u178F"},{"id":198,"word":"\u1780\u1793\u17D2\u178F\u17BE\u1799"},{"id":199,"word":"\u1780\u1793\u17D2\u178F\u17C1\u17C7\u17A1\u1784\u17CB"},{"id":200,"word":"\u1780\u1793\u17D2\u178F\u17C2\u179A\u17C9\u17C2"},{"id":201,"word":"\u1780\u1793\u17D2\u178F\u17B6\u17C6\u1784"},{"id":202,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A"},{"id":203,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u1784"},{"id":204,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u1784\u1794\u17D2\u179A\u17C1\u1784"},{"id":205,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u1794\u17CB"},{"id":206,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17B6\u1780"},{"id":207,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17B6\u1780\u17CB"},{"id":208,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17BE\u1799"},{"id":209,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17C1\u1780\u1780\u1793\u17D2\u178F\u17D2\u179A\u17B6\u1780"},{"id":210,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17C2\u1784"},{"id":211,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17C3"},{"id":212,"word":"\u1780\u1793\u17D2\u178A\u17D2\u179A\u17C4\u1784"},{"id":213,"word":"\u1780\u1793\u17D2\u178F\u17D2\u179A\u17C4\u1793"},{"id":214,"word":"\u1780\u1793\u17D2\u1790\u17B9\u1780"},{"id":215,"word":"\u1780\u1793\u17D2\u1790\u17C4\u179A"},{"id":216,"word":"\u1780\u1793\u17D2\u1791\u1780\u17CB"},{"id":217,"word":"\u1780\u1793\u17D2\u1791\u1780\u17CB\u1780\u1793\u17D2\u1791\u17C1\u1789"},{"id":218,"word":"\u1780\u1793\u17D2\u1791\u1780\u17CB\u17A2\u1784\u17D2\u1780\u17B6\u1793\u17CB"},{"id":219,"word":"\u1780\u1793\u17D2\u1791\u1793\u1787\u17C3"},{"id":220,"word":"\u1780\u1793\u17D2\u1791\u1793\u17CB\u1794\u17B6\u1780\u17CB\u1780"},{"id":221,"word":"\u1780\u1793\u17D2\u1791\u1794"},{"id":222,"word":"\u1780\u1793\u17D2\u1791\u17B6\u1791\u17BC\u1780"},{"id":223,"word":"\u1780\u1793\u17D2\u1791\u17B6\u179B\u178F\u17D2\u179A\u17A2\u17B6\u1780"},{"id":224,"word":"\u1780\u1793\u17D2\u1791\u17B8"},{"id":225,"word":"\u1780\u1793\u17D2\u1791\u17B8\u1784\u179A\u17B8\u1784"},{"id":226,"word":"\u1780\u1793\u17D2\u1791\u17B9\u179F"},{"id":227,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799"},{"id":228,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799\u1780\u17D2\u179A\u1796\u17BE"},{"id":229,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799\u1785\u1785\u1780"},{"id":230,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799\u1786\u17D2\u1780\u17C2"},{"id":231,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799\u178A\u17C6\u179A\u17B8"},{"id":232,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799\u1790\u17D2\u179B\u17C2\u1793"},{"id":233,"word":"\u1780\u1793\u17D2\u1791\u17BB\u1799\u179B\u17B9\u1793"},{"id":234,"word":"\u1780\u1793\u17D2\u1791\u17BB\u179B"},{"id":235,"word":"\u1780\u1793\u17D2\u1791\u17BC\u178F\u17A2\u17BC\u1784"},{"id":236,"word":"\u1780\u1793\u17D2\u1791\u17BD\u178F"},{"id":237,"word":"\u1780\u1793\u17D2\u1791\u17BD\u178F\u1794\u17D2\u179A\u17C4\u1784"},{"id":238,"word":"\u1780\u1793\u17D2\u1791\u17BD\u178F\u1796\u17D2\u179A\u17C3"},{"id":239,"word":"\u1780\u1793\u17D2\u1791\u17BD\u179B"},{"id":240,"word":"\u1780\u1793\u17D2\u1791\u17BE\u1789"},{"id":241,"word":"\u1780\u1793\u17D2\u1791\u17C1\u1785\u17A2\u17B6\u179B"},{"id":242,"word":"\u1780\u1793\u17D2\u1791\u17C1\u179B"},{"id":243,"word":"\u1780\u1793\u17D2\u1791\u17C2\u1780"},{"id":244,"word":"\u1780\u1793\u17D2\u1791\u17C4\u1780"},{"id":245,"word":"\u1780\u1793\u17D2\u1791\u17C4\u1784"},{"id":246,"word":"\u1780\u1793\u17D2\u1791\u17BB\u17C6\u179A\u17BB\u1799"},{"id":247,"word":"\u1780\u1793\u17D2\u1791\u17B6\u17C6\u1784\u1794\u17B6\u1799\u179F"},{"id":248,"word":"\u1780\u1793\u17D2\u1791\u17B6\u17C6\u1784\u17A0\u17C2"},{"id":249,"word":"\u1780\u1793\u17D2\u1791\u17C7\u179A\u17B6"},{"id":250,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u1784\u17CB"},{"id":251,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u1798"},{"id":252,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u179B"},{"id":253,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1789"},{"id":254,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17B9\u179F"},{"id":255,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17BB\u1794"},{"id":256,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17BD\u1780"},{"id":257,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17BD\u1794"},{"id":258,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17BE\u1784"},{"id":259,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17C2\u178F"},{"id":260,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17C4\u1780"},{"id":261,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17C4\u1780\u178A\u17C6\u179A\u17B8"},{"id":262,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17BB\u17C6"},{"id":263,"word":"\u1780\u1793\u17D2\u1791\u17D2\u179A\u17B6\u17C6"},{"id":264,"word":"\u1780\u1793\u17D2\u1792\u179A"},{"id":265,"word":"\u1780\u1793\u17D2\u1792\u17B6"},{"id":266,"word":"\u1780\u1793\u17D2\u1792\u17B6\u1789"},{"id":267,"word":"\u1780\u1793\u17D2\u1792\u17B6\u178F\u17CB"},{"id":268,"word":"\u1780\u1793\u17D2\u1792\u17B6\u1799"},{"id":269,"word":"\u1780\u1793\u17D2\u1792\u17B7\u1784\u1780\u1793\u17D2\u1792\u17B6\u17C6\u1784"},{"id":270,"word":"\u1780\u1793\u17D2\u1792\u17B8\u1784"},{"id":271,"word":"\u1780\u1793\u17D2\u1792\u17B9\u1794"},{"id":272,"word":"\u1780\u1793\u17D2\u1792\u17BB\u1780"},{"id":273,"word":"\u1780\u1793\u17D2\u1792\u17BB\u1785"},{"id":274,"word":"\u1780\u1793\u17D2\u1792\u17BB\u179B"},{"id":275,"word":"\u1780\u1793\u17D2\u1792\u17BD\u1780"},{"id":276,"word":"\u1780\u1793\u17D2\u1792\u17C2\u1780"},{"id":277,"word":"\u1780\u1793\u17D2\u1792\u17B6\u17C6\u1784"},{"id":278,"word":"\u1780\u1793\u17D2\u1799\u17B6"},{"id":279,"word":"\u1780\u1793\u17D2\u179B\u1784"},{"id":280,"word":"\u1780\u1793\u17D2\u179B\u1784\u1781\u17D2\u1793\u1794\u17CB"},{"id":281,"word":"\u1780\u1793\u17D2\u179B\u1784\u1797\u17D2\u1793\u17C6"},{"id":282,"word":"\u1780\u1793\u17D2\u179B\u1784\u17CB"},{"id":283,"word":"\u1780\u1793\u17D2\u179B\u17B6\u178F"},{"id":284,"word":"\u1780\u1793\u17D2\u179B\u17B6\u179F\u17CB"},{"id":285,"word":"\u1780\u1793\u17D2\u179B\u17BB\u1780"},{"id":286,"word":"\u1780\u1793\u17D2\u179B\u17BB\u17C7"},{"id":287,"word":"\u1780\u1793\u17D2\u179B\u17BE\u178F"},{"id":288,"word":"\u1780\u1793\u17D2\u179B\u17BE\u178F\u1785\u1780"},{"id":289,"word":"\u1780\u1793\u17D2\u179B\u17C0\u178F"},{"id":290,"word":"\u1780\u1793\u17D2\u179B\u17C1\u1784"},{"id":291,"word":"\u1780\u1793\u17D2\u179B\u17C2\u1784"},{"id":292,"word":"\u1780\u1793\u17D2\u179B\u17C4\u1784"},{"id":293,"word":"\u1780\u1793\u17D2\u179B\u17C7"},{"id":294,"word":"\u1780\u1793\u17D2\u179F\u17C2\u1784"},{"id":295,"word":"\u1780\u1793\u17D2\u179F\u17C3"},{"id":296,"word":"\u1780\u1793\u17D2\u179F\u17C3\u179F\u17B6\u179A\u1796\u17C1\u1787\u17D2\u1789"},{"id":297,"word":"\u1780\u1793\u17D2\u179F\u17C4\u1798"},{"id":298,"word":"\u1780\u1793\u17D2\u179F\u17C4\u1798\u178F\u17B6\u17B1"},{"id":299,"word":"\u1780\u1793\u17D2\u179F\u17BB\u17C6"},{"id":300,"word":"\u1780\u1794"},{"id":301,"word":"\u1780\u1794\u17CB"},{"id":302,"word":"\u1780\u1794\u17C9\u17B6\u179B\u17CB"},{"id":303,"word":"\u1780\u1794\u17B7\u179B\u179C\u178F\u17D2\u1790\u17BB"},{"id":304,"word":"\u1780\u1794\u17D2\u1794"},{"id":305,"word":"\u1780\u1794\u17D2\u1794\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":306,"word":"\u1780\u1794\u17D2\u1794\u17B6\u179F"},{"id":307,"word":"\u1780\u1798"},{"id":308,"word":"\u1780\u1798\u179B"},{"id":309,"word":"\u1780\u1798\u17D2\u1785\u17B6\u178F\u17CB"},{"id":310,"word":"\u1780\u1798\u17D2\u1785\u17B6\u1799"},{"id":311,"word":"\u1780\u1798\u17D2\u1785\u17B8"},{"id":312,"word":"\u1780\u1798\u17D2\u1787\u17B6\u1794\u17CB"},{"id":313,"word":"\u1780\u1798\u17D2\u1787\u17B7\u179B"},{"id":314,"word":"\u1780\u1798\u17D2\u1787\u17C1\u1789"},{"id":315,"word":"\u1780\u1798\u17D2\u1789\u17B8"},{"id":316,"word":"\u1780\u1798\u17D2\u178A\u17C5"},{"id":317,"word":"\u1780\u1798\u17D2\u1791\u179A"},{"id":318,"word":"\u1780\u1798\u17D2\u1791\u17B6\u179A"},{"id":319,"word":"\u1780\u1798\u17D2\u1791\u17C1\u1785"},{"id":320,"word":"\u1780\u1798\u17D2\u1794\u1784\u17CB"},{"id":321,"word":"\u1780\u1798\u17D2\u1796\u179B"},{"id":322,"word":"\u1780\u1798\u17D2\u1796\u179F\u17CB"},{"id":323,"word":"\u1780\u1798\u17D2\u1796\u17BB"},{"id":324,"word":"\u1780\u1798\u17D2\u1796\u17BB\u1787"},{"id":326,"word":"\u1780\u1798\u17D2\u1796\u17C4\u1787"},{"id":327,"word":"\u1780\u1798\u17D2\u1796\u17C4\u1787\u17B7\u1780"},{"id":328,"word":"\u1780\u1798\u17D2\u1798"},{"id":329,"word":"\u1780\u1798\u17D2\u1798--"},{"id":330,"word":"\u1780\u1798\u17D2\u1798\u17B7\u1780\u179F\u1798\u17B6\u1787\u17B7\u1780"},{"id":331,"word":"\u1780\u1798\u17D2\u179A"},{"id":332,"word":"\u1780\u1798\u17D2\u179A\u1784"},{"id":333,"word":"\u1780\u1798\u17D2\u179A\u17B6\u1794"},{"id":334,"word":"\u1780\u1798\u17D2\u179A\u17B6\u179B"},{"id":335,"word":"\u1780\u1798\u17D2\u179A\u17B6\u179F\u17CB"},{"id":336,"word":"\u1780\u1798\u17D2\u179A\u17B7\u178F"},{"id":337,"word":"\u1780\u1798\u17D2\u179A\u17BE\u1780"},{"id":338,"word":"\u1780\u1798\u17D2\u179A\u17C0\u1798"},{"id":339,"word":"\u1780\u1798\u17D2\u179A\u17C0\u1798\u1780\u1798\u17D2\u179A\u17C4\u17C7"},{"id":340,"word":"\u1780\u1798\u17D2\u179A\u17C0\u179C"},{"id":341,"word":"\u1780\u1798\u17D2\u179A\u17C3"},{"id":342,"word":"\u1780\u1798\u17D2\u179B\u17B6"},{"id":343,"word":"\u1780\u1798\u17D2\u179B\u17B6\u1785"},{"id":344,"word":"\u1780\u1798\u17D2\u179B\u17C4\u1785"},{"id":345,"word":"\u1780\u1798\u17D2\u179B\u17C5"},{"id":346,"word":"\u1780\u1798\u17D2\u179B\u17B6\u17C6\u1784"},{"id":347,"word":"\u1780\u1798\u17D2\u179F\u178F\u17CB"},{"id":348,"word":"\u1780\u1798\u17D2\u179F\u178F\u17CB\u1780\u1798\u17D2\u179A"},{"id":349,"word":"\u1780\u1798\u17D2\u179F\u17B6\u1793\u17D2\u178F"},{"id":350,"word":"\u1780\u1798\u17D2\u179F\u17BD\u179B"},{"id":351,"word":"\u1780\u1798\u17D2\u179F\u17C4\u1799"},{"id":352,"word":"\u1780\u1798\u17D2\u17A2\u17BD\u178F"},{"id":353,"word":"\u1780\u1798\u17D2\u17A2\u17C2\u179B"},{"id":354,"word":"\u1780\u1780\u17CC\u178A"},{"id":355,"word":"\u1780\u1794\u17CC\u17BC\u179A"},{"id":356,"word":"\u1780\u179A"},{"id":357,"word":"\u1780\u179A\u1787\u1780\u17B6\u1799"},{"id":358,"word":"\u1780\u179A\u178E\u1793\u17B6\u1798"},{"id":359,"word":"\u1780\u179A\u178E\u17B8"},{"id":360,"word":"\u1780\u179A\u178E\u17B8\u1799\u1780\u17B7\u1785\u17D2\u1785"},{"id":361,"word":"\u1780\u179A\u179C\u17B7\u1780"},{"id":362,"word":"\u1780\u179A\u17B8"},{"id":363,"word":"\u1780\u179A\u17BB\u178E\u17B6"},{"id":364,"word":"\u1780\u179A\u17BB\u178E\u17B6\u179C\u17B7\u179F\u17C1\u179F"},{"id":365,"word":"\u1780\u179B"},{"id":366,"word":"\u1780\u179B\u17CB"},{"id":367,"word":"\u1780\u179B\u17CB\u1780\u17C2"},{"id":368,"word":"\u1780\u179B\u17A0\u17C8"},{"id":369,"word":"\u1780\u179B\u17A0\u1794\u17D2\u1794\u179C\u178C\u17D2\u178D\u1793\u17B8"},{"id":370,"word":"\u1780\u179B\u17A0\u1796\u17B7\u179A\u17C4\u1792"},{"id":371,"word":"\u1780\u179B\u17B7\u1799\u17BB\u1782"},{"id":372,"word":"\u1780\u179B\u17C4\u1794\u17B6\u1799"},{"id":373,"word":"\u1780\u179B\u17D2\u1794"},{"id":374,"word":"\u1780\u179B\u17D2\u1794\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":375,"word":"\u1780\u179B\u17D2\u1794\u179F\u1796\u17D2\u1791"},{"id":376,"word":"\u1780\u179B\u17D2\u1799\u17B6\u178E"},{"id":377,"word":"\u1780\u179B\u17D2\u1799\u17B6\u178E\u17B8"},{"id":378,"word":"\u1780\u179C\u17B8"},{"id":379,"word":"\u1780\u179C\u17B8\u1793\u17B7\u1796\u1793\u17D2\u1792"},{"id":380,"word":"\u1780\u179C\u17B8\u1793\u17B7\u1796\u1793\u17D2\u1792\u1793\u17CD"},{"id":381,"word":"\u1780\u179F\u17B7\u1780\u1798\u17D2\u1798"},{"id":382,"word":"\u1780\u179F\u17B7\u1780\u179A"},{"id":383,"word":"\u1780\u179F\u17B7\u1780\u17B6\u179A"},{"id":384,"word":"\u1780\u179F\u17B7\u178E"},{"id":385,"word":"\u1780\u179F\u17D2\u1799\u17B6\u1787\u17B8\u179C\u1780\u1798\u17D2\u1798"},{"id":386,"word":"\u1780\u17A0\u17B6\u1794\u178E\u17C8"},{"id":387,"word":"\u1780\u17A1\u17C4\u1794\u17B7\u17CD"},{"id":388,"word":"\u1780\u17B6"},{"id":389,"word":"\u1780\u17B6\u1780"},{"id":390,"word":"\u1780\u17B6\u1780\u1782\u178F\u17B7"},{"id":391,"word":"\u1780\u17B6\u1780\u178E\u17B7\u1780"},{"id":392,"word":"\u1780\u17B6\u1780\u1793\u17B6\u179F\u17BC\u179A"},{"id":393,"word":"\u1780\u17B6\u1780\u1794\u17B6\u1791"},{"id":394,"word":"\u1780\u17B6\u1780\u17CB"},{"id":395,"word":"\u1780\u17B6\u1780\u17CB\u17D7"},{"id":396,"word":"\u1780\u17B6\u1780\u17B8"},{"id":397,"word":"\u1780\u17B6\u1781\u17C2\u1780\u1780\u17B6\u1781\u17C4\u1780"},{"id":398,"word":"\u1780\u17B6\u1784"},{"id":399,"word":"\u1780\u17B6\u1785"},{"id":400,"word":"\u1780\u17B6\u1785\u17CB"},{"id":401,"word":"\u1780\u17B6\u1785\u17CB\u179F\u1784\u17D2\u179A\u17C2\u1780"},{"id":402,"word":"\u1780\u17B6\u1789\u17CB"},{"id":403,"word":"\u1780\u17B6\u178F"},{"id":404,"word":"\u1780\u17B6\u178F\u17CB"},{"id":405,"word":"\u1780\u17B6\u178F\u17CB\u1780\u17B6\u179B\u17CB"},{"id":406,"word":"\u1780\u17B6\u178F\u1796\u17D2\u179C\u1780\u17B7\u1785\u17D2\u1785"},{"id":407,"word":"\u1780\u17B6\u178F\u17CB\u179F\u17B6\u17C6"},{"id":408,"word":"\u1780\u17B6\u178F\u17B6\u1780"},{"id":409,"word":"\u1780\u17B6\u178F\u17B7\u1780"},{"id":410,"word":"\u1780\u17B6\u178F\u17B9\u1794"},{"id":411,"word":"\u1780\u17B6\u178F\u17C5"},{"id":412,"word":"\u1780\u17B6\u178F\u17C6"},{"id":413,"word":"\u1780\u17B6\u1793\u17CB"},{"id":414,"word":"\u1780\u17B6\u1793\u17CB\u178F\u17C2"},{"id":415,"word":"\u1780\u17B6\u1794"},{"id":416,"word":"\u1780\u17B6\u1794\u17D7"},{"id":417,"word":"\u1780\u17B6\u1794\u17CB"},{"id":418,"word":"\u1780\u17B6\u1794\u17CA\u17B8\u178E\u17C1\u178F\u17CD"},{"id":419,"word":"\u1780\u17B6\u1794\u17BC\u1794"},{"id":420,"word":"\u1780\u17B6\u1796\u17B7"},{"id":421,"word":"\u1780\u17B6\u1796\u17B7\u1795\u17C5"},{"id":422,"word":"\u1780\u17B6\u1796\u17D2\u1799"},{"id":423,"word":"\u1780\u17B6\u1798"},{"id":424,"word":"\u1780\u17B6\u1798--"},{"id":425,"word":"\u1780\u17B6\u1799"},{"id":426,"word":"\u1780\u17B6\u1799--"},{"id":427,"word":"\u1780\u17B6\u178E\u17CC"},{"id":428,"word":"\u1780\u17B6\u1794\u17CC\u17B6\u179F"},{"id":429,"word":"\u1780\u17B6\u179A"},{"id":430,"word":"\u1780\u17B6\u179A\u1780\u1793\u17B6\u1798"},{"id":431,"word":"\u1780\u17B6\u179A\u1780\u17C1\u178F"},{"id":432,"word":"\u1780\u17B6\u179A\u1784\u17B6\u179A"},{"id":433,"word":"\u1780\u17B6\u179A\u178A\u17D2\u178B\u17B6\u1793"},{"id":434,"word":"\u1780\u17B6\u179A\u178E\u17CD"},{"id":435,"word":"\u1780\u17B6\u179A\u1793\u17D2\u178F"},{"id":436,"word":"\u1780\u17B6\u179A\u1796\u17B6\u179A"},{"id":437,"word":"\u1780\u17B6\u179A\u17B6\u178F\u17CB"},{"id":438,"word":"\u1780\u17B6\u179A\u17B7\u1799\u1780\u1798\u17D2\u1798"},{"id":439,"word":"\u1780\u17B6\u179A\u17B7\u1799\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791"},{"id":440,"word":"\u1780\u17B6\u179A\u17B7\u1799\u17B6\u179B\u17D0\u1799"},{"id":441,"word":"\u1780\u17B6\u179A\u17B8"},{"id":442,"word":"\u1780\u17B6\u179A\u17B8"},{"id":443,"word":"\u1780\u17B6\u179A\u17BB\u1784"},{"id":444,"word":"\u1780\u17B6\u179A\u17BB\u1789\u17D2\u1789\u1785\u17B7\u178F\u17D2\u178F"},{"id":445,"word":"\u1780\u17B6\u179A\u17BB\u1789\u17D2\u1789\u1797\u17B6\u1796"},{"id":446,"word":"\u1780\u17B6\u179A\u17BB\u178E\u17B7\u1780"},{"id":447,"word":"\u1780\u17B6\u179B"},{"id":448,"word":"\u1780\u17B6\u179B\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":449,"word":"\u1780\u17B6\u179B\u17C8\u1791\u17C1\u179F\u17C8"},{"id":450,"word":"\u1780\u17B6\u179B\u17CB"},{"id":451,"word":"\u1780\u17B6\u179B\u17B7\u1780"},{"id":452,"word":"\u1780\u17B6\u179B\u17B7\u1780\u1794\u178F\u17D2\u179A"},{"id":453,"word":"\u1780\u17B6\u179C"},{"id":454,"word":"\u1780\u17B6\u179F"},{"id":455,"word":"\u1780\u17B6\u179F\u17A2\u1784\u17D2\u1780\u179A"},{"id":456,"word":"\u1780\u17B6\u179F\u17B6\u179C\u1796\u179F\u17D2\u178F\u17D2\u179A"},{"id":457,"word":"\u1780\u17B6\u179F\u17C2\u178F"},{"id":458,"word":"\u1780\u17B6\u17A0\u17B6\u178F"},{"id":459,"word":"\u1780\u17B6\u17A0\u17C2"},{"id":460,"word":"\u1780\u17B6\u17A0\u17C4"},{"id":461,"word":"\u1780\u17B6\u17A1\u1780\u178E\u17D2\u178E\u17B8"},{"id":462,"word":"\u1780\u17B6\u17A1\u1780\u17B7\u178E\u17B8"},{"id":463,"word":"\u1780\u17B6\u17A1\u17B6"},{"id":464,"word":"\u1780\u17B6\u17A1\u17B6\u1794\u17C9\u17B6"},{"id":465,"word":"\u1780\u17B6\u17A1\u17B8"},{"id":466,"word":"\u1780\u17B6\u17A1\u17C3"},{"id":467,"word":"\u1780\u17B7\u1780\u17B7"},{"id":468,"word":"\u1780\u17B7\u1780\u1780\u17BB\u1780"},{"id":469,"word":"\u1780\u17B7\u1784"},{"id":470,"word":"\u1780\u17B7\u1785\u17D2\u1785"},{"id":471,"word":"\u1780\u17B7\u178F"},{"id":472,"word":"\u1780\u17B7\u178F\u1793\u17B6\u1798"},{"id":473,"word":"\u1780\u17B7\u178F\u17A2\u17B6\u1785\u1798\u17CD"},{"id":474,"word":"\u1780\u17B7\u178F\u17D2\u178F\u17B7"},{"id":475,"word":"\u1780\u17B7\u178F\u17D2\u178F\u17B7\u1782\u17BB\u178E"},{"id":476,"word":"\u1780\u17B7\u178F\u17D2\u178F\u17B7\u1793\u17B6\u1798"},{"id":477,"word":"\u1780\u17B7\u178F\u17D2\u178F\u17B7\u1799\u179F"},{"id":478,"word":"\u1780\u17B7\u178F\u17D2\u178F\u17B7\u179F\u1796\u17D2\u1791"},{"id":479,"word":"\u1780\u17B7\u178F\u17D2\u1799\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":480,"word":"\u1780\u17B7\u1793"},{"id":481,"word":"\u1780\u17B7\u1793\u17D2\u1793\u179A"},{"id":482,"word":"\u1780\u17B7\u1794"},{"id":483,"word":"\u1780\u17B7\u1798\u17B7\u1787\u17B6\u178F\u17B7"},{"id":484,"word":"\u1780\u17B7\u179A\u17D2\u178F\u17B7\u17CD"},{"id":485,"word":"\u1780\u17B7\u179A\u17D2\u178F\u17B7\u179F\u1796\u17D2\u1791"},{"id":486,"word":"\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":487,"word":"\u1780\u17B7\u179A\u17B7\u1799\u17B6\u179C\u17B7\u179F\u17C1\u179F\u1793\u17CD"},{"id":488,"word":"\u1780\u17B7\u179A\u17B7\u1799\u17B6\u179F\u1796\u17D2\u1791"},{"id":489,"word":"\u1780\u17B7\u179B"},{"id":490,"word":"\u1780\u17B7\u179B\u17C1\u179F"},{"id":491,"word":"\u1780\u17B8"},{"id":492,"word":"\u1780\u17B8\u179B\u17C2\u1793"},{"id":493,"word":"\u1780\u17B8\u17A1\u178A\u17D2\u178B\u17B6\u1793"},{"id":494,"word":"\u1780\u17B8\u17A1\u17B6"},{"id":495,"word":"\u1780\u17B8\u17A1\u17B6\u1798\u178E\u17D2\u178C\u179B"},{"id":496,"word":"\u1780\u17B8\u17A1\u17B6\u17A2\u178F\u17D2\u178F\u1796\u179B\u1780\u1798\u17D2\u1798"},{"id":497,"word":"\u1780\u17B9\u1784\u1780\u1793\u17D2\u178F\u17D2\u179A\u17C3"},{"id":498,"word":"\u1780\u17B9\u17C7"},{"id":499,"word":"\u1780\u17BB\u1780"},{"id":500,"word":"\u1780\u17BB\u1780\u17D2\u1780\u17BB\u178A\u1793\u17C1\u178F\u17D2\u179A"},{"id":501,"word":"\u1780\u17BB\u1784"},{"id":502,"word":"\u1780\u17BB\u1784\u1780\u17B6\u1794\u17CB"},{"id":503,"word":"\u1780\u17BB\u1784\u1795\u17B6\u178F\u17CB"},{"id":504,"word":"\u1780\u17BB\u1784\u17D2\u179F\u17B8\u1799\u17CD"},{"id":505,"word":"\u1780\u17BB\u1784\u17D2\u179F\u17B8\u1799\u17CD\u179F\u17C1\u1793\u17B6\u1794\u178F\u17B8"},{"id":506,"word":"\u1780\u17BB\u1784\u179F\u17CA\u17B8"},{"id":507,"word":"\u1780\u17BB\u1784\u179F\u17CA\u17BB\u179B"},{"id":508,"word":"\u1780\u17BB\u1789"},{"id":509,"word":"\u1780\u17BB\u1789\u17D2\u1787\u179A"},{"id":510,"word":"\u1780\u17BB\u1789\u17D2\u1787\u179A\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":511,"word":"\u1780\u17BB\u178A\u17B7"},{"id":512,"word":"\u1780\u17BB\u178A\u17B7\u1780\u1797\u178F\u17D2\u178F"},{"id":513,"word":"\u1780\u17BB\u178A\u17BB\u1798\u17D2\u1796\u17B7\u1780\u17C8"},{"id":514,"word":"\u1780\u17BB\u178E\u17D2\u178C\u1780"},{"id":515,"word":"\u1780\u17BB\u178E\u17D2\u178C\u179B"},{"id":516,"word":"\u1780\u17BB\u178E\u17D2\u178C\u17B8"},{"id":517,"word":"\u1780\u17BB\u1791\u17B7\u178A\u17D2\u178B\u17B7"},{"id":518,"word":"\u1780\u17BB\u1793"},{"id":519,"word":"\u1780\u17BB\u1794"},{"id":520,"word":"\u1780\u17BB\u1794\u1780\u1798\u17D2\u1798"},{"id":521,"word":"\u1780\u17BB\u1794\u1780\u179A"},{"id":522,"word":"\u1780\u17BB\u1798\u17B6\u179A"},{"id":523,"word":"\u1780\u17BB\u1798\u17B6\u179A\u178A\u17D2\u178B\u17B6\u1793"},{"id":524,"word":"\u1780\u17BB\u1798\u17B6\u179A\u1797\u17B6\u1796"},{"id":525,"word":"\u1780\u17BB\u1798\u17B6\u179A\u179F\u1784\u17D2\u1782\u17D2\u179A\u17C4\u17C7"},{"id":526,"word":"\u1780\u17BB\u1798\u17B6\u179A\u17B6\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":527,"word":"\u1780\u17BB\u1798\u17B6\u179A\u17B8"},{"id":528,"word":"\u1780\u17BB\u1798\u17BB\u1791"},{"id":529,"word":"\u1780\u17BB\u1798\u17D2\u1797\u17C8"},{"id":530,"word":"\u1780\u17BB\u1798\u17D2\u1797\u1780\u17B6\u179A"},{"id":531,"word":"\u1780\u17BB\u1798\u17D2\u1797\u1780\u17B6\u179A\u178A\u17D2\u178B\u17B6\u1793"},{"id":532,"word":"\u1780\u17BB\u1798\u17D2\u1797\u178E\u17D2\u178C"},{"id":533,"word":"\u1780\u17BB\u1799"},{"id":534,"word":"\u1780\u17BB\u179A"},{"id":535,"word":"\u1780\u17BB\u179B\u1792\u17B8\u178F\u17B6"},{"id":536,"word":"\u1780\u17BB\u179B\u1794\u179B\u17B7\u1796\u17C4\u1792"},{"id":537,"word":"\u1780\u17BB\u179B\u1794\u17BB\u178F\u17D2\u179A"},{"id":538,"word":"\u1780\u17BB\u179B\u1796\u17B7\u179A\u17C4\u1792"},{"id":539,"word":"\u1780\u17BB\u179B\u1798\u1785\u17D2\u1786\u179A\u17B7\u1799\u17C8"},{"id":540,"word":"\u1780\u17BB\u179B\u179C\u1782\u17D2\u1782"},{"id":541,"word":"\u1780\u17BB\u179B\u179C\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":542,"word":"\u1780\u17BB\u179B\u179F\u1798\u17D2\u1794\u178F\u17D2\u178F\u17B7"},{"id":543,"word":"\u1780\u17BB\u179B\u179F\u1798\u17D2\u1796\u17D0\u1793\u17D2\u1792"},{"id":544,"word":"\u1780\u17BB\u179B\u179C\u17C6\u179F\u17C8"},{"id":545,"word":"\u1780\u17BB\u179B\u17B6\u1794"},{"id":546,"word":"\u1780\u17BB\u179B\u17B6\u179B\u1797\u17B6\u1787\u1793\u17CD"},{"id":547,"word":"\u1780\u17BB\u179F\u179B"},{"id":548,"word":"\u1780\u17BB\u179F\u179B\u17C4\u1794\u17B6\u1799"},{"id":549,"word":"\u1780\u17BB\u179F\u17B7\u1793\u17B6\u179A\u17B6"},{"id":550,"word":"\u1780\u17BB\u179F\u17B8\u178F\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":551,"word":"\u1780\u17BB\u179F\u17BB\u1798"},{"id":552,"word":"\u1780\u17BB\u17A0\u1780"},{"id":553,"word":"\u1780\u17BB\u17C7"},{"id":554,"word":"\u1780\u17BB\u17C7\u1780\u179A"},{"id":555,"word":"\u1780\u17BB\u17A1\u17B6"},{"id":556,"word":"\u1780\u17BC\u17CE\u1780!"},{"id":557,"word":"\u1780\u17BC\u17CE\u1780\u17D7"},{"id":558,"word":"\u1780\u17BC\u178A\u1780\u1798\u17D2\u1798"},{"id":559,"word":"\u1780\u17BC\u178A\u17C4\u1794\u17B6\u1799"},{"id":560,"word":"\u1780\u17BC\u178F"},{"id":561,"word":"\u1780\u17BC\u1793"},{"id":562,"word":"\u1780\u17BC\u1793\u1780\u178E\u17D2\u178A\u17BB\u179A"},{"id":563,"word":"\u1780\u17BC\u1793\u1780\u17C6\u1796\u17D2\u179A\u17B6"},{"id":564,"word":"\u1780\u17BC\u1793\u1780\u17D2\u179A\u17B6\u1789\u17CB"},{"id":565,"word":"\u1780\u17BC\u1793\u1782\u17C4\u179B"},{"id":566,"word":"\u1780\u17BC\u1793\u1782\u17D2\u179B\u17B8"},{"id":567,"word":"\u1780\u17BC\u1793\u1785\u17B6\u1794"},{"id":568,"word":"\u1780\u17BC\u1793\u1787\u1789\u17D2\u1787\u17B8\u1784"},{"id":569,"word":"\u1780\u17BC\u1793\u178F\u17B9\u1784"},{"id":570,"word":"\u1780\u17BC\u1793\u1791\u17C4\u179B"},{"id":571,"word":"\u1780\u17BC\u1793\u1794\u17D2\u179A\u1799\u17C4\u179B"},{"id":572,"word":"\u1780\u17BC\u1793\u179B\u1784"},{"id":573,"word":"\u1780\u17BC\u1793\u179B\u17C4\u1780"},{"id":574,"word":"\u1780\u17BC\u1793\u179F\u1784\u17D2\u1780\u178F\u17CB"},{"id":575,"word":"\u1780\u17BC\u1793\u179F\u179A"},{"id":576,"word":"\u1780\u17BC\u1793\u179F\u17D2\u1784\u17BE\u1793"},{"id":577,"word":"\u1780\u17BC\u1794"},{"id":578,"word":"\u1780\u17BC\u1794\u17D7"},{"id":579,"word":"\u1780\u17BC\u179A"},{"id":580,"word":"\u1780\u17BC\u179C"},{"id":581,"word":"\u1780\u17BC\u179C\u1780\u17C2"},{"id":582,"word":"\u1780\u17BD\u1785"},{"id":583,"word":"\u1780\u17BD\u178F"},{"id":584,"word":"\u1780\u17BD\u1793"},{"id":585,"word":"\u1780\u17BD\u1799"},{"id":586,"word":"\u1780\u17BD\u179A"},{"id":587,"word":"\u1780\u17BE"},{"id":588,"word":"\u1780\u17BE\u1784"},{"id":589,"word":"\u1780\u17BE\u1785"},{"id":590,"word":"\u1780\u17BE\u178F"},{"id":591,"word":"\u1780\u17BE\u178F\u1780\u17D2\u178A\u17B8"},{"id":592,"word":"\u1780\u17BE\u1793"},{"id":593,"word":"\u1780\u17BE\u1794"},{"id":594,"word":"\u1780\u17BE\u1799"},{"id":595,"word":"\u1780\u17BE\u179B"},{"id":596,"word":"\u1780\u17BE\u179B\u1794\u17D2\u179A\u17BE\u179F"},{"id":597,"word":"\u1780\u17BF\u1784"},{"id":598,"word":"\u1780\u17C0\u1780"},{"id":599,"word":"\u1780\u17C0\u1784"},{"id":600,"word":"\u1780\u17C0\u1785"},{"id":601,"word":"\u1780\u17C0\u178F"},{"id":602,"word":"\u1780\u17C0\u1793"},{"id":603,"word":"\u1780\u17C0\u1793\u179F\u17D2\u179C\u17B6\u1799"},{"id":604,"word":"\u1780\u17C0\u1794"},{"id":605,"word":"\u1780\u17C0\u179A"},{"id":606,"word":"\u1780\u17C0\u179A\u1782\u179A"},{"id":607,"word":"\u1780\u17C0\u179C"},{"id":608,"word":"\u1780\u17C0\u179F"},{"id":609,"word":"\u1780\u17C1\u1780\u17D7"},{"id":610,"word":"\u1780\u17C1\u1784"},{"id":611,"word":"\u1780\u17C1\u1784\u1780\u1784"},{"id":612,"word":"\u1780\u17C1\u1784\u1780\u17B6\u1784"},{"id":613,"word":"\u1780\u17C1\u178E\u17D2\u178C"},{"id":614,"word":"\u1780\u17C1\u178F\u1793\u1797\u178E\u17D2\u178C"},{"id":615,"word":"\u1780\u17C1\u178F\u17BB"},{"id":616,"word":"\u1780\u17C1\u178F\u17BB\u1798\u17B6\u179B\u17B6"},{"id":617,"word":"\u1780\u17C1\u179A"},{"id":618,"word":"\u1780\u17C1\u179A\u1780\u17B6\u179B"},{"id":619,"word":"\u1780\u17C1\u179A\u17D2\u178F\u17B7\u17CD"},{"id":620,"word":"\u1780\u17C1\u179A\u17B6\u178A\u17B7\u1780\u1787\u1793"},{"id":621,"word":"\u1780\u17C1\u179B"},{"id":622,"word":"\u1780\u17C1\u179C"},{"id":623,"word":"\u1780\u17C1\u179F"},{"id":624,"word":"\u1780\u17C1\u179F\u179A"},{"id":625,"word":"\u1780\u17C1\u179F\u179A\u179F\u17B8\u17A0\u17C8"},{"id":626,"word":"\u1780\u17C1\u17C7"},{"id":627,"word":"\u1780\u17C2"},{"id":628,"word":"\u1780\u17C2\u1780"},{"id":629,"word":"\u1780\u17C2\u1780\u17D2\u179A\u17B6\u1799"},{"id":630,"word":"\u1780\u17C2\u1781\u17C3"},{"id":631,"word":"\u1780\u17C2\u1784"},{"id":632,"word":"\u1780\u17C2\u1784\u1780\u17C4\u1784"},{"id":633,"word":"\u1780\u17C2\u1793"},{"id":634,"word":"\u1780\u17C2\u1794"},{"id":635,"word":"\u1780\u17C2\u1798"},{"id":636,"word":"\u1780\u17C2\u179C"},{"id":637,"word":"\u1780\u17C2\u179F"},{"id":638,"word":"\u1780\u17C2\u17A2\u17BD\u1780"},{"id":639,"word":"\u1780\u17C2\u17C7"},{"id":640,"word":"\u1780\u17C3"},{"id":641,"word":"\u1780\u17C3\u179B\u17B6\u179F"},{"id":642,"word":"\u1780\u17C4\u1780\u17D7"},{"id":643,"word":"\u1780\u17C4\u1784"},{"id":644,"word":"\u1780\u17C4\u1789\u17D2\u1785\u1793\u17B6\u1791"},{"id":645,"word":"\u1780\u17C4\u178A\u17B7"},{"id":646,"word":"\u1780\u17C4\u178A\u17D2\u178B"},{"id":647,"word":"\u1780\u17C4\u178E"},{"id":648,"word":"\u1780\u17C4\u178F"},{"id":649,"word":"\u1780\u17C4\u1793"},{"id":650,"word":"\u1780\u17C4\u1794"},{"id":651,"word":"\u1780\u17C4\u1798\u179B"},{"id":652,"word":"\u1780\u17C4\u1799"},{"id":653,"word":"\u1780\u17C4\u179A"},{"id":654,"word":"\u1780\u17C4\u179B\u17B6\u17A0\u179B"},{"id":655,"word":"\u1780\u17C4\u179F"},{"id":656,"word":"\u1780\u17C4\u179F\u179A\u17BC\u179F"},{"id":657,"word":"\u1780\u17C4\u179F\u179B\u17D2\u179B"},{"id":658,"word":"\u1780\u17C4\u179F\u17B7\u1799"},{"id":659,"word":"\u1780\u17C4\u179F\u17BB\u1798"},{"id":660,"word":"\u1780\u17C4\u179F\u17C1\u1799\u17D2\u1799"},{"id":661,"word":"\u1780\u17C4\u179F\u17C1\u1799\u17D2\u1799\u1796\u179F\u17D2\u178A\u17D2\u179A"},{"id":662,"word":"\u1780\u17C4\u179F\u17C1\u1799\u17D2\u1799\u179C\u1794\u17D2\u1794\u1780\u1798\u17D2\u1798"},{"id":663,"word":"\u1780\u17C4\u179F\u17C1\u1799\u17D2\u1799\u179C\u1794\u17D2\u1794\u1780\u179A"},{"id":664,"word":"\u1780\u17C4\u17C7"},{"id":665,"word":"\u1780\u17C4\u17C7\u1780\u17BB\u1784"},{"id":666,"word":"\u1780\u17C4\u17C7\u1792\u17C6"},{"id":667,"word":"\u1780\u17C4\u17C7\u179F\u17BC\u1791\u17B7\u1793"},{"id":668,"word":"\u1780\u17C4\u17C7\u17A2\u178E\u17D2\u178A\u17C2\u178F"},{"id":669,"word":"\u1780\u17C5\u1791\u178E\u17D2\u178C"},{"id":670,"word":"\u1780\u17C5\u1799\u1780\u17CB"},{"id":671,"word":"\u1780\u17C5\u179F\u17B7\u1794"},{"id":672,"word":"\u1780\u17C5\u179F\u17CA\u17BC"},{"id":673,"word":"\u1780\u17C5\u17A0\u17B6\u1799"},{"id":674,"word":"\u1780\u17C5\u17A1\u17B6\u1780\u17CB"},{"id":675,"word":"\u1780\u17C5\u17A1\u17C5"},{"id":676,"word":"\u1780\u17C5\u17A2\u17B8"},{"id":677,"word":"\u1780\u17C5\u17A2\u17BC\u179C"},{"id":678,"word":"\u1780\u17BB\u17C6"},{"id":679,"word":"\u1780\u17C6\u1785\u17B6\u1799"},{"id":680,"word":"\u1780\u17C6\u1785\u17B6\u1799\u1798\u17B6\u179A"},{"id":681,"word":"\u1780\u17C6\u1785\u17C4\u1780"},{"id":682,"word":"\u1780\u17C6\u1785\u17C4\u1780\u179A\u17C4\u1780"},{"id":683,"word":"\u1780\u17C6\u1789\u1798"},{"id":684,"word":"\u1780\u17C6\u1789\u17B6\u1793"},{"id":685,"word":"\u1780\u17C6\u1789\u17BE\u1789"},{"id":686,"word":"\u1780\u17C6\u178A\u179A"},{"id":687,"word":"\u1780\u17C6\u178A\u17B9\u1784"},{"id":688,"word":"\u1780\u17C6\u178E\u1780"},{"id":689,"word":"\u1780\u17C6\u178E\u178F\u17CB"},{"id":690,"word":"\u1780\u17C6\u178E\u178F\u17CB\u17A0\u17C1\u178F\u17BB"},{"id":691,"word":"\u1780\u17C6\u178E\u1794\u17CB"},{"id":692,"word":"\u1780\u17C6\u178E\u179B\u17CB"},{"id":693,"word":"\u1780\u17C6\u178E\u17B6\u179A"},{"id":694,"word":"\u1780\u17C6\u178E\u17B6\u1785"},{"id":695,"word":"\u1780\u17C6\u178E\u17B6\u1785\u17CB"},{"id":696,"word":"\u1780\u17C6\u178E\u17B6\u1789\u17CB"},{"id":697,"word":"\u1780\u17C6\u178E\u17B6\u178F\u17CB"},{"id":698,"word":"\u1780\u17C6\u178E\u17B6\u1793\u17CB"},{"id":699,"word":"\u1780\u17C6\u178E\u17B6\u1796\u17D2\u1799"},{"id":700,"word":"\u1780\u17C6\u178E\u17B7\u1793"},{"id":701,"word":"\u1780\u17C6\u178E\u17BD\u1785"},{"id":702,"word":"\u1780\u17C6\u178E\u17BE\u178F"},{"id":703,"word":"\u1780\u17C6\u178E\u17BE\u1793"},{"id":704,"word":"\u1780\u17C6\u178E\u17BE\u179B"},{"id":705,"word":"\u1780\u17C6\u178E\u17C0\u1784"},{"id":706,"word":"\u1780\u17C6\u178E\u17C0\u1785"},{"id":707,"word":"\u1780\u17C6\u178E\u17C0\u179A"},{"id":708,"word":"\u1780\u17C6\u178E\u17C0\u179C"},{"id":709,"word":"\u1780\u17C6\u178E\u17C0\u179F"},{"id":710,"word":"\u1780\u17C6\u178E\u17C1\u17C7"},{"id":711,"word":"\u1780\u17C6\u178E\u17C2"},{"id":712,"word":"\u1780\u17C6\u178E\u17C2\u1793"},{"id":713,"word":"\u1780\u17C6\u178E\u17C4\u1784"},{"id":714,"word":"\u1780\u17C6\u178E\u17C4\u178F"},{"id":715,"word":"\u1780\u17C6\u178E\u17C4\u1793"},{"id":716,"word":"\u1780\u17C6\u178E\u17C4\u179A"},{"id":717,"word":"\u1780\u17C6\u178E\u17C4\u179F"},{"id":718,"word":"\u1780\u17C6\u178E\u17C4\u17C7"},{"id":719,"word":"\u1780\u17C6\u1793\u17BD\u1785"},{"id":720,"word":"\u1780\u17C6\u1793\u17C0\u179A"},{"id":721,"word":"\u1780\u17C6\u1794\u17B6\u1780\u17CB"},{"id":722,"word":"\u1780\u17C6\u1794\u17B6\u1794"},{"id":723,"word":"\u1780\u17C6\u1794\u17BB\u178F"},{"id":724,"word":"\u1780\u17C6\u1794\u17BB\u178F\u1785\u17D2\u179A\u1798\u17BB\u17C7"},{"id":725,"word":"\u1780\u17C6\u1794\u17BB\u178F\u178F\u17D2\u1794\u17BC\u1784"},{"id":726,"word":"\u1780\u17C6\u1794\u17BC\u179C"},{"id":727,"word":"\u1780\u17C6\u1794\u17C2\u1780"},{"id":728,"word":"\u1780\u17C6\u1794\u17C4\u179A"},{"id":729,"word":"\u1780\u17C6\u1794\u17B6\u17C6\u1784"},{"id":730,"word":"\u1780\u17C6\u1794\u17C9\u17BB\u1784"},{"id":731,"word":"\u1780\u17C6\u1794\u17C9\u17B6\u1784"},{"id":732,"word":"\u1780\u17C6\u1794\u17C9\u17B6\u178F"},{"id":733,"word":"\u1780\u17C6\u1794\u17C9\u17B7\u1780\u1780\u17C6\u1794\u17C9\u17BB\u1780"},{"id":734,"word":"\u1780\u17C6\u1794\u17C9\u17BA\u178F"},{"id":735,"word":"\u1780\u17C6\u1794\u17C9\u17BB\u1780"},{"id":736,"word":"\u1780\u17C6\u1794\u17C9\u17BB\u179B"},{"id":737,"word":"\u1780\u17C6\u1794\u17C9\u17BC\u178F"},{"id":738,"word":"\u1780\u17C6\u1794\u17C9\u17BE\u1789"},{"id":739,"word":"\u1780\u17C6\u1794\u17C9\u17C1\u1784"},{"id":740,"word":"\u1780\u17C6\u1794\u17C9\u17C1\u179C\u17A2\u17B6\u179A\u17C9\u17C1\u179C"},{"id":741,"word":"\u1780\u17C6\u1794\u17C9\u17C1\u17C7"},{"id":742,"word":"\u1780\u17C6\u1794\u17C9\u17C2\u178F"},{"id":743,"word":"\u1780\u17C6\u1794\u17C9\u17C4\u1784"},{"id":744,"word":"\u1780\u17C6\u1794\u17C9\u17C4\u1799"},{"id":745,"word":"\u1780\u17C6\u1794\u17D2\u179A\u17BB\u1780"},{"id":746,"word":"\u1780\u17C6\u1794\u17D2\u179A\u17C1\u179C"},{"id":747,"word":"\u1780\u17C6\u1794\u17D2\u179A\u17C4\u1784"},{"id":748,"word":"\u1780\u17C6\u1794\u17D2\u179A\u17C4\u1793"},{"id":749,"word":"\u1780\u17C6\u1794\u17D2\u179B\u1784\u17CB"},{"id":750,"word":"\u1780\u17C6\u1794\u17D2\u179B\u17BB\u1780"},{"id":751,"word":"\u1780\u17C6\u1794\u17D2\u179B\u17BC\u1785"},{"id":752,"word":"\u1780\u17C6\u1794\u17D2\u179B\u17C2\u1784"},{"id":753,"word":"\u1780\u17C6\u1794\u17D2\u179B\u17C4\u1780"},{"id":754,"word":"\u1780\u17C6\u1795\u17B7\u178F"},{"id":755,"word":"\u1780\u17C6\u1795\u17C2\u1784"},{"id":756,"word":"\u1780\u17C6\u1795\u17C2\u179B"},{"id":757,"word":"\u1780\u17C6\u1795\u17D2\u179B\u17B9\u1798"},{"id":758,"word":"\u1780\u17C6\u1795\u17D2\u179B\u17C0\u1784"},{"id":759,"word":"\u1780\u17C6\u1795\u17D2\u179B\u17C0\u179C"},{"id":760,"word":"\u1780\u17C6\u1795\u17D2\u179B\u17C1\u179F"},{"id":761,"word":"\u1780\u17C6\u1796\u1780"},{"id":762,"word":"\u1780\u17C6\u1796\u1784\u17CB"},{"id":763,"word":"\u1780\u17C6\u1796\u178F"},{"id":764,"word":"\u1780\u17C6\u1796\u1794\u17CB"},{"id":765,"word":"\u1780\u17C6\u1796\u1799"},{"id":766,"word":"\u1780\u17C6\u1796\u17B6\u1784"},{"id":767,"word":"\u1780\u17C6\u1796\u17B6\u1789"},{"id":768,"word":"\u1780\u17C6\u1796\u17B6\u1799"},{"id":769,"word":"\u1780\u17C6\u1796\u17B8\u1780\u1780\u17C6\u1796\u1780"},{"id":770,"word":"\u1780\u17C6\u1796\u17B8\u1784"},{"id":771,"word":"\u1780\u17C6\u1796\u17B8\u1784\u178A\u17BC\u1784"},{"id":772,"word":"\u1780\u17C6\u1796\u17B8\u1784\u1796\u17BD\u1799"},{"id":773,"word":"\u1780\u17C6\u1796\u17B9\u179F"},{"id":774,"word":"\u1780\u17C6\u1796\u17BB\u1780"},{"id":775,"word":"\u1780\u17C6\u1796\u17BB\u1784"},{"id":776,"word":"\u1780\u17C6\u1796\u17BC\u1780"},{"id":777,"word":"\u1780\u17C6\u1796\u17BC\u1787"},{"id":778,"word":"\u1780\u17C6\u1796\u17BC\u179B"},{"id":779,"word":"\u1780\u17C6\u1796\u17BD\u179A"},{"id":780,"word":"\u1780\u17C6\u1796\u17BE\u1784"},{"id":781,"word":"\u1780\u17C6\u1796\u17C0\u1785"},{"id":782,"word":"\u1780\u17C6\u1796\u17C2\u1784"},{"id":783,"word":"\u1780\u17C6\u1796\u17C4\u1784"},{"id":784,"word":"\u1780\u17C6\u1796\u17D2\u179A\u1799"},{"id":785,"word":"\u1780\u17C6\u1796\u17D2\u179A\u17B6"},{"id":786,"word":"\u1780\u17C6\u1796\u17D2\u179A\u17B9\u1784"},{"id":787,"word":"\u1780\u17C6\u1796\u17D2\u179A\u17B9\u179F"},{"id":788,"word":"\u1780\u17C6\u1796\u17D2\u179A\u17BE\u179B"},{"id":789,"word":"\u1780\u17C6\u1797\u179A"},{"id":790,"word":"\u1780\u17C6\u1797\u17BC\u178F"},{"id":791,"word":"\u1780\u17C6\u1797\u17BD\u1793"},{"id":792,"word":"\u1780\u17C6\u1797\u17BD\u1793\u1787\u17BE\u1784"},{"id":793,"word":"\u1780\u17C6\u1797\u17BD\u1793\u178A\u17C3"},{"id":794,"word":"\u1780\u17C6\u1797\u17C1\u1798"},{"id":795,"word":"\u1780\u17C6\u1797\u17C2\u179B"},{"id":796,"word":"\u1780\u17C6\u1797\u17D2\u179B\u17B6\u1789"},{"id":797,"word":"\u1780\u17C6\u1797\u17D2\u179B\u17B9\u1784"},{"id":798,"word":"\u1780\u17C6\u179A\u17BE\u1794"},{"id":799,"word":"\u1780\u17C6\u179A\u17C4\u179B"},{"id":800,"word":"\u1780\u17C6\u179B\u17BB\u1784"},{"id":801,"word":"\u1780\u17C6\u179B\u17C4\u17C7"},{"id":802,"word":"\u1780\u17C6\u179F\u17B6\u1780"},{"id":803,"word":"\u1780\u17C6\u179F\u17B6\u1780\u1789\u17B8"},{"id":804,"word":"\u1780\u17C6\u179F\u17BD\u179B"},{"id":805,"word":"\u1780\u17C6\u179F\u17C0\u179C"},{"id":806,"word":"\u1780\u17C6\u17A0\u179B\u17CB"},{"id":807,"word":"\u1780\u17C6\u17A0\u17B6\u1780"},{"id":808,"word":"\u1780\u17C6\u17A0\u17B6\u178F"},{"id":809,"word":"\u1780\u17C6\u17A0\u17B7\u178F"},{"id":810,"word":"\u1780\u17C6\u17A0\u17B7\u179B"},{"id":811,"word":"\u1780\u17C6\u17A0\u17B9\u1784"},{"id":812,"word":"\u1780\u17C6\u17A0\u17BB\u179B"},{"id":813,"word":"\u1780\u17C6\u17A0\u17BB\u179F"},{"id":814,"word":"\u1780\u17C6\u17A0\u17BC\u1785"},{"id":815,"word":"\u1780\u17C6\u17A0\u17BE\u1785"},{"id":816,"word":"\u1780\u17C6\u17A0\u17C2\u1784"},{"id":817,"word":"\u1780\u17C6\u17A0\u17C4\u1780"},{"id":818,"word":"\u1780\u17C6\u17A2\u17BD\u1780"},{"id":819,"word":"\u1780\u17B6\u17C6"},{"id":820,"word":"\u1780\u17B6\u17C6\u1787\u17D2\u179A\u17BD\u1785"},{"id":821,"word":"\u1780\u17B6\u17C6\u1794\u17B7\u178F"},{"id":822,"word":"\u1780\u17B6\u17C6\u1794\u17D2\u179A\u1798\u17B6"},{"id":823,"word":"\u1780\u17B6\u17C6\u1797\u17D2\u179B\u17C4\u17C7"},{"id":824,"word":"\u1780\u17B6\u17C6\u1797\u17D2\u179B\u17BE\u1784"},{"id":825,"word":"\u1780\u17B6\u17C6\u1798\u17D2\u179A\u17B9\u178F"},{"id":826,"word":"\u1780\u17B6\u17C6\u179A\u1793\u17D2\u1791\u17C7"},{"id":827,"word":"\u1780\u17D2\u1784"},{"id":828,"word":"\u1780\u17D2\u1784\u1780\u17CB"},{"id":829,"word":"\u1780\u17D2\u1784\u1784\u17CB"},{"id":830,"word":"\u1780\u17D2\u1784\u17B6\u1793"},{"id":831,"word":"\u1780\u17D2\u1784\u17B7\u1784\u1780\u17D2\u1784\u1784\u17CB"},{"id":832,"word":"\u1780\u17D2\u1784\u17B7\u1785"},{"id":833,"word":"\u1780\u17D2\u1784\u17B7\u1785\u1780\u17D2\u1784\u1780\u17CB"},{"id":834,"word":"\u1780\u17D2\u1784\u17B7\u178F"},{"id":835,"word":"\u1780\u17D2\u1784\u17BB\u1780"},{"id":836,"word":"\u1780\u17D2\u1784\u17BB\u1784"},{"id":837,"word":"\u1780\u17D2\u1784\u17BB\u179B"},{"id":838,"word":"\u1780\u17D2\u1784\u17BB\u17C7"},{"id":839,"word":"\u1780\u17D2\u1784\u17BD\u179A"},{"id":840,"word":"\u1780\u17D2\u1784\u17C0\u1780"},{"id":841,"word":"\u1780\u17D2\u1784\u17C0\u1784"},{"id":842,"word":"\u1780\u17D2\u1784\u17C1\u17C7"},{"id":843,"word":"\u1780\u17D2\u1784\u17C2\u1784"},{"id":844,"word":"\u1780\u17D2\u1784\u17C4\u1780"},{"id":845,"word":"\u1780\u17D2\u178A"},{"id":846,"word":"\u1780\u17D2\u178A\u1780\u17CB"},{"id":847,"word":"\u1780\u17D2\u178A\u1793\u17CB"},{"id":848,"word":"\u1780\u17D2\u178A\u17B6\u178F"},{"id":849,"word":"\u1780\u17D2\u178A\u17B6\u178F\u17CB"},{"id":850,"word":"\u1780\u17D2\u178A\u17B6\u1793\u17CB"},{"id":851,"word":"\u1780\u17D2\u178A\u17B6\u1794\u17CB"},{"id":852,"word":"\u1780\u17D2\u178A\u17B6\u1798"},{"id":853,"word":"\u1780\u17D2\u178A\u17B6\u1798\u1791\u17BC\u1780"},{"id":854,"word":"\u1780\u17D2\u178A\u17B6\u179A"},{"id":855,"word":"\u1780\u17D2\u178A\u17B6\u179A\u1781\u17C0\u1793"},{"id":856,"word":"\u1780\u17D2\u178A\u17B6\u179A\u1786\u17D2\u1793\u17BD\u1793"},{"id":857,"word":"\u1780\u17D2\u178A\u17B7\u1785"},{"id":858,"word":"\u1780\u17D2\u178A\u17B7\u178F"},{"id":859,"word":"\u1780\u17D2\u178A\u17B8"},{"id":860,"word":"\u1780\u17D2\u178A\u17B8\u1780\u17D2\u178A\u17B6\u17C6"},{"id":861,"word":"\u1780\u17D2\u178A\u17B8\u178E\u17B6"},{"id":862,"word":"\u1780\u17D2\u178A\u17B9\u1794"},{"id":863,"word":"\u1780\u17D2\u178A\u17B9\u17C7"},{"id":864,"word":"\u1780\u17D2\u178A\u17BB\u1780"},{"id":865,"word":"\u1780\u17D2\u178A\u17BB\u1780\u17D7"},{"id":866,"word":"\u1780\u17D2\u178A\u17BB\u1784"},{"id":867,"word":"\u1780\u17D2\u178A\u17BB\u1784\u1780\u17D2\u178A\u17B6\u17C6\u1784"},{"id":868,"word":"\u1780\u17D2\u178A\u17BB\u179B"},{"id":869,"word":"\u1780\u17D2\u178A\u17BC\u1793\u1785\u17C1\u179F"},{"id":870,"word":"\u1780\u17D2\u178A\u17BD\u1785"},{"id":871,"word":"\u1780\u17D2\u178A\u17BD\u179B"},{"id":872,"word":"\u1780\u17D2\u178A\u17BF\u1784"},{"id":873,"word":"\u1780\u17D2\u178A\u17C0\u1793"},{"id":874,"word":"\u1780\u17D2\u178A\u17C0\u1794"},{"id":875,"word":"\u1780\u17D2\u178A\u17C2\u1784\u17D7"},{"id":876,"word":"\u1780\u17D2\u178A\u17C4\u1784"},{"id":877,"word":"\u1780\u17D2\u178A\u17C4\u1794"},{"id":878,"word":"\u1780\u17D2\u178A\u17C5"},{"id":879,"word":"\u1780\u17D2\u178A\u17B6\u17C6"},{"id":880,"word":"\u1780\u17D2\u178A\u17B6\u17C6\u1784"},{"id":881,"word":"\u1780\u17D2\u178A\u17B6\u17C6\u1784\u1784\u17B6"},{"id":882,"word":"\u1780\u17D2\u178C\u17BA\u1784"},{"id":883,"word":"\u1780\u17D2\u178C\u17BB\u1780"},{"id":884,"word":"\u1780\u17D2\u178C\u17BB\u1784"},{"id":885,"word":"\u1780\u17D2\u178C\u17BB\u17C6"},{"id":886,"word":"\u1780\u17D2\u178C\u17B6\u17C6\u1784"},{"id":887,"word":"\u1780\u17D2\u1791\u1798\u17D2\u1796"},{"id":888,"word":"\u1780\u17D2\u1791\u1798\u17D2\u1796\u1791\u17C1\u179F"},{"id":889,"word":"\u1780\u17D2\u1793\u1780\u17CB"},{"id":890,"word":"\u1780\u17D2\u1793\u17B6\u1789\u17CB"},{"id":891,"word":"\u1780\u17D2\u1793\u17B7\u1780\u1780\u17D2\u1793\u1780\u17CB"},{"id":892,"word":"\u1780\u17D2\u1793\u17B7\u1785"},{"id":893,"word":"\u1780\u17D2\u1793\u17BB\u1784"},{"id":894,"word":"\u1780\u17D2\u1794\u1780"},{"id":895,"word":"\u1780\u17D2\u1794\u1784\u17CB"},{"id":896,"word":"\u1780\u17D2\u1794\u178F\u17CB"},{"id":897,"word":"\u1780\u17D2\u1794\u17B6\u1793"},{"id":898,"word":"\u1780\u17D2\u1794\u17B6\u1794"},{"id":899,"word":"\u1780\u17D2\u1794\u17B6\u1799"},{"id":900,"word":"\u1780\u17D2\u1794\u17B6\u179B"},{"id":901,"word":"\u1780\u17D2\u1794\u17B6\u179B\u1780\u17D2\u179A\u1796\u17BE"},{"id":902,"word":"\u1780\u17D2\u1794\u17B6\u1780\u17CB"},{"id":903,"word":"\u1780\u17D2\u1794\u17B6\u1785\u17CB"},{"id":904,"word":"\u1780\u17D2\u1794\u17B7\u178F"},{"id":905,"word":"\u1780\u17D2\u1794\u17B7\u178F\u1780\u17D2\u1794\u17C0\u178F"},{"id":906,"word":"\u1780\u17D2\u1794\u17B7\u1793"},{"id":907,"word":"\u1780\u17D2\u1794\u17B7\u179B"},{"id":908,"word":"\u1780\u17D2\u1794\u17BA\u178F"},{"id":909,"word":"\u1780\u17D2\u1794\u17BB\u1784"},{"id":910,"word":"\u1780\u17D2\u1794\u17BB\u179F"},{"id":911,"word":"\u1780\u17D2\u1794\u17BC\u1793"},{"id":912,"word":"\u1780\u17D2\u1794\u17BC\u179A"},{"id":913,"word":"\u1780\u17D2\u1794\u17BD\u1793"},{"id":914,"word":"\u1780\u17D2\u1794\u17BF\u1784"},{"id":915,"word":"\u1780\u17D2\u1794\u17C0\u1794"},{"id":916,"word":"\u1780\u17D2\u1794\u17C0\u179F"},{"id":917,"word":"\u1780\u17D2\u1794\u17C1\u178F"},{"id":918,"word":"\u1780\u17D2\u1794\u17C2\u179A"},{"id":919,"word":"\u1780\u17D2\u1794\u17C4\u17C7"},{"id":920,"word":"\u1780\u17D2\u1794\u17C4\u17C7\u1780\u17D2\u1794\u17B6\u1799"},{"id":921,"word":"\u1780\u17D2\u1794\u17C6"},{"id":922,"word":"\u1780\u17D2\u1794\u17B6\u17C6\u1784"},{"id":923,"word":"\u1780\u17D2\u1798\u17B6\u1784"},{"id":924,"word":"\u1780\u17D2\u1798\u17BD\u1799"},{"id":925,"word":"\u1780\u17D2\u1798\u17C1\u1780"},{"id":926,"word":"\u1780\u17D2\u1798\u17C1\u1784"},{"id":927,"word":"\u1780\u17D2\u179A"},{"id":928,"word":"\u1780\u17D2\u179A\u1780"},{"id":929,"word":"\u1780\u17D2\u179A\u1780\u17B8"},{"id":930,"word":"\u1780\u17D2\u179A\u1780\u17C4"},{"id":931,"word":"\u1780\u17D2\u179A\u1781\u17BB\u1794"},{"id":932,"word":"\u1780\u17D2\u179A\u1782\u179A"},{"id":933,"word":"\u1780\u17D2\u179A\u1784"},{"id":934,"word":"\u1780\u17D2\u179A\u1784\u17CB"},{"id":935,"word":"\u1780\u17D2\u179A\u1785\u1780"},{"id":936,"word":"\u1780\u17D2\u179A\u1785\u1780\u17A2\u178E\u17D2\u178A\u17BE\u1780"},{"id":937,"word":"\u1780\u17D2\u179A\u1785\u1780\u1785\u17B6\u1794"},{"id":938,"word":"\u1780\u17D2\u179A\u1785\u17B6\u179F"},{"id":939,"word":"\u1780\u17D2\u179A\u1785\u17B6\u1794\u17CB"},{"id":940,"word":"\u1780\u17D2\u179A\u1785\u17C1\u17C7"},{"id":941,"word":"\u1780\u17D2\u179A\u1785\u17C5"},{"id":942,"word":"\u1780\u17D2\u179A\u1787\u17B8\u1784"},{"id":943,"word":"\u1780\u17D2\u179A\u1787\u17B6\u17C6"},{"id":944,"word":"\u1780\u17D2\u179A\u1789\u1784\u17CB"},{"id":945,"word":"\u1780\u17D2\u179A\u1789\u179A"},{"id":946,"word":"\u1780\u17D2\u179A\u1789\u17B6\u1784"},{"id":947,"word":"\u1780\u17D2\u179A\u1789\u17B6\u179F"},{"id":948,"word":"\u1780\u17D2\u179A\u1789\u17B6\u1789\u17CB"},{"id":949,"word":"\u1780\u17D2\u179A\u1789\u17B7\u1780\u1780\u17D2\u179A\u1789\u17BB\u1780"},{"id":950,"word":"\u1780\u17D2\u179A\u1789\u17B8"},{"id":951,"word":"\u1780\u17D2\u179A\u1789\u17B9\u1784"},{"id":952,"word":"\u1780\u17D2\u179A\u1789\u17B9\u1794"},{"id":953,"word":"\u1780\u17D2\u179A\u1789\u17B9\u1798"},{"id":954,"word":"\u1780\u17D2\u179A\u1789\u17BB\u1785"},{"id":955,"word":"\u1780\u17D2\u179A\u1789\u17BB\u1789"},{"id":956,"word":"\u1780\u17D2\u179A\u1789\u17BB\u179B"},{"id":957,"word":"\u1780\u17D2\u179A\u1789\u17BB\u17C7"},{"id":958,"word":"\u1780\u17D2\u179A\u1789\u17BC\u179C"},{"id":959,"word":"\u1780\u17D2\u179A\u1789\u17BC\u179F"},{"id":960,"word":"\u1780\u17D2\u179A\u1789\u17BE\u178F"},{"id":961,"word":"\u1780\u17D2\u179A\u1789\u17C1\u1784"},{"id":962,"word":"\u1780\u17D2\u179A\u1789\u17C1\u1789"},{"id":963,"word":"\u1780\u17D2\u179A\u1789\u17C1\u179F"},{"id":964,"word":"\u1780\u17D2\u179A\u1789\u17C4\u1793"},{"id":965,"word":"\u1780\u17D2\u179A\u1789\u17C5"},{"id":966,"word":"\u1780\u17D2\u179A\u1789\u17B6\u17C6"},{"id":967,"word":"\u1780\u17D2\u179A\u1789\u17B6\u17C6\u1784"},{"id":968,"word":"\u1780\u17D2\u179A\u178A\u17B6\u179F"},{"id":969,"word":"\u1780\u17D2\u179A\u178F\u17D7"},{"id":970,"word":"\u1780\u17D2\u179A\u178F\u17BE\u1793"},{"id":971,"word":"\u1780\u17D2\u179A\u1791\u17B6"},{"id":972,"word":"\u1780\u17D2\u179A\u1791\u17B8"},{"id":973,"word":"\u1780\u17D2\u179A\u1791\u17B8\u1780\u17D2\u179A\u1791\u17B6"},{"id":974,"word":"\u1780\u17D2\u179A\u1791\u17BA\u178F"},{"id":975,"word":"\u1780\u17D2\u179A\u1791\u17C2"},{"id":976,"word":"\u1780\u17D2\u179A\u1791\u17B6\u17C6\u1784"},{"id":977,"word":"\u1780\u17D2\u179A\u1793\u17C0\u179C"},{"id":978,"word":"\u1780\u17D2\u179A\u1793\u17C0\u179C\u1780\u17C2\u179C"},{"id":979,"word":"\u1780\u17D2\u179A\u1794"},{"id":980,"word":"\u1780\u17D2\u179A\u1794\u1781\u17D0\u178E\u17D2\u178C"},{"id":981,"word":"\u1780\u17D2\u179A\u1794\u17B8"},{"id":982,"word":"\u1780\u17D2\u179A\u1794\u17BD\u1785"},{"id":983,"word":"\u1780\u17D2\u179A\u1794\u17C2\u179B"},{"id":984,"word":"\u1780\u17D2\u179A\u1794\u17C5"},{"id":985,"word":"\u1780\u17D2\u179A\u1796\u1780"},{"id":986,"word":"\u1780\u17D2\u179A\u1796\u1784"},{"id":987,"word":"\u1780\u17D2\u179A\u1796\u178F"},{"id":988,"word":"\u1780\u17D2\u179A\u1796\u17B6"},{"id":989,"word":"\u1780\u17D2\u179A\u1796\u17B6\u178F\u17CB"},{"id":990,"word":"\u1780\u17D2\u179A\u1796\u17B6\u178F\u17CB\u1787\u17D2\u179A\u17BC\u1780"},{"id":991,"word":"\u1780\u17D2\u179A\u1796\u17B6\u178F\u17CB\u178A\u17C3"},{"id":992,"word":"\u1780\u17D2\u179A\u1796\u17B9\u178F"},{"id":993,"word":"\u1780\u17D2\u179A\u1796\u17BB\u179B"},{"id":994,"word":"\u1780\u17D2\u179A\u1796\u17BB\u179B\u1794\u17B6\u1799"},{"id":995,"word":"\u1780\u17D2\u179A\u1796\u17BE"},{"id":996,"word":"\u1780\u17D2\u179A\u1796\u17C1\u1789"},{"id":997,"word":"\u1780\u17D2\u179A\u1796\u17C1\u1793"},{"id":998,"word":"\u1780\u17D2\u179A\u1796\u17BB\u17C6"},{"id":999,"word":"\u1780\u17D2\u179A\u1796\u17C7"},{"id":1000,"word":"\u1780\u17D2\u179A\u1798"},{"id":1001,"word":"\u1780\u17D2\u179A\u1798\u1780\u17B6\u179A"},{"id":1002,"word":"\u1780\u17D2\u179A\u1798\u1794\u17CB"},{"id":1003,"word":"\u1780\u17D2\u179A\u1798\u1798"},{"id":1004,"word":"\u1780\u17D2\u179A\u1798\u179A"},{"id":1005,"word":"\u1780\u17D2\u179A\u1798\u17B6"},{"id":1006,"word":"\u1780\u17D2\u179A\u1798\u17B6\u1785"},{"id":1007,"word":"\u1780\u17D2\u179A\u1798\u17B6\u1785\u17CB"},{"id":1008,"word":"\u1780\u17D2\u179A\u1798\u17B6\u179B\u17CB"},{"id":1009,"word":"\u1780\u17D2\u179A\u1798\u17B7\u1785\u1780\u17D2\u179A\u1798\u17BE\u1798"},{"id":1010,"word":"\u1780\u17D2\u179A\u1798\u17B8"},{"id":1011,"word":"\u1780\u17D2\u179A\u1798\u17B9\u1798"},{"id":1012,"word":"\u1780\u17D2\u179A\u1798\u17BA\u1798"},{"id":1013,"word":"\u1780\u17D2\u179A\u1798\u17BD\u1793"},{"id":1014,"word":"\u1780\u17D2\u179A\u1798\u17C5"},{"id":1015,"word":"\u1780\u17D2\u179A\u1798\u17BB\u17C6"},{"id":1016,"word":"\u1780\u17D2\u179A\u1798\u17B6\u17C6"},{"id":1017,"word":"\u1780\u17D2\u179A\u1799\u17B6"},{"id":1018,"word":"\u1780\u17D2\u179A\u1799\u17B6\u178F\u17C6\u178E\u17B6\u17C6\u1784"},{"id":1019,"word":"\u1780\u17D2\u179A\u1799\u17B6\u179F\u1798\u17D2\u1796\u17B6\u1793\u17CB"},{"id":1020,"word":"\u1780\u17D2\u179A\u1799\u17B6\u179F\u17D2\u1784\u17C4\u1799"},{"id":1021,"word":"\u1780\u17D2\u179A\u1799\u17C5"},{"id":1022,"word":"\u1780\u17D2\u179A\u179B\u17C0\u1793"},{"id":1023,"word":"\u1780\u17D2\u179A\u179C\u1784\u17CB"},{"id":1024,"word":"\u1780\u17D2\u179A\u179C\u179B\u17CB\u1780\u17D2\u179A\u179C\u17B6\u1799"},{"id":1025,"word":"\u1780\u17D2\u179A\u179C\u17B6\u1789"},{"id":1026,"word":"\u1780\u17D2\u179A\u179C\u17B6\u1789\u1787\u17D2\u179A\u17BC\u1780"},{"id":1027,"word":"\u1780\u17D2\u179A\u179C\u17B6\u1798"},{"id":1028,"word":"\u1780\u17D2\u179A\u179C\u17B6\u178F\u17CB"},{"id":1029,"word":"\u1780\u17D2\u179A\u179C\u17B6\u1793\u17CB"},{"id":1030,"word":"\u1780\u17D2\u179A\u179C\u17B7\u1780\u1780\u17D2\u179A\u179C\u1780\u17CB"},{"id":1031,"word":"\u1780\u17D2\u179A\u179C\u17B7\u1793"},{"id":1032,"word":"\u1780\u17D2\u179A\u179C\u17B7\u179B"},{"id":1033,"word":"\u1780\u17D2\u179A\u179C\u17B9\u1798"},{"id":1034,"word":"\u1780\u17D2\u179A\u179C\u17BE\u1793"},{"id":1035,"word":"\u1780\u17D2\u179A\u179C\u17BE\u1793\u1780\u17D2\u179A\u178F\u17BE\u1793"},{"id":1036,"word":"\u1780\u17D2\u179A\u179C\u17C0\u1785"},{"id":1037,"word":"\u1780\u17D2\u179A\u179C\u17C0\u1793"},{"id":1038,"word":"\u1780\u17D2\u179A\u179C\u17C1\u1785"},{"id":1039,"word":"\u1780\u17D2\u179A\u179C\u17C1\u1798\u1780\u17D2\u179A\u179C\u17B6\u1798"},{"id":1040,"word":"\u1780\u17D2\u179A\u179C\u17C2\u179B"},{"id":1041,"word":"\u1780\u17D2\u179A\u179F\u17D0\u1799"},{"id":1042,"word":"\u1780\u17D2\u179A\u179F\u17B6\u179A"},{"id":1043,"word":"\u1780\u17D2\u179A\u179F\u17B6\u179B"},{"id":1044,"word":"\u1780\u17D2\u179A\u179F\u17B6\u179C"},{"id":1045,"word":"\u1780\u17D2\u179A\u179F\u17BD\u1784"},{"id":1046,"word":"\u1780\u17D2\u179A\u179F\u17C0\u1793"},{"id":1047,"word":"\u1780\u17D2\u179A\u179F\u17C2"},{"id":1048,"word":"\u1780\u17D2\u179A\u179F\u17C4\u1794"},{"id":1049,"word":"\u1780\u17D2\u179A\u179F\u17B6\u17C6\u1784"},{"id":1050,"word":"\u1780\u17D2\u179A\u179F\u17B6\u17C6\u1784\u1791\u17B6\u1794"},{"id":1051,"word":"\u1780\u17D2\u179A\u179F\u17B6\u17C6\u1784\u1791\u17C6\u17A0\u17C6"},{"id":1052,"word":"\u1780\u17D2\u179A\u179F\u17D2\u1793\u17B6"},{"id":1053,"word":"\u1780\u17D2\u179A\u17A0\u178F"},{"id":1054,"word":"\u1780\u17D2\u179A\u17A0\u1798"},{"id":1055,"word":"\u1780\u17D2\u179A\u17A0\u179B\u17CB"},{"id":1056,"word":"\u1780\u17D2\u179A\u17A0\u17B6\u1799"},{"id":1057,"word":"\u1780\u17D2\u179A\u17A0\u17BC\u1784"},{"id":1058,"word":"\u1780\u17D2\u179A\u17A0\u17BD\u1784"},{"id":1059,"word":"\u1780\u17D2\u179A\u17A0\u17BD\u1785"},{"id":1060,"word":"\u1780\u17D2\u179A\u17A0\u17C1\u1784"},{"id":1061,"word":"\u1780\u17D2\u179A\u17A0\u17C1\u178F"},{"id":1062,"word":"\u1780\u17D2\u179A\u17A0\u17C2\u1784"},{"id":1063,"word":"\u1780\u17D2\u179A\u17A0\u17C2\u178F"},{"id":1064,"word":"\u1780\u17D2\u179A\u17A1"},{"id":1065,"word":"\u1780\u17D2\u179A\u17A1\u1780"},{"id":1066,"word":"\u1780\u17D2\u179A\u17A1\u1784\u17CB"},{"id":1067,"word":"\u1780\u17D2\u179A\u17A1\u17B6"},{"id":1068,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1785\u17CB"},{"id":1069,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1789"},{"id":1070,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1789\u17CB"},{"id":1071,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u178A\u17BB\u1784\u178A\u17C4\u179A"},{"id":1072,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u178F\u1794\u17C8"},{"id":1073,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1794\u1789\u17D2\u1787\u17B8"},{"id":1074,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1793"},{"id":1075,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1794\u17CB"},{"id":1076,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1796\u17B6\u179F"},{"id":1077,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u1797\u17D2\u179B\u17BE\u1784"},{"id":1078,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u179F\u17CB"},{"id":1079,"word":"\u1780\u17D2\u179A\u17A1\u17B6\u17A0\u17C4\u1798"},{"id":1080,"word":"\u1780\u17D2\u179A\u17A1\u17B7\u178F"},{"id":1081,"word":"\u1780\u17D2\u179A\u17A1\u17B9\u1784"},{"id":1082,"word":"\u1780\u17D2\u179A\u17A1\u17B9\u1794"},{"id":1083,"word":"\u1780\u17D2\u179A\u17A1\u17B9\u1798"},{"id":1084,"word":"\u1780\u17D2\u179A\u17A1\u17BA\u1798"},{"id":1085,"word":"\u1780\u17D2\u179A\u17A1\u17BB\u1789"},{"id":1086,"word":"\u1780\u17D2\u179A\u17A1\u17BB\u1794"},{"id":1087,"word":"\u1780\u17D2\u179A\u17A1\u17BC\u1798"},{"id":1088,"word":"\u1780\u17D2\u179A\u17A1\u17C1\u1780"},{"id":1089,"word":"\u1780\u17D2\u179A\u17A1\u17C1\u1785"},{"id":1090,"word":"\u1780\u17D2\u179A\u17A1\u17C1\u1785\u1780\u17D2\u179A\u17A1\u17BB\u1785"},{"id":1091,"word":"\u1780\u17D2\u179A\u17A1\u17C2\u178F"},{"id":1092,"word":"\u1780\u17D2\u179A\u17A1\u17C4"},{"id":1093,"word":"\u1780\u17D2\u179A\u17A1\u17C4\u1787\u17B8"},{"id":1094,"word":"\u1780\u17D2\u179A\u17A1\u17C4\u178F"},{"id":1095,"word":"\u1780\u17D2\u179A\u17A1\u17C5"},{"id":1096,"word":"\u1780\u17D2\u179A\u17A2\u17B6\u1789"},{"id":1097,"word":"\u1780\u17D2\u179A\u17A2\u17B9\u1798\u1780\u17D2\u179A\u17A2\u17C0\u1798"},{"id":1098,"word":"\u1780\u17D2\u179A\u17A2\u17BA\u178F"},{"id":1099,"word":"\u1780\u17D2\u179A\u17A2\u17BA\u178F\u1780\u17D2\u179A\u1791\u1798"},{"id":1100,"word":"\u1780\u17D2\u179A\u17A2\u17BA\u178F\u1780\u17D2\u179A\u17A2\u17C4\u1784"},{"id":1101,"word":"\u1780\u17D2\u179A\u17A2\u17BB\u1785"},{"id":1102,"word":"\u1780\u17D2\u179A\u17A2\u17BB\u179B"},{"id":1103,"word":"\u1780\u17D2\u179A\u17A2\u17BC\u1794"},{"id":1104,"word":"\u1780\u17D2\u179A\u17A2\u17BC\u1798"},{"id":1105,"word":"\u1780\u17D2\u179A\u17A2\u17BD\u1793"},{"id":1106,"word":"\u1780\u17D2\u179A\u17A2\u17C1\u1780"},{"id":1107,"word":"\u1780\u17D2\u179A\u17A2\u17C2\u1784\u1780\u17D2\u179A\u17A2\u17C4\u1784"},{"id":1108,"word":"\u1780\u17D2\u179A\u17A2\u17C2\u1794"},{"id":1109,"word":"\u1780\u17D2\u179A\u17A2\u17C2\u179F"},{"id":1110,"word":"\u1780\u17D2\u179A\u17B1\u1784"},{"id":1111,"word":"\u1780\u17D2\u179A\u17B3"},{"id":1112,"word":"\u1780\u17D2\u179A\u17B6"},{"id":1113,"word":"\u1780\u17D2\u179A\u17B6\u1780"},{"id":1114,"word":"\u1780\u17D2\u179A\u17B6\u1780\u17CB"},{"id":1115,"word":"\u1780\u17D2\u179A\u17B6\u1780\u17CB\u17D7"},{"id":1116,"word":"\u1780\u17D2\u179A\u17B6\u1780\u17CB\u17A2\u17B6\u1785\u17CB"},{"id":1117,"word":"\u1780\u17D2\u179A\u17B6\u1784\u1780\u17D2\u179A\u17B3"},{"id":1118,"word":"\u1780\u17D2\u179A\u17B6\u1789"},{"id":1119,"word":"\u1780\u17D2\u179A\u17B6\u1789\u17CB"},{"id":1120,"word":"\u1780\u17D2\u179A\u17B6\u1793"},{"id":1121,"word":"\u1780\u17D2\u179A\u17B6\u1794"},{"id":1122,"word":"\u1780\u17D2\u179A\u17B6\u1794\u17CB"},{"id":1123,"word":"\u1780\u17D2\u179A\u17B6\u1794\u17CB\u17D7"},{"id":1124,"word":"\u1780\u17D2\u179A\u17B6\u1798"},{"id":1125,"word":"\u1780\u17D2\u179A\u17B6\u1798\u1791\u17B6\u179B\u17CB"},{"id":1126,"word":"\u1780\u17D2\u179A\u17B6\u1798\u179A\u1798\u17B6\u179F"},{"id":1127,"word":"\u1780\u17D2\u179A\u17B6\u1799"},{"id":1128,"word":"\u1780\u17D2\u179A\u17B6\u179B"},{"id":1129,"word":"\u1780\u17D2\u179A\u17B6\u179B\u17CB"},{"id":1130,"word":"\u1780\u17D2\u179A\u17B6\u179F"},{"id":1131,"word":"\u1780\u17D2\u179A\u17B6\u179F\u17CB"},{"id":1132,"word":"\u1780\u17D2\u179A\u17B7\u178F"},{"id":1133,"word":"\u1780\u17D2\u179A\u17B7\u1793"},{"id":1134,"word":"\u1780\u17D2\u179A\u17B7\u1794\u17D7"},{"id":1135,"word":"\u1780\u17D2\u179A\u17B7\u179F"},{"id":1136,"word":"\u1780\u17D2\u179A\u17B7\u17C7"},{"id":1137,"word":"\u1780\u17D2\u179A\u17B8"},{"id":1138,"word":"\u1780\u17D2\u179A\u17B9\u1780\u17D7"},{"id":1139,"word":"\u1780\u17D2\u179A\u17B9\u178F\u17D2\u1799"},{"id":1140,"word":"\u1780\u17D2\u179A\u17B9\u178F\u17D2\u1799\u1780\u17D2\u179A\u1798"},{"id":1141,"word":"\u1780\u17D2\u179A\u17B9\u1794"},{"id":1142,"word":"\u1780\u17D2\u179A\u17B9\u1794\u1780\u17D2\u179A\u17C0\u1794"},{"id":1143,"word":"\u1780\u17D2\u179A\u17B9\u1798"},{"id":1144,"word":"\u1780\u17D2\u179A\u17B9\u179F"},{"id":1145,"word":"\u1780\u17D2\u179A\u17BA\u178F"},{"id":1146,"word":"\u1780\u17D2\u179A\u17BB\u1780\u17D7"},{"id":1147,"word":"\u1780\u17D2\u179A\u17BB\u1784"},{"id":1148,"word":"\u1780\u17D2\u179A\u17BB\u1794\u17D7"},{"id":1149,"word":"\u1780\u17D2\u179A\u17BB\u1798"},{"id":1150,"word":"\u1780\u17D2\u179A\u17BB\u179F"},{"id":1151,"word":"\u1780\u17D2\u179A\u17BC\u1785"},{"id":1152,"word":"\u1780\u17D2\u179A\u17BC\u1785\u1786\u17D2\u1798\u17B6\u179A"},{"id":1153,"word":"\u1780\u17D2\u179A\u17BD\u1785"},{"id":1154,"word":"\u1780\u17D2\u179A\u17BD\u1794"},{"id":1155,"word":"\u1780\u17D2\u179A\u17BD\u179F"},{"id":1156,"word":"\u1780\u17D2\u179A\u17BE\u1793"},{"id":1157,"word":"\u1780\u17D2\u179A\u17C0\u1780"},{"id":1158,"word":"\u1780\u17D2\u179A\u17C0\u1794"},{"id":1159,"word":"\u1780\u17D2\u179A\u17C0\u1794\u17D7"},{"id":1160,"word":"\u1780\u17D2\u179A\u17C0\u1798"},{"id":1161,"word":"\u1780\u17D2\u179A\u17C0\u1798\u1780\u17D2\u179A\u17C4\u17C7"},{"id":1162,"word":"\u1780\u17D2\u179A\u17C0\u179B"},{"id":1163,"word":"\u1780\u17D2\u179A\u17C1\u1794"},{"id":1164,"word":"\u1780\u17D2\u179A\u17C1\u179C"},{"id":1165,"word":"\u1780\u17D2\u179A\u17C1\u179C\u1780\u17D2\u179A\u17C4\u1792"},{"id":1166,"word":"\u1780\u17D2\u179A\u17C1\u179F"},{"id":1167,"word":"\u1780\u17D2\u179A\u17C1\u17C7"},{"id":1168,"word":"\u1780\u17D2\u179A\u17C2\u1780"},{"id":1169,"word":"\u1780\u17D2\u179A\u17C2\u1780\u17D7"},{"id":1170,"word":"\u1780\u17D2\u179A\u17C2\u1784"},{"id":1171,"word":"\u1780\u17D2\u179A\u17C2\u1784\u178F\u17C2"},{"id":1172,"word":"\u1780\u17D2\u179A\u17C2\u1784\u179B\u17C4"},{"id":1173,"word":"\u1780\u17D2\u179A\u17C2\u1794"},{"id":1174,"word":"\u1780\u17D2\u179A\u17C2\u179B"},{"id":1175,"word":"\u1780\u17D2\u179A\u17C2\u17C7"},{"id":1176,"word":"\u1780\u17D2\u179A\u17C3"},{"id":1177,"word":"\u1780\u17D2\u179A\u17C3\u1796\u17C1\u1780"},{"id":1178,"word":"\u1780\u17D2\u179A\u17C3\u179F\u179A"},{"id":1179,"word":"\u1780\u17D2\u179A\u17C4\u1780"},{"id":1180,"word":"\u1780\u17D2\u179A\u17C4\u1792"},{"id":1181,"word":"\u1780\u17D2\u179A\u17C4\u1798"},{"id":1182,"word":"\u1780\u17D2\u179A\u17C4\u1799"},{"id":1183,"word":"\u1780\u17D2\u179A\u17C4\u179B"},{"id":1184,"word":"\u1780\u17D2\u179A\u17C4\u17C7"},{"id":1185,"word":"\u1780\u17D2\u179A\u17C4\u17C7\u179A\u1798\u17B6\u179F"},{"id":1186,"word":"\u1780\u17D2\u179A\u17C5"},{"id":1187,"word":"\u1780\u17D2\u179A\u17C6"},{"id":1188,"word":"\u1780\u17D2\u179A\u17B6\u17C6\u1784"},{"id":1189,"word":"\u1780\u17D2\u179B\u1784"},{"id":1190,"word":"\u1780\u17D2\u179B\u1784\u1781\u17C2\u1780"},{"id":1191,"word":"\u1780\u17D2\u179B\u1784\u1786\u17D2\u1793\u17C8"},{"id":1192,"word":"\u1780\u17D2\u179B\u1784\u1799\u17C9\u17BC\u1793"},{"id":1193,"word":"\u1780\u17D2\u179B\u1793"},{"id":1194,"word":"\u1780\u17D2\u179B\u1798"},{"id":1195,"word":"\u1780\u17D2\u179B\u179F\u17CB"},{"id":1196,"word":"\u1780\u17D2\u179B\u17B6"},{"id":1197,"word":"\u1780\u17D2\u179B\u17B6\u1780\u17CB"},{"id":1198,"word":"\u1780\u17D2\u179B\u17B6\u178F\u17CB"},{"id":1199,"word":"\u1780\u17D2\u179B\u17B6\u1799"},{"id":1200,"word":"\u1780\u17D2\u179B\u17B6\u179C"},{"id":1201,"word":"\u1780\u17D2\u179B\u17B6\u179F\u17CB"},{"id":1202,"word":"\u1780\u17D2\u179B\u17B6\u17A0\u17B6\u1793"},{"id":1203,"word":"\u1780\u17D2\u179B\u17B7\u1784\u17D2\u1782"},{"id":1204,"word":"\u1780\u17D2\u179B\u17B7\u1784\u17D2\u1782\u17D2\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":1205,"word":"\u1780\u17D2\u179B\u17B7\u178F"},{"id":1206,"word":"\u1780\u17D2\u179B\u17B7\u1793"},{"id":1207,"word":"\u1780\u17D2\u179B\u17B9\u1784"},{"id":1208,"word":"\u1780\u17D2\u179B\u17B9\u179F"},{"id":1209,"word":"\u1780\u17D2\u179B\u17BB\u1780"},{"id":1210,"word":"\u1780\u17D2\u179B\u17BE"},{"id":1211,"word":"\u1780\u17D2\u179B\u17C0\u1780"},{"id":1212,"word":"\u1780\u17D2\u179B\u17C0\u179C\u1780\u17D2\u179B\u1798"},{"id":1213,"word":"\u1780\u17D2\u179B\u17C1\u178F"},{"id":1214,"word":"\u1780\u17D2\u179B\u17C2\u1784"},{"id":1215,"word":"\u1780\u17D2\u179B\u17C2\u1794"},{"id":1216,"word":"\u1780\u17D2\u179B\u17C2\u1798"},{"id":1217,"word":"\u1780\u17D2\u179B\u17BB\u17C6"},{"id":1218,"word":"\u1780\u17D2\u179B\u17C6"},{"id":1219,"word":"\u1780\u17D2\u179B\u17B6\u17C6"},{"id":1220,"word":"\u1780\u17D2\u179B\u17B6\u17C6\u1784\u17A0\u17B6\u1799"},{"id":1221,"word":"\u1780\u17D2\u179B\u17B6\u17C6\u1796\u17B6\u1780\u17CB"},{"id":1222,"word":"\u1780\u17D2\u179B\u17B6\u17C6\u1796\u17BC"},{"id":1223,"word":"\u1780\u17D2\u179C\u17B6\u178F"},{"id":1224,"word":"\u1780\u17D2\u179C\u17C2\u1793"},{"id":1225,"word":"\u1780\u17D2\u179F\u178E\u17C8"},{"id":1226,"word":"\u1780\u17D2\u179F\u178F\u17D2\u179A"},{"id":1227,"word":"\u1780\u17D2\u179F\u17D0\u1799"},{"id":1228,"word":"\u1780\u17D2\u179F\u17B6\u1793\u17D2\u178F"},{"id":1229,"word":"\u1780\u17D2\u179F\u17B7\u178E"},{"id":1230,"word":"\u1780\u17D2\u179F\u17B7\u178E\u1780\u17D2\u179F\u17D0\u1799"},{"id":1231,"word":"\u1780\u17D2\u179F\u17B8\u178E"},{"id":1232,"word":"\u1780\u17D2\u179F\u17B8\u179A"},{"id":1233,"word":"\u1780\u17D2\u179F\u17C1\u178F\u17D2\u179A"},{"id":1234,"word":"\u1780\u17D2\u179F\u17C1\u178F\u17D2\u179A\u17B6\u1787\u17B8\u179C\u1780\u1798\u17D2\u1798"},{"id":1235,"word":"\u1780\u17D2\u179F\u17C1\u178F\u17D2\u179A\u17B6\u1792\u17B7\u1780\u17B6\u179A"},{"id":1236,"word":"\u1780\u17D2\u179F\u17C1\u178F\u17D2\u179A\u17B6\u179A\u1780\u17D2\u179F"},{"id":1237,"word":"\u1780\u17D2\u179F\u17C1\u1798"},{"id":1238,"word":"\u1780\u17D2\u179F\u17C1\u1798\u1780\u17D2\u179F\u17B6\u1793\u17D2\u178F"},{"id":1239,"word":"\u1780\u17D2\u17A2\u1780"},{"id":1240,"word":"\u1780\u17D2\u17A2\u1798"},{"id":1241,"word":"\u1780\u17D2\u17A2\u17B6\u1780"},{"id":1242,"word":"\u1780\u17D2\u17A2\u17B6\u1780\u17D7"},{"id":1243,"word":"\u1780\u17D2\u17A2\u17B6\u1780\u1780\u17D2\u17A2\u17B6\u1799"},{"id":1244,"word":"\u1780\u17D2\u17A2\u17B6\u1784"},{"id":1245,"word":"\u1780\u17D2\u17A2\u17B6\u178F"},{"id":1246,"word":"\u1780\u17D2\u17A2\u17B6\u178F\u17CB"},{"id":1247,"word":"\u1780\u17D2\u17A2\u17B7\u178F"},{"id":1248,"word":"\u1780\u17D2\u17A2\u17B7\u179B"},{"id":1249,"word":"\u1780\u17D2\u17A2\u17B8"},{"id":1250,"word":"\u1780\u17D2\u17A2\u17B9\u1780\u17D7"},{"id":1251,"word":"\u1780\u17D2\u17A2\u17BB\u1780"},{"id":1252,"word":"\u1780\u17D2\u17A2\u17BD\u178F"},{"id":1253,"word":"\u1780\u17D2\u17A2\u17BF\u1799"},{"id":1254,"word":"\u1780\u17D2\u17A2\u17C0\u1780\u17D7"},{"id":1255,"word":"\u1780\u17D2\u17A2\u17C1\u1784"},{"id":1256,"word":"\u1780\u17D2\u17A2\u17C1\u1784\u1780\u17D2\u17A2\u17B6\u1784"},{"id":1257,"word":"\u1780\u17D2\u17A2\u17C2"},{"id":1258,"word":"\u1780\u17D2\u17A2\u17C2\u1780"},{"id":1259,"word":"\u1780\u17D2\u17A2\u17C2\u1794"},{"id":1260,"word":"\u1780\u17D2\u17A2\u17C2\u179B"},{"id":1261,"word":"\u1780\u1784\u17D2\u179C\u17B6\u1780\u17CB"},{"id":1262,"word":"\u1780\u1784\u17D2\u179C\u17B7\u1793"},{"id":1263,"word":"\u1780\u1789\u17D2\u1785\u17BC\u1789"},{"id":1264,"word":"\u1780\u1789\u17D2\u1786\u17B6\u1789"},{"id":1265,"word":"\u1780\u178E\u17D2\u178F\u17C1\u1784"},{"id":1266,"word":"\u1780\u178F\u17CB"},{"id":1267,"word":"\u1780\u1793\u17D2\u179B\u17B6\u1789\u17CB"},{"id":1268,"word":"\u1780\u1798\u17D2\u179A\u17B6\u1789"},{"id":1269,"word":"\u1780\u1798\u17D2\u179A\u17B7\u1793"},{"id":1270,"word":"\u1780\u17B6\u178F\u17CB"},{"id":1271,"word":"\u1780\u17B6\u1793\u17CB\u1787\u17BE\u1784"},{"id":1272,"word":"\u1780\u17BB\u1784\u178F\u17B6\u1780\u17CB"},{"id":1273,"word":"\u1780\u17BC\u1793\u1780\u17D2\u179A\u1780"},{"id":1274,"word":"\u1780\u17BC\u1793\u1780\u17D2\u179A\u17B6\u1794\u17CB"},{"id":1275,"word":"\u1780\u17BC\u1793\u1794\u178E\u17D2\u178A\u17C2\u178F"},{"id":1276,"word":"\u1780\u17C2\u179C\u1796\u1784\u17D2\u179A\u17B8\u1780"},{"id":1277,"word":"\u1780\u17C6\u17A0\u1780"},{"id":1278,"word":"\u1780\u17C6\u17A0\u17B6\u178F\u17CB"},{"id":1279,"word":"\u1780\u17C6\u17A0\u17B6\u1793"},{"id":1280,"word":"\u1780\u17D2\u1794\u17B6\u1785\u17CB"},{"id":1281,"word":"\u1780\u17D2\u179A\u1785\u17C1"},{"id":1282,"word":"\u1780\u17D2\u179A\u178E\u17B6\u1793\u17CB"},{"id":1283,"word":"\u1780\u17D2\u179A\u17C0\u179C"},{"id":1284,"word":"\u1781"},{"id":1285,"word":"\u1781\u17D7"},{"id":1286,"word":"\u1781\u1780"},{"id":1287,"word":"\u1781\u1780\u17CB"},{"id":1288,"word":"\u1781\u1781\u17B7\u178F"},{"id":1289,"word":"\u1781\u17D0\u178C\u17D2\u1782"},{"id":1290,"word":"\u1781\u178E\u17C8"},{"id":1291,"word":"\u1781\u178E\u17D2\u178C"},{"id":1292,"word":"\u1781\u178E\u17D2\u178C\u1781\u17B6\u1794\u17CB"},{"id":1293,"word":"\u1781\u178E\u17D2\u178C\u179F\u1789\u17D2\u1789\u17B6"},{"id":1294,"word":"\u1781\u178E\u17D2\u178C\u179F\u17D2\u1780\u179A"},{"id":1295,"word":"\u1781\u178E\u17D2\u178C\u179F\u17B8\u1798\u17B6"},{"id":1296,"word":"\u1781\u178F\u17D2\u178F\u17B7\u1799\u17C8"},{"id":1297,"word":"\u1781\u1793"},{"id":1298,"word":"\u1781\u1793\u17CB"},{"id":1299,"word":"\u1781\u17D0\u1793"},{"id":1300,"word":"\u1781\u1793\u17D2\u178F\u17B8"},{"id":1301,"word":"\u1781\u1793\u17D2\u1791\u179A\u17B6"},{"id":1302,"word":"\u1781\u1793\u17D2\u1792"},{"id":1303,"word":"\u1781\u1798"},{"id":1304,"word":"\u1781\u1798\u17B6\u1791\u17C4\u179F"},{"id":1305,"word":"\u1781\u179A"},{"id":1306,"word":"\u1781\u179A\u17B6\u1796\u17B6\u1792"},{"id":1307,"word":"\u1781\u179B\u17BB\u1794\u1785\u17D2\u1786\u17B6\u1797\u178F\u17D2\u178F\u17B7\u1780\u1784\u17D2\u1782"},{"id":1308,"word":"\u1781\u17B6\u1780"},{"id":1309,"word":"\u1781\u17B6\u1784"},{"id":1310,"word":"\u1781\u17B6\u178F"},{"id":1311,"word":"\u1781\u17B6\u178F\u17CB"},{"id":1312,"word":"\u1781\u17B6\u1791\u1793\u17B8\u1799\u17B6\u17A0\u17B6\u179A"},{"id":1313,"word":"\u1781\u17B6\u1793"},{"id":1314,"word":"\u1781\u17B6\u1793\u179F\u17D2\u17A2\u17C2\u1780"},{"id":1315,"word":"\u1781\u17B6\u1793\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17BD\u1799"},{"id":1316,"word":"\u1781\u17B6\u1793\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17BD\u1799\u1793\u17B6\u1799"},{"id":1317,"word":"\u1781\u17B6\u1793\u17CB"},{"id":1318,"word":"\u1781\u17B6\u1793\u17CB\u1781\u17C5"},{"id":1319,"word":"\u1781\u17B6\u1793\u17CB\u1787\u17B8\u1794"},{"id":1320,"word":"\u1781\u17B6\u1793\u17CB\u1794\u17C0\u178F"},{"id":1321,"word":"\u1781\u17B6\u1793\u17CB\u179B\u17BF\u1784"},{"id":1322,"word":"\u1781\u17B6\u1793\u17CB\u179F\u17D2\u179B\u17B6"},{"id":1323,"word":"\u1781\u17B6\u1793\u17CB\u179F\u17D2\u179B\u17B6\u1780\u17CB"},{"id":1324,"word":"\u1781\u17B6\u1794"},{"id":1325,"word":"\u1781\u17B6\u1794\u1781\u17B6"},{"id":1326,"word":"\u1781\u17B6\u1794\u17CB"},{"id":1327,"word":"\u1781\u17B6\u1794\u17CB\u1781\u178E\u17D2\u178C"},{"id":1328,"word":"\u1781\u17B6\u1798"},{"id":1329,"word":"\u1781\u17B6\u179A"},{"id":1330,"word":"\u1781\u17B6\u179B"},{"id":1331,"word":"\u1781\u17B6\u179B\u17CB"},{"id":1332,"word":"\u1781\u17B6\u179C"},{"id":1333,"word":"\u1781\u17B7\u1784"},{"id":1334,"word":"\u1781\u17B7\u178F"},{"id":1335,"word":"\u1781\u17B7\u178F\u1781\u17B6\u178F\u17CB"},{"id":1336,"word":"\u1781\u17B7\u178F\u1781\u17C6"},{"id":1337,"word":"\u1781\u17B7\u178F\u17D2\u178F\u1794\u17D0\u178E\u17D2\u178E"},{"id":1338,"word":"\u1781\u17B7\u1798"},{"id":1339,"word":"\u1781\u17B7\u179B"},{"id":1340,"word":"\u1781\u17B8\u178E\u1797\u17B6\u1796"},{"id":1341,"word":"\u1781\u17B8\u178E\u17B6\u179F\u17D2\u179A\u1796"},{"id":1342,"word":"\u1781\u17B8\u179A\u1787\u17B6\u178F\u17B7"},{"id":1343,"word":"\u1781\u17B9\u1780\u17D7"},{"id":1344,"word":"\u1781\u17B9\u1784"},{"id":1345,"word":"\u1781\u17B9\u1798\u1781\u17B6\u178F\u17CB"},{"id":1346,"word":"\u1781\u17BB\u1784\u17D7"},{"id":1347,"word":"\u1781\u17BB\u1791\u17D2\u1791\u1780\u1797\u17B6\u1796"},{"id":1348,"word":"\u1781\u17BB\u1791\u17D2\u1791\u1780\u17B6\u179B\u17D0\u1799"},{"id":1349,"word":"\u1781\u17BB\u1793"},{"id":1350,"word":"\u1781\u17BB\u1793\u178E\u17B6\u1784"},{"id":1351,"word":"\u1781\u17BB\u1793\u17A0\u17D2\u1793\u17B9\u1784"},{"id":1352,"word":"\u1781\u17BB\u1794"},{"id":1353,"word":"\u1781\u17BB\u1799"},{"id":1354,"word":"\u1781\u17BB\u179A\u17D7"},{"id":1355,"word":"\u1781\u17BB\u179B"},{"id":1356,"word":"\u1781\u17BB\u179F"},{"id":1357,"word":"\u1781\u17BC\u1784"},{"id":1358,"word":"\u1781\u17BC\u1785"},{"id":1359,"word":"\u1781\u17BD"},{"id":1360,"word":"\u1781\u17BD\u1784"},{"id":1361,"word":"\u1781\u17BD\u1785"},{"id":1362,"word":"\u1781\u17BD\u1789"},{"id":1363,"word":"\u1781\u17BD\u1794"},{"id":1364,"word":"\u1781\u17BD\u179A"},{"id":1365,"word":"\u1781\u17BE\u1785"},{"id":1366,"word":"\u1781\u17BF\u1793"},{"id":1367,"word":"\u1781\u17C0\u1793"},{"id":1368,"word":"\u1781\u17C0\u179C"},{"id":1369,"word":"\u1781\u17C1"},{"id":1370,"word":"\u1781\u17C1\u178F\u17D2\u178F"},{"id":1371,"word":"\u1781\u17C1\u1793"},{"id":1372,"word":"\u1781\u17C1\u1798\u179A\u17C8"},{"id":1373,"word":"\u1781\u17C1\u1798\u179A\u1797\u17B6\u179F\u17B6"},{"id":1374,"word":"\u1781\u17C1\u1798\u179A\u179A\u178A\u17D2\u178B"},{"id":1375,"word":"\u1781\u17C2"},{"id":1376,"word":"\u1781\u17C2\u1784"},{"id":1377,"word":"\u1781\u17C2\u178F\u17D2\u179A"},{"id":1378,"word":"\u1781\u17C2\u179B"},{"id":1379,"word":"\u1781\u17C3"},{"id":1380,"word":"\u1781\u17C4"},{"id":1381,"word":"\u1781\u17C4\u1780"},{"id":1382,"word":"\u1781\u17C4\u179A"},{"id":1383,"word":"\u1781\u17C4\u179B"},{"id":1384,"word":"\u1781\u17C4\u179F"},{"id":1385,"word":"\u1781\u17C5\u178F\u17B6\u1780"},{"id":1386,"word":"\u1781\u17C6"},{"id":1387,"word":"\u1781\u17B6\u17C6"},{"id":1388,"word":"\u1781\u17B6\u17C6\u1784"},{"id":1389,"word":"\u1781\u17C7"},{"id":1390,"word":"\u1781\u17C7\u1781\u17C6"},{"id":1391,"word":"\u1781\u17D2\u1785\u1780"},{"id":1392,"word":"\u1781\u17D2\u1785\u1794\u17CB"},{"id":1393,"word":"\u1781\u17D2\u1785\u179A"},{"id":1394,"word":"\u1781\u17D2\u1785\u179A\u1781\u17D2\u1785\u17B6\u1799"},{"id":1395,"word":"\u1781\u17D2\u1785\u17B6\u178F\u17CB"},{"id":1396,"word":"\u1781\u17D2\u1785\u17B6\u178F\u17CB\u1781\u17D2\u1785\u17B6\u1799"},{"id":1397,"word":"\u1781\u17D2\u1785\u17B6\u1799"},{"id":1398,"word":"\u1781\u17D2\u1785\u17B6\u179F\u17CB"},{"id":1399,"word":"\u1781\u17D2\u1785\u17B8"},{"id":1400,"word":"\u1781\u17D2\u1785\u17BC\u179C"},{"id":1401,"word":"\u1781\u17D2\u1785\u17BE\u1785"},{"id":1402,"word":"\u1781\u17D2\u1785\u17C4\u1794"},{"id":1403,"word":"\u1781\u17D2\u1785\u17C4\u17C7"},{"id":1404,"word":"\u1781\u17D2\u1785\u17C5"},{"id":1405,"word":"\u1781\u17D2\u1787\u17B6\u1780"},{"id":1406,"word":"\u1781\u17D2\u1787\u17B6\u1780\u17CB"},{"id":1407,"word":"\u1781\u17D2\u1787\u17B6\u1784"},{"id":1408,"word":"\u1781\u17D2\u1787\u17B6\u1793\u17CB\u17D7"},{"id":1409,"word":"\u1781\u17D2\u1787\u17B6\u1794\u17CB"},{"id":1410,"word":"\u1781\u17D2\u1787\u17B6\u1794\u17CB\u1781\u17D2\u1787\u17BD\u1793"},{"id":1411,"word":"\u1781\u17D2\u1787\u17B6\u1799"},{"id":1412,"word":"\u1781\u17D2\u1787\u17B8\u1781\u17D2\u1787\u17B6"},{"id":1413,"word":"\u1781\u17D2\u1787\u17B7\u179B"},{"id":1414,"word":"\u1781\u17D2\u1787\u17B9\u1794"},{"id":1415,"word":"\u1781\u17D2\u1787\u17B9\u1784"},{"id":1416,"word":"\u1781\u17D2\u1787\u17B9\u1794"},{"id":1417,"word":"\u1781\u17D2\u1787\u17BD\u1793"},{"id":1418,"word":"\u1781\u17D2\u1787\u17BE\u1785"},{"id":1419,"word":"\u1781\u17D2\u1787\u17C1\u1789"},{"id":1420,"word":"\u1781\u17D2\u1787\u17C2\u1784"},{"id":1421,"word":"\u1781\u17D2\u1787\u17C4\u1780"},{"id":1422,"word":"\u1781\u17D2\u1787\u17C4\u1780\u1781\u17D2\u1787\u17B6\u1780"},{"id":1423,"word":"\u1781\u17D2\u1787\u17C4\u179B"},{"id":1424,"word":"\u1781\u17D2\u1787\u17B6\u17C6"},{"id":1425,"word":"\u1781\u17D2\u1787\u17B6\u17C6\u1784\u17D7"},{"id":1426,"word":"\u1781\u17D2\u1787\u17C7\u1781\u17D2\u1787\u17B6\u1799"},{"id":1427,"word":"\u1781\u17D2\u1789\u1780"},{"id":1428,"word":"\u1781\u17D2\u1789\u1784\u17CB"},{"id":1429,"word":"\u1781\u17D2\u1789\u17B6\u1780"},{"id":1430,"word":"\u1781\u17D2\u1789\u17B6\u179A"},{"id":1431,"word":"\u1781\u17D2\u1789\u17B6\u179B\u17CB"},{"id":1432,"word":"\u1781\u17D2\u1789\u17B7\u1780\u17D7"},{"id":1433,"word":"\u1781\u17D2\u1789\u17B7\u1780\u1781\u17D2\u1789\u17BB\u1780"},{"id":1434,"word":"\u1781\u17D2\u1789\u17B7\u179B\u17D7"},{"id":1435,"word":"\u1781\u17D2\u1789\u17B8"},{"id":1436,"word":"\u1781\u17D2\u1789\u17B8\u179C\u1781\u17D2\u1789\u17BC\u179C"},{"id":1437,"word":"\u1781\u17D2\u1789\u17B9\u1784"},{"id":1438,"word":"\u1781\u17D2\u1789\u17BB\u1780\u1781\u17D2\u1789\u17BC\u179C"},{"id":1439,"word":"\u1781\u17D2\u1789\u17BB\u1784"},{"id":1440,"word":"\u1781\u17D2\u1789\u17BC\u1785"},{"id":1441,"word":"\u1781\u17D2\u1789\u17BE\u1785"},{"id":1442,"word":"\u1781\u17D2\u1789\u17C0\u179C"},{"id":1443,"word":"\u1781\u17D2\u1789\u17C0\u179C\u1781\u17D2\u1789\u17B6\u179A"},{"id":1444,"word":"\u1781\u17D2\u1789\u17C2\u1780\u1781\u17D2\u1789\u1780"},{"id":1445,"word":"\u1781\u17D2\u1789\u17C2\u1780"},{"id":1446,"word":"\u1781\u17D2\u1789\u17C2\u178F\u17D7"},{"id":1447,"word":"\u1781\u17D2\u1789\u17C2\u1798"},{"id":1448,"word":"\u1781\u17D2\u1789\u17C2\u179A"},{"id":1449,"word":"\u1781\u17D2\u1789\u17C4\u1780"},{"id":1450,"word":"\u1781\u17D2\u1789\u17BB\u17C6"},{"id":1451,"word":"\u1781\u17D2\u1789\u17B6\u17C6"},{"id":1452,"word":"\u1781\u17D2\u178F\u178F"},{"id":1453,"word":"\u1781\u17D2\u1791\u1784\u17CB"},{"id":1454,"word":"\u1781\u17D2\u1791\u1794"},{"id":1455,"word":"\u1781\u17D2\u1791\u1794\u17CB"},{"id":1456,"word":"\u1781\u17D2\u1791\u1798"},{"id":1457,"word":"\u1781\u17D2\u1791\u179A"},{"id":1458,"word":"\u1781\u17D2\u1791\u179A\u1781\u17D2\u1791\u17D0\u179A"},{"id":1459,"word":"\u1781\u17D2\u1791\u17D0\u179A"},{"id":1460,"word":"\u1781\u17D2\u1791\u17B6\u178F"},{"id":1461,"word":"\u1781\u17D2\u1791\u17B6\u179A"},{"id":1462,"word":"\u1781\u17D2\u1791\u17B6\u179F\u17CB"},{"id":1463,"word":"\u1781\u17D2\u1791\u17B7\u17C7"},{"id":1464,"word":"\u1781\u17D2\u1791\u17B8\u1784"},{"id":1465,"word":"\u1781\u17D2\u1791\u17B8\u178F"},{"id":1466,"word":"\u1781\u17D2\u1791\u17B9\u1784"},{"id":1467,"word":"\u1781\u17D2\u1791\u17B9\u1798"},{"id":1468,"word":"\u1781\u17D2\u1791\u17BB\u178F"},{"id":1469,"word":"\u1781\u17D2\u1791\u17BB\u178F\u178A\u17B8"},{"id":1470,"word":"\u1781\u17D2\u1791\u17BB\u17C7"},{"id":1471,"word":"\u1781\u17D2\u1791\u17BD\u1799"},{"id":1472,"word":"\u1781\u17D2\u1791\u17BE\u178F"},{"id":1473,"word":"\u1781\u17D2\u1791\u17BE\u1799"},{"id":1474,"word":"\u1781\u17D2\u1791\u17C1\u1785"},{"id":1475,"word":"\u1781\u17D2\u1791\u17C1\u1785\u1781\u17D2\u1791\u17B8"},{"id":1476,"word":"\u1781\u17D2\u1791\u17C2\u1784"},{"id":1477,"word":"\u1781\u17D2\u1791\u17C2\u178F"},{"id":1478,"word":"\u1781\u17D2\u1791\u17C4\u1780\u17D7"},{"id":1479,"word":"\u1781\u17D2\u1791\u17B6\u17C6"},{"id":1480,"word":"\u1781\u17D2\u1791\u17C7"},{"id":1481,"word":"\u1781\u17D2\u1791\u17C7\u178F\u17D2\u1793\u17C4\u178F"},{"id":1482,"word":"\u1781\u17D2\u1793\u1784"},{"id":1483,"word":"\u1781\u17D2\u1793\u1794\u17CB"},{"id":1484,"word":"\u1781\u17D2\u1793\u179B\u17CB"},{"id":1485,"word":"\u1781\u17D2\u1793\u1793\u17CB"},{"id":1486,"word":"\u1781\u17D2\u1793\u17B6\u1785"},{"id":1487,"word":"\u1781\u17D2\u1793\u17B6\u1785\u17CB"},{"id":1488,"word":"\u1781\u17D2\u1793\u17B6\u178F"},{"id":1489,"word":"\u1781\u17D2\u1793\u17B6\u1793"},{"id":1490,"word":"\u1781\u17D2\u1793\u17B6\u1793\u17CB"},{"id":1491,"word":"\u1781\u17D2\u1793\u17B6\u1793\u17CB\u1781\u17D2\u1793\u17B6\u1794\u17CB"},{"id":1492,"word":"\u1781\u17D2\u1793\u17B6\u1794"},{"id":1493,"word":"\u1781\u17D2\u1793\u17B6\u1799"},{"id":1494,"word":"\u1781\u17D2\u1793\u17B6\u179A"},{"id":1495,"word":"\u1781\u17D2\u1793\u17B7\u1785"},{"id":1496,"word":"\u1781\u17D2\u1793\u17B7\u178F"},{"id":1497,"word":"\u1781\u17D2\u1793\u17BA\u1794"},{"id":1498,"word":"\u1781\u17D2\u1793\u17BB\u179A"},{"id":1499,"word":"\u1781\u17D2\u1793\u17BB\u179A\u179F\u1798\u17D2\u179B"},{"id":1500,"word":"\u1781\u17D2\u1793\u17BD\u1785"},{"id":1501,"word":"\u1781\u17D2\u1793\u17BD\u178F"},{"id":1502,"word":"\u1781\u17D2\u1793\u17BD\u178F\u17A2\u17C6\u1794\u17C4\u17C7"},{"id":1503,"word":"\u1781\u17D2\u1793\u17BE\u178F"},{"id":1504,"word":"\u1781\u17D2\u1793\u17BE\u1799"},{"id":1505,"word":"\u1781\u17D2\u1793\u17C2\u1784"},{"id":1506,"word":"\u1781\u17D2\u1793\u17C0\u179A"},{"id":1507,"word":"\u1781\u17D2\u1793\u17C0\u179F"},{"id":1508,"word":"\u1781\u17D2\u1793\u17C4\u179F"},{"id":1509,"word":"\u1781\u17D2\u1793\u17C4\u17C7"},{"id":1510,"word":"\u1781\u17D2\u1793\u17C5"},{"id":1511,"word":"\u1781\u17D2\u1793\u17C7\u1781\u17D2\u1793\u17C2\u1784"},{"id":1512,"word":"\u1781\u17D2\u1796"},{"id":1513,"word":"\u1781\u17D2\u1796\u1784\u17CB"},{"id":1514,"word":"\u1781\u17D2\u1796\u1784\u17CB\u1781\u17D2\u1796\u179F\u17CB"},{"id":1515,"word":"\u1781\u17D2\u1796\u1784\u17CB\u1798\u17C1\u1783"},{"id":1516,"word":"\u1781\u17D2\u1796\u1784\u17CB\u179A\u17B6\u1794"},{"id":1517,"word":"\u1781\u17D2\u1796\u1794"},{"id":1518,"word":"\u1781\u17D2\u1796\u179F\u17CB"},{"id":1519,"word":"\u1781\u17D2\u1796\u17B6\u1780"},{"id":1520,"word":"\u1781\u17D2\u1796\u17B6\u1780\u17CB\u17D7"},{"id":1521,"word":"\u1781\u17D2\u1796\u17B6\u1794\u17CB"},{"id":1522,"word":"\u1781\u17D2\u1796\u17BB\u1780"},{"id":1523,"word":"\u1781\u17D2\u1796\u17BB\u179A"},{"id":1524,"word":"\u1781\u17D2\u1796\u17BE\u1798"},{"id":1525,"word":"\u1781\u17D2\u1796\u17C4\u1780"},{"id":1526,"word":"\u1781\u17D2\u1798\u1784"},{"id":1527,"word":"\u1781\u17D2\u1798\u17B6\u1789\u17CB"},{"id":1528,"word":"\u1781\u17D2\u1798\u17B6\u1793\u17CB"},{"id":1529,"word":"\u1781\u17D2\u1798\u17B6\u1799"},{"id":1530,"word":"\u1781\u17D2\u1798\u17B6\u179F"},{"id":1531,"word":"\u1781\u17D2\u1798\u17B8"},{"id":1532,"word":"\u1781\u17D2\u1798\u17B8\u1783\u17D2\u1798\u17B6\u178F"},{"id":1533,"word":"\u1781\u17D2\u1798\u17BA\u178F"},{"id":1534,"word":"\u1781\u17D2\u1798\u17BB\u1780"},{"id":1535,"word":"\u1781\u17D2\u1798\u17BB\u179B"},{"id":1536,"word":"\u1781\u17D2\u1798\u17BC\u178F"},{"id":1537,"word":"\u1781\u17D2\u1798\u17BC\u179A"},{"id":1538,"word":"\u1781\u17D2\u1798\u17BD\u1789"},{"id":1539,"word":"\u1781\u17D2\u1798\u17BD\u1799"},{"id":1540,"word":"\u1781\u17D2\u1798\u17BD\u179B"},{"id":1541,"word":"\u1781\u17D2\u1798\u17BD\u179A"},{"id":1542,"word":"\u1781\u17D2\u1798\u17C1\u179A"},{"id":1543,"word":"\u1781\u17D2\u1798\u17C1\u17C7"},{"id":1544,"word":"\u1781\u17D2\u1798\u17C2\u179A"},{"id":1545,"word":"\u1781\u17D2\u1798\u17C4\u1785"},{"id":1546,"word":"\u1781\u17D2\u1798\u17C5"},{"id":1547,"word":"\u1781\u17D2\u1798\u17C4\u17C7"},{"id":1548,"word":"\u1781\u17D2\u1798\u17C4\u17C7\u1781\u17D2\u1798\u17BD\u179A"},{"id":1549,"word":"\u1781\u17D2\u1798\u17B6\u17C6\u1784"},{"id":1550,"word":"\u1781\u17D2\u1798\u17B6\u17C6\u1784\u1798\u17B7\u179B"},{"id":1551,"word":"\u1781\u17D2\u1799\u1784"},{"id":1552,"word":"\u1781\u17D2\u1799\u179B\u17CB"},{"id":1553,"word":"\u1781\u17D2\u1799\u17B6\u178A\u17C6\u179A\u17B8"},{"id":1554,"word":"\u1781\u17D2\u179B\u1794"},{"id":1555,"word":"\u1781\u17D2\u179B\u17B6"},{"id":1556,"word":"\u1781\u17D2\u179B\u17B6\u1785"},{"id":1557,"word":"\u1781\u17D2\u179B\u17B6\u1789\u17CB"},{"id":1558,"word":"\u1781\u17D2\u179B\u17B8"},{"id":1559,"word":"\u1781\u17D2\u179B\u17B9\u1798"},{"id":1560,"word":"\u1781\u17D2\u179B\u17BA\u178F"},{"id":1561,"word":"\u1781\u17D2\u179B\u17BB\u1780"},{"id":1562,"word":"\u1781\u17D2\u179B\u17BB\u1784"},{"id":1563,"word":"\u1781\u17D2\u179B\u17BB\u1799"},{"id":1564,"word":"\u1781\u17D2\u179B\u17BB\u17C7"},{"id":1565,"word":"\u1781\u17D2\u179B\u17BC\u178F"},{"id":1566,"word":"\u1781\u17D2\u179B\u17BD\u1793"},{"id":1567,"word":"\u1781\u17D2\u179B\u17C1\u179C\u17D7"},{"id":1568,"word":"\u1781\u17D2\u179B\u17C2\u1784"},{"id":1569,"word":"\u1781\u17D2\u179B\u17C4\u1784"},{"id":1570,"word":"\u1781\u17D2\u179B\u17C4\u1784\u1791\u17D2\u179C\u17B6\u179A"},{"id":1571,"word":"\u1781\u17D2\u179B\u17C4\u1785"},{"id":1572,"word":"\u1781\u17D2\u179B\u17C4\u1789\u17D7"},{"id":1573,"word":"\u1781\u17D2\u179B\u17C4\u178F"},{"id":1574,"word":"\u1781\u17D2\u179B\u17C5"},{"id":1575,"word":"\u1781\u17D2\u179B\u17B6\u17C6\u1784"},{"id":1576,"word":"\u1781\u17D2\u179B\u17C7"},{"id":1577,"word":"\u1781\u17D2\u179C\u1780"},{"id":1578,"word":"\u1781\u17D2\u179C\u1780\u17CB"},{"id":1579,"word":"\u1781\u17D2\u179C\u1784"},{"id":1580,"word":"\u1781\u17D2\u179C\u1784\u17CB"},{"id":1581,"word":"\u1781\u17D2\u179C\u179B\u17CB"},{"id":1582,"word":"\u1781\u17D2\u179C\u179B\u17CB\u1781\u17D2\u179C\u17B6\u1799"},{"id":1583,"word":"\u1781\u17D2\u179C\u17B6\u1780"},{"id":1584,"word":"\u1781\u17D2\u179C\u17B6\u1780\u17CB"},{"id":1585,"word":"\u1781\u17D2\u179C\u17B6\u1780\u17CB\u1798\u17B6\u1793\u17CB"},{"id":1586,"word":"\u1781\u17D2\u179C\u17B6\u1784"},{"id":1587,"word":"\u1781\u17D2\u179C\u17B6\u1785"},{"id":1588,"word":"\u1781\u17D2\u179C\u17B6\u1785\u17CB"},{"id":1589,"word":"\u1781\u17D2\u179C\u17B6\u178F\u17CB"},{"id":1590,"word":"\u1781\u17D2\u179C\u17B6\u178F\u17CB\u1781\u17D2\u179C\u17C2\u1784"},{"id":1591,"word":"\u1781\u17D2\u179C\u17B6\u1793"},{"id":1592,"word":"\u1781\u17D2\u179C\u17B6\u1793\u17CB"},{"id":1593,"word":"\u1781\u17D2\u179C\u17B6\u1793\u17CB\u1793\u17B6\u1782"},{"id":1594,"word":"\u1781\u17D2\u179C\u17B6\u1794\u17CB"},{"id":1595,"word":"\u1781\u17D2\u179C\u17B6\u1798"},{"id":1596,"word":"\u1781\u17D2\u179C\u17B6\u179F\u17D7"},{"id":1597,"word":"\u1781\u17D2\u179C\u17B6\u179A"},{"id":1598,"word":"\u1781\u17D2\u179C\u17B6\u179C"},{"id":1599,"word":"\u1781\u17D2\u179C\u17B7\u1785"},{"id":1600,"word":"\u1781\u17D2\u179C\u17B7\u178F"},{"id":1601,"word":"\u1781\u17D2\u179C\u17B7\u1793"},{"id":1602,"word":"\u1781\u17D2\u179C\u17B7\u179B"},{"id":1603,"word":"\u1781\u17D2\u179C\u17BE\u1780"},{"id":1604,"word":"\u1781\u17D2\u179C\u17BE\u1799\u17D7"},{"id":1605,"word":"\u1781\u17D2\u179C\u17C0\u1780"},{"id":1606,"word":"\u1781\u17D2\u179C\u17C0\u1793"},{"id":1607,"word":"\u1781\u17D2\u179C\u17C0\u1794"},{"id":1608,"word":"\u1781\u17D2\u179C\u17C1\u179A"},{"id":1609,"word":"\u1781\u17D2\u179C\u17C1\u17C7"},{"id":1610,"word":"\u1781\u17D2\u179C\u17C2"},{"id":1611,"word":"\u1781\u17D2\u179C\u17C2\u1780"},{"id":1612,"word":"\u1781\u17D2\u179C\u17C2\u1780\u178F\u17D2\u179A\u17C4\u1780"},{"id":1613,"word":"\u1781\u17D2\u179C\u17C2\u1784"},{"id":1614,"word":"\u1781\u17D2\u179C\u17C2\u178F"},{"id":1615,"word":"\u1781\u17D2\u179C\u17C2\u179C"},{"id":1616,"word":"\u1781\u17D2\u179C\u17C2\u17C7"},{"id":1617,"word":"\u1781\u17D2\u179C\u17C4\u1780"},{"id":1618,"word":"\u1781\u17D2\u179C\u17C4\u1780\u1781\u17D2\u179C\u17B6\u1780"},{"id":1619,"word":"\u1781\u17D2\u179C\u17C4\u17C7"},{"id":1620,"word":"\u1781\u17D2\u179C\u17C7"},{"id":1621,"word":"\u1781\u17D2\u179F\u178F"},{"id":1622,"word":"\u1781\u17D2\u179F\u178F\u17CB"},{"id":1623,"word":"\u1781\u17D2\u179F\u17B6\u1780"},{"id":1624,"word":"\u1781\u17D2\u179F\u17B6\u1785\u17CB"},{"id":1625,"word":"\u1781\u17D2\u179F\u17B6\u1785\u17CB\u1780\u178E\u17D2\u178A\u17B6\u179B"},{"id":1626,"word":"\u1781\u17D2\u179F\u17B6\u1793"},{"id":1627,"word":"\u1781\u17D2\u179F\u17B6\u1794"},{"id":1628,"word":"\u1781\u17D2\u179F\u17B6\u1799"},{"id":1629,"word":"\u1781\u17D2\u179F\u17B6\u179C"},{"id":1630,"word":"\u1781\u17D2\u179F\u17B9\u1780\u1781\u17D2\u179F\u17BD\u179B"},{"id":1631,"word":"\u1781\u17D2\u179F\u17B9\u1794"},{"id":1632,"word":"\u1781\u17D2\u179F\u17BA\u178F"},{"id":1633,"word":"\u1781\u17D2\u179F\u17BB\u1780"},{"id":1634,"word":"\u1781\u17D2\u179F\u17BB\u1785"},{"id":1635,"word":"\u1781\u17D2\u179F\u17BB\u1799"},{"id":1636,"word":"\u1781\u17D2\u179F\u17BB\u179B"},{"id":1637,"word":"\u1781\u17D2\u179F\u17BD\u179B"},{"id":1638,"word":"\u1781\u17D2\u179F\u17BD\u179F"},{"id":1639,"word":"\u1781\u17D2\u179F\u17C0"},{"id":1640,"word":"\u1781\u17D2\u179F\u17C0\u1782\u17D2\u179A\u1780\u17CB"},{"id":1641,"word":"\u1781\u17D2\u179F\u17C0\u1780"},{"id":1642,"word":"\u1781\u17D2\u179F\u17C0\u179C"},{"id":1643,"word":"\u1781\u17D2\u179F\u17C1\u179C"},{"id":1644,"word":"\u1781\u17D2\u179F\u17C2"},{"id":1645,"word":"\u1781\u17D2\u179F\u17C2\u1780\u17D2\u179A\u179C\u17B6\u178F\u17CB"},{"id":1646,"word":"\u1781\u17D2\u179F\u17C2\u1794\u17B6\u179F"},{"id":1647,"word":"\u1781\u17D2\u179F\u17C2\u1797\u17B6\u1796\u1799\u1793\u17D2\u178A"},{"id":1648,"word":"\u1781\u17D2\u179F\u17C2\u179F\u1799"},{"id":1649,"word":"\u1781\u17D2\u179F\u17C4\u1799"},{"id":1650,"word":"\u1781\u17D2\u179F\u17C4\u17C7"},{"id":1651,"word":"\u1781\u17D2\u1787\u17C1\u1789\u1781\u17D2\u1787\u17B7\u179B"},{"id":1652,"word":"\u1781\u17D2\u1789\u17BB\u17C6\u1780\u17C6\u178A\u179A"},{"id":1653,"word":"\u1782"},{"id":1654,"word":"\u1782\u1780"},{"id":1655,"word":"\u1782\u1780\u17CB"},{"id":1656,"word":"\u1782\u1782\u17B6\u1785"},{"id":1657,"word":"\u1782\u1782\u17B6\u178F"},{"id":1658,"word":"\u1782\u1782\u17B8\u179A"},{"id":1659,"word":"\u1782\u1782\u17B9\u1780"},{"id":1660,"word":"\u1782\u1782\u17B9\u178F"},{"id":1661,"word":"\u1782\u1782\u17BB\u1780"},{"id":1662,"word":"\u1782\u1782\u17BB\u1780\u1782\u1782\u17B6\u1780\u17CB"},{"id":1663,"word":"\u1782\u1782\u17BB\u179B"},{"id":1664,"word":"\u1782\u1782\u17BB\u17C7"},{"id":1665,"word":"\u1782\u1782\u17BE\u1798"},{"id":1666,"word":"\u1782\u1782\u17D2\u179A\u1780\u17CB"},{"id":1667,"word":"\u1782\u1782\u17D2\u179A\u1793\u17CB"},{"id":1668,"word":"\u1782\u1782\u17D2\u179A\u17B6\u1780\u17CB"},{"id":1669,"word":"\u1782\u1782\u17D2\u179A\u17B6\u178F"},{"id":1670,"word":"\u1782\u1782\u17D2\u179A\u17B7\u1784\u1782\u1782\u17D2\u179A\u17B6\u17C6\u1784"},{"id":1671,"word":"\u1782\u1782\u17D2\u179A\u17B7\u1785"},{"id":1672,"word":"\u1782\u1782\u17D2\u179A\u17B7\u17C7"},{"id":1673,"word":"\u1782\u1782\u17D2\u179A\u17B8\u178F\u1782\u1782\u17D2\u179A\u17B6\u178F"},{"id":1674,"word":"\u1782\u1782\u17D2\u179A\u17B8\u179C"},{"id":1675,"word":"\u1782\u1782\u17D2\u179A\u17B8\u179F\u1782\u1782\u17D2\u179A\u17BC\u179F"},{"id":1676,"word":"\u1782\u1782\u17D2\u179A\u17B9\u1780"},{"id":1677,"word":"\u1782\u1782\u17D2\u179A\u17B9\u1780\u1782\u1782\u17D2\u179A\u17C1\u1784"},{"id":1678,"word":"\u1782\u1782\u17D2\u179A\u17B9\u1798"},{"id":1679,"word":"\u1782\u1782\u17D2\u179A\u17BA\u178F"},{"id":1680,"word":"\u1782\u1782\u17D2\u179A\u17BB\u1780"},{"id":1681,"word":"\u1782\u1782\u17D2\u179A\u17BB\u1798"},{"id":1682,"word":"\u1782\u1782\u17D2\u179A\u17BB\u1799"},{"id":1683,"word":"\u1782\u1782\u17D2\u179A\u17BC\u1780"},{"id":1684,"word":"\u1782\u1782\u17D2\u179A\u17BD\u1794"},{"id":1685,"word":"\u1782\u1782\u17D2\u179A\u17BE\u1798"},{"id":1686,"word":"\u1782\u1782\u17D2\u179A\u17C1\u1784"},{"id":1687,"word":"\u1782\u1782\u17D2\u179A\u17C1\u1784\u1782\u1782\u17D2\u179A\u17B6\u17C6"},{"id":1688,"word":"\u1782\u1782\u17D2\u179A\u17C4\u1780"},{"id":1689,"word":"\u1782\u1782\u17D2\u179A\u17B6\u17C6"},{"id":1690,"word":"\u1782\u1782\u17D2\u179A\u17B6\u17C6\u1784"},{"id":1691,"word":"\u1782\u1783\u179A"},{"id":1692,"word":"\u1782\u1783\u17B6\u179A"},{"id":1693,"word":"\u1782\u1783\u17B9\u1780"},{"id":1694,"word":"\u1782\u1783\u17BC\u179F"},{"id":1695,"word":"\u1782\u1783\u17C0\u179A"},{"id":1696,"word":"\u1782\u1783\u17D2\u179B\u17BE\u1793"},{"id":1697,"word":"\u1782\u1784"},{"id":1698,"word":"\u1782\u1784\u1796\u17B7\u179F\u17B8"},{"id":1699,"word":"\u1782\u1784\u17CB"},{"id":1700,"word":"\u1782\u1784\u17CB\u178F\u17C2"},{"id":1701,"word":"\u1782\u1784\u17CB\u1793\u17C5"},{"id":1702,"word":"\u1782\u1784\u17CB\u179C\u1784\u17D2\u179F"},{"id":1703,"word":"\u1782\u1784\u17D2\u1782\u17B6"},{"id":1704,"word":"\u1782\u1784\u17D2\u1782\u17B6\u1793"},{"id":1705,"word":"\u1782\u1784\u17D2\u1782\u17BD\u1793"},{"id":1706,"word":"\u1782\u1784\u17D2\u179C\u17B6\u179B"},{"id":1707,"word":"\u1782\u1787"},{"id":1708,"word":"\u1782\u1787\u17CB"},{"id":1709,"word":"\u1782\u1787\u178F\u17B6"},{"id":1710,"word":"\u1782\u1787\u1791\u1793\u17D2\u178F"},{"id":1711,"word":"\u1782\u1787\u1798\u17BB\u1780\u17D2\u178F\u17B6"},{"id":1712,"word":"\u1782\u1787\u179F\u17B6\u179A"},{"id":1713,"word":"\u1782\u1787\u179F\u17B8\u17A0\u17CD"},{"id":1714,"word":"\u1782\u1787\u17B6"},{"id":1715,"word":"\u1782\u1787\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":1716,"word":"\u1782\u1787\u17D2\u179A\u17B6"},{"id":1717,"word":"\u1782\u178E"},{"id":1718,"word":"\u1782\u178E\u17C8"},{"id":1719,"word":"\u1782\u178E\u17C8\u1780\u1798\u17D2\u1798\u1780\u17B6\u179A"},{"id":1720,"word":"\u1782\u178E\u17C8\u1780\u1798\u17D2\u1798\u17B6\u1792\u17B7\u1780\u17B6\u179A"},{"id":1721,"word":"\u1782\u178E\u17D2\u178B\u17B8"},{"id":1722,"word":"\u1782\u178E\u1793\u17B6"},{"id":1723,"word":"\u1782\u178E\u1793\u17B8"},{"id":1724,"word":"\u1782\u178E\u1793\u17B8\u1799\u178A\u17D2\u178B\u17B6\u1793"},{"id":1725,"word":"\u1782\u178E\u1793\u17C1\u1799\u17D2\u1799"},{"id":1726,"word":"\u1782\u178E\u1793\u17C1\u1799\u17D2\u1799\u1780\u179A"},{"id":1727,"word":"\u1782\u178E\u1794\u1780\u17D2\u1781"},{"id":1728,"word":"\u1782\u178E\u17C8\u1794\u17D2\u179A\u178F\u17B7\u1797\u17BC"},{"id":1729,"word":"\u1782\u178E\u17C8\u179A\u178A\u17D2\u178B\u1798\u1793\u17D2\u178F\u17D2\u179A\u17B8"},{"id":1730,"word":"\u1782\u178E\u17B7\u178F\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":1731,"word":"\u1782\u178E\u17C1\u179F"},{"id":1732,"word":"\u1782\u178F\u17CB"},{"id":1733,"word":"\u1782\u178F\u17CB\u1798\u178F\u17CB"},{"id":1734,"word":"\u1782\u178F\u17B7"},{"id":1735,"word":"\u1782\u178F\u17B7\u1794\u178E\u17D2\u178C\u17B7\u178F"},{"id":1736,"word":"\u1782\u1793"},{"id":1737,"word":"\u1782\u1793\u17CB"},{"id":1738,"word":"\u1782\u1793\u17CB\u1782\u17BC\u179A"},{"id":1739,"word":"\u1782\u1793\u17D2\u1790\u17C8"},{"id":1740,"word":"\u1782\u1793\u17D2\u1790\u1792\u17BB\u179A\u17C8"},{"id":1741,"word":"\u1782\u1793\u17D2\u1790\u179A\u1785\u1793\u17B6"},{"id":1742,"word":"\u1782\u1793\u17D2\u1790\u179A\u1785\u1793\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":1743,"word":"\u1782\u1793\u17D2\u1792"},{"id":1744,"word":"\u1782\u1793\u17D2\u1792\u1796\u17D2\u179C"},{"id":1745,"word":"\u1782\u1793\u17D2\u179B\u1784"},{"id":1746,"word":"\u1782\u1793\u17D2\u179B\u17B6\u1780\u17CB"},{"id":1747,"word":"\u1782\u1793\u17D2\u179B\u17B6\u1780\u17CB\u1782\u1793\u17D2\u179B\u17BE\u1793"},{"id":1748,"word":"\u1782\u1793\u17D2\u179B\u17B6\u1780\u17CB\u17A2\u17B6\u1785\u1798\u17CD"},{"id":1749,"word":"\u1782\u1793\u17D2\u179B\u17B6\u179F\u17CB"},{"id":1750,"word":"\u1782\u1793\u17D2\u179B\u17B6\u179F\u17CB\u1782\u1793\u17D2\u179B\u17C4\u1784"},{"id":1751,"word":"\u1782\u1793\u17D2\u179B\u17B7\u1780\u1782\u1793\u17D2\u179B\u17B6\u1780\u17CB"},{"id":1752,"word":"\u1782\u1793\u17D2\u179B\u17B9\u17C7"},{"id":1753,"word":"\u1782\u1793\u17D2\u179B\u17C4\u1784"},{"id":1754,"word":"\u1782\u1794\u17CB"},{"id":1755,"word":"\u1782\u1794\u17CB\u1782\u17B7\u178F"},{"id":1756,"word":"\u1782\u1794\u17D2\u1794\u17B8"},{"id":1757,"word":"\u1782\u1797\u17CC"},{"id":1758,"word":"\u1782\u1798"},{"id":1759,"word":"\u1782\u1798\u1793\u17B6\u1780\u17B6\u179A"},{"id":1760,"word":"\u1782\u1798\u1793\u17B6\u1782\u1798\u1793\u17CD"},{"id":1761,"word":"\u1782\u1798\u17D2\u178A\u17C2\u1784"},{"id":1762,"word":"\u1782\u1798\u17D2\u1796\u17B8\u179A"},{"id":1763,"word":"\u1782\u1798\u17D2\u1797\u17B8\u179A"},{"id":1764,"word":"\u1782\u1798\u17D2\u179A\u1780\u17CB"},{"id":1765,"word":"\u1782\u1798\u17D2\u179A\u1784"},{"id":1766,"word":"\u1782\u1798\u17D2\u179A\u1794"},{"id":1767,"word":"\u1782\u1798\u17D2\u179A\u1794\u17CB"},{"id":1768,"word":"\u1782\u1798\u17D2\u179A\u17B7\u1784\u1782\u1798\u17D2\u179A\u17B6\u17C6\u1784"},{"id":1769,"word":"\u1782\u1798\u17D2\u179A\u17B7\u17C7"},{"id":1770,"word":"\u1782\u1798\u17D2\u179A\u17C0\u179C"},{"id":1771,"word":"\u1782\u1798\u17D2\u179A\u17C4\u1784"},{"id":1772,"word":"\u1782\u1798\u17D2\u179A\u17B6\u17C6\u1784"},{"id":1773,"word":"\u1782\u1798\u17D2\u179B\u1784\u17CB"},{"id":1774,"word":"\u1782\u1798\u17D2\u179B\u17B6\u1793"},{"id":1775,"word":"\u1782\u1799"},{"id":1776,"word":"\u1782\u1799\u1782\u1793\u17CB"},{"id":1777,"word":"\u1782\u1799\u1783\u17D2\u179B\u17B6\u17C6"},{"id":1778,"word":"\u1782\u179A"},{"id":1779,"word":"\u1782\u179A\u1782\u17C4\u1780"},{"id":1780,"word":"\u1782\u179A\u17A0\u17B6"},{"id":1781,"word":"\u1782\u179A\u17BB"},{"id":1782,"word":"\u1782\u179A\u17BB\u1780\u17C4\u179F\u179B\u17D2\u1799"},{"id":1783,"word":"\u1782\u179A\u17BB\u1791\u17C4\u179F"},{"id":1784,"word":"\u1782\u179A\u17BB\u1797\u178E\u17D2\u178C"},{"id":1785,"word":"\u1782\u179A\u17BB\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":1786,"word":"\u1782\u179B\u17CB"},{"id":1787,"word":"\u1782\u179B\u17CB\u1780\u17C2"},{"id":1788,"word":"\u1782\u179B\u17CB\u179A\u17B6\u17C6\u1784"},{"id":1789,"word":"\u1782\u17A0\u1794\u178F\u17B8"},{"id":1790,"word":"\u1782\u17B6\u1780\u17CB"},{"id":1791,"word":"\u1782\u17B6\u1784"},{"id":1792,"word":"\u1782\u17B6\u1784\u1783\u17D2\u179C\u17B6\u1799"},{"id":1793,"word":"\u1782\u17B6\u178F"},{"id":1794,"word":"\u1782\u17B6\u178F\u17CB"},{"id":1795,"word":"\u1782\u17B6\u1790\u17B6"},{"id":1796,"word":"\u1782\u17B6\u1790\u17B6\u1796\u1793\u17D2\u1792"},{"id":1797,"word":"\u1782\u17B6\u1790\u17B6\u1796\u17B6\u1793\u17CB"},{"id":1798,"word":"\u1782\u17B6\u1794"},{"id":1799,"word":"\u1782\u17B6\u1794\u17CB"},{"id":1800,"word":"\u1782\u17B6\u1798\u1780\u1790\u17B6"},{"id":1801,"word":"\u1782\u17B6\u1798\u1797\u17B6\u179F\u17B6"},{"id":1802,"word":"\u1782\u17B6\u1798\u1797\u17C4\u1787\u1780"},{"id":1803,"word":"\u1782\u17B6\u1799"},{"id":1804,"word":"\u1782\u17B6\u179A\u179C\u17C8"},{"id":1805,"word":"\u1782\u17B6\u179B\u17CB"},{"id":1806,"word":"\u1782\u17B6\u179C"},{"id":1807,"word":"\u1782\u17B6\u179C\u17BB\u178F"},{"id":1808,"word":"\u1782\u17B6\u179F\u17CB"},{"id":1809,"word":"\u1782\u17B7\u178F"},{"id":1810,"word":"\u1782\u17B7\u179A\u17B8"},{"id":1811,"word":"\u1782\u17B7\u179A\u17B8\u179C\u1784\u17D2\u1780\u178F"},{"id":1812,"word":"\u1782\u17B7\u179A\u17B8\u179C\u1784\u17CB"},{"id":1813,"word":"\u1782\u17B7\u179B"},{"id":1814,"word":"\u1782\u17B7\u179B\u17B6\u1793"},{"id":1815,"word":"\u1782\u17B8"},{"id":1816,"word":"\u1782\u17B8\u1784\u17D2\u1782\u1780\u17CB"},{"id":1817,"word":"\u1782\u17B8\u178F\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":1818,"word":"\u1782\u17B8\u1798\u17B8"},{"id":1819,"word":"\u1782\u17B9\u1780\u17D7"},{"id":1820,"word":"\u1782\u17B9\u179B"},{"id":1821,"word":"\u1782\u17BA"},{"id":1822,"word":"\u1782\u17BB\u1780"},{"id":1823,"word":"\u1782\u17BB\u1780\u17D7"},{"id":1824,"word":"\u1782\u17BB\u178E"},{"id":1825,"word":"\u1782\u17BB\u178E--"},{"id":1826,"word":"\u1782\u17BB\u178F"},{"id":1827,"word":"\u1782\u17BB\u1793"},{"id":1828,"word":"\u1782\u17BB\u1798\u17D2\u1796"},{"id":1829,"word":"\u1782\u17BB\u1798\u17D2\u1796\u17C4\u178F"},{"id":1830,"word":"\u1782\u17BB\u1799"},{"id":1831,"word":"\u1782\u17BB\u1799\u1791\u17B6\u179C"},{"id":1832,"word":"\u1782\u17BB\u1799\u17D2\u17A0\u17C8"},{"id":1833,"word":"\u1782\u17BB\u179B"},{"id":1834,"word":"\u1782\u17BB\u179B\u17B7\u1780\u17B6"},{"id":1835,"word":"\u1782\u17BB\u179B\u17B8"},{"id":1836,"word":"\u1782\u17BB\u17A0\u17B6"},{"id":1837,"word":"\u1782\u17BC"},{"id":1838,"word":"\u1782\u17BC\u1780"},{"id":1839,"word":"\u1782\u17BC\u1780\u1793"},{"id":1840,"word":"\u1782\u17BC\u1786\u17B6\u1799"},{"id":1841,"word":"\u1782\u17BC\u1790"},{"id":1842,"word":"\u1782\u17BC\u1791"},{"id":1843,"word":"\u1782\u17BC\u179A"},{"id":1844,"word":"\u1782\u17BC\u179B\u17B8"},{"id":1845,"word":"\u1782\u17BC\u179B\u17B8\u178F"},{"id":1846,"word":"\u1782\u17BC\u179B\u17C2\u1793"},{"id":1847,"word":"\u1782\u17BC\u179F"},{"id":1848,"word":"\u1782\u17BD\u1794"},{"id":1849,"word":"\u1782\u17BD\u179A"},{"id":1850,"word":"\u1782\u17BD\u179A"},{"id":1851,"word":"\u1782\u17BD\u179A\u1793\u17B6"},{"id":1852,"word":"\u1782\u17BD\u179A\u17B8\u1799\u17C1\u179A"},{"id":1853,"word":"\u1782\u17BE\u1798\u17D7"},{"id":1854,"word":"\u1782\u17C1"},{"id":1855,"word":"\u1782\u17C1\u1784"},{"id":1856,"word":"\u1782\u17C1\u1785"},{"id":1857,"word":"\u1782\u17C1\u1785\u1780\u17C2"},{"id":1858,"word":"\u1782\u17C1\u1785\u179C\u17C1\u17C7"},{"id":1859,"word":"\u1782\u17C1\u17A0\u17CD"},{"id":1860,"word":"\u1782\u17C1\u17A0\u1787\u1793"},{"id":1861,"word":"\u1782\u17C1\u17A0\u178A\u17D2\u178B\u17B6\u1793"},{"id":1862,"word":"\u1782\u17C1\u17A0\u1794\u17B6\u179B"},{"id":1863,"word":"\u1782\u17C1\u17A0\u179F\u17D2\u179F\u17B6\u1798\u17B7\u1780"},{"id":1864,"word":"\u1782\u17C1\u17A0\u17B6\u1797\u17B7\u1794\u17B6\u179B"},{"id":1865,"word":"\u1782\u17C2"},{"id":1866,"word":"\u1782\u17C2\u1793"},{"id":1867,"word":"\u1782\u17C2\u1794"},{"id":1868,"word":"\u1782\u17C2\u1798"},{"id":1869,"word":"\u1782\u17C2\u179B"},{"id":1870,"word":"\u1782\u17C2\u179B\u179B\u1780"},{"id":1871,"word":"\u1782\u17C2\u17A0\u17CA\u17C5"},{"id":1872,"word":"\u1782\u17C3"},{"id":1873,"word":"\u1782\u17C4"},{"id":1874,"word":"\u1782\u17C4\u1780"},{"id":1875,"word":"\u1782\u17C4\u1781\u17D2\u1798\u17C2\u179A"},{"id":1876,"word":"\u1782\u17C4\u1783\u17B6\u178F\u1780\u17CD"},{"id":1877,"word":"\u1782\u17C4\u1783\u17B6\u178F\u1780\u1798\u17D2\u1798"},{"id":1878,"word":"\u1782\u17C4\u1783\u17B6\u178F\u178A\u17D2\u178B\u17B6\u1793"},{"id":1879,"word":"\u1782\u17C4\u1783\u17B6\u178F\u179F\u17D2\u1790\u17B6\u1793"},{"id":1880,"word":"\u1782\u17C4\u1784"},{"id":1881,"word":"\u1782\u17C4\u1784\u17D7"},{"id":1882,"word":"\u1782\u17C4\u1785\u179A"},{"id":1883,"word":"\u1782\u17C4\u1786\u17D2\u1798\u17B6\u178F\u17CB"},{"id":1884,"word":"\u1782\u17C4\u178F"},{"id":1885,"word":"\u1782\u17C4\u178F\u1798"},{"id":1886,"word":"\u1782\u17C4\u178F\u1798\u1782\u17C4\u178F\u17D2\u178F"},{"id":1887,"word":"\u1782\u17C4\u178F\u1798\u1796\u17BB\u1791\u17D2\u1792"},{"id":1888,"word":"\u1782\u17C4\u178F\u17D2\u178F"},{"id":1889,"word":"\u1782\u17C4\u178F\u17D2\u178F\u1793\u17B6\u1798"},{"id":1890,"word":"\u1782\u17C4\u178F\u17D2\u179A"},{"id":1891,"word":"\u1782\u17C4\u178F\u17D2\u179A\u1780\u17BC\u179B"},{"id":1892,"word":"\u1782\u17C4\u178F\u17D2\u179A\u1797\u17BC"},{"id":1893,"word":"\u1782\u17C4\u178F\u17D2\u179A\u1797\u17BC\u1789\u17B6\u178E"},{"id":1894,"word":"\u1782\u17C4\u178F\u17D2\u179A\u1797\u17BC\u179F\u1784\u17D2\u1783"},{"id":1895,"word":"\u1782\u17C4\u1791\u17B6\u179C\u179A\u17B8"},{"id":1896,"word":"\u1782\u17C4\u1792\u17B7\u1780"},{"id":1897,"word":"\u1782\u17C4\u1794\u17B6"},{"id":1898,"word":"\u1782\u17C4\u1794\u17B6\u179B"},{"id":1899,"word":"\u1782\u17C4\u1796\u17D2\u179A\u17C3"},{"id":1900,"word":"\u1782\u17C4\u1796\u17D2\u179A\u17C4\u17C7"},{"id":1901,"word":"\u1782\u17C4\u1798"},{"id":1902,"word":"\u1782\u17C4\u1798\u17A0\u17C4\u17C7"},{"id":1903,"word":"\u1782\u17C4\u1798\u17C9"},{"id":1904,"word":"\u1782\u17C4\u1798\u17D0\u1799"},{"id":1905,"word":"\u1782\u17C4\u1798\u17BC\u178F\u17D2\u179A"},{"id":1906,"word":"\u1782\u17C4\u1798\u17BD\u1799"},{"id":1907,"word":"\u1782\u17C4\u179A\u1780\u17D2\u1781\u1780\u1798\u17D2\u1798"},{"id":1908,"word":"\u1782\u17C4\u179A\u1780\u17D2\u1781\u17B6"},{"id":1909,"word":"\u1782\u17C4\u179A\u1796"},{"id":1910,"word":"\u1782\u17C4\u179A\u1798"},{"id":1911,"word":"\u1782\u17C4\u179A\u1798\u1784\u17B6\u179A"},{"id":1912,"word":"\u1782\u17C4\u179A\u179F"},{"id":1913,"word":"\u1782\u17C4\u179A\u17B6\u178F"},{"id":1914,"word":"\u1782\u17C4\u179B"},{"id":1915,"word":"\u1782\u17C4\u179B\u17D2\u1794\u17B6\u1799"},{"id":1916,"word":"\u1782\u17C4\u179C\u178F\u17D2\u178F"},{"id":1917,"word":"\u1782\u17C4\u179F\u17C0\u1798"},{"id":1918,"word":"\u1782\u17C4\u17A0\u17C0"},{"id":1919,"word":"\u1782\u17C4\u17A0\u17D2\u1798"},{"id":1920,"word":"\u1782\u17C4\u17C7"},{"id":1921,"word":"\u1782\u17C4\u17C7\u1796\u1796\u17D2\u179B\u17B6\u1780\u17CB"},{"id":1922,"word":"\u1782\u17BB\u17C6"},{"id":1923,"word":"\u1782\u17C6"},{"id":1924,"word":"\u1782\u17C6\u1793\u1784"},{"id":1925,"word":"\u1782\u17C6\u1793\u1798"},{"id":1926,"word":"\u1782\u17C6\u1793\u179A"},{"id":1927,"word":"\u1782\u17C6\u1793\u17B6\u1780\u17CB"},{"id":1928,"word":"\u1782\u17C6\u1793\u17B6\u178F"},{"id":1929,"word":"\u1782\u17C6\u1793\u17B6\u1794"},{"id":1930,"word":"\u1782\u17C6\u1793\u17B6\u1794\u17CB"},{"id":1931,"word":"\u1782\u17C6\u1793\u17B6\u179B\u17CB"},{"id":1932,"word":"\u1782\u17C6\u1793\u17B6\u179F\u17CB"},{"id":1933,"word":"\u1782\u17C6\u1793\u17B7\u178F"},{"id":1934,"word":"\u1782\u17C6\u1793\u17BC\u179A"},{"id":1935,"word":"\u1782\u17C6\u1793\u17BC\u179F"},{"id":1936,"word":"\u1782\u17C6\u1793\u17BD\u1794"},{"id":1937,"word":"\u1782\u17C6\u1793\u17BD\u179A"},{"id":1938,"word":"\u1782\u17C6\u1793\u17C4\u17C7"},{"id":1939,"word":"\u1782\u17C6\u1793\u17BB\u17C6"},{"id":1940,"word":"\u1782\u17C6\u179A\u1784\u17CB"},{"id":1941,"word":"\u1782\u17C6\u179A\u179B"},{"id":1942,"word":"\u1782\u17C6\u179A\u17B6\u1798"},{"id":1943,"word":"\u1782\u17C6\u179A\u17B9\u179B"},{"id":1944,"word":"\u1782\u17C6\u179A\u17BC"},{"id":1945,"word":"\u1782\u17C6\u179A\u17BE\u1799"},{"id":1946,"word":"\u1782\u17C6\u179A\u17C1\u1785"},{"id":1947,"word":"\u1782\u17C6\u179A\u17C4\u17C7"},{"id":1948,"word":"\u1782\u17C6\u17A0\u1780"},{"id":1949,"word":"\u1782\u17C6\u17A0\u17B6\u178F\u17CB"},{"id":1950,"word":"\u1782\u17C6\u17A0\u17B9\u1793"},{"id":1951,"word":"\u1782\u17C6\u17A0\u17BB\u1780"},{"id":1952,"word":"\u1782\u17C6\u17A0\u17C2\u178F"},{"id":1953,"word":"\u1782\u17B6\u17C6"},{"id":1954,"word":"\u1782\u17B6\u17C6\u1784"},{"id":1955,"word":"\u1782\u17B6\u17C6\u1796\u17B6\u179A"},{"id":1956,"word":"\u1782\u17C7"},{"id":1957,"word":"\u1782\u17C7\u1782\u17B6"},{"id":1958,"word":"\u1782\u17D2\u1793\u17B6"},{"id":1959,"word":"\u1782\u17D2\u1793\u17B6\u1793\u17CB"},{"id":1960,"word":"\u1782\u17D2\u1793\u17B8"},{"id":1961,"word":"\u1782\u17D2\u1793\u17C1\u179A"},{"id":1962,"word":"\u1782\u17D2\u1793\u17C1\u179A\u1782\u17D2\u1793\u17B6\u1793\u17CB"},{"id":1963,"word":"\u1782\u17D2\u1798\u17B6\u1793"},{"id":1964,"word":"\u1782\u17D2\u179A"},{"id":1965,"word":"\u1782\u17D2\u179A\u1780"},{"id":1966,"word":"\u1782\u17D2\u179A\u1780\u17D7"},{"id":1967,"word":"\u1782\u17D2\u179A\u1780\u17CB"},{"id":1968,"word":"\u1782\u17D2\u179A\u1780\u17CB\u17D7"},{"id":1969,"word":"\u1782\u17D2\u179A\u1784"},{"id":1970,"word":"\u1782\u17D2\u179A\u1784\u17CB"},{"id":1971,"word":"\u1782\u17D2\u179A\u1787\u17B8\u179C"},{"id":1972,"word":"\u1782\u17D2\u179A\u1787\u17B9\u1794"},{"id":1973,"word":"\u1782\u17D2\u179A\u1787\u17B9\u1794\u1782\u17D2\u179A\u1787\u17B8\u179C"},{"id":1974,"word":"\u1782\u17D2\u179A\u1787\u17B9\u1794\u1782\u17D2\u179A\u1787\u17BD\u1785"},{"id":1975,"word":"\u1782\u17D2\u179A\u1787\u17BC\u179A"},{"id":1976,"word":"\u1782\u17D2\u179A\u1787\u17B6\u17C6"},{"id":1977,"word":"\u1782\u17D2\u179A\u1789\u17B7\u1785"},{"id":1978,"word":"\u1782\u17D2\u179A\u1789\u17B9\u1780"},{"id":1979,"word":"\u1782\u17D2\u179A\u1789\u17BC\u1784"},{"id":1980,"word":"\u1782\u17D2\u179A\u1789\u17C2\u1784"},{"id":1981,"word":"\u1782\u17D2\u179A\u1794"},{"id":1982,"word":"\u1782\u17D2\u179A\u1794\u1782\u17D2\u179A\u1784"},{"id":1983,"word":"\u1782\u17D2\u179A\u1794\u1792\u17D2\u1798\u17C1\u1789\u1788\u17BE"},{"id":1984,"word":"\u1782\u17D2\u179A\u1794\u17CB"},{"id":1985,"word":"\u1782\u17D2\u179A\u1794\u17CB\u1782\u17D2\u179A\u1784"},{"id":1986,"word":"\u1782\u17D2\u179A\u1798\u179A"},{"id":1987,"word":"\u1782\u17D2\u179A\u1798\u179B\u17CB"},{"id":1988,"word":"\u1782\u17D2\u179A\u1798\u17B6\u1780"},{"id":1989,"word":"\u1782\u17D2\u179A\u1798\u17B6\u1789"},{"id":1990,"word":"\u1782\u17D2\u179A\u1798\u17B6\u1798"},{"id":1991,"word":"\u1782\u17D2\u179A\u1798\u17B7\u1784\u1782\u17D2\u179A\u1798\u17B6\u17C6\u1784"},{"id":1992,"word":"\u1782\u17D2\u179A\u1798\u17BE\u1798"},{"id":1993,"word":"\u1782\u17D2\u179A\u1798\u17B6\u17C6\u1784"},{"id":1994,"word":"\u1782\u17D2\u179A\u179B\u1784\u17CB"},{"id":1995,"word":"\u1782\u17D2\u179A\u179B\u179A"},{"id":1996,"word":"\u1782\u17D2\u179A\u179B\u179F"},{"id":1997,"word":"\u1782\u17D2\u179A\u179B\u17B8\u178F"},{"id":1998,"word":"\u1782\u17D2\u179A\u179B\u17BB\u1780"},{"id":1999,"word":"\u1782\u17D2\u179A\u179B\u17BD\u1784"},{"id":2000,"word":"\u1782\u17D2\u179A\u179B\u17BD\u1785"},{"id":2001,"word":"\u1782\u17D2\u179A\u179B\u17C0\u179C"},{"id":2002,"word":"\u1782\u17D2\u179A\u179B\u17C0\u179F"},{"id":2003,"word":"\u1782\u17D2\u179A\u179B\u17C1\u1784\u1782\u17D2\u179A\u179B\u17C4\u1784"},{"id":2004,"word":"\u1782\u17D2\u179A\u179B\u17C1\u179C"},{"id":2005,"word":"\u1782\u17D2\u179A\u179B\u17C2\u1784"},{"id":2006,"word":"\u1782\u17D2\u179A\u179B\u17C2\u1784\u179C\u17C2\u1780"},{"id":2007,"word":"\u1782\u17D2\u179A\u179C\u17B6\u178F\u17CB"},{"id":2008,"word":"\u1782\u17D2\u179A\u179C\u17B6\u179F"},{"id":2009,"word":"\u1782\u17D2\u179A\u179C\u17B8"},{"id":2010,"word":"\u1782\u17D2\u179A\u179C\u17B8\u179F"},{"id":2011,"word":"\u1782\u17D2\u179A\u179C\u17C0\u1785"},{"id":2012,"word":"\u1782\u17D2\u179A\u179C\u17C0\u1793"},{"id":2013,"word":"\u1782\u17D2\u179A\u179C\u17C2\u1784"},{"id":2014,"word":"\u1782\u17D2\u179A\u179F\u17CA\u17C2\u178F"},{"id":2015,"word":"\u1782\u17D2\u179A\u17A0\u179A"},{"id":2016,"word":"\u1782\u17D2\u179A\u17A0\u179F\u17D2\u1790"},{"id":2017,"word":"\u1782\u17D2\u179A\u17A0\u17B6\u1789"},{"id":2018,"word":"\u1782\u17D2\u179A\u17A0\u17B7\u1780\u1782\u17D2\u179A\u17A0\u17BB\u1780"},{"id":2019,"word":"\u1782\u17D2\u179A\u17A0\u17B8\u178F"},{"id":2020,"word":"\u1782\u17D2\u179A\u17A0\u17B9\u1798"},{"id":2021,"word":"\u1782\u17D2\u179A\u17A0\u17BB\u1785"},{"id":2022,"word":"\u1782\u17D2\u179A\u17A0\u17BB\u1794"},{"id":2023,"word":"\u1782\u17D2\u179A\u17A0\u17BC"},{"id":2024,"word":"\u1782\u17D2\u179A\u17A0\u17BD\u1784"},{"id":2025,"word":"\u1782\u17D2\u179A\u17A0\u17BB\u1785"},{"id":2026,"word":"\u1782\u17D2\u179A\u17A0\u17BB\u1794"},{"id":2027,"word":"\u1782\u17D2\u179A\u17A0\u17BE"},{"id":2028,"word":"\u1782\u17D2\u179A\u17A0\u17C2\u178F"},{"id":2029,"word":"\u1782\u17D2\u179A\u17A0\u17C2\u1798"},{"id":2030,"word":"\u1782\u17D2\u179A\u17B6"},{"id":2031,"word":"\u1782\u17D2\u179A\u17B6\u1780"},{"id":2032,"word":"\u1782\u17D2\u179A\u17B6\u1780\u17CB"},{"id":2033,"word":"\u1782\u17D2\u179A\u17B6\u1780\u17CB\u17D7"},{"id":2034,"word":"\u1782\u17D2\u179A\u17B6\u1784"},{"id":2035,"word":"\u1782\u17D2\u179A\u17B6\u1793\u17CB"},{"id":2036,"word":"\u1782\u17D2\u179A\u17B6\u1793\u17CB\u1782\u17D2\u179A\u1794\u17CB"},{"id":2037,"word":"\u1782\u17D2\u179A\u17B6\u1793\u17CB\u178F\u17C2"},{"id":2038,"word":"\u1782\u17D2\u179A\u17B6\u1793\u17CB\u1794\u17BE"},{"id":2039,"word":"\u1782\u17D2\u179A\u17B6\u1794\u17CB"},{"id":2040,"word":"\u1782\u17D2\u179A\u17B6\u1798"},{"id":2041,"word":"\u1782\u17D2\u179A\u17B6\u1798\u178E\u17B8"},{"id":2042,"word":"\u1782\u17D2\u179A\u17B6\u1798\u1797\u17B6\u179F\u17B6"},{"id":2043,"word":"\u1782\u17D2\u179A\u17B6\u1798\u1797\u17C4\u1787\u1780"},{"id":2044,"word":"\u1782\u17D2\u179A\u17B6\u1798\u1798\u17BB\u1781"},{"id":2045,"word":"\u1782\u17D2\u179A\u17B6\u1798\u17C1\u179F"},{"id":2046,"word":"\u1782\u17D2\u179A\u17B6\u179C"},{"id":2047,"word":"\u1782\u17D2\u179A\u17B6\u179F"},{"id":2048,"word":"\u1782\u17D2\u179A\u17B6\u17A0\u17CD"},{"id":2049,"word":"\u1782\u17D2\u179A\u17B6\u17C7"},{"id":2050,"word":"\u1782\u17D2\u179A\u17B7\u1785\u17D7"},{"id":2051,"word":"\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"},{"id":2052,"word":"\u1782\u17D2\u179A\u17B8\u178F\u1782\u17D2\u179A\u17B6\u178F"},{"id":2053,"word":"\u1782\u17D2\u179A\u17B8\u1794"},{"id":2054,"word":"\u1782\u17D2\u179A\u17B9\u1780\u17D7"},{"id":2055,"word":"\u1782\u17D2\u179A\u17B9\u1794"},{"id":2056,"word":"\u1782\u17D2\u179A\u17B9\u1798\u17D7"},{"id":2057,"word":"\u1782\u17D2\u179A\u17B9\u17A0\u17B6"},{"id":2058,"word":"\u1782\u17D2\u179A\u17B9\u17A0\u17B6\u179C\u17B6\u179F"},{"id":2059,"word":"\u1782\u17D2\u179A\u17B9\u17C7"},{"id":2060,"word":"\u1782\u17D2\u179A\u17B9\u17C7\u179F\u17D2\u1790\u17B6\u1793"},{"id":2061,"word":"\u1782\u17D2\u179A\u17BA\u178F\u17D7"},{"id":2062,"word":"\u1782\u17D2\u179A\u17BB\u1780\u17D7"},{"id":2063,"word":"\u1782\u17D2\u179A\u17BB\u178C"},{"id":2064,"word":"\u1782\u17D2\u179A\u17BB\u1793"},{"id":2065,"word":"\u1782\u17D2\u179A\u17BB\u1794"},{"id":2066,"word":"\u1782\u17D2\u179A\u17BB\u1798"},{"id":2067,"word":"\u1782\u17D2\u179A\u17BB\u1799"},{"id":2068,"word":"\u1782\u17D2\u179A\u17BB\u17C7"},{"id":2069,"word":"\u1782\u17D2\u179A\u17BC"},{"id":2070,"word":"\u1782\u17D2\u179A\u17BC\u1780"},{"id":2071,"word":"\u1782\u17D2\u179A\u17BC\u1794\u17B6\u1792\u17D2\u1799\u17B6\u1799"},{"id":2072,"word":"\u1782\u17D2\u179A\u17BD"},{"id":2073,"word":"\u1782\u17D2\u179A\u17BD\u1794\u17D7"},{"id":2074,"word":"\u1782\u17D2\u179A\u17BD\u179F\u17B6\u179A"},{"id":2075,"word":"\u1782\u17D2\u179A\u17BE\u1798"},{"id":2076,"word":"\u1782\u17D2\u179A\u17BE\u179B"},{"id":2077,"word":"\u1782\u17D2\u179A\u17BF\u1784"},{"id":2078,"word":"\u1782\u17D2\u179A\u17BF\u1793"},{"id":2079,"word":"\u1782\u17D2\u179A\u17C0\u179C"},{"id":2080,"word":"\u1782\u17D2\u179A\u17C0\u179F"},{"id":2081,"word":"\u1782\u17D2\u179A\u17C1\u1784"},{"id":2082,"word":"\u1782\u17D2\u179A\u17C1\u1785"},{"id":2083,"word":"\u1782\u17D2\u179A\u17C2"},{"id":2084,"word":"\u1782\u17D2\u179A\u17C2\u1784"},{"id":2085,"word":"\u1782\u17D2\u179A\u17C4\u1784"},{"id":2086,"word":"\u1782\u17D2\u179A\u17C4\u178F"},{"id":2087,"word":"\u1782\u17D2\u179A\u17C4\u17C7"},{"id":2088,"word":"\u1782\u17D2\u179A\u17C4\u17C7\u1787\u17B6"},{"id":2089,"word":"\u1782\u17D2\u179A\u17BB\u17C6"},{"id":2090,"word":"\u1782\u17D2\u179A\u17C6"},{"id":2091,"word":"\u1782\u17D2\u179A\u17B6\u17C6"},{"id":2092,"word":"\u1782\u17D2\u179A\u17B6\u17C6\u1782\u17D2\u179A\u17B6"},{"id":2093,"word":"\u1782\u17D2\u179A\u17B6\u17C6\u1784\u17D7"},{"id":2094,"word":"\u1782\u17D2\u179C\u17B6\u1798"},{"id":2095,"word":"\u1782\u178F\u179F\u1789\u17D2\u1789\u17B6"},{"id":2096,"word":"\u1782\u1798\u17D2\u179A\u17C0\u179C"},{"id":2097,"word":"\u1782\u1798\u17D2\u179A\u17C1\u1785"},{"id":2098,"word":"\u1782\u17B8\u17A1\u17BC"},{"id":2099,"word":"\u1782\u17B8\u17A1\u17BC\u1780\u17D2\u179A\u17B6\u1798"},{"id":2100,"word":"\u1782\u17B8\u17A1\u17BC\u178F\u17C4\u1793"},{"id":2101,"word":"\u1782\u17B8\u17A1\u17BC\u1798\u17C9\u17C2\u178F\u17D2\u179A"},{"id":2102,"word":"\u1782\u17B8\u17A1\u17BC\u179C\u17C9\u17B6\u178F\u17CB"},{"id":2103,"word":"\u1782\u17B8\u17A1\u17BC\u179C\u17C9\u17BB\u179B"},{"id":2104,"word":"\u1782\u17B8\u17A1\u17BC\u179F\u17CA\u17B8\u1780"},{"id":2105,"word":"\u1782\u17C4\u179B\u17C4\u178F"},{"id":2106,"word":"\u1782\u17C6\u1793\u1780\u17CB"},{"id":2107,"word":"\u1782\u17C6\u1793\u1784"},{"id":2108,"word":"\u1782\u17C6\u1793\u1784\u17CB"},{"id":2109,"word":"\u1782\u17C6\u1793\u1793\u17CB"},{"id":2110,"word":"\u1782\u1793\u1794\u17CB"},{"id":2111,"word":"\u1782\u17D2\u179A\u17B6\u1794\u17CB\u1794\u17C2\u1780"},{"id":2112,"word":"\u1783"},{"id":2113,"word":"\u1783\u179A\u178E\u17B8"},{"id":2114,"word":"\u1783\u179A\u1798\u17BC\u179B"},{"id":2115,"word":"\u1783\u179A\u17B6\u179C\u17B6\u179F"},{"id":2116,"word":"\u1783\u17B6\u1784"},{"id":2117,"word":"\u1783\u17B6\u178F"},{"id":2118,"word":"\u1783\u17B6\u178F\u17CB"},{"id":2119,"word":"\u1783\u17B6\u178F\u1780\u17C8"},{"id":2120,"word":"\u1783\u17B6\u178F\u1780\u1798\u17D2\u1798"},{"id":2121,"word":"\u1783\u17B7\u1793\u1786\u17B6\u1799"},{"id":2122,"word":"\u1783\u17B9\u1780\u17D7"},{"id":2123,"word":"\u1783\u17B9\u1798"},{"id":2124,"word":"\u1783\u17BB\u1793"},{"id":2125,"word":"\u1783\u17BB\u1799\u1786\u17B6\u1799"},{"id":2126,"word":"\u1783\u17BC\u179A\u17D7"},{"id":2127,"word":"\u1783\u17BC\u179F\u17D7"},{"id":2128,"word":"\u1783\u17BE\u1789"},{"id":2129,"word":"\u1783\u17C2\u178F"},{"id":2130,"word":"\u1783\u17C4\u179A"},{"id":2131,"word":"\u1783\u17C4\u179A\u1783\u17C5"},{"id":2132,"word":"\u1783\u17C4\u179F"},{"id":2133,"word":"\u1783\u17C4\u179F\u1793\u17B6"},{"id":2134,"word":"\u1783\u17C4\u179F\u1793\u17B6\u1780\u17B6\u179A"},{"id":2135,"word":"\u1783\u17C4\u179F\u17B6\u1783\u17C4\u179F\u179C\u17B7\u1798\u17BB\u178F\u17D2\u178F"},{"id":2136,"word":"\u1783\u17C4\u179F\u17D2\u1793\u17B6"},{"id":2137,"word":"\u1783\u17BB\u17C6"},{"id":2138,"word":"\u1783\u17B6\u17C6\u1784"},{"id":2139,"word":"\u1783\u17D2\u1789\u17BE\u1785"},{"id":2140,"word":"\u1783\u17D2\u1793\u1784"},{"id":2141,"word":"\u1783\u17D2\u1793\u17B6\u1784"},{"id":2142,"word":"\u1783\u17D2\u1793\u17B6\u1794"},{"id":2143,"word":"\u1783\u17D2\u1793\u17BC\u179F"},{"id":2144,"word":"\u1783\u17D2\u1793\u17BE\u179F"},{"id":2145,"word":"\u1783\u17D2\u1793\u17BE\u179F\u1783\u17D2\u1793\u1784"},{"id":2146,"word":"\u1783\u17D2\u1798\u1784\u17CB"},{"id":2147,"word":"\u1783\u17D2\u1798\u178F\u17CB"},{"id":2148,"word":"\u1783\u17D2\u1798\u1798\u17D7"},{"id":2149,"word":"\u1783\u17D2\u1798\u17B6\u178F\u1781\u17D2\u1798\u17B8"},{"id":2150,"word":"\u1783\u17D2\u1798\u17B6\u1798\u17D7"},{"id":2151,"word":"\u1783\u17D2\u1798\u17B9\u1780"},{"id":2152,"word":"\u1783\u17D2\u1798\u17B9\u179B"},{"id":2153,"word":"\u1783\u17D2\u1798\u17C4\u17C7"},{"id":2154,"word":"\u1783\u17D2\u1798\u17BB\u17C6"},{"id":2155,"word":"\u1783\u17D2\u179B\u1784\u17CB"},{"id":2156,"word":"\u1783\u17D2\u179B\u17B6"},{"id":2157,"word":"\u1783\u17D2\u179B\u17B6\u178F"},{"id":2158,"word":"\u1783\u17D2\u179B\u17B6\u178F\u1783\u17D2\u179B\u17B6"},{"id":2159,"word":"\u1783\u17D2\u179B\u17B6\u178F\u1783\u17D2\u179B\u17C3"},{"id":2160,"word":"\u1783\u17D2\u179B\u17B6\u1793"},{"id":2161,"word":"\u1783\u17D2\u179B\u17B6\u1799\u1794\u17B6\u178F"},{"id":2162,"word":"\u1783\u17D2\u179B\u17B7\u1794"},{"id":2163,"word":"\u1783\u17D2\u179B\u17BB\u1780\u17D7"},{"id":2164,"word":"\u1783\u17D2\u179B\u17BB\u1794"},{"id":2165,"word":"\u1783\u17D2\u179B\u17BD\u1794"},{"id":2166,"word":"\u1783\u17D2\u179B\u17C0\u1784"},{"id":2167,"word":"\u1783\u17D2\u179B\u17C0\u1784\u1783\u17D2\u179B\u17B6\u178F"},{"id":2168,"word":"\u1783\u17D2\u179B\u17C0\u1785"},{"id":2169,"word":"\u1783\u17D2\u179B\u17C1"},{"id":2170,"word":"\u1783\u17D2\u179B\u17C1\u1784\u1783\u17D2\u179B\u17C4\u1784"},{"id":2171,"word":"\u1783\u17D2\u179B\u17C3"},{"id":2172,"word":"\u1783\u17D2\u179B\u17C4\u1780"},{"id":2173,"word":"\u1783\u17D2\u179B\u17C4\u1784"},{"id":2174,"word":"\u1783\u17D2\u179B\u17BB\u17C6"},{"id":2175,"word":"\u1783\u17D2\u179B\u17B6\u17C6"},{"id":2176,"word":"\u1783\u17D2\u179B\u17B6\u17C6\u1784"},{"id":2177,"word":"\u1783\u17D2\u179C\u17B6\u1784"},{"id":2178,"word":"\u1783\u17D2\u179C\u17B6\u1785\u17D7"},{"id":2179,"word":"\u1783\u17D2\u179C\u17B6\u1798"},{"id":2180,"word":"\u1783\u17D2\u179C\u17B6\u1799\u17D7"},{"id":2181,"word":"\u1783\u17D2\u179C\u17B6\u179B"},{"id":2182,"word":"\u1783\u17D2\u179C\u17B7\u1785"},{"id":2183,"word":"\u1783\u17D2\u179C\u17BE\u1784"},{"id":2184,"word":"\u1783\u17D2\u179C\u17BE\u1785\u17D7"},{"id":2185,"word":"\u1784"},{"id":2186,"word":"\u1784\u1780\u17CB"},{"id":2187,"word":"\u1784\u17C9\u1780\u17CB"},{"id":2188,"word":"\u1784\u1784\u1780\u17CB"},{"id":2189,"word":"\u1784\u1784\u179B\u17CB"},{"id":2190,"word":"\u1784\u1784\u17B6\u179F"},{"id":2191,"word":"\u1784\u1784\u17B7\u17C7\u1784\u1784\u17BB\u17C7"},{"id":2192,"word":"\u1784\u1784\u17B8\u179F\u1784\u1784\u17B6\u179F"},{"id":2193,"word":"\u1784\u1784\u17B9\u178F"},{"id":2194,"word":"\u1784\u1784\u17BB\u1799"},{"id":2195,"word":"\u1784\u1784\u17BB\u179B"},{"id":2196,"word":"\u1784\u1784\u17BB\u17C7"},{"id":2197,"word":"\u1784\u1784\u17BC\u179F"},{"id":2198,"word":"\u1784\u1784\u17BE\u179B"},{"id":2199,"word":"\u1784\u1784\u17C9\u17C1\u179F"},{"id":2200,"word":"\u1784\u1794\u17CB"},{"id":2201,"word":"\u1784\u179A"},{"id":2202,"word":"\u1784\u17B6"},{"id":2203,"word":"\u1784\u17B6\u1780"},{"id":2204,"word":"\u1784\u17C9\u17B6\u1784"},{"id":2205,"word":"\u1784\u17C9\u17B6\u1784\u17D7"},{"id":2206,"word":"\u1784\u17C9\u17B6\u1789\u17CB\u17D7"},{"id":2207,"word":"\u1784\u17B6\u1794\u17CB"},{"id":2208,"word":"\u1784\u17B6\u1799"},{"id":2209,"word":"\u1784\u17B6\u179A"},{"id":2210,"word":"\u1784\u17B6\u179C"},{"id":2211,"word":"\u1784\u17C9\u17B6\u179C"},{"id":2212,"word":"\u1784\u17C9\u17B6\u179C\u17D7"},{"id":2213,"word":"\u1784\u17B6\u179F"},{"id":2214,"word":"\u1784\u17B6\u179F\u17CB"},{"id":2215,"word":"\u1784\u17C9\u17B7\u1780\u1784\u17C9\u1780\u17CB"},{"id":2216,"word":"\u1784\u17B8\u1780"},{"id":2217,"word":"\u1784\u17B8\u1784\u17BE"},{"id":2218,"word":"\u1784\u17B8\u179C"},{"id":2219,"word":"\u1784\u17B9\u179B"},{"id":2220,"word":"\u1784\u17C9\u17B9\u1780"},{"id":2221,"word":"\u1784\u17BA\u17D7"},{"id":2222,"word":"\u1784\u17C9\u17BA\u178F\u17D7"},{"id":2223,"word":"\u1784\u17C9\u17BA\u179F\u17D7"},{"id":2224,"word":"\u1784\u17C9\u17BB\u1798"},{"id":2225,"word":"\u1784\u17C9\u17BB\u1798\u17D7"},{"id":2226,"word":"\u1784\u17BB\u179A\u1784\u1780\u17CB"},{"id":2227,"word":"\u1784\u17C9\u17BB\u179B\u17D7"},{"id":2228,"word":"\u1784\u17BC\u1784\u17D7"},{"id":2229,"word":"\u1784\u17C9\u17BC\u1784"},{"id":2230,"word":"\u1784\u17BC\u178F"},{"id":2231,"word":"\u1784\u17C9\u17BC\u178F\u17D7"},{"id":2232,"word":"\u1784\u17C9\u17BC\u179C\u17D7"},{"id":2233,"word":"\u1784\u17BC\u179F\u17D7"},{"id":2234,"word":"\u1784\u17BE\u178F"},{"id":2235,"word":"\u1784\u17BE\u1794"},{"id":2236,"word":"\u1784\u17BE\u1799"},{"id":2237,"word":"\u1784\u17BF"},{"id":2238,"word":"\u1784\u17BF\u1780"},{"id":2239,"word":"\u1784\u17BF\u1784"},{"id":2240,"word":"\u1784\u17C0\u1784"},{"id":2241,"word":"\u1784\u17C0\u178F"},{"id":2242,"word":"\u1784\u17C9\u17C1\u1780\u17D7"},{"id":2243,"word":"\u1784\u17C1\u1780\u1784\u17C4\u1780"},{"id":2244,"word":"\u1784\u17C1\u1784\u1784\u17C4\u1784"},{"id":2245,"word":"\u1784\u17C1\u1784\u17BE"},{"id":2246,"word":"\u1784\u17C9\u17C1\u178F\u17D7"},{"id":2247,"word":"\u1784\u17C9\u17C1\u179C\u17D7"},{"id":2248,"word":"\u1784\u17C9\u17C1\u179F\u17D7"},{"id":2249,"word":"\u1784\u17C9\u17C1\u17C7\u17D7"},{"id":2250,"word":"\u1784\u17C9\u17C2\u1784\u17C9"},{"id":2251,"word":"\u1784\u17C9\u17C2\u1784\u17C9\u179A"},{"id":2252,"word":"\u1784\u17C9\u17C2\u178F"},{"id":2253,"word":"\u1784\u17C9\u17C3"},{"id":2254,"word":"\u1784\u17C4\u1780"},{"id":2255,"word":"\u1784\u17C9\u17C4\u1780\u1784\u17C9\u17B6\u1780"},{"id":2256,"word":"\u1784\u17C4\u1784"},{"id":2257,"word":"\u1784\u17C9\u17C4\u1784"},{"id":2258,"word":"\u1784\u17C4\u1785\u17D7"},{"id":2259,"word":"\u1784\u17C4\u17C7"},{"id":2260,"word":"\u1784\u17C9\u17C4\u17C7\u17D7"},{"id":2261,"word":"\u1784\u17C5"},{"id":2262,"word":"\u1784\u17C9\u17C5"},{"id":2263,"word":"\u1784\u17C6"},{"id":2264,"word":"\u1784\u17C9\u17B6\u17C6"},{"id":2265,"word":"\u1784\u17B6\u17C6\u17D7"},{"id":2266,"word":"\u1784\u17B6\u17C6\u1784"},{"id":2267,"word":"\u1784\u17C9\u17B6\u17C6\u1784"},{"id":2268,"word":"\u1785"},{"id":2269,"word":"\u1785\u1780"},{"id":2270,"word":"\u1785\u1780\u17CB"},{"id":2271,"word":"\u1785\u17D0\u1780\u17D2\u1780\u1785\u17D0\u1793"},{"id":2272,"word":"\u1785\u1780\u17D2\u1781\u17BB"},{"id":2273,"word":"\u1785\u1780\u17D2\u1781\u17BB--"},{"id":2274,"word":"\u1785\u1780\u17D2\u179A"},{"id":2275,"word":"\u1785\u1780\u17D2\u179A\u1780\u17D2\u179A\u17B9\u179F\u17D2\u178E"},{"id":2276,"word":"\u1785\u1780\u17D2\u179A\u1794\u17B6\u178E\u17B8"},{"id":2277,"word":"\u1785\u1780\u17D2\u179A\u1796\u1784\u17D2\u179F"},{"id":2278,"word":"\u1785\u1780\u17D2\u179A\u1796\u178F\u17D2\u178F\u17B7"},{"id":2279,"word":"\u1785\u1780\u17D2\u179A\u1796\u178F\u17D2\u178F\u17B7\u1793\u17B7\u1799\u1798"},{"id":2280,"word":"\u1785\u1780\u17D2\u179A\u1796\u178F\u17D2\u179A\u17B6\u1792\u17B7\u179A\u17B6\u1787"},{"id":2281,"word":"\u1785\u1780\u17D2\u179A\u179A\u17B6\u179F\u17B8"},{"id":2282,"word":"\u1785\u1780\u17D2\u179A\u179C\u17B6\u178F"},{"id":2283,"word":"\u1785\u1780\u17D2\u179A\u179C\u17B6\u179B"},{"id":2284,"word":"\u1785\u1780\u17D2\u179A\u17B6\u1799\u17BB\u1792"},{"id":2285,"word":"\u1785\u1780\u17D2\u179A\u17B8"},{"id":2286,"word":"\u1785\u1780\u17D2\u179F\u17BB"},{"id":2287,"word":"\u1785\u1784"},{"id":2288,"word":"\u1785\u1784\u1780\u17B6\u179A"},{"id":2289,"word":"\u1785\u1784\u178A\u17C3"},{"id":2290,"word":"\u1785\u1784\u1796\u1793\u17D2\u1792"},{"id":2291,"word":"\u1785\u1784\u1796\u17BB\u1784"},{"id":2292,"word":"\u1785\u1784\u179F\u17C6\u179A\u17C4\u1784"},{"id":2293,"word":"\u1785\u1784\u17CB"},{"id":2294,"word":"\u1785\u1784\u17D2\u1780\u17B6"},{"id":2295,"word":"\u1785\u1784\u17D2\u1780\u17B6\u1780\u17CB"},{"id":2296,"word":"\u1785\u1784\u17D2\u1780\u17B9\u17C7"},{"id":2297,"word":"\u1785\u1784\u17D2\u1780\u17BB\u179B\u178E\u17B8"},{"id":2298,"word":"\u1785\u1784\u17D2\u1780\u17BC\u178F"},{"id":2299,"word":"\u1785\u1784\u17D2\u1780\u17BC\u1798"},{"id":2300,"word":"\u1785\u1784\u17D2\u1780\u17BC\u1798\u179F\u17D2\u1780\u17B6"},{"id":2301,"word":"\u1785\u1784\u17D2\u1780\u17BD\u1799"},{"id":2302,"word":"\u1785\u1784\u17D2\u1780\u17C0\u1784"},{"id":2303,"word":"\u1785\u1784\u17D2\u1780\u17C0\u179B"},{"id":2304,"word":"\u1785\u1784\u17D2\u1780\u17C0\u179B\u1781\u17D2\u1799\u1784"},{"id":2305,"word":"\u1785\u1784\u17D2\u1780\u17C0\u179F"},{"id":2306,"word":"\u1785\u1784\u17D2\u1780\u17C1\u17C7"},{"id":2307,"word":"\u1785\u1784\u17D2\u1780\u17C4\u1798"},{"id":2308,"word":"\u1785\u1784\u17D2\u1780\u17C6"},{"id":2309,"word":"\u1785\u1784\u17D2\u1780\u17D2\u179A\u1784\u17CB"},{"id":2310,"word":"\u1785\u1784\u17D2\u1780\u17D2\u179A\u1784\u17CB\u179F\u17D2\u179C\u17B6"},{"id":2311,"word":"\u1785\u1784\u17D2\u1780\u17D2\u179A\u178F\u17CB"},{"id":2312,"word":"\u1785\u1784\u17D2\u1780\u17D2\u179A\u1798"},{"id":2313,"word":"\u1785\u1784\u17D2\u1780\u17D2\u179A\u17B6\u1793"},{"id":2314,"word":"\u1785\u1784\u17D2\u1782\u17D2\u179A\u1780\u17CB"},{"id":2315,"word":"\u1785\u1784\u17D2\u1782\u17D2\u179A\u17B6\u1784"},{"id":2316,"word":"\u1785\u1784\u17D2\u1782\u17D2\u179A\u17B6\u179F\u17CB"},{"id":2317,"word":"\u1785\u1784\u17D2\u1782\u17D2\u179A\u17BB\u1784"},{"id":2318,"word":"\u1785\u1784\u17D2\u1782\u17D2\u179A\u17C4\u1784"},{"id":2319,"word":"\u1785\u1784\u17D2\u179A\u1780"},{"id":2320,"word":"\u1785\u1784\u17D2\u179A\u1794\u17CB"},{"id":2321,"word":"\u1785\u1784\u17D2\u179A\u17B7\u178F"},{"id":2322,"word":"\u1785\u1784\u17D2\u179A\u17C3"},{"id":2323,"word":"\u1785\u1784\u17D2\u179C\u17B6"},{"id":2324,"word":"\u1785\u1784\u17D2\u179C\u17B6\u1780\u17CB"},{"id":2325,"word":"\u1785\u1784\u17D2\u179C\u17B6\u1799"},{"id":2326,"word":"\u1785\u1784\u17D2\u179C\u17C2\u1780"},{"id":2327,"word":"\u1785\u1784\u17D2\u17A0\u17B6\u1793\u17CB"},{"id":2328,"word":"\u1785\u1784\u17D2\u17A0\u17B6\u1799"},{"id":2329,"word":"\u1785\u1784\u17D2\u17A0\u17BC\u179A"},{"id":2330,"word":"\u1785\u1784\u17D2\u17A2\u179B\u17CB"},{"id":2331,"word":"\u1785\u1784\u17D2\u17A2\u17BB\u179B"},{"id":2332,"word":"\u1785\u1784\u17D2\u17A2\u17BB\u179B\u1781\u17D2\u1798\u17C4\u1785"},{"id":2333,"word":"\u1785\u1784\u17D2\u17A2\u17BB\u179B\u178A\u17C3"},{"id":2334,"word":"\u1785\u1784\u17D2\u17A2\u17BC\u179A"},{"id":2335,"word":"\u1785\u1784\u17D2\u17A2\u17BD\u179A"},{"id":2336,"word":"\u1785\u1784\u17D2\u17A2\u17BD\u179A\u178F\u17D2\u1798\u17B6\u178F"},{"id":2337,"word":"\u1785\u1784\u17D2\u17A2\u17BE\u179A"},{"id":2338,"word":"\u1785\u1784\u17D2\u17A2\u17C0\u178F"},{"id":2339,"word":"\u1785\u1784\u17D2\u17A2\u17C1\u179A"},{"id":2340,"word":"\u1785\u1784\u17D2\u17A2\u17C4\u179A"},{"id":2341,"word":"\u1785\u1785\u1780"},{"id":2342,"word":"\u1785\u1785\u1780\u17CB"},{"id":2343,"word":"\u1785\u1785\u17B6\u1780\u17A2\u17B6\u179A\u17C9\u17B6\u1780"},{"id":2344,"word":"\u1785\u1785\u17B6\u1780\u17CB\u1785\u1785\u17BB\u1785"},{"id":2345,"word":"\u1785\u1785\u17B6\u178F"},{"id":2346,"word":"\u1785\u1785\u17B6\u1798\u17A2\u17B6\u179A\u17C9\u17B6\u1798"},{"id":2347,"word":"\u1785\u1785\u17B7\u1780\u1785\u1785\u17BB\u1780"},{"id":2348,"word":"\u1785\u1785\u17B9\u1780"},{"id":2349,"word":"\u1785\u1785\u17BC\u178F"},{"id":2350,"word":"\u1785\u1785\u17BE\u1784"},{"id":2351,"word":"\u1785\u1785\u17C1\u179F"},{"id":2352,"word":"\u1785\u1785\u17D2\u179A\u17C1\u179F\u1785\u1785\u17D2\u179A\u17B6\u179F"},{"id":2353,"word":"\u1785\u178E\u17D2\u178C"},{"id":2354,"word":"\u1785\u178E\u17D2\u178C\u17B6\u179B"},{"id":2355,"word":"\u1785\u178E\u17D2\u178C\u17B6\u179B\u17B8"},{"id":2356,"word":"\u1785\u178F"},{"id":2357,"word":"\u1785\u178F\u17CB"},{"id":2358,"word":"\u1785\u178F\u17BB"},{"id":2359,"word":"\u1785\u178F\u17BB\u1780\u17D2\u1780\u17BB\u179B\u179C\u1782\u17D2\u1782"},{"id":2360,"word":"\u1785\u178F\u17BB\u1791\u17D2\u1791\u17B7\u179F"},{"id":2361,"word":"\u1785\u178F\u17BB\u1791\u17D2\u179C\u17B8\u1794"},{"id":2362,"word":"\u1785\u178F\u17BB\u1794\u17D2\u1794\u1785\u17D2\u1785\u17D0\u1799"},{"id":2363,"word":"\u1785\u178F\u17BB\u1794\u17D2\u1794\u17B6\u1791"},{"id":2364,"word":"\u1785\u178F\u17BB\u1794\u17D2\u1794\u17B6\u179A\u17B7\u179F\u17BB\u1791\u17D2\u1792\u17B7\u179F\u17B8\u179B"},{"id":2365,"word":"\u1785\u178F\u17BB\u1796\u17D2\u1797\u17B6\u1782"},{"id":2366,"word":"\u1785\u178F\u17BB\u1796\u17D2\u1797\u17B6\u1782\u17B8"},{"id":2367,"word":"\u1785\u178F\u17BB\u1796\u17D2\u1797\u17BC\u178F"},{"id":2368,"word":"\u1785\u178F\u17BB\u1798\u17D2\u1798\u17BB\u1781"},{"id":2369,"word":"\u1785\u178F\u17BB\u179A\u1784\u17D2\u1782"},{"id":2370,"word":"\u1785\u178F\u17BB\u179A\u1784\u17D2\u1782\u179F\u1793\u17D2\u1793\u17B7\u1794\u17B6\u178F"},{"id":2371,"word":"\u1785\u178F\u17BB\u179A\u1784\u17D2\u1782\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":2372,"word":"\u1785\u178F\u17BB\u179A\u1784\u17D2\u1782\u17B7\u1793\u17B8"},{"id":2373,"word":"\u1785\u178F\u17BB\u179A\u17D0\u1784\u17D2\u179F"},{"id":2374,"word":"\u1785\u178F\u17BB\u179A\u1798\u17BB\u1781"},{"id":2375,"word":"\u1785\u178F\u17BB\u179A\u179F\u17D2\u179F"},{"id":2376,"word":"\u1785\u178F\u17BB\u179A\u17B6\u1794\u17B6\u1799"},{"id":2377,"word":"\u1785\u178F\u17BB\u179A\u17B6\u179A\u17B7\u1799\u179F\u1785\u17D2\u1785"},{"id":2378,"word":"\u1785\u178F\u17BB\u179B\u17C4\u1780\u1794\u17B6\u179B"},{"id":2379,"word":"\u1785\u178F\u17BB\u179F\u17D2\u178A\u1798\u17D2\u1797"},{"id":2380,"word":"\u1785\u178F\u17D2\u179A\u1784\u17D2\u1782"},{"id":2381,"word":"\u1785\u178F\u17D2\u179C\u17D0\u1784\u17D2\u179F"},{"id":2382,"word":"\u1785\u178F\u17D2\u179C\u17B6"},{"id":2383,"word":"\u1785\u17D0\u1793"},{"id":2384,"word":"\u1785\u1793\u17D2\u1791"},{"id":2385,"word":"\u1785\u1793\u17D2\u1791\u1782\u178F\u17B7"},{"id":2386,"word":"\u1785\u1793\u17D2\u1791\u1782\u178F\u17B7\u1780\u17B6\u179B"},{"id":2387,"word":"\u1785\u1793\u17D2\u1791\u1785\u17D2\u1786\u17B6\u1799\u17B6"},{"id":2388,"word":"\u1785\u1793\u17D2\u1791\u1793\u17CD"},{"id":2389,"word":"\u1785\u1793\u17D2\u1791\u1798\u178E\u17D2\u178C\u179B"},{"id":2390,"word":"\u1785\u1793\u17D2\u1791\u179A\u1784\u17D2\u179F\u17B8"},{"id":2391,"word":"\u1785\u1793\u17D2\u1791\u179B\u17CB"},{"id":2392,"word":"\u1785\u1793\u17D2\u1791\u179B\u17C1\u1781\u17B6"},{"id":2393,"word":"\u1785\u1793\u17D2\u1791\u17B6\u1780\u17B6"},{"id":2394,"word":"\u1785\u1793\u17D2\u1791\u17B6\u179B\u17CB"},{"id":2395,"word":"\u1785\u1793\u17D2\u1791\u17B6\u179F"},{"id":2396,"word":"\u1785\u1793\u17D2\u1791\u17B6\u179F\u17CB"},{"id":2397,"word":"\u1785\u1793\u17D2\u1791\u17B6\u179F\u17CB\u1791\u17B9\u1780"},{"id":2398,"word":"\u1785\u1793\u17D2\u1791\u17B8"},{"id":2399,"word":"\u1785\u1793\u17D2\u1791\u17BC\u1794\u1798\u17B6"},{"id":2400,"word":"\u1785\u1793\u17D2\u1791\u17C4\u1797\u17B6\u179F"},{"id":2401,"word":"\u1785\u1793\u17D2\u1791\u17C4\u179B"},{"id":2402,"word":"\u1785\u1793\u17D2\u1791\u17D2\u179A"},{"id":2403,"word":"\u1785\u1793\u17D2\u1791\u17D2\u179A\u1782\u17D2\u179A\u17B6\u179F"},{"id":2404,"word":"\u1785\u17D0\u1793\u17D2\u1792\u17BC"},{"id":2405,"word":"\u1785\u1793\u17D2\u179B\u1793\u17CB"},{"id":2406,"word":"\u1785\u1793\u17D2\u179B\u17BB\u17C7"},{"id":2407,"word":"\u1785\u1793\u17D2\u179B\u17C4\u17C7"},{"id":2408,"word":"\u1785\u1794"},{"id":2409,"word":"\u1785\u1794\u17CB"},{"id":2410,"word":"\u1785\u1798"},{"id":2411,"word":"\u1785\u1798\u17D2\u1780\u1799"},{"id":2412,"word":"\u1785\u1798\u17D2\u1780\u17B6\u179A"},{"id":2413,"word":"\u1785\u1798\u17D2\u1780\u17B6\u179A\u179B\u17BE"},{"id":2414,"word":"\u1785\u1798\u17D2\u1780\u17BD\u178F"},{"id":2415,"word":"\u1785\u1798\u17D2\u1784\u17B6\u1799"},{"id":2416,"word":"\u1785\u1798\u17D2\u1794\u1784"},{"id":2417,"word":"\u1785\u1798\u17D2\u1794\u17C9\u17B6"},{"id":2418,"word":"\u1785\u1798\u17D2\u1794\u17C9\u17B6\u178A\u17B6\u1780\u17CB"},{"id":2419,"word":"\u1785\u1798\u17D2\u1794\u17B6\u17C6\u1784"},{"id":2420,"word":"\u1785\u1798\u17D2\u1796\u17B6\u1798"},{"id":2421,"word":"\u1785\u1798\u17D2\u1798\u1794\u1780\u17D2\u179F\u17B8"},{"id":2422,"word":"\u1785\u1798\u17D2\u179A\u1780"},{"id":2423,"word":"\u1785\u1798\u17D2\u179A\u17B6\u1789\u17CB"},{"id":2424,"word":"\u1785\u1798\u17D2\u179A\u17B6\u179F"},{"id":2425,"word":"\u1785\u1798\u17D2\u179A\u17B9\u1784"},{"id":2426,"word":"\u1785\u1798\u17D2\u179A\u17BB\u1784"},{"id":2427,"word":"\u1785\u1798\u17D2\u179A\u17BB\u17C7"},{"id":2428,"word":"\u1785\u1798\u17D2\u179A\u17BC\u1784"},{"id":2429,"word":"\u1785\u1798\u17D2\u179A\u17BC\u1784\u1785\u1798\u17D2\u179A\u17B6\u179F"},{"id":2430,"word":"\u1785\u1798\u17D2\u179A\u17BC\u178F"},{"id":2431,"word":"\u1785\u1798\u17D2\u179A\u17BE\u1793"},{"id":2432,"word":"\u1785\u1798\u17D2\u179A\u17C0\u1780"},{"id":2433,"word":"\u1785\u1798\u17D2\u179A\u17C0\u1784"},{"id":2434,"word":"\u1785\u1798\u17D2\u179A\u17C1\u17C7"},{"id":2435,"word":"\u1785\u1798\u17D2\u179A\u17C4\u17C7"},{"id":2436,"word":"\u1785\u1798\u17D2\u179B\u1784"},{"id":2437,"word":"\u1785\u1798\u17D2\u179B\u17B6\u1780\u17CB"},{"id":2438,"word":"\u1785\u1798\u17D2\u179B\u17BE\u1799"},{"id":2439,"word":"\u1785\u1798\u17D2\u179B\u17C2\u1780"},{"id":2440,"word":"\u1785\u1798\u17D2\u17A2\u17B6\u1794"},{"id":2441,"word":"\u1785\u1798\u17D2\u17A2\u17B7\u1793"},{"id":2442,"word":"\u1785\u1798\u17D2\u17A2\u17B9\u1784"},{"id":2443,"word":"\u1785\u1798\u17D2\u17A2\u17C1\u17C7"},{"id":2444,"word":"\u1785\u1798\u17D2\u17A2\u17C2\u178F"},{"id":2445,"word":"\u1785\u179A"},{"id":2446,"word":"\u1785\u179A\u1780"},{"id":2447,"word":"\u1785\u179A\u1785\u17B6"},{"id":2448,"word":"\u1785\u179A\u1785\u17D2\u179A\u1794\u17CB"},{"id":2449,"word":"\u1785\u179A\u178E\u17C8"},{"id":2450,"word":"\u1785\u179A\u178E\u17B6\u179C\u17BB\u1792"},{"id":2451,"word":"\u1785\u179A\u178E\u17C3"},{"id":2452,"word":"\u1785\u179A\u1793\u17D2\u178F"},{"id":2453,"word":"\u1785\u179A\u1797\u17B6\u1796"},{"id":2454,"word":"\u1785\u179A\u179B\u17B8\u179B\u17B6"},{"id":2455,"word":"\u1785\u179A\u17B6\u1785\u179A"},{"id":2456,"word":"\u1785\u179A\u17B6\u1785\u179A\u1780"},{"id":2457,"word":"\u1785\u179A\u179A\u17B6\u1785\u179A\u178E\u17CD"},{"id":2458,"word":"\u1785\u179A\u17B7\u178F"},{"id":2459,"word":"\u1785\u179A\u17B7\u1799\u17B6"},{"id":2460,"word":"\u1785\u179A\u17B7\u1799\u17B6\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":2461,"word":"\u1785\u179A\u17B8"},{"id":2462,"word":"\u1785\u179B\u17D0\u178F"},{"id":2463,"word":"\u1785\u179B\u1793\u179C\u178F\u17D2\u1790\u17BB"},{"id":2464,"word":"\u1785\u179B\u1793\u17B6"},{"id":2465,"word":"\u1785\u179B\u1793\u17B6\u1785\u1780\u17D2\u179A"},{"id":2466,"word":"\u1785\u179B\u17B6\u1785\u179B"},{"id":2467,"word":"\u1785\u17A0\u17B6\u1784"},{"id":2468,"word":"\u1785\u17B6\u1780"},{"id":2469,"word":"\u1785\u17B6\u1780\u17CB"},{"id":2470,"word":"\u1785\u17B6\u1780\u17CB\u1780\u178E\u17D2\u178A\u17B6\u1789\u17CB"},{"id":2471,"word":"\u1785\u17B6\u1780\u17CB\u1780\u1793\u17D2\u1791\u17D2\u179A\u1784\u17CB"},{"id":2472,"word":"\u1785\u17B6\u1780\u17CB\u1780\u17D2\u179A\u17A1\u17C1\u1780"},{"id":2473,"word":"\u1785\u17B6\u1780\u17CB\u1785\u17BB\u1785"},{"id":2474,"word":"\u1785\u17B6\u1780\u17CB\u1785\u17BB\u179B"},{"id":2475,"word":"\u1785\u17B6\u1780\u17CB\u1785\u17D2\u179A\u17B6\u179F"},{"id":2476,"word":"\u1785\u17B6\u1780\u17CB\u1785\u17D2\u179A\u17C2\u1784"},{"id":2477,"word":"\u1785\u17B6\u1780\u17CB\u1786\u17C2\u179C"},{"id":2478,"word":"\u1785\u17B6\u1780\u17CB\u1791\u17B8\u1784"},{"id":2479,"word":"\u1785\u17B6\u1780\u17CB\u1791\u17B9\u1780\u178A\u17BC\u1784"},{"id":2480,"word":"\u1785\u17B6\u1780\u17CB\u1794\u178E\u17D2\u178A\u17C4\u1799"},{"id":2481,"word":"\u1785\u17B6\u1780\u17CB\u179F\u17D2\u1798\u17BB\u1782"},{"id":2482,"word":"\u1785\u17B6\u1780\u17CB\u179F\u17D2\u179A\u17C1\u17C7"},{"id":2483,"word":"\u1785\u17B6\u1780\u17B9\u1780"},{"id":2484,"word":"\u1785\u17B6\u1780\u17D2\u179A\u1796\u17B6\u1780"},{"id":2485,"word":"\u1785\u17B6\u1782\u17C8"},{"id":2486,"word":"\u1785\u17B6\u1782\u1785\u17C1\u178F\u1793\u17B6"},{"id":2487,"word":"\u1785\u17B6\u1784"},{"id":2488,"word":"\u1785\u17B6\u1784\u178E\u17B6\u1784"},{"id":2489,"word":"\u1785\u17B6\u1784\u179C\u17C9\u17B6\u1784"},{"id":2490,"word":"\u1785\u17B6\u1785\u17CB!"},{"id":2491,"word":"\u1785\u17B6\u1789\u17CB"},{"id":2492,"word":"\u1785\u17B6\u178F\u17CB"},{"id":2493,"word":"\u1785\u17B6\u178F\u17CB\u1785\u17C2\u1784"},{"id":2494,"word":"\u1785\u17B6\u1793"},{"id":2495,"word":"\u1785\u17B6\u1794"},{"id":2496,"word":"\u1785\u17B6\u1794\u1785\u1784\u17D2\u1780\u17D2\u179A\u1784\u17CB"},{"id":2497,"word":"\u1785\u17B6\u1794\u17CB"},{"id":2498,"word":"\u1785\u17B6\u1794\u17CB\u1780\u17BC\u1793\u1781\u17D2\u179B\u17C2\u1784"},{"id":2499,"word":"\u1785\u17B6\u1794\u17CB\u1785\u17B7\u178F\u17D2\u178F"},{"id":2500,"word":"\u1785\u17B6\u1794\u17CB\u1786\u17B6\u1799"},{"id":2501,"word":"\u1785\u17B6\u1794\u17CB\u178A\u1780"},{"id":2502,"word":"\u1785\u17B6\u1794\u17CB\u1797\u17D2\u179B\u17B9\u1780"},{"id":2503,"word":"\u1785\u17B6\u1794\u17C9\u17B8"},{"id":2504,"word":"\u1785\u17B6\u1794\u17C9\u17B9\u1780"},{"id":2505,"word":"\u1785\u17B6\u1794\u17C9\u17B9\u1784"},{"id":2506,"word":"\u1785\u17B6\u1794\u17C9\u17BB\u1780"},{"id":2507,"word":"\u1785\u17B6\u1794\u17C9\u17BB\u1785"},{"id":2508,"word":"\u1785\u17B6\u1796\u17D2\u179B\u17BC"},{"id":2509,"word":"\u1785\u17B6\u1798"},{"id":2510,"word":"\u1785\u17B6\u1798\u179A"},{"id":2511,"word":"\u1785\u17B6\u1798\u179A\u17B8"},{"id":2512,"word":"\u1785\u17B6\u1799"},{"id":2513,"word":"\u1785\u17B6\u1799\u178A\u17B8"},{"id":2514,"word":"\u1785\u17B6\u179A"},{"id":2515,"word":"\u1785\u17B6\u179A\u1785\u17C2\u1784"},{"id":2516,"word":"\u1785\u17B6\u179A\u1794\u17BB\u179A\u179F"},{"id":2517,"word":"\u1785\u17B6\u179A\u17B7\u1780"},{"id":2518,"word":"\u1785\u17B6\u179A\u17B9\u1780"},{"id":2519,"word":"\u1785\u17B6\u179A\u17BB\u17CD"},{"id":2520,"word":"\u1785\u17B6\u179B"},{"id":2521,"word":"\u1785\u17B6\u179B\u17CB"},{"id":2522,"word":"\u1785\u17B6\u179C"},{"id":2523,"word":"\u1785\u17B6\u179F"},{"id":2524,"word":"\u1785\u17B6\u179F\u17CB"},{"id":2525,"word":"\u1785\u17B6\u17A0\u17BD\u1799"},{"id":2526,"word":"\u1785\u17B7\u1780"},{"id":2527,"word":"\u1785\u17B7\u1789\u17D2\u1785\u17B6\u1785"},{"id":2528,"word":"\u1785\u17B7\u1789\u17D2\u1785\u17B9\u1798"},{"id":2529,"word":"\u1785\u17B7\u1789\u17D2\u1785\u17BE\u1798"},{"id":2530,"word":"\u1785\u17B7\u1789\u17D2\u1785\u17C0\u1793"},{"id":2531,"word":"\u1785\u17B7\u1789\u17D2\u1785\u17C2\u1784"},{"id":2532,"word":"\u1785\u17B7\u1789\u17D2\u1785\u17D2\u179A\u17B6\u17C6"},{"id":2533,"word":"\u1785\u17B7\u178F"},{"id":2534,"word":"\u1785\u17B7\u178F\u179F\u17B7\u1794"},{"id":2535,"word":"\u1785\u17B7\u178F\u17D2\u178F"},{"id":2536,"word":"\u1785\u17B7\u178F\u17D2\u178F"},{"id":2537,"word":"\u1785\u17B7\u178F\u17D2\u179A\u1798\u17BC\u179B\u1797\u17D2\u179B\u17BE\u1784"},{"id":2538,"word":"\u1785\u17B7\u1793"},{"id":2539,"word":"\u1785\u17B7\u1793\u17D2\u178F\u1793\u17B6\u1780\u17B6\u179A"},{"id":2540,"word":"\u1785\u17B7\u1793\u17D2\u178A\u17B6"},{"id":2541,"word":"\u1785\u17B7\u1793\u17D2\u178A\u17B6\u1798\u178E\u17B8"},{"id":2542,"word":"\u1785\u17B7\u179A\u179F\u17D2\u179F\u1780\u17B6\u179A"},{"id":2543,"word":"\u1785\u17B8\u1796\u179A"},{"id":2544,"word":"\u1785\u17B8\u179A\u1780\u17B6\u179B"},{"id":2545,"word":"\u1785\u17B8\u179A\u1785\u179A"},{"id":2546,"word":"\u1785\u17B8\u179C\u179A"},{"id":2547,"word":"\u1785\u17B8\u179C\u179A\u1780\u17B6\u179B"},{"id":2548,"word":"\u1785\u17B9\u1780"},{"id":2549,"word":"\u1785\u17B9\u1794"},{"id":2550,"word":"\u1785\u17B8\u1794\u1785\u179A"},{"id":2551,"word":"\u1785\u17B9\u179F"},{"id":2552,"word":"\u1785\u17BA\u1784\u1782\u17D2\u179A\u17B9\u1798\u17D7"},{"id":2553,"word":"\u1785\u17BA\u1793"},{"id":2554,"word":"\u1785\u17BA\u1798"},{"id":2555,"word":"\u1785\u17BB\u1780"},{"id":2556,"word":"\u1785\u17BB\u1784"},{"id":2557,"word":"\u1785\u17BB\u1784\u1780\u17B6\u179B\u17CB"},{"id":2558,"word":"\u1785\u17BB\u1784\u1780\u17BB\u179B"},{"id":2559,"word":"\u1785\u17BB\u1784\u178A\u17BD\u1785"},{"id":2560,"word":"\u1785\u17BB\u1784\u1797\u17C5"},{"id":2561,"word":"\u1785\u17BB\u1784\u17A2\u1784\u17D2\u1780\u179A"},{"id":2562,"word":"\u1785\u17BB\u1784\u17A2\u17C6\u1794\u17BB\u1780"},{"id":2563,"word":"\u1785\u17BB\u1785"},{"id":2564,"word":"\u1785\u17BB\u178F\u17B7"},{"id":2565,"word":"\u1785\u17BB\u1793"},{"id":2566,"word":"\u1785\u17BB\u1799"},{"id":2567,"word":"\u1785\u17BB\u179B\u17D2\u179B\u179F\u1780\u179A\u17B6\u1787"},{"id":2568,"word":"\u1785\u17BB\u17C7"},{"id":2569,"word":"\u1785\u17BB\u17C7\u1794\u17D2\u179A\u17C1\u1784"},{"id":2570,"word":"\u1785\u17BC\u1780"},{"id":2571,"word":"\u1785\u17BC\u179A"},{"id":2572,"word":"\u1785\u17BC\u179B"},{"id":2573,"word":"\u1785\u17BC\u17A1\u1796\u1793"},{"id":2574,"word":"\u1785\u17BC\u17A1\u17B6"},{"id":2575,"word":"\u1785\u17BC\u17A1\u17B6\u1798\u178E\u17B8"},{"id":2576,"word":"\u1785\u17BD\u1793"},{"id":2577,"word":"\u1785\u17BD\u1794"},{"id":2578,"word":"\u1785\u17BE\u1780"},{"id":2579,"word":"\u1785\u17BE\u1784\u1798\u17C9\u17BE\u1784"},{"id":2580,"word":"\u1785\u17BE\u179F"},{"id":2581,"word":"\u1785\u17C0\u1793"},{"id":2582,"word":"\u1785\u17C0\u1793\u1785\u17BD\u1793"},{"id":2583,"word":"\u1785\u17C0\u1798"},{"id":2584,"word":"\u1785\u17C0\u1798\u1787\u17B6\u17C6"},{"id":2585,"word":"\u1785\u17C0\u179A"},{"id":2586,"word":"\u1785\u17C0\u179F"},{"id":2587,"word":"\u1785\u17C1\u1780"},{"id":2588,"word":"\u1785\u17C1\u1780\u1791\u17C1\u179F"},{"id":2589,"word":"\u1785\u17C1\u1780\u1791\u17BB\u17C6"},{"id":2590,"word":"\u1785\u17C1\u1785\u17D7"},{"id":2591,"word":"\u1785\u17C1\u1785\u1785\u17B6\u1785"},{"id":2592,"word":"\u1785\u17C1\u1789"},{"id":2593,"word":"\u1785\u17C1\u178F\u1793\u17B6"},{"id":2594,"word":"\u1785\u17C1\u178F\u1794\u17BB\u178F\u17D2\u179A"},{"id":2595,"word":"\u1785\u17C1\u178F\u17B7\u1799"},{"id":2596,"word":"\u1785\u17C1\u178F\u17D2\u179A"},{"id":2597,"word":"\u1785\u17C1\u178F\u179F\u17B7\u1780"},{"id":2598,"word":"\u1785\u17C1\u1794\u17D7"},{"id":2599,"word":"\u1785\u17C1\u179A"},{"id":2600,"word":"\u1785\u17C1\u179A\u1785\u17B6"},{"id":2601,"word":"\u1785\u17C1\u179A\u179C\u17B7\u179B"},{"id":2602,"word":"\u1785\u17C1\u179B\u1780\u1787\u1793"},{"id":2603,"word":"\u1785\u17C1\u179F"},{"id":2604,"word":"\u1785\u17C1\u179F\u17D2\u178A\u17B6"},{"id":2605,"word":"\u1785\u17C1\u17C7"},{"id":2606,"word":"\u1785\u17C2"},{"id":2607,"word":"\u1785\u17C2\u17D7"},{"id":2608,"word":"\u1785\u17C2\u1780"},{"id":2609,"word":"\u1785\u17C2\u1784"},{"id":2610,"word":"\u1785\u17C2\u1784\u1785\u17B6"},{"id":2611,"word":"\u1785\u17C2\u1784\u1790\u17D2\u1784\u17C3"},{"id":2612,"word":"\u1785\u17C2\u1784\u1798\u17C9\u17C2\u1784"},{"id":2613,"word":"\u1785\u17C2\u1784\u179C\u17C9\u17C2\u1784"},{"id":2614,"word":"\u1785\u17C2\u1785\u17BC\u179C"},{"id":2615,"word":"\u1785\u17C2\u178F"},{"id":2616,"word":"\u1785\u17C2\u1794\u17C9\u1794\u17D2\u179A\u17C2"},{"id":2617,"word":"\u1785\u17C2\u179C"},{"id":2618,"word":"\u1785\u17C2\u179F"},{"id":2619,"word":"\u1785\u17C3"},{"id":2620,"word":"\u1785\u17C3\u178A\u1793\u17CB"},{"id":2621,"word":"\u1785\u17C3\u178A\u17B8"},{"id":2622,"word":"\u1785\u17C3\u178F\u17D2\u1799"},{"id":2623,"word":"\u1785\u17C3\u179A\u17C9\u17B6"},{"id":2624,"word":"\u1785\u17C4\u1784\u17A0\u17C4\u1784"},{"id":2625,"word":"\u1785\u17C4\u178F"},{"id":2626,"word":"\u1785\u17C4\u1791"},{"id":2627,"word":"\u1785\u17C4\u1791\u1780\u17C8"},{"id":2628,"word":"\u1785\u17C4\u1791\u1793\u17B6"},{"id":2629,"word":"\u1785\u17C4\u1798"},{"id":2630,"word":"\u1785\u17C4\u1798\u1796\u17BB\u1784"},{"id":2631,"word":"\u1785\u17C4\u179A"},{"id":2632,"word":"\u1785\u17C4\u179A\u1780\u178E\u17D2\u178A\u1780\u17C8"},{"id":2633,"word":"\u1785\u17C4\u179A\u1780\u1793\u17D2\u178A\u17B6\u179A"},{"id":2634,"word":"\u1785\u17C4\u179A\u1780\u1798\u17D2\u1798"},{"id":2635,"word":"\u1785\u17C4\u179A\u1783\u17B6\u178F"},{"id":2636,"word":"\u1785\u17C4\u179A\u1783\u17B6\u178F\u1780\u17C8"},{"id":2637,"word":"\u1785\u17C4\u179A\u1783\u17B6\u178F\u1780\u1798\u17D2\u1798"},{"id":2638,"word":"\u1785\u17C4\u179B"},{"id":2639,"word":"\u1785\u17C4\u17C7"},{"id":2640,"word":"\u1785\u17C5"},{"id":2641,"word":"\u1785\u17C5\u1780\u17BC\u179C"},{"id":2642,"word":"\u1785\u17C5\u1780\u17D2\u179A\u1798"},{"id":2643,"word":"\u1785\u17C5\u1785\u1798"},{"id":2644,"word":"\u1785\u17C5\u1787\u17B7\u178F"},{"id":2645,"word":"\u1785\u17C5\u1791\u17C1\u179F"},{"id":2646,"word":"\u1785\u17C5\u1791\u17C3"},{"id":2647,"word":"\u1785\u17C5\u1796\u1789\u17B6"},{"id":2648,"word":"\u1785\u17C5\u179A\u17C9\u17C5"},{"id":2649,"word":"\u1785\u17C5\u17A0\u17D2\u179C\u17B6\u1799"},{"id":2650,"word":"\u1785\u17C5\u17A2\u1792\u17B7\u1780\u17B6\u179A"},{"id":2651,"word":"\u1785\u17C6"},{"id":2652,"word":"\u1785\u17C6\u1780\u17B6\u1784"},{"id":2653,"word":"\u1785\u17C6\u1780\u17C4\u1784"},{"id":2654,"word":"\u1785\u17C6\u178E\u1784"},{"id":2655,"word":"\u1785\u17C6\u178E\u1784\u17CB"},{"id":2656,"word":"\u1785\u17C6\u178E\u178F"},{"id":2657,"word":"\u1785\u17C6\u178E\u178F\u17CB"},{"id":2658,"word":"\u1785\u17C6\u178E\u17B6\u1780\u17CB"},{"id":2659,"word":"\u1785\u17C6\u178E\u17B6\u1793"},{"id":2660,"word":"\u1785\u17C6\u178E\u17B6\u1794\u17CB"},{"id":2661,"word":"\u1785\u17C6\u178E\u17B6\u1799"},{"id":2662,"word":"\u1785\u17C6\u178E\u17B6\u179A"},{"id":2663,"word":"\u1785\u17C6\u178E\u17B6\u179B\u17CB"},{"id":2664,"word":"\u1785\u17C6\u178E\u17B6\u179F\u17CB"},{"id":2665,"word":"\u1785\u17C6\u178E\u17B7\u178F"},{"id":2666,"word":"\u1785\u17C6\u178E\u17B8"},{"id":2667,"word":"\u1785\u17C6\u178E\u17BB\u1780"},{"id":2668,"word":"\u1785\u17C6\u178E\u17BB\u1785"},{"id":2669,"word":"\u1785\u17C6\u178E\u17BB\u1785\u1785\u17B7\u178F\u17D2\u178F"},{"id":2670,"word":"\u1785\u17C6\u178E\u17BB\u17C7"},{"id":2671,"word":"\u1785\u17C6\u178E\u17BC\u1780"},{"id":2672,"word":"\u1785\u17C6\u178E\u17BC\u179A"},{"id":2673,"word":"\u1785\u17C6\u178E\u17BC\u179B"},{"id":2674,"word":"\u1785\u17C6\u178E\u17C1\u1789"},{"id":2675,"word":"\u1785\u17C6\u178E\u17C1\u179A"},{"id":2676,"word":"\u1785\u17C6\u178E\u17C1\u17C7"},{"id":2677,"word":"\u1785\u17C6\u178E\u17C2\u1780"},{"id":2678,"word":"\u1785\u17C6\u178E\u17C4\u178F"},{"id":2679,"word":"\u1785\u17C6\u178E\u17C4\u1791"},{"id":2680,"word":"\u1785\u17C6\u178E\u17C4\u1798"},{"id":2681,"word":"\u1785\u17C6\u178E\u17C4\u17C7"},{"id":2682,"word":"\u1785\u17C6\u178E\u17B6\u17C6"},{"id":2683,"word":"\u1785\u17C6\u178E\u17B6\u17C6\u178F\u17C2"},{"id":2684,"word":"\u1785\u17C6\u178E\u17B6\u17C6\u1784"},{"id":2685,"word":"\u1785\u17C6\u178F\u17B7\u178F"},{"id":2686,"word":"\u1785\u17C6\u178F\u17BC\u1784"},{"id":2687,"word":"\u1785\u17C6\u178F\u17BE\u178F"},{"id":2688,"word":"\u1785\u17C6\u1791\u1784\u17CB"},{"id":2689,"word":"\u1785\u17C6\u1791\u1799"},{"id":2690,"word":"\u1785\u17C6\u1791\u17B6\u1789"},{"id":2691,"word":"\u1785\u17C6\u1791\u17B6\u179B"},{"id":2692,"word":"\u1785\u17C6\u1791\u17B6\u179F\u17CB"},{"id":2693,"word":"\u1785\u17C6\u1791\u17BD\u1799"},{"id":2694,"word":"\u1785\u17C6\u1791\u17BE\u178F"},{"id":2695,"word":"\u1785\u17C6\u1791\u17BE\u179A"},{"id":2696,"word":"\u1785\u17C6\u1791\u17BE\u179F"},{"id":2697,"word":"\u1785\u17C6\u1791\u17C2\u1784"},{"id":2698,"word":"\u1785\u17C6\u1791\u17B6\u17C6\u1784"},{"id":2699,"word":"\u1785\u17C6\u1793\u17BD\u1793"},{"id":2700,"word":"\u1785\u17C6\u1793\u17BD\u1794"},{"id":2701,"word":"\u1785\u17C6\u1793\u17C0\u179A"},{"id":2702,"word":"\u1785\u17C6\u1794\u1780\u17CB"},{"id":2703,"word":"\u1785\u17C6\u1794\u17B6\u1794\u17CB"},{"id":2704,"word":"\u1785\u17C6\u1794\u17C9\u17B8"},{"id":2705,"word":"\u1785\u17C6\u1794\u17C9\u17B8\u1791\u17C1\u179F"},{"id":2706,"word":"\u1785\u17C6\u1794\u17BD\u179A"},{"id":2707,"word":"\u1785\u17C6\u1794\u17BE\u1784"},{"id":2708,"word":"\u1785\u17C6\u1794\u17C2\u1784"},{"id":2709,"word":"\u1785\u17C6\u1794\u17D2\u179A\u1794\u17CB"},{"id":2710,"word":"\u1785\u17C6\u1794\u17D2\u179A\u17B6\u179C"},{"id":2711,"word":"\u1785\u17C6\u1796\u1794\u17CB"},{"id":2712,"word":"\u1785\u17C6\u1796\u17B6\u1780\u17CB"},{"id":2713,"word":"\u1785\u17C6\u1796\u17B6\u179F\u17CB"},{"id":2714,"word":"\u1785\u17C6\u1796\u17B7\u178F"},{"id":2715,"word":"\u1785\u17C6\u1796\u17BB\u17C7"},{"id":2716,"word":"\u1785\u17C6\u1796\u17BB\u17C7\u1791\u17B6"},{"id":2717,"word":"\u1785\u17C6\u1796\u17BB\u17C7\u1791\u17BB\u1784"},{"id":2718,"word":"\u1785\u17C6\u1796\u17BC\u1780"},{"id":2719,"word":"\u1785\u17C6\u1796\u17BD\u1780"},{"id":2720,"word":"\u1785\u17C6\u1796\u17BD\u1799"},{"id":2721,"word":"\u1785\u17C6\u1796\u17BE\u1794"},{"id":2722,"word":"\u1785\u17C6\u1796\u17C4\u17C7"},{"id":2723,"word":"\u1785\u17C6\u17A1\u1780"},{"id":2724,"word":"\u1785\u17C6\u17A1\u1780\u17CB"},{"id":2725,"word":"\u1785\u17C6\u179B\u17C0\u179C"},{"id":2726,"word":"\u1785\u17C6\u17A1\u17C5\u1780\u17D2\u17A2\u17C2\u1780"},{"id":2727,"word":"\u1785\u17C6\u17A0"},{"id":2728,"word":"\u1785\u17C6\u17A0\u17B6\u1799"},{"id":2729,"word":"\u1785\u17C6\u17A0\u17BB\u1784"},{"id":2730,"word":"\u1785\u17C6\u17A0\u17BB\u178F"},{"id":2731,"word":"\u1785\u17C6\u17A0\u17BB\u1799"},{"id":2732,"word":"\u1785\u17C6\u17A0\u17BC\u179C"},{"id":2733,"word":"\u1785\u17C6\u17A0\u17C0\u1784"},{"id":2734,"word":"\u1785\u17C6\u17A0\u17C0\u179C"},{"id":2735,"word":"\u1785\u17C6\u17A0\u17B6\u17C6\u1784"},{"id":2736,"word":"\u1785\u17C6\u17A2\u1780"},{"id":2737,"word":"\u1785\u17C6\u17A2\u1793\u17CB"},{"id":2738,"word":"\u1785\u17C6\u17A2\u17B6\u1798"},{"id":2739,"word":"\u1785\u17C6\u17A2\u17B6\u179F"},{"id":2740,"word":"\u1785\u17C6\u17A2\u17BE\u178F"},{"id":2741,"word":"\u1785\u17C6\u17A2\u17C0\u1780"},{"id":2742,"word":"\u1785\u17C6\u17A2\u17C1\u1784"},{"id":2743,"word":"\u1785\u17C6\u17A2\u17C2"},{"id":2744,"word":"\u1785\u17B6\u17C6"},{"id":2745,"word":"\u1785\u17B6\u17C6\u1784"},{"id":2746,"word":"\u1785\u17B6\u17C6\u1784\u1787\u17BE\u1784"},{"id":2747,"word":"\u1785\u17B6\u17C6\u178F\u17C2"},{"id":2748,"word":"\u1785\u17B6\u17C6\u1794\u17B6\u1785\u17CB"},{"id":2749,"word":"\u1785\u17D2\u1793\u17B9\u1784"},{"id":2750,"word":"\u1785\u17D2\u1793\u17C1\u17C7"},{"id":2751,"word":"\u1785\u17D2\u1793\u17C3"},{"id":2752,"word":"\u1785\u17D2\u1793\u17C4\u17C7"},{"id":2753,"word":"\u1785\u17D2\u1794\u1784"},{"id":2754,"word":"\u1785\u17D2\u1794\u17B6"},{"id":2755,"word":"\u1785\u17D2\u1794\u17B6\u1780\u17CB"},{"id":2756,"word":"\u1785\u17D2\u1794\u17B6\u1794\u17CB"},{"id":2757,"word":"\u1785\u17D2\u1794\u17B6\u1794\u17CB\u1780\u17D2\u179A\u1798"},{"id":2758,"word":"\u1785\u17D2\u1794\u17B6\u1798"},{"id":2759,"word":"\u1785\u17D2\u1794\u17B6\u179A"},{"id":2760,"word":"\u1785\u17D2\u1794\u17B6\u179F\u17CB"},{"id":2761,"word":"\u1785\u17D2\u1794\u17B6\u179F\u17CB\u1785\u17D2\u1794\u1784"},{"id":2762,"word":"\u1785\u17D2\u1794\u17B6\u179F\u17CB\u179B\u17B6\u179F\u17CB"},{"id":2763,"word":"\u1785\u17D2\u1794\u17B7\u1785"},{"id":2764,"word":"\u1785\u17D2\u1794\u17B7\u1785\u1785\u17D2\u1794\u17BE\u1798"},{"id":2765,"word":"\u1785\u17D2\u1794\u17BB\u1785"},{"id":2766,"word":"\u1785\u17D2\u1794\u17BC\u1780"},{"id":2767,"word":"\u1785\u17D2\u1794\u17BC\u178F"},{"id":2768,"word":"\u1785\u17D2\u1794\u17C2\u1794"},{"id":2769,"word":"\u1785\u17D2\u1794\u17C4\u179B"},{"id":2770,"word":"\u1785\u17D2\u1794\u17C4\u179B\u17D7"},{"id":2771,"word":"\u1785\u17D2\u1794\u17C4\u179F"},{"id":2772,"word":"\u1785\u17D2\u1794\u17C4\u17C7"},{"id":2773,"word":"\u1785\u17D2\u1794\u17B6\u17C6\u1784"},{"id":2774,"word":"\u1785\u17D2\u1799\u17BB\u178F"},{"id":2775,"word":"\u1785\u17D2\u1799\u17BB\u178F\u17B7"},{"id":2776,"word":"\u1785\u17D2\u179A\u1780"},{"id":2777,"word":"\u1785\u17D2\u179A\u1780\u17CB"},{"id":2778,"word":"\u1785\u17D2\u179A\u1780\u17B6\u1785\u1785\u17D2\u179A\u1780\u17BC\u179C"},{"id":2779,"word":"\u1785\u17D2\u179A\u1780\u17C2\u1784"},{"id":2780,"word":"\u1785\u17D2\u179A\u1780\u17C2\u1784\u1791\u17BD\u1799"},{"id":2781,"word":"\u1785\u17D2\u179A\u1782\u17B6\u1784"},{"id":2782,"word":"\u1785\u17D2\u179A\u1782\u17B8\u1784\u1785\u17D2\u179A\u1782\u17B6\u1784"},{"id":2783,"word":"\u1785\u17D2\u179A\u1784\u17CB"},{"id":2784,"word":"\u1785\u17D2\u179A\u1784\u1780\u17CB"},{"id":2785,"word":"\u1785\u17D2\u179A\u1784\u17B6\u1784"},{"id":2786,"word":"\u1785\u17D2\u179A\u1784\u17B6\u1794\u17CB\u1785\u17D2\u179A\u1784\u17B7\u179B"},{"id":2787,"word":"\u1785\u17D2\u179A\u1784\u17B6\u1798"},{"id":2788,"word":"\u1785\u17D2\u179A\u1784\u17BC\u179C"},{"id":2789,"word":"\u1785\u17D2\u179A\u1784\u17C1\u1784\u1785\u17D2\u179A\u1784\u17B6\u1784"},{"id":2790,"word":"\u1785\u17D2\u179A\u1784\u17C4"},{"id":2791,"word":"\u1785\u17D2\u179A\u1784\u17B6\u17C6\u1784"},{"id":2792,"word":"\u1785\u17D2\u179A\u1785"},{"id":2793,"word":"\u1785\u17D2\u179A\u1785\u17D7"},{"id":2794,"word":"\u1785\u17D2\u179A\u178E\u17C2\u1793"},{"id":2795,"word":"\u1785\u17D2\u179A\u178F\u17CB"},{"id":2796,"word":"\u1785\u17D2\u179A\u178F\u17CB\u1793\u1784\u17D2\u1782\u17D0\u179B"},{"id":2797,"word":"\u1785\u17D2\u179A\u1793\u17BD\u1785"},{"id":2798,"word":"\u1785\u17D2\u179A\u1793\u17C0\u1784"},{"id":2799,"word":"\u1785\u17D2\u179A\u1794\u17CB"},{"id":2800,"word":"\u1785\u17D2\u179A\u1794\u17CB"},{"id":2801,"word":"\u1785\u17D2\u179A\u1794\u179B\u17CB"},{"id":2802,"word":"\u1785\u17D2\u179A\u1794\u17B6\u1785\u17CB"},{"id":2803,"word":"\u1785\u17D2\u179A\u1794\u17BB\u1785"},{"id":2804,"word":"\u1785\u17D2\u179A\u1794\u17BC\u1780"},{"id":2805,"word":"\u1785\u17D2\u179A\u1794\u17BC\u1789"},{"id":2806,"word":"\u1785\u17D2\u179A\u1796\u17BE\u1784"},{"id":2807,"word":"\u1785\u17D2\u179A\u1796\u17BE\u179F"},{"id":2808,"word":"\u1785\u17D2\u179A\u1798"},{"id":2809,"word":"\u1785\u17D2\u179A\u1798\u1780\u17CB"},{"id":2810,"word":"\u1785\u17D2\u179A\u1798\u17B7\u1785"},{"id":2811,"word":"\u1785\u17D2\u179A\u1798\u17BB\u17C7"},{"id":2812,"word":"\u1785\u17D2\u179A\u1798\u17BC\u1789"},{"id":2813,"word":"\u1785\u17D2\u179A\u1798\u17BC\u179B"},{"id":2814,"word":"\u1785\u17D2\u179A\u1798\u17BD\u1793"},{"id":2815,"word":"\u1785\u17D2\u179A\u179C\u17B6"},{"id":2816,"word":"\u1785\u17D2\u179A\u179C\u17B6\u1780\u17CB"},{"id":2817,"word":"\u1785\u17D2\u179A\u179C\u17B6\u178F\u17CB"},{"id":2818,"word":"\u1785\u17D2\u179A\u179C\u17B6\u1794"},{"id":2819,"word":"\u1785\u17D2\u179A\u179C\u17C1\u17C7"},{"id":2820,"word":"\u1785\u17D2\u179A\u179C\u17C2\u1794"},{"id":2821,"word":"\u1785\u17D2\u179A\u179C\u17C4\u17C7"},{"id":2822,"word":"\u1785\u17D2\u179A\u179F\u17D7"},{"id":2823,"word":"\u1785\u17D2\u179A\u17A0"},{"id":2824,"word":"\u1785\u17D2\u179A\u17A0\u17B6\u1789\u17CB"},{"id":2825,"word":"\u1785\u17D2\u179A\u17A0\u17B6\u1794"},{"id":2826,"word":"\u1785\u17D2\u179A\u17A0\u17C1\u1789"},{"id":2827,"word":"\u1785\u17D2\u179A\u17A0\u17C4\u1784"},{"id":2828,"word":"\u1785\u17D2\u179A\u17A0\u17C4\u17C7"},{"id":2829,"word":"\u1785\u17D2\u179A\u17A0\u17B6\u17C6\u1784"},{"id":2830,"word":"\u1785\u17D2\u179A\u17A1\u17B6\u179F"},{"id":2831,"word":"\u1785\u17D2\u179A\u17A1\u17B9\u1784"},{"id":2832,"word":"\u1785\u17D2\u179A\u17A1\u17BA\u1798"},{"id":2833,"word":"\u1785\u17D2\u179A\u17A1\u17BB\u1784"},{"id":2834,"word":"\u1785\u17D2\u179A\u17A1\u17BC\u1780"},{"id":2835,"word":"\u1785\u17D2\u179A\u17A1\u17BE\u1799"},{"id":2836,"word":"\u1785\u17D2\u179A\u17A1\u17BE\u179F"},{"id":2837,"word":"\u1785\u17D2\u179A\u17A1\u17BE\u179F\u1794\u17BE\u179F"},{"id":2838,"word":"\u1785\u17D2\u179A\u17A1\u17C1\u17C7"},{"id":2839,"word":"\u1785\u17D2\u179A\u17A1\u17C3"},{"id":2840,"word":"\u1785\u17D2\u179A\u17A1\u17C4"},{"id":2841,"word":"\u1785\u17D2\u179A\u17A1\u17C4\u1784\u1781\u17B6\u1798"},{"id":2842,"word":"\u1785\u17D2\u179A\u17A1\u17C4\u178F"},{"id":2843,"word":"\u1785\u17D2\u179A\u17A1\u17C4\u17C7\u1794\u17C4\u17C7"},{"id":2844,"word":"\u1785\u17D2\u179A\u17A1\u17C6"},{"id":2845,"word":"\u1785\u17D2\u179A\u17A2\u179A"},{"id":2846,"word":"\u1785\u17D2\u179A\u17A2\u17B6\u1784"},{"id":2847,"word":"\u1785\u17D2\u179A\u17A2\u17B9\u1784"},{"id":2848,"word":"\u1785\u17D2\u179A\u17A2\u17BC\u179F"},{"id":2849,"word":"\u1785\u17D2\u179A\u17B6\u1780"},{"id":2850,"word":"\u1785\u17D2\u179A\u17B6\u1784"},{"id":2851,"word":"\u1785\u17D2\u179A\u17B6\u1785\u17CB"},{"id":2852,"word":"\u1785\u17D2\u179A\u17B6\u1789"},{"id":2853,"word":"\u1785\u17D2\u179A\u17B6\u1793"},{"id":2854,"word":"\u1785\u17D2\u179A\u17B6\u1794"},{"id":2855,"word":"\u1785\u17D2\u179A\u17B6\u179B"},{"id":2856,"word":"\u1785\u17D2\u179A\u17B6\u179B\u17CB"},{"id":2857,"word":"\u1785\u17D2\u179A\u17B6\u179C"},{"id":2858,"word":"\u1785\u17D2\u179A\u17B6\u179F"},{"id":2859,"word":"\u1785\u17D2\u179A\u17B6\u179F\u1785\u17D2\u179A\u17C6"},{"id":2860,"word":"\u1785\u17D2\u179A\u17B6\u179F\u17CB\u1785\u17D2\u179A\u17B6\u179B\u17CB"},{"id":2861,"word":"\u1785\u17D2\u179A\u17B7\u1785\u17D7"},{"id":2862,"word":"\u1785\u17D2\u179A\u17B7\u1798\u1785\u17D2\u179A\u17BB\u1798"},{"id":2863,"word":"\u1785\u17D2\u179A\u17B7\u179B"},{"id":2864,"word":"\u1785\u17D2\u179A\u17B9\u1780\u17D7"},{"id":2865,"word":"\u1785\u17D2\u179A\u17B9\u1784"},{"id":2866,"word":"\u1785\u17D2\u179A\u17B9\u1794"},{"id":2867,"word":"\u1785\u17D2\u179A\u17BA\u17C7"},{"id":2868,"word":"\u1785\u17D2\u179A\u17BB\u1784"},{"id":2869,"word":"\u1785\u17D2\u179A\u17BB\u1794\u17D7"},{"id":2870,"word":"\u1785\u17D2\u179A\u17BB\u1798\u17D7"},{"id":2871,"word":"\u1785\u17D2\u179A\u17BB\u17C7"},{"id":2872,"word":"\u1785\u17D2\u179A\u17BC\u1784"},{"id":2873,"word":"\u1785\u17D2\u179A\u17BC\u1785"},{"id":2874,"word":"\u1785\u17D2\u179A\u17BC\u178F"},{"id":2875,"word":"\u1785\u17D2\u179A\u17BD\u1785"},{"id":2876,"word":"\u1785\u17D2\u179A\u17BD\u179B"},{"id":2877,"word":"\u1785\u17D2\u179A\u17BE\u1793"},{"id":2878,"word":"\u1785\u17D2\u179A\u17C0\u1780"},{"id":2879,"word":"\u1785\u17D2\u179A\u17C0\u1784"},{"id":2880,"word":"\u1785\u17D2\u179A\u17C0\u1785"},{"id":2881,"word":"\u1785\u17D2\u179A\u17C0\u1794"},{"id":2882,"word":"\u1785\u17D2\u179A\u17C0\u179C\u1785\u17D2\u179A\u17C3"},{"id":2883,"word":"\u1785\u17D2\u179A\u17C1\u1785"},{"id":2884,"word":"\u1785\u17D2\u179A\u17C1\u1789\u1785\u17D2\u179A\u17BB\u1789"},{"id":2885,"word":"\u1785\u17D2\u179A\u17C1\u179F"},{"id":2886,"word":"\u1785\u17D2\u179A\u17C1\u17C7"},{"id":2887,"word":"\u1785\u17D2\u179A\u17C2\u1784"},{"id":2888,"word":"\u1785\u17D2\u179A\u17C2\u178F\u17D7"},{"id":2889,"word":"\u1785\u17D2\u179A\u17C2\u179F"},{"id":2890,"word":"\u1785\u17D2\u179A\u17C2\u17C7"},{"id":2891,"word":"\u1785\u17D2\u179A\u17C4\u1780"},{"id":2892,"word":"\u1785\u17D2\u179A\u17C4\u1784"},{"id":2893,"word":"\u1785\u17D2\u179A\u17C4\u17C7"},{"id":2894,"word":"\u1785\u17D2\u179A\u17C6"},{"id":2895,"word":"\u1785\u17D2\u179A\u17B6\u17C6\u1784"},{"id":2896,"word":"\u1785\u1780\u17D2\u1781\u17BB\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u1780"},{"id":2897,"word":"\u1785\u1798\u17D2\u1784\u17B6\u1789\u17CB"},{"id":2898,"word":"\u1785\u1798\u17D2\u179A\u178F\u17CB"},{"id":2899,"word":"\u1785\u1798\u17D2\u179A\u17B6\u1789"},{"id":2900,"word":"\u1785\u1798\u17D2\u179A\u17B6\u1793"},{"id":2901,"word":"\u1785\u1798\u17D2\u179A\u17B6\u179B\u17CB"},{"id":2902,"word":"\u1785\u17B6\u1794\u17CB\u17A0\u17BD\u1799"},{"id":2903,"word":"\u1785\u17C6\u178E"},{"id":2904,"word":"\u1785\u17C6\u178E\u179A"},{"id":2905,"word":"\u1785\u17C6\u178E\u17B6\u1789\u17CB"},{"id":2906,"word":"\u1785\u17C6\u178E\u17B6\u179B"},{"id":2907,"word":"\u1785\u17C6\u178E\u17B9\u1780"},{"id":2908,"word":"\u1785\u17C6\u178E\u17B9\u1794"},{"id":2909,"word":"\u1785\u17C6\u178E\u17BB\u1780"},{"id":2910,"word":"\u1785\u17C6\u178E\u17C2\u1784"},{"id":2911,"word":"\u1785\u17C6\u178E\u17C2\u179C"},{"id":2912,"word":"\u1785\u17C6\u178E\u17C4\u179B"},{"id":2913,"word":"\u1785\u17C6\u178E\u17C0\u179F"},{"id":2914,"word":"\u1785\u17C6\u178E\u17C6"},{"id":2915,"word":"\u1785\u17C6\u17A0\u17B6\u1794"},{"id":2916,"word":"\u1785\u17C6\u17A0\u17BD\u179B"},{"id":2917,"word":"\u1785\u17C6\u17A0\u17C1\u17C7"},{"id":2918,"word":"\u1785\u17D2\u179A\u17A1\u17B6\u1798"},{"id":2919,"word":"\u1786"},{"id":2920,"word":"\u1786\u1780"},{"id":2921,"word":"\u1786\u1780\u17CB"},{"id":2922,"word":"\u1786\u1780\u17B6\u1798\u17B6\u179C\u1785\u179A"},{"id":2923,"word":"\u1786\u1780\u17B6\u1798\u17B6\u179C\u1785\u179A\u179F\u17BD\u1782\u17CC"},{"id":2924,"word":"\u1786\u1780\u17D2\u179F\u178F\u17D2\u179A"},{"id":2925,"word":"\u1786\u178A\u17B6"},{"id":2926,"word":"\u1786\u178A\u17B6\u1797\u17B6"},{"id":2927,"word":"\u1786\u178F"},{"id":2928,"word":"\u1786\u178F\u17D2\u179A"},{"id":2929,"word":"\u1786\u178F\u17D2\u179A\u179A\u17BD\u178F"},{"id":2930,"word":"\u1786\u1791\u17B6\u1793\u179F\u17B6\u179B\u17B6"},{"id":2931,"word":"\u1786\u1791\u17D2\u1791\u1793\u17D2\u178F"},{"id":2932,"word":"\u1786\u1791\u17D2\u179C\u17B6\u179A"},{"id":2933,"word":"\u1786\u1793\u17D2\u1791"},{"id":2934,"word":"\u1786\u1793\u17D2\u1791\u17C8"},{"id":2935,"word":"\u1786\u1793\u17D2\u1791\u179C\u17BB\u178F\u17D2\u178F\u17B7\u1794\u17D2\u1794\u1791\u17B8\u1794"},{"id":2936,"word":"\u1786\u1793\u17D2\u1791\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":2937,"word":"\u1786\u1793\u17D2\u1791\u17B6"},{"id":2938,"word":"\u1786\u1793\u17D2\u1791\u17B6\u1782\u178F\u17B7"},{"id":2939,"word":"\u1786\u1793\u17D2\u1793\u17A2\u17B6\u1798\u17B6\u178F\u17D2\u1799"},{"id":2940,"word":"\u1786\u1794"},{"id":2941,"word":"\u1786\u1796\u17D2\u179C\u178E\u17D2\u178E\u179A\u1784\u17D2\u179F\u17B8"},{"id":2942,"word":"\u1786\u1798\u17B6\u179F"},{"id":2943,"word":"\u1786\u179A"},{"id":2944,"word":"\u1786\u179C\u1782\u17D2\u179A\u17B9\u17C7"},{"id":2945,"word":"\u1786\u179C\u17B8"},{"id":2946,"word":"\u1786\u179C\u17B8\u179A\u17C4\u1782"},{"id":2947,"word":"\u1786\u179C\u17B8\u179C\u178E\u17D2\u178E"},{"id":2948,"word":"\u1786\u179F\u17D0\u1780"},{"id":2949,"word":"\u1786\u17B6"},{"id":2950,"word":"\u1786\u17B6\u17CE"},{"id":2951,"word":"\u1786\u17B6\u17D7"},{"id":2952,"word":"\u1786\u17B6\u1780"},{"id":2953,"word":"\u1786\u17B6\u1784"},{"id":2954,"word":"\u1786\u17B6\u1786\u17C5"},{"id":2955,"word":"\u1786\u17B6\u178F\u1780\u17B6\u179B"},{"id":2956,"word":"\u1786\u17B6\u178F\u1780\u1791\u17BB\u1780\u17D2\u1781"},{"id":2957,"word":"\u1786\u17B6\u178F\u1780\u1797\u17D0\u1799"},{"id":2958,"word":"\u1786\u17B6\u178F\u1780\u179A\u17C4\u1782"},{"id":2959,"word":"\u1786\u17B6\u1793\u17CB"},{"id":2960,"word":"\u1786\u17B6\u1794"},{"id":2961,"word":"\u1786\u17B6\u1794\u17CB"},{"id":2962,"word":"\u1786\u17B6\u1799"},{"id":2963,"word":"\u1786\u17B6\u1799\u17B6"},{"id":2964,"word":"\u1786\u17B6\u1799\u17B6\u1792\u179A"},{"id":2965,"word":"\u1786\u17B6\u1799\u17B6\u1794\u1790"},{"id":2966,"word":"\u1786\u17B6\u1799\u17B6\u1797\u17D2\u179A\u17B9\u178F"},{"id":2967,"word":"\u1786\u17B6\u1799\u17B6\u1798\u17B7\u178F\u17D2\u179A"},{"id":2968,"word":"\u1786\u17B6\u1799\u17B6\u179B\u17D0\u1780\u17D2\u1781\u178E\u17CD"},{"id":2969,"word":"\u1786\u17B6\u179B\u17CB"},{"id":2970,"word":"\u1786\u17B6\u179C"},{"id":2971,"word":"\u1786\u17B7\u1789"},{"id":2972,"word":"\u1786\u17B7\u178F"},{"id":2973,"word":"\u1786\u17B7\u179B"},{"id":2974,"word":"\u1786\u17B8"},{"id":2975,"word":"\u1786\u17B9\u1780\u17D7"},{"id":2976,"word":"\u1786\u17B9\u1784"},{"id":2977,"word":"\u1786\u17BA\u1784"},{"id":2978,"word":"\u1786\u17BB\u1780"},{"id":2979,"word":"\u1786\u17BB\u1784"},{"id":2980,"word":"\u1786\u17BB\u178F"},{"id":2981,"word":"\u1786\u17BB\u1794"},{"id":2982,"word":"\u1786\u17BB\u179A"},{"id":2983,"word":"\u1786\u17BC\u178F"},{"id":2984,"word":"\u1786\u17BC\u179C"},{"id":2985,"word":"\u1786\u17BD\u1784"},{"id":2986,"word":"\u1786\u17BD\u179B"},{"id":2987,"word":"\u1786\u17BE\u178F"},{"id":2988,"word":"\u1786\u17BE\u1799"},{"id":2989,"word":"\u1786\u17C0\u1780"},{"id":2990,"word":"\u1786\u17C0\u1784"},{"id":2991,"word":"\u1786\u17C0\u1794"},{"id":2992,"word":"\u1786\u17C1\u1789"},{"id":2993,"word":"\u1786\u17C1\u179A"},{"id":2994,"word":"\u1786\u17C1\u179C"},{"id":2995,"word":"\u1786\u17C1\u17C7"},{"id":2996,"word":"\u1786\u17C2"},{"id":2997,"word":"\u1786\u17C2\u1780"},{"id":2998,"word":"\u1786\u17C2\u1780\u17C2\u179C"},{"id":2999,"word":"\u1786\u17C2\u1780\u1786\u17C1\u179A"},{"id":3000,"word":"\u1786\u17C2\u1784"},{"id":3001,"word":"\u1786\u17C2\u178F"},{"id":3002,"word":"\u1786\u17C2\u1794"},{"id":3003,"word":"\u1786\u17C2\u179C"},{"id":3004,"word":"\u1786\u17C3\u1799\u17C9\u17B6\u17C6"},{"id":3005,"word":"\u1786\u17C4\u1784"},{"id":3006,"word":"\u1786\u17C4\u178F"},{"id":3007,"word":"\u1786\u17C4\u1798"},{"id":3008,"word":"\u1786\u17C4\u17A1\u17C4"},{"id":3009,"word":"\u1786\u17C5"},{"id":3010,"word":"\u1786\u17B6\u17C6\u1784"},{"id":3011,"word":"\u1786\u17B6\u17C6\u1784\u17D7"},{"id":3012,"word":"\u1786\u17B6\u17C6\u1786\u17B6"},{"id":3013,"word":"\u1786\u17D2\u1780\u1799"},{"id":3014,"word":"\u1786\u17D2\u1780\u17B6\u1784"},{"id":3015,"word":"\u1786\u17D2\u1780\u17B6\u179A"},{"id":3016,"word":"\u1786\u17D2\u1780\u17B7\u179B"},{"id":3017,"word":"\u1786\u17D2\u1780\u17B9\u1784"},{"id":3018,"word":"\u1786\u17D2\u1780\u17B9\u17C7"},{"id":3019,"word":"\u1786\u17D2\u1780\u17B9\u17C7\u1786\u17D2\u1780\u17C0\u179B"},{"id":3020,"word":"\u1786\u17D2\u1780\u17BA\u178F"},{"id":3021,"word":"\u1786\u17D2\u1780\u17BB\u1799"},{"id":3022,"word":"\u1786\u17D2\u1780\u17BC\u178F"},{"id":3023,"word":"\u1786\u17D2\u1780\u17BD\u178F"},{"id":3024,"word":"\u1786\u17D2\u1780\u17BD\u178F\u1787\u17D2\u179A\u17BC\u1780"},{"id":3025,"word":"\u1786\u17D2\u1780\u17C0\u179B"},{"id":3026,"word":"\u1786\u17D2\u1780\u17C0\u179F"},{"id":3027,"word":"\u1786\u17D2\u1780\u17C2"},{"id":3028,"word":"\u1786\u17D2\u1780\u17C2\u1789\u17B6\u17C6\u1784"},{"id":3029,"word":"\u1786\u17D2\u1780\u17C2\u179F\u17D2\u179A\u17C2\u1784"},{"id":3030,"word":"\u1786\u17D2\u1780\u17C4\u1780"},{"id":3031,"word":"\u1786\u17D2\u1782\u1784"},{"id":3032,"word":"\u1786\u17D2\u1782\u17B6\u17C6"},{"id":3033,"word":"\u1786\u17D2\u1784\u1780"},{"id":3034,"word":"\u1786\u17D2\u1784\u1780\u17CB"},{"id":3035,"word":"\u1786\u17D2\u1784\u179B\u17CB"},{"id":3036,"word":"\u1786\u17D2\u1784\u17B6\u1789\u17CB"},{"id":3037,"word":"\u1786\u17D2\u1784\u17B6\u1799"},{"id":3038,"word":"\u1786\u17D2\u1784\u17B7\u178F"},{"id":3039,"word":"\u1786\u17D2\u1784\u17B9\u1784"},{"id":3040,"word":"\u1786\u17D2\u1784\u17BB\u1799"},{"id":3041,"word":"\u1786\u17D2\u1784\u17BC\u179C"},{"id":3042,"word":"\u1786\u17D2\u1784\u17BE\u1780"},{"id":3043,"word":"\u1786\u17D2\u1784\u17BE\u1799"},{"id":3044,"word":"\u1786\u17D2\u1784\u17C2"},{"id":3045,"word":"\u1786\u17D2\u178A\u17BB\u1794"},{"id":3046,"word":"\u1786\u17D2\u178A\u17C1\u1789"},{"id":3047,"word":"\u1786\u17D2\u178A\u17C4"},{"id":3048,"word":"\u1786\u17D2\u178A\u17C4\u179A"},{"id":3049,"word":"\u1786\u17D2\u1793\u1784\u17CB"},{"id":3050,"word":"\u1786\u17D2\u1793\u17B6\u1780\u17CB"},{"id":3051,"word":"\u1786\u17D2\u1793\u17B6\u1794\u17CB\u1798\u17B6\u178F\u17CB"},{"id":3052,"word":"\u1786\u17D2\u1793\u17B6\u179B\u17CB"},{"id":3053,"word":"\u1786\u17D2\u1793\u17B6\u179B\u17CB\u1798\u17B6\u1793\u17CB"},{"id":3054,"word":"\u1786\u17D2\u1793\u17B6\u179F"},{"id":3055,"word":"\u1786\u17D2\u1793\u17B9\u1798"},{"id":3056,"word":"\u1786\u17D2\u1793\u17BB\u1780"},{"id":3057,"word":"\u1786\u17D2\u1793\u17BB\u1780\u1780\u17D2\u1794\u17B7\u1793"},{"id":3058,"word":"\u1786\u17D2\u1793\u17BC\u178F"},{"id":3059,"word":"\u1786\u17D2\u1793\u17BD\u1793"},{"id":3060,"word":"\u1786\u17D2\u1793\u17BE\u1798"},{"id":3061,"word":"\u1786\u17D2\u1793\u17C0\u1784"},{"id":3062,"word":"\u1786\u17D2\u1793\u17C1\u179A"},{"id":3063,"word":"\u1786\u17D2\u1793\u17C2\u1784"},{"id":3064,"word":"\u1786\u17D2\u1793\u17C3"},{"id":3065,"word":"\u1786\u17D2\u1793\u17C4\u178F"},{"id":3066,"word":"\u1786\u17D2\u1793\u17B6\u17C6"},{"id":3067,"word":"\u1786\u17D2\u1793\u17B6\u17C6\u1784"},{"id":3068,"word":"\u1786\u17D2\u1793\u17B6\u17C6\u1784\u179A\u1794\u17BD\u179B"},{"id":3069,"word":"\u1786\u17D2\u1796\u1784\u17CB"},{"id":3070,"word":"\u1786\u17D2\u1796\u17B6\u1798"},{"id":3071,"word":"\u1786\u17D2\u1796\u17B7\u178F"},{"id":3072,"word":"\u1786\u17D2\u1796\u17B7\u1793"},{"id":3073,"word":"\u1786\u17D2\u1796\u17B9\u17C7"},{"id":3074,"word":"\u1786\u17D2\u1796\u17BB\u1784"},{"id":3075,"word":"\u1786\u17D2\u1796\u17C4\u17C7"},{"id":3076,"word":"\u1786\u17D2\u1798\u1780\u17CB"},{"id":3077,"word":"\u1786\u17D2\u1798\u1794"},{"id":3078,"word":"\u1786\u17D2\u1798\u17B6"},{"id":3079,"word":"\u1786\u17D2\u1798\u17B6\u178F\u17CB"},{"id":3080,"word":"\u1786\u17D2\u1798\u17B6\u1794\u17B6"},{"id":3081,"word":"\u1786\u17D2\u1798\u17B6\u179A"},{"id":3082,"word":"\u1786\u17D2\u1798\u17BC\u179B"},{"id":3083,"word":"\u1786\u17D2\u1798\u17BE\u1784"},{"id":3084,"word":"\u1786\u17D2\u1798\u17C0\u1784"},{"id":3085,"word":"\u1786\u17D2\u1798\u17C3"},{"id":3086,"word":"\u1786\u17D2\u1798\u17B6\u17C6"},{"id":3087,"word":"\u1786\u17D2\u179B\u1780"},{"id":3088,"word":"\u1786\u17D2\u179B\u1784"},{"id":3089,"word":"\u1786\u17D2\u179B\u1784\u1796\u17D2\u179A\u17C7\u1794\u17B6\u1791"},{"id":3090,"word":"\u1786\u17D2\u179B\u17B6"},{"id":3091,"word":"\u1786\u17D2\u179B\u17B6\u1780\u17CB"},{"id":3092,"word":"\u1786\u17D2\u179B\u17B6\u178F"},{"id":3093,"word":"\u1786\u17D2\u179B\u17B6\u1798"},{"id":3094,"word":"\u1786\u17D2\u179B\u17B6\u179F"},{"id":3095,"word":"\u1786\u17D2\u179B\u17B6\u179F\u17CB"},{"id":3096,"word":"\u1786\u17D2\u179B\u17BA\u1798"},{"id":3097,"word":"\u1786\u17D2\u179B\u17BB\u17C7"},{"id":3098,"word":"\u1786\u17D2\u179B\u17BC\u1780"},{"id":3099,"word":"\u1786\u17D2\u179B\u17BC\u1784"},{"id":3100,"word":"\u1786\u17D2\u179B\u17BC\u1789"},{"id":3101,"word":"\u1786\u17D2\u179B\u17BC\u179C"},{"id":3102,"word":"\u1786\u17D2\u179B\u17BE\u1799"},{"id":3103,"word":"\u1786\u17D2\u179B\u17C0\u178F"},{"id":3104,"word":"\u1786\u17D2\u179B\u17C0\u179C\u1786\u17D2\u179B\u17B6\u178F"},{"id":3105,"word":"\u1786\u17D2\u179B\u17C0\u179C\u1786\u17D2\u179B\u17B6\u179F"},{"id":3106,"word":"\u1786\u17D2\u179B\u17C1"},{"id":3107,"word":"\u1786\u17D2\u179B\u17C2\u1780"},{"id":3108,"word":"\u1786\u17D2\u179B\u17C4\u1784"},{"id":3109,"word":"\u1786\u17D2\u179B\u17C5"},{"id":3110,"word":"\u1786\u17D2\u179B\u17B6\u17C6\u1784"},{"id":3111,"word":"\u1786\u17D2\u179C"},{"id":3112,"word":"\u1786\u17D2\u179C\u1784\u17CB"},{"id":3113,"word":"\u1786\u17D2\u179C\u17B6"},{"id":3114,"word":"\u1786\u17D2\u179C\u17B6\u1780"},{"id":3115,"word":"\u1786\u17D2\u179C\u17B6\u1780\u17CB"},{"id":3116,"word":"\u1786\u17D2\u179C\u17B6\u1784"},{"id":3117,"word":"\u1786\u17D2\u179C\u17B6\u1785"},{"id":3118,"word":"\u1786\u17D2\u179C\u17B6\u178F\u17CB\u1786\u17D2\u179C\u17C0\u179B"},{"id":3119,"word":"\u1786\u17D2\u179C\u17B6\u178F\u17CB\u1786\u17D2\u179C\u17C2\u1784"},{"id":3120,"word":"\u1786\u17D2\u179C\u17B6\u1799"},{"id":3121,"word":"\u1786\u17D2\u179C\u17C0\u179B"},{"id":3122,"word":"\u1786\u17D2\u179C\u17C0\u179B\u1786\u17D2\u179C\u17B6\u178F\u17CB"},{"id":3123,"word":"\u1786\u17D2\u179C\u17C1\u1784"},{"id":3124,"word":"\u1786\u17D2\u179C\u17C1\u17C7"},{"id":3125,"word":"\u1786\u17D2\u179C\u17C2\u179B"},{"id":3126,"word":"\u1786\u17D2\u17A2\u1793\u17CB"},{"id":3127,"word":"\u1786\u17D2\u17A2\u179B\u17CB"},{"id":3128,"word":"\u1786\u17D2\u17A2\u17B6\u1794"},{"id":3129,"word":"\u1786\u17D2\u17A2\u17B7\u178F"},{"id":3130,"word":"\u1786\u17D2\u17A2\u17B7\u1793"},{"id":3131,"word":"\u1786\u17D2\u17A2\u17B9\u1784"},{"id":3132,"word":"\u1786\u17D2\u17A2\u17B9\u1784\u1787\u17C6\u1793\u17B8\u179A"},{"id":3133,"word":"\u1786\u17D2\u17A2\u17BA\u179F"},{"id":3134,"word":"\u1786\u17D2\u17A2\u17BE\u1798"},{"id":3135,"word":"\u1786\u17D2\u17A2\u17BE\u179A"},{"id":3136,"word":"\u1786\u17D2\u17A2\u17BE\u179F\u1786\u17D2\u17A2\u17BE\u1798"},{"id":3137,"word":"\u1786\u17D2\u17A2\u17C1\u17C7"},{"id":3138,"word":"\u1786\u17D2\u17A2\u17C2\u1784"},{"id":3139,"word":"\u1786\u17D2\u17A2\u17C2\u178F"},{"id":3140,"word":"\u1786\u17D2\u17A2\u17C5"},{"id":3141,"word":"\u1786\u17C3\u1790\u17B6\u179C"},{"id":3142,"word":"\u1786\u17C3\u1794\u17C9\u17BC\u179C"},{"id":3143,"word":"\u1786\u17D2\u1793\u17B6\u17C6\u1791\u17C5"},{"id":3144,"word":"\u1787"},{"id":3145,"word":"\u1787\u1780\u17CB"},{"id":3146,"word":"\u1787\u1782\u178F"},{"id":3147,"word":"\u1787\u1784"},{"id":3148,"word":"\u1787\u1784\u17CB"},{"id":3149,"word":"\u1787\u1784\u17D2\u1782\u1784\u17CB"},{"id":3150,"word":"\u1787\u1784\u17D2\u1783"},{"id":3151,"word":"\u1787\u1784\u17D2\u1783\u1798\u1782\u17D2\u1782"},{"id":3152,"word":"\u1787\u1784\u17D2\u1783\u1798\u17B6\u1782\u17CC\u17B6"},{"id":3153,"word":"\u1787\u1784\u17D2\u1783\u17B6"},{"id":3154,"word":"\u1787\u1784\u17D2\u17A0\u17BB\u1780"},{"id":3155,"word":"\u1787\u1785\u17CB"},{"id":3156,"word":"\u1787\u1787\u17B8\u1780"},{"id":3157,"word":"\u1787\u1787\u17BB\u17C7"},{"id":3158,"word":"\u1787\u1787\u17BB\u17C7\u1787\u1787\u17B6\u1799"},{"id":3159,"word":"\u1787\u1787\u17BD\u179A"},{"id":3160,"word":"\u1787\u1787\u17BE\u179B"},{"id":3161,"word":"\u1787\u1787\u17C2\u1780"},{"id":3162,"word":"\u1787\u1787\u17D2\u179A\u1780"},{"id":3163,"word":"\u1787\u1787\u17D2\u179A\u1780\u1798\u1798\u1780"},{"id":3164,"word":"\u1787\u1787\u17D2\u179A\u17BB\u179B\u1787\u1787\u17D2\u179A\u1780"},{"id":3165,"word":"\u1787\u1787\u17D2\u179A\u17BB\u179B\u1787\u1787\u17D2\u179A\u17BD\u179F"},{"id":3166,"word":"\u1787\u1787\u17D2\u179A\u17BB\u179B\u1798\u1798\u17BB\u179B"},{"id":3167,"word":"\u1787\u1789\u17D2\u1787\u1780\u17CB"},{"id":3168,"word":"\u1787\u1789\u17D2\u1787\u17B6\u178F\u17CB"},{"id":3169,"word":"\u1787\u1789\u17D2\u1787\u17B6\u178F\u17CB\u1796\u17D2\u179A\u179B\u17B9\u1784"},{"id":3170,"word":"\u1787\u1789\u17D2\u1787\u17B6\u1793\u17CB"},{"id":3171,"word":"\u1787\u1789\u17D2\u1787\u17B6\u1793\u17CB\u179F\u17D2\u179B\u17B6\u1789"},{"id":3172,"word":"\u1787\u1789\u17D2\u1787\u17B6\u1794"},{"id":3173,"word":"\u1787\u1789\u17D2\u1787\u17B6\u1794\u17CB"},{"id":3174,"word":"\u1787\u1789\u17D2\u1787\u17B8\u1784"},{"id":3175,"word":"\u1787\u1789\u17D2\u1787\u17B9\u1784"},{"id":3176,"word":"\u1787\u1789\u17D2\u1787\u17BC\u1793"},{"id":3177,"word":"\u1787\u1789\u17D2\u1787\u17BD\u1785"},{"id":3178,"word":"\u1787\u1789\u17D2\u1787\u17BD\u1799"},{"id":3179,"word":"\u1787\u1789\u17D2\u1787\u17C2\u1784"},{"id":3180,"word":"\u1787\u1789\u17D2\u1787\u17B6\u17C6\u1784"},{"id":3181,"word":"\u1787\u1789\u17D2\u1787\u17D2\u179A\u17C6"},{"id":3182,"word":"\u1787\u1789\u17D2\u1787\u17D2\u179A\u17B6\u17C6\u1784"},{"id":3183,"word":"\u1787\u178A\u17B6"},{"id":3184,"word":"\u1787\u178A\u17B6\u1792\u179A"},{"id":3185,"word":"\u1787\u178A\u17B7\u179B"},{"id":3186,"word":"\u1787\u178E\u17D2\u178A\u17BE\u179A"},{"id":3187,"word":"\u1787\u178E\u17D2\u178A\u17BE\u179A\u179F\u17D2\u179C\u17B6"},{"id":3188,"word":"\u1787\u178F"},{"id":3189,"word":"\u1787\u178F\u17B6"},{"id":3190,"word":"\u1787\u1793"},{"id":3191,"word":"\u1787\u1793"},{"id":3192,"word":"\u1787\u1793\u17CB"},{"id":3193,"word":"\u1787\u1793\u1780"},{"id":3194,"word":"\u1787\u1793\u1780\u17B6\u1799"},{"id":3195,"word":"\u1787\u1793\u178F\u17B6"},{"id":3196,"word":"\u1787\u1793\u1793\u17B6\u1790"},{"id":3197,"word":"\u1787\u1793\u1793\u17B7\u1780\u179A"},{"id":3198,"word":"\u1787\u1793\u1793\u17B7\u1780\u17B6\u1799"},{"id":3199,"word":"\u1787\u1793\u1793\u17B8"},{"id":3200,"word":"\u1787\u1793\u1793\u17B8\u1793\u17B6\u1790"},{"id":3201,"word":"\u1787\u1793\u1794\u1791"},{"id":3202,"word":"\u1787\u1793\u1794\u1791\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":3203,"word":"\u1787\u1793\u17B6\u1785\u17B6\u179A"},{"id":3204,"word":"\u1787\u1793\u17B6\u1792\u17B7\u1794"},{"id":3205,"word":"\u1787\u1793\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":3206,"word":"\u1787\u1793\u17B6\u1793\u17BB\u1787\u1793"},{"id":3207,"word":"\u1787\u1793\u17B6\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":3208,"word":"\u1787\u1793\u17B6\u179F\u17D2\u179A\u17D0\u1799"},{"id":3209,"word":"\u1787\u1793\u17B7\u1793\u17D2\u1791"},{"id":3210,"word":"\u1787\u1793\u17B8"},{"id":3211,"word":"\u1787\u1793\u17B8\u1793\u17B6\u1790"},{"id":3212,"word":"\u1787\u1793\u17BB\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797"},{"id":3213,"word":"\u1787\u1793\u17BC\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u1780\u17C8"},{"id":3214,"word":"\u1787\u1793\u17C1\u178F\u17D2\u178F\u17B8"},{"id":3215,"word":"\u1787\u1793\u17C1\u1793\u17D2\u179A\u17D2\u1791"},{"id":3216,"word":"\u1787\u1793\u17C4\u178F\u17D2\u178F\u1798"},{"id":3217,"word":"\u1787\u1793\u17D2\u1798"},{"id":3218,"word":"\u1787\u1793\u17D2\u1798\u179C\u179F\u17D2\u179F\u17B6"},{"id":3219,"word":"\u1787\u1793\u17D2\u1798\u17B6"},{"id":3220,"word":"\u1787\u1793\u17D2\u179B"},{"id":3221,"word":"\u1787\u1793\u17D2\u179B\u1787\u1793\u17D2\u179B\u17C1\u1789"},{"id":3222,"word":"\u1787\u1793\u17D2\u179B\u1784\u17CB"},{"id":3223,"word":"\u1787\u1793\u17D2\u179B\u17B6\u178F\u17CB\u178A\u17C3"},{"id":3224,"word":"\u1787\u1793\u17D2\u179B\u17B6\u179F"},{"id":3225,"word":"\u1787\u1793\u17D2\u179B\u17BC\u179F"},{"id":3226,"word":"\u1787\u1793\u17D2\u179B\u17BD\u1789"},{"id":3227,"word":"\u1787\u1793\u17D2\u179B\u17BD\u1789\u1794\u179A"},{"id":3228,"word":"\u1787\u1793\u17D2\u179B\u17BD\u1789\u1798\u17B6\u1793\u17CB"},{"id":3229,"word":"\u1787\u1793\u17D2\u179B\u17C1\u1789"},{"id":3230,"word":"\u1787\u1793\u17D2\u179B\u17C1\u1793"},{"id":3231,"word":"\u1787\u1794"},{"id":3232,"word":"\u1787\u1794--"},{"id":3233,"word":"\u1787\u1794\u17CB"},{"id":3234,"word":"\u1787\u1798"},{"id":3235,"word":"\u1787\u1798\u17D2\u1793\u17C7"},{"id":3236,"word":"\u1787\u1798\u17D2\u1796\u17BC"},{"id":3237,"word":"\u1787\u1798\u17D2\u1796\u17BC\u1791\u17D2\u179C\u17B8\u1794"},{"id":3238,"word":"\u1787\u1798\u17D2\u1796\u17BC\u1793\u1791\u17C8"},{"id":3239,"word":"\u1787\u1798\u17D2\u1796\u17BC\u1793\u17BB\u1791"},{"id":3240,"word":"\u1787\u1798\u17D2\u1796\u17BC\u1795\u179B"},{"id":3241,"word":"\u1787\u1798\u17D2\u1796\u17BC\u1796\u17B6\u1793"},{"id":3242,"word":"\u1787\u1798\u17D2\u1796\u17BC\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":3243,"word":"\u1787\u1798\u17D2\u1798"},{"id":3244,"word":"\u1787\u1798\u17D2\u179A\u1780"},{"id":3245,"word":"\u1787\u1798\u17D2\u179A\u17B6\u1794"},{"id":3246,"word":"\u1787\u1798\u17D2\u179A\u17B6\u179B"},{"id":3247,"word":"\u1787\u1798\u17D2\u179A\u17BB\u179B"},{"id":3248,"word":"\u1787\u1798\u17D2\u179A\u17BB\u17C7"},{"id":3249,"word":"\u1787\u1798\u17D2\u179A\u17BE\u179F"},{"id":3250,"word":"\u1787\u1798\u17D2\u179A\u17C2\u1780"},{"id":3251,"word":"\u1787\u1798\u17D2\u179A\u17C5"},{"id":3252,"word":"\u1787\u1798\u17D2\u179A\u17C7"},{"id":3253,"word":"\u1787\u1798\u17D2\u179B\u17BE\u1799"},{"id":3254,"word":"\u1787\u1798\u17D2\u179B\u17C0\u179F"},{"id":3255,"word":"\u1787\u1798\u17D2\u179B\u17C4\u17C7"},{"id":3256,"word":"\u1787\u1799--"},{"id":3257,"word":"\u1787\u17D0\u1799"},{"id":3258,"word":"\u1787\u179A"},{"id":3259,"word":"\u1787\u179A\u1787\u17B6\u1799"},{"id":3260,"word":"\u1787\u179A\u1787\u17BD\u179A"},{"id":3261,"word":"\u1787\u17D0\u179A"},{"id":3262,"word":"\u1787\u179A\u17B6"},{"id":3263,"word":"\u1787\u179A\u17B6--"},{"id":3264,"word":"\u1787\u179B\u17CB"},{"id":3265,"word":"\u1787\u179B"},{"id":3266,"word":"\u1787\u179B--"},{"id":3267,"word":"\u1787\u179C\u1793\u17C8"},{"id":3268,"word":"\u1787\u179C\u1793\u1785\u17B7\u178F\u17D2\u178F"},{"id":3269,"word":"\u1787\u179C\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":3270,"word":"\u1787\u179C\u1793\u179C\u17B8\u1790\u17B7"},{"id":3271,"word":"\u1787\u179C\u1797\u17B6\u1796"},{"id":3272,"word":"\u1787\u179C\u179B\u17C1\u1781"},{"id":3273,"word":"\u1787\u179C\u179B\u17C1\u1781\u1780\u17C8"},{"id":3274,"word":"\u1787\u17A0\u17D2\u179C\u17B6"},{"id":3275,"word":"\u1787\u17B6"},{"id":3276,"word":"\u1787\u17B6\u1780\u17CB"},{"id":3277,"word":"\u1787\u17B6\u1784"},{"id":3278,"word":"\u1787\u17B6\u1789"},{"id":3279,"word":"\u1787\u17B6\u178F"},{"id":3280,"word":"\u1787\u17B6\u178F\u17CB"},{"id":3281,"word":"\u1787\u17B6\u178F\u1780"},{"id":3282,"word":"\u1787\u17B6\u178F\u179A\u17BC\u1794"},{"id":3283,"word":"\u1787\u17B6\u178F\u179C\u17C1\u1791"},{"id":3284,"word":"\u1787\u17B6\u178F\u179F\u17B7\u179B\u17B6"},{"id":3285,"word":"\u1787\u17B6\u178F\u179F\u17D2\u179A\u1784\u17CB"},{"id":3286,"word":"\u1787\u17B6\u178F\u179F\u17D2\u179A\u17C7"},{"id":3287,"word":"\u1787\u17B6\u178F\u17A0\u17B7\u1784\u17D2\u1782\u17BB\u179B"},{"id":3288,"word":"\u1787\u17B6\u178F\u17B6"},{"id":3289,"word":"\u1787\u17B6\u178F\u17B7"},{"id":3290,"word":"\u1787\u17B6\u178F\u17B7\u1791\u17BB\u1780\u17D2\u1781"},{"id":3291,"word":"\u1787\u17B6\u178F\u17B7\u1792\u1798\u17CC"},{"id":3292,"word":"\u1787\u17B6\u178F\u17B7\u1797\u17BC\u1798\u17B7"},{"id":3293,"word":"\u1787\u17B6\u178F\u17B7\u179A\u179F"},{"id":3294,"word":"\u1787\u17B6\u178F\u17B7\u179B\u17B7\u1784\u17D2\u1782"},{"id":3295,"word":"\u1787\u17B6\u178F\u17B8"},{"id":3296,"word":"\u1787\u17B6\u178F\u17BC\u1794\u1780\u179A\u178E\u17CD"},{"id":3297,"word":"\u1787\u17B6\u178F\u17BC\u1794\u1793\u17B8\u1799\u1780\u1798\u17D2\u1798"},{"id":3298,"word":"\u1787\u17B6\u1793\u17CB"},{"id":3299,"word":"\u1787\u17B6\u1793\u17CB\u1786\u17B6\u1799"},{"id":3300,"word":"\u1787\u17B6\u1793\u17CB\u17A1\u17BE\u1784"},{"id":3301,"word":"\u1787\u17B6\u1793\u1794\u1791"},{"id":3302,"word":"\u1787\u17B6\u1793\u17BB"},{"id":3303,"word":"\u1787\u17B6\u1793\u17BB\u1798\u178E\u17D2\u178C\u179B"},{"id":3304,"word":"\u1787\u17B6\u1794\u17CB"},{"id":3305,"word":"\u1787\u17B6\u1798"},{"id":3306,"word":"\u1787\u17B6\u1798\u17BD\u1799"},{"id":3307,"word":"\u1787\u17B6\u1799"},{"id":3308,"word":"\u1787\u17B6\u1799\u1782\u17D2\u179A\u17C2\u1784"},{"id":3309,"word":"\u1787\u17B6\u1799\u17B6"},{"id":3310,"word":"\u1787\u17B6\u179B"},{"id":3311,"word":"\u1787\u17B6\u179B\u17B6"},{"id":3312,"word":"\u1787\u17B6\u179B\u17B7\u1793\u17B8"},{"id":3313,"word":"\u1787\u17B6\u179B\u17B8"},{"id":3314,"word":"\u1787\u17B6\u179C"},{"id":3315,"word":"\u1787\u17B6\u179F"},{"id":3316,"word":"\u1787\u17B7\u178E\u17D2\u178E\u1780\u17B6\u1799"},{"id":3317,"word":"\u1787\u17B7\u178E\u17D2\u178E\u179A\u17BC\u1794"},{"id":3318,"word":"\u1787\u17B7\u178F"},{"id":3319,"word":"\u1787\u17B7\u178F!"},{"id":3320,"word":"\u1787\u17B7\u178F\u17C6!"},{"id":3321,"word":"\u1787\u17B7\u178F\u17B7\u1793\u17D2\u1791\u17D2\u179A\u17B7\u1799"},{"id":3322,"word":"\u1787\u17B7\u1793"},{"id":3323,"word":"\u1787\u17B7\u1793\u1794\u17BB\u178F\u17D2\u179A"},{"id":3324,"word":"\u1787\u17B7\u1793\u179C\u1784\u17D2\u179F"},{"id":3325,"word":"\u1787\u17B7\u1793\u179F\u17D2\u179A\u17B8"},{"id":3326,"word":"\u1787\u17B7\u1793\u17C4\u179A\u179F"},{"id":3327,"word":"\u1787\u17B7\u1794"},{"id":3328,"word":"\u1787\u17B7\u179C\u17D2\u17A0\u17B6"},{"id":3329,"word":"\u1787\u17B7\u179C\u17D2\u17A0\u17B6\u1794\u179F\u17B6\u1791"},{"id":3330,"word":"\u1787\u17B7\u17C7"},{"id":3331,"word":"\u1787\u17B8"},{"id":3332,"word":"\u1787\u17B8\u1780"},{"id":3333,"word":"\u1787\u17B8\u1780\u17D2\u179A\u17C2\u1784"},{"id":3334,"word":"\u1787\u17B8\u1784\u1787\u1780\u17CB"},{"id":3335,"word":"\u1787\u17B8\u178A\u17BC\u1793"},{"id":3336,"word":"\u1787\u17B8\u178A\u17BC\u1793\u1798\u17BD\u1799"},{"id":3337,"word":"\u1787\u17B8\u178F\u17B6"},{"id":3338,"word":"\u1787\u17B8\u178F\u17BB\u1793"},{"id":3339,"word":"\u1787\u17B8\u1791\u17BD\u178F"},{"id":3340,"word":"\u1787\u17B8\u1791\u17BD\u178F\u1798\u17BD\u1799"},{"id":3341,"word":"\u1787\u17B8\u1794"},{"id":3342,"word":"\u1787\u17B8\u1794\u17C9\u17B6"},{"id":3343,"word":"\u1787\u17B8\u1796"},{"id":3344,"word":"\u1787\u17B8\u1796\u1785\u179A"},{"id":3345,"word":"\u1787\u17B8\u1796\u17BB\u1780"},{"id":3346,"word":"\u1787\u17B8\u179A"},{"id":3347,"word":"\u1787\u17B8\u179B\u17B6"},{"id":3348,"word":"\u1787\u17B8\u179B\u17BD\u178F"},{"id":3349,"word":"\u1787\u17B8\u179B\u17BD\u178F\u1798\u17BD\u1799"},{"id":3350,"word":"\u1787\u17B8\u179C\u17C8"},{"id":3351,"word":"\u1787\u17B8\u179C\u17CD"},{"id":3352,"word":"\u1787\u17B8\u179C\u1780\u1787\u17B8\u179C\u17B6\u1780"},{"id":3353,"word":"\u1787\u17B8\u179C\u1784\u17D2\u1782\u178F"},{"id":3354,"word":"\u1787\u17B8\u179C\u1787\u17B6\u178F\u17B7"},{"id":3355,"word":"\u1787\u17B8\u179C\u17D0\u1793"},{"id":3356,"word":"\u1787\u17B8\u179C\u1793\u17D2\u178F"},{"id":3357,"word":"\u1787\u17B8\u179C\u1794\u17D2\u1794\u179C\u178F\u17D2\u178F\u17B7"},{"id":3358,"word":"\u1787\u17B8\u179C\u1796\u179B"},{"id":3359,"word":"\u1787\u17B8\u179C\u1797\u17B6\u1796"},{"id":3360,"word":"\u1787\u17B8\u179C\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":3361,"word":"\u1787\u17B8\u179C\u17B6"},{"id":3362,"word":"\u1787\u17B8\u179C\u17B7\u178F"},{"id":3363,"word":"\u1787\u17B8\u179C\u17B7\u178F\u1780\u17D2\u179F\u17D0\u1799"},{"id":3364,"word":"\u1787\u17B8\u179C\u17B7\u178F\u1793\u17D2\u178F\u179A\u17B6\u1799"},{"id":3365,"word":"\u1787\u17B8\u179C\u17B7\u178F\u17B7\u1793\u17D2\u1791\u17D2\u179A\u17B7\u1799"},{"id":3366,"word":"\u1787\u17B8\u179C\u17B7\u1793"},{"id":3367,"word":"\u1787\u17B8\u179C\u17B8"},{"id":3368,"word":"\u1787\u17BB\u1780"},{"id":3369,"word":"\u1787\u17BB\u1785"},{"id":3370,"word":"\u1787\u17BB\u178E\u17D2\u17A0\u1794\u17D0\u1780\u17D2\u1781"},{"id":3371,"word":"\u1787\u17BB\u178F\u17B7\u1798\u1793\u17D2\u178F"},{"id":3372,"word":"\u1787\u179B\u17CB"},{"id":3373,"word":"\u1787\u17BB\u179B\u17B8"},{"id":3374,"word":"\u1787\u17BB\u17C7"},{"id":3375,"word":"\u1787\u17BC\u1787\u1780"},{"id":3376,"word":"\u1787\u17BC\u178F"},{"id":3377,"word":"\u1787\u17BC\u178F\u1780\u1798\u17D2\u1798"},{"id":3378,"word":"\u1787\u17BC\u178F\u1780\u17B6\u179A\u1780\u17CD"},{"id":3379,"word":"\u1787\u17BC\u178F\u1780\u17B6\u179A\u17B8"},{"id":3380,"word":"\u1787\u17BC\u1793"},{"id":3381,"word":"\u1787\u17BC\u179A"},{"id":3382,"word":"\u1787\u17BD"},{"id":3383,"word":"\u1787\u17BD\u1784"},{"id":3384,"word":"\u1787\u17BD\u1789"},{"id":3385,"word":"\u1787\u17BD\u178F"},{"id":3386,"word":"\u1787\u17BD\u1793"},{"id":3387,"word":"\u1787\u17BD\u1793\u1780\u17B6\u179B"},{"id":3388,"word":"\u1787\u17BD\u1793\u178E\u17B6"},{"id":3389,"word":"\u1787\u17BD\u1794"},{"id":3390,"word":"\u1787\u17BD\u1799"},{"id":3391,"word":"\u1787\u17BD\u179A"},{"id":3392,"word":"\u1787\u17BD\u179B"},{"id":3393,"word":"\u1787\u17BD\u179F"},{"id":3394,"word":"\u1787\u17BD\u179F\u1787\u17BB\u179B"},{"id":3395,"word":"\u1787\u17BE!"},{"id":3396,"word":"\u1787\u17BE\u1784"},{"id":3397,"word":"\u1787\u17BE\u1784\u1780\u1789\u17D2\u1787\u17BE"},{"id":3398,"word":"\u1787\u17BE\u1784\u1780\u1789\u17D2\u1787\u17C4"},{"id":3399,"word":"\u1787\u17BE\u1784\u1780\u1789\u17D2\u1787\u17BB\u17C6"},{"id":3400,"word":"\u1787\u17BE\u1784\u1780\u1794"},{"id":3401,"word":"\u1787\u17BE\u1784\u1780\u17B6\u179A"},{"id":3402,"word":"\u1787\u17BE\u1784\u1780\u17BB\u1780"},{"id":3403,"word":"\u1787\u17BE\u1784\u1780\u17C4\u179F"},{"id":3404,"word":"\u1787\u17BE\u1784\u1780\u17D2\u179A\u17B6\u1793"},{"id":3405,"word":"\u1787\u17BE\u1784\u1780\u17D2\u179A\u17B6\u179F"},{"id":3406,"word":"\u1787\u17BE\u1784\u1780\u17D2\u17A2\u17C2\u1780"},{"id":3407,"word":"\u1787\u17BE\u1784\u1781\u17D2\u179B\u17C2\u1784"},{"id":3408,"word":"\u1787\u17BE\u1784\u1782\u1780"},{"id":3409,"word":"\u1787\u17BE\u1784\u1782\u17BB\u179B"},{"id":3410,"word":"\u1787\u17BE\u1784\u1782\u17C4"},{"id":3411,"word":"\u1787\u17BE\u1784\u1782\u17D2\u179A\u17BB\u178C"},{"id":3412,"word":"\u1787\u17BE\u1784\u1782\u17D2\u179A\u17BB\u179F"},{"id":3413,"word":"\u1787\u17BE\u1784\u1785\u17B6\u1794"},{"id":3414,"word":"\u1787\u17BE\u1784\u1785\u17C2\u179C"},{"id":3415,"word":"\u1787\u17BE\u1784\u1786\u17D2\u1780\u17C4\u1780"},{"id":3416,"word":"\u1787\u17BE\u1784\u1787\u1784\u17CB"},{"id":3417,"word":"\u1787\u17BE\u1784\u178F\u17B6\u17C6\u1784"},{"id":3418,"word":"\u1787\u17BE\u1784\u1790\u17D2\u1780\u179A"},{"id":3419,"word":"\u1787\u17BE\u1784\u1791\u17BE\u1793"},{"id":3420,"word":"\u1787\u17BE\u1784\u1791\u17C0\u1793"},{"id":3421,"word":"\u1787\u17BE\u1784\u1791\u17C1\u1789"},{"id":3422,"word":"\u1787\u17BE\u1784\u1791\u17C1\u179A"},{"id":3423,"word":"\u1787\u17BE\u1784\u1791\u17D2\u179A\u1793\u17B6\u1794\u17CB"},{"id":3424,"word":"\u1787\u17BE\u1784\u1794\u17B6\u178F\u17D2\u179A"},{"id":3425,"word":"\u1787\u17BE\u1784\u1796\u17B6\u1793"},{"id":3426,"word":"\u1787\u17BE\u1784\u1796\u17C1\u179B"},{"id":3427,"word":"\u1787\u17BE\u1784\u1796\u17D2\u1793\u17B6\u1799"},{"id":3428,"word":"\u1787\u17BE\u1784\u1796\u17D2\u179A\u17C3"},{"id":3429,"word":"\u1787\u17BE\u1784\u1796\u17D2\u179A\u17C7"},{"id":3430,"word":"\u1787\u17BE\u1784\u1797\u17C1\u179B"},{"id":3431,"word":"\u1787\u17BE\u1784\u1798\u17C9\u17B6"},{"id":3432,"word":"\u1787\u17BE\u1784\u1798\u17B6\u1793\u17CB"},{"id":3433,"word":"\u1787\u17BE\u1784\u1798\u17D2\u178A\u17C2\u1784"},{"id":3434,"word":"\u1787\u17BE\u1784\u179A\u1798\u17B6\u17C6\u1784"},{"id":3435,"word":"\u1787\u17BE\u1784\u179A\u1798\u17B6\u17C6\u1784\u178E\u17C2\u1784\u178E\u1784"},{"id":3436,"word":"\u1787\u17BE\u1784\u179A\u17B6\u179C"},{"id":3437,"word":"\u1787\u17BE\u1784\u179B\u17D0\u1796\u17D2\u1792"},{"id":3438,"word":"\u1787\u17BE\u1784\u179C\u178F\u17D2\u178F"},{"id":3439,"word":"\u1787\u17BE\u1784\u179F\u1780\u17CB"},{"id":3440,"word":"\u1787\u17BE\u1784\u179F\u17B6"},{"id":3441,"word":"\u1787\u17BE\u1784\u179F\u17C1\u17C7"},{"id":3442,"word":"\u1787\u17BE\u1784\u179F\u17D2\u179A\u1798"},{"id":3443,"word":"\u1787\u17BE\u1784\u179F\u17D2\u179A\u17B6\u1796\u1780\u17CD"},{"id":3444,"word":"\u1787\u17BE\u1784\u179F\u17D2\u179A\u17BB\u1780"},{"id":3445,"word":"\u1787\u17BE\u1784\u17A0\u17B6\u179A"},{"id":3446,"word":"\u1787\u17BE\u1784\u17A2\u17B6\u1792\u17B6\u179A"},{"id":3447,"word":"\u1787\u17BE\u1784\u17A7\u1794\u17C4\u179F\u1790\u17CD"},{"id":3448,"word":"\u1787\u17BE\u1784\u17AF\u1780"},{"id":3449,"word":"\u1787\u17BE\u178F"},{"id":3450,"word":"\u1787\u17BE\u1799"},{"id":3451,"word":"\u1787\u17BF"},{"id":3452,"word":"\u1787\u17BF\u1793"},{"id":3453,"word":"\u1787\u17C0\u178F"},{"id":3454,"word":"\u1787\u17C0\u1793"},{"id":3455,"word":"\u1787\u17C0\u1793\u1787\u17BD\u1793"},{"id":3456,"word":"\u1787\u17C0\u1794"},{"id":3457,"word":"\u1787\u17C0\u1794\u1780\u1794\u17D2\u1794\u17B6\u179F"},{"id":3458,"word":"\u1787\u17C0\u179C"},{"id":3459,"word":"\u1787\u17C0\u179F"},{"id":3460,"word":"\u1787\u17C0\u179F\u17D2\u178B\u1787\u17D0\u1799"},{"id":3461,"word":"\u1787\u17C1\u178A\u17D2\u178B\u1798\u17B6\u179F"},{"id":3462,"word":"\u1787\u17C1\u178A\u17D2\u178B\u17B6"},{"id":3463,"word":"\u1787\u17C1\u178F\u1796\u1793"},{"id":3464,"word":"\u1787\u17C1\u178F\u179C\u1793"},{"id":3465,"word":"\u1787\u17C1\u178F\u17BB\u178F\u17D2\u178F\u179A"},{"id":3466,"word":"\u1787\u17C1\u1793"},{"id":3467,"word":"\u1787\u17C1\u179A"},{"id":3468,"word":"\u1787\u17C1\u179F\u17D2\u178B"},{"id":3469,"word":"\u1787\u17C1\u179F\u17D2\u178B\u1787\u17D0\u1799"},{"id":3470,"word":"\u1787\u17C1\u17C7"},{"id":3471,"word":"\u1787\u17C2\u1780"},{"id":3472,"word":"\u1787\u17C2\u1784"},{"id":3473,"word":"\u1787\u17C2\u1784"},{"id":3474,"word":"\u1787\u17C2\u1796\u1796\u17D2\u179A\u17C2"},{"id":3475,"word":"\u1787\u17C2\u17C7"},{"id":3476,"word":"\u1787\u17C4\u1780"},{"id":3477,"word":"\u1787\u17C4\u1782"},{"id":3478,"word":"\u1787\u17C4\u1782\u1787\u17D0\u1799"},{"id":3479,"word":"\u1787\u17C4\u1782\u179C\u17B6\u179F\u1793\u17B6"},{"id":3480,"word":"\u1787\u17C4\u178F\u1780"},{"id":3481,"word":"\u1787\u17C4\u178F\u1793\u17B6\u1780\u17B6\u179A"},{"id":3482,"word":"\u1787\u17C4\u178F\u17B7"},{"id":3483,"word":"\u1787\u17C4\u178F\u17B7\u1780"},{"id":3484,"word":"\u1787\u17C4\u178F\u17B7\u1780\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":3485,"word":"\u1787\u17C4\u178F\u17B7\u1797\u17B6\u1796"},{"id":3486,"word":"\u1787\u17C4\u178F\u17B7\u179A\u179F"},{"id":3487,"word":"\u1787\u17C4\u178F\u17B7\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":3488,"word":"\u1787\u17C4\u179A"},{"id":3489,"word":"\u1787\u17C4\u17C7"},{"id":3490,"word":"\u1787\u17C5"},{"id":3491,"word":"\u1787\u17BB\u17C6"},{"id":3492,"word":"\u1787\u17BB\u17C6\u1780\u1793\u17D2\u179B\u1784\u17CB"},{"id":3493,"word":"\u1787\u17BB\u17C6\u179A\u17BB\u17C6"},{"id":3494,"word":"\u1787\u17C6"},{"id":3495,"word":"\u1787\u17C6\u1784\u17BA"},{"id":3496,"word":"\u1787\u17C6\u1791\u1784\u17CB"},{"id":3497,"word":"\u1787\u17C6\u1791\u1794\u17CB"},{"id":3498,"word":"\u1787\u17C6\u1791\u1799"},{"id":3499,"word":"\u1787\u17C6\u1791\u17B6\u1789"},{"id":3500,"word":"\u1787\u17C6\u1791\u17B6\u179C"},{"id":3501,"word":"\u1787\u17C6\u1791\u17B6\u179F\u17CB"},{"id":3502,"word":"\u1787\u17C6\u1791\u17BD\u1799"},{"id":3503,"word":"\u1787\u17C6\u1791\u17BE\u179A"},{"id":3504,"word":"\u1787\u17C6\u1791\u17BE\u179F"},{"id":3505,"word":"\u1787\u17C6\u1791\u17C2\u1784"},{"id":3506,"word":"\u1787\u17C6\u1791\u17B6\u17C6\u1784"},{"id":3507,"word":"\u1787\u17C6\u1793\u1793\u17CB"},{"id":3508,"word":"\u1787\u17C6\u1793\u17B6"},{"id":3509,"word":"\u1787\u17C6\u1793\u17B6\u1784"},{"id":3510,"word":"\u1787\u17C6\u1793\u17B6\u1789"},{"id":3511,"word":"\u1787\u17C6\u1793\u17B6\u1789\u1787\u17B6\u1789\u1787\u17D0\u1799"},{"id":3512,"word":"\u1787\u17C6\u1793\u17B6\u1793\u17CB"},{"id":3513,"word":"\u1787\u17C6\u1793\u17B6\u1793\u17B8\u179F"},{"id":3514,"word":"\u1787\u17C6\u1793\u17B6\u1794\u17CB"},{"id":3515,"word":"\u1787\u17C6\u1793\u17B7\u178F"},{"id":3516,"word":"\u1787\u17C6\u1793\u17B7\u17C7"},{"id":3517,"word":"\u1787\u17C6\u1793\u17B8\u1780"},{"id":3518,"word":"\u1787\u17C6\u1793\u17BC\u1793"},{"id":3519,"word":"\u1787\u17C6\u1793\u17BD\u1789"},{"id":3520,"word":"\u1787\u17C6\u1793\u17BD\u1794"},{"id":3521,"word":"\u1787\u17C6\u1793\u17BD\u1799"},{"id":3522,"word":"\u1787\u17C6\u1793\u17BD\u179F"},{"id":3523,"word":"\u1787\u17C6\u1793\u17BF"},{"id":3524,"word":"\u1787\u17C6\u1793\u17BF\u1793"},{"id":3525,"word":"\u1787\u17C6\u1793\u17C4\u179A"},{"id":3526,"word":"\u1787\u17C6\u1793\u17BB\u17C6"},{"id":3527,"word":"\u1787\u17C6\u1793\u17C6"},{"id":3528,"word":"\u1787\u17C6\u1794\u17BD\u179A"},{"id":3529,"word":"\u1787\u17C6\u1796\u1794\u17CB"},{"id":3530,"word":"\u1787\u17C6\u1796\u17B6\u1780\u17CB"},{"id":3531,"word":"\u1787\u17C6\u1796\u17BC\u1780"},{"id":3532,"word":"\u1787\u17C6\u179A\u178F\u17CB"},{"id":3533,"word":"\u1787\u17C6\u179A\u17B7\u178F"},{"id":3534,"word":"\u1787\u17C6\u179A\u17BB\u1789"},{"id":3535,"word":"\u1787\u17C6\u179A\u17BF\u1793"},{"id":3536,"word":"\u1787\u17C6\u179A\u17C6"},{"id":3537,"word":"\u1787\u17C6\u179B\u17B6\u1794"},{"id":3538,"word":"\u1787\u17C6\u17A0\u1794\u17CB"},{"id":3539,"word":"\u1787\u17C6\u17A0\u1798"},{"id":3540,"word":"\u1787\u17C6\u17A0\u179A"},{"id":3541,"word":"\u1787\u17C6\u17A0\u17B6\u1789"},{"id":3542,"word":"\u1787\u17C6\u17A0\u17B6\u1793"},{"id":3543,"word":"\u1787\u17C6\u17A0\u17BC\u179F"},{"id":3544,"word":"\u1787\u17C6\u17A0\u17C4\u1784"},{"id":3545,"word":"\u1787\u17C6\u17A0\u17C5"},{"id":3546,"word":"\u1787\u17B6\u17C6"},{"id":3547,"word":"\u1787\u17C7"},{"id":3548,"word":"\u1787\u17D2\u179A\u1780"},{"id":3549,"word":"\u1787\u17D2\u179A\u1780\u1798\u1798\u1780"},{"id":3550,"word":"\u1787\u17D2\u179A\u1780\u17CB"},{"id":3551,"word":"\u1787\u17D2\u179A\u1784"},{"id":3552,"word":"\u1787\u17D2\u179A\u1784\u17CB"},{"id":3553,"word":"\u1787\u17D2\u179A\u1784\u1780\u17CB"},{"id":3554,"word":"\u1787\u17D2\u179A\u1784\u17C4"},{"id":3555,"word":"\u1787\u17D2\u179A\u1784\u17C6"},{"id":3556,"word":"\u1787\u17D2\u179A\u1789\u17CB"},{"id":3557,"word":"\u1787\u17D2\u179A\u1793\u1784\u17CB"},{"id":3558,"word":"\u1787\u17D2\u179A\u1793\u17B8\u1780"},{"id":3559,"word":"\u1787\u17D2\u179A\u1793\u17BD\u1785"},{"id":3560,"word":"\u1787\u17D2\u179A\u1793\u17C0\u1784"},{"id":3561,"word":"\u1787\u17D2\u179A\u1794"},{"id":3562,"word":"\u1787\u17D2\u179A\u1794\u17CB"},{"id":3563,"word":"\u1787\u17D2\u179A\u1798\u17B8\u179F"},{"id":3564,"word":"\u1787\u17D2\u179A\u1798\u17BB\u1787"},{"id":3565,"word":"\u1787\u17D2\u179A\u1798\u17BC\u179F"},{"id":3566,"word":"\u1787\u17D2\u179A\u179B\u1780\u17CB"},{"id":3567,"word":"\u1787\u17D2\u179A\u179B\u1784"},{"id":3568,"word":"\u1787\u17D2\u179A\u179B\u1798"},{"id":3569,"word":"\u1787\u17D2\u179A\u179B\u17B7\u17C7"},{"id":3570,"word":"\u1787\u17D2\u179A\u179B\u17BD\u179F"},{"id":3571,"word":"\u1787\u17D2\u179A\u179B\u17C2\u1784"},{"id":3572,"word":"\u1787\u17D2\u179A\u17A0\u1798"},{"id":3573,"word":"\u1787\u17D2\u179A\u17A0\u17B7\u178F\u1787\u17D2\u179A\u17A0\u1798"},{"id":3574,"word":"\u1787\u17D2\u179A\u17B6\u1780"},{"id":3575,"word":"\u1787\u17D2\u179A\u17B6\u1794"},{"id":3576,"word":"\u1787\u17D2\u179A\u17B6\u1798"},{"id":3577,"word":"\u1787\u17D2\u179A\u17B6\u1799"},{"id":3578,"word":"\u1787\u17D2\u179A\u17B6\u179B"},{"id":3579,"word":"\u1787\u17D2\u179A\u17B6\u179C"},{"id":3580,"word":"\u1787\u17D2\u179A\u17B6\u179F"},{"id":3581,"word":"\u1787\u17D2\u179A\u17B7\u17C7"},{"id":3582,"word":"\u1787\u17D2\u179A\u17B8\u179C"},{"id":3583,"word":"\u1787\u17D2\u179A\u17B9\u1784"},{"id":3584,"word":"\u1787\u17D2\u179A\u17BB\u1784"},{"id":3585,"word":"\u1787\u17D2\u179A\u17BB\u179B"},{"id":3586,"word":"\u1787\u17D2\u179A\u17BB\u17C7"},{"id":3587,"word":"\u1787\u17D2\u179A\u17BC\u1780"},{"id":3588,"word":"\u1787\u17D2\u179A\u17BC\u1780\u178F\u17D2\u179A\u17B9\u1794"},{"id":3589,"word":"\u1787\u17D2\u179A\u17BC\u1780\u1796\u17D2\u179A\u17BB\u179B"},{"id":3590,"word":"\u1787\u17D2\u179A\u17BD\u1780"},{"id":3591,"word":"\u1787\u17D2\u179A\u17BD\u1789"},{"id":3592,"word":"\u1787\u17D2\u179A\u17BD\u178F"},{"id":3593,"word":"\u1787\u17D2\u179A\u17BD\u1799"},{"id":3594,"word":"\u1787\u17D2\u179A\u17BD\u179B"},{"id":3595,"word":"\u1787\u17D2\u179A\u17BD\u179F"},{"id":3596,"word":"\u1787\u17D2\u179A\u17BE\u1798"},{"id":3597,"word":"\u1787\u17D2\u179A\u17BE\u179F"},{"id":3598,"word":"\u1787\u17D2\u179A\u17C0\u1784"},{"id":3599,"word":"\u1787\u17D2\u179A\u17C0\u178F"},{"id":3600,"word":"\u1787\u17D2\u179A\u17C1"},{"id":3601,"word":"\u1787\u17D2\u179A\u17C1\u1789"},{"id":3602,"word":"\u1787\u17D2\u179A\u17C2"},{"id":3603,"word":"\u1787\u17D2\u179A\u17C2\u1780"},{"id":3604,"word":"\u1787\u17D2\u179A\u17C2\u1784"},{"id":3605,"word":"\u1787\u17D2\u179A\u17C2\u17C7"},{"id":3606,"word":"\u1787\u17D2\u179A\u17C3"},{"id":3607,"word":"\u1787\u17D2\u179A\u17C4"},{"id":3608,"word":"\u1787\u17D2\u179A\u17C4\u1780"},{"id":3609,"word":"\u1787\u17D2\u179A\u17C4\u1784"},{"id":3610,"word":"\u1787\u17D2\u179A\u17C4\u1798\u1787\u17D2\u179A\u17C2\u1784"},{"id":3611,"word":"\u1787\u17D2\u179A\u17C4\u1799"},{"id":3612,"word":"\u1787\u17D2\u179A\u17C4\u17C7"},{"id":3613,"word":"\u1787\u17D2\u179A\u17C5"},{"id":3614,"word":"\u1787\u17D2\u179A\u17C6"},{"id":3615,"word":"\u1787\u17D2\u179A\u17B6\u17C6"},{"id":3616,"word":"\u1787\u17D2\u179A\u17B6\u17C6\u1784"},{"id":3617,"word":"\u1787\u17D2\u179A\u17C7"},{"id":3618,"word":"\u1787\u17D2\u179C\u17B6"},{"id":3619,"word":"\u1787\u17D2\u179C\u17B6\u179B\u17B6"},{"id":3620,"word":"\u1787\u1798\u17D2\u179A\u17BD\u1789"},{"id":3621,"word":"\u1787\u1798\u17D2\u179A\u17C1\u1789"},{"id":3622,"word":"\u1787\u1798\u17D2\u179A\u17C4\u1784"},{"id":3623,"word":"\u1787\u17C6\u1793\u1780\u17CB"},{"id":3624,"word":"\u1787\u17C6\u1793\u1784\u17CB"},{"id":3625,"word":"\u1787\u17C6\u1793\u1785\u17CB"},{"id":3626,"word":"\u1787\u17C6\u1793\u17B6\u1784\u1795\u17D2\u1791\u17C7"},{"id":3627,"word":"\u1787\u17C6\u1793\u17B6\u178F\u17CB"},{"id":3628,"word":"\u1787\u17C6\u1793\u17B6\u179C"},{"id":3629,"word":"\u1787\u17C6\u1793\u17B8\u1794"},{"id":3630,"word":"\u1787\u17C6\u1793\u17BC\u178F"},{"id":3631,"word":"\u1787\u17C6\u1793\u17BD\u179B"},{"id":3632,"word":"\u1787\u17C6\u1793\u17C1\u179A"},{"id":3633,"word":"\u1787\u17C6\u1793\u17C2\u1784"},{"id":3634,"word":"\u1787\u17C6\u1793\u17C4\u17C7"},{"id":3635,"word":"\u1788"},{"id":3636,"word":"\u1788\u1794!"},{"id":3637,"word":"\u1788\u1794\u17CB"},{"id":3638,"word":"\u1788\u1798"},{"id":3639,"word":"\u1788\u179A"},{"id":3640,"word":"\u1788\u17B6\u1793"},{"id":3641,"word":"\u1788\u17B6\u1793--"},{"id":3642,"word":"\u1788\u17B6\u1794\u1793\u1780\u17B7\u1785\u17D2\u1785"},{"id":3643,"word":"\u1788\u17B6\u1794\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":3644,"word":"\u1788\u17B6\u1798"},{"id":3645,"word":"\u1788\u17B6\u179C"},{"id":3646,"word":"\u1788\u17B7\u1784"},{"id":3647,"word":"\u1788\u17B9\u1784"},{"id":3648,"word":"\u1788\u17B9\u1794"},{"id":3649,"word":"\u1788\u17BA"},{"id":3650,"word":"\u1788\u17BA\u1786\u17D2\u17A2\u17B6\u179B"},{"id":3651,"word":"\u1788\u17BB\u178F"},{"id":3652,"word":"\u1788\u17BC"},{"id":3653,"word":"\u1788\u17BC\u1780"},{"id":3654,"word":"\u1788\u17BC\u1784"},{"id":3655,"word":"\u1788\u17BC\u1785"},{"id":3656,"word":"\u1788\u17BC\u1786\u179A"},{"id":3657,"word":"\u1788\u17BC\u1788\u17B8"},{"id":3658,"word":"\u1788\u17BC\u179F"},{"id":3659,"word":"\u1788\u17BE"},{"id":3660,"word":"\u1788\u17BE\u1780\u1784\u17CB"},{"id":3661,"word":"\u1788\u17BE\u1780\u17BC\u178F"},{"id":3662,"word":"\u1788\u17BE\u1780\u17C2\u179C"},{"id":3663,"word":"\u1788\u17BE\u1781\u17D2\u1798\u17C5"},{"id":3664,"word":"\u1788\u17BE\u1782\u17BC\u179F"},{"id":3665,"word":"\u1788\u17BE\u1785\u17B6\u1780\u17CB\u1792\u17D2\u1798\u17C1\u1789"},{"id":3666,"word":"\u1788\u17BE\u1785\u17D2\u179A\u178F\u17CB"},{"id":3667,"word":"\u1788\u17BE\u1785\u17D2\u179A\u17B6\u1793"},{"id":3668,"word":"\u1788\u17BE\u1787\u17D2\u179A\u17C2\u1784"},{"id":3669,"word":"\u1788\u17BE\u1788\u17D2\u1793\u17B6\u1793\u17CB"},{"id":3670,"word":"\u1788\u17BE\u178F\u17D2\u179A\u1784\u17CB"},{"id":3671,"word":"\u1788\u17BE\u1791\u17B6\u179B"},{"id":3672,"word":"\u1788\u17BE\u1791\u17B6\u179B\u178F\u17D2\u179A\u17B6\u1789\u17CB"},{"id":3673,"word":"\u1788\u17BE\u1794\u17BB\u1780"},{"id":3674,"word":"\u1788\u17BE\u1795\u17D2\u178A\u17C1\u1780"},{"id":3675,"word":"\u1788\u17BE\u1797\u17D2\u179B\u17BE\u1784"},{"id":3676,"word":"\u1788\u17BE\u179A\u17B6"},{"id":3677,"word":"\u1788\u17BE\u179A\u17B9\u178F"},{"id":3678,"word":"\u1788\u17BE\u179F\u17BC\u179B"},{"id":3679,"word":"\u1788\u17BE\u179F\u17D2\u178A\u17B9\u1784"},{"id":3680,"word":"\u1788\u17BE\u179F\u17D2\u1791\u1793\u17CB"},{"id":3681,"word":"\u1788\u17BE\u179F\u17D2\u179A\u17BD\u1785"},{"id":3682,"word":"\u1788\u17BE\u17A0\u17BB\u1794"},{"id":3683,"word":"\u1788\u17BE\u17A2\u178E\u17D2\u178A\u17C4\u178F"},{"id":3684,"word":"\u1788\u17BE\u17A2\u1793\u17D2\u1791\u1784"},{"id":3685,"word":"\u1788\u17BE\u17A2\u17C2\u1798"},{"id":3686,"word":"\u1788\u17C2\u179B"},{"id":3687,"word":"\u1788\u17C4\u1784"},{"id":3688,"word":"\u1788\u17D2\u1784\u1794\u17CB"},{"id":3689,"word":"\u1788\u17D2\u1784\u1794\u17CB\u1788\u17D2\u1784\u17BB\u1799"},{"id":3690,"word":"\u1788\u17D2\u1784\u17BB\u1799"},{"id":3691,"word":"\u1788\u17D2\u1784\u17C0\u1798"},{"id":3692,"word":"\u1788\u17D2\u1784\u17C4\u1780"},{"id":3693,"word":"\u1788\u17D2\u1793\u1780\u17CB"},{"id":3694,"word":"\u1788\u17D2\u1793\u17B6\u1784"},{"id":3695,"word":"\u1788\u17D2\u1793\u17B6\u1793\u17CB"},{"id":3696,"word":"\u1788\u17D2\u1793\u17B6\u1793\u17B8\u179F"},{"id":3697,"word":"\u1788\u17D2\u1793\u17BB\u179B"},{"id":3698,"word":"\u1788\u17D2\u1793\u17BB\u179B\u178F\u1784\u17D2\u1780\u179A"},{"id":3699,"word":"\u1788\u17D2\u1793\u17BD\u178F"},{"id":3700,"word":"\u1788\u17D2\u1793\u17BD\u179B"},{"id":3701,"word":"\u1788\u17D2\u1793\u17C0\u1784"},{"id":3702,"word":"\u1788\u17D2\u1793\u17C7"},{"id":3703,"word":"\u1788\u17D2\u1793\u17C7\u1788\u17D2\u1793\u17B6\u1793"},{"id":3704,"word":"\u1788\u17D2\u1798\u1784"},{"id":3705,"word":"\u1788\u17D2\u1798\u17BB\u179B"},{"id":3706,"word":"\u1788\u17D2\u1798\u17BB\u179F"},{"id":3707,"word":"\u1788\u17D2\u1798\u17BB\u179F\u1791\u17C1\u179F"},{"id":3708,"word":"\u1788\u17D2\u1798\u17BD\u1789"},{"id":3709,"word":"\u1788\u17D2\u1798\u17BD\u1799"},{"id":3710,"word":"\u1788\u17D2\u1798\u17C0\u178F"},{"id":3711,"word":"\u1788\u17D2\u1798\u17C2"},{"id":3712,"word":"\u1788\u17D2\u1798\u17C4\u179B"},{"id":3713,"word":"\u1788\u17D2\u1798\u17C4\u17C7"},{"id":3714,"word":"\u1788\u17D2\u179B\u1780\u17CB"},{"id":3715,"word":"\u1788\u17D2\u179B\u1794"},{"id":3716,"word":"\u1788\u17D2\u179B\u1794\u17CB"},{"id":3717,"word":"\u1788\u17D2\u179B\u1798"},{"id":3718,"word":"\u1788\u17D2\u179B\u17B6\u1793\u1796\u17B6\u1793"},{"id":3719,"word":"\u1788\u17D2\u179B\u17B6\u179F"},{"id":3720,"word":"\u1788\u17D2\u179B\u17B8"},{"id":3721,"word":"\u1788\u17D2\u179B\u17B8\u1780"},{"id":3722,"word":"\u1788\u17D2\u179B\u17BC\u179F"},{"id":3723,"word":"\u1788\u17D2\u179B\u17BE\u1784"},{"id":3724,"word":"\u1788\u17D2\u179B\u17BE\u1799"},{"id":3725,"word":"\u1788\u17D2\u179B\u17C0\u179F"},{"id":3726,"word":"\u1788\u17D2\u179B\u17C1\u1785"},{"id":3727,"word":"\u1788\u17D2\u179B\u17C1\u1798"},{"id":3728,"word":"\u1788\u17D2\u179B\u17C2\u1798"},{"id":3729,"word":"\u1788\u17D2\u179B\u17C4\u17C7"},{"id":3730,"word":"\u1788\u17D2\u179C\u17B6\u178F"},{"id":3731,"word":"\u1788\u17D2\u179C\u17C1\u1784"},{"id":3732,"word":"\u1788\u17D2\u179C\u17C1\u1784\u1799\u179B\u17CB"},{"id":3733,"word":"\u1788\u17D2\u179C\u17B6\u17C6\u1784"},{"id":3734,"word":"\u1788\u17D2\u1793\u17BD\u178F"},{"id":3735,"word":"\u1789"},{"id":3736,"word":"\u1789\u1780"},{"id":3737,"word":"\u1789\u1780\u17CB"},{"id":3738,"word":"\u1789\u1785\u17CB"},{"id":3739,"word":"\u1789\u1789\u17D0\u179A"},{"id":3740,"word":"\u1789\u1789\u17B6\u1780\u17CB"},{"id":3741,"word":"\u1789\u1789\u17B7\u1798"},{"id":3742,"word":"\u1789\u1789\u17B8"},{"id":3743,"word":"\u1789\u1789\u17BD\u179A"},{"id":3744,"word":"\u1789\u1789\u17BE\u178F"},{"id":3745,"word":"\u1789\u1789\u17BE\u1798"},{"id":3746,"word":"\u1789\u1789\u17C2\u1798"},{"id":3747,"word":"\u1789\u1789\u17C4\u1785"},{"id":3748,"word":"\u1789\u178F\u17D2\u178F\u17B7"},{"id":3749,"word":"\u1789\u178F\u17D2\u178F\u17B7\u1780\u1798\u17D2\u1798"},{"id":3750,"word":"\u1789\u178F\u17D2\u178F\u17B7\u1785\u178F\u17BB\u178F\u17D2\u1790\u1780\u1798\u17D2\u1798"},{"id":3751,"word":"\u1789\u178F\u17D2\u178F\u17B7\u1791\u17BB\u178F\u17B7\u1799\u1780\u1798\u17D2\u1798"},{"id":3752,"word":"\u1789\u1793"},{"id":3753,"word":"\u1789\u1794\u17D7"},{"id":3754,"word":"\u1789\u17C9\u1798"},{"id":3755,"word":"\u1789\u1799"},{"id":3756,"word":"\u1789\u17D0\u179A"},{"id":3757,"word":"\u1789\u179B\u17CB"},{"id":3758,"word":"\u1789\u17B6\u1780\u17CB"},{"id":3759,"word":"\u1789\u17C9\u17B6\u1780"},{"id":3760,"word":"\u1789\u17C9\u17B6\u1785\u17CB!"},{"id":3761,"word":"\u1789\u17B6\u178E"},{"id":3762,"word":"\u1789\u17B6\u178E--"},{"id":3763,"word":"\u1789\u17B6\u178E\u17B8"},{"id":3764,"word":"\u1789\u17B6\u178F\u17CB"},{"id":3765,"word":"\u1789\u17B6\u178F\u1780\u17B6"},{"id":3766,"word":"\u1789\u17B6\u178F\u179F\u17D2\u1794\u17B6\u178F"},{"id":3767,"word":"\u1789\u17B6\u178F\u17B6"},{"id":3768,"word":"\u1789\u17B6\u178F\u17B7"},{"id":3769,"word":"\u1789\u17B6\u178F\u17B7--"},{"id":3770,"word":"\u1789\u17B6\u1794\u17CB"},{"id":3771,"word":"\u1789\u17C9\u17B6\u1794"},{"id":3772,"word":"\u1789\u17C9\u17B6\u1798"},{"id":3773,"word":"\u1789\u17B6\u179F\u17CB"},{"id":3774,"word":"\u1789\u17C9\u17B7\u1780\u1789\u17C9\u1780\u17CB"},{"id":3775,"word":"\u1789\u17C9\u17B7\u1789\u1789\u17C9\u17BB\u1789"},{"id":3776,"word":"\u1789\u17C9\u17B7\u1798"},{"id":3777,"word":"\u1789\u17C9\u17B7\u179B"},{"id":3778,"word":"\u1789\u17B8"},{"id":3779,"word":"\u1789\u17B8\u1789\u1789\u17BC\u1789"},{"id":3780,"word":"\u1789\u17B9\u1780"},{"id":3781,"word":"\u1789\u17B9\u1780\u17D7"},{"id":3782,"word":"\u1789\u17C9\u17B9\u1784"},{"id":3783,"word":"\u1789\u17B9\u1793"},{"id":3784,"word":"\u1789\u17C9\u17B9\u1798"},{"id":3785,"word":"\u1789\u17C9\u17BB\u1789"},{"id":3786,"word":"\u1789\u17C9\u17BB\u1798\u17D7"},{"id":3787,"word":"\u1789\u17BB\u17C7"},{"id":3788,"word":"\u1789\u17BB\u17C7\u1789\u1784\u17CB"},{"id":3789,"word":"\u1789\u17BC\u1789"},{"id":3790,"word":"\u1789\u17C9\u17BC\u1789\u1789\u17C9\u17B6\u1789"},{"id":3791,"word":"\u1789\u17C9\u17BE\u1780"},{"id":3792,"word":"\u1789\u17BE\u1789"},{"id":3793,"word":"\u1789\u17BE\u1794\u17D7"},{"id":3794,"word":"\u1789\u17BE\u179F"},{"id":3795,"word":"\u1789\u17C0\u1785"},{"id":3796,"word":"\u1789\u17C0\u178F"},{"id":3797,"word":"\u1789\u17C0\u178F\u179F\u17D2\u1794\u17B6\u178F"},{"id":3798,"word":"\u1789\u17C0\u1793"},{"id":3799,"word":"\u1789\u17C1\u1789"},{"id":3800,"word":"\u1789\u17C1\u1785"},{"id":3801,"word":"\u1789\u17C9\u17C1\u1785\u1789\u17C9\u17B6\u1785"},{"id":3802,"word":"\u1789\u17C9\u17C1\u1785\u1789\u17C9\u17BC\u1785"},{"id":3803,"word":"\u1789\u17C9\u17C1\u1794\u17D7"},{"id":3804,"word":"\u1789\u17C1\u1799\u17D2\u1799\u1792\u1798\u17D2\u1798"},{"id":3805,"word":"\u1789\u17C9\u17C1\u179C"},{"id":3806,"word":"\u1789\u17C9\u17C1\u179C\u1789\u17C9\u17B6\u179C"},{"id":3807,"word":"\u1789\u17C9\u17C1\u17C7\u1789\u17C9\u17C4\u17C7"},{"id":3808,"word":"\u1789\u17C9\u17C2"},{"id":3809,"word":"\u1789\u17C2\u1780"},{"id":3810,"word":"\u1789\u17C9\u17C2\u1780\u1789\u17C9\u1780"},{"id":3811,"word":"\u1789\u17C9\u17C2\u1784"},{"id":3812,"word":"\u1789\u17C9\u17C2\u1784\u1789\u17C9\u1784"},{"id":3813,"word":"\u1789\u17C9\u17C2\u1798\u17D7!"},{"id":3814,"word":"\u1789\u17C9\u17C4\u1784"},{"id":3815,"word":"\u1789\u17C4\u1785"},{"id":3816,"word":"\u1789\u17C4\u1798"},{"id":3817,"word":"\u1789\u17C4\u1798\u179C\u178F\u17D2\u178F"},{"id":3818,"word":"\u1789\u17C4\u179F"},{"id":3819,"word":"\u1789\u17C4\u17C7"},{"id":3820,"word":"\u1789\u17C6\u17D7"},{"id":3821,"word":"\u1789\u17B6\u17C6"},{"id":3822,"word":"\u1789\u17C9\u17B6\u17C6"},{"id":3823,"word":"\u1789\u17C9\u17B6\u17C6\u1784"},{"id":3824,"word":"\u1789\u17C9\u17B6\u17C6\u1784\u17D7"},{"id":3825,"word":"\u1789\u17C9\u17B6\u17C6\u1789\u17C9\u17BE"},{"id":3826,"word":"\u178A"},{"id":3827,"word":"\u178A\u17CF"},{"id":3828,"word":"\u178A\u1780"},{"id":3829,"word":"\u178A\u1780\u1781\u17B7\u1798"},{"id":3830,"word":"\u178A\u1780\u1782\u17B6\u17C6"},{"id":3831,"word":"\u178A\u1780\u1785\u1793\u17D2\u1791\u1793\u17CD"},{"id":3832,"word":"\u178A\u1780\u1791\u1784"},{"id":3833,"word":"\u178A\u1780\u1796"},{"id":3834,"word":"\u178A\u1780\u1796\u17B6\u1799"},{"id":3835,"word":"\u178A\u1780\u1798\u17C9\u17C3"},{"id":3836,"word":"\u178A\u1780\u17CB"},{"id":3837,"word":"\u178A\u1780\u17CB\u178A\u17BF"},{"id":3838,"word":"\u178A\u1784"},{"id":3839,"word":"\u178A\u1784\u1780\u1789\u17D2\u1785\u17B6\u1798"},{"id":3840,"word":"\u178A\u1784\u1780\u1793\u17D2\u1791\u17BB\u1799"},{"id":3841,"word":"\u178A\u1784\u1780\u17B6\u17C6\u1794\u17B7\u178F"},{"id":3842,"word":"\u178A\u1784\u1780\u17D2\u178A\u17B6\u179A"},{"id":3843,"word":"\u178A\u1784\u1781\u17D2\u1791\u17C2\u1784"},{"id":3844,"word":"\u178A\u1784\u1782\u17C4\u1798"},{"id":3845,"word":"\u178A\u1784\u178A\u17B9\u1784"},{"id":3846,"word":"\u178A\u1784\u178A\u17C4\u1799"},{"id":3847,"word":"\u178A\u1784\u178E\u17C4\u17C7"},{"id":3848,"word":"\u178A\u1784\u1794\u1784\u17D2\u17A0\u17BD\u179A"},{"id":3849,"word":"\u178A\u1784\u1796\u17D2\u179A\u17C3"},{"id":3850,"word":"\u178A\u1784\u1797\u17D2\u1793\u17C6"},{"id":3851,"word":"\u178A\u1784\u179A\u17C2\u1780"},{"id":3852,"word":"\u178A\u1784\u179F\u17D2\u1791\u17B9\u1784"},{"id":3853,"word":"\u178A\u1784\u17D2\u1780\u17B6\u1794\u17CB"},{"id":3854,"word":"\u178A\u1784\u17D2\u1780\u17B6\u179C"},{"id":3855,"word":"\u178A\u1784\u17D2\u1780\u17BC\u179C"},{"id":3856,"word":"\u178A\u1784\u17D2\u1780\u17C2"},{"id":3857,"word":"\u178A\u1784\u17D2\u1780\u17C4"},{"id":3858,"word":"\u178A\u1784\u17D2\u1780\u17C4\u1781\u17D2\u1798\u17C4\u1785"},{"id":3859,"word":"\u178A\u1784\u17D2\u1781\u17C5"},{"id":3860,"word":"\u178A\u1784\u17D2\u1782\u178F\u17CB"},{"id":3861,"word":"\u178A\u1784\u17D2\u1782\u1793\u17CB"},{"id":3862,"word":"\u178A\u1784\u17D2\u1782\u17C4\u179B"},{"id":3863,"word":"\u178A\u1784\u17D2\u1782\u17BB\u17C6"},{"id":3864,"word":"\u178A\u1784\u17D2\u179C\u17B7\u1793"},{"id":3865,"word":"\u178A\u1784\u17D2\u17A0\u1780\u17CB"},{"id":3866,"word":"\u178A\u1784\u17D2\u17A0\u17B6\u1780\u17CB"},{"id":3867,"word":"\u178A\u1784\u17D2\u17A0\u17B7\u178F"},{"id":3868,"word":"\u178A\u1784\u17D2\u17A0\u17BE\u1798"},{"id":3869,"word":"\u178A\u1784\u17D2\u17A0\u17C2"},{"id":3870,"word":"\u178A\u1784\u17D2\u17A0\u17C4\u1799"},{"id":3871,"word":"\u178A\u178A\u17BB\u179F"},{"id":3872,"word":"\u178A\u178A\u17C2\u179B"},{"id":3873,"word":"\u178A\u178E\u17D2\u178A\u1794\u17CB"},{"id":3874,"word":"\u178A\u178E\u17D2\u178A\u17B9\u1784"},{"id":3875,"word":"\u178A\u178E\u17D2\u178A\u17BE\u1798"},{"id":3876,"word":"\u178A\u178E\u17D2\u178A\u17B6\u17C6"},{"id":3877,"word":"\u178A\u1791\u17C3"},{"id":3878,"word":"\u178A\u1793\u17D2\u179B\u1784"},{"id":3879,"word":"\u178A\u1793\u17D2\u179B\u17B6\u1794\u17CB"},{"id":3880,"word":"\u178A\u1794"},{"id":3881,"word":"\u178A\u1794\u1791\u17C0\u1798"},{"id":3882,"word":"\u178A\u1794\u17CB"},{"id":3883,"word":"\u178A\u1798"},{"id":3884,"word":"\u178A\u179A"},{"id":3885,"word":"\u178A\u179A\u1792\u179A"},{"id":3886,"word":"\u178A\u17B6\u179A\u17B6\u1794"},{"id":3887,"word":"\u178A\u179B\u17CB"},{"id":3888,"word":"\u178A\u179B\u17C4\u1780"},{"id":3889,"word":"\u178A\u17CF\u17A0\u17BE\u1799"},{"id":3890,"word":"\u178A\u17CF\u17A1\u17BB\u1784"},{"id":3891,"word":"\u178A\u17B6"},{"id":3892,"word":"\u178A\u17B6\u1780\u17CB"},{"id":3893,"word":"\u178A\u17B6\u1784"},{"id":3894,"word":"\u178A\u17B6\u1785"},{"id":3895,"word":"\u178A\u17B6\u1785\u17CB"},{"id":3896,"word":"\u178A\u17B6\u1793"},{"id":3897,"word":"\u178A\u17B6\u1794"},{"id":3898,"word":"\u178A\u17B6\u1794\u17CB"},{"id":3899,"word":"\u178A\u17B6\u1798"},{"id":3900,"word":"\u178A\u17B6\u1799"},{"id":3901,"word":"\u178A\u17B6\u179A"},{"id":3902,"word":"\u178A\u17B6\u179B"},{"id":3903,"word":"\u178A\u17B6\u179B\u179C\u17C9\u17B6\u179B"},{"id":3904,"word":"\u178A\u17B6\u179B\u17CB"},{"id":3905,"word":"\u178A\u17B6\u179B\u17CB\u17A2\u17C6\u1794\u17BB\u1780"},{"id":3906,"word":"\u178A\u17B6\u179C"},{"id":3907,"word":"\u178A\u17B6\u179F"},{"id":3908,"word":"\u178A\u17B6\u179F\u17CB"},{"id":3909,"word":"\u178A\u17B6\u179F\u17CB\u178A\u17C2"},{"id":3910,"word":"\u178A\u17B6\u179F\u17CB\u178F\u17BF\u1793"},{"id":3911,"word":"\u178A\u17B6\u179F\u17CB\u1791\u17C6"},{"id":3912,"word":"\u178A\u17B7\u178F"},{"id":3913,"word":"\u178A\u17B8\u1780\u17B6"},{"id":3914,"word":"\u178A\u17B8\u1781\u17D2\u1798\u17C5"},{"id":3915,"word":"\u178A\u17B8\u1794\u17D2\u179B\u17B8"},{"id":3916,"word":"\u178A\u17B8\u179B\u17C2\u1784"},{"id":3917,"word":"\u178A\u17B8\u179F"},{"id":3918,"word":"\u178A\u17B8\u179F\u17D2\u17A2\u17B7\u178F"},{"id":3919,"word":"\u178A\u17B9\u1780"},{"id":3920,"word":"\u178A\u17B9\u1780\u178A\u17BF"},{"id":3921,"word":"\u178A\u17B9\u1780\u178A\u17C0\u179C"},{"id":3922,"word":"\u178A\u17B9\u1780\u1793\u17B6\u17C6"},{"id":3923,"word":"\u178A\u17B9\u1784"},{"id":3924,"word":"\u178A\u17B9\u1784\u1780\u17D2\u178A\u17B8"},{"id":3925,"word":"\u178A\u17B9\u1794"},{"id":3926,"word":"\u178A\u17B9\u179F"},{"id":3927,"word":"\u178A\u17B8"},{"id":3928,"word":"\u178A\u17BB\u1780\u178A\u17B6\u1793\u17CB"},{"id":3929,"word":"\u178A\u17BB\u178F"},{"id":3930,"word":"\u178A\u17BB\u1793"},{"id":3931,"word":"\u178A\u17BB\u1793!"},{"id":3932,"word":"\u178A\u17BB\u1794"},{"id":3933,"word":"\u178A\u17BB\u1794\u17D7"},{"id":3934,"word":"\u178A\u17BB\u179B"},{"id":3935,"word":"\u178A\u17BB\u179B\u17D2\u179B\u17B6\u179A"},{"id":3936,"word":"\u178A\u17BB\u179F"},{"id":3937,"word":"\u178A\u17BB\u17C7"},{"id":3938,"word":"\u178A\u17BB\u17C7\u178A\u17B6\u179B"},{"id":3939,"word":"\u178A\u17BC\u1784"},{"id":3940,"word":"\u178A\u17BC\u1784\u1785\u17C2\u1798"},{"id":3941,"word":"\u178A\u17BC\u1784\u1796\u17D2\u179A\u17C7"},{"id":3942,"word":"\u178A\u17BC\u1785"},{"id":3943,"word":"\u178A\u17BC\u1785\u178A\u17C2\u179B"},{"id":3944,"word":"\u178A\u17BC\u1785\u17D2\u1793\u17B9\u1784"},{"id":3945,"word":"\u178A\u17BC\u1785\u17D2\u1793\u17C1\u17C7"},{"id":3946,"word":"\u178A\u17BC\u1785\u17D2\u1793\u17C4\u17C7"},{"id":3947,"word":"\u178A\u17BC\u1793"},{"id":3948,"word":"\u178A\u17BC\u1793\u1787\u17B8"},{"id":3949,"word":"\u178A\u17BC\u1793\u178F\u17B6"},{"id":3950,"word":"\u178A\u17BC\u1793\u1796\u17C1\u1789"},{"id":3951,"word":"\u178A\u17BC\u179A"},{"id":3952,"word":"\u178A\u17BD\u1784"},{"id":3953,"word":"\u178A\u17BD\u1785"},{"id":3954,"word":"\u178A\u17BD\u1785\u178A\u179B\u17CB"},{"id":3955,"word":"\u178A\u17BD\u1793"},{"id":3956,"word":"\u178A\u17BD\u179B"},{"id":3957,"word":"\u178A\u17BD\u179F"},{"id":3958,"word":"\u178A\u17BE\u1798"},{"id":3959,"word":"\u178A\u17BE\u1798\u17D2\u1794\u17B8"},{"id":3960,"word":"\u178A\u17BE\u179A"},{"id":3961,"word":"\u178A\u17BE\u179A\u178F\u17BD"},{"id":3962,"word":"\u178A\u17BE\u179A\u1791\u17B6"},{"id":3963,"word":"\u178A\u17BE\u179A\u1791\u17C1\u179F"},{"id":3964,"word":"\u178A\u17BE\u179A\u17A0\u17BE\u179A"},{"id":3965,"word":"\u178A\u17C0\u1784"},{"id":3966,"word":"\u178A\u17C0\u1794"},{"id":3967,"word":"\u178A\u17C0\u1798\u178A\u17B6\u1798"},{"id":3968,"word":"\u178A\u17C0\u179B"},{"id":3969,"word":"\u178A\u17C0\u179C"},{"id":3970,"word":"\u178A\u17C1\u1780"},{"id":3971,"word":"\u178A\u17C1\u1789"},{"id":3972,"word":"\u178A\u17C1\u179A"},{"id":3973,"word":"\u178A\u17C1\u179A\u178A\u17B6\u179F"},{"id":3974,"word":"\u178A\u17C2\u1780"},{"id":3975,"word":"\u178A\u17C2\u1784"},{"id":3976,"word":"\u178A\u17C2\u1793"},{"id":3977,"word":"\u178A\u17C2\u179A"},{"id":3978,"word":"\u178A\u17C2\u179B"},{"id":3979,"word":"\u178A\u17C3"},{"id":3980,"word":"\u178A\u17C3\u1780\u17C2\u179C"},{"id":3981,"word":"\u178A\u17C3\u1781\u17D2\u179B\u17B6"},{"id":3982,"word":"\u178A\u17C3\u179A\u1782\u17C0\u1798"},{"id":3983,"word":"\u178A\u17C3\u179A\u178E\u17C2\u1784"},{"id":3984,"word":"\u178A\u17C3\u179A\u17A0\u17B6\u178F\u17CB"},{"id":3985,"word":"\u178A\u17C3\u179F\u17D2\u179C\u17B6"},{"id":3986,"word":"\u178A\u17C4\u1780"},{"id":3987,"word":"\u178A\u17C4\u1785"},{"id":3988,"word":"\u178A\u17C4\u178F"},{"id":3989,"word":"\u178A\u17C4\u1794"},{"id":3990,"word":"\u178A\u17C4\u1798"},{"id":3991,"word":"\u178A\u17C4\u1799"},{"id":3992,"word":"\u178A\u17C4\u1799\u1793\u17BC\u179C"},{"id":3993,"word":"\u178A\u17C4\u1799\u179F\u17B6\u179A"},{"id":3994,"word":"\u178A\u17C4\u1799\u17A0\u17C1\u178F\u17BB"},{"id":3995,"word":"\u178A\u17C4\u179A"},{"id":3996,"word":"\u178A\u17C4\u179B"},{"id":3997,"word":"\u178A\u17C4\u17C7"},{"id":3998,"word":"\u178A\u17C4\u17C7\u1782\u1793\u17CB"},{"id":3999,"word":"\u178A\u17C4\u17C7\u1789"},{"id":4000,"word":"\u178A\u17C4\u17C7\u178A\u17C3"},{"id":4001,"word":"\u178A\u17C4\u17C7\u1791\u17BB\u1780\u17D2\u1781\u179F\u178F\u17D2\u179C"},{"id":4002,"word":"\u178A\u17C4\u17C7\u179F\u17B6"},{"id":4003,"word":"\u178A\u17C5"},{"id":4004,"word":"\u178A\u17BB\u17C6"},{"id":4005,"word":"\u178A\u17BB\u17C6\u178A\u17C3"},{"id":4006,"word":"\u178A\u17C6"},{"id":4007,"word":"\u178A\u17C6\u1784\u17BE\u1785"},{"id":4008,"word":"\u178A\u17C6\u178E\u1780"},{"id":4009,"word":"\u178A\u17C6\u178E\u1780\u17CB"},{"id":4010,"word":"\u178A\u17C6\u178E\u17B6\u1780\u17CB"},{"id":4011,"word":"\u178A\u17C6\u178E\u17B6\u1785\u17CB"},{"id":4012,"word":"\u178A\u17C6\u178E\u17B6\u1794\u17CB"},{"id":4013,"word":"\u178A\u17C6\u178E\u17B6\u179B"},{"id":4014,"word":"\u178A\u17C6\u178E\u17B9\u1784"},{"id":4015,"word":"\u178A\u17C6\u178E\u17BB\u179F"},{"id":4016,"word":"\u178A\u17C6\u178E\u17BB\u17C7"},{"id":4017,"word":"\u178A\u17C6\u178E\u17BC\u1785"},{"id":4018,"word":"\u178A\u17C6\u178E\u17BD\u1785"},{"id":4019,"word":"\u178A\u17C6\u178E\u17BD\u179B"},{"id":4020,"word":"\u178A\u17C6\u178E\u17BE\u1794"},{"id":4021,"word":"\u178A\u17C6\u178E\u17BE\u179A"},{"id":4022,"word":"\u178A\u17C6\u178E\u17C0\u179B"},{"id":4023,"word":"\u178A\u17C6\u178E\u17C1\u1780"},{"id":4024,"word":"\u178A\u17C6\u178E\u17C1\u1789"},{"id":4025,"word":"\u178A\u17C6\u178E\u17C2\u1784"},{"id":4026,"word":"\u178A\u17C6\u178E\u17C2\u179B"},{"id":4027,"word":"\u178A\u17C6\u178E\u17C4\u17C7"},{"id":4028,"word":"\u178A\u17C6\u178E\u17C6"},{"id":4029,"word":"\u178A\u17C6\u178E\u17B6\u17C6"},{"id":4030,"word":"\u178A\u17C6\u1794"},{"id":4031,"word":"\u178A\u17C6\u1794\u1784"},{"id":4032,"word":"\u178A\u17C6\u1794\u1784\u1782\u17D2\u179A\u1789\u17BC\u1784"},{"id":4033,"word":"\u178A\u17C6\u1794\u1784\u1799\u1780\u17D2\u179F"},{"id":4034,"word":"\u178A\u17C6\u1794\u1793\u17CB"},{"id":4035,"word":"\u178A\u17C6\u1794\u17B6\u179A"},{"id":4036,"word":"\u178A\u17C6\u1794\u17BC\u1780"},{"id":4037,"word":"\u178A\u17C6\u1794\u17BC\u1784"},{"id":4038,"word":"\u178A\u17C6\u1794\u17BC\u1793\u17D2\u1798\u17B6\u1793"},{"id":4039,"word":"\u178A\u17C6\u1794\u17BC\u179B"},{"id":4040,"word":"\u178A\u17C6\u1794\u17BD\u1785"},{"id":4041,"word":"\u178A\u17C6\u1794\u17C2"},{"id":4042,"word":"\u178A\u17C6\u1794\u17C5"},{"id":4043,"word":"\u178A\u17C6\u179A\u17B8"},{"id":4044,"word":"\u178A\u17C6\u179A\u17BD\u1785"},{"id":4045,"word":"\u178A\u17C6\u179A\u17BD\u1799"},{"id":4046,"word":"\u178A\u17C6\u179A\u17C0\u178F"},{"id":4047,"word":"\u178A\u17C6\u179A\u17C2\u1780"},{"id":4048,"word":"\u178A\u17C6\u17A1\u17B6\u1793\u17CB"},{"id":4049,"word":"\u178A\u17C6\u17A1\u17BC\u1784"},{"id":4050,"word":"\u178A\u17C6\u17A1\u17BE\u1784"},{"id":4051,"word":"\u178A\u17C6\u17A1\u17C4\u1780"},{"id":4052,"word":"\u178A\u17C6\u17A2\u1780\u17CB"},{"id":4053,"word":"\u178A\u17B6\u17C6"},{"id":4054,"word":"\u178A\u17B6\u17C6\u178A\u17BC\u1784"},{"id":4055,"word":"\u178A\u17B6\u17C6\u178A\u17C2\u1784"},{"id":4056,"word":"\u178A\u17B6\u17C6\u1791\u17B8\u1784"},{"id":4057,"word":"\u178A\u17B6\u17C6\u1784"},{"id":4058,"word":"\u178A\u17D2\u1794\u17B7\u178F"},{"id":4059,"word":"\u178A\u17C6\u178E\u1784"},{"id":4060,"word":"\u178A\u17C6\u178E\u179B\u17CB"},{"id":4061,"word":"\u178A\u17C6\u178E\u17B6\u179B\u17CB"},{"id":4062,"word":"\u178A\u17C6\u178E\u17B6\u179F\u17CB"},{"id":4063,"word":"\u178A\u17C6\u178E\u17B7\u178F"},{"id":4064,"word":"\u178A\u17C6\u178E\u17BB\u178F"},{"id":4065,"word":"\u178A\u17C6\u178E\u17BC\u179A"},{"id":4066,"word":"\u178A\u17C6\u178E\u17BD\u179F"},{"id":4067,"word":"\u178A\u17C6\u178E\u17C0\u1784"},{"id":4068,"word":"\u178A\u17C6\u178E\u17C1\u179A"},{"id":4069,"word":"\u178A\u17C6\u178E\u17C4\u178F"},{"id":4070,"word":"\u178A\u17C6\u178E\u17C4\u1799"},{"id":4071,"word":"\u178A\u17C6\u178E\u17C4\u179B"},{"id":4072,"word":"\u178A\u17C6\u178E\u17C5"},{"id":4073,"word":"\u178B"},{"id":4074,"word":"\u178B\u1794\u1793\u1780\u1798\u17D2\u1798"},{"id":4075,"word":"\u178B\u1794\u1793\u17B6\u1780\u17B6\u179A"},{"id":4076,"word":"\u178B\u1794\u1793\u17B8\u1799\u1797\u178E\u17D2\u178C"},{"id":4077,"word":"\u178B\u1794\u1793\u17B8\u1799\u179C\u178F\u17D2\u1790\u17BB"},{"id":4078,"word":"\u178B\u1794\u1793\u17C4\u1780\u17B6\u179F"},{"id":4079,"word":"\u178B\u1794\u1793\u17C4\u1794\u17B6\u1799"},{"id":4080,"word":"\u178B\u17B6\u1793"},{"id":4081,"word":"\u178B\u17B6\u1793\u17C8"},{"id":4082,"word":"\u178B\u17B6\u1793\u1793\u17D2\u178F\u179A"},{"id":4083,"word":"\u178B\u17B6\u1793\u1793\u17D2\u178F\u179A\u179F\u1780\u17D2\u178F\u17B7"},{"id":4084,"word":"\u178B\u17B6\u1793\u1794\u1791\u17D2\u1798"},{"id":4085,"word":"\u178B\u17B6\u1793\u1794\u17D2\u1794\u1797\u17C1\u1791"},{"id":4086,"word":"\u178B\u17B6\u1793\u1797\u17B6\u1796"},{"id":4087,"word":"\u178B\u17B6\u1793\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798"},{"id":4088,"word":"\u178B\u17B6\u1793\u17B6\u1793\u17BB\u179A\u17BC\u1794"},{"id":4089,"word":"\u178B\u17B6\u1793\u17B8\u1799"},{"id":4090,"word":"\u178B\u17B7\u178F"},{"id":4091,"word":"\u178B\u17B7\u178F\u1790\u17C1\u179A"},{"id":4092,"word":"\u178B\u17B7\u178F\u1790\u17C1\u179A\u1785\u17B8\u179A\u1780\u17B6\u179B"},{"id":4093,"word":"\u178B\u17B7\u178F\u17B7"},{"id":4094,"word":"\u178B\u17B7\u178F\u17B7\u1780\u17B6\u179B"},{"id":4095,"word":"\u178B\u17B7\u178F\u17B7\u1797\u17B6\u1796"},{"id":4096,"word":"\u178C"},{"id":4097,"word":"\u178C\u1798\u1787\u1793"},{"id":4098,"word":"\u178C\u17B6\u1780\u17B7\u1793\u17B8"},{"id":4099,"word":"\u178C\u17B6\u178C\u17B7\u1798"},{"id":4100,"word":"\u178C\u17B6\u17A0\u179A\u17C4\u1782"},{"id":4101,"word":"\u178C\u17B7\u1780\u178F\u17C1"},{"id":4102,"word":"\u178C\u17B7\u1793"},{"id":4103,"word":"\u178C\u17BA"},{"id":4104,"word":"\u178C\u17BA\u178A\u1784"},{"id":4105,"word":"\u178C\u17BB\u178A\u17B6\u1793\u17CB"},{"id":4106,"word":"\u178C\u17BB\u1780\u178A\u17B6\u1793\u17CB"},{"id":4107,"word":"\u178C\u17BB\u1793"},{"id":4108,"word":"\u178C\u17C1\u1794\u1793\u1780\u1798\u17D2\u1798"},{"id":4109,"word":"\u178C\u17C1\u1794\u1793\u17B6\u1780\u17B6\u179A"},{"id":4110,"word":"\u178D"},{"id":4111,"word":"\u178D\u17B6\u1798\u179A\u17B6"},{"id":4112,"word":"\u178D\u17B6\u179B"},{"id":4113,"word":"\u178D\u17B6\u179B\u17B7\u1793"},{"id":4114,"word":"\u178D\u17BB\u178E\u17D2\u178D\u17B7"},{"id":4115,"word":"\u178E"},{"id":4116,"word":"\u178E\u178F\u178E\u1799"},{"id":4117,"word":"\u178E\u17B6"},{"id":4118,"word":"\u178E\u17B6\u17CE!"},{"id":4119,"word":"\u178E\u17B6\u178F\u17CB"},{"id":4120,"word":"\u178E\u17B6\u1798\u179F\u17D2\u179A\u1784\u17CB"},{"id":4121,"word":"\u178E\u17B6\u1799"},{"id":4122,"word":"\u178E\u17B6\u179F\u17CB"},{"id":4123,"word":"\u178E\u17B6\u179F\u17CB\u179F\u17B6"},{"id":4124,"word":"\u178E\u17B7\u1784\u178E\u17BB\u1784"},{"id":4125,"word":"\u178E\u17B7\u1798\u178E\u17BB\u1798"},{"id":4126,"word":"\u178E\u17B7\u179B"},{"id":4127,"word":"\u178E\u17BA\u1784"},{"id":4128,"word":"\u178E\u17BC\u1784"},{"id":4129,"word":"\u178E\u17BC\u179A\u17B8"},{"id":4130,"word":"\u178E\u17C1\u1784\u178E\u17BC\u1784"},{"id":4131,"word":"\u178E\u17C1\u17C7\u178E\u17C4\u17C7"},{"id":4132,"word":"\u178E\u17C2"},{"id":4133,"word":"\u178E\u17C2\u1780\u178E\u1780"},{"id":4134,"word":"\u178E\u17C2\u1784\u178E\u1784"},{"id":4135,"word":"\u178E\u17C2\u1784\u178E\u17C4\u1784"},{"id":4136,"word":"\u178E\u17C2\u178E\u1793"},{"id":4137,"word":"\u178E\u17C2\u1793"},{"id":4138,"word":"\u178E\u17C2\u1793\u178E\u17B6\u1793\u17CB"},{"id":4139,"word":"\u178E\u17C2\u1793\u17B6\u17C6"},{"id":4140,"word":"\u178E\u17C2\u1798"},{"id":4141,"word":"\u178E\u17C2\u179B\u178E\u17C4\u179B"},{"id":4142,"word":"\u178E\u17C2\u179C"},{"id":4143,"word":"\u178E\u17B6\u17C6\u1793\u17BD\u1793"},{"id":4144,"word":"\u178E\u17B6\u17C6\u179C\u17C9\u17B6"},{"id":4145,"word":"\u178E\u17B6\u17C6\u1784"},{"id":4146,"word":"\u178E\u17CE\u17C7!"},{"id":4147,"word":"\u178E\u17D2\u17A0\u17BE\u1799"},{"id":4148,"word":"\u178E\u17D2\u17A0\u17BE\u1799\u1785\u17BB\u17C7"},{"id":4149,"word":"\u178F"},{"id":4150,"word":"\u178F\u1780\u17CB"},{"id":4151,"word":"\u178F\u1780\u17CB\u1780\u17D2\u179A\u17A0\u179B\u17CB"},{"id":4152,"word":"\u178F\u1780\u17CB\u1794\u17D2\u179A\u1798\u17B6"},{"id":4153,"word":"\u178F\u1780\u17CB\u179F\u17D2\u179B\u17BB\u178F"},{"id":4154,"word":"\u178F\u1780\u17D2\u1780"},{"id":4155,"word":"\u178F\u1780\u17D2\u1780\u1798\u17B6"},{"id":4156,"word":"\u178F\u1780\u17D2\u1780\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":4157,"word":"\u178F\u1780\u17D2\u1780\u179C\u17B7\u1789\u17D2\u1789\u17BC"},{"id":4158,"word":"\u178F\u1780\u17D2\u1780\u179C\u17B7\u1791"},{"id":4159,"word":"\u178F\u1780\u17D2\u1780\u179C\u17B7\u1791\u17BC"},{"id":4160,"word":"\u178F\u1780\u17D2\u1780\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":4161,"word":"\u178F\u1784"},{"id":4162,"word":"\u178F\u1784\u17D2\u1780\u179A"},{"id":4163,"word":"\u178F\u1784\u17D2\u1780\u17C0\u1794"},{"id":4164,"word":"\u178F\u1784\u17D2\u1780\u17C0\u1794\u1780\u17D2\u178A\u17B6\u1798"},{"id":4165,"word":"\u178F\u1784\u17D2\u179C\u17B6\u1799"},{"id":4166,"word":"\u178F\u1785\u1794\u1789\u17D2\u1785\u1780\u1780\u1798\u17D2\u1798\u178A\u17D2\u178B\u17B6\u1793"},{"id":4167,"word":"\u178F\u1785\u179F\u17B6\u179A\u1787\u17B6\u178F\u17B7"},{"id":4168,"word":"\u178F\u1785\u179F\u17B6\u179A\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":4169,"word":"\u178F\u1787\u17D2\u1787\u17B6\u179A\u17B8"},{"id":4170,"word":"\u178F\u178E\u17D2\u17A0\u17B6"},{"id":4171,"word":"\u178F\u178E\u17D2\u17A0\u17B6\u1791\u17B6\u179F"},{"id":4172,"word":"\u178F\u178F\u1784\u17A2\u17B6\u179A\u17C9\u1784"},{"id":4173,"word":"\u178F\u178F\u178F\u1799"},{"id":4174,"word":"\u178F\u178F\u17B6\u1780\u17CB\u178F\u178F\u17B6\u17C6"},{"id":4175,"word":"\u178F\u178F\u17B7\u1794\u178F\u178F\u17BB\u1794"},{"id":4176,"word":"\u178F\u178F\u17BC\u1784"},{"id":4177,"word":"\u178F\u178F\u17BC\u1784\u178F\u178F\u17B6\u1784"},{"id":4178,"word":"\u178F\u178F\u17C1\u1784\u178F\u178F\u17B6\u1784"},{"id":4179,"word":"\u178F\u178F\u17C1\u17C7\u178F\u178F\u17C4\u17C7"},{"id":4180,"word":"\u178F\u178F\u17C1\u17C7\u178F\u178F\u17C7"},{"id":4181,"word":"\u178F\u178F\u17C2\u1784\u178F\u178F\u17C4\u1784"},{"id":4182,"word":"\u178F\u178F\u17C2\u178F\u178F\u17C4"},{"id":4183,"word":"\u178F\u178F\u17C2\u179B\u178F\u178F\u17C4\u179B"},{"id":4184,"word":"\u178F\u178F\u17C7"},{"id":4185,"word":"\u178F\u1790\u17B6\u1782\u178F"},{"id":4186,"word":"\u178F\u1790\u17B6\u1793\u17BB\u179A\u17BC\u1794"},{"id":4187,"word":"\u178F\u1793\u17CB"},{"id":4188,"word":"\u178F\u1793\u17D0\u1799"},{"id":4189,"word":"\u178F\u1793\u1799\u17B6"},{"id":4190,"word":"\u178F\u1793\u17BB"},{"id":4191,"word":"\u178F\u1793\u17BB\u1787"},{"id":4192,"word":"\u178F\u17C8\u1781\u17C1"},{"id":4193,"word":"\u178F\u1793\u17D2\u178F\u17B7\u1797\u17B6\u179F\u17B6"},{"id":4194,"word":"\u178F\u1793\u17D2\u179A\u17D2\u178F\u17B8"},{"id":4195,"word":"\u178F\u1793\u17D2\u178F\u17D2\u179A\u17C6"},{"id":4196,"word":"\u178F\u1793\u17D2\u1790\u17BE\u1793"},{"id":4197,"word":"\u178F\u1794"},{"id":4198,"word":"\u178F\u1794\u17CB"},{"id":4199,"word":"\u178F\u1794\u1780\u1790\u17B6"},{"id":4200,"word":"\u178F\u1794\u17CB\u1780\u1798\u179B"},{"id":4201,"word":"\u178F\u1794\u1792\u1798\u17CC"},{"id":4202,"word":"\u178F\u1794\u17CB\u1794\u17D2\u179A\u1798\u179B\u17CB"},{"id":4203,"word":"\u178F\u1794\u179F\u17D2\u179F\u17B8"},{"id":4204,"word":"\u178F\u1794\u17C8"},{"id":4205,"word":"\u178F\u1794\u17C4\u1792\u1793"},{"id":4206,"word":"\u178F\u1794\u17C7"},{"id":4207,"word":"\u178F\u1796\u17C4\u1780"},{"id":4208,"word":"\u178F\u1798"},{"id":4209,"word":"\u178F\u1798\u17D2\u1780\u179B\u17CB"},{"id":4210,"word":"\u178F\u1798\u17D2\u1780\u17B6\u178F\u17CB"},{"id":4211,"word":"\u178F\u1798\u17D2\u1780\u17BE\u1784"},{"id":4212,"word":"\u178F\u1798\u17D2\u1780\u17BB\u17C6\u178F\u1798\u17D2\u1780\u17BE\u1784"},{"id":4213,"word":"\u178F\u1798\u17D2\u1794\u17B6\u1789"},{"id":4214,"word":"\u178F\u1798\u17D2\u1794\u17B6\u179A"},{"id":4215,"word":"\u178F\u1798\u17D2\u1794\u17BB\u178F"},{"id":4216,"word":"\u178F\u1798\u17D2\u1794\u17C0\u178F"},{"id":4217,"word":"\u178F\u1798\u17D2\u1796\u1780\u17CB"},{"id":4218,"word":"\u178F\u1798\u17D2\u1796\u17BB\u179B"},{"id":4219,"word":"\u178F\u1798\u17D2\u1796\u17C1\u1785"},{"id":4220,"word":"\u178F\u1798\u17D2\u1796\u17C2\u1780"},{"id":4221,"word":"\u178F\u1798\u17D2\u179A\u1784"},{"id":4222,"word":"\u178F\u1798\u17D2\u179A\u1784\u17CB"},{"id":4223,"word":"\u178F\u1798\u17D2\u179A\u17B6"},{"id":4224,"word":"\u178F\u1798\u17D2\u179A\u17B6\u1794\u17CB"},{"id":4225,"word":"\u178F\u1798\u17D2\u179A\u17B6\u1799"},{"id":4226,"word":"\u178F\u1798\u17D2\u179A\u17B6\u179F\u17CB"},{"id":4227,"word":"\u178F\u1798\u17D2\u179A\u17B7\u17C7"},{"id":4228,"word":"\u178F\u1798\u17D2\u179A\u17B9\u1798"},{"id":4229,"word":"\u178F\u1798\u17D2\u179A\u17BB\u1799"},{"id":4230,"word":"\u178F\u1798\u17D2\u179A\u17BC\u179C"},{"id":4231,"word":"\u178F\u1798\u17D2\u179A\u17BD\u178F"},{"id":4232,"word":"\u178F\u1798\u17D2\u179A\u17C0\u1794"},{"id":4233,"word":"\u178F\u1798\u17D2\u179A\u17C1\u1780"},{"id":4234,"word":"\u178F\u1798\u17D2\u179A\u17B6\u17C6"},{"id":4235,"word":"\u178F\u1798\u17D2\u179B\u1784\u17CB"},{"id":4236,"word":"\u178F\u1798\u17D2\u179B\u17B6"},{"id":4237,"word":"\u178F\u1798\u17D2\u179B\u17B9\u1784"},{"id":4238,"word":"\u178F\u1798\u17D2\u179B\u17BB\u1789"},{"id":4239,"word":"\u178F\u1798\u17D2\u179B\u17C3"},{"id":4240,"word":"\u178F\u1798\u17D2\u179B\u17C4\u17C7"},{"id":4241,"word":"\u178F\u1798\u17D2\u17A2\u17B9\u1784"},{"id":4242,"word":"\u178F\u1798\u17D2\u17A2\u17BC\u1789"},{"id":4243,"word":"\u178F\u1799"},{"id":4244,"word":"\u178F\u1799\u1784\u17C9\u1799"},{"id":4245,"word":"\u178F\u179A\u1784\u17D2\u1782\u1782\u178F\u17B7"},{"id":4246,"word":"\u178F\u179A\u17BB\u178E"},{"id":4247,"word":"\u178F\u179A\u17BB\u178E\u1794\u17BB\u178F\u17D2\u178F"},{"id":4248,"word":"\u178F\u179A\u17BB\u178E\u1797\u17B6\u1796"},{"id":4249,"word":"\u178F\u179A\u17BB\u178E\u179C\u17D0\u1799"},{"id":4250,"word":"\u178F\u179A\u17BB\u178E\u17B8"},{"id":4251,"word":"\u178F\u179C\u17C9\u17B6"},{"id":4252,"word":"\u178F\u17B6"},{"id":4253,"word":"\u178F\u17B6\u1780"},{"id":4254,"word":"\u178F\u17B6\u1780\u179A\u1781\u17B6\u1780"},{"id":4255,"word":"\u178F\u17B6\u1780\u179A\u17C9\u17B6\u1780"},{"id":4256,"word":"\u178F\u17B6\u1780\u17C2"},{"id":4257,"word":"\u178F\u17B6\u1780\u17CB\u178F\u17C2\u1784"},{"id":4258,"word":"\u178F\u17B6\u1781\u17B6\u1799"},{"id":4259,"word":"\u178F\u17B6\u1781\u17C1"},{"id":4260,"word":"\u178F\u17B6\u1784"},{"id":4261,"word":"\u178F\u17B6\u178A\u178F\u17CB"},{"id":4262,"word":"\u178F\u17B6\u1784\u179A\u17C9\u17B6\u1784"},{"id":4263,"word":"\u178F\u17B6\u1785"},{"id":4264,"word":"\u178F\u17B6\u1787\u17B8"},{"id":4265,"word":"\u178F\u17B6\u178E\u17B8"},{"id":4266,"word":"\u178F\u17B6\u178F"},{"id":4267,"word":"\u178F\u17B6\u178F\u17D2\u179A\u17C5"},{"id":4268,"word":"\u178F\u17B6\u1793"},{"id":4269,"word":"\u178F\u17B6\u1793\u178F\u17B9\u1784"},{"id":4270,"word":"\u178F\u17B6\u1793\u17CB"},{"id":4271,"word":"\u178F\u17B6\u1794\u17CB\u178F\u17B6\u1793\u17CB"},{"id":4272,"word":"\u178F\u17B6\u1794"},{"id":4273,"word":"\u178F\u17B6\u1794\u17CB"},{"id":4274,"word":"\u178F\u17B6\u1794\u179F"},{"id":4275,"word":"\u178F\u17B6\u1798"},{"id":4276,"word":"\u178F\u17B6\u1798\u178F\u17C2"},{"id":4277,"word":"\u178F\u17B6\u1798\u17C4\u1784"},{"id":4278,"word":"\u178F\u17B6\u1799\u1782\u17C6\u1793\u17B7\u178F"},{"id":4279,"word":"\u178F\u17B6\u1799\u1794\u17BE\u1782\u17B7\u178F"},{"id":4280,"word":"\u178F\u17B6\u1799\u179F\u17B6\u1780"},{"id":4281,"word":"\u178F\u17B6\u1799\u179F\u17D2\u1798\u17B7\u1784"},{"id":4282,"word":"\u178F\u17B6\u1799\u17A0\u17C4\u1784"},{"id":4283,"word":"\u178F\u17B6\u179A\u17B6"},{"id":4284,"word":"\u178F\u17B6\u179A\u17B6\u1784"},{"id":4285,"word":"\u178F\u17B6\u179A\u17B6\u1794\u1790"},{"id":4286,"word":"\u178F\u17B6\u179A\u17B6\u1797\u17BC\u179F\u17B6"},{"id":4287,"word":"\u178F\u17B6\u179A\u17B6\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":4288,"word":"\u178F\u17B6\u179B\u1794\u178F\u17D2\u179A"},{"id":4289,"word":"\u178F\u17B6\u179B\u179C\u17D0\u1793"},{"id":4290,"word":"\u178F\u17B6\u179B\u17A0\u17B6\u179B"},{"id":4291,"word":"\u178F\u17B6\u179B\u17BB"},{"id":4292,"word":"\u178F\u17B6\u179B\u17BB\u1787\u17C8"},{"id":4293,"word":"\u178F\u17B6\u179C\u1780\u17B6\u179B\u17B7\u1780"},{"id":4294,"word":"\u178F\u17B6\u179C\u178F\u17D2\u178F\u17B7\u1784\u17D2\u179F"},{"id":4295,"word":"\u178F\u17B6\u179C\u17C5"},{"id":4296,"word":"\u178F\u17B6\u179F\u1780\u17CB"},{"id":4297,"word":"\u178F\u17B6\u17A2\u1780"},{"id":4298,"word":"\u178F\u17B6\u17B1"},{"id":4299,"word":"\u178F\u17B7\u1780\u17C8"},{"id":4300,"word":"\u178F\u17B7\u1780\u178F\u17BB\u1780"},{"id":4301,"word":"\u178F\u17B7\u1785"},{"id":4302,"word":"\u178F\u17B7\u1785\u17D7"},{"id":4303,"word":"\u178F\u17B7\u1789\u178F\u17BB\u1789"},{"id":4304,"word":"\u178F\u17B7\u178E\u1787\u17B6\u178F\u17B7"},{"id":4305,"word":"\u178F\u17B7\u1790\u17B8"},{"id":4306,"word":"\u178F\u17B7\u1790\u17B8\u1780\u17D2\u179F\u17D0\u1799"},{"id":4307,"word":"\u178F\u17B7\u1794\u178F\u17BB\u1794"},{"id":4308,"word":"\u178F\u17B7\u1794\u17BB\u1780"},{"id":4309,"word":"\u178F\u17B7\u1798\u1792\u17B8"},{"id":4310,"word":"\u178F\u17B7\u179A\u1785\u17D2\u1786\u17B6\u1793"},{"id":4311,"word":"\u178F\u17B7\u179A\u1785\u17D2\u1786\u17B6\u1793\u1780\u1790\u17B6"},{"id":4312,"word":"\u178F\u17B7\u179A\u17D2\u1790\u17B7\u1799"},{"id":4313,"word":"\u178F\u17B7\u179A\u17C4\u1780\u17BB\u178C\u17D2\u178C\u179F\u17BC\u178F\u17D2\u179A"},{"id":4314,"word":"\u178F\u17B7\u179B\u1780"},{"id":4315,"word":"\u178F\u17B7\u17C7"},{"id":4316,"word":"\u178F\u17B7\u17C7\u178A\u17C0\u179B"},{"id":4317,"word":"\u178F\u17B8\u179A\u179C\u17B7\u1790\u17B8"},{"id":4318,"word":"\u178F\u17B9\u1780"},{"id":4319,"word":"\u178F\u17B9\u1780\u17D7"},{"id":4320,"word":"\u178F\u17B9\u1780\u1780\u17C2"},{"id":4321,"word":"\u178F\u17B9\u1780\u178F\u17B6\u1784"},{"id":4322,"word":"\u178F\u17B9\u1784"},{"id":4323,"word":"\u178F\u17B9\u1784\u179A\u17C9\u17B9\u1784"},{"id":4324,"word":"\u178F\u17B9\u1784"},{"id":4325,"word":"\u178F\u17BA\u178F\u179A\u1781\u17BA\u178F"},{"id":4326,"word":"\u178F\u17BB"},{"id":4327,"word":"\u178F\u17BB\u1780\u1780\u17C2"},{"id":4328,"word":"\u178F\u17BB\u1780\u178F\u17BB\u179B"},{"id":4329,"word":"\u178F\u17BB\u1780\u179A\u1784\u17D2\u179C\u17B6\u1793\u17CB"},{"id":4330,"word":"\u178F\u17BB\u1784"},{"id":4331,"word":"\u178F\u17BB\u1784\u178F\u17B6\u17C6\u1784"},{"id":4332,"word":"\u178F\u17BB\u1789"},{"id":4333,"word":"\u178F\u17BB\u1784\u1791\u17B8\u1793"},{"id":4334,"word":"\u178F\u17BB\u178E\u17D2\u17A0\u17B8\u1797\u17B6\u1796"},{"id":4335,"word":"\u178F\u17BB\u1794\u17D7"},{"id":4336,"word":"\u178F\u17BB\u1798\u178F\u17D2\u1790\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":4337,"word":"\u178F\u17BB\u1798\u17D2\u1796"},{"id":4338,"word":"\u178F\u17BB\u1798\u17D2\u1796\u1790\u17BC\u1794"},{"id":4339,"word":"\u178F\u17BB\u179A\u1784\u17D2\u1782"},{"id":4340,"word":"\u178F\u17BB\u179A\u17B7\u1799\u17B6\u1784\u17D2\u1782"},{"id":4341,"word":"\u178F\u17BB\u179B"},{"id":4342,"word":"\u178F\u17BB\u179B\u1798\u17C9\u17BB\u179B"},{"id":4343,"word":"\u178F\u17BB\u179B\u17D2\u1799"},{"id":4344,"word":"\u178F\u17BB\u179B\u17D2\u1799\u1780\u17B6\u179A"},{"id":4345,"word":"\u178F\u17BB\u179B\u17D2\u1799\u1797\u17B6\u1796"},{"id":4346,"word":"\u178F\u17BB\u179B\u17D2\u1799\u17B6\u1780\u17B6\u179A"},{"id":4347,"word":"\u178F\u17BB\u179B\u17D2\u1799\u17B6\u1792\u17B7\u1780\u179A\u178E\u17C8"},{"id":4348,"word":"\u178F\u17BB\u179B\u17B6"},{"id":4349,"word":"\u178F\u17BB\u179B\u17B6\u1780\u17B6\u179A"},{"id":4350,"word":"\u178F\u17BB\u179F\u17B7\u178F"},{"id":4351,"word":"\u178F\u17BB\u179F\u17D2\u178A\u17B8"},{"id":4352,"word":"\u178F\u17BB\u17C7"},{"id":4353,"word":"\u178F\u17BC\u1784"},{"id":4354,"word":"\u178F\u17BC\u1784\u178F\u17B6\u1784"},{"id":4355,"word":"\u178F\u17BC\u1785"},{"id":4356,"word":"\u178F\u17BC\u1793"},{"id":4357,"word":"\u178F\u17BC\u1794"},{"id":4358,"word":"\u178F\u17BC\u1799\u17CC\u178F\u1793\u17D2\u178F\u17D2\u179A\u17B8"},{"id":4359,"word":"\u178F\u17BD"},{"id":4360,"word":"\u178F\u17BD\u1785"},{"id":4361,"word":"\u178F\u17BD\u1793"},{"id":4362,"word":"\u178F\u17BD\u1798\u17D7"},{"id":4363,"word":"\u178F\u17BD\u1799\u17C9\u17B6\u1784"},{"id":4364,"word":"\u178F\u17BD\u17AF\u1780"},{"id":4365,"word":"\u178F\u17BE"},{"id":4366,"word":"\u178F\u17BE\u1780"},{"id":4367,"word":"\u178F\u17BE\u1780\u17D7"},{"id":4368,"word":"\u178F\u17BE\u178F\u17D7"},{"id":4369,"word":"\u178F\u17BE\u1793"},{"id":4370,"word":"\u178F\u17BE\u1799"},{"id":4371,"word":"\u178F\u17BF"},{"id":4372,"word":"\u178F\u17BF\u1793"},{"id":4373,"word":"\u178F\u17C0\u1784"},{"id":4374,"word":"\u178F\u17C0\u1787\u17B8\u179C"},{"id":4375,"word":"\u178F\u17C0\u1793"},{"id":4376,"word":"\u178F\u17C0\u1794"},{"id":4377,"word":"\u178F\u17C0\u1798"},{"id":4378,"word":"\u178F\u17C1\u1784\u178F\u17B6\u1784"},{"id":4379,"word":"\u178F\u17C1\u1785\u17B8\u179C\u179A\u17B7\u1780\u1784\u17D2\u1782\u17C8"},{"id":4380,"word":"\u178F\u17C1\u1787"},{"id":4381,"word":"\u178F\u17C1\u1787\u179C\u1793\u17D2\u178F"},{"id":4382,"word":"\u178F\u17C1\u1787\u179F\u17B8"},{"id":4383,"word":"\u178F\u17C1\u1787\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":4384,"word":"\u178F\u17C1\u1787\u17C4\u1780\u179F\u17B7\u178E"},{"id":4385,"word":"\u178F\u17C1\u1787\u17C4\u1787\u17D0\u1799"},{"id":4386,"word":"\u178F\u17C1\u1787\u17C4\u1792\u17B6\u178F\u17BB"},{"id":4387,"word":"\u178F\u17C1\u1787\u17C4\u1796\u179B"},{"id":4388,"word":"\u178F\u17C1\u1787\u17C7"},{"id":4389,"word":"\u178F\u17C1\u178F"},{"id":4390,"word":"\u178F\u17C1\u1793"},{"id":4391,"word":"\u178F\u17C1\u1794\u178F\u17B6\u1794"},{"id":4392,"word":"\u178F\u17C1\u179B\u178F\u17B6\u179B"},{"id":4393,"word":"\u178F\u17C1\u17C7\u178F\u17C4\u17C7"},{"id":4394,"word":"\u178F\u17C2"},{"id":4395,"word":"\u178F\u17C2\u1780\u178F\u17C4\u1780"},{"id":4396,"word":"\u178F\u17C2\u1784"},{"id":4397,"word":"\u178F\u17C2\u1784\u178F\u17C4\u1784"},{"id":4398,"word":"\u178F\u17C2\u1784\u178F\u17B6\u17C6\u1784"},{"id":4399,"word":"\u178F\u17C2\u178F\u17C4"},{"id":4400,"word":"\u178F\u17C2\u1793\u178F\u17B7\u17CD"},{"id":4401,"word":"\u178F\u17C2\u1798"},{"id":4402,"word":"\u178F\u17C2\u1798"},{"id":4403,"word":"\u178F\u17C2\u179B\u178F\u17C4\u179B"},{"id":4404,"word":"\u178F\u17C2\u179C\u17C9\u17C2"},{"id":4405,"word":"\u178F\u17C3\u17A0\u17C4\u1784"},{"id":4406,"word":"\u178F\u17C4"},{"id":4407,"word":"\u178F\u17C4"},{"id":4408,"word":"\u178F\u17C4\u1780"},{"id":4409,"word":"\u178F\u17C4\u1780\u1799\u17C9\u17B6\u1780"},{"id":4410,"word":"\u178F\u17C4\u1780\u179A\u1781\u17C4\u1780"},{"id":4411,"word":"\u178F\u17C4\u1780\u17A2\u17B6\u179A\u1780\u17D2\u179F"},{"id":4412,"word":"\u178F\u17C4\u1784"},{"id":4413,"word":"\u178F\u17C4\u1784\u1780\u17D2\u179A\u1796\u17B6\u178F\u17CB"},{"id":4414,"word":"\u178F\u17C4\u1784\u1780\u17B6\u179A"},{"id":4415,"word":"\u178F\u17C4\u1784\u1791\u17B6\u1798"},{"id":4416,"word":"\u178F\u17C4\u178F\u178F\u17BC\u1784"},{"id":4417,"word":"\u178F\u17C4\u178F\u1798\u17C9\u17B6"},{"id":4418,"word":"\u178F\u17C4\u178F\u1798\u17C9\u17C4\u1784"},{"id":4419,"word":"\u178F\u17C4\u1793"},{"id":4420,"word":"\u178F\u17C4\u1798\u179A"},{"id":4421,"word":"\u178F\u17C4\u1798\u179A\u1792\u179A"},{"id":4422,"word":"\u178F\u17C4\u1799\u17C9\u17C4"},{"id":4423,"word":"\u178F\u17C4\u179A\u178E\u17C8"},{"id":4424,"word":"\u178F\u17C4\u179B\u1798\u17C9\u17C4\u179B"},{"id":4425,"word":"\u178F\u17C4\u179F\u1798\u17C9\u17C4\u179F"},{"id":4426,"word":"\u178F\u17C4\u17C7\u17D7"},{"id":4427,"word":"\u178F\u17C4\u17C7\u178F\u17BE\u1799"},{"id":4428,"word":"\u178F\u17C5"},{"id":4429,"word":"\u178F\u17C5\u1781\u17BC\u179C"},{"id":4430,"word":"\u178F\u17C5\u179F\u17CA\u1793"},{"id":4431,"word":"\u178F\u17C5\u17A0\u17CA\u17BC"},{"id":4432,"word":"\u178F\u17C6\u178E"},{"id":4433,"word":"\u178F\u17C6\u178E\u1780\u17CB"},{"id":4434,"word":"\u178F\u17C6\u178E\u17B6\u1784"},{"id":4435,"word":"\u178F\u17C6\u178E\u17B6\u1794\u17CB"},{"id":4436,"word":"\u178F\u17C6\u178E\u17B6\u179B"},{"id":4437,"word":"\u178F\u17C6\u178E\u17B7\u17C7"},{"id":4438,"word":"\u178F\u17C6\u178E\u17B7\u17C7 \u178A\u17C6\u178E\u17C0\u179B"},{"id":4439,"word":"\u178F\u17C6\u178E\u17BB\u17C7"},{"id":4440,"word":"\u178F\u17C6\u178E\u17BC\u1785"},{"id":4441,"word":"\u178F\u17C6\u178E\u17C2\u1784"},{"id":4442,"word":"\u178F\u17C6\u178E\u17B6\u17C6\u1784"},{"id":4443,"word":"\u178F\u17C6\u1794\u1793\u17CB"},{"id":4444,"word":"\u178F\u17B6\u17C6\u1784"},{"id":4445,"word":"\u178F\u17B6\u17C6\u1784\u1799\u17BC"},{"id":4446,"word":"\u178F\u17B6\u17C6\u1784\u17B1"},{"id":4447,"word":"\u178F\u17B6\u17C6\u178E\u17B6\u1793"},{"id":4448,"word":"\u178F\u17C7"},{"id":4449,"word":"\u178F\u17D2\u1784\u17C4\u1780"},{"id":4450,"word":"\u178F\u17D2\u1793\u17C4\u178F"},{"id":4451,"word":"\u178F\u17D2\u1794\u1780"},{"id":4452,"word":"\u178F\u17D2\u1794\u1791"},{"id":4453,"word":"\u178F\u17D2\u1794\u17B6\u1789"},{"id":4454,"word":"\u178F\u17D2\u1794\u17B6\u179A"},{"id":4455,"word":"\u178F\u17D2\u1794\u17B6\u179B\u17CB"},{"id":4456,"word":"\u178F\u17D2\u1794\u17B6\u179B\u17CB\u1780\u17B7\u1793"},{"id":4457,"word":"\u178F\u17D2\u1794\u17B6\u179B\u17CB\u178A\u17C2\u1780"},{"id":4458,"word":"\u178F\u17D2\u1794\u17B7\u178F"},{"id":4459,"word":"\u178F\u17D2\u1794\u17BB\u178F"},{"id":4460,"word":"\u178F\u17D2\u1794\u17BB\u179A"},{"id":4461,"word":"\u178F\u17D2\u1794\u17BC\u1784"},{"id":4462,"word":"\u178F\u17D2\u1794\u17BC\u1784\u1783\u17D2\u1798\u17BB\u17C6"},{"id":4463,"word":"\u178F\u17D2\u1794\u17C0\u178F"},{"id":4464,"word":"\u178F\u17D2\u1794\u17C2\u1784"},{"id":4465,"word":"\u178F\u17D2\u1798\u17B6\u178F"},{"id":4466,"word":"\u178F\u17D2\u1798\u17B7\u179B"},{"id":4467,"word":"\u178F\u17D2\u1798\u17C4\u1784"},{"id":4468,"word":"\u178F\u17D2\u1798\u17C4\u179B"},{"id":4469,"word":"\u178F\u17D2\u1798\u17C7"},{"id":4470,"word":"\u178F\u17D2\u179A"},{"id":4471,"word":"\u178F\u17D2\u179A\u17C8"},{"id":4472,"word":"\u178F\u17D2\u179A\u1780"},{"id":4473,"word":"\u178F\u17D2\u179A\u1780\u17CB"},{"id":4474,"word":"\u178F\u17D2\u179A\u1780\u1784"},{"id":4475,"word":"\u178F\u17D2\u179A\u1780\u17B6\u179B"},{"id":4476,"word":"\u178F\u17D2\u179A\u1780\u17BC\u179B"},{"id":4477,"word":"\u178F\u17D2\u179A\u1780\u17BD\u1789"},{"id":4478,"word":"\u178F\u17D2\u179A\u1780\u17BD\u1793"},{"id":4479,"word":"\u178F\u17D2\u179A\u1780\u17BD\u1793\u1780\u1793\u17D2\u1791\u17C2\u1780"},{"id":4480,"word":"\u178F\u17D2\u179A\u1780\u17C0\u178F"},{"id":4481,"word":"\u178F\u17D2\u179A\u1780\u17C0\u178F\u1794\u17C9\u17C4\u1784"},{"id":4482,"word":"\u178F\u17D2\u179A\u1782\u17B6\u1780"},{"id":4483,"word":"\u178F\u17D2\u179A\u1784"},{"id":4484,"word":"\u178F\u17D2\u179A\u1784\u17CB"},{"id":4485,"word":"\u178F\u17D2\u179A\u1784\u17B6\u179B"},{"id":4486,"word":"\u178F\u17D2\u179A\u1784\u17B7\u179B"},{"id":4487,"word":"\u178F\u17D2\u179A\u1784\u17BE\u179B"},{"id":4488,"word":"\u178F\u17D2\u179A\u1784\u17C4\u179B"},{"id":4489,"word":"\u178F\u17D2\u179A\u1785\u1784\u17CB"},{"id":4490,"word":"\u178F\u17D2\u179A\u1785\u17BE\u179B"},{"id":4491,"word":"\u178F\u17D2\u179A\u1785\u17C0\u1780"},{"id":4492,"word":"\u178F\u17D2\u179A\u1785\u17C0\u1780\u1780\u178E\u17D2\u178A\u17BB\u179A"},{"id":4493,"word":"\u178F\u17D2\u179A\u1785\u17C0\u1780\u1780\u17B6\u17C6"},{"id":4494,"word":"\u178F\u17D2\u179A\u1785\u17C0\u1780\u178A\u17C6\u179A\u17B8"},{"id":4495,"word":"\u178F\u17D2\u179A\u1785\u17C0\u1780\u1794\u17D2\u179A\u17BE\u179F"},{"id":4496,"word":"\u178F\u17D2\u179A\u1785\u17C0\u1780\u1796\u17D2\u1793\u1784"},{"id":4497,"word":"\u178F\u17D2\u179A\u1785\u17C7"},{"id":4498,"word":"\u178F\u17D2\u179A\u1787\u17B6\u1780\u17CB"},{"id":4499,"word":"\u178F\u17D2\u179A\u1787\u17C6"},{"id":4500,"word":"\u178F\u17D2\u179A\u1788\u17B9\u1784"},{"id":4501,"word":"\u178F\u17D2\u179A\u1788\u17C3"},{"id":4502,"word":"\u178F\u17D2\u179A\u178A\u1780\u17CB"},{"id":4503,"word":"\u178F\u17D2\u179A\u178A\u1780\u17CB\u178F\u17D2\u179A\u179F\u17BB\u17C6"},{"id":4504,"word":"\u178F\u17D2\u179A\u178A\u179A"},{"id":4505,"word":"\u178F\u17D2\u179A\u178A\u17B6\u1784"},{"id":4506,"word":"\u178F\u17D2\u179A\u178A\u17B6\u1785"},{"id":4507,"word":"\u178F\u17D2\u179A\u178A\u17B6\u1794\u178F\u17D2\u179A\u178A\u17BD\u179F"},{"id":4508,"word":"\u178F\u17D2\u179A\u178A\u17B6\u179B\u17CB"},{"id":4509,"word":"\u178F\u17D2\u179A\u178A\u17B7\u178F"},{"id":4510,"word":"\u178F\u17D2\u179A\u178A\u17B9\u1784"},{"id":4511,"word":"\u178F\u17D2\u179A\u178A\u17B9\u1798"},{"id":4512,"word":"\u178F\u17D2\u179A\u178A\u17BB\u179F"},{"id":4513,"word":"\u178F\u17D2\u179A\u178A\u17BD\u1785"},{"id":4514,"word":"\u178F\u17D2\u179A\u178A\u17C1"},{"id":4515,"word":"\u178F\u17D2\u179A\u178A\u17C1\u1794"},{"id":4516,"word":"\u178F\u17D2\u179A\u178A\u17C1\u179C"},{"id":4517,"word":"\u178F\u17D2\u179A\u178A\u17C1\u179C\u179C\u17B7\u1785"},{"id":4518,"word":"\u178F\u17D2\u179A\u178A\u17C2\u178F"},{"id":4519,"word":"\u178F\u17D2\u179A\u178A\u17C4\u1780"},{"id":4520,"word":"\u178F\u17D2\u179A\u178A\u17C4\u1780\u1780\u17D2\u178A\u17B6\u179A"},{"id":4521,"word":"\u178F\u17D2\u179A\u178A\u17C4\u1780\u1787\u17BE\u1784\u1785\u17C2\u179C"},{"id":4522,"word":"\u178F\u17D2\u179A\u178A\u17C4\u1798"},{"id":4523,"word":"\u178F\u17D2\u179A\u178A\u17C4\u17C7"},{"id":4524,"word":"\u178F\u17D2\u179A\u178E\u1798"},{"id":4525,"word":"\u178F\u17D2\u179A\u178E\u17B6\u1780\u17CB\u1785\u17B7\u178F\u17D2\u178F"},{"id":4526,"word":"\u178F\u17D2\u179A\u178E\u17C4\u178F"},{"id":4527,"word":"\u178F\u17D2\u179A\u178F\u17D7"},{"id":4528,"word":"\u178F\u17D2\u179A\u1790\u17BB\u1780"},{"id":4529,"word":"\u178F\u17D2\u179A\u1790\u17BF\u1784"},{"id":4530,"word":"\u178F\u17D2\u179A\u1794\u17CB"},{"id":4531,"word":"\u178F\u17D2\u179A\u1794\u17CB\u1791\u17BB\u17C6"},{"id":4532,"word":"\u178F\u17D2\u179A\u1794\u1780"},{"id":4533,"word":"\u178F\u17D2\u179A\u1794\u17C9\u1780\u17CB"},{"id":4534,"word":"\u178F\u17D2\u179A\u1794\u1780\u1788\u17BC\u1780"},{"id":4535,"word":"\u178F\u17D2\u179A\u1794\u17B6\u1780\u17CB"},{"id":4536,"word":"\u178F\u17D2\u179A\u1794\u17B6\u1789\u17CB"},{"id":4537,"word":"\u178F\u17D2\u179A\u1794\u17C9\u17C2"},{"id":4538,"word":"\u178F\u17D2\u179A\u1794\u17C2\u1780"},{"id":4539,"word":"\u178F\u17D2\u179A\u1794\u17C2\u1780\u1787\u17BC\u179A"},{"id":4540,"word":"\u178F\u17D2\u179A\u1794\u17C2\u1780\u1796\u17D2\u179A\u17C3"},{"id":4541,"word":"\u178F\u17D2\u179A\u1794\u17C2\u1784"},{"id":4542,"word":"\u178F\u17D2\u179A\u1794\u17C2\u1784\u178A\u17C3"},{"id":4543,"word":"\u178F\u17D2\u179A\u1794\u17C4\u1798"},{"id":4544,"word":"\u178F\u17D2\u179A\u1794\u17B6\u17C6\u1784\u1794\u17C7"},{"id":4545,"word":"\u178F\u17D2\u179A\u1794\u17C7"},{"id":4546,"word":"\u178F\u17D2\u179A\u1796\u17B9\u1793"},{"id":4547,"word":"\u178F\u17D2\u179A\u1796\u17C4\u1780"},{"id":4548,"word":"\u178F\u17D2\u179A\u1796\u17B6\u17C6\u1784"},{"id":4549,"word":"\u178F\u17D2\u179A\u1796\u17B6\u17C6\u1784\u1796\u17B6\u1799"},{"id":4550,"word":"\u178F\u17D2\u179A\u1798\u1780\u17CB"},{"id":4551,"word":"\u178F\u17D2\u179A\u1798\u1784\u17CB"},{"id":4552,"word":"\u178F\u17D2\u179A\u1798\u17BB\u179B"},{"id":4553,"word":"\u178F\u17D2\u179A\u1798\u17C0\u1785"},{"id":4554,"word":"\u178F\u17D2\u179A\u1798\u17C2\u1784"},{"id":4555,"word":"\u178F\u17D2\u179A\u1798\u17C4\u1784"},{"id":4556,"word":"\u178F\u17D2\u179A\u1798\u17C4\u1785"},{"id":4557,"word":"\u178F\u17D2\u179A\u1798\u17C4\u179B"},{"id":4558,"word":"\u178F\u17D2\u179A\u17D0\u1799"},{"id":4559,"word":"\u178F\u17D2\u179A\u1799\u1784"},{"id":4560,"word":"\u178F\u17D2\u179A\u1799\u1784\u17CB"},{"id":4561,"word":"\u178F\u17D2\u179A\u17D0\u1799\u178F\u17D2\u179A\u17B7\u1784\u17D2\u179F"},{"id":4562,"word":"\u178F\u17D2\u179A\u1799\u17BC\u1784"},{"id":4563,"word":"\u178F\u17D2\u179A\u1799\u17BC\u1784\u1785\u17C1\u1780"},{"id":4564,"word":"\u178F\u17D2\u179A\u179B\u17CB"},{"id":4565,"word":"\u178F\u17D2\u179A\u179B\u1794\u17CB"},{"id":4566,"word":"\u178F\u17D2\u179A\u179B\u17B6\u178F\u17CB"},{"id":4567,"word":"\u178F\u17D2\u179A\u179B\u17B7\u1793"},{"id":4568,"word":"\u178F\u17D2\u179A\u179B\u17BB\u1785"},{"id":4569,"word":"\u178F\u17D2\u179A\u179B\u17B6\u17C6\u1784"},{"id":4570,"word":"\u178F\u17D2\u179A\u179F\u17CB"},{"id":4571,"word":"\u178F\u17D2\u179A\u179F\u17D2\u178A\u17B7"},{"id":4572,"word":"\u178F\u17D2\u179A\u179F\u1780\u17CB"},{"id":4573,"word":"\u178F\u17D2\u179A\u179F\u1784"},{"id":4574,"word":"\u178F\u17D2\u179A\u179F\u17B6\u1794\u17CB"},{"id":4575,"word":"\u178F\u17D2\u179A\u179F\u17B6\u1799"},{"id":4576,"word":"\u178F\u17D2\u179A\u179F\u17B6\u179B\u17CB"},{"id":4577,"word":"\u178F\u17D2\u179A\u179F\u17BB\u1780"},{"id":4578,"word":"\u178F\u17D2\u179A\u179F\u17BB\u179B"},{"id":4579,"word":"\u178F\u17D2\u179A\u179F\u17BB\u179F"},{"id":4580,"word":"\u178F\u17D2\u179A\u179F\u17BC\u179B"},{"id":4581,"word":"\u178F\u17D2\u179A\u179F\u17C0\u1780"},{"id":4582,"word":"\u178F\u17D2\u179A\u179F\u17C1\u17C7"},{"id":4583,"word":"\u178F\u17D2\u179A\u179F\u17C2\u178F"},{"id":4584,"word":"\u178F\u17D2\u179A\u179F\u17C4\u1798"},{"id":4585,"word":"\u178F\u17D2\u179A\u179F\u17C4\u179B"},{"id":4586,"word":"\u178F\u17D2\u179A\u179F\u17BB\u17C6"},{"id":4587,"word":"\u178F\u17D2\u179A\u17A1\u1780"},{"id":4588,"word":"\u178F\u17D2\u179A\u17A1\u17B6\u1785"},{"id":4589,"word":"\u178F\u17D2\u179A\u17A1\u17B6\u1799"},{"id":4590,"word":"\u178F\u17D2\u179A\u17A1\u17BB\u1784"},{"id":4591,"word":"\u178F\u17D2\u179A\u17A1\u17C2\u1784\u1780\u17C2\u1784"},{"id":4592,"word":"\u178F\u17D2\u179A\u17A1\u17C4\u1780"},{"id":4593,"word":"\u178F\u17D2\u179A\u17A1\u17BB\u17C6"},{"id":4594,"word":"\u178F\u17D2\u179A\u17A2\u1780"},{"id":4595,"word":"\u178F\u17D2\u179A\u17A2\u17B6\u179B"},{"id":4596,"word":"\u178F\u17D2\u179A\u17A2\u17C0\u1793"},{"id":4597,"word":"\u178F\u17D2\u179A\u17A2\u17C1\u1780"},{"id":4598,"word":"\u178F\u17D2\u179A\u17B1\u1793"},{"id":4599,"word":"\u178F\u17D2\u179A\u17B6"},{"id":4600,"word":"\u178F\u17D2\u179A\u1780\u17CB"},{"id":4601,"word":"\u178F\u17D2\u179A\u17B6\u1780\u17CB\u17D7"},{"id":4602,"word":"\u178F\u17D2\u179A\u17B6\u1780\u17CB\u1791\u17D0\u179A"},{"id":4603,"word":"\u178F\u17D2\u179A\u17B6\u1784"},{"id":4604,"word":"\u178F\u17D2\u179A\u17B6\u1785"},{"id":4605,"word":"\u178F\u17D2\u179A\u17B6\u1785\u17CB"},{"id":4606,"word":"\u178F\u17D2\u179A\u17B6\u1787\u17BC"},{"id":4607,"word":"\u178F\u17D2\u179A\u17B6\u1789\u17CB"},{"id":4608,"word":"\u178F\u17D2\u179A\u17B6\u178E"},{"id":4609,"word":"\u178F\u17D2\u179A\u17B6\u178E\u178F\u17D2\u179A\u17BE\u1799"},{"id":4610,"word":"\u178F\u17D2\u179A\u17B6\u178F\u17C2"},{"id":4611,"word":"\u178F\u17D2\u179A\u17B6\u1794\u17CB"},{"id":4612,"word":"\u178F\u17D2\u179A\u17B6\u1799"},{"id":4613,"word":"\u178F\u17D2\u179A\u17B6\u179C"},{"id":4614,"word":"\u178F\u17D2\u179A\u17B6\u179F\u17CB"},{"id":4615,"word":"\u178F\u17D2\u179A\u17B7\u1794\u17B7\u178A\u1780"},{"id":4616,"word":"\u178F\u17D2\u179A\u17B7\u1799\u1784\u17D2\u179F"},{"id":4617,"word":"\u178F\u17D2\u179A\u17B7\u179B"},{"id":4618,"word":"\u178F\u17D2\u179A\u17B8"},{"id":4619,"word":"\u178F\u17D2\u179A\u17B8--"},{"id":4620,"word":"\u178F\u17D2\u179A\u17B8\u1798\u17BB\u1781"},{"id":4621,"word":"\u178F\u17D2\u179A\u17B8\u179C\u17B7\u179F\u17D0\u1799"},{"id":4622,"word":"\u178F\u17D2\u179A\u17B9\u1780"},{"id":4623,"word":"\u178F\u17D2\u179A\u17B9\u1780\u17D7"},{"id":4624,"word":"\u178F\u17D2\u179A\u17B9\u1784"},{"id":4625,"word":"\u178F\u17D2\u179A\u17B9\u1794"},{"id":4626,"word":"\u178F\u17D2\u179A\u17B9\u1798"},{"id":4627,"word":"\u178F\u17D2\u179A\u17BB\u1780\u17D7"},{"id":4628,"word":"\u178F\u17D2\u179A\u17BB\u178A"},{"id":4629,"word":"\u178F\u17D2\u179A\u17BB\u178A\u17B7"},{"id":4630,"word":"\u178F\u17D2\u179A\u17BB\u1793\u17D7"},{"id":4631,"word":"\u178F\u17D2\u179A\u17BB\u1799"},{"id":4632,"word":"\u178F\u17D2\u179A\u17BB\u179B"},{"id":4633,"word":"\u178F\u17D2\u179A\u17BB\u179B\u17D7"},{"id":4634,"word":"\u178F\u17D2\u179A\u17BC\u179B"},{"id":4635,"word":"\u178F\u17D2\u179A\u17BC\u179C"},{"id":4636,"word":"\u178F\u17D2\u179A\u17BD\u178F"},{"id":4637,"word":"\u178F\u17D2\u179A\u17BD\u178F\u178F\u17D2\u179A\u17B6"},{"id":4638,"word":"\u178F\u17D2\u179A\u17BD\u1799"},{"id":4639,"word":"\u178F\u17D2\u179A\u17BD\u179F"},{"id":4640,"word":"\u178F\u17D2\u179A\u17BD\u179F\u17D7"},{"id":4641,"word":"\u178F\u17D2\u179A\u17BE\u1784"},{"id":4642,"word":"\u178F\u17D2\u179A\u17BE\u1799"},{"id":4643,"word":"\u178F\u17D2\u179A\u17BE\u1799\u1786\u1780"},{"id":4644,"word":"\u178F\u17D2\u179A\u17BE\u1799\u178F\u17D2\u179A\u17B6\u178E"},{"id":4645,"word":"\u178F\u17D2\u179A\u17BE\u1799\u179B\u1799"},{"id":4646,"word":"\u178F\u17D2\u179A\u17C0\u1780"},{"id":4647,"word":"\u178F\u17D2\u179A\u17C0\u1794"},{"id":4648,"word":"\u178F\u17D2\u179A\u17C0\u1794\u178F\u17D2\u179A\u17B6"},{"id":4649,"word":"\u178F\u17D2\u179A\u17C0\u1798"},{"id":4650,"word":"\u178F\u17D2\u179A\u17C0\u179B"},{"id":4651,"word":"\u178F\u17D2\u179A\u17C1\u1780"},{"id":4652,"word":"\u178F\u17D2\u179A\u17C1\u1784"},{"id":4653,"word":"\u178F\u17D2\u179A\u17C1\u17C7\u178F\u17D2\u179A\u17BB\u17C7"},{"id":4654,"word":"\u178F\u17D2\u179A\u17C2"},{"id":4655,"word":"\u178F\u17D2\u179A\u17C2\u1784"},{"id":4656,"word":"\u178F\u17D2\u179A\u17C2\u178F\u17D7"},{"id":4657,"word":"\u178F\u17D2\u179A\u17C2\u178F\u178F\u17D2\u179A\u178F"},{"id":4658,"word":"\u178F\u17D2\u179A\u17C2\u17C7"},{"id":4659,"word":"\u178F\u17D2\u179A\u17C3"},{"id":4660,"word":"\u178F\u17D2\u179A\u17C3--"},{"id":4661,"word":"\u178F\u17D2\u179A\u17C4\u1780"},{"id":4662,"word":"\u178F\u17D2\u179A\u17C4\u1780\u1799\u17C4\u179B"},{"id":4663,"word":"\u178F\u17D2\u179A\u17C4\u1780\u179F\u17B6\u1789"},{"id":4664,"word":"\u178F\u17D2\u179A\u17C4\u179F"},{"id":4665,"word":"\u178F\u17D2\u179A\u17BB\u17C6"},{"id":4666,"word":"\u178F\u17D2\u179A\u17B6\u17C6"},{"id":4667,"word":"\u178F\u17D2\u179A\u17B6\u17C6\u1780\u1780\u17CB"},{"id":4668,"word":"\u178F\u17D2\u179A\u17B6\u17C6\u178F\u17D2\u179A\u17C2\u1784"},{"id":4669,"word":"\u178F\u17D2\u179B\u17B9\u1784"},{"id":4670,"word":"\u178F\u17D2\u179B\u17BB\u1780"},{"id":4671,"word":"\u178F\u17D2\u179B\u17BB\u1784"},{"id":4672,"word":"\u178F\u17D2\u179B\u17BB\u1798"},{"id":4673,"word":"\u178F\u17D2\u179B\u17C1\u179C"},{"id":4674,"word":"\u178F\u17D2\u179B\u17C2"},{"id":4675,"word":"\u178F\u17D2\u179B\u17C2\u178F"},{"id":4676,"word":"\u178F\u17D2\u179B\u17C4\u178F"},{"id":4677,"word":"\u178F\u17D2\u179B\u17BB\u17C6"},{"id":4678,"word":"\u178F\u17D2\u179C\u17B6"},{"id":4679,"word":"\u178F\u17D2\u179C\u17B6\u1784"},{"id":4680,"word":"\u178F\u17D2\u17A2\u17B9\u1784"},{"id":4681,"word":"\u178F\u17D2\u17A2\u17BC\u1789"},{"id":4682,"word":"\u178F\u17D2\u17A2\u17BC\u1789\u178F\u17D2\u17A2\u17C2\u179A"},{"id":4683,"word":"\u178F\u17D2\u17A2\u17BD"},{"id":4684,"word":"\u178F\u17D2\u17A2\u17BD\u179A"},{"id":4685,"word":"\u178F\u17D2\u17A2\u17BE\u1780"},{"id":4686,"word":"\u178F\u1798\u178F\u17D2\u1790\u17C6"},{"id":4687,"word":"\u178F\u17BB\u1780\u17D2\u1780\u178F\u17B6"},{"id":4688,"word":"\u178F\u17C6\u178E\u17B7\u1785"},{"id":4689,"word":"\u178F\u17C6\u178E\u17B9\u1784"},{"id":4690,"word":"\u178F\u17C6\u178E\u17C4\u1784"},{"id":4691,"word":"\u178F\u17C6\u1793\u17BF"},{"id":4692,"word":"\u178F\u17C6\u1793\u17BF\u1793"},{"id":4693,"word":"\u178F\u17D2\u179A\u17A0\u17C1\u1794\u178F\u17D2\u179A\u17A0\u1794"},{"id":4694,"word":"\u1790"},{"id":4695,"word":"\u1790\u1784"},{"id":4696,"word":"\u1790\u1784\u17CB"},{"id":4697,"word":"\u1790\u17C8\u178E\u17B6\u1799"},{"id":4698,"word":"\u1790\u1784\u1798\u17BD\u1793"},{"id":4699,"word":"\u1790\u1784\u1799\u17C9\u178F"},{"id":4700,"word":"\u1790\u1784\u1799\u1793\u17CB"},{"id":4701,"word":"\u1790\u1784\u1799\u17B7\u1794"},{"id":4702,"word":"\u1790\u1784\u17CB\u179A\u1784"},{"id":4703,"word":"\u1790\u178F"},{"id":4704,"word":"\u1790\u1793\u17C8"},{"id":4705,"word":"\u1790\u1793\u17B7\u1780\u179F\u178F\u17D2\u179C"},{"id":4706,"word":"\u1790\u1794\u17CB"},{"id":4707,"word":"\u1790\u1798\u1790\u1799"},{"id":4708,"word":"\u1790\u1799"},{"id":4709,"word":"\u1790\u1799\u17A0\u17D2\u179B\u17D0\u1784"},{"id":4710,"word":"\u1790\u179B\u1787\u179B\u17B7\u1780"},{"id":4711,"word":"\u1790\u179B\u1794\u1790"},{"id":4712,"word":"\u1790\u179B\u1798\u1782\u17D2\u1782"},{"id":4713,"word":"\u1790\u179B\u1799\u17B6\u1793"},{"id":4714,"word":"\u1790\u179B\u1799\u17B6\u178F\u17D2\u179A\u17B6"},{"id":4715,"word":"\u1790\u179C\u17B7\u1780\u17B6"},{"id":4716,"word":"\u1790\u17B6"},{"id":4717,"word":"\u1790\u17B6\u1790\u17B6\u1784"},{"id":4718,"word":"\u1790\u17B6\u1794\u17CB"},{"id":4719,"word":"\u1790\u17B6\u1798\u1796\u179B"},{"id":4720,"word":"\u1790\u17B6\u1798\u1797\u17B6\u1796"},{"id":4721,"word":"\u1790\u17B6\u1798\u1798\u17B6\u178F\u17D2\u179A"},{"id":4722,"word":"\u1790\u17B6\u1798\u179C\u1793\u17D2\u178F"},{"id":4723,"word":"\u1790\u17B6\u179C"},{"id":4724,"word":"\u1790\u17B6\u179C\u179A\u17C8"},{"id":4725,"word":"\u1790\u17B6\u179C\u179A\u1780\u1798\u17D2\u1798"},{"id":4726,"word":"\u1790\u17B6\u179C\u179A\u179C\u178F\u17D2\u1790\u17BB"},{"id":4727,"word":"\u1790\u17B6\u179F"},{"id":4728,"word":"\u1790\u17B7\u179A\u1797\u17B6\u1796"},{"id":4729,"word":"\u1790\u17B7\u179A\u179C\u17C1\u179B\u17B6"},{"id":4730,"word":"\u1790\u17B7\u179A\u17B6\u1799\u17BB"},{"id":4731,"word":"\u1790\u17B8"},{"id":4732,"word":"\u1790\u17B8?"},{"id":4733,"word":"\u1790\u17B8\u1793\u1798\u17B7\u1791\u17D2\u1792"},{"id":4734,"word":"\u1790\u17BB\u1785!"},{"id":4735,"word":"\u1790\u17BC"},{"id":4736,"word":"\u1790\u17BC\u1793"},{"id":4737,"word":"\u1790\u17BD"},{"id":4738,"word":"\u1790\u17BD\u1793"},{"id":4739,"word":"\u1790\u17BD\u1793"},{"id":4740,"word":"\u1790\u17BE\u1794"},{"id":4741,"word":"\u1790\u17BF\u1780"},{"id":4742,"word":"\u1790\u17C1\u1799\u17D2\u1799\u179F\u17C6\u179C\u17B6\u179F"},{"id":4743,"word":"\u1790\u17C1\u1799\u17D2\u1799\u179F\u17C6\u179C\u17B6\u179F\u1780\u17C8"},{"id":4744,"word":"\u1790\u17C1\u179A"},{"id":4745,"word":"\u1790\u17C1\u179A\u17C8"},{"id":4746,"word":"\u1790\u17C1\u179A\u1797\u17B6\u1796"},{"id":4747,"word":"\u1790\u17C1\u179A\u1797\u17BC\u1798\u17B7"},{"id":4748,"word":"\u1790\u17C1\u179A\u179C\u17B6\u1791"},{"id":4749,"word":"\u1790\u17C1\u179A\u179C\u17B6\u1791\u17B8"},{"id":4750,"word":"\u1790\u17C1\u179A\u17B6\u1793\u17BB\u178F\u17D2\u1790\u17C1\u179A\u17C8"},{"id":4751,"word":"\u1790\u17C1\u179A\u17B8"},{"id":4752,"word":"\u1790\u17C2"},{"id":4753,"word":"\u1790\u17C2\u1791\u17B6\u17C6"},{"id":4754,"word":"\u1790\u17C2\u1794"},{"id":4755,"word":"\u1790\u17C2\u1798"},{"id":4756,"word":"\u1790\u17C2\u179C"},{"id":4757,"word":"\u1790\u17C3"},{"id":4758,"word":"\u1790\u17C3\u17A0\u17D2\u179B\u17D0\u1784"},{"id":4759,"word":"\u1790\u17C4"},{"id":4760,"word":"\u1790\u17C4\u1780"},{"id":4761,"word":"\u1790\u17C4\u1798\u1793\u17B6\u1780\u17B6\u179A"},{"id":4762,"word":"\u1790\u17C4\u1798\u1797\u17B6\u1796"},{"id":4763,"word":"\u1790\u17C4\u1798\u179C\u17B6\u1791"},{"id":4764,"word":"\u1790\u17C4\u1798\u179C\u17B6\u1791\u17B8"},{"id":4765,"word":"\u1790\u17C4\u1798\u179C\u17B6\u1791\u17B7\u1793\u17B8"},{"id":4766,"word":"\u1790\u17C4\u17C7"},{"id":4767,"word":"\u1790\u17C5\u1780\u17C2"},{"id":4768,"word":"\u1790\u17C5\u17A1\u17B7\u1784"},{"id":4769,"word":"\u1790\u17B6\u17C6"},{"id":4770,"word":"\u1790\u17B6\u17C6\u1784"},{"id":4771,"word":"\u1790\u17D2\u1780\u179A"},{"id":4772,"word":"\u1790\u17D2\u1780\u179B\u17CB"},{"id":4773,"word":"\u1790\u17D2\u1780\u17B6\u178F\u17CB"},{"id":4774,"word":"\u1790\u17D2\u1780\u17B6\u1793"},{"id":4775,"word":"\u1790\u17D2\u1780\u17B6\u1794\u17CB"},{"id":4776,"word":"\u1790\u17D2\u1780\u17B6\u179F"},{"id":4777,"word":"\u1790\u17D2\u1780\u17BC\u179C"},{"id":4778,"word":"\u1790\u17D2\u1780\u17BE\u1784"},{"id":4779,"word":"\u1790\u17D2\u1780\u17C0\u1794"},{"id":4780,"word":"\u1790\u17D2\u1780\u17C4\u179B"},{"id":4781,"word":"\u1790\u17D2\u1780\u17C6"},{"id":4782,"word":"\u1790\u17D2\u1782\u17B6\u1798"},{"id":4783,"word":"\u1790\u17D2\u1782\u17C4\u179B"},{"id":4784,"word":"\u1790\u17D2\u1784"},{"id":4785,"word":"\u1790\u17D2\u1784\u1794"},{"id":4786,"word":"\u1790\u17D2\u1784\u17B6\u1793\u17CB"},{"id":4787,"word":"\u1790\u17D2\u1784\u17B6\u179F"},{"id":4788,"word":"\u1790\u17D2\u1784\u17B7\u1785\u1790\u17D2\u1784\u179A"},{"id":4789,"word":"\u1790\u17D2\u1784\u17BB\u1784"},{"id":4790,"word":"\u1790\u17D2\u1784\u17BB\u1789"},{"id":4791,"word":"\u1790\u17D2\u1784\u17BB\u1799"},{"id":4792,"word":"\u1790\u17D2\u1784\u17BC\u179A"},{"id":4793,"word":"\u1790\u17D2\u1784\u17BC\u179C"},{"id":4794,"word":"\u1790\u17D2\u1784\u17BD\u1785"},{"id":4795,"word":"\u1790\u17D2\u1784\u17C3"},{"id":4796,"word":"\u1790\u17D2\u178A\u17C4\u1780"},{"id":4797,"word":"\u1790\u17D2\u178A\u17C4\u1780\u1780\u17D2\u178A\u17B6\u179A"},{"id":4798,"word":"\u1790\u17D2\u178A\u17C4\u1780\u1787\u17BE\u1784\u1785\u17C2\u179C"},{"id":4799,"word":"\u1790\u17D2\u1793\u1780\u17CB"},{"id":4800,"word":"\u1790\u17D2\u1793\u1784"},{"id":4801,"word":"\u1790\u17D2\u1793\u1798"},{"id":4802,"word":"\u1790\u17D2\u1793\u179A"},{"id":4803,"word":"\u1790\u17D2\u1793\u179B\u17CB"},{"id":4804,"word":"\u1790\u17D2\u1793\u179B\u17CB\u1791\u1791\u17B9\u1784"},{"id":4805,"word":"\u1790\u17D2\u1793\u17B6\u1780\u17CB"},{"id":4806,"word":"\u1790\u17D2\u1793\u17B6\u1780\u17CB\u1790\u17D2\u1793\u1798"},{"id":4807,"word":"\u1790\u17D2\u1793\u17B6\u1780\u17CB\u1790\u17D2\u1793\u179B\u17CB"},{"id":4808,"word":"\u1790\u17D2\u1793\u17B6\u1780\u17CB\u1790\u17D2\u1793\u17B6\u17C6\u1784"},{"id":4809,"word":"\u1790\u17D2\u1793\u17B6\u179B"},{"id":4810,"word":"\u1790\u17D2\u1793\u17B6\u179F"},{"id":4811,"word":"\u1790\u17D2\u1793\u17B7\u178F"},{"id":4812,"word":"\u1790\u17D2\u1793\u17B9\u1780"},{"id":4813,"word":"\u1790\u17D2\u1793\u17B9\u1784"},{"id":4814,"word":"\u1790\u17D2\u1793\u17BC\u179A"},{"id":4815,"word":"\u1790\u17D2\u1793\u17C1\u179A"},{"id":4816,"word":"\u1790\u17D2\u1793\u17C4\u179B"},{"id":4817,"word":"\u1790\u17D2\u1793\u17B6\u17C6"},{"id":4818,"word":"\u1790\u17D2\u1793\u17B6\u17C6\u1784"},{"id":4819,"word":"\u1790\u17D2\u1793\u17B6\u17C6\u1784\u1790\u17D2\u1793\u17B6\u1780\u17CB"},{"id":4820,"word":"\u1790\u17D2\u1793\u17C7"},{"id":4821,"word":"\u1790\u17D2\u1796\u1780\u17CB"},{"id":4822,"word":"\u1790\u17D2\u1796\u1784"},{"id":4823,"word":"\u1790\u17D2\u1796\u17B6\u179B\u17CB"},{"id":4824,"word":"\u1790\u17D2\u1796\u17B7\u1793"},{"id":4825,"word":"\u1790\u17D2\u1796\u17B9\u1793"},{"id":4826,"word":"\u1790\u17D2\u1796\u17BC\u178F"},{"id":4827,"word":"\u1790\u17D2\u1796\u17C1\u1785"},{"id":4828,"word":"\u1790\u17D2\u1796\u17C2\u1780"},{"id":4829,"word":"\u1790\u17D2\u1798"},{"id":4830,"word":"\u1790\u17D2\u1798\u17B6\u178F\u17CB"},{"id":4831,"word":"\u1790\u17D2\u1798\u17B6\u179A"},{"id":4832,"word":"\u1790\u17D2\u1798\u17B8"},{"id":4833,"word":"\u1790\u17D2\u1798\u17BE\u179A"},{"id":4834,"word":"\u1790\u17D2\u1798\u17BE\u179A\u1787\u17BE\u1784"},{"id":4835,"word":"\u1790\u17D2\u1798\u17BE\u179A\u1791\u17C1\u179F"},{"id":4836,"word":"\u1790\u17D2\u1798\u17BE\u179A\u1796\u17D2\u179A\u17C3"},{"id":4837,"word":"\u1790\u17D2\u1798\u17C2"},{"id":4838,"word":"\u1790\u17D2\u1798\u17C4\u1784"},{"id":4839,"word":"\u1790\u17D2\u179B\u1784\u17CB"},{"id":4840,"word":"\u1790\u17D2\u179B\u17B6"},{"id":4841,"word":"\u1790\u17D2\u179B\u17B6\u1784"},{"id":4842,"word":"\u1790\u17D2\u179B\u17B6\u1789\u17CB"},{"id":4843,"word":"\u1790\u17D2\u179B\u17B6\u1793\u17CB"},{"id":4844,"word":"\u1790\u17D2\u179B\u17B9\u1784"},{"id":4845,"word":"\u1790\u17D2\u179B\u17BB\u1780"},{"id":4846,"word":"\u1790\u17D2\u179B\u17BE\u1784"},{"id":4847,"word":"\u1790\u17D2\u179B\u17BE\u1798"},{"id":4848,"word":"\u1790\u17D2\u179B\u17BE\u1798\u17A2\u178E\u17D2\u178A\u17BE\u1780"},{"id":4849,"word":"\u1790\u17D2\u179B\u17C2\u1784"},{"id":4850,"word":"\u1790\u17D2\u179B\u17C2\u1793"},{"id":4851,"word":"\u1790\u17D2\u179B\u17C3"},{"id":4852,"word":"\u1790\u17D2\u179B\u17C3\u1790\u17D2\u1793\u17BC\u179A"},{"id":4853,"word":"\u1790\u17D2\u179B\u17C4\u179F"},{"id":4854,"word":"\u1790\u17D2\u179B\u17C4\u17C7"},{"id":4855,"word":"\u1790\u17D2\u179B\u17C4\u17C7\u1792\u17D2\u179B\u17C4\u1799"},{"id":4856,"word":"\u1790\u17D2\u179C\u17B6\u1780"},{"id":4857,"word":"\u1790\u17D2\u179C\u17B6\u1784"},{"id":4858,"word":"\u1790\u17D2\u179C\u17B6\u178F\u17CB"},{"id":4859,"word":"\u1790\u17D2\u179C\u17B6\u1799"},{"id":4860,"word":"\u1790\u17D2\u179C\u17B6\u1799\u1794\u1784\u17D2\u1782\u17C6"},{"id":4861,"word":"\u1790\u17D2\u179C\u17B7\u1785"},{"id":4862,"word":"\u1790\u17D2\u179C\u17B8!"},{"id":4863,"word":"\u1790\u17D2\u179C\u17B8\u1782\u17C6\u1793\u17B7\u178F"},{"id":4864,"word":"\u1790\u17D2\u179C\u17B8\u178A\u17C3"},{"id":4865,"word":"\u1790\u17D2\u179C\u17B8\u1794\u17BE"},{"id":4866,"word":"\u1790\u17D2\u179C\u17B8\u1798\u17B6\u178F\u17CB"},{"id":4867,"word":"\u1790\u17D2\u179C\u17B8\u17A0\u17C8\u1790\u17D2\u179C\u17B8\u17A0\u17BE\u1799?"},{"id":4868,"word":"\u1790\u17D2\u179C\u17BA\u1799!"},{"id":4869,"word":"\u1790\u17D2\u179C\u17C2"},{"id":4870,"word":"\u1791"},{"id":4871,"word":"\u1791\u1780"},{"id":4872,"word":"\u1791\u1780\u17CB"},{"id":4873,"word":"\u1791\u1780\u17B6\u179F\u17D0\u1799"},{"id":4874,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u1791\u17B7\u179F"},{"id":4875,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u1793\u17B7\u1780\u17B6\u1799"},{"id":4876,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17B6\u1791\u17B6\u1793"},{"id":4877,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17B6\u1793\u17BB\u1791\u17B7\u179F"},{"id":4878,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17B6\u1793\u17BB\u1794\u17D2\u1794\u1791\u17B6\u1793"},{"id":4879,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17B6\u1796\u17D0\u178F\u17CC"},{"id":4880,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17B6\u179C\u178A\u17D2\u178A"},{"id":4881,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17C1\u1799\u17D2\u1799\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":4882,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17C1\u1799\u17D2\u1799\u179F\u1798\u17D2\u1794\u1791\u17B6"},{"id":4883,"word":"\u1791\u1780\u17D2\u1781\u17B7\u178E\u17C4\u1791\u1780"},{"id":4884,"word":"\u1791\u1780\u17D2\u179F\u17B7\u178E"},{"id":4885,"word":"\u1791\u1780\u17D2\u179F\u17B7\u178E\u17C4\u1791\u1780"},{"id":4886,"word":"\u1791\u1784"},{"id":4887,"word":"\u1791\u1784\u1780\u1793\u17D2\u178F\u17D2\u179A\u17C3"},{"id":4888,"word":"\u1791\u1784\u1782\u1793\u17D2\u179B\u1784"},{"id":4889,"word":"\u1791\u1784\u178F\u17D2\u179A\u179F\u1780\u17CB"},{"id":4890,"word":"\u1791\u1784\u178F\u17D2\u179A\u17B6"},{"id":4891,"word":"\u1791\u1784\u178F\u17D2\u179A\u17C5"},{"id":4892,"word":"\u1791\u1784\u1794\u1784\u17D2\u17A0\u17BD\u179A"},{"id":4893,"word":"\u1791\u1784\u179C\u1784"},{"id":4894,"word":"\u1791\u1784\u17CB"},{"id":4895,"word":"\u1791\u1784\u17CB\u1787\u17D0\u1799"},{"id":4896,"word":"\u1791\u1784\u17D2\u1782\u178F\u17CB"},{"id":4897,"word":"\u17A2\u1784\u17D2\u1782\u17B7\u1785"},{"id":4898,"word":"\u1791\u1784\u17D2\u1782\u17B9\u17C7"},{"id":4899,"word":"\u1791\u1784\u17D2\u1782\u17BB\u1780"},{"id":4900,"word":"\u1791\u1784\u17D2\u1782\u17BE"},{"id":4901,"word":"\u1791\u1784\u17D2\u1782\u17C4\u179B"},{"id":4902,"word":"\u1791\u1784\u17D2\u1782\u17BB\u17C6"},{"id":4903,"word":"\u1791\u1784\u17D2\u1782\u17C7"},{"id":4904,"word":"\u1791\u1784\u17CB\u178A\u17C2\u1784"},{"id":4905,"word":"\u1791\u1784\u17CB\u1791\u17B6\u1789"},{"id":4906,"word":"\u1791\u1784\u17CB\u17A0\u17CA\u17D2\u179C\u17B6"},{"id":4907,"word":"\u1791\u1785\u17CB"},{"id":4908,"word":"\u1791\u1789\u17CB"},{"id":4909,"word":"\u1791\u178E\u17D2\u178C"},{"id":4910,"word":"\u1791\u178E\u17D2\u178C\u1780\u1798\u17D2\u1798"},{"id":4911,"word":"\u1791\u178E\u17D2\u178C\u1780\u1798\u17D2\u1798\u1793\u17B6\u179F\u1793\u17B6"},{"id":4912,"word":"\u1791\u178E\u17D2\u178C\u1783\u17B6\u178A"},{"id":4913,"word":"\u1791\u178F"},{"id":4914,"word":"\u1791\u1791\u178F\u17CB"},{"id":4915,"word":"\u1791\u1791\u17D0\u179A"},{"id":4916,"word":"\u1791\u1791\u17B6"},{"id":4917,"word":"\u1791\u1791\u17B6\u1780\u17CB"},{"id":4918,"word":"\u1791\u1791\u17B6\u1780\u17CB\u1791\u1791\u17B6\u1798"},{"id":4919,"word":"\u1791\u1791\u17B6\u179A"},{"id":4920,"word":"\u1791\u1791\u17B6\u179F\u17CB\u1791\u1791\u17C2\u1784"},{"id":4921,"word":"\u1791\u1791\u17B8\u1791\u1791\u17D0\u179A"},{"id":4922,"word":"\u1791\u1791\u17B8\u1784\u1791\u1791\u17B6\u1784"},{"id":4923,"word":"\u1791\u1791\u17B8\u1798\u1791\u1791\u17B6\u1798"},{"id":4924,"word":"\u1791\u1791\u17B8\u1798\u1791\u1791\u17BE\u1798"},{"id":4925,"word":"\u1791\u1791\u17B8\u179F\u1791\u1791\u17B6\u179F"},{"id":4926,"word":"\u1791\u1791\u17B9\u1780"},{"id":4927,"word":"\u1791\u1791\u17B9\u1784"},{"id":4928,"word":"\u1791\u1791\u17B9\u1784\u1782\u17B6\u1784"},{"id":4929,"word":"\u1791\u1791\u17B9\u1784\u1790\u17D2\u1784\u17C3"},{"id":4930,"word":"\u1791\u1791\u17B9\u1784\u1791\u1791\u17C2\u1784"},{"id":4931,"word":"\u1791\u1791\u17B9\u1784\u1791\u17B7\u179F"},{"id":4932,"word":"\u1791\u1791\u17B9\u1798"},{"id":4933,"word":"\u1791\u1791\u17BC\u1785"},{"id":4934,"word":"\u1791\u1791\u17BC\u179A"},{"id":4935,"word":"\u1791\u1791\u17BD\u179B"},{"id":4936,"word":"\u1791\u1791\u17BD\u179B\u1791\u17B6\u1793"},{"id":4937,"word":"\u1791\u1791\u17BE\u1798"},{"id":4938,"word":"\u1791\u1791\u17BE\u179F\u1791\u1791\u17C2\u1784"},{"id":4939,"word":"\u1791\u1791\u17C1"},{"id":4940,"word":"\u1791\u1791\u17C2"},{"id":4941,"word":"\u1791\u1791\u17C4\u1780"},{"id":4942,"word":"\u1791\u1791\u17C7"},{"id":4943,"word":"\u1791\u1791\u17D2\u179A\u178F"},{"id":4944,"word":"\u1791\u1791\u17D2\u179A\u1794"},{"id":4945,"word":"\u1791\u1791\u17D2\u179A\u1798"},{"id":4946,"word":"\u1791\u1791\u17D2\u179A\u17B6\u1780\u17CB"},{"id":4947,"word":"\u1791\u1791\u17D2\u179A\u17B8\u1794\u1791\u1791\u17D2\u179A\u1794"},{"id":4948,"word":"\u1791\u1791\u17D2\u179A\u17B8\u1794\u1791\u1791\u17D2\u179A\u17B6\u1794"},{"id":4949,"word":"\u1791\u1791\u17D2\u179A\u17B8\u1798\u1791\u1791\u17D2\u179A\u1798"},{"id":4950,"word":"\u1791\u1791\u17D2\u179A\u17B9\u1794"},{"id":4951,"word":"\u1791\u1791\u17D2\u179A\u17BE\u1780"},{"id":4952,"word":"\u1791\u1791\u17D2\u179A\u17BE\u178F"},{"id":4953,"word":"\u1791\u1791\u17D2\u179A\u17C1\u178F\u1791\u1791\u17D2\u179A\u17C4\u178F"},{"id":4954,"word":"\u1791\u1791\u17D2\u179A\u17C2\u1798\u1791\u1791\u17D2\u179A\u1798"},{"id":4955,"word":"\u1791\u1792\u17B6\u1780\u17CB"},{"id":4956,"word":"\u1791\u1792\u17B7"},{"id":4957,"word":"\u1791\u1793\u17CB"},{"id":4958,"word":"\u1791\u1793\u17CB\u178A\u17B8"},{"id":4959,"word":"\u1791\u1793\u17CB\u1797\u17D2\u179B\u1793\u17CB"},{"id":4960,"word":"\u1791\u1793\u17D2\u178F"},{"id":4961,"word":"\u1791\u1793\u17D2\u178F\u1780\u1798\u17D2\u1798"},{"id":4962,"word":"\u1791\u1793\u17D2\u178F\u1780\u17B6\u179A"},{"id":4963,"word":"\u1791\u1793\u17D2\u178F\u1787"},{"id":4964,"word":"\u1791\u1793\u17D2\u178F\u1792\u17B6\u178F\u17BB"},{"id":4965,"word":"\u1791\u1793\u17D2\u178F\u1796\u17C1\u1791\u17D2\u1799"},{"id":4966,"word":"\u1791\u1793\u17D2\u178F\u1798\u17D0\u1799"},{"id":4967,"word":"\u1791\u1793\u17D2\u178F\u179C\u17C1\u1787\u17D2\u1787\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":4968,"word":"\u1791\u1793\u17D2\u178F\u17D2\u179A\u17C6"},{"id":4969,"word":"\u1791\u1793\u17D2\u1790\u17BE\u1793"},{"id":4970,"word":"\u1791\u1793\u17D2\u1791\u1794"},{"id":4971,"word":"\u1791\u1793\u17D2\u1791\u17B6\u1793\u17CB"},{"id":4972,"word":"\u1791\u1793\u17D2\u1791\u17B7\u1789"},{"id":4973,"word":"\u1791\u1793\u17D2\u1791\u17B9\u1784"},{"id":4974,"word":"\u1791\u1793\u17D2\u1791\u17B9\u1798"},{"id":4975,"word":"\u1791\u1793\u17D2\u1791\u17BC\u179A"},{"id":4976,"word":"\u1791\u1793\u17D2\u1791\u17C1\u1784"},{"id":4977,"word":"\u1791\u1793\u17D2\u1791\u17C1\u1789"},{"id":4978,"word":"\u1791\u1793\u17D2\u1791\u17B6\u17C6"},{"id":4979,"word":"\u1791\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1793"},{"id":4980,"word":"\u1791\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1793\u1781\u17C1\u178F\u17D2\u178F"},{"id":4981,"word":"\u1791\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1798"},{"id":4982,"word":"\u1791\u1793\u17D2\u179B\u17B6"},{"id":4983,"word":"\u1791\u1793\u17D2\u179B\u17B6\u1780\u17CB"},{"id":4984,"word":"\u1791\u1793\u17D2\u179B\u17B6\u1794\u17CB"},{"id":4985,"word":"\u1791\u1793\u17D2\u179B\u17B8\u1784"},{"id":4986,"word":"\u1791\u1793\u17D2\u179B\u17C1"},{"id":4987,"word":"\u1791\u1793\u17D2\u179B\u17C1\u178F\u17BC\u1785"},{"id":4988,"word":"\u1791\u1793\u17D2\u179B\u17C1\u1792\u17C6"},{"id":4989,"word":"\u1791\u1793\u17D2\u179B\u17C1\u1794\u17B6\u1791\u17B8"},{"id":4990,"word":"\u1791\u1793\u17D2\u179B\u17C1\u179A\u1796\u17C5"},{"id":4991,"word":"\u1791\u1793\u17D2\u179B\u17C1\u179F\u17B6\u1794"},{"id":4992,"word":"\u1791\u1793\u17D2\u179F\u1784"},{"id":4993,"word":"\u1791\u1793\u17D2\u179F\u17B6"},{"id":4994,"word":"\u1791\u1793\u17D2\u179F\u17B6\u1799"},{"id":4995,"word":"\u1791\u1793\u17D2\u179F\u17C2"},{"id":4996,"word":"\u1791\u1793\u17D2\u179F\u17C4\u1784"},{"id":4997,"word":"\u1791\u1794\u17CB"},{"id":4998,"word":"\u1791\u1794\u17CB\u1791\u179B\u17CB"},{"id":4999,"word":"\u1791\u17C8\u1794\u17B6\u1793"},{"id":5000,"word":"\u1791\u17D0\u1796"},{"id":5001,"word":"\u1791\u1796\u17D2\u179C\u17C8"},{"id":5002,"word":"\u1791\u1796\u17D2\u179C\u179F\u1798\u17D2\u1797\u17B6\u179A\u17C8"},{"id":5003,"word":"\u1791\u1798"},{"id":5004,"word":"\u1791\u1798\u17D0\u1780"},{"id":5005,"word":"\u1791\u1798\u1797\u17B6\u1796"},{"id":5006,"word":"\u1791\u1798\u17B7\u17A1"},{"id":5007,"word":"\u1791\u1798\u17D2\u1784\u1793\u17CB"},{"id":5008,"word":"\u1791\u1798\u17D2\u179A"},{"id":5009,"word":"\u1791\u1798\u17D2\u179A\u1784\u17CB"},{"id":5010,"word":"\u1791\u1798\u17D2\u179A\u1784\u17CB\u1780\u17B6\u179A"},{"id":5011,"word":"\u1791\u1798\u17D2\u179A\u1784\u17CB\u179F\u17D0\u1780\u17D2\u178A\u17B7"},{"id":5012,"word":"\u1791\u1798\u17D2\u179A\u1793\u17CB"},{"id":5013,"word":"\u1791\u1798\u17D2\u179A\u1798"},{"id":5014,"word":"\u1791\u1798\u17D2\u179A\u17B9\u1784"},{"id":5015,"word":"\u1791\u1798\u17D2\u179A\u17BB\u178C"},{"id":5016,"word":"\u1791\u1798\u17D2\u179A\u17BE\u179F"},{"id":5017,"word":"\u1791\u1798\u17D2\u179A\u17C1\u178F"},{"id":5018,"word":"\u1791\u1798\u17D2\u179A\u17C1\u179B"},{"id":5019,"word":"\u1791\u1798\u17D2\u179A\u17C4\u1794"},{"id":5020,"word":"\u1791\u1798\u17D2\u179A\u17C4\u1798"},{"id":5021,"word":"\u1791\u1798\u17D2\u179A\u17B6\u17C6"},{"id":5022,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1780\u17CB"},{"id":5023,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1780\u17CB--"},{"id":5024,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1794\u17CB"},{"id":5025,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1799"},{"id":5026,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1799\u179A\u178F"},{"id":5027,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1799\u179F\u17D2\u1798\u1784"},{"id":5028,"word":"\u1791\u1798\u17D2\u179B\u17B6\u1799\u17A2\u17B6\u1780\u17B6\u179F"},{"id":5029,"word":"\u1791\u1798\u17D2\u179B\u17BB\u17C7"},{"id":5030,"word":"\u1791\u1799"},{"id":5031,"word":"\u1791\u179A"},{"id":5032,"word":"\u1791\u179B\u17CB"},{"id":5033,"word":"\u1791\u179B\u17CB"},{"id":5034,"word":"\u1791\u179B\u17CB\u1795\u17D2\u17A2\u1780"},{"id":5035,"word":"\u1791\u179B\u17CB\u17A2\u1784\u17D2\u179A\u17C2"},{"id":5036,"word":"\u1791\u17D0\u179B"},{"id":5037,"word":"\u1791\u179B\u17B7\u1791\u17D2\u1791"},{"id":5038,"word":"\u1791\u179B\u17B7\u1791\u17D2\u1791\u1797\u17B6\u1796"},{"id":5039,"word":"\u1791\u179F"},{"id":5040,"word":"\u1791\u179F\u17CB"},{"id":5041,"word":"\u1791\u179F--"},{"id":5042,"word":"\u1791\u179F\u179C\u178F\u17D2\u179F\u179A\u17CD"},{"id":5043,"word":"\u1791\u179F\u17D2\u179F\u1793"},{"id":5044,"word":"\u1791\u179F\u17D2\u179F\u1793--"},{"id":5045,"word":"\u1791\u17A1\u17D2\u17A0"},{"id":5046,"word":"\u1791\u17A1\u17D2\u17A0\u17C8"},{"id":5047,"word":"\u1791\u17A1\u17D2\u17A0\u1780\u17B6\u179A\u17B8"},{"id":5048,"word":"\u1791\u17A1\u17D2\u17A0\u1794\u17D2\u179A\u17A0\u17B6\u179A"},{"id":5049,"word":"\u1791\u17A1\u17D2\u17A0\u1798\u17B7\u178F\u17D2\u178F"},{"id":5050,"word":"\u1791\u17A1\u17D2\u17A0\u17B8\u1780\u1798\u17D2\u1798"},{"id":5051,"word":"\u1791\u17A1\u17D2\u17A0\u17B8\u1780\u179A\u178E\u17C8"},{"id":5052,"word":"\u1791\u17B6"},{"id":5053,"word":"\u1791\u17B6\u1780"},{"id":5054,"word":"\u1791\u17B6\u1780\u17CB"},{"id":5055,"word":"\u1791\u17B6\u1780\u17CB\u1791\u1784"},{"id":5056,"word":"\u1791\u17B6\u1780\u17CB\u1791\u17B6\u1798"},{"id":5057,"word":"\u1791\u17B6\u1780\u17CB\u1791\u17B7\u1793"},{"id":5058,"word":"\u1791\u17B6\u1784"},{"id":5059,"word":"\u1791\u17B6\u1785"},{"id":5060,"word":"\u1791\u17B6\u1789"},{"id":5061,"word":"\u1791\u17B6\u1789\u1791\u1784\u17CB"},{"id":5062,"word":"\u1791\u17B6\u1789\u1796\u17D2\u179A\u17D0\u178F\u17D2\u179A"},{"id":5063,"word":"\u1791\u17B6\u178B\u1792\u17B6\u178F\u17BB"},{"id":5064,"word":"\u1791\u17B6\u178B\u17B6"},{"id":5065,"word":"\u1791\u17B6\u178B\u17B6\u1792\u17B6\u178F\u17BB"},{"id":5066,"word":"\u1791\u17B6\u178F\u17CB"},{"id":5067,"word":"\u1791\u17B6\u1793"},{"id":5068,"word":"\u1791\u17B6\u1793--"},{"id":5069,"word":"\u1791\u17B6\u1793\u17CB"},{"id":5070,"word":"\u1791\u17B6\u1793\u17CB\u17A0\u1793\u17CB"},{"id":5071,"word":"\u1791\u17B6\u1794"},{"id":5072,"word":"\u1791\u17B6\u1798"},{"id":5073,"word":"\u1791\u17B6\u1798\u1791\u17B6\u179A"},{"id":5074,"word":"\u1791\u17B6\u1799"},{"id":5075,"word":"\u1791\u17B6\u1799\u1780"},{"id":5076,"word":"\u1791\u17B6\u1799\u1780 \u179F\u1798\u17B6\u1787\u17B7\u1780"},{"id":5077,"word":"\u1791\u17B6\u1799\u1796\u1793\u17D2\u1792\u17BB"},{"id":5078,"word":"\u1791\u17B6\u1799\u1797\u17B6\u1782"},{"id":5079,"word":"\u1791\u17B6\u1799\u179C\u17B7\u1797\u17B6\u1782"},{"id":5080,"word":"\u1791\u17B6\u1799\u17B6\u1791"},{"id":5081,"word":"\u1791\u17B6\u1799\u17B7\u1780\u17B6"},{"id":5082,"word":"\u1791\u17B6\u1799\u17B8"},{"id":5083,"word":"\u1791\u17B6\u179A"},{"id":5084,"word":"\u1791\u17B6\u179A\u1780"},{"id":5085,"word":"\u1791\u17B6\u179A\u179F\u1784\u17D2\u179A\u17D2\u1782\u17C4\u17C7"},{"id":5086,"word":"\u1791\u17B6\u179A\u17B6"},{"id":5087,"word":"\u1791\u17B6\u179A\u17B6\u1792\u17B8\u1793"},{"id":5088,"word":"\u1791\u17B6\u179A\u17B6\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":5089,"word":"\u1791\u17B6\u179A\u17B7\u1780\u17B6"},{"id":5090,"word":"\u1791\u17B6\u179A\u17BB\u1780\u1798\u17D2\u1798"},{"id":5091,"word":"\u1791\u17B6\u179A\u17BB\u178E"},{"id":5092,"word":"\u1791\u17B6\u179A\u17BB\u178E\u1780\u1798\u17D2\u1798"},{"id":5093,"word":"\u1791\u17B6\u179A\u17BB\u178E\u1797\u17B6\u1796"},{"id":5094,"word":"\u1791\u17B6\u179A\u17BB\u1798\u17D0\u1799"},{"id":5095,"word":"\u1791\u17B6\u179B"},{"id":5096,"word":"\u1791\u17B6\u179B\u17CB"},{"id":5097,"word":"\u1791\u17B6\u179B\u17CB\u178F\u17C2"},{"id":5098,"word":"\u1791\u17B6\u179F"},{"id":5099,"word":"\u1791\u17B6\u179F\u17CB"},{"id":5100,"word":"\u1791\u17B6\u179F\u17B8"},{"id":5101,"word":"\u1791\u17B6\u17A0\u17B6\u1793"},{"id":5102,"word":"\u1791\u17B7\u1782\u1798\u17D2\u1796\u179A"},{"id":5103,"word":"\u1791\u17B7\u1784\u1791\u17B6\u17C6\u1784"},{"id":5104,"word":"\u1791\u17B7\u1785"},{"id":5105,"word":"\u1791\u17B7\u1789"},{"id":5106,"word":"\u1791\u17B7\u178A\u17D2\u178B\u1792\u1798\u17D2\u1798"},{"id":5107,"word":"\u1791\u17B7\u178A\u17D2\u178B\u1792\u1798\u17D2\u1798\u17B7\u1780"},{"id":5108,"word":"\u1791\u17B7\u178A\u17D2\u178B\u1792\u1798\u17D2\u1798\u17B7\u1780\u1794\u17D2\u179A\u1799\u17C4\u1787\u1793\u17CD"},{"id":5109,"word":"\u1791\u17B7\u178A\u17D2\u178B\u1792\u1798\u17CC"},{"id":5110,"word":"\u1791\u17B7\u178A\u17D2\u178B\u1797\u17B6\u1796"},{"id":5111,"word":"\u1791\u17B7\u178A\u17D2\u178B\u1798\u178F\u17D2\u178F"},{"id":5112,"word":"\u1791\u17B7\u178A\u17D2\u178B\u17B6\u1780\u17B6\u179A"},{"id":5113,"word":"\u1791\u17B7\u178A\u17D2\u178B\u17B6\u1793\u17BB\u1782\u178F\u17B7"},{"id":5114,"word":"\u1791\u17B7\u178A\u17D2\u178B\u17B7"},{"id":5115,"word":"\u1791\u17B7\u178A\u17D2\u178B\u17B7\u179C\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":5116,"word":"\u1791\u17B7\u178A\u17D2\u178B\u17B7\u179F\u1798\u17D2\u1794\u178F\u17D2\u178F\u17B7"},{"id":5117,"word":"\u1791\u17B7\u178A\u17D2\u178B\u17BB\u1787\u17BB\u1780\u1798\u17D2\u1798"},{"id":5118,"word":"\u1791\u17B7\u178F\u17C0\u1793"},{"id":5119,"word":"\u1791\u17B7\u1793"},{"id":5120,"word":"\u1791\u17B7\u1793\u1780\u179A"},{"id":5121,"word":"\u1791\u17B7\u1793\u1780\u17D2\u179F\u17D0\u1799"},{"id":5122,"word":"\u1791\u17B7\u1793\u1794\u178F\u17B8"},{"id":5123,"word":"\u1791\u17B7\u1793\u1794\u17D2\u179A\u1797\u17B6"},{"id":5124,"word":"\u1791\u17B7\u1793\u1798\u178E\u17B8"},{"id":5125,"word":"\u1791\u17B7\u1793\u1798\u17BB\u1781"},{"id":5126,"word":"\u1791\u17B7\u1793\u179A\u178F\u17D2\u1793"},{"id":5127,"word":"\u1791\u17B7\u1793\u17B6\u1793\u17BB\u1794\u17D2\u1794\u179C\u178F\u17D2\u178F\u17B7"},{"id":5128,"word":"\u1791\u17B7\u1793\u17B6\u1793\u17BB\u1794\u17D2\u179A\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7"},{"id":5129,"word":"\u1791\u17B7\u1793\u17B6\u1793\u17BB\u179B\u17C1\u1781\u1793\u17CD"},{"id":5130,"word":"\u1791\u17B7\u1793\u17B6\u179C\u179F\u17B6\u1793"},{"id":5131,"word":"\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799"},{"id":5132,"word":"\u1791\u17B7\u1793\u17D2\u1793\u1797\u178E\u17D2\u178C"},{"id":5133,"word":"\u1791\u17B7\u1793\u17D2\u1793\u179C\u178F\u17D2\u1790\u17BB"},{"id":5134,"word":"\u1791\u17B7\u1793\u17D2\u1793\u17B6\u1791\u17B6\u1799\u17B8"},{"id":5135,"word":"\u1791\u17B7\u1793\u17D2\u1793\u17B6\u1791\u17B6\u1799\u17B7\u1793\u17B8"},{"id":5136,"word":"\u1791\u17B7\u1793\u17B7\u1780\u1787\u1793"},{"id":5137,"word":"\u1791\u17B7\u1793\u17B7\u1780\u17B6"},{"id":5138,"word":"\u1791\u17B7\u1796\u17D2\u179C"},{"id":5139,"word":"\u1791\u17B7\u1796\u17D2\u179C--"},{"id":5140,"word":"\u1791\u17B7\u1796\u17D2\u1799"},{"id":5141,"word":"\u1791\u17B7\u179B"},{"id":5142,"word":"\u1791\u17B7\u179C\u1784\u17D2\u1782\u178F"},{"id":5143,"word":"\u1791\u17B7\u179C\u17D0\u1793"},{"id":5144,"word":"\u1791\u17B7\u179C\u179F\u1797\u17B6\u1782"},{"id":5145,"word":"\u1791\u17B7\u179C\u17B6"},{"id":5146,"word":"\u1791\u17B7\u179C\u17B6\u1780\u179A"},{"id":5147,"word":"\u1791\u17B7\u179C\u17B6\u1785\u179A"},{"id":5148,"word":"\u1791\u17B7\u179C\u17C4\u1780\u17D0\u179F"},{"id":5149,"word":"\u1791\u17B7\u179F"},{"id":5150,"word":"\u1791\u17B7\u179F\u17B6"},{"id":5151,"word":"\u1791\u17B7\u179F\u17B6\u1793\u17BB\u1791\u17B7\u179F"},{"id":5152,"word":"\u1791\u17B7\u179F\u17B6\u1794\u17B6\u1798\u17C4\u1780\u17D2\u1781"},{"id":5153,"word":"\u1791\u17B7\u179F\u17B6\u1797\u17B6\u1782"},{"id":5154,"word":"\u1791\u17B8"},{"id":5155,"word":"\u1791\u17B8\u1780\u17C4"},{"id":5156,"word":"\u1791\u17B8\u1780\u17D2\u179F\u17B6"},{"id":5157,"word":"\u1791\u17B8\u1783"},{"id":5158,"word":"\u1791\u17B8\u1783--"},{"id":5159,"word":"\u1791\u17B8\u1784"},{"id":5160,"word":"\u1791\u17B8\u1784\u1791\u17B6\u1784"},{"id":5161,"word":"\u1791\u17B8\u1784\u1791\u17B6\u17C6\u1784"},{"id":5162,"word":"\u1791\u17B8\u1784\u1798\u17C4\u1784"},{"id":5163,"word":"\u1791\u17B8\u1791\u17BB\u1799"},{"id":5164,"word":"\u1791\u17B8\u1791\u17BB\u1799\u1796\u17BE\u178F\u1796\u17BE\u1784"},{"id":5165,"word":"\u1791\u17B8\u1791\u17BE\u179A"},{"id":5166,"word":"\u1791\u17B8\u1791\u17C3"},{"id":5167,"word":"\u1791\u17B8\u1793\u17D0\u1784"},{"id":5168,"word":"\u1791\u17B8\u1796\u17C4"},{"id":5169,"word":"\u1791\u17B8\u1798\u1791\u17B6\u1798"},{"id":5170,"word":"\u1791\u17B8\u179C"},{"id":5171,"word":"\u1791\u17B9\u1780"},{"id":5172,"word":"\u1791\u17B9\u1780--"},{"id":5173,"word":"\u1791\u17B9\u1780\u1792\u17D2\u179B\u17B6\u1780\u17CB"},{"id":5174,"word":"\u1791\u17B9\u1780\u1794\u17B6\u1780\u17CB"},{"id":5175,"word":"\u1791\u17B9\u1784"},{"id":5176,"word":"\u1791\u17B9\u1784\u1791\u17B6\u17C6\u1784"},{"id":5177,"word":"\u1791\u17B9\u1784\u1798\u17B9\u1784"},{"id":5178,"word":"\u1791\u17B9\u1794"},{"id":5179,"word":"\u1791\u17B9\u1798"},{"id":5180,"word":"\u1791\u17B9\u179B"},{"id":5181,"word":"\u1791\u17B9\u179B"},{"id":5182,"word":"\u1791\u17BA\u1784"},{"id":5183,"word":"\u1791\u17BA\u1791\u17C2"},{"id":5184,"word":"\u1791\u17BA\u17C7"},{"id":5185,"word":"\u1791\u17BB\u1780"},{"id":5186,"word":"\u1791\u17BB\u1780\u1785\u17B7\u178F\u17D2\u178F"},{"id":5187,"word":"\u1791\u17BB\u1780\u1787\u17B6"},{"id":5188,"word":"\u1791\u17BB\u1780\u178A\u17B6\u1780\u17CB"},{"id":5189,"word":"\u1791\u17BB\u1780\u1791\u17D2\u179A\u17BC"},{"id":5190,"word":"\u1791\u17BB\u1780\u1794\u17B6\u178F\u17D2\u179A"},{"id":5191,"word":"\u1791\u17BB\u1780\u17BC\u179B\u1796\u179F\u17D2\u178F\u17D2\u179A"},{"id":5192,"word":"\u1791\u17BB\u1780\u17BC\u179B\u1797\u179F\u17D2\u178F\u17D2\u179A"},{"id":5193,"word":"\u1791\u17BB\u1780\u17D2\u1780\u178A"},{"id":5194,"word":"\u1791\u17BB\u1780\u17D2\u1780\u179A\u17C8"},{"id":5195,"word":"\u1791\u17BB\u1780\u17D2\u1781"},{"id":5196,"word":"\u1791\u17BB\u1780\u17D2\u1781"},{"id":5197,"word":"\u1791\u17BB\u1780\u17D2\u1781\u17C6"},{"id":5198,"word":"\u1791\u17BB\u1782\u17D2\u1782\u178F"},{"id":5199,"word":"\u1791\u17BB\u1782\u17D2\u1782\u178F--"},{"id":5200,"word":"\u1791\u17BB\u1782\u17D2\u1782\u178F\u17B7"},{"id":5201,"word":"\u1791\u17BB\u1782\u17D2\u1782\u178F\u17B7"},{"id":5202,"word":"\u1791\u17BB\u1784"},{"id":5203,"word":"\u1791\u17BB\u1784\u17D7"},{"id":5204,"word":"\u1791\u17BB\u1785\u17D2\u1785\u179A\u17B7\u178F"},{"id":5205,"word":"\u1791\u17BB\u1785\u17D2\u1786\u1793\u17D2\u1791\u17C8"},{"id":5206,"word":"\u1791\u17BB\u178F\u17B7\u1799"},{"id":5207,"word":"\u1791\u17BB\u178F\u17B7\u1799\u179F\u1784\u17D2\u1782\u17B6\u1799\u1793\u17B6"},{"id":5208,"word":"\u1791\u17BB\u178F\u17B7\u1799\u17B6"},{"id":5209,"word":"\u1791\u17BB\u178F\u17B7\u1799\u17B6"},{"id":5210,"word":"\u1791\u17BB\u178F\u17B7\u1799\u17B6\u179F\u17B6\u178D"},{"id":5211,"word":"\u1791\u17BB\u1791\u17D2\u1791\u17B7\u178A\u17D2\u178B\u17B7\u1793\u17B7\u1799\u1798"},{"id":5212,"word":"\u1791\u17BB\u1793"},{"id":5213,"word":"\u1791\u17BB\u1796\u17D2\u179C\u1785\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":5214,"word":"\u1791\u17BB\u1796\u17D2\u179C\u179B"},{"id":5215,"word":"\u1791\u17BB\u1796\u17D2\u179C\u179B\u1797\u17B6\u1796"},{"id":5216,"word":"\u1791\u17BB\u1796\u17D2\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":5217,"word":"\u1791\u17BB\u1796\u17D2\u1797\u17B6\u179F\u17B7\u178F"},{"id":5218,"word":"\u1791\u17BB\u1796\u17D2\u1797\u17B7\u1780\u17D2\u1781"},{"id":5219,"word":"\u1791\u17BB\u1796\u17D2\u1797\u17B7\u1780\u17D2\u1781\u1780\u17B6\u179B"},{"id":5220,"word":"\u1791\u17BB\u1796\u17D2\u1797\u17B7\u1780\u17D2\u1781\u1797\u17D0\u1799"},{"id":5221,"word":"\u1791\u17BB\u1796\u17D2\u1797\u17B7\u1780\u17D2\u1781\u179F\u1798\u17D0\u1799"},{"id":5222,"word":"\u1791\u17BB\u1799\u1798\u17BB\u1799"},{"id":5223,"word":"\u1791\u17BB\u179A\u1782\u178F"},{"id":5224,"word":"\u1791\u17BB\u179A\u1782\u1798"},{"id":5225,"word":"\u1791\u17BB\u179A\u1787\u1793"},{"id":5226,"word":"\u1791\u17BB\u179A\u1793\u17CB"},{"id":5227,"word":"\u1791\u17BB\u179A\u1796\u179B"},{"id":5228,"word":"\u1791\u17BB\u179A\u1797\u17B7\u1780\u17D2\u179F"},{"id":5229,"word":"\u1791\u17BB\u179A\u1799\u179F"},{"id":5230,"word":"\u1791\u17BB\u179A\u17B6"},{"id":5231,"word":"\u1791\u17BB\u179A\u17B6\u1782\u1798\u1793\u17CD"},{"id":5232,"word":"\u1791\u17BB\u179A\u17B6\u1785\u17B6\u179A"},{"id":5233,"word":"\u1791\u17BB\u179A\u17C1\u1793"},{"id":5234,"word":"\u1791\u17BB\u1782\u17CC\u178F"},{"id":5235,"word":"\u1791\u17BB\u1782\u17CC\u1798"},{"id":5236,"word":"\u1791\u17BB\u1787\u17CC\u1793"},{"id":5237,"word":"\u1791\u17BB\u1796\u17CC\u179B"},{"id":5238,"word":"\u1791\u17BB\u179A\u17D2\u1797\u17B7\u1780\u17D2\u179F"},{"id":5239,"word":"\u1791\u17BB\u1799\u17CC\u179F"},{"id":5240,"word":"\u1791\u17BB\u179B"},{"id":5241,"word":"\u1791\u17BB\u179B\u17A0\u17CA\u17C2\u1794\u17D7"},{"id":5242,"word":"\u1791\u17BB\u179B\u17D2\u179B\u1797\u17C8"},{"id":5243,"word":"\u1791\u17BB\u179B\u17D2\u179B\u1797--"},{"id":5244,"word":"\u1791\u17BB\u179F\u17D2\u179F\u1780\u17BB\u178A\u17B7"},{"id":5245,"word":"\u1791\u17BC"},{"id":5246,"word":"\u1791\u17BC"},{"id":5247,"word":"\u1791\u17BC\u1780"},{"id":5248,"word":"\u1791\u17BC\u1784"},{"id":5249,"word":"\u1791\u17BC\u1785"},{"id":5250,"word":"\u1791\u17BC\u1789"},{"id":5251,"word":"\u1791\u17BC\u1789\u1791\u17B6\u1789"},{"id":5252,"word":"\u1791\u17BC\u1789\u1794\u17BC\u1789"},{"id":5253,"word":"\u1791\u17BC\u178F"},{"id":5254,"word":"\u1791\u17BC\u178F\u1780\u17D2\u179A\u17B7\u1799\u17B6"},{"id":5255,"word":"\u1791\u17BC\u178F\u17B6\u1793\u17BB\u1791\u17BC\u178F"},{"id":5256,"word":"\u1791\u17BC\u1791\u17D0\u179A"},{"id":5257,"word":"\u1791\u17BC\u1791\u17B6\u178F\u17CB"},{"id":5258,"word":"\u1791\u17BC\u1791\u17B9\u1798"},{"id":5259,"word":"\u1791\u17BC\u1791\u17BB\u1780\u17D2\u1781"},{"id":5260,"word":"\u1791\u17BC\u1791\u17C5"},{"id":5261,"word":"\u1791\u17BC\u179A"},{"id":5262,"word":"\u1791\u17BC\u179A\u1793\u17CB"},{"id":5263,"word":"\u1791\u17BC\u179A\u1782\u1798\u1793\u17B6\u1782\u1798\u1793\u17CD"},{"id":5264,"word":"\u1791\u17BC\u179A\u178A\u17D2\u178B\u17B6\u1793"},{"id":5265,"word":"\u1791\u17BC\u179A\u1791\u179F\u17D2\u179F\u1793\u17CD"},{"id":5266,"word":"\u1791\u17BC\u179A\u179B\u17C1\u1781"},{"id":5267,"word":"\u1791\u17BC\u179A\u179F\u17D0\u1796\u17D2\u1791"},{"id":5268,"word":"\u1791\u17BC\u179B"},{"id":5269,"word":"\u1791\u17BC\u179B\u1796\u17D2\u179A\u17C7\u1794\u1784\u17D2\u1782\u17C6"},{"id":5270,"word":"\u1791\u17BC\u179B\u17B6\u1799"},{"id":5271,"word":"\u1791\u17BC\u179B\u17C6"},{"id":5272,"word":"\u1791\u17BD\u1784"},{"id":5273,"word":"\u1791\u17BD\u1789"},{"id":5274,"word":"\u1791\u17BD\u178F"},{"id":5275,"word":"\u1791\u17BD\u1791\u17D0\u179A"},{"id":5276,"word":"\u1791\u17BD\u1791\u17C5"},{"id":5277,"word":"\u1791\u17BD\u1793"},{"id":5278,"word":"\u1791\u17BD\u1798"},{"id":5279,"word":"\u1791\u17BD\u179B"},{"id":5280,"word":"\u1791\u17BE\u1780\u1798\u1798\u17BE\u1780"},{"id":5281,"word":"\u1791\u17BE\u1784"},{"id":5282,"word":"\u1791\u17BE\u1784\u1798\u17BE\u1784"},{"id":5283,"word":"\u1791\u17BE\u178F"},{"id":5284,"word":"\u1791\u17BE\u178F\u1791\u17BE\u1784"},{"id":5285,"word":"\u1791\u17BE\u1794"},{"id":5286,"word":"\u1791\u17BE\u1798\u17D7"},{"id":5287,"word":"\u1791\u17BE\u179A"},{"id":5288,"word":"\u1791\u17C0\u1784"},{"id":5289,"word":"\u1791\u17C0\u1784--"},{"id":5290,"word":"\u1791\u17C0\u178F"},{"id":5291,"word":"\u1791\u17C0\u1793"},{"id":5292,"word":"\u1791\u17C0\u1793\u1780\u179B\u17D2\u1794"},{"id":5293,"word":"\u1791\u17C0\u1793\u1782\u17C4\u179B"},{"id":5294,"word":"\u1791\u17C0\u1793\u1787\u17D0\u1799"},{"id":5295,"word":"\u1791\u17C0\u1793\u179C\u179F\u17D2\u179F\u17B6"},{"id":5296,"word":"\u1791\u17C0\u1794"},{"id":5297,"word":"\u1791\u17C0\u1794\u1780\u17C4\u17C7"},{"id":5298,"word":"\u1791\u17C0\u179C"},{"id":5299,"word":"\u1791\u17C1"},{"id":5300,"word":"\u1791\u17C1\u1789"},{"id":5301,"word":"\u1791\u17C1\u178F\u17BE"},{"id":5302,"word":"\u1791\u17C1\u178F\u17D2\u1799"},{"id":5303,"word":"\u1791\u17C1\u1791\u17BE\u179A"},{"id":5304,"word":"\u1791\u17C1\u1796"},{"id":5305,"word":"\u1791\u17C1\u1796--"},{"id":5306,"word":"\u1791\u17C1\u1796\u17D2\u178A\u17B6"},{"id":5307,"word":"\u1791\u17C1\u1796\u17B8"},{"id":5308,"word":"\u1791\u17C1\u1796\u17D2\u179A\u1780\u17D2\u179F"},{"id":5309,"word":"\u1791\u17C1\u1799\u17D2\u1799\u1791\u17B6\u1793"},{"id":5310,"word":"\u1791\u17C1\u1799\u17D2\u1799\u1792\u1798\u17CC"},{"id":5311,"word":"\u1791\u17C1\u1799\u17D2\u1799\u179C\u178F\u17D2\u1790\u17BB"},{"id":5312,"word":"\u1791\u17C1\u179A"},{"id":5313,"word":"\u1791\u17C1\u179C"},{"id":5314,"word":"\u1791\u17C1\u179C--"},{"id":5315,"word":"\u1791\u17C1\u179C\u1791\u178F\u17D2\u178F"},{"id":5316,"word":"\u1791\u17C1\u179C\u17B7\u1793\u17D2\u1791"},{"id":5317,"word":"\u1791\u17C1\u179C\u17B8"},{"id":5318,"word":"\u1791\u17C1\u179F"},{"id":5319,"word":"\u1791\u17C1\u179F\u1780\u17B6\u179B"},{"id":5320,"word":"\u1791\u17C1\u179F\u1785\u179A"},{"id":5321,"word":"\u1791\u17C1\u179F\u1785\u179A\u178E\u17CD"},{"id":5322,"word":"\u1791\u17C1\u179F\u1792\u1798\u17CC"},{"id":5323,"word":"\u1791\u17C1\u179F\u1793\u17CD"},{"id":5324,"word":"\u1791\u17C1\u179F\u1793\u17B6"},{"id":5325,"word":"\u1791\u17C1\u179F\u1797\u17B6\u1796"},{"id":5326,"word":"\u1791\u17C1\u179F\u17B6\u1797\u17B7\u1794\u17B6\u179B"},{"id":5327,"word":"\u1791\u17C1\u179F\u17D2\u1793\u17B6"},{"id":5328,"word":"\u1791\u17C1\u17A0\u17C8?"},{"id":5329,"word":"\u1791\u17C1\u17A0\u1780\u17D2\u179F\u17D0\u1799"},{"id":5330,"word":"\u1791\u17C2\u1784"},{"id":5331,"word":"\u1791\u17C2\u1793"},{"id":5332,"word":"\u1791\u17C2\u1793\u1791\u1799"},{"id":5333,"word":"\u1791\u17C2\u1796"},{"id":5334,"word":"\u1791\u17C2\u179B\u1798\u17C9\u17BC\u179C"},{"id":5335,"word":"\u1791\u17C2\u179B\u1798\u17C2\u179B"},{"id":5336,"word":"\u1791\u17C2\u17C7"},{"id":5337,"word":"\u1791\u17C3"},{"id":5338,"word":"\u1791\u17C3\u1782\u17D2\u179A\u17BC"},{"id":5339,"word":"\u1791\u17C4"},{"id":5340,"word":"\u1791\u17C4\u1784"},{"id":5341,"word":"\u1791\u17C4\u1785"},{"id":5342,"word":"\u1791\u17C4\u1785\u1780\u17D2\u179A\u1799\u17B6\u1793"},{"id":5343,"word":"\u1791\u17C4\u178E"},{"id":5344,"word":"\u1791\u17C4\u1798"},{"id":5345,"word":"\u1791\u17C4\u1798\u1793\u179F\u17D2\u179F"},{"id":5346,"word":"\u1791\u17C4\u179A"},{"id":5347,"word":"\u1791\u17C4\u179B"},{"id":5348,"word":"\u1791\u17C4\u179F"},{"id":5349,"word":"\u1791\u17C4\u179F\u17D0\u1780"},{"id":5350,"word":"\u1791\u17C4\u179F\u1780\u17B6\u179A\u178E\u17CD"},{"id":5351,"word":"\u1791\u17C4\u179F\u1785\u179A\u17B7\u178F"},{"id":5352,"word":"\u1791\u17C4\u179F\u1785\u17B7\u178F\u17D2\u178F"},{"id":5353,"word":"\u1791\u17C4\u179F\u1789\u17D2\u1789\u17BC"},{"id":5354,"word":"\u1791\u17C4\u179F\u1796\u17C3\u179A\u17CD"},{"id":5355,"word":"\u1791\u17C4\u179F\u1798\u17BC\u179B"},{"id":5356,"word":"\u1791\u17C4\u179F\u17B6\u1782\u178F\u17B7"},{"id":5357,"word":"\u1791\u17C4\u179F\u17B6\u1793\u17BB\u1791\u17C4\u179F"},{"id":5358,"word":"\u1791\u17C4\u179F\u17C4"},{"id":5359,"word":"\u1791\u17C4\u17C7"},{"id":5360,"word":"\u1791\u17C4\u17C7\u1787\u17B6"},{"id":5361,"word":"\u1791\u17C4\u17C7\u1794\u17B8"},{"id":5362,"word":"\u1791\u17C4\u17C7\u1794\u17B8\u1787\u17B6"},{"id":5363,"word":"\u1791\u17C4\u17C7\u1794\u17B8\u1794\u17BE"},{"id":5364,"word":"\u1791\u17C5"},{"id":5365,"word":"\u1791\u17C5\u17CF!"},{"id":5366,"word":"\u1791\u17BB\u17C6"},{"id":5367,"word":"\u1791\u17BB\u17C6\u1791\u17C1\u179F"},{"id":5368,"word":"\u1791\u17BB\u17C6\u17A0\u17BC"},{"id":5369,"word":"\u1791\u17C6"},{"id":5370,"word":"\u1791\u17C6\u1793\u1784"},{"id":5371,"word":"\u1791\u17C6\u1793\u1784\u1787\u17B6"},{"id":5372,"word":"\u1791\u17C6\u1793\u1789\u17CB"},{"id":5373,"word":"\u1791\u17C6\u1793\u178F\u1796\u17D2\u179A\u17C7\u1793\u17C1\u178F\u17D2\u179A"},{"id":5374,"word":"\u1791\u17C6\u1793\u1794\u17CB"},{"id":5375,"word":"\u1791\u17C6\u1793\u17B6\u1780\u17CB"},{"id":5376,"word":"\u1791\u17C6\u1793\u17B6\u1789"},{"id":5377,"word":"\u1791\u17C6\u1793\u17B6\u1793\u17CB"},{"id":5378,"word":"\u1791\u17C6\u1793\u17B6\u1794"},{"id":5379,"word":"\u1791\u17C6\u1793\u17B6\u1799"},{"id":5380,"word":"\u1791\u17C6\u1793\u17B6\u179B\u17CB"},{"id":5381,"word":"\u1791\u17C6\u1793\u17B6\u179F\u17CB"},{"id":5382,"word":"\u1791\u17C6\u1793\u17B7\u1789"},{"id":5383,"word":"\u1791\u17C6\u1793\u17B9\u1798"},{"id":5384,"word":"\u1791\u17C6\u1793\u17B9\u1798\u1791\u17C6\u1793\u17C0\u1798"},{"id":5385,"word":"\u1791\u17C6\u1793\u17BB\u1780"},{"id":5386,"word":"\u1791\u17C6\u1793\u17BB\u1780\u1794\u1798\u17D2\u179A\u17BB\u1784"},{"id":5387,"word":"\u1791\u17C6\u1793\u17BC\u179B"},{"id":5388,"word":"\u1791\u17C6\u1793\u17BD\u1789"},{"id":5389,"word":"\u1791\u17C6\u1793\u17BD\u179B"},{"id":5390,"word":"\u1791\u17C6\u1793\u17BE\u1784"},{"id":5391,"word":"\u1791\u17C6\u1793\u17BE\u1794"},{"id":5392,"word":"\u1791\u17C6\u1793\u17C0\u1794"},{"id":5393,"word":"\u1791\u17C6\u1793\u17BE\u179A"},{"id":5394,"word":"\u1791\u17C6\u1793\u17C0\u1798"},{"id":5395,"word":"\u1791\u17C6\u1793\u17C1\u179A"},{"id":5396,"word":"\u1791\u17C6\u1796\u17D0\u179A"},{"id":5397,"word":"\u1791\u17C6\u1796\u17B6"},{"id":5398,"word":"\u1791\u17C6\u1796\u17BB\u1793"},{"id":5399,"word":"\u1791\u17C6\u1796\u17BC\u1784"},{"id":5400,"word":"\u1791\u17C6\u1796\u17BD\u1793"},{"id":5401,"word":"\u1791\u17C6\u1796\u17C2\u1780"},{"id":5402,"word":"\u1791\u17C6\u1796\u17C4\u17C7"},{"id":5403,"word":"\u1791\u17C6\u1796\u17B6\u17C6\u1784"},{"id":5404,"word":"\u1791\u17C6\u1796\u17B6\u17C6\u1784\u1787\u17BC\u179A"},{"id":5405,"word":"\u1791\u17C6\u1799\u17BE"},{"id":5406,"word":"\u1791\u17C6\u17A0\u17B6\u178F\u17CB"},{"id":5407,"word":"\u1791\u17C6\u17A0\u17B9\u1784"},{"id":5408,"word":"\u1791\u17C6\u17A0\u17BD\u1793"},{"id":5409,"word":"\u1791\u17C6\u17A0\u17C1\u1784"},{"id":5410,"word":"\u1791\u17C6\u17A0\u17C2\u1784"},{"id":5411,"word":"\u1791\u17C6\u17A0\u17C6"},{"id":5412,"word":"\u1791\u17B6\u17C6"},{"id":5413,"word":"\u1791\u17B6\u17C6\u17D7"},{"id":5414,"word":"\u1791\u17B6\u17C6\u1784"},{"id":5415,"word":"\u1791\u17B6\u17C6\u1784\u17D7"},{"id":5416,"word":"\u1791\u17B6\u17C6\u1784\u1796\u17BD\u1784"},{"id":5417,"word":"\u1791\u17B6\u17C6\u1784\u1798\u17BC\u179B"},{"id":5418,"word":"\u1791\u17B6\u17C6\u1784\u179F\u17D2\u179A\u17BB\u1784"},{"id":5419,"word":"\u1791\u17B6\u17C6\u1784\u17A0\u17D2\u179B\u17B6\u1799"},{"id":5420,"word":"\u1791\u17B6\u17C6\u1784\u17A1\u17B6\u1799"},{"id":5421,"word":"\u1791\u17B6\u17C6\u1798\u17B8\u1784"},{"id":5422,"word":"\u1791\u17C7"},{"id":5423,"word":"\u1791\u17C7\u1780\u17B6\u1785\u17CB"},{"id":5424,"word":"\u1791\u17D2\u179A"},{"id":5425,"word":"\u1791\u17D2\u179A\u1782\u17C4\u17C7"},{"id":5426,"word":"\u1791\u17D2\u179A\u1784\u17CB"},{"id":5427,"word":"\u1791\u17D2\u179A\u1784\u17CB\u1791\u17D2\u179A\u17B6\u1799"},{"id":5428,"word":"\u1791\u17D2\u179A\u1784\u17B6\u1784"},{"id":5429,"word":"\u1791\u17D2\u179A\u1784\u17BE\u1784"},{"id":5430,"word":"\u1791\u17D2\u179A\u1784\u17BE\u179B"},{"id":5431,"word":"\u1791\u17D2\u179A\u178F\u17D7"},{"id":5432,"word":"\u1791\u17D2\u179A\u1791\u17BC\u1784"},{"id":5433,"word":"\u1791\u17D2\u179A\u1791\u17BD\u1799"},{"id":5434,"word":"\u1791\u17D2\u179A\u1791\u17C1\u179F"},{"id":5435,"word":"\u1791\u17D2\u179A\u1791\u17C1\u179F\u1791\u17D2\u179A\u1791\u1793\u17CB"},{"id":5436,"word":"\u1791\u17D2\u179A\u1791\u17C1\u179F\u1791\u17D2\u179A\u1791\u17BD\u1799"},{"id":5437,"word":"\u1791\u17D2\u179A\u1791\u17D2\u179A\u1784\u17CB"},{"id":5438,"word":"\u1791\u17D2\u179A\u1793\u1784\u17CB"},{"id":5439,"word":"\u1791\u17D2\u179A\u1793\u179B\u17CB"},{"id":5440,"word":"\u1791\u17D2\u179A\u1793\u17B6\u1794\u17CB"},{"id":5441,"word":"\u1791\u17D2\u179A\u1793\u17B6\u1794\u17CB\u1787\u17BE\u1784"},{"id":5442,"word":"\u1791\u17D2\u179A\u1793\u17B7\u1785"},{"id":5443,"word":"\u1791\u17D2\u179A\u1793\u17B9\u1794"},{"id":5444,"word":"\u1791\u17D2\u179A\u1793\u17BB\u1784"},{"id":5445,"word":"\u1791\u17D2\u179A\u1793\u17BB\u179B"},{"id":5446,"word":"\u1791\u17D2\u179A\u1793\u17BC\u179B"},{"id":5447,"word":"\u1791\u17D2\u179A\u1793\u17BE\u179A"},{"id":5448,"word":"\u1791\u17D2\u179A\u1793\u17C1\u179B"},{"id":5449,"word":"\u1791\u17D2\u179A\u1793\u17C1\u179F"},{"id":5450,"word":"\u1791\u17D2\u179A\u1793\u17C6"},{"id":5451,"word":"\u1791\u17D2\u179A\u1793\u17C6\u179B\u179B\u1780"},{"id":5452,"word":"\u1791\u17D2\u179A\u1794\u17D7"},{"id":5453,"word":"\u1791\u17D2\u179A\u1796\u1784"},{"id":5454,"word":"\u1791\u17D2\u179A\u1796\u17D2\u1799"},{"id":5455,"word":"\u1791\u17D2\u179A\u1796\u17D2\u1799\u17B6"},{"id":5456,"word":"\u1791\u17D2\u179A\u1798"},{"id":5457,"word":"\u1791\u17D2\u179A\u1798\u1780\u17CB"},{"id":5458,"word":"\u1791\u17D2\u179A\u1798\u1798"},{"id":5459,"word":"\u1791\u17D2\u179A\u1798\u179B\u17CB"},{"id":5460,"word":"\u1791\u17D2\u179A\u1798\u17B6\u1780"},{"id":5461,"word":"\u1791\u17D2\u179A\u1798\u17B6\u1780\u17CB"},{"id":5462,"word":"\u1791\u17D2\u179A\u1798\u17B6\u1780\u17CB\u1781\u17D2\u179B\u17B6"},{"id":5463,"word":"\u1791\u17D2\u179A\u1798\u17B8\u1784"},{"id":5464,"word":"\u1791\u17D2\u179A\u1798\u17B9\u1784"},{"id":5465,"word":"\u1791\u17D2\u179A\u1798\u17BC\u1784"},{"id":5466,"word":"\u1791\u17D2\u179A\u1798\u17BC\u1784\u179F\u17C1\u1780"},{"id":5467,"word":"\u1791\u17D2\u179A\u1798\u17BD\u1785"},{"id":5468,"word":"\u1791\u17D2\u179A\u1798\u17BE"},{"id":5469,"word":"\u1791\u17D2\u179A\u1798\u17BE\u1784"},{"id":5470,"word":"\u1791\u17D2\u179A\u1798\u17BE\u1798"},{"id":5471,"word":"\u1791\u17D2\u179A\u1798\u17BE\u1799"},{"id":5472,"word":"\u1791\u17D2\u179A\u1798\u17C1\u1789"},{"id":5473,"word":"\u1791\u17D2\u179A\u1798\u17C1\u1798"},{"id":5474,"word":"\u1791\u17D2\u179A\u1798\u17C2"},{"id":5475,"word":"\u1791\u17D2\u179A\u1798\u17C2\u1784"},{"id":5476,"word":"\u1791\u17D2\u179A\u1798\u17B6\u17C6\u1784"},{"id":5477,"word":"\u1791\u17D2\u179A\u1799\u1793"},{"id":5478,"word":"\u1791\u17D2\u179A\u1799\u17B6\u1793"},{"id":5479,"word":"\u1791\u17D2\u179A\u1799\u17B9\u1784"},{"id":5480,"word":"\u1791\u17D2\u179A\u1799\u17BB\u1780"},{"id":5481,"word":"\u1791\u17D2\u179A\u179B\u1793\u17CB"},{"id":5482,"word":"\u1791\u17D2\u179A\u179B\u17B9\u1784\u1791\u17B9\u1784"},{"id":5483,"word":"\u1791\u17D2\u179A\u179B\u17BB\u1780"},{"id":5484,"word":"\u1791\u17D2\u179A\u179B\u17BC"},{"id":5485,"word":"\u1791\u17D2\u179A\u179B\u17C4\u1798"},{"id":5486,"word":"\u1791\u17D2\u179A\u179C\u17C0\u1785"},{"id":5487,"word":"\u1791\u17D2\u179A\u179C\u17C2\u1784"},{"id":5488,"word":"\u1791\u17D2\u179A\u179C\u17C7"},{"id":5489,"word":"\u1791\u17D2\u179A\u17A0\u17B9\u1784"},{"id":5490,"word":"\u1791\u17D2\u179A\u17A0\u17C4"},{"id":5491,"word":"\u1791\u17D2\u179A\u17B6\u1793\u17CB"},{"id":5492,"word":"\u1791\u17D2\u179A\u17B6\u1794"},{"id":5493,"word":"\u1791\u17D2\u179A\u17B6\u1794\u17CB"},{"id":5494,"word":"\u1791\u17D2\u179A\u17B6\u1799"},{"id":5495,"word":"\u1791\u17D2\u179A\u17B6\u179B"},{"id":5496,"word":"\u1791\u17D2\u179A\u17B6\u179F"},{"id":5497,"word":"\u1791\u17D2\u179A\u17B9\u1784"},{"id":5498,"word":"\u1791\u17D2\u179A\u17B9\u179F\u17D2\u178A\u17B7"},{"id":5499,"word":"\u1791\u17D2\u179A\u17B9\u179F\u17D2\u178A\u17B7\u179F\u17D2\u1798\u17BC\u179A"},{"id":5500,"word":"\u1791\u17D2\u179A\u17B9\u179F\u17D2\u178A\u17B8"},{"id":5501,"word":"\u1791\u17D2\u179A\u17BB\u1784"},{"id":5502,"word":"\u1791\u17D2\u179A\u17BB\u178C"},{"id":5503,"word":"\u1791\u17D2\u179A\u17BB\u1794"},{"id":5504,"word":"\u1791\u17D2\u179A\u17BB\u1794\u17D7"},{"id":5505,"word":"\u1791\u17D2\u179A\u17BB\u1798"},{"id":5506,"word":"\u1791\u17D2\u179A\u17BB\u1799"},{"id":5507,"word":"\u1791\u17D2\u179A\u17BB\u179B"},{"id":5508,"word":"\u1791\u17D2\u179A\u17BB\u179F\u17D2\u178A"},{"id":5509,"word":"\u1791\u17D2\u179A\u17BB\u179F\u17D2\u178A\u179F\u17B8\u179B"},{"id":5510,"word":"\u1791\u17D2\u179A\u17BB\u17C7"},{"id":5511,"word":"\u1791\u17D2\u179A\u17BC"},{"id":5512,"word":"\u1791\u17D2\u179A\u17BC\u179B\u17B6\u179C"},{"id":5513,"word":"\u1791\u17D2\u179A\u17BC\u1784"},{"id":5514,"word":"\u1791\u17D2\u179A\u17BD\u1780"},{"id":5515,"word":"\u1791\u17D2\u179A\u17BD\u179F"},{"id":5516,"word":"\u1791\u17D2\u179A\u17BD\u179F\u17D7"},{"id":5517,"word":"\u1791\u17D2\u179A\u17BE\u1784"},{"id":5518,"word":"\u1791\u17D2\u179A\u17BE\u178F\u17D7"},{"id":5519,"word":"\u1791\u17D2\u179A\u17BE\u179F"},{"id":5520,"word":"\u1791\u17D2\u179A\u17BE\u179F\u1783\u17D2\u1793\u1784"},{"id":5521,"word":"\u1791\u17D2\u179A\u17BE\u179F\u1791\u17D2\u179A\u1784\u17CB"},{"id":5522,"word":"\u1791\u17D2\u179A\u17C0\u1780"},{"id":5523,"word":"\u1791\u17D2\u179A\u17C0\u179B"},{"id":5524,"word":"\u1791\u17D2\u179A\u17C0\u179F"},{"id":5525,"word":"\u1791\u17D2\u179A\u17C1\u178F"},{"id":5526,"word":"\u1791\u17D2\u179A\u17C1\u178F\u1791\u17D2\u179A\u17C4\u178F"},{"id":5527,"word":"\u1791\u17D2\u179A\u17C1\u179B"},{"id":5528,"word":"\u1791\u17D2\u179A\u17C2\u1798"},{"id":5529,"word":"\u1791\u17D2\u179A\u17C2\u179B\u1791\u17D2\u179A\u179B"},{"id":5530,"word":"\u1791\u17D2\u179A\u17C4\u1794"},{"id":5531,"word":"\u1791\u17D2\u179A\u17C4\u1798"},{"id":5532,"word":"\u1791\u17D2\u179A\u17C4\u1798!"},{"id":5533,"word":"\u1791\u17D2\u179A\u17C4\u179B"},{"id":5534,"word":"\u1791\u17D2\u179A\u17B6\u17C6"},{"id":5535,"word":"\u1791\u17D2\u179A\u17B6\u17C6\u1784"},{"id":5536,"word":"\u1791\u17D2\u179A\u17B6\u17C6\u1791\u17D2\u179A"},{"id":5537,"word":"\u1791\u17D2\u179A\u17B6\u17C6\u1791\u17D2\u179A\u17B9\u179F\u17D2\u178A\u17B7"},{"id":5538,"word":"\u1791\u17D2\u179C\u1793\u17D2\u1791"},{"id":5539,"word":"\u1791\u17D2\u179C\u1793\u17D2\u1791\u1799\u17BB\u1792"},{"id":5540,"word":"\u1791\u17D2\u179C\u1799\u179C\u17B6\u1791"},{"id":5541,"word":"\u1791\u17D2\u179C\u17B6\u1791\u179F"},{"id":5542,"word":"\u1791\u17D2\u179C\u17B6\u1791\u179F\u1798\u17B6\u179F"},{"id":5543,"word":"\u1791\u17D2\u179C\u17B6\u1791\u179F\u179C\u178F\u17D2\u179F\u179A\u17CD"},{"id":5544,"word":"\u1791\u17D2\u179C\u17B6\u179A"},{"id":5545,"word":"\u1791\u17D2\u179C\u17B6\u179A\u1793\u17B6\u1799\u1780"},{"id":5546,"word":"\u1791\u17D2\u179C\u17B6\u179A\u1794\u178F\u17B8"},{"id":5547,"word":"\u1791\u17D2\u179C\u17B6\u179A\u1794\u17B6\u179B"},{"id":5548,"word":"\u1791\u17D2\u179C\u17B7\u1787\u1780"},{"id":5549,"word":"\u1791\u17D2\u179C\u17B7\u1791\u1793\u17D2\u178F"},{"id":5550,"word":"\u1791\u17D2\u179C\u17B7\u1794\u1790"},{"id":5551,"word":"\u1791\u17D2\u179C\u17B7\u1794\u1791"},{"id":5552,"word":"\u1791\u17D2\u179C\u17B7\u1794\u17B6\u1791"},{"id":5553,"word":"\u1791\u17D2\u179C\u17B7\u179A\u17B6\u1794"},{"id":5554,"word":"\u1791\u17D2\u179C\u17B7\u179F\u1794\u17D2\u178F\u17B6\u17A0\u17C8"},{"id":5555,"word":"\u1791\u17D2\u179C\u17B8"},{"id":5556,"word":"\u1791\u17D2\u179C\u17B8\u1782\u17BB\u178E"},{"id":5557,"word":"\u1791\u17D2\u179C\u17B8\u1794"},{"id":5558,"word":"\u1791\u17D2\u179C\u17C1"},{"id":5559,"word":"\u1791\u17D2\u179C\u17C1\u1782\u17BB\u178E"},{"id":5560,"word":"\u1791\u17D2\u179C\u17C1\u1782\u17D2\u179A\u17B6\u17C7"},{"id":5561,"word":"\u1791\u17D2\u179C\u17C1\u1794\u17B6\u1791"},{"id":5562,"word":"\u1791\u17D2\u179C\u17C1\u1796\u17D2\u1799\u17B6\u1784\u17D2\u1782"},{"id":5563,"word":"\u1791\u17D2\u179C\u17C1\u1797\u17B6\u1782"},{"id":5564,"word":"\u1791\u17D2\u179C\u17C1\u1797\u17B6\u1782\u17B8"},{"id":5565,"word":"\u1791\u17D2\u179C\u17C1\u1797\u17B6\u1796"},{"id":5566,"word":"\u1791\u17D2\u179C\u17C1\u179F\u17D2\u179F\u1787\u1793"},{"id":5567,"word":"\u1791\u17D2\u179C\u17C1\u17A0\u17B6\u179A"},{"id":5568,"word":"\u1791\u1791\u17BB\u1784"},{"id":5569,"word":"\u1791\u17BD\u179A\u178E\u17BA\u179C\u17B7\u179F"},{"id":5570,"word":"\u1791\u17BE\u179F"},{"id":5571,"word":"\u1791\u17C6\u1793\u1793\u17CB"},{"id":5572,"word":"\u1791\u17C6\u1793\u17BE\u179F"},{"id":5573,"word":"\u1792"},{"id":5574,"word":"\u1792\u17D0\u1780"},{"id":5575,"word":"\u1792\u1789\u17D2\u1789\u1787\u17B6\u178F\u17B7"},{"id":5576,"word":"\u1792\u1789\u17D2\u1789\u1798\u17B6\u179F"},{"id":5577,"word":"\u1792\u178F\u179A\u178A\u17D2\u178B"},{"id":5578,"word":"\u1792\u1793"},{"id":5579,"word":"\u1792\u1793\u17CB"},{"id":5580,"word":"\u1792\u1793\u1780\u17D2\u1780\u17B8\u178F\u17B6"},{"id":5581,"word":"\u1792\u1793\u1780\u17D2\u179A\u17B8\u178F"},{"id":5582,"word":"\u1792\u1793\u1780\u17D2\u179F\u17D0\u1799"},{"id":5583,"word":"\u1792\u1793\u1791\u178E\u17D2\u178C"},{"id":5584,"word":"\u1792\u1793\u1792\u17B6\u1793"},{"id":5585,"word":"\u1792\u1793\u1794\u17D0\u178E\u17D2\u178E"},{"id":5586,"word":"\u1792\u1793\u1794\u178F\u17D2\u179A"},{"id":5587,"word":"\u1792\u1793\u1798\u17BC\u179B"},{"id":5588,"word":"\u1792\u1793\u179B\u17B6\u1797"},{"id":5589,"word":"\u1792\u1793\u179B\u17C4\u1797"},{"id":5590,"word":"\u1792\u1793\u179F\u17B6\u179A"},{"id":5591,"word":"\u1792\u1793\u17B6\u1780\u179A"},{"id":5592,"word":"\u1792\u1793\u17B6\u1782\u17B6\u179A"},{"id":5593,"word":"\u1792\u1793\u17B6\u1782\u17B6\u179A\u17B7\u1780"},{"id":5594,"word":"\u1792\u1793\u17B6\u1792\u17B7\u1780\u17B6\u179A\u17B8"},{"id":5595,"word":"\u1792\u1793\u17B7\u178F"},{"id":5596,"word":"\u1792\u1793\u17B7\u1793"},{"id":5597,"word":"\u1792\u1793\u17BB"},{"id":5598,"word":"\u1792\u1793\u17BB\u17A0\u178F\u17D2\u1790"},{"id":5599,"word":"\u1792\u1798\u1793\u17B8"},{"id":5600,"word":"\u1792\u1798\u17D2\u1798"},{"id":5601,"word":"\u1792\u1798\u17D2\u1798--"},{"id":5602,"word":"\u1792\u1798\u17D2\u1798\u1780\u1790\u17B7\u1780"},{"id":5603,"word":"\u1792\u1798\u17D2\u1798\u1792\u179A"},{"id":5604,"word":"\u1792\u179A\u178E\u17B7\u1793\u17D2\u1791"},{"id":5605,"word":"\u1792\u179A\u178E\u17B8"},{"id":5606,"word":"\u1792\u179A\u178E\u17B8\u178A\u1784\u1782\u17C4\u1798"},{"id":5607,"word":"\u1792\u179A\u178E\u17B8\u178A\u1784\u1791\u1784\u17CB"},{"id":5608,"word":"\u1792\u179A\u178E\u17B8\u1791\u17D2\u179C\u17B6\u179A"},{"id":5609,"word":"\u1792\u179A\u178E\u17B8\u179F\u1784\u17D2\u1783"},{"id":5610,"word":"\u1792\u179A\u1798\u17B6\u1793"},{"id":5611,"word":"\u1792\u179A\u1798\u17B6\u1793\u1794\u17D2\u1794\u1789\u17D2\u1789\u178F\u17D2\u178F\u17B7"},{"id":5612,"word":"\u1792\u1798\u17CC"},{"id":5613,"word":"\u1792\u17B6\u1780\u17CB"},{"id":5614,"word":"\u1792\u17B6\u1784"},{"id":5615,"word":"\u1792\u17B6\u178F\u17CB"},{"id":5616,"word":"\u1792\u17B6\u178F\u17BB"},{"id":5617,"word":"\u1792\u17B6\u178F\u17BB--"},{"id":5618,"word":"\u1792\u17B6\u178F\u17D2\u179A\u17B8"},{"id":5619,"word":"\u1792\u17B6\u1793"},{"id":5620,"word":"\u1792\u17B6\u1793\u17B6"},{"id":5621,"word":"\u1792\u17B6\u1793\u17B8"},{"id":5622,"word":"\u1792\u17B6\u179A"},{"id":5623,"word":"\u1792\u17B8"},{"id":5624,"word":"\u1792\u17B8\u178F\u17B6"},{"id":5625,"word":"\u1792\u17B8\u1794"},{"id":5626,"word":"\u1792\u17B9\u1784"},{"id":5627,"word":"\u1792\u17BA"},{"id":5628,"word":"\u1792\u17BB\u1784"},{"id":5629,"word":"\u1792\u17BB\u1784"},{"id":5630,"word":"\u1792\u17BB\u1789"},{"id":5631,"word":"\u1792\u17BB\u178F\u1784\u17D2\u1782"},{"id":5632,"word":"\u1792\u17BB\u1793"},{"id":5633,"word":"\u1792\u17BB\u179A\u17C8"},{"id":5634,"word":"\u1792\u17BB\u179A\u1793\u17B7\u1780\u17D2\u1781\u17C1\u1794"},{"id":5635,"word":"\u1792\u17BC\u178F\u1784\u17D2\u1782"},{"id":5636,"word":"\u1792\u17BC\u1794"},{"id":5637,"word":"\u1792\u17BC\u1798\u1780\u17B6\u179B\u17B7\u1780"},{"id":5638,"word":"\u1792\u17BC\u1798\u1780\u17C1\u178F\u17BB"},{"id":5639,"word":"\u1792\u17BC\u179A"},{"id":5640,"word":"\u1792\u17BC\u179B\u17B8"},{"id":5641,"word":"\u1792\u17BD"},{"id":5642,"word":"\u1792\u17BD\u1793"},{"id":5643,"word":"\u1792\u17C0\u1794"},{"id":5644,"word":"\u1792\u17C1\u1784"},{"id":5645,"word":"\u1792\u17C1\u1784\u1792\u17C4\u1784"},{"id":5646,"word":"\u1792\u17C4\u179C\u1780\u17C8"},{"id":5647,"word":"\u1792\u17C4\u179C\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":5648,"word":"\u1792\u17BB\u17C6"},{"id":5649,"word":"\u1792\u17C6"},{"id":5650,"word":"\u1792\u17D2\u1784\u1793\u17CB"},{"id":5651,"word":"\u1792\u17D2\u1784\u1793\u17CB\u1792\u17D2\u1784\u179A"},{"id":5652,"word":"\u1792\u17D2\u1784\u17B6\u1784"},{"id":5653,"word":"\u1792\u17D2\u1784\u17BE\u1784"},{"id":5654,"word":"\u1792\u17D2\u1784\u17BE\u179B"},{"id":5655,"word":"\u1792\u17D2\u1784\u17C4\u1784"},{"id":5656,"word":"\u1792\u17D2\u1784\u17C4\u179B"},{"id":5657,"word":"\u1792\u17D2\u1784\u17B6\u17C6\u1784"},{"id":5658,"word":"\u1792\u17D2\u1793\u1784\u17CB"},{"id":5659,"word":"\u1792\u17D2\u1793\u179B\u17CB"},{"id":5660,"word":"\u1792\u17D2\u1793\u179F\u17CB"},{"id":5661,"word":"\u1792\u17D2\u1793\u17B6\u1780\u17CB"},{"id":5662,"word":"\u1792\u17D2\u1793\u17B6\u1794\u17CB"},{"id":5663,"word":"\u1792\u17D2\u1793\u17B6\u179A"},{"id":5664,"word":"\u1792\u17D2\u1793\u17B7\u1798"},{"id":5665,"word":"\u1792\u17D2\u1793\u17B9\u1798"},{"id":5666,"word":"\u1792\u17D2\u1793\u17B9\u1798\u1794\u178E\u17D2\u178A\u17C2\u178F"},{"id":5667,"word":"\u1792\u17D2\u1793\u17BC"},{"id":5668,"word":"\u1792\u17D2\u1793\u17BC\u1781\u17D2\u179C\u17C2\u1780"},{"id":5669,"word":"\u1792\u17D2\u1793\u17BE\u179A"},{"id":5670,"word":"\u1792\u17D2\u1793\u17C7"},{"id":5671,"word":"\u1792\u17D2\u1798\u1784\u17CB"},{"id":5672,"word":"\u1792\u17D2\u1798\u178F\u17CB"},{"id":5673,"word":"\u1792\u17D2\u1798\u1794\u17CB"},{"id":5674,"word":"\u1792\u17D2\u1798\u17B6"},{"id":5675,"word":"\u1792\u17D2\u1798\u17B9\u1784"},{"id":5676,"word":"\u1792\u17D2\u1798\u17BB\u1784"},{"id":5677,"word":"\u1792\u17D2\u1798\u17BB\u1784\u1780\u1789\u17D2\u1785\u17BB\u17C7"},{"id":5678,"word":"\u1792\u17D2\u1798\u17BE\u1784"},{"id":5679,"word":"\u1792\u17D2\u1798\u17C1\u1785"},{"id":5680,"word":"\u1792\u17D2\u1798\u17C1\u1789"},{"id":5681,"word":"\u1792\u17D2\u1798\u17C1\u1789\u1780\u178E\u17D2\u178A\u17BB\u179A"},{"id":5682,"word":"\u1792\u17D2\u1798\u17C1\u1789\u1780\u178E\u17D2\u178A\u17BC\u1794"},{"id":5683,"word":"\u1792\u17D2\u1798\u17C1\u1789\u1780\u17D2\u179A\u1794\u17B8"},{"id":5684,"word":"\u1792\u17D2\u1798\u17C1\u1789\u1785\u17B6\u179F\u17CB"},{"id":5685,"word":"\u1792\u17D2\u1798\u17C1\u1789\u1788\u17BE"},{"id":5686,"word":"\u1792\u17D2\u1798\u17C1\u1789\u178F\u17D2\u179A\u17B8"},{"id":5687,"word":"\u1792\u17D2\u1798\u17C1\u1789\u179F\u17C1\u17C7"},{"id":5688,"word":"\u1792\u17D2\u1798\u17C3"},{"id":5689,"word":"\u1792\u17D2\u1798\u17C4\u1784"},{"id":5690,"word":"\u1792\u17D2\u1798\u17C5"},{"id":5691,"word":"\u1792\u17D2\u1798\u17B6\u17C6\u1784"},{"id":5692,"word":"\u1792\u17D2\u1799\u17B6\u1793"},{"id":5693,"word":"\u1792\u17D2\u1799\u17B6\u1793\u1785\u17B7\u178F\u17D2\u178F"},{"id":5694,"word":"\u1792\u17D2\u1799\u17B6\u1793\u1795\u179B"},{"id":5695,"word":"\u1792\u17D2\u1799\u17B6\u1793\u1796\u179B"},{"id":5696,"word":"\u1792\u17D2\u1799\u17B6\u1793\u179F\u17BB\u1781"},{"id":5697,"word":"\u1792\u17D2\u1799\u17B6\u1793\u17AB\u1791\u17D2\u1792\u17B7"},{"id":5698,"word":"\u1792\u17D2\u1799\u17B6\u1793\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":5699,"word":"\u1792\u17D2\u1799\u17BC\u1784"},{"id":5700,"word":"\u1792\u17D2\u179B\u1780"},{"id":5701,"word":"\u1792\u17D2\u179B\u17B6"},{"id":5702,"word":"\u1792\u17D2\u179B\u17B6\u1780\u17CB"},{"id":5703,"word":"\u1792\u17D2\u179B\u17B6\u1794\u17CB"},{"id":5704,"word":"\u1792\u17D2\u179B\u17B6\u1799"},{"id":5705,"word":"\u1792\u17D2\u179B\u17B8\u1784"},{"id":5706,"word":"\u1792\u17D2\u179B\u17BB\u1784"},{"id":5707,"word":"\u1792\u17D2\u179B\u17BB\u1789"},{"id":5708,"word":"\u1792\u17D2\u179B\u17BB\u17C7"},{"id":5709,"word":"\u1792\u17D2\u179B\u17BC"},{"id":5710,"word":"\u1792\u17D2\u179B\u17BC\u1789"},{"id":5711,"word":"\u1792\u17D2\u179B\u17BD\u1784"},{"id":5712,"word":"\u1792\u17D2\u179B\u17C2\u179A"},{"id":5713,"word":"\u1792\u17D2\u179B\u17C4"},{"id":5714,"word":"\u1792\u17D2\u179B\u17C4\u1799"},{"id":5715,"word":"\u1792\u17D2\u179B\u17B6\u17C6\u1784"},{"id":5716,"word":"\u1792\u17D2\u179B\u17C7"},{"id":5717,"word":"\u1792\u17D2\u179C\u17BE"},{"id":5718,"word":"\u1792\u17D2\u179C\u17BE\u1791\u17BB\u1780\u17D2\u1781"},{"id":5719,"word":"\u1792\u17D2\u179C\u17C1\u179F"},{"id":5720,"word":"\u1792\u17D2\u179C\u17C1\u179F\u1791\u17D2\u179C\u17C1"},{"id":5721,"word":"\u1793"},{"id":5722,"word":"\u1793\u17CF"},{"id":5723,"word":"\u1793\u1780"},{"id":5724,"word":"\u1793\u1780\u17D2\u1781\u178F\u17D2\u178F\u17AB\u1780\u17D2\u179F"},{"id":5725,"word":"\u1793\u1780\u17D2\u179F\u178F\u17D2\u179A"},{"id":5726,"word":"\u1793\u1780\u17D2\u179F\u178F\u17D2\u179A\u17AB\u1780\u17D2\u179F"},{"id":5727,"word":"\u1793\u1781\u17B6"},{"id":5728,"word":"\u1793\u1781\u17D2\u179C\u17B6\u1780\u17CB"},{"id":5729,"word":"\u1793\u1782\u179A"},{"id":5730,"word":"\u1793\u1782\u179A\u1787\u1793"},{"id":5731,"word":"\u1793\u1782\u179A\u1787\u17BB\u17C6"},{"id":5732,"word":"\u1793\u1782\u179A\u1792\u17C6"},{"id":5733,"word":"\u1793\u1782\u179A\u1794\u17B6\u179B"},{"id":5734,"word":"\u1793\u1782\u179A\u1794\u17BB\u179A\u17B8"},{"id":5735,"word":"\u1793\u1782\u179A\u179A\u17B6\u1787"},{"id":5736,"word":"\u1793\u1782\u179A\u179A\u17B6\u1787\u1787\u17B6\u178F\u17B7"},{"id":5737,"word":"\u1793\u1782\u179A\u179A\u17B6\u1787\u1787\u17BE\u1784\u1796\u17D2\u179A\u17C3"},{"id":5738,"word":"\u1793\u1782\u179A\u179C\u178F\u17D2\u178F"},{"id":5739,"word":"\u1793\u1782\u179A\u179F\u17C4\u1797\u17B7\u1793\u17B8"},{"id":5740,"word":"\u1793\u1782\u17D2\u1782\u1787\u1793"},{"id":5741,"word":"\u1793\u1784\u17D2\u1782\u17D0\u179B"},{"id":5742,"word":"\u1793\u178F\u17D2\u178F\u17B6"},{"id":5743,"word":"\u1793\u178F\u17D2\u1790\u17B7\u1797\u17B6\u1796"},{"id":5744,"word":"\u1793\u178F\u17D2\u1790\u17BB\u1780\u1798\u17D2\u1798"},{"id":5745,"word":"\u1793\u1791\u17B8"},{"id":5746,"word":"\u1793\u1793\u179B"},{"id":5747,"word":"\u1793\u1793\u17C0\u179B"},{"id":5748,"word":"\u1793\u1793\u17C4\u1784"},{"id":5749,"word":"\u1793\u1793\u17C4\u1784\u1796\u17D2\u179A\u17C3"},{"id":5750,"word":"\u1793\u1793\u17C7"},{"id":5751,"word":"\u1793\u1793\u17C7\u1793\u179A\u1793\u17B6\u1791"},{"id":5752,"word":"\u1793\u1794"},{"id":5753,"word":"\u1793\u1794\u17CB"},{"id":5754,"word":"\u1793\u1794\u17BB\u17C6\u179F\u1780\u17C8"},{"id":5755,"word":"\u1793\u1794\u17BB\u17C6\u179F\u1780\u179B\u17B7\u1784\u17D2\u1782"},{"id":5756,"word":"\u1793\u1796\u17D2\u179C"},{"id":5757,"word":"\u1793\u1797\u1780\u17C1\u178F\u1793\u17CD"},{"id":5758,"word":"\u1793\u1797\u1794\u17D2\u179A\u17B6\u178E"},{"id":5759,"word":"\u1793\u1797\u1798\u178E\u17D2\u178C\u179B"},{"id":5760,"word":"\u1793\u1797\u1798\u178E\u17B8"},{"id":5761,"word":"\u1793\u1797\u17B6"},{"id":5762,"word":"\u1793\u1797\u17B6\u179B\u17D0\u1799"},{"id":5763,"word":"\u1793\u1797\u17C4\u1792\u17BC\u1798"},{"id":5764,"word":"\u1793\u1798\u179F\u17D2\u1780\u17B6\u179A"},{"id":5765,"word":"\u1793\u17D0\u1799"},{"id":5766,"word":"\u1793\u1799\u1793\u17C8"},{"id":5767,"word":"\u1793\u1799\u1793\u17C1\u178F\u17D2\u179A"},{"id":5768,"word":"\u1793\u1799\u179B\u1780\u17D2\u1781\u178E\u17C8"},{"id":5769,"word":"\u1793\u1799\u17C4\u1794\u17B6\u1799"},{"id":5770,"word":"\u1793\u179A\u17C8"},{"id":5771,"word":"\u1793\u179A\u1780"},{"id":5772,"word":"\u1793\u179A\u1780\u1780\u17BB\u178E\u17D2\u178C"},{"id":5773,"word":"\u1793\u179A\u1783\u17B6\u178F"},{"id":5774,"word":"\u1793\u179A\u1783\u17B6\u178F\u1780"},{"id":5775,"word":"\u1793\u179A\u1783\u17B6\u178F\u1780\u1798\u17D2\u1798"},{"id":5776,"word":"\u1793\u179A\u1787\u17B6\u178F\u17B7"},{"id":5777,"word":"\u1793\u179A\u1787\u17C1\u178A\u17D2\u178B"},{"id":5778,"word":"\u1793\u179A\u178E\u17B6"},{"id":5779,"word":"\u1793\u179A\u1791\u17C1\u1796"},{"id":5780,"word":"\u1793\u179A\u1793\u17B6\u1790"},{"id":5781,"word":"\u1793\u179A\u1793\u17B6\u1790\u17B6"},{"id":5782,"word":"\u1793\u179A\u1793\u17B6\u1791"},{"id":5783,"word":"\u1793\u179A\u1794\u178F\u17B8"},{"id":5784,"word":"\u1793\u179A\u1796\u17B7\u179F\u17D2\u179C\u178E\u17CD"},{"id":5785,"word":"\u1793\u179A\u179F\u17B8\u17A0\u17C8"},{"id":5786,"word":"\u1793\u179A\u179F\u17B9\u17A0\u17C8"},{"id":5787,"word":"\u1793\u179A\u17B6\u1792\u17B7\u1794\u178F\u17B7\u1793\u17D2\u1791"},{"id":5788,"word":"\u1793\u179A\u17B6\u1792\u17B7\u1794"},{"id":5789,"word":"\u1793\u179A\u17B6\u179F\u1797"},{"id":5790,"word":"\u1793\u179A\u17B7\u1793\u17D2\u1791"},{"id":5791,"word":"\u1793\u179A\u17BC"},{"id":5792,"word":"\u1793\u179A\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":5793,"word":"\u1793\u179A\u17C1\u179F\u17BC\u179A"},{"id":5794,"word":"\u1793\u179A\u17C4\u178F\u17D2\u178F\u1798"},{"id":5795,"word":"\u1793\u179B\u17B6\u178A"},{"id":5796,"word":"\u1793\u179C\u1793\u17B8\u178F"},{"id":5797,"word":"\u1793\u179C\u1798\u17B6\u179B\u17B7\u1780\u17B6"},{"id":5798,"word":"\u1793\u179C\u17B6\u1782\u178F"},{"id":5799,"word":"\u1793\u179C\u17B6\u1782\u178F\u1797\u178E\u17D2\u178C"},{"id":5800,"word":"\u1793\u179C\u17BB\u178F\u17B7"},{"id":5801,"word":"\u1793\u179C\u17C4\u178F\u17D2\u1794\u1793\u17D2\u1793"},{"id":5802,"word":"\u1793\u17A0\u17B6\u1793\u17C4\u1791\u1780"},{"id":5803,"word":"\u1793\u17A0\u17B6\u179A\u17BB"},{"id":5804,"word":"\u1793\u17A0\u17BB\u178F"},{"id":5805,"word":"\u1793\u17B6"},{"id":5806,"word":"\u1793\u17B6\u1780\u17CB"},{"id":5807,"word":"\u1793\u17B6\u1780\u17B6\u179B"},{"id":5808,"word":"\u1793\u17B6\u1782"},{"id":5809,"word":"\u1793\u17B6\u1782\u1791\u1793\u17D2\u178F"},{"id":5810,"word":"\u1793\u17B6\u1782\u1794\u17B6\u179F"},{"id":5811,"word":"\u1793\u17B6\u1782\u1794\u17D2\u179A\u1780\u17CB"},{"id":5812,"word":"\u1793\u17B6\u1782\u1796\u17D0\u1793\u17D2\u1792"},{"id":5813,"word":"\u1793\u17B6\u1782\u1798\u17B6\u178E\u179C\u17B8"},{"id":5814,"word":"\u1793\u17B6\u1782\u179A\u17B6"},{"id":5815,"word":"\u1793\u17B6\u1782\u179A\u17B6\u1787"},{"id":5816,"word":"\u1793\u17B6\u1782\u179A\u17B7\u1780"},{"id":5817,"word":"\u1793\u17B6\u1782\u179A\u17B8"},{"id":5818,"word":"\u1793\u17B6\u1782\u179B\u17C4\u1780"},{"id":5819,"word":"\u1793\u17B6\u1782\u179C\u17B7\u1790\u17B8"},{"id":5820,"word":"\u1793\u17B6\u1782\u17B6"},{"id":5821,"word":"\u1793\u17B6\u1782\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":5822,"word":"\u1793\u17B6\u1784"},{"id":5823,"word":"\u1793\u17B6\u1784\u1785\u17D2\u179A\u17B6\u179B"},{"id":5824,"word":"\u1793\u17B6\u1784\u178A\u17C2\u1784"},{"id":5825,"word":"\u1793\u17B6\u1784\u178A\u17C3"},{"id":5826,"word":"\u1793\u17B6\u1784\u1793\u1780\u17CB"},{"id":5827,"word":"\u1793\u17B6\u1784\u1793\u17B6\u1782"},{"id":5828,"word":"\u1793\u17B6\u1784\u1793\u17BD\u1793"},{"id":5829,"word":"\u1793\u17B6\u1784\u1795\u17D2\u17A2\u17C2\u1780"},{"id":5830,"word":"\u1793\u17B6\u1784\u179A\u1784"},{"id":5831,"word":"\u1793\u17B6\u1784\u179C\u1784"},{"id":5832,"word":"\u1793\u17B6\u1784\u179F\u17D2\u179C\u17B6\u1799"},{"id":5833,"word":"\u1793\u17B6\u1785"},{"id":5834,"word":"\u1793\u17B6\u178A"},{"id":5835,"word":"\u1793\u17B6\u178A\u1780"},{"id":5836,"word":"\u1793\u17B6\u178A\u1780\u1798\u17D2\u1798"},{"id":5837,"word":"\u1793\u17B6\u178A\u1780\u179F\u17B6\u179B"},{"id":5838,"word":"\u1793\u17B6\u178A\u1780\u17B6"},{"id":5839,"word":"\u1793\u17B6\u1790"},{"id":5840,"word":"\u1793\u17B6\u1791\u17B8"},{"id":5841,"word":"\u1793\u17B6\u1793\u17B6"},{"id":5842,"word":"\u1793\u17B6\u1793\u17B6\u1787\u17B6\u178F\u17B7"},{"id":5843,"word":"\u1793\u17B6\u1793\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798"},{"id":5844,"word":"\u1793\u17B6\u1793\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":5845,"word":"\u1793\u17B6\u1793\u17B6\u1794\u17D2\u179A\u1791\u17C1\u179F"},{"id":5846,"word":"\u1793\u17B6\u1793\u17B6\u179F\u17C6\u179C\u17B6\u179F"},{"id":5847,"word":"\u1793\u17B6\u1794\u17B8"},{"id":5848,"word":"\u1793\u17B6\u1797\u17B8"},{"id":5849,"word":"\u1793\u17B6\u1798"},{"id":5850,"word":"\u1793\u17B6\u1798\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":5851,"word":"\u1793\u17B6\u1798\u1782\u17D2\u1782\u17A0\u178E\u1798\u1784\u17D2\u1782\u179B"},{"id":5852,"word":"\u1793\u17B6\u1798\u1794\u17D2\u1794\u1789\u17D2\u1789\u178F\u17D2\u178F\u17B7"},{"id":5853,"word":"\u1793\u17B6\u1798\u1794\u17D0\u178E\u17D2\u178E"},{"id":5854,"word":"\u1793\u17B6\u1798\u179F\u1796\u17D2\u1791"},{"id":5855,"word":"\u1793\u17B6\u1798\u17C9\u17BA\u1793"},{"id":5856,"word":"\u1793\u17B6\u1799"},{"id":5857,"word":"\u1793\u17B6\u1799\u1780"},{"id":5858,"word":"\u1793\u17B6\u1799\u1780\u1792\u1798\u17CC"},{"id":5859,"word":"\u1793\u17B6\u1799\u1785\u17C6\u178E\u1784\u17CB"},{"id":5860,"word":"\u1793\u17B6\u1799\u1791\u17C4"},{"id":5861,"word":"\u1793\u17B6\u1799\u17AF\u1780"},{"id":5862,"word":"\u1793\u17B6\u179A"},{"id":5863,"word":"\u1793\u17B6\u179A\u1791\u1787\u17B6\u178F\u1780"},{"id":5864,"word":"\u1793\u17B6\u179A\u17B6\u1799\u178E\u17CD"},{"id":5865,"word":"\u1793\u17B6\u179A\u17B8"},{"id":5866,"word":"\u1793\u17B6\u179A\u17B8\u1780\u17D2\u179B\u17B6\u17A0\u17B6\u1793"},{"id":5867,"word":"\u1793\u17B6\u179A\u17B8\u1795\u179B"},{"id":5868,"word":"\u1793\u17B6\u179A\u17B8\u179A\u178F\u17D2\u1793"},{"id":5869,"word":"\u1793\u17B6\u179B"},{"id":5870,"word":"\u1793\u17B6\u179B\u17B7"},{"id":5871,"word":"\u1793\u17B6\u179C"},{"id":5872,"word":"\u1793\u17B6\u179C\u17B6"},{"id":5873,"word":"\u1793\u17B6\u179C\u17B7\u1780"},{"id":5874,"word":"\u1793\u17B6\u179C\u17B7\u1780\u1793\u17B6\u1799\u1780"},{"id":5875,"word":"\u1793\u17B6\u179C\u17B7\u1780\u1794\u178F\u17B8"},{"id":5876,"word":"\u1793\u17B6\u179C\u17B7\u1780\u17B6"},{"id":5877,"word":"\u1793\u17B6\u179C\u17B7\u1780\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":5878,"word":"\u1793\u17B6\u179C\u17BC\u1794\u1780\u179A\u178E\u17CD"},{"id":5879,"word":"\u1793\u17B6\u179F\u1793"},{"id":5880,"word":"\u1793\u17B6\u179F\u1793\u1784\u17D2\u1782"},{"id":5881,"word":"\u1793\u17B6\u179F\u1793\u17B6"},{"id":5882,"word":"\u1793\u17B6\u179F\u17B6"},{"id":5883,"word":"\u1793\u17B6\u179F\u17B7\u1780\u178A\u17D2\u178B\u17B6\u1793\u1787\u17C8"},{"id":5884,"word":"\u1793\u17B6\u179F\u17B7\u1780\u179A\u17C4\u1782"},{"id":5885,"word":"\u1793\u17B6\u17A1\u17B7"},{"id":5886,"word":"\u1793\u17B6\u17A1\u17B7\u1780\u17B6"},{"id":5887,"word":"\u1793\u17B7\u1780\u179A"},{"id":5888,"word":"\u1793\u17B7\u1780\u17B6\u1799"},{"id":5889,"word":"\u1793\u17B7\u1780\u17D2\u1780\u1784\u17D2\u1781\u17B6"},{"id":5890,"word":"\u1793\u17B7\u1780\u17D2\u1781\u17C1\u1794\u1794\u1791"},{"id":5891,"word":"\u1793\u17B7\u1782\u1798"},{"id":5892,"word":"\u1793\u17B7\u1782\u1798\u179C\u1785\u1793\u17C8"},{"id":5893,"word":"\u1793\u17B7\u1782\u17D2\u1782\u17A0\u17B7\u178F"},{"id":5894,"word":"\u1793\u17B7\u1782\u17D2\u179A\u1793\u17D2\u1790"},{"id":5895,"word":"\u1793\u17B7\u1782\u17D2\u179A\u17C4\u1792"},{"id":5896,"word":"\u1793\u17B7\u1782\u17D2\u179A\u17C4\u1792\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":5897,"word":"\u1793\u17B7\u1782\u17D2\u179A\u17C4\u1792\u17B6\u179A\u17B6\u1798"},{"id":5898,"word":"\u1793\u17B7\u1784"},{"id":5899,"word":"\u1793\u17B7\u1785\u17D2\u1785"},{"id":5900,"word":"\u1793\u17B7\u178F\u17D2\u1799"},{"id":5901,"word":"\u1793\u17B7\u1791\u179F\u17D2\u179F\u1793\u17CD"},{"id":5902,"word":"\u1793\u17B7\u1791\u17B6\u1783\u17C8"},{"id":5903,"word":"\u1793\u17B7\u1791\u17B6\u1793"},{"id":5904,"word":"\u1793\u17B7\u1791\u17B6\u1793\u1780\u1790\u17B6"},{"id":5905,"word":"\u1793\u17B7\u1791\u17D2\u1791\u17C1\u179F"},{"id":5906,"word":"\u1793\u17B7\u1791\u17D2\u1791\u17C1\u179F\u1794\u1791"},{"id":5907,"word":"\u1793\u17B7\u1791\u17D2\u1791\u17C1\u179F\u179C\u17B6\u179A\u17C8"},{"id":5908,"word":"\u1793\u17B7\u1791\u17D2\u179A\u17B6"},{"id":5909,"word":"\u1793\u17B7\u1793\u17D2\u1791\u17B6"},{"id":5910,"word":"\u1793\u17B7\u1793\u17D2\u1793\u17B6\u1780\u17B6\u179A"},{"id":5911,"word":"\u1793\u17B7\u1793\u17D2\u1793\u17B6\u1791"},{"id":5912,"word":"\u1793\u17B7\u1794\u17D2\u1794\u179A\u17B7\u1799\u17B6\u1799"},{"id":5913,"word":"\u1793\u17B7\u1794\u17B6\u178F"},{"id":5914,"word":"\u1793\u17B7\u1794\u17B6\u178F"},{"id":5915,"word":"\u1793\u17B7\u1794\u17B6\u178F\u179F\u1796\u17D2\u1791"},{"id":5916,"word":"\u1793\u17B7\u1796\u1791\u17D2\u1792\u1780\u17BB\u179F\u179B"},{"id":5917,"word":"\u1793\u17B7\u1796\u1793\u17D2\u1792"},{"id":5918,"word":"\u1793\u17B7\u1796\u17D2\u179C\u17B6\u1793"},{"id":5919,"word":"\u1793\u17B7\u1796\u17D2\u179C\u17B6\u1793\u1793\u179A\u1780"},{"id":5920,"word":"\u1793\u17B7\u1798\u1793\u17D2\u178F"},{"id":5921,"word":"\u1793\u17B7\u1798\u1793\u17D2\u178F\u1793\u17CD"},{"id":5922,"word":"\u1793\u17B7\u1798\u179B"},{"id":5923,"word":"\u1793\u17B7\u1798\u17B7\u178F"},{"id":5924,"word":"\u1793\u17B7\u1798\u17B7\u178F\u17D2\u178F"},{"id":5925,"word":"\u1793\u17B7\u1798\u17B7\u178F\u17D2\u178F\u179A\u17BC\u1794"},{"id":5926,"word":"\u1793\u17B7\u1798\u17B7\u178F\u17D2\u178F\u17A0\u17C1\u178F\u17BB"},{"id":5927,"word":"\u1793\u17B7\u1798\u17D2\u1798\u17B6\u1794\u1793\u1780\u1798\u17D2\u1798"},{"id":5928,"word":"\u1793\u17B7\u1798\u17D2\u1798\u17B6\u1794\u1793\u17B7\u1780"},{"id":5929,"word":"\u1793\u17B7\u1798\u17D2\u1798\u17B6\u1793\u179A\u178F\u17B8"},{"id":5930,"word":"\u1793\u17B7\u1799\u178F\u1798\u17B7\u1785\u17D2\u1786\u17B6\u1791\u17B7\u178A\u17D2\u178B\u17B7"},{"id":5931,"word":"\u1793\u17B7\u1799\u1798"},{"id":5932,"word":"\u1793\u17B7\u1799\u17B6\u1799"},{"id":5933,"word":"\u1793\u17B7\u1799\u17C4\u1787\u1780"},{"id":5934,"word":"\u1793\u17B7\u1799\u17C4\u1787\u17B7\u178F"},{"id":5935,"word":"\u1793\u17B7\u1799\u17D2\u1799\u17B6\u1793\u17B7\u1780\u1792\u1798\u17CC"},{"id":5936,"word":"\u1793\u17B7\u179A\u1782\u17BB\u178E"},{"id":5937,"word":"\u1793\u17B7\u179A\u178E\u17C1\u178F\u17D2\u179A"},{"id":5938,"word":"\u1793\u17B7\u179A\u178F\u17B8"},{"id":5939,"word":"\u1793\u17B7\u179A\u1791\u17BB\u1780\u17D2\u1781"},{"id":5940,"word":"\u1793\u17B7\u179A\u1791\u17C1\u179F"},{"id":5941,"word":"\u1793\u17B7\u179A\u1791\u17C4\u179F"},{"id":5942,"word":"\u1793\u17B7\u179A\u1793\u17D2\u178F\u179A"},{"id":5943,"word":"\u1793\u17B7\u179A\u1793\u17D2\u178F\u179A\u17B6\u1799"},{"id":5944,"word":"\u1793\u17B7\u179A\u1797\u17D0\u1799"},{"id":5945,"word":"\u1793\u17B7\u179A\u1798\u17B7\u178F"},{"id":5946,"word":"\u1793\u17B7\u179A\u17B6\u179F"},{"id":5947,"word":"\u1793\u17B7\u179A\u17BB\u178F\u17D2\u178F\u17B7"},{"id":5948,"word":"\u1793\u17B7\u179A\u17BB\u1791\u1780\u1794\u17B6\u1799\u17B6\u179F"},{"id":5949,"word":"\u1793\u17B7\u179A\u17C4\u1792"},{"id":5950,"word":"\u1793\u17B7\u179B"},{"id":5951,"word":"\u1793\u17B7\u179B\u1796\u17B7\u179F\u17B8"},{"id":5952,"word":"\u1793\u17B7\u179B\u179A\u17D0\u178F\u17D2\u1793"},{"id":5953,"word":"\u1793\u17B7\u179C\u178F\u17D2\u178F"},{"id":5954,"word":"\u1793\u17B7\u179C\u178F\u17D2\u178F\u1793\u17CD"},{"id":5955,"word":"\u1793\u17B7\u179C\u178F\u17D2\u178F\u1793\u17B6\u1780\u17B6\u179A"},{"id":5956,"word":"\u1793\u17B7\u179C\u17B6\u179A\u178E\u178A\u17D2\u178B\u17B6\u1793"},{"id":5957,"word":"\u1793\u17B7\u179C\u17B6\u179F\u178A\u17D2\u178B\u17B6\u1793"},{"id":5958,"word":"\u1793\u17B7\u179C\u17C1\u1791\u1793\u1780\u1790\u17B6"},{"id":5959,"word":"\u1793\u17B7\u179C\u17C1\u179F\u1793\u17CD"},{"id":5960,"word":"\u1793\u17B7\u179C\u17C1\u179F\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":5961,"word":"\u1793\u17B7\u179F\u17B6"},{"id":5962,"word":"\u1793\u17B7\u179F\u17B6\u1780\u179A"},{"id":5963,"word":"\u1793\u17B7\u179F\u17B6\u1785\u179A"},{"id":5964,"word":"\u1793\u17B7\u179F\u17D2\u179F\u17D0\u1799"},{"id":5965,"word":"\u1793\u17B7\u179F\u17D2\u179F\u1799\u1787\u1793"},{"id":5966,"word":"\u1793\u17B7\u179F\u17D2\u179F\u1799\u1798\u17BB\u178F\u17D2\u178F\u1780\u17C8"},{"id":5967,"word":"\u1793\u17B7\u179F\u17D2\u179F\u1799\u1793\u17D2\u178F\u17C1\u179C\u17B6\u179F\u17B7\u1780"},{"id":5968,"word":"\u1793\u17B7\u179F\u17D2\u179F\u1799\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":5969,"word":"\u1793\u17B7\u179F\u17D2\u179F\u17B7\u178F"},{"id":5970,"word":"\u1793\u17B7\u179F\u17B8\u1791\u1793\u17C8"},{"id":5971,"word":"\u1793\u17B7\u179F\u17B8\u1791\u1793\u17B6\u1780\u17B6\u179A"},{"id":5972,"word":"\u1793\u17B8"},{"id":5973,"word":"\u1793\u17B8\u178F\u17B7"},{"id":5974,"word":"\u1793\u17B8\u178F\u17B7--"},{"id":5975,"word":"\u1793\u17B8\u1798\u17BD\u1799"},{"id":5976,"word":"\u1793\u17B8\u1798\u17BD\u1799\u17D7"},{"id":5977,"word":"\u1793\u17B8\u179C\u179A\u178E\u1792\u1798\u17CC"},{"id":5978,"word":"\u1793\u17B8\u17A0\u179A\u178E\u1780\u1798\u17D2\u1798"},{"id":5979,"word":"\u1793\u17B8\u17A0\u179A\u17D0\u178E"},{"id":5980,"word":"\u1793\u17B8\u17A1\u17BB\u1784"},{"id":5981,"word":"\u1793\u17B9\u1780"},{"id":5982,"word":"\u1793\u17B9\u1784"},{"id":5983,"word":"\u1793\u17B9\u1798"},{"id":5984,"word":"\u1793\u17BB\u17CE\u1784"},{"id":5985,"word":"\u1793\u17BB\u1799"},{"id":5986,"word":"\u1793\u17BB\u17C7"},{"id":5987,"word":"\u1793\u17BB\u17CE\u17C7"},{"id":5988,"word":"\u1793\u17BC\u179C"},{"id":5989,"word":"\u1793\u17BD\u1793"},{"id":5990,"word":"\u1793\u17BD\u1793\u179B\u17D2\u17A2\u1784"},{"id":5991,"word":"\u1793\u17BD\u1793\u179F\u17D2\u179A\u17B8"},{"id":5992,"word":"\u1793\u17BF\u1780"},{"id":5993,"word":"\u1793\u17BF\u1799"},{"id":5994,"word":"\u1793\u17BF\u1799\u178E\u17B6\u1799"},{"id":5995,"word":"\u1793\u17C0\u179C"},{"id":5996,"word":"\u1793\u17C1\u178F\u17D2\u179A"},{"id":5997,"word":"\u1793\u17C1\u178F\u17D2\u179A\u17B6"},{"id":5998,"word":"\u1793\u17C1\u1793"},{"id":5999,"word":"\u1793\u17C1\u1798\u17B7\u179A\u17B6\u1787"},{"id":6000,"word":"\u1793\u17C1\u179A\u1782\u17BB\u178E"},{"id":6001,"word":"\u1793\u17C1\u179A\u1791\u17BB\u1780\u17D2\u1781"},{"id":6002,"word":"\u1793\u17C1\u179A\u1797\u17D0\u1799"},{"id":6003,"word":"\u1793\u17C1\u179F\u1787\u17D2\u1787\u17B7\u1780\u1784\u17D2\u1782\u17C8"},{"id":6004,"word":"\u1793\u17C1\u179F\u17B6\u1791"},{"id":6005,"word":"\u1793\u17C1\u179F\u17B6\u1791\u17BB\u1794\u1780\u179A\u178E\u17CD"},{"id":6006,"word":"\u1793\u17C1\u17C7"},{"id":6007,"word":"\u1793\u17C2!"},{"id":6008,"word":"\u1793\u17C2\u17A2\u17D2\u17A0\u17BA!"},{"id":6009,"word":"\u1793\u17C2\u1794"},{"id":6010,"word":"\u1793\u17C2\u1794\u1793\u17B7\u178F\u17D2\u1799"},{"id":6011,"word":"\u1793\u17C2\u179B\u1793\u179B"},{"id":6012,"word":"\u1793\u17C3"},{"id":6013,"word":"\u1793\u17C4\u1794"},{"id":6014,"word":"\u1793\u17C4\u1798"},{"id":6015,"word":"\u1793\u17C4\u179A\u17B8"},{"id":6016,"word":"\u1793\u17C4\u17C7"},{"id":6017,"word":"\u1793\u17C5"},{"id":6018,"word":"\u1793\u17C6"},{"id":6019,"word":"\u1793\u17B6\u17C6"},{"id":6020,"word":"\u1793\u17B6\u17C6\u1796\u17B6"},{"id":6021,"word":"\u1793\u17B6\u17C6\u17A2\u17B6\u1791\u17B7\u17CD"},{"id":6022,"word":"\u1793\u17D2\u179A\u1794\u178F\u17B8"},{"id":6023,"word":"\u1793\u17D2\u179A\u17B6\u1799"},{"id":6024,"word":"\u1793\u17D2\u17A2\u17B6\u179B\u1793\u17B9\u1784"},{"id":6025,"word":"\u1794"},{"id":6026,"word":"\u1794\u1780"},{"id":6027,"word":"\u1794\u1780\u17CB"},{"id":6028,"word":"\u1794\u1780\u17D2\u179F\u17B6"},{"id":6029,"word":"\u1794\u1780\u17D2\u179F\u17B8"},{"id":6030,"word":"\u1794\u1784"},{"id":6031,"word":"\u1794\u1784\u17CB"},{"id":6032,"word":"\u1794\u1784\u17CB\u1780"},{"id":6033,"word":"\u1794\u1784\u17CB\u1780\u17D2\u1798\u17C1\u1784"},{"id":6034,"word":"\u1794\u1784\u17CB\u1781\u17D2\u179B\u17B6\u1789\u17CB"},{"id":6035,"word":"\u1794\u1784\u17CB\u1783\u17D2\u179B\u17B6\u178F"},{"id":6036,"word":"\u1794\u1784\u17CB\u1785\u17B6\u1789\u17CB"},{"id":6037,"word":"\u1794\u1784\u17CB\u1785\u17C6\u178E\u17C2\u1784"},{"id":6038,"word":"\u1794\u1784\u17CB\u1785\u17C6\u1791\u17B6\u1789"},{"id":6039,"word":"\u1794\u1784\u17CB\u1787\u17C6\u1791\u17B6\u1789"},{"id":6040,"word":"\u1794\u1784\u17CB\u1794\u178F\u17CB"},{"id":6041,"word":"\u1794\u1784\u17CB\u1794\u17B6\u1789\u17CB"},{"id":6042,"word":"\u1794\u1784\u17CB\u1794\u17C4\u1799"},{"id":6043,"word":"\u1794\u1784\u17CB\u1798\u17D2\u179F\u17C0\u178F"},{"id":6044,"word":"\u1794\u1784\u17CB\u179F\u17C0\u178F"},{"id":6045,"word":"\u1794\u1784\u17CB\u179F\u17C6\u178E\u17B6\u1789\u17CB"},{"id":6046,"word":"\u1794\u1784\u17D2\u1780"},{"id":6047,"word":"\u1794\u1784\u17D2\u1780\u1780"},{"id":6048,"word":"\u1794\u1784\u17D2\u1780\u1780\u17CB"},{"id":6049,"word":"\u1794\u1784\u17D2\u1780\u1784"},{"id":6050,"word":"\u1794\u1784\u17D2\u1780\u1784\u17CB"},{"id":6051,"word":"\u1794\u1784\u17D2\u1780\u1794\u17CB"},{"id":6052,"word":"\u1794\u1784\u17D2\u1780\u17B6\u1785\u17CB"},{"id":6053,"word":"\u1794\u1784\u17D2\u1780\u17B6\u178F\u17CB"},{"id":6054,"word":"\u1794\u1784\u17D2\u1780\u17B6\u1793\u17CB\u178A\u17C3"},{"id":6055,"word":"\u1794\u1784\u17D2\u1780\u17B6\u179A"},{"id":6056,"word":"\u1794\u1784\u17D2\u1780\u17B7\u1793"},{"id":6057,"word":"\u1794\u1784\u17D2\u1780\u17B7\u179B"},{"id":6058,"word":"\u1794\u1784\u17D2\u1780\u17BB\u1784"},{"id":6059,"word":"\u1794\u1784\u17D2\u1780\u17BC\u1780"},{"id":6060,"word":"\u1794\u1784\u17D2\u1780\u17BD\u1799"},{"id":6061,"word":"\u1794\u1784\u17D2\u1780\u17BD\u1799\u178F\u17D2\u179A\u1784"},{"id":6062,"word":"\u1794\u1784\u17D2\u1780\u17BE\u1785"},{"id":6063,"word":"\u1794\u1784\u17D2\u1780\u17BE\u178F"},{"id":6064,"word":"\u1794\u1784\u17D2\u1780\u17BE\u1793"},{"id":6065,"word":"\u1794\u1784\u17D2\u1780\u17BE\u1799"},{"id":6066,"word":"\u1794\u1784\u17D2\u1780\u17BE\u179B"},{"id":6067,"word":"\u1794\u1784\u17D2\u1780\u17BF\u1784"},{"id":6068,"word":"\u1794\u1784\u17D2\u1780\u17C0\u179A"},{"id":6069,"word":"\u1794\u1784\u17D2\u1780\u17C1\u179B"},{"id":6070,"word":"\u1794\u1784\u17D2\u1780\u17C2\u1780"},{"id":6071,"word":"\u1794\u1784\u17D2\u1780\u17C3"},{"id":6072,"word":"\u1794\u1784\u17D2\u1780\u17C4\u1784"},{"id":6073,"word":"\u1794\u1784\u17D2\u1780\u17D2\u179A\u17B6\u1794"},{"id":6074,"word":"\u1794\u1784\u17D2\u1780\u17D2\u179A\u17C0\u1780"},{"id":6075,"word":"\u1794\u1784\u17D2\u1781\u1780"},{"id":6076,"word":"\u1794\u1784\u17D2\u1781\u1793"},{"id":6077,"word":"\u1794\u1784\u17D2\u1781\u17B6\u1780"},{"id":6078,"word":"\u1794\u1784\u17D2\u1781\u17B6\u178F"},{"id":6079,"word":"\u1794\u1784\u17D2\u1781\u17B6\u1793"},{"id":6080,"word":"\u1794\u1784\u17D2\u1781\u17B7\u178F"},{"id":6081,"word":"\u1794\u1784\u17D2\u1781\u17BB\u179F"},{"id":6082,"word":"\u1794\u1784\u17D2\u1781\u17BC\u1784"},{"id":6083,"word":"\u1794\u1784\u17D2\u1781\u17BC\u1785"},{"id":6084,"word":"\u1794\u1784\u17D2\u1781\u17BE\u1785"},{"id":6085,"word":"\u1794\u1784\u17D2\u1781\u17C6"},{"id":6086,"word":"\u1794\u1784\u17D2\u1781\u17B6\u17C6"},{"id":6087,"word":"\u1794\u1784\u17D2\u1781\u17B6\u17C6\u1784"},{"id":6088,"word":"\u1794\u1784\u17D2\u1781\u17C7"},{"id":6089,"word":"\u1794\u1784\u17D2\u1782\u1784"},{"id":6090,"word":"\u1794\u1784\u17D2\u1782\u1793\u17CB"},{"id":6091,"word":"\u1794\u1784\u17D2\u1782\u179A"},{"id":6092,"word":"\u1794\u1784\u17D2\u1782\u17B6"},{"id":6093,"word":"\u1794\u1784\u17D2\u1782\u17B6\u1793"},{"id":6094,"word":"\u1794\u1784\u17D2\u1782\u17B6\u1794\u17CB"},{"id":6095,"word":"\u1794\u1784\u17D2\u1782\u17B6\u179C"},{"id":6096,"word":"\u1794\u1784\u17D2\u1782\u17B8"},{"id":6097,"word":"\u1794\u1784\u17D2\u1782\u17B8\u1794\u1784\u17D2\u1782\u17B6"},{"id":6098,"word":"\u1794\u1784\u17D2\u1782\u17BB\u1799"},{"id":6099,"word":"\u1794\u1784\u17D2\u1782\u17BD\u179A"},{"id":6100,"word":"\u1794\u1784\u17D2\u1782\u17C1\u1785"},{"id":6101,"word":"\u1794\u1784\u17D2\u1782\u17C4\u179B"},{"id":6102,"word":"\u1794\u1784\u17D2\u1782\u17C4\u17C7"},{"id":6103,"word":"\u1794\u1784\u17D2\u1782\u17C5"},{"id":6104,"word":"\u1794\u1784\u17D2\u1782\u17C6"},{"id":6105,"word":"\u1794\u1784\u17D2\u1794\u17C4\u1799"},{"id":6106,"word":"\u1794\u1784\u17D2\u1782\u17D2\u179A\u1794"},{"id":6107,"word":"\u1794\u1784\u17D2\u1782\u17D2\u179A\u1794\u17CB"},{"id":6108,"word":"\u1794\u1784\u17D2\u179A\u17B6\u179F"},{"id":6109,"word":"\u1794\u1784\u17D2\u179A\u17BB\u17C7"},{"id":6110,"word":"\u1794\u1784\u17D2\u179A\u17BD\u1789"},{"id":6111,"word":"\u1794\u1784\u17D2\u179A\u17BD\u1794"},{"id":6112,"word":"\u1794\u1784\u17D2\u179A\u17BD\u1798"},{"id":6113,"word":"\u1794\u1784\u17D2\u179A\u17C0\u1793"},{"id":6114,"word":"\u1794\u1784\u17D2\u179A\u17C4\u179F"},{"id":6115,"word":"\u1794\u1784\u17D2\u179A\u17C7"},{"id":6116,"word":"\u1794\u1784\u17D2\u179C\u17B7\u179B"},{"id":6117,"word":"\u1794\u1784\u17D2\u179C\u17B9\u1780"},{"id":6118,"word":"\u1794\u1784\u17D2\u179C\u17C0\u1793"},{"id":6119,"word":"\u1794\u1784\u17D2\u179C\u17C0\u17C7"},{"id":6120,"word":"\u1794\u1784\u17D2\u179C\u17C1\u1785"},{"id":6121,"word":"\u1794\u1784\u17D2\u179C\u17C1\u17C7"},{"id":6122,"word":"\u1794\u1784\u17D2\u179C\u17C2\u1784"},{"id":6123,"word":"\u1794\u1784\u17D2\u179C\u17C2\u179A"},{"id":6124,"word":"\u1794\u1784\u17D2\u179F\u17BB\u1780\u17BC\u179B"},{"id":6125,"word":"\u1794\u1784\u17D2\u17A0\u1780"},{"id":6126,"word":"\u1794\u1784\u17D2\u17A0\u1780\u17CB"},{"id":6127,"word":"\u1794\u1784\u17D2\u17A0\u178F\u17CB"},{"id":6128,"word":"\u1794\u1784\u17D2\u17A0\u1794"},{"id":6129,"word":"\u1794\u1784\u17D2\u17A0\u1794\u17CB"},{"id":6130,"word":"\u1794\u1784\u17D2\u17A0\u179B\u17CB"},{"id":6131,"word":"\u1794\u1784\u17D2\u17A0\u17B6"},{"id":6132,"word":"\u1794\u1784\u17D2\u17A0\u17B6\u1789"},{"id":6133,"word":"\u1794\u1784\u17D2\u17A0\u17B6\u178F\u17CB"},{"id":6134,"word":"\u1794\u1784\u17D2\u17A0\u17B6\u1794\u17CB"},{"id":6135,"word":"\u1794\u1784\u17D2\u17A0\u17B7\u1793"},{"id":6136,"word":"\u1794\u1784\u17D2\u17A0\u17B7\u179B"},{"id":6137,"word":"\u1794\u1784\u17D2\u17A0\u17BB\u1799"},{"id":6138,"word":"\u1794\u1784\u17D2\u17A0\u17BC\u178F"},{"id":6139,"word":"\u1794\u1784\u17D2\u17A0\u17BC\u179A"},{"id":6140,"word":"\u1794\u1784\u17D2\u17A0\u17BD\u178F"},{"id":6141,"word":"\u1794\u1784\u17D2\u17A0\u17BD\u179A"},{"id":6142,"word":"\u1794\u1784\u17D2\u17A0\u17BD\u179B"},{"id":6143,"word":"\u1794\u1784\u17D2\u17A0\u17BD\u179F"},{"id":6144,"word":"\u1794\u1784\u17D2\u17A0\u17BE\u1794"},{"id":6145,"word":"\u1794\u1784\u17D2\u17A0\u17BE\u1798"},{"id":6146,"word":"\u1794\u1784\u17D2\u17A0\u17BE\u1799"},{"id":6147,"word":"\u1794\u1784\u17D2\u17A0\u17BE\u179A"},{"id":6148,"word":"\u1794\u1784\u17D2\u17A0\u17C0\u179A"},{"id":6149,"word":"\u1794\u1784\u17D2\u17A0\u17C0\u179A\u1781\u17D2\u1798\u17BC\u178F"},{"id":6150,"word":"\u1794\u1784\u17D2\u17A0\u17C1\u179C"},{"id":6151,"word":"\u1794\u1784\u17D2\u17A0\u17C2"},{"id":6152,"word":"\u1794\u1784\u17D2\u17A0\u17C2\u1794"},{"id":6153,"word":"\u1794\u1784\u17D2\u17A0\u17C2\u179B"},{"id":6154,"word":"\u1794\u1784\u17D2\u17A0\u17C4\u1785"},{"id":6155,"word":"\u1794\u1784\u17D2\u17A0\u17C4\u17C7"},{"id":6156,"word":"\u1794\u1784\u17D2\u17A2\u1780"},{"id":6157,"word":"\u1794\u1784\u17D2\u17A2\u1784\u17CB"},{"id":6158,"word":"\u1794\u1784\u17D2\u17A2\u178F\u17CB"},{"id":6159,"word":"\u1794\u1784\u17D2\u17A2\u1793\u17CB"},{"id":6160,"word":"\u1794\u1784\u17D2\u17A2\u179A"},{"id":6161,"word":"\u1794\u1784\u17D2\u17A2\u179F\u17CB"},{"id":6162,"word":"\u1794\u1784\u17D2\u17A2\u17B6\u1780\u17CB"},{"id":6163,"word":"\u1794\u1784\u17D2\u17A2\u17B6\u1785"},{"id":6164,"word":"\u1794\u1784\u17D2\u17A2\u17B6\u1794\u17CB"},{"id":6165,"word":"\u1794\u1784\u17D2\u17A2\u17BB\u179A"},{"id":6166,"word":"\u1794\u1784\u17D2\u17A2\u17BC\u1793"},{"id":6167,"word":"\u1794\u1784\u17D2\u17A2\u17BC\u179F"},{"id":6168,"word":"\u1794\u1784\u17D2\u17A2\u17BD\u1785"},{"id":6169,"word":"\u1794\u1784\u17D2\u17A2\u17BD\u178F"},{"id":6170,"word":"\u1794\u1784\u17D2\u17A2\u17BD\u179B"},{"id":6171,"word":"\u1794\u1784\u17D2\u17A2\u17BE\u178F"},{"id":6172,"word":"\u1794\u1784\u17D2\u17A2\u17BE\u179B"},{"id":6173,"word":"\u1794\u1784\u17D2\u17A2\u17C0\u1784"},{"id":6174,"word":"\u1794\u1784\u17D2\u17A2\u17C0\u1793"},{"id":6175,"word":"\u1794\u1784\u17D2\u17A2\u17C0\u179C"},{"id":6176,"word":"\u1794\u1784\u17D2\u17A2\u17C2"},{"id":6177,"word":"\u1794\u1784\u17D2\u17A2\u17C2\u1780"},{"id":6178,"word":"\u1794\u1784\u17D2\u17A2\u17C2\u1793"},{"id":6179,"word":"\u1794\u1784\u17D2\u17A2\u17C2\u1794"},{"id":6180,"word":"\u1794\u1784\u17D2\u17A2\u17C2\u1798"},{"id":6181,"word":"\u1794\u1784\u17D2\u17A2\u17C4\u1784"},{"id":6182,"word":"\u1794\u1784\u17D2\u17A2\u17C4\u178F"},{"id":6183,"word":"\u1794\u1784\u17D2\u17A2\u17C4\u1793"},{"id":6184,"word":"\u1794\u1784\u17D2\u17A2\u17C4\u179A"},{"id":6185,"word":"\u1794\u1784\u17D2\u17A2\u17C5"},{"id":6186,"word":"\u1794\u1789\u17D2\u1785\u1784\u17CB"},{"id":6187,"word":"\u1794\u1789\u17D2\u1785\u1784\u17D2\u1782"},{"id":6188,"word":"\u1794\u1789\u17D2\u1785\u1794\u17CB"},{"id":6189,"word":"\u1794\u1789\u17D2\u1785\u1796\u178E\u17CC"},{"id":6190,"word":"\u1794\u1789\u17D2\u1785\u179A\u1784\u17D2\u1782"},{"id":6191,"word":"\u1794\u1789\u17D2\u1785\u17B6"},{"id":6192,"word":"\u1794\u1789\u17D2\u1785\u17B6\u1785\u17CB"},{"id":6193,"word":"\u1794\u1789\u17D2\u1785\u17B6\u179B\u17CB"},{"id":6194,"word":"\u1794\u1789\u17D2\u1785\u17BB\u1780"},{"id":6195,"word":"\u1794\u1789\u17D2\u1785\u17BB\u17C7"},{"id":6196,"word":"\u1794\u1789\u17D2\u1785\u17BC\u179B"},{"id":6197,"word":"\u1794\u1789\u17D2\u1785\u17BE"},{"id":6198,"word":"\u1794\u1789\u17D2\u1785\u17BE\u1785"},{"id":6199,"word":"\u1794\u1789\u17D2\u1785\u17C0\u179F"},{"id":6200,"word":"\u1794\u1789\u17D2\u1785\u17C1\u1789"},{"id":6201,"word":"\u1794\u1789\u17D2\u1785\u17C1\u179A"},{"id":6202,"word":"\u1794\u1789\u17D2\u1785\u17C1\u17C7"},{"id":6203,"word":"\u1794\u1789\u17D2\u1785\u17C4\u179A"},{"id":6204,"word":"\u1794\u1789\u17D2\u1785\u17B6\u17C6"},{"id":6205,"word":"\u1794\u1789\u17D2\u1785\u17B6\u17C6\u1784"},{"id":6206,"word":"\u1794\u1789\u17D2\u1785\u17D2\u179A\u1780"},{"id":6207,"word":"\u1794\u1789\u17D2\u1785\u17D2\u179A\u17B6\u179F"},{"id":6208,"word":"\u1794\u1789\u17D2\u1785\u17D2\u179A\u17B7\u1785"},{"id":6209,"word":"\u1794\u1789\u17D2\u1785\u17D2\u179A\u17BC\u1785"},{"id":6210,"word":"\u1794\u1789\u17D2\u1785\u17D2\u179A\u17C4\u17C7"},{"id":6211,"word":"\u1794\u1789\u17D2\u1786\u17B6\u1780"},{"id":6212,"word":"\u1794\u1789\u17D2\u1786\u17B6\u1785\u17CB"},{"id":6213,"word":"\u1794\u1789\u17D2\u1786\u17B6\u1794"},{"id":6214,"word":"\u1794\u1789\u17D2\u1786\u17B7\u1785"},{"id":6215,"word":"\u1794\u1789\u17D2\u1786\u17B7\u178F"},{"id":6216,"word":"\u1794\u1789\u17D2\u1786\u17B9\u1780"},{"id":6217,"word":"\u1794\u1789\u17D2\u1786\u17BB\u1780"},{"id":6218,"word":"\u1794\u1789\u17D2\u1786\u17BD\u179B"},{"id":6219,"word":"\u1794\u1789\u17D2\u1786\u17BE\u178F"},{"id":6220,"word":"\u1794\u1789\u17D2\u1786\u17C0\u1784"},{"id":6221,"word":"\u1794\u1789\u17D2\u1786\u17C1\u17C7"},{"id":6222,"word":"\u1794\u1789\u17D2\u1786\u17C4\u178F"},{"id":6223,"word":"\u1794\u1789\u17D2\u1787\u1780\u17CB"},{"id":6224,"word":"\u1794\u1789\u17D2\u1787\u1785\u17CB"},{"id":6225,"word":"\u1794\u1789\u17D2\u1787\u178F"},{"id":6226,"word":"\u1794\u1789\u17D2\u1787\u179A"},{"id":6227,"word":"\u1794\u1789\u17D2\u1787\u179B\u17CB"},{"id":6228,"word":"\u1794\u1789\u17D2\u1787\u17B6"},{"id":6229,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1780\u17CB"},{"id":6230,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1780\u17B6\u179A"},{"id":6231,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1793\u17CB"},{"id":6232,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1793\u17CB\u178F\u17D2\u179A\u179F\u17D2\u178A\u17B7"},{"id":6233,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1794\u17CB"},{"id":6234,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1794\u17CB\u1796\u17B6\u1780\u17D2\u1799"},{"id":6235,"word":"\u1794\u1789\u17D2\u1787\u17B6\u1794\u17CB\u1796\u17D2\u179A\u179B\u17B9\u1784"},{"id":6236,"word":"\u1794\u1789\u17D2\u1787\u17B7\u1780\u17B6"},{"id":6237,"word":"\u1794\u1789\u17D2\u1787\u17B7\u1780\u17B6\u1780\u17D2\u179A\u17B9\u178F"},{"id":6238,"word":"\u1794\u1789\u17D2\u1787\u17B7\u17C7"},{"id":6239,"word":"\u1794\u1789\u17D2\u1787\u17B8"},{"id":6240,"word":"\u1794\u1789\u17D2\u1787\u17BC\u1793"},{"id":6241,"word":"\u1794\u1789\u17D2\u1787\u17BE\u1785"},{"id":6242,"word":"\u1794\u1789\u17D2\u1787\u17C4\u1780"},{"id":6243,"word":"\u1794\u1789\u17D2\u1787\u17C4\u179A"},{"id":6244,"word":"\u1794\u1789\u17D2\u1787\u17C4\u17C7"},{"id":6245,"word":"\u1794\u1789\u17D2\u1787\u17D2\u179A\u1780"},{"id":6246,"word":"\u1794\u1789\u17D2\u1787\u17D2\u179A\u17B6\u1794"},{"id":6247,"word":"\u1794\u1789\u17D2\u1787\u17D2\u179A\u17B6\u179B"},{"id":6248,"word":"\u1794\u1789\u17D2\u1787\u17D2\u179A\u17B7\u17C7"},{"id":6249,"word":"\u1794\u1789\u17D2\u1787\u17D2\u179A\u17BB\u179B"},{"id":6250,"word":"\u1794\u1789\u17D2\u1787\u17D2\u179A\u17BD\u179F"},{"id":6251,"word":"\u1794\u1789\u17D2\u1788\u1794\u17CB"},{"id":6252,"word":"\u1794\u1789\u17D2\u1788\u179A"},{"id":6253,"word":"\u1794\u1789\u17D2\u1788\u17BA"},{"id":6254,"word":"\u1794\u1789\u17D2\u1788\u17C2\u179B"},{"id":6255,"word":"\u1794\u1789\u17D2\u1789\u178F\u17D2\u178F"},{"id":6256,"word":"\u1794\u1789\u17D2\u1789\u178F\u17D2\u178F\u17B7"},{"id":6257,"word":"\u1794\u1789\u17D2\u1789\u17BE"},{"id":6258,"word":"\u1794\u1789\u17D2\u1789\u17BE\u1780\u17D2\u17A2\u17C2\u1780"},{"id":6259,"word":"\u1794\u1789\u17D2\u1789\u17C2"},{"id":6260,"word":"\u1794\u1789\u17D2\u1789\u17C2\u1798"},{"id":6261,"word":"\u1794\u1789\u17D2\u17A0\u17B6"},{"id":6262,"word":"\u1794\u178E\u17D2\u178A\u17B6"},{"id":6263,"word":"\u1794\u178E\u17D2\u178A\u17B6\u1780\u17CB"},{"id":6264,"word":"\u1794\u178E\u17D2\u178A\u17B6\u1785\u17CB"},{"id":6265,"word":"\u1794\u178E\u17D2\u178A\u17B6\u1789"},{"id":6266,"word":"\u1794\u178E\u17D2\u178A\u17B6\u179B"},{"id":6267,"word":"\u1794\u178E\u17D2\u178A\u17B6\u179F\u17B6"},{"id":6268,"word":"\u1794\u178E\u17D2\u178A\u17B7\u1794"},{"id":6269,"word":"\u1794\u178E\u17D2\u178A\u17B9\u1784"},{"id":6270,"word":"\u1794\u178E\u17D2\u178A\u17B9\u1794"},{"id":6271,"word":"\u1794\u178E\u17D2\u178A\u17BB\u1793"},{"id":6272,"word":"\u1794\u178E\u17D2\u178A\u17BB\u17C7"},{"id":6273,"word":"\u1794\u178E\u17D2\u178A\u17BC\u179B"},{"id":6274,"word":"\u1794\u178E\u17D2\u178A\u17BC\u179B\u179B\u17D2\u1796\u17C5"},{"id":6275,"word":"\u1794\u178E\u17D2\u178A\u17BE\u179A"},{"id":6276,"word":"\u1794\u178E\u17D2\u178A\u17C1\u1789"},{"id":6277,"word":"\u1794\u178E\u17D2\u178A\u17C2\u178F"},{"id":6278,"word":"\u1794\u178E\u17D2\u178A\u17C4\u1799"},{"id":6279,"word":"\u1794\u178E\u17D2\u178A\u17C4\u17C7"},{"id":6280,"word":"\u1794\u178E\u17D2\u178A\u17C4\u17C7\u1794\u178E\u17D2\u178A\u17C3"},{"id":6281,"word":"\u1794\u178E\u17D2\u178A\u17C4\u17C7\u17A2\u17B6\u179F\u1793\u17D2\u1793"},{"id":6282,"word":"\u1794\u178E\u17D2\u178A\u17C5"},{"id":6283,"word":"\u1794\u178E\u17D2\u178A\u17BB\u17C6"},{"id":6284,"word":"\u1794\u178E\u17D2\u178A\u17B6\u17C6"},{"id":6285,"word":"\u1794\u178E\u17D2\u178C\u1780"},{"id":6286,"word":"\u1794\u178E\u17D2\u178C\u17B6"},{"id":6287,"word":"\u1794\u178E\u17D2\u178C\u17B7\u178F"},{"id":6288,"word":"\u1794\u178E\u17D2\u178C\u17B7\u178F\u1798\u17B6\u1793\u17C7"},{"id":6289,"word":"\u1794\u178E\u17D2\u178C\u17B7\u178F\u1798\u17B6\u1793\u17B8"},{"id":6290,"word":"\u1794\u178E\u17D2\u178C\u17B7\u178F\u17D2\u1799"},{"id":6291,"word":"\u1794\u178E\u17D2\u178C\u17BB\u1780\u1798\u17D2\u1796\u179B\u179F\u17B7\u179B\u17B6"},{"id":6292,"word":"\u1794\u178E\u17D2\u178C\u17BB\u179A\u17C4\u1782"},{"id":6293,"word":"\u1794\u178E\u17D2\u178E\u179F\u17B6\u179B\u17B6"},{"id":6294,"word":"\u1794\u178E\u17D2\u178E\u17B6\u1780\u17B6\u179A"},{"id":6295,"word":"\u1794\u178E\u17D2\u178E\u17C2"},{"id":6296,"word":"\u1794\u178F\u17CB"},{"id":6297,"word":"\u1794\u178F\u17CB\u1787\u17BE\u1784"},{"id":6298,"word":"\u1794\u1791"},{"id":6299,"word":"\u1794\u1793"},{"id":6300,"word":"\u1794\u1793\u17CB"},{"id":6301,"word":"\u1794\u1793\u17D2\u178F"},{"id":6302,"word":"\u1794\u1793\u17D2\u178F\u1780\u17CB"},{"id":6303,"word":"\u1794\u1793\u17D2\u178F\u1798"},{"id":6304,"word":"\u1794\u1793\u17D2\u178F\u17B7\u1785"},{"id":6305,"word":"\u1794\u1793\u17D2\u178F\u17B9\u1784"},{"id":6306,"word":"\u1794\u1793\u17D2\u178F\u17BB\u1794"},{"id":6307,"word":"\u1794\u1793\u17D2\u178F\u17BB\u17C7"},{"id":6308,"word":"\u1794\u1793\u17D2\u178F\u17BC\u1785"},{"id":6309,"word":"\u1794\u1793\u17D2\u178F\u17BD\u1785"},{"id":6310,"word":"\u1794\u1793\u17D2\u178F\u17BE\u178F"},{"id":6311,"word":"\u1794\u1793\u17D2\u178F\u17C4\u1780"},{"id":6312,"word":"\u1794\u1793\u17D2\u178F\u17C4\u1784"},{"id":6313,"word":"\u1794\u1793\u17D2\u1790\u178F"},{"id":6314,"word":"\u1794\u1793\u17D2\u1790\u1799"},{"id":6315,"word":"\u1794\u1793\u17D2\u1790\u17BB\u1785"},{"id":6316,"word":"\u1794\u1793\u17D2\u1790\u17BE\u179A"},{"id":6317,"word":"\u1794\u1793\u17D2\u1790\u17C2"},{"id":6318,"word":"\u1794\u1793\u17D2\u1790\u17C2\u1798"},{"id":6319,"word":"\u1794\u1793\u17D2\u1790\u17C4\u1780"},{"id":6320,"word":"\u1794\u1793\u17D2\u1791\u1785\u17CB"},{"id":6321,"word":"\u1794\u1793\u17D2\u1791\u1793\u17CB"},{"id":6322,"word":"\u1794\u1793\u17D2\u1791\u1794\u17CB"},{"id":6323,"word":"\u1794\u1793\u17D2\u1791\u179A"},{"id":6324,"word":"\u1794\u1793\u17D2\u1791\u17B6\u178F\u17CB"},{"id":6325,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1793\u17CB"},{"id":6326,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1794"},{"id":6327,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB"},{"id":6328,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB\u1794\u1793\u17D2\u179F\u17C6"},{"id":6329,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799"},{"id":6330,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799\u1780\u17B7\u179B"},{"id":6331,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799\u1780\u17D2\u178A\u17B8"},{"id":6332,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799\u1786\u17D2\u1798\u17B6\u179A"},{"id":6333,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799\u1798\u17B6\u179F"},{"id":6334,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799\u179B\u1784\u17D2\u179C\u17C2\u1780"},{"id":6335,"word":"\u1794\u1793\u17D2\u1791\u17B6\u1799\u179F\u17D2\u179A\u17B8"},{"id":6336,"word":"\u1794\u1793\u17D2\u1791\u17B6\u179A"},{"id":6337,"word":"\u1794\u1793\u17D2\u1791\u17B6\u179B"},{"id":6338,"word":"\u1794\u1793\u17D2\u1791\u17B6\u179B\u17CB"},{"id":6339,"word":"\u1794\u1793\u17D2\u1791\u17B6\u179F"},{"id":6340,"word":"\u1794\u1793\u17D2\u1791\u17B8\u1784"},{"id":6341,"word":"\u1794\u1793\u17D2\u1791\u17BB\u1780"},{"id":6342,"word":"\u1794\u1793\u17D2\u1791\u17BB\u179B"},{"id":6343,"word":"\u1794\u1793\u17D2\u1791\u17BC\u179B"},{"id":6344,"word":"\u1794\u1793\u17D2\u1791\u17BE\u1784"},{"id":6345,"word":"\u1794\u1793\u17D2\u1791\u17BE\u178F"},{"id":6346,"word":"\u1794\u1793\u17D2\u1791\u17BE\u179A"},{"id":6347,"word":"\u1794\u1793\u17D2\u1791\u17C1\u179A"},{"id":6348,"word":"\u1794\u1793\u17D2\u1791\u17C4"},{"id":6349,"word":"\u1794\u1793\u17D2\u1791\u17C4\u1794\u1784\u17CB"},{"id":6350,"word":"\u1794\u1793\u17D2\u1791\u17C4\u179F"},{"id":6351,"word":"\u1794\u1793\u17D2\u1791\u17C4\u17C7"},{"id":6352,"word":"\u1794\u1793\u17D2\u1791\u17C4\u17C7\u1794\u17D2\u179A\u17A0\u17BB\u1780"},{"id":6353,"word":"\u1794\u1793\u17D2\u1791\u17BB\u17C6"},{"id":6354,"word":"\u1794\u1793\u17D2\u1791\u17C6"},{"id":6355,"word":"\u1794\u1793\u17D2\u1791\u17C7"},{"id":6356,"word":"\u1794\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1793\u17CB"},{"id":6357,"word":"\u1794\u1793\u17D2\u1791\u17D2\u179A\u17C1\u178F"},{"id":6358,"word":"\u1794\u1793\u17D2\u1791\u17D2\u179A\u17C4\u1798"},{"id":6359,"word":"\u1794\u1793\u17D2\u1792\u17B6\u178F\u17CB"},{"id":6360,"word":"\u1794\u1793\u17D2\u1792\u17BC\u179A"},{"id":6361,"word":"\u1794\u1793\u17D2\u1792\u17C6"},{"id":6362,"word":"\u1794\u1793\u17D2\u179B\u1794\u17CB"},{"id":6363,"word":"\u1794\u1793\u17D2\u179B\u17B6"},{"id":6364,"word":"\u1794\u1793\u17D2\u179B\u17B6\u1785"},{"id":6365,"word":"\u1794\u1793\u17D2\u179B\u17B6\u1799"},{"id":6366,"word":"\u1794\u1793\u17D2\u179B\u17B6\u179F\u17CB"},{"id":6367,"word":"\u1794\u1793\u17D2\u179B\u17B7\u1785"},{"id":6368,"word":"\u1794\u1793\u17D2\u179B\u17B9\u1798"},{"id":6369,"word":"\u1794\u1793\u17D2\u179B\u17BA"},{"id":6370,"word":"\u1794\u1793\u17D2\u179B\u17BB\u1780"},{"id":6371,"word":"\u1794\u1793\u17D2\u179B\u17BB\u1784"},{"id":6372,"word":"\u1794\u1793\u17D2\u179B\u17BB\u1799"},{"id":6373,"word":"\u1794\u1793\u17D2\u179B\u17BD\u1789"},{"id":6374,"word":"\u1794\u1793\u17D2\u179B\u17C0\u1780"},{"id":6375,"word":"\u1794\u1793\u17D2\u179B\u17C0\u1793"},{"id":6376,"word":"\u1794\u1793\u17D2\u179B\u17C2"},{"id":6377,"word":"\u1794\u1793\u17D2\u179B\u17C2\u1794\u1784\u17D2\u1780\u17B6\u179A"},{"id":6378,"word":"\u1794\u1793\u17D2\u179B\u17C2\u1784"},{"id":6379,"word":"\u1794\u1793\u17D2\u179B\u17C4\u17C7"},{"id":6380,"word":"\u1794\u1793\u17D2\u179B\u17C6"},{"id":6381,"word":"\u1794\u1793\u17D2\u179F\u179B\u17CB"},{"id":6382,"word":"\u1794\u1793\u17D2\u179F\u17B6\u1780\u17CB"},{"id":6383,"word":"\u1794\u1793\u17D2\u179F\u17B6\u178F\u17CB"},{"id":6384,"word":"\u1794\u1793\u17D2\u179F\u17B6\u1794"},{"id":6385,"word":"\u1794\u1793\u17D2\u179F\u17B6\u179A"},{"id":6386,"word":"\u1794\u1793\u17D2\u179F\u17B6\u179B\u17CB"},{"id":6387,"word":"\u1794\u1793\u17D2\u179F\u17C9\u17B8"},{"id":6388,"word":"\u1794\u1793\u17D2\u179F\u17BB\u1791\u17D2\u1792"},{"id":6389,"word":"\u1794\u1793\u17D2\u179F\u17BE\u1785"},{"id":6390,"word":"\u1794\u1793\u17D2\u179F\u17BE\u1798"},{"id":6391,"word":"\u1794\u1793\u17D2\u179F\u17C4\u17C7"},{"id":6392,"word":"\u1794\u1793\u17D2\u179F\u17B6\u17C6"},{"id":6393,"word":"\u1794\u1793\u17D2\u179F\u17C7"},{"id":6394,"word":"\u1794\u1794\u1780\u17CB"},{"id":6395,"word":"\u1794\u1794\u179A"},{"id":6396,"word":"\u1794\u1794\u17BB\u179F"},{"id":6397,"word":"\u1794\u1794\u17BC\u179A"},{"id":6398,"word":"\u1794\u1794\u17BD\u179B"},{"id":6399,"word":"\u1794\u1794\u17C2\u179B"},{"id":6400,"word":"\u1794\u1794\u17C4\u179F"},{"id":6401,"word":"\u1794\u1794\u17C4\u179F\u17A2\u1784\u17D2\u17A2\u17C2\u179B"},{"id":6402,"word":"\u1794\u1796\u17D2\u179C\u17C8"},{"id":6403,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u1793\u17D2\u178F\u17C1\u179C\u17B6\u179F\u17B7\u1780"},{"id":6404,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u17B6"},{"id":6405,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u17B6\u1780\u1798\u17D2\u1798"},{"id":6406,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":6407,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u17B6\u1793\u17B7\u179F\u1784\u17D2\u179F"},{"id":6408,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u17B6\u1794\u17C1\u1780\u17D2\u1781\u17C8"},{"id":6409,"word":"\u1794\u1796\u17D2\u179C\u1787\u17D2\u1787\u17B6\u179C\u17B7\u1792\u17B8"},{"id":6410,"word":"\u1794\u1796\u17D2\u179C\u1787\u17B7\u178F"},{"id":6411,"word":"\u1794\u1796\u17D2\u179C\u1787\u17B7\u178F\u1793\u17B6\u1798"},{"id":6412,"word":"\u1794\u1796\u17D2\u179C\u178F\u179A\u17B6\u1787"},{"id":6413,"word":"\u1794\u1796\u17D2\u179C\u17B6\u1787\u1793\u17B8\u1799\u1780\u1798\u17D2\u1798"},{"id":6414,"word":"\u1794\u1796\u17B7\u178F\u17D2\u179A"},{"id":6415,"word":"\u1794\u1798"},{"id":6416,"word":"\u1794\u1798\u17D2\u179A\u17B6\u1794"},{"id":6417,"word":"\u1794\u1798\u17D2\u179A\u17B6\u1794\u17CB"},{"id":6418,"word":"\u1794\u1798\u17D2\u179A\u17B6\u1798"},{"id":6419,"word":"\u1794\u1798\u17D2\u179A\u17B6\u179F"},{"id":6420,"word":"\u1794\u1798\u17D2\u179A\u17B6\u179F\u17CB"},{"id":6421,"word":"\u1794\u1798\u17D2\u179A\u17B9\u1784"},{"id":6422,"word":"\u1794\u1798\u17D2\u179A\u17BB\u1784"},{"id":6423,"word":"\u1794\u1798\u17D2\u179A\u17BE"},{"id":6424,"word":"\u1794\u1798\u17D2\u179A\u17C4\u179F"},{"id":6425,"word":"\u1794\u1798\u17D2\u179A\u17C7"},{"id":6426,"word":"\u1794\u179A"},{"id":6427,"word":"\u1794\u179A\u1782\u17B6\u179C"},{"id":6428,"word":"\u1794\u179A\u1791\u17C1\u179F"},{"id":6429,"word":"\u1794\u179A\u1796\u178F"},{"id":6430,"word":"\u1794\u179A\u1798"},{"id":6431,"word":"\u1794\u179A\u1798\u1780\u17C4\u178A\u17D2\u178B"},{"id":6432,"word":"\u1794\u179A\u1798\u178F\u17D2\u1790"},{"id":6433,"word":"\u1794\u179A\u1798\u178F\u17D2\u1790\u1780\u1790\u17B6"},{"id":6434,"word":"\u1794\u179A\u1798\u178F\u17D2\u1790\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":6435,"word":"\u1794\u179A\u1798\u178F\u17D2\u1790\u179C\u17B7\u1791\u17BC"},{"id":6436,"word":"\u1794\u179A\u1798\u17B6\u1783"},{"id":6437,"word":"\u1794\u179A\u179B\u17C4\u1780"},{"id":6438,"word":"\u1794\u179A\u17B7\u1780\u1798\u17D2\u1798"},{"id":6439,"word":"\u1794\u179A\u17B7\u1780\u17D2\u1781\u17B6\u179A"},{"id":6440,"word":"\u1794\u179A\u17B7\u1785\u17D2\u1785\u17B6\u1782"},{"id":6441,"word":"\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791"},{"id":6442,"word":"\u1794\u179A\u17B7\u1794\u17BC\u179A"},{"id":6443,"word":"\u1794\u179A\u17B7\u1794\u17BC\u179A\u178E\u17CD"},{"id":6444,"word":"\u1794\u179A\u17B7\u1794\u17BC\u178E\u17CC"},{"id":6445,"word":"\u1794\u179A\u17B7\u1796\u17B6\u179A"},{"id":6446,"word":"\u1794\u179A\u17B7\u1797\u17B6\u179F"},{"id":6447,"word":"\u1794\u179A\u17B7\u1797\u17B6\u179F\u1780\u17C8"},{"id":6448,"word":"\u1794\u179A\u17B7\u1797\u17B6\u179F\u1793\u17CD"},{"id":6449,"word":"\u1794\u179A\u17B7\u1797\u17B6\u179F\u17B7\u1780\u17B6"},{"id":6450,"word":"\u1794\u179A\u17B7\u1797\u17C4\u1780\u17D2\u178A\u17B6"},{"id":6451,"word":"\u1794\u179A\u17B7\u1797\u17C4\u1782"},{"id":6452,"word":"\u1794\u179A\u17B7\u1797\u17C4\u1782\u1794\u17D0\u178E\u17D2\u178E"},{"id":6453,"word":"\u1794\u179A\u17B7\u1799\u17B6\u1799"},{"id":6454,"word":"\u1794\u179A\u17B7\u179A\u1780\u17D2\u179F"},{"id":6455,"word":"\u1794\u179A\u17B7\u179C\u17B6\u179A"},{"id":6456,"word":"\u1794\u179A\u17B7\u179C\u17B6\u179A\u179F\u1798\u17D2\u1794\u17D0\u1791"},{"id":6457,"word":"\u1794\u179A\u17B7\u179C\u17B6\u179F"},{"id":6458,"word":"\u1794\u179A\u17B7\u179C\u17B6\u179F\u1780\u1798\u17D2\u1798"},{"id":6459,"word":"\u1794\u179A\u17B7\u179C\u17C1\u178E"},{"id":6460,"word":"\u1794\u179A\u17B7\u179F\u17D0\u1791"},{"id":6461,"word":"\u1794\u179A\u17B7\u179F\u1791\u17D2\u1799"},{"id":6462,"word":"\u1794\u179A\u17B7\u179F\u17BB\u1791\u17D2\u1792"},{"id":6463,"word":"\u1794\u179A\u17B7\u179F\u17BB\u1791\u17D2\u1792\u17B7"},{"id":6464,"word":"\u1794\u179A\u17B7\u17A0\u17B6\u179A"},{"id":6465,"word":"\u1794\u179A\u17C4\u17A0\u17B7\u178F"},{"id":6466,"word":"\u1794\u179C\u179A"},{"id":6467,"word":"\u1794\u179C\u179A\u1780\u1789\u17D2\u1789\u17B6"},{"id":6468,"word":"\u1794\u179F\u17D2\u1785\u17B7\u1798"},{"id":6469,"word":"\u1794\u17B6"},{"id":6470,"word":"\u1794\u17B6\u1780\u17CB"},{"id":6471,"word":"\u1794\u17B6\u1780\u17CB\u1782\u17B6\u17C6"},{"id":6472,"word":"\u1794\u17B6\u1780\u17CB\u1787\u17D0\u179A\u1794\u17B6\u1799"},{"id":6473,"word":"\u1794\u17B6\u1780\u17CB\u178A\u1784"},{"id":6474,"word":"\u1794\u17B6\u1780\u17CB\u178A\u17C6\u17A1\u17BC\u1784"},{"id":6475,"word":"\u1794\u17B6\u1780\u17CB\u1794\u1794"},{"id":6476,"word":"\u1794\u17B6\u1780\u17CB\u1795\u17D2\u178A\u17C5"},{"id":6477,"word":"\u1794\u17B6\u1780\u17CB\u179F\u17B6\u1785\u17CB"},{"id":6478,"word":"\u1794\u17B6\u1780\u17CB\u179F\u17D2\u1794\u17B6\u178F"},{"id":6479,"word":"\u1794\u17B6\u1780\u17B6\u1793"},{"id":6480,"word":"\u1794\u17B6\u1781\u17C2\u1784"},{"id":6481,"word":"\u1794\u17B6\u1782\u1784"},{"id":6482,"word":"\u1794\u17B6\u1782\u17C4"},{"id":6483,"word":"\u1794\u17B6\u1784"},{"id":6484,"word":"\u1794\u17B6\u1784\u1780\u1780"},{"id":6485,"word":"\u1794\u17B6\u1785"},{"id":6486,"word":"\u1794\u17B6\u1785\u17CB"},{"id":6487,"word":"\u1794\u17B6\u1785\u179F\u179A"},{"id":6488,"word":"\u1794\u17B6\u1789"},{"id":6489,"word":"\u1794\u17B6\u1789\u17CB"},{"id":6490,"word":"\u1794\u17B6\u1789\u17CB\u179A\u1784"},{"id":6491,"word":"\u1794\u17B6\u178F"},{"id":6492,"word":"\u1794\u17B6\u178F\u17CB"},{"id":6493,"word":"\u1794\u17B6\u178F\u17CB\u178A\u17B9\u1784"},{"id":6494,"word":"\u1794\u17B6\u178F\u17CB\u1794\u1784\u17CB"},{"id":6495,"word":"\u1794\u17B6\u178F\u17B6\u179B"},{"id":6496,"word":"\u1794\u17B6\u178F\u17D2\u179A"},{"id":6497,"word":"\u1794\u17B6\u1791"},{"id":6498,"word":"\u1794\u17B6\u1791\u1785\u179A\u178E\u17CD"},{"id":6499,"word":"\u1794\u17B6\u1791\u1785\u17B6\u179A\u17B8"},{"id":6500,"word":"\u1794\u17B6\u1791\u1794\u179A\u17B7\u1785\u17B6\u179A\u17B7\u1780\u17B6"},{"id":6501,"word":"\u1794\u17B6\u1791\u1798\u17BC\u179B"},{"id":6502,"word":"\u1794\u17B6\u1791\u1799\u17BB\u1782\u179B"},{"id":6503,"word":"\u1794\u17B6\u1791\u17B6"},{"id":6504,"word":"\u1794\u17B6\u1791\u17B8"},{"id":6505,"word":"\u1794\u17B6\u1791\u17BB\u1780"},{"id":6506,"word":"\u1794\u17B6\u1793"},{"id":6507,"word":"\u1794\u17B6\u1794"},{"id":6508,"word":"\u1794\u17B6\u1794\u1780\u1798\u17D2\u1798"},{"id":6509,"word":"\u1794\u17B6\u1794\u1782\u17D2\u179A\u17C4\u17C7"},{"id":6510,"word":"\u1794\u17B6\u1794\u1785\u17B7\u178F\u17D2\u178F"},{"id":6511,"word":"\u1794\u17B6\u1794\u1792\u1798\u17CC"},{"id":6512,"word":"\u1794\u17B6\u1794\u1798\u17B7\u178F\u17D2\u178F"},{"id":6513,"word":"\u1794\u17B6\u1796\u17BD\u1793"},{"id":6514,"word":"\u1794\u17B6\u1797\u17D2\u1793\u17C6"},{"id":6515,"word":"\u1794\u17B6\u1799"},{"id":6516,"word":"\u1794\u17B6\u1799\u1780\u1780"},{"id":6517,"word":"\u1794\u17B6\u1799\u1780\u17D2\u178A\u17B6\u17C6\u1784"},{"id":6518,"word":"\u1794\u17B6\u1799\u1780\u17D2\u179A\u1789\u17B7\u1789"},{"id":6519,"word":"\u1794\u17B6\u1799\u1780\u17D2\u179A\u17C0\u1798"},{"id":6520,"word":"\u1794\u17B6\u1799\u1780\u17D2\u17A2\u17C2\u1780"},{"id":6521,"word":"\u1794\u17B6\u1799\u1781\u17BB\u1793"},{"id":6522,"word":"\u1794\u17B6\u1799\u1781\u17BB\u17C6"},{"id":6523,"word":"\u1794\u17B6\u1799\u1782\u17C6\u1791\u17B9\u1780"},{"id":6524,"word":"\u1794\u17B6\u1799\u178A\u17C6\u178E\u17BE\u1794"},{"id":6525,"word":"\u1794\u17B6\u1799\u178F\u1798\u17D2\u179A\u17B6\u17C6"},{"id":6526,"word":"\u1794\u17B6\u1799\u17D0\u1793"},{"id":6527,"word":"\u1794\u17B6\u1799\u1794\u178F\u17D2\u178F\u1794\u17BC\u179A"},{"id":6528,"word":"\u1794\u17B6\u1799\u1794\u17C0\u1784"},{"id":6529,"word":"\u1794\u17B6\u1799\u1796\u17D2\u179A\u179B\u17B9\u1784"},{"id":6530,"word":"\u1794\u17B6\u1799\u1798\u17C9\u17B6\u178F"},{"id":6531,"word":"\u1794\u17B6\u1799\u1798\u17C9\u17B6\u1793"},{"id":6532,"word":"\u1794\u17B6\u1799\u179F\u17B7\u1784\u17D2\u1783\u17B6\u178A\u1780\u17CD"},{"id":6533,"word":"\u1794\u17B6\u1799\u179F\u17B8"},{"id":6534,"word":"\u1794\u17B6\u1799\u179F\u17D2\u179A\u17B8"},{"id":6535,"word":"\u1794\u17B6\u1799\u17A1\u17B8"},{"id":6536,"word":"\u1794\u17B6\u1799\u17A1\u17BB\u1780\u1794\u17B6\u1799\u17A1"},{"id":6537,"word":"\u1794\u17B6\u1799\u17A2"},{"id":6538,"word":"\u1794\u17B6\u1799\u17A2\u1782\u17C4\u1798\u17D0\u1799"},{"id":6539,"word":"\u1794\u17B6\u1799\u17B6\u1794"},{"id":6540,"word":"\u1794\u17B6\u1799\u17B6\u179F"},{"id":6541,"word":"\u1794\u17B6\u179A"},{"id":6542,"word":"\u1794\u17B6\u179A\u1782\u17BC"},{"id":6543,"word":"\u1794\u17B6\u179A\u178F"},{"id":6544,"word":"\u1794\u17B6\u179A\u1791"},{"id":6545,"word":"\u1794\u17B6\u179A\u1798\u17D2\u1797"},{"id":6546,"word":"\u1794\u17B6\u179A\u1798\u17B8"},{"id":6547,"word":"\u1794\u17B6\u179A\u17B6\u1799"},{"id":6548,"word":"\u1794\u17B6\u179A\u17B6\u1799\u178E\u17CD"},{"id":6549,"word":"\u1794\u17B6\u179A\u17B6\u1799\u178E\u17CD\u1791\u17B9\u1780\u1790\u17D2\u179B\u17B6"},{"id":6550,"word":"\u1794\u17B6\u179A\u17B6\u179F"},{"id":6551,"word":"\u1794\u17B6\u179A\u17B8"},{"id":6552,"word":"\u1794\u17B6\u179A\u17C0\u1793"},{"id":6553,"word":"\u1794\u17B6\u179A\u17B6\u17C6"},{"id":6554,"word":"\u1794\u17B6\u179A\u17B6\u17C6\u1780\u17C6\u1796\u17BC\u179B"},{"id":6555,"word":"\u1794\u17B6\u179A\u17B6\u17C6\u1784"},{"id":6556,"word":"\u1794\u17B6\u179A\u17B6\u17C6\u1784\u179F\u17C2\u179F"},{"id":6557,"word":"\u1794\u17B6\u179A\u17B6\u17C6\u1799\u17C9\u178F"},{"id":6558,"word":"\u1794\u17B6\u179B\u17CB"},{"id":6559,"word":"\u1794\u17B6\u179B\u17D0\u178A\u17D2\u178B"},{"id":6560,"word":"\u1794\u17B6\u179B\u17B8"},{"id":6561,"word":"\u1794\u17B6\u179C"},{"id":6562,"word":"\u1794\u17B6\u179C\u1796\u17D2\u179A\u17B6\u179C"},{"id":6563,"word":"\u1794\u17B6\u179F"},{"id":6564,"word":"\u1794\u17B6\u179F\u1780"},{"id":6565,"word":"\u1794\u17B6\u179F\u1780\u17B6"},{"id":6566,"word":"\u1794\u17B6\u179F\u17D2\u1780\u17B6"},{"id":6567,"word":"\u1794\u17B6\u17A1\u17B6\u178F\u17CB"},{"id":6568,"word":"\u1794\u17B6\u17A1\u17B8"},{"id":6569,"word":"\u1794\u17B7\u178A\u1780"},{"id":6570,"word":"\u1794\u17B7\u178A\u1780\u178F\u17D2\u179A\u17D0\u1799"},{"id":6571,"word":"\u1794\u17B7\u178A\u179A"},{"id":6572,"word":"\u1794\u17B7\u178E\u17D2\u178C"},{"id":6573,"word":"\u1794\u17B7\u178E\u17D2\u178C\u1794\u17B6\u178F"},{"id":6574,"word":"\u1794\u17B7\u178E\u17D2\u178C\u1794\u17B6\u178F\u1785\u17B6\u179A\u17B7\u1780\u179C\u178F\u17D2\u178F"},{"id":6575,"word":"\u1794\u17B7\u178E\u17D2\u178C\u1794\u17B6\u178F\u1791\u17B6\u1793"},{"id":6576,"word":"\u1794\u17B7\u178E\u17D2\u178C\u1794\u17B6\u178F\u1794\u17D2\u1794\u1785\u17D2\u1785\u17D0\u1799"},{"id":6577,"word":"\u1794\u17B7\u178E\u17D2\u178C\u1794\u17B6\u178F\u17B7\u1780\u1784\u17D2\u1782\u17C8"},{"id":6578,"word":"\u1794\u17B7\u178F"},{"id":6579,"word":"\u1794\u17B7\u178F\u179A"},{"id":6580,"word":"\u1794\u17B7\u178F\u17B6"},{"id":6581,"word":"\u1794\u17B7\u178F\u17B6\u1798\u17A0\u17B6"},{"id":6582,"word":"\u1794\u17B7\u178F\u17D2\u178F\u1794\u17BC\u179A"},{"id":6583,"word":"\u1794\u17B7\u1791"},{"id":6584,"word":"\u1794\u17B7\u1791\u1796\u17BD\u1793"},{"id":6585,"word":"\u1794\u17B7\u1791\u1798\u17BB\u1781"},{"id":6586,"word":"\u1794\u17B7\u179F\u17B6\u1785"},{"id":6587,"word":"\u1794\u17B8"},{"id":6588,"word":"\u1794\u17B8\u178A\u17BC\u1785"},{"id":6589,"word":"\u1794\u17B8\u1794\u1798"},{"id":6590,"word":"\u1794\u17B8\u1794\u17B6\u1785\u17CB"},{"id":6591,"word":"\u1794\u17B9\u1784"},{"id":6592,"word":"\u1794\u17B9\u1798"},{"id":6593,"word":"\u1794\u17BA\u178F"},{"id":6594,"word":"\u1794\u17BA\u17C7!"},{"id":6595,"word":"\u1794\u17BB\u1780"},{"id":6596,"word":"\u1794\u17BB\u1780\u179B\u17D0\u1780\u17D2\u178A"},{"id":6597,"word":"\u1794\u17BB\u1780\u179F\u17D2\u179A\u17BC\u179C"},{"id":6598,"word":"\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":6599,"word":"\u1794\u17BB\u1782\u17D2\u1782\u179B\u1794\u17D2\u1794\u1789\u17D2\u1789\u178F\u17D2\u178F\u17B7"},{"id":6600,"word":"\u1794\u17BB\u1782\u17D2\u1782\u179B\u17B6\u1792\u17B7\u178A\u17D2\u178B\u17B6\u1793"},{"id":6601,"word":"\u1794\u17BB\u1782\u17D2\u1782\u179B\u17B7\u1780"},{"id":6602,"word":"\u1794\u17BB\u1782\u17D2\u1782\u179B\u17B7\u1780\u1791\u17B6\u1793"},{"id":6603,"word":"\u1794\u17BB\u1782\u17D2\u1782\u179B\u17B7\u1780\u179B\u1780\u17D2\u1781\u178E\u17C8"},{"id":6604,"word":"\u1794\u17BB\u1789\u17D2\u1789"},{"id":6605,"word":"\u1794\u17BB\u1789\u17D2\u1789--"},{"id":6606,"word":"\u1794\u17BB\u178E\u17D2\u178C\u179A\u17B7\u1780"},{"id":6607,"word":"\u1794\u17BB\u178E\u17D2\u1799"},{"id":6608,"word":"\u1794\u17BB\u178E\u17D2\u1799\u1791\u17B7\u1793"},{"id":6609,"word":"\u1794\u17BB\u178F\u17D2\u179A"},{"id":6610,"word":"\u1794\u17BB\u178F\u17D2\u179A\u17B6"},{"id":6611,"word":"\u1794\u17BB\u178F\u17D2\u179A\u17B6\u1792\u17B8\u1793"},{"id":6612,"word":"\u1794\u17BB\u178F\u17D2\u179A\u17B6\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":6613,"word":"\u1794\u17BB\u178F\u17D2\u179A\u17B8"},{"id":6614,"word":"\u1794\u17BB\u1794\u17D2\u1795\u1782\u1793\u17D2\u1792"},{"id":6615,"word":"\u1794\u17BB\u1794\u17D2\u1795\u1787\u17B6\u178F\u17B7"},{"id":6616,"word":"\u1794\u17BB\u1794\u17D2\u1795\u179C\u178F\u17B8"},{"id":6617,"word":"\u1794\u17BB\u1794\u17D2\u1795\u179C\u17B7\u1780\u17D0\u178F\u17B7"},{"id":6618,"word":"\u1794\u17BB\u1794\u17D2\u1795\u17B6"},{"id":6619,"word":"\u1794\u17BB\u1794\u17D2\u1795\u17B6\u1780\u17C1\u179F\u179A"},{"id":6620,"word":"\u1794\u17BB\u1794\u17D2\u1795\u17B6\u1793\u17B6\u179A\u17B8"},{"id":6621,"word":"\u1794\u17BB\u1794\u17D2\u1795\u17B6\u179A\u17B6\u1798"},{"id":6622,"word":"\u1794\u17BB\u1796\u17D2\u179C"},{"id":6623,"word":"\u1794\u17BB\u1796\u17D2\u179C--"},{"id":6624,"word":"\u1794\u17BB\u1796\u17D2\u179C\u17C1"},{"id":6625,"word":"\u1794\u17BB\u1796\u17D2\u179C\u17C1\u1793\u17B7\u179C\u17B6\u179F\u17B6\u1793\u17BB\u179F\u17D2\u179F\u178F\u17B7\u1789\u17D2\u1789\u17B6\u178E"},{"id":6626,"word":"\u1794\u17BB\u1796\u17D2\u179C\u17C1\u179F\u1793\u17D2\u1793\u17B7\u179C\u17B6\u179F"},{"id":6627,"word":"\u1794\u17BB\u1796\u17D2\u179C\u17C4"},{"id":6628,"word":"\u1794\u17BB\u179A\u179F"},{"id":6629,"word":"\u1794\u17BB\u179A\u17B6\u178E"},{"id":6630,"word":"\u1794\u17BB\u179A\u17B6\u178E\u1791\u17BB\u178F\u17B7\u1799\u17B7\u1780\u17B6"},{"id":6631,"word":"\u1794\u17BB\u179A\u17B7\u1793\u17D2\u1791"},{"id":6632,"word":"\u1794\u17BB\u179A\u17B8"},{"id":6633,"word":"\u1794\u17BB\u179A\u17B8\u179A\u1780\u17D2\u179F"},{"id":6634,"word":"\u1794\u17BB\u179A\u17B8\u179A\u1798\u17D2\u1799"},{"id":6635,"word":"\u1794\u17BB\u179A\u17C4\u17A0\u17B7\u178F"},{"id":6636,"word":"\u1794\u17BB\u179B"},{"id":6637,"word":"\u1794\u17BB\u179B\u17D2\u179B\u17B7\u1780\u17B6"},{"id":6638,"word":"\u1794\u17BB\u179F\u1793\u17B6\u1782"},{"id":6639,"word":"\u1794\u17BB\u179F\u17D2\u1794\u17B6"},{"id":6640,"word":"\u1794\u17BB\u179F\u17D2\u1794\u17BB\u1780"},{"id":6641,"word":"\u1794\u17BB\u179F\u17D2\u179F"},{"id":6642,"word":"\u1794\u17BB\u179F\u17D2\u179F\u179A\u1790"},{"id":6643,"word":"\u1794\u17BB\u17C7"},{"id":6644,"word":"\u1794\u17BC"},{"id":6645,"word":"\u1794\u17BC\u1780"},{"id":6646,"word":"\u1794\u17BC\u1780\u1782\u17C4"},{"id":6647,"word":"\u1794\u17BC\u1780\u1794\u17C4\u17C7"},{"id":6648,"word":"\u1794\u17BC\u1780\u1794\u17C9\u17B6\u1793\u17CB"},{"id":6649,"word":"\u1794\u17BC\u1780\u17A1\u17BC\u1780"},{"id":6650,"word":"\u1794\u17BC\u1782"},{"id":6651,"word":"\u1794\u17BC\u1782\u1782\u17C4"},{"id":6652,"word":"\u1794\u17BC\u1787\u1793\u1780\u17B7\u1785\u17D2\u1785"},{"id":6653,"word":"\u1794\u17BC\u1787\u1793\u17B8\u1799\u17C8"},{"id":6654,"word":"\u1794\u17BC\u1787\u1793\u17B8\u1799\u17C1\u179F\u1780\u17CD"},{"id":6655,"word":"\u1794\u17BC\u1787\u17B6"},{"id":6656,"word":"\u1794\u17BC\u1789"},{"id":6657,"word":"\u1794\u17BC\u1789\u1794\u17B6\u1789"},{"id":6658,"word":"\u1794\u17BC\u178E\u17CC\u1798\u17B8"},{"id":6659,"word":"\u1794\u17BC\u178F"},{"id":6660,"word":"\u1794\u17BC\u178F\u179F\u178E\u17D2\u178A\u17C2\u1780"},{"id":6661,"word":"\u1794\u17BC\u1798"},{"id":6662,"word":"\u1794\u17BC\u179A\u1794\u17B6\u1785\u17CB"},{"id":6663,"word":"\u1794\u17BC\u1796\u17CC"},{"id":6664,"word":"\u1794\u17BC\u1796\u17CC\u1791\u17B7\u179F"},{"id":6665,"word":"\u1794\u17BC\u1796\u17CC\u1793\u17B7\u1798\u17B7\u178F\u17D2\u178F"},{"id":6666,"word":"\u1794\u17BC\u179A\u17B6\u178E"},{"id":6667,"word":"\u1794\u17BC\u179B"},{"id":6668,"word":"\u1794\u17BC\u179F"},{"id":6669,"word":"\u1794\u17BD"},{"id":6670,"word":"\u1794\u17BD\u1784"},{"id":6671,"word":"\u1794\u17BD\u1784\u179F\u17BD\u1784"},{"id":6672,"word":"\u1794\u17BD\u1793"},{"id":6673,"word":"\u1794\u17BD\u179A"},{"id":6674,"word":"\u1794\u17BD\u179B"},{"id":6675,"word":"\u1794\u17BD\u179F"},{"id":6676,"word":"\u1794\u17BE"},{"id":6677,"word":"\u1794\u17BE\u1780"},{"id":6678,"word":"\u1794\u17BF\u1793"},{"id":6679,"word":"\u1794\u17C0"},{"id":6680,"word":"\u1794\u17C0\u1780"},{"id":6681,"word":"\u1794\u17C0\u178F"},{"id":6682,"word":"\u1794\u17C0\u178F!"},{"id":6683,"word":"\u1794\u17C0\u178F\u1794\u17C0\u1793"},{"id":6684,"word":"\u1794\u17C0\u178F\u179F\u17C0\u178F"},{"id":6685,"word":"\u1794\u17C0\u1798"},{"id":6686,"word":"\u1794\u17C0\u179A"},{"id":6687,"word":"\u1794\u17C0\u179B\u17C0\u1784"},{"id":6688,"word":"\u1794\u17C0\u179C\u178F\u17D2\u179F"},{"id":6689,"word":"\u1794\u17C1\u1784"},{"id":6690,"word":"\u1794\u17C1\u178F\u17BB\u1784"},{"id":6691,"word":"\u1794\u17C1\u17C7"},{"id":6692,"word":"\u1794\u17C1\u17C7\u1794\u17B7\u1791"},{"id":6693,"word":"\u1794\u17C1\u17C7\u1794\u17BD\u1799"},{"id":6694,"word":"\u1794\u17C2\u1780"},{"id":6695,"word":"\u1794\u17C2\u1780\u1794\u17B6\u1799"},{"id":6696,"word":"\u1794\u17C2\u1784"},{"id":6697,"word":"\u1794\u17C2\u1793"},{"id":6698,"word":"\u1794\u17C2\u1794"},{"id":6699,"word":"\u1794\u17C2\u179A"},{"id":6700,"word":"\u1794\u17C3\u178A\u17B8\u1780\u17B6"},{"id":6701,"word":"\u1794\u17C3\u178F\u1784"},{"id":6702,"word":"\u1794\u17C3\u1798\u1793\u17CB"},{"id":6703,"word":"\u1794\u17C3\u179A\u1780\u17B6"},{"id":6704,"word":"\u1794\u17C4\u1780"},{"id":6705,"word":"\u1794\u17C4\u1780\u1794\u17C4\u17C7"},{"id":6706,"word":"\u1794\u17C4\u1780\u17D2\u1781\u179A\u178E\u17B8"},{"id":6707,"word":"\u1794\u17C4\u1780\u17D2\u1781\u179A\u1796\u17D0\u179F\u17CC"},{"id":6708,"word":"\u1794\u17C4\u1784"},{"id":6709,"word":"\u1794\u17C4\u1785"},{"id":6710,"word":"\u1794\u17C4\u1794"},{"id":6711,"word":"\u1794\u17C4\u1799"},{"id":6712,"word":"\u1794\u17C4\u1799\u1794\u1780\u17CB"},{"id":6713,"word":"\u1794\u17C4\u179A"},{"id":6714,"word":"\u1794\u17C4\u179A\u1798\u17BB\u1781"},{"id":6715,"word":"\u1794\u17C4\u179B"},{"id":6716,"word":"\u1794\u17C4\u179F"},{"id":6717,"word":"\u1794\u17C4\u179F\u179B\u17B6\u1793"},{"id":6718,"word":"\u1794\u17C4\u17C7"},{"id":6719,"word":"\u1794\u17C4\u17C7\u1794\u1784\u17CB"},{"id":6720,"word":"\u1794\u17C4\u17C7\u1794\u17C4\u1780"},{"id":6721,"word":"\u1794\u17C4\u17C7\u1796\u17BD\u1799"},{"id":6722,"word":"\u1794\u17C4\u17C7\u179F\u17C4\u1780"},{"id":6723,"word":"\u1794\u17C5"},{"id":6724,"word":"\u1794\u17C6\u178E\u1784"},{"id":6725,"word":"\u1794\u17C6\u178E\u1793\u17CB"},{"id":6726,"word":"\u1794\u17C6\u178E\u17B6\u1780\u17CB"},{"id":6727,"word":"\u1794\u17C6\u178E\u17B6\u1785\u17CB"},{"id":6728,"word":"\u1794\u17C6\u178E\u17B6\u1785\u17CB\u1793\u17B9\u1784"},{"id":6729,"word":"\u1794\u17C6\u178E\u17BB\u179B"},{"id":6730,"word":"\u1794\u17C6\u178E\u17C2"},{"id":6731,"word":"\u1794\u17C6\u178E\u17C2\u1780"},{"id":6732,"word":"\u1794\u17C6\u178E\u17C2\u1780\u179B\u17D2\u1784"},{"id":6733,"word":"\u1794\u17C6\u178E\u17B6\u17C6"},{"id":6734,"word":"\u1794\u17C6\u178E\u17C7"},{"id":6735,"word":"\u1794\u17C6\u1794\u1784\u17CB"},{"id":6736,"word":"\u1794\u17C6\u1794\u178F\u17CB"},{"id":6737,"word":"\u1794\u17C6\u1794\u1794"},{"id":6738,"word":"\u1794\u17C6\u1794\u179A"},{"id":6739,"word":"\u1794\u17C6\u1794\u179A\u1794\u1784\u17CB"},{"id":6740,"word":"\u1794\u17C6\u1794\u17B6\u1780\u17CB"},{"id":6741,"word":"\u1794\u17C6\u1794\u17B6\u178F\u17CB"},{"id":6742,"word":"\u1794\u17C6\u1794\u17B6\u1793"},{"id":6743,"word":"\u1794\u17C6\u1794\u17B7\u1791"},{"id":6744,"word":"\u1794\u17C6\u1794\u17BD\u179F"},{"id":6745,"word":"\u1794\u17C6\u1794\u17C0\u178F"},{"id":6746,"word":"\u1794\u17C6\u1794\u17C2\u1780"},{"id":6747,"word":"\u1794\u17C6\u1794\u17C2\u1793"},{"id":6748,"word":"\u1794\u17C6\u1794\u17C2\u179A"},{"id":6749,"word":"\u1794\u17C6\u1794\u17C4\u179A"},{"id":6750,"word":"\u1794\u17C6\u1794\u17C4\u179B"},{"id":6751,"word":"\u1794\u17C6\u1794\u17C5"},{"id":6752,"word":"\u1794\u17C6\u1794\u17B6\u17C6\u1784"},{"id":6753,"word":"\u1794\u17C6\u1794\u17C7"},{"id":6754,"word":"\u1794\u17C6\u1794\u17C9\u1793"},{"id":6755,"word":"\u1794\u17C6\u1794\u17C9\u17B6\u1793\u17CB"},{"id":6756,"word":"\u1794\u17C6\u1794\u17C9\u17B9\u1798"},{"id":6757,"word":"\u1794\u17C6\u1794\u17C9\u17C4\u1784"},{"id":6758,"word":"\u1794\u17C6\u1794\u17C9\u17C7"},{"id":6759,"word":"\u1794\u17C6\u1794\u17D2\u179A\u17BD\u1798"},{"id":6760,"word":"\u1794\u17C6\u1794\u17D2\u179B\u17C1\u1784"},{"id":6761,"word":"\u1794\u17C6\u1794\u17D2\u179B\u17C2\u1784"},{"id":6762,"word":"\u1794\u17C6\u1794\u17D2\u179B\u17C4\u1784"},{"id":6763,"word":"\u1794\u17C6\u1795\u178F"},{"id":6764,"word":"\u1794\u17C6\u1795\u17B6\u1799"},{"id":6765,"word":"\u1794\u17C6\u1795\u17B9\u1780"},{"id":6766,"word":"\u1794\u17C6\u1795\u17BB\u1784"},{"id":6767,"word":"\u1794\u17C6\u1795\u17BB\u178F"},{"id":6768,"word":"\u1794\u17C6\u1795\u17BB\u1799"},{"id":6769,"word":"\u1794\u17C6\u1795\u17BB\u179B"},{"id":6770,"word":"\u1794\u17C6\u1795\u17BB\u179F"},{"id":6771,"word":"\u1794\u17C6\u1795\u17BC\u179A"},{"id":6772,"word":"\u1794\u17C6\u1795\u17BE\u1798"},{"id":6773,"word":"\u1794\u17C6\u1795\u17D2\u179B\u17B6\u1784"},{"id":6774,"word":"\u1794\u17C6\u1795\u17D2\u179B\u17B6\u1789"},{"id":6775,"word":"\u1794\u17C6\u1795\u17D2\u179B\u17B7\u1785"},{"id":6776,"word":"\u1794\u17C6\u1795\u17D2\u179B\u17BE\u179F"},{"id":6777,"word":"\u1794\u17C6\u1796\u1780\u17CB"},{"id":6778,"word":"\u1794\u17C6\u1796\u1784"},{"id":6779,"word":"\u1794\u17C6\u1796\u1784\u17CB"},{"id":6780,"word":"\u1794\u17C6\u1796\u1784\u17CB\u1780"},{"id":6781,"word":"\u1794\u17C6\u1796\u1784\u17CB\u1780\u179A\u17BF\u1784"},{"id":6782,"word":"\u1794\u17C6\u1796\u178F\u17CB"},{"id":6783,"word":"\u1794\u17C6\u1796\u17D0\u1791\u17D2\u1792"},{"id":6784,"word":"\u1794\u17C6\u1796\u1798"},{"id":6785,"word":"\u1794\u17C6\u1796\u17B6\u1780\u17CB"},{"id":6786,"word":"\u1794\u17C6\u1796\u17B6\u1793"},{"id":6787,"word":"\u1794\u17C6\u1796\u17B6\u179A"},{"id":6788,"word":"\u1794\u17C6\u1796\u17BB\u179B"},{"id":6789,"word":"\u1794\u17C6\u1796\u17BD\u1793"},{"id":6790,"word":"\u1794\u17C6\u1796\u17BD\u1793\u179F\u17D2\u1780\u179A"},{"id":6791,"word":"\u1794\u17C6\u1796\u17BE\u1784"},{"id":6792,"word":"\u1794\u17C6\u1796\u17BE\u178F"},{"id":6793,"word":"\u1794\u17C6\u1796\u17C0\u1785"},{"id":6794,"word":"\u1794\u17C6\u1796\u17C1"},{"id":6795,"word":"\u1794\u17C6\u1796\u17C1\u1789"},{"id":6796,"word":"\u1794\u17C6\u1796\u17C1\u1789\u179A\u17B6\u1787\u17D2\u1799"},{"id":6797,"word":"\u1794\u17C6\u1796\u17C1\u1793"},{"id":6798,"word":"\u1794\u17C6\u1796\u17C4\u1780"},{"id":6799,"word":"\u1794\u17C6\u1796\u17C4\u178F"},{"id":6800,"word":"\u1794\u17C6\u1796\u17C4\u1794"},{"id":6801,"word":"\u1794\u17C6\u1796\u17C4\u179A"},{"id":6802,"word":"\u1794\u17C6\u1796\u17B6\u17C6"},{"id":6803,"word":"\u1794\u17C6\u1796\u17B6\u17C6\u1784"},{"id":6804,"word":"\u1794\u17C6\u1796\u17D2\u179A\u1784"},{"id":6805,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17B6\u1784"},{"id":6806,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17B6\u1785"},{"id":6807,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17B6\u178F\u17CB"},{"id":6808,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17BB\u179B"},{"id":6809,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17BD\u1798"},{"id":6810,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17C3"},{"id":6811,"word":"\u1794\u17C6\u1796\u17D2\u179A\u17C6"},{"id":6812,"word":"\u1794\u17C6\u1797\u17D0\u1793\u17D2\u178F"},{"id":6813,"word":"\u1794\u17C6\u1797\u17D0\u1799"},{"id":6814,"word":"\u1794\u17C6\u1797\u179B"},{"id":6815,"word":"\u1794\u17C6\u1797\u17B6\u1793\u17CB"},{"id":6816,"word":"\u1794\u17C6\u1797\u17B7\u178F"},{"id":6817,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17B6\u1784"},{"id":6818,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17B6\u178F\u17CB"},{"id":6819,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17BA"},{"id":6820,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17BC\u1780"},{"id":6821,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17C1\u1785"},{"id":6822,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17C3"},{"id":6823,"word":"\u1794\u17C6\u1797\u17D2\u179B\u17B6\u17C6\u1784"},{"id":6824,"word":"\u1794\u17B6\u17C6\u1784"},{"id":6825,"word":"\u1794\u17B6\u17C6\u1784\u1781\u17C2\u179B"},{"id":6826,"word":"\u1794\u17B6\u17C6\u1784\u1781\u17D2\u179B\u17C2\u1784"},{"id":6827,"word":"\u1794\u17B6\u17C6\u1784\u1786\u178F\u17D2\u179A"},{"id":6828,"word":"\u1794\u17B6\u17C6\u1784\u1797\u1780\u17CB"},{"id":6829,"word":"\u1794\u17B6\u17C6\u1784\u179F\u17B6\u1785"},{"id":6830,"word":"\u1794\u17B6\u17C6\u1784\u179F\u17C2\u1784"},{"id":6831,"word":"\u1794\u17B6\u17C6\u1784\u179F\u17D2\u1791\u17BE\u179A"},{"id":6832,"word":"\u1794\u17C7"},{"id":6833,"word":"\u1794\u17C9"},{"id":6834,"word":"\u1794\u17C9\u1780"},{"id":6835,"word":"\u1794\u17C9\u1780\u17CB"},{"id":6836,"word":"\u1794\u1780\u178F\u17B7"},{"id":6837,"word":"\u1794\u1780\u178F\u17B7\u1791\u17B7\u1793"},{"id":6838,"word":"\u1794\u1780\u178F\u17B7\u1793\u17B6\u1798"},{"id":6839,"word":"\u1794\u1780\u178F\u17B7\u1797\u17B6\u1796"},{"id":6840,"word":"\u1794\u1780\u178F\u17B7\u179F\u17C6\u1781\u17D2\u1799\u17B6"},{"id":6841,"word":"\u1794\u17C9\u17D0\u1780\u1794\u17C9\u17C5"},{"id":6842,"word":"\u1794\u1780\u17B6\u179A\u17C8"},{"id":6843,"word":"\u1794\u1780\u17B7\u178E\u17D2\u178E\u1780"},{"id":6844,"word":"\u1794\u1780\u17C4\u178A\u17B7"},{"id":6845,"word":"\u1794\u1780\u17D2\u1781"},{"id":6846,"word":"\u1794\u1780\u17D2\u1781\u1782\u178E\u1793\u17B6"},{"id":6847,"word":"\u1794\u1780\u17D2\u1781\u1796\u17D0\u1793\u17D2\u1792"},{"id":6848,"word":"\u1794\u1780\u17D2\u1781\u179F\u1798\u17D2\u1796\u17D0\u1793\u17D2\u1792"},{"id":6849,"word":"\u1794\u1780\u17D2\u179F"},{"id":6850,"word":"\u1794\u17C9\u1784"},{"id":6851,"word":"\u1794\u17C9\u17D0\u1784"},{"id":6852,"word":"\u1794\u17C9\u1785"},{"id":6853,"word":"\u1794\u1785\u17D2\u1785\u1793\u17D2\u178F\u1782\u17D2\u179A\u17B6\u1798"},{"id":6854,"word":"\u1794\u1785\u17D2\u1785\u1793\u17D2\u178F\u1787\u1793\u1794\u1791"},{"id":6855,"word":"\u1794\u1785\u17D2\u1785\u1793\u17D2\u178F\u1794\u17D2\u179A\u1791\u17C1\u179F"},{"id":6856,"word":"\u1794\u1785\u17D2\u1785\u17D0\u1799"},{"id":6857,"word":"\u1794\u1785\u17D2\u1785\u1799\u179F\u1793\u17D2\u1793\u17B7\u179F\u17D2\u179F\u17B7\u178F\u179F\u17B8\u179B"},{"id":6858,"word":"\u1794\u1785\u17D2\u1785\u179C\u17C1\u1780\u17D2\u1781\u178E\u17C8"},{"id":6859,"word":"\u1794\u1785\u17D2\u1785\u179C\u17C1\u1780\u17D2\u1781\u178E\u1789\u17D2\u1789\u17B6\u178E"},{"id":6860,"word":"\u1794\u1785\u17D2\u1785\u17B6\u1798\u17B7\u178F\u17D2\u178F"},{"id":6861,"word":"\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793"},{"id":6862,"word":"\u1794\u1785\u17D2\u1785\u17BB\u1794\u17D2\u1794\u1793\u17D2\u1793\u1780\u17B6\u179B"},{"id":6863,"word":"\u1794\u1785\u17D2\u1785\u17BC\u179F"},{"id":6864,"word":"\u1794\u1785\u17D2\u1785\u17BC\u179F\u1780\u17B6\u179B"},{"id":6865,"word":"\u1794\u1785\u17D2\u1785\u17C1\u1780\u17C8"},{"id":6866,"word":"\u1794\u1785\u17D2\u1785\u17C1\u1780\u1791\u17C1\u179F"},{"id":6867,"word":"\u1794\u1785\u17D2\u1785\u17C1\u1780\u1796\u17BB\u1791\u17D2\u1792"},{"id":6868,"word":"\u1794\u1785\u17D2\u1785\u17C1\u1780\u1796\u17C4\u1792\u17B7"},{"id":6869,"word":"\u1794\u1785\u17D2\u1785\u17C1\u1780\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":6870,"word":"\u1794\u1785\u17D2\u1786\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":6871,"word":"\u1794\u1785\u17D2\u1786\u17B6\u1794\u179A\u17B7\u1785\u17B6\u179A\u1780\u17B7\u1785\u17D2\u1785"},{"id":6872,"word":"\u1794\u1785\u17D2\u1786\u17B6\u1797\u178F\u17D2\u178F"},{"id":6873,"word":"\u1794\u1785\u17D2\u1786\u17B6\u1797\u178F\u17D2\u178F\u1780\u17B6\u179B"},{"id":6874,"word":"\u1794\u1785\u17D2\u1786\u17B6\u1797\u178F\u17D2\u178F\u1780\u17B7\u1785\u17D2\u1785"},{"id":6875,"word":"\u1794\u1785\u17D2\u1786\u17B6\u179F\u1798\u178E\u17C8"},{"id":6876,"word":"\u1794\u1785\u17D2\u1786\u17B7\u1798"},{"id":6877,"word":"\u1794\u1785\u17D2\u1786\u17B7\u1798\u1791\u17B7\u179F"},{"id":6878,"word":"\u1794\u1785\u17D2\u1786\u17B7\u1798\u17B6\u1793\u17BB\u1791\u17B7\u179F"},{"id":6879,"word":"\u1794\u1789\u17D2\u1785"},{"id":6880,"word":"\u1794\u1789\u17D2\u1785\u1780\u17B6\u1798\u1782\u17BB\u178E"},{"id":6881,"word":"\u1794\u1789\u17D2\u1785\u1780\u17D2\u1781\u1793\u17D2\u1792"},{"id":6882,"word":"\u1794\u1789\u17D2\u1785\u1791\u17C1\u1796"},{"id":6883,"word":"\u1794\u1789\u17D2\u1785\u1796\u17B7\u1792"},{"id":6884,"word":"\u1794\u1789\u17D2\u1785\u1796\u17B7\u1792\u1780\u179B\u17D2\u1799\u17B6\u178E\u17B8"},{"id":6885,"word":"\u1794\u1789\u17D2\u1785\u179F\u17B6\u1781\u17B6"},{"id":6886,"word":"\u1794\u1789\u17D2\u1785\u179F\u17B8\u179B"},{"id":6887,"word":"\u1794\u1789\u17D2\u1789\u179C\u1793\u17D2\u178F"},{"id":6888,"word":"\u1794\u1789\u17D2\u1789\u17B6"},{"id":6889,"word":"\u1794\u1789\u17D2\u1789\u17B6\u178E"},{"id":6890,"word":"\u1794\u1789\u17D2\u1789\u17B6\u1793\u17BB\u179A\u17BC\u1794"},{"id":6891,"word":"\u1794\u1789\u17D2\u1789\u17B6\u1794\u17B6\u179A\u1798\u17B8"},{"id":6892,"word":"\u1794\u178A\u17B6"},{"id":6893,"word":"\u1794\u178A\u17B7\u1780\u1798\u17D2\u1798"},{"id":6894,"word":"\u1794\u178A\u17B7\u1780\u17B6\u179A"},{"id":6895,"word":"\u1794\u178A\u17B7\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":6896,"word":"\u1794\u178A\u17B7\u1780\u17BC\u179B"},{"id":6897,"word":"\u1794\u178A\u17B7\u1780\u17BC\u179B\u179F\u1789\u17D2\u1789\u17B6"},{"id":6898,"word":"\u1794\u178A\u17B7\u1782\u17D2\u1782\u17B6\u17A0\u1780"},{"id":6899,"word":"\u1794\u178A\u17B7\u1783\u17C8"},{"id":6900,"word":"\u1794\u178A\u17B7\u1785\u17D2\u1785\u179F\u1798\u17BB\u1794\u17D2\u1794\u17B6\u1791"},{"id":6901,"word":"\u1794\u178A\u17B7\u1789\u17D2\u1789\u17B6"},{"id":6902,"word":"\u1794\u178A\u17B7\u1791\u17B6\u1793"},{"id":6903,"word":"\u1794\u178A\u17B7\u1791\u17B7\u1793"},{"id":6904,"word":"\u1794\u178A\u17B7\u1794\u1780\u17D2\u1781"},{"id":6905,"word":"\u1794\u178A\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":6906,"word":"\u1794\u178A\u17B7\u1794\u1791\u17B6"},{"id":6907,"word":"\u1794\u178A\u17B7\u1797\u17B6\u1782"},{"id":6908,"word":"\u1794\u178A\u17B7\u1797\u17B6\u178E"},{"id":6909,"word":"\u1794\u178A\u17B7\u1797\u17BC"},{"id":6910,"word":"\u1794\u178A\u17B7\u1798\u17B6"},{"id":6911,"word":"\u1794\u178A\u17B7\u1798\u17B6\u1780\u179A"},{"id":6912,"word":"\u1794\u178A\u17B7\u179B\u17B6\u1797"},{"id":6913,"word":"\u1794\u178A\u17B7\u179B\u17C4\u1798"},{"id":6914,"word":"\u1794\u178A\u17B7\u179C\u178F\u17D2\u178F"},{"id":6915,"word":"\u1794\u178A\u17B7\u179C\u178F\u17D2\u178F\u1793\u17CD"},{"id":6916,"word":"\u1794\u178A\u17B7\u179F\u178E\u17D2\u178B\u17B6\u179A\u17C8"},{"id":6917,"word":"\u1794\u178A\u17B7\u179F\u178E\u17D2\u178B\u17B6\u179A\u1780\u17B7\u1785\u17D2\u1785"},{"id":6918,"word":"\u1794\u178A\u17B7\u179F\u1793\u17D2\u1792\u17B7"},{"id":6919,"word":"\u1794\u178A\u17B7\u179F\u1798\u17D2\u1797\u17B7\u1791\u17B6"},{"id":6920,"word":"\u1794\u178A\u17B7\u179F\u179A\u178E\u178A\u17D2\u178B\u17B6\u1793"},{"id":6921,"word":"\u1794\u178A\u17B7\u179F\u17C1\u1792"},{"id":6922,"word":"\u1794\u178B\u1798"},{"id":6923,"word":"\u1794\u178B\u1798\u178F\u17D2\u179A\u17B6\u179F\u17CB"},{"id":6924,"word":"\u1794\u178B\u1798\u17B6\u179F\u17B6\u178D"},{"id":6925,"word":"\u1794\u178B\u179C\u17B8"},{"id":6926,"word":"\u1794\u178B\u179C\u17B8\u1780\u179F\u17B7\u178E"},{"id":6927,"word":"\u1794\u178B\u179C\u17B8\u1792\u17B6\u178F\u17BB"},{"id":6928,"word":"\u1794\u178E\u17B8\u178F"},{"id":6929,"word":"\u1794\u178E\u17B8\u178F\u1797\u17B6\u1796"},{"id":6930,"word":"\u1794\u178E\u17B8\u178F\u17B6\u17A0\u17B6\u179A"},{"id":6931,"word":"\u1794\u178E\u17D2\u178E\u17B6\u1782\u17B6\u179A"},{"id":6932,"word":"\u1794\u178E\u17D2\u178E\u17B6\u1782\u17B6\u179A\u17B7\u1780"},{"id":6933,"word":"\u1794\u178E\u17D2\u178E\u17B6\u1792\u17B7\u1780\u17B6\u179A"},{"id":6934,"word":"\u1794\u178E\u17D2\u178E\u17B6\u179A\u1780\u17D2\u1781"},{"id":6935,"word":"\u1794\u178E\u17D2\u178E\u17B6\u179B\u17D0\u1799"},{"id":6936,"word":"\u1794\u178F\u1793\u17B8"},{"id":6937,"word":"\u1794\u178F\u17D2\u178F\u1794\u17B7\u178E\u17D2\u178C\u17B7\u1780\u1784\u17D2\u1782\u17C8"},{"id":6938,"word":"\u1794\u178F\u17D2\u178F\u17B6\u1793\u17BB\u1798\u17C4\u1791\u1793\u17B6\u1798\u1799\u17C8"},{"id":6939,"word":"\u1794\u178F\u17D2\u178F\u17B7\u1791\u17B6\u1793\u1798\u1799\u17C8"},{"id":6940,"word":"\u1794\u1791\u178A\u17D2\u178B\u17B6\u1793"},{"id":6941,"word":"\u1794\u1791\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798"},{"id":6942,"word":"\u1794\u1791\u17BB\u1798"},{"id":6943,"word":"\u1794\u1791\u17BB\u1798\u179A\u17B6\u1782"},{"id":6944,"word":"\u1794\u1791\u17C1\u179F"},{"id":6945,"word":"\u1794\u1791\u17C1\u179F\u1794\u17D2\u1794\u1789\u17D2\u1789\u178F\u17D2\u178F\u17B7"},{"id":6946,"word":"\u1794\u1791\u17C1\u179F\u179A\u17B6\u1787"},{"id":6947,"word":"\u1794\u1792\u17B6\u1793"},{"id":6948,"word":"\u1794\u1792\u17B6\u1793\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":6949,"word":"\u1794\u1792\u17B6\u1793\u17B6\u1793\u17BB\u1799\u17C4\u1782"},{"id":6950,"word":"\u1794\u17C9\u1793\u17CB"},{"id":6951,"word":"\u1794\u17C9\u1794\u17CB"},{"id":6952,"word":"\u1794\u17C9\u1794\u17C9\u1780"},{"id":6953,"word":"\u1794\u17C9\u1794\u17C9\u1794\u17CB"},{"id":6954,"word":"\u1794\u17C9\u1794\u17C9\u17B6\u1780\u17CB\u1794\u17C9\u1794\u17C9\u17BE\u1780"},{"id":6955,"word":"\u1794\u17C9\u1794\u17C9\u17B6\u1785\u17CB"},{"id":6956,"word":"\u1794\u17C9\u1794\u17C9\u17B6\u1785\u17CB\u1794\u17C9\u1794\u17C9\u17C4\u1785"},{"id":6957,"word":"\u1794\u17C9\u1794\u17C9\u17B7\u1780\u1794\u17C9\u1794\u17C9\u17B6\u1780\u17CB"},{"id":6958,"word":"\u1794\u17C9\u1794\u17C9\u17B7\u1785"},{"id":6959,"word":"\u1794\u17C9\u1794\u17C9\u17B7\u1793\u1794\u17C9\u1794\u17C9\u17B6\u1793\u17CB"},{"id":6960,"word":"\u1794\u17C9\u1794\u17C9\u17B7\u179B"},{"id":6961,"word":"\u1794\u17C9\u1794\u17C9\u17B7\u179B\u1794\u17C9\u1794\u17C9\u17BC\u1785"},{"id":6962,"word":"\u1794\u17C9\u1794\u17C9\u17BB\u1780"},{"id":6963,"word":"\u1794\u17C9\u1794\u17C9\u17BB\u1794"},{"id":6964,"word":"\u1794\u17C9\u1794\u17C9\u17C2\u17C7"},{"id":6965,"word":"\u1794\u17C9\u1794\u17C9\u17C4\u1785"},{"id":6966,"word":"\u1794\u17C9\u1794\u17C9\u17C5"},{"id":6967,"word":"\u1794\u17C9\u1794\u17C9\u17C7"},{"id":6968,"word":"\u1794\u17C9\u1794\u17C9\u17C7\u1794\u17C9\u1794\u17C9\u17BB\u1793"},{"id":6969,"word":"\u1794\u17C9\u1794\u17D2\u179A\u1780"},{"id":6970,"word":"\u1794\u17C9\u1794\u17D2\u179A\u1784"},{"id":6971,"word":"\u1794\u17C9\u1794\u17D2\u179A\u1785"},{"id":6972,"word":"\u1794\u17C9\u1794\u17D2\u179A\u179F"},{"id":6973,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B6\u1785\u17CB"},{"id":6974,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B6\u179C"},{"id":6975,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B7\u1785"},{"id":6976,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B7\u1789"},{"id":6977,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B7\u1798"},{"id":6978,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B7\u179B"},{"id":6979,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17B9\u179F"},{"id":6980,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BB\u1780"},{"id":6981,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BB\u1793"},{"id":6982,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BB\u1799"},{"id":6983,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BC\u1784"},{"id":6984,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BC\u1785"},{"id":6985,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BC\u179F"},{"id":6986,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17BE\u179F"},{"id":6987,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C1\u1789"},{"id":6988,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C1\u179C"},{"id":6989,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C1\u17C7"},{"id":6990,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C2\u1780"},{"id":6991,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C2\u17C7"},{"id":6992,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C3"},{"id":6993,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C4\u1780"},{"id":6994,"word":"\u1794\u17C9\u1794\u17D2\u179A\u17C7"},{"id":6995,"word":"\u1794\u17C9\u1794\u17D2\u179B\u1780\u17CB"},{"id":6996,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17B6\u1780\u17CB"},{"id":6997,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17B6\u1785\u17CB"},{"id":6998,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17B6\u1789"},{"id":6999,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17B7\u1780"},{"id":7000,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17B7\u1785"},{"id":7001,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17B9\u1780"},{"id":7002,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17BA\u1798"},{"id":7003,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17BB\u1784"},{"id":7004,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17BC\u1780"},{"id":7005,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17BC\u1785"},{"id":7006,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17BE\u1780"},{"id":7007,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17C1\u1785\u1794\u17C9\u1794\u17D2\u179B\u17BC\u1785"},{"id":7008,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17C1\u17C7\u1794\u17C9\u1794\u17D2\u179B\u17C4\u17C7"},{"id":7009,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17C4\u1789"},{"id":7010,"word":"\u1794\u17C9\u1794\u17D2\u179B\u17C4\u178F"},{"id":7011,"word":"\u1794\u17C9\u1795\u1784\u17CB"},{"id":7012,"word":"\u1794\u17C9\u1795\u179F"},{"id":7013,"word":"\u1794\u17C9\u1795\u17B6\u1784"},{"id":7014,"word":"\u1794\u17C9\u1795\u17B6\u1794\u17CB"},{"id":7015,"word":"\u1794\u17C9\u1795\u17BB\u1780"},{"id":7016,"word":"\u1794\u17C9\u1795\u17BB\u178F"},{"id":7017,"word":"\u1794\u17C9\u1795\u17BC\u1784"},{"id":7018,"word":"\u1794\u17C9\u1795\u17BC\u179A"},{"id":7019,"word":"\u1794\u17C9\u1795\u17BC\u179F"},{"id":7020,"word":"\u1794\u17C9\u1795\u17C2\u178F"},{"id":7021,"word":"\u1794\u17C9\u1795\u17D2\u1784\u17B6\u1780\u17CB"},{"id":7022,"word":"\u1794\u17C9\u1795\u17D2\u1784\u17BE\u1780"},{"id":7023,"word":"\u1794\u17C9\u1795\u17D2\u1785\u1794\u17CB"},{"id":7024,"word":"\u1794\u17C9\u1795\u17D2\u1789\u17B6\u1785\u17CB"},{"id":7025,"word":"\u1794\u17C9\u1795\u17D2\u1789\u17B6\u1789"},{"id":7026,"word":"\u1794\u17C9\u1795\u17D2\u1789\u17C4\u1789"},{"id":7027,"word":"\u1794\u17C9\u1795\u17D2\u178F\u1780\u17CB"},{"id":7028,"word":"\u1794\u17C9\u1795\u17D2\u178F\u17BA\u178F"},{"id":7029,"word":"\u1794\u17C9\u1795\u17D2\u178F\u17C0\u1785"},{"id":7030,"word":"\u1794\u17C9\u1795\u17D2\u178F\u17B7\u178F\u1794\u17C9\u1795\u17D2\u178F\u17BC\u1784"},{"id":7031,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17B6\u1780\u17CB\u1794\u17C9\u1795\u17D2\u17A2\u17BE\u1780"},{"id":7032,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17B9\u17C7"},{"id":7033,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17B9\u1794"},{"id":7034,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17BB\u1780"},{"id":7035,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17BC\u1780"},{"id":7036,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17BC\u1785"},{"id":7037,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17BD\u179F"},{"id":7038,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17C0\u1785"},{"id":7039,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17C1\u17C7"},{"id":7040,"word":"\u1794\u17C9\u1795\u17D2\u17A2\u17C2\u1794"},{"id":7041,"word":"\u1794\u17C9\u1796\u17BC"},{"id":7042,"word":"\u1794\u17C9\u1798"},{"id":7043,"word":"\u1794\u17C9\u1799"},{"id":7044,"word":"\u1794\u1799\u17D2\u1799\u1780\u17C8"},{"id":7045,"word":"\u1794\u179A\u1791\u17B6\u179A\u1780\u1798\u17D2\u1798"},{"id":7046,"word":"\u1794\u179A\u1798\u17B6\u178E\u17BC"},{"id":7047,"word":"\u1794\u179A\u1798\u17B6\u1797\u17B7\u1792\u17C1\u1799\u17D2\u1799"},{"id":7048,"word":"\u1794\u179A\u1798\u17B6\u1797\u17B7\u179F\u1798\u17D2\u1796\u17C4\u1792\u17B7"},{"id":7049,"word":"\u1794\u179A\u1798\u17B6\u1797\u17B7\u179F\u17C1\u1780"},{"id":7050,"word":"\u1794\u179A\u1798\u17B7\u1793\u17D2\u1791"},{"id":7051,"word":"\u1794\u179A\u1798\u17C1\u179F\u17D2\u178B"},{"id":7052,"word":"\u1794\u179A\u1798\u17C1\u179F\u17D2\u179C\u179A\u17C8"},{"id":7053,"word":"\u1794\u179A\u1798\u17C4\u179C\u17B6\u1791"},{"id":7054,"word":"\u1794\u179A\u17B6"},{"id":7055,"word":"\u1794\u179A\u17B6\u1787\u17D0\u1799"},{"id":7056,"word":"\u1794\u179A\u17B6\u1792\u17B8\u1793"},{"id":7057,"word":"\u1794\u179A\u17B6\u1797\u1796"},{"id":7058,"word":"\u1794\u179A\u17B6\u1798\u17BB\u1781"},{"id":7059,"word":"\u1794\u179A\u17B7\u1785\u17B6\u179A\u17B7\u1780\u17B6"},{"id":7060,"word":"\u1794\u179A\u17B7\u1787\u1793"},{"id":7061,"word":"\u1794\u179A\u17B7\u1789\u17D2\u1789\u17B6\u1794\u178F\u17D2\u179A"},{"id":7062,"word":"\u1794\u179A\u17B7\u178F\u17D2\u178F"},{"id":7063,"word":"\u1794\u179A\u17B7\u1793\u17B6\u1799\u1780"},{"id":7064,"word":"\u1794\u179A\u17B7\u1798\u178E\u17D2\u178C\u179B"},{"id":7065,"word":"\u1794\u179A\u17B7\u1798\u17B6\u178E"},{"id":7066,"word":"\u1794\u179A\u17B7\u1799\u178F\u17D2\u178F\u17B7"},{"id":7067,"word":"\u1794\u179A\u17B7\u1799\u17B6\u1780\u17B6\u179F"},{"id":7068,"word":"\u1794\u179A\u17B7\u1799\u17C4\u179F\u17B6\u1793"},{"id":7069,"word":"\u1794\u179A\u17B7\u179C\u1785\u17D2\u1786\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":7070,"word":"\u1794\u179A\u17B7\u179C\u17B7\u178F\u1780\u17D2\u1780"},{"id":7071,"word":"\u1794\u17C9\u179A\u17BD\u178F"},{"id":7072,"word":"\u1794\u179A\u17C1"},{"id":7073,"word":"\u1794\u179A\u17C4"},{"id":7074,"word":"\u1794\u179B\u17D2\u179B\u17D0\u1784\u17D2\u1780"},{"id":7075,"word":"\u1794\u179C\u178F\u17D2\u178F\u17B7"},{"id":7076,"word":"\u1794\u179C\u17B6\u179A\u178E\u17B6"},{"id":7077,"word":"\u1794\u179C\u17C1\u178E\u17B8"},{"id":7078,"word":"\u1794\u179C\u17C1\u179F\u1793\u1780\u17B6\u179B"},{"id":7079,"word":"\u1794\u179F\u17BB\u1796\u17C1\u1791\u17D2\u1799"},{"id":7080,"word":"\u1794\u179F\u17BB\u1796\u17D2\u1799\u17B6\u1794\u17B6\u179B"},{"id":7081,"word":"\u1794\u179F\u17BB\u179F\u178F\u17D2\u179C"},{"id":7082,"word":"\u1794\u179F\u17B6\u1791"},{"id":7083,"word":"\u1794\u179F\u17C6\u179F\u17B6"},{"id":7084,"word":"\u1794\u179F\u17D2\u179F\u17B6\u179C\u17C8"},{"id":7085,"word":"\u1794\u179F\u17D2\u179F\u17B6\u179C\u1798\u1782\u17D2\u1782"},{"id":7086,"word":"\u1794\u179F\u17D2\u179F\u17B6\u179F\u17C8"},{"id":7087,"word":"\u1794\u17C9\u17B6\u1780\u17CB"},{"id":7088,"word":"\u1794\u17C9\u17B6\u1780\u1780\u17B6"},{"id":7089,"word":"\u1794\u17C9\u17B6\u1780\u1780\u17C3"},{"id":7090,"word":"\u1794\u17C9\u17B6\u1780\u178E\u17B6\u1798"},{"id":7091,"word":"\u1794\u17C9\u17B6\u1780\u17CB\u1790\u17C5"},{"id":7092,"word":"\u1794\u17C9\u17B6\u1780\u17CB\u1794\u17C9\u17BE\u1780"},{"id":7093,"word":"\u1794\u17C9\u17B6\u1780\u17CB\u1794\u17C9\u17C5"},{"id":7094,"word":"\u1794\u17C9\u17B6\u1785\u17CB"},{"id":7095,"word":"\u1794\u17C9\u17B6\u1785\u179A\u17A0\u17B6\u1785"},{"id":7096,"word":"\u1794\u17B6\u1785\u17B7\u178F\u17D2\u178F\u17B7\u1799\u17C8"},{"id":7097,"word":"\u1794\u17C9\u17B6\u1786\u17B6"},{"id":7098,"word":"\u1794\u17B6\u178A\u17B7\u1791\u17C1\u179F\u1793\u17B8\u1799"},{"id":7099,"word":"\u1794\u17B6\u178A\u17B7\u1794\u17BB\u1782\u17D2\u1782\u179B\u17B7\u1780"},{"id":7100,"word":"\u1794\u17B6\u178A\u17B7\u1797\u17C4\u1782"},{"id":7101,"word":"\u1794\u17B6\u178A\u17B7\u1798\u17C4\u1780\u17D2\u1781"},{"id":7102,"word":"\u1794\u17B6\u178A\u17B7\u17A0\u17B6\u179A\u17B7\u1799\u17CD"},{"id":7103,"word":"\u1794\u17B6\u178A\u17B7\u17A0\u17B6\u179A\u17D2\u1799"},{"id":7104,"word":"\u1794\u17B6\u178B"},{"id":7105,"word":"\u1794\u17B6\u178B\u1780\u17C8"},{"id":7106,"word":"\u1794\u17B6\u178B\u1780\u1790\u17B6"},{"id":7107,"word":"\u1794\u17B6\u178B\u17B7\u1780\u17B6"},{"id":7108,"word":"\u1794\u17B6\u178E\u17C8"},{"id":7109,"word":"\u1794\u17B6\u178E\u17B6\u178F\u17B7\u1794\u17B6\u178F"},{"id":7110,"word":"\u1794\u17C9\u17B6\u178F"},{"id":7111,"word":"\u1794\u17B6\u178F\u179A\u17B6\u179F"},{"id":7112,"word":"\u1794\u17C9\u17B6\u178F\u17A1\u17B6\u178F"},{"id":7113,"word":"\u1794\u17C9\u17B6\u178F\u17CB"},{"id":7114,"word":"\u1794\u17C9\u17B6\u178F\u17CB\u179A\u1789\u17C9\u17B6\u178F\u17CB"},{"id":7115,"word":"\u1794\u17B6\u178F\u17B7\u1798\u17C4\u1780\u17D2\u1781"},{"id":7116,"word":"\u1794\u17B6\u178F\u17BB\u1780\u1798\u17D2\u1798"},{"id":7117,"word":"\u1794\u17B6\u178F\u17BB\u1797\u17BC\u178F"},{"id":7118,"word":"\u1794\u17C9\u17B6\u1793"},{"id":7119,"word":"\u1794\u17C9\u17B6\u1793\u17CB"},{"id":7120,"word":"\u1794\u17B6\u1793\u17B8\u1799"},{"id":7121,"word":"\u1794\u17C9\u17B6\u1794\u17CB"},{"id":7122,"word":"\u1794\u17B6\u1798\u17C4\u1780\u17D2\u1781"},{"id":7123,"word":"\u1794\u17B6\u1798\u17C4\u1787\u17D2\u1787"},{"id":7124,"word":"\u1794\u17C9\u17B6\u1799"},{"id":7125,"word":"\u1794\u17C9\u17B6\u1799\u17A0\u17BD\u1799"},{"id":7126,"word":"\u1794\u17B6\u179A\u17B6\u1787\u17B7\u1780"},{"id":7127,"word":"\u1794\u17C9\u17B6\u179C"},{"id":7128,"word":"\u1794\u17C9\u17B6\u179C\u1782\u1784"},{"id":7129,"word":"\u1794\u17B6\u179C\u1785\u1793\u17C8"},{"id":7130,"word":"\u1794\u17B6\u179F\u17B6\u1791\u17B7\u1780\u179F\u1798\u17B6\u1787\u17B7\u1780"},{"id":7131,"word":"\u1794\u17B6\u17A0\u17BB\u1793\u1780\u17C8"},{"id":7132,"word":"\u1794\u17B6\u17A0\u17BB\u1793\u1780\u178A\u17D2\u178B\u17B6\u1793"},{"id":7133,"word":"\u1794\u17C9\u17B6\u17A0\u17B6\u17C6\u1784"},{"id":7134,"word":"\u1794\u17C9\u17B7\u1780"},{"id":7135,"word":"\u1794\u17C9\u17B7\u1780\u17BD\u17C8"},{"id":7136,"word":"\u1794\u17C9\u17B7\u1785"},{"id":7137,"word":"\u1794\u17B7\u178A\u17D2\u178B\u17D2\u1799\u178A\u17D2\u178B\u17B7\u1780\u179F\u178F\u17D2\u179C"},{"id":7138,"word":"\u1794\u17C9\u17B7\u178F"},{"id":7139,"word":"\u1794\u17C9\u17B7\u178F\u1794\u17C9\u17BB\u178F"},{"id":7140,"word":"\u1794\u17B7\u178F\u17BB\u1782\u17BB\u178E"},{"id":7141,"word":"\u1794\u17B7\u178F\u17BB\u1783\u17B6\u178F"},{"id":7142,"word":"\u1794\u17B7\u178F\u17BB\u1783\u17B6\u178F\u1780\u17C8"},{"id":7143,"word":"\u1794\u17B7\u178F\u17BB\u1783\u17B6\u178F\u17B7\u1780\u17B6"},{"id":7144,"word":"\u1794\u17B7\u178F\u17BB\u1785\u17D2\u1786\u17B6"},{"id":7145,"word":"\u1794\u17B7\u178F\u17BB\u179B\u17C8"},{"id":7146,"word":"\u1794\u17B7\u178F\u17BB\u179B\u17B6\u1793\u17B8"},{"id":7147,"word":"\u1794\u17C9\u17B7\u1793"},{"id":7148,"word":"\u1794\u17C9\u17B7\u1793\u1794\u17C9\u17B6\u1793\u17CB"},{"id":7149,"word":"\u1794\u17C9\u17B7\u179B"},{"id":7150,"word":"\u1794\u17C9\u17B8"},{"id":7151,"word":"\u1794\u17B8\u178F\u17B7"},{"id":7152,"word":"\u1794\u17C9\u17B9\u1784"},{"id":7153,"word":"\u1794\u17C9\u17B9\u1798"},{"id":7154,"word":"\u1794\u17C9\u17BA\u1784"},{"id":7155,"word":"\u1794\u17C9\u17BA\u178F\u1794\u17C9\u17C4\u1784"},{"id":7156,"word":"\u1794\u17C9\u17BA\u1793"},{"id":7157,"word":"\u1794\u17C9\u17BA\u1794"},{"id":7158,"word":"\u1794\u17C9\u17BA\u1798"},{"id":7159,"word":"\u1794\u17C9\u17BB\u1780"},{"id":7160,"word":"\u1794\u17C9\u17BB\u1780\u17D7"},{"id":7161,"word":"\u1794\u17C9\u17BB\u1780\u1785\u17B6\u1799"},{"id":7162,"word":"\u1794\u17C9\u17BB\u1780\u1794\u17C9\u17BA\u1793"},{"id":7163,"word":"\u1794\u17C9\u17BB\u1780\u1796\u17BE\u1780"},{"id":7164,"word":"\u1794\u17C9\u17BB\u1784"},{"id":7165,"word":"\u1794\u17C9\u17BB\u1784"},{"id":7166,"word":"\u1794\u17BB\u1785\u17D2\u1786\u1793\u179F\u1789\u17D2\u1789\u17B6"},{"id":7167,"word":"\u1794\u17BB\u1785\u17D2\u1786\u17B6"},{"id":7168,"word":"\u1794\u17C9\u17BB\u178E\u17D2\u178E\u17B9\u1784"},{"id":7169,"word":"\u1794\u17C9\u17BB\u178E\u17D2\u178E\u17C1\u17C7"},{"id":7170,"word":"\u1794\u17C9\u17BB\u178E\u17D2\u178E\u17C4\u17C7"},{"id":7171,"word":"\u1794\u17BB\u178F\u17D2\u178F\u17B6"},{"id":7172,"word":"\u1794\u17BB\u1790\u17BB\u1787\u17D2\u1787\u1793"},{"id":7173,"word":"\u1794\u17C9\u17BB\u1793"},{"id":7174,"word":"\u1794\u17BB\u1793\u1794\u17D2\u1794\u17BB\u1793\u1780\u17D2\u1780\u1798\u17D2\u1798"},{"id":7175,"word":"\u1794\u17BB\u1793\u1794\u17D2\u1794\u17BB\u1793\u1780\u17D2\u1780\u17B6\u179A"},{"id":7176,"word":"\u1794\u17C9\u17BB\u1793\u17A2\u1798\u17D2\u1794\u17B6\u179B"},{"id":7177,"word":"\u1794\u17C9\u17BB\u1793\u17D2\u178F\u17C2"},{"id":7178,"word":"\u1794\u17C9\u17BB\u1793\u17D2\u1798\u17B6\u1793"},{"id":7179,"word":"\u1794\u17C9\u17BB\u1794"},{"id":7180,"word":"\u1794\u17C9\u17BB\u1799"},{"id":7181,"word":"\u1794\u17BB\u179A\u178F\u17D2\u1790\u17B7\u1798\u1791\u17B7\u179F"},{"id":7182,"word":"\u1794\u17BB\u179A\u178F\u17D2\u1790\u17B7\u1798\u17B6\u1793\u17BB\u1791\u17B7\u179F"},{"id":7183,"word":"\u1794\u17BB\u179A\u17C1\u1797\u178F\u17D2\u178F"},{"id":7184,"word":"\u1794\u17BB\u179A\u17C1\u1797\u178F\u17D2\u178F\u1780\u17B6\u179B"},{"id":7185,"word":"\u1794\u17BB\u179A\u17C1\u1797\u178F\u17D2\u178F\u1780\u17B7\u1785\u17D2\u1785"},{"id":7186,"word":"\u1794\u17C9\u17BB\u179F\u17D2\u178F\u17B7\u17CD"},{"id":7187,"word":"\u1794\u17C9\u17BC\u1780\u17D7"},{"id":7188,"word":"\u1794\u17C9\u17BC\u1784"},{"id":7189,"word":"\u1794\u17C9\u17BC\u1785"},{"id":7190,"word":"\u1794\u17BC\u178F\u17B7\u1780\u17B6\u1799"},{"id":7191,"word":"\u1794\u17BC\u178F\u17B7\u179B\u178F\u17B6"},{"id":7192,"word":"\u1794\u17BC\u179A\u178E\u1797\u17B6\u1796"},{"id":7193,"word":"\u1794\u17BC\u179A\u178E\u179F\u17C6\u1781\u17D2\u1799\u17B6"},{"id":7194,"word":"\u1794\u17C9\u17BC\u179B\u17B7\u179F"},{"id":7195,"word":"\u1794\u17C9\u17BC\u179C"},{"id":7196,"word":"\u1794\u17BC\u179C\u178A\u17D2\u178B\u17B6\u1793"},{"id":7197,"word":"\u1794\u17C9\u17BC\u179C\u1790\u17C5"},{"id":7198,"word":"\u1794\u17C9\u17BE\u1780\u17D7"},{"id":7199,"word":"\u1794\u17C9\u17BE\u1784"},{"id":7200,"word":"\u1794\u17C9\u17BE\u1784\u179A\u17C9\u17BE\u1784"},{"id":7201,"word":"\u1794\u17C9\u17BE\u1785"},{"id":7202,"word":"\u1794\u17C9\u17BE\u1798"},{"id":7203,"word":"\u1794\u17C1\u1780\u17D2\u1781\u1787\u1793"},{"id":7204,"word":"\u1794\u17C9\u17C1\u1784"},{"id":7205,"word":"\u1794\u17C9\u17C1\u1784\u1794\u17C9\u17C4\u17C7"},{"id":7206,"word":"\u1794\u17C1\u178F\u17B7\u1780\u1797\u178E\u17D2\u178C"},{"id":7207,"word":"\u1794\u17C1\u178F\u17B8"},{"id":7208,"word":"\u1794\u17C1\u1799\u17D2\u1799\u17B6\u179B\u17C8"},{"id":7209,"word":"\u1794\u17C9\u17C1\u179B\u1794\u17C9\u17B6\u179B"},{"id":7210,"word":"\u1794\u17C9\u17C1\u179C"},{"id":7211,"word":"\u1794\u17C1\u179F\u1780\u1780\u1798\u17D2\u1798"},{"id":7212,"word":"\u1794\u17C1\u179F\u1780\u1787\u1793"},{"id":7213,"word":"\u1794\u17C1\u17A1\u17B6"},{"id":7214,"word":"\u1794\u17C9\u17C2"},{"id":7215,"word":"\u1794\u17C9\u17C2\u1780"},{"id":7216,"word":"\u1794\u17C9\u17C2\u1784"},{"id":7217,"word":"\u1794\u17C9\u17C2\u178F\u178F\u17B6\u179A\u17B6\u1784"},{"id":7218,"word":"\u1794\u17C9\u17C2\u178F\u179F\u17B7\u1794"},{"id":7219,"word":"\u1794\u17C9\u17C2\u1793"},{"id":7220,"word":"\u1794\u17C9\u17C2\u179B"},{"id":7221,"word":"\u1794\u17C9\u17C2\u17C7"},{"id":7222,"word":"\u1794\u17C9\u17C3"},{"id":7223,"word":"\u1794\u17C9\u17C3!"},{"id":7224,"word":"\u1794\u17C9\u17C3\u179B\u17B7\u1793"},{"id":7225,"word":"\u1794\u17C3\u179F\u17B6\u1785\u17B8"},{"id":7226,"word":"\u1794\u17C9\u17C3\u17A1\u17B6\u17C6"},{"id":7227,"word":"\u1794\u17C9\u17C4"},{"id":7228,"word":"\u1794\u17C9\u17C4\u1780"},{"id":7229,"word":"\u1794\u17C9\u17C4\u1784"},{"id":7230,"word":"\u1794\u17C9\u17C4\u1785\u17D7"},{"id":7231,"word":"\u1794\u17C9\u17C4\u178F"},{"id":7232,"word":"\u1794\u17C9\u17C4\u1798"},{"id":7233,"word":"\u1794\u17C9\u17C4\u1799"},{"id":7234,"word":"\u1794\u17C4\u179A\u17B6\u178E\u17B6"},{"id":7235,"word":"\u1794\u17C4\u179A\u17B6\u178E\u17B6\u1793\u17BB\u1794\u17C4\u179A\u17B6\u178E"},{"id":7236,"word":"\u1794\u17C4\u179A\u17B8\u1797\u17B6\u179F\u17B6"},{"id":7237,"word":"\u1794\u17C9\u17C4\u179B"},{"id":7238,"word":"\u1794\u17C9\u17C4\u179B\u178F\u17C4\u1780"},{"id":7239,"word":"\u1794\u17C4\u179F\u17B7\u178F\u1796\u17D2\u179C\u1780\u17B7\u1785\u17D2\u1785"},{"id":7240,"word":"\u1794\u17C9\u17C4\u17A1\u17C2"},{"id":7241,"word":"\u1794\u17C9\u17C5"},{"id":7242,"word":"\u1794\u17C6\u179F\u17BB\u1780\u17BC\u179B\u17B7\u1780\u1784\u17D2\u1782\u17C8"},{"id":7243,"word":"\u1794\u17C9\u17C7"},{"id":7244,"word":"\u1794\u17D2\u178A\u17B8"},{"id":7245,"word":"\u1794\u17D2\u178A\u17B9\u1784"},{"id":7246,"word":"\u1794\u17D2\u178A\u17BC\u179A"},{"id":7247,"word":"\u1794\u17D2\u178A\u17C1\u1787\u17D2\u1789\u17B6"},{"id":7248,"word":"\u1794\u17D2\u179A\u1780\u17CB"},{"id":7249,"word":"\u1794\u17D2\u179A\u1780\u1794"},{"id":7250,"word":"\u1794\u17D2\u179A\u1780\u1794\u178A\u17C4\u1799"},{"id":7251,"word":"\u1794\u17D2\u179A\u1780\u17CB\u1795\u17D2\u179B\u17C2"},{"id":7252,"word":"\u1794\u17D2\u179A\u1780\u17CB\u1796\u179B"},{"id":7253,"word":"\u1794\u17D2\u179A\u1780\u17CB\u1796\u17D2\u179A\u17C6"},{"id":7254,"word":"\u1794\u17D2\u179A\u1780\u179B\u17CB"},{"id":7255,"word":"\u1794\u17D2\u179A\u1780\u17B6"},{"id":7256,"word":"\u1794\u17D2\u179A\u1780\u17B6\u1780\u17CB"},{"id":7257,"word":"\u1794\u17D2\u179A\u1780\u17B6\u1785\u17CB"},{"id":7258,"word":"\u1794\u17D2\u179A\u1780\u17B6\u1793\u17CB"},{"id":7259,"word":"\u1794\u17D2\u179A\u1780\u17B6\u1794\u17CB"},{"id":7260,"word":"\u1794\u17D2\u179A\u1780\u17B6\u179A"},{"id":7261,"word":"\u1794\u17D2\u179A\u1780\u17B6\u179F"},{"id":7262,"word":"\u1794\u17D2\u179A\u1780\u17B6\u179F\u1780\u17C8"},{"id":7263,"word":"\u1794\u17D2\u179A\u1780\u17B6\u179F\u1793\u17B8\u1799\u1794\u178F\u17D2\u179A"},{"id":7264,"word":"\u1794\u17D2\u179A\u1780\u17B6\u179F\u17B7\u1780\u17B6"},{"id":7265,"word":"\u1794\u17D2\u179A\u1780\u17B6\u179F\u17B7\u178F"},{"id":7266,"word":"\u1794\u17D2\u179A\u1780\u17B7\u178F"},{"id":7267,"word":"\u1794\u17D2\u179A\u1780\u17B9\u1784"},{"id":7268,"word":"\u1794\u17D2\u179A\u1780\u17BB\u1793"},{"id":7269,"word":"\u1794\u17D2\u179A\u1780\u17BD\u178F"},{"id":7270,"word":"\u1794\u17D2\u179A\u1780\u17BE\u1799"},{"id":7271,"word":"\u1794\u17D2\u179A\u1780\u17C0\u1780"},{"id":7272,"word":"\u1794\u17D2\u179A\u1780\u17C0\u1784"},{"id":7273,"word":"\u1794\u17D2\u179A\u1780\u17C2\u1780"},{"id":7274,"word":"\u1794\u17D2\u179A\u1780\u17C3"},{"id":7275,"word":"\u1794\u17D2\u179A\u1780\u17C4\u17C7"},{"id":7276,"word":"\u1794\u17D2\u179A\u1780\u17BB\u17C6"},{"id":7277,"word":"\u1794\u17D2\u179A\u1780\u17B6\u17C6"},{"id":7278,"word":"\u1794\u17D2\u179A\u1780\u17B6\u17C6\u1784"},{"id":7279,"word":"\u1794\u17D2\u179A\u1780\u17D2\u179A\u178F\u17B7\u1791\u17B7\u1793"},{"id":7280,"word":"\u1794\u17D2\u179A\u1780\u17D2\u179A\u178F\u17B8"},{"id":7281,"word":"\u1794\u17D2\u179A\u1781\u1784"},{"id":7282,"word":"\u1794\u17D2\u179A\u1781\u17BB\u1794"},{"id":7283,"word":"\u1794\u17D2\u179A\u1781\u17B6\u17C6"},{"id":7284,"word":"\u1794\u17D2\u179A\u1782\u1784"},{"id":7285,"word":"\u1794\u17D2\u179A\u1782\u179A"},{"id":7286,"word":"\u1794\u17D2\u179A\u1782\u179B\u17CB"},{"id":7287,"word":"\u1794\u17D2\u179A\u1782\u17B6\u1780\u17CB"},{"id":7288,"word":"\u1794\u17D2\u179A\u1782\u17B6\u1794"},{"id":7289,"word":"\u1794\u17D2\u179A\u1782\u17C1\u1793"},{"id":7290,"word":"\u1794\u17D2\u179A\u1782\u17C6"},{"id":7291,"word":"\u1794\u17D2\u179A\u1782\u17D2\u179A\u17B8\u179C"},{"id":7292,"word":"\u1794\u17D2\u179A\u1784\u17CB"},{"id":7293,"word":"\u1794\u17D2\u179A\u1785"},{"id":7294,"word":"\u1794\u17D2\u179A\u1785\u1780\u17D2\u179F"},{"id":7295,"word":"\u1794\u17D2\u179A\u1785\u1785"},{"id":7296,"word":"\u1794\u17D2\u179A\u1785\u178E\u17D2\u178C"},{"id":7297,"word":"\u1794\u17D2\u179A\u1785\u17B6\u1780\u17CB"},{"id":7298,"word":"\u1794\u17D2\u179A\u1785\u17B6\u1794\u17CB"},{"id":7299,"word":"\u1794\u17D2\u179A\u1785\u17B7\u178F\u17D2\u178F"},{"id":7300,"word":"\u1794\u17D2\u179A\u1785\u17B8"},{"id":7301,"word":"\u1794\u17D2\u179A\u1785\u17B9\u1780"},{"id":7302,"word":"\u1794\u17D2\u179A\u1785\u17BB\u1794"},{"id":7303,"word":"\u1794\u17D2\u179A\u1785\u17BD\u1793"},{"id":7304,"word":"\u1794\u17D2\u179A\u1785\u17BD\u1794"},{"id":7305,"word":"\u1794\u17D2\u179A\u1785\u17C0\u1785"},{"id":7306,"word":"\u1794\u17D2\u179A\u1785\u17C0\u179C"},{"id":7307,"word":"\u1794\u17D2\u179A\u1785\u17C2"},{"id":7308,"word":"\u1794\u17D2\u179A\u1785\u17C2\u1784"},{"id":7309,"word":"\u1794\u17D2\u179A\u1785\u17C4\u1798"},{"id":7310,"word":"\u1794\u17D2\u179A\u1785\u17B6\u17C6"},{"id":7311,"word":"\u1794\u17D2\u179A\u1786\u17C1\u17C7"},{"id":7312,"word":"\u1794\u17D2\u179A\u1786\u17B6\u17C6\u1784"},{"id":7313,"word":"\u1794\u17D2\u179A\u1786\u17D2\u1784\u17B7\u178F"},{"id":7314,"word":"\u1794\u17D2\u179A\u1787\u17B6"},{"id":7315,"word":"\u1794\u17D2\u179A\u1787\u17B6\u1793\u17CB"},{"id":7316,"word":"\u1794\u17D2\u179A\u1787\u17B6\u1794\u17CB"},{"id":7317,"word":"\u1794\u17D2\u179A\u1787\u17BD\u1793"},{"id":7318,"word":"\u1794\u17D2\u179A\u1787\u17BD\u1794"},{"id":7319,"word":"\u1794\u17D2\u179A\u1787\u17BD\u179F"},{"id":7320,"word":"\u1794\u17D2\u179A\u1787\u17C0\u1785"},{"id":7321,"word":"\u1794\u17D2\u179A\u1787\u17C0\u179C"},{"id":7322,"word":"\u1794\u17D2\u179A\u1787\u17C2\u1784"},{"id":7323,"word":"\u1794\u17D2\u179A\u1787\u17BB\u17C6"},{"id":7324,"word":"\u1794\u17D2\u179A\u1787\u17D2\u179A\u17BB\u1799"},{"id":7325,"word":"\u1794\u17D2\u179A\u1787\u17D2\u179A\u17BD\u179F"},{"id":7326,"word":"\u1794\u17D2\u179A\u1787\u17D2\u179A\u17C0\u178F"},{"id":7327,"word":"\u1794\u17D2\u179A\u1788\u1798"},{"id":7328,"word":"\u1794\u17D2\u179A\u1788\u17BD\u1793"},{"id":7329,"word":"\u1794\u17D2\u179A\u1788\u17D2\u179B\u17C4\u17C7"},{"id":7330,"word":"\u1794\u17D2\u179A\u1789\u1794\u17D2\u178F"},{"id":7331,"word":"\u1794\u17D2\u179A\u1789\u1794\u17D2\u178F\u17B7"},{"id":7332,"word":"\u1794\u17D2\u179A\u1789\u17B6\u1794\u17CB"},{"id":7333,"word":"\u1794\u17D2\u179A\u1789\u17B6\u1799"},{"id":7334,"word":"\u1794\u17D2\u179A\u1789\u17B6\u179B\u17CB"},{"id":7335,"word":"\u1794\u17D2\u179A\u1789\u17B7\u1794"},{"id":7336,"word":"\u1794\u17D2\u179A\u1789\u17B9\u1780"},{"id":7337,"word":"\u1794\u17D2\u179A\u178A\u1780\u17CB"},{"id":7338,"word":"\u1794\u17D2\u179A\u178A\u17B6"},{"id":7339,"word":"\u1794\u17D2\u179A\u178A\u17B6\u1780\u17CB"},{"id":7340,"word":"\u1794\u17D2\u179A\u178A\u17B6\u1780\u17CB\u1794\u17D2\u179A\u178A\u17BA\u178F"},{"id":7341,"word":"\u1794\u17D2\u179A\u178A\u17B6\u1780\u17CB\u1794\u17D2\u179A\u1791\u17BB\u1780\u17D2\u1781"},{"id":7342,"word":"\u1794\u17D2\u179A\u178A\u17B6\u1789"},{"id":7343,"word":"\u1794\u17D2\u179A\u178A\u17B6\u1793\u17CB"},{"id":7344,"word":"\u1794\u17D2\u179A\u178A\u17B6\u1794\u17CB"},{"id":7345,"word":"\u1794\u17D2\u179A\u178A\u17B6\u179B\u17CB"},{"id":7346,"word":"\u1794\u17D2\u179A\u178A\u17B7\u178F"},{"id":7347,"word":"\u1794\u17D2\u179A\u178A\u17B7\u178F\u1794\u17D2\u179A\u1787\u17B8"},{"id":7348,"word":"\u1794\u17D2\u179A\u178A\u17B9\u179F"},{"id":7349,"word":"\u1794\u17D2\u179A\u178A\u17BA\u178F"},{"id":7350,"word":"\u1794\u17D2\u179A\u178A\u17BB\u1784\u1794\u17D2\u179A\u1787\u17B6"},{"id":7351,"word":"\u1794\u17D2\u179A\u178A\u17BC\u1785"},{"id":7352,"word":"\u1794\u17D2\u179A\u178A\u17BE\u179F"},{"id":7353,"word":"\u1794\u17D2\u179A\u178A\u17C1\u1789"},{"id":7354,"word":"\u1794\u17D2\u179A\u178A\u17C2"},{"id":7355,"word":"\u1794\u17D2\u179A\u178A\u17C4\u178F"},{"id":7356,"word":"\u1794\u17D2\u179A\u178A\u17C4\u179B"},{"id":7357,"word":"\u1794\u17D2\u179A\u178A\u17C5"},{"id":7358,"word":"\u1794\u17D2\u179A\u178A\u17C6"},{"id":7359,"word":"\u1794\u17D2\u179A\u178C\u17B7\u178A\u17D2\u178B"},{"id":7360,"word":"\u1794\u17D2\u179A\u178E\u1798"},{"id":7361,"word":"\u1794\u17D2\u179A\u178E\u1798\u17D2\u1799"},{"id":7362,"word":"\u1794\u17D2\u179A\u178E\u17B6\u1780"},{"id":7363,"word":"\u1794\u17D2\u179A\u178E\u17B6\u1798"},{"id":7364,"word":"\u1794\u17D2\u179A\u178E\u17B7\u1784\u1794\u17D2\u179A\u178E\u17BB\u1784"},{"id":7365,"word":"\u1794\u17D2\u179A\u178E\u17B7\u178F"},{"id":7366,"word":"\u1794\u17D2\u179A\u178E\u17B7\u1792\u17B6\u1793"},{"id":7367,"word":"\u1794\u17D2\u179A\u178E\u17B7\u1792\u17B7"},{"id":7368,"word":"\u1794\u17D2\u179A\u178E\u17B7\u1794\u17D0\u178F\u1793\u17CD"},{"id":7369,"word":"\u1794\u17D2\u179A\u178E\u17B8"},{"id":7370,"word":"\u1794\u17D2\u179A\u178E\u17B8\u178F"},{"id":7371,"word":"\u1794\u17D2\u179A\u178E\u17B8\u178F\u1797\u17B6\u1796"},{"id":7372,"word":"\u1794\u17D2\u179A\u178E\u17B8\u178F\u17B6\u17A0\u17B6\u179A"},{"id":7373,"word":"\u1794\u17D2\u179A\u178E\u17C2\u1784\u1794\u17D2\u179A\u178E\u17C4\u1784"},{"id":7374,"word":"\u1794\u17D2\u179A\u178E\u17B6\u17C6\u1784"},{"id":7375,"word":"\u1794\u17D2\u179A\u178F\u1794\u17CB"},{"id":7376,"word":"\u1794\u17D2\u179A\u178F\u17B6\u1780"},{"id":7377,"word":"\u1794\u17D2\u179A\u178F\u17B6\u1794\u17CB\u1794\u17D2\u179A\u1789\u17B6\u179B\u17CB"},{"id":7378,"word":"\u1794\u17D2\u179A\u178F\u17B6\u1799"},{"id":7379,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1780\u1798\u17D2\u1798"},{"id":7380,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1780\u17D2\u179A\u17B7\u1799\u17B6"},{"id":7381,"word":"\u1794\u17D2\u179A\u178F\u17B7\u178A\u17D2\u178B"},{"id":7382,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1791\u17B7\u1793"},{"id":7383,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":7384,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1794\u1791\u17B6"},{"id":7385,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1796\u17D0\u1791\u17D2\u1792"},{"id":7386,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1796\u1793\u17D2\u1792"},{"id":7387,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1796\u179B"},{"id":7388,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1797\u17B6\u1782"},{"id":7389,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1797\u17B6\u178E"},{"id":7390,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1797\u17BC"},{"id":7391,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1798\u17B6"},{"id":7392,"word":"\u1794\u17D2\u179A\u178F\u17B7\u1798\u17B6\u1780\u179A"},{"id":7393,"word":"\u1794\u17D2\u179A\u178F\u17B7\u179B\u17B6\u1797"},{"id":7394,"word":"\u1794\u17D2\u179A\u178F\u17B7\u179B\u17C4\u1798"},{"id":7395,"word":"\u1794\u178F\u17B7\u179C\u17C1\u1791"},{"id":7396,"word":"\u1794\u17D2\u179A\u178F\u17B7\u179C\u17C1\u1791\u1793\u17CD"},{"id":7397,"word":"\u1794\u17D2\u179A\u178F\u17B7\u179F\u1793\u17D2\u1792\u17B7"},{"id":7398,"word":"\u1794\u17D2\u179A\u178F\u17B7\u179F\u17D2\u1793"},{"id":7399,"word":"\u1794\u17D2\u179A\u178F\u17B7\u179F\u17D2\u178B\u17B6\u1793"},{"id":7400,"word":"\u1794\u17D2\u179A\u178F\u17BA\u1784\u17A2\u17CA\u200C\u17B9\u17C7"},{"id":7401,"word":"\u1794\u17D2\u179A\u178F\u17C1\u1780"},{"id":7402,"word":"\u1794\u17D2\u179A\u178F\u17C2\u1784"},{"id":7403,"word":"\u1794\u17D2\u179A\u178F\u17C4\u1780"},{"id":7404,"word":"\u1794\u17D2\u179A\u178F\u17C4\u1784"},{"id":7405,"word":"\u1794\u17D2\u179A\u178F\u17D2\u1799\u1780\u17D2\u179F"},{"id":7406,"word":"\u1794\u17D2\u179A\u1790\u1798"},{"id":7407,"word":"\u1794\u17D2\u179A\u1790\u1798\u17B6\u179F\u17B6\u178D"},{"id":7408,"word":"\u1794\u17D2\u179A\u1790\u17B6\u1793"},{"id":7409,"word":"\u1794\u17D2\u179A\u1790\u17B6\u1794\u17CB"},{"id":7410,"word":"\u1794\u17D2\u179A\u1790\u17BB\u1785"},{"id":7411,"word":"\u1794\u17D2\u179A\u1790\u17BB\u1787\u17D2\u1787\u1793"},{"id":7412,"word":"\u1794\u17D2\u179A\u1790\u17BB\u1799"},{"id":7413,"word":"\u1794\u17D2\u179A\u1790\u17BD\u1793"},{"id":7414,"word":"\u1794\u17D2\u179A\u1790\u17C6"},{"id":7415,"word":"\u1794\u17D2\u179A\u1791\u1780\u17D2\u179F\u17B7\u178E"},{"id":7416,"word":"\u1794\u17D2\u179A\u1791\u1784\u17CB"},{"id":7417,"word":"\u1794\u17D2\u179A\u1791\u179B\u17CB"},{"id":7418,"word":"\u1794\u17D2\u179A\u1791\u17B6\u1780\u17CB"},{"id":7419,"word":"\u1794\u17D2\u179A\u1791\u17B6\u1789"},{"id":7420,"word":"\u1794\u17D2\u179A\u1791\u17B6\u1793"},{"id":7421,"word":"\u1794\u17D2\u179A\u1791\u17B6\u179B"},{"id":7422,"word":"\u1794\u17D2\u179A\u1791\u17B6\u179B\u17CB"},{"id":7423,"word":"\u1794\u17D2\u179A\u1791\u17B6\u179F"},{"id":7424,"word":"\u1794\u17D2\u179A\u1791\u17B6\u179F\u17CB"},{"id":7425,"word":"\u1794\u17D2\u179A\u1791\u17B6\u179F\u17CB\u1780\u17B6\u17C6\u1780\u17B8"},{"id":7426,"word":"\u1794\u17D2\u179A\u1791\u17B8\u1794"},{"id":7427,"word":"\u1794\u17D2\u179A\u1791\u17BB\u1780\u17D2\u1781\u1794\u17D2\u179A\u178A\u17B6\u1780\u17CB"},{"id":7428,"word":"\u1794\u17D2\u179A\u1791\u17BC\u179F"},{"id":7429,"word":"\u1794\u17D2\u179A\u1791\u17BC\u179F\u179A\u17C9\u17B6\u1799"},{"id":7430,"word":"\u1794\u17D2\u179A\u1791\u17BE\u179F"},{"id":7431,"word":"\u1794\u17D2\u179A\u1791\u17C1\u1785"},{"id":7432,"word":"\u1794\u17D2\u179A\u1791\u17C1\u179F"},{"id":7433,"word":"\u1794\u17D2\u179A\u1791\u17C4\u179F\u1780\u17B6\u179B"},{"id":7434,"word":"\u1794\u17D2\u179A\u1791\u17B6\u17C6\u1784"},{"id":7435,"word":"\u1794\u17D2\u179A\u1791\u17C7"},{"id":7436,"word":"\u1794\u17D2\u179A\u1792\u17B6\u1780\u17CB"},{"id":7437,"word":"\u1794\u17D2\u179A\u1792\u17B6\u1793"},{"id":7438,"word":"\u1794\u17D2\u179A\u1792\u17B6\u1793\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":7439,"word":"\u1794\u17D2\u179A\u1792\u17B6\u1793\u17B6\u1793\u17BB\u1799\u17C4\u1782"},{"id":7440,"word":"\u1794\u17D2\u179A\u1792\u17BD\u1793"},{"id":7441,"word":"\u1794\u17D2\u179A\u1793\u17C0\u179B"},{"id":7442,"word":"\u1794\u17D2\u179A\u1794"},{"id":7443,"word":"\u1794\u17D2\u179A\u1794\u17B7\u1785"},{"id":7444,"word":"\u1794\u17D2\u179A\u1794\u17C0\u178F"},{"id":7445,"word":"\u1794\u17D2\u179A\u1794\u17C1\u17C7"},{"id":7446,"word":"\u1794\u17D2\u179A\u1794\u17C2\u1780"},{"id":7447,"word":"\u1794\u17D2\u179A\u1794\u17C2\u179B"},{"id":7448,"word":"\u1794\u17D2\u179A\u1794\u17C4\u1785"},{"id":7449,"word":"\u1794\u17D2\u179A\u1795\u1784\u17CB"},{"id":7450,"word":"\u1794\u17D2\u179A\u1795\u17B6\u178F\u17CB"},{"id":7451,"word":"\u1794\u17D2\u179A\u1795\u17B6\u1794\u17CB"},{"id":7452,"word":"\u1794\u17D2\u179A\u1795\u17BB\u178F"},{"id":7453,"word":"\u1794\u17D2\u179A\u1795\u17BC\u179A"},{"id":7454,"word":"\u1794\u17D2\u179A\u1795\u17C1\u1789"},{"id":7455,"word":"\u1794\u17D2\u179A\u1795\u17C1\u17C7"},{"id":7456,"word":"\u1794\u17D2\u179A\u1795\u17D2\u1793\u17BC\u179B"},{"id":7457,"word":"\u1794\u17D2\u179A\u1796\u1793\u17D2\u1792"},{"id":7458,"word":"\u1794\u17D2\u179A\u1796\u17D0\u1793\u17D2\u1792"},{"id":7459,"word":"\u1794\u17D2\u179A\u1796\u17B6\u1780\u17CB"},{"id":7460,"word":"\u1794\u17D2\u179A\u1796\u17B6\u178F"},{"id":7461,"word":"\u1794\u17D2\u179A\u1796\u17B6\u1793"},{"id":7462,"word":"\u1794\u17D2\u179A\u1796\u17B6\u1799"},{"id":7463,"word":"\u1794\u17D2\u179A\u1796\u17B6\u179B"},{"id":7464,"word":"\u1794\u17D2\u179A\u1796\u17B6\u179F"},{"id":7465,"word":"\u1794\u17D2\u179A\u1796\u17BC\u1793"},{"id":7466,"word":"\u1794\u17D2\u179A\u1796\u17C3"},{"id":7467,"word":"\u1794\u17D2\u179A\u1796\u17C3\u178E\u17B8"},{"id":7468,"word":"\u1794\u17D2\u179A\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F"},{"id":7469,"word":"\u1794\u17D2\u179A\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7"},{"id":7470,"word":"\u1794\u17D2\u179A\u1797\u1796"},{"id":7471,"word":"\u1794\u17D2\u179A\u1797\u179F\u17D2\u179F\u179A"},{"id":7472,"word":"\u1794\u17D2\u179A\u1797\u17B6"},{"id":7473,"word":"\u1794\u17D2\u179A\u1797\u17B6\u1780\u179A"},{"id":7474,"word":"\u1794\u17D2\u179A\u1797\u17B6\u178F"},{"id":7475,"word":"\u1794\u17D2\u179A\u1797\u17B6\u1796"},{"id":7476,"word":"\u1794\u17D2\u179A\u1797\u17B6\u179F"},{"id":7477,"word":"\u1794\u17D2\u179A\u1797\u17BC"},{"id":7478,"word":"\u1794\u17D2\u179A\u1797\u17BE\u1785"},{"id":7479,"word":"\u1794\u17D2\u179A\u1797\u17C1\u1791"},{"id":7480,"word":"\u1794\u17D2\u179A\u1798\u1784\u17CB"},{"id":7481,"word":"\u1794\u17D2\u179A\u1798\u179B\u17CB"},{"id":7482,"word":"\u1794\u17D2\u179A\u1798\u17B6"},{"id":7483,"word":"\u1794\u17D2\u179A\u1798\u17B6\u1789\u17CB"},{"id":7484,"word":"\u1794\u17D2\u179A\u1798\u17B6\u178E"},{"id":7485,"word":"\u1794\u17D2\u179A\u1798\u17B6\u178E\u1794\u178F\u17D2\u179A"},{"id":7486,"word":"\u1794\u17D2\u179A\u1798\u17B6\u178E\u1794\u17BB\u179A\u179F"},{"id":7487,"word":"\u1794\u17D2\u179A\u1798\u17B6\u178F\u17CB"},{"id":7488,"word":"\u1794\u17D2\u179A\u1798\u17B6\u178F\u17CB\u1780\u1784\u17D2\u1780\u17C2\u1794"},{"id":7489,"word":"\u1794\u17D2\u179A\u1798\u17B6\u178F\u17CB\u178A\u17B8"},{"id":7490,"word":"\u1794\u17D2\u179A\u1798\u17B6\u1790"},{"id":7491,"word":"\u1794\u17D2\u179A\u1798\u17B6\u1791"},{"id":7492,"word":"\u1794\u17D2\u179A\u1798\u17B9\u1780"},{"id":7493,"word":"\u1794\u17D2\u179A\u1798\u17BB\u1781"},{"id":7494,"word":"\u1794\u17D2\u179A\u1798\u17BB\u1781\u179A\u178A\u17D2\u178B"},{"id":7495,"word":"\u1794\u17D2\u179A\u1798\u17BB\u1781\u17D2\u1799"},{"id":7496,"word":"\u1794\u17D2\u179A\u1798\u17BB\u1785"},{"id":7497,"word":"\u1794\u17D2\u179A\u1798\u17BB\u1789"},{"id":7498,"word":"\u1794\u17D2\u179A\u1798\u17BB\u1798"},{"id":7499,"word":"\u1794\u17D2\u179A\u1798\u17BC\u179B"},{"id":7500,"word":"\u1794\u17D2\u179A\u1798\u17BE\u179B"},{"id":7501,"word":"\u1794\u17D2\u179A\u1798\u17C0\u179B"},{"id":7502,"word":"\u1794\u17D2\u179A\u1798\u17C1"},{"id":7503,"word":"\u1794\u17D2\u179A\u1798\u17C1\u17A0\u179A\u17C4\u1782"},{"id":7504,"word":"\u1794\u17D2\u179A\u1798\u17C1\u17C7"},{"id":7505,"word":"\u1794\u17D2\u179A\u1798\u17C2"},{"id":7506,"word":"\u1794\u17D2\u179A\u1798\u17C4\u1780"},{"id":7507,"word":"\u1794\u17D2\u179A\u1798\u17C4\u1791"},{"id":7508,"word":"\u1794\u17D2\u179A\u1798\u17C4\u1799"},{"id":7509,"word":"\u1794\u17D2\u179A\u1798\u17C4\u1799\u178A\u17C6\u179A\u17B8"},{"id":7510,"word":"\u1794\u17D2\u179A\u1798\u17BB\u17C6"},{"id":7511,"word":"\u1794\u17D2\u179A\u1799\u1784\u17D2\u1782\u17BB"},{"id":7512,"word":"\u1794\u17D2\u179A\u1799\u17D0\u178F"},{"id":7513,"word":"\u1794\u17D2\u179A\u1799\u17D0\u178F\u17D2\u1793"},{"id":7514,"word":"\u1794\u17D2\u179A\u1799\u17BB\u1791\u17D2\u1792"},{"id":7515,"word":"\u1794\u17D2\u179A\u1799\u17BC\u179A"},{"id":7516,"word":"\u1794\u17D2\u179A\u1799\u17C2\u1784"},{"id":7517,"word":"\u1794\u17D2\u179A\u1799\u17C4\u1782"},{"id":7518,"word":"\u1794\u17D2\u179A\u1799\u17C4\u1782\u179C\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":7519,"word":"\u1794\u17D2\u179A\u1799\u17C4\u1782\u179F\u1798\u17D2\u1794\u178F\u17D2\u178F\u17B7"},{"id":7520,"word":"\u1794\u17D2\u179A\u1799\u17C4\u1787\u1793\u17CD"},{"id":7521,"word":"\u1794\u17D2\u179A\u1799\u17C4\u179B"},{"id":7522,"word":"\u1794\u17D2\u179A\u179B\u1784"},{"id":7523,"word":"\u1794\u17D2\u179A\u179B\u1784\u17CB"},{"id":7524,"word":"\u1794\u17D2\u179A\u179B\u17D0\u1799"},{"id":7525,"word":"\u1794\u17D2\u179A\u179B\u17BC\u1780"},{"id":7526,"word":"\u1794\u17D2\u179A\u179B\u17BC\u1789"},{"id":7527,"word":"\u1794\u17D2\u179A\u179B\u17BC\u179F"},{"id":7528,"word":"\u1794\u17D2\u179A\u179B\u17BD\u178F\u179B\u17B6\u1780\u17CB"},{"id":7529,"word":"\u1794\u17D2\u179A\u179B\u17C1\u17C7"},{"id":7530,"word":"\u1794\u17D2\u179A\u179B\u17C2\u1784"},{"id":7531,"word":"\u1794\u17D2\u179A\u179B\u17C4\u1798"},{"id":7532,"word":"\u1794\u17D2\u179A\u179B\u17C4\u1798\u179B\u17C4\u1780"},{"id":7533,"word":"\u1794\u17D2\u179A\u179B\u17C4\u17C7"},{"id":7534,"word":"\u1794\u17D2\u179A\u179B\u17B6\u17C6\u1794\u17D2\u179A\u1780\u17BC\u179C"},{"id":7535,"word":"\u1794\u17D2\u179A\u179C\u17D0\u1789\u17D2\u1785"},{"id":7536,"word":"\u1794\u17D2\u179A\u179C\u17D0\u1789\u17D2\u1785\u1793\u17CD"},{"id":7537,"word":"\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7"},{"id":7538,"word":"\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7\u179A\u17BC\u1794"},{"id":7539,"word":"\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":7540,"word":"\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7\u17A0\u17C1\u178F\u17BB"},{"id":7541,"word":"\u1794\u17D2\u179A\u179C\u17B6"},{"id":7542,"word":"\u1794\u17D2\u179A\u179C\u17B6\u1799"},{"id":7543,"word":"\u1794\u17D2\u179A\u179C\u17B6\u179B"},{"id":7544,"word":"\u1794\u17D2\u179A\u179C\u17B6\u179F\u17CB"},{"id":7545,"word":"\u1794\u17D2\u179A\u179C\u17B7\u1793\u1794\u17D2\u179A\u179C\u17B6\u1793\u17CB"},{"id":7546,"word":"\u1794\u17D2\u179A\u179C\u17B9\u1780"},{"id":7547,"word":"\u1794\u17D2\u179A\u179C\u17C1"},{"id":7548,"word":"\u1794\u17D2\u179A\u179C\u17C1\u178E\u17B8"},{"id":7549,"word":"\u1794\u17D2\u179A\u179C\u17C2\u1784"},{"id":7550,"word":"\u1794\u17D2\u179A\u179F"},{"id":7551,"word":"\u1794\u17D2\u179A\u179F\u17CB"},{"id":7552,"word":"\u1794\u17D2\u179A\u179F\u1794\u17CB"},{"id":7553,"word":"\u1794\u17D2\u179A\u179F\u1796\u17D2\u179C"},{"id":7554,"word":"\u1794\u17D2\u179A\u179F\u17B6"},{"id":7555,"word":"\u1794\u17D2\u179A\u179F\u17B6\u1785"},{"id":7556,"word":"\u1794\u17D2\u179A\u179F\u17B6\u1791"},{"id":7557,"word":"\u1794\u17D2\u179A\u179F\u17B6\u1791\u179A\u17BC\u1794"},{"id":7558,"word":"\u1794\u17D2\u179A\u179F\u17B6\u1792\u1793"},{"id":7559,"word":"\u1794\u17D2\u179A\u179F\u17B6\u179F\u1793\u17CD"},{"id":7560,"word":"\u1794\u17D2\u179A\u179F\u17B7\u1791\u17D2\u1792"},{"id":7561,"word":"\u1794\u17D2\u179A\u179F\u17B7\u1791\u17D2\u1792\u17B7\u17CD"},{"id":7562,"word":"\u1794\u17D2\u179A\u179F\u17B7\u1791\u17D2\u1792\u17B8"},{"id":7563,"word":"\u1794\u17D2\u179A\u179F\u17B7\u1793\u1787\u17B6"},{"id":7564,"word":"\u1794\u17D2\u179A\u179F\u17B7\u1793\u178E\u17B6\u1794\u17BE"},{"id":7565,"word":"\u1794\u17D2\u179A\u179F\u17B7\u1793\u1794\u17BE"},{"id":7566,"word":"\u1794\u17D2\u179A\u179F\u17BC\u178F"},{"id":7567,"word":"\u1794\u17D2\u179A\u179F\u17BC\u178F\u17B7"},{"id":7568,"word":"\u1794\u17D2\u179A\u179F\u17BC\u178F\u17B7\u1780\u1798\u17D2\u1798"},{"id":7569,"word":"\u1794\u17D2\u179A\u179F\u17BC\u178F\u17B7\u1780\u17B6"},{"id":7570,"word":"\u1794\u17D2\u179A\u179F\u17BC\u178F\u17B7\u1782\u17D2\u179A\u17B9\u17C7"},{"id":7571,"word":"\u1794\u17D2\u179A\u179F\u17BE\u179A"},{"id":7572,"word":"\u1794\u17D2\u179A\u179F\u17C1\u1785"},{"id":7573,"word":"\u1794\u17D2\u179A\u179F\u17D2\u178A\u17C2\u1784"},{"id":7574,"word":"\u1794\u17D2\u179A\u179F\u17D2\u1793\u17B6"},{"id":7575,"word":"\u1794\u17D2\u179A\u179F\u17D2\u1793\u17B7\u178F"},{"id":7576,"word":"\u1794\u17D2\u179A\u179F\u17D2\u179A\u17D0\u1799"},{"id":7577,"word":"\u1794\u17D2\u179A\u179F\u17D2\u179A\u17B6\u179C\u17C8"},{"id":7578,"word":"\u1794\u17D2\u179A\u179F\u17D2\u179A\u17B6\u179C\u1797\u17B6\u1787\u1793\u17C8"},{"id":7579,"word":"\u1794\u17D2\u179A\u17A0\u1780"},{"id":7580,"word":"\u1794\u17D2\u179A\u17A0\u17B6\u1780\u17CB"},{"id":7581,"word":"\u1794\u17D2\u179A\u17A0\u17B6\u178F"},{"id":7582,"word":"\u1794\u17D2\u179A\u17A0\u17B6\u179A"},{"id":7583,"word":"\u1794\u17D2\u179A\u17A0\u17B6\u179A\u1791\u17B6\u1793"},{"id":7584,"word":"\u1794\u17D2\u179A\u17A0\u17B7\u178F"},{"id":7585,"word":"\u1794\u17D2\u179A\u17A0\u17BB\u1780"},{"id":7586,"word":"\u1794\u17D2\u179A\u17A0\u17BD\u179A"},{"id":7587,"word":"\u1794\u17D2\u179A\u17A0\u17BE\u179A"},{"id":7588,"word":"\u1794\u17D2\u179A\u17A0\u17C1\u178F"},{"id":7589,"word":"\u1794\u17D2\u179A\u17A0\u17C2\u1780"},{"id":7590,"word":"\u1794\u17D2\u179A\u17A0\u17C2\u1784"},{"id":7591,"word":"\u1794\u17D2\u179A\u17A0\u17C2\u179B"},{"id":7592,"word":"\u1794\u17D2\u179A\u17A0\u17C2\u179F"},{"id":7593,"word":"\u1794\u17D2\u179A\u17A0\u17C4\u1784"},{"id":7594,"word":"\u1794\u17D2\u179A\u17A0\u17B6\u17C6\u1784"},{"id":7595,"word":"\u1794\u17D2\u179A\u17A1\u1784"},{"id":7596,"word":"\u1794\u17D2\u179A\u17A1\u1784\u17CB"},{"id":7597,"word":"\u1794\u17D2\u179A\u17A1\u17B6\u1780\u17CB"},{"id":7598,"word":"\u1794\u17D2\u179A\u17A1\u17B6\u1799"},{"id":7599,"word":"\u1794\u17D2\u179A\u17A1\u17B7\u1784\u1794\u17D2\u179A\u17A1\u17B6\u17C6\u1784"},{"id":7600,"word":"\u1794\u17D2\u179A\u17A1\u17B7\u1798\u1794\u17D2\u179A\u17A1\u17BB\u17C6"},{"id":7601,"word":"\u1794\u17D2\u179A\u17A1\u17BB\u1794\u1794\u17C9\u17D0\u1785\u17D2\u1786\u17B6"},{"id":7602,"word":"\u1794\u17D2\u179A\u17A1\u17BC\u1780"},{"id":7603,"word":"\u1794\u17D2\u179A\u17A1\u17BC\u1789"},{"id":7604,"word":"\u1794\u17D2\u179A\u17A1\u17BC\u179F"},{"id":7605,"word":"\u1794\u17D2\u179A\u17A1\u17C1\u17C7"},{"id":7606,"word":"\u1794\u17D2\u179A\u17A1\u17C2\u1784"},{"id":7607,"word":"\u1794\u17D2\u179A\u17A1\u17C2\u1794\u17D2\u179A\u1780\u17C4"},{"id":7608,"word":"\u1794\u17D2\u179A\u17A1\u17C3\u179F\u1780"},{"id":7609,"word":"\u1794\u17D2\u179A\u17A1\u17C4\u17C7"},{"id":7610,"word":"\u1794\u17D2\u179A\u17A1\u17C5"},{"id":7611,"word":"\u1794\u17D2\u179A\u17A1\u17C5\u1796\u1796\u17C2"},{"id":7612,"word":"\u1794\u17D2\u179A\u17A1\u17C5\u17A2\u17C6\u1796\u17C2"},{"id":7613,"word":"\u1794\u17D2\u179A\u17A1\u17B6\u17C6\u1784\u1780\u17B6\u179F"},{"id":7614,"word":"\u1794\u17D2\u179A\u17A1\u17B6\u17C6\u1794\u17D2\u179A\u1780\u17BC\u179C"},{"id":7615,"word":"\u1794\u17D2\u179A\u17A2\u1794\u17CB"},{"id":7616,"word":"\u1794\u17D2\u179A\u17A2\u1794\u17CB\u1787\u17BE\u1784"},{"id":7617,"word":"\u1794\u17D2\u179A\u17A2\u17BC\u1784"},{"id":7618,"word":"\u1794\u17D2\u179A\u17A2\u17BC\u179F"},{"id":7619,"word":"\u1794\u17D2\u179A\u17A2\u17BD\u179B"},{"id":7620,"word":"\u1794\u17D2\u179A\u17B1\u1794"},{"id":7621,"word":"\u1794\u17D2\u179A\u17B6"},{"id":7622,"word":"\u1794\u17D2\u179A\u17B6\u17A2\u17C0\u179C"},{"id":7623,"word":"\u1794\u17D2\u179A\u17B6\u1780"},{"id":7624,"word":"\u1794\u17D2\u179A\u17B6\u1780\u17CB"},{"id":7625,"word":"\u1794\u17D2\u179A\u17B6\u1780\u178A"},{"id":7626,"word":"\u1794\u17D2\u179A\u17B6\u1780\u17B6\u179A"},{"id":7627,"word":"\u1794\u17D2\u179A\u17B6\u1780\u17D2\u179A\u17B9\u178F"},{"id":7628,"word":"\u1794\u17D2\u179A\u17B6\u1783\u17B6\u178F"},{"id":7629,"word":"\u1794\u17D2\u179A\u17B6\u1784\u17D2\u1782"},{"id":7630,"word":"\u1794\u17D2\u179A\u17B6\u1784\u17D2\u1782\u178E\u17CD"},{"id":7631,"word":"\u1794\u17D2\u179A\u17B6\u1785\u17CB"},{"id":7632,"word":"\u1794\u17D2\u179A\u17B6\u1785\u17B7\u1793"},{"id":7633,"word":"\u1794\u17D2\u179A\u17B6\u1787\u17D2\u1789"},{"id":7634,"word":"\u1794\u17D2\u179A\u17B6\u1787\u17D2\u1789\u17B6"},{"id":7635,"word":"\u1794\u17D2\u179A\u17B6\u178E"},{"id":7636,"word":"\u1794\u17D2\u179A\u17B6\u178F\u17CB"},{"id":7637,"word":"\u1794\u17D2\u179A\u17B6\u1790\u17D2\u1793\u17B6"},{"id":7638,"word":"\u1794\u17D2\u179A\u17B6\u1794"},{"id":7639,"word":"\u1794\u17D2\u179A\u17B6\u1794\u17CB"},{"id":7640,"word":"\u1794\u17D2\u179A\u17B6\u1794\u17D2\u178F"},{"id":7641,"word":"\u1794\u17D2\u179A\u17B6\u1794\u17D2\u178A\u17B6\u1797\u17B7\u179B\u17B6\u1797"},{"id":7642,"word":"\u1794\u17D2\u179A\u17B6\u1794\u17D2\u178F\u17B6\u1797\u17B7\u179F\u17C1\u1780"},{"id":7643,"word":"\u1794\u17D2\u179A\u17B6\u1798"},{"id":7644,"word":"\u1794\u17D2\u179A\u17B6\u1798\u17C4\u1791\u17D2\u1799"},{"id":7645,"word":"\u1794\u17D2\u179A\u17B6\u1799"},{"id":7646,"word":"\u1794\u17D2\u179A\u17B6\u1799"},{"id":7647,"word":"\u1794\u17D2\u179A\u17B6\u179A\u1796\u17D2\u1792"},{"id":7648,"word":"\u1794\u17D2\u179A\u17B6\u179C"},{"id":7649,"word":"\u1794\u17D2\u179A\u17B6\u179F"},{"id":7650,"word":"\u1794\u17D2\u179A\u17B6\u179F\u17CB"},{"id":7651,"word":"\u1794\u17D2\u179A\u17B6\u179F\u17B6\u1791"},{"id":7652,"word":"\u1794\u17D2\u179A\u17B6\u179F\u17D2\u179A\u17D0\u1799"},{"id":7653,"word":"\u1794\u17D2\u179A\u17B7\u1785"},{"id":7654,"word":"\u1794\u17D2\u179A\u17B7\u1785\u17D7"},{"id":7655,"word":"\u1794\u17D2\u179A\u17B7\u1789\u17D7"},{"id":7656,"word":"\u1794\u17D2\u179A\u17B7\u178F"},{"id":7657,"word":"\u1794\u17D2\u179A\u17B7\u178F\u1794\u17D2\u179A\u17C0\u1784"},{"id":7658,"word":"\u1794\u17D2\u179A\u17B7\u178F\u1794\u17D2\u179A\u17C0\u1793"},{"id":7659,"word":"\u1794\u17D2\u179A\u17B7\u178F\u1794\u17D2\u179A\u17C0\u1794"},{"id":7660,"word":"\u1794\u17D2\u179A\u17B7\u1793\u1794\u17D2\u179A\u17BB\u1793"},{"id":7661,"word":"\u1794\u17D2\u179A\u17B7\u1794"},{"id":7662,"word":"\u1794\u17D2\u179A\u17B7\u1798\u1794\u17D2\u179A\u17B7\u1799"},{"id":7663,"word":"\u1794\u17D2\u179A\u17B7\u1799\u1794\u17D2\u179A\u17B6\u1799"},{"id":7664,"word":"\u1794\u17D2\u179A\u17B7\u1799\u1797\u17B6\u1796"},{"id":7665,"word":"\u1794\u17D2\u179A\u17B7\u179B"},{"id":7666,"word":"\u1794\u17D2\u179A\u17B8"},{"id":7667,"word":"\u1794\u17D2\u179A\u17B8\u1787\u17B6"},{"id":7668,"word":"\u1794\u17D2\u179A\u17B8\u178F\u17B6"},{"id":7669,"word":"\u1794\u17D2\u179A\u17B9\u1780\u17D2\u179F\u17B6"},{"id":7670,"word":"\u1794\u17D2\u179A\u17B9\u1784"},{"id":7671,"word":"\u1794\u17D2\u179A\u17B9\u1790\u1796\u17B8"},{"id":7672,"word":"\u1794\u17D2\u179A\u17B9\u1794"},{"id":7673,"word":"\u1794\u17D2\u179A\u17B9\u179F"},{"id":7674,"word":"\u1794\u17D2\u179A\u17B9\u179F\u17D7"},{"id":7675,"word":"\u1794\u17D2\u179A\u17B9\u179F\u17D2\u178A\u17B6\u1784\u17D2\u1782"},{"id":7676,"word":"\u1794\u17D2\u179A\u17B9\u179F\u17D2\u178B"},{"id":7677,"word":"\u1794\u17D2\u179A\u17B9\u179F\u17D2\u178B\u17B6\u1784\u17D2\u1782"},{"id":7678,"word":"\u1794\u17D2\u179A\u17B9\u17C7\u17D7"},{"id":7679,"word":"\u1794\u17D2\u179A\u17BB\u1784"},{"id":7680,"word":"\u1794\u17D2\u179A\u17BB\u1793\u17D7"},{"id":7681,"word":"\u1794\u17D2\u179A\u17BB\u1799"},{"id":7682,"word":"\u1794\u17D2\u179A\u17BB\u179F"},{"id":7683,"word":"\u1794\u17D2\u179A\u17BB\u17C7"},{"id":7684,"word":"\u1794\u17D2\u179A\u17BC\u1784"},{"id":7685,"word":"\u1794\u17D2\u179A\u17BC\u1785"},{"id":7686,"word":"\u1794\u17D2\u179A\u17BC\u179F"},{"id":7687,"word":"\u1794\u17D2\u179A\u17BD\u1780"},{"id":7688,"word":"\u1796\u17D2\u179A\u17BD\u1789"},{"id":7689,"word":"\u1794\u17D2\u179A\u17BD\u178F"},{"id":7690,"word":"\u1794\u17D2\u179A\u17BD\u1798"},{"id":7691,"word":"\u1794\u17D2\u179A\u17BD\u179B"},{"id":7692,"word":"\u1794\u17D2\u179A\u17BE"},{"id":7693,"word":"\u1794\u17D2\u179A\u17BE\u179F"},{"id":7694,"word":"\u1794\u17D2\u179A\u17BF\u1784"},{"id":7695,"word":"\u1794\u17D2\u179A\u17C0\u1785"},{"id":7696,"word":"\u1794\u17D2\u179A\u17C0\u1793"},{"id":7697,"word":"\u1794\u17D2\u179A\u17C0\u1794"},{"id":7698,"word":"\u1794\u17D2\u179A\u17C1\u1784"},{"id":7699,"word":"\u1794\u17D2\u179A\u17C1\u178F"},{"id":7700,"word":"\u1794\u17D2\u179A\u17C1\u178F\u178F\u17B7\u179A\u17C4\u1780"},{"id":7701,"word":"\u1794\u17D2\u179A\u17C1\u178F\u179B\u17C4\u1780"},{"id":7702,"word":"\u1794\u17D2\u179A\u17C1\u178F\u179C\u17D0\u1793"},{"id":7703,"word":"\u1794\u17D2\u179A\u17C1\u178F\u179C\u17B7\u179F\u17D0\u1799"},{"id":7704,"word":"\u1794\u17D2\u179A\u17C1\u1798\u1794\u17D2\u179A\u17B7\u1799"},{"id":7705,"word":"\u1794\u17D2\u179A\u17C1\u179C"},{"id":7706,"word":"\u1794\u17D2\u179A\u17C1\u179F\u17B7\u178F"},{"id":7707,"word":"\u1794\u17D2\u179A\u17C1\u17C7"},{"id":7708,"word":"\u1794\u17D2\u179A\u17C2"},{"id":7709,"word":"\u1794\u17D2\u179A\u17C2\u1780"},{"id":7710,"word":"\u1794\u17D2\u179A\u17C2\u1784"},{"id":7711,"word":"\u1794\u17D2\u179A\u17C2\u17C7\u17D7"},{"id":7712,"word":"\u1794\u17D2\u179A\u17C3"},{"id":7713,"word":"\u1794\u17D2\u179A\u17C3\u179F\u178E\u17B8\u1799\u17CD"},{"id":7714,"word":"\u1794\u17D2\u179A\u17C4\u1780"},{"id":7715,"word":"\u1794\u17D2\u179A\u17C4\u179F"},{"id":7716,"word":"\u1794\u17D2\u179A\u17C4\u17C7"},{"id":7717,"word":"\u1794\u17D2\u179A\u17C4\u17C7\u1796\u17D2\u179A\u17C6"},{"id":7718,"word":"\u1794\u17D2\u179A\u17C4\u17C7\u179F\u17D2\u179C\u17B6"},{"id":7719,"word":"\u1794\u17D2\u179A\u17B6\u17C6"},{"id":7720,"word":"\u1794\u17D2\u179A\u17B6\u17C6\u1784"},{"id":7721,"word":"\u1794\u17D2\u179A\u17B6\u17C6\u1792\u17B6\u1793"},{"id":7722,"word":"\u1794\u17D2\u179A\u17B6\u17C6\u1794\u17B8"},{"id":7723,"word":"\u1794\u17D2\u179A\u17B6\u17C6\u1794\u17BD\u1793"},{"id":7724,"word":"\u1794\u17D2\u179A\u17B6\u17C6\u1796\u17B8\u179A"},{"id":7725,"word":"\u1794\u17D2\u179A\u17C7"},{"id":7726,"word":"\u1794\u17D2\u179B\u1780\u17CB"},{"id":7727,"word":"\u1794\u17D2\u179B\u178F"},{"id":7728,"word":"\u1794\u17D2\u179B\u1793\u17CB"},{"id":7729,"word":"\u1794\u17D2\u179B\u1794\u17CB"},{"id":7730,"word":"\u1794\u17D2\u179B\u1798"},{"id":7731,"word":"\u1794\u17D2\u179B\u17B6\u1785\u17CB"},{"id":7732,"word":"\u1794\u17D2\u179B\u17B6\u1789\u17D7"},{"id":7733,"word":"\u1794\u17D2\u179B\u17B6\u178F"},{"id":7734,"word":"\u1794\u17D2\u179B\u17B6\u1792\u17BC"},{"id":7735,"word":"\u1794\u17D2\u179B\u17B6\u1794"},{"id":7736,"word":"\u1794\u17D2\u179B\u17B6\u1794\u17CB"},{"id":7737,"word":"\u1794\u17D2\u179B\u17B6\u1799"},{"id":7738,"word":"\u1794\u17D2\u179B\u17B7\u1780\u17D7"},{"id":7739,"word":"\u1794\u17D2\u179B\u17B7\u1785"},{"id":7740,"word":"\u1794\u17D2\u179B\u17B9\u1780\u17D7"},{"id":7741,"word":"\u1794\u17D2\u179B\u17BA\u1798"},{"id":7742,"word":"\u1794\u17D2\u179B\u17BB\u1780"},{"id":7743,"word":"\u1794\u17D2\u179B\u17BB\u1784"},{"id":7744,"word":"\u1794\u17D2\u179B\u17BB\u1784\u17D7"},{"id":7745,"word":"\u1794\u17D2\u179B\u17BC\u1780"},{"id":7746,"word":"\u1794\u17D2\u179B\u17BC\u1785"},{"id":7747,"word":"\u1794\u17D2\u179B\u17BD\u1780"},{"id":7748,"word":"\u1794\u17D2\u179B\u17BE\u1780\u17D7"},{"id":7749,"word":"\u1794\u17D2\u179B\u17C0\u1780\u17D7"},{"id":7750,"word":"\u1794\u17D2\u179B\u17C0\u179C"},{"id":7751,"word":"\u1794\u17D2\u179B\u17C1\u1784"},{"id":7752,"word":"\u1794\u17D2\u179B\u17C1\u1784\u1794\u17D2\u179B\u17C4\u1784"},{"id":7753,"word":"\u1794\u17D2\u179B\u17C1\u17C7\u1794\u17D2\u179B\u17C4\u17C7"},{"id":7754,"word":"\u1794\u17D2\u179B\u17C2\u1780"},{"id":7755,"word":"\u1794\u17D2\u179B\u17C2\u1784"},{"id":7756,"word":"\u1794\u17D2\u179B\u17C2\u1793"},{"id":7757,"word":"\u1794\u17D2\u179B\u17C2\u1798\u17D7"},{"id":7758,"word":"\u1794\u17D2\u179B\u17C4\u1780"},{"id":7759,"word":"\u1794\u17D2\u179B\u17C4\u1784"},{"id":7760,"word":"\u1794\u17D2\u179B\u17C4\u1789\u17D7"},{"id":7761,"word":"\u1794\u17D2\u179B\u17C4\u178F"},{"id":7762,"word":"\u1794\u17D2\u179B\u17B6\u17C6"},{"id":7763,"word":"\u1794\u17D2\u17A2\u17BC\u1793"},{"id":7764,"word":"\u1794\u17CA"},{"id":7765,"word":"\u1794\u17CA\u17D0\u179A"},{"id":7766,"word":"\u1794\u17CA\u17B7\u1780"},{"id":7767,"word":"\u1794\u17CA\u17B7\u179F\u17D2\u1782\u17D2\u179C\u17B8\u178F\u17CD"},{"id":7768,"word":"\u1794\u17CA\u17B7\u17A0\u17D2\u179C\u178F\u17B7\u1780"},{"id":7769,"word":"\u1794\u17CA\u17B7\u17C7"},{"id":7770,"word":"\u1794\u17CA\u17B8\u178A\u17BB\u1784"},{"id":7771,"word":"\u1794\u17CA\u17B8\u1799\u17C1\u179A"},{"id":7772,"word":"\u1794\u17CA\u17BB\u178F"},{"id":7773,"word":"\u1794\u17D2\u17A2\u17CA\u17B9\u17C7"},{"id":7774,"word":"\u1794\u1789\u17D2\u1785\u179A"},{"id":7775,"word":"\u1794\u17C6\u178E\u17B6\u1780\u17CB"},{"id":7776,"word":"\u1794\u17C6\u178E\u17B6\u178F\u17CB"},{"id":7777,"word":"\u1794\u17C6\u178E\u17B7\u1791"},{"id":7778,"word":"\u1794\u17C6\u178E\u17BE\u1780"},{"id":7779,"word":"\u1794\u17C6\u178E\u17C4\u1780"},{"id":7780,"word":"\u1794\u17D2\u179A\u1787\u17B6\u1794\u17D2\u179A\u17B7\u1799"},{"id":7781,"word":"\u1794\u17D2\u179A\u1787\u17B6\u179F\u179C\u1793\u17B6\u1780\u17B6\u179A"},{"id":7782,"word":"\u1794\u17D2\u179A\u1794\u17C1\u179A"},{"id":7783,"word":"\u1794\u17C9\u17D0\u1784\u178F\u17C4"},{"id":7784,"word":"\u1795"},{"id":7785,"word":"\u1795\u1782\u17D2\u1782\u17BB\u178E"},{"id":7786,"word":"\u1795\u1782\u17D2\u1782\u17BB\u1793\u17B8"},{"id":7787,"word":"\u1795\u1784"},{"id":7788,"word":"\u1795\u1784\u17CB"},{"id":7789,"word":"\u1795\u178F"},{"id":7790,"word":"\u1795\u179A\u178E\u17B6\u1794\u17B8\u178F\u17B7"},{"id":7791,"word":"\u1795\u179A\u17BB\u179F\u179C\u17B6\u1785\u17B6"},{"id":7792,"word":"\u1795\u179A\u17BB\u179F\u179F\u1796\u17D2\u1791"},{"id":7793,"word":"\u1795\u179B"},{"id":7794,"word":"\u1795\u179B--"},{"id":7795,"word":"\u1795\u179B\u17CB\u179F\u17D2\u1798\u17B6"},{"id":7796,"word":"\u1795\u179B\u17B7\u1780"},{"id":7797,"word":"\u1795\u179B\u17B7\u178F\u1780\u1798\u17D2\u1798"},{"id":7798,"word":"\u1795\u179B\u17B7\u178F\u1795\u179B"},{"id":7799,"word":"\u1795\u179B\u17D2\u1782\u17BB\u1793"},{"id":7800,"word":"\u1795\u179F"},{"id":7801,"word":"\u1795\u179F\u17D2\u179F"},{"id":7802,"word":"\u1795\u179F\u17D2\u179F\u17B6\u17A0\u17B6\u179A"},{"id":7803,"word":"\u1795\u17B6\u1780"},{"id":7804,"word":"\u1795\u17B6\u1780\u17D2\u179A\u17B6\u1794"},{"id":7805,"word":"\u1795\u17B6\u1784"},{"id":7806,"word":"\u1795\u17B6\u178C\u17B7\u1794"},{"id":7807,"word":"\u1795\u17B6\u178E\u17B7\u178F"},{"id":7808,"word":"\u1795\u17B6\u178F\u17CB"},{"id":7809,"word":"\u1795\u17B6\u178F\u17CB\u1787\u17B6\u1799"},{"id":7810,"word":"\u1795\u17B6\u178F\u17B7\u1780\u1798\u17D2\u1798"},{"id":7811,"word":"\u1795\u17B6\u1794\u17CB"},{"id":7812,"word":"\u1795\u17B6\u1794\u17C9\u17B6"},{"id":7813,"word":"\u1795\u17B6\u1798\u17BD\u1784"},{"id":7814,"word":"\u1795\u17B6\u1799"},{"id":7815,"word":"\u1795\u17B6\u1799\u17C4\u1784"},{"id":7816,"word":"\u1795\u17B6\u179B"},{"id":7817,"word":"\u1795\u17B6\u179C"},{"id":7818,"word":"\u1795\u17B6\u179F"},{"id":7819,"word":"\u1795\u17B6\u179F\u17BB\u1780"},{"id":7820,"word":"\u1795\u17B6\u179F\u17BB\u1780\u17B6"},{"id":7821,"word":"\u1795\u17B6\u179F\u17BB\u179C\u17B7\u17A0\u17B6\u179A"},{"id":7822,"word":"\u1795\u17B6\u17A0\u17CA\u17BB\u1798"},{"id":7823,"word":"\u1795\u17B7\u178F"},{"id":7824,"word":"\u1795\u17B9\u1780"},{"id":7825,"word":"\u1795\u17B9\u1784"},{"id":7826,"word":"\u1795\u17BA\u178F"},{"id":7827,"word":"\u1795\u17BB\u1784"},{"id":7828,"word":"\u1795\u17BB\u178F"},{"id":7829,"word":"\u1795\u17BB\u1799"},{"id":7830,"word":"\u1795\u17BB\u1799\u1795\u17B6\u1799"},{"id":7831,"word":"\u1795\u17BB\u179A"},{"id":7832,"word":"\u1795\u17BB\u179F"},{"id":7833,"word":"\u1795\u17BB\u179F\u17D2\u179F\u178F\u17B8"},{"id":7834,"word":"\u1795\u17BB\u179F\u17D2\u179F\u179A\u17B6\u1782"},{"id":7835,"word":"\u1795\u17BC\u1780"},{"id":7836,"word":"\u1795\u17BC\u1784"},{"id":7837,"word":"\u1795\u17BC\u1799"},{"id":7838,"word":"\u1795\u17BC\u179A\u1795\u1784\u17CB"},{"id":7839,"word":"\u1795\u17BC\u179F"},{"id":7840,"word":"\u1795\u17BD\u1799"},{"id":7841,"word":"\u1795\u17BE\u1784"},{"id":7842,"word":"\u1795\u17BE\u178F"},{"id":7843,"word":"\u1795\u17BE\u1798"},{"id":7844,"word":"\u1795\u17BE\u1799"},{"id":7845,"word":"\u1795\u17BF\u1780"},{"id":7846,"word":"\u1795\u17C1\u1784"},{"id":7847,"word":"\u1795\u17C1\u179A"},{"id":7848,"word":"\u1795\u17C1\u17C7"},{"id":7849,"word":"\u1795\u17C2"},{"id":7850,"word":"\u1795\u17C2\u1784"},{"id":7851,"word":"\u1795\u17C2\u178F"},{"id":7852,"word":"\u1795\u17C2\u1793"},{"id":7853,"word":"\u1795\u17C2\u1793\u1780\u17B6\u179A"},{"id":7854,"word":"\u1795\u17C2\u1793\u1791\u17B8"},{"id":7855,"word":"\u1795\u17C2\u179B"},{"id":7856,"word":"\u1795\u17C2\u179B\u1791\u17B9\u1780"},{"id":7857,"word":"\u1795\u17C2\u17C7"},{"id":7858,"word":"\u1795\u17C4\u1784"},{"id":7859,"word":"\u1795\u17C4\u178A\u17D2\u178B\u1796\u17D2\u179C\u17C8"},{"id":7860,"word":"\u1795\u17C4\u178A\u17D2\u178B\u1796\u17D2\u179C\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD"},{"id":7861,"word":"\u1795\u17C4\u1798"},{"id":7862,"word":"\u1795\u17C5"},{"id":7863,"word":"\u1795\u17B6\u17C6\u1784"},{"id":7864,"word":"\u1795\u17D2\u1780\u17B6"},{"id":7865,"word":"\u1795\u17D2\u1780\u17B6\u1780\u1798\u17D2\u179A\u1784"},{"id":7866,"word":"\u1795\u17D2\u1780\u17B6\u1785\u1793\u17D2\u1791\u1793\u17CD"},{"id":7867,"word":"\u1795\u17D2\u1780\u17B6\u1785\u17B6\u179A"},{"id":7868,"word":"\u1795\u17D2\u1780\u17B6\u1785\u17C1\u1780"},{"id":7869,"word":"\u1795\u17D2\u1780\u17B6\u1788\u17BC\u1780"},{"id":7870,"word":"\u1795\u17D2\u1780\u17B6\u1788\u17BE"},{"id":7871,"word":"\u1795\u17D2\u1780\u17B6\u1789\u17D0\u179A"},{"id":7872,"word":"\u1795\u17D2\u1780\u17B6\u178A\u17C6\u1794\u17C5"},{"id":7873,"word":"\u1795\u17D2\u1780\u17B6\u178F\u17D2\u179A\u17C2\u1784"},{"id":7874,"word":"\u1795\u17D2\u1780\u17B6\u1794\u17CB"},{"id":7875,"word":"\u1795\u17D2\u1780\u17B6\u1794\u17B7\u178E\u17D2\u178C"},{"id":7876,"word":"\u1795\u17D2\u1780\u17B6\u1794\u17CB\u1795\u17D2\u1784\u17B6\u179A"},{"id":7877,"word":"\u1795\u17D2\u1780\u17B6\u1797\u17D2\u179B\u17BE\u1784"},{"id":7878,"word":"\u1795\u17D2\u1780\u17B6\u1798\u17B6\u179F"},{"id":7879,"word":"\u1795\u17D2\u1780\u17B6\u1799"},{"id":7880,"word":"\u1795\u17D2\u1780\u17B6\u179A\u17B6\u17C6\u1784"},{"id":7881,"word":"\u1795\u17D2\u1780\u17B6\u179F"},{"id":7882,"word":"\u1795\u17D2\u1780\u17B6\u17A2\u17C6\u1794\u17B7\u179B"},{"id":7883,"word":"\u1795\u17D2\u1782\u1784"},{"id":7884,"word":"\u1795\u17D2\u1782\u1784\u17CB"},{"id":7885,"word":"\u1795\u17D2\u1782\u178F\u17CB"},{"id":7886,"word":"\u1795\u17D2\u1782\u179A"},{"id":7887,"word":"\u1795\u17D2\u1782\u17B6\u1780\u17CB"},{"id":7888,"word":"\u1795\u17D2\u1782\u17B6\u1794\u17CB"},{"id":7889,"word":"\u1795\u17D2\u1782\u17BB\u1793"},{"id":7890,"word":"\u1795\u17D2\u1782\u17BC"},{"id":7891,"word":"\u1795\u17D2\u1782\u17BC\u1795\u17D2\u1782\u1784"},{"id":7892,"word":"\u1795\u17D2\u1782\u17BD\u1794"},{"id":7893,"word":"\u1795\u17D2\u1782\u17BE\u1793"},{"id":7894,"word":"\u1795\u17D2\u1782\u17BB\u17C6"},{"id":7895,"word":"\u1795\u17D2\u1782\u17B6\u17C6"},{"id":7896,"word":"\u1795\u17D2\u1784\u1780\u17CB\u17D7"},{"id":7897,"word":"\u1795\u17D2\u1784\u17B6\u1780"},{"id":7898,"word":"\u1795\u17D2\u1784\u17B6\u1780\u17CB\u1795\u17D2\u1784\u17BE\u1780"},{"id":7899,"word":"\u1795\u17D2\u1784\u17B6\u179A"},{"id":7900,"word":"\u1795\u17D2\u1784\u17B6\u179C"},{"id":7901,"word":"\u1795\u17D2\u1784\u17BB\u1794"},{"id":7902,"word":"\u1795\u17D2\u1784\u17BC\u178F"},{"id":7903,"word":"\u1795\u17D2\u1784\u17BE\u1799"},{"id":7904,"word":"\u1795\u17D2\u1784\u17C6"},{"id":7905,"word":"\u1795\u17D2\u1785\u1784\u17CB"},{"id":7906,"word":"\u1795\u17D2\u1785\u1794\u17CB\u17D7"},{"id":7907,"word":"\u1795\u17D2\u1785\u17B6\u1785\u17CB"},{"id":7908,"word":"\u1795\u17D2\u1785\u17B6\u1789\u17CB"},{"id":7909,"word":"\u1795\u17D2\u1785\u17B6\u1794\u17CB\u17D7"},{"id":7910,"word":"\u1795\u17D2\u1785\u17B6\u179B"},{"id":7911,"word":"\u1795\u17D2\u1785\u17B7\u178F"},{"id":7912,"word":"\u1795\u17D2\u1785\u17B7\u178F\u1795\u17D2\u1785\u1784\u17CB"},{"id":7913,"word":"\u1795\u17D2\u1785\u17B9\u1780"},{"id":7914,"word":"\u1795\u17D2\u1785\u17BB\u1780"},{"id":7915,"word":"\u1795\u17D2\u1785\u17BB\u1784\u1795\u17D2\u178A\u17BE\u1798"},{"id":7916,"word":"\u1795\u17D2\u1785\u17BB\u1785"},{"id":7917,"word":"\u1795\u17D2\u1785\u17C4\u178F"},{"id":7918,"word":"\u1795\u17D2\u1789\u17B6\u1785\u17CB\u17D7"},{"id":7919,"word":"\u1795\u17D2\u1789\u17B6\u1789\u17D7"},{"id":7920,"word":"\u1795\u17D2\u1789\u17BB\u1780"},{"id":7921,"word":"\u1795\u17D2\u1789\u17BB\u1785"},{"id":7922,"word":"\u1795\u17D2\u1789\u17BE"},{"id":7923,"word":"\u1795\u17D2\u1789\u17C0\u179C"},{"id":7924,"word":"\u1795\u17D2\u1789\u17C4\u1789\u17D7"},{"id":7925,"word":"\u1795\u17D2\u178A\u1793\u17D2\u1791\u17B6"},{"id":7926,"word":"\u1795\u17D2\u178A\u179B\u17CB"},{"id":7927,"word":"\u1795\u17D2\u178A\u17B6\u1780\u17CB\u1795\u17D2\u178A\u17BA\u178F"},{"id":7928,"word":"\u1795\u17D2\u178A\u17B6\u1785\u17CB"},{"id":7929,"word":"\u1795\u17D2\u178A\u17B6\u179F"},{"id":7930,"word":"\u1795\u17D2\u178A\u17B6\u179F\u17B6"},{"id":7931,"word":"\u1795\u17D2\u178A\u17B6\u179F\u17B6\u1799"},{"id":7932,"word":"\u1795\u17D2\u178A\u17B7\u178F"},{"id":7933,"word":"\u1795\u17D2\u178A\u17B7\u179B"},{"id":7934,"word":"\u1795\u17D2\u178A\u17BA\u178F\u17D7"},{"id":7935,"word":"\u1795\u17D2\u178A\u17BA\u178F\u1795\u17D2\u178A\u1780\u17CB"},{"id":7936,"word":"\u1795\u17D2\u178A\u17BB\u179F"},{"id":7937,"word":"\u1795\u17D2\u178A\u17BC\u178F"},{"id":7938,"word":"\u1795\u17D2\u178A\u17BD\u1785"},{"id":7939,"word":"\u1795\u17D2\u178A\u17BD\u179B"},{"id":7940,"word":"\u1795\u17D2\u178A\u17BE\u1798"},{"id":7941,"word":"\u1795\u17D2\u178A\u17C0\u1780"},{"id":7942,"word":"\u1795\u17D2\u178A\u17C0\u1784"},{"id":7943,"word":"\u1795\u17D2\u178A\u17C0\u1784\u1795\u17D2\u178A\u1784"},{"id":7944,"word":"\u1795\u17D2\u178A\u17C0\u1785"},{"id":7945,"word":"\u1795\u17D2\u178A\u17C1\u1780"},{"id":7946,"word":"\u1795\u17D2\u178A\u17C1\u1785"},{"id":7947,"word":"\u1795\u17D2\u178A\u17C1\u179F\u1795\u17D2\u178A\u17B6\u179F"},{"id":7948,"word":"\u1795\u17D2\u178A\u17C2"},{"id":7949,"word":"\u1795\u17D2\u178A\u17C2\u1780"},{"id":7950,"word":"\u1795\u17D2\u178A\u17C2\u1780\u179C\u17C1\u179A"},{"id":7951,"word":"\u1795\u17D2\u178A\u17C2\u179A"},{"id":7952,"word":"\u1795\u17D2\u178A\u17C4\u178F"},{"id":7953,"word":"\u1795\u17D2\u178A\u17C4\u1798\u17D7"},{"id":7954,"word":"\u1795\u17D2\u178A\u17C4\u17C7\u1795\u17D2\u178A\u1784"},{"id":7955,"word":"\u1795\u17D2\u178A\u17C5"},{"id":7956,"word":"\u1795\u17D2\u178A\u17BB\u17C6"},{"id":7957,"word":"\u1795\u17D2\u178A\u17B6\u17C6"},{"id":7958,"word":"\u1795\u17D2\u178F\u1780\u17CB"},{"id":7959,"word":"\u1795\u17D2\u178F\u17B7\u178F\u1795\u17D2\u178F\u17BC\u1784"},{"id":7960,"word":"\u1795\u17D2\u178F\u17B7\u179B"},{"id":7961,"word":"\u1795\u17D2\u178F\u17B9\u1780\u17D7"},{"id":7962,"word":"\u1795\u17D2\u178F\u17BE\u1780\u17D7"},{"id":7963,"word":"\u1795\u17D2\u178F\u17C1\u178F\u17D7"},{"id":7964,"word":"\u1795\u17D2\u1791\u1780\u17CB"},{"id":7965,"word":"\u1795\u17D2\u1791\u1789\u17CB"},{"id":7966,"word":"\u1795\u17D2\u1791\u1794\u17CB"},{"id":7967,"word":"\u1795\u17D2\u1791\u179B\u17CB"},{"id":7968,"word":"\u1795\u17D2\u1791\u17B6"},{"id":7969,"word":"\u1795\u17D2\u1791\u17B6\u178F\u17CB"},{"id":7970,"word":"\u1795\u17D2\u1791\u17B6\u1793\u17CB"},{"id":7971,"word":"\u1795\u17D2\u1791\u17B6\u1794\u17CB"},{"id":7972,"word":"\u1795\u17D2\u1791\u17B6\u179A"},{"id":7973,"word":"\u1795\u17D2\u1791\u17B6\u179B"},{"id":7974,"word":"\u1795\u17D2\u1791\u17B6\u179B\u17CB"},{"id":7975,"word":"\u1795\u17D2\u1791\u17B8"},{"id":7976,"word":"\u1795\u17D2\u1791\u17B8\u1784"},{"id":7977,"word":"\u1795\u17D2\u1791\u17B9\u1798"},{"id":7978,"word":"\u1795\u17D2\u1791\u17BA"},{"id":7979,"word":"\u1795\u17D2\u1791\u17BB\u1780"},{"id":7980,"word":"\u1795\u17D2\u1791\u17BB\u1799"},{"id":7981,"word":"\u1795\u17D2\u1791\u17BB\u179A"},{"id":7982,"word":"\u1795\u17D2\u1791\u17BC\u179A"},{"id":7983,"word":"\u1795\u17D2\u1791\u17BD\u1793"},{"id":7984,"word":"\u1795\u17D2\u1791\u17C0\u1784"},{"id":7985,"word":"\u1795\u17D2\u1791\u17C1\u179A"},{"id":7986,"word":"\u1795\u17D2\u1791\u17C3"},{"id":7987,"word":"\u1795\u17D2\u1791\u17C4\u1784"},{"id":7988,"word":"\u1795\u17D2\u1791\u17C4\u179B"},{"id":7989,"word":"\u1795\u17D2\u1791\u17C6"},{"id":7990,"word":"\u1795\u17D2\u1791\u17B6\u17C6\u1784"},{"id":7991,"word":"\u1795\u17D2\u1791\u17C7"},{"id":7992,"word":"\u1795\u17D2\u1793\u1780\u17CB\u1791\u17B9\u1780"},{"id":7993,"word":"\u1795\u17D2\u1793\u1784\u17CB"},{"id":7994,"word":"\u1795\u17D2\u1793\u1784\u17CB\u1791\u17B9\u1780"},{"id":7995,"word":"\u1795\u17D2\u1793\u178F\u17CB"},{"id":7996,"word":"\u1795\u17D2\u1793\u17B6\u179B\u17D7"},{"id":7997,"word":"\u1795\u17D2\u1793\u17BC\u1780\u1781\u17D2\u179F\u17B6\u1785\u17CB"},{"id":7998,"word":"\u1795\u17D2\u1793\u17BC\u178F"},{"id":7999,"word":"\u1795\u17D2\u1793\u17BC\u179A"},{"id":8000,"word":"\u1795\u17D2\u1793\u17BC\u179A\u1781\u17D2\u179F\u17B6\u1785\u17CB"},{"id":8001,"word":"\u1795\u17D2\u1793\u17BC\u179B"},{"id":8002,"word":"\u1795\u17D2\u1793\u17BD\u1784"},{"id":8003,"word":"\u1795\u17D2\u1793\u17BD\u178F\u1780"},{"id":8004,"word":"\u1795\u17D2\u1793\u17BD\u179F"},{"id":8005,"word":"\u1795\u17D2\u1793\u17C0\u1784"},{"id":8006,"word":"\u1795\u17D2\u1793\u17C0\u179A"},{"id":8007,"word":"\u1795\u17D2\u1793\u17C2\u1780"},{"id":8008,"word":"\u1795\u17D2\u1793\u17C2\u179B\u17D7"},{"id":8009,"word":"\u1795\u17D2\u1793\u17C4\u179B\u17D7"},{"id":8010,"word":"\u1795\u17D2\u1793\u17C4\u17C7"},{"id":8011,"word":"\u1795\u17D2\u1793\u17C4\u17C7\u1780\u17D2\u179A\u17B6\u1793"},{"id":8012,"word":"\u1795\u17D2\u179B\u1794\u17CB"},{"id":8013,"word":"\u1795\u17D2\u179B\u17B6\u1784"},{"id":8014,"word":"\u1795\u17D2\u179B\u17B6\u1789"},{"id":8015,"word":"\u1795\u17D2\u179B\u17B6\u1789\u17D7"},{"id":8016,"word":"\u1795\u17D2\u179B\u17B6\u1793"},{"id":8017,"word":"\u1795\u17D2\u179B\u17B6\u1794\u17CB"},{"id":8018,"word":"\u1795\u17D2\u179B\u17B6\u179F\u17CB"},{"id":8019,"word":"\u1795\u17D2\u179B\u17B7\u178F"},{"id":8020,"word":"\u1795\u17D2\u179B\u17BC\u1785"},{"id":8021,"word":"\u1795\u17D2\u179B\u17BC\u1793"},{"id":8022,"word":"\u1795\u17D2\u179B\u17BC\u179C"},{"id":8023,"word":"\u1795\u17D2\u179B\u17BD\u1780"},{"id":8024,"word":"\u1795\u17D2\u179B\u17BD\u178F"},{"id":8025,"word":"\u1795\u17D2\u179B\u17BE\u179F"},{"id":8026,"word":"\u1795\u17D2\u179B\u17C0\u1780"},{"id":8027,"word":"\u1795\u17D2\u179B\u17C1\u1780"},{"id":8028,"word":"\u1795\u17D2\u179B\u17C1\u1780\u1794\u1793\u17D2\u1791\u17C4\u179A"},{"id":8029,"word":"\u1795\u17D2\u179B\u17C1\u1780\u1795\u17D2\u179B\u17C4\u17C7"},{"id":8030,"word":"\u1795\u17D2\u179B\u17C2"},{"id":8031,"word":"\u1795\u17D2\u179B\u17C2\u1784"},{"id":8032,"word":"\u1795\u17D2\u179B\u17C2\u17A2\u17B6\u1799"},{"id":8033,"word":"\u1795\u17D2\u179B\u17C4\u1784"},{"id":8034,"word":"\u1795\u17D2\u179B\u17C4\u178F"},{"id":8035,"word":"\u1795\u17D2\u179B\u17C4\u17C7"},{"id":8036,"word":"\u1795\u17D2\u179B\u17BB\u17C6"},{"id":8037,"word":"\u1795\u17D2\u179F\u1784"},{"id":8038,"word":"\u1795\u17D2\u179F\u1784\u1795\u17D2\u179F\u17BC\u179A"},{"id":8039,"word":"\u1795\u17D2\u179F\u1796\u17D2\u179C"},{"id":8040,"word":"\u1795\u17D2\u179F\u1796\u17D2\u179C\u1795\u17D2\u179F\u17B6\u1799"},{"id":8041,"word":"\u1795\u17D2\u179F\u17B6"},{"id":8042,"word":"\u1795\u17D2\u179F\u17B6\u1799"},{"id":8043,"word":"\u1795\u17D2\u179F\u17B6\u179A"},{"id":8044,"word":"\u1795\u17D2\u179F\u17B7\u1784"},{"id":8045,"word":"\u1795\u17D2\u179F\u17B7\u178F"},{"id":8046,"word":"\u1795\u17D2\u179F\u17B9\u1780"},{"id":8047,"word":"\u1795\u17D2\u179F\u17BC\u179A\u1795\u17D2\u179F\u1784"},{"id":8048,"word":"\u1795\u17D2\u179F\u17BE\u1798"},{"id":8049,"word":"\u1795\u17D2\u179F\u17C1\u1784"},{"id":8050,"word":"\u1795\u17D2\u179F\u17C2"},{"id":8051,"word":"\u1795\u17D2\u179F\u17C2\u1784"},{"id":8052,"word":"\u1795\u17D2\u179F\u17C2\u178F"},{"id":8053,"word":"\u1795\u17D2\u179F\u17C3"},{"id":8054,"word":"\u1795\u17D2\u179F\u17C4"},{"id":8055,"word":"\u1795\u17D2\u179F\u17C4\u178F"},{"id":8056,"word":"\u1795\u17D2\u179F\u17C4\u17C7"},{"id":8057,"word":"\u1795\u17D2\u179F\u17C6"},{"id":8058,"word":"\u1795\u17D2\u179F\u17B6\u17C6"},{"id":8059,"word":"\u1795\u17D2\u179F\u17CA\u200D\u17B6\u17C6"},{"id":8060,"word":"\u1795\u17D2\u179F\u17B6\u17C6\u1784"},{"id":8061,"word":"\u1795\u17D2\u179F\u17C7"},{"id":8062,"word":"\u1795\u17D2\u179F\u17C7\u1795\u17D2\u179F\u17B6"},{"id":8063,"word":"\u1795\u17D2\u17A2\u1780"},{"id":8064,"word":"\u1795\u17D2\u17A2\u1784"},{"id":8065,"word":"\u1795\u17D2\u17A2\u1794"},{"id":8066,"word":"\u1795\u17D2\u17A2\u179A"},{"id":8067,"word":"\u1795\u17D2\u17A2\u17B6\u1780"},{"id":8068,"word":"\u1795\u17D2\u17A2\u17B6\u1780\u17CB\u1795\u17D2\u17A2\u17BE\u1780"},{"id":8069,"word":"\u1795\u17D2\u17A2\u17B6\u1794\u17CB"},{"id":8070,"word":"\u1795\u17D2\u17A2\u17B6\u179C"},{"id":8071,"word":"\u1795\u17D2\u17A2\u17B9\u1780\u17D7"},{"id":8072,"word":"\u1795\u17D2\u17A2\u17B9\u1794"},{"id":8073,"word":"\u1795\u17D2\u17A2\u17B9\u17C7"},{"id":8074,"word":"\u1795\u17D2\u17A2\u17BA\u1794\u17D7"},{"id":8075,"word":"\u1795\u17D2\u17A2\u17BB\u1780\u17D7"},{"id":8076,"word":"\u1795\u17D2\u17A2\u17BB\u1784"},{"id":8077,"word":"\u1795\u17D2\u17A2\u17BC\u1780"},{"id":8078,"word":"\u1795\u17D2\u17A2\u17BC\u1785\u17D7"},{"id":8079,"word":"\u1795\u17D2\u17A2\u17BC\u1798"},{"id":8080,"word":"\u1795\u17D2\u17A2\u17BD\u179A"},{"id":8081,"word":"\u1795\u17D2\u17A2\u17BD\u179F\u17D7"},{"id":8082,"word":"\u1795\u17D2\u17A2\u17BE\u179B"},{"id":8083,"word":"\u1795\u17D2\u17A2\u17BE\u17C7"},{"id":8084,"word":"\u1795\u17D2\u17A2\u17C0\u1784"},{"id":8085,"word":"\u1795\u17D2\u17A2\u17C1\u17C7\u17D7"},{"id":8086,"word":"\u1795\u17D2\u17A2\u17C2\u1780"},{"id":8087,"word":"\u1795\u17D2\u17A2\u17C2\u1794\u17D7"},{"id":8088,"word":"\u1795\u17D2\u17A2\u17C2\u1798"},{"id":8089,"word":"\u1795\u17D2\u17A2\u17C4\u1784"},{"id":8090,"word":"\u1795\u17D2\u17A2\u17C4\u1794"},{"id":8091,"word":"\u1795\u17D2\u17A2\u17C4\u17C7"},{"id":8092,"word":"\u1796"},{"id":8093,"word":"\u1796\u1780"},{"id":8094,"word":"\u1796\u1784"},{"id":8095,"word":"\u178A\u17C6\u17A1\u17BE\u1784"},{"id":8096,"word":"\u1796\u1784\u1780\u17D2\u179A\u1796\u17BE"},{"id":8097,"word":"\u1796\u1784\u1780\u17D2\u17A2\u17BB\u1780"},{"id":8098,"word":"\u1796\u1784\u1785\u17B6\u1794"},{"id":8099,"word":"\u1796\u1784\u178F\u17D2\u179A\u1784"},{"id":8100,"word":"\u1796\u1784\u178F\u17D2\u179A\u17B8"},{"id":8101,"word":"\u1796\u1784\u1791\u17B9\u1780"},{"id":8102,"word":"\u1796\u1784\u1794\u1784\u17D2\u1780\u17BD\u1799"},{"id":8103,"word":"\u1796\u1784\u1794\u17C2\u1780"},{"id":8104,"word":"\u1796\u1784\u1798\u17B6\u1793\u17CB"},{"id":8105,"word":"\u1796\u1784\u179B\u179B\u1780"},{"id":8106,"word":"\u1796\u1784\u179B\u17D2\u179C\u17B6"},{"id":8107,"word":"\u1796\u1784\u179F\u17D2\u179C\u17B6\u179F"},{"id":8108,"word":"\u1796\u1784\u17D2\u179A"},{"id":8109,"word":"\u1796\u1784\u17D2\u179A\u178F\u17CB"},{"id":8110,"word":"\u1796\u1784\u17D2\u179A\u1793"},{"id":8111,"word":"\u1796\u1784\u17D2\u179A\u179B"},{"id":8112,"word":"\u1796\u1784\u17D2\u179A\u17B6"},{"id":8113,"word":"\u1796\u1784\u17D2\u179A\u17B6\u1780"},{"id":8114,"word":"\u1796\u1784\u17D2\u179A\u17B6\u1780\u17CB"},{"id":8115,"word":"\u1796\u1784\u17D2\u179A\u17B6\u1784"},{"id":8116,"word":"\u1796\u1784\u17D2\u179A\u17B6\u178F\u17CB"},{"id":8117,"word":"\u1796\u1784\u17D2\u179A\u17B6\u1794"},{"id":8118,"word":"\u1796\u1784\u17D2\u179A\u17B6\u1799"},{"id":8119,"word":"\u1796\u1784\u17D2\u179A\u17B6\u179B"},{"id":8120,"word":"\u1796\u1784\u17D2\u179A\u17B8\u1780"},{"id":8121,"word":"\u1796\u1784\u17D2\u179A\u17B8\u1784"},{"id":8122,"word":"\u1796\u1784\u17D2\u179A\u17B9\u1784"},{"id":8123,"word":"\u1796\u1784\u17D2\u179A\u17B9\u178F"},{"id":8124,"word":"\u1796\u1784\u17D2\u179A\u17B9\u179B"},{"id":8125,"word":"\u1796\u1784\u17D2\u179A\u17BB\u179B"},{"id":8126,"word":"\u1796\u1784\u17D2\u179A\u17BC\u1784"},{"id":8127,"word":"\u1796\u1784\u17D2\u179A\u17BC\u179B"},{"id":8128,"word":"\u1796\u1784\u17D2\u179A\u17BD\u1794"},{"id":8129,"word":"\u1796\u1784\u17D2\u179A\u17BD\u1798"},{"id":8130,"word":"\u1796\u1784\u17D2\u179A\u17C1"},{"id":8131,"word":"\u1796\u1784\u17D2\u179A\u17C1\u1785"},{"id":8132,"word":"\u1796\u1784\u17D2\u179A\u17C4\u17C7"},{"id":8133,"word":"\u1796\u1784\u17D2\u179C\u1780\u17CB"},{"id":8134,"word":"\u1796\u1784\u17D2\u179C\u17B6\u1784"},{"id":8135,"word":"\u1796\u1784\u17D2\u179C\u17B6\u178F"},{"id":8136,"word":"\u1796\u1784\u17D2\u179C\u17B7\u179B"},{"id":8137,"word":"\u1796\u1784\u17D2\u179C\u17B8\u1796\u1784\u17D2\u179C\u1780\u17CB"},{"id":8138,"word":"\u1796\u1784\u17D2\u179C\u17B9\u1780"},{"id":8139,"word":"\u1796\u1784\u17D2\u179C\u17C0\u1793"},{"id":8140,"word":"\u1796\u1784\u17D2\u179C\u17C0\u17C7"},{"id":8141,"word":"\u1796\u1784\u17D2\u179C\u17C1\u17C7"},{"id":8142,"word":"\u1796\u1784\u17D2\u179F"},{"id":8143,"word":"\u1796\u1784\u17D2\u179F\u17B6\u179C\u178F\u17B6\u179A"},{"id":8144,"word":"\u1796\u1784\u17D2\u179F\u17B6\u179C\u179B\u17B8"},{"id":8145,"word":"\u1796\u17D0\u1785\u1793\u17CD"},{"id":8146,"word":"\u1796\u1789\u17B6"},{"id":8147,"word":"\u1796\u1789\u17B6\u1780\u17D2\u179A\u17C2\u1780"},{"id":8148,"word":"\u1796\u1789\u17B6\u179A\u1780\u17D2\u179F\u17B6\u1797\u17B7\u1794\u17B6\u179B"},{"id":8149,"word":"\u1796\u1789\u17B6\u17AE"},{"id":8150,"word":"\u1796\u1789\u17D2\u1789\u17B6\u1780\u17CB"},{"id":8151,"word":"\u1796\u178E\u17D2\u178E\u179A\u17B6\u1799"},{"id":8152,"word":"\u1796\u178E\u17CC"},{"id":8153,"word":"\u1796\u178E\u17CC\u1793\u17B6"},{"id":8154,"word":"\u1796\u178F\u17CB"},{"id":8155,"word":"\u1796\u17D0\u178F"},{"id":8156,"word":"\u1796\u17D0\u178F\u17CC\u1798\u17B6\u1793"},{"id":8157,"word":"\u1796\u17D0\u1791\u17D2\u1792"},{"id":8158,"word":"\u1796\u17D0\u1791\u17D2\u1792\u1792\u17D2\u179B\u17BB\u1784"},{"id":8159,"word":"\u1796\u1791\u17D2\u1792\u179F\u17B8\u1798\u17B6"},{"id":8160,"word":"\u1796\u1793"},{"id":8161,"word":"\u1796\u1793\u17CB"},{"id":8162,"word":"\u1796\u1793\u17B6\u179B\u17D0\u1799"},{"id":8163,"word":"\u1796\u1793\u17B6\u179F\u17D0\u1799"},{"id":8164,"word":"\u1796\u1793\u17B6\u179F\u17D2\u179A\u1798"},{"id":8165,"word":"\u1796\u1793\u17B6\u179F\u17D2\u179A\u17D0\u1799"},{"id":8166,"word":"\u1796\u1793\u17B7\u178F\u17B6"},{"id":8167,"word":"\u1796\u1793\u17C1\u1785\u179A"},{"id":8168,"word":"\u1796\u1793\u17D2\u1791"},{"id":8169,"word":"\u1796\u1793\u17D2\u1792"},{"id":8170,"word":"\u1796\u17D0\u1793\u17D2\u1792"},{"id":8171,"word":"\u1796\u17D0\u1793\u17D2\u1792\u178A\u17B6\u1798"},{"id":8172,"word":"\u1796\u17D0\u1793\u17D2\u1792\u1792\u17D2\u179B\u17BB\u1784"},{"id":8173,"word":"\u1796\u1793\u17D2\u1792\u1793\u17B6\u1780\u17B6\u179A"},{"id":8174,"word":"\u1796\u1793\u17D2\u1792\u1793\u17B6\u1782\u17B6\u179A"},{"id":8175,"word":"\u1796\u17D0\u1793\u17D2\u1792\u1798\u17BC\u179B"},{"id":8176,"word":"\u1796\u17D0\u1793\u17D2\u1792\u179B\u17B9\u1784"},{"id":8177,"word":"\u1796\u17D0\u1793\u17D2\u1792\u179F\u17D2\u1793\u17B9\u1784"},{"id":8178,"word":"\u1796\u1793\u17D2\u1799\u179B\u17CB"},{"id":8179,"word":"\u1796\u1793\u17D2\u1799\u17B6\u179A"},{"id":8180,"word":"\u1796\u1793\u17D2\u1799\u17B8"},{"id":8181,"word":"\u1796\u1793\u17D2\u1799\u17BA\u178F"},{"id":8182,"word":"\u1796\u1793\u17D2\u1799\u17BA\u1793"},{"id":8183,"word":"\u1796\u1793\u17D2\u1799\u17BB\u1799"},{"id":8184,"word":"\u1796\u1793\u17D2\u1799\u17BB\u179B"},{"id":8185,"word":"\u1796\u1793\u17D2\u1799\u17BB\u17C7"},{"id":8186,"word":"\u1796\u1793\u17D2\u1799\u17BC\u1799"},{"id":8187,"word":"\u1796\u1793\u17D2\u1799\u17BE"},{"id":8188,"word":"\u1796\u1793\u17D2\u1799\u17C4\u179B"},{"id":8189,"word":"\u1796\u1793\u17D2\u1799\u17C7"},{"id":8190,"word":"\u1796\u1793\u17D2\u179A\u17B6\u1799"},{"id":8191,"word":"\u1796\u1793\u17D2\u179B\u1780"},{"id":8192,"word":"\u1796\u1793\u17D2\u179B\u1784\u17CB"},{"id":8193,"word":"\u1796\u1793\u17D2\u179B\u178F\u17CB"},{"id":8194,"word":"\u1796\u1793\u17D2\u179B\u17B6"},{"id":8195,"word":"\u1796\u1793\u17D2\u179B\u17B6\u1780"},{"id":8196,"word":"\u1796\u1793\u17D2\u179B\u17B6\u1789"},{"id":8197,"word":"\u1796\u1793\u17D2\u179B\u17B6\u178F\u17CB"},{"id":8198,"word":"\u1796\u1793\u17D2\u179B\u17B7\u1785"},{"id":8199,"word":"\u1796\u1793\u17D2\u179B\u17B9\u1780"},{"id":8200,"word":"\u1796\u1793\u17D2\u179B\u17B9\u1794"},{"id":8201,"word":"\u1796\u1793\u17D2\u179B\u17BA"},{"id":8202,"word":"\u1796\u1793\u17D2\u179B\u17BB\u1784"},{"id":8203,"word":"\u1796\u1793\u17D2\u179B\u17BB\u178F"},{"id":8204,"word":"\u1796\u1793\u17D2\u179B\u17BB\u1793"},{"id":8205,"word":"\u1796\u1793\u17D2\u179B\u17BC\u1780"},{"id":8206,"word":"\u1796\u1793\u17D2\u179B\u17BC\u1785"},{"id":8207,"word":"\u1796\u1793\u17D2\u179B\u17BC\u178F"},{"id":8208,"word":"\u1796\u1793\u17D2\u179B\u17BC\u1793"},{"id":8209,"word":"\u1796\u1793\u17D2\u179B\u17BD\u1789"},{"id":8210,"word":"\u1796\u1793\u17D2\u179B\u17BE\u179F"},{"id":8211,"word":"\u1796\u1793\u17D2\u179B\u17C0\u1780"},{"id":8212,"word":"\u1796\u1793\u17D2\u179B\u17C0\u1793"},{"id":8213,"word":"\u1796\u1793\u17D2\u179B\u17C2\u1784"},{"id":8214,"word":"\u1796\u1793\u17D2\u179B\u17C3"},{"id":8215,"word":"\u1796\u1793\u17D2\u179B\u17C4\u178F"},{"id":8216,"word":"\u1796\u1793\u17D2\u179B\u17C7"},{"id":8217,"word":"\u1796\u1796\u1780"},{"id":8218,"word":"\u1796\u1796\u17B6\u1780\u17CB"},{"id":8219,"word":"\u1796\u1796\u17B6\u1785"},{"id":8220,"word":"\u1796\u1796\u17B6\u1793"},{"id":8221,"word":"\u1796\u1796\u17B6\u1799\u1793\u17B6\u1799"},{"id":8222,"word":"\u1796\u1796\u17B6\u179A"},{"id":8223,"word":"\u1796\u1796\u17B6\u179A\u1793\u17B6\u1782\u179A\u17B6\u1787"},{"id":8224,"word":"\u1796\u1796\u17B6\u179B"},{"id":8225,"word":"\u1796\u1796\u17B6\u179B\u1781\u17C2"},{"id":8226,"word":"\u1796\u1796\u17B7\u1785"},{"id":8227,"word":"\u1796\u1796\u17B7\u179B"},{"id":8228,"word":"\u1796\u1796\u17B8\u1798"},{"id":8229,"word":"\u1796\u1796\u17B8\u179A"},{"id":8230,"word":"\u1796\u1796\u17B9\u1780"},{"id":8231,"word":"\u1796\u1796\u17B9\u1780\u1786\u17D2\u1780\u17C2"},{"id":8232,"word":"\u1796\u1796\u17BB\u179A"},{"id":8233,"word":"\u1796\u1796\u17BB\u17C7"},{"id":8234,"word":"\u1796\u1796\u17BB\u17C7\u1791\u17B9\u1780"},{"id":8235,"word":"\u1796\u1796\u17BB\u17C7\u179F\u178E\u17D2\u178A\u17C2\u1780"},{"id":8236,"word":"\u1796\u1796\u17BC"},{"id":8237,"word":"\u1796\u1796\u17BC\u1780"},{"id":8238,"word":"\u1796\u1796\u17BC\u1793"},{"id":8239,"word":"\u1796\u1796\u17BC\u179B"},{"id":8240,"word":"\u1796\u1796\u17BC\u179B\u1790\u17D2\u1798"},{"id":8241,"word":"\u1796\u1796\u17BC\u179B\u1791\u17B9\u1780"},{"id":8242,"word":"\u1796\u1796\u17BD\u1780"},{"id":8243,"word":"\u1796\u1796\u17BE\u1798"},{"id":8244,"word":"\u1796\u1796\u17C1\u1785"},{"id":8245,"word":"\u1796\u1796\u17C1\u1785\u1785\u1784\u17D2\u179C\u17B6"},{"id":8246,"word":"\u1796\u1796\u17C1\u1793"},{"id":8247,"word":"\u1796\u1796\u17C1\u179B"},{"id":8248,"word":"\u1796\u1796\u17C2"},{"id":8249,"word":"\u1796\u1796\u17C2\u1797\u17D2\u1793\u17C2\u1780"},{"id":8250,"word":"\u1796\u1796\u17C4\u1780"},{"id":8251,"word":"\u1796\u1796\u17D2\u179A\u178F"},{"id":8252,"word":"\u1796\u1796\u17D2\u179A\u179B"},{"id":8253,"word":"\u1796\u1796\u17D2\u179A\u17B6\u1780\u17CB"},{"id":8254,"word":"\u1796\u1796\u17D2\u179A\u17B6\u178F"},{"id":8255,"word":"\u1796\u1796\u17D2\u179A\u17B6\u1799"},{"id":8256,"word":"\u1796\u1796\u17D2\u179A\u17B7\u1785"},{"id":8257,"word":"\u1796\u1796\u17D2\u179A\u17B9\u1798"},{"id":8258,"word":"\u1796\u1796\u17D2\u179A\u17B9\u179B"},{"id":8259,"word":"\u1796\u1796\u17D2\u179A\u17BA\u179F"},{"id":8260,"word":"\u1796\u1796\u17D2\u179A\u17BB\u179F"},{"id":8261,"word":"\u1796\u1796\u17D2\u179A\u17BC\u179F"},{"id":8262,"word":"\u1796\u1796\u17D2\u179A\u17BD\u1780"},{"id":8263,"word":"\u1796\u1796\u17D2\u179A\u17BD\u1785"},{"id":8264,"word":"\u1796\u1796\u17D2\u179A\u17BE\u178F"},{"id":8265,"word":"\u1796\u1796\u17D2\u179A\u17BE\u1798"},{"id":8266,"word":"\u1796\u1796\u17D2\u179A\u17BE\u179F"},{"id":8267,"word":"\u1796\u1796\u17D2\u179A\u17C0\u1780"},{"id":8268,"word":"\u1796\u1796\u17D2\u179A\u17C0\u1794"},{"id":8269,"word":"\u1796\u1796\u17D2\u179A\u17B6\u17C6\u1784\u1796\u1796\u17D2\u179A\u17BE\u178F"},{"id":8270,"word":"\u1796\u1796\u17D2\u179B\u17B6\u1780\u17CB"},{"id":8271,"word":"\u1796\u1796\u17D2\u179B\u17B7\u1780\u1796\u1796\u17D2\u179B\u17B6\u1780\u17CB"},{"id":8272,"word":"\u1796\u1796\u17D2\u179B\u17C2\u1798"},{"id":8273,"word":"\u1796\u1797\u1780\u17CB"},{"id":8274,"word":"\u1796\u1797\u179B"},{"id":8275,"word":"\u1796\u1797\u17B8\u1784"},{"id":8276,"word":"\u1796\u1797\u17B9\u1794"},{"id":8277,"word":"\u1796\u1797\u17B9\u179B"},{"id":8278,"word":"\u1796\u1797\u17BA\u178F"},{"id":8279,"word":"\u1796\u1797\u17BA\u179F"},{"id":8280,"word":"\u1796\u1797\u17BB\u1784"},{"id":8281,"word":"\u1796\u1797\u17BC\u179F"},{"id":8282,"word":"\u1796\u1797\u17D2\u179B\u1780\u17CB"},{"id":8283,"word":"\u1796\u1797\u17D2\u179B\u1793"},{"id":8284,"word":"\u1796\u1797\u17D2\u179B\u17B6"},{"id":8285,"word":"\u1796\u1797\u17D2\u179B\u17B6\u1780\u17CB\u1796\u1797\u17D2\u179B\u17BE"},{"id":8286,"word":"\u1796\u1797\u17D2\u179B\u17B6\u1780\u17CB\u1796\u1797\u17D2\u179B\u17BE\u1780"},{"id":8287,"word":"\u1796\u1797\u17D2\u179B\u17B6\u1798"},{"id":8288,"word":"\u1796\u1797\u17D2\u179B\u17B8\u1796\u1797\u17D2\u179B\u17BE"},{"id":8289,"word":"\u1796\u1797\u17D2\u179B\u17B8\u1798\u1796\u1797\u17D2\u179B\u17B6\u1798"},{"id":8290,"word":"\u1796\u1797\u17D2\u179B\u17B8\u17C7\u1796\u1797\u17D2\u179B\u17C2\u17C7"},{"id":8291,"word":"\u1796\u1797\u17D2\u179B\u17B9\u1794\u1796\u1797\u17D2\u179B\u17C2\u178F"},{"id":8292,"word":"\u1796\u1797\u17D2\u179B\u17B9\u1798"},{"id":8293,"word":"\u1796\u1797\u17D2\u179B\u17B9\u1798\u1796\u1797\u17D2\u179B\u17C2\u178F"},{"id":8294,"word":"\u1796\u1797\u17D2\u179B\u17B9\u17C7"},{"id":8295,"word":"\u1796\u1797\u17D2\u179B\u17BB\u1780"},{"id":8296,"word":"\u1796\u1797\u17D2\u179B\u17BB\u1784"},{"id":8297,"word":"\u1796\u1797\u17D2\u179B\u17BD\u1780"},{"id":8298,"word":"\u1796\u1797\u17D2\u179B\u17BE"},{"id":8299,"word":"\u1796\u1797\u17D2\u179B\u17BE\u1780"},{"id":8300,"word":"\u1796\u1797\u17D2\u179B\u17C0\u1780"},{"id":8301,"word":"\u1796\u1797\u17D2\u179B\u17C2\u178F"},{"id":8302,"word":"\u1796\u1797\u17D2\u179B\u17C2\u179B"},{"id":8303,"word":"\u1796\u1797\u17D2\u179B\u17C2\u17C7"},{"id":8304,"word":"\u1796\u1798"},{"id":8305,"word":"\u1796\u1799"},{"id":8306,"word":"\u1796\u179A"},{"id":8307,"word":"\u1796\u17D0\u179A"},{"id":8308,"word":"\u1796\u179A\u17D2\u179F\u17BA\u17A1\u17C2\u1793"},{"id":8309,"word":"\u1796\u179B"},{"id":8310,"word":"\u1796\u179B\u1780\u17B6\u1799"},{"id":8311,"word":"\u1796\u179B\u1780\u17D2\u1780\u17B6\u179A"},{"id":8312,"word":"\u1796\u179B\u1791\u17C4"},{"id":8313,"word":"\u1796\u179B\u1793\u17B7\u1780\u17B6\u1799"},{"id":8314,"word":"\u1796\u179B\u1794\u17B6\u179B\u178F\u17D2\u179A\u17B8"},{"id":8315,"word":"\u1796\u179B\u1794\u17B6\u179B\u1791\u17C4"},{"id":8316,"word":"\u1796\u179B\u1794\u17B6\u179B\u17AF\u1780"},{"id":8317,"word":"\u1796\u179B\u1796\u17D2\u179A\u17C7"},{"id":8318,"word":"\u1796\u179B\u179A\u178A\u17D2\u178B"},{"id":8319,"word":"\u1796\u179B\u179F\u1780\u17D2\u178F\u17B7"},{"id":8320,"word":"\u1796\u179B\u17AF\u1780"},{"id":8321,"word":"\u1796\u179B\u17B6\u17A0\u1780"},{"id":8322,"word":"\u1796\u179B\u17B7\u1780\u1798\u17D2\u1798"},{"id":8323,"word":"\u1796\u179B\u17B7\u1780\u17B6\u179A"},{"id":8324,"word":"\u1796\u179B\u17B7\u1791\u17B6\u1793"},{"id":8325,"word":"\u1796\u179B\u17B8"},{"id":8326,"word":"\u1796\u179B\u17B8\u1780\u17B6\u179A"},{"id":8327,"word":"\u1796\u179B\u17C3"},{"id":8328,"word":"\u1796\u179B\u17C6"},{"id":8329,"word":"\u1796\u179F\u17CB"},{"id":8330,"word":"\u1796\u179F\u17BB\u1792\u17B6"},{"id":8331,"word":"\u1796\u179F\u17BB\u1793\u17D2\u1792\u179A\u17B6"},{"id":8332,"word":"\u1796\u17D0\u179F\u17D2\u178A\u17BB"},{"id":8333,"word":"\u1796\u179F\u17D2\u179A\u17D2\u178F"},{"id":8334,"word":"\u1796\u179F\u17D2\u178F\u17D2\u179A\u17B6\u1797\u179A\u178E\u17C8"},{"id":8335,"word":"\u1796\u179F\u17D2\u178F\u17D2\u179A\u17B6\u179B\u1784\u17D2\u1780\u17B6\u179A"},{"id":8336,"word":"\u1796\u17A0\u17BB\u1780\u17B6\u179A\u17B8"},{"id":8337,"word":"\u1796\u17A0\u17BB\u1780\u17B7\u1785\u17D2\u1785"},{"id":8338,"word":"\u1796\u17A0\u17BB\u1780\u17C4\u178E"},{"id":8339,"word":"\u1796\u17A0\u17BB\u1796\u17D2\u1799\u17B6\u1784\u17D2\u1782"},{"id":8340,"word":"\u1796\u17A0\u17BB\u1797\u17B6\u179F\u1780"},{"id":8341,"word":"\u1796\u17A0\u17BB\u1798\u1793\u17D2\u178F\u17B8"},{"id":8342,"word":"\u1796\u17A0\u17BB\u179C\u1785\u1793"},{"id":8343,"word":"\u1796\u17A0\u17BB\u179F\u17D2\u179F\u17BC\u178F"},{"id":8344,"word":"\u1796\u17A0\u17BC\u179F\u1780\u17D2\u178F\u17B7"},{"id":8345,"word":"\u1796\u17A0\u17BC\u179F\u17BC\u178F"},{"id":8346,"word":"\u1796\u17B6\u1780\u17CB"},{"id":8347,"word":"\u1796\u17B6\u1780\u17CB\u1780\u1784"},{"id":8348,"word":"\u1796\u17B6\u1780\u17CB\u1780\u178E\u17D2\u178A\u17B6\u179B"},{"id":8349,"word":"\u1796\u17B6\u1780\u17D2\u1799"},{"id":8350,"word":"\u1796\u17B6\u1780\u17D2\u1799\u1780\u17C6\u1796\u17D2\u179A\u17B6"},{"id":8351,"word":"\u1796\u17B6\u1784"},{"id":8352,"word":"\u1796\u17B6\u1787\u17B8"},{"id":8353,"word":"\u1796\u17B6\u1787\u1793\u17B8"},{"id":8354,"word":"\u1796\u17B6\u178C\u17B8\u179A"},{"id":8355,"word":"\u1796\u17B6\u178E\u17B7\u1787"},{"id":8356,"word":"\u1796\u17B6\u178E\u17B7\u1787\u17D2\u1787"},{"id":8357,"word":"\u1796\u17B6\u178E\u17B7\u1787\u17D2\u1787\u1780\u1798\u17D2\u1798"},{"id":8358,"word":"\u1796\u17B6\u178E\u17B7\u1787\u17D2\u1787\u1780\u17B6\u179A"},{"id":8359,"word":"\u1796\u17B6\u178E\u17B7\u1787\u17D2\u1799"},{"id":8360,"word":"\u1796\u17B6\u178E\u17CC\u1793\u17B6"},{"id":8361,"word":"\u1796\u17B6\u178F"},{"id":8362,"word":"\u1796\u17B6\u178F\u1794\u17B6"},{"id":8363,"word":"\u1796\u17B6\u1791\u17D2\u1799"},{"id":8364,"word":"\u1796\u17B6\u1791\u17D2\u1799\u1797\u178E\u17D2\u178C"},{"id":8365,"word":"\u1796\u17B6\u1791\u17D2\u1799\u1798\u17C9\u17B6\u1784"},{"id":8366,"word":"\u1796\u17B6\u1792\u1787\u1793\u17D2\u1798"},{"id":8367,"word":"\u1796\u17B6\u1792\u17B6"},{"id":8368,"word":"\u1796\u17B6\u1793"},{"id":8369,"word":"\u1796\u17B6\u1793\u17CB"},{"id":8370,"word":"\u1796\u17B6\u1793\u17CB\u178F\u17B6"},{"id":8371,"word":"\u1796\u17B6\u1793\u17CB\u1793\u17C1\u178F\u17D2\u179A"},{"id":8372,"word":"\u1796\u17B6\u1793\u1796\u17D2\u179A\u17C7\u179F\u17D2\u179A\u17B8"},{"id":8373,"word":"\u1796\u17B6\u1793\u179A"},{"id":8374,"word":"\u1796\u17B6\u1793\u179A\u17B7\u1793\u17D2\u1791"},{"id":8375,"word":"\u1796\u17B6\u1793\u179A\u17B8"},{"id":8376,"word":"\u1796\u17B6\u1793\u179A\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":8377,"word":"\u1796\u17B6\u1793\u17B6"},{"id":8378,"word":"\u1796\u17B6\u1794\u17CB"},{"id":8379,"word":"\u1796\u17B6\u1798"},{"id":8380,"word":"\u1796\u17B6\u1799"},{"id":8381,"word":"\u1796\u17B6\u1799\u1784\u17B6\u1799"},{"id":8382,"word":"\u1796\u17B6\u1799\u1796\u17D2\u1799"},{"id":8383,"word":"\u1796\u17B6\u1799\u17BB"},{"id":8384,"word":"\u1796\u17B6\u1799\u17BB\u1782\u17BB\u179B\u17D2\u1798"},{"id":8385,"word":"\u1796\u17B6\u1799\u17BB\u1794\u17BB\u178F\u17D2\u179A"},{"id":8386,"word":"\u1796\u17B6\u179A"},{"id":8387,"word":"\u1796\u17B6\u179A\u17B6\u178E\u179F\u17B8"},{"id":8388,"word":"\u1796\u17B6\u179A\u17BB\u178E\u17B8"},{"id":8389,"word":"\u1796\u17B6\u179A\u17B6\u17C6\u1784"},{"id":8390,"word":"\u1796\u17B6\u179B"},{"id":8391,"word":"\u1796\u17B6\u179B\u17CB"},{"id":8392,"word":"\u1796\u17B6\u179B\u1798\u17B6\u1793\u17B8"},{"id":8393,"word":"\u1796\u17B6\u179B\u17B8"},{"id":8394,"word":"\u1796\u17B6\u179B\u17BB\u1780\u17B6"},{"id":8395,"word":"\u1796\u17B6\u179B\u17BB\u1780\u1785\u17C1\u178F\u17B7\u1799"},{"id":8396,"word":"\u1796\u17B6\u179B\u17C4"},{"id":8397,"word":"\u1796\u17B6\u179F"},{"id":8398,"word":"\u1796\u17B6\u179F\u17BB\u1780\u17B8"},{"id":8399,"word":"\u1796\u17B6\u17A0\u1793\u17C8"},{"id":8400,"word":"\u1796\u17B6\u17A0\u1793\u1796\u17B7\u179F\u17C1\u179F"},{"id":8401,"word":"\u1796\u17B6\u17A0\u1793\u179C\u17B7\u179F\u17C1\u179F"},{"id":8402,"word":"\u1796\u17B6\u17A0\u1793\u179F\u178F\u17D2\u179C"},{"id":8403,"word":"\u1796\u17B6\u17A0\u17B6"},{"id":8404,"word":"\u1796\u17B6\u17A0\u17B7\u179A\u1780\u1790\u17B6"},{"id":8405,"word":"\u1796\u17B6\u17A0\u17BB"},{"id":8406,"word":"\u1796\u17B6\u17A0\u17BB\u1787\u17C8"},{"id":8407,"word":"\u1796\u17B6\u17A0\u17BB\u1794\u17D2\u179A\u17A0\u17B6\u179A"},{"id":8408,"word":"\u1796\u17B6\u17A0\u17BB\u1798\u17BC\u179B"},{"id":8409,"word":"\u1796\u17B6\u17A0\u17BB\u1799\u17BB\u1791\u17D2\u1792"},{"id":8410,"word":"\u1796\u17B6\u17A0\u17BB\u179A\u178F\u17D2\u1793"},{"id":8411,"word":"\u1796\u17B6\u17A0\u17BB\u179F\u1785\u17D2\u1785"},{"id":8412,"word":"\u1796\u17B6\u17A0\u17BB\u179F\u1798\u17D2\u1797\u1796"},{"id":8413,"word":"\u1796\u17B6\u17A1\u1798\u17D2\u179A\u17B9\u1782"},{"id":8414,"word":"\u1796\u17B7\u1780\u17B6\u179A"},{"id":8415,"word":"\u1796\u17B7\u1782\u17D2\u179A\u17C4\u17C7"},{"id":8416,"word":"\u1796\u17B7\u1783\u17B6\u178A"},{"id":8417,"word":"\u1796\u17B7\u1785\u17D0\u1799"},{"id":8418,"word":"\u1796\u17B7\u1785\u17B6\u179A\u178E\u17B6"},{"id":8419,"word":"\u1796\u17B7\u1785\u17B7\u178F\u17D2\u179A"},{"id":8420,"word":"\u1796\u17B7\u1787\u17D0\u1799"},{"id":8421,"word":"\u1796\u17B7\u1787\u17D0\u1799\u179F\u1784\u17D2\u1782\u17D2\u179A\u17B6\u1798"},{"id":8422,"word":"\u1796\u17B7\u1787\u17B7\u178F\u1798\u17B6\u179A"},{"id":8423,"word":"\u1796\u17B7\u1787\u17B7\u178F\u179A\u178A\u17D2\u178B"},{"id":8424,"word":"\u1796\u17B7\u1787\u17B7\u178F\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":8425,"word":"\u1796\u17B7\u1787\u17C1\u178A\u17D2\u178B"},{"id":8426,"word":"\u1796\u17B7\u178A\u17C4\u179A"},{"id":8427,"word":"\u1796\u17B7\u178E"},{"id":8428,"word":"\u1796\u17B7\u178E\u1796\u17B6\u1791\u17D2\u1799"},{"id":8429,"word":"\u1796\u17B7\u178F"},{"id":8430,"word":"\u1796\u17B7\u178F\u1796\u17B7\u179B"},{"id":8431,"word":"\u1796\u17B7\u178F\u17B6\u1793"},{"id":8432,"word":"\u1796\u17B7\u1791\u17D0\u1782\u17D2\u1792"},{"id":8433,"word":"\u1796\u17B7\u1791\u17B6\u1799"},{"id":8434,"word":"\u1796\u17B7\u1791\u17BC\u179A\u17D2\u1799"},{"id":8435,"word":"\u1796\u17B7\u1791\u17D2\u1799\u17B6\u1792\u179A"},{"id":8436,"word":"\u1796\u17B7\u1791\u17D2\u179A\u17BB\u1798"},{"id":8437,"word":"\u1796\u17B7\u1792\u17B8"},{"id":8438,"word":"\u1796\u17B7\u1792\u17BB\u179A"},{"id":8439,"word":"\u1796\u17B7\u1792\u17BB\u179A\u1797\u17B6\u1796"},{"id":8440,"word":"\u1796\u17B7\u1792\u17BC\u179A"},{"id":8441,"word":"\u1796\u17B7\u1793"},{"id":8442,"word":"\u1796\u17B7\u1793\u178F\u17BC"},{"id":8443,"word":"\u1796\u17B7\u1793\u17D0\u1799"},{"id":8444,"word":"\u1796\u17B7\u1793\u17B7\u178F\u17D2\u1799"},{"id":8445,"word":"\u1796\u17B7\u1793\u17B7\u179F\u17D2\u1785\u17D0\u1799"},{"id":8446,"word":"\u1796\u17B7\u1793\u17D2\u1791\u1784"},{"id":8447,"word":"\u1796\u17B7\u1793\u17D2\u1791\u17BB"},{"id":8448,"word":"\u1796\u17B7\u1793\u17D2\u1791\u17BB\u1780\u1794\u17D2\u1794\u17C8"},{"id":8449,"word":"\u1796\u17B7\u1794\u17B6\u1780"},{"id":8450,"word":"\u1796\u17B7\u1794\u17B7\u1793"},{"id":8451,"word":"\u1796\u17B7\u1795\u17B6\u178F"},{"id":8452,"word":"\u1796\u17B7\u1796\u178C\u17D2\u178D\u179F\u1785\u17D2\u1785\u17B6"},{"id":8453,"word":"\u1796\u17B7\u1796\u178E\u17CC\u1793\u17B6"},{"id":8454,"word":"\u1796\u17B7\u1796\u17D0\u179A\u178E\u17CD"},{"id":8455,"word":"\u1796\u17B7\u1796\u17B6\u17A0\u17CD"},{"id":8456,"word":"\u1796\u17B7\u1796\u17B7\u1792"},{"id":8457,"word":"\u1796\u17B7\u1797\u17D0\u1780\u17D2\u178A\u17B7"},{"id":8458,"word":"\u1796\u17B7\u1797\u1791\u17D2\u1791\u179F\u1785\u17D2\u1785\u17B6"},{"id":8459,"word":"\u1796\u17B7\u1797\u1796"},{"id":8460,"word":"\u1796\u17B7\u1797\u17B6\u1780\u17D2\u179F\u17B6"},{"id":8461,"word":"\u1796\u17B7\u1797\u17B6\u179B\u17CB"},{"id":8462,"word":"\u1796\u17B7\u1797\u17C1\u1780"},{"id":8463,"word":"\u1796\u17B7\u1797\u17C1\u1780\u17D2\u179F\u178E\u17CD"},{"id":8464,"word":"\u1796\u17B7\u1797\u17C1\u1791\u1780\u17CD"},{"id":8465,"word":"\u1796\u17B7\u1798\u179B"},{"id":8466,"word":"\u1796\u17B7\u1798\u17B6\u1793"},{"id":8467,"word":"\u1796\u17B7\u1798\u17B6\u1793\u17A2\u17B6\u1780\u17B6\u179F"},{"id":8468,"word":"\u1796\u17B7\u1798\u17D2\u1796"},{"id":8469,"word":"\u1796\u17B7\u1798\u17D2\u1796\u17B6"},{"id":8470,"word":"\u1796\u17B7\u1798\u17D2\u1796\u17B7\u179F\u17B6\u179A"},{"id":8471,"word":"\u1796\u17B7\u179A\u17B6\u179B\u17D0\u1799"},{"id":8472,"word":"\u1796\u17B7\u179A\u17BB\u178E"},{"id":8473,"word":"\u1796\u17B7\u179A\u17BB\u178E\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":8474,"word":"\u1796\u17B7\u179A\u17BB\u1791\u17D2\u1792"},{"id":8475,"word":"\u1796\u17B7\u179A\u17C4\u1792"},{"id":8476,"word":"\u1796\u17B7\u179A\u17C4\u1792\u1793\u17CD"},{"id":8477,"word":"\u1796\u17B7\u179B"},{"id":8478,"word":"\u1796\u17B7\u179B\u17B6\u1794"},{"id":8479,"word":"\u1796\u17B7\u179B\u17B6\u179B\u17D0\u1799"},{"id":8480,"word":"\u1796\u17B7\u179B\u17B6\u179F"},{"id":8481,"word":"\u1796\u17B7\u179B\u17B6\u179F\u17D0\u1799"},{"id":8482,"word":"\u1796\u17B7\u179B\u17B6\u179F\u17B7\u1793\u17B8"},{"id":8483,"word":"\u1796\u17B7\u179B\u17B6\u179F\u17B8"},{"id":8484,"word":"\u1796\u17B7\u179F"},{"id":8485,"word":"\u1796\u17B7\u179F\u1798\u17D0\u1799"},{"id":8486,"word":"\u1796\u17B7\u179F\u17B6"},{"id":8487,"word":"\u1796\u17B7\u179F\u17B6\u1781"},{"id":8488,"word":"\u1796\u17B7\u179F\u17B6\u1781\u1794\u17BC\u1787\u17B6"},{"id":8489,"word":"\u1796\u17B7\u179F\u17B6\u179B"},{"id":8490,"word":"\u1796\u17B7\u179F\u17B7\u178A\u17D2\u178B"},{"id":8491,"word":"\u1796\u17B7\u179F\u17B8"},{"id":8492,"word":"\u1796\u17B7\u179F\u17BB\u1791\u17D2\u1792"},{"id":8493,"word":"\u1796\u17B7\u179F\u17BB\u1791\u17D2\u1792\u17B7"},{"id":8494,"word":"\u1796\u17B7\u179F\u17C1\u179F"},{"id":8495,"word":"\u1796\u17B7\u179F\u17C2\u179F"},{"id":8496,"word":"\u1796\u17B7\u179F\u17C4\u1792"},{"id":8497,"word":"\u1796\u17B7\u179F\u17C4\u1792\u1793\u17CD"},{"id":8498,"word":"\u1796\u17B7\u179F\u17D2\u178A\u17B6\u179A"},{"id":8499,"word":"\u1796\u17B7\u179F\u17D2\u178E\u17BB"},{"id":8500,"word":"\u1796\u17B7\u179F\u17D2\u178E\u17BB\u1780\u17B6\u179A"},{"id":8501,"word":"\u1796\u17B7\u179F\u17D2\u178E\u17BB\u179B\u17C4\u1780"},{"id":8502,"word":"\u1796\u17B7\u179F\u17D2\u1798\u17D0\u1799"},{"id":8503,"word":"\u1796\u17B7\u179F\u17D2\u179F\u17BB\u178F"},{"id":8504,"word":"\u1796\u17B7\u17A1\u17B6\u179A"},{"id":8505,"word":"\u1796\u17B8"},{"id":8506,"word":"\u1796\u17B8\u1784"},{"id":8507,"word":"\u1796\u17B8\u1784\u1796\u1784\u17CB"},{"id":8508,"word":"\u1796\u17B8\u1784\u1796\u17B6\u1784"},{"id":8509,"word":"\u1796\u17B8\u1784\u1796\u17B6\u17C6\u1784"},{"id":8510,"word":"\u1796\u17B8\u1787\u1782\u178E\u17B7\u178F"},{"id":8511,"word":"\u1796\u17B8\u1787\u1782\u17B6\u1798"},{"id":8512,"word":"\u1796\u17B8\u1795\u17B6\u178F"},{"id":8513,"word":"\u1796\u17B8\u1796\u17D2\u179A\u17C4\u17C7"},{"id":8514,"word":"\u1796\u17B8\u1798\u1796\u17BE\u1798"},{"id":8515,"word":"\u1796\u17B8\u179A"},{"id":8516,"word":"\u1796\u17B8\u179A\u17C4\u17C7"},{"id":8517,"word":"\u1796\u17B8\u179F\u17B6"},{"id":8518,"word":"\u1796\u17B8\u179F\u17B8"},{"id":8519,"word":"\u1796\u17B9\u1784"},{"id":8520,"word":"\u1796\u17B9\u178F"},{"id":8521,"word":"\u1796\u17B9\u1794"},{"id":8522,"word":"\u1796\u17BA\u178F"},{"id":8523,"word":"\u1796\u17BB\u1780"},{"id":8524,"word":"\u1796\u17BB\u1780\u1785\u1784\u17D2\u1780\u17B6"},{"id":8525,"word":"\u1796\u17BB\u1780\u1786\u17D2\u1798\u17B6"},{"id":8526,"word":"\u1796\u17BB\u1780\u1794\u1784\u17D2\u1780\u1784"},{"id":8527,"word":"\u1796\u17BB\u1780\u1798\u17B6\u178F\u17CB"},{"id":8528,"word":"\u1796\u17BB\u1784"},{"id":8529,"word":"\u1796\u17BB\u178F"},{"id":8530,"word":"\u1796\u17BB\u178F\u1792\u17D2\u179B\u17C1"},{"id":8531,"word":"\u1796\u17BB\u178F\u179B\u17C6\u1789\u1784"},{"id":8532,"word":"\u1796\u17BB\u1791\u17D2\u1792"},{"id":8533,"word":"\u1796\u17BB\u1791\u17D2\u1792 --"},{"id":8534,"word":"\u1796\u17BB\u1791\u17D2\u1792\u1783\u17C4\u179F\u17C8"},{"id":8535,"word":"\u1796\u17BB\u1791\u17D2\u1792\u1787\u17B6\u178F"},{"id":8536,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17B7"},{"id":8537,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17B7\u1780"},{"id":8538,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17B7\u1785\u179A\u17B7\u178F"},{"id":8539,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17B7\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792"},{"id":8540,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17B7\u179C\u17B7\u1794\u179B\u17D2\u179B\u17B6\u179F"},{"id":8541,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17BB\u1794\u17D2\u1794\u17B6\u1791"},{"id":8542,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17C4 ! "},{"id":8543,"word":"\u1796\u17BB\u1791\u17D2\u1792\u17C4\u179C\u17B6\u1791"},{"id":8544,"word":"\u1796\u17BB\u1791\u17D2\u179A\u17B6"},{"id":8545,"word":"\u1796\u17BB\u1792"},{"id":8546,"word":"\u1796\u17BB\u1792\u1787\u1793"},{"id":8547,"word":"\u1796\u17BB\u1793"},{"id":8548,"word":"\u1796\u17BB\u1794"},{"id":8549,"word":"\u1796\u17BB\u1798\u17D2\u1796"},{"id":8550,"word":"\u1796\u17BB\u179A"},{"id":8551,"word":"\u1796\u17BB\u179B"},{"id":8552,"word":"\u1796\u17BB\u17C7"},{"id":8553,"word":"\u1796\u17BC"},{"id":8554,"word":"\u1796\u17BC\u1780"},{"id":8555,"word":"\u1796\u17BC\u1780\u17C2"},{"id":8556,"word":"\u1796\u17BC\u1787"},{"id":8557,"word":"\u1796\u17BC\u178F"},{"id":8558,"word":"\u1796\u17BC\u1790\u17C5"},{"id":8559,"word":"\u1796\u17BC\u1793"},{"id":8560,"word":"\u1796\u17BC\u179A\u17B6\u1784"},{"id":8561,"word":"\u1796\u17BD\u1780"},{"id":8562,"word":"\u1796\u17BD\u1785"},{"id":8563,"word":"\u1796\u17BD\u178F"},{"id":8564,"word":"\u1796\u17BD\u1793"},{"id":8565,"word":"\u1796\u17BD\u1799"},{"id":8566,"word":"\u1796\u17BD\u179A"},{"id":8567,"word":"\u1796\u17BE"},{"id":8568,"word":"\u1796\u17BE\u1780"},{"id":8569,"word":"\u1796\u17BE\u1780\u17D7"},{"id":8570,"word":"\u1796\u17BE\u1784"},{"id":8571,"word":"\u1796\u17BE\u178F"},{"id":8572,"word":"\u1796\u17BE\u1794"},{"id":8573,"word":"\u1796\u17BE\u1798\u17D7"},{"id":8574,"word":"\u1796\u17C0\u1785"},{"id":8575,"word":"\u1796\u17C0\u1794"},{"id":8576,"word":"\u1796\u17C0\u179A"},{"id":8577,"word":"\u1796\u17C1\u1780"},{"id":8578,"word":"\u1796\u17C1\u1785\u1793\u17CD"},{"id":8579,"word":"\u1796\u17C1\u1785\u1796\u17B7\u179B"},{"id":8580,"word":"\u1796\u17C1\u1787\u1799\u17D0\u1793\u17D2\u178F"},{"id":8581,"word":"\u1796\u17C1\u1787\u17D2\u1788\u1783\u17B6\u178A"},{"id":8582,"word":"\u1796\u17C1\u1787\u17D2\u179A"},{"id":8583,"word":"\u1796\u17C1\u1789"},{"id":8584,"word":"\u1796\u17C1\u1789 --"},{"id":8585,"word":"\u1796\u17C1\u1791\u17D2\u1799"},{"id":8586,"word":"\u1796\u17C1\u1791\u17D2\u1799\u1798\u1793\u17D2\u1791\u17B8\u179A"},{"id":8587,"word":"\u1796\u17C1\u1791\u17D2\u1799\u179C\u17B7\u1791\u17D2\u1799\u17B6"},{"id":8588,"word":"\u1796\u17C1\u1791\u17D2\u1799\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":8589,"word":"\u1796\u17C1\u1791\u17D2\u1799\u179F\u17D2\u1790\u17B6\u1793"},{"id":8590,"word":"\u1796\u17C1\u1793"},{"id":8591,"word":"\u1796\u17C1\u1794"},{"id":8592,"word":"\u1796\u17C1\u1798\u1796\u17BE\u1798"},{"id":8593,"word":"\u1796\u17C1\u179B"},{"id":8594,"word":"\u1796\u17C1\u179B\u17B6"},{"id":8595,"word":"\u1796\u17C1\u179F\u17D2\u1799\u17B6"},{"id":8596,"word":"\u1796\u17C1\u179F\u17D2\u1799\u17B6\u1782\u17C4\u1785\u179A"},{"id":8597,"word":"\u1796\u17C1\u179F\u17D2\u1799\u17B6\u179F\u17D2\u1790\u17B6\u1793"},{"id":8598,"word":"\u1796\u17C2"},{"id":8599,"word":"\u1796\u17C2\u1784"},{"id":8600,"word":"\u1796\u17C2\u1784\u1785\u1780"},{"id":8601,"word":"\u1796\u17C2\u1791\u17D2\u1799"},{"id":8602,"word":"\u1796\u17C2\u1793"},{"id":8603,"word":"\u1796\u17C3"},{"id":8604,"word":"\u1796\u17C3\u1791\u17BC\u179A\u17D2\u1799"},{"id":8605,"word":"\u1796\u17C3\u179A\u17CD"},{"id":8606,"word":"\u1796\u17C3\u179A\u17B8"},{"id":8607,"word":"\u1796\u17C3\u179F\u17B6\u179B\u17B8"},{"id":8608,"word":"\u1796\u17C3\u179F\u17D2\u179A\u1796\u178E\u17CD"},{"id":8609,"word":"\u1796\u17C4"},{"id":8610,"word":"\u1796\u17C4\u1784"},{"id":8611,"word":"\u1796\u17C4\u1784\u1796\u17B6\u1799"},{"id":8612,"word":"\u1796\u17C4\u1787\u17D2\u1788\u1784\u17D2\u1782"},{"id":8613,"word":"\u1796\u17C4\u178F"},{"id":8614,"word":"\u1796\u17C4\u1792\u17B7"},{"id":8615,"word":"\u1796\u17C4\u1792\u17B7\u17CD"},{"id":8616,"word":"\u1796\u17C4\u1792\u17B7\u1780\u17B6\u179B"},{"id":8617,"word":"\u1796\u17C4\u1792\u17B7\u1789\u17B6\u178E"},{"id":8618,"word":"\u1796\u17C4\u1792\u17B7\u1791\u17D2\u179A\u17BB\u1798 "},{"id":8619,"word":"\u1796\u17C4\u1792\u17B7\u17CD\u1792\u17C6"},{"id":8620,"word":"\u1796\u17C4\u1792\u17B7\u17CD\u1792\u17D2\u179B\u17C1"},{"id":8621,"word":"\u1796\u17C4\u1792\u17B7\u1794\u1780\u17D2\u1781\u17B7\u1799\u1792\u1798\u17CC"},{"id":8622,"word":"\u1796\u17C4\u1792\u17B7\u17CD\u1794\u17B6\u1799"},{"id":8623,"word":"\u1796\u17C4\u1792\u17B7\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":8624,"word":"\u1796\u17C4\u1792\u17B7\u179C\u17D0\u1784\u17D2\u179F"},{"id":8625,"word":"\u1796\u17C4\u1792\u17B7\u179F\u178F\u17D2\u179C"},{"id":8626,"word":"\u1796\u17C4\u1792\u17B7\u179F\u1798\u17D0\u1799"},{"id":8627,"word":"\u1796\u17C4\u1792\u17B7\u179F\u1798\u17D2\u1797\u17B6\u179A"},{"id":8628,"word":"\u1796\u17C4\u1792\u17B7\u17CD\u179F\u17B6\u178F\u17CB"},{"id":8629,"word":"\u1796\u17C4\u1793"},{"id":8630,"word":"\u1796\u17C4\u1793\u179F\u17D2\u179C\u17B6"},{"id":8631,"word":"\u1796\u17C4\u1794"},{"id":8632,"word":"\u1796\u17C4\u179A"},{"id":8633,"word":"\u1796\u17C4\u179A\u1799\u17C6"},{"id":8634,"word":"\u1796\u17C4\u179B"},{"id":8635,"word":"\u1796\u17C4\u179B\u17D2\u1799\u17C6"},{"id":8636,"word":"\u1796\u17C4\u17C7"},{"id":8637,"word":"\u1796\u17C4\u17C7\u178A\u17C6\u17A1\u17BE\u1784"},{"id":8638,"word":"\u1796\u17C4\u17C7\u178F\u17B6\u17C6\u1784"},{"id":8639,"word":"\u1796\u17C4\u17C7\u1796\u17BB\u1784"},{"id":8640,"word":"\u1796\u17C4\u17C7\u1797\u17D2\u179B\u17B6\u1789"},{"id":8641,"word":"\u1796\u17C4\u17C7\u1798\u17C9\u17B6\u1799"},{"id":8642,"word":"\u1796\u17C4\u17C7\u179C\u17C0\u1793"},{"id":8643,"word":"\u1796\u17C4\u17C7\u179F\u1798\u17D2\u179A\u1780"},{"id":8644,"word":"\u1796\u17C4\u17C7\u17A2\u17C6\u1794\u17C2\u1784"},{"id":8645,"word":"\u1796\u17C5"},{"id":8646,"word":"\u1796\u17BB\u17C6"},{"id":8647,"word":"\u1796\u17BB\u17C6\u1784\u17B6"},{"id":8648,"word":"\u1796\u17BB\u17C6\u1785\u17C1\u179A"},{"id":8649,"word":"\u1796\u17BB\u17C6\u1787\u17BC\u1780\u17B6\u179B"},{"id":8650,"word":"\u1796\u17BB\u17C6\u1793\u17C4\u17C7"},{"id":8651,"word":"\u1796\u17BB\u17C6\u179F\u17C2\u1793"},{"id":8652,"word":"\u1796\u17C6\u1793\u17B6\u1780\u17CB"},{"id":8653,"word":"\u1796\u17C6\u1793\u17B7\u178F"},{"id":8654,"word":"\u1796\u17C6\u1793\u17B9\u1784"},{"id":8655,"word":"\u1796\u17C6\u1793\u17BC\u1780"},{"id":8656,"word":"\u1796\u17C6\u1793\u17BC\u178F"},{"id":8657,"word":"\u1796\u17C6\u1793\u17BD\u178F"},{"id":8658,"word":"\u1796\u17C6\u1793\u17C0\u179A"},{"id":8659,"word":"\u1796\u17C6\u1793\u17C4\u179B"},{"id":8660,"word":"\u1796\u17B6\u17C6"},{"id":8661,"word":"\u1796\u17B6\u17C6\u1784"},{"id":8662,"word":"\u1796\u17C7"},{"id":8663,"word":"\u1796\u17C7 !"},{"id":8664,"word":"\u1796\u17D2\u1780\u17BB\u179B"},{"id":8665,"word":"\u1796\u17D2\u1793\u1784"},{"id":8666,"word":"\u1796\u17D2\u1793\u17B6\u1799"},{"id":8667,"word":"\u1796\u17D2\u1793\u17B7\u179B"},{"id":8668,"word":"\u1796\u17D2\u1793\u17C0\u178F"},{"id":8669,"word":"\u1796\u17D2\u1793\u17C3"},{"id":8670,"word":"\u1796\u17D2\u1793\u17C5"},{"id":8671,"word":"\u1796\u17D2\u1799\u1782\u17D2\u1783"},{"id":8672,"word":"\u1796\u17D2\u1799\u1789\u17D2\u1787\u1793\u17C8"},{"id":8673,"word":"\u1796\u17D2\u1799\u1789\u17D2\u1787\u1793\u179F\u17B7\u179B\u17B7\u178A\u17D2\u178B"},{"id":8674,"word":"\u1796\u17D2\u1799\u178F\u17B7\u17A0\u17B6\u179A"},{"id":8675,"word":"\u1796\u17D2\u1799\u178F\u17C4\u1794\u17B6\u178F"},{"id":8676,"word":"\u1796\u17D2\u1799\u178F\u17D2\u178F\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":8677,"word":"\u1796\u17D2\u1799\u178F\u17D2\u178F\u1797\u17B6\u1796"},{"id":8678,"word":"\u1796\u17D2\u1799\u178F\u17D2\u178F\u179C\u17C4\u17A0\u17B6\u179A"},{"id":8679,"word":"\u1796\u17D2\u1799\u179F\u1793\u17CD"},{"id":8680,"word":"\u1796\u17D2\u1799\u17B6\u1780\u179A"},{"id":8681,"word":"\u1796\u17D2\u1799\u17B6\u1780\u179A\u178E\u17CD"},{"id":8682,"word":"\u1796\u17D2\u1799\u17B6\u1780\u17D2\u179A\u17B9\u178F\u17B7"},{"id":8683,"word":"\u1796\u17D2\u1799\u17B6\u1784\u17D2\u1782"},{"id":8684,"word":"\u1796\u17D2\u1799\u17B6\u178C\u179F\u178F\u17D2\u179C"},{"id":8685,"word":"\u1796\u17D2\u1799\u17B6\u1792\u17B7"},{"id":8686,"word":"\u1796\u17D2\u1799\u17B6\u1792\u17B7\u17CD"},{"id":8687,"word":"\u1796\u17D2\u1799\u17B6\u1792\u17B7\u1791\u17BB\u1780\u17D2\u1781"},{"id":8688,"word":"\u1796\u17D2\u1799\u17B6\u1792\u17B7\u1792\u1798\u17CC"},{"id":8689,"word":"\u1796\u17D2\u1799\u17B6\u1794\u1791"},{"id":8690,"word":"\u1796\u17D2\u1799\u17B6\u1794\u17B6\u1791"},{"id":8691,"word":"\u1796\u17D2\u1799\u17B6\u1794\u17B6\u179A"},{"id":8692,"word":"\u1796\u17D2\u1799\u17B6\u1794\u17B6\u179B"},{"id":8693,"word":"\u1796\u17D2\u1799\u17B6\u1798"},{"id":8694,"word":"\u1796\u17D2\u1799\u17B6\u1798\u1794\u17D2\u1794\u1797\u17B6"},{"id":8695,"word":"\u1796\u17D2\u1799\u17B6\u1799\u17B6\u1798"},{"id":8696,"word":"\u1796\u17D2\u1799\u17BB\u17A0\u17C8"},{"id":8697,"word":"\u1796\u17D2\u1799\u17BB\u17C7"},{"id":8698,"word":"\u1796\u17D2\u1799\u17BC\u17A0\u17C8"},{"id":8699,"word":"\u1796\u17D2\u1799\u17BC\u17A0\u17CD"},{"id":8700,"word":"\u1796\u17D2\u1799\u17BD\u179A"},{"id":8701,"word":"\u1796\u17D2\u1799\u17C4\u1780\u17B6\u179A"},{"id":8702,"word":"\u1796\u17D2\u1799\u17C4\u1798"},{"id":8703,"word":"\u1796\u17D2\u179A\u1780"},{"id":8704,"word":"\u1796\u17D2\u179A\u1784\u17CB"},{"id":8705,"word":"\u1796\u17D2\u179A\u1784\u17B6\u179B\u17CB"},{"id":8706,"word":"\u1796\u17D2\u179A\u1784\u17BE\u1799"},{"id":8707,"word":"\u1796\u17D2\u179A\u1789\u17BC\u1789"},{"id":8708,"word":"\u1796\u17D2\u179A\u178F\u17D7"},{"id":8709,"word":"\u1796\u17D2\u179A\u178F"},{"id":8710,"word":"\u1796\u17D2\u179A\u17D0\u178F\u17D2\u179A"},{"id":8711,"word":"\u1796\u17D2\u179A\u1793\u1784\u17CB "},{"id":8712,"word":"\u1796\u17D2\u179A\u1793\u1798"},{"id":8713,"word":"\u1796\u17D2\u179A\u1793\u179A"},{"id":8714,"word":"\u1796\u17D2\u179A\u1793\u17B6\u1780\u17CB"},{"id":8715,"word":"\u1796\u17D2\u179A\u1793\u17B6\u1780\u17CB\u1781\u17D2\u179F\u17C2\u178F\u17D2\u1794\u17B6\u1789"},{"id":8716,"word":"\u1796\u17D2\u179A\u1793\u17B6\u1780\u17CB\u1794\u17C6\u1796\u1784"},{"id":8717,"word":"\u1796\u17D2\u179A\u1793\u17BD\u178F"},{"id":8718,"word":"\u1796\u17D2\u179A\u1798"},{"id":8719,"word":"\u1796\u17D2\u179A\u1798\u179A"},{"id":8720,"word":"\u1796\u17D2\u179A\u1798\u17B6\u1793"},{"id":8721,"word":"\u1796\u17D2\u179A\u1798\u17B9\u1780"},{"id":8722,"word":"\u1796\u17D2\u179A\u1799"},{"id":8723,"word":"\u1796\u17D2\u179A\u1799\u17BA\u178F"},{"id":8724,"word":"\u1796\u17D2\u179A\u1799\u17BB\u1784"},{"id":8725,"word":"\u1796\u17D2\u179A\u1799\u17C4\u1784"},{"id":8726,"word":"\u1796\u17D2\u179A\u179A\u17B9\u178F"},{"id":8727,"word":"\u1796\u17D2\u179A\u179A\u17BD\u178F"},{"id":8728,"word":"\u1796\u17D2\u179A\u179B"},{"id":8729,"word":"\u1796\u17D2\u179A\u179B\u1794\u17CB"},{"id":8730,"word":"\u1796\u17D2\u179A\u179B\u1799"},{"id":8731,"word":"\u1796\u17D2\u179A\u179B\u17B7\u1784"},{"id":8732,"word":"\u1796\u17D2\u179A\u179B\u17B7\u178F"},{"id":8733,"word":"\u1796\u17D2\u179A\u179B\u17B8\u178F"},{"id":8734,"word":"\u1796\u17D2\u179A\u179B\u17B8\u179F"},{"id":8735,"word":"\u1796\u17D2\u179A\u179B\u17B9\u1784"},{"id":8736,"word":"\u1796\u17D2\u179A\u179B\u17B9\u178F"},{"id":8737,"word":"\u1796\u17D2\u179A\u179B\u17B9\u1798"},{"id":8738,"word":"\u1796\u17D2\u179A\u179B\u17BC\u1784"},{"id":8739,"word":"\u1796\u17D2\u179A\u179B\u17BC\u1789"},{"id":8740,"word":"\u1796\u17D2\u179A\u179B\u17BC\u179F"},{"id":8741,"word":"\u1796\u17D2\u179A\u179B\u17BD\u178F\u179B\u17B6\u1780\u17CB"},{"id":8742,"word":"\u1796\u17D2\u179A\u179B\u17C2\u178F"},{"id":8743,"word":"\u1796\u17D2\u179A\u179B\u17B6\u17C6"},{"id":8744,"word":"\u1796\u17D2\u179A\u179B\u17B6\u17C6\u1784"},{"id":8745,"word":"\u1796\u17D2\u179A\u179B\u17C7"},{"id":8746,"word":"\u1796\u17D2\u179A\u179C\u17B6\u179A"},{"id":8747,"word":"\u1796\u17D2\u179A\u179C\u17B8\u1796\u17D2\u179A\u179C\u17B6\u179A"},{"id":8748,"word":"\u1796\u17D2\u179A\u179C\u17B9\u1784"},{"id":8749,"word":"\u1796\u17D2\u179A\u179C\u17C2\u1780"},{"id":8750,"word":"\u1796\u17D2\u179A\u17A0\u1780\u17CB"},{"id":8751,"word":"\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD"},{"id":8752,"word":"\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u1785\u1780\u17D2\u179A"},{"id":8753,"word":"\u1796\u17D2\u179A\u17A0\u17B6\u1798"},{"id":8754,"word":"\u1796\u17D2\u179A\u17A0\u17B6\u179A\u1789\u17D2\u1789"},{"id":8755,"word":"\u1796\u17D2\u179A\u17A0\u17B6\u179C\u1793"},{"id":8756,"word":"\u1796\u17D2\u179A\u17A0\u17B8\u178F"},{"id":8757,"word":"\u1796\u17D2\u179A\u17A0\u17BC\u178F"},{"id":8758,"word":"\u1796\u17D2\u179A\u17A0\u17BD\u1789"},{"id":8759,"word":"\u1796\u17D2\u179A\u17A0\u17BD\u1798"},{"id":8760,"word":"\u1796\u17D2\u179A\u17A0\u17BE\u1793"},{"id":8761,"word":"\u1796\u17D2\u179A\u17A0\u17C2\u178F"},{"id":8762,"word":"\u1796\u17D2\u179A\u17A0\u17D2\u1798"},{"id":8763,"word":"\u1796\u17D2\u179A\u17A0\u17D2\u1798 --"},{"id":8764,"word":"\u1796\u17D2\u179A\u17A2\u17BC\u1789"},{"id":8765,"word":"\u1796\u17D2\u179A\u17B6"},{"id":8766,"word":"\u1796\u17D2\u179A\u17B6\u1780"},{"id":8767,"word":"\u1796\u17D2\u179A\u17B6\u1780\u17D7"},{"id":8768,"word":"\u1796\u17D2\u179A\u17B6\u1784"},{"id":8769,"word":"\u1796\u17D2\u179A\u17B6\u1785"},{"id":8770,"word":"\u1796\u17D2\u179A\u17B6\u178F"},{"id":8771,"word":"\u1796\u17D2\u179A\u17B6\u178F\u17CB"},{"id":8772,"word":"\u1796\u17D2\u179A\u17B6\u1793"},{"id":8773,"word":"\u1796\u17D2\u179A\u17B6\u1794"},{"id":8774,"word":"\u1796\u17D2\u179A\u17B6\u1798"},{"id":8775,"word":"\u1796\u17D2\u179A\u17B6\u1799"},{"id":8776,"word":"\u1796\u17D2\u179A\u17B6\u179B"},{"id":8777,"word":"\u1796\u17D2\u179A\u17B6\u179B\u17D7"},{"id":8778,"word":"\u1796\u17D2\u179A\u17B6\u179C"},{"id":8779,"word":"\u1796\u17D2\u179A\u17B6\u17A0\u17D2\u1798\u178E\u17CD"},{"id":8780,"word":"\u1796\u17D2\u179A\u17B6\u17A0\u17D2\u1798\u178E\u17D2\u1799"},{"id":8781,"word":"\u1796\u17D2\u179A\u17B6\u17A0\u17D2\u1798\u178E\u17B7\u1780"},{"id":8782,"word":"\u1796\u17D2\u179A\u17B6\u17A0\u17D2\u1798\u178E\u17B8"},{"id":8783,"word":"\u1796\u17D2\u179A\u17B7\u1785"},{"id":8784,"word":"\u1796\u17D2\u179A\u17B7\u1785\u17D7"},{"id":8785,"word":"\u1796\u17D2\u179A\u17B7\u1789\u17D7"},{"id":8786,"word":"\u1796\u17D2\u179A\u17B7\u179B"},{"id":8787,"word":"\u1796\u17D2\u179A\u17B8\u1780"},{"id":8788,"word":"\u1796\u17D2\u179A\u17B8\u1784"},{"id":8789,"word":"\u1796\u17D2\u179A\u17B9\u1780"},{"id":8790,"word":"\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":8791,"word":"\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F\u17B6"},{"id":8792,"word":"\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F\u17B6\u1787\u17B6\u178F\u17B7"},{"id":8793,"word":"\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7"},{"id":8794,"word":"\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7\u1780\u17B6\u179A"},{"id":8795,"word":"\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7\u1780\u17B6\u179A\u178E\u17CD"},{"id":8796,"word":"\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7\u1794\u178F\u17D2\u179A "},{"id":8797,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792"},{"id":8798,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792\u179F\u1797\u17B6"},{"id":8799,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":8800,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792\u17B6\u1794\u1785\u17B6\u1799\u1793\u17C8"},{"id":8801,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792"},{"id":8802,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792\u17B7\u1780\u1798\u17D2\u1798"},{"id":8803,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792\u17B7\u179A\u17C4\u1782 "},{"id":8804,"word":"\u1796\u17D2\u179A\u17B9\u1791\u17D2\u1792\u17B8"},{"id":8805,"word":"\u1796\u17D2\u179A\u17B9\u1793\u17D2\u1791"},{"id":8806,"word":"\u1796\u17D2\u179A\u17B9\u1794"},{"id":8807,"word":"\u1796\u17D2\u179A\u17B9\u1798"},{"id":8808,"word":"\u1796\u17D2\u179A\u17B9\u1798\u17D7"},{"id":8809,"word":"\u1796\u17D2\u179A\u17B9\u179B"},{"id":8810,"word":"\u1796\u17D2\u179A\u17B9\u179B\u17D7"},{"id":8811,"word":"\u1796\u17D2\u179A\u17B9\u179F\u17D2\u1785\u17B7\u1780"},{"id":8812,"word":"\u1796\u17D2\u179A\u17B9\u179F\u1797\u17C8"},{"id":8813,"word":"\u1796\u17D2\u179A\u17BA"},{"id":8814,"word":"\u1796\u17D2\u179A\u17BA\u179F"},{"id":8815,"word":"\u1796\u17D2\u179A\u17BA\u17C7"},{"id":8816,"word":"\u1796\u17D2\u179A\u17BB\u1780\u17D7"},{"id":8817,"word":"\u1796\u17D2\u179A\u17BB\u1799"},{"id":8818,"word":"\u1796\u17D2\u179A\u17BB\u179B"},{"id":8819,"word":"\u1796\u17D2\u179A\u17BB\u179F"},{"id":8820,"word":"\u1796\u17D2\u179A\u17BC"},{"id":8821,"word":"\u1796\u17D2\u179A\u17BC\u178F"},{"id":8822,"word":"\u1796\u17D2\u179A\u17BC\u1793"},{"id":8823,"word":"\u1796\u17D2\u179A\u17BC\u179F"},{"id":8824,"word":"\u1796\u17D2\u179A\u17BD\u1780"},{"id":8825,"word":"\u1796\u17D2\u179A\u17BD\u1785"},{"id":8826,"word":"\u1796\u17D2\u179A\u17BD\u1789"},{"id":8827,"word":"\u1796\u17D2\u179A\u17BD\u178F"},{"id":8828,"word":"\u1796\u17D2\u179A\u17BD\u1798"},{"id":8829,"word":"\u1796\u17D2\u179A\u17BD\u1799"},{"id":8830,"word":"\u1796\u17D2\u179A\u17BD\u179B"},{"id":8831,"word":"\u1796\u17D2\u179A\u17BD\u179F"},{"id":8832,"word":"\u1796\u17D2\u179A\u17BE\u178F"},{"id":8833,"word":"\u1796\u17D2\u179A\u17BE\u1798"},{"id":8834,"word":"\u1796\u17D2\u179A\u17BE\u179B"},{"id":8835,"word":"\u1796\u17D2\u179A\u17BE\u179F"},{"id":8836,"word":"\u1796\u17D2\u179A\u17C0\u1784\u179B\u17B6\u1793"},{"id":8837,"word":"\u1796\u17D2\u179A\u17C0\u1785"},{"id":8838,"word":"\u1796\u17D2\u179A\u17C0\u1794"},{"id":8839,"word":"\u1796\u17D2\u179A\u17C1\u1784"},{"id":8840,"word":"\u1796\u17D2\u179A\u17C1\u1785"},{"id":8841,"word":"\u1796\u17D2\u179A\u17C1\u1793"},{"id":8842,"word":"\u1796\u17D2\u179A\u17C2"},{"id":8843,"word":"\u1796\u17D2\u179A\u17C2\u1780"},{"id":8844,"word":"\u1796\u17D2\u179A\u17C2\u179B"},{"id":8845,"word":"\u1796\u17D2\u179A\u17C3"},{"id":8846,"word":"\u1796\u17D2\u179A\u17C3\u1780\u1794\u17D2\u1794\u17B6\u179F"},{"id":8847,"word":"\u1796\u17D2\u179A\u17C3\u1784\u17B6\u179A"},{"id":8848,"word":"\u1796\u17D2\u179A\u17C3\u1788\u179A"},{"id":8849,"word":"\u1796\u17D2\u179A\u17C3\u1793\u1782\u179A"},{"id":8850,"word":"\u1796\u17D2\u179A\u17C3\u179C\u17C2\u1784"},{"id":8851,"word":"\u1796\u17D2\u179A\u17C3\u17A2\u1784\u17D2\u1782\u179A"},{"id":8852,"word":"\u1796\u17D2\u179A\u17C4\u1780"},{"id":8853,"word":"\u1796\u17D2\u179A\u17C4\u1784"},{"id":8854,"word":"\u1796\u17D2\u179A\u17C4\u1793"},{"id":8855,"word":"\u1796\u17D2\u179A\u17C4\u17C7"},{"id":8856,"word":"\u1796\u17D2\u179A\u17C5"},{"id":8857,"word":"\u1796\u17D2\u179A\u17C6"},{"id":8858,"word":"\u1796\u17D2\u179A\u17B6\u17C6"},{"id":8859,"word":"\u1796\u17D2\u179A\u17C7"},{"id":8860,"word":"\u1796\u17D2\u179A\u17C7\u1780\u1798\u17D2\u1785\u17B6\u178F\u17CB"},{"id":8861,"word":"\u1796\u17D2\u179A\u17C7\u1780\u1798\u17D2\u1785\u17B6\u1799"},{"id":8862,"word":"\u1796\u17D2\u179A\u17C7\u1780\u17D2\u179A\u17B6\u1794"},{"id":8863,"word":"\u1796\u17D2\u179A\u17C7\u1781\u17D2\u179B\u1794"},{"id":8864,"word":"\u1796\u17D2\u179A\u17C7\u1787\u17B8\u179C\u17CD"},{"id":8865,"word":"\u1796\u17D2\u179A\u17C7\u178F\u17C1\u1787\u1796\u17D2\u179A\u17C7\u1782\u17BB\u178E"},{"id":8866,"word":"\u1796\u17D2\u179A\u17C7\u1790\u17C4\u1784"},{"id":8867,"word":"\u1796\u17D2\u179A\u17C7\u1790\u17D2\u1780\u17C4\u179B"},{"id":8868,"word":"\u1796\u17D2\u179A\u17C7\u1790\u17D2\u1782\u17C4\u179B"},{"id":8869,"word":"\u1796\u17D2\u179A\u17C7\u1791\u17D2\u179A\u17A0\u17B9\u1784"},{"id":8870,"word":"\u1796\u17D2\u179A\u17C7\u1793\u17C1\u178F\u17D2\u179A\u1796\u17D2\u179A\u17C7"},{"id":8871,"word":"\u1796\u17D2\u179A\u17C7\u1794\u178F\u17CB"},{"id":8872,"word":"\u1796\u17D2\u179A\u17C7\u1794\u17B6\u1791"},{"id":8873,"word":"\u1796\u17D2\u179A\u17C7\u1794\u17D2\u179A\u1792\u17B6\u1793"},{"id":8874,"word":"\u1796\u17D2\u179A\u17C7\u179A\u17C6\u1784\u17B6\u1785"},{"id":8875,"word":"\u1796\u17D2\u179A\u17C7\u179F\u17D2\u178A\u17C1\u1785"},{"id":8876,"word":"\u1796\u17D2\u179A\u17C7\u179F\u17D2\u178A\u17C2\u1784"},{"id":8877,"word":"\u1796\u17D2\u179A\u17C7\u17A2\u1784\u17D2\u1780\u17C4\u179B"},{"id":8878,"word":"\u1796\u17D2\u179A\u17C7\u17A2\u1793\u17D2\u179B\u1780\u17CB"},{"id":8879,"word":"\u1796\u17D2\u179B\u17B7\u1780\u17B6\u179A"},{"id":8880,"word":"\u1796\u17D2\u179B\u17BB\u1780"},{"id":8881,"word":"\u1796\u17D2\u179B\u17C2\u1798\u17D7"},{"id":8882,"word":"\u1796\u17D2\u17A2\u17B9\u17C7"},{"id":8883,"word":"\u1796\u17C6\u1793\u178F\u17CB"},{"id":8884,"word":"\u1796\u17C6\u1793\u17BC\u1793"},{"id":8885,"word":"\u1797"},{"id":8886,"word":"\u1797\u1780\u17CB"},{"id":8887,"word":"\u1797\u17D0\u1780"},{"id":8888,"word":"\u1797\u1780\u17D2\u178A\u17B7"},{"id":8889,"word":"\u1797\u1780\u17D2\u178A\u17B8"},{"id":8890,"word":"\u1797\u1780\u17D2\u178F\u17D2\u179A"},{"id":8891,"word":"\u1797\u1780\u17D2\u179F\u17B6"},{"id":8892,"word":"\u1797\u1780\u17D2\u179F\u17B6\u17A0\u17B6\u179A"},{"id":8893,"word":"\u1797\u1782\u178E\u17D2\u178C\u179B\u17B6"},{"id":8894,"word":"\u1797\u1782\u1793\u17D2\u1791\u179A\u179A\u17C4\u1782"},{"id":8895,"word":"\u1797\u1782\u179C\u17D0\u178F"},{"id":8896,"word":"\u1797\u1782\u179C\u178F\u17B8"},{"id":8897,"word":"\u1797\u1782\u179C\u1793\u17D2\u178F"},{"id":8898,"word":"\u1797\u1782\u179C\u1793\u17D2\u178F\u1798\u17BB\u1793\u17B8"},{"id":8899,"word":"\u1797\u1782\u179C\u17B6"},{"id":8900,"word":"\u1797\u1782\u17B7\u1793\u17B8"},{"id":8901,"word":"\u1797\u1782\u17B7\u1793\u17B8\u1797\u179F\u17D2\u178A\u17B6"},{"id":8902,"word":"\u1797\u1784\u17D2\u1782\u17C8"},{"id":8903,"word":"\u1797\u1784\u17D2\u1782\u17B8"},{"id":8904,"word":"\u1797\u178E\u17D2\u178C"},{"id":8905,"word":"\u1797\u178E\u17D2\u178C\u1791\u17C1\u1799\u17D2\u1799"},{"id":8906,"word":"\u1797\u178E\u17D2\u178C\u1793\u17C8"},{"id":8907,"word":"\u1797\u178E\u17D2\u178C\u17A0\u17B6\u179F\u17B7\u1793\u17B8"},{"id":8908,"word":"\u1797\u178E\u17D2\u178C\u17B6\u1782\u17B6\u179A"},{"id":8909,"word":"\u1797\u178E\u17D2\u178C\u17B6\u1782\u17B6\u179A\u17B7\u1780"},{"id":8910,"word":"\u1797\u178E\u17D2\u178C\u17B7\u179B"},{"id":8911,"word":"\u1797\u178E\u17D2\u178C\u17BB\u1780\u1798\u17D2\u1798"},{"id":8912,"word":"\u1797\u178F\u17B7\u1780\u1798\u17D2\u1798"},{"id":8913,"word":"\u1797\u178F\u17B7\u1780\u17B6\u179A"},{"id":8914,"word":"\u1797\u178F\u17D2\u178F"},{"id":8915,"word":"\u1797\u178F\u17D2\u178F\u1780\u17B6\u179A"},{"id":8916,"word":"\u1797\u178F\u17D2\u178F\u1780\u17B6\u179B"},{"id":8917,"word":"\u1797\u178F\u17D2\u178F\u1780\u17B7\u1785\u17D2\u1785"},{"id":8918,"word":"\u1797\u178F\u17D2\u178F\u178F\u17B7\u179A\u17C2\u1780"},{"id":8919,"word":"\u1797\u178F\u17D2\u178F\u17B6\u1793\u17BB\u1798\u17C4\u1791\u1793\u17B6"},{"id":8920,"word":"\u1797\u178F\u17D2\u178F\u17B6\u1797\u17B7\u17A0\u17B6\u179A"},{"id":8921,"word":"\u1797\u178F\u17D2\u178F\u17B6\u179C\u179F\u17B6\u1793"},{"id":8922,"word":"\u1797\u178F\u17D2\u178F\u17B6\u17A0\u17B6\u179A"},{"id":8923,"word":"\u1797\u178F\u17D2\u178F\u17BB\u1791\u17D2\u1791\u17C1\u179F\u1780\u17C8"},{"id":8924,"word":"\u1797\u1791\u1793\u17D2\u178F"},{"id":8925,"word":"\u1797\u1791\u1793\u17D2\u178F\u17C1 !"},{"id":8926,"word":"\u1797\u1791\u17D2\u1791\u1780\u1794\u17D2\u1794"},{"id":8927,"word":"\u1797\u1791\u17D2\u179A\u1794\u1791"},{"id":8928,"word":"\u1797\u17D0\u1793\u17D2\u178F"},{"id":8929,"word":"\u1797\u1794\u17CB"},{"id":8930,"word":"\u1797\u1796"},{"id":8931,"word":"\u1797\u17D0\u1796\u17D2\u179C"},{"id":8932,"word":"\u1797\u1798\u179A"},{"id":8933,"word":"\u1797\u1798\u179A\u1787\u17B6\u178F\u17B7"},{"id":8934,"word":"\u1797\u1798\u179A\u17B7\u1793\u17D2\u1791"},{"id":8935,"word":"\u1797\u1798\u179A\u17B8"},{"id":8936,"word":"\u1797\u1798\u17BC"},{"id":8937,"word":"\u1797\u1799"},{"id":8938,"word":"\u1797\u17D0\u1799"},{"id":8939,"word":"\u1797\u1799\u1784\u17D2\u1780\u179A"},{"id":8940,"word":"\u1797\u1799\u1793\u17D2\u178F\u179A\u17B6\u1799"},{"id":8941,"word":"\u1797\u1799\u17B6\u1782\u178F\u17B7"},{"id":8942,"word":"\u1797\u1799\u17BC\u1794\u1791\u17D2\u179A\u1796"},{"id":8943,"word":"\u1797\u1799\u17BC\u1794\u179F\u1782\u17D2\u1782"},{"id":8944,"word":"\u1797\u179A"},{"id":8945,"word":"\u1797\u179A\u178E\u1780\u1798\u17D2\u1798"},{"id":8946,"word":"\u1797\u179A\u178E\u17B8"},{"id":8947,"word":"\u1797\u179A\u17B7\u1799\u17B6"},{"id":8948,"word":"\u1797\u179A\u17B7\u1799\u17B6\u178A"},{"id":8949,"word":"\u1797\u179A\u17B7\u1799\u17B6\u178A\u17B7\u1780"},{"id":8950,"word":"\u1797\u179A\u17B7\u1799\u17B6\u178F\u17B7\u1780\u17D2\u179A\u1798"},{"id":8951,"word":"\u1797\u179B"},{"id":8952,"word":"\u1797\u179C\u178F\u178E\u17D2\u17A0\u17B6"},{"id":8953,"word":"\u1797\u179C\u17B6\u1797\u1796"},{"id":8954,"word":"\u1797\u179F\u17D2\u178A\u17B6"},{"id":8955,"word":"\u1797\u179F\u17D2\u178A\u17BB"},{"id":8956,"word":"\u1797\u179F\u17D2\u178F\u17D2\u179A\u17B6"},{"id":8957,"word":"\u1797\u179F\u17D2\u1798\u1780\u17B6\u179A"},{"id":8958,"word":"\u1797\u17B6\u1782"},{"id":8959,"word":"\u1797\u17B6\u1782"},{"id":8960,"word":"\u1797\u17B6\u1782\u17B7\u1793\u17C1\u1799\u17D2\u1799"},{"id":8961,"word":"\u1797\u17B6\u1782\u17B7\u1793\u17C1\u1799\u17D2\u1799\u17B6"},{"id":8962,"word":"\u1797\u17B6\u1787\u1793\u17C8"},{"id":8963,"word":"\u1797\u17B6\u1787\u1793\u1797\u178E\u17D2\u178C"},{"id":8964,"word":"\u1797\u17B6\u1787\u1793\u179C\u17B7\u179F\u17C1\u179F"},{"id":8965,"word":"\u1797\u17B6\u1787\u1793\u17B8\u1799\u1797\u178E\u17D2\u178C"},{"id":8966,"word":"\u1797\u17B6\u178E"},{"id":8967,"word":"\u1797\u17B6\u178E\u179C\u17B6\u179A"},{"id":8968,"word":"\u1797\u17B6\u178E\u17BB"},{"id":8969,"word":"\u1797\u17B6\u178E\u17BB\u1798\u17B6"},{"id":8970,"word":"\u1797\u17B6\u178F\u179A\u1797\u17B6\u1796"},{"id":8971,"word":"\u1797\u17B6\u178F\u17B6"},{"id":8972,"word":"\u1797\u17B6\u178F\u17BB\u1794\u17BB\u178F\u17D2\u178F"},{"id":8973,"word":"\u1797\u17B6\u178F\u17BB\u1797\u17B6\u1796"},{"id":8974,"word":"\u1797\u17B6\u1793"},{"id":8975,"word":"\u1797\u17B6\u1793\u17CB"},{"id":8976,"word":"\u1797\u17B6\u1793\u17BB"},{"id":8977,"word":"\u1797\u17B6\u1796"},{"id":8978,"word":"\u1797\u17B6\u1796\u1799\u1793\u17D2\u178F"},{"id":8979,"word":"\u1797\u17B6\u1799"},{"id":8980,"word":"\u1797\u17B6\u179A"},{"id":8981,"word":"\u1797\u17B6\u179A\u17C8"},{"id":8982,"word":"\u1797\u17B6\u179A\u178F"},{"id":8983,"word":"\u1797\u17B6\u179A\u178F\u1799\u17BB\u1791\u17D2\u1792"},{"id":8984,"word":"\u1797\u17B6\u179A\u1792\u17B6\u179A\u17B8"},{"id":8985,"word":"\u1797\u17B6\u179A\u17B6"},{"id":8986,"word":"\u1797\u17B6\u179C"},{"id":8987,"word":"\u1797\u17B6\u179C"},{"id":8988,"word":"\u1797\u17B6\u179C\u1793\u17B6"},{"id":8989,"word":"\u1797\u17B6\u179C\u1793\u17BC\u1794\u1793\u17B7\u179F\u17D2\u179F\u17D0\u1799"},{"id":8990,"word":"\u1797\u17B6\u179C\u179A\u17BC\u1794"},{"id":8991,"word":"\u1797\u17B6\u179F\u17B6"},{"id":8992,"word":"\u1797\u17B6\u179F\u17B6\u1794\u179A\u17B7\u179C\u178F\u17D2\u178F\u1780\u17C8"},{"id":8993,"word":"\u1797\u17B6\u179F\u17B6\u1794\u179A\u17B7\u179C\u178F\u17D2\u178F\u1793\u17CD"},{"id":8994,"word":"\u1797\u17B6\u179F\u17B7\u178F"},{"id":8995,"word":"\u1797\u17B6\u179F\u17CA\u17B8"},{"id":8996,"word":"\u1797\u17B7\u1780\u17D2\u1781\u179C\u17C4  !"},{"id":8997,"word":"\u1797\u17B7\u1780\u17D2\u1781\u17B6"},{"id":8998,"word":"\u1797\u17B7\u1780\u17D2\u1781\u17BB"},{"id":8999,"word":"\u1797\u17B7\u1780\u17D2\u1781\u17BB\u1793\u17B8"},{"id":9000,"word":"\u1797\u17B7\u178F"},{"id":9001,"word":"\u1797\u17B7\u1793"},{"id":9002,"word":"\u1797\u17B7\u1793\u17D2\u1793\u1794\u17B7\u178F\u17BB\u1780"},{"id":9003,"word":"\u1797\u17B7\u1793\u17D2\u1793\u17C4\u1791\u179A"},{"id":9004,"word":"\u1797\u17B7\u1799\u17D2\u1799\u17C4"},{"id":9005,"word":"\u1797\u17B7\u1799\u17D2\u1799\u17C4\u1797\u17B6\u1796"},{"id":9006,"word":"\u1797\u17B7\u179B"},{"id":9007,"word":"\u1797\u17B7\u179F\u179C\u1784\u17CB"},{"id":9008,"word":"\u1797\u17B8"},{"id":9009,"word":"\u1797\u17B8\u1784"},{"id":9010,"word":"\u1797\u17B8\u179B\u1797\u179B"},{"id":9011,"word":"\u1797\u17B8\u179B\u17C0\u1784"},{"id":9012,"word":"\u1797\u17B9\u1784"},{"id":9013,"word":"\u1797\u17B9\u1794"},{"id":9014,"word":"\u1797\u17B9\u179B"},{"id":9015,"word":"\u1797\u17BA\u178F\u17D7"},{"id":9016,"word":"\u1797\u17BA\u1793"},{"id":9017,"word":"\u1797\u17BA\u179F"},{"id":9018,"word":"\u1797\u17BB\u1784"},{"id":9019,"word":"\u1797\u17BB\u1787\u1784\u17D2\u1782"},{"id":9020,"word":"\u1797\u17BB\u1787\u1784\u17D2\u1782\u179B\u17B8\u179B\u17B6"},{"id":9021,"word":"\u1797\u17BB\u1787\u17B7\u179F\u17D2\u179F\u1787\u1793"},{"id":9022,"word":"\u1797\u17BB\u1787\u17B7\u179F\u17D2\u179F\u178F\u17B6"},{"id":9023,"word":"\u1797\u17BB\u178F\u17D2\u178F\u179F\u17C1\u179F"},{"id":9024,"word":"\u1797\u17BB\u1798\u17D2\u1798\u1791\u17C1\u179C\u178F\u17B6"},{"id":9025,"word":"\u1797\u17BB\u1799"},{"id":9026,"word":"\u1797\u17BB\u179B"},{"id":9027,"word":"\u1797\u17BC"},{"id":9028,"word":"\u1797\u17BC\u1782\u17C4\u179B"},{"id":9029,"word":"\u1797\u17BC\u1788\u17BD\u1799"},{"id":9030,"word":"\u1797\u17BC\u178F"},{"id":9031,"word":"\u1797\u17BC\u178F\u1780\u17B6\u179B"},{"id":9032,"word":"\u1797\u17BC\u178F\u1782\u17B6\u1798"},{"id":9033,"word":"\u1797\u17BC\u178F\u1796\u17C1\u1791\u17D2\u1799"},{"id":9034,"word":"\u1797\u17BC\u178F\u179A\u17BC\u1794"},{"id":9035,"word":"\u1797\u17BC\u1792\u1793"},{"id":9036,"word":"\u1797\u17BC\u1792\u179A"},{"id":9037,"word":"\u1797\u17BC\u1794\u17B6\u179B"},{"id":9038,"word":"\u1797\u17BC\u1798"},{"id":9039,"word":"\u1797\u17BC\u1798\u1791\u17C1\u179C\u178F\u17B6"},{"id":9040,"word":"\u1797\u17BC\u1798\u179A\u17B6"},{"id":9041,"word":"\u1797\u17BC\u1798\u179A\u17B7\u1793\u17D2\u1791"},{"id":9042,"word":"\u1797\u17BC\u1798\u17B6"},{"id":9043,"word":"\u1797\u17BC\u1798\u17B7"},{"id":9044,"word":"\u1797\u17BC\u1798\u17B7\u1793\u17D2\u1791"},{"id":9045,"word":"\u1797\u17BC\u1798\u17B7\u1794\u17B6\u179B"},{"id":9046,"word":"\u1797\u17BC\u1798\u17B7\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":9047,"word":"\u1797\u17BC\u1798\u17B8"},{"id":9048,"word":"\u1797\u17BC\u1798\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":9049,"word":"\u1797\u17BC\u1798\u17C4"},{"id":9050,"word":"\u1797\u17BC\u179C\u1793\u17D0\u1799"},{"id":9051,"word":"\u1797\u17BC\u179C\u17B6\u17C6\u1784"},{"id":9052,"word":"\u1797\u17BC\u179F"},{"id":9053,"word":"\u1797\u17BC\u179F\u17B6"},{"id":9054,"word":"\u1797\u17BC\u179F\u17B6\u1798\u17B6\u179B\u17B6"},{"id":9055,"word":"\u1797\u17BC\u17C7"},{"id":9056,"word":"\u1797\u17BD\u1784"},{"id":9057,"word":"\u1797\u17BD\u1799"},{"id":9058,"word":"\u1797\u17BE"},{"id":9059,"word":"\u1797\u17BE\u1785"},{"id":9060,"word":"\u1797\u17BE\u178F\u17D7"},{"id":9061,"word":"\u1797\u17BF\u1793"},{"id":9062,"word":"\u1797\u17C0\u179F"},{"id":9063,"word":"\u1797\u17C1"},{"id":9064,"word":"\u1797\u17C1\u1787\u17D2\u1787\u179A\u17BC\u1794"},{"id":9065,"word":"\u1797\u17C1\u178F\u17D2\u179A\u17B6"},{"id":9066,"word":"\u1797\u17C1\u1791"},{"id":9067,"word":"\u1797\u17C1\u179A\u179C\u17C8"},{"id":9068,"word":"\u1797\u17C1\u179A\u17B8"},{"id":9069,"word":"\u1797\u17C1\u179B"},{"id":9070,"word":"\u1797\u17C1\u179F\u1787\u17D2\u1787"},{"id":9071,"word":"\u1797\u17C2\u179B\u1797\u179B"},{"id":9072,"word":"\u1797\u17C4\u1780\u17D2\u178A\u17B6"},{"id":9073,"word":"\u1797\u17C4\u1782"},{"id":9074,"word":"\u1797\u17C4\u1782\u179F\u1798\u17D2\u1794\u17D0\u1791"},{"id":9075,"word":"\u1797\u17C4\u1787\u1793"},{"id":9076,"word":"\u1797\u17C4\u1787\u1793\u17B6\u1782\u17B6\u179A"},{"id":9077,"word":"\u1797\u17C4\u1787\u1793\u17B6\u17A0\u17B6\u179A"},{"id":9078,"word":"\u1797\u17C4\u1787\u1793\u17B8\u1799"},{"id":9079,"word":"\u1797\u17C4\u1787\u1793\u17B8\u1799\u179F\u17C4\u1797\u17D0\u178E"},{"id":9080,"word":"\u1797\u17C4\u1787\u1793\u17B8\u1799\u17B6\u17A0\u17B6\u179A"},{"id":9081,"word":"\u1797\u17C4\u1787\u17D2\u1787\u1797\u17D0\u179F\u17D2\u178F\u17BB"},{"id":9082,"word":"\u1797\u17C4\u1787\u17D2\u1787\u179F\u17B6\u179B\u17B8"},{"id":9083,"word":"\u1797\u17C4\u1798\u17B8\u179A\u17B6"},{"id":9084,"word":"\u1797\u17C4\u179A\u1797\u17B6\u179C"},{"id":9085,"word":"\u1797\u17BB\u17C6\u1797\u17BF\u1793"},{"id":9086,"word":"\u1797\u17B6\u17C6\u1784"},{"id":9087,"word":"\u1797\u17D2\u1784\u1780\u17CB\u17D7"},{"id":9088,"word":"\u1797\u17D2\u1784\u1794\u17CB"},{"id":9089,"word":"\u1797\u17D2\u1784\u17B6"},{"id":9090,"word":"\u1797\u17D2\u1784\u17B6\u1794\u17D2\u179A\u17B7\u1799"},{"id":9091,"word":"\u1797\u17D2\u1784\u17B6\u179A"},{"id":9092,"word":"\u1797\u17D2\u1784\u17B6\u179F"},{"id":9093,"word":"\u1797\u17D2\u1784\u17BC\u178F"},{"id":9094,"word":"\u1797\u17D2\u1784\u17BE\u1780\u17D7"},{"id":9095,"word":"\u1797\u17D2\u1784\u17BE\u1799"},{"id":9096,"word":"\u1797\u17D2\u1784\u17C6"},{"id":9097,"word":"\u1797\u17D2\u1787\u1784\u17CB"},{"id":9098,"word":"\u1797\u17D2\u1787\u179A"},{"id":9099,"word":"\u1797\u17D2\u1787\u17D0\u179A"},{"id":9100,"word":"\u1797\u17D2\u1787\u179B\u17CB"},{"id":9101,"word":"\u1797\u17D2\u1787\u17B6\u1794\u17CB"},{"id":9102,"word":"\u1797\u17D2\u1787\u17B7\u178F"},{"id":9103,"word":"\u1797\u17D2\u1787\u17BD\u179A"},{"id":9104,"word":"\u1797\u17D2\u1787\u17BE\u1789"},{"id":9105,"word":"\u1797\u17D2\u1787\u17C4\u1780"},{"id":9106,"word":"\u1797\u17D2\u1787\u17BB\u17C6"},{"id":9107,"word":"\u1797\u17D2\u1787\u17B6\u17C6"},{"id":9108,"word":"\u1797\u17D2\u1789\u1785\u17CB"},{"id":9109,"word":"\u1797\u17D2\u1789\u179B\u17CB"},{"id":9110,"word":"\u1797\u17D2\u1789\u17B6\u1780\u17CB"},{"id":9111,"word":"\u1797\u17D2\u1789\u17B6\u179F\u17CB"},{"id":9112,"word":"\u1797\u17D2\u1789\u17B8"},{"id":9113,"word":"\u1797\u17D2\u1789\u17B8\u1791\u17C0\u1793"},{"id":9114,"word":"\u1797\u17D2\u1789\u17C0\u179C"},{"id":9115,"word":"\u1797\u17D2\u1793\u1780"},{"id":9116,"word":"\u1797\u17D2\u1793\u1780\u17CB"},{"id":9117,"word":"\u1797\u17D2\u1793\u17B6\u1780\u17CB\u1784\u17B6\u179A"},{"id":9118,"word":"\u1797\u17D2\u1793\u17B6\u1780\u17CB\u178A\u17C3"},{"id":9119,"word":"\u1797\u17D2\u1793\u17B6\u1793"},{"id":9120,"word":"\u1797\u17D2\u1793\u17B6\u179B\u17CB"},{"id":9121,"word":"\u1797\u17D2\u1793\u17B6\u179F"},{"id":9122,"word":"\u1797\u17D2\u1793\u17BE\u1793"},{"id":9123,"word":"\u1797\u17D2\u1793\u17C1\u1793"},{"id":9124,"word":"\u1797\u17D2\u1793\u17C2\u1780"},{"id":9125,"word":"\u1797\u17D2\u1793\u17C2\u1780\u1780\u17D2\u179A\u17BD\u1785"},{"id":9126,"word":"\u1797\u17D2\u1793\u17C2\u1780\u1782\u17C4\u179A"},{"id":9127,"word":"\u1797\u17D2\u1793\u17C2\u1780\u1786\u17D2\u1798\u17B6"},{"id":9128,"word":"\u1797\u17D2\u1793\u17C2\u1780\u1787\u1789\u17D2\u1787\u17B8\u1784"},{"id":9129,"word":"\u1797\u17D2\u1793\u17C2\u1780\u1796\u17D2\u179A\u17B6\u1794"},{"id":9130,"word":"\u1797\u17D2\u1793\u17C2\u1780\u1798\u17B6\u1793\u17CB"},{"id":9131,"word":"\u1797\u17D2\u1793\u17C2\u1793"},{"id":9132,"word":"\u1797\u17D2\u1793\u17C2\u179B"},{"id":9133,"word":"\u1797\u17D2\u1793\u17C6"},{"id":9134,"word":"\u1797\u17D2\u1793\u17C6\u1780\u17D2\u179A\u179C\u17B6\u1789"},{"id":9135,"word":"\u1797\u17D2\u1793\u17C6\u1781\u17D2\u179F\u17B6\u1785\u17CB"},{"id":9136,"word":"\u1797\u17D2\u1793\u17C6\u1796\u17C1\u1789"},{"id":9137,"word":"\u1797\u17D2\u1793\u17C6\u1797\u17D2\u1793\u17C2\u1784"},{"id":9138,"word":"\u1797\u17D2\u1793\u17C6\u1799\u17C4\u1784"},{"id":9139,"word":"\u1797\u17D2\u1793\u17C6\u179F\u17D2\u179A\u17BB\u1780"},{"id":9140,"word":"\u1797\u17D2\u1793\u17C6\u179F\u17D2\u179A\u17BC\u179C"},{"id":9141,"word":"\u1797\u17D2\u1793\u17C6\u179F\u17D2\u179A\u17BD\u1785"},{"id":9142,"word":"\u1797\u17D2\u1793\u17B6\u17C6"},{"id":9143,"word":"\u1797\u17D2\u1798\u17B6\u179F"},{"id":9144,"word":"\u1797\u17D2\u179A\u1798\u179A"},{"id":9145,"word":"\u1797\u17D2\u179A\u17B9\u178F\u1780"},{"id":9146,"word":"\u1797\u17D2\u179A\u17BB\u179F"},{"id":9147,"word":"\u1797\u17D2\u179A\u17BC\u178E"},{"id":9148,"word":"\u1797\u17D2\u179B\u1780\u17CB"},{"id":9149,"word":"\u1797\u17D2\u179B\u1784"},{"id":9150,"word":"\u1797\u17D2\u179B\u1793"},{"id":9151,"word":"\u1797\u17D2\u179B\u1799"},{"id":9152,"word":"\u1797\u17D2\u179B\u17B6"},{"id":9153,"word":"\u1797\u17D2\u179B\u17B6\u1784"},{"id":9154,"word":"\u1797\u17D2\u179B\u17B6\u178F\u17CB"},{"id":9155,"word":"\u1797\u17D2\u179B\u17B6\u1798"},{"id":9156,"word":"\u1797\u17D2\u179B\u17B6\u179C"},{"id":9157,"word":"\u1797\u17D2\u179B\u17B6\u179F"},{"id":9158,"word":"\u1797\u17D2\u179B\u17B8\u1797\u17D2\u179B\u17BE"},{"id":9159,"word":"\u1797\u17D2\u179B\u17B8\u17C7\u1797\u17D2\u179B\u17C2\u17C7"},{"id":9160,"word":"\u1797\u17D2\u179B\u17B9\u1780"},{"id":9161,"word":"\u1797\u17D2\u179B\u17B9\u1784"},{"id":9162,"word":"\u1797\u17D2\u179B\u17B9\u1794"},{"id":9163,"word":"\u1797\u17D2\u179B\u17B9\u1798\u17D7 "},{"id":9164,"word":"\u1797\u17D2\u179B\u17B9\u17C7\u17D7"},{"id":9165,"word":"\u1797\u17D2\u179B\u17BA"},{"id":9166,"word":"\u1797\u17D2\u179B\u17BB\u1780"},{"id":9167,"word":"\u1797\u17D2\u179B\u17BB\u1784"},{"id":9168,"word":"\u1797\u17D2\u179B\u17BC"},{"id":9169,"word":"\u1797\u17D2\u179B\u17BC\u1780"},{"id":9170,"word":"\u1797\u17D2\u179B\u17BC\u1785"},{"id":9171,"word":"\u1797\u17D2\u179B\u17BD\u178F"},{"id":9172,"word":"\u1797\u17D2\u179B\u17BE"},{"id":9173,"word":"\u1797\u17D2\u179B\u17BE\u1780\u17D7"},{"id":9174,"word":"\u1797\u17D2\u179B\u17BE\u1784"},{"id":9175,"word":"\u1797\u17D2\u179B\u17BE\u178F\u1797\u17D2\u179B\u17BE\u1793"},{"id":9176,"word":"\u1797\u17D2\u179B\u17BE\u1793"},{"id":9177,"word":"\u1797\u17D2\u179B\u17BE\u1799"},{"id":9178,"word":"\u1797\u17D2\u179B\u17C0\u1780"},{"id":9179,"word":"\u1797\u17D2\u179B\u17C0\u1784"},{"id":9180,"word":"\u1797\u17D2\u179B\u17C1\u1784"},{"id":9181,"word":"\u1797\u17D2\u179B\u17C1\u1785"},{"id":9182,"word":"\u1797\u17D2\u179B\u17C2\u178F"},{"id":9183,"word":"\u1797\u17D2\u179B\u17C2\u1798\u17D7"},{"id":9184,"word":"\u1797\u17D2\u179B\u17C2\u179B"},{"id":9185,"word":"\u1797\u17D2\u179B\u17C4\u17C7"},{"id":9186,"word":"\u1797\u17D2\u179B\u17C5"},{"id":9187,"word":"\u1797\u17D2\u179B\u17C5\u1780\u1784\u17D2\u1780\u17C2\u1794"},{"id":9188,"word":"\u1797\u17D2\u179B\u17C5\u1780\u17D2\u1784\u17C4\u1780"},{"id":9189,"word":"\u1797\u17D2\u179B\u17C5\u1793\u17B6\u1784"},{"id":9190,"word":"\u1797\u17D2\u179B\u17B6\u17C6\u1784"},{"id":9191,"word":"\u1797\u17D2\u179F\u17B6\u17C6"},{"id":9192,"word":"\u1798"},{"id":9193,"word":"\u1798\u17CF"},{"id":9194,"word":"\u1798\u1780"},{"id":9195,"word":"\u1798\u17C9\u1780"},{"id":9196,"word":"\u1798\u17C9\u1780\u17CB"},{"id":9197,"word":"\u1798\u17C9\u1780\u17CB\u17D7"},{"id":9198,"word":"\u1798\u1780\u179A"},{"id":9199,"word":"\u1798\u1780\u179A"},{"id":9200,"word":"\u1798\u1780\u179A\u1793\u17D2\u1791"},{"id":9201,"word":"\u1798\u1780\u17B6"},{"id":9202,"word":"\u1798\u1780\u17B6\u179A\u1793\u17D2\u178F"},{"id":9203,"word":"\u1798\u1780\u17BB\u178A"},{"id":9204,"word":"\u1798\u1780\u17D2\u1781\u1787\u1793"},{"id":9205,"word":"\u1798\u1780\u17D2\u179B\u17BF"},{"id":9206,"word":"\u1798\u1780\u17D2\u179B\u17B6\u17C6"},{"id":9207,"word":"\u1798\u1782\u1792\u17C8"},{"id":9208,"word":"\u1798\u1782\u1792\u1796\u17B6\u1780\u17D2\u1799"},{"id":9209,"word":"\u1798\u1782\u1792\u1797\u17B6\u179F\u17B6"},{"id":9210,"word":"\u1798\u1782\u1792\u179A\u178A\u17D2\u178B"},{"id":9211,"word":"\u1798\u1782\u17D2\u1782"},{"id":9212,"word":"\u1798\u1782\u17D2\u1782\u1791\u17C1\u179F\u1780\u17CD"},{"id":9213,"word":"\u1798\u1782\u17D2\u1782\u1793\u1780\u1798\u17D2\u1798"},{"id":9214,"word":"\u1798\u1782\u17D2\u1782\u1793\u17B6\u1799\u1780"},{"id":9215,"word":"\u1798\u1783\u179C\u17D0\u178F"},{"id":9216,"word":"\u1798\u1783\u179C\u17B6"},{"id":9217,"word":"\u1798\u1784"},{"id":9218,"word":"\u1798\u17C9\u1784\u17CB\u17D7"},{"id":9219,"word":"\u1798\u1784\u17D2\u1780\u17BB\u1797\u17B6\u1796"},{"id":9220,"word":"\u1798\u1784\u17D2\u1780\u17BB\u1797\u17BC\u178F"},{"id":9221,"word":"\u1798\u1784\u17D2\u1782\u179B"},{"id":9222,"word":"\u1798\u1784\u17D2\u1782\u179B\u1791\u17C1\u1796\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":9223,"word":"\u1798\u1784\u17D2\u1782\u179B\u1794\u17BB\u179A\u17B8"},{"id":9224,"word":"\u1798\u1784\u17D2\u1783\u17BB\u178F"},{"id":9225,"word":"\u1798\u1785\u17D2\u1785\u17BB"},{"id":9226,"word":"\u1798\u1785\u17D2\u1786\u1787\u17B6\u178F\u17B7"},{"id":9227,"word":"\u1798\u1785\u17D2\u1786\u178E\u17D2\u178C\u179F\u1789\u17D2\u1789\u17B6"},{"id":9228,"word":"\u1798\u1785\u17D2\u1786\u1796\u17D0\u1793\u17D2\u1792"},{"id":9229,"word":"\u1798\u1785\u17D2\u1786\u179A\u17B7\u1799"},{"id":9230,"word":"\u1798\u1785\u17D2\u1786\u179A\u17B8"},{"id":9231,"word":"\u1798\u1785\u17D2\u1786\u17B6"},{"id":9232,"word":"\u1798\u1785\u17D2\u1786\u17B6\u1793\u17BB"},{"id":9233,"word":"\u1798\u1785\u17D2\u1786\u17C1\u179A\u1785\u17B7\u178F\u17D2\u178F"},{"id":9234,"word":"\u1798\u17C9\u1786\u17C2"},{"id":9235,"word":"\u1798\u1787\u17D2\u1787"},{"id":9236,"word":"\u1798\u1787\u17D2\u1787\u17B6\u179A"},{"id":9237,"word":"\u1798\u1787\u17D2\u1788\u178A\u17D2\u178B\u17B6\u1793"},{"id":9238,"word":"\u1798\u1787\u17D2\u1788\u178F\u17D2\u178F\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD"},{"id":9239,"word":"\u1798\u1787\u17D2\u1788\u1793\u17D2\u178F\u17B7\u1780\u1780\u17B6\u179B"},{"id":9240,"word":"\u1798\u1787\u17D2\u1788\u1798\u178E\u17D2\u178C\u179B"},{"id":9241,"word":"\u1798\u1787\u17D2\u1788\u17B7\u1798"},{"id":9242,"word":"\u1798\u1787\u17D2\u1788\u17C1\u179B\u17BB\u1794"},{"id":9243,"word":"\u1798\u1788\u17BC\u179F"},{"id":9244,"word":"\u1798\u1789\u17D2\u1787\u17B7\u1780\u17B6"},{"id":9245,"word":"\u1798\u1789\u17D2\u1787\u17BC\u179F\u17B6"},{"id":9246,"word":"\u1798\u1789\u17D2\u1787\u17C1\u178A\u17D2\u178B"},{"id":9247,"word":"\u1798\u17C9\u178A\u17D2\u178A"},{"id":9248,"word":"\u1798\u178E\u17B8"},{"id":9249,"word":"\u1798\u178E\u17D2\u178C\u1793\u1797\u178E\u17D2\u178C"},{"id":9250,"word":"\u1798\u178E\u17D2\u178C\u1794"},{"id":9251,"word":"\u1798\u178E\u17D2\u178C\u179B"},{"id":9252,"word":"\u1798\u178E\u17D2\u178C\u179B\u1782\u17B7\u179A\u17B8"},{"id":9253,"word":"\u1798\u178E\u17D2\u178C\u179B\u179C\u17B6\u178F"},{"id":9254,"word":"\u1798\u178E\u17D2\u178C\u17BB\u1780\u178A"},{"id":9255,"word":"\u1798\u178F\u17CB"},{"id":9256,"word":"\u1798\u178F\u1780"},{"id":9257,"word":"\u1798\u17C9\u178F\u17CB"},{"id":9258,"word":"\u1798\u17C9\u178F\u17CB\u1785\u178F\u17CB"},{"id":9259,"word":"\u1798\u17C9\u178F\u17CB\u1798\u17C9\u1784"},{"id":9260,"word":"\u1798\u178F\u17B7"},{"id":9261,"word":"\u1798\u178F\u17D2\u178F\u1789\u17D2\u1789\u17BB\u178F\u17B6"},{"id":9262,"word":"\u1798\u178F\u17D2\u178F\u1789\u17D2\u1789\u17BC"},{"id":9263,"word":"\u1798\u178F\u17D2\u178F\u17B7\u1780\u17B6"},{"id":9264,"word":"\u1798\u178F\u17D2\u178F\u17C1\u1799\u17D2\u1799\u1780\u17C8"},{"id":9265,"word":"\u1798\u1791\u17D2\u1791\u179A\u178A\u17D2\u178B"},{"id":9266,"word":"\u1798\u1791\u17D2\u179A\u17B8"},{"id":9267,"word":"\u1798\u1791\u17D2\u179A\u17B8\u1794\u17B6\u1796\u17CC"},{"id":9268,"word":"\u1798\u1792\u17BB"},{"id":9269,"word":"\u1798\u1792\u17BB\u1798\u17C1\u17A0\u17C8"},{"id":9270,"word":"\u1798\u1792\u17BB\u179A\u17C8"},{"id":9271,"word":"\u1798\u1792\u17BB\u179A\u179F"},{"id":9272,"word":"\u1798\u1792\u17BB\u179A\u17C4\u1791\u1780"},{"id":9273,"word":"\u1798\u1792\u17D2\u1799\u17D0\u178F"},{"id":9274,"word":"\u1798\u1792\u17D2\u1799\u1798"},{"id":9275,"word":"\u1798\u1792\u17D2\u1799\u17C4\u1794\u17B6\u1799"},{"id":9276,"word":"\u1798\u1793"},{"id":9277,"word":"\u1798\u1793\u179F\u17B7\u1780\u17B6\u179A"},{"id":9278,"word":"\u1798\u1793\u179F\u17D2\u1780\u17B6\u179A"},{"id":9279,"word":"\u1798\u1793\u17B6\u1794\u17C8"},{"id":9280,"word":"\u1798\u1793\u17BB"},{"id":9281,"word":"\u1798\u1793\u17BB\u1787\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":9282,"word":"\u1798\u1793\u17BB\u1787\u17B7\u1793\u17D2\u1791"},{"id":9283,"word":"\u1798\u1793\u17BB\u1789\u17D2\u1789"},{"id":9284,"word":"\u1798\u1793\u17BB\u179F\u17B6\u179A"},{"id":9285,"word":"\u1798\u1793\u17BB\u179F\u17D2\u179F"},{"id":9286,"word":"\u1798\u1793\u17BC\u179F\u17B6\u179A"},{"id":9287,"word":"\u1798\u1793\u17C4"},{"id":9288,"word":"\u1798\u1793\u17C4\u179F\u17B6\u179A"},{"id":9289,"word":"\u1798\u1793\u17C4\u179F\u17B7\u179B\u17B6"},{"id":9290,"word":"\u1798\u1793\u17D2\u178F"},{"id":9291,"word":"\u1798\u1793\u17D2\u178F\u17D2\u179A\u179C\u17B7\u178F"},{"id":9292,"word":"\u1798\u1793\u17D2\u178F\u17D2\u179A\u17B8"},{"id":9293,"word":"\u1798\u1793\u17D2\u1791\u179B\u17C1\u1793"},{"id":9294,"word":"\u1798\u1793\u17D2\u1791\u17B6\u179A"},{"id":9295,"word":"\u1798\u1793\u17D2\u1791\u17B7\u179B"},{"id":9296,"word":"\u1798\u1793\u17D2\u1791\u17B8\u179A"},{"id":9297,"word":"\u1798\u1793\u17D2\u1791\u17B8\u179A\u1794\u17B6\u179B"},{"id":9298,"word":"\u1798\u1793\u17D2\u1791\u17BB\u179A\u17B6"},{"id":9299,"word":"\u1798\u1793\u17D2\u1791\u17C4\u1791\u179A\u17B8"},{"id":9300,"word":"\u1798\u17C9\u1794"},{"id":9301,"word":"\u1798\u1798\u1784\u17CB"},{"id":9302,"word":"\u1798\u1798\u1784\u17D2\u1780\u17B6\u179A"},{"id":9303,"word":"\u1798\u1798\u17B6\u1785"},{"id":9304,"word":"\u1798\u1798\u17B6\u1789"},{"id":9305,"word":"\u1798\u1798\u17B6\u1789\u17B9\u1780"},{"id":9306,"word":"\u1798\u1798\u17B6\u1799"},{"id":9307,"word":"\u1798\u1798\u17B6\u179B"},{"id":9308,"word":"\u1798\u1798\u17B7\u1784\u1798\u1798\u17B6\u17C6\u1784"},{"id":9309,"word":"\u1798\u1798\u17B7\u1785\u1798\u1798\u17C0\u179C"},{"id":9310,"word":"\u1798\u1798\u17B8"},{"id":9311,"word":"\u1798\u1798\u17B8\u179F"},{"id":9312,"word":"\u1798\u1798\u17B9\u17C7"},{"id":9313,"word":"\u1798\u1798\u17BB\u179B"},{"id":9314,"word":"\u1798\u1798\u17BE"},{"id":9315,"word":"\u1798\u1798\u17BE\u1780"},{"id":9316,"word":"\u1798\u1798\u17C0\u179A"},{"id":9317,"word":"\u1798\u1798\u17C9\u17C1\u17C7\u1798\u1798\u17C9\u17C4\u17C7"},{"id":9318,"word":"\u1798\u1798\u17C2"},{"id":9319,"word":"\u1798\u1798\u17C3"},{"id":9320,"word":"\u1798\u1798\u17C4\u1780"},{"id":9321,"word":"\u1798\u1798\u17C6\u1780\u17B6\u179A"},{"id":9322,"word":"\u1798\u1799\u17B8"},{"id":9323,"word":"\u1798\u1799\u17BC\u179A"},{"id":9324,"word":"\u1798\u1799\u17BC\u179A\u1786\u178F\u17D2\u179A "},{"id":9325,"word":"\u1798\u179A"},{"id":9326,"word":"\u1798\u179A\u1780\u178F"},{"id":9327,"word":"\u1798\u179A\u178A\u1780"},{"id":9328,"word":"\u1798\u179A\u178E\u17C8"},{"id":9329,"word":"\u1798\u179A\u178E"},{"id":9330,"word":"\u1798\u179A\u178E\u17B6"},{"id":9331,"word":"\u1798\u179A\u178E\u17BB\u1794\u17B6\u1799"},{"id":9332,"word":"\u1798\u179A\u178F\u1780"},{"id":9333,"word":"\u1798\u179A\u17BB\u1780\u1793\u17D2\u178F\u17B6\u179A"},{"id":9334,"word":"\u1798\u179B\u1780\u17D2\u1780\u17B6"},{"id":9335,"word":"\u1798\u179B\u17C9\u17B6\u1799\u17BC"},{"id":9336,"word":"\u1798\u179B\u17D2\u179B"},{"id":9337,"word":"\u1798\u179B\u17D2\u179B\u17B7\u1780\u17B6"},{"id":9338,"word":"\u1798\u179F\u17B6\u179A\u1782\u179B\u17D2\u179B"},{"id":9339,"word":"\u1798\u179F\u17B7"},{"id":9340,"word":"\u1798\u179F\u17D2\u179F\u17BB"},{"id":9341,"word":"\u1798\u17A0\u1780\u1798\u17D2\u1798"},{"id":9342,"word":"\u1798\u17A0\u178E\u17D2\u178E\u1796"},{"id":9343,"word":"\u1798\u17A0\u1791\u17D2\u1792\u1793"},{"id":9344,"word":"\u1798\u17A0\u1793\u17D2\u178F"},{"id":9345,"word":"\u1798\u17A0\u1793\u17D2\u1792\u1780\u17B6\u179A"},{"id":9346,"word":"\u1798\u17A0\u1799\u17D2\u1799\u1780\u17C4"},{"id":9347,"word":"\u1798\u17A0\u1799\u17D2\u1799\u1780\u17B6"},{"id":9348,"word":"\u1798\u17A0\u179B\u17D2\u179B\u1780\u17C8"},{"id":9349,"word":"\u1798\u17A0\u179B\u17D2\u179B\u1780\u1797\u17B6\u1796"},{"id":9350,"word":"\u1798\u17A0\u179F\u17D2\u1785\u17B6\u179A\u17D2\u1799"},{"id":9351,"word":"\u1798\u17A0\u17B6"},{"id":9352,"word":"\u1798\u17A0\u17B6 --"},{"id":9353,"word":"\u1798\u17A0\u17B6\u1780\u1790\u17B6\u1793\u17C8"},{"id":9354,"word":"\u1798\u17A0\u17B6\u178F"},{"id":9355,"word":"\u1798\u17A0\u17B6\u178F\u1790\u17C3"},{"id":9356,"word":"\u1798\u17A0\u17B6\u178F\u179B\u17B7\u1780"},{"id":9357,"word":"\u1798\u17A0\u17B6\u178F\u17D2\u179A\u1780\u17B6\u179B"},{"id":9358,"word":"\u1798\u17A0\u17B6\u178F\u17D2\u179A\u179F\u17C4\u179B"},{"id":9359,"word":"\u1798\u17A0\u17B6\u1790\u17C3"},{"id":9360,"word":"\u1798\u17A0\u17B6\u1790\u17D2\u179B\u17C3"},{"id":9361,"word":"\u1798\u17A0\u17B6\u1794\u17BB\u179A\u17B7\u179F\u179B\u1780\u17D2\u1781\u178E\u17C8"},{"id":9362,"word":"\u1798\u17A0\u17B6\u1795\u17D2\u1791\u17C3"},{"id":9363,"word":"\u1798\u17A0\u17B6\u1797\u17B6\u179A\u178F\u17C8"},{"id":9364,"word":"\u1798\u17A0\u17B6\u1797\u17B6\u179A\u178F\u1799\u17BB\u1791\u17D2\u1792"},{"id":9365,"word":"\u1798\u17A0\u17B6\u1798\u17C9\u17B6\u178F\u17CB"},{"id":9366,"word":"\u1798\u17A0\u17B6\u179A\u179B\u17B6\u1799"},{"id":9367,"word":"\u1798\u17A0\u17B6\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A\u17B8"},{"id":9368,"word":"\u1798\u17A0\u17B6\u179A\u17B8\u1780"},{"id":9369,"word":"\u1798\u17A0\u17B6\u179A\u1798\u17D2\u179B\u17B6\u1799"},{"id":9370,"word":"\u1798\u17A0\u17B6\u179F\u17BB\u1798\u17C1\u1792\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":9371,"word":"\u1798\u17A0\u17B6\u17A0\u1784\u17D2\u179F"},{"id":9372,"word":"\u1798\u17A0\u17B6\u17A0\u17B7\u1784\u17D2\u1782\u17BB"},{"id":9373,"word":"\u1798\u17A0\u17B6\u17A2\u17BB\u1785"},{"id":9374,"word":"\u1798\u17A0\u17B7\u1785\u17D2\u1786\u178F\u17B6"},{"id":9375,"word":"\u1798\u17A0\u17B7\u1791\u17D2\u1792\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":9376,"word":"\u1798\u17A0\u17B7\u1791\u17D2\u1792\u17B7\u17AB\u1791\u17D2\u1792\u17B7"},{"id":9377,"word":"\u1798\u17A0\u17B7\u1793\u17D2\u1791\u178F\u17D2\u1790\u17C1\u179A"},{"id":9378,"word":"\u1798\u17A0\u17B7\u1798\u17B6"},{"id":9379,"word":"\u1798\u17A0\u17B7\u179F\u17D2\u179F\u179A\u17C8"},{"id":9380,"word":"\u1798\u17A0\u17B8"},{"id":9381,"word":"\u1798\u17A0\u17B8\u179B\u178F\u17B6"},{"id":9382,"word":"\u1798\u17A0\u17B9\u179F\u17B6"},{"id":9383,"word":"\u1798\u17A0\u17C1\u179F\u1780\u17D2\u1781"},{"id":9384,"word":"\u1798\u17A0\u17C1\u179F\u17B8"},{"id":9385,"word":"\u1798\u17A0\u17C1\u179F\u17D2\u179C\u179A\u17C8"},{"id":9386,"word":"\u1798\u17A0\u17C3\u179F\u17BC\u179A\u17D2\u1799"},{"id":9387,"word":"\u1798\u17A0\u17C4\u1783"},{"id":9388,"word":"\u1798\u17A0\u17C4\u179A\u1792\u17B9\u1780"},{"id":9389,"word":"\u1798\u17A0\u17C4\u179A\u179F\u17D2\u179A\u1796"},{"id":9390,"word":"\u1798\u17A0\u17C4\u179A\u17B8"},{"id":9391,"word":"\u1798\u17A0\u17C4\u179F\u1790"},{"id":9392,"word":"\u1798\u17A0\u17C4\u179F\u17D2\u179A\u1796"},{"id":9393,"word":"\u1798\u17A0\u17C4\u17A1\u17B6\u179A"},{"id":9394,"word":"\u1798\u17A0\u17C4\u17A1\u17B6\u179A\u17B7\u1780"},{"id":9395,"word":"\u1798\u17B6"},{"id":9396,"word":"\u1798\u17C9\u17B6\u1780\u17CB"},{"id":9397,"word":"\u1798\u17B6\u1780\u17CB\u1780\u17D2\u179B\u17BF"},{"id":9398,"word":"\u1798\u17B6\u1780\u17CB\u1784\u17B6\u1799"},{"id":9399,"word":"\u1798\u17B6\u1780\u17CB\u178A\u17C4\u1780"},{"id":9400,"word":"\u1798\u17B6\u1780\u17CB\u1790\u17C4\u1780"},{"id":9401,"word":"\u1798\u17B6\u1780\u17CB\u1794\u17B6\u178F"},{"id":9402,"word":"\u1798\u17B6\u1780\u17CB\u1794\u17C9\u17C2\u1793"},{"id":9403,"word":"\u1798\u17B6\u1780\u17CB\u1794\u17D2\u179A\u17B6\u1784"},{"id":9404,"word":"\u1798\u17B6\u1780\u17CB\u1794\u17D2\u179A\u17B7\u1784"},{"id":9405,"word":"\u1798\u17B6\u1780\u17CB\u1794\u17D2\u179A\u17C1\u1784"},{"id":9406,"word":"\u1798\u17B6\u1780\u17CB\u179F\u17B6\u1784"},{"id":9407,"word":"\u1798\u17B6\u1780\u17CB\u179F\u17B6\u1793\u17CB"},{"id":9408,"word":"\u1798\u17B6\u1782\u1792\u17C8"},{"id":9409,"word":"\u1798\u17B6\u1782\u1792\u17B8"},{"id":9410,"word":"\u1798\u17B6\u1782\u179F\u17B7\u179A"},{"id":9411,"word":"\u1798\u17B6\u1782\u17CC"},{"id":9412,"word":"\u1798\u17B6\u1782\u17CC\u17B6"},{"id":9413,"word":"\u1798\u17B6\u1783"},{"id":9414,"word":"\u1798\u17B6\u1783\u1793\u1780\u17D2\u179F\u178F\u17D2\u179A"},{"id":9415,"word":"\u1798\u17B6\u1783\u1794\u17BC\u1787\u17B6"},{"id":9416,"word":"\u1798\u17C9\u17B6\u1784"},{"id":9417,"word":"\u1798\u17C9\u17B6\u1785\u17CB"},{"id":9418,"word":"\u1798\u17B6\u178C"},{"id":9419,"word":"\u1798\u17B6\u178E\u1796"},{"id":9420,"word":"\u1798\u17B6\u178E\u1796\u1780\u17CD"},{"id":9421,"word":"\u1798\u17B6\u178E\u179C\u17B7\u1780\u17B6"},{"id":9422,"word":"\u1798\u17B6\u178F\u17CB"},{"id":9423,"word":"\u1798\u17C9\u17B6\u178F\u17CB"},{"id":9424,"word":"\u1798\u17B6\u178F\u17CB\u1785\u17B6\u1794"},{"id":9425,"word":"\u1798\u17B6\u178F\u17CB\u1787\u17D2\u179A\u17BC\u1780"},{"id":9426,"word":"\u1798\u17B6\u178F\u17CB\u178A\u1784\u17D2\u1780\u17B6\u1794\u17CB"},{"id":9427,"word":"\u1798\u17B6\u178F\u17CB\u1793\u17C0\u179C"},{"id":9428,"word":"\u1798\u17B6\u178F\u179B\u17B8"},{"id":9429,"word":"\u1798\u17B6\u178F\u17B6"},{"id":9430,"word":"\u1798\u17B6\u178F\u17B6\u1794\u17B7\u178F\u17BB\u1782\u17BB\u178E"},{"id":9431,"word":"\u1798\u17B6\u178F\u17B6\u1794\u17B7\u178F\u17BB\u1794\u178A\u17D2\u178B\u17B6\u1793"},{"id":9432,"word":"\u1798\u17B6\u178F\u17B6\u1798\u17A0\u17C8"},{"id":9433,"word":"\u1798\u17B6\u178F\u17B6\u1798\u17A0\u1799\u17D2\u1799\u1780\u17C8"},{"id":9434,"word":"\u1798\u17B6\u178F\u17B6\u1798\u17A0\u1799\u17D2\u1799\u1780\u17B6"},{"id":9435,"word":"\u1798\u17B6\u178F\u17B6\u1798\u17A0\u17B8"},{"id":9436,"word":"\u1798\u17B6\u178F\u17B7\u1780\u17B6"},{"id":9437,"word":"\u1798\u17B6\u178F\u17B7\u1780\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798"},{"id":9438,"word":"\u1798\u17B6\u178F\u17B7\u1780\u17B6\u1794\u17D2\u179A\u1797\u17C1\u1791"},{"id":9439,"word":"\u1798\u17B6\u178F\u17BB\u1782\u17BB\u178E"},{"id":9440,"word":"\u1798\u17B6\u178F\u17BB\u1782\u17D2\u179A\u17B6\u1798"},{"id":9441,"word":"\u1798\u17B6\u178F\u17BB\u1783\u17B6\u178F"},{"id":9442,"word":"\u1798\u17B6\u178F\u17BB\u1783\u17B6\u178F\u1780\u17C8"},{"id":9443,"word":"\u1798\u17B6\u178F\u17BB\u1783\u17B6\u178F\u17B7\u1780\u17B6"},{"id":9444,"word":"\u1798\u17B6\u178F\u17BB\u1785\u17D2\u1786\u17B6"},{"id":9445,"word":"\u1798\u17B6\u178F\u17BB\u1794\u17D2\u179A\u1791\u17C1\u179F"},{"id":9446,"word":"\u1798\u17B6\u178F\u17BB\u1797\u17BC\u1798\u17B7"},{"id":9447,"word":"\u1798\u17B6\u178F\u17BB\u179B\u17C8"},{"id":9448,"word":"\u1798\u17B6\u178F\u17BB\u179B\u17B6\u1793\u17B8"},{"id":9449,"word":"\u1798\u17B6\u178F\u17D2\u179A"},{"id":9450,"word":"\u1798\u17B6\u178F\u17D2\u179A\u17B6"},{"id":9451,"word":"\u1798\u17B6\u178F\u17D2\u179A\u17B6\u1791\u178E\u17D2\u178C"},{"id":9452,"word":"\u1798\u17B6\u1793"},{"id":9453,"word":"\u1798\u17B6\u1793\u17CB"},{"id":9454,"word":"\u1798\u17B6\u1793\u1791\u178E\u17D2\u178C"},{"id":9455,"word":"\u1798\u17B6\u1793\u17CB\u1791\u17B9\u1780"},{"id":9456,"word":"\u1798\u17B6\u1793\u17CB\u1791\u17C4\u179A"},{"id":9457,"word":"\u1798\u17B6\u1793\u17CB\u1796\u17D2\u179A\u17C3"},{"id":9458,"word":"\u1798\u17B6\u1793\u17CB\u179A\u1784\u17B6\u179C"},{"id":9459,"word":"\u1798\u17B6\u1793\u17C7"},{"id":9460,"word":"\u1798\u17B6\u1799\u17B6"},{"id":9461,"word":"\u1798\u17B6\u1799\u17B8"},{"id":9462,"word":"\u1798\u17B6\u179A"},{"id":9463,"word":"\u1798\u17B6\u179A\u1782\u17B6"},{"id":9464,"word":"\u1798\u17B6\u179A\u1799\u17B6\u1791"},{"id":9465,"word":"\u1798\u17B6\u179B\u179F\u17B6\u179B\u17B6"},{"id":9466,"word":"\u1798\u17B6\u179B\u1780\u179F\u17B6\u179B\u17B6"},{"id":9467,"word":"\u1798\u17B6\u179B\u178F\u17B8"},{"id":9468,"word":"\u1798\u17B6\u179B\u17D0\u1799"},{"id":9469,"word":"\u1798\u17B6\u179B\u17B6"},{"id":9470,"word":"\u1798\u17B6\u179B\u17B6\u1780\u17B6\u179A"},{"id":9471,"word":"\u1798\u17B6\u179B\u17B6\u179C\u17B7\u1780\u17D0\u178F\u17B7"},{"id":9472,"word":"\u1798\u17B6\u179B\u17B8"},{"id":9473,"word":"\u1798\u17B6\u179B\u17D2\u1794\u17B6\u1799"},{"id":9474,"word":"\u1798\u17B6\u179F"},{"id":9475,"word":"\u1798\u17B6\u179F\u1780"},{"id":9476,"word":"\u1798\u17B6\u179F\u1798\u17D0\u1799"},{"id":9477,"word":"\u1798\u17B6\u179F\u179F\u17C1\u179F"},{"id":9478,"word":"\u1798\u17B6\u179F\u179F\u17D2\u1784\u17BD\u1793"},{"id":9479,"word":"\u1798\u17B6\u179F\u17B6\u1793\u17BB\u1794\u17D2\u1794\u179C\u178F\u17D2\u178F\u17B7"},{"id":9480,"word":"\u1798\u17B6\u179F\u17B6\u1793\u17BB\u1794\u17D2\u179A\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7"},{"id":9481,"word":"\u1798\u17B6\u179F\u17B7\u1780\u1787\u1793"},{"id":9482,"word":"\u1798\u17B6\u179F\u17B7\u1780\u17B6"},{"id":9483,"word":"\u1798\u17C9\u17B6\u179F\u17CA\u17B8\u1793"},{"id":9484,"word":"\u1798\u17B7\u1782\u1787\u17B6\u178F\u17B7"},{"id":9485,"word":"\u1798\u17B7\u1782\u1791\u17B6\u1799\u1796\u1793"},{"id":9486,"word":"\u1798\u17B7\u1782\u1796\u17D0\u1793\u17D2\u1792\u1793\u17CD"},{"id":9487,"word":"\u1798\u17B7\u1782\u179A\u17B6\u1787"},{"id":9488,"word":"\u1798\u17B7\u1782\u179F\u17B7\u179A"},{"id":9489,"word":"\u1798\u17B7\u1784\u1798\u17B6\u17C6\u1784"},{"id":9490,"word":"\u1798\u17B7\u1785"},{"id":9491,"word":"\u1798\u17B7\u1785\u17D2\u1786\u17B6"},{"id":9492,"word":"\u1798\u17B7\u1785\u17D2\u1786\u17B6 --"},{"id":9493,"word":"\u1798\u17B7\u178F\u1797\u17B6\u178E\u17B8"},{"id":9494,"word":"\u1798\u17C9\u17B7\u178F\u1794\u17D2\u179A\u17B6\u1799"},{"id":9495,"word":"\u1798\u17B7\u178F\u17D2\u178F"},{"id":9496,"word":"\u1798\u17B7\u178F\u17D2\u178F\u1791\u17D2\u179A\u17BB\u179F\u17D2\u178F"},{"id":9497,"word":"\u1798\u17B7\u178F\u17D2\u178F\u1797\u17B6\u1796"},{"id":9498,"word":"\u1798\u17B7\u178F\u17D2\u178F\u1797\u17C1\u1791"},{"id":9499,"word":"\u1798\u17B7\u178F\u17D2\u178F\u1797\u17D2\u1784\u17B6"},{"id":9500,"word":"\u1798\u17B7\u178F\u17D2\u178F\u179B\u17B6\u1797"},{"id":9501,"word":"\u1798\u17B7\u178F\u17D2\u178F\u179F\u1793\u17D2\u1790\u179C\u1797\u17B6\u1796"},{"id":9502,"word":"\u1798\u17B7\u178F\u17D2\u179A"},{"id":9503,"word":"\u1798\u17B7\u178F\u17D2\u179A\u1797\u17B6\u1796"},{"id":9504,"word":"\u1798\u17B7\u178F\u17D2\u179A\u1797\u17C1\u1791"},{"id":9505,"word":"\u1798\u17B7\u178F\u17D2\u179A\u1797\u17D2\u1784\u17B6"},{"id":9506,"word":"\u1798\u17B7\u178F\u17D2\u179A\u179B\u17B6\u1797"},{"id":9507,"word":"\u1798\u17B7\u178F\u17D2\u179A\u17B6\u1797\u17B7\u1794\u17B6\u179B"},{"id":9508,"word":"\u1798\u17B7\u1790\u17B7\u179B\u17B6"},{"id":9509,"word":"\u1798\u17B7\u1790\u17BB\u1793"},{"id":9510,"word":"\u1798\u17B7\u1790\u17BB\u1793\u179A\u17B6\u179F\u17B8"},{"id":9511,"word":"\u1798\u17B7\u1790\u17D2\u1799\u17B6\u1785\u17B6\u179A"},{"id":9512,"word":"\u1798\u17B7\u1791\u17D2\u1792\u17C8"},{"id":9513,"word":"\u1798\u17B7\u1793"},{"id":9514,"word":"\u1798\u17C9\u17B7\u1798"},{"id":9515,"word":"\u1798\u17C9\u17B7\u1798\u17D7"},{"id":9516,"word":"\u1798\u17B7\u179B\u1780\u17D2\u1781\u17C8"},{"id":9517,"word":"\u1798\u17B7\u179B\u17D2\u179B\u17B8\u1798\u17C9\u17C2\u178F\u17D2\u179A"},{"id":9518,"word":"\u1798\u17B8"},{"id":9519,"word":"\u1798\u17B8\u1784"},{"id":9520,"word":"\u1798\u17B8\u1793"},{"id":9521,"word":"\u1798\u17B8\u1793\u179A\u17B6\u179F\u17B8"},{"id":9522,"word":"\u1798\u17B8\u179A"},{"id":9523,"word":"\u1798\u17B8\u179F\u17BD"},{"id":9524,"word":"\u1798\u17B9\u1780"},{"id":9525,"word":"\u1798\u17B9\u1784"},{"id":9526,"word":"\u1798\u17C9\u17B9\u1784"},{"id":9527,"word":"\u1798\u17C9\u17B9\u1784\u17D7"},{"id":9528,"word":"\u1798\u17B9\u178F"},{"id":9529,"word":"\u1798\u17B9\u178F\u1796\u178F\u17CB"},{"id":9530,"word":"\u1798\u17B9\u1793"},{"id":9531,"word":"\u1798\u17C9\u17B9\u1794"},{"id":9532,"word":"\u1798\u17C9\u17B9\u1798"},{"id":9533,"word":"\u1798\u17C9\u17B9\u1798\u17D7"},{"id":9534,"word":"\u1798\u17B9\u17C7\u17D7"},{"id":9535,"word":"\u1798\u17C9\u17BA\u1784"},{"id":9536,"word":"\u1798\u17BA\u178F"},{"id":9537,"word":"\u1798\u17C9\u17BA\u1793"},{"id":9538,"word":"\u1798\u17BB\u1780\u17D2\u178A\u17B6"},{"id":9539,"word":"\u1798\u17BB\u1781"},{"id":9540,"word":"\u1798\u17BB\u1781\u1780\u17C6\u1796\u17BC\u179B"},{"id":9541,"word":"\u1798\u17BB\u1781\u1782\u17BD\u179A"},{"id":9542,"word":"\u1798\u17BB\u1781\u1787\u17B6"},{"id":9543,"word":"\u1798\u17BB\u1781\u1788\u17D2\u1793\u17B6\u1784"},{"id":9544,"word":"\u1798\u17BB\u1781\u178A\u17B6\u1785\u17CB"},{"id":9545,"word":"\u1798\u17BB\u1781\u178F\u17C2"},{"id":9546,"word":"\u1798\u17BB\u1781\u1791\u17D2\u179C\u17B6\u179A"},{"id":9547,"word":"\u1798\u17BB\u1781\u1794\u17B6\u178B"},{"id":9548,"word":"\u1798\u17BB\u1781\u1794\u17B6\u1791"},{"id":9549,"word":"\u1798\u17BB\u1781\u1798\u1782\u17D2\u1782"},{"id":9550,"word":"\u1798\u17BB\u1781\u179A\u17C4"},{"id":9551,"word":"\u1798\u17BB\u1784"},{"id":9552,"word":"\u1798\u17C9\u17BB\u1784"},{"id":9553,"word":"\u1798\u17BB\u1784\u17D2\u1782\u17D2\u179A\u17C1"},{"id":9554,"word":"\u1798\u17BB\u1785\u17D2\u1786\u17B6"},{"id":9555,"word":"\u1798\u17BB\u1787"},{"id":9556,"word":"\u1798\u17BB\u1789\u17D2\u1785\u1793\u17B6\u1780\u17B6\u179A"},{"id":9557,"word":"\u1798\u17BB\u1789\u17D2\u1785\u1793\u17C4\u1794\u17B6\u1799"},{"id":9558,"word":"\u1798\u17BB\u178F"},{"id":9559,"word":"\u1798\u17BB\u178F\u1798\u17B6\u17C6"},{"id":9560,"word":"\u1798\u17BB\u178F\u17D2\u178F\u17B6"},{"id":9561,"word":"\u1798\u17BB\u1791\u17B7\u178F\u17B6"},{"id":9562,"word":"\u1798\u17BB\u1791\u17BB"},{"id":9563,"word":"\u1798\u17BB\u1791\u17BB\u178F\u17B6"},{"id":9564,"word":"\u1798\u17BB\u1791\u17D2\u1792\u1787\u17C8"},{"id":9565,"word":"\u1798\u17BB\u1791\u17D2\u1792\u17B6"},{"id":9566,"word":"\u1798\u17BB\u1791\u17D2\u1792\u17B6\u1797\u17B7\u179F\u17B7\u178F\u17D2\u178F"},{"id":9567,"word":"\u1798\u17BB\u1791\u17D2\u1792\u17B6\u1797\u17B7\u179F\u17C1\u1780"},{"id":9568,"word":"\u1798\u17BB\u1791\u17D2\u179A\u17B6"},{"id":9569,"word":"\u1798\u17BB\u1793"},{"id":9570,"word":"\u1798\u17BB\u1793\u17B7"},{"id":9571,"word":"\u1798\u17BB\u1793\u17B8"},{"id":9572,"word":"\u1798\u17BB\u1798"},{"id":9573,"word":"\u1798\u17C9\u17BB\u1798"},{"id":9574,"word":"\u1798\u17BB\u1799\u17D7"},{"id":9575,"word":"\u1798\u17BB\u179F\u17B6"},{"id":9576,"word":"\u1798\u17BB\u179F\u17B6\u179C\u17B6\u1791"},{"id":9577,"word":"\u1798\u17BB\u179F\u17B6\u179C\u17B6\u1791\u17B8"},{"id":9578,"word":"\u1798\u17BB\u17A0\u17BB\u178F\u17D2\u178F\u179C\u17B7\u1787\u17B6\u178F\u179C\u17B6\u1791\u17B8"},{"id":9579,"word":"\u1798\u17C9\u17BC\u1780"},{"id":9580,"word":"\u1798\u17BC\u1782\u179C\u178F\u17D2\u178F"},{"id":9581,"word":"\u1798\u17BC\u1784"},{"id":9582,"word":"\u1798\u17C9\u17BC\u1784"},{"id":9583,"word":"\u1798\u17C9\u17BC\u1784\u1782\u17D2\u179A\u17BB\u17C6"},{"id":9584,"word":"\u1798\u17C9\u17BC\u178F"},{"id":9585,"word":"\u1798\u17BC\u178F\u17D2\u179A"},{"id":9586,"word":"\u1798\u17BC\u178F\u17D2\u179A\u17B6\u179F\u17D0\u1799"},{"id":9587,"word":"\u1798\u17BC\u1791\u17BC"},{"id":9588,"word":"\u1798\u17BC\u179A"},{"id":9589,"word":"\u1798\u17BC\u179A\u178F\u17B8"},{"id":9590,"word":"\u1798\u17BC\u179A\u17C9\u17B6"},{"id":9591,"word":"\u1798\u17BC\u179B"},{"id":9592,"word":"\u1798\u17BC\u179B\u17B8"},{"id":9593,"word":"\u1798\u17BC\u179B\u17D2\u1799"},{"id":9594,"word":"\u1798\u17BC\u179F"},{"id":9595,"word":"\u1798\u17BC\u179F\u17B7\u1780\u1791\u1793\u17D2\u178F"},{"id":9596,"word":"\u1798\u17BC\u179F\u17D2\u1799\u17B6\u1799\u17D0\u178E"},{"id":9597,"word":"\u1798\u17BC\u17A1\u17D2\u17A0\u17C8"},{"id":9598,"word":"\u1798\u17BD"},{"id":9599,"word":"\u1798\u17BD\u1780"},{"id":9600,"word":"\u1798\u17BD\u1793"},{"id":9601,"word":"\u1798\u17BD\u1798\u17C9\u17C5"},{"id":9602,"word":"\u1798\u17BD\u1799"},{"id":9603,"word":"\u1798\u17BD\u1799\u1780\u17D2\u179B\u17B6\u1799\u1787\u17B6\u178A\u1794\u17CB"},{"id":9604,"word":"\u1798\u17BD\u1799\u17A2\u1793\u17D2\u179B\u17BE"},{"id":9605,"word":"\u1798\u17BD\u179A"},{"id":9606,"word":"\u1798\u17BD\u179B"},{"id":9607,"word":"\u1798\u17BD\u17A0\u17D2\u1798\u1784"},{"id":9608,"word":"\u1798\u17BE"},{"id":9609,"word":"\u1798\u17BE\u1780\u17D7"},{"id":9610,"word":"\u1798\u17BE\u1798"},{"id":9611,"word":"\u1798\u17BE\u179B"},{"id":9612,"word":"\u1798\u17BE\u179B\u1784\u17B6\u1799"},{"id":9613,"word":"\u1798\u17BE\u179B\u1794\u17C6\u178E\u17B6\u17C6"},{"id":9614,"word":"\u1798\u17BF\u1784"},{"id":9615,"word":"\u1798\u17C0\u1784"},{"id":9616,"word":"\u1798\u17C0\u1784\u1798\u17BE\u179B"},{"id":9617,"word":"\u1798\u17C0\u1793"},{"id":9618,"word":"\u1798\u17C0\u1798"},{"id":9619,"word":"\u1798\u17C1"},{"id":9620,"word":"\u1798\u17C1 ! "},{"id":9621,"word":"\u1798\u17C1\u1780\u1784"},{"id":9622,"word":"\u1798\u17C1\u1780\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1789"},{"id":9623,"word":"\u1798\u17C1\u1780\u17BB\u1784"},{"id":9624,"word":"\u1798\u17C1\u1780\u17C6\u1796\u17D2\u179A\u17B6"},{"id":9625,"word":"\u1798\u17C1\u1780\u17D2\u179A\u1798\u17B8"},{"id":9626,"word":"\u1798\u17C1\u1781\u179B\u17B6"},{"id":9627,"word":"\u1798\u17C1\u1781\u17B6"},{"id":9628,"word":"\u1798\u17C1\u1781\u17D2\u179B\u17C4\u1784"},{"id":9629,"word":"\u1798\u17C1\u1782\u178E"},{"id":9630,"word":"\u1798\u17C1\u1783"},{"id":9631,"word":"\u1798\u17C1\u1783\u1785\u17D2\u1786\u17B6\u1799"},{"id":9632,"word":"\u1798\u17C1\u1783\u17BB\u17C6"},{"id":9633,"word":"\u1798\u17C9\u17C1\u1785"},{"id":9634,"word":"\u1798\u17C1\u1786\u17B6"},{"id":9635,"word":"\u1798\u17C1\u1787\u17D0\u179A"},{"id":9636,"word":"\u1798\u17C1\u1787\u17B8"},{"id":9637,"word":"\u1798\u17C1\u178A\u17B6\u1799"},{"id":9638,"word":"\u1798\u17C1\u178A\u17C2\u1780"},{"id":9639,"word":"\u1798\u17C1\u178A\u17C4\u17C7"},{"id":9640,"word":"\u1798\u17C1\u178A\u17C6\u1794\u17BC\u179B"},{"id":9641,"word":"\u1798\u17C9\u17C1\u178F\u1794\u17D2\u179A\u17B6\u1799"},{"id":9642,"word":"\u1798\u17C1\u178F\u17D2\u178F\u17B6"},{"id":9643,"word":"\u1798\u17C1\u178F\u17D2\u179A\u17B8"},{"id":9644,"word":"\u1798\u17C1\u1790\u17BB\u1793"},{"id":9645,"word":"\u1798\u17C1\u1791\u1793\u17B8"},{"id":9646,"word":"\u1798\u17C1\u1791\u17C4"},{"id":9647,"word":"\u1798\u17C1\u1792\u1782\u1797\u17B6\u1796"},{"id":9648,"word":"\u1798\u17C1\u1792\u17B6"},{"id":9649,"word":"\u1798\u17C1\u1792\u17B6\u179C\u17B8"},{"id":9650,"word":"\u1798\u17C1\u1793"},{"id":9651,"word":"\u1798\u17C1\u1793\u17C6"},{"id":9652,"word":"\u1798\u17C1\u1794\u17B6"},{"id":9653,"word":"\u1798\u17C1\u1797\u17D2\u179B\u17C0\u1784"},{"id":9654,"word":"\u1798\u17C1\u1798\u178F\u17CB"},{"id":9655,"word":"\u1798\u17C1\u1798\u17C9\u17B6\u1799"},{"id":9656,"word":"\u1798\u17C1\u179A\u17D0\u1799"},{"id":9657,"word":"\u1798\u17C1\u179A\u17BB"},{"id":9658,"word":"\u1798\u17C1\u179A\u17C0\u1798"},{"id":9659,"word":"\u1798\u17C1\u179B\u17B9\u1798"},{"id":9660,"word":"\u1798\u17C1\u179B\u17C1\u1781"},{"id":9661,"word":"\u1798\u17C1\u179B\u17C4\u1784"},{"id":9662,"word":"\u1798\u17C1\u179B\u17C6"},{"id":9663,"word":"\u1798\u17C1\u179C\u178F\u17D2\u178F"},{"id":9664,"word":"\u1798\u17C1-\u179F"},{"id":9665,"word":"\u1798\u17C1\u179F"},{"id":9666,"word":"\u1798\u17C1\u179F\u1794\u17B6\u179B"},{"id":9667,"word":"\u1798\u17C1\u179F\u179A\u17B6\u179F\u17B8"},{"id":9668,"word":"\u1798\u17C1\u179F\u17BC\u178F\u17D2\u179A"},{"id":9669,"word":"\u1798\u17C1\u179F\u17D2\u179A\u17BB\u1780"},{"id":9670,"word":"\u1798\u17C1\u17A2\u178E\u17D2\u178A\u17BE\u1780"},{"id":9671,"word":"\u1798\u17C1\u17A2\u17C6\u1794\u17C5"},{"id":9672,"word":"\u1798\u17C2"},{"id":9673,"word":"\u1798\u17C9\u17C2"},{"id":9674,"word":"\u1798\u17C2\u1780"},{"id":9675,"word":"\u1798\u17C9\u17C2\u178F\u17D2\u179A"},{"id":9676,"word":"\u1798\u17C2\u1793"},{"id":9677,"word":"\u1798\u17C2\u1793\u1798\u17B6\u1793"},{"id":9678,"word":"\u1798\u17C9\u17C3"},{"id":9679,"word":"\u1798\u17C3\u17D7"},{"id":9680,"word":"\u1798\u17C9\u17C3\u179F\u17D0\u1780"},{"id":9681,"word":"\u1798\u17C4\u1780"},{"id":9682,"word":"\u1798\u17C4\u1780\u17D2\u1781"},{"id":9683,"word":"\u1798\u17C4\u1780\u17D2\u1781\u17BB\u1794\u17B6\u1799"},{"id":9684,"word":"\u1798\u17C4\u1782\u17D2\u1782\u179B\u17D2\u179B\u17B6\u1793"},{"id":9685,"word":"\u1798\u17C4\u1783"},{"id":9686,"word":"\u1798\u17C4\u1784"},{"id":9687,"word":"\u1798\u17C9\u17C4\u1784"},{"id":9688,"word":"\u1798\u17C9\u17C4\u1784\u1787\u17B6\u1784"},{"id":9689,"word":"\u1798\u17C4\u1791\u1780\u1797\u17B6\u1796"},{"id":9690,"word":"\u1798\u17C4\u1791\u1793\u17B6"},{"id":9691,"word":"\u1798\u17C4\u1793\u1797\u17B6\u1796"},{"id":9692,"word":"\u1798\u17C4\u1793\u17C1\u1799\u17D2\u1799\u1797\u17B6\u1796"},{"id":9693,"word":"\u1798\u17C4\u179A\u1780\u179B\u17B6\u1794"},{"id":9694,"word":"\u1798\u17C4\u179A\u17C9\u17B6"},{"id":9695,"word":"\u1798\u17C4\u179B\u17B8"},{"id":9696,"word":"\u1798\u17C4\u17A0\u17C8"},{"id":9697,"word":"\u1798\u17C4\u17A0\u17CD"},{"id":9698,"word":"\u1798\u17C4\u17A0\u1793\u17D2\u1792"},{"id":9699,"word":"\u1798\u17C4\u17A0\u1793\u17D2\u1792\u1780\u17B6\u179A"},{"id":9700,"word":"\u1798\u17C4\u17A0\u17B6\u1782\u178F\u17B7"},{"id":9701,"word":"\u1798\u17C4\u17A0\u17C4"},{"id":9702,"word":"\u1798\u17C4\u17C7"},{"id":9703,"word":"\u1798\u17C4\u17C7\u1798\u17BB\u178F"},{"id":9704,"word":"\u1798\u17C5"},{"id":9705,"word":"\u1798\u17C9\u17C5"},{"id":9706,"word":"\u1798\u17C6\u179F\u17C8"},{"id":9707,"word":"\u1798\u17C6\u179F\u17C6"},{"id":9708,"word":"\u1798\u17B6\u17C6"},{"id":9709,"word":"\u1798\u17C9\u17B6\u17C6"},{"id":9710,"word":"\u1798\u17C9\u17B6\u17C6\u1784"},{"id":9711,"word":"\u1798\u17D2\u1780\u17B6\u1780\u17CB"},{"id":9712,"word":"\u1798\u17D2\u1780\u17B6\u179B"},{"id":9713,"word":"\u1798\u17D2\u1781\u17B6\u1784"},{"id":9714,"word":"\u1798\u17D2\u1784\u17C9\u17B7\u1780\u1798\u17C9\u17D2\u1784\u1780\u17CB"},{"id":9715,"word":"\u1798\u17D2\u1784\u17C9\u17C3"},{"id":9716,"word":"\u1798\u17D2\u1785\u178F\u17CB"},{"id":9717,"word":"\u1798\u17D2\u1785\u17B6\u1780\u17CB"},{"id":9718,"word":"\u1798\u17D2\u1785\u17B6\u1793"},{"id":9719,"word":"\u1798\u17D2\u1785\u17B6\u179F\u17CB"},{"id":9720,"word":"\u1798\u17D2\u1785\u17B6\u179F\u17CB\u1787\u17B8\u179C\u17B7\u178F"},{"id":9721,"word":"\u1798\u17D2\u1785\u17B6\u179F\u17CB\u1795\u17C2\u1793\u178A\u17B8"},{"id":9722,"word":"\u1798\u17D2\u1787\u17BB\u179B"},{"id":9723,"word":"\u1798\u17D2\u1787\u17BC\u179A"},{"id":9724,"word":"\u1798\u17D2\u1789\u17C9\u17B7\u1780\u1798\u17D2\u1789\u17C9\u1780\u17CB"},{"id":9725,"word":"\u1798\u17D2\u1789\u17C9\u17C2\u1798\u17D2\u1789\u17C9"},{"id":9726,"word":"\u1798\u17D2\u178A\u1784"},{"id":9727,"word":"\u1798\u17D2\u178A\u17B6"},{"id":9728,"word":"\u1798\u17D2\u178A\u17B6\u1799"},{"id":9729,"word":"\u1798\u17D2\u178A\u17C1\u1785"},{"id":9730,"word":"\u1798\u17D2\u178A\u17BB\u17C6"},{"id":9731,"word":"\u1798\u17D2\u1791\u17C1\u179F"},{"id":9732,"word":"\u1798\u17D2\u1793\u17B6"},{"id":9733,"word":"\u1798\u17D2\u1793\u17B6\u1780\u17CB "},{"id":9734,"word":"\u1798\u17D2\u1793\u17B6\u1784"},{"id":9735,"word":"\u1798\u17D2\u1793\u17B6\u1784\u179F\u17B7\u179B\u17B6"},{"id":9736,"word":"\u1798\u17D2\u1793\u17B6\u179B"},{"id":9737,"word":"\u1798\u17D2\u1793\u17B6\u179F\u17CB"},{"id":9738,"word":"\u1798\u17D2\u1793\u17B7\u179B"},{"id":9739,"word":"\u1798\u17D2\u1793\u17B8\u1798\u17D2\u1793\u17B6"},{"id":9740,"word":"\u1798\u17D2\u1793\u17C1\u1789"},{"id":9741,"word":"\u1798\u17D2\u1793\u17C4\u1798\u17D2\u1793\u17C1\u1789"},{"id":9742,"word":"\u1798\u17D2\u1793\u17C4\u1798\u17D2\u1793\u17C7"},{"id":9743,"word":"\u1798\u17D2\u1793\u17C5\u17D7"},{"id":9744,"word":"\u1798\u17D2\u1797\u17C3"},{"id":9745,"word":"\u1798\u17D2\u1799\u1794\u17CB"},{"id":9746,"word":"\u1798\u17D2\u1799\u17C9\u17B6\u1784"},{"id":9747,"word":"\u1798\u17D2\u1799\u17B6\u1798"},{"id":9748,"word":"\u1798\u17D2\u1799\u17B8\u1798\u17D2\u1799\u17C9"},{"id":9749,"word":"\u1798\u17D2\u1799\u17B8\u1798\u17D2\u1799\u17B6"},{"id":9750,"word":"\u1798\u17D2\u1799\u17C9\u17C2\u1798\u17D2\u1799\u17C9"},{"id":9751,"word":"\u1798\u17D2\u179A\u1799"},{"id":9752,"word":"\u1798\u17D2\u179A\u17D0\u1780\u17D2\u179F\u178E\u17CD"},{"id":9753,"word":"\u1798\u17D2\u179A\u17B6\u1780\u17CB"},{"id":9754,"word":"\u1798\u17C9\u17D2\u179A\u17B6\u1784"},{"id":9755,"word":"\u1798\u17D2\u179A\u17B6\u1798"},{"id":9756,"word":"\u1798\u17D2\u179A\u17B8\u1780\u17D7"},{"id":9757,"word":"\u1798\u17D2\u179A\u17B9\u1780\u1798\u17D2\u179A\u17C3"},{"id":9758,"word":"\u1798\u17D2\u179A\u17B9\u1782"},{"id":9759,"word":"\u1798\u17D2\u179A\u17B9\u178F"},{"id":9760,"word":"\u1798\u17D2\u179A\u17B9\u178F\u17D2\u1799\u17BB"},{"id":9761,"word":"\u1798\u17D2\u179A\u17B9\u178F\u17D2\u1799\u17BB\u179F\u1799\u17D2\u1799\u17B6"},{"id":9762,"word":"\u1798\u17D2\u179A\u17B9\u178F\u17D2\u1799\u17BC\u179C"},{"id":9763,"word":"\u1798\u17D2\u179A\u17B9\u1791\u17B7\u1793\u17B8"},{"id":9764,"word":"\u1798\u17D2\u179A\u17BB\u1798"},{"id":9765,"word":"\u1798\u17D2\u179A\u17BE\u1798\u1796\u17D2\u179A\u17C7"},{"id":9766,"word":"\u1798\u17D2\u179A\u17C1\u1785"},{"id":9767,"word":"\u1798\u17D2\u179A\u17C1\u1785\u1780\u1784\u17D2\u1780\u17C2\u1794"},{"id":9768,"word":"\u1798\u17D2\u179A\u17C1\u1789"},{"id":9769,"word":"\u1798\u17D2\u179A\u17C1\u1789\u1780\u1784\u17D2\u179C\u17B6\u179B"},{"id":9770,"word":"\u1798\u17D2\u179A\u17C2\u1784"},{"id":9771,"word":"\u1798\u17D2\u179A\u17C4\u1798"},{"id":9772,"word":"\u1798\u17D2\u179A\u17BB\u17C6"},{"id":9773,"word":"\u1798\u17D2\u179A\u17C7"},{"id":9774,"word":"\u1798\u17D2\u179A\u17C7\u1796\u17D2\u179A\u17C5"},{"id":9775,"word":"\u1798\u17D2\u179B\u1794\u17CB"},{"id":9776,"word":"\u1798\u17C9\u17D2\u179B\u17B6"},{"id":9777,"word":"\u1798\u17D2\u179B\u17B6\u1793\u17CB"},{"id":9778,"word":"\u1798\u17D2\u179B\u17B6\u1799\u17D7"},{"id":9779,"word":"\u1798\u17D2\u179B\u17B7\u17C7"},{"id":9780,"word":"\u1798\u17D2\u179B\u17C9\u17B9\u1784"},{"id":9781,"word":"\u1798\u17D2\u179B\u17BA\u178F\u17D7"},{"id":9782,"word":"\u1798\u17D2\u179B\u17BC"},{"id":9783,"word":"\u1798\u17D2\u179B\u17BC\u1791\u17C1\u179F"},{"id":9784,"word":"\u1798\u17D2\u179B\u17BC\u1796\u17D2\u179A\u17C3"},{"id":9785,"word":"\u1798\u17D2\u179B\u17C9\u17C1\u17C7"},{"id":9786,"word":"\u1798\u17D2\u179F\u17B6\u1789\u17CB"},{"id":9787,"word":"\u1798\u17D2\u179F\u17B7\u179B"},{"id":9788,"word":"\u1798\u17D2\u179F\u17B7\u179B\u1798\u17C9\u17D2\u1784\u17C3"},{"id":9789,"word":"\u1798\u17D2\u179F\u17B7\u179B\u1798\u17D2\u1784\u17C9\u17C3\u1798\u17BD\u1799\u1793\u17B6\u1799"},{"id":9790,"word":"\u1798\u17D2\u179F\u17C0\u178F"},{"id":9791,"word":"\u1798\u17D2\u179F\u17C1\u179C"},{"id":9792,"word":"\u1798\u17D2\u179F\u17C5"},{"id":9793,"word":"\u1798\u17D2\u17A0\u1794\u17D7"},{"id":9794,"word":"\u1798\u17D2\u17A0\u17B6"},{"id":9795,"word":"\u1798\u17D2\u17A0\u17CA\u17B7\u17C7\u17D7"},{"id":9796,"word":"\u1798\u17D2\u17A0\u17BC\u1794"},{"id":9797,"word":"\u1798\u17D2\u17A0\u17BE\u1794\u17D7"},{"id":9798,"word":"\u1798\u17D2\u17A0\u17C1\u1794\u17D7"},{"id":9799,"word":"\u1798\u17D2\u17A0\u17C1\u1794\u1798\u17D2\u17A0\u1794"},{"id":9800,"word":"\u1798\u17D2\u17A0\u17C1\u17C7\u17D7"},{"id":9801,"word":"\u1798\u17D2\u17A0\u17CA\u17C2\u178F\u17D7"},{"id":9802,"word":"\u1798\u17D2\u17A0\u17C2\u1794\u1798\u17D2\u17A0\u1794"},{"id":9803,"word":"\u1798\u17D2\u17A2\u1798"},{"id":9804,"word":"\u1798\u17D2\u17A2\u1798\u1780\u17D2\u178A\u17B6\u1798"},{"id":9805,"word":"\u1799"},{"id":9806,"word":"\u1799\u17C9"},{"id":9807,"word":"\u1799\u1780\u17CD"},{"id":9808,"word":"\u1799\u1780"},{"id":9809,"word":"\u1799\u1780\u17CB"},{"id":9810,"word":"\u1799\u1780\u17CB !"},{"id":9811,"word":"\u1799\u1780\u1793\u17C8"},{"id":9812,"word":"\u1799\u1780\u17D2\u179A\u17B9\u178F"},{"id":9813,"word":"\u1799\u1780\u17D2\u1781"},{"id":9814,"word":"\u1799\u1780\u17D2\u1781\u17B7\u1793\u17B8"},{"id":9815,"word":"\u1799\u1780\u17D2\u179F\u17B6"},{"id":9816,"word":"\u1799\u1780\u17D2\u179F\u17B8"},{"id":9817,"word":"\u1799\u17C9\u1784"},{"id":9818,"word":"\u1799\u1784\u17CB"},{"id":9819,"word":"\u1799\u1784\u17CB\u1783\u17D2\u1793\u1784"},{"id":9820,"word":"\u1799\u1784\u17CB\u1799\u179B\u17CB"},{"id":9821,"word":"\u1799\u1789\u17D2\u1789"},{"id":9822,"word":"\u1799\u178A\u17D2\u178B\u17B7"},{"id":9823,"word":"\u1799\u178F\u17B7"},{"id":9824,"word":"\u1799\u178F\u17B7\u1797\u1784\u17D2\u1782"},{"id":9825,"word":"\u1799\u1790\u17B6\u1780\u1798\u17D2\u1798"},{"id":9826,"word":"\u1799\u1790\u17B6\u1780\u17B6\u1798"},{"id":9827,"word":"\u1799\u1790\u17B6\u1780\u17D2\u179A\u1798"},{"id":9828,"word":"\u1799\u1790\u17B6\u178B\u17B6\u1793"},{"id":9829,"word":"\u1799\u1790\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798"},{"id":9830,"word":"\u1799\u1790\u17B6\u1793\u17BB\u179A\u17BC\u1794"},{"id":9831,"word":"\u1799\u1790\u17B6\u1795\u17B6\u179F\u17BB\u1780"},{"id":9832,"word":"\u1799\u1790\u17B6\u1797\u17BC\u178F"},{"id":9833,"word":"\u1799\u1790\u17B6\u179B\u17B6\u1797"},{"id":9834,"word":"\u1799\u1790\u17B6\u17A0\u17C1\u178F\u17BB"},{"id":9835,"word":"\u1799\u1793\u17CB"},{"id":9836,"word":"\u1799\u1793\u17D2\u178F"},{"id":9837,"word":"\u1799\u17D0\u1793\u17D2\u178F"},{"id":9838,"word":"\u1799\u1794\u17CB"},{"id":9839,"word":"\u1799\u1798\u17C8"},{"id":9840,"word":"\u1799\u1798\u1780"},{"id":9841,"word":"\u1799\u1798\u1791\u17BC\u178F"},{"id":9842,"word":"\u1799\u1798\u1794\u17B6\u179B"},{"id":9843,"word":"\u1799\u1798\u179A\u17B6\u1787"},{"id":9844,"word":"\u1799\u1798\u179B\u17C4\u1780"},{"id":9845,"word":"\u1799\u1798\u17BB\u1793\u17B6"},{"id":9846,"word":"\u1799\u17D0\u179A !"},{"id":9847,"word":"\u1799\u179B\u17CB"},{"id":9848,"word":"\u1799\u179B\u17CB\u179F\u1794\u17D2\u178F"},{"id":9849,"word":"\u1799\u179B\u17CB\u179F\u1794\u17D2\u1793"},{"id":9850,"word":"\u1799\u179B\u17CB\u179F\u17BC\u1784"},{"id":9851,"word":"\u1799\u179F"},{"id":9852,"word":"\u1799\u17C9\u179F"},{"id":9853,"word":"\u1799\u179F\u17C4\u1792\u179A\u17B6"},{"id":9854,"word":"\u1799\u17C9\u17B6\u1780"},{"id":9855,"word":"\u1799\u17B6\u1782\u17BC"},{"id":9856,"word":"\u1799\u17B6\u1784"},{"id":9857,"word":"\u1799\u17C9\u17B6\u1784"},{"id":9858,"word":"\u1799\u17B6\u1784\u1785\u17BB\u17C7"},{"id":9859,"word":"\u1799\u17B6\u1784\u1799\u17B6\u179C"},{"id":9860,"word":"\u1799\u17B6\u1784\u1799\u17B6\u179F"},{"id":9861,"word":"\u1799\u17B6\u1785\u1780"},{"id":9862,"word":"\u1799\u17C9\u17B6\u178A\u17B6\u17C6"},{"id":9863,"word":"\u1799\u17B6\u178E\u17BC\u179C"},{"id":9864,"word":"\u1799\u17B6\u178F\u17D2\u179A\u17B6"},{"id":9865,"word":"\u1799\u17B6\u1793"},{"id":9866,"word":"\u1799\u17C9\u17B6\u1793\u17D0\u178F\u17D2\u1790\u17BB"},{"id":9867,"word":"\u1799\u17B6\u1793\u1794\u17B6\u178F\u17D2\u179A"},{"id":9868,"word":"\u1799\u17B6\u1793\u1798\u17B6\u179F"},{"id":9869,"word":"\u1799\u17B6\u1793\u17BC\u1794\u1780\u179A\u178E\u17CD"},{"id":9870,"word":"\u1799\u17C9\u17B6\u1794\u17CB"},{"id":9871,"word":"\u1799\u17C9\u17B6\u1794\u1786\u17B6"},{"id":9872,"word":"\u1799\u17B6\u1794\u1793\u1798\u178F\u17D2\u178F"},{"id":9873,"word":"\u1799\u17C9\u17B6\u1794\u17CB\u1799\u17C9\u17BA\u1793"},{"id":9874,"word":"\u1799\u17B6\u1794\u17D2\u179B\u1784"},{"id":9875,"word":"\u1799\u17B6\u1798"},{"id":9876,"word":"\u1799\u17B6\u1798\u17C8"},{"id":9877,"word":"\u1799\u17B6\u1798\u1780\u17B6\u179B\u17B7\u1780"},{"id":9878,"word":"\u1799\u17B6\u1798\u1783\u17C4\u179F"},{"id":9879,"word":"\u1799\u17B6\u1798\u1793\u17B6\u179B\u17B8"},{"id":9880,"word":"\u1799\u17B6\u1798\u179C\u178F\u17B8"},{"id":9881,"word":"\u1799\u17B6\u1798\u17B6"},{"id":9882,"word":"\u1799\u17B6\u1798\u17B7\u1780"},{"id":9883,"word":"\u1799\u17B6\u1799"},{"id":9884,"word":"\u1799\u17B6\u1799\u17B8"},{"id":9885,"word":"\u1799\u17B6\u179A"},{"id":9886,"word":"\u1799\u17B6\u179C"},{"id":9887,"word":"\u1799\u17C9\u17B6\u179C"},{"id":9888,"word":"\u1799\u17B6\u179C\u1780\u17B6\u179B\u17B7\u1780"},{"id":9889,"word":"\u1799\u17C9\u17B6\u179C\u1786\u17B6\u1781\u17D2\u179C\u17C3"},{"id":9890,"word":"\u1799\u17B6\u179C\u1787\u17B8\u179C\u17B7\u1780"},{"id":9891,"word":"\u1799\u17B6\u179C\u1787\u17B8\u179C\u17C6"},{"id":9892,"word":"\u1799\u17B6\u179F"},{"id":9893,"word":"\u1799\u17B6\u179F\u17CB"},{"id":9894,"word":"\u1799\u17B7\u178F\u1790\u17C4"},{"id":9895,"word":"\u1799\u17B8 !"},{"id":9896,"word":"\u1799\u17B8\u1780\u1799\u17C4\u1780"},{"id":9897,"word":"\u1799\u17B8\u1780\u17C1"},{"id":9898,"word":"\u1799\u17B8\u1790\u17C4"},{"id":9899,"word":"\u1799\u17B8\u179F\u17CA\u17BB\u1793"},{"id":9900,"word":"\u1799\u17B8\u17A0\u17CA\u17BB\u1793"},{"id":9901,"word":"\u1799\u17B8\u17A0\u17CA\u17BB\u1794"},{"id":9902,"word":"\u1799\u17B8\u17A0\u17C4"},{"id":9903,"word":"\u1799\u17B8\u17A2\u17BE !"},{"id":9904,"word":"\u1799\u17B8\u17C7 !"},{"id":9905,"word":"\u1799\u17B9\u178F"},{"id":9906,"word":"\u1799\u17B9\u178F\u1799\u17C4\u1784"},{"id":9907,"word":"\u1799\u17BA\u178F"},{"id":9908,"word":"\u1799\u17BA\u1793"},{"id":9909,"word":"\u1799\u17C9\u17BA\u179A"},{"id":9910,"word":"\u1799\u17BB\u1780"},{"id":9911,"word":"\u1799\u17BB\u1780\u1780\u17D2\u1794\u17D0\u178F\u17D2\u179A"},{"id":9912,"word":"\u1799\u17BB\u1780\u1799\u17B6\u1780\u17CB"},{"id":9913,"word":"\u1799\u17BB\u1782"},{"id":9914,"word":"\u1799\u17BB\u1782\u1782\u17D2\u179A\u17B6\u17C7"},{"id":9915,"word":"\u1799\u17BB\u1782\u1793\u17D2\u178F\u1780\u179B"},{"id":9916,"word":"\u1799\u17BB\u1782\u1793\u17D2\u1792\u179A"},{"id":9917,"word":"\u1799\u17BB\u1782\u179B\u17C8"},{"id":9918,"word":"\u1799\u17BB\u1782\u179B\u1796\u17B7\u1793\u17D2\u1791\u17BB"},{"id":9919,"word":"\u1799\u17BB\u178F\u17D2\u178F\u17C8"},{"id":9920,"word":"\u1799\u17BB\u178F\u17D2\u178F\u17B7\u1792\u1798\u17CC"},{"id":9921,"word":"\u1799\u17BB\u1790\u17D2\u1780\u17B6"},{"id":9922,"word":"\u1799\u17BB\u1791\u17D2\u1792"},{"id":9923,"word":"\u1799\u17BB\u1791\u17D2\u1792\u1793\u17B6"},{"id":9924,"word":"\u1799\u17BB\u1791\u17D2\u1792\u1793\u17B6\u1792\u17B7\u1780\u17B6\u179A"},{"id":9925,"word":"\u1799\u17BB\u1791\u17D2\u1792\u17BB\u1794\u1780\u179A\u178E\u17CD"},{"id":9926,"word":"\u1799\u17BB\u1791\u17D2\u1792\u17C4\u1794\u1780\u179A\u178E\u17CD"},{"id":9927,"word":"\u1799\u17BB\u1796\u17B6"},{"id":9928,"word":"\u1799\u17BB\u1799 !"},{"id":9929,"word":"\u1799\u17BB\u179A"},{"id":9930,"word":"\u1799\u17BB\u179A\u179F\u17D2\u1794\u17BC\u179C"},{"id":9931,"word":"\u1799\u17BB\u179C\u17C8"},{"id":9932,"word":"\u1799\u17BB\u179C\u178F\u17B8"},{"id":9933,"word":"\u1799\u17BB\u17C7\u17D7 !"},{"id":9934,"word":"\u1799\u17BC\u1799 !"},{"id":9935,"word":"\u1799\u17C9\u17BC\u1799 !"},{"id":9936,"word":"\u1799\u17BC\u179A"},{"id":9937,"word":"\u1799\u17BC\u17A0\u17BA"},{"id":9938,"word":"\u1799\u17BD\u1793"},{"id":9939,"word":"\u1799\u17BD\u179A"},{"id":9940,"word":"\u1799\u17BE !"},{"id":9941,"word":"\u1799\u17C9\u17BE !"},{"id":9942,"word":"\u1799\u17BE\u1784"},{"id":9943,"word":"\u1799\u17C9\u17BE\u179A"},{"id":9944,"word":"\u1799\u17C9\u17BE\u17C7 !"},{"id":9945,"word":"\u1799\u17C1\u1780\u1799\u17C4\u1780"},{"id":9946,"word":"\u1799\u17C1\u179F\u17CA\u17BC"},{"id":9947,"word":"\u1799\u17C9\u17C1\u17C8\u1799\u17C9\u17BB"},{"id":9948,"word":"\u1799\u17C2\u1780"},{"id":9949,"word":"\u1799\u17C3"},{"id":9950,"word":"\u1799\u17C9\u17C3"},{"id":9951,"word":"\u1799\u17C4"},{"id":9952,"word":"\u1799\u17C4\u1780"},{"id":9953,"word":"\u1799\u17C4\u1780\u17D2\u1794\u17D0\u178F\u17D2\u179A"},{"id":9954,"word":"\u1799\u17C4\u1782"},{"id":9955,"word":"\u1799\u17C4\u1782"},{"id":9956,"word":"\u1799\u17C4\u1782\u17B6\u179C\u1785\u179A"},{"id":9957,"word":"\u1799\u17C4\u1782\u17B7\u1793"},{"id":9958,"word":"\u1799\u17C4\u1782\u17D2\u1799\u1797\u17B6\u1796"},{"id":9959,"word":"\u1799\u17C4\u1784"},{"id":9960,"word":"\u1799\u17C4\u1787\u1793\u17CD"},{"id":9961,"word":"\u1799\u17C4\u1787\u1793\u17B6"},{"id":9962,"word":"\u1799\u17C4\u1792"},{"id":9963,"word":"\u1799\u17C4\u1792\u17B6"},{"id":9964,"word":"\u1799\u17C4\u1792\u17B7\u1793"},{"id":9965,"word":"\u1799\u17C4\u1793"},{"id":9966,"word":"\u1799\u17C4\u1793\u1799\u1780\u1780\u17C6\u178E\u17BE\u178F"},{"id":9967,"word":"\u1799\u17C4\u1793\u1799\u17B6\u1793"},{"id":9968,"word":"\u1799\u17C4\u1793\u17B7\u179F\u17C4\u1798\u1793\u179F\u17B7\u1780\u17B6\u179A"},{"id":9969,"word":"\u1799\u17C4\u1793\u17B8"},{"id":9970,"word":"\u1799\u17C4\u1794\u179B\u17CB"},{"id":9971,"word":"\u1799\u17C4\u1794\u17C6 "},{"id":9972,"word":"\u1799\u17C4\u1796\u17D2\u179C\u1793\u17C8"},{"id":9973,"word":"\u1799\u17C4\u1798\u179A\u17B6\u1787"},{"id":9974,"word":"\u1799\u17C4\u179B"},{"id":9975,"word":"\u1799\u17C4\u179F\u17B6"},{"id":9976,"word":"\u1799\u17C4\u179F\u17C4"},{"id":9977,"word":"\u1799\u17C5"},{"id":9978,"word":"\u1799\u17C5\u179C\u17CD"},{"id":9979,"word":"\u1799\u17C5\u179C\u17D0\u1793"},{"id":9980,"word":"\u1799\u17C6"},{"id":9981,"word":"\u1799\u17B6\u17C6\u1784"},{"id":9982,"word":"\u1799\u17C7"},{"id":9983,"word":"\u1799\u17C7\u1780\u1793\u17D2\u1792\u17C2\u1780"},{"id":9984,"word":"\u179A"},{"id":9985,"word":"\u179A\u17C9"},{"id":9986,"word":"\u179A\u1780\u17CD"},{"id":9987,"word":"\u179A\u1780"},{"id":9988,"word":"\u179A\u17C9\u1780"},{"id":9989,"word":"\u179A\u1780\u1780\u179B\u17CB"},{"id":9990,"word":"\u179A\u1780\u178F\u17C2"},{"id":9991,"word":"\u179A\u1780\u1798"},{"id":9992,"word":"\u179A\u1780\u17B6"},{"id":9993,"word":"\u179A\u1780\u17B6\u178A\u17C2\u1780"},{"id":9994,"word":"\u179A\u1780\u17B9\u1780"},{"id":9995,"word":"\u179A\u1780\u17B9\u1784"},{"id":9996,"word":"\u179A\u1780\u17BC\u178F"},{"id":9997,"word":"\u179A\u1780\u17C0\u179F"},{"id":9998,"word":"\u179A\u1780\u17C1\u178F"},{"id":9999,"word":"\u179A\u1780\u17B6\u17C6"},{"id":10000,"word":"\u179A\u1780\u17B6\u17C6\u179A\u1780\u17BC\u179F"},{"id":10001,"word":"\u179A\u1780\u17D2\u179F"},{"id":10002,"word":"\u179A\u1780\u17D2\u179F\u17B6"},{"id":10003,"word":"\u179A\u1780\u17D2\u179F\u17B6\u1797\u17B7\u1794\u17B6\u179B"},{"id":10004,"word":"\u179A\u1780\u17D2\u179F\u17B6\u1796\u17D2\u179A\u17C7\u17A2\u1784\u17D2\u1782"},{"id":10005,"word":"\u179A\u1780\u17D2\u179F\u17B6\u179F\u17D2\u179A\u17BB\u1780"},{"id":10006,"word":"\u179A\u1781\u1780"},{"id":10007,"word":"\u179A\u1781\u1780\u17CB"},{"id":10008,"word":"\u179A\u1781\u17B6\u1780"},{"id":10009,"word":"\u179A\u1781\u17B7\u1780\u179A\u1781\u1780\u17CB"},{"id":10010,"word":"\u179A\u1781\u17B7\u1789"},{"id":10011,"word":"\u179A\u1781\u17B7\u178F"},{"id":10012,"word":"\u179A\u1781\u17B7\u1793"},{"id":10013,"word":"\u179A\u1781\u17BA\u178F"},{"id":10014,"word":"\u179A\u1781\u17BB\u1789"},{"id":10015,"word":"\u179A\u1781\u17BC\u179F"},{"id":10016,"word":"\u179A\u1781\u17C1\u1780"},{"id":10017,"word":"\u179A\u1781\u17C2\u1780"},{"id":10018,"word":"\u179A\u1781\u17C2\u17C7"},{"id":10019,"word":"\u179A\u1781\u17C4\u1780"},{"id":10020,"word":"\u179A\u1782\u1784"},{"id":10021,"word":"\u179A\u1782\u17B6\u1798"},{"id":10022,"word":"\u179A\u1782\u17B7\u1794\u179A\u1782\u17BB\u1794"},{"id":10023,"word":"\u179A\u1782\u17B8\u1784"},{"id":10024,"word":"\u179A\u1782\u17B8\u1798"},{"id":10025,"word":"\u179A\u1782\u17B9\u1784"},{"id":10026,"word":"\u179A\u1782\u17BB\u1794"},{"id":10027,"word":"\u179A\u1782\u17BE\u1798"},{"id":10028,"word":"\u179A\u1782\u17BE\u179B"},{"id":10029,"word":"\u179A\u1782\u17C1\u1784"},{"id":10030,"word":"\u179A\u1782\u17C4\u1784"},{"id":10031,"word":"\u179A\u1782\u17C4\u179B"},{"id":10032,"word":"\u179A\u1782\u17B6\u17C6\u1784"},{"id":10033,"word":"\u179A\u1783\u17B7\u1780\u179A\u1783\u17BB\u1780"},{"id":10034,"word":"\u179A\u1783\u17B7\u1784\u179A\u1783\u17BB\u1784"},{"id":10035,"word":"\u179A\u1783\u17B9\u1780\u179A\u1783\u17BB\u1780"},{"id":10036,"word":"\u179A\u1783\u17BB\u1780\u179A\u1783\u17B6\u1780\u17CB"},{"id":10037,"word":"\u179A\u1783\u17BB\u1784"},{"id":10038,"word":"\u179A\u1783\u17BB\u1784\u179A\u1783\u17B6\u17C6\u1784"},{"id":10039,"word":"\u179A\u1783\u17B6\u17C6\u1784"},{"id":10040,"word":"\u179A\u1784"},{"id":10041,"word":"\u179A\u1784"},{"id":10042,"word":"\u179A\u1784\u17CB"},{"id":10043,"word":"\u179A\u1784\u1786\u17B6\u1799"},{"id":10044,"word":"\u179A\u1784\u1787\u17BE\u1784"},{"id":10045,"word":"\u179A\u1784\u17CB\u178A\u17BF\u1784"},{"id":10046,"word":"\u179A\u1784\u1791\u17B9\u1780"},{"id":10047,"word":"\u179A\u1784\u179B\u17CB"},{"id":10048,"word":"\u179A\u1784\u17B6"},{"id":10049,"word":"\u179A\u1784\u17B6\u1780\u17CB"},{"id":10050,"word":"\u179A\u1784\u17B6\u1780\u17CB\u179A\u1784\u17BE\u1780"},{"id":10051,"word":"\u179A\u1784\u17C9\u17B6\u1780\u17CB\u179A\u1784\u17C9\u17BE\u1780"},{"id":10052,"word":"\u179A\u1784\u17B6\u1793\u17CB"},{"id":10053,"word":"\u179A\u1784\u17B6\u1794\u17CB"},{"id":10054,"word":"\u179A\u1784\u17C9\u17B6\u1794\u17CB\u179A\u1784\u17BD"},{"id":10055,"word":"\u179A\u1784\u17C9\u17B6\u1794\u17CB\u179A\u1784\u17BE"},{"id":10056,"word":"\u179A\u1784\u17B6\u179B"},{"id":10057,"word":"\u179A\u1784\u17B6\u179C"},{"id":10058,"word":"\u179A\u1784\u17B6\u179C\u1780\u1780"},{"id":10059,"word":"\u179A\u1784\u17C9\u17B7\u1780\u179A\u1784\u17C9\u1780\u17CB"},{"id":10060,"word":"\u179A\u1784\u17B8\u1780"},{"id":10061,"word":"\u179A\u1784\u17B8\u179A\u1784\u17BE"},{"id":10062,"word":"\u179A\u1784\u17C9\u17BA\u178F"},{"id":10063,"word":"\u179A\u1784\u17BB\u1798"},{"id":10064,"word":"\u179A\u1784\u17BC"},{"id":10065,"word":"\u179A\u1784\u17C9\u17BC\u179C"},{"id":10066,"word":"\u179A\u1784\u17BD\u1799"},{"id":10067,"word":"\u179A\u1784\u17BE\u1780"},{"id":10068,"word":"\u179A\u1784\u17BE\u1798"},{"id":10069,"word":"\u179A\u1784\u17C0\u1780"},{"id":10070,"word":"\u179A\u1784\u17C0\u1798"},{"id":10071,"word":"\u179A\u1784\u17C1\u179A\u1784\u17BE"},{"id":10072,"word":"\u179A\u1784\u17C9\u17C2"},{"id":10073,"word":"\u179A\u1784\u17C2\u1780"},{"id":10074,"word":"\u179A\u1784\u17C3"},{"id":10075,"word":"\u179A\u1784\u17C4\u1780"},{"id":10076,"word":"\u179A\u1784\u17C9\u17C4\u1798"},{"id":10077,"word":"\u179A\u1784\u17BB\u17C6"},{"id":10078,"word":"\u179A\u1784\u17C6"},{"id":10079,"word":"\u179A\u1784\u17D2\u1780\u17C0\u1780"},{"id":10080,"word":"\u179A\u1784\u17D2\u1780\u17C0\u1780\u1794\u1784\u17D2\u1782\u17C4\u179B"},{"id":10081,"word":"\u179A\u1784\u17D2\u1780\u17C0\u179F"},{"id":10082,"word":"\u179A\u1784\u17D2\u1782"},{"id":10083,"word":"\u179A\u1784\u17D2\u1782\u17B6\u1787\u17B8\u1796"},{"id":10084,"word":"\u179A\u1784\u17D2\u1782\u17B6\u178F\u17CB"},{"id":10085,"word":"\u179A\u1784\u17D2\u1782\u17B6\u179B"},{"id":10086,"word":"\u179A\u1784\u17D2\u1782\u17BE"},{"id":10087,"word":"\u179A\u1784\u17D2\u1782\u17BE\u1780"},{"id":10088,"word":"\u179A\u1784\u17D2\u1782\u17C4\u17C7"},{"id":10089,"word":"\u179A\u1784\u17D2\u1782\u17C6"},{"id":10090,"word":"\u179A\u1784\u17D2\u179C\u1784\u17CB"},{"id":10091,"word":"\u179A\u1784\u17D2\u179C\u17B6\u1793\u17CB"},{"id":10092,"word":"\u179A\u1784\u17D2\u179C\u17B6\u179B\u17CB"},{"id":10093,"word":"\u179A\u1784\u17D2\u179C\u17B6\u179F\u17CB"},{"id":10094,"word":"\u179A\u1784\u17D2\u179C\u17B9\u1784"},{"id":10095,"word":"\u179A\u1784\u17D2\u179C\u17BE\u179B"},{"id":10096,"word":"\u179A\u1784\u17D2\u179C\u17C1\u179B"},{"id":10097,"word":"\u179A\u1784\u17D2\u179C\u17C7"},{"id":10098,"word":"\u179A\u1784\u17D2\u179F\u17B8"},{"id":10099,"word":"\u179A\u1785\u1793\u17B6"},{"id":10100,"word":"\u179A\u1785\u1793\u17B6\u1794\u1791\u17BB\u1798"},{"id":10101,"word":"\u179A\u1785\u1793\u17B6\u1794\u17D0\u1791\u17D2\u1798"},{"id":10102,"word":"\u179A\u1785\u179B\u17CB"},{"id":10103,"word":"\u179A\u1785\u179B\u17C1\u1781\u17B6"},{"id":10104,"word":"\u179A\u1785\u17C1\u1785\u179A\u1785\u17B6\u1785"},{"id":10105,"word":"\u179A\u1785\u17C2\u1780\u179A\u1785\u17C4\u1780"},{"id":10106,"word":"\u179A\u1786\u17C0\u1794\u179A\u1789\u17C1\u1789"},{"id":10107,"word":"\u179A\u1786\u17C1\u1784\u179A\u1786\u17BC\u1784"},{"id":10108,"word":"\u179A\u1786\u17C1\u1785\u179A\u1786\u17BC\u1785"},{"id":10109,"word":"\u179A\u1786\u17C1\u178F\u179A\u1786\u17BC\u178F"},{"id":10110,"word":"\u179A\u1787\u1780"},{"id":10111,"word":"\u179A\u1787\u1780\u17B8"},{"id":10112,"word":"\u179A\u1787\u178F\u17C8"},{"id":10113,"word":"\u179A\u1787\u1793\u1780\u1798\u17D2\u1798"},{"id":10114,"word":"\u179A\u1787\u1793\u17B8"},{"id":10115,"word":"\u179A\u1787\u1799"},{"id":10116,"word":"\u179A\u1787\u17B7\u1780\u17B6"},{"id":10117,"word":"\u179A\u1787\u17BE\u1794"},{"id":10118,"word":"\u179A\u1787\u17C4\u179A"},{"id":10119,"word":"\u179A\u1787\u17D2\u1787\u1780\u17B6\u179B"},{"id":10120,"word":"\u179A\u1787\u17D2\u1787\u1791\u17B6\u1799\u17B6\u1791"},{"id":10121,"word":"\u179A\u1787\u17D2\u1787\u1794\u17D2\u1794\u179C\u17C1\u178E\u17B8"},{"id":10122,"word":"\u179A\u1787\u17D2\u1787\u179F\u1798\u17D0\u1799"},{"id":10123,"word":"\u179A\u1787\u17D2\u1787\u179F\u17B8\u1798\u17B6"},{"id":10124,"word":"\u179A\u1787\u17D2\u1787\u17BC\u1794\u1780\u179A\u178E\u17CD"},{"id":10125,"word":"\u179A\u1787\u17D2\u1787\u17BC\u1794\u1780\u17B6\u179A"},{"id":10126,"word":"\u179A\u1789\u17CB"},{"id":10127,"word":"\u179A\u1789\u17C9"},{"id":10128,"word":"\u179A\u1789\u1784\u17CB"},{"id":10129,"word":"\u179A\u1789\u1798"},{"id":10130,"word":"\u179A\u1789\u17B6"},{"id":10131,"word":"\u179A\u1789\u17C9\u17B6\u179B\u17CB"},{"id":10132,"word":"\u179A\u1789\u17C9\u17B7\u1780\u179A\u1789\u17C9\u17BB\u1780 "},{"id":10133,"word":"\u179A\u1789\u17C9\u17B7\u1784\u179A\u1789\u17C9\u17B6\u17C6\u1784"},{"id":10134,"word":"\u179A\u1789\u17C9\u17B7\u1794\u179A\u1789\u17C9\u17BB\u1794"},{"id":10135,"word":"\u179A\u1789\u17C9\u17B7\u1798"},{"id":10136,"word":"\u179A\u1789\u17C9\u17B7\u179B"},{"id":10137,"word":"\u179A\u1789\u17B8"},{"id":10138,"word":"\u179A\u1789\u17C9\u17B8"},{"id":10139,"word":"\u179A\u1789\u17B8\u179C"},{"id":10140,"word":"\u179A\u1789\u17B9\u1780"},{"id":10141,"word":"\u179A\u1789\u17B9\u1780\u179A\u1789\u17C9\u17B8"},{"id":10142,"word":"\u179A\u1789\u17C9\u17B9\u1780\u179A\u1789\u17C9\u17C2"},{"id":10143,"word":"\u179A\u1789\u17BC\u179A\u1789\u17C1\u1789"},{"id":10144,"word":"\u179A\u1789\u17C0\u179C"},{"id":10145,"word":"\u179A\u1789\u17C9\u17C1\u1785\u179A\u1789\u17C9\u17B6\u1785"},{"id":10146,"word":"\u179A\u1789\u17C9\u17C1\u1785\u179A\u1789\u17C9\u17BC\u1785"},{"id":10147,"word":"\u179A\u1789\u17C1\u1789"},{"id":10148,"word":"\u179A\u1789\u17C9\u17C1\u179C\u179A\u1789\u17C9\u17B6\u179C"},{"id":10149,"word":"\u179A\u1789\u17C9\u17C1\u17C7\u179A\u1789\u17C9\u17C4\u17C7"},{"id":10150,"word":"\u179A\u1789\u17C9\u17C2"},{"id":10151,"word":"\u179A\u1789\u17C9\u17C2\u1780\u179A\u1789\u17C9\u1780"},{"id":10152,"word":"\u179A\u1789\u17C9\u17C2\u179A\u1789\u17C9\u17BC\u179C"},{"id":10153,"word":"\u179A\u1789\u17C4\u179A\u1789\u17C1\u1789"},{"id":10154,"word":"\u179A\u1789\u17C9\u17B6\u17C6"},{"id":10155,"word":"\u179A\u1789\u17C9\u17B6\u17C6\u179A\u1789\u17C9\u17BC\u179C"},{"id":10156,"word":"\u179A\u1789\u17D2\u1787\u17BD\u1799"},{"id":10157,"word":"\u179A\u178A\u1780"},{"id":10158,"word":"\u179A\u178A\u17B6\u1780\u17CB"},{"id":10159,"word":"\u179A\u178A\u17B6\u1785\u17CB"},{"id":10160,"word":"\u179A\u178A\u17B6\u1785\u17CB\u179A\u178A\u17C4\u1785"},{"id":10161,"word":"\u179A\u178A\u17B7\u1794"},{"id":10162,"word":"\u179A\u178A\u17B9\u1780"},{"id":10163,"word":"\u179A\u178A\u17BA\u1793"},{"id":10164,"word":"\u179A\u178A\u17BB\u1794"},{"id":10165,"word":"\u179A\u178A\u17BC\u1780"},{"id":10166,"word":"\u179A\u178A\u17C0\u1793"},{"id":10167,"word":"\u179A\u178A\u17C1\u1785"},{"id":10168,"word":"\u179A\u178A\u17C1\u1798\u179A\u178A\u1798"},{"id":10169,"word":"\u179A\u178A\u17C2"},{"id":10170,"word":"\u179A\u178A\u17C2\u178F"},{"id":10171,"word":"\u179A\u178A\u17C2\u1798\u179A\u178A\u1798"},{"id":10172,"word":"\u179A\u178A\u17C4\u17C7"},{"id":10173,"word":"\u179A\u178A\u17D2\u178B"},{"id":10174,"word":"\u179A\u178C\u17BB\u1780"},{"id":10175,"word":"\u179A\u178E\u17C8"},{"id":10176,"word":"\u179A\u178E\u1794"},{"id":10177,"word":"\u179A\u178E\u17B6\u179A"},{"id":10178,"word":"\u179A\u178E\u17B7\u1784\u179A\u178E\u17BB\u1784"},{"id":10179,"word":"\u179A\u178E\u17B7\u1798\u179A\u178E\u17BB\u17C6"},{"id":10180,"word":"\u179A\u178E\u17B7\u179B"},{"id":10181,"word":"\u179A\u178E\u17BC\u1784\u179A\u178E\u17B6\u1784"},{"id":10182,"word":"\u179A\u178E\u17C1\u1794\u179A\u178E\u1794"},{"id":10183,"word":"\u179A\u178E\u17C1\u1794\u179A\u178E\u17BA\u1794"},{"id":10184,"word":"\u179A\u178E\u17C2\u1784"},{"id":10185,"word":"\u179A\u178E\u17C2\u179A\u178E\u17C4"},{"id":10186,"word":"\u179A\u178E\u17C2\u1794\u179A\u178E\u1794"},{"id":10187,"word":"\u179A\u178E\u17C2\u179B"},{"id":10188,"word":"\u179A\u178E\u17C4\u1784"},{"id":10189,"word":"\u179A\u178E\u17C4\u1794\u17B6\u1799"},{"id":10190,"word":"\u179A\u178E\u17D2\u178F\u17B6\u1794\u17CB"},{"id":10191,"word":"\u179A\u178E\u17D2\u178F\u17B6\u179F"},{"id":10192,"word":"\u179A\u178E\u17D2\u178A\u17C5"},{"id":10193,"word":"\u179A\u178E\u17D2\u178F\u17C6"},{"id":10194,"word":"\u179A\u178E\u17D2\u178C\u1780\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":10195,"word":"\u179A\u178F"},{"id":10196,"word":"\u179A\u178F\u17CB"},{"id":10197,"word":"\u179A\u178F\u1793\u17C8"},{"id":10198,"word":"\u179A\u178F\u1793 --"},{"id":10199,"word":"\u179A\u178F\u1793\u1782\u17B7\u179A\u17B8"},{"id":10200,"word":"\u179A\u178F\u1793\u17B6"},{"id":10201,"word":"\u179A\u178F\u1793\u17C4\u1797\u17B6\u179F"},{"id":10202,"word":"\u179A\u178F\u17CB\u1799\u17BD\u1793"},{"id":10203,"word":"\u179A\u178F\u17B6\u1780"},{"id":10204,"word":"\u179A\u178F\u17B6\u178F\u17CB"},{"id":10205,"word":"\u179A\u178F\u17B6\u1799"},{"id":10206,"word":"\u179A\u178F\u17B6\u179C"},{"id":10207,"word":"\u179A\u178F\u17B7"},{"id":10208,"word":"\u179A\u178F\u17B7\u1780\u179A\u178F\u17BB\u1780"},{"id":10209,"word":"\u179A\u178F\u17B7\u1794\u179A\u178F\u17BB\u1794"},{"id":10210,"word":"\u179A\u178F\u17B9\u1784"},{"id":10211,"word":"\u179A\u178F\u17BC\u178F"},{"id":10212,"word":"\u179A\u178F\u17BC\u179C"},{"id":10213,"word":"\u179A\u178F\u17C1\u1780"},{"id":10214,"word":"\u179A\u178F\u17C1\u178F"},{"id":10215,"word":"\u179A\u178F\u17C1\u1799"},{"id":10216,"word":"\u179A\u178F\u17C1\u179C"},{"id":10217,"word":"\u179A\u178F\u17C2\u1780"},{"id":10218,"word":"\u179A\u178F\u17C2\u1784"},{"id":10219,"word":"\u179A\u178F\u17C4\u1780"},{"id":10220,"word":"\u179A\u178F\u17C4\u1784"},{"id":10221,"word":"\u179A\u178F\u17D2\u178F"},{"id":10222,"word":"\u179A\u178F\u17D2\u178F\u1789\u17D2\u1789\u17BC"},{"id":10223,"word":"\u179A\u178F\u17D2\u178F\u17B7\u1780\u17B6\u179B"},{"id":10224,"word":"\u179A\u178F\u17D2\u178F\u17B7\u1785\u179A"},{"id":10225,"word":"\u179A\u178F\u17D2\u178F\u17B7\u1785\u17D2\u1786\u17C1\u1791"},{"id":10226,"word":"\u179A\u178F\u17D2\u178F\u17B7\u1793\u17D2\u1791\u17B7\u1796"},{"id":10227,"word":"\u179A\u178F\u17D2\u178F\u17B7\u1797\u17B6\u1782"},{"id":10228,"word":"\u179A\u178F\u17D2\u178F\u17BB\u1794\u17D2\u1794\u179B"},{"id":10229,"word":"\u179A\u178F\u17D2\u1793 --"},{"id":10230,"word":"\u179A\u178F\u17D2\u1793\u178F\u17D2\u179A\u17D0\u1799"},{"id":10231,"word":"\u179A\u178F\u17D2\u1793\u17B6"},{"id":10232,"word":"\u179A\u178F\u17D2\u1793\u17B6\u1780\u179A"},{"id":10233,"word":"\u179A\u1790"},{"id":10234,"word":"\u179A\u1790 --"},{"id":10235,"word":"\u179A\u1790\u17B6 --"},{"id":10236,"word":"\u179A\u1790\u17BC\u1794\u1780\u179A\u178E\u17CD"},{"id":10237,"word":"\u179A\u1791\u1784"},{"id":10238,"word":"\u179A\u1791\u17B6\u179F"},{"id":10239,"word":"\u179A\u1791\u17B8\u179F"},{"id":10240,"word":"\u179A\u1791\u17BB\u17C7"},{"id":10241,"word":"\u179A\u1791\u17BC"},{"id":10242,"word":"\u179A\u1791\u17BC\u179A\u1791\u17B6\u17C6"},{"id":10243,"word":"\u179A\u1791\u17BE\u179F"},{"id":10244,"word":"\u179A\u1791\u17C1\u1789"},{"id":10245,"word":"\u179A\u1791\u17C1\u17C7"},{"id":10246,"word":"\u179A\u1791\u17C2\u1784"},{"id":10247,"word":"\u179A\u1791\u17C4\u1784\u17D7"},{"id":10248,"word":"\u179A\u1791\u17B6\u17C6"},{"id":10249,"word":"\u179A\u1791\u17B6\u17C6\u1784"},{"id":10250,"word":"\u179A\u1793"},{"id":10251,"word":"\u179A\u1793\u1784"},{"id":10252,"word":"\u179A\u1793\u179B"},{"id":10253,"word":"\u179A\u1793\u17B6\u178F"},{"id":10254,"word":"\u179A\u1793\u17B6\u1794"},{"id":10255,"word":"\u179A\u1793\u17B6\u1798"},{"id":10256,"word":"\u179A\u1793\u17B6\u179B"},{"id":10257,"word":"\u179A\u1793\u17B6\u179F\u17CB"},{"id":10258,"word":"\u179A\u1793\u17B7\u1784\u179A\u1793\u17B6\u17C6\u1784"},{"id":10259,"word":"\u179A\u1793\u17BB\u1780"},{"id":10260,"word":"\u179A\u1793\u17BC\u178F"},{"id":10261,"word":"\u179A\u1793\u17BD\u178F"},{"id":10262,"word":"\u179A\u1793\u17C1\u179B"},{"id":10263,"word":"\u179A\u1793\u17C4\u1784"},{"id":10264,"word":"\u179A\u1793\u17C4\u1785"},{"id":10265,"word":"\u179A\u1793\u17C4\u179B"},{"id":10266,"word":"\u179A\u1793\u17B6\u17C6\u1784"},{"id":10267,"word":"\u179A\u1793\u17C7"},{"id":10268,"word":"\u179A\u1793\u17C7\u179A\u1793\u17B6\u178F"},{"id":10269,"word":"\u179A\u1793\u17D2\u178F\u17B7\u1797\u17B6\u1796"},{"id":10270,"word":"\u179A\u1793\u17D2\u1790\u17B6\u1793\u17CB"},{"id":10271,"word":"\u179A\u1793\u17D2\u1791\u17B6"},{"id":10272,"word":"\u179A\u1793\u17D2\u1791\u17B6\u179B"},{"id":10273,"word":"\u179A\u1793\u17D2\u1791\u17BA"},{"id":10274,"word":"\u179A\u1793\u17D2\u1791\u17C1\u1794"},{"id":10275,"word":"\u179A\u1793\u17D2\u1791\u17C7"},{"id":10276,"word":"\u179A\u1793\u17D2\u1791\u17C7\u1798\u17B6\u178F\u17CB"},{"id":10277,"word":"\u179A\u1793\u17D2\u1792"},{"id":10278,"word":"\u179A\u1793\u17D2\u1792\u1780\u179F\u178F\u17D2\u178F"},{"id":10279,"word":"\u179A\u1793\u17D2\u1792\u1782\u179C\u17C1\u179F\u17B7\u1793\u17B8"},{"id":10280,"word":"\u179A\u1793\u17D2\u1792\u1782\u179C\u17C1\u179F\u17B8"},{"id":10281,"word":"\u179A\u1793\u17D2\u1792\u178F\u17CB"},{"id":10282,"word":"\u179A\u1793\u17D2\u1792\u179C\u17B6\u179F"},{"id":10283,"word":"\u179A\u1793\u17D2\u1792\u179C\u17B6\u179F\u17B7\u1793\u17B8"},{"id":10284,"word":"\u179A\u1793\u17D2\u1792\u179C\u17B6\u179F\u17B8"},{"id":10285,"word":"\u179A\u1794"},{"id":10286,"word":"\u179A\u1794\u1780"},{"id":10287,"word":"\u179A\u1794\u1784"},{"id":10288,"word":"\u179A\u1794\u178F\u17CB"},{"id":10289,"word":"\u179A\u1794\u1791\u17B7\u1798"},{"id":10290,"word":"\u179A\u1794\u1794"},{"id":10291,"word":"\u179A\u1794\u179A"},{"id":10292,"word":"\u179A\u1794\u179F\u17CB"},{"id":10293,"word":"\u179A\u1794\u17B6"},{"id":10294,"word":"\u179A\u1794\u17B6\u1789"},{"id":10295,"word":"\u179A\u1794\u17C9\u17B6\u178F\u17CB\u179A\u1794\u17C9\u17B6\u1799"},{"id":10296,"word":"\u179A\u1794\u17B6\u1791"},{"id":10297,"word":"\u179A\u1794\u17B6\u1799"},{"id":10298,"word":"\u179A\u1794\u17C9\u17B6\u1799"},{"id":10299,"word":"\u179A\u1794\u17B6\u179A"},{"id":10300,"word":"\u179A\u1794\u17B6\u179B"},{"id":10301,"word":"\u179A\u1794\u17C9\u17B7\u1780\u179A\u1794\u17C9\u17BB\u1780"},{"id":10302,"word":"\u179A\u1794\u17C9\u17B7\u1785\u179A\u1794\u17C9\u17B8"},{"id":10303,"word":"\u179A\u1794\u17B7\u1789\u179A\u1794\u17BB\u1789"},{"id":10304,"word":"\u179A\u1794\u17C9\u17B7\u178F\u179A\u1794\u17C9\u17BB\u178F"},{"id":10305,"word":"\u179A\u1794\u17C9\u17B7\u1793\u179A\u1794\u17C9\u17B6\u1793\u17CB"},{"id":10306,"word":"\u179A\u1794\u17C9\u17B7\u179B\u179A\u1794\u17C9\u17BC\u1785"},{"id":10307,"word":"\u179A\u1794\u17B9\u1784"},{"id":10308,"word":"\u179A\u1794\u17B9\u1794"},{"id":10309,"word":"\u179A\u1794\u17C9\u17BA\u178F\u179A\u1794\u17C9\u17C4\u1784"},{"id":10310,"word":"\u179A\u1794\u17BB\u1780"},{"id":10311,"word":"\u179A\u1794\u17BB\u1780\u1787\u17B6\u179F"},{"id":10312,"word":"\u179A\u1794\u17BB\u1784"},{"id":10313,"word":"\u179A\u1794\u17BB\u1789"},{"id":10314,"word":"\u179A\u1794\u17BB\u1798"},{"id":10315,"word":"\u179A\u1794\u17BC\u178F"},{"id":10316,"word":"\u179A\u1794\u17BD\u179B"},{"id":10317,"word":"\u179A\u1794\u17BD\u179F"},{"id":10318,"word":"\u179A\u1794\u17BE\u1780"},{"id":10319,"word":"\u179A\u1794\u17BE\u179A"},{"id":10320,"word":"\u179A\u1794\u17BE\u179F"},{"id":10321,"word":"\u179A\u1794\u17C0\u1784"},{"id":10322,"word":"\u179A\u1794\u17C0\u1793"},{"id":10323,"word":"\u179A\u1794\u17C0\u1794"},{"id":10324,"word":"\u179A\u1794\u17C1\u1784"},{"id":10325,"word":"\u179A\u1794\u17C1\u1789\u179A\u1794\u17BB\u1789"},{"id":10326,"word":"\u179A\u1794\u17C9\u17C1\u179F\u179A\u1794\u17C9\u179F"},{"id":10327,"word":"\u179A\u1794\u17C1\u17C7"},{"id":10328,"word":"\u179A\u1794\u17C9\u17C1\u17C7\u179A\u1794\u17C9\u17C4\u17C7"},{"id":10329,"word":"\u179A\u1794\u17C9\u17C2\u1780\u179A\u1794\u17C9\u17B6\u1799"},{"id":10330,"word":"\u179A\u1794\u17C9\u17C2\u1780\u179A\u1794\u17C9\u17C4\u1780"},{"id":10331,"word":"\u179A\u1794\u17C2\u1784"},{"id":10332,"word":"\u179A\u1794\u17C2\u179A\u179A\u1794\u17C4\u179A"},{"id":10333,"word":"\u179A\u1794\u17C9\u17C2\u179F\u179A\u1794\u17C9\u179F"},{"id":10334,"word":"\u179A\u1794\u17C3"},{"id":10335,"word":"\u179A\u1794\u17C3\u179A\u17C3\u178A\u17B6\u1780\u17CB"},{"id":10336,"word":"\u179A\u1794\u17C4\u1785"},{"id":10337,"word":"\u179A\u1794\u17C4\u1798"},{"id":10338,"word":"\u179A\u1794\u17C4\u1799"},{"id":10339,"word":"\u179A\u1794\u17C9\u17C4\u1799"},{"id":10340,"word":"\u179A\u1794\u17C4\u17C7"},{"id":10341,"word":"\u179A\u1794\u17C4\u17C7\u179A\u1794\u17C4\u1799"},{"id":10342,"word":"\u179A\u1794\u17BB\u17C6"},{"id":10343,"word":"\u179A\u1794\u17B6\u17C6"},{"id":10344,"word":"\u179A\u1794\u17B6\u17C6\u1784"},{"id":10345,"word":"\u179A\u1794\u17B6\u17C6\u1784\u1797\u1780\u17CB"},{"id":10346,"word":"\u179A\u1794\u17B6\u17C6\u1784\u1798\u17BB\u1781"},{"id":10347,"word":"\u179A\u1794\u17C7"},{"id":10348,"word":"\u179A\u1794\u17C7 --"},{"id":10349,"word":"\u179A\u1794\u17C7\u179A\u1794\u17BE\u1784"},{"id":10350,"word":"\u179A\u1794\u17C7\u179A\u1794\u17C4\u179A"},{"id":10351,"word":"\u179A\u1795\u17B6\u178F\u17CB\u179A\u1791\u17B6\u17C6\u1784"},{"id":10352,"word":"\u179A\u1795\u17B6\u178F\u17CB\u179A\u1795\u17BB\u1799"},{"id":10353,"word":"\u179A\u1796\u17B6\u1780\u17CB"},{"id":10354,"word":"\u179A\u1796\u17B6\u1799"},{"id":10355,"word":"\u179A\u1796\u17B8\u1784"},{"id":10356,"word":"\u179A\u1796\u17B9\u1780"},{"id":10357,"word":"\u179A\u1796\u17B9\u179B"},{"id":10358,"word":"\u179A\u1796\u17B9\u179F"},{"id":10359,"word":"\u179A\u1796\u17BB\u1780"},{"id":10360,"word":"\u179A\u1796\u17BB\u1799"},{"id":10361,"word":"\u179A\u1796\u17BE\u178F\u179A\u1796\u17BE\u1784"},{"id":10362,"word":"\u179A\u1796\u17C4\u1784"},{"id":10363,"word":"\u179A\u1798"},{"id":10364,"word":"\u179A\u1798\u17C9\u1784\u17CB"},{"id":10365,"word":"\u179A\u1798\u178E\u17B8"},{"id":10366,"word":"\u179A\u1798\u178E\u17B8\u1799"},{"id":10367,"word":"\u179A\u1798\u178F\u17CB"},{"id":10368,"word":"\u179A\u1798\u178F\u17B7"},{"id":10369,"word":"\u179A\u1798\u1791\u1798"},{"id":10370,"word":"\u179A\u1798\u17B6\u1780"},{"id":10371,"word":"\u179A\u1798\u17B6\u178F\u17CB"},{"id":10372,"word":"\u179A\u1798\u17B6\u179F"},{"id":10373,"word":"\u179A\u1798\u17B6\u179F\u17CB"},{"id":10374,"word":"\u179A\u1798\u17C9\u17B7\u1780\u179A\u1798\u17C9\u1780\u17CB"},{"id":10375,"word":"\u179A\u1798\u17C9\u17B7\u1784"},{"id":10376,"word":"\u179A\u1798\u17C9\u17B7\u1784\u179A\u1798\u17C9\u17B6\u17C6\u1784"},{"id":10377,"word":"\u179A\u1798\u17B7\u179B"},{"id":10378,"word":"\u179A\u1798\u17B7\u179B\u1782\u17BB\u178E"},{"id":10379,"word":"\u179A\u1798\u17C9\u17B9\u1798"},{"id":10380,"word":"\u179A\u1798\u17B9\u179B"},{"id":10381,"word":"\u179A\u1798\u17B9\u179B\u1782\u17BB\u178E"},{"id":10382,"word":"\u179A\u1798\u17BC\u179A"},{"id":10383,"word":"\u179A\u1798\u17BC\u179B"},{"id":10384,"word":"\u179A\u1798\u17BD\u179B"},{"id":10385,"word":"\u179A\u1798\u17BD\u179B\u1780\u17D2\u179A\u1796\u17BE"},{"id":10386,"word":"\u179A\u1798\u17C0\u178F"},{"id":10387,"word":"\u179A\u1798\u17C0\u179B"},{"id":10388,"word":"\u179A\u1798\u17C1\u1789"},{"id":10389,"word":"\u179A\u1798\u17C9\u17C1\u17C7\u179A\u1798\u17C9\u17C4\u17C7"},{"id":10390,"word":"\u179A\u1798\u17C2\u1784"},{"id":10391,"word":"\u179A\u1798\u17C9\u17C4\u1780"},{"id":10392,"word":"\u179A\u1798\u17B6\u17C6\u1784"},{"id":10393,"word":"\u179A\u1798\u17B6\u17C6\u1784\u1794\u17BE\u1780 \u1794\u17B6\u179F"},{"id":10394,"word":"\u179A\u1798\u17C9\u17B6\u17C6\u1784\u179A\u1798\u17C9\u17C4\u1780"},{"id":10395,"word":"\u179A\u1798\u17D2\u1784\u1780"},{"id":10396,"word":"\u179A\u1798\u17D2\u1784\u17B6\u1785"},{"id":10397,"word":"\u179A\u1798\u17D2\u1784\u17B6\u1794\u17CB"},{"id":10398,"word":"\u179A\u1798\u17D2\u1784\u17B6\u179F\u17CB"},{"id":10399,"word":"\u179A\u1798\u17D2\u1784\u17BE\u1780"},{"id":10400,"word":"\u179A\u1798\u17D2\u178F\u17C4\u17C7"},{"id":10401,"word":"\u179A\u1798\u17D2\u1797\u17B6"},{"id":10402,"word":"\u179A\u1798\u17D2\u1799"},{"id":10403,"word":"\u179A\u1798\u17D2\u1799\u1791\u1798"},{"id":10404,"word":"\u179A\u1798\u17D2\u1799\u17B6"},{"id":10405,"word":"\u179A\u1798\u17D2\u179B\u178F\u17CB"},{"id":10406,"word":"\u179A\u1798\u17D2\u179B\u1794\u17CB"},{"id":10407,"word":"\u179A\u1798\u17D2\u179B\u179F\u17CB"},{"id":10408,"word":"\u179A\u1798\u17D2\u179B\u17B6\u1780"},{"id":10409,"word":"\u179A\u1798\u17D2\u179B\u17B6\u1799"},{"id":10410,"word":"\u179A\u1798\u17D2\u179B\u17B8\u1784"},{"id":10411,"word":"\u179A\u1798\u17D2\u179B\u17B9\u1780"},{"id":10412,"word":"\u179A\u1798\u17D2\u179B\u17BB\u1794"},{"id":10413,"word":"\u179A\u1798\u17D2\u179B\u17BB\u17C7"},{"id":10414,"word":"\u179A\u1798\u17D2\u179B\u17BC\u178F"},{"id":10415,"word":"\u179A\u1798\u17D2\u179B\u17BE\u1784"},{"id":10416,"word":"\u179A\u1798\u17D2\u179B\u17C4\u1780"},{"id":10417,"word":"\u179A\u1798\u17D2\u179B\u17C6"},{"id":10418,"word":"\u179A\u1798\u17D2\u179F\u17B6\u1799"},{"id":10419,"word":"\u179A\u1798\u17D2\u17A0"},{"id":10420,"word":"\u179A\u1798\u17D2\u17A0\u17B6\u1785"},{"id":10421,"word":"\u179A\u1798\u17D2\u17A0\u17BC\u178F"},{"id":10422,"word":"\u179A\u1798\u17D2\u17A0\u17BE\u1799"},{"id":10423,"word":"\u179A\u1798\u17D2\u17A0\u17C2"},{"id":10424,"word":"\u179A\u1798\u17D2\u17A2\u17B6"},{"id":10425,"word":"\u179A\u1798\u17D2\u17A2\u17B7\u179B"},{"id":10426,"word":"\u179A\u1798\u17D2\u17A2\u17C2\u1784"},{"id":10427,"word":"\u179A\u1799"},{"id":10428,"word":"\u179A\u1799\u17C8"},{"id":10429,"word":"\u179A\u17C9\u1799\u1780\u17C2\u179C"},{"id":10430,"word":"\u179A\u1799\u17C9\u17B6"},{"id":10431,"word":"\u179A\u1799\u17B6\u1780"},{"id":10432,"word":"\u179A\u1799\u17B6\u1784"},{"id":10433,"word":"\u179A\u1799\u17B6\u1793"},{"id":10434,"word":"\u179A\u1799\u17B6\u1794"},{"id":10435,"word":"\u179A\u1799\u17B6\u1799"},{"id":10436,"word":"\u179A\u1799\u17B6\u179B"},{"id":10437,"word":"\u179A\u1799\u17C9\u17B7\u179B"},{"id":10438,"word":"\u179A\u1799\u17C9\u17B8"},{"id":10439,"word":"\u179A\u1799\u17B8\u1780"},{"id":10440,"word":"\u179A\u1799\u17B8\u1780\u179A\u1799\u17C4\u1780"},{"id":10441,"word":"\u179A\u1799\u17B8\u1784"},{"id":10442,"word":"\u179A\u1799\u17BA\u178F\u17D7"},{"id":10443,"word":"\u179A\u1799\u17C1\u1780\u179A\u1799\u17C4\u1780"},{"id":10444,"word":"\u179A\u1799\u17C1\u1784"},{"id":10445,"word":"\u179A\u1799\u17C9\u17C3"},{"id":10446,"word":"\u179A\u1799\u17C4\u1784"},{"id":10447,"word":"\u179A\u1799\u17C4\u1793"},{"id":10448,"word":"\u179A\u1799\u17C6"},{"id":10449,"word":"\u179A\u1799\u17C7"},{"id":10450,"word":"\u179A\u179B "},{"id":10451,"word":"\u179A\u179B\u17CB"},{"id":10452,"word":"\u179A\u179B\u1780"},{"id":10453,"word":"\u179A\u179B\u1780\u1780\u17C2\u179C"},{"id":10454,"word":"\u179A\u179B\u1780\u179A\u1784\u17D2\u1782\u17C6"},{"id":10455,"word":"\u179A\u179B\u1784"},{"id":10456,"word":"\u179A\u179B\u1784\u17CB"},{"id":10457,"word":"\u179A\u179B\u178F\u17CB"},{"id":10458,"word":"\u179A\u179B\u1794\u17CB"},{"id":10459,"word":"\u179A\u179B\u1798"},{"id":10460,"word":"\u179A\u179B\u179A"},{"id":10461,"word":"\u179A\u179B\u179F\u17CB"},{"id":10462,"word":"\u179A\u179B\u17B6"},{"id":10463,"word":"\u179A\u179B\u17B6\u1780"},{"id":10464,"word":"\u179A\u179B\u17B6\u1780\u17CB"},{"id":10465,"word":"\u179A\u179B\u17B6\u178F"},{"id":10466,"word":"\u179A\u179B\u17B6\u178F\u17CB"},{"id":10467,"word":"\u179A\u179B\u17B6\u1794"},{"id":10468,"word":"\u179A\u179B\u17B6\u1794\u17D2\u17A2\u17C0\u179A"},{"id":10469,"word":"\u179A\u179B\u17B6\u1798"},{"id":10470,"word":"\u179A\u179B\u17B6\u1799"},{"id":10471,"word":"\u179A\u179B\u17B6\u179F\u17CB"},{"id":10472,"word":"\u179A\u179B\u17B7\u179F"},{"id":10473,"word":"\u179A\u179B\u17B8"},{"id":10474,"word":"\u179A\u179B\u17B8\u1780"},{"id":10475,"word":"\u179A\u179B\u17B8\u1784"},{"id":10476,"word":"\u179A\u179B\u17B8\u1784\u1788\u17BC\u1780"},{"id":10477,"word":"\u179A\u179B\u17B8\u1784\u179A\u179B\u17C4\u1784"},{"id":10478,"word":"\u179A\u179B\u17B8\u1794\u179A\u179B\u17B6\u1794"},{"id":10479,"word":"\u179A\u179B\u17B8\u1798\u179A\u179B\u17B6\u1798"},{"id":10480,"word":"\u179A\u179B\u17B8\u179C"},{"id":10481,"word":"\u179A\u179B\u17B9\u1780"},{"id":10482,"word":"\u179A\u179B\u17B9\u1794\u179A\u179B"},{"id":10483,"word":"\u179A\u179B\u17B9\u1798"},{"id":10484,"word":"\u179A\u179B\u17BB\u1784"},{"id":10485,"word":"\u179A\u179B\u17BB\u1794"},{"id":10486,"word":"\u179A\u179B\u17BB\u17C7"},{"id":10487,"word":"\u179A\u179B\u17BB\u17C7\u179A\u179B\u17B6\u1789"},{"id":10488,"word":"\u179A\u179B\u17BC\u1780\u179A\u179B"},{"id":10489,"word":"\u179A\u179B\u17BC\u1784"},{"id":10490,"word":"\u179A\u179B\u17BC\u178F"},{"id":10491,"word":"\u179A\u179B\u17BC\u1793"},{"id":10492,"word":"\u179A\u179B\u17BD\u178F"},{"id":10493,"word":"\u179A\u179B\u17BD\u1799"},{"id":10494,"word":"\u179A\u179B\u17BD\u179F"},{"id":10495,"word":"\u179A\u179B\u17BD\u179F\u1795\u17D2\u17A2\u17BB\u1784"},{"id":10496,"word":"\u179A\u179B\u17BE"},{"id":10497,"word":"\u179A\u179B\u17BE\u1784"},{"id":10498,"word":"\u179A\u179B\u17BE\u1794 "},{"id":10499,"word":"\u179A\u179B\u17BF"},{"id":10500,"word":"\u179A\u179B\u17C0\u1780"},{"id":10501,"word":"\u179A\u179B\u17C0\u1784"},{"id":10502,"word":"\u179A\u179B\u17C1"},{"id":10503,"word":"\u179A\u179B\u17C1\u1784\u179A\u179B\u17C4\u1784"},{"id":10504,"word":"\u179A\u179B\u17C1\u1789"},{"id":10505,"word":"\u179A\u179B\u17C1\u17C7"},{"id":10506,"word":"\u179A\u179B\u17C2\u1780"},{"id":10507,"word":"\u179A\u179B\u17C2\u1798"},{"id":10508,"word":"\u179A\u179B\u17C2\u17C7"},{"id":10509,"word":"\u179A\u179B\u17C3"},{"id":10510,"word":"\u179A\u179B\u17C4\u1780"},{"id":10511,"word":"\u179A\u179B\u17C4\u1784"},{"id":10512,"word":"\u179A\u179B\u17C4\u1785"},{"id":10513,"word":"\u179A\u179B\u17C4\u179A\u179B\u17B6\u17C6"},{"id":10514,"word":"\u179A\u179B\u17C6"},{"id":10515,"word":"\u179A\u179B\u17B6\u17C6"},{"id":10516,"word":"\u179A\u179B\u17B6\u17C6\u1784"},{"id":10517,"word":"\u179A\u179B\u17C7"},{"id":10518,"word":"\u179A\u179B\u17C7\u179A\u179B\u17B6\u17C6\u1784"},{"id":10519,"word":"\u179A\u179C\u17C9\u1780\u17CB"},{"id":10520,"word":"\u179A\u179C\u17D0\u178E\u17D2\u178C"},{"id":10521,"word":"\u179A\u179C\u179B\u17CB"},{"id":10522,"word":"\u179A\u179C\u17B6\u1784"},{"id":10523,"word":"\u179A\u179C\u17C9\u17B6\u1785\u17CB"},{"id":10524,"word":"\u179A\u179C\u17B6\u178F"},{"id":10525,"word":"\u179A\u179C\u17B6\u1793"},{"id":10526,"word":"\u179A\u179C\u17B6\u1793\u17CB"},{"id":10527,"word":"\u179A\u179C\u17B6\u1798"},{"id":10528,"word":"\u179A\u179C\u17B7"},{"id":10529,"word":"\u179A\u179C\u17C9\u17B7\u1780"},{"id":10530,"word":"\u179A\u179C\u1785"},{"id":10531,"word":"\u179A\u179C\u17B7\u1785\u179A\u179C\u17B6\u1798"},{"id":10532,"word":"\u179A\u179C\u17B7\u1793"},{"id":10533,"word":"\u179A\u179C\u17B7\u1793\u17D2\u1791"},{"id":10534,"word":"\u179A\u179C\u17B7\u17A0\u1784\u17D2\u179F"},{"id":10535,"word":"\u179A\u179C\u17B8\u1780"},{"id":10536,"word":"\u179A\u179C\u17B8\u1798"},{"id":10537,"word":"\u179A\u179C\u17B8\u179F"},{"id":10538,"word":"\u179A\u179C\u17BC\u1794"},{"id":10539,"word":"\u179A\u179C\u1798"},{"id":10540,"word":"\u179A\u179C\u17C9\u17BC\u179F"},{"id":10541,"word":"\u179A\u179C\u17BE\u1780"},{"id":10542,"word":"\u179A\u179C\u17C9\u17BE\u1780"},{"id":10543,"word":"\u179A\u179C\u17BE\u1798"},{"id":10544,"word":"\u179A\u179C\u17BE\u179A\u179C\u17B6\u1799"},{"id":10545,"word":"\u179A\u179C\u17C0\u179F"},{"id":10546,"word":"\u179A\u179C\u17C1"},{"id":10547,"word":"\u179A\u179C\u17C9\u17C1\u178F\u179A\u179C\u17C9\u178F"},{"id":10548,"word":"\u179A\u179C\u17C9\u17C1\u179F\u179A\u179C\u17C9\u179F"},{"id":10549,"word":"\u179A\u179C\u17C9\u17C1\u179F\u179A\u179C\u17C9\u17B6\u179F"},{"id":10550,"word":"\u179A\u179C\u17C9\u17C1\u179F\u179A\u179C\u17C9\u17BC\u179F"},{"id":10551,"word":"\u179A\u179C\u17C2\u1784"},{"id":10552,"word":"\u179A\u179C\u17C2\u1784\u1794\u1784\u17CB"},{"id":10553,"word":"\u179A\u179C\u17C9\u17C2\u178F\u179A\u179C\u17C9\u178F"},{"id":10554,"word":"\u179A\u179C\u17C3"},{"id":10555,"word":"\u179A\u179C\u17C9\u17C4\u1785"},{"id":10556,"word":"\u179A\u179C\u17C9\u17C4\u1794"},{"id":10557,"word":"\u179A\u179C\u17B6\u17C6\u1784"},{"id":10558,"word":"\u179A\u179C\u17B6\u17C6\u1784\u1796\u17D2\u179A\u17C3"},{"id":10559,"word":"\u179A\u179C\u17C7\u179A\u179C\u17B6\u1798"},{"id":10560,"word":"\u179A\u179F"},{"id":10561,"word":"\u179A\u179F\u17CB"},{"id":10562,"word":"\u179A\u17C9\u179F\u17CB"},{"id":10563,"word":"\u179A\u179F\u1780"},{"id":10564,"word":"\u179A\u179F\u17B6\u1780"},{"id":10565,"word":"\u179A\u179F\u17B6\u1785"},{"id":10566,"word":"\u179A\u179F\u17B6\u178F\u17CB"},{"id":10567,"word":"\u179A\u179F\u17B6\u1794\u17CB\u179A\u179F\u179B\u17CB"},{"id":10568,"word":"\u179A\u179F\u17B6\u1794\u17CB\u179A\u179F\u17B6\u1799"},{"id":10569,"word":"\u179A\u179F\u17B6\u1799"},{"id":10570,"word":"\u179A\u179F\u17B6\u1799\u1793\u179C\u17B7\u1791"},{"id":10571,"word":"\u179A\u179F\u17B6\u179C"},{"id":10572,"word":"\u179A\u179F\u17B7\u1780"},{"id":10573,"word":"\u179A\u179F\u17B8"},{"id":10574,"word":"\u179A\u179F\u17B9\u1794"},{"id":10575,"word":"\u179A\u179F\u17B9\u1794\u179A\u179F\u17C0\u1794"},{"id":10576,"word":"\u179A\u179F\u17B9\u1794\u179A\u179F\u17C0\u179C"},{"id":10577,"word":"\u179A\u179F\u17BB\u1780"},{"id":10578,"word":"\u179A\u179F\u17BB\u179B"},{"id":10579,"word":"\u179A\u179F\u17BB\u179F"},{"id":10580,"word":"\u179A\u179F\u17BC\u179C"},{"id":10581,"word":"\u179A\u179F\u17BE\u1794"},{"id":10582,"word":"\u179A\u179F\u17C0\u179B"},{"id":10583,"word":"\u179A\u179F\u17C1\u1785"},{"id":10584,"word":"\u179A\u179F\u17C1\u1798\u179A\u179F\u17B6\u1798"},{"id":10585,"word":"\u179A\u179F\u17C1\u179C"},{"id":10586,"word":"\u179A\u179F\u17C1\u17C7\u179A\u179F\u17C4\u17C7"},{"id":10587,"word":"\u179A\u179F\u17C4\u1784"},{"id":10588,"word":"\u179A\u179F\u17C4\u17C7"},{"id":10589,"word":"\u179A\u179F\u17D2\u1798\u17B8"},{"id":10590,"word":"\u179A\u179F\u17D2\u1798\u17B8\u1798\u17D0\u178F"},{"id":10591,"word":"\u179A\u179F\u17D2\u179F"},{"id":10592,"word":"\u179A\u179F\u17D2\u179F\u1780\u1787\u17B6\u178F\u17B7"},{"id":10593,"word":"\u179A\u179F\u17D2\u179F\u1780\u179F\u178F\u17D2\u178F"},{"id":10594,"word":"\u179A\u179F\u17D2\u179F\u1780\u17B6\u179B"},{"id":10595,"word":"\u179A\u179F\u17D2\u179F\u1787\u17B6\u178F\u17B7"},{"id":10596,"word":"\u179A\u179F\u17D2\u179F\u1791\u179F\u17D2\u179F\u17B7\u1793\u17B8"},{"id":10597,"word":"\u179A\u179F\u17D2\u179F\u1791\u179F\u17D2\u179F\u17B8"},{"id":10598,"word":"\u179A\u179F\u17D2\u179F\u179F\u1789\u17D2\u1789\u17B6"},{"id":10599,"word":"\u179A\u179F\u17D2\u179F\u179F\u1796\u17D2\u1791"},{"id":10600,"word":"\u179A\u179F\u17D2\u179F\u179F\u179A"},{"id":10601,"word":"\u179A\u179F\u17D2\u179F\u17B6\u179C\u17BB\u1792"},{"id":10602,"word":"\u179A\u17A0"},{"id":10603,"word":"\u179A\u17A0\u1780"},{"id":10604,"word":"\u179A\u17A0\u1780\u17CB"},{"id":10605,"word":"\u179A\u17A0\u1784\u17CB"},{"id":10606,"word":"\u179A\u17A0\u1791\u178A\u17D2\u178B\u17B6\u1793"},{"id":10607,"word":"\u179A\u17A0\u1791\u1794\u17D2\u1794\u1791\u17C1\u179F"},{"id":10608,"word":"\u179A\u17A0\u1794"},{"id":10609,"word":"\u179A\u17A0\u17D0\u179F"},{"id":10610,"word":"\u179A\u17A0\u179F\u17D2\u1790\u17B6\u1793"},{"id":10611,"word":"\u179A\u17A0\u179F\u17D2\u179F"},{"id":10612,"word":"\u179A\u17A0\u17B6\u1780\u17CB"},{"id":10613,"word":"\u179A\u17A0\u17B6\u1785"},{"id":10614,"word":"\u179A\u17A0\u17B6\u178F\u17CB"},{"id":10615,"word":"\u179A\u17A0\u17B6\u178F\u17CB\u1791\u17B9\u1780"},{"id":10616,"word":"\u179A\u17A0\u17B6\u1798"},{"id":10617,"word":"\u179A\u17A0\u17B6\u179B"},{"id":10618,"word":"\u179A\u17A0\u17B6\u179B\u17CB"},{"id":10619,"word":"\u179A\u17A0\u17B7\u1780"},{"id":10620,"word":"\u179A\u17A0\u17B7\u1785"},{"id":10621,"word":"\u179A\u17A0\u17B7\u178F"},{"id":10622,"word":"\u179A\u17A0\u17B7\u178F\u179A\u17A0\u17C3"},{"id":10623,"word":"\u179A\u17A0\u17B7\u179B"},{"id":10624,"word":"\u179A\u17A0\u17CA\u17B7\u17C7"},{"id":10625,"word":"\u179A\u17A0\u17CA\u17B7\u17C7\u179A\u17A0\u17CA\u17BB\u17C7"},{"id":10626,"word":"\u179A\u17A0\u17B9\u1798"},{"id":10627,"word":"\u179A\u17A0\u17CA\u17B9\u1798"},{"id":10628,"word":"\u179A\u17A0\u17CA\u17B9\u17C7"},{"id":10629,"word":"\u179A\u17A0\u17CA\u17BB\u1798"},{"id":10630,"word":"\u179A\u17A0\u17BB\u1799"},{"id":10631,"word":"\u179A\u17A0\u17CA\u17BB\u17C7"},{"id":10632,"word":"\u179A\u17A0\u17BC\u178F"},{"id":10633,"word":"\u179A\u17A0\u17BC\u1793"},{"id":10634,"word":"\u179A\u17A0\u17BE\u1784"},{"id":10635,"word":"\u179A\u17A0\u17BE\u178F"},{"id":10636,"word":"\u179A\u17A0\u17BE\u178F\u179A\u17A0\u17B6\u17C6\u1784"},{"id":10637,"word":"\u179A\u17A0\u17BE\u1799"},{"id":10638,"word":"\u179A\u17A0\u17BE\u179A\u179A\u17A0\u17B6\u1799"},{"id":10639,"word":"\u179A\u17A0\u17C0\u1784"},{"id":10640,"word":"\u179A\u17A0\u17C0\u179A"},{"id":10641,"word":"\u179A\u17A0\u17C1\u1784\u179A\u17A0\u17B6\u1784"},{"id":10642,"word":"\u179A\u17A0\u17C1\u178F\u179A\u17A0\u17BC\u178F"},{"id":10643,"word":"\u179A\u17A0\u17C1\u1798"},{"id":10644,"word":"\u179A\u17A0\u17C1\u179C"},{"id":10645,"word":"\u179A\u17A0\u17C1\u179C\u179A\u17A0\u17B6\u179C"},{"id":10646,"word":"\u179A\u17A0\u17C2"},{"id":10647,"word":"\u179A\u17A0\u17C2\u1780"},{"id":10648,"word":"\u179A\u17A0\u17C2\u1784"},{"id":10649,"word":"\u179A\u17A0\u17C2\u179B"},{"id":10650,"word":"\u179A\u17A0\u17C4\u1780"},{"id":10651,"word":"\u179A\u17A0\u17C4"},{"id":10652,"word":"\u179A\u17A0\u17C4\u178B\u17B6\u1793"},{"id":10653,"word":"\u179A\u17A0\u17C4\u1797\u17B6\u1796"},{"id":10654,"word":"\u179A\u17A0\u17C4\u179B"},{"id":10655,"word":"\u179A\u17A0\u17C4\u179F"},{"id":10656,"word":"\u179A\u17A1"},{"id":10657,"word":"\u179A\u17A1\u1794\u17CB"},{"id":10658,"word":"\u179A\u17A1\u17B6\u1780\u17CB"},{"id":10659,"word":"\u179A\u17A1\u17B6\u1789"},{"id":10660,"word":"\u179A\u17A1\u17B6\u1798"},{"id":10661,"word":"\u179A\u17A1\u17B7\u1780\u179A\u17A1\u1780\u17CB"},{"id":10662,"word":"\u179A\u17A1\u17B7\u1780\u179A\u17A1\u17B6\u1780\u17CB"},{"id":10663,"word":"\u179A\u17A1\u17B7\u1784\u179A\u17A1\u1784\u17CB"},{"id":10664,"word":"\u179A\u17A1\u17B7\u1794\u179A\u17A1\u1794\u17CB"},{"id":10665,"word":"\u179A\u17A1\u17BA\u1798"},{"id":10666,"word":"\u179A\u17A1\u17BC"},{"id":10667,"word":"\u179A\u17A1\u17BC\u1784"},{"id":10668,"word":"\u179A\u17A1\u17BC\u1784\u179A\u17A1\u17B6\u1784"},{"id":10669,"word":"\u179A\u17A1\u17BC\u179A\u17A1\u17B6"},{"id":10670,"word":"\u179A\u17A1\u17C1\u1798\u179A\u17A1\u17B6\u1798"},{"id":10671,"word":"\u179A\u17A1\u17C1\u1798\u179A\u17A1\u17BA\u1798"},{"id":10672,"word":"\u179A\u17A1\u17C1\u17C7\u179A\u17A1\u17C4\u17C7"},{"id":10673,"word":"\u179A\u17A1\u17C1\u17C7\u179A\u17A1\u17C7"},{"id":10674,"word":"\u179A\u17A1\u17C2\u179A\u17A1"},{"id":10675,"word":"\u179A\u17A1\u17C2\u179A\u17A1\u1794\u17CB"},{"id":10676,"word":"\u179A\u17A1\u17C5"},{"id":10677,"word":"\u179A\u17A2\u17B6"},{"id":10678,"word":"\u179A\u17A2\u17B6\u1780\u179A\u1796\u17B6\u1799"},{"id":10679,"word":"\u179A\u17A2\u17B6\u1780\u179A\u17A2\u17B6\u1799"},{"id":10680,"word":"\u179A\u17A2\u17B6\u1780\u17CB\u179A\u17A2\u17BD\u179B"},{"id":10681,"word":"\u179A\u17A2\u17B6\u1780\u17CB\u179A\u17A2\u17BE"},{"id":10682,"word":"\u179A\u17A2\u17B6\u1784"},{"id":10683,"word":"\u179A\u17A2\u17B6\u178F"},{"id":10684,"word":"\u179A\u17A2\u17B6\u1798"},{"id":10685,"word":"\u179A\u17A2\u17B6\u179A\u17A2\u17BC\u1798"},{"id":10686,"word":"\u179A\u17A2\u17B7\u1785"},{"id":10687,"word":"\u179A\u17A2\u17B7\u179B"},{"id":10688,"word":"\u179A\u17A2\u17CA\u200C\u17B7\u17C7\u179A\u17A2\u17CA\u17BB\u17C7"},{"id":10689,"word":"\u179A\u17A2\u17CA\u200C\u17B8\u179A\u17A2\u17CA\u17BC"},{"id":10690,"word":"\u179A\u17A2\u17B9\u1780"},{"id":10691,"word":"\u179A\u17A2\u17B9\u1780\u179A\u17A2\u17BA\u1793"},{"id":10692,"word":"\u179A\u17A2\u17B9\u1780\u179A\u17A2\u17B6\u17C6"},{"id":10693,"word":"\u179A\u17A2\u17BA\u178F"},{"id":10694,"word":"\u179A\u17A2\u17BB\u1785"},{"id":10695,"word":"\u179A\u17A2\u17CA\u17BB\u17C7"},{"id":10696,"word":"\u179A\u17A2\u17CA\u17BC"},{"id":10697,"word":"\u179A\u17A2\u17BC\u1785"},{"id":10698,"word":"\u179A\u17A2\u17BC\u1785\u179A\u17A2\u17BE\u1794"},{"id":10699,"word":"\u179A\u17A2\u17BC\u1785\u179A\u17A2\u17BE\u1798"},{"id":10700,"word":"\u179A\u17A2\u17CA\u17BC\u179A\u1791\u17B6\u17C6"},{"id":10701,"word":"\u179A\u17A2\u17BE\u178F\u179A\u17A2\u17BE\u1798"},{"id":10702,"word":"\u179A\u17A2\u17BE\u1794"},{"id":10703,"word":"\u179A\u17A2\u17BE\u1794\u179A\u1787\u17BE\u1794"},{"id":10704,"word":"\u179A\u17A2\u17BE\u1794\u179A\u1787\u17C4\u179A"},{"id":10705,"word":"\u179A\u17A2\u17BE\u1798"},{"id":10706,"word":"\u179A\u17A2\u17BE\u179B"},{"id":10707,"word":"\u179A\u17A2\u17C0\u1780\u179A\u17A2\u17B6\u1799"},{"id":10708,"word":"\u179A\u17A2\u17C0\u1785"},{"id":10709,"word":"\u179A\u17A2\u17C0\u179F"},{"id":10710,"word":"\u179A\u17A2\u17C1\u1785\u179A\u17A2\u17BC\u1785"},{"id":10711,"word":"\u179A\u17A2\u17C1\u178F\u179A\u17A2\u178F"},{"id":10712,"word":"\u179A\u17A2\u17C1\u17C7\u179A\u17A2\u17BB\u17C7"},{"id":10713,"word":"\u179A\u17A2\u17C1\u17C8\u179A\u17A2\u17BB"},{"id":10714,"word":"\u179A\u17A2\u17C2\u1780"},{"id":10715,"word":"\u179A\u17A2\u17C2\u1784"},{"id":10716,"word":"\u179A\u17A2\u17C2\u178F\u179A\u17A2\u178F"},{"id":10717,"word":"\u179A\u17A2\u17C2\u179A\u17A2\u17BC\u179C"},{"id":10718,"word":"\u179A\u17A2\u17C3"},{"id":10719,"word":"\u179A\u17A2\u17C4\u1780"},{"id":10720,"word":"\u179A\u17B1\u179F"},{"id":10721,"word":"\u179A\u17B1\u179F\u178B\u17B6\u1793"},{"id":10722,"word":"\u179A\u17AD\u1780"},{"id":10723,"word":"\u179A\u17B6"},{"id":10724,"word":"\u179A\u17C9\u17B6"},{"id":10725,"word":"\u179A\u17B6\u1780"},{"id":10726,"word":"\u179A\u17B6\u1780\u17CB"},{"id":10727,"word":"\u179A\u17B6\u1780\u17CB\u1791\u17B6\u1780\u17CB"},{"id":10728,"word":"\u179A\u17B6\u1780\u17D2\u179F\u17D0\u179F"},{"id":10729,"word":"\u179A\u17B6\u1780\u17D2\u179F\u179F\u17B8"},{"id":10730,"word":"\u179A\u17B6\u1782"},{"id":10731,"word":"\u179A\u17B6\u1784"},{"id":10732,"word":"\u179A\u17C9\u17B6\u1784"},{"id":10733,"word":"\u179A\u17B6\u1784\u178A\u17BC\u1785\u1787\u17B6 "},{"id":10734,"word":"\u179A\u17B6\u1784\u179A\u17C5"},{"id":10735,"word":"\u179A\u17B6\u1785"},{"id":10736,"word":"\u179A\u17B6\u1787"},{"id":10737,"word":"\u179A\u17B6\u1787\u1780\u1780\u17BB\u1792\u1797\u178E\u17D2\u178C"},{"id":10738,"word":"\u179A\u17B6\u1787\u1786\u17D2\u1796\u17B9\u179F"},{"id":10739,"word":"\u179A\u17B6\u1787\u178F\u17B6\u1791\u17D2\u179A\u17B7"},{"id":10740,"word":"\u179A\u17B6\u1787\u178F\u17B6\u1793\u17D2\u179C\u17B7\u178F"},{"id":10741,"word":"\u179A\u17B6\u1787\u1794\u178E\u17D2\u178C\u17B7\u178F\u17D2\u1799\u179F\u1797\u17B6"},{"id":10742,"word":"\u179A\u17B6\u1787\u1794\u178E\u17D2\u178C\u17B7\u178F\u17D2\u1799\u179F\u17D2\u1790\u17B6\u1793"},{"id":10743,"word":"\u179A\u17B6\u1787\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":10744,"word":"\u179A\u17B6\u1787\u179C\u17D0\u178F\u17B7"},{"id":10745,"word":"\u179A\u17B6\u1787\u17B6"},{"id":10746,"word":"\u179A\u17B6\u1787\u17B6\u1782\u178E\u17C8"},{"id":10747,"word":"\u179A\u17B6\u1787\u17B6\u1792\u17B7\u1780\u17B6\u179A\u17B8"},{"id":10748,"word":"\u179A\u17B6\u1787\u17B6\u1799\u178F\u1793\u17C8"},{"id":10749,"word":"\u179A\u17B6\u1787\u17B6\u1799\u178F\u1793\u1785\u17C1\u178F\u17B7\u1799"},{"id":10750,"word":"\u179A\u17B6\u1787\u17B7\u1793\u17B8"},{"id":10751,"word":"\u179A\u17B6\u1787\u17B7\u1793\u17B8\u1780\u17BC\u179B"},{"id":10752,"word":"\u179A\u17B6\u1787\u17B7\u179F\u17B8"},{"id":10753,"word":"\u179A\u17B6\u1787\u17B8"},{"id":10754,"word":"\u179A\u17B6\u1787\u17BC\u1794\u1780\u179A\u178E\u17CD"},{"id":10755,"word":"\u179A\u17B6\u1787\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":10756,"word":"\u179A\u17B6\u1787\u17C4\u1794\u1780\u179A\u178E\u17CD"},{"id":10757,"word":"\u179A\u17B6\u1787\u17D2\u1799"},{"id":10758,"word":"\u179A\u17B6\u1787\u17D2\u1799\u17B6\u1784\u17D2\u1782"},{"id":10759,"word":"\u179A\u17B6\u178F\u17CB"},{"id":10760,"word":"\u179A\u17C9\u17B6\u178F\u17CB"},{"id":10761,"word":"\u179A\u17B6\u178F\u178F\u17D2\u1794\u17B6\u178F"},{"id":10762,"word":"\u179A\u17C9\u17B6\u178F\u17CB\u1794\u17D2\u179A\u1781\u17BB\u178F"},{"id":10763,"word":"\u179A\u17B6\u178F\u1798\u17D2\u1794\u17B6\u1789"},{"id":10764,"word":"\u179A\u17B6\u178F\u17CB\u179A\u17B6\u1799"},{"id":10765,"word":"\u179A\u17B6\u178F\u17D2\u179A\u17B8"},{"id":10766,"word":"\u179A\u17B6\u1792\u1793\u17CD"},{"id":10767,"word":"\u179A\u17B6\u1793"},{"id":10768,"word":"\u179A\u17B6\u1793\u17CB"},{"id":10769,"word":"\u179A\u17B6\u1793\u1780\u17B6\u1793"},{"id":10770,"word":"\u179A\u17B6\u1793\u17A0\u17B6\u179B"},{"id":10771,"word":"\u179A\u17B6\u1794"},{"id":10772,"word":"\u179A\u17B6\u1794\u17CB"},{"id":10773,"word":"\u179A\u17C9\u17B6\u1794\u17CB"},{"id":10774,"word":"\u179A\u17B6\u1794\u1791\u17B6\u1794"},{"id":10775,"word":"\u179A\u17C9\u17B6\u1794\u17CB\u179A\u1784"},{"id":10776,"word":"\u179A\u17B6\u1794\u17CB\u179A\u17C0\u1794"},{"id":10777,"word":"\u179A\u17B6\u1794\u179F\u17B6"},{"id":10778,"word":"\u179A\u17B6\u1794\u17CB\u17A2\u17B6\u1793"},{"id":10779,"word":"\u179A\u17B6\u1794\u178E\u17CD"},{"id":10780,"word":"\u179A\u17B6\u1798"},{"id":10781,"word":"\u179A\u17B6\u1798\u1780\u17B7\u179A\u17D2\u178F\u17B7\u17CD"},{"id":10782,"word":"\u179A\u17B6\u1798\u1785\u1793\u17D2\u1791\u17D2\u179A"},{"id":10783,"word":"\u179A\u17B6\u1798\u1789\u17D2\u1789"},{"id":10784,"word":"\u179A\u17B6\u1798\u178E\u17C1\u1799\u17D2\u1799"},{"id":10785,"word":"\u179A\u17B6\u1798\u1797\u17BC\u1798\u17B7"},{"id":10786,"word":"\u179A\u17B6\u1798\u179A\u17B6\u1787\u17D2\u1799"},{"id":10787,"word":"\u179A\u17B6\u1798\u179F\u17BC\u179A"},{"id":10788,"word":"\u179A\u17B6\u1798\u17B6\u1799\u178E"},{"id":10789,"word":"\u179A\u17B6\u1798\u17B6\u1799\u178E\u17B7\u1780"},{"id":10790,"word":"\u179A\u17B6\u1799"},{"id":10791,"word":"\u179A\u17B6\u1799\u1784\u17C9\u17B6\u1793"},{"id":10792,"word":"\u179A\u17B6\u1799\u1796\u1796\u17B6\u1799"},{"id":10793,"word":"\u179A\u17B6\u1799\u1798\u17B6\u1799"},{"id":10794,"word":"\u179A\u17B6\u1799\u179A\u1784"},{"id":10795,"word":"\u179A\u17B6\u1799\u179A\u17B6\u1794\u17CB"},{"id":10796,"word":"\u179A\u17B6\u179A\u1784\u17CB"},{"id":10797,"word":"\u179A\u17B6\u179A\u17C2\u1780"},{"id":10798,"word":"\u179A\u17B6\u179A\u17B6\u17C6\u1784"},{"id":10799,"word":"\u179A\u17B6\u179B"},{"id":10800,"word":"\u179A\u17B6\u179B\u17CB"},{"id":10801,"word":"\u179A\u17B6\u179C"},{"id":10802,"word":"\u179A\u17C9\u17B6\u179C"},{"id":10803,"word":"\u179A\u17C9\u17B6\u179C\u178F\u17B6\u179C"},{"id":10804,"word":"\u179A\u17B6\u179C\u17B8"},{"id":10805,"word":"\u179A\u17B6\u179F\u17CB"},{"id":10806,"word":"\u179A\u17B6\u179F\u17B7\u1785\u1780\u17D2\u179A"},{"id":10807,"word":"\u179A\u17B6\u179F\u17B8"},{"id":10808,"word":"\u179A\u17B6\u179F\u17B8\u1785\u1780\u17D2\u179A"},{"id":10809,"word":"\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":10810,"word":"\u179A\u17B6\u17A0\u17BB"},{"id":10811,"word":"\u179A\u17B6\u17A0\u17BB\u17CD"},{"id":10812,"word":"\u179A\u17B6\u17A0\u17BB\u179B"},{"id":10813,"word":"\u179A\u17B6\u17A0\u17BB\u179B\u1798\u17B6\u178F\u17B6"},{"id":10814,"word":"\u179A\u17B6\u17A0\u17BC"},{"id":10815,"word":"\u179A\u17B6\u17A0\u17BC"},{"id":10816,"word":"\u179A\u17B7\u1789\u17D7"},{"id":10817,"word":"\u179A\u17B7\u178F\u17D2\u178F\u1797\u17B6\u1796"},{"id":10818,"word":"\u179A\u17B7\u1794\u17BB\u1789\u17D2\u1787\u17D0\u1799"},{"id":10819,"word":"\u179A\u17B7\u1798"},{"id":10820,"word":"\u179A\u17B7\u179B"},{"id":10821,"word":"\u179A\u17C9\u17B7\u179B"},{"id":10822,"word":"\u179A\u17B7\u179F\u17D2\u178F"},{"id":10823,"word":"\u179A\u17B7\u17C7"},{"id":10824,"word":"\u179A\u17B8"},{"id":10825,"word":"\u179A\u17C9\u17B8 ?"},{"id":10826,"word":"\u179A\u17B8\u1780"},{"id":10827,"word":"\u179A\u17B8\u1780\u179A\u17B6\u1799"},{"id":10828,"word":"\u179A\u17B8\u1784"},{"id":10829,"word":"\u179A\u17B8\u178F"},{"id":10830,"word":"\u179A\u17B8\u178F\u17B7"},{"id":10831,"word":"\u179A\u17B9\u1784"},{"id":10832,"word":"\u179A\u17B9\u1784\u178F\u17D2\u17A2\u17B9\u1784"},{"id":10833,"word":"\u179A\u17B9\u1784\u1794\u17C9\u17B9\u1784"},{"id":10834,"word":"\u179A\u17B9\u1784\u179A\u17B9\u178F"},{"id":10835,"word":"\u179A\u17B9\u1784\u179A\u17BC\u179F"},{"id":10836,"word":"\u179A\u17C9\u17B9\u1784"},{"id":10837,"word":"\u179A\u17B9\u178F"},{"id":10838,"word":"\u179A\u17B9\u178F\u178F\u17D2\u1794\u17B7\u178F"},{"id":10839,"word":"\u179A\u17B9\u1791\u17D2\u1792\u17B7"},{"id":10840,"word":"\u179A\u17B9\u1794"},{"id":10841,"word":"\u179A\u17B9\u1798"},{"id":10842,"word":"\u179A\u17B9\u1798\u17D7"},{"id":10843,"word":"\u179A\u17B9\u179B"},{"id":10844,"word":"\u179A\u17B9\u179F\u17D2\u1799\u17B6"},{"id":10845,"word":"\u179A\u17B9\u17C7"},{"id":10846,"word":"\u179A\u17C9\u17BA\u1784\u17D7"},{"id":10847,"word":"\u179A\u17BA\u178F"},{"id":10848,"word":"\u179A\u17BB\u1780"},{"id":10849,"word":"\u179A\u17BB\u1780\u1780\u17BD\u1793"},{"id":10850,"word":"\u179A\u17BB\u1780\u179A"},{"id":10851,"word":"\u179A\u17BB\u1780\u179A\u17B6\u1793"},{"id":10852,"word":"\u179A\u17BB\u1780\u17D2\u1781"},{"id":10853,"word":"\u179A\u17BB\u1780\u17D2\u1781\u17B6"},{"id":10854,"word":"\u179A\u17BB\u1784"},{"id":10855,"word":"\u179A\u17BB\u1784\u179A\u17BF\u1784"},{"id":10856,"word":"\u179A\u17BB\u1784\u179A\u17C4\u1785\u1793\u17CD"},{"id":10857,"word":"\u179A\u17BB\u1784\u179A\u17B6\u17C6\u1784"},{"id":10858,"word":"\u179A\u17BB\u1785\u17B7\u179A"},{"id":10859,"word":"\u179A\u17BB\u1785\u17D2\u1785\u1793\u17C8"},{"id":10860,"word":"\u179A\u17BB\u1787\u17B6"},{"id":10861,"word":"\u179A\u17BB\u1789"},{"id":10862,"word":"\u179A\u17C9\u17BB\u1789"},{"id":10863,"word":"\u179A\u17BB\u1789\u17A2\u1784\u17D2\u179A\u17C2"},{"id":10864,"word":"\u179A\u17BB\u178E\u17D2\u178E"},{"id":10865,"word":"\u179A\u17BB\u178F"},{"id":10866,"word":"\u179A\u17C9\u17BB\u178F\u178E\u17B6\u1798"},{"id":10867,"word":"\u179A\u17BB\u1793"},{"id":10868,"word":"\u179A\u17BB\u1798\u17D2\u1798\u17B7\u178E\u17D2\u178F\u17C1"},{"id":10869,"word":"\u179A\u17BB\u1799"},{"id":10870,"word":"\u179A\u17C9\u17BB\u1799"},{"id":10871,"word":"\u179A\u17C9\u17BB\u1799\u17D7"},{"id":10872,"word":"\u179A\u17BB\u179B"},{"id":10873,"word":"\u179A\u17C9\u17BB\u179B"},{"id":10874,"word":"\u179A\u17BB\u17C7"},{"id":10875,"word":"\u179A\u17BC"},{"id":10876,"word":"\u179A\u17BC\u1784"},{"id":10877,"word":"\u179A\u17C9\u17BC\u1784"},{"id":10878,"word":"\u179A\u17BC\u178F"},{"id":10879,"word":"\u179A\u17BC\u178F\u179A\u17C7"},{"id":10880,"word":"\u179A\u17BC\u1794"},{"id":10881,"word":"\u179A\u17BC\u1794 --"},{"id":10882,"word":"\u179A\u17BC\u1794\u17B6"},{"id":10883,"word":"\u179A\u17BC\u1794\u17B6 --"},{"id":10884,"word":"\u179A\u17BC\u1794\u17B7\u1793\u17B8"},{"id":10885,"word":"\u179A\u17BC\u1794\u17B7\u1799 "},{"id":10886,"word":"\u179A\u17BC\u1794\u17B8"},{"id":10887,"word":"\u179A\u17BC\u1796\u17B8"},{"id":10888,"word":"\u179A\u17BC\u179F"},{"id":10889,"word":"\u179A\u17BC\u17A0\u17B6\u1793"},{"id":10890,"word":"\u179A\u17BD\u1785"},{"id":10891,"word":"\u179A\u17BD\u1785\u179A\u17B6\u179B\u17CB"},{"id":10892,"word":"\u179A\u17BD\u1789"},{"id":10893,"word":"\u179A\u17BD\u1789\u179A\u17B6"},{"id":10894,"word":"\u179A\u17BD\u178F"},{"id":10895,"word":"\u179A\u17BD\u1793"},{"id":10896,"word":"\u179A\u17BD\u1794"},{"id":10897,"word":"\u179A\u17BD\u1794\u179A\u17B9\u178F"},{"id":10898,"word":"\u179A\u17BD\u1794\u179A\u17BD\u1798"},{"id":10899,"word":"\u179A\u17BD\u1798"},{"id":10900,"word":"\u179A\u17BD\u1799"},{"id":10901,"word":"\u179A\u17BD\u179B"},{"id":10902,"word":"\u179A\u17BD\u179F"},{"id":10903,"word":"\u179A\u17BD\u179F\u179A\u1780"},{"id":10904,"word":"\u179A\u17BD\u179F\u179A\u17B6\u1793\u17CB"},{"id":10905,"word":"\u179A\u17BD\u179F\u179A\u17B6\u1799"},{"id":10906,"word":"\u179A\u17BD\u179F\u179A\u17C9\u17B6\u179C"},{"id":10907,"word":"\u179A\u17BE"},{"id":10908,"word":"\u179A\u17C9\u17BE\u1780\u17D7"},{"id":10909,"word":"\u179A\u17C9\u17BE\u1784\u17D7"},{"id":10910,"word":"\u179A\u17BE\u1794"},{"id":10911,"word":"\u179A\u17BE\u1798"},{"id":10912,"word":"\u179A\u17BE\u179F"},{"id":10913,"word":"\u179A\u17BE\u179F\u178F\u17D2\u17A2\u17BE\u179F"},{"id":10914,"word":"\u179A\u17BE\u179F\u17A2\u17BE\u1784"},{"id":10915,"word":"\u179A\u17BE\u17A2\u17C0\u1784"},{"id":10916,"word":"\u179A\u17BF"},{"id":10917,"word":"\u179A\u17BF\u1784"},{"id":10918,"word":"\u179A\u17BF\u1784\u179A\u17C9\u17B6\u179C"},{"id":10919,"word":"\u179A\u17BF\u178E\u179A\u1784\u17D2\u1782"},{"id":10920,"word":"\u179A\u17BF\u1793\u17A0\u17D2\u179B\u17BD\u1784"},{"id":10921,"word":"\u179A\u17BF\u1799"},{"id":10922,"word":"\u179A\u17C0\u1784"},{"id":10923,"word":"\u179A\u17C0\u1793"},{"id":10924,"word":"\u179A\u17C0\u1794"},{"id":10925,"word":"\u179A\u17C0\u1794\u1785\u17C6"},{"id":10926,"word":"\u179A\u17C0\u1794\u179A\u1794"},{"id":10927,"word":"\u179A\u17C0\u1794\u179A\u1799"},{"id":10928,"word":"\u179A\u17C0\u1794\u179A\u17B6\u1794\u17CB"},{"id":10929,"word":"\u179A\u17C0\u1794\u179A\u17C0\u1784"},{"id":10930,"word":"\u179A\u17C0\u1798"},{"id":10931,"word":"\u179A\u17C0\u1798\u1785\u17D2\u1794\u1784 "},{"id":10932,"word":"\u179A\u17C0\u179A\u17C9\u17B6\u1799"},{"id":10933,"word":"\u179A\u17C0\u179A\u17C9\u17C3"},{"id":10934,"word":"\u179A\u17C0\u179B"},{"id":10935,"word":"\u179A\u17C0\u179C"},{"id":10936,"word":"\u179A\u17C1"},{"id":10937,"word":"\u179A\u17C9\u17C1"},{"id":10938,"word":"\u179A\u17C1\u1781\u17B6"},{"id":10939,"word":"\u179A\u17C1\u1785"},{"id":10940,"word":"\u179A\u17C1\u1785\u1780 \u1797\u17C1\u179F\u1787\u17D2\u1787\u17C8"},{"id":10941,"word":"\u179A\u17C1\u1785\u1793\u1780\u1798\u17D2\u1798"},{"id":10942,"word":"\u179A\u17C1\u1789"},{"id":10943,"word":"\u179A\u17C1\u1789\u17D7"},{"id":10944,"word":"\u179A\u17C1\u178E\u17BB"},{"id":10945,"word":"\u179A\u17C1\u1794\u17D0\u179F"},{"id":10946,"word":"\u179A\u17C1\u1795\u17C8"},{"id":10947,"word":"\u179A\u17C1\u1796\u179B"},{"id":10948,"word":"\u179A\u17C1\u179A\u1784\u17CB"},{"id":10949,"word":"\u179A\u17C1\u179B"},{"id":10950,"word":"\u179A\u17C9\u17C1\u179C"},{"id":10951,"word":"\u179A\u17C1\u179C\u178F\u17B8"},{"id":10952,"word":"\u179A\u17C1\u17A0\u17CD\u1796\u179B"},{"id":10953,"word":"\u179A\u17C1\u17C7"},{"id":10954,"word":"\u179A\u17C9\u17C1\u17C7\u17D7 "},{"id":10955,"word":"\u179A\u17C9\u17C2\u17D7"},{"id":10956,"word":"\u179A\u17C2\u1780"},{"id":10957,"word":"\u179A\u17C2\u1784"},{"id":10958,"word":"\u179A\u17C9\u17C2\u1784\u17D7"},{"id":10959,"word":"\u179A\u17C9\u17C2\u178F"},{"id":10960,"word":"\u179A\u17C9\u17C2\u179A\u17C9"},{"id":10961,"word":"\u179A\u17C2\u17C7"},{"id":10962,"word":"\u179A\u17C3"},{"id":10963,"word":"\u179A\u17C9\u17C3"},{"id":10964,"word":"\u179A\u17C3\u1791\u17B9\u1780"},{"id":10965,"word":"\u179A\u17C4\u1780"},{"id":10966,"word":"\u179A\u17C4\u1782"},{"id":10967,"word":"\u179A\u17C4\u1782\u17B6"},{"id":10968,"word":"\u179A\u17C4\u1782\u17B6\u1796\u17B6\u1792"},{"id":10969,"word":"\u179A\u17C4\u1782\u17B6\u1799\u178F\u1793\u17C8"},{"id":10970,"word":"\u179A\u17C4\u1782\u17B7\u1793\u17B8"},{"id":10971,"word":"\u179A\u17C4\u1782\u17B8"},{"id":10972,"word":"\u179A\u17C4\u1784"},{"id":10973,"word":"\u179A\u17C4\u1785"},{"id":10974,"word":"\u179A\u17C4\u1785\u1793\u17C8"},{"id":10975,"word":"\u179A\u17C4\u1791\u17CD"},{"id":10976,"word":"\u179A\u17C4\u1791\u1793"},{"id":10977,"word":"\u179A\u17C4\u1792\u1793"},{"id":10978,"word":"\u179A\u17C4\u1794\u1780"},{"id":10979,"word":"\u179A\u17C4\u1794\u1793"},{"id":10980,"word":"\u179A\u17C4\u1794\u1780\u17B6\u179A\u17B7\u1793\u17B8"},{"id":10981,"word":"\u179A\u17C4\u1798"},{"id":10982,"word":"\u179A\u17C4\u1799"},{"id":10983,"word":"\u179A\u17C4\u1799\u179A\u17B6\u1799"},{"id":10984,"word":"\u179A\u17C4\u1799\u179A\u17C0\u179C"},{"id":10985,"word":"\u179A\u17C4\u1799\u179F\u17D2\u1794\u17C3"},{"id":10986,"word":"\u179A\u17C4\u179A\u1796"},{"id":10987,"word":"\u179A\u17C4\u179B"},{"id":10988,"word":"\u179A\u17C4\u179B\u179A\u17B6\u179B"},{"id":10989,"word":"\u179A\u17C4\u179F"},{"id":10990,"word":"\u179A\u17C4\u17A0\u17B7\u178E\u17B8"},{"id":10991,"word":"\u179A\u17C4\u17A0\u17B7\u178F"},{"id":10992,"word":"\u179A\u17BB\u17C6"},{"id":10993,"word":"\u179A\u17BB\u17C6\u1780\u17C4\u17C7"},{"id":10994,"word":"\u179A\u17C6"},{"id":10995,"word":"\u179A\u17C6\u1780\u17B6\u1785\u17CB"},{"id":10996,"word":"\u179A\u17C6\u1780\u17B6\u1785\u17CB\u1798\u17B6\u179F"},{"id":10997,"word":"\u179A\u17C6\u1780\u17B6\u1785\u17CB\u179A\u17C6\u1780\u17C4\u1785"},{"id":10998,"word":"\u179A\u17C6\u1780\u17B7\u179B"},{"id":10999,"word":"\u179A\u17C6\u1781\u17B6\u1793"},{"id":11000,"word":"\u179A\u17C6\u1782\u1784\u1780\u17C2\u179C\u179F\u17D2\u1793\u17C1\u17A0\u17CD"},{"id":11001,"word":"\u179A\u17C6\u1782\u17B6\u1799"},{"id":11002,"word":"\u179A\u17C6\u1782\u17B6\u179B"},{"id":11003,"word":"\u179A\u17C6\u1782\u17C1\u1789"},{"id":11004,"word":"\u179A\u17C6\u1784\u1780"},{"id":11005,"word":"\u179A\u17C6\u1784\u17B6\u1785"},{"id":11006,"word":"\u179A\u17C6\u1784\u17B6\u1794\u17CB"},{"id":11007,"word":"\u179A\u17C6\u1784\u17B6\u179F\u17CB"},{"id":11008,"word":"\u179A\u17C6\u1784\u17BE\u1780"},{"id":11009,"word":"\u179A\u17C6\u1785\u17B6\u1780"},{"id":11010,"word":"\u179A\u17C6\u1785\u17B8\u178A\u17C3"},{"id":11011,"word":"\u179A\u17C6\u1785\u17C1\u1780"},{"id":11012,"word":"\u179A\u17C6\u1787\u17B6"},{"id":11013,"word":"\u179A\u17C6\u1787\u17B8\u1780"},{"id":11014,"word":"\u179A\u17C6\u1787\u17B8\u179A\u17C6\u1787\u17B6"},{"id":11015,"word":"\u179A\u17C6\u1787\u17BD\u179B"},{"id":11016,"word":"\u179A\u17C6\u1787\u17BE\u1794"},{"id":11017,"word":"\u179A\u17C6\u1787\u17C1\u1789"},{"id":11018,"word":"\u179A\u17C6\u1787\u17C2"},{"id":11019,"word":"\u179A\u17C6\u1787\u17C2\u1780"},{"id":11020,"word":"\u179A\u17C6\u1787\u17C6\u179A\u17C6\u1787\u17C2\u1784 "},{"id":11021,"word":"\u179A\u17C6\u178A\u17B6\u1780"},{"id":11022,"word":"\u179A\u17C6\u178A\u17BD\u179B"},{"id":11023,"word":"\u179A\u17C6\u178A\u17C1\u1780"},{"id":11024,"word":"\u179A\u17C6\u178A\u17C1\u1784"},{"id":11025,"word":"\u179A\u17C6\u178A\u17C1\u1789"},{"id":11026,"word":"\u179A\u17C6\u178A\u17C1\u1789\u1798\u17B6\u179F"},{"id":11027,"word":"\u179A\u17C6\u178A\u17C4\u17C7"},{"id":11028,"word":"\u179A\u17C6\u1791\u17C6"},{"id":11029,"word":"\u179A\u17C6\u1794\u179B\u17CB"},{"id":11030,"word":"\u179A\u17C6\u1794\u17C9\u17BE\u1780"},{"id":11031,"word":"\u179A\u17C6\u1796\u1784"},{"id":11032,"word":"\u179A\u17C6\u1796\u178F\u17CB"},{"id":11033,"word":"\u179A\u17C6\u1796\u17B6"},{"id":11034,"word":"\u179A\u17C6\u1796\u17B6\u178F\u17CB"},{"id":11035,"word":"\u179A\u17C6\u1796\u17B6\u179F\u17CB"},{"id":11036,"word":"\u179A\u17C6\u1796\u17B9\u1784"},{"id":11037,"word":"\u179A\u17C6\u1796\u17BB\u17C7"},{"id":11038,"word":"\u179A\u17C6\u1796\u17BE\u1780"},{"id":11039,"word":"\u179A\u17C6\u1796\u17BE\u1793"},{"id":11040,"word":"\u179A\u17C6\u1796\u17C1"},{"id":11041,"word":"\u179A\u17C6\u1796\u17C1\u1785"},{"id":11042,"word":"\u179A\u17C6\u1796\u17C1\u1793"},{"id":11043,"word":"\u179A\u17C6\u1796\u17C3"},{"id":11044,"word":"\u179A\u17C6\u1797\u17B6\u1799"},{"id":11045,"word":"\u179A\u17C6\u1797\u17BE\u1780"},{"id":11046,"word":"\u179A\u17C6\u1797\u17BE\u1794"},{"id":11047,"word":"\u179A\u17C6\u1797\u17BE\u1799"},{"id":11048,"word":"\u179A\u17C6\u1799\u17B6\u1780"},{"id":11049,"word":"\u179A\u17C6\u1799\u17B8\u1780"},{"id":11050,"word":"\u179A\u17C6\u1799\u17C4\u179B"},{"id":11051,"word":"\u179A\u17C6\u179B\u1784"},{"id":11052,"word":"\u179A\u17C6\u179B\u178F\u17CB"},{"id":11053,"word":"\u179A\u17C6\u179B\u1794\u17CB"},{"id":11054,"word":"\u179A\u17C6\u179B\u179F\u17CB"},{"id":11055,"word":"\u179A\u17C6\u179B\u17B6"},{"id":11056,"word":"\u179A\u17C6\u179B\u17B6\u1780"},{"id":11057,"word":"\u179A\u17C6\u179B\u17B6\u1784"},{"id":11058,"word":"\u179A\u17C6\u179B\u17B6\u1799"},{"id":11059,"word":"\u179A\u17C6\u179B\u17B7\u1785"},{"id":11060,"word":"\u179A\u17C6\u179B\u17B8\u1784"},{"id":11061,"word":"\u179A\u17C6\u179B\u17B9\u1780"},{"id":11062,"word":"\u179A\u17C6\u179B\u17BB\u1784"},{"id":11063,"word":"\u179A\u17C6\u179B\u17BB\u1794"},{"id":11064,"word":"\u179A\u17C6\u179B\u17BB\u17C7"},{"id":11065,"word":"\u179A\u17C6\u179B\u17BC\u178F"},{"id":11066,"word":"\u179A\u17C6\u179B\u17BE\u1780"},{"id":11067,"word":"\u179A\u17C6\u179B\u17BE\u1784"},{"id":11068,"word":"\u179A\u17C6\u179B\u17C0\u1780"},{"id":11069,"word":"\u179A\u17C6\u179B\u17C0\u1784"},{"id":11070,"word":"\u179A\u17C6\u179B\u17C1\u1785"},{"id":11071,"word":"\u179A\u17C6\u179B\u17C1\u1794"},{"id":11072,"word":"\u179A\u17C6\u179B\u17C1\u1798"},{"id":11073,"word":"\u179A\u17C6\u179B\u17C1\u17C7"},{"id":11074,"word":"\u179A\u17C6\u179B\u17C2\u1780"},{"id":11075,"word":"\u179A\u17C6\u179B\u17C2\u17C7"},{"id":11076,"word":"\u179A\u17C6\u179B\u17C4\u1780"},{"id":11077,"word":"\u179A\u17C6\u179B\u17C4\u1784"},{"id":11078,"word":"\u179A\u17C6\u179B\u17C4\u1797"},{"id":11079,"word":"\u179A\u17C6\u179B\u17C6"},{"id":11080,"word":"\u179A\u17C6\u179F\u17B6\u1799"},{"id":11081,"word":"\u179A\u17C6\u179F\u17BB\u179F"},{"id":11082,"word":"\u179A\u17C6\u179F\u17C1\u179C"},{"id":11083,"word":"\u179A\u17C6\u179F\u17C4\u17C7"},{"id":11084,"word":"\u179A\u17C6\u17A0"},{"id":11085,"word":"\u179A\u17C6\u17A0\u17D0\u179F"},{"id":11086,"word":"\u179A\u17C6\u17A0\u17B6\u1785"},{"id":11087,"word":"\u179A\u17C6\u17A0\u17BB\u1780"},{"id":11088,"word":"\u179A\u17C6\u17A0\u17BC\u178F"},{"id":11089,"word":"\u179A\u17C6\u17A0\u17BC\u179A"},{"id":11090,"word":"\u179A\u17C6\u17A0\u17BD\u178F"},{"id":11091,"word":"\u179A\u17C6\u17A0\u17BE\u1799"},{"id":11092,"word":"\u179A\u17C6\u17A0\u17C2"},{"id":11093,"word":"\u179A\u17C6\u17A0\u17C4\u1780"},{"id":11094,"word":"\u179A\u17C6\u17A2\u17B6"},{"id":11095,"word":"\u179A\u17C6\u17A2\u17B7\u179B "},{"id":11096,"word":"\u179A\u17C6\u17A2\u17BB\u1780"},{"id":11097,"word":"\u179A\u17C6\u17A2\u17BB\u1780\u179A\u17C6\u17A2\u17C2"},{"id":11098,"word":"\u179A\u17C6\u17A2\u17BD\u1799"},{"id":11099,"word":"\u179A\u17C6\u17A2\u17BE\u1780"},{"id":11100,"word":"\u179A\u17C6\u17A2\u17C2\u1784"},{"id":11101,"word":"\u179A\u17C6\u17A2\u17C2\u179A\u17C6\u17A2\u17BD\u1799"},{"id":11102,"word":"\u179A\u17C6\u17AD\u1780"},{"id":11103,"word":"\u179A\u17B6\u17C6"},{"id":11104,"word":"\u179A\u17C9\u17B6\u17C6"},{"id":11105,"word":"\u179A\u17B6\u17C6\u1784"},{"id":11106,"word":"\u179A\u17B6\u17C6\u1784\u1782\u1793\u17D2\u179B\u1784"},{"id":11107,"word":"\u179A\u17B6\u17C6\u1784\u1787\u179B"},{"id":11108,"word":"\u179A\u17C9\u17B6\u17C6\u1784\u178E\u17BB\u1780"},{"id":11109,"word":"\u179A\u17B6\u17C6\u1784\u179A\u17B6"},{"id":11110,"word":"\u179A\u17B6\u17C6\u1784\u179F\u17B6\u1794"},{"id":11111,"word":"\u179A\u17B6\u17C6\u179A\u17C0\u179B"},{"id":11112,"word":"\u179A\u17C9\u17B6\u17C6\u179A\u17C9\u17C3"},{"id":11113,"word":"\u179A\u17C7"},{"id":11114,"word":"\u179A\u17C7\u1798\u17BB\u1781"},{"id":11115,"word":"\u179A\u17C7\u179F\u17C6\u1794\u17C2\u1784"},{"id":11116,"word":"\u17AB"},{"id":11117,"word":"\u17AB\u1780"},{"id":11118,"word":"\u17AB\u1780\u17D2\u179F"},{"id":11119,"word":"\u17AB\u1780\u17D2\u179F\u178E\u17C8"},{"id":11120,"word":"\u17AB\u1780\u17D2\u179F\u1796\u17B6\u179A"},{"id":11121,"word":"\u17AB\u1780\u17D2\u179F\u17C1\u179F"},{"id":11122,"word":"\u17AB\u1782\u17D2\u179C\u17C1\u1791"},{"id":11123,"word":"\u17AB\u178E"},{"id":11124,"word":"\u17AB\u178F"},{"id":11125,"word":"\u17AB\u178F\u17B7\u1799\u17B6"},{"id":11126,"word":"\u17AB\u178F\u17BB"},{"id":11127,"word":"\u17AB\u1791\u17D2\u1792"},{"id":11128,"word":"\u17AB\u1791\u17D2\u1792\u17B6 "},{"id":11129,"word":"\u17AB\u1791\u17D2\u1792\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":11130,"word":"\u17AB\u1791\u17D2\u1792\u17B7"},{"id":11131,"word":"\u17AB\u179F"},{"id":11132,"word":"\u17AB\u179F\u178A\u17B8"},{"id":11133,"word":"\u17AB\u179F\u178A\u17BC\u1784"},{"id":11134,"word":"\u17AB\u179F\u178A\u17BC\u1784\u1794\u17B6\u178F"},{"id":11135,"word":"\u17AB\u179F\u1797"},{"id":11136,"word":"\u17AB\u179F\u17B8"},{"id":11137,"word":"\u17AB\u179F\u17B8\u1794\u17D2\u179B\u17C2\u1784\u179F\u17B6\u179A"},{"id":11138,"word":"\u17AB\u179F\u17B8\u1795\u17D2\u179F\u17C6 \u179F\u17D2\u179A\u17C1\u1785"},{"id":11139,"word":"\u17AB\u179F\u17D2\u178A\u17B8"},{"id":11140,"word":"\u17AB\u179F\u17D2\u1799\u17B6"},{"id":11141,"word":"\u17AB\u179F\u17D2\u179F\u17B8"},{"id":11142,"word":"\u17AC"},{"id":11143,"word":"\u17AC"},{"id":11144,"word":"\u179B"},{"id":11145,"word":"\u17D4\u179B\u17D4"},{"id":11146,"word":"\u179B\u1780"},{"id":11147,"word":"\u179B\u1780\u17CB"},{"id":11148,"word":"\u179B\u17D0\u1780\u17D2\u1780\u1785\u17B6\u1793\u17CB"},{"id":11149,"word":"\u179B\u1780\u17D2\u1781"},{"id":11150,"word":"\u179B\u1780\u17D2\u1781\u1781\u178E\u17D2\u178C"},{"id":11151,"word":"\u179B\u1780\u17D2\u1781\u178E"},{"id":11152,"word":"\u179B\u1780\u17D2\u1781\u178E\u17CD"},{"id":11153,"word":"\u179B\u17D0\u1780\u17D2\u1781\u178E\u17CD"},{"id":11154,"word":"\u179B\u1780\u17D2\u1781\u178E\u17B6"},{"id":11155,"word":"\u179B\u1780\u17D2\u1781\u1793\u17D2\u178F\u17B7\u1780"},{"id":11156,"word":"\u179B\u17D0\u1780\u17D2\u178F"},{"id":11157,"word":"\u179B\u1780\u17D2\u179F\u178E\u17CD"},{"id":11158,"word":"\u179B\u1780\u17D2\u179F\u17D2\u1798\u178E\u17C8"},{"id":11159,"word":"\u179B\u1780\u17D2\u179F\u17D2\u1798\u17B8"},{"id":11160,"word":"\u179B\u17D0\u1781"},{"id":11161,"word":"\u179B\u1782\u17BB\u178C"},{"id":11162,"word":"\u179B\u1783\u17BB"},{"id":11163,"word":"\u179B\u1784"},{"id":11164,"word":"\u179B\u1784\u17CB"},{"id":11165,"word":"\u179B\u1784\u17CB\u1791\u17D2\u179A\u1793\u17C1\u179F"},{"id":11166,"word":"\u179B\u1784\u17CB\u179B\u17BB\u17C7"},{"id":11167,"word":"\u179B\u1784\u17CB\u17A0\u17B7\u1793"},{"id":11168,"word":"\u179B\u1784\u17D2\u1780\u17B6"},{"id":11169,"word":"\u179B\u1784\u17D2\u1780\u17B6\u1791\u17D2\u179C\u17B8\u1794"},{"id":11170,"word":"\u179B\u1784\u17D2\u1783\u1793\u17C8"},{"id":11171,"word":"\u179B\u1784\u17D2\u179C\u17C2\u1780"},{"id":11172,"word":"\u179B\u1784\u17D2\u17A0\u17B7\u1793"},{"id":11173,"word":"\u179B\u1787\u17D2\u1787\u17B6\u1797\u17B6\u1796"},{"id":11174,"word":"\u179B\u1787\u17D2\u1787\u17B7\u1793\u17B8"},{"id":11175,"word":"\u179B\u1787\u17D2\u1787\u17B8"},{"id":11176,"word":"\u179B\u1789\u17CB"},{"id":11177,"word":"\u179B\u1789\u17D2\u1785"},{"id":11178,"word":"\u179B\u1789\u17D2\u1786\u1780\u179A"},{"id":11179,"word":"\u179B\u1789\u17D2\u1786\u1780\u17B6\u179A"},{"id":11180,"word":"\u179B\u1789\u17D2\u1787\u17B7\u1780\u17B6"},{"id":11181,"word":"\u179B\u178F"},{"id":11182,"word":"\u179B\u178F\u17CB"},{"id":11183,"word":"\u179B\u178F\u17B6"},{"id":11184,"word":"\u179B\u1791\u17D2\u1792"},{"id":11185,"word":"\u179B\u1791\u17D2\u1792\u17B7"},{"id":11186,"word":"\u179B\u1793"},{"id":11187,"word":"\u179B\u1793\u17CB"},{"id":11188,"word":"\u179B\u1793\u17CB\u178F\u17BD "},{"id":11189,"word":"\u179B\u1793\u17D2\u178F\u17C2"},{"id":11190,"word":"\u179B\u1793\u17D2\u179B\u1784\u17CB"},{"id":11191,"word":"\u179B\u1793\u17D2\u179B\u17B6\u1798"},{"id":11192,"word":"\u179B\u1793\u17D2\u179B\u17B9\u1798"},{"id":11193,"word":"\u179B\u1793\u17D2\u179B\u17C4\u1785"},{"id":11194,"word":"\u179B\u1794"},{"id":11195,"word":"\u179B\u1794\u17CB"},{"id":11196,"word":"\u179B\u1796\u1794\u17BB\u179A\u17B8"},{"id":11197,"word":"\u179B\u17D0\u1796\u17D2\u1792"},{"id":11198,"word":"\u179B\u1798"},{"id":11199,"word":"\u179B\u1798\u17C9\u17BE"},{"id":11200,"word":"\u179B\u1798\u17D2\u1794\u178A"},{"id":11201,"word":"\u179B\u1798\u17D2\u17A0"},{"id":11202,"word":"\u179B\u1798\u17D2\u17A0\u17B6\u1785"},{"id":11203,"word":"\u179B\u1798\u17D2\u17A0\u17BE\u1799"},{"id":11204,"word":"\u179B\u1798\u17D2\u17A0\u17C2"},{"id":11205,"word":"\u179B\u1798\u17D2\u17A2"},{"id":11206,"word":"\u179B\u1798\u17D2\u17A2\u1780\u17CB"},{"id":11207,"word":"\u179B\u1798\u17D2\u17A2\u1780\u17CB\u1796\u17D0\u178E\u17CC"},{"id":11208,"word":"\u179B\u1798\u17D2\u17A2\u1784"},{"id":11209,"word":"\u179B\u1798\u17D2\u17A2\u1793\u17CB"},{"id":11210,"word":"\u179B\u1798\u17D2\u17A2\u17B7\u178F"},{"id":11211,"word":"\u179B\u1798\u17D2\u17A2\u17C0\u1784"},{"id":11212,"word":"\u179B\u1799"},{"id":11213,"word":"\u179B\u1799\u17C8"},{"id":11214,"word":"\u179B\u1799\u1780\u17C2\u179C"},{"id":11215,"word":"\u179B\u1799\u1786\u17B6\u1799"},{"id":11216,"word":"\u179B\u179B\u1780"},{"id":11217,"word":"\u179B\u179B\u1780\u1781\u17D2\u1798\u17C4\u1785"},{"id":11218,"word":"\u179B\u179B\u1780\u1791\u17D2\u179A\u17B6\u17C6\u1784"},{"id":11219,"word":"\u179B\u179B\u1780\u1794\u17D2\u179A\u17C7"},{"id":11220,"word":"\u179B\u179B\u1780\u179F"},{"id":11221,"word":"\u179B\u179B\u17B6"},{"id":11222,"word":"\u179B\u179B\u17B6"},{"id":11223,"word":"\u179B\u179B\u17B6\u178A"},{"id":11224,"word":"\u179B\u179B\u17B6\u178A\u1794\u178A\u17D2\u178A"},{"id":11225,"word":"\u179B\u179B\u17B6\u178F\u17C2"},{"id":11226,"word":"\u179B\u179B\u17B6\u1798"},{"id":11227,"word":"\u179B\u179B\u17B7\u178F"},{"id":11228,"word":"\u179B\u179B\u17B8\u1798\u179B\u179B\u17B6\u1798"},{"id":11229,"word":"\u179B\u179B\u17B9\u1798"},{"id":11230,"word":"\u179B\u179B\u17BD\u1784"},{"id":11231,"word":"\u179B\u179B\u17C1"},{"id":11232,"word":"\u179B\u179B\u17C3"},{"id":11233,"word":"\u179B\u179C\u17C4"},{"id":11234,"word":"\u179B\u179F\u17CB"},{"id":11235,"word":"\u179B\u179F\u17CB\u179B\u17B6"},{"id":11236,"word":"\u179B\u17A0\u17BB"},{"id":11237,"word":"\u179B\u17A0\u17BB\u1780\u17B6\u1794\u178F\u17D2\u178F\u17B7"},{"id":11238,"word":"\u179B\u17B6"},{"id":11239,"word":"\u179B\u17B6\u1780"},{"id":11240,"word":"\u179B\u17B6\u1780\u17CB"},{"id":11241,"word":"\u179B\u17B6\u1780\u17CB\u1780\u1793\u17D2\u179F\u17C2\u1784"},{"id":11242,"word":"\u179B\u17B6\u1780\u17CB\u1780\u17BC\u1793 \u1780\u17B6\u179F"},{"id":11243,"word":"\u179B\u17B6\u1780\u17CB\u1792\u17D2\u1799\u17BC\u1784"},{"id":11244,"word":"\u179B\u17B6\u1780\u17BB\u178A\u17B7\u1780"},{"id":11245,"word":"\u179B\u17B6\u1783\u179C\u17C8"},{"id":11246,"word":"\u179B\u17B6\u1784"},{"id":11247,"word":"\u179B\u17B6\u1784\u179F\u17B6\u1792"},{"id":11248,"word":"\u179B\u17B6\u1787"},{"id":11249,"word":"\u179B\u17B6\u1787\u1795\u17D2\u1791\u17BB\u17C7"},{"id":11250,"word":"\u179B\u17B6\u1789"},{"id":11251,"word":"\u179B\u17B6\u178F"},{"id":11252,"word":"\u179B\u17B6\u178F\u17CB"},{"id":11253,"word":"\u179B\u17B6\u1791\u17B6"},{"id":11254,"word":"\u179B\u17B6\u1793"},{"id":11255,"word":"\u179B\u17B6\u1793\u17CB"},{"id":11256,"word":"\u179B\u17B6\u1793\u1787\u17B6\u1784"},{"id":11257,"word":"\u179B\u17B6\u1794"},{"id":11258,"word":"\u179B\u17B6\u1794\u17CB"},{"id":11259,"word":"\u179B\u17B6\u1797"},{"id":11260,"word":"\u179B\u17B6\u1797\u17BC\u1794\u1793\u17B7\u179F\u17B6"},{"id":11261,"word":"\u179B\u17B6\u1798"},{"id":11262,"word":"\u179B\u17B6\u1798\u1780"},{"id":11263,"word":"\u179B\u17B6\u1799"},{"id":11264,"word":"\u179B\u17B6\u1799\u178A\u17C3"},{"id":11265,"word":"\u179B\u17B6\u1799\u1791\u17C2\u1784"},{"id":11266,"word":"\u179B\u17B6\u1799\u1793\u1780\u1798\u17D2\u1798"},{"id":11267,"word":"\u179B\u17B6\u1799\u179B\u1780\u17D2\u1781\u178E\u17CD"},{"id":11268,"word":"\u179B\u17B6\u1799\u179B\u17D0\u1780\u17D2\u178F"},{"id":11269,"word":"\u179B\u17B6\u1799\u179B\u17D0\u1781"},{"id":11270,"word":"\u179B\u17B6\u1799\u179F\u17B6\u17C6"},{"id":11271,"word":"\u179B\u17B6\u1799\u17A1\u17C6"},{"id":11272,"word":"\u179B\u17B6\u179C"},{"id":11273,"word":"\u179B\u17B6\u179C\u1780"},{"id":11274,"word":"\u179B\u17B6\u179C\u17D0\u178E\u17D2\u1799 "},{"id":11275,"word":"\u179B\u17B6\u179C\u17B7\u1780\u17B6"},{"id":11276,"word":"\u179B\u17B6\u179F"},{"id":11277,"word":"\u179B\u17B6\u179F\u17CB"},{"id":11278,"word":"\u179B\u17B6\u179F\u1780"},{"id":11279,"word":"\u179B\u17B6\u179F\u1793"},{"id":11280,"word":"\u179B\u17B6\u179F\u17B7\u1780\u17B6"},{"id":11281,"word":"\u179B\u17B7\u1780\u17C1"},{"id":11282,"word":"\u179B\u17B7\u1780\u17D2\u1781\u17B6"},{"id":11283,"word":"\u179B\u17B7\u1781\u1793\u1780\u1798\u17D2\u1798"},{"id":11284,"word":"\u179B\u17B7\u1781\u1793\u1780\u17B7\u1785\u17D2\u1785"},{"id":11285,"word":"\u179B\u17B7\u1781\u17B7\u178F"},{"id":11286,"word":"\u179B\u17B7\u1781\u17B7\u178F\u1782\u17C4\u1785\u179A"},{"id":11287,"word":"\u179B\u17B7\u1781\u17B7\u178F\u1786\u17D2\u179B\u1784\u178A\u17C2\u1793"},{"id":11288,"word":"\u179B\u17B7\u1784\u17D2\u1782"},{"id":11289,"word":"\u179B\u17B7\u1784\u17D2\u1782\u178F\u17D2\u1790\u17C1\u1793\u1780\u17C8"},{"id":11290,"word":"\u179B\u17B7\u1784\u17D2\u1782\u1793\u17B6\u179F\u1793\u17B6"},{"id":11291,"word":"\u179B\u17B7\u1784\u17D2\u1782\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7"},{"id":11292,"word":"\u179B\u17B7\u1784\u17D2\u1782\u179C\u17B7\u1794\u179B\u17D2\u179B\u17B6\u179F"},{"id":11293,"word":"\u179B\u17B7\u1784\u17D2\u1782\u17A2\u179A\u17B7\u1799\u17C8"},{"id":11294,"word":"\u179B\u17B7\u1785"},{"id":11295,"word":"\u179B\u17B7\u1789"},{"id":11296,"word":"\u179B\u17B7\u1789\u1782\u17B7\u1789"},{"id":11297,"word":"\u179B\u17B7\u178D"},{"id":11298,"word":"\u179B\u17B7\u1791\u17D2\u1792"},{"id":11299,"word":"\u179B\u17B7\u1793\u1787\u17B8"},{"id":11300,"word":"\u179B\u17B7\u1794\u17B7\u1780\u17B6\u179A"},{"id":11301,"word":"\u179B\u17B7\u1794\u17B7\u1780\u17B6\u179A\u17B7\u1780\u17B6"},{"id":11302,"word":"\u179B\u17B7\u1794\u17B7\u1780\u17D2\u179A\u1798"},{"id":11303,"word":"\u179B\u17B7\u1794\u17B7\u179F\u1787\u17D2\u1787\u17B6"},{"id":11304,"word":"\u179B\u17B7\u1794\u17D2\u178F\u17B6"},{"id":11305,"word":"\u179B\u17B7\u1794\u17D2\u179F\u17B6"},{"id":11306,"word":"\u179B\u17B7\u1798\u17D2\u1794\u1780\u1798\u17D2\u1798"},{"id":11307,"word":"\u179B\u17B7\u1798\u17D2\u1794\u1780\u17B6\u179A"},{"id":11308,"word":"\u179B\u17B7\u1798\u17D2\u1794\u1780\u17B6\u179A\u17B7\u1780\u17B6"},{"id":11309,"word":"\u179B\u17B8"},{"id":11310,"word":"\u179B\u17B8\u1780\u179B\u17B6\u1793"},{"id":11311,"word":"\u179B\u17B8\u1784"},{"id":11312,"word":"\u179B\u17B8\u1784\u179B\u17D0\u1780\u17D2\u178F"},{"id":11313,"word":"\u179B\u17B8\u1784\u179B\u17B6\u1787"},{"id":11314,"word":"\u179B\u17B8\u179B\u17B6"},{"id":11315,"word":"\u179B\u17B8\u179B\u17B6\u1794\u17CB"},{"id":11316,"word":"\u179B\u17B8\u179B\u17B6\u179F"},{"id":11317,"word":"\u179B\u17B8\u179C"},{"id":11318,"word":"\u179B\u17B8\u17A1\u17D2\u17A0\u17B6"},{"id":11319,"word":"\u179B\u17B9\u1793"},{"id":11320,"word":"\u179B\u17B9\u1794"},{"id":11321,"word":"\u179B\u17B9\u1798\u17D7"},{"id":11322,"word":"\u179B\u17BA"},{"id":11323,"word":"\u179B\u17BA\u1787\u17D0\u1799"},{"id":11324,"word":"\u179B\u17BA\u1787\u17B6"},{"id":11325,"word":"\u179B\u17BA\u179B\u17B6\u1793\u17CB"},{"id":11326,"word":"\u179B\u17BA\u179F\u17B6\u1799"},{"id":11327,"word":"\u179B\u17BB\u1780"},{"id":11328,"word":"\u179B\u17BB\u1784"},{"id":11329,"word":"\u179B\u17BB\u178F"},{"id":11330,"word":"\u179B\u17BB\u178F\u17D2\u178F"},{"id":11331,"word":"\u179B\u17BB\u1791\u17D2\u1791\u17C8"},{"id":11332,"word":"\u179B\u17BB\u1791\u17D2\u1792\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":11333,"word":"\u179B\u17BB\u1793"},{"id":11334,"word":"\u179B\u17BB\u1794"},{"id":11335,"word":"\u179B\u17BB\u1794\u1793\u17D0\u1799"},{"id":11336,"word":"\u179B\u17BB\u1798\u17D2\u1794\u1780"},{"id":11337,"word":"\u179B\u17BB\u1798\u17D2\u1794\u1780\u1798\u17D2\u1798"},{"id":11338,"word":"\u179B\u17BB\u1798\u17D2\u1794\u17B7\u1780\u17B6 "},{"id":11339,"word":"\u179B\u17BB\u1798\u17D2\u1796\u17B7\u1793\u17B8"},{"id":11340,"word":"\u179B\u17BB\u1799"},{"id":11341,"word":"\u179B\u17BB\u17C7"},{"id":11342,"word":"\u179B\u17BC"},{"id":11343,"word":"\u179B\u17BC\u1780"},{"id":11344,"word":"\u179B\u17BC\u1780\u1783\u17BB\u1793"},{"id":11345,"word":"\u179B\u17BC\u1780\u179B\u17B6\u1793\u17CB"},{"id":11346,"word":"\u179B\u17BC\u1781"},{"id":11347,"word":"\u179B\u17BC\u1785"},{"id":11348,"word":"\u179B\u17BC\u178F"},{"id":11349,"word":"\u179B\u17BC\u1793"},{"id":11350,"word":"\u179B\u17BD\u1784"},{"id":11351,"word":"\u179B\u17BD\u1785"},{"id":11352,"word":"\u179B\u17BD\u178F"},{"id":11353,"word":"\u179B\u17BD\u179F"},{"id":11354,"word":"\u179B\u17BE"},{"id":11355,"word":"\u179B\u17BE\u1780"},{"id":11356,"word":"\u179B\u17BE\u1784"},{"id":11357,"word":"\u179B\u17BE\u179F"},{"id":11358,"word":"\u179B\u17BF\u1784"},{"id":11359,"word":"\u179B\u17BF\u1784\u17AE"},{"id":11360,"word":"\u179B\u17BF\u1793"},{"id":11361,"word":"\u179B\u17BF\u1798"},{"id":11362,"word":"\u179B\u17BF\u1799"},{"id":11363,"word":"\u179B\u17C0\u1784"},{"id":11364,"word":"\u179B\u17C0\u1784\u1797\u17B6"},{"id":11365,"word":"\u179B\u17C0\u178F"},{"id":11366,"word":"\u179B\u17C0\u1793"},{"id":11367,"word":"\u179B\u17C0\u1794"},{"id":11368,"word":"\u179B\u17C0\u1798"},{"id":11369,"word":"\u179B\u17C0\u179C"},{"id":11370,"word":"\u179B\u17C0\u179F"},{"id":11371,"word":"\u179B\u17C1\u1781"},{"id":11372,"word":"\u179B\u17C1\u1781"},{"id":11373,"word":"\u179B\u17C1\u1781\u1780\u17C8"},{"id":11374,"word":"\u179B\u17C1\u1781\u1791\u17C4"},{"id":11375,"word":"\u179B\u17C1\u1781\u1793\u17B8"},{"id":11376,"word":"\u179B\u17C1\u1781\u1794\u178F\u17D2\u179A"},{"id":11377,"word":"\u179B\u17C1\u1781\u17A0\u17B6\u179A\u17B8"},{"id":11378,"word":"\u179B\u17C1\u1781\u17A2\u179F\u17D2\u178A\u17B6"},{"id":11379,"word":"\u179B\u17C1\u1781\u17B6"},{"id":11380,"word":"\u179B\u17C1\u1781\u17B6\u1792\u17B7\u1780\u17B6\u179A"},{"id":11381,"word":"\u179B\u17C1\u1781\u17B6\u1793\u17BB\u1780\u17B6\u179A"},{"id":11382,"word":"\u179B\u17C1\u1784"},{"id":11383,"word":"\u179B\u17C1\u1785"},{"id":11384,"word":"\u179B\u17C1\u1789"},{"id":11385,"word":"\u179B\u17C1\u1789\u179B\u17C1\u1784"},{"id":11386,"word":"\u179B\u17C1\u1789\u17D2\u1787\u17B6"},{"id":11387,"word":"\u179B\u17C1\u178C\u17D2\u178C\u17BB\u1794\u17B6\u178F"},{"id":11388,"word":"\u179B\u17C1\u178E\u178A\u17D2\u178B\u17B6\u1793"},{"id":11389,"word":"\u179B\u17C1\u178E\u17D2\u178C\u17BB\u1794\u17B6\u178F"},{"id":11390,"word":"\u179B\u17C1\u1794"},{"id":11391,"word":"\u179B\u17C1\u1794\u1780\u1798\u17D2\u1798"},{"id":11392,"word":"\u179B\u17C1\u1794\u1780\u17B6\u179A"},{"id":11393,"word":"\u179B\u17C1\u179B\u17B6"},{"id":11394,"word":"\u179B\u17C1\u179B\u17B6\u1794\u17CB"},{"id":11395,"word":"\u179B\u17C1\u179F"},{"id":11396,"word":"\u179B\u17C1\u17C7"},{"id":11397,"word":"\u179B\u17C2"},{"id":11398,"word":"\u179B\u17C2\u1784"},{"id":11399,"word":"\u179B\u17C2\u1793\u1796\u17C2\u1793"},{"id":11400,"word":"\u179B\u17C2\u1793\u179B\u1793"},{"id":11401,"word":"\u179B\u17C2\u1794\u1781\u17B6\u1799"},{"id":11402,"word":"\u179B\u17C2\u17C7"},{"id":11403,"word":"\u179B\u17C3"},{"id":11404,"word":"\u179B\u17C3\u179B\u1780"},{"id":11405,"word":"\u179B\u17C4"},{"id":11406,"word":"\u179B\u17C4\u1780"},{"id":11407,"word":"\u179B\u17C4\u1780 --"},{"id":11408,"word":"\u179B\u17C4\u1780\u1793\u17D2\u178F\u179A\u1793\u179A\u1780"},{"id":11409,"word":"\u179B\u17C4\u1780\u17B6"},{"id":11410,"word":"\u179B\u17C4\u1780\u17B6 --"},{"id":11411,"word":"\u179B\u17C4\u1780\u17B7\u1799"},{"id":11412,"word":"\u179B\u17C4\u1780\u17B8\u1799\u17CD"},{"id":11413,"word":"\u179B\u17C4\u1780\u17BB\u178F\u17D2\u178F\u179A"},{"id":11414,"word":"\u179B\u17C4\u1780\u17C1\u179F\u17D2\u179C\u179A\u17C8"},{"id":11415,"word":"\u179B\u17C4\u1784"},{"id":11416,"word":"\u179B\u17C4\u178E \u1798\u17D2\u1796\u17B7\u179B"},{"id":11417,"word":"\u179B\u17C4\u178F"},{"id":11418,"word":"\u179B\u17C4\u178F\u17A2\u1784\u17D2\u179A\u17C2"},{"id":11419,"word":"\u179B\u17C4\u178F\u17A2\u1793\u17D2\u1791\u17B6\u1780\u17CB"},{"id":11420,"word":"\u179B\u17C4\u178F\u17C2"},{"id":11421,"word":"\u179B\u17C4\u1791"},{"id":11422,"word":"\u179B\u17C4\u1794"},{"id":11423,"word":"\u179B\u17C4\u1797"},{"id":11424,"word":"\u179B\u17C4\u1797\u17C8"},{"id":11425,"word":"\u179B\u17C4\u1797\u17C4"},{"id":11426,"word":"\u179B\u17C4\u1798"},{"id":11427,"word":"\u179B\u17C4\u1798\u1791\u17C4\u1798 "},{"id":11428,"word":"\u179B\u17C4\u1798\u1796\u17D0\u178E\u17CC"},{"id":11429,"word":"\u179B\u17C4\u1798\u179F\u17B6\u179A"},{"id":11430,"word":"\u179B\u17C4\u1798\u17B6"},{"id":11431,"word":"\u179B\u17C4\u179B\u178F\u17B6"},{"id":11432,"word":"\u179B\u17C4\u179B\u17B6"},{"id":11433,"word":"\u179B\u17C4\u179B\u17BB\u1794"},{"id":11434,"word":"\u179B\u17C4\u17A0\u17C8"},{"id":11435,"word":"\u179B\u17C4\u17A0 --"},{"id":11436,"word":"\u179B\u17C4\u17A0\u17B7\u178F"},{"id":11437,"word":"\u179B\u17C4\u17A0\u17B7\u178F \u1794\u1780\u17D2\u1781\u1793\u17D2\u1791\u17B7\u1780\u17B6\u1796\u17B6\u1792"},{"id":11438,"word":"\u179B\u17C4\u17A0\u17B7\u178F\u1797\u1780\u17D2\u1781"},{"id":11439,"word":"\u179B\u17C4\u17A0\u17B7\u178F\u17B6\u1782\u17B6\u179A"},{"id":11440,"word":"\u179B\u17C4\u17A0\u17B7\u178F\u17B6\u1796\u17B6\u1792"},{"id":11441,"word":"\u179B\u17C4\u17A0\u17B7\u178F\u17BB\u1794\u17D2\u1794\u17B6\u1791"},{"id":11442,"word":"\u179B\u17C4\u17C7"},{"id":11443,"word":"\u179B\u17C4\u17C7\u179B\u17B6\u1799"},{"id":11444,"word":"\u179B\u17C5"},{"id":11445,"word":"\u179B\u17C6"},{"id":11446,"word":"\u179B\u17C6\u1782\u17C1\u1789"},{"id":11447,"word":"\u179B\u17C6\u1785\u1784\u17CB"},{"id":11448,"word":"\u179B\u17C6\u1789\u1784"},{"id":11449,"word":"\u179B\u17C6\u178A\u17B6\u1794\u17CB"},{"id":11450,"word":"\u179B\u17C6\u178A\u17C4\u1799"},{"id":11451,"word":"\u179B\u17C6\u1791\u17C4\u1793"},{"id":11452,"word":"\u179B\u17C6\u1793\u17B6\u1785"},{"id":11453,"word":"\u179B\u17C6\u1793\u17B9\u1784"},{"id":11454,"word":"\u179B\u17C6\u1793\u17C5"},{"id":11455,"word":"\u179B\u17C6\u1793\u17B6\u17C6"},{"id":11456,"word":"\u179B\u17C6\u1793\u17B6\u17C6\u179F\u1798\u179F\u17B6\u179A"},{"id":11457,"word":"\u179B\u17C6\u1794\u17C9\u17B6"},{"id":11458,"word":"\u179B\u17C6\u1794\u17B6\u1780"},{"id":11459,"word":"\u179B\u17C6\u1794\u17B7\u1793"},{"id":11460,"word":"\u179B\u17C6\u1794\u17C1\u1780"},{"id":11461,"word":"\u179B\u17C6\u1795\u1780"},{"id":11462,"word":"\u179B\u17C6\u1795\u17BC\u1784"},{"id":11463,"word":"\u179B\u17C6\u1796\u1784\u17CB"},{"id":11464,"word":"\u179B\u17C6\u1796\u179F\u17CB"},{"id":11465,"word":"\u179B\u17C6\u1796\u17B6\u1793\u17CB"},{"id":11466,"word":"\u179B\u17C6\u1796\u17B6\u179F\u17CB"},{"id":11467,"word":"\u179B\u17C6\u1796\u17BE\u1793"},{"id":11468,"word":"\u179B\u17C6\u1796\u17C2\u1784"},{"id":11469,"word":"\u179B\u17C6\u1796\u17C2\u1784\u1796\u17D2\u179A\u17C7\u179A\u17B6\u1798"},{"id":11470,"word":"\u179B\u17C6\u1796\u17C2\u1784\u179F\u17D2\u1793\u17C2\u1784\u1780\u17D2\u179A\u1794\u17B8"},{"id":11471,"word":"\u179B\u17C6\u1796\u17C2\u1784\u17A2\u179A\u17B9\u179F"},{"id":11472,"word":"\u179B\u17C6\u1796\u17B6\u17C6\u1784"},{"id":11473,"word":"\u179B\u17C6\u17A0"},{"id":11474,"word":"\u179B\u17C6\u17A0\u17B6\u1785"},{"id":11475,"word":"\u179B\u17C6\u17A0\u17BB\u1780"},{"id":11476,"word":"\u179B\u17C6\u17A0\u17BD\u178F"},{"id":11477,"word":"\u179B\u17C6\u17A0\u17BE\u1799"},{"id":11478,"word":"\u179B\u17C6\u17A0\u17C2"},{"id":11479,"word":"\u179B\u17C6\u17A0\u17C4\u1780"},{"id":11480,"word":"\u179B\u17C6\u17A2"},{"id":11481,"word":"\u179B\u17C6\u17A2\u1780\u17CB"},{"id":11482,"word":"\u179B\u17C6\u17A2\u1780\u17CB\u1796\u17D0\u178E\u17CC"},{"id":11483,"word":"\u179B\u17C6\u17A2\u1784"},{"id":11484,"word":"\u179B\u17C6\u17A2\u1793\u17CB"},{"id":11485,"word":"\u179B\u17C6\u17A2\u17B7\u178F"},{"id":11486,"word":"\u179B\u17C6\u17A2\u17B7\u178F\u179B\u17C6\u17A2\u17BC\u1793"},{"id":11487,"word":"\u179B\u17C6\u17A2\u17BB\u178F"},{"id":11488,"word":"\u179B\u17C6\u17A2\u17BC\u178F"},{"id":11489,"word":"\u179B\u17C6\u17A2\u17C0\u1784"},{"id":11490,"word":"\u179B\u17C6\u17B1\u1793"},{"id":11491,"word":"\u179B\u17B6\u17C6"},{"id":11492,"word":"\u179B\u17B6\u17C6\u1784"},{"id":11493,"word":"\u179B\u17B6\u17C6\u1784\u17D7"},{"id":11494,"word":"\u179B\u17B6\u17C6\u1784\u1787\u17D0\u1799"},{"id":11495,"word":"\u179B\u17B6\u17C6\u1784\u179F\u17B6\u178F"},{"id":11496,"word":"\u179B\u17B6\u17C6\u179B\u17BE\u179F"},{"id":11497,"word":"\u179B\u17C7"},{"id":11498,"word":"\u179B\u17C7\u1794\u1784\u17CB"},{"id":11499,"word":"\u179B\u17C7\u179B\u17B6\u1780"},{"id":11500,"word":"\u179B\u17C7\u179B\u17C2\u1784"},{"id":11501,"word":"\u179B\u17D2\u1780\u1780\u17CB"},{"id":11502,"word":"\u179B\u17D2\u1780\u1798"},{"id":11503,"word":"\u179B\u17D2\u1781\u17C4\u1793"},{"id":11504,"word":"\u179B\u17D2\u1782\u1784"},{"id":11505,"word":"\u179B\u17D2\u1782\u17B6\u1799"},{"id":11506,"word":"\u179B\u17D2\u1782\u17B6\u1799\u179B\u17D2\u1782\u1784"},{"id":11507,"word":"\u179B\u17D2\u1782\u17B9\u1780"},{"id":11508,"word":"\u179B\u17D2\u1782\u17B9\u1780\u178E\u17B6\u178F\u17C2"},{"id":11509,"word":"\u179B\u17D2\u1782\u17C1\u1793"},{"id":11510,"word":"\u179B\u17D2\u1784"},{"id":11511,"word":"\u179B\u17D2\u1784\u1784\u17CB"},{"id":11512,"word":"\u179B\u17D2\u1784\u1798"},{"id":11513,"word":"\u179B\u17D2\u1784\u17B6\u1785"},{"id":11514,"word":"\u179B\u17D2\u1784\u17B6\u1793\u17CB"},{"id":11515,"word":"\u179B\u17D2\u1784\u17B8\u179B\u17D2\u1784\u17BE"},{"id":11516,"word":"\u179B\u17D2\u1784\u17C0\u1784"},{"id":11517,"word":"\u179B\u17D2\u1784\u17C0\u1784\u1787\u17BC\u178F\u17A2\u17B6\u1785\u1798\u17CD\u1780\u17BC\u1793"},{"id":11518,"word":"\u179B\u17D2\u1784\u17C0\u1798"},{"id":11519,"word":"\u179B\u17D2\u1784\u17C1\u179B\u17D2\u1784\u17BE"},{"id":11520,"word":"\u179B\u17D2\u1794\u1780"},{"id":11521,"word":"\u179B\u17D2\u1794\u1780\u17CB"},{"id":11522,"word":"\u179B\u17D2\u1794\u1784"},{"id":11523,"word":"\u179B\u17D2\u1794\u178F\u17CB"},{"id":11524,"word":"\u179B\u17D2\u1794\u1794\u17CB"},{"id":11525,"word":"\u179B\u17D2\u1794\u17B6\u1780\u17CB"},{"id":11526,"word":"\u179B\u17D2\u1794\u17B6\u1780\u17CB\u1791\u17B9\u1780"},{"id":11527,"word":"\u179B\u17D2\u1794\u17B6\u1780\u17CB\u179F\u17B6"},{"id":11528,"word":"\u179B\u17D2\u1794\u17B6\u1789"},{"id":11529,"word":"\u179B\u17D2\u1794\u17B6\u178F"},{"id":11530,"word":"\u179B\u17D2\u1794\u17B6\u1794\u17CB"},{"id":11531,"word":"\u179B\u17D2\u1794\u17B6\u1799"},{"id":11532,"word":"\u179B\u17D2\u1794\u17B6\u179F\u17CB"},{"id":11533,"word":"\u179B\u17D2\u1794\u17B6\u179F\u17CB\u1780\u17B6\u17C6"},{"id":11534,"word":"\u179B\u17D2\u1794\u17B7\u1785"},{"id":11535,"word":"\u179B\u17D2\u1794\u17B7\u1785\u1785\u17C5\u1780\u17D2\u179A\u1798"},{"id":11536,"word":"\u179B\u17D2\u1794\u17B8"},{"id":11537,"word":"\u179B\u17D2\u1794\u17BB\u1780\u17D2\u1780\u178F\u17C4"},{"id":11538,"word":"\u179B\u17D2\u1794\u17BB\u1784"},{"id":11539,"word":"\u179B\u17D2\u1794\u17BD\u1784"},{"id":11540,"word":"\u179B\u17D2\u1794\u17BE\u1780"},{"id":11541,"word":"\u179B\u17D2\u1794\u17BF\u1793"},{"id":11542,"word":"\u179B\u17D2\u1794\u17C2\u1784"},{"id":11543,"word":"\u179B\u17D2\u1794\u17C4\u1799"},{"id":11544,"word":"\u179B\u17D2\u1794\u17C4\u17C7"},{"id":11545,"word":"\u179B\u17D2\u1794\u17C4\u17C7\u179B\u17D2\u1794\u17C4\u1799"},{"id":11546,"word":"\u179B\u17D2\u1794\u17C7"},{"id":11547,"word":"\u179B\u17D2\u1796\u17C1\u1789\u179B\u17D2\u1796\u17C5"},{"id":11548,"word":"\u179B\u17D2\u1796\u17C5"},{"id":11549,"word":"\u179B\u17D2\u1798\u1798"},{"id":11550,"word":"\u179B\u17D2\u1798\u1798\u179B\u17D2\u1798\u17C3"},{"id":11551,"word":"\u179B\u17D2\u1798\u17B6\u1780\u17CB"},{"id":11552,"word":"\u179B\u17D2\u1798\u17B6\u179F"},{"id":11553,"word":"\u179B\u17D2\u1798\u17B7\u1785"},{"id":11554,"word":"\u179B\u17D2\u1798\u17B8\u179B\u17D2\u1798\u17BE"},{"id":11555,"word":"\u179B\u17D2\u1798\u17BB\u1784"},{"id":11556,"word":"\u179B\u17D2\u1798\u17BB\u178F"},{"id":11557,"word":"\u179B\u17D2\u1798\u17BD\u1785"},{"id":11558,"word":"\u179B\u17D2\u1798\u17BD\u178F"},{"id":11559,"word":"\u179B\u17D2\u1798\u17C9\u17BE"},{"id":11560,"word":"\u179B\u17D2\u1798\u17BE\u179F"},{"id":11561,"word":"\u179B\u17D2\u1798\u17BF\u1784"},{"id":11562,"word":"\u179B\u17D2\u1798\u17BF\u1799"},{"id":11563,"word":"\u179B\u17D2\u1798\u17C0\u178F"},{"id":11564,"word":"\u179B\u17D2\u1798\u17C1\u1785"},{"id":11565,"word":"\u179B\u17D2\u1798\u17C1\u1789\u179B\u17D2\u1798\u17BE"},{"id":11566,"word":"\u179B\u17D2\u1798\u17C2\u17C7"},{"id":11567,"word":"\u179B\u17D2\u1798\u17C3"},{"id":11568,"word":"\u179B\u17D2\u1798\u17C4\u1797"},{"id":11569,"word":"\u179B\u17D2\u1798\u17B6\u17C6\u1784"},{"id":11570,"word":"\u179B\u17D2\u1799\u17C6"},{"id":11571,"word":"\u179B\u17D2\u179C\u1780\u17CB"},{"id":11572,"word":"\u179B\u17D2\u179C\u178F"},{"id":11573,"word":"\u179B\u17D2\u179C\u1793\u17CB"},{"id":11574,"word":"\u179B\u17D2\u179C\u17B6"},{"id":11575,"word":"\u179B\u17D2\u179C\u17B6\u1785\u17C1\u1780"},{"id":11576,"word":"\u179B\u17D2\u179C\u17B6\u178A\u17B8"},{"id":11577,"word":"\u179B\u17D2\u179C\u17B6\u179F\u179B\u17D2\u179C\u1793\u17CB"},{"id":11578,"word":"\u179B\u17D2\u179C\u17B8\u1784"},{"id":11579,"word":"\u179B\u17D2\u179C\u17B9\u1784"},{"id":11580,"word":"\u179B\u17D2\u179C\u17B9\u1784\u179B\u17D2\u179C\u17BE\u1799"},{"id":11581,"word":"\u179B\u17D2\u179C\u17BE\u1799"},{"id":11582,"word":"\u179B\u17D2\u179C\u17C0\u1784"},{"id":11583,"word":"\u179B\u17D2\u179C\u17C1\u1784\u179B\u17D2\u179C\u17BE\u1799"},{"id":11584,"word":"\u179B\u17D2\u179C\u17C2\u1784"},{"id":11585,"word":"\u179B\u17D2\u179C\u17C2\u178F"},{"id":11586,"word":"\u179B\u17D2\u179C\u17C3"},{"id":11587,"word":"\u179B\u17D2\u17A0"},{"id":11588,"word":"\u179B\u17D2\u17A0\u1780"},{"id":11589,"word":"\u179B\u17D2\u17A0\u1780\u17CB"},{"id":11590,"word":"\u179B\u17D2\u17A0\u17B6\u1785"},{"id":11591,"word":"\u179B\u17D2\u17A0\u17B6\u179B"},{"id":11592,"word":"\u179B\u17D2\u17A0\u17B7\u178F\u179B\u17D2\u17A0\u17C3"},{"id":11593,"word":"\u179B\u17D2\u17A0\u17B9\u1798"},{"id":11594,"word":"\u179B\u17D2\u17A0\u17BB\u1784"},{"id":11595,"word":"\u179B\u17D2\u17A0\u17BD\u178F"},{"id":11596,"word":"\u179B\u17D2\u17A0\u17BE\u1799"},{"id":11597,"word":"\u179B\u17D2\u17A0\u17C1\u179C"},{"id":11598,"word":"\u179B\u17D2\u17A0\u17C2"},{"id":11599,"word":"\u179B\u17D2\u17A0\u17C2\u1798"},{"id":11600,"word":"\u179B\u17D2\u17A0\u17C4\u179B"},{"id":11601,"word":"\u179B\u17D2\u17A0\u17C4\u179F"},{"id":11602,"word":"\u179B\u17D2\u17A2"},{"id":11603,"word":"\u179B\u17D2\u17A2\u1780\u17CB"},{"id":11604,"word":"\u179B\u17D2\u17A2\u1784"},{"id":11605,"word":"\u179B\u17D2\u17A2\u1793\u17CB"},{"id":11606,"word":"\u179B\u17D2\u17A2\u17B6\u1784"},{"id":11607,"word":"\u179B\u17D2\u17A2\u17B6\u1785\u17CB"},{"id":11608,"word":"\u179B\u17D2\u17A2\u17B6\u178F"},{"id":11609,"word":"\u179B\u17D2\u17A2\u17B6\u1793"},{"id":11610,"word":"\u179B\u17D2\u17A2\u17B7\u178F"},{"id":11611,"word":"\u179B\u17D2\u17A2\u17B7\u1793"},{"id":11612,"word":"\u179B\u17D2\u17A2\u17B8"},{"id":11613,"word":"\u179B\u17D2\u17A2\u17BC\u1780"},{"id":11614,"word":"\u179B\u17D2\u17A2\u17BC\u178F"},{"id":11615,"word":"\u179B\u17D2\u17A2\u17BD\u178F"},{"id":11616,"word":"\u179B\u17D2\u17A2\u17C0\u1784"},{"id":11617,"word":"\u179B\u17D2\u17A2\u17C0\u1785"},{"id":11618,"word":"\u179B\u17D2\u17A2\u17C0\u1785\u179B\u17D2\u17A2\u17C2"},{"id":11619,"word":"\u179B\u17D2\u17A2\u17C4\u1785"},{"id":11620,"word":"\u179B\u17D2\u17A2\u17C4\u1789"},{"id":11621,"word":"\u179B\u17D2\u17A2\u17C4\u1798"},{"id":11622,"word":"\u179B\u17D2\u17A2\u17C7"},{"id":11623,"word":"\u17AD"},{"id":11624,"word":"\u17AE"},{"id":11625,"word":"\u17AE\u1787\u17D0\u1799"},{"id":11626,"word":"\u17AE\u1787\u17B6"},{"id":11627,"word":"\u17AE\u179B\u17B6\u1793\u17CB"},{"id":11628,"word":"\u17AE\u179F\u17B6\u1799"},{"id":11629,"word":"\u179C"},{"id":11630,"word":"\u179C\u17C9"},{"id":11631,"word":"\u179C\u17C8 ! "},{"id":11632,"word":"\u179C\u1780"},{"id":11633,"word":"\u179C\u17C9\u1780 !"},{"id":11634,"word":"\u179C\u1780\u17CB"},{"id":11635,"word":"\u179C\u1780\u17D2\u1780\u17C6"},{"id":11636,"word":"\u179C\u1782\u17D2\u1782"},{"id":11637,"word":"\u179C\u1782\u17D2\u1782\u1793\u17D2\u178F\u17C8"},{"id":11638,"word":"\u179C\u1782\u17D2\u1782\u17BB"},{"id":11639,"word":"\u179C\u1784"},{"id":11640,"word":"\u179C\u1784\u17CB"},{"id":11641,"word":"\u179C\u17C9\u1784\u17CB"},{"id":11642,"word":"\u179C\u1784\u17CB\u1780\u17D2\u179A\u1785\u1780"},{"id":11643,"word":"\u179C\u1784\u17CB\u1796\u17D2\u179A\u17C7\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799"},{"id":11644,"word":"\u179C\u1784\u17D2\u1780\u17C8"},{"id":11645,"word":"\u179C\u1784\u17D2\u1780\u178F"},{"id":11646,"word":"\u179C\u1784\u17D2\u179C\u17B6\u1793\u17CB"},{"id":11647,"word":"\u179C\u1784\u17D2\u179C\u17C1\u1784"},{"id":11648,"word":"\u179C\u1784\u17D2\u179F"},{"id":11649,"word":"\u179C\u1784\u17D2\u179F\u17B6"},{"id":11650,"word":"\u179C\u1784\u17D2\u179F\u17B6 --"},{"id":11651,"word":"\u179C\u1784\u17D2\u179F\u17B6\u17A2\u1782\u17D2\u1782\u179A\u17B6\u1787"},{"id":11652,"word":"\u179C\u1785\u1793\u17C8"},{"id":11653,"word":"\u179C\u1785\u1793 --"},{"id":11654,"word":"\u179C\u1785\u1793\u17B6 --"},{"id":11655,"word":"\u179C\u1785\u1793\u17B6\u1792\u17B7\u1794\u17D2\u1794\u17B6\u1799"},{"id":11656,"word":"\u179C\u1785\u1793\u17B6\u1793\u17BB\u1780\u17D2\u179A\u1798"},{"id":11657,"word":"\u179C\u1785\u17B8"},{"id":11658,"word":"\u179C\u1785\u17B8\u1780\u1798\u17D2\u1798"},{"id":11659,"word":"\u179C\u1785\u17D2\u1785"},{"id":11660,"word":"\u179C\u1787\u17B7\u179A\u17C8"},{"id":11661,"word":"\u179C\u1787\u17B7\u179A\u1794\u17B6\u178E\u17B8"},{"id":11662,"word":"\u179C\u1787\u17B8\u179A"},{"id":11663,"word":"\u179C\u1787\u17D2\u1787\u1791\u179F\u17D2\u179F\u17B7\u1793\u17B8"},{"id":11664,"word":"\u179C\u1787\u17D2\u1787\u1791\u179F\u17D2\u179F\u17B8"},{"id":11665,"word":"\u179C\u1789\u17D2\u1785"},{"id":11666,"word":"\u179C\u1789\u17D2\u1785\u1793\u17B6\u1780\u17B6\u179A"},{"id":11667,"word":"\u179C\u1789\u17D2\u1788\u17C8"},{"id":11668,"word":"\u179C\u1789\u17D2\u1788\u17B6"},{"id":11669,"word":"\u179C\u178A\u17D2\u178A"},{"id":11670,"word":"\u179C\u178A\u17D2\u178A --"},{"id":11671,"word":"\u179C\u178C\u17D2\u178D\u1780\u17B8"},{"id":11672,"word":"\u179C\u178C\u17D2\u178D\u1793"},{"id":11673,"word":"\u179C\u178C\u17D2\u178D\u1793 --"},{"id":11674,"word":"\u179C\u178C\u17D2\u178D\u1793\u17B6\u1780\u17B6\u179A"},{"id":11675,"word":"\u179C\u178E\u179A\u17C4\u1782"},{"id":11676,"word":"\u179C\u178E\u17B7\u1787\u17D2\u1787\u17B6"},{"id":11677,"word":"\u179C\u178E\u17B7\u1796\u17D2\u179C\u1780"},{"id":11678,"word":"\u179C\u178E\u17D2\u178A"},{"id":11679,"word":"\u179C\u17D0\u178E\u17D2\u178A"},{"id":11680,"word":"\u179C\u178E\u17D2\u178E"},{"id":11681,"word":"\u179C\u178E\u17D2\u178E\u1793\u17B6"},{"id":11682,"word":"\u179C\u178E\u17D2\u178E\u1799\u17BB\u178F\u17D2\u178F"},{"id":11683,"word":"\u179C\u178F\u17D2\u178F"},{"id":11684,"word":"\u179C\u178F\u17D2\u178F\u1793\u17B8"},{"id":11685,"word":"\u179C\u178F\u17D2\u178F\u1798\u17B6\u1793"},{"id":11686,"word":"\u179C\u178F\u17D2\u178F\u1798\u17B6\u1793\u1780\u17B6\u179B"},{"id":11687,"word":"\u179C\u178F\u17D2\u178F\u1798\u17B6\u1793\u17B6"},{"id":11688,"word":"\u179C\u178F\u17D2\u1790"},{"id":11689,"word":"\u179C\u178F\u17D2\u1790 --"},{"id":11690,"word":"\u179C\u178F\u17D2\u1790\u1796\u1793\u17D2\u1792"},{"id":11691,"word":"\u179C\u178F\u17D2\u1790\u17B6 --"},{"id":11692,"word":"\u179C\u178F\u17D2\u1790\u17B7"},{"id":11693,"word":"\u179C\u178F\u17D2\u1790\u17BB"},{"id":11694,"word":"\u179C\u178F\u17D2\u1790\u17BB --"},{"id":11695,"word":"\u179C\u178F\u17D2\u179F"},{"id":11696,"word":"\u179C\u178F\u17D2\u179F\u179A\u17CD"},{"id":11697,"word":"\u179C\u1791\u17D0\u1793"},{"id":11698,"word":"\u179C\u1791\u1789\u17D2\u1789\u17BC"},{"id":11699,"word":"\u179C\u17D0\u1792"},{"id":11700,"word":"\u179C\u1792\u1797\u17BC\u1798\u17B7"},{"id":11701,"word":"\u179C\u1792\u17BC"},{"id":11702,"word":"\u179C\u1792\u17D2\u1799\u179F\u17D2\u1790\u17B6\u1793"},{"id":11703,"word":"\u179C\u1793"},{"id":11704,"word":"\u179C\u1793 --"},{"id":11705,"word":"\u179C\u1793\u1793\u17D2\u178F\u179A"},{"id":11706,"word":"\u179C\u1793\u1794\u17D2\u1794\u178F\u17B7"},{"id":11707,"word":"\u179C\u1793\u179A\u17D0\u178F"},{"id":11708,"word":"\u179C\u1793\u179A\u17D0\u178F\u1793\u17CD"},{"id":11709,"word":"\u179C\u1793\u179F\u17D2\u1794\u178F\u17B7"},{"id":11710,"word":"\u179C\u1793\u17B6 --"},{"id":11711,"word":"\u179C\u1793\u17B7\u178F\u17B6"},{"id":11712,"word":"\u179C\u1793\u17B7\u1796\u17D2\u179C\u1780"},{"id":11713,"word":"\u179C\u1793\u17C1\u1785\u179A"},{"id":11714,"word":"\u179C\u1793\u17D2\u178F"},{"id":11715,"word":"\u179C\u1793\u17D2\u1791\u1793\u17B6"},{"id":11716,"word":"\u179C\u1793\u17D2\u1791\u1793\u17D2\u178F"},{"id":11717,"word":"\u179C\u1793\u17D2\u1791\u1793\u17D2\u178F\u17B8"},{"id":11718,"word":"\u179C\u1793\u17D2\u1791\u17B6"},{"id":11719,"word":"\u179C\u1793\u17D2\u1791\u17B8\u1799\u17CD"},{"id":11720,"word":"\u179C\u1793\u17D2\u1791\u17B8\u1799\u1794\u17BB\u1782\u17D2\u1782\u179B"},{"id":11721,"word":"\u179C\u17C9\u1794"},{"id":11722,"word":"\u179C\u1794\u17D2\u1794"},{"id":11723,"word":"\u179C\u1794\u17D2\u1794 --"},{"id":11724,"word":"\u179C\u1798\u179A\u17C4\u1782"},{"id":11725,"word":"\u179C\u1798\u17D2\u1798\u17B7\u178F"},{"id":11726,"word":"\u179C\u1799"},{"id":11727,"word":"\u179C\u1799\u179C\u178C\u17D2\u178D\u1793\u17B6\u1780\u17B6\u179A"},{"id":11728,"word":"\u179C\u1799\u179F\u17D2\u1790"},{"id":11729,"word":"\u1799\u179F\u17D2\u1799"},{"id":11730,"word":"\u179C\u179A"},{"id":11731,"word":"\u179C\u179A --"},{"id":11732,"word":"\u179C\u179A\u17C4 --"},{"id":11733,"word":"\u179C\u179A\u17BB\u178E"},{"id":11734,"word":"\u179C\u178E\u17CC"},{"id":11735,"word":"\u179C\u179A\u17D2\u1798\u17D0\u1793"},{"id":11736,"word":"\u179C\u179A\u17D2\u1798\u17B7\u178F"},{"id":11737,"word":"\u179C\u179B\u17CB"},{"id":11738,"word":"\u179C\u179B\u17D0\u1799"},{"id":11739,"word":"\u179C\u179B\u17B6\u17A0\u1780"},{"id":11740,"word":"\u179C\u179B\u17B8"},{"id":11741,"word":"\u179C\u179B\u17B8\u1798\u17BB\u1781"},{"id":11742,"word":"\u179C\u179B\u17D2\u1798\u17B8\u1780\u17B7"},{"id":11743,"word":"\u179C\u179B\u17D2\u179B\u1797\u17C8"},{"id":11744,"word":"\u179C\u179B\u17D2\u179B\u1797\u17B6"},{"id":11745,"word":"\u179C\u179B\u17D2\u179B\u17B7"},{"id":11746,"word":"\u179C\u179B\u17D2\u179B\u17B7\u1787\u17B6\u178F\u17B7"},{"id":11747,"word":"\u179C\u17C9\u179F"},{"id":11748,"word":"\u179C\u179F\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":11749,"word":"\u179C\u179F\u1793\u17D2\u178F\u178F\u17B7\u179B\u1780"},{"id":11750,"word":"\u179C\u179F\u1793\u17D2\u178F\u179A\u178A\u17BC\u179C"},{"id":11751,"word":"\u179C\u179F\u179B"},{"id":11752,"word":"\u179C\u179F\u179C\u178F\u17D2\u178F\u17B8"},{"id":11753,"word":"\u179C\u179F\u17BB\u1792\u17B6"},{"id":11754,"word":"\u179C\u179F\u17BB\u1793\u17D2\u1792\u179A\u17B6"},{"id":11755,"word":"\u179C\u179F\u17BB\u1798\u178F\u17B8"},{"id":11756,"word":"\u179C\u179F\u17D2\u179F\u1780\u17B6\u179B"},{"id":11757,"word":"\u179C\u179F\u17D2\u179F\u179C\u179B\u17B6\u17A0\u1780"},{"id":11758,"word":"\u179C\u179F\u17D2\u179F\u17B6"},{"id":11759,"word":"\u179C\u179F\u17D2\u179F\u17B6\u1793\u17C8"},{"id":11760,"word":"\u179C\u179F\u17D2\u179F\u17BC\u1794\u1793\u17B6\u1799\u17B7\u1780\u17B6"},{"id":11761,"word":"\u179C\u17A0\u178F\u17B8"},{"id":11762,"word":"\u179C\u17A0\u1793\u1780\u1798\u17D2\u1798"},{"id":11763,"word":"\u179C\u17B6"},{"id":11764,"word":"\u179C\u17C9\u17B6"},{"id":11765,"word":"\u179C\u17B6\u1780\u17CB"},{"id":11766,"word":"\u179C\u17B6\u1780\u1785\u17B7\u179A\u1796\u179F\u17D2\u178A\u17D2\u179A"},{"id":11767,"word":"\u179C\u17B6\u1780\u17D2\u1799"},{"id":11768,"word":"\u179C\u17B6\u1780\u17D2\u1799 --"},{"id":11769,"word":"\u179C\u17B6\u1780\u17D2\u1799\u17B6 --"},{"id":11770,"word":"\u179C\u17B6\u1782\u17B6\u179A"},{"id":11771,"word":"\u179C\u17B6\u1782\u17BB\u179A\u17B6"},{"id":11772,"word":"\u179C\u17B6\u1782\u17BB\u179A\u17B7\u1780"},{"id":11773,"word":"\u179C\u17B6\u1782\u17D2\u1798\u17B7\u1793"},{"id":11774,"word":"\u179C\u17B6\u1784"},{"id":11775,"word":"\u179C\u17C9\u17B6\u1784"},{"id":11776,"word":"\u179C\u17C9\u17B6\u1784\u1798\u17BB\u1781"},{"id":11777,"word":"\u179C\u17B6\u1784\u179C\u17C3"},{"id":11778,"word":"\u179C\u17B6\u1785"},{"id":11779,"word":"\u179C\u17B6\u1785\u1780"},{"id":11780,"word":"\u179C\u17B6\u1785\u179F\u17B7\u1780"},{"id":11781,"word":"\u179C\u17B6\u1785\u17B6"},{"id":11782,"word":"\u179C\u17B6\u1785\u17B6 --"},{"id":11783,"word":"\u179C\u17B6\u1785\u17B6\u179B"},{"id":11784,"word":"\u179C\u17B6\u1785\u17B6\u179F\u17B7\u179B\u17B7\u178A\u17D2\u178B"},{"id":11785,"word":"\u179C\u17B6\u1785\u17B7\u1780"},{"id":11786,"word":"\u179C\u17B6\u1785\u17B7\u1780\u1794\u178F\u17D2\u179A"},{"id":11787,"word":"\u179C\u17B6\u1785\u17B7\u1780\u17A0\u17B6\u179A\u1780"},{"id":11788,"word":"\u179C\u17B6\u1785\u17B7\u1780\u17A0\u17B6\u179A\u17B7\u1780\u17B6"},{"id":11789,"word":"\u179C\u17B6\u1787\u17B7\u1793\u17B8"},{"id":11790,"word":"\u179C\u17B6\u178E\u179C\u17B6\u179A"},{"id":11791,"word":"\u179C\u17B6\u178E\u17B7\u1787"},{"id":11792,"word":"\u179C\u17B6\u178E\u17B7\u1787\u17D2\u1787"},{"id":11793,"word":"\u179C\u17B6\u178E\u17B7\u1787\u17D2\u1787\u1780\u1798\u17D2\u1798"},{"id":11794,"word":"\u179C\u17B6\u178E\u17B7\u1787\u17D2\u1787\u1780\u17B6\u179A"},{"id":11795,"word":"\u179C\u17B6\u178E\u17B8"},{"id":11796,"word":"\u179C\u17B6\u178F"},{"id":11797,"word":"\u179C\u17B6\u178F"},{"id":11798,"word":"\u179C\u17B6\u178F --"},{"id":11799,"word":"\u179C\u17B6\u178F\u17CB"},{"id":11800,"word":"\u179C\u17B6\u178F\u179C\u179B\u17B6\u17A0\u1780"},{"id":11801,"word":"\u179C\u17B6\u178F\u17A2\u17B6\u1791\u17B7"},{"id":11802,"word":"\u179C\u17B6\u178F\u17BB\u179B"},{"id":11803,"word":"\u179C\u17B6\u178F\u17BB\u179B\u17B6"},{"id":11804,"word":"\u179C\u17B6\u178F\u17D2\u1799\u17B6"},{"id":11805,"word":"\u179C\u17B6\u1791"},{"id":11806,"word":"\u179C\u17B6\u1791\u1780\u17C8"},{"id":11807,"word":"\u179C\u17B6\u1791\u1793\u1780\u1798\u17D2\u1798"},{"id":11808,"word":"\u179C\u17B6\u1791\u17A2\u17B6\u1791\u17B7\u17CD"},{"id":11809,"word":"\u179C\u17B6\u1791\u17B7\u1780\u17B6"},{"id":11810,"word":"\u179C\u17B6\u1791\u17B7\u1793\u17B8"},{"id":11811,"word":"\u179C\u17B6\u1791\u17B8"},{"id":11812,"word":"\u179C\u17B6\u1791\u17D2\u1799\u1797\u178E\u17D2\u178C"},{"id":11813,"word":"\u179C\u17B6\u1793\u17CB"},{"id":11814,"word":"\u179C\u17B6\u1793\u17C8"},{"id":11815,"word":"\u179C\u17B6\u1793\u179A"},{"id":11816,"word":"\u179C\u17B6\u1793\u179A\u17B7\u1793\u17D2\u1791"},{"id":11817,"word":"\u179C\u17B6\u1793\u179A\u17B8"},{"id":11818,"word":"\u179C\u17B6\u1793\u179A\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":11819,"word":"\u179C\u17C9\u17B6\u1793\u17CB\u179F\u17CA\u17BB\u1799"},{"id":11820,"word":"\u179C\u17B6\u1794\u17CB"},{"id":11821,"word":"\u179C\u17C9\u17B6\u1794\u17CB"},{"id":11822,"word":"\u179C\u17B6\u1794\u17B8"},{"id":11823,"word":"\u179C\u17B6\u1798\u179B\u17BC\u179A"},{"id":11824,"word":"\u179C\u17B6\u1799"},{"id":11825,"word":"\u179C\u17B6\u1799\u1791\u178E\u17D2\u178C"},{"id":11826,"word":"\u179C\u17B6\u1799\u17BB"},{"id":11827,"word":"\u179C\u17B6\u1799\u17BB --"},{"id":11828,"word":"\u179C\u17B6\u1799\u17C4"},{"id":11829,"word":"\u179C\u17B6\u179A"},{"id":11830,"word":"\u179C\u17B6\u179A\u17C8"},{"id":11831,"word":"\u179C\u17B6\u179A\u1787\u17BE\u1784"},{"id":11832,"word":"\u179C\u17B6\u179A\u178E\u17C8"},{"id":11833,"word":"\u179C\u17B6\u179A\u179C\u179B\u17B6\u179F\u17B7\u1793\u17B8"},{"id":11834,"word":"\u179C\u17B6\u179A\u17B6\u178E\u179F\u17B8"},{"id":11835,"word":"\u179C\u17B6\u179A\u17B7"},{"id":11836,"word":"\u179C\u17B6\u179A\u17B7 --"},{"id":11837,"word":"\u179C\u17B6\u179A\u17BB\u178E\u17B8"},{"id":11838,"word":"\u179C\u17B6\u179A\u17C1\u178E\u179C\u17B6\u1780\u17D2\u1799"},{"id":11839,"word":"\u179C\u17C9\u17B6\u179A\u17C4\u1784"},{"id":11840,"word":"\u179C\u17B6\u179B"},{"id":11841,"word":"\u179C\u17B6\u179B\u17C8"},{"id":11842,"word":"\u179C\u17B6\u179B --"},{"id":11843,"word":"\u179C\u17B6\u179B\u17CB"},{"id":11844,"word":"\u179C\u17C9\u17B6\u179B\u17CB"},{"id":11845,"word":"\u179C\u17B6\u179B\u1798\u17B8\u1780\u17B7"},{"id":11846,"word":"\u179C\u17B6\u179B\u179C\u17B8\u1787\u1793\u17B8"},{"id":11847,"word":"\u179C\u17B6\u179B\u17B7\u1780\u17B6"},{"id":11848,"word":"\u179C\u17C9\u17B6\u179B\u17B7\u179F"},{"id":11849,"word":"\u179C\u17B6\u179B\u17BB\u1780\u1785\u17C1\u178F\u17B7\u1799"},{"id":11850,"word":"\u179C\u179B\u17BB\u1780\u17B6"},{"id":11851,"word":"\u179C\u17B6\u179B\u17D2\u1798\u17B8\u1780\u17C8"},{"id":11852,"word":"\u179C\u17B6\u179C"},{"id":11853,"word":"\u179C\u17B6\u179F"},{"id":11854,"word":"\u179C\u17C9\u17B6\u179F"},{"id":11855,"word":"\u179C\u17B6\u179F\u17CB"},{"id":11856,"word":"\u179C\u17B6\u179F\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":11857,"word":"\u179C\u17B6\u179F\u1793\u17B6"},{"id":11858,"word":"\u179C\u17B6\u179F\u179A"},{"id":11859,"word":"\u179C\u17B6\u179F\u179A\u179F\u1784\u17D2\u1782\u17C8"},{"id":11860,"word":"\u179C\u17B6\u179F\u179A\u179F\u1784\u17D2\u1782\u17B6\u1797\u17B7\u179C\u17B6\u1791"},{"id":11861,"word":"\u179C\u17B6\u179F\u179C\u17C8"},{"id":11862,"word":"\u179C\u17B6\u179F\u179C\u17B6\u1784"},{"id":11863,"word":"\u179C\u17B6\u179F\u17B6\u1782\u17B6\u179A"},{"id":11864,"word":"\u179C\u17B6\u179F\u17B7\u178F"},{"id":11865,"word":"\u179C\u17B6\u179F\u17BB\u1780\u17B8"},{"id":11866,"word":"\u179C\u17B6\u179F\u17BB\u1791\u17C1\u1796"},{"id":11867,"word":"\u179C\u17B6\u179F\u17BB\u179A\u17B6"},{"id":11868,"word":"\u179C\u17B6\u179F\u17D2\u1793\u17B6"},{"id":11869,"word":"\u179C\u17B6\u17A0\u1793\u17C8"},{"id":11870,"word":"\u179C\u17B6\u17A0\u1793\u179C\u17B7\u179F\u17C1\u179F"},{"id":11871,"word":"\u179C\u17B6\u17A0\u1793\u179F\u178F\u17D2\u179C"},{"id":11872,"word":"\u179C\u17B6\u17A0\u17B7\u1793\u17B8"},{"id":11873,"word":"\u179C\u17B6\u17A1\u1782\u17D2\u1782\u17B6\u17A0\u17B7\u1793\u17B8"},{"id":11874,"word":"\u179C\u17B6\u17A1\u1782\u17D2\u1782\u17B6\u17A0\u17B8"},{"id":11875,"word":"\u179C\u17B6\u17A1\u1798\u17D2\u179A\u17B9\u1782"},{"id":11876,"word":"\u179C\u17B6\u17A1\u179F\u178F\u17D2\u179C"},{"id":11877,"word":"\u179C\u17B7\u1780\u178F\u17B7"},{"id":11878,"word":"\u179C\u17B7\u1780\u178F\u17B7\u1780\u178F\u17D2\u178F\u17B6"},{"id":11879,"word":"\u179C\u17B7\u1780\u178F\u17B7\u1780\u1798\u17D2\u1798"},{"id":11880,"word":"\u179C\u17B7\u1780\u178F\u17B7\u1780\u17B6"},{"id":11881,"word":"\u179C\u17B7\u1780\u178F\u17B7\u1780\u17B6\u179F\u1793\u17C8"},{"id":11882,"word":"\u179C\u17B7\u1780\u178F\u17D2\u1790\u1793\u17C8"},{"id":11883,"word":"\u179C\u17B7\u1780\u1794\u17D2\u1794"},{"id":11884,"word":"\u179C\u17B7\u1780\u1794\u17D2\u1794\u179F\u1793\u17D2\u1792\u17B6\u1793"},{"id":11885,"word":"\u179C\u17B7\u1780\u179A"},{"id":11886,"word":"\u179C\u17B7\u1780\u179B"},{"id":11887,"word":"\u179C\u17B7\u1780\u179B\u17D2\u1799"},{"id":11888,"word":"\u179C\u17B7\u1780\u179F\u17B7\u178F"},{"id":11889,"word":"\u179C\u17B7\u1780\u17B6\u179A"},{"id":11890,"word":"\u179C\u17B7\u1780\u17B6\u179B"},{"id":11891,"word":"\u179C\u17B7\u1780\u17B6\u179F"},{"id":11892,"word":"\u179C\u17B7\u1780\u17D2\u1780\u1799\u1794\u178F\u17D2\u179A"},{"id":11893,"word":"\u179C\u17B7\u1780\u17D2\u1780\u1799\u179F\u17B6\u179B\u17B6"},{"id":11894,"word":"\u179C\u17B7\u1780\u17D2\u1780\u1799\u17B7\u1780"},{"id":11895,"word":"\u179C\u17B7\u1780\u17D2\u1780\u17B6\u1799\u17B7\u1780"},{"id":11896,"word":"\u179C\u17B7\u1780\u17D2\u1781\u17B7\u178F\u17D2\u178F\u1785\u17B7\u178F\u17D2\u178F"},{"id":11897,"word":"\u179C\u17B7\u1780\u17D2\u1781\u17C1\u1794"},{"id":11898,"word":"\u179C\u17B7\u1780\u17D2\u179A\u1798"},{"id":11899,"word":"\u179C\u17B7\u1780\u17D2\u179A\u1799\u1782\u17D2\u179A\u17B9\u17C7"},{"id":11900,"word":"\u179C\u17B7\u1780\u17D2\u179A\u1799\u17B6\u1782\u17B6\u179A"},{"id":11901,"word":"\u179C\u17B7\u1780\u17D2\u179A\u1799\u17B6\u1793\u17BB\u179F\u17D0\u1799"},{"id":11902,"word":"\u179C\u17B7\u1780\u17D2\u179A\u1799\u17B7\u1780"},{"id":11903,"word":"\u179C\u17B7\u1780\u17D2\u179A\u17B6\u1793\u17D2\u178F"},{"id":11904,"word":"\u179C\u17B7\u1780\u17D2\u179A\u17B6\u1799\u17B7\u1780"},{"id":11905,"word":"\u179C\u17B7\u1780\u17D2\u179A\u17B7\u1799\u17B6"},{"id":11906,"word":"\u179C\u17B7\u1780\u17D2\u179A\u17B8\u178C\u17B6"},{"id":11907,"word":"\u179C\u17B7\u1780\u17D2\u179A\u17C4\u179F"},{"id":11908,"word":"\u179C\u17B7\u1782\u17D2\u1782\u17A0"},{"id":11909,"word":"\u179C\u17B7\u1782\u17D2\u179A\u17C4\u17C7"},{"id":11910,"word":"\u179C\u17B7\u1783\u17B6\u178F\u1797\u17B6\u1796"},{"id":11911,"word":"\u179C\u17B7\u1783\u17B6\u179F\u17B6\u178F"},{"id":11912,"word":"\u179C\u17B7\u1783\u17B6\u179F\u17B6\u1791\u17B6"},{"id":11913,"word":"\u179C\u17B7\u1783\u17B6\u179F\u17B6\u17A0\u17B6\u179A"},{"id":11914,"word":"\u179C\u17B7\u1783\u17D2\u1793\u1797\u17B6\u1796"},{"id":11915,"word":"\u179C\u17B7\u1783\u17D2\u1793\u17C1\u179F"},{"id":11916,"word":"\u179C\u17B7\u1783\u17D2\u179A\u1797\u17B6\u1796"},{"id":11917,"word":"\u179C\u17B7\u1784\u179F\u17CA\u17BB\u1784"},{"id":11918,"word":"\u179C\u17B7\u1785"},{"id":11919,"word":"\u179C\u17B7\u1785\u17D7 "},{"id":11920,"word":"\u179C\u17B7\u1785\u1780\u17D2\u1781\u178E"},{"id":11921,"word":"\u179C\u17B7\u1785\u1780\u17D2\u1781\u17BB"},{"id":11922,"word":"\u179C\u17B7\u1785\u1793\u17D2\u1791\u17D2\u179A"},{"id":11923,"word":"\u179C\u17B7\u1785\u1799"},{"id":11924,"word":"\u179C\u17B7\u1785\u1799 --"},{"id":11925,"word":"\u179C\u17B7\u1785\u179B"},{"id":11926,"word":"\u179C\u17B7\u1785\u179B\u17B6\u1785\u179B"},{"id":11927,"word":"\u179C\u17B7\u1785\u17B6\u179A"},{"id":11928,"word":"\u179C\u17B7\u1785\u17B6\u179A\u1780\u17C8"},{"id":11929,"word":"\u179C\u17B7\u1785\u17B6\u179A\u178E\u17CD"},{"id":11930,"word":"\u179C\u17B7\u1785\u17B6\u179A\u178E\u1780\u1790\u17B6"},{"id":11931,"word":"\u179C\u17B7\u1785\u17B6\u179A\u178E\u1789\u17D2\u1789\u17B6 \u178E"},{"id":11932,"word":"\u179C\u17B7\u1785\u17B6\u179A\u17B7\u1780\u17B6"},{"id":11933,"word":"\u179C\u17B7\u1785\u17B7\u1780\u17B7\u1785\u17D2\u1786\u17B6"},{"id":11934,"word":"\u179C\u17B7\u1785\u17B7\u178F\u17D2\u179A"},{"id":11935,"word":"\u179C\u17B7\u1785\u17B7\u1793\u17D2\u178F\u17B6"},{"id":11936,"word":"\u179C\u17B7\u1785\u17C1\u1799\u17D2\u1799\u1791\u17B6\u1793"},{"id":11937,"word":"\u179C\u17B7\u1785\u17C1\u179F\u17D2\u178F\u1793"},{"id":11938,"word":"\u179C\u17B7\u1785\u17D2\u1786\u1793\u17D2\u1791\u1782\u17D2\u179A\u17B9\u17C7"},{"id":11939,"word":"\u179C\u17B7\u1785\u17D2\u1786\u17B6\u1799"},{"id":11940,"word":"\u179C\u17B7\u1785\u17D2\u1786\u17B6\u1799 --"},{"id":11941,"word":"\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17C8"},{"id":11942,"word":"\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u179A\u17B6\u179F\u17B8"},{"id":11943,"word":"\u179C\u17B7\u1785\u17D2\u1786\u17C1\u1791"},{"id":11944,"word":"\u179C\u17B7\u1785\u17D2\u1786\u17C1\u1791 --"},{"id":11945,"word":"\u179C\u17B7\u1787\u1793\u178A\u17D2\u178B\u17B6\u1793"},{"id":11946,"word":"\u179C\u17B7\u1787\u1799"},{"id":11947,"word":"\u179C\u17B7\u1787\u1799 --"},{"id":11948,"word":"\u179C\u17B7\u1787\u1799\u17B7\u1793"},{"id":11949,"word":"\u179C\u17B7\u1787\u1799\u17B7\u1793\u17B8"},{"id":11950,"word":"\u179C\u17B7\u1787\u1799\u17B8"},{"id":11951,"word":"\u179C\u17B7\u1787\u179B\u178A\u17D2\u178B\u17B6\u1793"},{"id":11952,"word":"\u179C\u17B7\u1787\u17B6\u178F"},{"id":11953,"word":"\u179C\u17B7\u1787\u17B6\u178F --"},{"id":11954,"word":"\u179C\u17B7\u1787\u17B6\u178F\u17B7"},{"id":11955,"word":"\u179C\u17B7\u1787\u17B6\u178F\u17B8\u1799"},{"id":11956,"word":"\u179C\u17B7\u1787\u17B7\u178F\u1798\u17B6\u179A"},{"id":11957,"word":"\u179C\u17B7\u1787\u17B7\u178F\u179A\u178A\u17D2\u178B"},{"id":11958,"word":"\u179C\u17B7\u1787\u17B7\u178F\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":11959,"word":"\u179C\u17B7\u1787\u17D2\u1787\u1798\u17B6\u1793"},{"id":11960,"word":"\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":11961,"word":"\u179C\u17B7\u1787\u17D2\u1787\u17B6 --"},{"id":11962,"word":"\u179C\u17B7\u1787\u17D2\u1787\u17BB"},{"id":11963,"word":"\u179C\u17B7\u1787\u17D2\u1787\u17BB\u178F\u17B6"},{"id":11964,"word":"\u179C\u17B7\u1787\u17D2\u1787\u17C4\u178F"},{"id":11965,"word":"\u179C\u17B7\u1789"},{"id":11966,"word":"\u179C\u17B7\u1789\u17D2\u1789\u178F\u17D2\u178F\u17B7"},{"id":11967,"word":"\u179C\u17B7\u1789\u17D2\u1789\u17B6\u178E"},{"id":11968,"word":"\u179C\u17B7\u1789\u17D2\u1789\u17B6\u178F\u1780\u1798\u17D2\u1798"},{"id":11969,"word":"\u179C\u17B7\u1789\u17D2\u1789\u17B6\u1794\u1793\u1794\u178F\u17D2\u179A"},{"id":11970,"word":"\u179C\u17B7\u1789\u17D2\u1789\u17B6\u1794\u1793\u17B8"},{"id":11971,"word":"\u179C\u17B7\u1789\u17D2\u1789\u17B6\u179F\u17B6"},{"id":11972,"word":"\u179C\u17B7\u1789\u17D2\u1789\u17BC"},{"id":11973,"word":"\u179C\u17B7\u178F\u1780\u17D2\u1780"},{"id":11974,"word":"\u179C\u17B7\u178F\u179F\u17D2\u178F\u17B7"},{"id":11975,"word":"\u179C\u17B7\u178F\u17D2\u178F\u17C8"},{"id":11976,"word":"\u179C\u17B7\u178F\u17D2\u1790\u17B6\u179A"},{"id":11977,"word":"\u179C\u17B7\u1791\u17D0\u1782\u17D2\u1792"},{"id":11978,"word":"\u179C\u17B7\u1791\u178F\u17D2\u1790\u17B7"},{"id":11979,"word":"\u179C\u17B7\u1791\u17BC"},{"id":11980,"word":"\u179C\u17B7\u1791\u17C1\u179F"},{"id":11981,"word":"\u179C\u17B7\u1791\u17C1\u179F\u17B7\u1780"},{"id":11982,"word":"\u179C\u17B7\u1791\u17C1\u179F\u17B7\u1780\u17B6"},{"id":11983,"word":"\u179C\u17B7\u1791\u17D2\u1791\u179F"},{"id":11984,"word":"\u179C\u17B7\u1791\u17D2\u1791\u17C1\u179F"},{"id":11985,"word":"\u179C\u17B7\u1791\u17D2\u1791\u17C1\u179F\u17B7\u1793\u17B8"},{"id":11986,"word":"\u179C\u17B7\u1791\u17D2\u1791\u17C1\u179F\u17B8"},{"id":11987,"word":"\u179C\u17B7\u1791\u17D2\u1792\u1784\u17D2\u179F\u1793\u17B6"},{"id":11988,"word":"\u179C\u17B7\u1791\u17D2\u1792\u1784\u17D2\u179F\u1793\u17B6\u1780\u17B6\u179A"},{"id":11989,"word":"\u179C\u17B7\u1791\u17D2\u1799\u17B6"},{"id":11990,"word":"\u179C\u17B7\u1791\u17D2\u1799\u17BB"},{"id":11991,"word":"\u179C\u17B7\u1791\u17D2\u1799\u17BB\u178F"},{"id":11992,"word":"\u179C\u17B7\u1791\u17D2\u1799\u17BB\u179B\u178F\u17B6"},{"id":11993,"word":"\u179C\u17B7\u1791\u17D2\u1799\u17C4\u178F"},{"id":11994,"word":"\u179C\u17B7\u1791\u17D2\u179A\u17BB\u1798"},{"id":11995,"word":"\u179C\u17B7\u1791\u17D2\u179C\u17B6"},{"id":11996,"word":"\u179C\u17B7\u1792\u179C\u17B6"},{"id":11997,"word":"\u179C\u17B7\u1792\u17B6"},{"id":11998,"word":"\u179C\u17B7\u1792\u17B6\u1793"},{"id":11999,"word":"\u179C\u17B7\u1792\u17B7"},{"id":12000,"word":"\u179C\u17B7\u1792\u17B8"},{"id":12001,"word":"\u179C\u17B7\u1792\u17BB\u179A"},{"id":12002,"word":"\u179C\u17B7\u1792\u17BB\u179A\u1797\u17B6\u1796"},{"id":12003,"word":"\u179C\u17B7\u1792\u17BC\u1794\u1780"},{"id":12004,"word":"\u179C\u17B7\u1792\u17BC\u1794\u1793\u1780\u1798\u17D2\u1798"},{"id":12005,"word":"\u179C\u17B7\u1792\u17BC\u1794\u17B7\u1780\u17B6"},{"id":12006,"word":"\u179C\u17B7\u1793\u1799"},{"id":12007,"word":"\u179C\u17B7\u1793\u1799 --"},{"id":12008,"word":"\u179C\u17B7\u1793\u17B6\u178C\u17B7\u1780\u17B6"},{"id":12009,"word":"\u179C\u17B7\u1793\u17B6\u1790"},{"id":12010,"word":"\u179C\u17B7\u1793\u17B6\u1790\u17B6"},{"id":12011,"word":"\u179C\u17B7\u1793\u17B6\u1799\u1780"},{"id":12012,"word":"\u179C\u17B7\u1793\u17B6\u1799\u17B7\u1780\u17B6"},{"id":12013,"word":"\u179C\u17B7\u1793\u17B6\u179F"},{"id":12014,"word":"\u179C\u17B7\u1793\u17B6\u179F\u1793\u17C8"},{"id":12015,"word":"\u179C\u17B7\u1793\u17B7\u1780\u17B6\u179A"},{"id":12016,"word":"\u179C\u17B7\u1793\u17B7\u1785\u17D2\u1786\u1799"},{"id":12017,"word":"\u179C\u17B7\u1793\u17B7\u1791\u17D2\u179A\u17B6"},{"id":12018,"word":"\u179C\u17B7\u1793\u17B7\u1794\u17B6\u178F"},{"id":12019,"word":"\u179C\u17B7\u1793\u17B7\u1794\u17B6\u178F\u17B7\u1780"},{"id":12020,"word":"\u179C\u17B7\u1793\u17B8\u178F"},{"id":12021,"word":"\u179C\u17B7\u1793\u17D2\u1791"},{"id":12022,"word":"\u179C\u17B7\u1793\u17D2\u1791\u17BB"},{"id":12023,"word":"\u179C\u17B7\u1794\u1780\u17D2\u1781"},{"id":12024,"word":"\u179C\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":12025,"word":"\u179C\u17B7\u1794\u17D0\u1791"},{"id":12026,"word":"\u179C\u17B7\u1794\u179A\u17B7\u178E\u17B6\u1798\u1792\u1798\u17CC"},{"id":12027,"word":"\u179C\u17B7\u1794\u179A\u17B7\u178F"},{"id":12028,"word":"\u179C\u17B7\u1794\u179A\u17B7\u1799\u17B6\u1799"},{"id":12029,"word":"\u179C\u17B7\u1794\u179A\u17B7\u1799\u17B6\u179F"},{"id":12030,"word":"\u179C\u17B7\u1794\u1799\u17CC\u17B6\u1799"},{"id":12031,"word":"\u179C\u17B7\u1794\u1799\u17CC\u17B6\u179F"},{"id":12032,"word":"\u179C\u17B7\u1794\u179B\u17D2\u179B\u17B6\u179F"},{"id":12033,"word":"\u179C\u17B7\u1794\u179F\u17D2\u1785\u17B7\u178F"},{"id":12034,"word":"\u179C\u17B7\u1794\u179F\u17D2\u179F\u1793\u17B6"},{"id":12035,"word":"\u179C\u17B7\u1794\u179F\u17D2\u179F\u17B7\u1793\u17B8"},{"id":12036,"word":"\u179C\u17B7\u1794\u17B6\u1780"},{"id":12037,"word":"\u179C\u17B7\u1794\u17B6\u1785\u1793\u1780\u1798\u17D2\u1798"},{"id":12038,"word":"\u179C\u17B7\u1794\u17BB\u179B"},{"id":12039,"word":"\u179C\u17B7\u1794\u17D2\u1794\u1780\u17B6\u179A"},{"id":12040,"word":"\u179C\u17B7\u1794\u17D2\u1794\u1780\u17B7\u178E\u17D2\u178E\u1797\u17B6\u1796"},{"id":12041,"word":"\u179C\u17B7\u1794\u17D2\u1794\u178A\u17B7\u179F\u17B6\u179A\u17C8"},{"id":12042,"word":"\u179C\u17B7\u1794\u17D2\u1794\u178A\u17B7\u179F\u17B6\u179A\u17B7\u1793\u17B8"},{"id":12043,"word":"\u179C\u17B7\u1794\u17D2\u1794\u178A\u17B7\u179F\u17B6\u179A\u17B8"},{"id":12044,"word":"\u179C\u17B7\u1794\u17D2\u1794\u1799\u17C4\u1782"},{"id":12045,"word":"\u179C\u17B7\u1794\u17D2\u1794\u179B\u17B6\u1794"},{"id":12046,"word":"\u179C\u17B7\u1794\u17D2\u1794\u179C\u17B6\u179F"},{"id":12047,"word":"\u179C\u17B7\u1794\u17D2\u179A\u1780\u17B6\u179A"},{"id":12048,"word":"\u179C\u17B7\u1794\u17D2\u179A\u1780\u17D2\u179A\u17B9\u178F\u17B7"},{"id":12049,"word":"\u179C\u17B7\u1794\u17D2\u179A\u1785\u17D2\u1786\u1793\u17D2\u1793"},{"id":12050,"word":"\u179C\u17B7\u1794\u17D2\u179A\u178F\u17B7\u1780\u17B6\u179A"},{"id":12051,"word":"\u179C\u17B7\u1794\u17D2\u179A\u178F\u17B7\u1794\u178F\u17D2\u178F\u17B7"},{"id":12052,"word":"\u179C\u17B7\u1794\u17D2\u179A\u178F\u17B7\u179F\u17B6\u179A\u17C8"},{"id":12053,"word":"\u179C\u17B7\u1794\u17D2\u179A\u1799\u17C4\u1782"},{"id":12054,"word":"\u179C\u17B7\u1794\u17D2\u179A\u179B\u17B6\u1794"},{"id":12055,"word":"\u179C\u17B7\u1794\u17D2\u179A\u179C\u17B6\u179F"},{"id":12056,"word":"\u179C\u17B7\u1796\u1793\u17D2\u1792\u179A\u17C4\u1782"},{"id":12057,"word":"\u179C\u17B7\u1796\u17BB\u1792"},{"id":12058,"word":"\u179C\u17B7\u1796\u17D2\u1797\u1793\u17D2\u178F"},{"id":12059,"word":"\u179C\u17B7\u1796\u17D2\u1797\u1793\u17D2\u178F\u1780"},{"id":12060,"word":"\u179C\u17B7\u1796\u17D2\u1797\u1793\u17D2\u178F\u17B7\u1780\u17B6"},{"id":12061,"word":"\u179C\u17B7\u1797\u1784\u17D2\u1782"},{"id":12062,"word":"\u179C\u17B7\u1797\u178F\u17D2\u178F\u17B7"},{"id":12063,"word":"\u179C\u17B7\u1797\u1796"},{"id":12064,"word":"\u179C\u17B7\u1797\u17B6"},{"id":12065,"word":"\u179C\u17B7\u1797\u17B6\u1780\u179A"},{"id":12066,"word":"\u179C\u17B7\u1797\u17B6\u1782"},{"id":12067,"word":"\u179C\u17B7\u1797\u17B6\u1782\u1791\u17B6\u1793"},{"id":12068,"word":"\u179C\u17B7\u1797\u17B6\u1787\u1780"},{"id":12069,"word":"\u179C\u17B7\u1797\u17B6\u1787\u17B7\u1780\u17B6"},{"id":12070,"word":"\u179C\u17B7\u1797\u17B6\u178F\u1780\u17B6\u179B"},{"id":12071,"word":"\u179C\u17B7\u1797\u17B6\u1796"},{"id":12072,"word":"\u179C\u17B7\u1797\u17B6\u179C\u179A\u17B8"},{"id":12073,"word":"\u179C\u17B7\u1797\u17B6\u179C\u17B7\u1793\u17B8"},{"id":12074,"word":"\u179C\u17B7\u1797\u17B6\u179C\u17B8"},{"id":12075,"word":"\u179C\u17B7\u1797\u17B8\u179F\u178E\u17C8"},{"id":12076,"word":"\u179C\u17B7\u1797\u17BC"},{"id":12077,"word":"\u179C\u17B7\u1797\u17BC\u179F\u1793\u17C8"},{"id":12078,"word":"\u179C\u17B7\u1797\u17BC\u179F\u17B6"},{"id":12079,"word":"\u179C\u17B7\u1797\u17BC\u179F\u17B7\u178F"},{"id":12080,"word":"\u179C\u17B7\u1798\u178F\u17B7"},{"id":12081,"word":"\u179C\u17B7\u1798\u179B"},{"id":12082,"word":"\u179C\u17B7\u1798\u179B\u17B6"},{"id":12083,"word":"\u179C\u17B7\u1798\u17B6\u1793"},{"id":12084,"word":"\u179C\u17B7\u1798\u17B6\u1793\u179C\u178F\u17D2\u1790\u17BB"},{"id":12085,"word":"\u179C\u17B7\u1798\u17B6\u1793\u17A2\u17B6\u1780\u17B6\u179F"},{"id":12086,"word":"\u179C\u17B7\u1798\u17BB\u178F\u17D2\u178F"},{"id":12087,"word":"\u179C\u17B7\u1798\u17BB\u178F\u17D2\u178F\u17B7"},{"id":12088,"word":"\u179C\u17B7\u1798\u17C4\u1780\u17D2\u1781"},{"id":12089,"word":"\u179C\u17B7\u1798\u17D2\u17A0\u1799\u17C8"},{"id":12090,"word":"\u179C\u17B7\u1799\u17C4\u1782"},{"id":12091,"word":"\u179C\u17B7\u179A\u178F\u17B7"},{"id":12092,"word":"\u179C\u17B7\u179A\u17B6\u1782"},{"id":12093,"word":"\u179C\u17B7\u179A\u17B6\u1796"},{"id":12094,"word":"\u179C\u17B7\u179A\u17B6\u1798"},{"id":12095,"word":"\u179C\u17B7\u179A\u17B6\u179B\u17D0\u1799"},{"id":12096,"word":"\u179C\u17B7\u179A\u17BB\u1791\u17D2\u1792"},{"id":12097,"word":"\u179C\u17B7\u179A\u17BB\u17A1\u17D2\u17A0\u17C8"},{"id":12098,"word":"\u179C\u17B7\u179A\u17BB\u17A1\u17D2\u17A0\u1780"},{"id":12099,"word":"\u179C\u17B7\u179A\u17BC\u1794"},{"id":12100,"word":"\u179C\u17B7\u179A\u17BC\u1794\u1780\u17D2\u1781"},{"id":12101,"word":"\u179C\u17B7\u179A\u17BC\u17A1\u17D2\u17A0\u1780"},{"id":12102,"word":"\u179C\u17B7\u179A\u17C1\u1785\u1793"},{"id":12103,"word":"\u179C\u17B7\u179A\u17C4\u1782\u1797\u17B6\u1796"},{"id":12104,"word":"\u179C\u17B7\u179A\u17C4\u1785\u1793\u17C8"},{"id":12105,"word":"\u179C\u17B7\u179A\u17C4\u1792"},{"id":12106,"word":"\u179C\u17B7\u179B"},{"id":12107,"word":"\u179C\u17B7\u179B !"},{"id":12108,"word":"\u179C\u17B7\u179B\u1798\u17BB\u1781"},{"id":12109,"word":"\u179C\u17B7\u179B\u17B6\u1794"},{"id":12110,"word":"\u179C\u17B7\u179B\u17B6\u179B\u17D0\u1799"},{"id":12111,"word":"\u179C\u17B7\u179B\u17B6\u179F"},{"id":12112,"word":"\u179C\u17B7\u179B\u17B6\u179F\u17B7\u1793\u17B8"},{"id":12113,"word":"\u179C\u17B7\u179B\u17B6\u179F\u17B8"},{"id":12114,"word":"\u179C\u17B7\u179B\u17B7\u1794\u17D2\u178F\u17B6"},{"id":12115,"word":"\u179C\u17B7\u179B\u17B8\u1793\u1792\u17B6\u178F\u17BB"},{"id":12116,"word":"\u179C\u17B7\u179B\u17BB\u1798\u17D2\u1794\u1780"},{"id":12117,"word":"\u179C\u17B7\u179B\u17C1\u1794\u1793\u17C8"},{"id":12118,"word":"\u179C\u17B7\u179B\u17C4\u1780\u1793\u17C8"},{"id":12119,"word":"\u179C\u17B7\u179B\u17C4\u1797\u1793\u17C8"},{"id":12120,"word":"\u179C\u17B7\u179C\u178A\u17D2\u178A"},{"id":12121,"word":"\u179C\u17B7\u179C\u178C\u17D2\u178D\u1793\u17C8"},{"id":12122,"word":"\u179C\u17B7\u179C\u179A\u178A\u17D2\u178B\u17B6\u1793"},{"id":12123,"word":"\u179C\u17B7\u179C\u179A\u178E\u17C8"},{"id":12124,"word":"\u179C\u17B7\u179C\u179A\u178E\u17B8\u1799\u17C8"},{"id":12125,"word":"\u179C\u17B7\u179C\u17B6\u1791"},{"id":12126,"word":"\u179C\u17B7\u179C\u17B6\u1791 --"},{"id":12127,"word":"\u179C\u17B7\u179C\u17B6\u17A0\u17C8"},{"id":12128,"word":"\u179C\u17B7\u179C\u17B6\u17A0\u1780\u17C5\u178F\u17BB\u1780"},{"id":12129,"word":"\u179C\u17B7\u179C\u17B7\u178F\u17D2\u178F"},{"id":12130,"word":"\u179C\u17B7\u179C\u17B7\u1792"},{"id":12131,"word":"\u179C\u17B7\u179C\u17C1\u1780"},{"id":12132,"word":"\u179C\u17B7\u179F\u1787\u17D2\u1787\u1793\u17B6"},{"id":12133,"word":"\u179C\u17B7\u179F\u1789\u17D2\u1789\u17B7\u1797\u17B6\u1796"},{"id":12134,"word":"\u179C\u17B7\u179F\u1791\u1796\u17D0\u178E\u17CC"},{"id":12135,"word":"\u179C\u17B7\u179F\u1791\u17B7\u179F"},{"id":12136,"word":"\u179C\u17B7\u179F\u1797\u17B6\u1782"},{"id":12137,"word":"\u179C\u17B7\u179F\u1798"},{"id":12138,"word":"\u179C\u17B7\u179F\u1798\u17B6\u1793\u1785\u17B7\u178F\u17D2\u178F"},{"id":12139,"word":"\u179C\u17B7\u179F\u1799"},{"id":12140,"word":"\u179C\u17B7\u179F\u1782\u17CC\u17C8"},{"id":12141,"word":"\u179C\u17B7\u179F\u17B6\u1781"},{"id":12142,"word":"\u179C\u17B7\u179F\u17B6\u1781\u1794\u17BC\u1787\u17B6"},{"id":12143,"word":"\u179C\u17B7\u179F\u17B6\u1781\u17B6"},{"id":12144,"word":"\u179C\u17B7\u179F\u17B6\u1791\u17B7\u179F"},{"id":12145,"word":"\u179C\u17B7\u179F\u17B6\u1798\u1789\u17D2\u1789"},{"id":12146,"word":"\u179C\u17B7\u179F\u17B6\u179A\u1791"},{"id":12147,"word":"\u179C\u17B7\u179F\u17B6\u179B"},{"id":12148,"word":"\u179C\u17B7\u179F\u17B7\u178A\u17D2\u178B"},{"id":12149,"word":"\u179C\u17B7\u179F\u17BB\u1791\u17D2\u1792"},{"id":12150,"word":"\u179C\u17B7\u179F\u17BB\u1791\u17D2\u1792\u17B7"},{"id":12151,"word":"\u179C\u17B7\u179F\u17BB\u1791\u17D2\u1792\u17B7\u1798\u1782\u17D2\u1782"},{"id":12152,"word":"\u179C\u17B7\u179F\u17BC\u1785\u17B7\u1780\u17B6"},{"id":12153,"word":"\u179C\u17B7\u179F\u17C1\u179F"},{"id":12154,"word":"\u179C\u17B7\u179F\u17C1\u179F\u1782\u17BB\u178E\u1793\u17B6\u1798"},{"id":12155,"word":"\u179C\u17B7\u179F\u17C1\u179F\u178F\u17D2\u1790\u179C\u17B6\u1785\u1780"},{"id":12156,"word":"\u179C\u17B7\u179F\u17C1\u179F\u1793"},{"id":12157,"word":"\u179C\u17B7\u179F\u17C1\u179F\u1793 \u179F\u1796\u17D2\u179C\u1793\u17B6\u1798"},{"id":12158,"word":"\u179C\u17B7\u179F\u17C4\u1792\u1793"},{"id":12159,"word":"\u179C\u17B7\u179F\u17D2\u178E\u17BB"},{"id":12160,"word":"\u179C\u17B7\u179F\u17D2\u1798\u17D0\u1799"},{"id":12161,"word":"\u179C\u17B7\u179F\u17D2\u179C\u1780\u179A"},{"id":12162,"word":"\u179C\u17B7\u179F\u17D2\u179C\u1793\u17B6\u1790"},{"id":12163,"word":"\u179C\u17B7\u179F\u17D2\u179C\u17B6\u1798\u17B7\u178F\u17D2\u179A"},{"id":12164,"word":"\u179C\u17B7\u179F\u17D2\u179C\u17B6\u179F\u1794\u17B6\u178F\u17D2\u179A"},{"id":12165,"word":"\u179C\u17B7\u179F\u17D2\u179F\u1780\u1798\u17D2\u1798"},{"id":12166,"word":"\u179C\u17B7\u179F\u17D2\u179F\u1798"},{"id":12167,"word":"\u179C\u17B7\u179F\u17D2\u179F\u17B6\u179F\u17C8"},{"id":12168,"word":"\u179C\u17B7\u179F\u17D2\u179F\u17B6\u179F\u17B7\u1780"},{"id":12169,"word":"\u179C\u17B7\u179F\u17D2\u179F\u17B6\u179F\u17B7\u1780\u17B6"},{"id":12170,"word":"\u179C\u17B7\u179F\u17D2\u179F\u17BB\u178F"},{"id":12171,"word":"\u179C\u17B7\u179F\u17D2\u179F\u17BB\u178F\u1793\u17B6\u1798"},{"id":12172,"word":"\u179C\u17B7\u17A0\u1782"},{"id":12173,"word":"\u179C\u17B7\u17A0\u1782 --"},{"id":12174,"word":"\u179C\u17B7\u17A0\u17B6"},{"id":12175,"word":"\u179C\u17B7\u17A0\u17B6\u179A"},{"id":12176,"word":"\u179C\u17B7\u17A0\u17B6\u179A\u17C8"},{"id":12177,"word":"\u179C\u17B7\u17A0\u17B6\u179A --"},{"id":12178,"word":"\u179C\u17B7\u17A0\u17B7\u1784\u17D2\u179F\u17B6"},{"id":12179,"word":"\u179C\u17B7\u17A0\u17C1\u179F\u1780\u1780\u1798\u17D2\u1798"},{"id":12180,"word":"\u179C\u17B7\u17A1\u17B6\u179A"},{"id":12181,"word":"\u179C\u17B7\u17C7"},{"id":12182,"word":"\u179C\u17B8"},{"id":12183,"word":"\u179C\u17C9\u17B8"},{"id":12184,"word":"\u179C\u17B8\u1787\u1793\u17B8"},{"id":12185,"word":"\u179C\u17B8\u178F"},{"id":12186,"word":"\u179C\u17B8\u178F\u17B6\u1798\u17B8\u1793"},{"id":12187,"word":"\u179C\u17B8\u178F\u17B7\u1780\u17D2\u1780\u1798"},{"id":12188,"word":"\u179C\u17B8\u1790\u17B7"},{"id":12189,"word":"\u179C\u17B8\u1798\u1784\u17D2\u179F\u17B6"},{"id":12190,"word":"\u179C\u17B8\u1798\u179C\u17B6\u1798"},{"id":12191,"word":"\u179C\u17B8\u1798\u179C\u17BE\u1798"},{"id":12192,"word":"\u179C\u17B8\u179A"},{"id":12193,"word":"\u179C\u17B8\u179A\u17B7\u1799"},{"id":12194,"word":"\u179C\u17B8\u179A\u17B7\u1799 --"},{"id":12195,"word":"\u179C\u17B8\u179C\u1780\u17CB"},{"id":12196,"word":"\u179C\u17B8\u179C\u179A"},{"id":12197,"word":"\u179C\u17B8\u179C\u17B6\u1785"},{"id":12198,"word":"\u179C\u17B8\u179C\u17C2\u1780"},{"id":12199,"word":"\u179C\u17B9\u1780"},{"id":12200,"word":"\u179C\u17B9\u1780\u179C\u179A"},{"id":12201,"word":"\u179C\u17B9\u1784"},{"id":12202,"word":"\u179C\u17B9\u178F"},{"id":12203,"word":"\u179C\u17B9\u1794"},{"id":12204,"word":"\u179C\u17B9\u179B"},{"id":12205,"word":"\u179C\u17B9\u179B !"},{"id":12206,"word":"\u179C\u17B7\u179B\u1798\u17BB\u1781"},{"id":12207,"word":"\u179C\u17B9\u17C7"},{"id":12208,"word":"\u179C\u17BA"},{"id":12209,"word":"\u179C\u17C9\u17BA\u1784"},{"id":12210,"word":"\u179C\u17C9\u17BA\u1784\u179C\u17C9\u17B6\u1784"},{"id":12211,"word":"\u179C\u17C9\u17BA\u178F\u17D7"},{"id":12212,"word":"\u179C\u17C9\u17BA\u1793\u179C\u17C9\u17B6\u1799"},{"id":12213,"word":"\u179C\u17BA\u1794\u17D7"},{"id":12214,"word":"\u179C\u17C9\u17BA\u1799"},{"id":12215,"word":"\u179C\u17C9\u17BA\u17C7"},{"id":12216,"word":"\u179C\u17BB\u178C\u17D2\u178D\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":12217,"word":"\u179C\u17BB\u178C\u17D2\u178D\u17B6\u1794\u1785\u17B6\u1799\u1793\u17C8"},{"id":12218,"word":"\u179C\u17BB\u178C\u17D2\u178D\u17B7"},{"id":12219,"word":"\u179C\u17BB\u178F\u17D2\u178F"},{"id":12220,"word":"\u179C\u17BB\u178F\u17D2\u178F\u1796\u17B8\u1787"},{"id":12221,"word":"\u179C\u17BB\u178F\u17D2\u178F\u17B7"},{"id":12222,"word":"\u179C\u17BB\u178F\u17D2\u178F\u17C4\u1791\u17D0\u1799"},{"id":12223,"word":"\u179C\u17BB\u1791\u17D2\u1792\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":12224,"word":"\u179C\u17BB\u1791\u17D2\u1792\u17B6\u1794\u1785\u17B6\u1799\u1793\u17C8"},{"id":12225,"word":"\u179C\u17BB\u1791\u17D2\u1792\u17B7\u179A\u17C4\u1782"},{"id":12226,"word":"\u179C\u17BB\u1793"},{"id":12227,"word":"\u179C\u17BB\u1793\u179C\u17C9\u17B6\u1799"},{"id":12228,"word":"\u179C\u17C9\u17BB\u179B"},{"id":12229,"word":"\u179C\u17BC"},{"id":12230,"word":"\u179C\u17C9\u17BC"},{"id":12231,"word":"\u179C\u17C9\u17BC\u1784"},{"id":12232,"word":"\u179C\u17C9\u17BC\u1784\u179C\u17C9\u17B6\u1784"},{"id":12233,"word":"\u179C\u17C9\u17BC\u178F"},{"id":12234,"word":"\u179C\u17BC\u1794"},{"id":12235,"word":"\u179C\u17C9\u17BC\u1794"},{"id":12236,"word":"\u179C\u17BC\u1794\u179F\u1793\u17D2\u178F"},{"id":12237,"word":"\u179C\u17BC\u1798"},{"id":12238,"word":"\u179C\u17BC\u1798\u179C\u17C8!"},{"id":12239,"word":"\u179C\u17C9\u17BC\u179F"},{"id":12240,"word":"\u179C\u17C9\u17BC\u179F\u179C\u17C9\u17B6\u179F"},{"id":12241,"word":"\u179C\u17BE\u1780"},{"id":12242,"word":"\u179C\u17BE\u1780\u17D7"},{"id":12243,"word":"\u179C\u17BE\u178F"},{"id":12244,"word":"\u179C\u17BE\u1798\u17D7"},{"id":12245,"word":"\u179C\u17C0\u1784"},{"id":12246,"word":"\u179C\u17C0\u1784\u1787\u17D0\u1799"},{"id":12247,"word":"\u179C\u17C0\u1785"},{"id":12248,"word":"\u179C\u17C0\u1793"},{"id":12249,"word":"\u179C\u17C0\u179A"},{"id":12250,"word":"\u179C\u17C0\u179B"},{"id":12251,"word":"\u179C\u17C0\u17C7"},{"id":12252,"word":"\u179C\u17C0\u17C7\u179C\u17C0\u1793"},{"id":12253,"word":"\u179C\u17C9\u17C1"},{"id":12254,"word":"\u179C\u17C1\u1782\u1796\u179B"},{"id":12255,"word":"\u179C\u17C1\u1782\u179F\u179A"},{"id":12256,"word":"\u179C\u17C1\u1782\u17B7\u1793\u17B8"},{"id":12257,"word":"\u179C\u17C1\u1782\u17B8"},{"id":12258,"word":"\u179C\u17C1\u1785"},{"id":12259,"word":"\u179C\u17C1\u1785\u17B6"},{"id":12260,"word":"\u179C\u17C1\u1785\u17D2\u1785"},{"id":12261,"word":"\u179C\u17C1\u1787\u1799\u17D0\u1793\u17D2\u178F"},{"id":12262,"word":"\u179C\u17C1\u1787\u17D2\u1787"},{"id":12263,"word":"\u179C\u17C1\u1789"},{"id":12264,"word":"\u179C\u17C1\u178B\u1793\u1796\u179F\u17D2\u178F\u17D2\u179A"},{"id":12265,"word":"\u179C\u17C1\u178C\u17B6"},{"id":12266,"word":"\u179C\u17C1\u178F\u17B6\u179B"},{"id":12267,"word":"\u179C\u17C1\u178F\u17B6\u17A1\u17B7\u1780"},{"id":12268,"word":"\u179C\u17C1\u1791"},{"id":12269,"word":"\u179C\u17C1\u1791 --"},{"id":12270,"word":"\u179C\u17C1\u1791\u1782\u17BC"},{"id":12271,"word":"\u179C\u17C1\u1791\u1793\u17B6"},{"id":12272,"word":"\u179C\u17C1\u1791\u1793\u17B6 --"},{"id":12273,"word":"\u179C\u17C1\u1791\u1793\u17D2\u178F"},{"id":12274,"word":"\u179C\u17C1\u1791\u17B6\u1784\u17D2\u1782"},{"id":12275,"word":"\u179C\u17C1\u1791\u17B6\u1793\u17D2\u178F"},{"id":12276,"word":"\u179C\u17C1\u1791\u17B7\u1780\u17B6"},{"id":12277,"word":"\u179C\u17C1\u1791\u17B7\u1793\u17B8"},{"id":12278,"word":"\u179C\u17C1\u1791\u17B8"},{"id":12279,"word":"\u179C\u17C1\u1792\u1780\u1798\u17D2\u1798"},{"id":12280,"word":"\u179C\u17C1\u1792\u17B8"},{"id":12281,"word":"\u179C\u17C1\u1793"},{"id":12282,"word":"\u179C\u17C1\u1793\u178F\u17C1\u1799\u17D2\u1799"},{"id":12283,"word":"\u179C\u17C1\u1793\u17C1\u1799\u17D2\u1799"},{"id":12284,"word":"\u179C\u17C1\u1794\u1785\u17B7\u178F\u17D2\u178F\u17B7"},{"id":12285,"word":"\u179C\u17C1\u1794\u17C1\u178F\u17B7\u1780"},{"id":12286,"word":"\u179C\u17C1\u1794\u17C1\u178F\u17B7\u1780\u17B6"},{"id":12287,"word":"\u179C\u17C1\u1798\u179C\u17BE\u1798"},{"id":12288,"word":"\u179C\u17C1\u1798\u17B6\u178F\u17B7\u1780"},{"id":12289,"word":"\u179C\u17C1\u1798\u17B6\u178F\u17B7\u1780\u17B6"},{"id":12290,"word":"\u179C\u17C1\u1798\u17B6\u1793\u17B7\u1780\u1794\u17D2\u179A\u17C1\u178F"},{"id":12291,"word":"\u179C\u17C1\u1798\u17B6\u1793\u17B7\u1780\u1794\u17D2\u179A\u17C1\u178F\u17B8"},{"id":12292,"word":"\u179C\u17C1\u1799\u17D2\u1799\u17B6\u1780\u179A\u178E\u17CD"},{"id":12293,"word":"\u179C\u17C1\u1799\u17D2\u1799\u17B6\u1780\u179A \u178E\u17B7\u1780"},{"id":12294,"word":"\u179C\u17C1\u1799\u17D2\u1799\u17B6\u1780\u179A \u178E\u17B7\u1780\u17B6"},{"id":12295,"word":"\u179C\u17C1\u1799\u17D2\u1799\u17B6\u179C\u1785\u17D2\u1785"},{"id":12296,"word":"\u179C\u17C1\u179A"},{"id":12297,"word":"\u179C\u17C1\u179A\u1794\u17D2\u1794\u178A\u17B7\u179C\u17C1\u179A"},{"id":12298,"word":"\u179C\u17C1\u179A\u1797\u17B6\u1796"},{"id":12299,"word":"\u179C\u17C1\u179A\u1798\u178E\u17B8"},{"id":12300,"word":"\u179C\u17C1\u179A\u1798\u17D2\u1797\u179C\u17B6\u178F"},{"id":12301,"word":"\u179C\u17C1\u179A\u179C\u17C1\u1782"},{"id":12302,"word":"\u179C\u17C1\u179A\u17B6"},{"id":12303,"word":"\u179C\u17C1\u179A\u17B7 --"},{"id":12304,"word":"\u179C\u17C1\u179A\u17B7\u1793\u17B8"},{"id":12305,"word":"\u179C\u17C1\u179A\u17B8"},{"id":12306,"word":"\u179C\u17C1\u179B\u17B6"},{"id":12307,"word":"\u179C\u17C9\u17C1\u179C"},{"id":12308,"word":"\u179C\u17C1\u179C\u1785\u1793\u17C8"},{"id":12309,"word":"\u179C\u17C9\u17C1\u179C\u179C\u17C9\u17B6\u179C"},{"id":12310,"word":"\u179C\u17C9\u17C1\u179F\u179C\u17C9\u179F"},{"id":12311,"word":"\u179C\u17C9\u17C1\u179F\u179C\u17C9\u17B6\u179F"},{"id":12312,"word":"\u179C\u17C9\u17C1\u179F\u179C\u17C9\u17BC\u179F"},{"id":12313,"word":"\u179C\u17C1\u179F\u17B6\u179B\u17B8"},{"id":12314,"word":"\u179C\u17C1\u179F\u17B7\u1799\u17B6"},{"id":12315,"word":"\u179C\u17C1\u179F\u17D2\u178F\u1793\u1796\u17D2\u179A\u179F\u17D2\u178F"},{"id":12316,"word":"\u179C\u17C1\u179F\u17D2\u1798\u17D0\u1793"},{"id":12317,"word":"\u179C\u17C1\u179F\u17D2\u179F\u17C8"},{"id":12318,"word":"\u179C\u17C1\u179F\u17D2\u179F\u1793\u17D2\u178F\u179A"},{"id":12319,"word":"\u179C\u17C1\u179F\u17D2\u179F\u1797\u17BC"},{"id":12320,"word":"\u179C\u17C1\u179F\u17D2\u179F\u179C\u17D0\u178E"},{"id":12321,"word":"\u179C\u17C1\u179F\u17D2\u179F\u17B6\u1793\u179A"},{"id":12322,"word":"\u179C\u17C1\u17A0\u17B6"},{"id":12323,"word":"\u179C\u17C1\u17A1\u17BB\u179C\u17D0\u1793"},{"id":12324,"word":"\u179C\u17C1\u17C7"},{"id":12325,"word":"\u179C\u17C1\u17C7\u179C\u17C0\u1793"},{"id":12326,"word":"\u179C\u17C2\u1780"},{"id":12327,"word":"\u179C\u17C2\u1780\u1785\u17C6\u17A0\u17C0\u1784"},{"id":12328,"word":"\u179C\u17C2\u1780\u17B1"},{"id":12329,"word":"\u179C\u17C2\u1784"},{"id":12330,"word":"\u179C\u17C9\u17C2\u178F"},{"id":12331,"word":"\u179C\u17C9\u17C2\u1793"},{"id":12332,"word":"\u179C\u17C9\u17C2\u1793\u178F\u17B6"},{"id":12333,"word":"\u179C\u17C9\u17C2\u1794\u17D7"},{"id":12334,"word":"\u179C\u17C3"},{"id":12335,"word":"\u179C\u17C3\u1780\u17D2\u179C\u17C2\u1793"},{"id":12336,"word":"\u179C\u17C9\u17C3"},{"id":12337,"word":"\u179C\u17C3\u178F\u17B6\u179B\u17B7\u1780"},{"id":12338,"word":"\u179C\u17C3\u1799\u179A\u17B6\u1796\u178E\u17CD"},{"id":12339,"word":"\u179C\u17C3\u1799\u17B6\u1780\u179A\u178E\u17CD"},{"id":12340,"word":"\u179C\u17C3\u179F\u17D2\u178E\u179C\u17C8"},{"id":12341,"word":"\u179C\u17C3\u179F\u17D2\u1799\u17C8"},{"id":12342,"word":"\u179C\u17C4 ! "},{"id":12343,"word":"\u179C\u17C4\u1780\u17B6\u179A"},{"id":12344,"word":"\u179C\u17C4\u178F"},{"id":12345,"word":"\u179C\u17C4\u1791\u17B6\u1793\u1780\u1798\u17D2\u1798"},{"id":12346,"word":"\u179C\u17C9\u17C4\u1794\u17D7"},{"id":12347,"word":"\u179C\u17C4\u179B\u17C4\u1780\u1793\u17C8"},{"id":12348,"word":"\u179C\u17C4\u17A0\u17B6\u179A"},{"id":12349,"word":"\u179C\u17C4\u17A0\u17B6\u179A\u17B7\u1793\u17B8"},{"id":12350,"word":"\u179C\u17C4\u17A0\u17B6\u179A\u17B8"},{"id":12351,"word":"\u179C\u17C4\u17A0\u17B6\u179A\u17BB\u1794\u1787\u17B8\u179C\u17B7\u1793\u17B8"},{"id":12352,"word":"\u179C\u17C4\u17A0\u17B6\u179A\u17BB\u1794\u1787\u17B8\u179C\u17B8"},{"id":12353,"word":"\u179C\u17C9\u17C5"},{"id":12354,"word":"\u179C\u17B6\u17C6\u1784"},{"id":12355,"word":"\u179C\u17B6\u17C6\u1784\u1787\u17B6"},{"id":12356,"word":"\u179C\u17B6\u17C6\u1784\u1793\u1793"},{"id":12357,"word":"\u179C\u17B6\u17C6\u1784\u1793\u17B6\u17C6"},{"id":12358,"word":"\u179C\u17C7"},{"id":12359,"word":"\u179C\u17D2\u17A0\u17B8"},{"id":12360,"word":"\u179C\u17D2\u17A0\u17BE\u1799"},{"id":12361,"word":"\u179C\u17D2\u17A0\u17C4\u17C7\u179C\u17D2\u17A0\u17BE\u1799"},{"id":12362,"word":"\u179F"},{"id":12363,"word":"\u179F\u1780"},{"id":12364,"word":"\u179F\u1780\u17CB"},{"id":12365,"word":"\u179F\u17CA\u1780"},{"id":12366,"word":"\u179F-\u1780"},{"id":12367,"word":"\u179F\u17D0\u1780"},{"id":12368,"word":"\u179F\u1780\u17CB\u1780\u17D0\u1793\u17D2\u178F"},{"id":12369,"word":"\u179F\u1780\u17CB\u1780\u1793\u17D2\u1791\u17BB\u1799"},{"id":12370,"word":"\u179F\u1780\u1780\u17B6\u179B"},{"id":12371,"word":"\u179F\u1780\u1789\u17C9\u1780"},{"id":12372,"word":"\u179F\u1780\u178A\u1798\u1782\u17D2\u1782"},{"id":12373,"word":"\u179F\u1780\u178A\u1798\u17B6\u1782\u17CC\u17B6"},{"id":12374,"word":"\u179F\u1780\u178A\u17D2\u178B\u17B6\u1793 \u1793\u17B6\u179F\u17B7\u1780\u1787\u17C8"},{"id":12375,"word":"\u179F\u1780\u178F\u17D2\u1790"},{"id":12376,"word":"\u179F\u1780\u1791\u17B6\u1782\u17B6\u1798\u17B7"},{"id":12377,"word":"\u179F\u1780\u1791\u17B6\u1782\u17B6\u1798\u17B7\u1793\u17B8"},{"id":12378,"word":"\u179F\u1780\u1791\u17B6\u1782\u17B6\u1798\u17B8"},{"id":12379,"word":"\u179F\u1780\u1793\u17B7\u179A\u17BB\u178F\u17D2\u178F\u17B7"},{"id":12380,"word":"\u179F\u1780\u1797\u17B6\u179F\u17B6"},{"id":12381,"word":"\u179F\u1780\u1798\u17C9\u17D2\u1789\u1780"},{"id":12382,"word":"\u179F\u1780\u1798\u17D2\u1798"},{"id":12383,"word":"\u179F\u1780\u1798\u17D2\u1798\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":12384,"word":"\u179F\u1780\u1798\u17D2\u1798\u1792\u17B6\u178F\u17BB"},{"id":12385,"word":"\u179F\u1780\u1798\u17D2\u1798\u1797\u17B6\u1796"},{"id":12386,"word":"\u179F\u1780\u1798\u17D2\u1798\u17B6\u1780\u1798\u17D2\u1798\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":12387,"word":"\u179F\u1780\u179A\u178E\u17B8\u1799"},{"id":12388,"word":"\u179F\u1780\u179A\u178E\u17B8\u1799\u17B6"},{"id":12389,"word":"\u179F\u1780\u179A\u17B6\u1787"},{"id":12390,"word":"\u179F\u1780\u179B"},{"id":12391,"word":"\u179F\u1780\u179C\u17B6\u1791\u17CD"},{"id":12392,"word":"\u179F\u1780\u179C\u17B6\u1791\u17B7\u17CD "},{"id":12393,"word":"\u179F\u1780\u179C\u17B6\u1791\u17B7\u1793\u17B8"},{"id":12394,"word":"\u179F\u1780\u179C\u17B6\u1791\u17B8"},{"id":12395,"word":"\u179F\u17CA\u1780\u179F\u17C0\u178F"},{"id":12396,"word":"\u179F\u1780\u17CB\u179F\u17C1\u17C7"},{"id":12397,"word":"\u179F\u1780\u17CB\u179F\u17D2\u179C\u17B6\u1799"},{"id":12398,"word":"\u179F\u1780\u17CB\u17A1\u1780\u17CB"},{"id":12399,"word":"\u179F\u1780\u17A2\u17C6\u1796\u17C5"},{"id":12400,"word":"\u179F\u1780\u17B6\u1799\u1791\u17B7\u178A\u17D2\u178B\u17B7"},{"id":12401,"word":"\u179F\u1780\u17B6\u1799\u1793\u17B7\u179A\u17BB\u178F\u17D2\u178F\u17B7"},{"id":12402,"word":"\u179F\u1780\u17BB\u178E\u1787\u17B6\u178F\u17B7"},{"id":12403,"word":"\u179F\u1780\u17BB\u178E\u178E\u17D2\u178C"},{"id":12404,"word":"\u179F\u1780\u17D2\u1780"},{"id":12405,"word":"\u179F\u1780\u17D2\u1780\u178A\u1797\u17B6\u179F\u17B6"},{"id":12406,"word":"\u179F\u1780\u17D2\u1780\u17B6\u179A"},{"id":12407,"word":"\u179F\u1780\u17D2\u1780\u17B6\u179A\u179F\u1798\u17D2\u1798\u17B6\u1793"},{"id":12408,"word":"\u179F\u1780\u17D2\u1781\u179A\u17B6"},{"id":12409,"word":"\u179F\u1780\u17D2\u1781\u17B8"},{"id":12410,"word":"\u179F\u1780\u17D2\u178F\u17B6"},{"id":12411,"word":"\u179F\u1780\u17D2\u178A\u17B7"},{"id":12412,"word":"\u179F\u17D0\u1780\u17D2\u178A\u17B7\u179F\u17B7\u1791\u17D2\u1792\u17B7"},{"id":12413,"word":"\u179F\u1780\u17D2\u1799"},{"id":12414,"word":"\u179F\u1780\u17D2\u1799 --"},{"id":12415,"word":"\u179F\u1780\u17D2\u179B\u17B6\u178F"},{"id":12416,"word":"\u179F\u1781\u17B7\u179B\u1797\u17B6\u179F"},{"id":12417,"word":"\u179F\u1781\u17B7\u179B\u1797\u17B6\u179F\u17B6"},{"id":12418,"word":"\u179F\u1781\u17B7\u179B\u1797\u17B6\u179F\u17B7\u1793\u17B8"},{"id":12419,"word":"\u179F\u1781\u17B7\u179B\u1797\u17B6\u179F\u17B8"},{"id":12420,"word":"\u179F\u1782\u17B6\u179A\u179C\u1780\u1790\u17B6"},{"id":12421,"word":"\u179F\u1782\u17BB\u178E"},{"id":12422,"word":"\u179F\u1782\u17C4\u178F\u17D2\u178F"},{"id":12423,"word":"\u179F\u1782\u17D2\u1782"},{"id":12424,"word":"\u179F\u1784"},{"id":12425,"word":"\u179F\u1784\u17CB"},{"id":12426,"word":"\u179F\u17CA\u1784"},{"id":12427,"word":"\u179F\u1784\u1781\u17B6\u1784"},{"id":12428,"word":"\u179F\u1784\u17CB\u1781\u17D2\u1799\u17B6"},{"id":12429,"word":"\u179F\u1784\u17CB\u1782\u17C4\u179B"},{"id":12430,"word":"\u179F\u1784\u17CB\u1787\u17D2\u179A\u17C4\u1784"},{"id":12431,"word":"\u179F\u1784\u17CB\u1791\u17B8\u1798\u17C9\u17C2\u178F\u17D2\u179A"},{"id":12432,"word":"\u179F\u1784\u17CB\u1791\u17D2\u179A\u1799\u17BB\u1784"},{"id":12433,"word":"\u179F\u1784\u17CB\u1795\u17D2\u1791\u17C7"},{"id":12434,"word":"\u179F\u1784\u179F\u17B9\u1780"},{"id":12435,"word":"\u179F\u1784\u17CB\u179F\u17BF"},{"id":12436,"word":"\u179F\u1784\u17C9\u17B6"},{"id":12437,"word":"\u179F\u1784\u17D2\u1780\u178F\u17CB"},{"id":12438,"word":"\u179F\u1784\u17D2\u1780\u178F\u17CB\u179F\u1784\u17D2\u1780\u17B7\u1793"},{"id":12439,"word":"\u179F\u1784\u17D2\u1780\u1790\u17B6"},{"id":12440,"word":"\u179F\u1784\u17D2\u1780\u1794\u17D2\u1794"},{"id":12441,"word":"\u179F\u1784\u17D2\u1780\u179A"},{"id":12442,"word":"\u179F\u1784\u17D2\u1780\u179B"},{"id":12443,"word":"\u179F\u1784\u17D2\u1780\u179B\u17CB"},{"id":12444,"word":"\u179F\u17D0\u1784\u17D2\u1780\u179F\u17B8"},{"id":12445,"word":"\u179F\u1784\u17D2\u1780\u17B6"},{"id":12446,"word":"\u179F\u1784\u17D2\u1780\u17B6\u178F\u17CB"},{"id":12447,"word":"\u179F\u1784\u17D2\u1780\u17B6\u179A"},{"id":12448,"word":"\u179F\u1784\u17D2\u1780\u17B6\u179A\u17B8"},{"id":12449,"word":"\u179F\u1784\u17D2\u1780\u17B6\u179F"},{"id":12450,"word":"\u179F\u1784\u17D2\u1780\u17B7\u178E\u17D2\u178E"},{"id":12451,"word":"\u179F\u1784\u17D2\u1780\u17B7\u1793"},{"id":12452,"word":"\u179F\u1784\u17D2\u1780\u17B7\u1798"},{"id":12453,"word":"\u179F\u1784\u17D2\u1780\u17B7\u179B\u17C1\u179F"},{"id":12454,"word":"\u179F\u1784\u17D2\u1780\u17B7\u179B\u17C1\u179F\u17B7\u1780"},{"id":12455,"word":"\u179F\u1784\u17D2\u1780\u17B9\u1798"},{"id":12456,"word":"\u179F\u1784\u17D2\u1780\u17BD\u178F"},{"id":12457,"word":"\u179F\u1784\u17D2\u1780\u17BE\u1785"},{"id":12458,"word":"\u179F\u1784\u17D2\u1780\u17BE\u179F\u1784\u17D2\u1780\u17B6\u1789\u17CB"},{"id":12459,"word":"\u179F\u1784\u17D2\u1780\u17C0\u178F"},{"id":12460,"word":"\u179F\u1784\u17D2\u1780\u17C0\u179A"},{"id":12461,"word":"\u179F\u1784\u17D2\u1780\u17C1\u178F"},{"id":12462,"word":"\u179F\u1784\u17D2\u1780\u17C2"},{"id":12463,"word":"\u179F\u1784\u17D2\u1780\u17C2\u1797\u17D2\u179B\u17BE\u1784"},{"id":12464,"word":"\u179F\u1784\u17D2\u1780\u17C4\u1785\u1793"},{"id":12465,"word":"\u179F\u1784\u17D2\u1780\u17C4\u1794"},{"id":12466,"word":"\u179F\u1784\u17D2\u1780\u17D2\u179A\u17B6\u1793\u17D2\u178F"},{"id":12467,"word":"\u179F\u17D0\u1784\u17D2\u1781"},{"id":12468,"word":"\u179F\u1784\u17D2\u1781\u1780\u17BB\u178A\u17D2\u178B\u17B7"},{"id":12469,"word":"\u179F\u1784\u17D2\u1781\u178F\u1792\u1798\u17CC"},{"id":12470,"word":"\u179F\u1784\u17D2\u1781\u17B6\u179A"},{"id":12471,"word":"\u179F\u1784\u17D2\u1781\u17B7\u178F\u17D2\u178F"},{"id":12472,"word":"\u179F\u1784\u17D2\u1781\u17BB\u1789"},{"id":12473,"word":"\u179F\u1784\u17D2\u1781\u17C1\u1794"},{"id":12474,"word":"\u179F\u1784\u17D2\u1781\u17C4\u1797"},{"id":12475,"word":"\u179F\u1784\u17D2\u1781\u17D2\u1799\u17B6"},{"id":12476,"word":"\u179F\u1784\u17D2\u1781\u17D2\u1799\u17B6\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":12477,"word":"\u179F\u1784\u17D2\u1782\u178F\u17B7"},{"id":12478,"word":"\u179F\u1784\u17D2\u1782\u1798"},{"id":12479,"word":"\u179F\u1784\u17D2\u1782\u1798\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A\u1793\u17B7\u1799\u1798"},{"id":12480,"word":"\u179F\u1784\u17D2\u1782\u17A0\u17C8"},{"id":12481,"word":"\u179F\u1784\u17D2\u1782\u17B6\u1799\u1793\u17B6"},{"id":12482,"word":"\u179F\u1784\u17D2\u1782\u17B6\u17A0\u1780"},{"id":12483,"word":"\u179F\u1784\u17D2\u1782\u17B8\u178F\u17B7"},{"id":12484,"word":"\u179F\u1784\u17D2\u1782\u17B8\u178F\u17B7\u1780"},{"id":12485,"word":"\u179F\u1784\u17D2\u1782\u17D2\u179A\u17B6\u1787"},{"id":12486,"word":"\u179F\u1784\u17D2\u1782\u17D2\u179A\u17B6\u1798"},{"id":12487,"word":"\u179F\u1784\u17D2\u1782\u17D2\u179A\u17BB\u1794"},{"id":12488,"word":"\u179F\u1784\u17D2\u1782\u17D2\u179A\u17C4\u17C7"},{"id":12489,"word":"\u179F\u1784\u17D2\u1782\u17D2\u179A\u17C7"},{"id":12490,"word":"\u179F\u1784\u17D2\u1783"},{"id":12491,"word":"\u179F\u1784\u17D2\u1783 --"},{"id":12492,"word":"\u179F\u1784\u17D2\u1783\u1780"},{"id":12493,"word":"\u179F\u1784\u17D2\u1783\u17D0\u179A"},{"id":12494,"word":"\u179F\u1784\u17D2\u1783\u179A\u17B6"},{"id":12495,"word":"\u179F\u1784\u17D2\u1783\u17B6"},{"id":12496,"word":"\u179F\u1784\u17D2\u1783\u17B6\u178A\u17B8"},{"id":12497,"word":"\u179F\u1784\u17D2\u1783\u17B6\u178F"},{"id":12498,"word":"\u179F\u1784\u17D2\u1783\u17B7\u1780"},{"id":12499,"word":"\u179F\u1784\u17D2\u1783\u17B9\u1780"},{"id":12500,"word":"\u179F\u1784\u17D2\u1783\u17B9\u1798"},{"id":12501,"word":"\u179F\u1784\u17D2\u1783\u17BB\u178A\u17D2\u178B\u179F\u1796\u17D2\u1791"},{"id":12502,"word":"\u179F\u1784\u17D2\u1783\u17D2\u179A\u17B6\u1787"},{"id":12503,"word":"\u179F\u1784\u17D2\u179A\u17BD\u1794\u179F\u1784\u17D2\u179A\u17BD\u1798"},{"id":12504,"word":"\u179F\u1784\u17D2\u179A\u17BD\u1798"},{"id":12505,"word":"\u179F\u1784\u17D2\u179A\u17C1\u1784"},{"id":12506,"word":"\u179F\u1784\u17D2\u179A\u17C2\u1780"},{"id":12507,"word":"\u179F\u1784\u17D2\u179A\u17C3"},{"id":12508,"word":"\u179F\u1784\u17D2\u179C\u179A"},{"id":12509,"word":"\u179F\u1784\u17D2\u179C\u17B6\u178F"},{"id":12510,"word":"\u179F\u1784\u17D2\u179C\u17B6\u179A"},{"id":12511,"word":"\u179F\u1784\u17D2\u179C\u17B6\u179F"},{"id":12512,"word":"\u179F\u1784\u17D2\u179C\u17B7\u178F"},{"id":12513,"word":"\u179F\u1784\u17D2\u179C\u17B7\u179B"},{"id":12514,"word":"\u179F\u1784\u17D2\u179C\u17C0\u1793"},{"id":12515,"word":"\u179F\u1784\u17D2\u179C\u17C1\u1782"},{"id":12516,"word":"\u179F\u1784\u17D2\u179C\u17C2\u1784"},{"id":12517,"word":"\u179F\u1784\u17D2\u179C\u17C4\u1799"},{"id":12518,"word":"\u179F\u1784\u17D2\u179F\u17D0\u1799"},{"id":12519,"word":"\u179F\u1784\u17D2\u179F\u17B6\u179A"},{"id":12520,"word":"\u179F\u1784\u17D2\u17A0\u179A"},{"id":12521,"word":"\u179F\u1784\u17D2\u17A0\u179A\u178E\u17CD"},{"id":12522,"word":"\u179F\u1784\u17D2\u17A0\u17B6"},{"id":12523,"word":"\u179F\u1784\u17D2\u17A0\u17B6\u179A"},{"id":12524,"word":"\u179F\u1784\u17D2\u17A0\u17B6\u179A\u17B7\u1798"},{"id":12525,"word":"\u179F\u1784\u17D2\u17A2\u1793\u17CB"},{"id":12526,"word":"\u179F\u1784\u17D2\u17A2\u17B6\u179A"},{"id":12527,"word":"\u179F\u1785\u17B7\u178F\u17D2\u178F\u1780\u17C8"},{"id":12528,"word":"\u179F\u1785\u17D2\u1785"},{"id":12529,"word":"\u179F\u1785\u17D2\u1785 --"},{"id":12530,"word":"\u179F\u1785\u17D2\u1785\u17B6"},{"id":12531,"word":"\u179F\u1785\u17D2\u1785\u17B6\u1792\u17B7\u178A\u17D2\u178B\u17B6\u1793"},{"id":12532,"word":"\u179F\u1785\u17D2\u1785\u17B6\u1794\u17D2\u179A\u178E\u17B7\u1792\u17B6\u1793"},{"id":12533,"word":"\u179F\u1785\u17D2\u1785\u17C6"},{"id":12534,"word":"\u179F\u1785\u17D2\u1786\u1793\u17D2\u1791"},{"id":12535,"word":"\u179F\u1785\u17D2\u1786\u17B7\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":12536,"word":"\u179F\u1787\u1793"},{"id":12537,"word":"\u179F\u1787\u17B8"},{"id":12538,"word":"\u179F\u1787\u17B8\u1796"},{"id":12539,"word":"\u179F\u1787\u17D2\u1788"},{"id":12540,"word":"\u179F\u1787\u17D2\u1788\u17B6\u1799\u1793\u1780\u1798\u17D2\u1798"},{"id":12541,"word":"\u179F\u1789\u17D2\u1785\u179A"},{"id":12542,"word":"\u179F\u1789\u17D2\u1785\u17B6\u179A"},{"id":12543,"word":"\u179F\u1789\u17D2\u1785\u17B6\u179A\u17B7\u1780\u17B6"},{"id":12544,"word":"\u179F\u1789\u17D2\u1787\u1794\u17CB"},{"id":12545,"word":"\u179F\u1789\u17D2\u1787\u17D0\u1799"},{"id":12546,"word":"\u179F\u1789\u17D2\u1787\u17B6\u178F"},{"id":12547,"word":"\u179F\u1789\u17D2\u1787\u17B6\u178F\u17B7"},{"id":12548,"word":"\u179F\u1789\u17D2\u1787\u17B8\u1796"},{"id":12549,"word":"\u179F\u1789\u17D2\u1787\u17B8\u179C\u17D0\u1793"},{"id":12550,"word":"\u179F\u1789\u17D2\u1787\u17B8\u179C\u1793\u1780\u1798\u17D2\u1798"},{"id":12551,"word":"\u179F\u1789\u17D2\u1787\u17B9\u1784"},{"id":12552,"word":"\u179F\u1789\u17D2\u1788\u17B6"},{"id":12553,"word":"\u179F\u1789\u17D2\u1789\u17B6"},{"id":12554,"word":"\u179F\u1789\u17D2\u1789\u17B6 --"},{"id":12555,"word":"\u179F\u1789\u17D2\u1789\u17B6\u178E"},{"id":12556,"word":"\u179F\u1789\u17D2\u1789\u17B8"},{"id":12557,"word":"\u179F\u1789\u17D2\u1789\u17C4\u1787\u1793"},{"id":12558,"word":"\u179F\u178A\u17B6\u1799\u17BB\u179F"},{"id":12559,"word":"\u179F\u178A\u17BC\u179C"},{"id":12560,"word":"\u179F\u178C\u17B6\u1784\u17D2\u1782"},{"id":12561,"word":"\u179F\u178E\u17D2\u178A"},{"id":12562,"word":"\u179F\u178E\u17D2\u178A\u1780"},{"id":12563,"word":"\u179F\u178E\u17D2\u178A\u1784\u17CB"},{"id":12564,"word":"\u179F\u178E\u17D2\u178A\u17B6"},{"id":12565,"word":"\u179F\u178E\u17D2\u178A\u17B6\u1793\u17CB"},{"id":12566,"word":"\u179F\u178E\u17D2\u178A\u17B6\u1794"},{"id":12567,"word":"\u179F\u178E\u17D2\u178A\u17B6\u1794\u17CB"},{"id":12568,"word":"\u179F\u178E\u17D2\u178A\u17B6\u1794\u17CB\u1792\u17D2\u1793\u17B6\u1794\u17CB"},{"id":12569,"word":"\u179F\u178E\u17D2\u178A\u17B6\u1799"},{"id":12570,"word":"\u179F\u178E\u17D2\u178A\u17BC\u1780"},{"id":12571,"word":"\u179F\u178E\u17D2\u178A\u17BC\u1793"},{"id":12572,"word":"\u179F\u178E\u17D2\u178A\u17C2\u1780"},{"id":12573,"word":"\u179F\u178E\u17D2\u178A\u17C2\u1780\u178A\u17B8"},{"id":12574,"word":"\u179F\u178E\u17D2\u178A\u17C4\u1784"},{"id":12575,"word":"\u179F\u178E\u17D2\u178A\u17C6"},{"id":12576,"word":"\u179F\u178E\u17D2\u178B\u17B6\u1782\u17B6\u179A"},{"id":12577,"word":"\u179F\u178E\u17D2\u178B\u17B6\u1793"},{"id":12578,"word":"\u179F\u178E\u17D2\u178B\u17B7\u178F"},{"id":12579,"word":"\u179F\u178E\u17D2\u178C\u1785\u17D2\u1786\u17B6\u1799\u1796\u17D2\u179A\u17B9\u1780\u17D2\u1799"},{"id":12580,"word":"\u179F\u178E\u17D2\u178C\u17B6\u179F"},{"id":12581,"word":"\u179F\u178E\u17D2\u17A0"},{"id":12582,"word":"\u179F\u178F"},{"id":12583,"word":"\u179F\u178F --"},{"id":12584,"word":"\u179F\u178F\u1793\u17B6\u1782\u1793\u17A0\u17BB\u178F"},{"id":12585,"word":"\u179F\u178F\u17B7"},{"id":12586,"word":"\u179F\u178F\u17B7 --"},{"id":12587,"word":"\u179F\u178F\u17B7\u1798"},{"id":12588,"word":"\u179F\u178F\u17C1\u1780\u17B7\u1785\u17D2\u1786\u17C8"},{"id":12589,"word":"\u179F\u178F\u17D2\u178F"},{"id":12590,"word":"\u179F\u178F\u17D2\u178F"},{"id":12591,"word":"\u179F\u178F\u17D2\u178F --"},{"id":12592,"word":"\u179F\u178F\u17D2\u178F --"},{"id":12593,"word":"\u179F\u178F\u17D2\u178F\u1794\u1784\u17D2\u1780\u17D0\u1787"},{"id":12594,"word":"\u179F\u178F\u17D2\u178F\u1794\u17BB\u179F\u17D2\u1794"},{"id":12595,"word":"\u179F\u178F\u17D2\u178F\u1794\u17BB\u179F\u17D2\u179F"},{"id":12596,"word":"\u179F\u178F\u17D2\u178F\u1794\u17D2\u1794\u1780\u179A\u178E\u17CD"},{"id":12597,"word":"\u179F\u178F\u17D2\u178F\u1794\u17D2\u1794\u1780\u179A\u178E\u17B6\u1797\u17B7\u1792\u1798\u17D2\u1798"},{"id":12598,"word":"\u179F\u178F\u17D2\u178F\u1798"},{"id":12599,"word":"\u179F\u178F\u17D2\u178F\u1798\u17A0\u17B6\u178B\u17B6\u1793"},{"id":12600,"word":"\u179F\u178F\u17D2\u178F\u1798\u17B8"},{"id":12601,"word":"\u179F\u178F\u17D2\u1799"},{"id":12602,"word":"\u179F\u178F\u17D2\u1799 --"},{"id":12603,"word":"\u179F\u178F\u17D2\u1799\u17B6"},{"id":12604,"word":"\u179F\u178F\u17D2\u179A\u17B6"},{"id":12605,"word":"\u179F\u178F\u17D2\u179A\u17B8"},{"id":12606,"word":"\u179F\u178F\u17D2\u179A\u17BC\u179C"},{"id":12607,"word":"\u179F\u178F\u17D2\u179C"},{"id":12608,"word":"\u179F\u178F\u17D2\u179C\u17B6"},{"id":12609,"word":"\u179F\u1790\u17BC\u1794"},{"id":12610,"word":"\u179F\u1791\u17B6\u1782\u178F\u17B7"},{"id":12611,"word":"\u179F\u1791\u17B6\u1791\u17B6\u1793"},{"id":12612,"word":"\u179F\u1791\u17B6\u1795\u179B"},{"id":12613,"word":"\u179F\u1791\u17B6\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":12614,"word":"\u179F\u1791\u17B6\u179A\u179F\u1793\u17D2\u178A\u17C4\u179F"},{"id":12615,"word":"\u179F\u1791\u17B7\u179F"},{"id":12616,"word":"\u179F\u1791\u17B7\u179F\u179F\u1789\u17D2\u1789\u17B6"},{"id":12617,"word":"\u179F\u1791\u17D2\u1791"},{"id":12618,"word":"\u179F\u1791\u17D2\u1791--"},{"id":12619,"word":"\u179F\u1791\u17D2\u1792\u1798\u17D2\u1798"},{"id":12620,"word":"\u179F\u1791\u17D2\u1792\u17B6"},{"id":12621,"word":"\u179F\u1791\u17D2\u1792\u17B6 --"},{"id":12622,"word":"\u179F\u1791\u17D2\u1792\u17B7\u179C\u17B7\u17A0\u17B6\u179A\u17B7\u1780"},{"id":12623,"word":"\u179F\u17CA\u1793"},{"id":12624,"word":"\u179F\u1793\u17D2\u178F\u178F\u17B7"},{"id":12625,"word":"\u179F\u1793\u17D2\u178A\u17B6\u1793"},{"id":12626,"word":"\u179F\u1793\u17D2\u178A\u17B6\u1794"},{"id":12627,"word":"\u179F\u1793\u17D2\u178F\u17B7"},{"id":12628,"word":"\u179F\u1793\u17D2\u178F\u17BB\u178A\u17D2\u178B\u17B8"},{"id":12629,"word":"\u179F\u1793\u17D2\u178A\u17C4\u179F"},{"id":12630,"word":"\u179F\u1793\u17D2\u1790\u178F"},{"id":12631,"word":"\u179F\u1793\u17D2\u1790\u179C\u17C8"},{"id":12632,"word":"\u179F\u1793\u17D2\u1790\u17B6\u1782\u17B6\u179A"},{"id":12633,"word":"\u179F\u1793\u17D2\u1791\u1793\u17B6 "},{"id":12634,"word":"\u179F\u1793\u17D2\u1791\u17B7\u178A\u17D2\u178B\u1798\u17B7\u178F\u17D2\u178F"},{"id":12635,"word":"\u179F\u1793\u17D2\u1791\u17B7\u178A\u17D2\u178B\u17B7\u1780"},{"id":12636,"word":"\u179F\u1793\u17D2\u1791\u17B7\u17C7"},{"id":12637,"word":"\u179F\u1793\u17D2\u1791\u17BB\u17C7"},{"id":12638,"word":"\u179F\u1793\u17D2\u1791\u17BC\u1784"},{"id":12639,"word":"\u179F\u1793\u17D2\u1791\u17BC\u1785"},{"id":12640,"word":"\u179F\u1793\u17D2\u1791\u17C1\u179F\u17A0\u17B6\u179A"},{"id":12641,"word":"\u179F\u1793\u17D2\u1791\u17C1\u179F\u17A0\u17B6\u179A\u17B7\u1793\u17B8"},{"id":12642,"word":"\u179F\u1793\u17D2\u1791\u17C1\u17A0"},{"id":12643,"word":"\u179F\u1793\u17D2\u1791\u17C1\u17C7"},{"id":12644,"word":"\u179F\u1793\u17D2\u1791\u17C3"},{"id":12645,"word":"\u179F\u1793\u17D2\u1791\u17C7"},{"id":12646,"word":"\u179F\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1796"},{"id":12647,"word":"\u179F\u1793\u17D2\u1792\u1794\u17CB"},{"id":12648,"word":"\u179F\u1793\u17D2\u1792\u179A"},{"id":12649,"word":"\u179F\u1793\u17D2\u1792\u17B6\u1793"},{"id":12650,"word":"\u179F\u1793\u17D2\u1792\u17B6\u1793\u17B8"},{"id":12651,"word":"\u179F\u1793\u17D2\u1792\u17B6\u1794\u17CB"},{"id":12652,"word":"\u179F\u1793\u17D2\u1792\u17B6\u179A\u178E\u17C8"},{"id":12653,"word":"\u179F\u1793\u17D2\u1792\u17B7"},{"id":12654,"word":"\u179F\u1793\u17D2\u1792\u17B7\u1794\u17D2\u179A\u1780\u17B6\u179F"},{"id":12655,"word":"\u179F\u1793\u17D2\u1792\u17B7\u1799\u17B6"},{"id":12656,"word":"\u179F\u1793\u17D2\u1792\u17B9\u1780"},{"id":12657,"word":"\u179F\u1793\u17D2\u1792\u17B9\u1780\u1795\u17D2\u1782\u179A\u1782\u17D2\u179A\u17B6\u17C6"},{"id":12658,"word":"\u179F\u1793\u17D2\u1792\u17B9\u1780\u179F\u1793\u17D2\u1792\u17C3"},{"id":12659,"word":"\u179F\u1793\u17D2\u1792\u17B9\u1784"},{"id":12660,"word":"\u179F\u1793\u17D2\u1792\u17C3"},{"id":12661,"word":"\u179F\u1793\u17D2\u1792\u17C4"},{"id":12662,"word":"\u179F\u1793\u17D2\u1792\u17C5"},{"id":12663,"word":"\u179F\u1793\u17D2\u1792\u17C6"},{"id":12664,"word":"\u179F\u1793\u17D2\u1792\u17D2\u1799\u17B6"},{"id":12665,"word":"\u179F\u1793\u17D2\u1793\u17B7\u1785\u17D2\u1785\u17D0\u1799"},{"id":12666,"word":"\u179F\u1793\u17D2\u1793\u17B7\u178A\u17D2\u178B\u17B6\u1793"},{"id":12667,"word":"\u179F\u1793\u17D2\u1793\u17B7\u1792\u17B7"},{"id":12668,"word":"\u179F\u1793\u17D2\u1793\u17B7\u1794\u17B6\u178F"},{"id":12669,"word":"\u179F\u1793\u17D2\u1793\u17B7\u1796\u1793\u17D2\u1792"},{"id":12670,"word":"\u179F\u1793\u17D2\u1793\u17B7\u1796\u1793\u17D2\u1792\u1793\u17CD"},{"id":12671,"word":"\u179F\u1793\u17D2\u1793\u17B7\u1797"},{"id":12672,"word":"\u179F\u1793\u17D2\u1793\u17B7\u179C\u17B6\u179F"},{"id":12673,"word":"\u179F\u1793\u17D2\u1793\u17B7\u179C\u17C1\u179F"},{"id":12674,"word":"\u179F\u1793\u17D2\u1793\u17B7\u179F\u17D0\u1791"},{"id":12675,"word":"\u179F\u1793\u17D2\u1793\u17B7\u179F\u17B8\u1791"},{"id":12676,"word":"\u179F\u1793\u17D2\u1798\u178F"},{"id":12677,"word":"\u179F\u1793\u17D2\u1798\u178F\u17B7"},{"id":12678,"word":"\u179F\u1793\u17D2\u1799\u17B6"},{"id":12679,"word":"\u179F\u1793\u17D2\u1799\u17B6\u179F\u1797\u17B6\u1796"},{"id":12680,"word":"\u179F\u1793\u17D2\u179B\u1784\u17CB"},{"id":12681,"word":"\u179F\u1793\u17D2\u179B\u1794\u17CB"},{"id":12682,"word":"\u179F\u1793\u17D2\u179B\u17B6\u1780\u17CB"},{"id":12683,"word":"\u179F\u1793\u17D2\u179B\u17B6\u1784"},{"id":12684,"word":"\u179F\u1793\u17D2\u179B\u17B7\u1793"},{"id":12685,"word":"\u179F\u1793\u17D2\u179B\u17B9\u1780"},{"id":12686,"word":"\u179F\u1793\u17D2\u179B\u17B9\u1784"},{"id":12687,"word":"\u179F\u1793\u17D2\u179B\u17B9\u1798"},{"id":12688,"word":"\u179F\u1793\u17D2\u179B\u17BB\u1784"},{"id":12689,"word":"\u179F\u1793\u17D2\u179F\u17B9\u1798"},{"id":12690,"word":"\u179F\u1793\u17D2\u179F\u17BE\u1798"},{"id":12691,"word":"\u179F\u1793\u17D2\u179F\u17C2"},{"id":12692,"word":"\u179F\u1793\u17D2\u179F\u17C6"},{"id":12693,"word":"\u179F\u1794"},{"id":12694,"word":"\u179F\u1794\u17CB"},{"id":12695,"word":"\u179F\u17CA\u1794\u17CB"},{"id":12696,"word":"\u179F\u1794\u178F\u17D2\u178F\u1787\u1793"},{"id":12697,"word":"\u179F\u1794\u1790"},{"id":12698,"word":"\u179F\u1794\u17CA\u17BC"},{"id":12699,"word":"\u179F\u1794\u17D2\u178F"},{"id":12700,"word":"\u179F\u1794\u17D2\u178F\u1794\u17D2\u179A\u1780\u179A\u178E\u17CD"},{"id":12701,"word":"\u179F\u1794\u17D2\u1794"},{"id":12702,"word":"\u179F\u1794\u17D2\u1794\u178A\u17B7\u1797\u17D0\u1799"},{"id":12703,"word":"\u179F\u1794\u17D2\u1794\u178A\u17B7\u1797\u17B6\u1782"},{"id":12704,"word":"\u179F\u1794\u17D2\u1794\u1792\u1793\u17CB"},{"id":12705,"word":"\u179F\u1794\u17D2\u1794\u17B6\u1799"},{"id":12706,"word":"\u179F\u1794\u17D2\u1794\u17B7"},{"id":12707,"word":"\u179F\u1794\u17D2\u1794\u17BB\u179A\u179F"},{"id":12708,"word":"\u179F\u1794\u17D2\u1794\u17BB\u179A\u17B7\u179F"},{"id":12709,"word":"\u179F\u1796"},{"id":12710,"word":"\u179F\u1796\u17D2\u1791"},{"id":12711,"word":"\u179F\u1796\u17D2\u179C"},{"id":12712,"word":"\u179F\u1796 --"},{"id":12713,"word":"\u179F\u1796\u17D2\u179C\u1793\u17B6\u1798"},{"id":12714,"word":"\u179F\u1796\u17D2\u179C\u1794\u17BE"},{"id":12715,"word":"\u179F\u1789\u17D2\u179C\u179C\u17BB\u1792"},{"id":12716,"word":"\u179F\u1796\u17D2\u1797\u17B7"},{"id":12717,"word":"\u179F\u1796\u17D2\u179A\u17A0\u17D2\u1798\u1785\u17B6\u179A\u17B7\u1793\u17B8"},{"id":12718,"word":"\u179F\u1796\u17D2\u179A\u17A0\u17D2\u1798\u1785\u17B6\u179A\u17B8"},{"id":12719,"word":"\u179F\u1797\u17B6"},{"id":12720,"word":"\u179F\u1797\u17B6 --"},{"id":12721,"word":"\u179F\u1797\u17B6\u1782"},{"id":12722,"word":"\u179F\u1797\u17B6\u1787\u1793"},{"id":12723,"word":"\u179F\u1797\u17B6\u1796"},{"id":12724,"word":"\u179F\u1797\u17B6\u179C\u17C8"},{"id":12725,"word":"\u179F\u1798"},{"id":12726,"word":"\u179F\u1798"},{"id":12727,"word":"\u179F\u1798"},{"id":12728,"word":"\u179F\u1798\u17C9"},{"id":12729,"word":"\u179F\u1798\u1782\u17D2\u1782"},{"id":12730,"word":"\u179F\u1798\u1787\u17D2\u1787"},{"id":12731,"word":"\u179F\u1798\u1787\u17D2\u1787\u17B6"},{"id":12732,"word":"\u179F\u1798\u1789\u17D2\u1789\u17B6"},{"id":12733,"word":"\u179F\u1798\u178E"},{"id":12734,"word":"\u179F\u1798\u178E --"},{"id":12735,"word":"\u179F\u1798\u178E\u1782\u17C4\u178F\u1798"},{"id":12736,"word":"\u179F\u1798\u178E\u179F\u1780\u17D2\u178A\u17B7"},{"id":12737,"word":"\u179F\u1798\u178E\u17B8"},{"id":12738,"word":"\u179F\u1798\u178E\u17BB\u178F\u17D2\u178F\u1798\u17B6\u1797\u17B7\u179F\u17C1\u1780"},{"id":12739,"word":"\u179F\u1798\u178E\u17BB\u1791\u17D2\u1791\u17C1\u179F"},{"id":12740,"word":"\u179F\u1798\u178E\u17C4\u1782\u17D2\u179A\u17BD"},{"id":12741,"word":"\u179F\u1798\u178F\u17D2\u1790"},{"id":12742,"word":"\u179F\u1798\u178F\u17D2\u1790 --"},{"id":12743,"word":"\u179F\u1798\u1790"},{"id":12744,"word":"\u179F\u1798\u1793\u17D2\u1792\u1780\u17B6\u179A"},{"id":12745,"word":"\u179F\u1798\u1796\u17D2\u179A\u1798\u178F\u17CB"},{"id":12746,"word":"\u179F\u1798\u1797\u17B6\u1796"},{"id":12747,"word":"\u179F\u1798\u1797\u17B7\u17A0\u17B6\u179A"},{"id":12748,"word":"\u179F\u1798\u17D0\u1799"},{"id":12749,"word":"\u179F\u1798\u179A"},{"id":12750,"word":"\u179F\u1798\u179C\u17B6\u1799"},{"id":12751,"word":"\u179F\u1798\u179F\u1789\u17D2\u1789\u17B6"},{"id":12752,"word":"\u179F\u1798\u179F\u17C2\u1798"},{"id":12753,"word":"\u179F\u1798\u17B6\u1782\u178F\u179A\u178A\u17D2\u178B"},{"id":12754,"word":"\u179F\u1798\u17B6\u1782\u1798"},{"id":12755,"word":"\u179F\u1798\u17B6\u1785\u17B6\u179A"},{"id":12756,"word":"\u179F\u1798\u17B6\u1787"},{"id":12757,"word":"\u179F\u1798\u17B6\u1787\u17B7\u1780"},{"id":12758,"word":"\u179F\u1798\u17B6\u1787\u17B7\u1780\u17B6"},{"id":12759,"word":"\u179F\u1798\u17B6\u1791\u17B6\u1793"},{"id":12760,"word":"\u179F\u1798\u17B6\u1792\u17B6\u1793"},{"id":12761,"word":"\u179F\u1798\u17B6\u1792\u17B7"},{"id":12762,"word":"\u179F\u1798\u17B6\u1793"},{"id":12763,"word":"\u179F\u1798\u17B6\u1794\u178F\u17D2\u178F\u17B7"},{"id":12764,"word":"\u179F\u1798\u17B6\u1799\u17C4\u1782"},{"id":12765,"word":"\u179F\u1798\u17B6\u179A\u1798\u17D2\u1797"},{"id":12766,"word":"\u179F\u1798\u17B6\u179F"},{"id":12767,"word":"\u179F\u1798\u17B6\u179F\u17D0\u1791"},{"id":12768,"word":"\u179F\u1798\u17B6\u17A0\u17B7\u178F\u1785\u17B7\u178F\u17D2\u178F"},{"id":12769,"word":"\u179F\u1798\u17B7\u178F"},{"id":12770,"word":"\u179F\u1798\u17B7\u178F\u17B7"},{"id":12771,"word":"\u179F\u1798\u17B7\u1791\u17D2\u1792"},{"id":12772,"word":"\u179F\u1798\u17B7\u1791\u17D2\u1792\u17B7"},{"id":12773,"word":"\u179F\u1798\u17B7\u1793\u17D2\u1792\u1793\u17CD"},{"id":12774,"word":"\u179F\u1798\u17BB\u1785\u17D2\u1785\u17D0\u1799"},{"id":12775,"word":"\u179F\u1798\u17BB\u1785\u17D2\u1786\u17C1\u1791"},{"id":12776,"word":"\u179F\u1798\u17BB\u1787\u17D2\u1787\u179B"},{"id":12777,"word":"\u179F\u1798\u17BB\u178A\u17D2\u178B\u17B6\u1793"},{"id":12778,"word":"\u179F\u1798\u17BB\u1791\u1799\u17C8"},{"id":12779,"word":"\u179F\u1798\u17BB\u1791\u17B6\u1785\u17B6\u179A"},{"id":12780,"word":"\u179F\u1798\u17BB\u1791\u17B6\u1799"},{"id":12781,"word":"\u179F\u1798\u17BB\u1791\u17D2\u1791"},{"id":12782,"word":"\u179F\u1798\u17BB\u17A0\u17CD"},{"id":12783,"word":"\u179F\u1798\u17BB\u17A0\u1794\u1789\u17D2\u1787\u17B8"},{"id":12784,"word":"\u179F\u1798\u17BC\u179C"},{"id":12785,"word":"\u179F\u1798\u17BC\u17A0"},{"id":12786,"word":"\u179F\u1798\u17C4\u1792\u17B6\u1793"},{"id":12787,"word":"\u179F\u1798\u17C4\u179F\u179A"},{"id":12788,"word":"\u179F\u1798\u17C4\u179F\u179A\u178E\u17C8"},{"id":12789,"word":"\u179F\u1798\u17D2\u1780\u1780"},{"id":12790,"word":"\u179F\u1798\u17D2\u1780\u17B6\u1780"},{"id":12791,"word":"\u179F\u1798\u17D2\u1780\u17BB\u1784"},{"id":12792,"word":"\u179F\u1798\u17D2\u1780\u17BB\u179B"},{"id":12793,"word":"\u179F\u1798\u17D2\u1780\u17BC\u1789"},{"id":12794,"word":"\u179F\u1798\u17D2\u1780\u17BC\u179C"},{"id":12795,"word":"\u179F\u1798\u17D2\u1782\u1798"},{"id":12796,"word":"\u179F\u1798\u17D2\u1782\u17B6\u179B\u17CB"},{"id":12797,"word":"\u179F\u1798\u17D2\u1782\u17BB\u179B"},{"id":12798,"word":"\u179F\u1798\u17D2\u1782\u17C4\u1780"},{"id":12799,"word":"\u179F\u1798\u17D2\u1782\u17B6\u17C6\u1784"},{"id":12800,"word":"\u179F\u1798\u17D2\u1784\u17B6\u1785"},{"id":12801,"word":"\u179F\u1798\u17D2\u1784\u17B6\u178F\u17CB"},{"id":12802,"word":"\u179F\u1798\u17D2\u1784\u17BE\u1785"},{"id":12803,"word":"\u179F\u1798\u17D2\u1784\u17C6"},{"id":12804,"word":"\u179F\u1798\u17D2\u1789\u17B6\u1789"},{"id":12805,"word":"\u179F\u1798\u17D2\u1789\u17C1\u1789"},{"id":12806,"word":"\u179F\u1798\u17D2\u1789\u17C2\u1784"},{"id":12807,"word":"\u179F\u1798\u17D2\u178A\u17B8"},{"id":12808,"word":"\u179F\u1798\u17D2\u178A\u17B9\u1784"},{"id":12809,"word":"\u179F\u1798\u17D2\u178A\u17BA\u178F"},{"id":12810,"word":"\u179F\u1798\u17D2\u178A\u17BE\u1784"},{"id":12811,"word":"\u179F\u1798\u17D2\u178A\u17C1\u1785"},{"id":12812,"word":"\u179F\u1798\u17D2\u178A\u17C1\u1787"},{"id":12813,"word":"\u179F\u1798\u17D2\u178A\u17C2\u1784"},{"id":12814,"word":"\u179F\u1798\u17D2\u178A\u17C4\u17C7"},{"id":12815,"word":"\u179F\u1798\u17D2\u178F\u178F"},{"id":12816,"word":"\u179F\u1798\u17D2\u178F\u17BB\u179B"},{"id":12817,"word":"\u179F\u1798\u17D2\u178F\u17C4\u1780"},{"id":12818,"word":"\u179F\u1798\u17D2\u1791\u1780\u17CB"},{"id":12819,"word":"\u179F\u1798\u17D2\u1791\u1784\u17CB"},{"id":12820,"word":"\u179F\u1798\u17D2\u1791\u179B"},{"id":12821,"word":"\u179F\u1798\u17D2\u1791\u17B6\u1789"},{"id":12822,"word":"\u179F\u1798\u17D2\u1791\u17B6\u1799"},{"id":12823,"word":"\u179F\u1798\u17D2\u1791\u17B6\u179A"},{"id":12824,"word":"\u179F\u1798\u17D2\u1791\u17B8\u1780"},{"id":12825,"word":"\u179F\u1798\u17D2\u1791\u17BB\u17C7"},{"id":12826,"word":"\u179F\u1798\u17D2\u1791\u17BB\u17C7\u1780\u17D2\u17A2\u17C2\u1780"},{"id":12827,"word":"\u179F\u1798\u17D2\u1791\u17BC\u1784"},{"id":12828,"word":"\u179F\u1798\u17D2\u1791\u17BE\u1789"},{"id":12829,"word":"\u179F\u1798\u17D2\u1791\u17C1\u17C7"},{"id":12830,"word":"\u179F\u1798\u17D2\u1791\u17C2\u179B"},{"id":12831,"word":"\u179F\u1798\u17D2\u1793\u17B6\u1780\u17CB"},{"id":12832,"word":"\u179F\u1798\u17D2\u1793\u17B6\u178A\u17C3"},{"id":12833,"word":"\u179F\u1798\u17D2\u1793\u17B6\u1798"},{"id":12834,"word":"\u179F\u1798\u17D2\u1794\u1780"},{"id":12835,"word":"\u179F\u1798\u17D2\u1794\u1787\u1789\u17D2\u1789\u17C8"},{"id":12836,"word":"\u179F\u1798\u17D2\u1794\u1787\u17B6\u1793 \u1798\u17BB\u179F\u17B6\u179C\u17B6\u1791"},{"id":12837,"word":"\u179F\u1798\u17D2\u1794\u178F\u17D2\u178F\u17B7"},{"id":12838,"word":"\u179F\u1798\u17D2\u1794\u1790"},{"id":12839,"word":"\u179F\u1798\u17D2\u1794\u17D0\u1791"},{"id":12840,"word":"\u179F\u1798\u17D2\u1794\u1791\u17B6\u1793"},{"id":12841,"word":"\u179F\u1798\u17D2\u1794\u1792\u17B6\u1793"},{"id":12842,"word":"\u179F\u1798\u17D2\u1794\u1799\u17BB\u178F\u17D2\u178F"},{"id":12843,"word":"\u179F\u1798\u17D2\u1794\u1799\u17C4\u1782"},{"id":12844,"word":"\u179F\u1798\u17D2\u1794\u179A\u17B6\u1799"},{"id":12845,"word":"\u179F\u1798\u17D2\u1794\u179A\u17B6\u1799\u17B7\u1780"},{"id":12846,"word":"\u179F\u1798\u17D2\u1794\u179A\u17B7 \u179C\u178F\u17D2\u178F\u1793\u17CD"},{"id":12847,"word":"\u179F\u1798\u17D2\u1794\u179F\u17B6\u1791"},{"id":12848,"word":"\u179F\u1798\u17D2\u1794\u17A0\u17B6\u179A"},{"id":12849,"word":"\u179F\u1798\u17D2\u1794\u17B6"},{"id":12850,"word":"\u179F\u1798\u17D2\u1794\u17B6\u1785\u17CB"},{"id":12851,"word":"\u179F\u1798\u17D2\u1794\u17B6\u179A"},{"id":12852,"word":"\u179F\u1798\u17D2\u1794\u17BB\u1780"},{"id":12853,"word":"\u179F\u1798\u17D2\u1794\u17BB\u1780\u1785\u17B6\u1794"},{"id":12854,"word":"\u179F\u1798\u17D2\u1794\u17BB\u1780\u1791\u17D2\u179A\u1799\u17BB\u1780"},{"id":12855,"word":"\u179F\u1798\u17D2\u1794\u17BB\u178A"},{"id":12856,"word":"\u179F\u1798\u17D2\u1794\u17BB\u179A"},{"id":12857,"word":"\u179F\u1798\u17D2\u1794\u17BB\u179A\u1790\u17D2\u1784\u17C3"},{"id":12858,"word":"\u179F\u1798\u17D2\u1794\u17BB\u179A\u179B\u17D2\u179C\u17C2\u1784"},{"id":12859,"word":"\u179F\u1798\u17D2\u1794\u17BB\u179A\u179F\u17D2\u1794\u17C2\u1780"},{"id":12860,"word":"\u179F\u1798\u17D2\u1794\u17BC\u1784\u179F\u1784\u17D2\u179A\u17BC\u1784"},{"id":12861,"word":"\u179F\u1798\u17D2\u1794\u17BC\u179A"},{"id":12862,"word":"\u179F\u1798\u17D2\u1794\u17BC\u178E\u17CC"},{"id":12863,"word":"\u179F\u1798\u17D2\u1794\u17BD\u179A"},{"id":12864,"word":"\u179F\u1798\u17D2\u1794\u17BE\u1798"},{"id":12865,"word":"\u179F\u1798\u17D2\u1794\u17C2\u1784"},{"id":12866,"word":"\u179F\u1798\u17D2\u1794\u17C4\u179A"},{"id":12867,"word":"\u179F\u1798\u17D2\u1795\u1794\u17D2\u1794\u179B\u17B6\u1794"},{"id":12868,"word":"\u179F\u1798\u17D2\u1795\u179F\u17D2\u179F"},{"id":12869,"word":"\u179F\u1798\u17D2\u1795\u17BB\u179B\u17D2\u179B"},{"id":12870,"word":"\u179F\u1798\u17D2\u1796\u1784\u17D2\u179F"},{"id":12871,"word":"\u179F\u1798\u17D2\u1796\u1785\u17D2\u1786\u179A\u17C8"},{"id":12872,"word":"\u179F\u1798\u17D2\u1796\u1793\u17D2\u1792"},{"id":12873,"word":"\u179F\u1798\u17D2\u1796\u1793\u17D2\u1792 --"},{"id":12874,"word":"\u179F\u1798\u17D2\u1796\u1793\u17D2\u1792\u17B7\u1793"},{"id":12875,"word":"\u179F\u1798\u17D2\u1796\u1793\u17D2\u1792\u17B7\u1793\u17B8"},{"id":12876,"word":"\u179F\u1798\u17D2\u1796\u179A"},{"id":12877,"word":"\u179F\u1798\u17D2\u1796\u179B"},{"id":12878,"word":"\u179F\u1798\u17D2\u1796\u179B\u17B8"},{"id":12879,"word":"\u179F\u1798\u17D2\u1796\u17B6\u1792"},{"id":12880,"word":"\u179F\u1798\u17D2\u1796\u17B6\u1792 --"},{"id":12881,"word":"\u179F\u1798\u17D2\u1796\u17B6\u1799"},{"id":12882,"word":"\u179F\u1798\u17D2\u1796\u17B6\u17A0\u1780"},{"id":12883,"word":"\u179F\u1798\u17D2\u1796\u17B6\u17A0\u1793\u1780\u1798\u17D2\u1798"},{"id":12884,"word":"\u179F\u1798\u17D2\u1796\u17B6\u17A0\u17B7\u1780\u17B6"},{"id":12885,"word":"\u179F\u1798\u17D2\u1796\u17B9\u1780"},{"id":12886,"word":"\u179F\u1798\u17D2\u1796\u17BB\u1791\u17D2\u1792"},{"id":12887,"word":"\u179F\u1798\u17D2\u1796\u17C0\u178F"},{"id":12888,"word":"\u179F\u1798\u17D2\u1796\u17C2\u17C7"},{"id":12889,"word":"\u179F\u1798\u17D2\u1796\u17C4\u1792"},{"id":12890,"word":"\u179F\u1798\u17D2\u1796\u17C4\u1792\u1793\u17C8"},{"id":12891,"word":"\u179F\u1798\u17D2\u1796\u17C4\u1792\u17B7"},{"id":12892,"word":"\u179F\u1798\u17D2\u1797\u178F\u17D2\u178F\u1798\u17B7\u178F\u17D2\u178F"},{"id":12893,"word":"\u179F\u1798\u17D2\u1797\u1796"},{"id":12894,"word":"\u179F\u1798\u17D2\u1797\u179C\u179A\u17B6\u1782"},{"id":12895,"word":"\u179F\u1798\u17D2\u1797\u179C\u17C1\u179F\u17B8"},{"id":12896,"word":"\u179F\u1798\u17D2\u1797\u17B6\u1796\u1793\u17CD"},{"id":12897,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179A"},{"id":12898,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179A \u1797\u17D2\u179B\u17B9\u1780"},{"id":12899,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179C\u1780\u1790\u17B6"},{"id":12900,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179C\u1793\u17C8"},{"id":12901,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179C\u179A\u17B6\u1782"},{"id":12902,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179C\u17B7\u178F"},{"id":12903,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179F"},{"id":12904,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179F\u17B6"},{"id":12905,"word":"\u179F\u1798\u17D2\u1797\u17B6\u179F\u17B7\u178F"},{"id":12906,"word":"\u179F\u1798\u17D2\u1797\u17B7\u178F"},{"id":12907,"word":"\u179F\u1798\u17D2\u1797\u17B7\u1793\u17D2\u1793"},{"id":12908,"word":"\u179F\u1798\u17D2\u1797\u17B8"},{"id":12909,"word":"\u179F\u1798\u17D2\u1797\u17BC\u178F\u17B7"},{"id":12910,"word":"\u179F\u1798\u17D2\u1797\u17C1\u1791"},{"id":12911,"word":"\u179F\u1798\u17D2\u1797\u17C4\u1782"},{"id":12912,"word":"\u179F\u1798\u17D2\u1797\u17C4\u1787"},{"id":12913,"word":"\u179F\u1798\u17D2\u1797\u17C4\u1791\u17D2\u1799"},{"id":12914,"word":"\u179F\u1798\u17D2\u1797\u17C4\u179A"},{"id":12915,"word":"\u179F\u1798\u17D2\u1798\u1787\u17D2\u1787\u1793"},{"id":12916,"word":"\u179F\u1798\u17D2\u1798\u1787\u17D2\u1787\u1793\u17B8"},{"id":12917,"word":"\u179F\u1798\u17D2\u1798\u178F"},{"id":12918,"word":"\u179F\u1798\u17D2\u1798\u178F\u17B7"},{"id":12919,"word":"\u179F\u1798\u17D2\u1798\u178F\u17B7 --"},{"id":12920,"word":"\u179F\u1798\u17D2\u1798\u178F\u17B7\u179B\u17B7\u1784\u17D2\u1782"},{"id":12921,"word":"\u179F\u1798\u17D2\u1798\u17B6"},{"id":12922,"word":"\u179F\u1798\u17D2\u1798\u17B6 --"},{"id":12923,"word":"\u179F\u1798\u17D2\u1798\u17B6\u1793"},{"id":12924,"word":"\u179F\u1798\u17D2\u1798\u17B6\u179F\u1798\u17D2\u1796\u17BB\u1791\u17D2\u1792"},{"id":12925,"word":"\u179F\u1798\u17D2\u1798\u17BB\u1781\u17B8\u1797\u17BC\u178F"},{"id":12926,"word":"\u179F\u1798\u17D2\u1798\u17C4\u1791\u1793\u1780\u1790\u17B6"},{"id":12927,"word":"\u179F\u1798\u17D2\u1798\u17C4\u1791\u1793\u17B8\u1799\u1780\u1790\u17B6"},{"id":12928,"word":"\u179F\u1798\u17D2\u179A\u1780"},{"id":12929,"word":"\u179F\u1798\u17D2\u179A\u1780\u17CB"},{"id":12930,"word":"\u179F\u1798\u17D2\u179A\u1784\u17CB"},{"id":12931,"word":"\u179F\u1798\u17D2\u179A\u1793\u17CB"},{"id":12932,"word":"\u179F\u1798\u17D2\u179A\u1794"},{"id":12933,"word":"\u179F\u1798\u17D2\u179A\u179F\u17CB"},{"id":12934,"word":"\u179F\u1798\u17D2\u179A\u17B6\u1780"},{"id":12935,"word":"\u179F\u1798\u17D2\u179A\u17B6\u1787"},{"id":12936,"word":"\u179F\u1798\u17D2\u179A\u17B6\u178F"},{"id":12937,"word":"\u179F\u1798\u17D2\u179A\u17B6\u1793\u17D2\u178F"},{"id":12938,"word":"\u179F\u1798\u17D2\u179A\u17B6\u1794\u17CB"},{"id":12939,"word":"\u179F\u1798\u17D2\u179A\u17B6\u1799"},{"id":12940,"word":"\u179F\u1798\u17D2\u179A\u17B6\u179B"},{"id":12941,"word":"\u179F\u1798\u17D2\u179A\u17B6\u179F\u17CB"},{"id":12942,"word":"\u179F\u1798\u17D2\u179A\u17B7\u178F"},{"id":12943,"word":"\u179F\u1798\u17D2\u179A\u17B7\u179B"},{"id":12944,"word":"\u179F\u1798\u17D2\u179A\u17B9\u1784"},{"id":12945,"word":"\u179F\u1798\u17D2\u179A\u17BB\u1780"},{"id":12946,"word":"\u179F\u1798\u17D2\u179A\u17BB\u1784"},{"id":12947,"word":"\u179F\u1798\u17D2\u179A\u17BB\u1789"},{"id":12948,"word":"\u179F\u1798\u17D2\u179A\u17BB\u178F"},{"id":12949,"word":"\u179F\u1798\u17D2\u179A\u17BB\u17C7"},{"id":12950,"word":"\u179F\u1798\u17D2\u179A\u17BB\u17C7\u179F\u1798\u17D2\u179A\u17BD\u179B"},{"id":12951,"word":"\u179F\u1798\u17D2\u179A\u17BC\u178F"},{"id":12952,"word":"\u179F\u1798\u17D2\u179A\u17BC\u1794"},{"id":12953,"word":"\u179F\u1798\u17D2\u179A\u17BD\u1785"},{"id":12954,"word":"\u179F\u1798\u17D2\u179A\u17BD\u178F"},{"id":12955,"word":"\u179F\u1798\u17D2\u179A\u17BD\u179B"},{"id":12956,"word":"\u179F\u1798\u17D2\u179A\u17BE\u1794"},{"id":12957,"word":"\u179F\u1798\u17D2\u179A\u17C1\u1780"},{"id":12958,"word":"\u179F\u1798\u17D2\u179A\u17C1\u1784"},{"id":12959,"word":"\u179F\u1798\u17D2\u179A\u17C1\u1785"},{"id":12960,"word":"\u179F\u1798\u17D2\u179A\u17C1\u17C7"},{"id":12961,"word":"\u179F\u1798\u17D2\u179A\u17C2\u1780"},{"id":12962,"word":"\u179F\u1798\u17D2\u179A\u17C2\u1780\u179F\u178F\u17D2\u179C"},{"id":12963,"word":"\u179F\u1798\u17D2\u179A\u17C2\u1784"},{"id":12964,"word":"\u179F\u1798\u17D2\u179A\u17C4\u1785"},{"id":12965,"word":"\u179F\u1798\u17D2\u179A\u17C4\u1794"},{"id":12966,"word":"\u179F\u1798\u17D2\u179A\u17C4\u17C7"},{"id":12967,"word":"\u179F\u1798\u17D2\u179A\u17B6\u17C6\u1784"},{"id":12968,"word":"\u179F\u1798\u17D2\u179B"},{"id":12969,"word":"\u179F\u1798\u17D2\u179B\u1780\u17CB"},{"id":12970,"word":"\u179F\u1798\u17D2\u179B\u1794"},{"id":12971,"word":"\u179F\u1798\u17D2\u179B\u17B6\u1780"},{"id":12972,"word":"\u179F\u1798\u17D2\u179B\u17B6\u1780\u17CB\u179F\u17C6\u1781\u17B6\u1793\u17CB"},{"id":12973,"word":"\u179F\u1798\u17D2\u179B\u17B6\u1789\u17CB"},{"id":12974,"word":"\u179F\u1798\u17D2\u179B\u17B6\u1794\u17CB"},{"id":12975,"word":"\u179F\u1798\u17D2\u179B\u17B6\u1794\u17CB \u1780\u1784\u17D2\u1780\u17C2\u1794"},{"id":12976,"word":"\u179F\u1798\u17D2\u179B\u17B7\u1785"},{"id":12977,"word":"\u179F\u1798\u17D2\u179B\u17B8"},{"id":12978,"word":"\u179F\u1798\u17D2\u179B\u17B9\u1784"},{"id":12979,"word":"\u179F\u1798\u17D2\u179B\u17BB\u1780"},{"id":12980,"word":"\u179F\u1798\u17D2\u179B\u17BB\u178F"},{"id":12981,"word":"\u179F\u1798\u17D2\u179B\u17BB\u1799"},{"id":12982,"word":"\u179F\u1798\u17D2\u179B\u17BC\u178F"},{"id":12983,"word":"\u179F\u1798\u17D2\u179B\u17BE\u178F"},{"id":12984,"word":"\u179F\u1798\u17D2\u179B\u17C1\u1780"},{"id":12985,"word":"\u179F\u1798\u17D2\u179B\u17C1\u1785"},{"id":12986,"word":"\u179F\u1798\u17D2\u179B\u17C2\u179C"},{"id":12987,"word":"\u179F\u1798\u17D2\u179B\u17C4\u1780"},{"id":12988,"word":"\u179F\u1798\u17D2\u17A2\u1780"},{"id":12989,"word":"\u179F\u1798\u17D2\u17A2\u1794\u17CB"},{"id":12990,"word":"\u179F\u1798\u17D2\u17A2\u1794\u17CB\u1796\u17BB\u178F"},{"id":12991,"word":"\u179F\u1798\u17D2\u17A2\u17B6\u1784"},{"id":12992,"word":"\u179F\u1798\u17D2\u17A2\u17B6\u178F"},{"id":12993,"word":"\u179F\u1798\u17D2\u17A2\u17B7\u178F"},{"id":12994,"word":"\u179F\u1798\u17D2\u17A2\u17BB\u1799"},{"id":12995,"word":"\u179F\u1798\u17D2\u17A2\u17C1\u1780"},{"id":12996,"word":"\u179F\u1798\u17D2\u17A2\u17C2\u179B"},{"id":12997,"word":"\u179F\u1799"},{"id":12998,"word":"\u179F\u17CA\u1799"},{"id":12999,"word":"\u179F\u1799\u1793\u17C8"},{"id":13000,"word":"\u179F\u1799\u1793 --"},{"id":13001,"word":"\u179F\u1799\u1798\u17D2\u1796\u179A\u17B6"},{"id":13002,"word":"\u179F\u1799\u1798\u17D2\u1797\u17BC"},{"id":13003,"word":"\u179F\u1799\u17B6\u179B\u17BB"},{"id":13004,"word":"\u179F\u1799\u17D2\u1799\u17B6"},{"id":13005,"word":"\u179F\u1799\u17D2\u1799\u17B6\u179F\u1793\u17CD"},{"id":13006,"word":"\u179F\u1799\u17BC\u179C"},{"id":13007,"word":"\u179F\u179A"},{"id":13008,"word":"\u179F\u179A\u17C8"},{"id":13009,"word":"\u179F\u1782\u17CC\u17C8"},{"id":13010,"word":"\u179F\u179A\u178E\u17C8"},{"id":13011,"word":"\u179F\u179A\u178E --"},{"id":13012,"word":"\u179F\u179A\u1791\u17C8"},{"id":13013,"word":"\u179F\u179A\u1791\u1780\u17B6\u179B"},{"id":13014,"word":"\u179F\u179A\u1796\u17B6\u1784\u17D2\u1782"},{"id":13015,"word":"\u179F\u179A\u1796\u17BE"},{"id":13016,"word":"\u179F\u179A\u1796\u17C1\u1787\u17D2\u1789"},{"id":13017,"word":"\u179F\u1796\u17CC\u1787\u17D2\u1789"},{"id":13018,"word":"\u179F\u1796\u17CC\u17B6\u1784\u17D2\u1782"},{"id":13019,"word":"\u179F\u1796\u17CC\u17C1\u1787\u17D2\u1789"},{"id":13020,"word":"\u179F\u179A\u1796\u17D2\u179A\u17C7"},{"id":13021,"word":"\u179F\u179A\u1797\u1789\u17D2\u1789"},{"id":13022,"word":"\u179F\u179A\u179F\u1793\u17CB"},{"id":13023,"word":"\u179F\u179A\u179F\u17BE\u179A"},{"id":13024,"word":"\u179F\u179A\u179F\u17C1\u179A"},{"id":13025,"word":"\u179F\u179A\u179F\u17C3"},{"id":13026,"word":"\u179F\u179A\u179F\u17D2\u179C\u17D0\u178F"},{"id":13027,"word":"\u179F\u179A\u17B7\u179B"},{"id":13028,"word":"\u179F\u179A\u17B8\u179A\u17C8"},{"id":13029,"word":"\u179F\u179A\u17B8\u179A --"},{"id":13030,"word":"\u179F\u179A\u17B8\u179A\u17B7\u1793"},{"id":13031,"word":"\u179F\u179A\u17B8\u179F\u17D2\u179A\u17B9\u1794"},{"id":13032,"word":"\u179F\u179A\u17BB\u1794"},{"id":13033,"word":"\u179F\u179A\u17C4\u1787"},{"id":13034,"word":"\u179F\u179B\u17CB"},{"id":13035,"word":"\u179F\u179B\u17CB\u179C\u17C9\u179B\u17CB"},{"id":13036,"word":"\u179F\u179B\u17B6\u1780"},{"id":13037,"word":"\u179F\u179B\u17B6\u178A\u17BB\u1795\u179B"},{"id":13038,"word":"\u179F\u179B\u17C0\u1784"},{"id":13039,"word":"\u179F\u179B\u17D2\u179B\u17B6\u1794"},{"id":13040,"word":"\u179F\u179C"},{"id":13041,"word":"\u179F\u179C\u1793\u17C8"},{"id":13042,"word":"\u179F\u179C\u1793 --"},{"id":13043,"word":"\u179F\u179C\u1793\u17B8\u1799\u17CD"},{"id":13044,"word":"\u179F\u179C\u1793\u17BC --"},{"id":13045,"word":"\u179F\u179C\u1793\u17D2\u178F\u17B8"},{"id":13046,"word":"\u179F\u179C\u17B7\u1789\u17D2\u1789\u17B6\u178E\u1780\u17C8"},{"id":13047,"word":"\u179F\u17CA\u179F\u1782\u17D2\u179A\u179B\u179F"},{"id":13048,"word":"\u179F\u179F\u179A"},{"id":13049,"word":"\u179F\u179F\u17B6\u1784\u17D2\u1780"},{"id":13050,"word":"\u179F\u179F\u17B7"},{"id":13051,"word":"\u179F\u179F\u17B7\u178F"},{"id":13052,"word":"\u179F\u179F\u17B7\u1793"},{"id":13053,"word":"\u179F\u179F\u17B9\u1780"},{"id":13054,"word":"\u179F\u179F\u17BB\u1780 \u1798\u1798\u17C9\u17BB\u1780"},{"id":13055,"word":"\u179F\u179F\u17BB\u179A\u17C8"},{"id":13056,"word":"\u179F\u179F\u17BB\u179B"},{"id":13057,"word":"\u179F\u179F\u17BC\u179B"},{"id":13058,"word":"\u179F\u179F\u17C0\u179A"},{"id":13059,"word":"\u179F\u179F\u17C1\u17C7"},{"id":13060,"word":"\u179F\u179F\u17C4\u17C7"},{"id":13061,"word":"\u179F\u179F\u17C4\u17C7\u17A2\u1793\u17D2\u1791\u1784"},{"id":13062,"word":"\u179F\u179F\u17D2\u178F\u17D2\u179A"},{"id":13063,"word":"\u179F\u179F\u17D2\u178F\u17D2\u179A --"},{"id":13064,"word":"\u179F\u179F\u17D2\u178F\u17D2\u179A\u17B6"},{"id":13065,"word":"\u179F\u179F\u17D2\u179A\u17B6\u1780\u17CB"},{"id":13066,"word":"\u179F\u179F\u17D2\u179A\u17B6\u1789\u17CB"},{"id":13067,"word":"\u179F\u179F\u17D2\u179A\u17CA\u17B6\u179F"},{"id":13068,"word":"\u179F\u179F\u17D2\u179A\u17B7\u1780"},{"id":13069,"word":"\u179F\u179F\u17D2\u179A\u17B7\u1785"},{"id":13070,"word":"\u179F\u179F\u17D2\u179A\u17B7\u1794"},{"id":13071,"word":"\u179F\u179F\u17D2\u179A\u17CA\u200C\u17B9\u1784"},{"id":13072,"word":"\u179F\u179F\u17D2\u179A\u17B9\u1794"},{"id":13073,"word":"\u179F\u179F\u17D2\u179A\u17CA\u200C\u17B9\u1794"},{"id":13074,"word":"\u179F\u179F\u17CA\u17D2\u179A\u200C\u17B9\u1798"},{"id":13075,"word":"\u179F\u179F\u17D2\u179A\u17CA\u17BB\u1785"},{"id":13076,"word":"\u179F\u179F\u17D2\u179A\u17CA\u17BB\u1794"},{"id":13077,"word":"\u179F\u179F\u17D2\u179A\u17BC\u179F"},{"id":13078,"word":"\u179F\u179F\u17D2\u179A\u17BC\u17C7"},{"id":13079,"word":"\u179F\u179F\u17D2\u179A\u17BD\u1789"},{"id":13080,"word":"\u179F\u179F\u17D2\u179A\u17C1\u1780\u179F\u179F\u17D2\u179A\u17B6\u1780"},{"id":13081,"word":"\u179F\u179F\u17D2\u179A\u17C4\u1780"},{"id":13082,"word":"\u179F\u179F\u17D2\u179A\u17B6\u17C6"},{"id":13083,"word":"\u179F\u179F\u17D2\u179B\u1780\u17CB"},{"id":13084,"word":"\u179F\u179F\u17D2\u179B\u1793\u17CB\u179F\u179F\u17D2\u179B\u17C4"},{"id":13085,"word":"\u179F\u179F\u17D2\u179B\u17BE\u178F"},{"id":13086,"word":"\u179F\u179F\u17D2\u179B\u17BE\u178F\u179F\u179F\u17D2\u179B\u1780\u17CB"},{"id":13087,"word":"\u179F\u179F\u17D2\u179B\u17C4"},{"id":13088,"word":"\u179F\u179F\u17D2\u179F"},{"id":13089,"word":"\u179F\u179F\u17D2\u179F\u17BB"},{"id":13090,"word":"\u179F\u17A0"},{"id":13091,"word":"\u179F\u17A0 --"},{"id":13092,"word":"\u179F\u17A0\u17D0\u179F"},{"id":13093,"word":"\u179F\u17A0\u179F\u17B6"},{"id":13094,"word":"\u179F\u17A0\u179F\u17D2\u179F"},{"id":13095,"word":"\u179F\u17A0\u179F\u17D2\u179F --"},{"id":13096,"word":"\u179F\u17A0\u17B6 --"},{"id":13097,"word":"\u179F\u17A0\u17B6\u1799"},{"id":13098,"word":"\u179F\u17A0\u17B6\u1799\u17B7\u1780\u17B6"},{"id":13099,"word":"\u179F\u17A0\u17B6\u179A"},{"id":13100,"word":"\u179F\u17A0\u17B7\u1785 \u179F\u17A0\u17B6\u179A"},{"id":13101,"word":"\u179F\u17A0\u17C4\u1791\u179A"},{"id":13102,"word":"\u179F\u17B6"},{"id":13103,"word":"\u179F\u17B6\u1780"},{"id":13104,"word":"\u179F\u17B6\u1780\u17CB"},{"id":13105,"word":"\u179F\u17B6\u1780 --"},{"id":13106,"word":"\u179F\u17B6\u1780\u17C8"},{"id":13107,"word":"\u179F\u17B6\u1780\u1785\u17D2\u1786\u17B6"},{"id":13108,"word":"\u179F\u17B6\u1780\u178F\u17D2\u179A\u17B6\u1780"},{"id":13109,"word":"\u179F\u17B6\u1780\u1793\u17D2\u1791\u17C1\u179B"},{"id":13110,"word":"\u179F\u17B6\u1780\u17CB\u1794\u17BE"},{"id":13111,"word":"\u179F\u17B6\u1780\u1794\u17C9\u178F\u17D2\u179A\u17B6\u1780"},{"id":13112,"word":"\u179F\u17B6\u1780\u1798\u17C9\u17D2\u1789\u17B6\u1780"},{"id":13113,"word":"\u179F\u17B6\u1780\u179B"},{"id":13114,"word":"\u179F\u17B6\u1780\u179F\u1796"},{"id":13115,"word":"\u179F\u17B6\u1780\u179F\u17BD\u179A"},{"id":13116,"word":"\u179F\u17B6\u1780\u17B7\u1799\u17C8"},{"id":13117,"word":"\u179F\u17B6\u1780\u17B7\u1799\u17B6\u1793\u17B8"},{"id":13118,"word":"\u179F\u17B6\u1780\u17BB\u178E\u17B7\u1780"},{"id":13119,"word":"\u179F\u17B6\u1780\u17C1"},{"id":13120,"word":"\u179F\u17B6\u1780\u17D2\u1799"},{"id":13121,"word":"\u179F\u17B6\u1780\u17D2\u179F\u17B8"},{"id":13122,"word":"\u179F\u17B6\u1781\u17B6"},{"id":13123,"word":"\u179F\u17B6\u1782\u179A"},{"id":13124,"word":"\u179F\u17B6\u1782\u179A\u179C\u17B7\u1791\u17D2\u1799\u17B6"},{"id":13125,"word":"\u179F\u17B6\u1782\u17BC"},{"id":13126,"word":"\u179F\u17B6\u1782\u17BC\u179A\u1793\u17B6\u1798"},{"id":13127,"word":"\u179F\u17B6\u1784"},{"id":13128,"word":"\u179F\u17B6\u1784\u1789\u17C9\u17B6\u1784"},{"id":13129,"word":"\u179F\u17B6\u1785"},{"id":13130,"word":"\u179F\u17B6\u1785\u17CB"},{"id":13131,"word":"\u179F\u17B6\u1785\u17CB\u1787\u17BC\u179A"},{"id":13132,"word":"\u179F\u17B6\u1787\u17B8"},{"id":13133,"word":"\u179F\u17B6\u1787\u17BC\u179A"},{"id":13134,"word":"\u179F\u17B6\u1789"},{"id":13135,"word":"\u179F\u17B6\u1789\u17D2\u1787\u1793\u179F\u178F\u17D2\u179C"},{"id":13136,"word":"\u179F\u17B6\u178A\u1780"},{"id":13137,"word":"\u179F\u17B6\u178A\u17B6\u1793"},{"id":13138,"word":"\u179F\u17B6\u178A\u17C0\u179C"},{"id":13139,"word":"\u179F\u17B6\u178E"},{"id":13140,"word":"\u179F\u17B6\u178E\u1796\u179F\u17D2\u178F\u17D2\u179A"},{"id":13141,"word":"\u179F\u17B6\u178E\u17B7"},{"id":13142,"word":"\u179F\u17B6\u178E\u17B7\u1799\u17B6"},{"id":13143,"word":"\u179F\u17B6\u178F"},{"id":13144,"word":"\u179F\u17B6\u178F\u17CB"},{"id":13145,"word":"\u179F\u17B6\u178F\u17B6\u17C6\u1784"},{"id":13146,"word":"\u179F\u17B6\u178F\u17D2\u179A\u17B6"},{"id":13147,"word":"\u179F\u17B6\u1791\u179A"},{"id":13148,"word":"\u179F\u17B6\u1791\u17B7\u1793"},{"id":13149,"word":"\u179F\u17B6\u1791\u17B7\u179F"},{"id":13150,"word":"\u179F\u17B6\u1791\u17BB\u1780\u17D2\u1781"},{"id":13151,"word":"\u179F\u17B6\u1791\u17BB\u1797\u17C4\u1787\u1793"},{"id":13152,"word":"\u179F\u17B6\u1791\u17C4\u179F"},{"id":13153,"word":"\u179F\u17B6\u1792"},{"id":13154,"word":"\u179F\u17B6\u1792\u1780"},{"id":13155,"word":"\u179F\u17B6\u1792\u1793\u17C8"},{"id":13156,"word":"\u179F\u17B6\u1792\u17B6\u179A\u178E\u17C8"},{"id":13157,"word":"\u179F\u17B6\u1792\u17B6\u179A\u178E --"},{"id":13158,"word":"\u179F\u17B6\u1792\u17BB"},{"id":13159,"word":"\u179F\u17B6\u1792\u17BB --"},{"id":13160,"word":"\u179F\u17B6\u1792\u17D2\u179C\u179F\u17B6\u1792\u17BB"},{"id":13161,"word":"\u179F\u17B6\u1792\u17D2\u179C\u17B6\u1785\u17B6\u179A"},{"id":13162,"word":"\u179F\u17B6\u1793"},{"id":13163,"word":"\u179F\u17B6\u1793\u1780\u17D2\u179A\u1798"},{"id":13164,"word":"\u179F\u17B6\u1793\u178E\u17BC\u179C"},{"id":13165,"word":"\u179F\u17B6\u1793\u17CB\u179C\u17BB\u17D0\u178E\u17D2\u178F"},{"id":13166,"word":"\u179F\u17B6\u1793\u17CB\u179C\u17C9\u17B6\u1793\u17CB"},{"id":13167,"word":"\u179F\u17B6\u1793\u17BB\u179F\u17B7\u179F\u17D2\u179F"},{"id":13168,"word":"\u179F\u17B6\u1793\u17BC"},{"id":13169,"word":"\u179F\u17B6\u1793\u17D2\u178F"},{"id":13170,"word":"\u179F\u17B6\u1793\u17D2\u178F\u17B7"},{"id":13171,"word":"\u179F\u17B6\u1794"},{"id":13172,"word":"\u179F\u17B6\u1794"},{"id":13173,"word":"\u179F\u17B6\u1794\u17CB"},{"id":13174,"word":"\u179F\u17B6\u1794\u178F\u17C1\u1799\u17D2\u1799"},{"id":13175,"word":"\u179F\u17B6\u1794\u178F\u17C3\u1799"},{"id":13176,"word":"\u179F\u17B6\u1794\u17B6\u1793"},{"id":13177,"word":"\u179F\u17B6\u1794\u17B6\u179B"},{"id":13178,"word":"\u179F\u17B6\u1794\u17CA\u17BC"},{"id":13179,"word":"\u179F\u17B6\u1796\u17B7\u1797\u17D0\u1780\u17D2\u178F\u17B7"},{"id":13180,"word":"\u179F\u17B6\u1798\u17C8"},{"id":13181,"word":"\u179F\u17B6\u1798\u1782\u17D2\u1782\u17B8"},{"id":13182,"word":"\u179F\u17B6\u1798\u1782\u17D2\u1782\u17B8\u1797\u17C1\u1791"},{"id":13183,"word":"\u179F\u17B6\u1798\u1789\u17D2\u1789"},{"id":13184,"word":"\u179F\u17B6\u1798\u1789\u17D2\u1789"},{"id":13185,"word":"\u179F\u17B6\u1798\u178E\u17C1\u179A"},{"id":13186,"word":"\u179F\u17B6\u1798\u178E\u17C1\u179A\u17B8"},{"id":13187,"word":"\u179F\u17B6\u1798\u1793\u17D2\u178F"},{"id":13188,"word":"\u179F\u17B6\u1798\u179F\u17B7\u1794"},{"id":13189,"word":"\u179F\u17B6\u1798\u17A0\u17B6\u1794"},{"id":13190,"word":"\u179F\u17B6\u1798\u17B6\u1793\u17D2\u1799"},{"id":13191,"word":"\u179F\u17B6\u1798\u17B6\u1799\u17B7\u1780"},{"id":13192,"word":"\u179F\u17B6\u1798\u17B7\u1780"},{"id":13193,"word":"\u179F\u17B6\u1798\u17B7\u1793\u17B8"},{"id":13194,"word":"\u179F\u17B6\u1798\u17B8"},{"id":13195,"word":"\u179F\u17B6\u1798\u17B8\u1785\u17B7"},{"id":13196,"word":"\u179F\u17B6\u1798\u17B8\u179F\u1798\u17D2\u1796\u1793\u17D2\u1792"},{"id":13197,"word":"\u179F\u17B6\u1798\u17BB\u1791\u17D2\u1791\u17C8"},{"id":13198,"word":"\u179F\u17B6\u1798\u17BB\u1791\u17D2\u1791\u17B7\u1780"},{"id":13199,"word":"\u179F\u17B6\u1799"},{"id":13200,"word":"\u179F\u17B6\u1799\u178A\u17C0\u179C"},{"id":13201,"word":"\u179F\u17B6\u1799\u178E\u17D2\u17A0\u17C8"},{"id":13202,"word":"\u179F\u17B6\u1799\u178E\u17D2\u17A0 --"},{"id":13203,"word":"\u179F\u17B6\u1799\u1794\u17B6\u178F"},{"id":13204,"word":"\u179F\u17B6\u1799\u1797\u17C4\u1787\u1793"},{"id":13205,"word":"\u179F\u17B6\u1799\u1798\u17B6\u179F"},{"id":13206,"word":"\u179F\u17B6\u1799\u1799\u17BB\u178F"},{"id":13207,"word":"\u179F\u17B6\u1799\u17BA\u1793"},{"id":13208,"word":"\u179F\u17B6\u179A"},{"id":13209,"word":"\u179F\u17B6\u179A --"},{"id":13210,"word":"\u179F\u17B6\u179A\u178E\u17B7\u1780"},{"id":13211,"word":"\u179F\u17B6\u179A\u178E\u17B7\u1780\u17B6"},{"id":13212,"word":"\u179F\u17B6\u179A\u178F\u17D2\u179A\u17B6"},{"id":13213,"word":"\u179F\u17B6\u179A\u1790\u17B8"},{"id":13214,"word":"\u179F\u17B6\u179A\u1791\u17B7\u1780"},{"id":13215,"word":"\u179F\u17B6\u179A\u1794\u17B6\u1794\u17CB"},{"id":13216,"word":"\u179F\u17B6\u179A\u1796\u17D0\u1793"},{"id":13217,"word":"\u179F\u17B6\u179A\u1796\u17B6\u1784\u17D2\u1782"},{"id":13218,"word":"\u179F\u17B6\u179A\u1796\u17BE"},{"id":13219,"word":"\u179F\u17B6\u179A\u1796\u17BE\u1799\u17BB\u178F\u17D2\u178F"},{"id":13220,"word":"\u179F\u17B6\u179A\u1796\u17BE\u179F\u17BC\u178F\u17D2\u179A"},{"id":13221,"word":"\u179F\u17B6\u179A\u1796\u17C1\u1787\u17D2\u1789"},{"id":13222,"word":"\u179F\u17B6\u179A\u1797\u17B6\u1796"},{"id":13223,"word":"\u179F\u17B6\u179A\u1798\u17D2\u1797\u1780\u1790\u17B6"},{"id":13224,"word":"\u179F\u17B6\u179A\u179C\u17D0\u178F\u17D2\u179A"},{"id":13225,"word":"\u179F\u17B6\u179A\u17B6 --"},{"id":13226,"word":"\u179F\u17B6\u179A\u17B6\u178E\u17B8\u1799"},{"id":13227,"word":"\u179F\u17B6\u179A\u17B6\u1799"},{"id":13228,"word":"\u179F\u17B6\u179A\u17B6\u1799\u17A2\u178E\u17D2\u178F\u17C2\u178F"},{"id":13229,"word":"\u179F\u17B6\u179A\u17B7\u1780\u17B6"},{"id":13230,"word":"\u179F\u17B6\u179A\u17B8"},{"id":13231,"word":"\u179F\u17B6\u179A\u17B8\u1794\u17BB\u178F\u17D2\u178F"},{"id":13232,"word":"\u179F\u17B6\u179A\u17B8\u179A\u179F\u17B6\u179F\u17D2\u179A\u17D2\u178F"},{"id":13233,"word":"\u179F\u17B6\u179A\u17B8\u179A\u17B7\u1780"},{"id":13234,"word":"\u179F\u17B6\u179A\u17BB\u1784"},{"id":13235,"word":"\u179F\u17B6\u179A\u17BB\u1794\u17D2\u1794"},{"id":13236,"word":"\u179F\u17B6\u179A\u17BC"},{"id":13237,"word":"\u179F\u17B6\u179A\u17BC\u1794"},{"id":13238,"word":"\u179F\u17B6\u179A\u17C4\u1787"},{"id":13239,"word":"\u179F\u17B6\u179B"},{"id":13240,"word":"\u179F\u17B6\u179B\u1785\u178F\u17BB\u1798\u17D2\u1798\u17BB\u1781"},{"id":13241,"word":"\u179F\u17B6\u179B\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":13242,"word":"\u179F\u17B6\u179B\u17CB"},{"id":13243,"word":"\u179F\u17B6\u179B\u17B6"},{"id":13244,"word":"\u179F\u17B6\u179B\u17B6\u178A"},{"id":13245,"word":"\u179F\u17B6\u179B\u17B7\u1780\u17B6"},{"id":13246,"word":"\u179F\u17B6\u179B\u17B8"},{"id":13247,"word":"\u179F\u17B6\u179B\u17C4\u17A0\u17B7\u178F"},{"id":13248,"word":"\u179F\u17B6\u179C"},{"id":13249,"word":"\u179F\u17B6\u179C\u1780"},{"id":13250,"word":"\u179F\u17B6\u179C\u1780\u17C2"},{"id":13251,"word":"\u179F\u17B6\u179C\u1787\u17C3"},{"id":13252,"word":"\u179F\u17B6\u179C\u178E\u1798\u17B6\u179F"},{"id":13253,"word":"\u179F\u17B6\u179C\u178F\u17B6\u179A"},{"id":13254,"word":"\u179F\u17B6\u179C\u178F\u17D2\u1790\u17B8"},{"id":13255,"word":"\u179F\u17B6\u179C\u1791\u17B6\u179C"},{"id":13256,"word":"\u179F\u17B6\u179C\u1798\u17C9\u17B6\u179C"},{"id":13257,"word":"\u179F\u17B6\u179C\u1799\u17BB\u178F"},{"id":13258,"word":"\u179F\u17B6\u179C\u179F\u17C1\u179F"},{"id":13259,"word":"\u179F\u17B6\u179C\u17A1\u17B7\u1780"},{"id":13260,"word":"\u179F\u17B6\u179C\u17B6"},{"id":13261,"word":"\u179F\u17B6\u179C\u17B7\u1780\u17B6"},{"id":13262,"word":"\u179F\u17B6\u179F\u1784"},{"id":13263,"word":"\u179F\u17B6\u179F\u1793"},{"id":13264,"word":"\u179F\u17B6\u179F\u1793 --"},{"id":13265,"word":"\u179F\u17B6\u179F\u1793\u17CD"},{"id":13266,"word":"\u179F\u17B6\u179F\u1793\u17B6"},{"id":13267,"word":"\u179F\u17B6\u179F\u1793\u17B7\u1780"},{"id":13268,"word":"\u179F\u17B6\u179F\u1796\u17D2\u1791"},{"id":13269,"word":"\u179F\u17B6\u179F\u179A\u17C4\u1782"},{"id":13270,"word":"\u179F\u17B6\u179F\u17D2\u178A\u17B6"},{"id":13271,"word":"\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A"},{"id":13272,"word":"\u179F\u17B6\u179F\u17D2\u178F\u17D2\u179A\u17B6"},{"id":13273,"word":"\u179F\u17B6\u17A0\u178F\u17D2\u1790"},{"id":13274,"word":"\u179F\u17B6\u17A0\u17D0\u179F"},{"id":13275,"word":"\u179F\u17B6\u17A0\u17B6\u179A"},{"id":13276,"word":"\u179F\u17B6\u17A0\u17B6\u179C"},{"id":13277,"word":"\u179F\u17A0\u17BB !"},{"id":13278,"word":"\u179F\u17B6\u17A0\u17C1\u178F\u17BB"},{"id":13279,"word":"\u179F\u17B7\u1780\u17D2\u1781"},{"id":13280,"word":"\u179F\u17B7\u1780\u17D2\u1781\u1798\u17B6\u1793\u17B6"},{"id":13281,"word":"\u179F\u17B7\u1780\u17D2\u1781\u17B6"},{"id":13282,"word":"\u179F\u17B7\u1780\u17D2\u179F\u17B6"},{"id":13283,"word":"\u179F\u17B7\u1781\u178E\u17D2\u178C\u17B7\u1793"},{"id":13284,"word":"\u179F\u17B7\u1781\u179A\u17B7\u1793"},{"id":13285,"word":"\u179F\u17B7\u1781\u17B6"},{"id":13286,"word":"\u179F\u17B7\u1781\u17B7\u1793"},{"id":13287,"word":"\u179F\u17B7\u1782\u17B6\u179B"},{"id":13288,"word":"\u179F\u17B7\u1782\u17B6\u179B\u17B8"},{"id":13289,"word":"\u179F\u17B7\u1784"},{"id":13290,"word":"\u179F\u17B7\u1784\u17D2\u1782\u17B6\u179B"},{"id":13291,"word":"\u179F\u17B7\u1784\u17D2\u1783\u17B6\u178A"},{"id":13292,"word":"\u179F\u17B7\u1784\u17D2\u1783\u17B6\u178A\u1780"},{"id":13293,"word":"\u179F\u17B7\u1784\u17D2\u1783\u17B6\u1793\u17B7\u1780"},{"id":13294,"word":"\u179F\u17B7\u1784\u17D2\u17A0"},{"id":13295,"word":"\u179F\u17B7\u1784\u17D2\u17A0\u17C8"},{"id":13296,"word":"\u179F\u17B7\u1784\u17D2\u17A0\u179B"},{"id":13297,"word":"\u179F\u17B7\u1785\u1794\u17C9\u1794\u17D2\u179A\u17B7\u1785"},{"id":13298,"word":"\u179F\u17B7\u1785\u1798\u1798\u17C9\u17B7\u1785"},{"id":13299,"word":"\u179F\u17B7\u1789 "},{"id":13300,"word":"\u179F\u17B7\u178F"},{"id":13301,"word":"\u179F\u17B7\u178F\u1780\u17B6\u179A\u178E\u17CD"},{"id":13302,"word":"\u179F\u17B7\u178F\u17A2\u1793\u17D2\u179B\u17B7\u1780"},{"id":13303,"word":"\u179F\u17B7\u1790\u17B7\u179B"},{"id":13304,"word":"\u179F\u17B7\u1790\u17B7\u179B --"},{"id":13305,"word":"\u179F\u17B7\u1791\u17D2\u1792"},{"id":13306,"word":"\u179F\u17B7\u1791\u17D2\u1792 --"},{"id":13307,"word":"\u179F\u17B7\u1791\u17D2\u1792\u178F\u17D2\u1790"},{"id":13308,"word":"\u179F\u17B7\u1791\u17D2\u1792\u17B6 --"},{"id":13309,"word":"\u179F\u17B7\u1791\u17D2\u1792\u17B6\u1790\u17CC"},{"id":13310,"word":"\u179F\u17B7\u1791\u17D2\u1792\u17B7"},{"id":13311,"word":"\u179F\u17B7\u1791\u17D2\u1792\u17B7 --"},{"id":13312,"word":"\u179F\u17B7\u1793"},{"id":13313,"word":"\u179F\u17CA\u17B7\u1793\u179F\u17C2"},{"id":13314,"word":"\u179F\u17B7\u1793\u17B7\u1791\u17D2\u1792"},{"id":13315,"word":"\u179F\u17B7\u1793\u17C1\u179A\u17BB"},{"id":13316,"word":"\u179F\u17B7\u1793\u17C1\u17A0"},{"id":13317,"word":"\u179F\u17B7\u1793\u17C1\u17A0 --"},{"id":13318,"word":"\u179F\u17B7\u1793\u17D2\u1791"},{"id":13319,"word":"\u179F\u17B7\u1793\u17D2\u1792\u1796"},{"id":13320,"word":"\u179F\u17B7\u1793\u17D2\u1792\u1796\u17A2\u1798\u179A\u17B7\u1793\u17D2\u1791"},{"id":13321,"word":"\u179F\u17B7\u1793\u17D2\u1792\u179C"},{"id":13322,"word":"\u179F\u17B7\u1793\u17D2\u1792\u17BB"},{"id":13323,"word":"\u179F\u17B7\u1793\u17D2\u1792\u17BB\u179F\u1784\u17D2\u1782\u1798"},{"id":13324,"word":"\u179F\u17B7\u1793\u17D2\u1792\u17C5\u179C\u17CD"},{"id":13325,"word":"\u179F\u17B7\u1794\u17D2\u1794"},{"id":13326,"word":"\u179F\u17B7\u1794\u17D2\u1794 --"},{"id":13327,"word":"\u179F\u17B7\u1794\u17D2\u1794\u17B7\u1780\u17C8"},{"id":13328,"word":"\u179F\u17B7\u1794\u17D2\u1794\u17B7\u1780\u17B6"},{"id":13329,"word":"\u179F\u17B7\u1794\u17D2\u1794\u17B7\u1799\u1780\u17B6\u179A"},{"id":13330,"word":"\u179F\u17B7\u1794\u17D2\u1794\u17B8"},{"id":13331,"word":"\u179F\u17B7\u1794\u17D2\u1794\u17B8\u1787\u17B6\u178F\u17B7"},{"id":13332,"word":"\u179F\u17B7\u1796\u17D2\u179C\u1793"},{"id":13333,"word":"\u179F\u17B7\u1796\u17D2\u179C\u1793\u17B8"},{"id":13334,"word":"\u179F\u17B7\u1798\u17D2\u1796\u179B\u17B8"},{"id":13335,"word":"\u179F\u17B7\u179A"},{"id":13336,"word":"\u179F\u17B7\u179A --"},{"id":13337,"word":"\u179F\u17B7\u179A\u1798\u17B6\u1793\u17CB"},{"id":13338,"word":"\u179F\u17B7\u179A\u179F\u17CD"},{"id":13339,"word":"\u179F\u17B7\u179A\u17C4 --"},{"id":13340,"word":"\u179F\u17B7\u179A\u17B7"},{"id":13341,"word":"\u179F\u17B7\u179A\u17B8"},{"id":13342,"word":"\u179F\u17B7\u179A\u17B8 --"},{"id":13343,"word":"\u179F\u17B7\u179A\u17D2\u179F"},{"id":13344,"word":"\u179F\u17B7\u179B\u17B6"},{"id":13345,"word":"\u179F\u17B7\u179B\u17B6 --"},{"id":13346,"word":"\u179F\u17B7\u179B\u17BB\u1785\u17D2\u1785\u17D0\u1799"},{"id":13347,"word":"\u179F\u17B7\u179B\u17C4\u1780"},{"id":13348,"word":"\u179F\u17B7\u179B\u17C4\u179A\u179F\u17D2\u1780"},{"id":13349,"word":"\u179F\u17B7\u179B\u17D2\u1794"},{"id":13350,"word":"\u179F\u17B7\u179B\u17D2\u1794 --"},{"id":13351,"word":"\u179F\u17B7\u179C\u17C8"},{"id":13352,"word":"\u179F\u17B7\u179C --"},{"id":13353,"word":"\u179F\u17B7\u179C\u17B7\u1780\u17B6"},{"id":13354,"word":"\u179F\u17B7\u179F\u17B7\u179A\u17C8"},{"id":13355,"word":"\u179F\u17B7\u179F\u17BB"},{"id":13356,"word":"\u179F\u17B7\u179F\u17D2\u1799"},{"id":13357,"word":"\u179F\u17B7\u179F\u17D2\u179F"},{"id":13358,"word":"\u179F\u17B7\u179F\u17D2\u179F\u17B6\u1793\u17BB\u179F\u17B7\u179F\u17D2\u179F"},{"id":13359,"word":"\u179F\u17B8"},{"id":13360,"word":"\u179F\u17CA\u17B8"},{"id":13361,"word":"\u179F\u17CA\u17B8 --"},{"id":13362,"word":"\u179F\u17CA\u17B8\u1782\u17C4\u179B"},{"id":13363,"word":"\u179F\u17B8\u1783"},{"id":13364,"word":"\u179F\u17CA\u17B8\u1789\u17C1"},{"id":13365,"word":"\u179F\u17B8\u178F"},{"id":13366,"word":"\u179F\u17B8\u178F --"},{"id":13367,"word":"\u179F\u17B8\u178F\u17B6"},{"id":13368,"word":"\u179F\u17B8\u178F\u17B6\u179B\u17BB"},{"id":13369,"word":"\u179F\u17B8\u1791\u1793\u17D2\u178F\u179A"},{"id":13370,"word":"\u179F\u17CA\u17B8\u1794\u17C9\u17B6\u179A\u17C1\u178F"},{"id":13371,"word":"\u179F\u17CA\u17B8\u1798\u17C9\u1784\u178F\u17CD"},{"id":13372,"word":"\u179F\u17B8\u1798\u1793\u17D2\u178F\u179A\u17B7\u1780"},{"id":13373,"word":"\u179F\u17B8\u1798\u17B6"},{"id":13374,"word":"\u179F\u17CA\u17B8\u1798\u17B9\u1784"},{"id":13375,"word":"\u179F\u17B8\u179A\u179F\u17B6\u1785\u17CB"},{"id":13376,"word":"\u179F\u17CA\u17B8\u179A\u17C9\u17BC\u1794\u17CD"},{"id":13377,"word":"\u179F\u17B8\u179B"},{"id":13378,"word":"\u179F\u17B8\u179B --"},{"id":13379,"word":"\u179F\u17B8\u179B\u1796\u17D2\u179C\u178F --"},{"id":13380,"word":"\u179F\u17B8\u179B\u1796\u17D2\u179C\u17D0\u178F"},{"id":13381,"word":"\u179F\u17B8\u179B\u17B6 --"},{"id":13382,"word":"\u179F\u17B8\u179C\u1790\u17B7\u1780\u17B6"},{"id":13383,"word":"\u179F\u17CA\u17B8\u179C\u17B7\u17A1\u17B6\u178F"},{"id":13384,"word":"\u179F\u17B8\u179F --"},{"id":13385,"word":"\u179F\u17B8\u179F\u17C8"},{"id":13386,"word":"\u179F\u17CA\u17B8\u179F\u1784"},{"id":13387,"word":"\u179F\u17CA\u17B8\u179F\u17B9\u1780"},{"id":13388,"word":"\u179F\u17CA\u17B8\u179F\u17BC\u1795\u17BB\u1793"},{"id":13389,"word":"\u179F\u17B8\u17A0\u17C8"},{"id":13390,"word":"\u179F\u17B8\u17A0\u17C8"},{"id":13391,"word":"\u179F\u17B8\u17A0 --"},{"id":13392,"word":"\u179F\u17B8\u17A0\u179B"},{"id":13393,"word":"\u179F\u17B8\u17A0\u179B\u17C4"},{"id":13394,"word":"\u179F\u17B8\u17A0\u17A1"},{"id":13395,"word":"\u179F\u17B8\u17A0\u17B6 --"},{"id":13396,"word":"\u179F\u17B9\u1780"},{"id":13397,"word":"\u179F\u17B9\u1780\u1794\u17C9\u1794\u17D2\u179B\u17B9\u1780"},{"id":13398,"word":"\u179F\u17B9\u1780\u1794\u17D2\u178F\u17B9\u1780"},{"id":13399,"word":"\u179F\u17B9\u1784"},{"id":13400,"word":"\u179F\u17CA\u17B9\u1784"},{"id":13401,"word":"\u179F\u17B9\u1798"},{"id":13402,"word":"\u179F\u17BA"},{"id":13403,"word":"\u179F\u17BB\u1780"},{"id":13404,"word":"\u179F\u17CA\u17BB\u1780\u1782\u17D2\u179A\u179B\u17BB\u1780"},{"id":13405,"word":"\u179F\u17BB\u1780\u17D0\u1793\u17D2\u178F"},{"id":13406,"word":"\u179F\u17BB\u1780\u1798\u1798\u17C9\u17BB\u1780"},{"id":13407,"word":"\u179F\u17BB\u1780\u179A"},{"id":13408,"word":"\u179F\u17BB\u1780\u17BB\u1798\u17B6\u179A"},{"id":13409,"word":"\u179F\u17BB\u1780\u17BB\u1798\u17B6\u179A\u17B8"},{"id":13410,"word":"\u179F\u17BB\u1780\u17D2\u1780"},{"id":13411,"word":"\u179F\u17BB\u1780\u17D2\u1780 --"},{"id":13412,"word":"\u179F\u17BB\u1780\u17D2\u179A"},{"id":13413,"word":"\u179F\u17BB\u1780\u17D2\u179A\u17B9\u178F"},{"id":13414,"word":"\u179F\u17BB\u1781"},{"id":13415,"word":"\u179F\u17BB\u1781 --"},{"id":13416,"word":"\u179F\u17BB\u1781\u1780\u17C6\u1794\u17BB\u178F"},{"id":13417,"word":"\u179F\u17BB\u1781\u178A\u17BB\u1798"},{"id":13418,"word":"\u179F\u17BB\u1781\u178A\u17BB\u17C6"},{"id":13419,"word":"\u179F\u17BB\u1781\u17B7\u178F\u1780\u17B6\u179B"},{"id":13420,"word":"\u179F\u17BB\u1781\u17BB\u1798"},{"id":13421,"word":"\u179F\u17BB\u1781\u17BB\u1798 --"},{"id":13422,"word":"\u179F\u17BB\u1781\u17BB\u1798\u17B6\u179B"},{"id":13423,"word":"\u179F\u17BB\u1781\u17C1\u1792\u17B7\u178F"},{"id":13424,"word":"\u179F\u17BB\u1781\u17C4\u1791\u17D0\u1799"},{"id":13425,"word":"\u179F\u17BB\u1782\u178F"},{"id":13426,"word":"\u179F\u17BB\u1782\u178F\u17B7"},{"id":13427,"word":"\u179F\u17BB\u1782\u1793\u17D2\u1792"},{"id":13428,"word":"\u179F\u17BB\u1782\u1793\u17D2\u1792 --"},{"id":13429,"word":"\u179F\u17BB\u1782\u1798\u1793\u17C6"},{"id":13430,"word":"\u179F\u17BB\u1782\u17D2\u179A\u17B8\u1796"},{"id":13431,"word":"\u179F\u17BB\u1784"},{"id":13432,"word":"\u179F\u17BB\u1784\u17D2\u1780"},{"id":13433,"word":"\u179F\u17BB\u1785"},{"id":13434,"word":"\u179F\u17BB\u1785\u179A\u17B7\u178F"},{"id":13435,"word":"\u179F\u17BB\u1785\u1793\u17B8\u1799\u17CD "},{"id":13436,"word":"\u179F\u17BB\u1785\u17B7"},{"id":13437,"word":"\u179F\u17BB\u1785\u17B7 --"},{"id":13438,"word":"\u179F\u17BB\u1785\u17B7\u178F"},{"id":13439,"word":"\u179F\u17BB\u1785\u17B7\u178F\u17D2\u178F\u17B6"},{"id":13440,"word":"\u179F\u17BB\u1785\u17B7\u178F\u17D2\u179A"},{"id":13441,"word":"\u179F\u17BB.\u1785\u17B7.\u1794\u17BB.\u179B\u17B7."},{"id":13442,"word":"\u179F\u17BB\u1785\u17D2\u1786\u1793\u17D2\u1791\u17C8"},{"id":13443,"word":"\u179F\u17BB\u1787\u1793"},{"id":13444,"word":"\u179F\u17BB\u1787\u1798\u17D2\u1794\u178F\u17B8"},{"id":13445,"word":"\u179F\u17BB\u1795\u17B6\u178F"},{"id":13446,"word":"\u179F\u17BB\u1787\u17B6\u178F\u17B6"},{"id":13447,"word":"\u179F\u17BB\u1787\u17B8\u179C\u1792\u1798\u17CC"},{"id":13448,"word":"\u179F\u17BB\u1789"},{"id":13449,"word":"\u179F\u17BB\u1789\u17D2\u1789"},{"id":13450,"word":"\u179F\u17BB\u1789\u17D2\u1789 --"},{"id":13451,"word":"\u179F\u17BB\u1789\u17D2\u1789\u17C4"},{"id":13452,"word":"\u179F\u17BB\u178A\u1793\u17CB"},{"id":13453,"word":"\u179F\u17BB\u178E\u17B7\u179F\u17B6"},{"id":13454,"word":"\u179F\u17BB\u178F\u17C8"},{"id":13455,"word":"\u179F\u17CA\u17BB\u178F"},{"id":13456,"word":"\u179F\u17CA\u17BB\u178F\u1791\u17D2\u179A\u17BB\u178C"},{"id":13457,"word":"\u179F\u17BB\u178F\u17D2\u178F\u1793\u17D2\u178F\u1794\u17B7\u178A\u1780"},{"id":13458,"word":"\u179F\u17BB\u1791\u1793\u17D2\u178F"},{"id":13459,"word":"\u179F\u17BB\u1791\u179F\u17D2\u179F\u17B6"},{"id":13460,"word":"\u179F\u17BB\u1791\u179F\u17D2\u179F\u17B8"},{"id":13461,"word":"\u179F\u17BB\u1791\u17B7\u178A\u17D2\u178B\u17B7\u1793\u17B7\u1799\u1798"},{"id":13462,"word":"\u179F\u17BB\u1791\u17B7\u1793"},{"id":13463,"word":"\u179F\u17BB\u1791\u17B7\u1793\u17D2\u1793"},{"id":13464,"word":"\u179F\u17BB\u1791\u17BB\u1780\u17D2\u1780\u179A"},{"id":13465,"word":"\u179F\u17BB\u1791\u17D2\u1791\u17C8"},{"id":13466,"word":"\u179F\u17BB\u1791\u17D2\u1791\u17B8"},{"id":13467,"word":"\u179F\u17BB\u1791\u17D2\u1792"},{"id":13468,"word":"\u179F\u17BB\u1791\u17D2\u1792 --"},{"id":13469,"word":"\u179F\u17BB\u1791\u17D2\u1792\u178F\u17C2"},{"id":13470,"word":"\u179F\u17BB\u1791\u17D2\u1792\u17B7"},{"id":13471,"word":"\u179F\u17BB\u1791\u17D2\u1792\u17B7 --"},{"id":13472,"word":"\u179F\u17BB\u1791\u17D2\u1792\u17C4 --"},{"id":13473,"word":"\u179F\u17BB\u1791\u17D2\u1792\u17C4\u1791\u1793\u17C8"},{"id":13474,"word":"\u179F\u17BB\u1791\u17D2\u1792\u17C4\u1791\u1793\u17B7"},{"id":13475,"word":"\u179F\u17BB\u1792\u1798\u17D2\u1798"},{"id":13476,"word":"\u179F\u17BB\u1792\u1798\u17D2\u1798\u17B6"},{"id":13477,"word":"\u179F\u17BB\u1792\u1798\u17D2\u1798\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":13478,"word":"\u179F\u17BB\u1792\u17B6"},{"id":13479,"word":"\u179F\u17BB\u1792\u17B6 --"},{"id":13480,"word":"\u179F\u17BB\u1792\u17B8"},{"id":13481,"word":"\u179F\u17BB\u1792\u17B8\u179A"},{"id":13482,"word":"\u179F\u17CA\u17BB\u1793"},{"id":13483,"word":"\u179F\u17BB\u1793\u1780"},{"id":13484,"word":"\u179F\u17BB\u1793\u1781\u17B8"},{"id":13485,"word":"\u179F\u17BB\u1793\u178F\u17D2\u179A\u17BB\u1793"},{"id":13486,"word":"\u179F\u17BB\u1793\u1793\u17D2\u1791\u17B6"},{"id":13487,"word":"\u179F\u17BB\u1793\u17B8\u178F\u17B7"},{"id":13488,"word":"\u179F\u17BB\u1793\u17D2\u1791\u179A"},{"id":13489,"word":"\u179F\u17BB\u1793\u17D2\u1791\u179A --"},{"id":13490,"word":"\u179F\u17BB\u1793\u17D2\u1791\u179A\u17CD\u1791\u17B6\u1793"},{"id":13491,"word":"\u179F\u17BB\u1793\u17D2\u1791\u179A\u17B8"},{"id":13492,"word":"\u179F\u17BB\u1793\u17D2\u1791\u179A\u17C4 --"},{"id":13493,"word":"\u179F\u17CA\u17BB\u1794"},{"id":13494,"word":"\u179F\u17BB\u1794\u178E\u17D2\u178E"},{"id":13495,"word":"\u179F\u17CA\u17BB\u1794\u1791\u17D2\u179A\u17BB\u1794"},{"id":13496,"word":"\u179F\u17BB\u1794\u1794\u17D2\u179A\u17A1\u17BB\u1794"},{"id":13497,"word":"\u179F\u17BB\u1794\u179F\u17C5"},{"id":13498,"word":"\u179F\u17BB\u1794\u17B7\u1793"},{"id":13499,"word":"\u179F\u17BB\u1794\u17D2\u1794\u1790"},{"id":13500,"word":"\u179F\u17BB\u1794\u17D2\u179A\u1780\u17B6\u179F"},{"id":13501,"word":"\u179F\u17BB\u1794\u17D2\u1794\u1797\u17B6\u178F"},{"id":13502,"word":"\u179F\u17BB\u1794\u17D2\u179A\u1797\u17B6\u1796"},{"id":13503,"word":"\u179F\u17BB\u1794\u17D2\u179A\u1799\u17C4\u1782"},{"id":13504,"word":"\u179F\u17BB\u1794\u17D2\u179A\u17B6\u178F"},{"id":13505,"word":"\u179F\u17BB\u1795\u179B"},{"id":13506,"word":"\u179F\u17BB\u1796\u1785\u17C8"},{"id":13507,"word":"\u179F\u17BB\u1796\u1785 --"},{"id":13508,"word":"\u179F\u17BB\u1796\u178E\u17CC"},{"id":13509,"word":"\u179F\u17BB\u1797"},{"id":13510,"word":"\u179F\u17BB\u1797 --"},{"id":13511,"word":"\u179F\u17BB\u1797\u17D0\u1782"},{"id":13512,"word":"\u179F\u17BB\u1797\u179A"},{"id":13513,"word":"\u179F\u17BB\u1797\u17B6"},{"id":13514,"word":"\u179F\u17BB\u1797\u17B6 --"},{"id":13515,"word":"\u179F\u17BB\u1797\u17B6\u1785\u17B6\u179A\u1794\u17BB\u179A\u179F"},{"id":13516,"word":"\u179F\u17BB\u1797\u17B6\u178F\u17BB\u179B\u17B6\u1780\u17B6\u179A"},{"id":13517,"word":"\u179F\u17BB\u1797\u17B6\u1796"},{"id":13518,"word":"\u179F\u17BB\u1797\u17B6\u179F\u17B7\u178F"},{"id":13519,"word":"\u179F\u17BB\u1797\u17B6\u179F\u17B7\u178F --"},{"id":13520,"word":"\u179F\u17BB\u1797\u17B7\u1780\u17D2\u1781"},{"id":13521,"word":"\u179F\u17BB\u1797\u17C4\u1787\u1793"},{"id":13522,"word":"\u179F\u17BB\u1797\u17C6"},{"id":13523,"word":"\u179F\u17CA\u17BB\u1798"},{"id":13524,"word":"\u179F\u17CA\u17BB\u1798\u1782\u17D2\u179A\u179B\u17BB\u17C6"},{"id":13525,"word":"\u179F\u17CA\u17BB\u1798\u1791\u17D2\u179A\u17BB\u1798"},{"id":13526,"word":"\u179F\u17BB\u1798\u1793\u17B6"},{"id":13527,"word":"\u179F\u17BB\u1798\u17B6\u179B\u17B8"},{"id":13528,"word":"\u179F\u17BB\u1798\u17C1\u1792"},{"id":13529,"word":"\u179F\u17BB\u1798\u17C1\u1792\u17B6"},{"id":13530,"word":"\u179F\u17BB\u1798\u17C1\u179A\u17BB"},{"id":13531,"word":"\u179F\u17BB\u1799\u1798\u17C9\u17BB\u1799"},{"id":13532,"word":"\u179F\u17BB\u1799\u1798\u17C9\u17C1\u17C8"},{"id":13533,"word":"\u179F\u17BB\u1799\u17B6\u178F\u17D2\u179A\u17B6"},{"id":13534,"word":"\u179F\u17BB\u179A"},{"id":13535,"word":"\u179F\u17BB\u179A --"},{"id":13536,"word":"\u179F\u17BB\u179A\u1780\u17D2\u1781\u17B6"},{"id":13537,"word":"\u179F\u17BB\u179A\u1797\u17B8"},{"id":13538,"word":"\u179F\u17BB\u179A\u179F\u1797\u17C4\u1787\u1793 "},{"id":13539,"word":"\u179F\u17BB\u179A\u17B6"},{"id":13540,"word":"\u179F\u17BB\u179A\u17B6 --"},{"id":13541,"word":"\u179F\u17BB\u179A\u17B6 --"},{"id":13542,"word":"\u179F\u17BB\u179A\u17B7\u1793\u17D2\u1791"},{"id":13543,"word":"\u179F\u17BB\u179A\u17B7\u1793\u17D2\u1791\u1781\u17D2\u1793\u1784\u1797\u17D2\u1793\u17C6"},{"id":13544,"word":"\u179F\u17BB\u179A\u17B7\u1793\u17D2\u1791\u17B6\u1792\u17B7\u1794\u178F\u17B8"},{"id":13545,"word":"\u179F\u17BB\u179A\u17B7\u1799"},{"id":13546,"word":"\u179F\u17BB\u179A\u17B7\u1799 --"},{"id":13547,"word":"\u179F\u17BB\u179A\u17B7\u1799\u1784\u17D2\u1782"},{"id":13548,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17D0\u1793"},{"id":13549,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17B6"},{"id":13550,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17B6 --"},{"id":13551,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17B6 \u179B\u17D2\u1784\u17B6\u1785\u1790\u17D2\u1784\u17C3"},{"id":13552,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17C1"},{"id":13553,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17C4 --"},{"id":13554,"word":"\u179F\u17BB\u179A\u17B7\u1799\u17C4\u178A\u17B8"},{"id":13555,"word":"\u179F\u17BB\u179A\u17B7\u179B"},{"id":13556,"word":"\u179F\u17BB\u179A\u17BC\u1794"},{"id":13557,"word":"\u179F\u17BB\u179A\u17C1\u1793\u17D2\u1791\u17D2\u179A"},{"id":13558,"word":"\u179F\u17BB\u179B"},{"id":13559,"word":"\u179F\u17BB\u179B\u17D7"},{"id":13560,"word":"\u179F\u17BB\u179B\u1780\u17D2\u1781\u178E\u17C8"},{"id":13561,"word":"\u179F\u17CA\u17BB\u179B\u1782\u1783\u17BB\u179B"},{"id":13562,"word":"\u179F\u17BB\u179B\u1797"},{"id":13563,"word":"\u179F\u17BB\u179B\u17B6\u179B\u17D0\u1799"},{"id":13564,"word":"\u179F\u17BB\u179B\u17D2\u1780"},{"id":13565,"word":"\u179F\u17BB\u179C\u1785\u17C8"},{"id":13566,"word":"\u179F\u17BB\u179C\u178E\u17D2\u178E"},{"id":13567,"word":"\u179F\u17BB\u179C\u178E\u17D2\u178E --"},{"id":13568,"word":"\u179F\u17BB\u179C\u178F\u17D2\u1790\u17B7"},{"id":13569,"word":"\u179F\u17BB\u179C\u179F\u1793\u1797\u17B6\u1796"},{"id":13570,"word":"\u179F\u17BB\u179C\u17B7\u1785\u17B7\u178F\u17D2\u179A"},{"id":13571,"word":"\u179F\u17BB\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":13572,"word":"\u179F\u17BB\u179C\u17C4\u17A0\u17B6\u179A"},{"id":13573,"word":"\u179F\u17BB\u179F"},{"id":13574,"word":"\u179F\u17BB\u179F\u1799\u17D2\u1799\u17B6"},{"id":13575,"word":"\u179F\u17BB\u179F\u17B6\u1793"},{"id":13576,"word":"\u179F\u17BB\u179F\u17B7\u1780\u17D2\u179F\u17B6"},{"id":13577,"word":"\u179F\u17BB\u179F\u17C1\u1799\u17D2\u1799\u17B6"},{"id":13578,"word":"\u179F\u17BB\u179F\u17D2\u1798\u17D0\u1793 "},{"id":13579,"word":"\u179F\u17BB\u179F\u17D2\u1798\u17B7\u1793"},{"id":13580,"word":"\u179F\u17BB\u17A0\u17D2\u17AB\u1791"},{"id":13581,"word":"\u179F\u17BC"},{"id":13582,"word":"\u179F\u17CA\u17BC"},{"id":13583,"word":"\u179F\u17BC\u1780"},{"id":13584,"word":"\u179F\u17BC\u1780\u179A"},{"id":13585,"word":"\u179F\u17BC\u1780\u179A\u1793\u17D2\u178F\u1780\u17C8"},{"id":13586,"word":"\u179F\u17BC\u1780\u179A\u1798\u1791\u17D2\u1791\u179C\u17C8"},{"id":13587,"word":"\u179F\u17BC\u1780\u179A\u17B7\u1780"},{"id":13588,"word":"\u179F\u17BC\u1789\u1798\u17C9\u17BC\u1789"},{"id":13589,"word":"\u179F\u17BC\u178F"},{"id":13590,"word":"\u179F\u17BC\u178F\u17D2\u179A"},{"id":13591,"word":"\u179F\u17BC\u1791"},{"id":13592,"word":"\u179F\u17BC\u1791\u17D2\u179A"},{"id":13593,"word":"\u179F\u17BC\u1791\u17D2\u179A\u1793\u17B7\u1782\u1798"},{"id":13594,"word":"\u179F\u17BC\u1791\u17D2\u179A\u17B6"},{"id":13595,"word":"\u179F\u17CA\u17BC\u1791\u17D2\u179A\u17BC"},{"id":13596,"word":"\u179F\u17BC\u1792\u17D2\u1799"},{"id":13597,"word":"\u179F\u17BC\u1793"},{"id":13598,"word":"\u179F\u17BC\u1793\u17D2\u1799"},{"id":13599,"word":"\u179F\u17BC\u1794"},{"id":13600,"word":"\u179F\u17CA\u17BC\u1794\u17C9\u1791\u17D2\u179A\u17BC"},{"id":13601,"word":"\u179F\u17BC\u1798"},{"id":13602,"word":"\u179F\u17BC\u1798\u1780\u17D2\u179A\u17B6\u1794 \u1794\u1784\u17D2\u1782\u17C6\u1791\u17BC\u179B"},{"id":13603,"word":"\u179F\u17BC\u179A"},{"id":13604,"word":"\u179F\u17BC\u179A\u1784"},{"id":13605,"word":"\u179F\u17BC\u179A\u17D2\u1799"},{"id":13606,"word":"\u179F\u17BC\u179A\u17D2\u1799 --"},{"id":13607,"word":"\u179F\u17BC\u179A\u17D2\u1799\u1780\u17B6\u1793\u17D2\u178F"},{"id":13608,"word":"\u179F\u17BC\u179A\u17C1\u1785"},{"id":13609,"word":"\u179F\u17BC\u179B"},{"id":13610,"word":"\u179F\u17BC\u179B\u17B8"},{"id":13611,"word":"\u179F\u17BC\u179C"},{"id":13612,"word":"\u179F\u17BC\u179C\u17D7"},{"id":13613,"word":"\u179F\u17BD"},{"id":13614,"word":"\u179F\u17BD\u1784"},{"id":13615,"word":"\u179F\u17BD\u178F"},{"id":13616,"word":"\u179F\u17BD\u1793"},{"id":13617,"word":"\u179F\u17BD\u1799"},{"id":13618,"word":"\u179F\u17BD\u179A"},{"id":13619,"word":"\u179F\u17BD\u1782\u17CC"},{"id":13620,"word":"\u179F\u17BD\u1782\u17CC\u17B6"},{"id":13621,"word":"\u179F\u17BD\u179F\u17D2\u178F\u17B7\u17CD"},{"id":13622,"word":"\u179F\u17BD\u179F\u17D2\u178A\u17B8"},{"id":13623,"word":"\u179F\u17BE"},{"id":13624,"word":"\u179F\u17BE\u1780"},{"id":13625,"word":"\u179F\u17CA\u17BE\u1780\u17D7"},{"id":13626,"word":"\u179F\u17BE\u1780\u178F\u17D2\u179A\u17BE\u1780"},{"id":13627,"word":"\u179F\u17BE\u1780\u1794\u17C9\u1794\u17D2\u179A\u17BE\u1780"},{"id":13628,"word":"\u179F\u17BE\u1780\u1794\u17C9\u1794\u17D2\u179B\u17BE\u1780"},{"id":13629,"word":"\u179F\u17CA\u17BE\u1780\u1796\u1796\u17BE\u1780"},{"id":13630,"word":"\u179F\u17CA\u17BE\u1780\u1796\u1797\u17D2\u179B\u17BE\u1780"},{"id":13631,"word":"\u179F\u17CA\u17BE\u1780\u1798\u1798\u17BE\u1780"},{"id":13632,"word":"\u179F\u17CA\u17BE\u1784\u1791\u17D2\u179A\u17BE\u1784"},{"id":13633,"word":"\u179F\u17BE\u1784\u1798\u1798\u17C9\u17BE\u1784"},{"id":13634,"word":"\u179F\u17CA\u17BE\u1784\u1798\u17BE\u1784"},{"id":13635,"word":"\u179F\u17BE\u1785"},{"id":13636,"word":"\u179F\u17BE\u1793"},{"id":13637,"word":"\u179F\u17CA\u17BE\u1794"},{"id":13638,"word":"\u179F\u17BE\u1798"},{"id":13639,"word":"\u179F\u17CA\u17BE\u1798\u1782\u1782\u17D2\u179A\u17BE\u1798"},{"id":13640,"word":"\u179F\u17BE\u1799"},{"id":13641,"word":"\u179F\u17BE\u179A\u17BE"},{"id":13642,"word":"\u179F\u17BE\u179C\u17C9\u17BE"},{"id":13643,"word":"\u179F\u17CA\u17BE\u179F \u1782\u17D2\u179A\u1798\u17BE\u179F"},{"id":13644,"word":"\u179F\u17BF\u1784"},{"id":13645,"word":"\u179F\u17C0"},{"id":13646,"word":"\u179F\u17C0\u1784"},{"id":13647,"word":"\u179F\u17C0\u178F"},{"id":13648,"word":"\u179F\u17C0\u178F\u1795\u17D2\u1780\u17B6"},{"id":13649,"word":"\u179F\u17C0\u1792\u17B8"},{"id":13650,"word":"\u179F\u17C0\u1793"},{"id":13651,"word":"\u179F\u17C0\u1793\u1798\u1798\u17C0\u1793"},{"id":13652,"word":"\u179F\u17C0\u1794\u17D2\u179A\u17C0\u1794"},{"id":13653,"word":"\u179F\u17C0\u1798"},{"id":13654,"word":"\u179F\u17C0\u1798\u1794\u17D2\u179A\u17C0\u1798"},{"id":13655,"word":"\u179F\u17C0\u1798\u179A\u17B6\u1794"},{"id":13656,"word":"\u179F\u17C0\u179A"},{"id":13657,"word":"\u179F\u17C0\u179C"},{"id":13658,"word":"\u179F\u17C0\u179C\u1797\u17C5"},{"id":13659,"word":"\u179F\u17C1"},{"id":13660,"word":"\u179F\u17C1\u1780"},{"id":13661,"word":"\u179F\u17C1\u1780\u1780\u17B7\u1785\u17D2\u1785"},{"id":13662,"word":"\u179F\u17C1\u1780\u17D2\u1781"},{"id":13663,"word":"\u179F\u17C1\u1784"},{"id":13664,"word":"\u179F\u17C1\u1785\u1780\u17D2\u178A\u17B8"},{"id":13665,"word":"\u179F\u17C1\u1785\u1780\u17D2\u178A\u17B6\u17C6"},{"id":13666,"word":"\u179F\u17C1\u1785\u1782\u17D2\u179A\u17C1\u1785"},{"id":13667,"word":"\u179F\u17C1\u1785\u1793\u1780\u17B7\u1785\u17D2\u1785"},{"id":13668,"word":"\u179F\u17C1\u1789"},{"id":13669,"word":"\u179F\u17C1\u178A\u17D2\u178B"},{"id":13670,"word":"\u179F\u17C1\u178A\u17D2\u178B--"},{"id":13671,"word":"\u179F\u17C1\u178A\u17D2\u178B\u17B7\u1793\u17B8"},{"id":13672,"word":"\u179F\u17C1\u178A\u17D2\u178B\u17B8"},{"id":13673,"word":"\u179F\u17C1\u178A\u17D2\u178B\u17C4"},{"id":13674,"word":"\u179F\u17C1\u178E\u17B8"},{"id":13675,"word":"\u179F\u17C1\u178F"},{"id":13676,"word":"\u179F\u17C1\u178F --"},{"id":13677,"word":"\u179F\u17C1\u178F\u1798\u17D2\u1796\u179A"},{"id":13678,"word":"\u179F\u17C1\u178F\u1794\u178E\u17D2\u178E"},{"id":13679,"word":"\u179F\u17C1\u1791\u17C8"},{"id":13680,"word":"\u179F\u17C1\u1791\u1787"},{"id":13681,"word":"\u179F\u17C1\u1791\u17C4"},{"id":13682,"word":"\u179F\u17C1\u1793"},{"id":13683,"word":"\u179F\u17C1\u1793\u1794\u1791"},{"id":13684,"word":"\u179F\u17C1\u1793\u17B6"},{"id":13685,"word":"\u179F\u17C1\u1793\u17B6--"},{"id":13686,"word":"\u179F\u17C1\u1793\u17B6\u179F\u1793\u17C8"},{"id":13687,"word":"\u179F\u17C1\u1793\u17B6\u179F\u1793 --"},{"id":13688,"word":"\u179F\u17C1\u1793\u17B8\u1799\u17CD"},{"id":13689,"word":"\u179F\u17C1\u1793\u17D2\u178F"},{"id":13690,"word":"\u179F\u17C1\u1795\u17B6\u179B\u17B7\u1780\u17B6"},{"id":13691,"word":"\u179F\u17C1\u1796"},{"id":13692,"word":"\u179F\u17C1\u1798\u17D2\u17A0\u17C8"},{"id":13693,"word":"\u179F\u17C1\u1799\u17D2\u1799\u17B6 "},{"id":13694,"word":"\u179F\u17C1\u1799\u17D2\u1799\u17B6\u179F\u1793\u17CD"},{"id":13695,"word":"\u179F\u17C1\u179A"},{"id":13696,"word":"\u179F\u17C1\u179A"},{"id":13697,"word":"\u179F\u17C1\u179A\u1798\u17B6\u1793\u17CB"},{"id":13698,"word":"\u179F\u17C1\u179A\u17B7\u1793\u17B8"},{"id":13699,"word":"\u179F\u17C1\u179A\u17B8"},{"id":13700,"word":"\u179F\u17C1\u179B"},{"id":13701,"word":"\u179F\u17C1\u179B--"},{"id":13702,"word":"\u179F\u17C1\u179C"},{"id":13703,"word":"\u179F\u17C1\u179C\u1780\u17C8"},{"id":13704,"word":"\u179F\u17C1\u179C\u1780--"},{"id":13705,"word":"\u179F\u17C1\u179C\u1793\u17C8"},{"id":13706,"word":"\u179F\u17C1\u179C\u17B6\u179B"},{"id":13707,"word":"\u179F\u17C1\u179C\u17B7\u1780\u17B6"},{"id":13708,"word":"\u179F\u17C1\u179F"},{"id":13709,"word":"\u179F\u17C1\u179F\u179C\u1782\u17D2\u1782"},{"id":13710,"word":"\u179F\u17C1\u179F\u17B6"},{"id":13711,"word":"\u179F\u17C1\u179F\u17C6"},{"id":13712,"word":"\u179F\u17C1\u17C7"},{"id":13713,"word":"\u179F\u17C1\u17C7\u1796\u17B6\u1780\u17CB\u1794\u1784\u17D2\u1780\u1784\u17CB"},{"id":13714,"word":"\u179F\u17C2"},{"id":13715,"word":"\u179F\u17CA\u17C2"},{"id":13716,"word":"\u179F\u17C2\u1780"},{"id":13717,"word":"\u179F\u17C2\u1784"},{"id":13718,"word":"\u179F\u17C2\u1784\u1796\u17D2\u179A\u17C7\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799"},{"id":13719,"word":"\u179F\u17C2\u178A\u17B6"},{"id":13720,"word":"\u179F\u17C2\u178F"},{"id":13721,"word":"\u179F\u17C2\u178F\u17A2\u1789\u17D2\u1787\u1784\u17CB"},{"id":13722,"word":"\u179F\u17C2\u1793"},{"id":13723,"word":"\u179F\u17C2\u1793\u178F\u17D2\u179C\u17D0\u1793"},{"id":13724,"word":"\u179F\u17C2\u1793\u1791\u17D2\u179C\u17B8"},{"id":13725,"word":"\u179F\u17C2\u1793\u1794\u1791"},{"id":13726,"word":"\u179F\u17C2\u1793\u17D2\u1799"},{"id":13727,"word":"\u179F\u17CA\u17C2\u1798"},{"id":13728,"word":"\u179F\u17CA\u17C2\u179F \u1782\u17D2\u179A\u1798\u17C2\u179F"},{"id":13729,"word":"\u179F\u17C2\u179F\u17B7\u1794"},{"id":13730,"word":"\u179F\u17CA\u17C2\u17C7\u1796\u1797\u17D2\u179B\u17C2\u17C7"},{"id":13731,"word":"\u179F\u17C3\u1798\u1798\u17C9\u17C3"},{"id":13732,"word":"\u179F\u17C3\u1799"},{"id":13733,"word":"\u179F\u17C3\u1799\u17B6"},{"id":13734,"word":"\u179F\u17C3\u1799\u17B6\u179F\u1793\u17CD"},{"id":13735,"word":"\u179F\u17C3\u1799\u17C9\u17BA\u1793"},{"id":13736,"word":"\u179F\u17C4"},{"id":13737,"word":"\u179F\u17C4\u1780"},{"id":13738,"word":"\u179F\u17C4\u1780\u1782\u17D2\u179A\u17C4\u1780"},{"id":13739,"word":"\u179F\u17C4\u1780\u178F\u17D2\u179A\u17C4\u1780"},{"id":13740,"word":"\u179F\u17C4\u1780\u17D0\u1793\u17D2\u178F"},{"id":13741,"word":"\u179F\u17C4\u1780\u1794\u17C9\u178F\u17D2\u179A\u17C4\u1780"},{"id":13742,"word":"\u179F\u17C4\u1780\u1798\u1798\u17C9\u17C4\u1780"},{"id":13743,"word":"\u179F\u17C4\u1780\u17B6"},{"id":13744,"word":"\u179F\u17C4\u1780\u17B6\u1793\u17D2\u178F"},{"id":13745,"word":"\u179F\u17C4\u1780\u17B7\u1793\u17B8"},{"id":13746,"word":"\u179F\u17C4\u1780\u17B8"},{"id":13747,"word":"\u179F\u17C4\u1780\u17C0"},{"id":13748,"word":"\u179F\u17C4\u1782\u1793\u17D2\u1792\u17B7\u1780\u17C8"},{"id":13749,"word":"\u179F\u17C4\u1782\u1793\u17D2\u1792\u17B7\u1780\u17B6"},{"id":13750,"word":"\u179F\u17C4\u1782\u17D2\u179A\u17C4\u1780"},{"id":13751,"word":"\u179F\u17CA\u17C4\u1784 \u17A2\u17C6\u1796\u17C4\u1784"},{"id":13752,"word":"\u179F\u17C4\u1785"},{"id":13753,"word":"\u179F\u17C4\u178A\u17B6"},{"id":13754,"word":"\u179F\u17C4\u178F"},{"id":13755,"word":"\u179F\u17C4\u178F"},{"id":13756,"word":"\u179F\u17C4\u178F\u17B6"},{"id":13757,"word":"\u179F\u17C4\u178F\u17D2\u179A\u17C4"},{"id":13758,"word":"\u179F\u17C4\u178F\u17D2\u1790\u17B7\u1797\u17B6\u1796"},{"id":13759,"word":"\u179F\u17C4\u1791\u1780"},{"id":13760,"word":"\u179F\u17C4\u1791\u1780\u1794\u17B6\u1799\u17B6\u179F"},{"id":13761,"word":"\u179F\u17C4\u1791\u179A"},{"id":13762,"word":"\u179F\u17C4\u1791\u179A\u17B6"},{"id":13763,"word":"\u179F\u17C4\u1792\u1793"},{"id":13764,"word":"\u179F\u17C4\u1792\u1793\u17B8"},{"id":13765,"word":"\u179F\u17C4\u1794\u17C9\u178F\u17D2\u179A\u17C4"},{"id":13766,"word":"\u179F\u17C4\u1794\u17B6\u1793"},{"id":13767,"word":"\u179F\u17C4\u1797\u1782\u17D2\u1782"},{"id":13768,"word":"\u179F\u17C4\u1797\u17D0\u178E"},{"id":13769,"word":"\u179F\u17C4\u1797\u17B6"},{"id":13770,"word":"\u179F\u17C4\u1797\u17B7\u1793\u17B8"},{"id":13771,"word":"\u179F\u17C4\u1798"},{"id":13772,"word":"\u179F\u17C4\u1798\u1782\u17D2\u179A\u17C4\u17C7"},{"id":13773,"word":"\u179F\u17C4\u1798\u1793\u179F\u17D2\u179F"},{"id":13774,"word":"\u179F\u17C4\u1798\u1796\u17B6\u179A"},{"id":13775,"word":"\u179F\u17C4\u1798\u179B\u178F\u17B6"},{"id":13776,"word":"\u179F\u17C4\u1798\u179C\u179B\u17D2\u179B\u17B7"},{"id":13777,"word":"\u179F\u17C4\u1798\u179C\u17B6\u179A\u17C8"},{"id":13778,"word":"\u179F\u17C4\u1798\u17B6\u1793"},{"id":13779,"word":"\u179F\u17C4\u1799"},{"id":13780,"word":"\u179F\u17C4\u179A\u1796\u17B6\u179A"},{"id":13781,"word":"\u179F\u17C4\u179C\u178E\u17D2\u178E"},{"id":13782,"word":"\u179F\u17C4\u179C\u178E\u17D2\u178E\u1798\u17D0\u1799"},{"id":13783,"word":"\u179F\u17C4\u179F\u17B7"},{"id":13784,"word":"\u179F\u17C4\u17A0\u17CA\u17BB\u1799"},{"id":13785,"word":"\u179F\u17C4\u17A1\u179F"},{"id":13786,"word":"\u179F\u17C4\u17C7"},{"id":13787,"word":"\u179F\u17C4\u17C7\u179F\u17B6"},{"id":13788,"word":"\u179F\u17C4\u17C7\u17A2\u1784\u17D2\u1782\u17BE\u1799"},{"id":13789,"word":"\u179F\u17C5"},{"id":13790,"word":"\u179F\u17C5\u1780\u17C2"},{"id":13791,"word":"\u179F\u17C5\u1782\u1793\u17D2\u1792"},{"id":13792,"word":"\u179F\u17C5\u1787\u17C3"},{"id":13793,"word":"\u179F\u17C5\u178A\u17C5"},{"id":13794,"word":"\u179F\u17C5\u1797\u17B6\u1782\u17D2\u1799"},{"id":13795,"word":"\u179F\u17C5\u1798\u17C9\u1784"},{"id":13796,"word":"\u179F\u17C5\u179A\u17CD"},{"id":13797,"word":"\u179F\u17C5\u179A\u17D0\u1797"},{"id":13798,"word":"\u179F\u17C5\u179A\u1797\u17B6"},{"id":13799,"word":"\u179F\u17C5\u179A\u179F\u17C1\u1793\u17B8"},{"id":13800,"word":"\u179F\u17C5\u179C\u1782\u1793\u17D2\u1792"},{"id":13801,"word":"\u179F\u17C5\u179C\u178F\u17B6\u179A"},{"id":13802,"word":"\u179F\u17C5\u179C\u1793\u17B8\u1799\u17CD"},{"id":13803,"word":"\u179F\u17C5\u179C\u1797\u17B6"},{"id":13804,"word":"\u179F\u17C5\u179C\u1797\u17B6\u1782\u17D2\u1799"},{"id":13805,"word":"\u179F\u17C5\u179C\u179B\u1780\u17D2\u179F\u178E\u17CD"},{"id":13806,"word":"\u179F\u17C5\u179F\u17C4\u1780"},{"id":13807,"word":"\u179F\u17C5\u17A0\u17D2\u1798\u1784"},{"id":13808,"word":"\u179F\u17C5\u17A0\u17D2\u17AB\u1791"},{"id":13809,"word":"\u179F\u17C5\u17A1\u17B9\u1780"},{"id":13810,"word":"\u179F\u17BB\u17C6"},{"id":13811,"word":"\u179F\u17C6"},{"id":13812,"word":"\u179F\u17C6\u1780\u1780"},{"id":13813,"word":"\u179F\u17C6\u1780\u17B6\u1780"},{"id":13814,"word":"\u179F\u17C6\u1780\u17BB\u1780"},{"id":13815,"word":"\u179F\u17C6\u1780\u17BB\u1784"},{"id":13816,"word":"\u179F\u17C6\u1780\u17BB\u179B"},{"id":13817,"word":"\u179F\u17C6\u1780\u17BC\u1789"},{"id":13818,"word":"\u179F\u17C6\u1780\u17BC\u179C"},{"id":13819,"word":"\u179F\u17C6\u1780\u17C1\u1780"},{"id":13820,"word":"\u179F\u17C6\u1780\u17C4\u1780"},{"id":13821,"word":"\u179F\u17C6\u1780\u17B6\u17C6\u1784"},{"id":13822,"word":"\u179F\u17C6\u1781\u17B6\u1793\u17CB"},{"id":13823,"word":"\u179F\u17C6\u1781\u17D2\u1799\u17B6"},{"id":13824,"word":"\u179F\u17C6\u1781\u17D2\u1799\u17B6\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":13825,"word":"\u179F\u17C6\u1782\u1798"},{"id":13826,"word":"\u179F\u17C6\u1782\u17B6\u179B\u17CB"},{"id":13827,"word":"\u179F\u17C6\u1782\u17B7\u179F"},{"id":13828,"word":"\u179F\u17C6\u1782\u17B8\u1798"},{"id":13829,"word":"\u179F\u17C6\u1782\u17BB\u179B"},{"id":13830,"word":"\u179F\u17C6\u1782\u17C2\u1798"},{"id":13831,"word":"\u179F\u17C6\u1782\u17C4\u1780"},{"id":13832,"word":"\u179F\u17C6\u1782\u17B6\u17C6\u1784"},{"id":13833,"word":"\u179F\u17C6\u1784\u17B6\u1785"},{"id":13834,"word":"\u179F\u17C6\u1784\u17B6\u178F\u17CB"},{"id":13835,"word":"\u179F\u17C6\u1784\u17BE\u1785"},{"id":13836,"word":"\u179F\u17C6\u1784\u17C6"},{"id":13837,"word":"\u179F\u17C6\u1785\u178F"},{"id":13838,"word":"\u179F\u17C6\u1785\u17D0\u1799"},{"id":13839,"word":"\u179F\u17C6\u1785\u17C2"},{"id":13840,"word":"\u179F\u17C6\u1785\u17C3"},{"id":13841,"word":"\u179F\u17C6\u1789\u17C5"},{"id":13842,"word":"\u179F\u17C6\u178A\u17B7\u179B"},{"id":13843,"word":"\u179F\u17C6\u178A\u17B8"},{"id":13844,"word":"\u179F\u17C6\u178A\u17B9\u1784"},{"id":13845,"word":"\u179F\u17C6\u178A\u17BA\u178F"},{"id":13846,"word":"\u179F\u17C6\u178A\u17BE\u1784"},{"id":13847,"word":"\u179F\u17C6\u178A\u17C2\u1784"},{"id":13848,"word":"\u179F\u17C6\u178A\u17C4\u17C7 "},{"id":13849,"word":"\u179F\u17C6\u178A\u17C5"},{"id":13850,"word":"\u179F\u17C6\u178E"},{"id":13851,"word":"\u179F\u17C6\u178E\u1780"},{"id":13852,"word":"\u179F\u17C6\u178E\u1784"},{"id":13853,"word":"\u179F\u17C6\u178E\u1784\u17CB"},{"id":13854,"word":"\u179F\u17C6\u178E\u1796\u17D2\u179C"},{"id":13855,"word":"\u179F\u17C6\u178E\u179B\u17CB"},{"id":13856,"word":"\u179F\u17C6\u178E\u17B6\u1780"},{"id":13857,"word":"\u179F\u17C6\u178E\u17B6\u1780\u17CB"},{"id":13858,"word":"\u179F\u17C6\u178E\u17B6\u1784"},{"id":13859,"word":"\u179F\u17C6\u178E\u17B6\u1789"},{"id":13860,"word":"\u179F\u17C6\u178E\u17B6\u1789\u17CB"},{"id":13861,"word":"\u179F\u17C6\u178E\u17B6\u1789\u17CB\u1789\u17B6\u178E"},{"id":13862,"word":"\u179F\u17C6\u178E\u17B6\u178A\u17C3"},{"id":13863,"word":"\u179F\u17C6\u178E\u17B6\u178F\u17CB"},{"id":13864,"word":"\u179F\u17C6\u178E\u17B6\u1794"},{"id":13865,"word":"\u179F\u17C6\u178E\u17B6\u1798"},{"id":13866,"word":"\u179F\u17C6\u178E\u17B7\u1784"},{"id":13867,"word":"\u179F\u17C6\u178E\u17B9\u1780"},{"id":13868,"word":"\u179F\u17C6\u178E\u17BB\u179F"},{"id":13869,"word":"\u179F\u17C6\u178E\u17BB\u17C7"},{"id":13870,"word":"\u179F\u17C6\u178E\u17BC\u1780"},{"id":13871,"word":"\u179F\u17C6\u178E\u17BC\u1798"},{"id":13872,"word":"\u179F\u17C6\u178E\u17BD\u179A"},{"id":13873,"word":"\u179F\u17C6\u178E\u17BE\u1785"},{"id":13874,"word":"\u179F\u17C6\u178E\u17BE\u1798"},{"id":13875,"word":"\u179F\u17C6\u178E\u17BE"},{"id":13876,"word":"\u179F\u17C6\u178E\u17C1\u17C7"},{"id":13877,"word":"\u179F\u17C6\u178E\u17C1\u17C7\u179F\u17C6\u178E\u17B6\u179B"},{"id":13878,"word":"\u179F\u17C6\u178E\u17C2\u1793"},{"id":13879,"word":"\u179F\u17C6\u178E\u17C2\u1796"},{"id":13880,"word":"\u179F\u17C6\u178E\u17C2\u179F"},{"id":13881,"word":"\u179F\u17C6\u178E\u17C4\u1780"},{"id":13882,"word":"\u179F\u17C6\u178E\u17C5"},{"id":13883,"word":"\u179F\u17C6\u178E\u17BB\u17C6"},{"id":13884,"word":"\u179F\u17C6\u178E\u17C6"},{"id":13885,"word":"\u179F\u17C6\u178F\u178F"},{"id":13886,"word":"\u179F\u17C6\u178F\u17BB\u179B"},{"id":13887,"word":"\u179F\u17C6\u178F\u17C1\u178F"},{"id":13888,"word":"\u179F\u17C6\u178F\u17C2\u1780"},{"id":13889,"word":"\u179F\u17C6\u178F\u17C4\u1780"},{"id":13890,"word":"\u179F\u17C6\u1791\u1780\u17CB"},{"id":13891,"word":"\u179F\u17C6\u1791\u1784\u17CB"},{"id":13892,"word":"\u179F\u17C6\u1791\u179B"},{"id":13893,"word":"\u179F\u17C6\u1791\u17B6\u1789"},{"id":13894,"word":"\u179F\u17C6\u1791\u17B6\u179A"},{"id":13895,"word":"\u179F\u17C6\u1791\u17B8\u1780"},{"id":13896,"word":"\u179F\u17C6\u1791\u17BB\u17C7"},{"id":13897,"word":"\u179F\u17C6\u1791\u17BB\u17C7\u1780\u17D2\u17A2\u17C2\u1780"},{"id":13898,"word":"\u179F\u17C6\u1791\u17BC\u1784"},{"id":13899,"word":"\u179F\u17C6\u1791\u17BE\u1789"},{"id":13900,"word":"\u179F\u17C6\u1791\u17C1\u17C7"},{"id":13901,"word":"\u179F\u17C6\u1791\u17C2\u179B"},{"id":13902,"word":"\u179F\u17C6\u1791\u17C2\u17C7"},{"id":13903,"word":"\u179F\u17C6\u1793\u17B9\u1780"},{"id":13904,"word":"\u179F\u17C6\u1793\u17BD\u1793"},{"id":13905,"word":"\u179F\u17C6\u1793\u17C0\u1784"},{"id":13906,"word":"\u179F\u17C6\u1794\u1780"},{"id":13907,"word":"\u179F\u17C6\u1794\u1790"},{"id":13908,"word":"\u179F\u17C6\u1794\u17B6"},{"id":13909,"word":"\u179F\u17C6\u1794\u17B6\u1785\u17CB"},{"id":13910,"word":"\u179F\u17C6\u1794\u17C9\u17B6\u178F"},{"id":13911,"word":"\u179F\u17C6\u1794\u17C9\u17B6\u1793"},{"id":13912,"word":"\u179F\u17C6\u1794\u17B6\u179A"},{"id":13913,"word":"\u179F\u17C6\u1794\u17BB\u1780"},{"id":13914,"word":"\u179F\u17C6\u1794\u17BB\u1780\u1785\u17B6\u1794"},{"id":13915,"word":"\u179F\u17C6\u1794\u17BB\u1780\u1791\u17D2\u179A\u1799\u17BB\u1780"},{"id":13916,"word":"\u179F\u17C6\u1794\u17BB\u178A"},{"id":13917,"word":"\u179F\u17C6\u1794\u17BB\u178F\u17D2\u179A"},{"id":13918,"word":"\u179F\u17C6\u1794\u17BC\u1784\u179F\u1784\u17D2\u179A\u17BC\u1784"},{"id":13919,"word":"\u179F\u17C6\u1794\u17BD\u179A"},{"id":13920,"word":"\u179F\u17C6\u1794\u17BD\u179A\u1780\u1780\u17CB"},{"id":13921,"word":"\u179F\u17C6\u1794\u17C2\u1784"},{"id":13922,"word":"\u179F\u17C6\u1794\u17C9\u17C2\u178F"},{"id":13923,"word":"\u179F\u17C6\u1794\u17C4\u179A"},{"id":13924,"word":"\u179F\u17C6\u1795\u17B7\u1784"},{"id":13925,"word":"\u179F\u17C6\u1795\u17BB\u179B\u17D2\u179B"},{"id":13926,"word":"\u179F\u17C6\u1796\u1784"},{"id":13927,"word":"\u179F\u17C6\u1796\u1784\u17CB"},{"id":13928,"word":"\u179F\u17C6\u1796\u178F\u17CB"},{"id":13929,"word":"\u179F\u17C6\u1796\u17D0\u179A"},{"id":13930,"word":"\u179F\u17C6\u1796\u17B6\u1799"},{"id":13931,"word":"\u179F\u17C6\u1796\u17B7\u1793"},{"id":13932,"word":"\u179F\u17C6\u1796\u17B8\u1784"},{"id":13933,"word":"\u179F\u17C6\u1796\u17B9\u1780"},{"id":13934,"word":"\u179F\u17C6\u1796\u17BB\u1784"},{"id":13935,"word":"\u179F\u17C6\u1796\u17BC"},{"id":13936,"word":"\u179F\u17C6\u1796\u17C0\u178F"},{"id":13937,"word":"\u179F\u17C6\u1796\u17C1\u17C7"},{"id":13938,"word":"\u179F\u17C6\u1796\u17C2\u17C7"},{"id":13939,"word":"\u179F\u17C6\u1796\u17C4\u1784"},{"id":13940,"word":"\u179F\u17C6\u1796\u17C4\u1785"},{"id":13941,"word":"\u179F\u17C6\u1796\u17C5"},{"id":13942,"word":"\u179F\u17C6\u1796\u17C5\u1790\u1799"},{"id":13943,"word":"\u179F\u17C6\u1796\u17C7"},{"id":13944,"word":"\u179F\u17C6\u1796\u17D2\u179A\u17BB\u179F"},{"id":13945,"word":"\u179F\u17C6\u1796\u17D2\u179A\u17C4"},{"id":13946,"word":"\u179F\u17C6\u1797\u17B8"},{"id":13947,"word":"\u179F\u17C6\u1797\u17C4\u179A"},{"id":13948,"word":"\u179F\u17C6\u1799\u17B6\u1780"},{"id":13949,"word":"\u179F\u17C6\u1799\u17B6\u1794"},{"id":13950,"word":"\u179F\u17C6\u1799\u17B6\u1799"},{"id":13951,"word":"\u179F\u17C6\u1799\u17BB\u1784"},{"id":13952,"word":"\u179F\u17C6\u1799\u17C1\u17C7"},{"id":13953,"word":"\u179F\u17C6\u1799\u17C4\u1782"},{"id":13954,"word":"\u179F\u17C6\u1799\u17C4\u1782\u179F\u1789\u17D2\u1789\u17B6"},{"id":13955,"word":"\u179F\u17C6\u1799\u17C4\u1787\u1793\u17C8"},{"id":13956,"word":"\u179F\u17C6\u179A\u1784"},{"id":13957,"word":"\u179F\u17C6\u179A\u17B6\u1787"},{"id":13958,"word":"\u179F\u17C6\u179A\u17B6\u1798"},{"id":13959,"word":"\u179F\u17C6\u179A\u17B9\u1791\u17D2\u1792"},{"id":13960,"word":"\u179F\u17C6\u179A\u17B9\u1791\u17D2\u1792\u17B7--"},{"id":13961,"word":"\u179F\u17C6\u179A\u17B9\u1791\u17D2\u1792\u17B8"},{"id":13962,"word":"\u179F\u17C6\u179A\u17BB\u1784"},{"id":13963,"word":"\u179F\u17C6\u179A\u17BC\u1794"},{"id":13964,"word":"\u179F\u17C6\u179A\u17C0\u1798"},{"id":13965,"word":"\u179F\u17C6\u179A\u17C2"},{"id":13966,"word":"\u179F\u17C6\u179A\u17C4\u1784"},{"id":13967,"word":"\u179F\u17C6\u17AB\u1791\u17D2\u1792"},{"id":13968,"word":"\u179F\u17C6\u17AB\u1791\u17D2\u1792\u17B8"},{"id":13969,"word":"\u179F\u17C6\u179B\u17C0\u1784"},{"id":13970,"word":"\u179F\u17C6\u179C\u179A"},{"id":13971,"word":"\u179F\u17C6\u179C\u179A\u17B8"},{"id":13972,"word":"\u179F\u17C6\u179C\u17B6\u179F"},{"id":13973,"word":"\u179F\u17C6\u179C\u17B6\u179F\u1793\u17B6\u179F\u1793\u17B6"},{"id":13974,"word":"\u179F\u17C6\u179C\u17C1\u1782"},{"id":13975,"word":"\u179F\u17C6\u179C\u17C1\u1787\u1793\u17B8\u1799"},{"id":13976,"word":"\u179F\u17C6\u179F\u1793\u17D2\u1791\u1793\u17B6"},{"id":13977,"word":"\u179F\u17C6\u179F\u1799\u178F\u17D2\u1790\u1793\u17B7\u1794\u17B6\u178F"},{"id":13978,"word":"\u179F\u17C6\u179F\u1799\u178F\u17D2\u1790\u179C\u17B6\u1785\u1780"},{"id":13979,"word":"\u179F\u17C6\u179F\u17B6\u179A\u17C8"},{"id":13980,"word":"\u179F\u17C6\u179F\u17B6\u179A"},{"id":13981,"word":"\u179F\u17C6\u179F\u17C1\u1791\u1787"},{"id":13982,"word":"\u179F\u17C6\u179F\u17C2"},{"id":13983,"word":"\u179F\u17C6\u179F\u17D2\u1780\u17B6\u179A"},{"id":13984,"word":"\u179F\u17C6\u179F\u17D2\u1780\u17D2\u179A\u17B9\u178F"},{"id":13985,"word":"\u179F\u17C6\u17A0\u17B6\u179A\u17B7\u1798"},{"id":13986,"word":"\u179F\u17C6\u17A1\u17B6\u1789"},{"id":13987,"word":"\u179F\u17C6\u17A1\u17B8"},{"id":13988,"word":"\u179F\u17C6\u17A1\u17C1\u1784"},{"id":13989,"word":"\u179F\u17C6\u17A1\u17C1\u17C7"},{"id":13990,"word":"\u179F\u17C6\u17A1\u17C2\u17C7"},{"id":13991,"word":"\u179F\u17C6\u17A2\u1780"},{"id":13992,"word":"\u179F\u17C6\u17A2\u1794\u17CB"},{"id":13993,"word":"\u179F\u17C6\u17A2\u1794\u17CB\u1796\u17BB\u178F"},{"id":13994,"word":"\u179F\u17C6\u17A2\u17B6\u1784"},{"id":13995,"word":"\u179F\u17C6\u17A2\u17B6\u178F"},{"id":13996,"word":"\u179F\u17C6\u17A2\u17B7\u178F"},{"id":13997,"word":"\u179F\u17C6\u17A2\u17BB\u1799"},{"id":13998,"word":"\u179F\u17C6\u17A2\u17BB\u17C7"},{"id":13999,"word":"\u179F\u17C6\u17A2\u17C1\u1780"},{"id":14000,"word":"\u179F\u17C6\u17A2\u17C2\u1780"},{"id":14001,"word":"\u179F\u17C6\u17A2\u17C2\u179B"},{"id":14002,"word":"\u179F\u17C6\u17A2\u17C4\u1780"},{"id":14003,"word":"\u179F\u17B6\u17C6"},{"id":14004,"word":"\u179F\u17CA\u17B6\u17C6"},{"id":14005,"word":"\u179F\u17B6\u17C6\u1784"},{"id":14006,"word":"\u179F\u17B6\u17C6\u1784\u17D2\u1780\u179F\u17B8"},{"id":14007,"word":"\u179F\u17B6\u17C6\u1789\u17C9\u17B6\u17C6"},{"id":14008,"word":"\u179F\u17B6\u17C6\u178A\u17C2\u179B"},{"id":14009,"word":"\u179F\u17B6\u17C6\u1791\u17B6\u17C6"},{"id":14010,"word":"\u179F\u17B6\u17C6\u1794\u17C9\u17C3\u179F\u17B6\u17C6\u1798\u17C9\u17B6"},{"id":14011,"word":"\u179F\u17B6\u17C6\u1798\u178E\u17C4\u1782\u17D2\u179A\u17BD"},{"id":14012,"word":"\u179F\u17CA\u17B6\u17C6\u179F\u17CA\u1793"},{"id":14013,"word":"\u179F\u17C7"},{"id":14014,"word":"\u179F\u17D2\u1780\u1780"},{"id":14015,"word":"\u179F\u17D2\u1780\u1793\u17D2\u1791"},{"id":14016,"word":"\u179F\u17D2\u1780\u1793\u17D2\u1792"},{"id":14017,"word":"\u179F\u17D2\u1780\u1793\u17D2\u1792\u17B6\u1796\u17B6\u179A"},{"id":14018,"word":"\u179F\u17D2\u1780\u1794\u17CB"},{"id":14019,"word":"\u179F\u17D2\u1780\u179A"},{"id":14020,"word":"\u179F\u17D2\u1780\u179B\u17CB"},{"id":14021,"word":"\u179F\u17D2\u1780\u17B6"},{"id":14022,"word":"\u179F\u17D2\u1780\u17B6\u1780"},{"id":14023,"word":"\u179F\u17D2\u1780\u17B6\u1789"},{"id":14024,"word":"\u179F\u17D2\u1780\u17B6\u178F"},{"id":14025,"word":"\u179F\u17D2\u1780\u17B6\u178F\u17CB"},{"id":14026,"word":"\u179F\u17D2\u1780\u17B6\u179A"},{"id":14027,"word":"\u179F\u17D2\u1780\u17B6\u179B"},{"id":14028,"word":"\u179F\u17D2\u1780\u17B7\u179B"},{"id":14029,"word":"\u179F\u17D2\u1780\u17B9\u1798\u179F\u17D2\u1780\u17C3"},{"id":14030,"word":"\u179F\u17D2\u1780\u17BB\u1784"},{"id":14031,"word":"\u179F\u17D2\u1780\u17BB\u1793"},{"id":14032,"word":"\u179F\u17D2\u1780\u17BB\u1799"},{"id":14033,"word":"\u179F\u17D2\u1780\u17BB\u179B"},{"id":14034,"word":"\u179F\u17D2\u1780\u17BC\u1789"},{"id":14035,"word":"\u179F\u17D2\u1780\u17BC\u179C"},{"id":14036,"word":"\u179F\u17D2\u1780\u17BC\u179C\u179B\u179B\u1780"},{"id":14037,"word":"\u179F\u17D2\u1780\u17BD\u1799"},{"id":14038,"word":"\u179F\u17D2\u1780\u17BE\u1780"},{"id":14039,"word":"\u179F\u17D2\u1780\u17C0\u1794"},{"id":14040,"word":"\u179F\u17D2\u1780\u17B6\u17C6"},{"id":14041,"word":"\u179F\u17D2\u1780\u17C7"},{"id":14042,"word":"\u179F\u17D2\u1782\u1793\u17CB"},{"id":14043,"word":"\u179F\u17D2\u1782\u1793\u17CB\u1791\u17C6\u1793\u1794\u17CB"},{"id":14044,"word":"\u179F\u17D2\u1782\u1798"},{"id":14045,"word":"\u179F\u17D2\u1782\u179A"},{"id":14046,"word":"\u179F\u17D2\u1782\u17B6"},{"id":14047,"word":"\u179F\u17D2\u1782\u17B6\u1780\u17CB"},{"id":14048,"word":"\u179F\u17D2\u1782\u17B6\u1799"},{"id":14049,"word":"\u179F\u17D2\u1782\u17B6\u179A"},{"id":14050,"word":"\u179F\u17D2\u1782\u17B6\u179B\u17CB"},{"id":14051,"word":"\u179F\u17D2\u1782\u17B9\u17C7"},{"id":14052,"word":"\u179F\u17D2\u1782\u17BA"},{"id":14053,"word":"\u179F\u17D2\u1782\u17BB\u1799"},{"id":14054,"word":"\u179F\u17D2\u1782\u17BB\u179B"},{"id":14055,"word":"\u179F\u17D2\u1782\u17BB\u179F"},{"id":14056,"word":"\u179F\u17D2\u1782\u17BB\u17C7"},{"id":14057,"word":"\u179F\u17D2\u1782\u17BD\u1799"},{"id":14058,"word":"\u179F\u17D2\u1782\u17C4\u1780"},{"id":14059,"word":"\u179F\u17D2\u1782\u17B6\u17C6\u1784"},{"id":14060,"word":"\u179F\u17D2\u1784\u1794\u17CB"},{"id":14061,"word":"\u179F\u17D2\u1784\u17B6\u1785"},{"id":14062,"word":"\u179F\u17D2\u1784\u17B6\u178F\u17CB"},{"id":14063,"word":"\u179F\u17D2\u1784\u17B6\u1794"},{"id":14064,"word":"\u179F\u17D2\u1784\u17BD\u178F"},{"id":14065,"word":"\u179F\u17D2\u1784\u17BD\u1793"},{"id":14066,"word":"\u179F\u17D2\u1784\u17BE\u1780"},{"id":14067,"word":"\u179F\u17D2\u1784\u17BE\u1785"},{"id":14068,"word":"\u179F\u17D2\u1784\u17BE\u1793"},{"id":14069,"word":"\u179F\u17D2\u1784\u17C0\u1798"},{"id":14070,"word":"\u179F\u17D2\u1784\u17C4\u179A"},{"id":14071,"word":"\u179F\u17D2\u1789\u1780\u17CB"},{"id":14072,"word":"\u179F\u17D2\u1789\u1794\u17CB"},{"id":14073,"word":"\u179F\u17D2\u1789\u17B6\u1789"},{"id":14074,"word":"\u179F\u17D2\u1789\u17B6\u1789\u1791\u17D2\u179A\u17B6"},{"id":14075,"word":"\u179F\u17D2\u1789\u17B7\u1789"},{"id":14076,"word":"\u179F\u17D2\u1789\u17BB\u1780"},{"id":14077,"word":"\u179F\u17D2\u1789\u17BB\u1780\u179F\u17D2\u1789\u17BC\u179C"},{"id":14078,"word":"\u179F\u17D2\u1789\u17BB\u179A"},{"id":14079,"word":"\u179F\u17D2\u1789\u17BC\u1789"},{"id":14080,"word":"\u179F\u17D2\u1789\u17BE\u1794"},{"id":14081,"word":"\u179F\u17D2\u1789\u17C1\u1789"},{"id":14082,"word":"\u179F\u17D2\u1789\u17C2"},{"id":14083,"word":"\u179F\u17D2\u1789\u17C2\u1784"},{"id":14084,"word":"\u179F\u17D2\u1789\u17C4\u179A"},{"id":14085,"word":"\u179F\u17D2\u178A"},{"id":14086,"word":"\u179F\u17D2\u178A\u1793"},{"id":14087,"word":"\u179F\u17D2\u178A\u1798\u17D2\u1797"},{"id":14088,"word":"\u179F\u17D2\u178A\u17B6\u1794\u17CB"},{"id":14089,"word":"\u179F\u17D2\u178A\u17B6\u1799"},{"id":14090,"word":"\u179F\u17D2\u178A\u17B6\u179A"},{"id":14091,"word":"\u179F\u17D2\u178A\u17B8"},{"id":14092,"word":"\u179F\u17D2\u178A\u17B9\u1784"},{"id":14093,"word":"\u179F\u17D2\u178A\u17BA\u178F"},{"id":14094,"word":"\u179F\u17D2\u178A\u17BB\u1780"},{"id":14095,"word":"\u179F\u17D2\u178A\u17BB\u1780\u179F\u17D2\u178A\u17BB\u179A"},{"id":14096,"word":"\u179F\u17D2\u178A\u17BC\u1780"},{"id":14097,"word":"\u179F\u17D2\u178A\u17BD\u1785"},{"id":14098,"word":"\u179F\u17D2\u178A\u17BE\u1784"},{"id":14099,"word":"\u179F\u17D2\u178A\u17C0\u1784"},{"id":14100,"word":"\u179F\u17D2\u178A\u17C0\u1793"},{"id":14101,"word":"\u179F\u17D2\u178A\u17C1\u1785"},{"id":14102,"word":"\u179F\u17D2\u178A\u17C1\u1785\u1785\u1784\u17CB"},{"id":14103,"word":"\u179F\u17D2\u178A\u17C1\u1785\u178A\u17BE\u179A"},{"id":14104,"word":"\u179F\u17D2\u178A\u17C1\u1785\u178F\u17D2\u179A\u17B6\u1789\u17CB"},{"id":14105,"word":"\u179F\u17D2\u178A\u17C1\u1785\u1795\u17D2\u1791\u17C6"},{"id":14106,"word":"\u179F\u17D2\u178A\u17C2\u1784"},{"id":14107,"word":"\u179F\u17D2\u178A\u17C4\u17C7"},{"id":14108,"word":"\u179F\u17D2\u178A\u17C5"},{"id":14109,"word":"\u179F\u17D2\u178A\u17B6\u17C6"},{"id":14110,"word":"\u179F\u17D2\u178F\u178F"},{"id":14111,"word":"\u179F\u17D2\u178F\u1793\u17B7\u1780\u179F\u178F\u17D2\u179C"},{"id":14112,"word":"\u179F\u17D2\u178F\u17B6"},{"id":14113,"word":"\u179F\u17D2\u178F\u17B9\u1780"},{"id":14114,"word":"\u179F\u17D2\u178F\u17BB\u1780"},{"id":14115,"word":"\u179F\u17D2\u178F\u17BB\u178F\u17B7"},{"id":14116,"word":"\u179F\u17D2\u178F\u17BB\u178F\u17B7--"},{"id":14117,"word":"\u179F\u17D2\u178F\u17BB\u179B"},{"id":14118,"word":"\u179F\u17D2\u178F\u17BC\u1794"},{"id":14119,"word":"\u179F\u17D2\u178F\u17BC\u1794\u17C8"},{"id":14120,"word":"\u179F\u17D2\u178F\u17C1\u178F"},{"id":14121,"word":"\u179F\u17D2\u178F\u17C2\u1780"},{"id":14122,"word":"\u179F\u17D2\u178F\u17C2\u178F"},{"id":14123,"word":"\u179F\u17D2\u178F\u17C4"},{"id":14124,"word":"\u179F\u17D2\u178F\u17C4\u1780"},{"id":14125,"word":"\u179F\u17D2\u178F\u17C4\u1798\u1793\u17B6\u1780\u17B6\u179A"},{"id":14126,"word":"\u179F\u17D2\u178F\u17D2\u179A\u17B8"},{"id":14127,"word":"\u179F\u17D2\u178F\u17D2\u179A\u17B8 --"},{"id":14128,"word":"\u179F\u17D2\u1790\u179C\u17B7\u179A\u17C8"},{"id":14129,"word":"\u179F\u17D2\u1790\u17B6\u1793"},{"id":14130,"word":"\u179F\u17D2\u1790\u17B6\u1793\u17B8\u1799"},{"id":14131,"word":"\u179F\u17D2\u1790\u17B6\u1794\u1793\u17C8"},{"id":14132,"word":"\u179F\u17D2\u1790\u17B6\u1794\u1793\u1780\u1798\u17D2\u1798"},{"id":14133,"word":"\u179F\u17D2\u1790\u17B6\u1794\u1793\u17B7\u1780"},{"id":14134,"word":"\u179F\u17D2\u1790\u17B6\u1794\u1793\u17B7\u1780\u17B6"},{"id":14135,"word":"\u179F\u17D2\u1790\u17B6\u1796\u179A"},{"id":14136,"word":"\u179F\u17D2\u1790\u17B6\u179C\u179A --"},{"id":14137,"word":"\u179F\u17D2\u1790\u17B7\u178F"},{"id":14138,"word":"\u179F\u17D2\u1790\u17B7\u178F\u17B7"},{"id":14139,"word":"\u179F\u17D2\u1790\u17B7\u178F\u17B7 --"},{"id":14140,"word":"\u179F\u17D2\u1790\u17B7\u179A"},{"id":14141,"word":"\u179F\u17D2\u1791\u1780\u17CB"},{"id":14142,"word":"\u179F\u17D2\u1791\u1784"},{"id":14143,"word":"\u179F\u17D2\u1791\u1784\u17CB"},{"id":14144,"word":"\u179F\u17D2\u1791\u1793\u17CB"},{"id":14145,"word":"\u179F\u17D2\u1791\u1794"},{"id":14146,"word":"\u179F\u17D2\u1791\u1794\u17CB"},{"id":14147,"word":"\u179F\u17D2\u1791\u179B"},{"id":14148,"word":"\u179F\u17D2\u1791\u179B\u17CB"},{"id":14149,"word":"\u179F\u17D2\u1791\u17B6"},{"id":14150,"word":"\u179F\u17D2\u1791\u17B6\u1780\u17CB"},{"id":14151,"word":"\u179F\u17D2\u1791\u17B6\u1780\u17CB\u179F\u17D2\u1791\u17BE\u179A"},{"id":14152,"word":"\u179F\u17D2\u1791\u17B6\u1789"},{"id":14153,"word":"\u179F\u17D2\u1791\u17B6\u178F\u17CB"},{"id":14154,"word":"\u179F\u17D2\u1791\u17B6\u1794"},{"id":14155,"word":"\u179F\u17D2\u1791\u17B6\u179B\u17CB"},{"id":14156,"word":"\u179F\u17D2\u1791\u17B6\u179C"},{"id":14157,"word":"\u179F\u17D2\u1791\u17B7\u179B"},{"id":14158,"word":"\u179F\u17D2\u1791\u17B8\u1780"},{"id":14159,"word":"\u179F\u17D2\u1791\u17B9\u1784"},{"id":14160,"word":"\u179F\u17D2\u1791\u17B9\u1798"},{"id":14161,"word":"\u179F\u17D2\u1791\u17B9\u179B"},{"id":14162,"word":"\u179F\u17D2\u1791\u17BB\u1784"},{"id":14163,"word":"\u179F\u17D2\u1791\u17BB\u1799"},{"id":14164,"word":"\u179F\u17D2\u1791\u17BB\u179B\u17D7"},{"id":14165,"word":"\u179F\u17D2\u1791\u17BB\u17C7"},{"id":14166,"word":"\u179F\u17D2\u1791\u17BC\u1784"},{"id":14167,"word":"\u179F\u17D2\u1791\u17BC\u1785"},{"id":14168,"word":"\u179F\u17D2\u1791\u17BC\u179A"},{"id":14169,"word":"\u179F\u17D2\u1791\u17BD\u1793"},{"id":14170,"word":"\u179F\u17D2\u1791\u17BD\u1799"},{"id":14171,"word":"\u179F\u17D2\u1791\u17BE\u1784"},{"id":14172,"word":"\u179F\u17D2\u1791\u17BE\u1789"},{"id":14173,"word":"\u179F\u17D2\u1791\u17BE\u178F"},{"id":14174,"word":"\u179F\u17D2\u1791\u17BE\u179A"},{"id":14175,"word":"\u179F\u17D2\u1791\u17BE\u179A\u1780\u17C4\u17C7"},{"id":14176,"word":"\u179F\u17D2\u1791\u17BE\u179A\u1780\u17C6\u178E\u17BE\u178F"},{"id":14177,"word":"\u179F\u17D2\u1791\u17C0\u1784"},{"id":14178,"word":"\u179F\u17D2\u1791\u17C1\u1784"},{"id":14179,"word":"\u179F\u17D2\u1791\u17C1\u1789"},{"id":14180,"word":"\u179F\u17D2\u1791\u17C1\u17C7"},{"id":14181,"word":"\u179F\u17D2\u1791\u17C2"},{"id":14182,"word":"\u179F\u17D2\u1791\u17C2\u178F"},{"id":14183,"word":"\u179F\u17D2\u1791\u17C2\u179B"},{"id":14184,"word":"\u179F\u17D2\u1791\u17C2\u17C7"},{"id":14185,"word":"\u179F\u17D2\u1791\u17C3"},{"id":14186,"word":"\u179F\u17D2\u1791\u17C4\u1780"},{"id":14187,"word":"\u179F\u17D2\u1791\u17C4\u1784"},{"id":14188,"word":"\u179F\u17D2\u1791\u17C4\u17C7"},{"id":14189,"word":"\u179F\u17D2\u1791\u17C6"},{"id":14190,"word":"\u179F\u17D2\u1791\u17B6\u17C6\u1784"},{"id":14191,"word":"\u179F\u17D2\u1791\u17B6\u17C6\u1784\u17A0\u17BE\u179A"},{"id":14192,"word":"\u179F\u17D2\u1791\u17C7"},{"id":14193,"word":"\u179F\u17D2\u1793"},{"id":14194,"word":"\u179F\u17D2\u1793\u1784"},{"id":14195,"word":"\u179F\u17D2\u1793\u1794"},{"id":14196,"word":"\u179F\u17D2\u1793\u1794\u17CB"},{"id":14197,"word":"\u179F\u17D2\u1793\u179B"},{"id":14198,"word":"\u179F\u17D2\u1793\u17B6"},{"id":14199,"word":"\u179F\u17D2\u1793\u17B6\u1785"},{"id":14200,"word":"\u179F\u17D2\u1793\u17B6\u178A\u17C3"},{"id":14201,"word":"\u179F\u17D2\u1793\u17B6\u178F\u1780"},{"id":14202,"word":"\u179F\u17D2\u1793\u17B6\u1793"},{"id":14203,"word":"\u179F\u17D2\u1793\u17B6\u1793\u17B8\u1799"},{"id":14204,"word":"\u179F\u17D2\u1793\u17B6\u1794"},{"id":14205,"word":"\u179F\u17D2\u1793\u17B6\u1794\u17CB"},{"id":14206,"word":"\u179F\u17D2\u1793\u17B6\u1794\u17CB --"},{"id":14207,"word":"\u179F\u17D2\u1793\u17B6\u1794\u1780"},{"id":14208,"word":"\u179F\u17D2\u1793\u17B6\u1794\u17CB\u1798\u17BB\u1781"},{"id":14209,"word":"\u179F\u17D2\u1793\u17B6\u1798"},{"id":14210,"word":"\u179F\u17D2\u1793\u17B6\u1798\u1797\u17D2\u179B\u17C4\u17C7"},{"id":14211,"word":"\u179F\u17D2\u1793\u17B6\u1799"},{"id":14212,"word":"\u179F\u17D2\u1793\u17B6\u1799\u178A\u17C2\u179B"},{"id":14213,"word":"\u179F\u17D2\u1793\u17B6\u1799\u17BB"},{"id":14214,"word":"\u179F\u17D2\u1793\u17B6\u179B"},{"id":14215,"word":"\u179F\u17D2\u1793\u17B7\u178F"},{"id":14216,"word":"\u179F\u17D2\u1793\u17B7\u1791\u17D2\u1792"},{"id":14217,"word":"\u179F\u17D2\u1793\u17B7\u1791\u17D2\u1792 --"},{"id":14218,"word":"\u179F\u17D2\u1793\u17B7\u1791\u17D2\u1792\u179F\u17D2\u1793\u17B6\u179B"},{"id":14219,"word":"\u179F\u17D2\u1793\u17B7\u1798"},{"id":14220,"word":"\u179F\u17D2\u1793\u17B9\u1784"},{"id":14221,"word":"\u179F\u17D2\u1793\u17BC\u1780"},{"id":14222,"word":"\u179F\u17D2\u1793\u17BC\u179A"},{"id":14223,"word":"\u179F\u17D2\u1793\u17BC\u179B"},{"id":14224,"word":"\u179F\u17D2\u1793\u17BD"},{"id":14225,"word":"\u179F\u17D2\u1793\u17BD\u179B"},{"id":14226,"word":"\u179F\u17D2\u1793\u17BE"},{"id":14227,"word":"\u179F\u17D2\u1793\u17C0\u178F"},{"id":14228,"word":"\u179F\u17D2\u1793\u17C1\u17A0\u17CD"},{"id":14229,"word":"\u179F\u17D2\u1793\u17C1\u17A0\u17B6"},{"id":14230,"word":"\u179F\u17D2\u1793\u17C1\u17A0\u17CD\u17A0\u17BA\u178F"},{"id":14231,"word":"\u179F\u17D2\u1793\u17C1\u17A0\u17CD\u17A0\u17C3"},{"id":14232,"word":"\u179F\u17D2\u1793\u17C2\u1784"},{"id":14233,"word":"\u179F\u17D2\u1793\u17C2\u1784\u1791\u1793\u17D2\u179F\u17C4\u1784"},{"id":14234,"word":"\u179F\u17D2\u1793\u17C2\u1784\u1796\u1796\u17C2"},{"id":14235,"word":"\u179F\u17D2\u1793\u17C4"},{"id":14236,"word":"\u179F\u17D2\u1793\u17C4\u1791\u1780"},{"id":14237,"word":"\u179F\u17D2\u1793\u17BB\u17C6"},{"id":14238,"word":"\u179F\u17D2\u1793\u17C6"},{"id":14239,"word":"\u179F\u17D2\u1794\u1784\u17CB"},{"id":14240,"word":"\u179F\u17D2\u1794\u1784\u17D2\u1780\u17D0\u1787"},{"id":14241,"word":"\u179F\u17D2\u1794\u1790"},{"id":14242,"word":"\u179F\u17D2\u1794\u17D0\u179F\u17D2\u178A"},{"id":14243,"word":"\u179F\u17D2\u1794\u17B6\u178F"},{"id":14244,"word":"\u179F\u17D2\u1794\u17B6\u178F\u17CB"},{"id":14245,"word":"\u179F\u17D2\u1794\u17B6\u1793\u17CB"},{"id":14246,"word":"\u179F\u17D2\u1794\u17B7\u178F"},{"id":14247,"word":"\u179F\u17D2\u1794\u17B7\u178F\u179A\u17B9\u178F"},{"id":14248,"word":"\u179F\u17D2\u1794\u17BA\u178F"},{"id":14249,"word":"\u179F\u17D2\u1794\u17BB\u179A"},{"id":14250,"word":"\u179F\u17D2\u1794\u17BC\u1793"},{"id":14251,"word":"\u179F\u17D2\u1794\u17BC\u179C"},{"id":14252,"word":"\u179F\u17D2\u1794\u17BE\u1798"},{"id":14253,"word":"\u179F\u17D2\u1794\u17BE\u1799"},{"id":14254,"word":"\u179F\u17D2\u1794\u17C0\u1784"},{"id":14255,"word":"\u179F\u17D2\u1794\u17C1\u178F"},{"id":14256,"word":"\u179F\u17D2\u1794\u17C2"},{"id":14257,"word":"\u179F\u17D2\u1794\u17C2\u1780"},{"id":14258,"word":"\u179F\u17D2\u1794\u17C2\u1780\u1787\u17BE\u1784"},{"id":14259,"word":"\u179F\u17D2\u1794\u17C2\u1784"},{"id":14260,"word":"\u179F\u17D2\u1794\u17C2\u1794"},{"id":14261,"word":"\u179F\u17D2\u1794\u17C3"},{"id":14262,"word":"\u179F\u17D2\u1794\u17C3\u179A\u17BF\u1784"},{"id":14263,"word":"\u179F\u17D2\u1794\u17C3\u179A\u17C4\u1799"},{"id":14264,"word":"\u179F\u17D2\u1794\u17C4\u1784"},{"id":14265,"word":"\u179F\u17D2\u1794\u17C9\u178F"},{"id":14266,"word":"\u179F\u17D2\u1794\u17C9\u17B9\u1798"},{"id":14267,"word":"\u179F\u17D2\u1794\u17C9\u17BB\u179A"},{"id":14268,"word":"\u179F\u17D2\u1794\u17C9\u17C2\u178F"},{"id":14269,"word":"\u179F\u17D2\u1796\u1780"},{"id":14270,"word":"\u179F\u17D2\u1796\u1784\u17CB"},{"id":14271,"word":"\u179F\u17D2\u1796\u17B6\u1793"},{"id":14272,"word":"\u179F\u17D2\u1796\u17B6\u1793\u17CB"},{"id":14273,"word":"\u179F\u17D2\u1796\u17B6\u1793\u17CB\u1780\u17D2\u179A\u17B6\u1794"},{"id":14274,"word":"\u179F\u17D2\u1796\u17B6\u1793\u17CB\u1792\u17D0\u179A"},{"id":14275,"word":"\u179F\u17D2\u1796\u17B6\u1793\u1798\u17C1\u178F\u17D2\u179A\u17B8"},{"id":14276,"word":"\u179F\u17D2\u1796\u17B6\u1799"},{"id":14277,"word":"\u179F\u17D2\u1796\u17B6\u1799\u1786\u17C0\u1784"},{"id":14278,"word":"\u179F\u17D2\u1796\u17B6\u1799\u179B\u17C0\u1784"},{"id":14279,"word":"\u179F\u17D2\u1796\u17B8\u1784"},{"id":14280,"word":"\u179F\u17D2\u1796\u17B9\u1780"},{"id":14281,"word":"\u179F\u17D2\u1796\u17B9\u1784"},{"id":14282,"word":"\u179F\u17D2\u1796\u17BA"},{"id":14283,"word":"\u179F\u17D2\u1796\u17BB\u1785"},{"id":14284,"word":"\u179F\u17D2\u1796\u17BB\u1799"},{"id":14285,"word":"\u179F\u17D2\u1796\u17BB\u179A"},{"id":14286,"word":"\u179F\u17D2\u1796\u17BE\u1793"},{"id":14287,"word":"\u179F\u17D2\u1796\u17C0\u178F"},{"id":14288,"word":"\u179F\u17D2\u1796\u17C1\u17C7"},{"id":14289,"word":"\u179F\u17D2\u1796\u17C2\u178F"},{"id":14290,"word":"\u179F\u17D2\u1796\u17C2\u17C7"},{"id":14291,"word":"\u179F\u17D2\u1796\u17C3"},{"id":14292,"word":"\u179F\u17D2\u1796\u17C3\u1782\u17C4\u1780"},{"id":14293,"word":"\u179F\u17D2\u1796\u17C4\u178F"},{"id":14294,"word":"\u179F\u17D2\u1796\u17C4\u179A"},{"id":14295,"word":"\u179F\u17D2\u1796\u17C5"},{"id":14296,"word":"\u179F\u17D2\u1798\u17D0\u1782\u17D2\u179A"},{"id":14297,"word":"\u179F\u17D2\u1798\u1784"},{"id":14298,"word":"\u179F\u17D2\u1798\u178F\u17CB"},{"id":14299,"word":"\u179F\u17D2\u1798\u1793\u17CB"},{"id":14300,"word":"\u179F\u17D2\u1798\u1793\u17D2\u1792"},{"id":14301,"word":"\u179F\u17D2\u1798\u179A"},{"id":14302,"word":"\u179F\u17D2\u1798\u179F\u17B6\u1793"},{"id":14303,"word":"\u179F\u17D2\u1798\u17B6"},{"id":14304,"word":"\u179F\u17D2\u1798\u17B6\u1780\u17D2\u178F\u17B8"},{"id":14305,"word":"\u179F\u17D2\u1798\u17B6\u1782\u1798"},{"id":14306,"word":"\u179F\u17D2\u1798\u17B6\u1785\u17CB"},{"id":14307,"word":"\u179F\u17D2\u1798\u17B6\u1785\u17CB\u178A\u17C4\u1798"},{"id":14308,"word":"\u179F\u17D2\u1798\u17B6\u1787\u17B7\u1780"},{"id":14309,"word":"\u179F\u17D2\u1798\u17B6\u1789"},{"id":14310,"word":"\u179F\u17D2\u1798\u17B6\u1791\u17B6\u1793"},{"id":14311,"word":"\u179F\u17D2\u1798\u17B6\u1792\u17B7"},{"id":14312,"word":"\u179F\u17D2\u1798\u17B6\u1792\u17B7\u17CD"},{"id":14313,"word":"\u179F\u17D2\u1798\u17B6\u1793"},{"id":14314,"word":"\u179F\u17D2\u1798\u17B6\u1793\u17CB"},{"id":14315,"word":"\u179F\u17D2\u1798\u17B6\u1797\u17B6\u1796"},{"id":14316,"word":"\u179F\u17D2\u1798\u17B6\u179A\u178F\u17B8"},{"id":14317,"word":"\u179F\u17D2\u1798\u17B6\u179A\u17D2\u178F\u17B8"},{"id":14318,"word":"\u179F\u17D2\u1798\u17B6\u179A\u179B\u17B6"},{"id":14319,"word":"\u179F\u17D2\u1798\u17B7\u1784"},{"id":14320,"word":"\u179F\u17D2\u1798\u17B7\u1789"},{"id":14321,"word":"\u179F\u17D2\u1798\u17B7\u178F"},{"id":14322,"word":"\u179F\u17D2\u1798\u17B7\u1794"},{"id":14323,"word":"\u179F\u17D2\u1798\u17B7\u179B"},{"id":14324,"word":"\u179F\u17D2\u1798\u17B8"},{"id":14325,"word":"\u179F\u17D2\u1798\u17B9\u1784"},{"id":14326,"word":"\u179F\u17D2\u1798\u17B9\u1794"},{"id":14327,"word":"\u179F\u17D2\u1798\u17B9\u1798"},{"id":14328,"word":"\u179F\u17D2\u1798\u17BA"},{"id":14329,"word":"\u179F\u17D2\u1798\u17BA\u1794"},{"id":14330,"word":"\u179F\u17D2\u1798\u17BB\u1782"},{"id":14331,"word":"\u179F\u17D2\u1798\u17BB\u178F\u1791\u17D2\u179A\u17BB\u178C"},{"id":14332,"word":"\u179F\u17D2\u1798\u17BB\u1799"},{"id":14333,"word":"\u179F\u17D2\u1798\u17BC\u1789"},{"id":14334,"word":"\u179F\u17D2\u1798\u17BC\u178F"},{"id":14335,"word":"\u179F\u17D2\u1798\u17BC\u1793"},{"id":14336,"word":"\u179F\u17D2\u1798\u17BC\u1793\u1786\u17D2\u1793\u17B6\u17C6\u1784"},{"id":14337,"word":"\u179F\u17D2\u1798\u17BC\u1798"},{"id":14338,"word":"\u179F\u17D2\u1798\u17BC\u179A"},{"id":14339,"word":"\u179F\u17D2\u1798\u17BC\u179A\u1787\u1793"},{"id":14340,"word":"\u179F\u17D2\u1798\u17BE"},{"id":14341,"word":"\u179F\u17D2\u1798\u17BF\u1780"},{"id":14342,"word":"\u179F\u17D2\u1798\u17C0\u1793"},{"id":14343,"word":"\u179F\u17D2\u1798\u17C1"},{"id":14344,"word":"\u179F\u17D2\u1798\u17C1\u1789"},{"id":14345,"word":"\u179F\u17D2\u1798\u17C1\u179A"},{"id":14346,"word":"\u179F\u17D2\u1798\u17C2"},{"id":14347,"word":"\u179F\u17D2\u1798\u17C2\u1780"},{"id":14348,"word":"\u179F\u17D2\u1798\u17C2\u1784"},{"id":14349,"word":"\u179F\u17D2\u1798\u17C4\u1780"},{"id":14350,"word":"\u179F\u17D2\u1798\u17C4\u1780\u1782\u17D2\u179A\u17C4\u1780"},{"id":14351,"word":"\u179F\u17D2\u1798\u17CA\u17C4\u1780\u1782\u17D2\u179A\u17C4\u1780"},{"id":14352,"word":"\u179F\u17D2\u1798\u17C4\u1784"},{"id":14353,"word":"\u179F\u17D2\u1798\u17C4\u1789"},{"id":14354,"word":"\u179F\u17D2\u1798\u17C4\u17C7"},{"id":14355,"word":"\u179F\u17D2\u1798\u17C4\u17C7\u1784\u17B6\u179A"},{"id":14356,"word":"\u179F\u17D2\u1798\u17C4\u17C7\u179F\u179A"},{"id":14357,"word":"\u179F\u17D2\u1798\u17C5"},{"id":14358,"word":"\u179F\u17D2\u1798\u17C5\u179F\u17D2\u179A\u17BC\u1794\u1796\u17B7\u179F\u1796\u179F\u17CB"},{"id":14359,"word":"\u179F\u17D2\u1798\u17BB\u17C6"},{"id":14360,"word":"\u179F\u17D2\u1799\u17B6"},{"id":14361,"word":"\u179F\u17D2\u1799\u17B6\u1798"},{"id":14362,"word":"\u179F\u17D2\u1799\u17BB\u179B"},{"id":14363,"word":"\u179F\u17D2\u179A"},{"id":14364,"word":"\u179F\u17D2\u179A\u17C8"},{"id":14365,"word":"\u179F\u17D2\u179A\u1780"},{"id":14366,"word":"\u179F\u17D2\u179A\u1780\u17CB"},{"id":14367,"word":"\u179F\u17D2\u179A\u1780\u1780\u17CB"},{"id":14368,"word":"\u179F\u17D2\u179A\u1780\u179A"},{"id":14369,"word":"\u179F\u17D2\u179A\u1780\u17B6"},{"id":14370,"word":"\u179F\u17D2\u179A\u1780\u17B6\u1780"},{"id":14371,"word":"\u179F\u17D2\u179A\u1780\u17B6\u1793\u17B6\u1782"},{"id":14372,"word":"\u179F\u17D2\u179A\u1780\u17B8"},{"id":14373,"word":"\u179F\u17D2\u179A\u1780\u17B8\u17A2\u178E\u17D2\u178F\u17C2\u1784"},{"id":14374,"word":"\u179F\u17D2\u179A\u1780\u17BC\u1780"},{"id":14375,"word":"\u179F\u17D2\u179A\u1780\u17C1\u1780"},{"id":14376,"word":"\u179F\u17D2\u179A\u1780\u17C4\u1780"},{"id":14377,"word":"\u179F\u17D2\u179A\u1781\u1780\u17CB"},{"id":14378,"word":"\u179F\u17D2\u179A\u1781\u17BC\u179C"},{"id":14379,"word":"\u179F\u17D2\u179A\u1782\u178F\u17CB\u179F\u17D2\u179A\u1782\u17C6"},{"id":14380,"word":"\u179F\u17D2\u179A\u1782\u17B6\u179B"},{"id":14381,"word":"\u179F\u17D2\u179A\u1782\u17B7\u179B \u179F\u17D2\u179A\u1782\u17BB\u179B"},{"id":14382,"word":"\u179F\u17D2\u179A\u1782\u17BB\u1780"},{"id":14383,"word":"\u179F\u17D2\u179A\u1782\u17BB\u179B"},{"id":14384,"word":"\u179F\u17D2\u179A\u1782\u17C2\u179B"},{"id":14385,"word":"\u179F\u17D2\u179A\u1782\u17C4\u1798"},{"id":14386,"word":"\u179F\u17D2\u179A\u1782\u17C6"},{"id":14387,"word":"\u179F\u17D2\u179A\u1782\u17B6\u17C6"},{"id":14388,"word":"\u179F\u17D2\u179A\u1783\u17B7\u179B \u179F\u17D2\u179A\u1783\u17BB\u179B"},{"id":14389,"word":"\u179F\u17D2\u179A\u1783\u17BB\u179B"},{"id":14390,"word":"\u179F\u17D2\u179A\u1784"},{"id":14391,"word":"\u179F\u17D2\u179A\u1784\u17CB"},{"id":14392,"word":"\u179F\u17D2\u179A\u1784\u1780"},{"id":14393,"word":"\u179F\u17D2\u179A\u1784\u179B\u17CB"},{"id":14394,"word":"\u179F\u17D2\u179A\u1784\u17B6\u1780"},{"id":14395,"word":"\u179F\u17D2\u179A\u1784\u17B6\u1780\u179F\u17D2\u178A\u17B6\u1794\u17CB\u1795\u17D2\u1782\u179A"},{"id":14396,"word":"\u179F\u17D2\u179A\u1784\u17B6\u178F\u17CB"},{"id":14397,"word":"\u179F\u17D2\u179A\u1784\u17B9\u1798"},{"id":14398,"word":"\u179F\u17D2\u179A\u1784\u17BC\u178F"},{"id":14399,"word":"\u179F\u17D2\u179A\u1784\u17BE"},{"id":14400,"word":"\u179F\u17D2\u179A\u1784\u17C0\u179C"},{"id":14401,"word":"\u179F\u17D2\u179A\u1784\u17C1\u179C"},{"id":14402,"word":"\u179F\u17D2\u179A\u1784\u17C1\u17C7\u179F\u17D2\u179A\u1784\u17C4\u1785"},{"id":14403,"word":"\u179F\u17D2\u179A\u1784\u17C2"},{"id":14404,"word":"\u179F\u17D2\u179A\u1784\u17C4\u1785"},{"id":14405,"word":"\u179F\u17D2\u179A\u1784\u17C5"},{"id":14406,"word":"\u179F\u17D2\u179A\u1784\u17B6\u17C6"},{"id":14407,"word":"\u179F\u17D2\u179A\u1787\u17C2\u178F"},{"id":14408,"word":"\u179F\u17D2\u179A\u178A\u17B6\u179F\u17CB"},{"id":14409,"word":"\u179F\u17D2\u179A\u178A\u17B8"},{"id":14410,"word":"\u179F\u17D2\u179A\u178E\u17B6\u1784"},{"id":14411,"word":"\u179F\u17D2\u179A\u178E\u17B6\u1793"},{"id":14412,"word":"\u179F\u17D2\u179A\u178E\u17BB\u1780"},{"id":14413,"word":"\u179F\u17D2\u179A\u178E\u17C4\u1780"},{"id":14414,"word":"\u179F\u17D2\u179A\u178E\u17C4\u17C7"},{"id":14415,"word":"\u179F\u17D2\u179A\u178F\u17B9\u1780"},{"id":14416,"word":"\u179F\u17D2\u179A\u178F\u17BC\u179C"},{"id":14417,"word":"\u179F\u17D2\u179A\u1791\u1793\u17CB"},{"id":14418,"word":"\u179F\u17D2\u179A\u1791\u1794"},{"id":14419,"word":"\u179F\u17D2\u179A\u1791\u17B6\u1784"},{"id":14420,"word":"\u179F\u17D2\u179A\u1791\u17B6\u1794\u17CB"},{"id":14421,"word":"\u179F\u17D2\u179A\u1791\u17C0\u1780"},{"id":14422,"word":"\u179F\u17D2\u179A\u1791\u17C6"},{"id":14423,"word":"\u179F\u17D2\u179A\u1791\u17D2\u1792\u17B6"},{"id":14424,"word":"\u179F\u17D2\u179A\u1793\u17CB"},{"id":14425,"word":"\u179F\u17D2\u179A\u1794"},{"id":14426,"word":"\u179F\u17D2\u179A\u1794\u17CB"},{"id":14427,"word":"\u179F\u17D2\u179A\u1794\u1780\u17CB"},{"id":14428,"word":"\u179F\u17D2\u179A\u1794\u1780\u17CB\u179F\u17D2\u179A\u1794\u17B6\u179B"},{"id":14429,"word":"\u179F\u17D2\u179A\u1794\u17B6\u179B"},{"id":14430,"word":"\u179F\u17D2\u179A\u1794\u17B6\u17C6\u1784"},{"id":14431,"word":"\u179F\u17D2\u179A\u1794\u17C9\u17B6\u1794"},{"id":14432,"word":"\u179F\u17D2\u179A\u1794\u17C9\u17BC\u1794"},{"id":14433,"word":"\u179F\u17D2\u179A\u1794\u17C9\u17BE\u1780"},{"id":14434,"word":"\u179F\u17D2\u179A\u1794\u17C9\u17C1\u1780"},{"id":14435,"word":"\u179F\u17D2\u179A\u17C8\u1795\u17D2\u179F\u17C6"},{"id":14436,"word":"\u179F\u17D2\u179A\u1796"},{"id":14437,"word":"\u179F\u17D2\u179A\u1796\u1793\u17CB"},{"id":14438,"word":"\u179F\u17D2\u179A\u1796\u17B6\u1794"},{"id":14439,"word":"\u179F\u17D2\u179A\u1796\u17B6\u1794\u17CB"},{"id":14440,"word":"\u179F\u17D2\u179A\u1796\u17B7\u179B"},{"id":14441,"word":"\u179F\u17D2\u179A\u1796\u17C1\u1785\u179F\u17D2\u179A\u1796\u17B7\u179B"},{"id":14442,"word":"\u179F\u17D2\u179A\u17C8\u1796\u17C1\u1789\u178F\u17BD"},{"id":14443,"word":"\u179F\u17D2\u179A\u1796\u17C4\u1793"},{"id":14444,"word":"\u179F\u17D2\u179A\u1798\u17C9"},{"id":14445,"word":"\u179F\u17D2\u179A\u1798\u1780"},{"id":14446,"word":"\u179F\u17D2\u179A\u1798\u178E\u17C8"},{"id":14447,"word":"\u179F\u17D2\u179A\u1798\u178E --"},{"id":14448,"word":"\u179F\u17D2\u179A\u1798\u178E\u179F\u1780\u17D2\u178A\u17B7"},{"id":14449,"word":"\u179F\u17D2\u179A\u1798\u178E\u17B8"},{"id":14450,"word":"\u179F\u17D2\u179A\u1798\u178E\u17BB\u1791\u17D2\u1791\u17C1\u179F"},{"id":14451,"word":"\u179F\u17D2\u179A\u1798\u17B6\u1780\u17CB"},{"id":14452,"word":"\u179F\u17D2\u179A\u1798\u17B6\u1789"},{"id":14453,"word":"\u179F\u17D2\u179A\u1798\u17B6\u1798"},{"id":14454,"word":"\u179F\u17D2\u179A\u1798\u17B6\u1798\u1794\u17C9\u17B6\u1780"},{"id":14455,"word":"\u179F\u17D2\u179A\u1798\u17B7\u1780"},{"id":14456,"word":"\u179F\u17D2\u179A\u1798\u17B9\u1798"},{"id":14457,"word":"\u179F\u17D2\u179A\u1798\u17BB\u1780"},{"id":14458,"word":"\u179F\u17D2\u179A\u1798\u17BB\u178F\u1785\u17B7\u178F\u17D2\u178F"},{"id":14459,"word":"\u179F\u17D2\u179A\u1798\u17BB\u1799"},{"id":14460,"word":"\u179F\u17D2\u179A\u1798\u17BC\u1789"},{"id":14461,"word":"\u179F\u17D2\u179A\u1798\u17BC\u1798"},{"id":14462,"word":"\u179F\u17D2\u179A\u1798\u17BC\u179B"},{"id":14463,"word":"\u179F\u17D2\u179A\u1798\u17BC\u179C"},{"id":14464,"word":"\u179F\u17D2\u179A\u1798\u17BE"},{"id":14465,"word":"\u179F\u17D2\u179A\u1798\u17BE\u1784"},{"id":14466,"word":"\u179F\u17D2\u179A\u1798\u17BE\u179B"},{"id":14467,"word":"\u179F\u17D2\u179A\u1798\u17C0\u1793"},{"id":14468,"word":"\u179F\u17D2\u179A\u1798\u17C1\u1780"},{"id":14469,"word":"\u179F\u17D2\u179A\u1798\u17C1\u1798"},{"id":14470,"word":"\u179F\u17D2\u179A\u1798\u17C1\u179C"},{"id":14471,"word":"\u179F\u17D2\u179A\u1798\u17C1\u17C7"},{"id":14472,"word":"\u179F\u17D2\u179A\u1798\u17C3"},{"id":14473,"word":"\u179F\u17D2\u179A\u1798\u17C4\u1785"},{"id":14474,"word":"\u179F\u17D2\u179A\u1798\u17C4\u179B"},{"id":14475,"word":"\u179F\u17D2\u179A\u17D0\u1799"},{"id":14476,"word":"\u179F\u17D2\u179A\u1799\u1784\u17CB"},{"id":14477,"word":"\u179F\u17D2\u179A\u1799\u1798"},{"id":14478,"word":"\u179F\u17D2\u179A\u1799\u17B6\u1780"},{"id":14479,"word":"\u179F\u17D2\u179A\u1799\u17B6\u179B"},{"id":14480,"word":"\u179F\u17D2\u179A\u1799\u17B6\u179C"},{"id":14481,"word":"\u179F\u17D2\u179A\u1799\u17BA\u179B"},{"id":14482,"word":"\u179F\u17D2\u179A\u1799\u17BB\u178F"},{"id":14483,"word":"\u179F\u17D2\u179A\u1799\u17BC\u179C"},{"id":14484,"word":"\u179F\u17D2\u179A\u1799\u17BE\u179B"},{"id":14485,"word":"\u179F\u17D2\u179A\u179B\u1780"},{"id":14486,"word":"\u179F\u17D2\u179A\u179B\u17CB"},{"id":14487,"word":"\u179F\u17D2\u179A\u179B\u1793"},{"id":14488,"word":"\u179F\u17D2\u179A\u179B\u17B6\u1789\u17CB"},{"id":14489,"word":"\u179F\u17D2\u179A\u179B\u17B6\u1794"},{"id":14490,"word":"\u179F\u17D2\u179A\u179B\u17B7\u178F"},{"id":14491,"word":"\u179F\u17D2\u179A\u179B\u17B9\u1784"},{"id":14492,"word":"\u179F\u17D2\u179A\u179B\u17B9\u1794"},{"id":14493,"word":"\u179F\u17D2\u179A\u179B\u17BA\u1780\u17BA"},{"id":14494,"word":"\u179F\u17D2\u179A\u179B\u17BB\u1784"},{"id":14495,"word":"\u179F\u17D2\u179A\u179B\u17BC\u1784"},{"id":14496,"word":"\u179F\u17D2\u179A\u179B\u17BD\u178F"},{"id":14497,"word":"\u179F\u17D2\u179A\u179B\u17BD\u1793"},{"id":14498,"word":"\u179F\u17D2\u179A\u179B\u17BE"},{"id":14499,"word":"\u179F\u17D2\u179A\u179B\u17BE\u1780\u17BE"},{"id":14500,"word":"\u179F\u17D2\u179A\u179B\u17C0\u1784"},{"id":14501,"word":"\u179F\u17D2\u179A\u179B\u17C1\u1789"},{"id":14502,"word":"\u179F\u17D2\u179A\u179B\u17C1\u178F"},{"id":14503,"word":"\u179F\u17D2\u179A\u179B\u17C1\u179C"},{"id":14504,"word":"\u179F\u17D2\u179A\u179B\u17C2\u179C"},{"id":14505,"word":"\u179F\u17D2\u179A\u179B\u17C7"},{"id":14506,"word":"\u179F\u17D2\u179A\u179C\u1793\u17D2\u178F\u17B8"},{"id":14507,"word":"\u179F\u17D2\u179A\u179C\u17B6"},{"id":14508,"word":"\u179F\u17D2\u179A\u179C\u17B6\u1780\u17CB\u179F\u17D2\u179A\u179C\u17B6\u1793\u17CB"},{"id":14509,"word":"\u179F\u17D2\u179A\u179C\u17B6\u179F\u17D2\u179A\u1791\u17C1\u1789"},{"id":14510,"word":"\u179F\u17D2\u179A\u179C\u17B9\u1784"},{"id":14511,"word":"\u179F\u17D2\u179A\u179C\u17BE\u1793"},{"id":14512,"word":"\u179F\u17D2\u179A\u179C\u17B6\u17C6\u1784"},{"id":14513,"word":"\u179F\u17D2\u179A\u179F"},{"id":14514,"word":"\u179F\u17D2\u179A\u179F\u17CB"},{"id":14515,"word":"\u179F\u17D2\u179A\u17D0\u179F"},{"id":14516,"word":"\u179F\u17D2\u179A\u179F\u17CB\u1794\u179F\u17CB"},{"id":14517,"word":"\u179F\u17D2\u179A\u179F\u17CB\u179F\u17D2\u179A\u17B6\u1799"},{"id":14518,"word":"\u179F\u17D2\u179A\u179F\u17CB\u179F\u17D2\u179A\u17BC\u1794"},{"id":14519,"word":"\u179F\u17D2\u179A\u179F\u17CB\u179F\u17D2\u179A\u17C4\u1784"},{"id":14520,"word":"\u179F\u17D2\u179A\u17A1\u1780"},{"id":14521,"word":"\u179F\u17D2\u179A\u17A1\u1780\u17CB"},{"id":14522,"word":"\u179F\u17D2\u179A\u17A1\u1793"},{"id":14523,"word":"\u179F\u17D2\u179A\u17A1\u1794\u17CB"},{"id":14524,"word":"\u179F\u17D2\u179A\u17A1\u17B6\u1784"},{"id":14525,"word":"\u179F\u17D2\u179A\u17A1\u17B6\u1789\u17CB"},{"id":14526,"word":"\u179F\u17D2\u179A\u17A1\u17B6\u1794"},{"id":14527,"word":"\u179F\u17D2\u179A\u17A1\u17B7\u178F"},{"id":14528,"word":"\u179F\u17D2\u179A\u17A1\u17B9\u1784"},{"id":14529,"word":"\u179F\u17D2\u179A\u17A1\u17B9\u1794"},{"id":14530,"word":"\u179F\u17D2\u179A\u17A1\u17BA\u1780\u17BA"},{"id":14531,"word":"\u179F\u17D2\u179A\u17A1\u17BB\u1784"},{"id":14532,"word":"\u179F\u17D2\u179A\u17A1\u17BC\u1784"},{"id":14533,"word":"\u179F\u17D2\u179A\u17A1\u17BE"},{"id":14534,"word":"\u179F\u17D2\u179A\u17A1\u17BE\u1780\u17BE"},{"id":14535,"word":"\u179F\u17D2\u179A\u17A1\u17C1\u178F"},{"id":14536,"word":"\u179F\u17D2\u179A\u17A1\u17C1\u179C"},{"id":14537,"word":"\u179F\u17D2\u179A\u17A1\u17C2\u179C"},{"id":14538,"word":"\u179F\u17D2\u179A\u17A1\u17C3"},{"id":14539,"word":"\u179F\u17D2\u179A\u17A1\u17C3"},{"id":14540,"word":"\u179F\u17D2\u179A\u17A1\u17C4"},{"id":14541,"word":"\u179F\u17D2\u179A\u17A1\u17C4\u1780\u17C4"},{"id":14542,"word":"\u179F\u17D2\u179A\u17A1\u17C4\u1785"},{"id":14543,"word":"\u179F\u17D2\u179A\u17A1\u17C5"},{"id":14544,"word":"\u179F\u17D2\u179A\u17A1\u17C6"},{"id":14545,"word":"\u179F\u17D2\u179A\u17A1\u17B6\u17C6\u1784\u1780\u17B6\u17C6\u1784"},{"id":14546,"word":"\u179F\u17D2\u179A\u17A1\u17C7"},{"id":14547,"word":"\u179F\u17D2\u179A\u17A2\u17D0\u1796\u17D2\u1791"},{"id":14548,"word":"\u179F\u17D2\u179A\u17A2\u17B6\u1794\u17CB"},{"id":14549,"word":"\u179F\u17D2\u179A\u17A2\u17B7\u1794"},{"id":14550,"word":"\u179F\u17D2\u179A\u17A2\u17CA\u17BB\u1780"},{"id":14551,"word":"\u179F\u17D2\u179A\u17A2\u17CA\u17BB\u1798"},{"id":14552,"word":"\u179F\u17D2\u179A\u17A2\u17C2\u178F"},{"id":14553,"word":"\u179F\u17D2\u179A\u17A2\u17C2\u1798"},{"id":14554,"word":"\u179F\u17D2\u179A\u17A2\u17CA\u17BB\u17C6"},{"id":14555,"word":"\u179F\u17D2\u179A\u17B6"},{"id":14556,"word":"\u179F\u17D2\u179A\u17B6\u1780"},{"id":14557,"word":"\u179F\u17D2\u179A\u17B6\u1780\u17CB"},{"id":14558,"word":"\u179F\u17D2\u179A\u17B6\u1780\u17CB\u17D7"},{"id":14559,"word":"\u179F\u17D2\u179A\u17B6\u1784"},{"id":14560,"word":"\u179F\u17D2\u179A\u17B6\u1789"},{"id":14561,"word":"\u179F\u17D2\u179A\u17B6\u178F"},{"id":14562,"word":"\u179F\u17D2\u179A\u17B6\u1791\u17D2\u1792\u1796\u17B7\u1792\u17B8"},{"id":14563,"word":"\u179F\u17D2\u179A\u17B6\u1793\u17D2\u178F"},{"id":14564,"word":"\u179F\u17D2\u179A\u17B6\u1794\u17CB"},{"id":14565,"word":"\u179F\u17D2\u179A\u17B6\u1794\u17CB\u178F\u17C2"},{"id":14566,"word":"\u179F\u17D2\u179A\u17B6\u1796\u1780\u17CD"},{"id":14567,"word":"\u179F\u17D2\u179A\u17B6\u1796\u178E\u17CD"},{"id":14568,"word":"\u179F\u17D2\u179A\u17B6\u1796\u178E\u17B8"},{"id":14569,"word":"\u179F\u17D2\u179A\u17B6\u1799"},{"id":14570,"word":"\u179F\u17D2\u179A\u17B6\u179B"},{"id":14571,"word":"\u179F\u17D2\u179A\u17B6\u179B\u17CB"},{"id":14572,"word":"\u179F\u17D2\u179A\u17B6\u179C"},{"id":14573,"word":"\u179F\u17D2\u179A\u17B6\u179C\u1780"},{"id":14574,"word":"\u179F\u17D2\u179A\u17B6\u179C\u1787\u17D2\u179A\u17B6\u179C"},{"id":14575,"word":"\u179F\u17D2\u179A\u17B6\u179C\u178E\u17B8"},{"id":14576,"word":"\u179F\u17D2\u179A\u17B6\u179C\u17B7\u1780\u17B6"},{"id":14577,"word":"\u179F\u17D2\u179A\u17B6\u179F\u17CB"},{"id":14578,"word":"\u179F\u17D2\u179A\u17B7\u1785\u17D7"},{"id":14579,"word":"\u179F\u17D2\u179A\u17B7\u178F"},{"id":14580,"word":"\u179F\u17D2\u179A\u17B7\u1794\u17D7"},{"id":14581,"word":"\u179F\u17D2\u179A\u17B7\u1794\u179F\u17D2\u179A\u17C0\u1794"},{"id":14582,"word":"\u179F\u17D2\u179A\u17B7\u1798"},{"id":14583,"word":"\u179F\u17D2\u179A\u17B7\u179B"},{"id":14584,"word":"\u179F\u17D2\u179A\u17B8"},{"id":14585,"word":"\u179F\u17D2\u179A\u17B8\u1794\u17D2\u179A\u179F\u17BE\u179A"},{"id":14586,"word":"\u179F\u17D2\u179A\u17B8\u1798\u17D0\u178F"},{"id":14587,"word":"\u179F\u17D2\u179A\u17B8\u1798\u178F\u17B8"},{"id":14588,"word":"\u179F\u17D2\u179A\u17B8\u179F\u17C4\u1797\u17D0\u178E"},{"id":14589,"word":"\u179F\u17D2\u179A\u17B9\u1784"},{"id":14590,"word":"\u179F\u17D2\u179A\u17CA\u17B9\u1784"},{"id":14591,"word":"\u179F\u17D2\u179A\u17B9\u1784\u17D2\u1782"},{"id":14592,"word":"\u179F\u17D2\u179A\u17B9\u1784\u17D2\u1782\u17B6\u179A"},{"id":14593,"word":"\u179F\u17D2\u179A\u17B9\u1784\u17D2\u1782\u17B8"},{"id":14594,"word":"\u179F\u17D2\u179A\u17B9\u1794"},{"id":14595,"word":"\u179F\u17D2\u179A\u17CA\u17B9\u1794"},{"id":14596,"word":"\u179F\u17D2\u179A\u17B9\u1794\u17D7"},{"id":14597,"word":"\u179F\u17D2\u179A\u17B9\u1794\u179F\u17D2\u179A\u17C0\u1794"},{"id":14598,"word":"\u179F\u17D2\u179A\u17B9\u1798"},{"id":14599,"word":"\u179F\u17D2\u179A\u17BB\u1780"},{"id":14600,"word":"\u179F\u17D2\u179A\u17BB\u1784"},{"id":14601,"word":"\u179F\u17D2\u179A\u17CA\u17BB\u1785"},{"id":14602,"word":"\u179F\u17D2\u179A\u17BB\u1789"},{"id":14603,"word":"\u179F\u17D2\u179A\u17BB\u178F"},{"id":14604,"word":"\u179F\u17D2\u179A\u17BB\u178F\u17B7"},{"id":14605,"word":"\u179F\u17D2\u179A\u17CA\u17BB\u1794"},{"id":14606,"word":"\u179F\u17D2\u179A\u17BB\u179F"},{"id":14607,"word":"\u179F\u17D2\u179A\u17BB\u17C7"},{"id":14608,"word":"\u179F\u17D2\u179A\u17BC\u178F"},{"id":14609,"word":"\u179F\u17D2\u179A\u17BC\u1794"},{"id":14610,"word":"\u179F\u17D2\u179A\u17BC\u179B"},{"id":14611,"word":"\u179F\u17D2\u179A\u17BC\u179F"},{"id":14612,"word":"\u179F\u17D2\u179A\u17CA\u17BC\u179F"},{"id":14613,"word":"\u179F\u17D2\u179A\u17BD\u1785"},{"id":14614,"word":"\u179F\u17D2\u179A\u17BD\u1785\u179F\u17D2\u179A\u17B6\u179B\u17CB"},{"id":14615,"word":"\u179F\u17D2\u179A\u17BD\u178F"},{"id":14616,"word":"\u179F\u17D2\u179A\u17BD\u1794"},{"id":14617,"word":"\u179F\u17D2\u179A\u17BD\u1799"},{"id":14618,"word":"\u179F\u17D2\u179A\u17BD\u179B"},{"id":14619,"word":"\u179F\u17D2\u179A\u17BD\u179B\u1794\u17BD\u179B"},{"id":14620,"word":"\u179F\u17D2\u179A\u17BE\u1794"},{"id":14621,"word":"\u179F\u17D2\u179A\u17BE\u1794\u179F\u17D2\u179A\u17B6\u179B"},{"id":14622,"word":"\u179F\u17D2\u179A\u17BF\u1784"},{"id":14623,"word":"\u179F\u17D2\u179A\u17C0\u1780"},{"id":14624,"word":"\u179F\u17D2\u179A\u17C0\u179C"},{"id":14625,"word":"\u179F\u17D2\u179A\u17C1\u1780"},{"id":14626,"word":"\u179F\u17D2\u179A\u17C1\u1784"},{"id":14627,"word":"\u179F\u17D2\u179A\u17C1\u1785"},{"id":14628,"word":"\u179F\u17D2\u179A\u17C1\u1785\u1794\u17B6\u1785\u17CB"},{"id":14629,"word":"\u179F\u17D2\u179A\u17C1\u178E\u17B8"},{"id":14630,"word":"\u179F\u17D2\u179A\u17C1\u17C7"},{"id":14631,"word":"\u179F\u17D2\u179A\u17C2"},{"id":14632,"word":"\u179F\u17D2\u179A\u17C2\u1780"},{"id":14633,"word":"\u179F\u17D2\u179A\u17C2\u1784"},{"id":14634,"word":"\u179F\u17D2\u179A\u17C2\u1784\u1780\u1784\u17D2\u1780\u17C2\u1794"},{"id":14635,"word":"\u179F\u17D2\u179A\u17C2\u1793\u17D2\u1799"},{"id":14636,"word":"\u179F\u17D2\u179A\u17C2\u1798\u17BD\u179A"},{"id":14637,"word":"\u179F\u17D2\u179A\u17C2\u179F"},{"id":14638,"word":"\u179F\u17D2\u179A\u17C2\u17C7"},{"id":14639,"word":"\u179F\u17D2\u179A\u17C4\u1780"},{"id":14640,"word":"\u179F\u17D2\u179A\u17C4\u1780\u1791\u17B9\u1780"},{"id":14641,"word":"\u179F\u17D2\u179A\u17C4\u1784"},{"id":14642,"word":"\u179F\u17D2\u179A\u17C4\u1785"},{"id":14643,"word":"\u179F\u17D2\u179A\u17C4\u178F\u17B6"},{"id":14644,"word":"\u179F\u17D2\u179A\u17C4\u178F\u17D2\u179A"},{"id":14645,"word":"\u179F\u17D2\u179A\u17C4\u178F\u17D2\u179A\u17B7\u1799\u17C8"},{"id":14646,"word":"\u179F\u17D2\u179A\u17C4\u1794"},{"id":14647,"word":"\u179F\u17D2\u179A\u17C4\u1794\u178A\u178E\u17D2\u178F\u1794\u17CB"},{"id":14648,"word":"\u179F\u17D2\u179A\u17C4\u1798"},{"id":14649,"word":"\u179F\u17D2\u179A\u17C4\u179B\u17D7"},{"id":14650,"word":"\u179F\u17D2\u179A\u17C6"},{"id":14651,"word":"\u179F\u17D2\u179A\u17B6\u17C6"},{"id":14652,"word":"\u179F\u17D2\u179A\u17B6\u17C6\u1784"},{"id":14653,"word":"\u179F\u17D2\u179A\u17C7"},{"id":14654,"word":"\u179F\u17D2\u179B"},{"id":14655,"word":"\u179F\u17D2\u179B\u1780\u17CB"},{"id":14656,"word":"\u179F\u17D2\u179B\u1784\u17CB"},{"id":14657,"word":"\u179F\u17D2\u179B\u178F"},{"id":14658,"word":"\u179F\u17D2\u179B\u1793\u17CB"},{"id":14659,"word":"\u179F\u17D2\u179B\u1794"},{"id":14660,"word":"\u179F\u17D2\u179B\u17B6"},{"id":14661,"word":"\u179F\u17D2\u179B\u17B6\u1780"},{"id":14662,"word":"\u179F\u17D2\u179B\u17B6\u1780\u17CB"},{"id":14663,"word":"\u179F\u17D2\u179B\u17B6\u1780\u179F\u17D2\u1793\u17B6\u1798"},{"id":14664,"word":"\u179F\u17D2\u179B\u17B6\u1780\u17C6\u1789\u17B6\u1793"},{"id":14665,"word":"\u179F\u17D2\u179B\u17B6\u1787\u1798"},{"id":14666,"word":"\u179F\u17D2\u179B\u17B6\u1787\u17D2\u179C\u17B6"},{"id":14667,"word":"\u179F\u17D2\u179B\u17B6\u1788\u17D2\u1798\u17C4\u179B"},{"id":14668,"word":"\u179F\u17D2\u179B\u17B6\u178F"},{"id":14669,"word":"\u179F\u17D2\u179B\u17B6\u178F\u17B6\u17B1\u1793"},{"id":14670,"word":"\u179F\u17D2\u179B\u17B6\u178F\u17D2\u179A\u17BD\u1799"},{"id":14671,"word":"\u179F\u17D2\u179B\u17B6\u1792\u1798\u17CC"},{"id":14672,"word":"\u179F\u17D2\u179B\u17B6\u1794"},{"id":14673,"word":"\u179F\u17D2\u179B\u17B6\u1794\u17CB"},{"id":14674,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1780\u17C2\u179C"},{"id":14675,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1785\u17D2\u179A\u179C\u17B6"},{"id":14676,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1791\u17B6"},{"id":14677,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1794\u17C9\u17B6\u1780\u1780\u17B6"},{"id":14678,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1794\u17D2\u179A\u1785\u17C0\u179C"},{"id":14679,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1796\u17D2\u179A\u17B6"},{"id":14680,"word":"\u179F\u17D2\u179B\u17B6\u1794\u1796\u17D2\u179A\u17B7\u179B"},{"id":14681,"word":"\u179F\u17D2\u179B\u17B6\u1799"},{"id":14682,"word":"\u179F\u17D2\u179B\u17B6\u179F\u17D2\u1784\u17B6\u1794"},{"id":14683,"word":"\u179F\u17D2\u179B\u17B6\u17A2\u17B8"},{"id":14684,"word":"\u179F\u17D2\u179B\u17B9\u1780"},{"id":14685,"word":"\u179F\u17D2\u179B\u17B9\u1780\u1782\u17D2\u179A\u17C3"},{"id":14686,"word":"\u179F\u17D2\u179B\u17B9\u1780\u1796\u17C4\u1792\u17B7\u17CD"},{"id":14687,"word":"\u179F\u17D2\u179B\u17B9\u1784"},{"id":14688,"word":"\u179F\u17D2\u179B\u17B9\u1794"},{"id":14689,"word":"\u179F\u17D2\u179B\u17BA"},{"id":14690,"word":"\u179F\u17D2\u179B\u17BA\u178F"},{"id":14691,"word":"\u179F\u17D2\u179B\u17BA\u178F\u179F\u17D2\u179B\u1780\u17CB"},{"id":14692,"word":"\u179F\u17D2\u179B\u17BB\u1780"},{"id":14693,"word":"\u179F\u17D2\u179B\u17BB\u1784"},{"id":14694,"word":"\u179F\u17D2\u179B\u17BB\u178F"},{"id":14695,"word":"\u179F\u17D2\u179B\u17BB\u178F\u17B8"},{"id":14696,"word":"\u179F\u17D2\u179B\u17BB\u1794"},{"id":14697,"word":"\u179F\u17D2\u179B\u17BB\u1799"},{"id":14698,"word":"\u179F\u17D2\u179B\u17BB\u17C7 "},{"id":14699,"word":"\u179F\u17D2\u179B\u17BC\u1789"},{"id":14700,"word":"\u179F\u17D2\u179B\u17BC\u178F"},{"id":14701,"word":"\u179F\u17D2\u179B\u17BC\u178F\u1794\u17BC\u178F"},{"id":14702,"word":"\u179F\u17D2\u179B\u17BE\u178F"},{"id":14703,"word":"\u179F\u17D2\u179B\u17BE\u178F\u179F\u17D2\u179B\u1780\u17CB"},{"id":14704,"word":"\u179F\u17D2\u179B\u17C0\u1780"},{"id":14705,"word":"\u179F\u17D2\u179B\u17C1\u1780"},{"id":14706,"word":"\u179F\u17D2\u179B\u17C1\u179C"},{"id":14707,"word":"\u179F\u17D2\u179B\u17C1\u179F\u17D2\u1798"},{"id":14708,"word":"\u179F\u17D2\u179B\u17C1\u17C7"},{"id":14709,"word":"\u179F\u17D2\u179B\u17C2"},{"id":14710,"word":"\u179F\u17D2\u179B\u17C2\u1784"},{"id":14711,"word":"\u179F\u17D2\u179B\u17C2\u1784\u178A\u1784\u178A\u17B9\u1784"},{"id":14712,"word":"\u179F\u17D2\u179B\u17C2\u1784\u1796\u17D2\u179A\u179C\u17C0\u1780"},{"id":14713,"word":"\u179F\u17D2\u179B\u17C2\u178F"},{"id":14714,"word":"\u179F\u17D2\u179B\u17C2\u179C"},{"id":14715,"word":"\u179F\u17D2\u179B\u17C4"},{"id":14716,"word":"\u179F\u17D2\u179B\u17C4\u1780"},{"id":14717,"word":"\u179F\u17D2\u179B\u17C4\u1798"},{"id":14718,"word":"\u179F\u17D2\u179B\u17C5"},{"id":14719,"word":"\u179F\u17D2\u179B\u17B6\u17C6\u1784"},{"id":14720,"word":"\u179F\u17D2\u179C\u1785\u17D2\u1786\u1793\u17D2\u1791"},{"id":14721,"word":"\u179F\u17D2\u179C\u1787\u1793"},{"id":14722,"word":"\u179F\u17D2\u179C\u178F"},{"id":14723,"word":"\u179F\u17D2\u179C\u1791\u17C1\u179F"},{"id":14724,"word":"\u179F\u17D2\u179C\u1797\u17BC\u1798\u17B7"},{"id":14725,"word":"\u179F\u17D2\u179C\u1799\u17D0\u178F"},{"id":14726,"word":"\u179F\u17D2\u179C\u1799\u1798\u17D2\u1796\u179A\u17B6"},{"id":14727,"word":"\u179F\u17D2\u179C\u1799\u1798\u17D2\u1797\u17BC"},{"id":14728,"word":"\u179F\u17D2\u179C\u17D0\u1799\u178F\u17D2\u179A\u17B6\u178E"},{"id":14729,"word":"\u179F\u17D2\u179C\u17D0\u1799\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F"},{"id":14730,"word":"\u179F\u17D2\u179C\u17D0\u1799\u1794\u17D2\u179A\u179C\u178F\u17D2\u178F\u17B7"},{"id":14731,"word":"\u179F\u17D2\u179C\u17D0\u1799\u1797\u17B6\u1796 "},{"id":14732,"word":"\u179F\u17D2\u179C\u179A\u17C8"},{"id":14733,"word":"\u179F\u17D2\u179C\u179F\u17D2\u178F\u17B7"},{"id":14734,"word":"\u179F\u17D2\u179C\u179F\u17D2\u178A\u17B7\u1780"},{"id":14735,"word":"\u179F\u17D2\u179C\u179F\u17D2\u178A\u17B8"},{"id":14736,"word":"\u179F\u17D2\u179C\u17B6"},{"id":14737,"word":"\u179F\u17D2\u179C\u17B6\u1780\u17CB"},{"id":14738,"word":"\u179F\u17D2\u179C\u17B6\u1782\u178F"},{"id":14739,"word":"\u179F\u17D2\u179C\u17B6\u1782\u178F\u17C6 !"},{"id":14740,"word":"\u179F\u17D2\u179C\u17B6\u1782\u1798\u1793\u17CD"},{"id":14741,"word":"\u179F\u17D2\u179C\u17B6\u1784"},{"id":14742,"word":"\u179F\u17D2\u179C\u17B6\u1784\u17D2\u1782"},{"id":14743,"word":"\u179F\u17D2\u179C\u17B6\u1784\u17D2\u1782\u1793\u17B6"},{"id":14744,"word":"\u179F\u17D2\u179C\u17B6\u1784\u17D2\u1782\u17B6"},{"id":14745,"word":"\u179F\u17D2\u179C\u17B6\u1789\u17B6\u1780\u17CB\u1785\u17B7\u1789\u17D2\u1785\u17BE\u1798"},{"id":14746,"word":"\u179F\u17D2\u179C\u17B6\u178F"},{"id":14747,"word":"\u179F\u17D2\u179C\u17B6\u1791\u17BB"},{"id":14748,"word":"\u179F\u17D2\u179C\u17B6\u1792\u17B8\u1793"},{"id":14749,"word":"\u179F\u17D2\u179C\u17B6\u1792\u17D2\u1799\u17B6\u1799"},{"id":14750,"word":"\u179F\u17D2\u179C\u17B6\u1792\u17D2\u1799\u17B6\u1799\u1793\u17CD"},{"id":14751,"word":"\u179F\u17D2\u179C\u17B6\u1792\u17D2\u1799\u17B6\u1799\u17B7\u1793"},{"id":14752,"word":"\u179F\u17D2\u179C\u17B6\u1793"},{"id":14753,"word":"\u179F\u17D2\u179C\u17B6\u1798\u17B8"},{"id":14754,"word":"\u179F\u17D2\u179C\u17B6\u1799"},{"id":14755,"word":"\u179F\u17D2\u179C\u17B6\u1799\u1785\u1793\u17D2\u1791\u17B8"},{"id":14756,"word":"\u179F\u17D2\u179C\u17B6\u1799\u178F\u17D2\u179A\u17B6\u17C6"},{"id":14757,"word":"\u179F\u17D2\u179C\u17B6\u1799\u1796\u17D2\u179A\u17C3"},{"id":14758,"word":"\u179F\u17D2\u179C\u17B6\u179A\u17B6\u1787"},{"id":14759,"word":"\u179F\u17D2\u179C\u17B6\u179A\u17B6\u1787\u17D2\u1799"},{"id":14760,"word":"\u179F\u17D2\u179C\u17B6\u179F"},{"id":14761,"word":"\u179F\u17D2\u179C\u17B6\u179F\u179A\u17C4\u1782"},{"id":14762,"word":"\u179F\u17D2\u179C\u17B6\u17A0\u17C8"},{"id":14763,"word":"\u179F\u17D2\u178A\u17B6\u1794\u17CB\u179F\u17D2\u179C\u17B6\u17A0\u17B6"},{"id":14764,"word":"\u179F\u17D2\u179C\u17B6\u17A0\u17B6\u1794\u17CB"},{"id":14765,"word":"\u179F\u17D2\u179C\u17B6\u17A0\u17B6\u1794\u178F\u17B7"},{"id":14766,"word":"\u179F\u17D2\u179C\u17B6\u17A0\u17B6\u1799"},{"id":14767,"word":"\u179F\u17D2\u179C\u17B6\u17A0\u17B7\u1785 \u179F\u17D2\u179C\u17B6\u17A0\u17B6\u179A"},{"id":14768,"word":"\u179F\u17D2\u179C\u17B7\u178F"},{"id":14769,"word":"\u179F\u17D2\u179C\u17B7\u178F\u1785\u17C5"},{"id":14770,"word":"\u179F\u17D2\u179C\u17B7\u178F\u179F\u17D2\u179C\u17B6\u1789"},{"id":14771,"word":"\u179F\u17D2\u179C\u17B8\u1780\u179A\u178E\u17CD"},{"id":14772,"word":"\u179F\u17D2\u179C\u17B8\u1780\u17B6\u179A"},{"id":14773,"word":"\u179F\u17D2\u179C\u17B8\u1780\u17D2\u179A\u17B9\u178F\u17B7"},{"id":14774,"word":"\u179F\u17D2\u179C\u17C1\u178F"},{"id":14775,"word":"\u179F\u17D2\u179C\u17C2\u1784"},{"id":14776,"word":"\u179F\u17D2\u179C\u17C2\u178F"},{"id":14777,"word":"\u179F\u17D2\u179C\u17C3\u179A\u17B7\u1793"},{"id":14778,"word":"\u179F\u17D2\u179C\u17C3\u179A\u17B7\u1793\u17B8"},{"id":14779,"word":"\u179F\u17D2\u179C\u17C4\u1799"},{"id":14780,"word":"\u179F\u17D2\u179C\u17C7"},{"id":14781,"word":"\u179F\u17D2\u179C\u17C7\u1796\u1793\u17D2\u179B\u17C7"},{"id":14782,"word":"\u179F\u17D2\u17A2\u1780"},{"id":14783,"word":"\u179F\u17D2\u17A2\u1794\u17CB"},{"id":14784,"word":"\u179F\u17D2\u17A2\u1799"},{"id":14785,"word":"\u179F\u17D2\u17A2\u17B6"},{"id":14786,"word":"\u179F\u17D2\u17A2\u17B6\u1784"},{"id":14787,"word":"\u179F\u17D2\u17A2\u17B6\u178F"},{"id":14788,"word":"\u179F\u17D2\u17A2\u17B6\u178F\u1794\u17B6\u178F"},{"id":14789,"word":"\u179F\u17D2\u17A2\u17B6\u1793"},{"id":14790,"word":"\u179F\u17D2\u17A2\u17B6\u1794\u17CB"},{"id":14791,"word":"\u179F\u17D2\u17A2\u17B7\u178F"},{"id":14792,"word":"\u179F\u17D2\u17A2\u17B7\u178F\u179F\u17D2\u17A2\u17B6\u1784"},{"id":14793,"word":"\u179F\u17D2\u17A2\u17B8"},{"id":14794,"word":"\u179F\u17D2\u17A2\u17BB\u1784"},{"id":14795,"word":"\u179F\u17D2\u17A2\u17BB\u1799"},{"id":14796,"word":"\u179F\u17CA\u17D2\u17A2\u17BB\u1799"},{"id":14797,"word":"\u179F\u17D2\u17A2\u17BB\u17C7"},{"id":14798,"word":"\u179F\u17D2\u17A2\u17BC\u1785"},{"id":14799,"word":"\u179F\u17D2\u17A2\u17C0\u1785"},{"id":14800,"word":"\u179F\u17D2\u17A2\u17C1\u1780"},{"id":14801,"word":"\u179F\u17D2\u17A2\u17C2\u1780"},{"id":14802,"word":"\u179F\u17D2\u17A2\u17C2\u179B"},{"id":14803,"word":"\u179F\u17D2\u17A2\u17C6"},{"id":14804,"word":"\u17A0"},{"id":14805,"word":"\u17A0 !"},{"id":14806,"word":"\u17A0\u17CA"},{"id":14807,"word":"\u17A0\u17C8"},{"id":14808,"word":"\u17A0\u1780"},{"id":14809,"word":"\u17A0\u1780\u17CB"},{"id":14810,"word":"\u17A0\u1784"},{"id":14811,"word":"\u17A0\u1784\u17D2\u179F"},{"id":14812,"word":"\u17A0\u1784\u17D2\u179F --"},{"id":14813,"word":"\u17A0\u1784\u17D2\u179F\u1794\u17B6\u1791"},{"id":14814,"word":"\u17A0\u178A\u17D2\u178A\u1785\u17C4\u179A\u1780"},{"id":14815,"word":"\u17A0\u178A\u17D2\u178A\u1785\u17C4\u179A\u17B7\u1780\u17B6"},{"id":14816,"word":"\u17A0\u178A\u17D2\u178A\u179C\u17B7\u179B\u17B6\u179F\u17B7\u1793\u17B8"},{"id":14817,"word":"\u17A0\u178A\u17D2\u178B\u1785\u17B7\u178F\u17D2\u178F"},{"id":14818,"word":"\u17A0\u178B\u1799\u17C4\u1782"},{"id":14819,"word":"\u17A0\u178B\u179C\u17B7\u1791\u17D2\u1799\u17B6"},{"id":14820,"word":"\u17A0\u178F\u17CB"},{"id":14821,"word":"\u17A0\u178F\u1780\u17D2\u1780\u17B7\u179B\u17C1\u179F"},{"id":14822,"word":"\u17A0\u17D0\u178F\u17A0\u17C4\u1784"},{"id":14823,"word":"\u17A0\u178F\u17D2\u1790"},{"id":14824,"word":"\u17A0\u178F\u17D2\u1790 --"},{"id":14825,"word":"\u17A0\u178F\u17D2\u1790\u1794\u17B6\u179F"},{"id":14826,"word":"\u17A0\u178F\u17D2\u1790\u17B6 --"},{"id":14827,"word":"\u17A0\u178F\u17D2\u1790\u17B7\u1782\u17C4\u1794\u1780"},{"id":14828,"word":"\u17A0\u178F\u17D2\u1790\u17B7\u1782\u17C4\u1794\u17B7\u1780\u17B6"},{"id":14829,"word":"\u17A0\u178F\u17D2\u1790\u17B7\u1793\u17B8"},{"id":14830,"word":"\u17A0\u178F\u17D2\u1790\u17B7\u1794\u17B6\u179B"},{"id":14831,"word":"\u17A0\u178F\u17D2\u1790\u17B7\u1798\u17B6\u179A\u1780"},{"id":14832,"word":"\u17A0\u178F\u17D2\u1790\u17B7\u179B\u17B7\u1784\u17D2\u1782"},{"id":14833,"word":"\u17A0\u178F\u17D2\u1790\u17B8"},{"id":14834,"word":"\u17A0\u1791\u17D0\u1799"},{"id":14835,"word":"\u17A0\u17D0\u1793"},{"id":14836,"word":"\u17A0\u1793\u17BB\u1798\u17B6\u1793"},{"id":14837,"word":"\u17A0\u1793\u17BC"},{"id":14838,"word":"\u17A0\u1793\u17C1\u1799\u17D2\u1799\u17BB\u17C6"},{"id":14839,"word":"\u17A0\u1793\u17D2\u1791\u1799\u17BB\u17C6"},{"id":14840,"word":"\u17A0\u1794"},{"id":14841,"word":"\u17A0\u1794\u17CB"},{"id":14842,"word":"\u17A0\u17CA\u1794 !"},{"id":14843,"word":"\u17A0\u1798\u17D2\u1798\u17B7\u1799"},{"id":14844,"word":"\u17A0\u1799 --"},{"id":14845,"word":"\u17A0\u1799\u17C8"},{"id":14846,"word":"\u17A0\u1799\u17B6 --"},{"id":14847,"word":"\u17A0\u1799\u17B7\u1793"},{"id":14848,"word":"\u17A0\u1799\u17C4  --"},{"id":14849,"word":"\u17A0\u179A --"},{"id":14850,"word":"\u17A0\u179A\u17C8"},{"id":14851,"word":"\u17A0\u179A\u17B7"},{"id":14852,"word":"\u17A0\u179A\u17B7 --"},{"id":14853,"word":"\u17A0\u179A\u17B7\u178F"},{"id":14854,"word":"\u17A0\u179A\u17B7\u178F\u17B6\u179B"},{"id":14855,"word":"\u17A0\u17AB\u1791\u17D0\u1799"},{"id":14856,"word":"\u17A0\u179B\u17CB"},{"id":14857,"word":"\u17A0\u179B\u17B6\u17A0\u179B"},{"id":14858,"word":"\u17A0\u17D0\u179C"},{"id":14859,"word":"\u17A0\u179C\u17B7\u179F"},{"id":14860,"word":"\u17A0\u179F"},{"id":14861,"word":"\u17A0\u17CA\u179F"},{"id":14862,"word":"\u17A0\u179F\u1793 --"},{"id":14863,"word":"\u17A0\u179F\u1793\u17C8"},{"id":14864,"word":"\u17A0\u179F\u1793\u17B6 --"},{"id":14865,"word":"\u17A0\u179F\u1793\u17B8\u1799"},{"id":14866,"word":"\u17A0\u179F\u1793\u17B8\u1799 --"},{"id":14867,"word":"\u17A0\u179F\u1793\u17C4  --"},{"id":14868,"word":"\u17A0\u179F\u17B6\u1797\u17B7\u1794\u17D2\u179A\u17B6\u1799"},{"id":14869,"word":"\u17A0\u179F\u17B7\u1780\u17B6"},{"id":14870,"word":"\u17A0\u179F\u17B7\u178F"},{"id":14871,"word":"\u17A0\u179F\u17B7\u178F --"},{"id":14872,"word":"\u17A0\u179F\u17D2\u178F"},{"id":14873,"word":"\u17A0\u179F\u17D2\u178A\u17B7\u1793"},{"id":14874,"word":"\u17A0\u17A0\u17D2\u1798\u17BB\u1780"},{"id":14875,"word":"\u17A0\u17B6"},{"id":14876,"word":"\u17A0\u17B6"},{"id":14877,"word":"\u17A0\u17B6 !"},{"id":14878,"word":"\u17A0\u17B6\u1780\u17CB"},{"id":14879,"word":"\u17A0\u17B6\u1780\u17CB\u17D7"},{"id":14880,"word":"\u17A0\u17B6\u1784"},{"id":14881,"word":"\u17A0\u17B6\u1785\u17CB"},{"id":14882,"word":"\u17A0\u17B6\u1785\u17CB\u1787\u17B6"},{"id":14883,"word":"\u17A0\u17B6\u178A\u1780"},{"id":14884,"word":"\u17A0\u17B6\u178E\u17BC\u1799"},{"id":14885,"word":"\u17A0\u17B6\u178F\u17CB"},{"id":14886,"word":"\u17A0\u17B6\u178F\u17CB\u1796\u17D2\u1799\u17B6\u1798"},{"id":14887,"word":"\u17A0\u17B6\u178F\u17CB\u17A0\u17C4\u1784"},{"id":14888,"word":"\u17A0\u17B6\u1793"},{"id":14889,"word":"\u17A0\u17B6\u1793\u17CB"},{"id":14890,"word":"\u17A0\u17CA\u17B6\u1793"},{"id":14891,"word":"\u17A0\u17B6\u1793\u178F\u17C2\u1790\u17B6"},{"id":14892,"word":"\u17A0\u17B6\u1793\u1797\u17B6\u1782\u17B7\u1793\u17B8"},{"id":14893,"word":"\u17A0\u17B6\u1793\u1797\u17B6\u1782\u17B7\u1799"},{"id":14894,"word":"\u17A0\u17B6\u1793\u1797\u17B6\u1782\u17B8"},{"id":14895,"word":"\u17A0\u17B6\u1794"},{"id":14896,"word":"\u17A0\u17B6\u1794\u17CB"},{"id":14897,"word":"\u17A0\u17B6\u1798"},{"id":14898,"word":"\u17A0\u17B6\u1799\u1793 --"},{"id":14899,"word":"\u17A0\u17B6\u1799\u1793\u17C8"},{"id":14900,"word":"\u17A0\u17B6\u179A"},{"id":14901,"word":"\u17A0\u17B6\u179A\u17B7\u1793"},{"id":14902,"word":"\u17A0\u17B6\u179A\u17B7\u1793\u17B8"},{"id":14903,"word":"\u17A0\u17B6\u179A\u17B8"},{"id":14904,"word":"\u17A0\u17B6\u179B"},{"id":14905,"word":"\u17A0\u17B6\u179C"},{"id":14906,"word":"\u17A0\u17B6\u179C  !"},{"id":14907,"word":"\u17A0\u17B6\u179F  !"},{"id":14908,"word":"\u17A0\u17B6\u179F"},{"id":14909,"word":"\u17A0\u17B6\u179F\u1793\u17B8\u1799"},{"id":14910,"word":"\u17A0\u17B6\u179F\u17A0\u17B6\u1799!"},{"id":14911,"word":"\u17A0\u17B6\u179F\u17A0\u17BA\u1799"},{"id":14912,"word":"\u17A0\u17B6\u179F\u17B7\u1794"},{"id":14913,"word":"\u17A0\u17B6\u17A0\u17B6"},{"id":14914,"word":"\u17A0\u17B6\u17A2\u17BA \u17D7"},{"id":14915,"word":"\u17A0\u17CA\u200C\u17B7"},{"id":14916,"word":"\u17A0\u17B7\u1784\u17D2\u1782\u17BB"},{"id":14917,"word":"\u17A0\u17B7\u1784\u17D2\u1782\u17BB\u179B"},{"id":14918,"word":"\u17A0\u17B7\u1784\u17D2\u179F\u17B6"},{"id":14919,"word":"\u17A0\u17B7\u1785"},{"id":14920,"word":"\u17A0\u17B7\u1789 "},{"id":14921,"word":"\u17A0\u17B7\u178E\u17D2\u178C\u17B7\u1780"},{"id":14922,"word":"\u17A0\u17B7\u178E\u17D2\u178C\u17BC"},{"id":14923,"word":"\u17A0\u17B7\u178F"},{"id":14924,"word":"\u17A0\u17B7\u178F"},{"id":14925,"word":"\u17A0\u17B7\u178F --"},{"id":14926,"word":"\u17A0\u17B7\u178F\u1794\u17D2\u179A\u178E\u17B8"},{"id":14927,"word":"\u17A0\u17B7\u178F\u179A\u17C4\u1782"},{"id":14928,"word":"\u17A0\u17B7\u178F\u17B6 --"},{"id":14929,"word":"\u17A0\u17B7\u1793"},{"id":14930,"word":"\u17A0\u17B7\u1793\u17A0\u17BB\u1793"},{"id":14931,"word":"\u17A0\u17B7\u1794"},{"id":14932,"word":"\u17A0\u17B7\u1798 --"},{"id":14933,"word":"\u17A0\u17B7\u1798\u17C8"},{"id":14934,"word":"\u17A0\u17B7\u1798\u1796\u17B6\u1793\u17D2\u178F"},{"id":14935,"word":"\u17A0\u17B7\u1798\u179C\u17D0\u178F"},{"id":14936,"word":"\u17A0\u17B7\u1798\u17B6 --"},{"id":14937,"word":"\u17A0\u17B7\u1798\u17B6\u179B\u17D0\u1799"},{"id":14938,"word":"\u17A0\u17B7\u179A\u1789\u17D2\u1789"},{"id":14939,"word":"\u17A0\u17B7\u179A\u1789\u17D2\u1789 --"},{"id":14940,"word":"\u17A0\u17B7\u179A\u178E\u17D2\u1799"},{"id":14941,"word":"\u17A0\u17B7\u179A\u17B7"},{"id":14942,"word":"\u17A0\u17B7\u179A\u17B7 --"},{"id":14943,"word":"\u17A0\u17B7\u179A\u17C4\u178F\u17D2\u178F\u1794\u17D2\u1794\u17C8"},{"id":14944,"word":"\u17A0\u17B7\u179B"},{"id":14945,"word":"\u17A0\u17CA\u200C\u17B7\u17C7"},{"id":14946,"word":"\u17A0\u17CA\u200C\u17B8"},{"id":14947,"word":"\u17A0\u17CA\u200C\u17B8\u1784"},{"id":14948,"word":"\u17A0\u17CA\u200C\u17B8\u1784\u17A0\u17CA\u17B6\u1784"},{"id":14949,"word":"\u17A0\u17B8\u1793"},{"id":14950,"word":"\u17A0\u17B8\u1793 --"},{"id":14951,"word":"\u17A0\u17B8\u1793\u1799\u17B6\u1793"},{"id":14952,"word":"\u17A0\u17B8\u179A"},{"id":14953,"word":"\u17A0\u17CA\u200C\u17B9 !"},{"id":14954,"word":"\u17A0\u17CA\u200C\u17B9\u1780"},{"id":14955,"word":"\u17A0\u17CA\u200C\u17B9\u1780\u17A0\u17CA\u17B6\u1780\u17CB"},{"id":14956,"word":"\u17A0\u17CA\u200C\u17B9\u1784"},{"id":14957,"word":"\u17A0\u17B9\u1794"},{"id":14958,"word":"\u17A0\u17CA\u200C\u17B9\u1794"},{"id":14959,"word":"\u17A0\u17CA\u200C\u17B9\u1798\u17D7"},{"id":14960,"word":"\u17A0\u17B9\u179A"},{"id":14961,"word":"\u17A0\u17B9\u179F\u17B6"},{"id":14962,"word":"\u17A0\u17CA\u200C\u17B9\u17C7"},{"id":14963,"word":"\u17A0\u17BA"},{"id":14964,"word":"\u17A0\u17CA\u200C\u17BA"},{"id":14965,"word":"\u17A0\u17CA\u200C\u17BA\u17C8 !"},{"id":14966,"word":"\u17A0\u17BA\u178F"},{"id":14967,"word":"\u17A0\u17BA\u1794"},{"id":14968,"word":"\u17A0\u17BA\u1799 !"},{"id":14969,"word":"\u17A0\u17CA\u200C\u17BA\u1799"},{"id":14970,"word":"\u17A0\u17CA\u200C\u17BA\u17A0\u17B6"},{"id":14971,"word":"\u17A0\u17BB\u1780\u179F\u17B7\u1794"},{"id":14972,"word":"\u17A0\u17BB\u1784"},{"id":14973,"word":"\u17A0\u17BB\u1785"},{"id":14974,"word":"\u17A0\u17BB\u178F"},{"id":14975,"word":"\u17A0\u17CA\u17BB\u178F"},{"id":14976,"word":"\u17A0\u17BB\u178F"},{"id":14977,"word":"\u17A0\u17BB\u178F --"},{"id":14978,"word":"\u17A0\u17CA\u17BB\u1793"},{"id":14979,"word":"\u17A0\u17CA\u17BB\u1793\u17A0\u1799"},{"id":14980,"word":"\u17A0\u17CA\u17BB\u1798"},{"id":14981,"word":"\u17A0\u17CA\u17BB\u1798\u1796\u17D2\u179A\u17C2"},{"id":14982,"word":"\u17A0\u17CA\u17BB\u1798\u179A\u17C4\u1784"},{"id":14983,"word":"\u17A0\u17CA\u17BB\u1798\u17A0"},{"id":14984,"word":"\u17A0\u17BB\u1799"},{"id":14985,"word":"\u17A0\u17BB\u1799\u17A0\u17B6\u1799"},{"id":14986,"word":"\u17A0\u17BB\u179A\u17D7 "},{"id":14987,"word":"\u17A0\u17CA\u17BB\u17C7\u17D7"},{"id":14988,"word":"\u17A0\u17CA\u17BC"},{"id":14989,"word":"\u17A0\u17BC\u178F"},{"id":14990,"word":"\u17A0\u17BC\u178F\u1790\u17D2\u1793\u17B6\u1780\u17CB"},{"id":14991,"word":"\u17A0\u17BC\u1793\u17A0\u17CA\u1780\u17CB"},{"id":14992,"word":"\u17A0\u17BC\u1794"},{"id":14993,"word":"\u17A0\u17CA\u17BC\u1796\u17B6\u1793\u17CB"},{"id":14994,"word":"\u17A0\u17CA\u17BC\u1796\u17BC"},{"id":14995,"word":"\u17A0\u17BC\u179A"},{"id":14996,"word":"\u17A0\u17BC\u179B"},{"id":14997,"word":"\u17A0\u17BD\u1784"},{"id":14998,"word":"\u17A0\u17BD\u1784\u17A0\u17C2\u1784"},{"id":14999,"word":"\u17A0\u17BD\u1784\u17A0\u17C2\u1793"},{"id":15000,"word":"\u17A0\u17BD\u1785"},{"id":15001,"word":"\u17A0\u17BD\u1789"},{"id":15002,"word":"\u17A0\u17BD\u178F"},{"id":15003,"word":"\u17A0\u17BD\u1798"},{"id":15004,"word":"\u17A0\u17BD\u1798\u17C9\u17C3"},{"id":15005,"word":"\u17A0\u17BD\u1799"},{"id":15006,"word":"\u17A0\u17BD\u179A"},{"id":15007,"word":"\u17A0\u17BD\u179B"},{"id":15008,"word":"\u17A0\u17BD\u179F"},{"id":15009,"word":"\u17A0\u17BE\u1794"},{"id":15010,"word":"\u17A0\u17BE\u1798"},{"id":15011,"word":"\u17A0\u17BE\u1798\u179F\u17D2\u179A\u1780"},{"id":15012,"word":"\u17A0\u17BE\u1799"},{"id":15013,"word":"\u17A0\u17CA\u200C\u17BE\u1799 !"},{"id":15014,"word":"\u17A0\u17BE\u179A"},{"id":15015,"word":"\u17A0\u17C0"},{"id":15016,"word":"\u17A0\u17C0\u1793"},{"id":15017,"word":"\u17A0\u17C0\u1794\u1793\u17B9\u1784"},{"id":15018,"word":"\u17A0\u17C0\u179A"},{"id":15019,"word":"\u17A0\u17C0\u179C"},{"id":15020,"word":"\u17A0\u17C0\u179C\u17A0\u17C4\u17C7"},{"id":15021,"word":"\u17A0\u17C1"},{"id":15022,"word":"\u17A0\u17C1 !"},{"id":15023,"word":"\u17A0\u17C1\u17C8"},{"id":15024,"word":"\u17A0\u17C1\u1784"},{"id":15025,"word":"\u17A0\u17C1\u1784\u17A0\u17B6\u1784"},{"id":15026,"word":"\u17A0\u17C1\u1789"},{"id":15027,"word":"\u17A0\u17C1\u178A\u17D2\u178B\u17B7\u1798"},{"id":15028,"word":"\u17A0\u17C1\u178F\u17BB"},{"id":15029,"word":"\u17A0\u17C1\u178F\u17BB --"},{"id":15030,"word":"\u17A0\u17C1\u1794\u17D7"},{"id":15031,"word":"\u17A0\u17C1\u1798"},{"id":15032,"word":"\u17A0\u17C1\u1798 --"},{"id":15033,"word":"\u17A0\u17C1\u1798\u1793\u17D2\u178F"},{"id":15034,"word":"\u17A0\u17C1\u1798\u1793\u17D2\u178F --"},{"id":15035,"word":"\u17A0\u17C1\u1798\u1796\u17B6\u1793\u17D2\u178F"},{"id":15036,"word":"\u17A0\u17C1\u1798\u179C\u17D0\u178F"},{"id":15037,"word":"\u17A0\u17C1\u1798\u179C\u178F\u17B8"},{"id":15038,"word":"\u17A0\u17C1\u1798\u179C\u17D0\u1793\u17D2\u178F"},{"id":15039,"word":"\u17A0\u17C1\u1798\u17D2\u1794\u17BC\u1796\u17B6\u1793\u17D2\u178F"},{"id":15040,"word":"\u17A0\u17C1\u1798\u17B6\u1791\u17D2\u179A\u17B7"},{"id":15041,"word":"\u17A0\u17C1\u179A\u1789\u17D2\u1789\u17B7\u1780"},{"id":15042,"word":"\u17A0\u17C1\u179A\u1789\u17D2\u1789\u17B7\u1780\u17B6"},{"id":15043,"word":"\u17A0\u17C1\u179A\u17B7\u1780"},{"id":15044,"word":"\u17A0\u17C1\u179A\u17B7\u1780\u17B6"},{"id":15045,"word":"\u17A0\u17C1\u179B\u17A0\u179B"},{"id":15046,"word":"\u17A0\u17C1\u179B \u17A0\u17B6\u179B"},{"id":15047,"word":"\u17A0\u17C1\u179C"},{"id":15048,"word":"\u17A0\u17C1\u17C8\u17A0\u17CF"},{"id":15049,"word":"\u17A0\u17C1\u17A0\u17B6"},{"id":15050,"word":"\u17A0\u17C1\u17C7\u17D7"},{"id":15051,"word":"\u17A0\u17C2"},{"id":15052,"word":"\u17A0\u17CA\u17C2"},{"id":15053,"word":"\u17A0\u17CA\u17C2\u17C8"},{"id":15054,"word":"\u17A0\u17C2\u1780"},{"id":15055,"word":"\u17A0\u17C2\u1784"},{"id":15056,"word":"\u17A0\u17C2\u1794"},{"id":15057,"word":"\u17A0\u17C2\u1798"},{"id":15058,"word":"\u17A0\u17C2\u17A0\u17C3"},{"id":15059,"word":"\u17A0\u17C2\u179B\u17A0\u179B"},{"id":15060,"word":"\u17A0\u17C2\u17C8\u17A0\u17CF"},{"id":15061,"word":"\u17A0\u17C2\u17A0\u1798"},{"id":15062,"word":"\u17A0\u17C2\u17A0\u17BD\u1785"},{"id":15063,"word":"\u17A0\u17C2\u17C7"},{"id":15064,"word":"\u17A0\u17CA\u17C2\u17C7"},{"id":15065,"word":"\u17A0\u17C3"},{"id":15066,"word":"\u17A0\u17C3\u178E\u17B6\u17C6"},{"id":15067,"word":"\u17A0\u17C3\u1798\u1796\u178E\u17CC"},{"id":15068,"word":"\u17A0\u17C3\u1798\u179C\u178F\u17B8"},{"id":15069,"word":"\u17A0\u17C3\u179A\u17B7\u1780"},{"id":15070,"word":"\u17A0\u17C3\u179F\u17B6\u1793"},{"id":15071,"word":"\u17A0\u17C3\u17A2\u17BE !"},{"id":15072,"word":"\u17A0\u17C4"},{"id":15073,"word":"\u17A0\u17CA\u17C4"},{"id":15074,"word":"\u17A0\u17C4 --"},{"id":15075,"word":"\u17A0\u17C4\u1780"},{"id":15076,"word":"\u17A0\u17C4\u1784"},{"id":15077,"word":"\u17A0\u17C4\u1785"},{"id":15078,"word":"\u17A0\u17C4\u1785\u179B\u17D2\u17A2\u17C4\u1789"},{"id":15079,"word":"\u17A0\u17C4\u1787\u17B6\u1784"},{"id":15080,"word":"\u17A0\u17C4\u178E\u17D0\u1784"},{"id":15081,"word":"\u17A0\u17C4\u178F\u17B7\u179B"},{"id":15082,"word":"\u17A0\u17C4\u178F\u17D2\u179A"},{"id":15083,"word":"\u17A0\u17C4\u178F\u17D2\u179A\u17D0\u1799"},{"id":15084,"word":"\u17A0\u17C4\u1794\u17C9\u17C5"},{"id":15085,"word":"\u17A0\u17C4\u1798"},{"id":15086,"word":"\u17A0\u17C4\u1798 --"},{"id":15087,"word":"\u17A0\u17C4\u1798\u179A\u17C4\u1784"},{"id":15088,"word":"\u17A0\u17C4\u179A"},{"id":15089,"word":"\u17A0\u17C4\u179A  --"},{"id":15090,"word":"\u17A0\u17C4\u179A\u17B6"},{"id":15091,"word":"\u17A0\u17C4\u179A\u17B6  --"},{"id":15092,"word":"\u17A0\u17C4\u179A\u17C9\u17B6"},{"id":15093,"word":"\u17A0\u17C4\u179B"},{"id":15094,"word":"\u17A0\u17C4\u179B\u17D7"},{"id":15095,"word":"\u17A0\u17C4\u17C7"},{"id":15096,"word":"\u17A0\u17C5"},{"id":15097,"word":"\u17A0\u17CA\u17C5"},{"id":15098,"word":"\u17A0\u17C5\u17A0\u17B6\u1793"},{"id":15099,"word":"\u17A0\u17C6"},{"id":15100,"word":"\u17A0\u17D2\u1793"},{"id":15101,"word":"\u17A0\u17D2\u1793\u17D0\u1784"},{"id":15102,"word":"\u17A0\u17D2\u1793\u17B6\u17CE !"},{"id":15103,"word":"\u17A0\u17D2\u1793\u17B9\u1784"},{"id":15104,"word":"\u17A0\u17D2\u1793\u17B6\u17C6\u1784"},{"id":15105,"word":"\u17A0\u17D2\u1793\u17CE\u17C7 !"},{"id":15106,"word":"\u17A0\u17D2\u1798"},{"id":15107,"word":"\u17A0\u17D2\u1798 --"},{"id":15108,"word":"\u17A0\u17D2\u1798\u1782\u17D2\u179C\u17B6\u1798"},{"id":15109,"word":"\u17A0\u17D2\u1798\u1784"},{"id":15110,"word":"\u17A0\u17D2\u1798\u178F\u17CB"},{"id":15111,"word":"\u17A0\u17D2\u1798\u178F\u17CB\u1785\u178F\u17CB"},{"id":15112,"word":"\u17A0\u17D2\u1798\u178F\u17CB\u17A0\u17D2\u1798\u1784"},{"id":15113,"word":"\u17A0\u17D2\u1798\u1794"},{"id":15114,"word":"\u17A0\u17D2\u1798\u1794\u17A0\u17D2\u1798\u17B6\u1799"},{"id":15115,"word":"\u17A0\u17D2\u1798\u17B6\u1799"},{"id":15116,"word":"\u17A0\u17D2\u1798\u17BA\u1793"},{"id":15117,"word":"\u17A0\u17D2\u1798\u17BC\u178F"},{"id":15118,"word":"\u17A0\u17D2\u1798\u17C1 !"},{"id":15119,"word":"\u17A0\u17D2\u179A\u179F\u17D2\u179C"},{"id":15120,"word":"\u17A0\u17D2\u179C\u17D2\u179A\u1784\u17D2\u1780"},{"id":15121,"word":"\u17A0\u17D2\u179C\u17D2\u179A\u17D0\u1784"},{"id":15122,"word":"\u17A0\u17D2\u17AB\u1791\u17D0\u1799"},{"id":15123,"word":"\u17A0\u17D2\u179B\u17D0\u1780"},{"id":15124,"word":"\u17A0\u17D2\u179B\u17D0\u1780\u17A0\u17D2\u179B\u17D0\u1784"},{"id":15125,"word":"\u17A0\u17D2\u179B\u17B6\u1780"},{"id":15126,"word":"\u17A0\u17D2\u179B\u17B6\u1780\u17CB"},{"id":15127,"word":"\u17A0\u17D2\u179B\u17B6\u1780\u17CB --"},{"id":15128,"word":"\u17A0\u17D2\u179B\u17B6\u1780\u17CB\u17A0\u17D2\u179B\u17B6\u17C6\u1784"},{"id":15129,"word":"\u17A0\u17D2\u179B\u17B6\u1799"},{"id":15130,"word":"\u17A0\u17D2\u179B\u17BD\u1784"},{"id":15131,"word":"\u17A0\u17D2\u179B\u17BD\u1784\u1796\u17D2\u179A\u17C7\u1794\u17B6\u1784"},{"id":15132,"word":"\u17A0\u17D2\u179B\u17C1\u179C\u17A0\u17D2\u179B\u17C3"},{"id":15133,"word":"\u17A0\u17D2\u179C\u1784\u17CB"},{"id":15134,"word":"\u17A0\u17D2\u179C\u17B6\u179A"},{"id":15135,"word":"\u17A0\u17D2\u179C\u17CA\u200C\u17B8\u179B"},{"id":15136,"word":"\u17A0\u17D2\u179C\u17B9\u1780"},{"id":15137,"word":"\u17A0\u17D2\u179C\u17B9\u1780\u17A0\u17D2\u179C\u17BA\u1793"},{"id":15138,"word":"\u17A0\u17D2\u179C\u17BC\u1784"},{"id":15139,"word":"\u17A0\u17D2\u179C\u17BC\u1784\u17A0\u17D2\u179C\u17B6\u1799"},{"id":15140,"word":"\u17A0\u17D2\u179C\u17BC\u1784\u178A\u17B7\u1793"},{"id":15141,"word":"\u17A0\u17D2\u179C\u17C1"},{"id":15142,"word":"\u17A0\u17D2\u179C\u17C5"},{"id":15143,"word":"\u17A1"},{"id":15144,"word":"\u17A1\u1780"},{"id":15145,"word":"\u17A1\u1780\u17A1\u17B6\u1799"},{"id":15146,"word":"\u17A1\u1784\u17D7"},{"id":15147,"word":"\u17A1\u1784\u17CB"},{"id":15148,"word":"\u17A1\u178F"},{"id":15149,"word":"\u17A1\u1794\u17CB"},{"id":15150,"word":"\u17A1\u1794\u17CB\u17D7"},{"id":15151,"word":"\u17A1\u1794\u17CB\u17A1\u17C2"},{"id":15152,"word":"\u17A1\u17B6\u1780"},{"id":15153,"word":"\u17A1\u17B6\u1780\u17CB"},{"id":15154,"word":"\u17A1\u17B6\u1780\u17CB\u17A1\u17B6\u17C6\u1784"},{"id":15155,"word":"\u17A1\u17B6\u1785\u17C5"},{"id":15156,"word":"\u17A1\u17B6\u1789\u17CB"},{"id":15157,"word":"\u17A1\u17B6\u1793"},{"id":15158,"word":"\u17A1\u17B6\u1793\u17CB"},{"id":15159,"word":"\u17A1\u17B6\u1794"},{"id":15160,"word":"\u17A1\u17B6\u1794\u17CB\u1799\u17C1\u179A"},{"id":15161,"word":"\u17A1\u17B6\u1799"},{"id":15162,"word":"\u17A1\u17B6\u1799\u17A1\u17BB\u1784"},{"id":15163,"word":"\u17A1\u17B6\u179C"},{"id":15164,"word":"\u17A1\u17B6\u179C\u17A0\u17B6\u179C"},{"id":15165,"word":"\u17A1\u17B7\u1780\u17A1\u1780\u17CB"},{"id":15166,"word":"\u17A1\u17B7\u1784\u17A1\u1784\u17CB"},{"id":15167,"word":"\u17A1\u17B7\u1784\u17A1\u17B6\u17C6\u1784"},{"id":15168,"word":"\u17A1\u17B7\u1785"},{"id":15169,"word":"\u17A1\u17B7\u1793"},{"id":15170,"word":"\u17A1\u17B7\u1794\u17A1\u17BB\u1794"},{"id":15171,"word":"\u17A1\u17B7\u1798\u17A1\u17BB\u1798"},{"id":15172,"word":"\u17A1\u17B9\u1794"},{"id":15173,"word":"\u17A1\u17B9\u1798\u17D7 "},{"id":15174,"word":"\u17A1\u17BA\u178F"},{"id":15175,"word":"\u17A1\u17BA\u1793\u17A1\u1784\u17CB"},{"id":15176,"word":"\u17A1\u17BA\u1798"},{"id":15177,"word":"\u17A1\u17BB\u1780\u17A1\u17B6\u1780\u17CB"},{"id":15178,"word":"\u17A1\u17BB\u1784\u1785\u17BB\u1784"},{"id":15179,"word":"\u17A1\u17BB\u1784\u1794\u17BB\u178F"},{"id":15180,"word":"\u17A1\u17BB\u1784\u179F\u17BB\u1784"},{"id":15181,"word":"\u17A1\u17BB\u1794\u17D7"},{"id":15182,"word":"\u17A1\u17BB\u179B\u17D7"},{"id":15183,"word":"\u17A1\u17BC"},{"id":15184,"word":"\u17A1\u17BC\u1784"},{"id":15185,"word":"\u17A1\u17BC\u1784\u17A1\u17B6\u1784"},{"id":15186,"word":"\u17A1\u17BC\u1789"},{"id":15187,"word":"\u17A1\u17BC\u178F\u17CD"},{"id":15188,"word":"\u17A1\u17BC\u1799"},{"id":15189,"word":"\u17A1\u17BC\u1799\u1790\u17BC\u1799"},{"id":15190,"word":"\u17A1\u17BC\u17A1\u17B6"},{"id":15191,"word":"\u17A1\u17BE\u1784"},{"id":15192,"word":"\u17A1\u17BE\u1784\u1785\u17B6\u1784"},{"id":15193,"word":"\u17A1\u17BE\u1799"},{"id":15194,"word":"\u17A1\u17BE\u1799\u1793\u17B8\u179B\u17C2\u1784"},{"id":15195,"word":"\u17A1\u17C1\u1798\u17A1\u17B6\u1798"},{"id":15196,"word":"\u17A1\u17C1\u1798\u17A1\u17BA\u1798"},{"id":15197,"word":"\u17A1\u17C1\u179C"},{"id":15198,"word":"\u17A1\u17C1\u179C\u17A1\u17C3"},{"id":15199,"word":"\u17A1\u17C1\u179C\u17A2\u17B6\u179C"},{"id":15200,"word":"\u17A1\u17C1\u17C7\u17A1\u17C4\u17C7"},{"id":15201,"word":"\u17A1\u17C1\u17C7\u17A1\u17C7"},{"id":15202,"word":"\u17A1\u17C2\u17D7"},{"id":15203,"word":"\u17A1\u17C2\u1780"},{"id":15204,"word":"\u17A1\u17C2\u1780\u17A1\u17B6\u1793\u17CB"},{"id":15205,"word":"\u17A1\u17C2\u1794\u1781\u17B6\u1799"},{"id":15206,"word":"\u17A1\u17C2\u1794\u17A1\u1794"},{"id":15207,"word":"\u17A1\u17C2\u1798\u17D7"},{"id":15208,"word":"\u17A1\u17C2\u17A1"},{"id":15209,"word":"\u17A1\u17C2\u17A1\u1794\u17CB"},{"id":15210,"word":"\u17A1\u17C4"},{"id":15211,"word":"\u17A1\u17C4\u1780"},{"id":15212,"word":"\u17A1\u17C4\u1798"},{"id":15213,"word":"\u17A1\u17C5"},{"id":15214,"word":"\u17A1\u17C5\u178F\u17C1\u1784"},{"id":15215,"word":"\u17A1\u17B6\u17C6"},{"id":15216,"word":"\u17A1\u17B6\u17C6\u1784"},{"id":15217,"word":"\u17A1\u17B6\u17C6\u1794\u17C9\u17B6"},{"id":15218,"word":"\u17A1\u17B6\u17C6\u179F\u17B6\u17C6"},{"id":15219,"word":"\u17A1\u17C7 "},{"id":15220,"word":"\u17A2"},{"id":15221,"word":"\u17A2 !"},{"id":15222,"word":"\u17A2\u1780"},{"id":15223,"word":"\u17A2\u1780\u178F\u1789\u17D2\u1789\u17BB\u178F\u17B6"},{"id":15224,"word":"\u17A2\u1780\u178F\u1789\u17D2\u1789\u17BC"},{"id":15225,"word":"\u17A2\u1780\u178F\u179C\u17C1\u1791\u17B7\u178F\u17B6"},{"id":15226,"word":"\u17A2\u1780\u178F\u179C\u17C1\u1791\u17B7\u1793\u17B8"},{"id":15227,"word":"\u17A2\u1780\u178F\u179C\u17C1\u1791\u17B8"},{"id":15228,"word":"\u17A2\u1780\u1793\u17B7\u178A\u17D2\u178B"},{"id":15229,"word":"\u17A2\u1780\u1793\u17B7\u178A\u17D2\u178B\u17B6"},{"id":15230,"word":"\u17A2\u1780\u1794\u17D2\u1794\u17B7\u1799"},{"id":15231,"word":"\u17A2\u1780\u1798\u17D2\u1798\u1780\u17B7\u179A\u17B7\u1799\u17B6"},{"id":15232,"word":"\u17A2\u1780\u1798\u17D2\u1798\u1792\u17B6\u178F\u17BB"},{"id":15233,"word":"\u17A2\u1780\u1799\u17C6"},{"id":15234,"word":"\u17A2\u1780\u179A\u17CD"},{"id":15235,"word":"\u17A2\u1780\u179A\u178E\u17B8\u1799"},{"id":15236,"word":"\u17A2\u1780\u17A2\u17C6\u1794\u17BB\u1780"},{"id":15237,"word":"\u17A2\u1780\u17B6\u179B"},{"id":15238,"word":"\u17A2\u1780\u17B7\u179A\u17B7\u1799\u179C\u17B6\u1791"},{"id":15239,"word":"\u17A2\u1780\u17B7\u179A\u17B7\u1799\u179C\u17B6\u1791\u17B7\u1793\u17B8"},{"id":15240,"word":"\u17A2\u1780\u17B7\u179A\u17B7\u1799\u179C\u17B6\u1791\u17B8"},{"id":15241,"word":"\u17A2\u1780\u17BB\u179F\u179B"},{"id":15242,"word":"\u17A2\u1780\u17BB\u179F\u179B --"},{"id":15243,"word":"\u17A2\u1780\u17D2\u1780"},{"id":15244,"word":"\u17A2\u1780\u17D2\u1780\u17C4\u179F\u1793"},{"id":15245,"word":"\u17A2\u1780\u17D2\u1780\u17C4\u179F\u1793  --"},{"id":15246,"word":"\u17A2\u1780\u17D2\u1780\u17C4\u179F\u179C\u178F\u17D2\u1790\u17BB"},{"id":15247,"word":"\u17A2\u1780\u17D2\u1781\u178E\u17C8"},{"id":15248,"word":"\u17A2\u1780\u17D2\u1781\u1791\u179F\u17D2\u179F"},{"id":15249,"word":"\u17A2\u1780\u17D2\u1781\u1791\u17C1\u179C\u17B7\u1793\u17B8"},{"id":15250,"word":"\u17A2\u1780\u17D2\u1781\u1791\u17C1\u179C\u17B8"},{"id":15251,"word":"\u17A2\u1780\u17D2\u1781\u1792\u17BB\u178F\u17D2\u178F\u17B8"},{"id":15252,"word":"\u17A2\u1780\u17D2\u1781\u1792\u17BC\u178F"},{"id":15253,"word":"\u17A2\u1780\u17D2\u1781\u1793\u17D2\u178F\u17B8"},{"id":15254,"word":"\u17A2\u1780\u17D2\u1781\u1794\u17B6\u178A"},{"id":15255,"word":"\u17A2\u1780\u17D2\u1781\u1794\u17B6\u178A\u1780"},{"id":15256,"word":"\u17A2\u1780\u17D2\u1781\u1798\u17B6"},{"id":15257,"word":"\u17A2\u1780\u17D2\u1781\u179A"},{"id":15258,"word":"\u17A2\u1780\u17D2\u1781\u179A --"},{"id":15259,"word":"\u17A2\u1780\u17D2\u1781\u179A\u1780\u17C4\u179C\u17B7\u1791"},{"id":15260,"word":"\u17A2\u1780\u17D2\u1781\u179A\u1794\u17D2\u1794\u1797\u17C1\u1791"},{"id":15261,"word":"\u17A2\u1780\u17D2\u1781\u179A\u17B6"},{"id":15262,"word":"\u17A2\u1780\u17D2\u1781\u179A\u17B6 --"},{"id":15263,"word":"\u17A2\u1780\u17D2\u1781\u17B7"},{"id":15264,"word":"\u17A2\u1780\u17D2\u1781\u17C4"},{"id":15265,"word":"\u17A2\u1780\u17D2\u1781\u17C4\u1797\u17B7\u1793\u17B8"},{"id":15266,"word":"\u17A2\u1780\u17D2\u1781\u17C4\u17A0\u17B7\u178E\u17B8"},{"id":15267,"word":"\u17A2\u17D0\u1780\u17D2\u179F"},{"id":15268,"word":"\u17A2\u1780\u17D2\u179F\u178E\u17C8"},{"id":15269,"word":"\u17A2\u1780\u17D2\u179F\u1791\u17C1\u179C\u17B7\u1793"},{"id":15270,"word":"\u17A2\u1780\u17D2\u179F\u1798\u17B6"},{"id":15271,"word":"\u17A2\u1780\u17D2\u179F\u179A"},{"id":15272,"word":"\u17A2\u1780\u17D2\u179F\u179A"},{"id":15273,"word":"\u17A2\u1780\u17D2\u179F\u179A --"},{"id":15274,"word":"\u17A2\u1780\u17D2\u179F\u17B6\u1793\u17D2\u178F\u17B8"},{"id":15275,"word":"\u17A2\u1780\u17D2\u179F\u17B7"},{"id":15276,"word":"\u17A2\u1780\u17D2\u179F\u17C5\u17A0\u17B7\u178E\u17B8"},{"id":15277,"word":"\u17A2\u1782\u178F\u17B7"},{"id":15278,"word":"\u17A2\u1782\u1793\u17D2\u1792\u1780"},{"id":15279,"word":"\u17A2\u1782\u1798\u1793\u17B8\u1799"},{"id":15280,"word":"\u17A2\u1782\u17B6\u1792"},{"id":15281,"word":"\u17A2\u1782\u17B6\u179A"},{"id":15282,"word":"\u17A2\u1782\u17B6\u179A\u179C\u17C8"},{"id":15283,"word":"\u17A2\u1782\u17BB\u178E"},{"id":15284,"word":"\u17A2\u1782\u17C4\u1785\u179A"},{"id":15285,"word":"\u17A2\u1782\u17D2\u1782"},{"id":15286,"word":"\u17A2\u1782\u17D2\u1782 --"},{"id":15287,"word":"\u17A2\u1782\u17D2\u1782\u17B7"},{"id":15288,"word":"\u17A2\u1782\u17D2\u1782\u17B7 --"},{"id":15289,"word":"\u17A2\u1782\u17D2\u1783"},{"id":15290,"word":"\u17A2\u1782\u17D2\u1793\u1793\u17D2\u1799\u17D0\u179F\u17D2\u178F\u17D2\u179A"},{"id":15291,"word":"\u17A2\u1782\u17D2\u1793\u1793\u17D2\u1799\u17BB\u178F\u17D2\u1794\u17B6\u178F"},{"id":15292,"word":"\u17A2\u1782\u17D2\u1793\u17B7"},{"id":15293,"word":"\u17A2\u1782\u17D2\u1793\u17B7 --"},{"id":15294,"word":"\u17A2\u1782\u17D2\u1799\u17B6\u1782\u17B6\u179A"},{"id":15295,"word":"\u17A2\u1782\u17D2\u179A"},{"id":15296,"word":"\u17A2\u1783\u1798\u17D0\u1799"},{"id":15297,"word":"\u17A2\u1783\u17C4\u179F"},{"id":15298,"word":"\u17A2\u1784"},{"id":15299,"word":"\u17A2\u1784\u17CB"},{"id":15300,"word":"\u17A2\u1784\u17CB\u1782\u17D2\u179B\u17C1\u179F"},{"id":15301,"word":"\u17A2\u1784\u17CB\u17A2\u17B6\u1785"},{"id":15302,"word":"\u17A2\u1784\u17D2\u1780"},{"id":15303,"word":"\u17A2\u1784\u17D2\u1780\u178F\u17CB"},{"id":15304,"word":"\u17A2\u1784\u17D2\u1780\u178F\u17CB\u1781\u17D2\u1798\u17C5"},{"id":15305,"word":"\u17A2\u1784\u17D2\u1780\u1793\u17CB"},{"id":15306,"word":"\u17A2\u1784\u17D2\u1780\u1794\u17B6\u179B\u17B7\u1780\u17B6"},{"id":15307,"word":"\u17A2\u1784\u17D2\u1780\u179A"},{"id":15308,"word":"\u17A2\u1784\u17D2\u1780\u17B6"},{"id":15309,"word":"\u17A2\u1784\u17D2\u1780\u17B6\u1789\u17CB"},{"id":15310,"word":"\u17A2\u1784\u17D2\u1780\u17B6\u1793\u17CB"},{"id":15311,"word":"\u17A2\u1784\u17D2\u1780\u17B6\u1794\u17CB\u17A2\u1784\u17D2\u1780\u17BE"},{"id":15312,"word":"\u17A2\u1784\u17D2\u1780\u17B6\u1798"},{"id":15313,"word":"\u17A2\u1784\u17D2\u1780\u17B6\u179B\u17CB"},{"id":15314,"word":"\u17A2\u1784\u17D2\u1780\u17B9"},{"id":15315,"word":"\u17A2\u1784\u17D2\u1780\u17B9\u1780"},{"id":15316,"word":"\u17A2\u1784\u17D2\u1780\u17BA\u179B"},{"id":15317,"word":"\u17A2\u1784\u17D2\u1780\u17BB\u1780"},{"id":15318,"word":"\u17A2\u1784\u17D2\u1780\u17BB\u1789"},{"id":15319,"word":"\u17A2\u1784\u17D2\u1780\u17BB\u179B"},{"id":15320,"word":"\u17A2\u1784\u17D2\u1780\u17BB\u179F"},{"id":15321,"word":"\u17A2\u1784\u17D2\u1780\u17BC\u179A"},{"id":15322,"word":"\u17A2\u1784\u17D2\u1780\u17BD\u1785"},{"id":15323,"word":"\u17A2\u1784\u17D2\u1780\u17BD\u1789"},{"id":15324,"word":"\u17A2\u1784\u17D2\u1780\u17BD\u1789\u178A\u17B8"},{"id":15325,"word":"\u17A2\u1784\u17D2\u1780\u17BE\u1780"},{"id":15326,"word":"\u17A2\u1784\u17D2\u1780\u17C0\u1798"},{"id":15327,"word":"\u17A2\u1784\u17D2\u1780\u17C0\u1798\u1784\u17C0\u178F"},{"id":15328,"word":"\u17A2\u1784\u17D2\u1780\u17C1\u178F"},{"id":15329,"word":"\u17A2\u1784\u17D2\u1780\u17C2"},{"id":15330,"word":"\u17A2\u1784\u17D2\u1780\u17C2\u178F"},{"id":15331,"word":"\u17A2\u1784\u17D2\u1780\u17C2\u179B\u17A2\u1784\u17D2\u1780\u17C3"},{"id":15332,"word":"\u17A2\u1784\u17D2\u1780\u17C4\u179B"},{"id":15333,"word":"\u17A2\u1784\u17D2\u1780\u17B6\u17C6"},{"id":15334,"word":"\u17A2\u1784\u17D2\u1780\u17D2\u179A\u1784"},{"id":15335,"word":"\u17A2\u1784\u17D2\u1780\u17D2\u179A\u178F"},{"id":15336,"word":"\u17A2\u1784\u17D2\u1780\u17D2\u179A\u17C1\u178F\u17A2\u1784\u17D2\u1780\u17D2\u179A\u178F"},{"id":15337,"word":"\u17A2\u1784\u17D2\u1782"},{"id":15338,"word":"\u17A2\u1784\u17D2\u1782 --"},{"id":15339,"word":"\u17A2\u1784\u17D2\u1782\u1789\u17CB"},{"id":15340,"word":"\u17A2\u1784\u17D2\u1782\u1789\u17CB\u179F\u17D2\u179C\u17B6"},{"id":15341,"word":"\u17A2\u1784\u17D2\u1782\u178F\u17CB"},{"id":15342,"word":"\u17A2\u1784\u17D2\u1782\u1793\u17B6"},{"id":15343,"word":"\u17A2\u1784\u17D2\u1782\u1794\u17CB"},{"id":15344,"word":"\u17A2\u1784\u17D2\u1782\u179A"},{"id":15345,"word":"\u17A2\u1784\u17D2\u1782\u179A --"},{"id":15346,"word":"\u17A2\u1784\u17D2\u1782\u179A\u1787\u17BB\u17C6"},{"id":15347,"word":"\u17A2\u1784\u17D2\u1782\u179A\u17B6\u1782"},{"id":15348,"word":"\u17A2\u1784\u17D2\u1782\u17D0\u179B"},{"id":15349,"word":"\u17A2\u1784\u17D2\u1782\u17B6"},{"id":15350,"word":"\u179A\u1784\u17D2\u1782\u17B6 --"},{"id":15351,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u178A\u17B8"},{"id":15352,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u1794\u17BB\u179F\u17D2\u1794"},{"id":15353,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u179A"},{"id":15354,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u179A --"},{"id":15355,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u179A\u17B7"},{"id":15356,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u179B\u17BF\u1784"},{"id":15357,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u179F"},{"id":15358,"word":"\u17A2\u1784\u17D2\u1782\u17B6\u179F\u17B8\u179B"},{"id":15359,"word":"\u17A2\u1784\u17D2\u1782\u17B8\u1780\u179A\u178E\u17CD"},{"id":15360,"word":"\u17A2\u1784\u17D2\u1782\u17B8\u179A\u179F"},{"id":15361,"word":"\u17A2\u1784\u17D2\u1782\u17BA"},{"id":15362,"word":"\u17A2\u1784\u17D2\u1782\u17BA\u17A2\u1784\u17D2\u1782\u17C2"},{"id":15363,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u1780"},{"id":15364,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u1780\u17A2\u1784\u17D2\u1782\u17BB\u179B"},{"id":15365,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u1799"},{"id":15366,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u1799\u1785\u17B6\u17C6\u178F\u17C2"},{"id":15367,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u179B"},{"id":15368,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u179B\u17C8"},{"id":15369,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u179B\u17B8"},{"id":15370,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u179B\u17B8 --"},{"id":15371,"word":"\u17A2\u1784\u17D2\u1782\u17BB\u179B\u17D2\u1799\u17B6\u1797\u179A\u178E\u17C8"},{"id":15372,"word":"\u17A2\u1784\u17D2\u1782\u17C2"},{"id":15373,"word":"\u17A2\u1784\u17D2\u1782\u17C6"},{"id":15374,"word":"\u17A2\u1784\u17D2\u1782\u17D2\u179A\u17D0\u1780\u17D2\u179F"},{"id":15375,"word":"\u17A2\u1784\u17D2\u1782\u17D2\u179A\u1784"},{"id":15376,"word":"\u17A2\u1784\u17D2\u1782\u17D2\u179A\u17BA\u178F"},{"id":15377,"word":"\u17A2\u1784\u17D2\u1782\u17D2\u179B\u17C1\u179F"},{"id":15378,"word":"\u17A2\u1784\u17D2\u1783\u17B6\u1780\u17CB"},{"id":15379,"word":"\u17A2\u1784\u17D2\u1783\u17BE\u179B"},{"id":15380,"word":"\u17A2\u1784\u17D2\u179A\u1784\u17CB"},{"id":15381,"word":"\u17A2\u1784\u17D2\u179A\u1793\u17CB"},{"id":15382,"word":"\u17A2\u1784\u17D2\u179A\u17B9\u1784"},{"id":15383,"word":"\u17A2\u1784\u17D2\u179A\u17BB\u178F"},{"id":15384,"word":"\u17A2\u1784\u17D2\u179A\u17BC\u179F"},{"id":15385,"word":"\u17A2\u1784\u17D2\u179A\u17BD\u1793"},{"id":15386,"word":"\u17A2\u1784\u17D2\u179A\u17C0\u178F\u1793\u17B9\u1784"},{"id":15387,"word":"\u17A2\u1784\u17D2\u179A\u17C2"},{"id":15388,"word":"\u17A2\u1784\u17D2\u179A\u17C2\u178A\u17C2\u1780"},{"id":15389,"word":"\u17A2\u1784\u17D2\u179C\u179A"},{"id":15390,"word":"\u17A2\u1784\u17D2\u179C\u179A\u1780\u179A"},{"id":15391,"word":"\u17A2\u1784\u17D2\u179C\u17C2\u1784"},{"id":15392,"word":"\u17A2\u1784\u17D2\u179F"},{"id":15393,"word":"\u17A2\u1784\u17D2\u179F --"},{"id":15394,"word":"\u17A2\u1784\u17D2\u179F\u17D0\u1780"},{"id":15395,"word":"\u17A2\u1784\u17D2\u179F\u17B6"},{"id":15396,"word":"\u17A2\u1784\u17D2\u179F\u17B6"},{"id":15397,"word":"\u17A2\u1784\u17D2\u179F\u17B7\u1780"},{"id":15398,"word":"\u17A2\u1784\u17D2\u179F\u17BB"},{"id":15399,"word":"\u17A2\u1784\u17D2\u17A2\u17C2\u179B"},{"id":15400,"word":"\u17A2\u1785\u179A\u178E\u1797\u17B6\u1796"},{"id":15401,"word":"\u17A2\u1785\u179B"},{"id":15402,"word":"\u17A2\u1785\u179B --"},{"id":15403,"word":"\u17A2\u1785\u179B\u1793 --"},{"id":15404,"word":"\u17A2\u1785\u179B\u1793\u17C8"},{"id":15405,"word":"\u17A2\u1785\u179B\u17B6"},{"id":15406,"word":"\u17A2\u1785\u17B7\u178F\u17D2\u178F"},{"id":15407,"word":"\u17A2\u1785\u17B7\u178F\u17D2\u178F\u1780 --"},{"id":15408,"word":"\u17A2\u1785\u17B7\u178F\u17D2\u178F\u1780\u17C8"},{"id":15409,"word":"\u17A2\u1785\u17B7\u178F\u17D2\u178F\u17B7\u1797\u17B6\u1796"},{"id":15410,"word":"\u17A2\u1785\u17B7\u1793\u17D2\u178F\u17B6"},{"id":15411,"word":"\u17A2\u1785\u17B7\u1793\u17D2\u178F\u17D2\u179A\u17C3\u1799\u17CD"},{"id":15412,"word":"\u17A2\u1785\u17B7\u179A"},{"id":15413,"word":"\u17A2\u1785\u17B7\u179A --"},{"id":15414,"word":"\u17A2\u1785\u17C1\u179B\u1780\u17C8"},{"id":15415,"word":"\u17A2\u1785\u17C1\u179F\u17D2\u178A\u17B6"},{"id":15416,"word":"\u17A2\u1785\u17C3\u178A\u1793\u17D2\u1799"},{"id":15417,"word":"\u17A2\u1785\u17D2\u1785\u17BB\u178F"},{"id":15418,"word":"\u17A2\u1785\u17D2\u1785\u17C1\u1780"},{"id":15419,"word":"\u17A2\u1785\u17D2\u1786\u179A\u17B6"},{"id":15420,"word":"\u17A2\u1785\u17D2\u1786\u179A\u17B7\u1799"},{"id":15421,"word":"\u17A2\u1785\u17D2\u1786\u179A\u17B7\u1799 --"},{"id":15422,"word":"\u17A2\u1785\u17D2\u1786\u17B6\u1791\u1793\u17C8"},{"id":15423,"word":"\u17A2\u1785\u17D2\u1786\u17B6\u179C\u17D0\u1791"},{"id":15424,"word":"\u17A2\u1785\u17D2\u1786\u17B7\u1791\u17D2\u1791\u179C\u17BB\u178F\u17D2\u178F\u17B7\u1793\u17B8"},{"id":15425,"word":"\u17A2\u1785\u17D2\u1786\u17B7\u1791\u17D2\u1791\u179C\u17BB\u178F\u17D2\u178F\u17B8"},{"id":15426,"word":"\u17A2\u1785\u17D2\u1786\u17B7\u1791\u17D2\u179A\u1796\u17D2\u179A\u17B9\u178F\u17D2\u178F\u17B7"},{"id":15427,"word":"\u17A2\u1787\u178A\u17B6\u1780\u17B6\u179F"},{"id":15428,"word":"\u17A2\u1787\u1793\u1794\u17D2\u179A\u1791\u17C1\u179F"},{"id":15429,"word":"\u17A2\u1787\u17D2\u1788\u178F\u17D2\u178F\u179F\u1793\u17D2\u178F\u17B6\u1793"},{"id":15430,"word":"\u17A2\u1787\u17D2\u1788\u178F\u17D2\u178F\u17B7\u1780\u1791\u17B6\u1793"},{"id":15431,"word":"\u17A2\u1787\u17D2\u1788\u17B6\u1785\u17B6\u179A"},{"id":15432,"word":"\u17A2\u1787\u17D2\u1788\u17B6\u179F\u17D0\u1799"},{"id":15433,"word":"\u17A2\u1787\u17D2\u1788\u17BB\u1794\u17D2\u1794\u17B6\u178F\u1780\u17C8"},{"id":15434,"word":"\u17A2\u1787\u17D2\u1788\u17C1\u179F\u1793\u17B6"},{"id":15435,"word":"\u17A2\u1787\u17D2\u1788\u17C4\u1780\u17B6\u179F"},{"id":15436,"word":"\u17A2\u1787\u17D2\u1788\u17C4\u179F\u17B6\u1793"},{"id":15437,"word":"\u17A2\u1789"},{"id":15438,"word":"\u17A2\u1789\u17D2\u1785\u1784"},{"id":15439,"word":"\u17A2\u1789\u17D2\u1785\u17B6\u1785"},{"id":15440,"word":"\u17A2\u1789\u17D2\u1785\u17B6\u1789"},{"id":15441,"word":"\u17A2\u1789\u17D2\u1785\u17B6\u1794"},{"id":15442,"word":"\u17A2\u1789\u17D2\u1785\u17BC\u1785\u17D7"},{"id":15443,"word":"\u17A2\u1789\u17D2\u1786\u17BE\u179B"},{"id":15444,"word":"\u17A2\u1789\u17D2\u1787\u1785\u17D7"},{"id":15445,"word":"\u17A2\u1789\u17D2\u1787\u17D0\u1793"},{"id":15446,"word":"\u17A2\u1789\u17D2\u1787\u179B\u17B7"},{"id":15447,"word":"\u17A2\u1789\u17D2\u1787\u17BB\u179B"},{"id":15448,"word":"\u17A2\u1789\u17D2\u1787\u17BB\u179B\u17B8"},{"id":15449,"word":"\u17A2\u1789\u17D2\u1787\u17BE\u1789 "},{"id":15450,"word":"\u17A2\u1789\u17B6\u178F\u1780\u1787\u1793"},{"id":15451,"word":"\u17A2\u1789\u17D2\u1789\u178F\u17D2\u179A"},{"id":15452,"word":"\u17A2\u1789\u17D2\u1789\u178F\u17D2\u179A\u179F\u1796\u17D2\u1791"},{"id":15453,"word":"\u17A2\u1789\u17D2\u1789\u1790\u17B6\u1797\u17B6\u1796"},{"id":15454,"word":"\u17A2\u1789\u17D2\u1789\u1794\u1791"},{"id":15455,"word":"\u17A2\u1789\u17D2\u1789\u179C\u17B6\u1791\u1780\u1798\u17D2\u1798"},{"id":15456,"word":"\u17A2\u1789\u17D2\u1789\u17B6\u178F"},{"id":15457,"word":"\u17A2\u1789\u17D2\u1789\u17B6\u178F --"},{"id":15458,"word":"\u17A2\u1789\u17D2\u1789\u17B6\u178F\u1780\u1787\u1793"},{"id":15459,"word":"\u17A2\u1789\u17D2\u1789\u17B6\u178F\u1780\u179C\u17C1\u179F"},{"id":15460,"word":"\u17A2\u1789\u17D2\u1789\u17B6\u178F\u1780\u179C\u17C1\u179F\u1780"},{"id":15461,"word":"\u17A2\u1789\u17D2\u1789\u17BC\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u17B7\u178F"},{"id":15462,"word":"\u17A2\u1789\u17D2\u1789\u17C4\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u17B7\u178F"},{"id":15463,"word":"\u17A2\u178A\u178A"},{"id":15464,"word":"\u17A2\u178A\u179C\u17B7\u1780"},{"id":15465,"word":"\u17A2\u178A\u179C\u17B8"},{"id":15466,"word":"\u17A2\u178A\u17D2\u178F\u1794\u17D2\u179A\u178F\u17B7\u1797\u17BC"},{"id":15467,"word":"\u17A2\u178A\u17D2\u178B"},{"id":15468,"word":"\u17A2\u178A\u17D2\u178B --"},{"id":15469,"word":"\u17A2\u178A\u17D2\u178B\u1780\u1790\u17B6"},{"id":15470,"word":"\u17A2\u178A\u17D2\u178B\u1794\u179A\u17B7\u1780\u17D2\u1781\u17B6\u179A"},{"id":15471,"word":"\u17A2\u178A\u17D2\u178B\u1794\u17B6\u1793"},{"id":15472,"word":"\u17A2\u178A\u17D2\u178B\u17B7"},{"id":15473,"word":"\u17A2\u178A\u17D2\u178B\u17B7 --"},{"id":15474,"word":"\u17A2\u178C\u17D2\u178D"},{"id":15475,"word":"\u17A2\u178C\u17D2\u178D --"},{"id":15476,"word":"\u17A2\u178C\u17D2\u178D\u1785\u1793\u17D2\u1791"},{"id":15477,"word":"\u17A2\u178C\u17D2\u178D\u1799\u17C4\u1782"},{"id":15478,"word":"\u17A2\u178E\u17BC"},{"id":15479,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u1780\u17CB\u17A2\u178E\u17D2\u178A\u179B\u17CB"},{"id":15480,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u178F"},{"id":15481,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u178F\u1782\u17C4"},{"id":15482,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u178F\u1786\u17D2\u1780\u17C2"},{"id":15483,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u178F\u1786\u17D2\u179B\u17B6\u1798"},{"id":15484,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u178F\u178F\u17D2\u179A\u1780\u17BD\u178F"},{"id":15485,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u178F\u179F\u1798\u17BB\u1791\u17D2\u179A"},{"id":15486,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u1794\u17CB"},{"id":15487,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u1794\u17CB\u17A2\u178E\u17D2\u178A\u17B6"},{"id":15488,"word":"\u17A2\u178E\u17D2\u178A\u17B6\u1794\u17CB\u17A2\u178E\u17D2\u178A\u17C4\u1799"},{"id":15489,"word":"\u17A2\u178E\u17D2\u178A\u17BA\u178F\u17A2\u178E\u17D2\u178A\u1780"},{"id":15490,"word":"\u17A2\u178E\u17D2\u178A\u17BC\u1784"},{"id":15491,"word":"\u17A2\u178E\u17D2\u178A\u17BE\u1780"},{"id":15492,"word":"\u17A2\u178E\u17D2\u178A\u17BE\u1780\u1798\u17B6\u179F"},{"id":15493,"word":"\u17A2\u178E\u17D2\u178A\u17BE\u179A"},{"id":15494,"word":"\u17A2\u178E\u17D2\u178A\u17C2\u1784"},{"id":15495,"word":"\u17A2\u178E\u17D2\u178A\u17C2\u178F"},{"id":15496,"word":"\u17A2\u178E\u17D2\u178A\u17C2\u178F  --"},{"id":15497,"word":"\u17A2\u178E\u17D2\u178A\u17C4\u178F"},{"id":15498,"word":"\u17A2\u178E\u17D2\u178C --"},{"id":15499,"word":"\u17A2\u178E\u17D2\u178C\u17C8"},{"id":15500,"word":"\u17A2\u178E\u17D2\u178C\u17B6 --"},{"id":15501,"word":"\u17A2\u178E\u17D2\u178E\u1796"},{"id":15502,"word":"\u17A2\u178E\u17D2\u178E\u17B6\u1798"},{"id":15503,"word":"\u17A2\u178F"},{"id":15504,"word":"\u17A2\u178F\u17CB"},{"id":15505,"word":"\u17A2\u178F\u1794\u17D2\u1794\u17B6"},{"id":15506,"word":"\u17A2\u178F\u17B7"},{"id":15507,"word":"\u17A2\u178F\u17B7 --"},{"id":15508,"word":"\u17A2\u178F\u17B7\u1790\u17B7"},{"id":15509,"word":"\u17A2\u178F\u17B7\u1790\u17B7 --"},{"id":15510,"word":"\u17A2\u178F\u17B7\u179A\u17C1\u1780"},{"id":15511,"word":"\u17A2\u178F\u17B7\u179A\u17C1\u1780 --"},{"id":15512,"word":"\u17A2\u178F\u17B7\u179F\u17B6\u179A"},{"id":15513,"word":"\u17A2\u178F\u17B8\u178F"},{"id":15514,"word":"\u17A2\u178F\u17B8\u178F --"},{"id":15515,"word":"\u17A2\u178F\u17C1\u1780\u17B7\u1785\u17D2\u1786"},{"id":15516,"word":"\u17A2\u178F\u17C1\u1780\u17B7\u1785\u17D2\u1786 --"},{"id":15517,"word":"\u17A2\u178F\u17D2\u178F"},{"id":15518,"word":"\u17A2\u178F\u17D2\u178F --"},{"id":15519,"word":"\u17A2\u178F\u17D2\u178F\u17C8"},{"id":15520,"word":"\u17A2\u178F\u17D2\u178F\u1781\u17B6\u178F\u17CB"},{"id":15521,"word":"\u17A2\u178F\u17D2\u178F\u1793\u17C4\u1794\u1791"},{"id":15522,"word":"\u17A2\u178F\u17D2\u178F\u1793\u17C4\u1798\u17D0\u178F\u17B7"},{"id":15523,"word":"\u17A2\u178F\u17D2\u178F\u1793\u17C4\u1798\u178F\u17D2\u1799\u17B6 \u1792\u17B7\u1794\u17D2\u1794\u17B6\u1799"},{"id":15524,"word":"\u17A2\u178F\u17D2\u178F\u17B6"},{"id":15525,"word":"\u17A2\u178F\u17D2\u178F\u17B6 --"},{"id":15526,"word":"\u17A2\u178F\u17D2\u178F\u17B7\u1781\u17B6\u178F\u17CB --"},{"id":15527,"word":"\u17A2\u178F\u17D2\u178F\u17BB --"},{"id":15528,"word":"\u17A2\u178F\u17D2\u1790"},{"id":15529,"word":"\u17A2\u178F\u17D2\u1790 --"},{"id":15530,"word":"\u17A2\u178F\u17D2\u1790\u1784\u17D2\u1782\u178F"},{"id":15531,"word":"\u17A2\u178F\u17D2\u1790\u17B6 --"},{"id":15532,"word":"\u17A2\u178F\u17D2\u1790\u17B7\u1797\u17B6\u1796"},{"id":15533,"word":"\u17A2\u178F\u17D2\u179A\u1787\u17C8"},{"id":15534,"word":"\u17A2\u178F\u17D2\u179A\u1787\u17B6"},{"id":15535,"word":"\u17A2\u178F\u17D2\u179A\u17B6\u1793\u17BB\u1780\u17BC\u179B\u178A\u17D2\u178B\u17B6\u1793"},{"id":15536,"word":"\u17A2\u1790\u17D0\u1793"},{"id":15537,"word":"\u17A2\u1790\u1796\u17D2\u179C"},{"id":15538,"word":"\u17A2\u1790\u17B7\u179A\u1797\u17B6\u1796"},{"id":15539,"word":"\u17A2\u1791\u17B6\u1799\u17B6\u1791"},{"id":15540,"word":"\u17A2\u1791\u17B6\u179A\u1787\u1793"},{"id":15541,"word":"\u17A2\u1791\u17B6\u179A\u17BB\u178E"},{"id":15542,"word":"\u17A2\u1791\u17B6\u179F\u178F\u17B6"},{"id":15543,"word":"\u17A2\u1791\u17B6\u179F\u1796\u17D2\u1799"},{"id":15544,"word":"\u17A2\u1791\u17B7\u178A\u17D2\u178B"},{"id":15545,"word":"\u17A2\u1791\u17B7\u178A\u17D2\u178B\u1798\u17B7\u178F\u17D2\u178F"},{"id":15546,"word":"\u17A2\u1791\u17B7\u1793\u17D2\u1793"},{"id":15547,"word":"\u17A2\u1791\u17B7\u1793\u17D2\u1793 --"},{"id":15548,"word":"\u17A2\u1791\u17B7\u179F\u17D2\u179F\u1798\u17B6\u1793"},{"id":15549,"word":"\u17A2\u1791\u17BB\u179A\u17B6\u1782\u178F"},{"id":15550,"word":"\u17A2\u1791\u17BB\u179A\u17B6\u1782\u178F\u17B6"},{"id":15551,"word":"\u17A2\u1791\u17D2\u1792\u1782\u17BC"},{"id":15552,"word":"\u17A2\u1791\u17D2\u1792\u17B6"},{"id":15553,"word":"\u17A2\u1791\u17D2\u1792\u17B6\u1793"},{"id":15554,"word":"\u17A2\u1791\u17D2\u1792\u17B6\u1793 --"},{"id":15555,"word":"\u17A2\u1792\u1798"},{"id":15556,"word":"\u17A2\u1792\u1798\u17D2\u1798"},{"id":15557,"word":"\u17A2\u1792\u1798\u17D2\u1798 --"},{"id":15558,"word":"\u17A2\u1792\u1798\u17CC"},{"id":15559,"word":"\u17A2\u1792\u179A\u1798\u17B6\u1793"},{"id":15560,"word":"\u17A2\u1792\u17B7\u1780"},{"id":15561,"word":"\u17A2\u1792\u17B7\u1780 --"},{"id":15562,"word":"\u17A2\u1792\u17B7\u1780\u179A\u178E --"},{"id":15563,"word":"\u17A2\u1792\u17B7\u1780\u179A\u178E\u17C8"},{"id":15564,"word":"\u17A2\u1792\u17B7\u1780\u17A2\u1792\u1798"},{"id":15565,"word":"\u17A2\u1792\u17B7\u1780\u17B6\u179A"},{"id":15566,"word":"\u17A2\u1792\u17B7\u1780\u17B6\u179A\u17B7\u178E\u17B8"},{"id":15567,"word":"\u17A2\u1792\u17B7\u1780\u17B6\u179A\u17B8 "},{"id":15568,"word":"\u17A2\u1792\u17B7\u1780\u17D2\u179A\u1798"},{"id":15569,"word":"\u17A2\u1792\u17B7\u1780\u17D2\u179A\u17B9\u178F\u17B7"},{"id":15570,"word":"\u17A2\u1792\u17B7\u1782\u178F"},{"id":15571,"word":"\u17A2\u1792\u17B7\u1782\u178F --"},{"id":15572,"word":"\u17A2\u1792\u17B7\u1782\u1798"},{"id":15573,"word":"\u17A2\u1792\u17B7\u1782\u17BB\u178E"},{"id":15574,"word":"\u17A2\u1792\u17B7\u1782\u17BB\u178E\u17B6"},{"id":15575,"word":"\u17A2\u1792\u17B7\u1785\u17B7\u178F\u17D2\u178F"},{"id":15576,"word":"\u17A2\u1792\u17B7\u1787\u17D0\u1799"},{"id":15577,"word":"\u17A2\u1792\u17B7\u1787\u17C1\u178A\u17D2\u178B"},{"id":15578,"word":"\u17A2\u1792\u17B7\u1787\u17C1\u178A\u17D2\u178B\u17B6"},{"id":15579,"word":"\u17A2\u1792\u17B7\u1787\u17D2\u1799\u17C4\u178F\u17B7\u179F"},{"id":15580,"word":"\u17A2\u1792\u17B7\u178A\u17D2\u178B\u17B6\u1793"},{"id":15581,"word":"\u17A2\u1792\u17B7\u1794"},{"id":15582,"word":"\u17A2\u1792\u17B7\u1794\u178F\u17B8"},{"id":15583,"word":"\u17A2\u1792\u17B7\u1794\u178F\u17C1\u1799\u17D2\u1799"},{"id":15584,"word":"\u17A2\u1792\u17B7\u1794\u17D2\u1794\u1789\u17D2\u1789\u17B6"},{"id":15585,"word":"\u17A2\u1792\u17B7\u1794\u17D2\u1794\u17B6\u1799"},{"id":15586,"word":"\u17A2\u1792\u17B7\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":15587,"word":"\u17A2\u1792\u17B7\u1797\u17BC"},{"id":15588,"word":"\u17A2\u1792\u17B7\u1798\u178F\u17D2\u178F"},{"id":15589,"word":"\u17A2\u1792\u17B7\u1798\u17B6\u1793\u17B7\u1780"},{"id":15590,"word":"\u17A2\u1792\u17B7\u1798\u17B6\u1793\u17B7\u1780\u17B6"},{"id":15591,"word":"\u17A2\u1792\u17B7\u1798\u17BB\u178F\u17D2\u178F\u17B7"},{"id":15592,"word":"\u17A2\u1792\u17B7\u1798\u17C4\u1780\u17D2\u1781"},{"id":15593,"word":"\u17A2\u1792\u17B7\u1799\u17C4\u1782"},{"id":15594,"word":"\u17A2\u1792\u17B7\u179A\u17B6\u1787"},{"id":15595,"word":"\u17A2\u1792\u17B7\u179A\u17B6\u1787\u17B7\u1793\u17B8"},{"id":15596,"word":"\u17A2\u1792\u17B7\u179A\u17C4\u17A0\u17B7\u178E\u17B8"},{"id":15597,"word":"\u17A2\u1792\u17B7\u179B\u17C4\u1780"},{"id":15598,"word":"\u17A2\u1792\u17B7\u179C\u1785\u1793\u17C8"},{"id":15599,"word":"\u17A2\u1792\u17B7\u179C\u17B6\u179F"},{"id":15600,"word":"\u17A2\u1792\u17B7\u179C\u17B6\u179F\u1793"},{"id":15601,"word":"\u17A2\u1792\u17B7\u179C\u17B6\u179F\u1793\u17B6"},{"id":15602,"word":"\u17A2\u1792\u17B7\u179F\u17B8\u179B"},{"id":15603,"word":"\u17A2\u1792\u17B7\u179F\u17D2\u178B\u17B6\u1793"},{"id":15604,"word":"\u17A2\u1792\u17B8\u1793"},{"id":15605,"word":"\u17A2\u1792\u17BB\u1793\u17B6\u1782\u178F"},{"id":15606,"word":"\u17A2\u1792\u17BB\u1793\u17B6\u1782\u178F\u17B6"},{"id":15607,"word":"\u17A2\u1792\u17BB\u1793\u17B7\u1780"},{"id":15608,"word":"\u17A2\u1792\u17BB\u1793\u17B7\u1780\u17B6"},{"id":15609,"word":"\u17A2\u1792\u17C4"},{"id":15610,"word":"\u17A2\u1792\u17C4 --"},{"id":15611,"word":"\u17A2\u1792\u17D2\u1799\u17B6\u179F\u17D2\u179A\u17D0\u1799"},{"id":15612,"word":"\u17A2\u1792\u17D2\u1799\u17C4\u1782"},{"id":15613,"word":"\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A"},{"id":15614,"word":"\u17A2\u1792\u17D2\u179C\u17D0\u1793"},{"id":15615,"word":"\u17A2\u1793"},{"id":15616,"word":"\u17A2\u1793\u17CB"},{"id":15617,"word":"\u17A2\u1793\u1782\u17D2\u1783"},{"id":15618,"word":"\u17A2\u1793\u1782\u17D2\u1783\u17B6"},{"id":15619,"word":"\u17A2\u1793\u1784\u17D2\u1782"},{"id":15620,"word":"\u17A2\u1793\u1784\u17D2\u1782 --"},{"id":15621,"word":"\u17A2\u1793\u1784\u17D2\u1782\u178E"},{"id":15622,"word":"\u17A2\u1793\u1789\u17D2\u1789"},{"id":15623,"word":"\u17A2\u1793\u1789\u17D2\u1789 --"},{"id":15624,"word":"\u17A2\u1793\u178F\u17D2\u178F\u179B\u1780\u17D2\u1781\u178E"},{"id":15625,"word":"\u17A2\u1793\u178F\u17D2\u178F\u179F\u1789\u17D2\u1789\u17B6"},{"id":15626,"word":"\u17A2\u1793\u178F\u17D2\u178F\u17B6"},{"id":15627,"word":"\u17A2\u1793\u178F\u17D2\u178F\u17B6 --"},{"id":15628,"word":"\u17A2\u1793\u178F\u17D2\u1790"},{"id":15629,"word":"\u17A2\u1793\u178F\u17D2\u1790 --"},{"id":15630,"word":"\u17A2\u1793\u1793\u17D2\u178F"},{"id":15631,"word":"\u17A2\u1793\u1793\u17D2\u178F --"},{"id":15632,"word":"\u17A2\u1793\u1793\u17D2\u178F\u179A"},{"id":15633,"word":"\u17A2\u1793\u1793\u17D2\u178F\u179A --"},{"id":15634,"word":"\u17A2\u1793\u1793\u17D2\u178F\u179A\u17B7\u1799\u1780\u1798\u17D2\u1798"},{"id":15635,"word":"\u17A2\u1793\u1793\u17D2\u178F\u17B6 --"},{"id":15636,"word":"\u17A2\u1793\u1797\u17B7\u179F\u17B7\u178F\u17D2\u178F\u179A\u17B6\u1787"},{"id":15637,"word":"\u17A2\u1793\u179A\u17B7\u1799"},{"id":15638,"word":"\u17A2\u1793\u179A\u17B7\u1799 --"},{"id":15639,"word":"\u17A2\u1793\u179C\u178F\u1794\u17D2\u178F\u17C8"},{"id":15640,"word":"\u17A2\u1793\u179C\u1791\u17D2\u1799"},{"id":15641,"word":"\u17A2\u1793\u179C\u17C9\u1793"},{"id":15642,"word":"\u17A2\u1793\u179F\u17D2\u1785\u17B6\u179A\u17D2\u1799"},{"id":15643,"word":"\u17A2\u1793\u17B6\u1780\u17BB\u179B"},{"id":15644,"word":"\u17A2\u1793\u17B6\u1782\u178F"},{"id":15645,"word":"\u17A2\u1793\u17B6\u1782\u178F --"},{"id":15646,"word":"\u17A2\u1793\u17B6\u1782\u1798"},{"id":15647,"word":"\u17A2\u1793\u17B6\u1782\u17B6\u1798\u17B6"},{"id":15648,"word":"\u17A2\u1793\u17B6\u1782\u17B6\u1798\u17B7 --"},{"id":15649,"word":"\u17A2\u1793\u17B6\u1782\u17B6\u1798\u17B8"},{"id":15650,"word":"\u17A2\u1793\u17B6\u1782\u17B6\u179A"},{"id":15651,"word":"\u17A2\u1793\u17B6\u1782\u17B6\u179A\u17B7\u1799"},{"id":15652,"word":"\u17A2\u1793\u17B6\u1785\u17B6\u179A"},{"id":15653,"word":"\u17A2\u1793\u17B6\u178F\u17BB\u179A\u1797\u17B6\u1796"},{"id":15654,"word":"\u17A2\u1793\u17B6\u178F\u17D2\u1798\u17D0\u1793"},{"id":15655,"word":"\u17A2\u1793\u17B6\u1790"},{"id":15656,"word":"\u17A2\u1793\u17B6\u1790 --"},{"id":15657,"word":"\u17A2\u1793\u17B6\u1790\u1794\u17B7\u178E\u17D2\u178C\u17B7\u1780"},{"id":15658,"word":"\u17A2\u1793\u17B6\u1790\u17B6"},{"id":15659,"word":"\u17A2\u1793\u17B6\u1791\u179A"},{"id":15660,"word":"\u17A2\u1793\u17B6\u1791\u179A --"},{"id":15661,"word":"\u17A2\u1793\u17B6\u1791\u17B7\u1797\u17B6\u1796"},{"id":15662,"word":"\u17A2\u1793\u17B6\u1792\u17B7\u1794\u178F\u17C1\u1799\u17D2\u1799"},{"id":15663,"word":"\u17A2\u1793\u17B6\u1794\u178F\u17D2\u178F\u17B7"},{"id":15664,"word":"\u17A2\u1793\u17B6\u1798\u1799"},{"id":15665,"word":"\u17A2\u1793\u17B6\u1798\u1799 --"},{"id":15666,"word":"\u17A2\u1793\u17B6\u1798\u179A\u17BC\u1794"},{"id":15667,"word":"\u17A2\u1793\u17B6\u1798\u17B7\u1780"},{"id":15668,"word":"\u17A2\u1793\u17B6\u1799\u17CC"},{"id":15669,"word":"\u17A2\u1793\u17B6\u179B\u17D0\u1799"},{"id":15670,"word":"\u17A2\u1793\u17B6\u179C\u17B6\u179F"},{"id":15671,"word":"\u17A2\u1793\u17B6\u179C\u17B6\u179F\u17B6"},{"id":15672,"word":"\u17A2\u1793\u17B6\u179F\u179C --"},{"id":15673,"word":"\u17A2\u1793\u17B6\u179F\u179C\u17C8"},{"id":15674,"word":"\u17A2\u1793\u17B6\u179F\u179C\u17B6"},{"id":15675,"word":"\u17A2\u1793\u17B6\u179F\u17D2\u179A\u1796"},{"id":15676,"word":"\u17A2\u1793\u17B7\u1785\u17D2\u1785"},{"id":15677,"word":"\u17A2\u1793\u17B7\u1785\u17D2\u1785 --"},{"id":15678,"word":"\u17A2\u1793\u17B7\u1785\u17D2\u1785\u17C6"},{"id":15679,"word":"\u17A2\u1793\u17B7\u1785\u17D2\u1785\u17B6"},{"id":15680,"word":"\u17A2\u1793\u17B7\u1785\u17D2\u1785\u17B6 --"},{"id":15681,"word":"\u17A2\u1793\u17B7\u178A\u17D2\u178B\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD"},{"id":15682,"word":"\u17A2\u1793\u17B7\u1791\u17D2\u179A\u17B6"},{"id":15683,"word":"\u17A2\u1793\u17B7\u1798\u1793\u17D2\u178F\u1793\u17CD"},{"id":15684,"word":"\u17A2\u1793\u17B7\u1798\u17B7\u178F\u17D2\u178F"},{"id":15685,"word":"\u17A2\u1793\u17B7\u1799\u178F"},{"id":15686,"word":"\u17A2\u1793\u17B7\u1799\u1798"},{"id":15687,"word":"\u17A2\u1793\u17B7\u1799\u1798 --"},{"id":15688,"word":"\u17A2\u1793\u17B7\u179B"},{"id":15689,"word":"\u17A2\u1793\u17B7\u179F\u17D2\u179F\u1799\u1798\u17BB\u178F\u17D2\u178F\u1780"},{"id":15690,"word":"\u17A2\u1793\u17B7\u179F\u17D2\u179F\u1799\u1798\u17BB\u178F\u17D2\u178F\u17B7\u1780\u17B6"},{"id":15691,"word":"\u17A2\u1793\u17B7\u179F\u17D2\u179F\u179A"},{"id":15692,"word":"\u17A2\u1793\u17B7\u179F\u17D2\u179F\u179A --"},{"id":15693,"word":"\u17A2\u1793\u17B8\u1780\u1791\u179F\u17D2\u179F\u1793\u17CD"},{"id":15694,"word":"\u17A2\u1793\u17B8\u1780\u179B\u1780\u17D2\u1781\u178E\u17C8"},{"id":15695,"word":"\u17A2\u1793\u17BB"},{"id":15696,"word":"\u17A2\u1793\u17BB --"},{"id":15697,"word":"\u17A2\u1793\u17BB\u1780\u17BC\u179B"},{"id":15698,"word":"\u17A2\u1793\u17BB\u1782\u17D2\u179A\u17C4\u17C7"},{"id":15699,"word":"\u17A2\u1793\u17BB\u1787"},{"id":15700,"word":"\u17A2\u1793\u17BB\u1789\u17D2\u1789\u17B6\u178F"},{"id":15701,"word":"\u17A2\u1793\u17BB\u178F\u17D2\u178F\u179A"},{"id":15702,"word":"\u17A2\u1793\u17BB\u178F\u17D2\u1790\u17C1\u179A"},{"id":15703,"word":"\u17A2\u1793\u17BB\u1791\u17B7\u179F"},{"id":15704,"word":"\u17A2\u1793\u17BB\u1791\u17BC\u178F"},{"id":15705,"word":"\u17A2\u1793\u17BB\u1792\u1798\u17D2\u1798\u1785\u17B6\u179A\u17B7\u1793\u17B8"},{"id":15706,"word":"\u17A2\u1793\u17BB\u1793\u17B6\u1799\u1780"},{"id":15707,"word":"\u17A2\u1793\u17BB\u1794\u1780\u17B6\u179A"},{"id":15708,"word":"\u17A2\u1793\u17BB\u1794\u1785\u17B6\u179A"},{"id":15709,"word":"\u17A2\u1793\u17BB\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797"},{"id":15710,"word":"\u17A2\u1793\u17BB\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u1780"},{"id":15711,"word":"\u17A2\u1793\u17BB\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u17B7\u1780\u17B6"},{"id":15712,"word":"\u17A2\u1793\u17BB\u1794\u1791\u17C1\u179F"},{"id":15713,"word":"\u17A2\u1793\u17BB\u1794\u1791\u17D2\u179A\u1796"},{"id":15714,"word":"\u17A2\u1793\u17BB\u1794\u1792\u17B7"},{"id":15715,"word":"\u17A2\u1793\u17BB\u1794\u1797\u17C4\u1782"},{"id":15716,"word":"\u17A2\u1793\u17BB\u1794\u1798\u17B6"},{"id":15717,"word":"\u17A2\u1793\u17BB\u1794\u1798\u17C1\u1799\u17D2\u1799"},{"id":15718,"word":"\u17A2\u1793\u17BB\u1794\u179C\u17B6\u1791"},{"id":15719,"word":"\u17A2\u1793\u17BB\u1794\u179C\u17B6\u1791\u17B7\u1793"},{"id":15720,"word":"\u17A2\u1793\u17BB\u1794\u179C\u17B6\u1791\u17B8"},{"id":15721,"word":"\u17A2\u1793\u17BB\u1794\u179F\u1782\u17D2\u1782"},{"id":15722,"word":"\u17A2\u1793\u17BB\u1794\u179F\u1798\u17D2\u1794\u1793\u17D2\u1793"},{"id":15723,"word":"\u17A2\u1793\u17BB\u1794\u179F\u1798\u17D2\u1794\u1793\u17D2\u1793\u17B6"},{"id":15724,"word":"\u17A2\u1793\u17BB\u1794\u17B6\u1791\u17B7\u1793\u17D2\u1793\u1780"},{"id":15725,"word":"\u17A2\u1793\u17BB\u1794\u17B6\u1791\u17B7\u179F\u17C1\u179F\u1793\u17B7\u1796\u17D2\u179C\u17B6\u1793"},{"id":15726,"word":"\u17A2\u1793\u17BB\u1794\u17D2\u179A\u1780\u17B6\u179A"},{"id":15727,"word":"\u17A2\u1793\u17BB\u1794\u17D2\u179A\u1799\u17C4\u1782"},{"id":15728,"word":"\u17A2\u1793\u17BB\u1796\u17B6\u179B"},{"id":15729,"word":"\u17A2\u1793\u17BB\u1797\u17B6\u1796"},{"id":15730,"word":"\u17A2\u1793\u17BB\u1798\u1793\u17D2\u178F\u17D2\u179A\u17B8"},{"id":15731,"word":"\u17A2\u1793\u17BB\u1798\u17B6\u178F\u17D2\u179A\u17B6"},{"id":15732,"word":"\u17A2\u1793\u17BB\u1798\u17C4\u1791\u1793\u17B6"},{"id":15733,"word":"\u17A2\u1793\u17BB\u1799\u17C4\u1782"},{"id":15734,"word":"\u17A2\u1793\u17BB\u179B\u17C4\u1798"},{"id":15735,"word":"\u17A2\u1793\u17BB\u179C\u17B6\u178F"},{"id":15736,"word":"\u17A2\u1793\u17BB\u179F\u17B6\u179A"},{"id":15737,"word":"\u17A2\u1793\u17BB\u179F\u17D2\u179C\u17B6\u179A"},{"id":15738,"word":"\u17A2\u1793\u17BB\u179F\u17D2\u179F\u17B6\u179C\u1793\u1780"},{"id":15739,"word":"\u17A2\u1793\u17BB\u179F\u17D2\u179F\u17B6\u179C\u1793\u17B6"},{"id":15740,"word":"\u17A2\u1793\u17BB\u179F\u17D2\u179F\u17B6\u179C\u179A\u17B8\u1799"},{"id":15741,"word":"\u17A2\u1793\u17C1\u1780"},{"id":15742,"word":"\u17A2\u1793\u17C1\u1780 --"},{"id":15743,"word":"\u17A2\u1793\u17C1\u1780\u178F\u17D2\u1790\u179F\u17C6\u1781\u17D2\u1799\u17B6"},{"id":15744,"word":"\u17A2\u1793\u17C1\u179F\u1793\u17C8"},{"id":15745,"word":"\u17A2\u1793\u17C4\u1780\u17B6\u179F"},{"id":15746,"word":"\u17A2\u1793\u17C4\u178F\u178F\u17D2\u178F"},{"id":15747,"word":"\u17A2\u1793\u17C4\u178F\u178F\u17D2\u178F\u179F\u17D2\u179A\u17C7"},{"id":15748,"word":"\u17A2\u1793\u17C4\u1798"},{"id":15749,"word":"\u17A2\u1793\u17C4\u1798 --"},{"id":15750,"word":"\u17A2\u1793\u17C4\u1798\u1791\u179F\u17D2\u179F\u17B8"},{"id":15751,"word":"\u17A2\u1793\u17C4\u179F\u1787\u17D2\u1787\u1797\u17B6\u1796"},{"id":15752,"word":"\u17A2\u1793\u17D2\u178F"},{"id":15753,"word":"\u17A2\u1793\u17D2\u178F --"},{"id":15754,"word":"\u17A2\u1793\u17D2\u178F\u17C8"},{"id":15755,"word":"\u17A2\u1793\u17D2\u178F\u1782\u17BB\u178E"},{"id":15756,"word":"\u17A2\u1793\u17D2\u178F\u1799"},{"id":15757,"word":"\u17A2\u1793\u17D2\u178F\u179A"},{"id":15758,"word":"\u17A2\u1793\u17D2\u178A\u179A !"},{"id":15759,"word":"\u17A2\u1793\u17D2\u178F\u179A --"},{"id":15760,"word":"\u17A2\u1793\u17D2\u178F\u179A\u178A\u17D2\u178B\u1780\u17B6"},{"id":15761,"word":"\u17A2\u1793\u17D2\u178F\u179A\u178F\u17D2\u1790\u179C\u17B6\u1785\u1780"},{"id":15762,"word":"\u17A2\u1793\u17D2\u178A\u179A\u1792\u17B6\u1793"},{"id":15763,"word":"\u17A2\u1793\u17D2\u178F\u179A\u179C\u17B6\u179F\u1780"},{"id":15764,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B6"},{"id":15765,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B6 --"},{"id":15766,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B6\u1782\u1798\u1793\u17CD"},{"id":15767,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B6\u1799"},{"id":15768,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B6\u1799\u17B7\u1780\u1792\u1798\u17CC"},{"id":15769,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B8\u1780\u17D2\u179F"},{"id":15770,"word":"\u17A2\u1793\u17D2\u178F\u179A\u17B8\u1794"},{"id":15771,"word":"\u17A2\u1793\u17D2\u178F\u179B\u17B7\u1780\u17D2\u1781"},{"id":15772,"word":"\u17A2\u1793\u17D2\u178F\u179F\u1799\u17D2\u1799\u17B6"},{"id":15773,"word":"\u17A2\u1793\u17D2\u178F\u17B6\u1780\u17CB\u17A2\u1793\u17D2\u178F\u17B7\u1785"},{"id":15774,"word":"\u17A2\u1793\u17D2\u178F\u17B6\u1799"},{"id":15775,"word":"\u17A2\u1793\u17D2\u178F\u17B7\u178F\u17A2\u1793\u17D2\u178F\u17BC\u1784"},{"id":15776,"word":"\u17A2\u1793\u17D2\u178F\u17B7\u1798"},{"id":15777,"word":"\u17A2\u1793\u17D2\u178F\u17B7\u1798 --"},{"id":15778,"word":"\u17A2\u1793\u17D2\u178F\u17BA\u178F"},{"id":15779,"word":"\u17A2\u1793\u17D2\u178F\u17BA\u179A\u17C9\u17BA\u179A\u17C9\u17BA\u178F"},{"id":15780,"word":"\u17A2\u1793\u17D2\u178F\u17BB\u1799"},{"id":15781,"word":"\u17A2\u1793\u17D2\u178F\u17BB\u179B"},{"id":15782,"word":"\u17A2\u1793\u17D2\u178F\u17C1"},{"id":15783,"word":"\u17A2\u1793\u17D2\u178F\u17C1 --"},{"id":15784,"word":"\u17A2\u1793\u17D2\u178F\u17C1\u1794\u17A2\u1793\u17D2\u178F\u17B6\u1794"},{"id":15785,"word":"\u17A2\u1793\u17D2\u178F\u17C1\u179C\u17B6\u179F\u17B7\u1780"},{"id":15786,"word":"\u17A2\u1793\u17D2\u178F\u17C1\u179C\u17B6\u179F\u17B7\u1793"},{"id":15787,"word":"\u17A2\u1793\u17D2\u178F\u17C2\u1784\u17A2\u1793\u17D2\u178F\u17C3"},{"id":15788,"word":"\u17A2\u1793\u17D2\u178F\u17C4"},{"id":15789,"word":"\u17A2\u1793\u17D2\u178F\u17C4 --"},{"id":15790,"word":"\u17A2\u1793\u17D2\u178F\u17D2\u179A\u178F"},{"id":15791,"word":"\u17A2\u1793\u17D2\u178F\u17D2\u179A\u17B6\u1780\u17CB"},{"id":15792,"word":"\u17A2\u1793\u17D2\u178F\u17D2\u179A\u17B9\u1780"},{"id":15793,"word":"\u17A2\u1793\u17D2\u178F\u17D2\u179A\u17BB\u1780"},{"id":15794,"word":"\u17A2\u1793\u17D2\u178F\u17D2\u179A\u17BE\u1780"},{"id":15795,"word":"\u17A2\u1793\u17D2\u178F\u17D2\u179A\u17C4\u1780"},{"id":15796,"word":"\u17A2\u1793\u17D2\u1790\u1798"},{"id":15797,"word":"\u17A2\u1793\u17D2\u1790\u17BA\u1798"},{"id":15798,"word":"\u17A2\u1793\u17D2\u1790\u17C4\u1785\u17D7"},{"id":15799,"word":"\u17A2\u1793\u17D2\u1791\u1784"},{"id":15800,"word":"\u17A2\u1793\u17D2\u1791\u1784\u17CB"},{"id":15801,"word":"\u17A2\u1793\u17D2\u1791\u1784\u17CB\u1794\u17B6\u179A"},{"id":15802,"word":"\u17A2\u1793\u17D2\u1791\u1784\u17CB\u179A\u17BB\u1780"},{"id":15803,"word":"\u17A2\u1793\u17D2\u1791\u1784\u17CB\u179C\u17B7\u178F"},{"id":15804,"word":"\u17A2\u1793\u17D2\u1791\u1784\u17CB\u17A2\u17B6\u17C6\u1784"},{"id":15805,"word":"\u17A2\u1793\u17D2\u1791\u17B6\u1780\u17CB"},{"id":15806,"word":"\u17A2\u1793\u17D2\u1791\u17B6\u1780\u17CB\u1781\u17D2\u179B\u17B6"},{"id":15807,"word":"\u17A2\u1793\u17D2\u1791\u17B7\u1780\u17B6"},{"id":15808,"word":"\u17A2\u1793\u17D2\u1791\u17B7\u179B"},{"id":15809,"word":"\u17A2\u1793\u17D2\u1791\u17BA\u179A\u17BA\u179A\u17BA\u178F"},{"id":15810,"word":"\u17A2\u1793\u17D2\u1791\u17BB"},{"id":15811,"word":"\u17A2\u1793\u17D2\u1791\u17BE\u178F"},{"id":15812,"word":"\u17A2\u1793\u17D2\u1791\u17C4\u1780"},{"id":15813,"word":"\u17A2\u1793\u17D2\u1791\u17C4\u1780\u17A2\u1793\u17D2\u1791\u17C4\u179B"},{"id":15814,"word":"\u17A2\u1793\u17D2\u1791\u17C4\u179B"},{"id":15815,"word":"\u17A2\u1793\u17D2\u1791\u17B6\u17C6\u179F\u17D2\u179B\u17B6"},{"id":15816,"word":"\u17A2\u1793\u17D2\u1791\u17C7\u179F\u17B6"},{"id":15817,"word":"\u17A2\u1793\u17D2\u1791\u17C7\u17A2\u1793\u17D2\u1791\u17C2\u1784"},{"id":15818,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u1780\u17CB"},{"id":15819,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u178F"},{"id":15820,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1780"},{"id":15821,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17B6\u1798"},{"id":15822,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17BA\u178F"},{"id":15823,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17BB\u1780"},{"id":15824,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17BC\u178F"},{"id":15825,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17BE\u178F\u17D7"},{"id":15826,"word":"\u17A2\u1793\u17D2\u1791\u17D2\u179A\u17BE\u1798"},{"id":15827,"word":"\u17A2\u1793\u17D2\u1792"},{"id":15828,"word":"\u17A2\u1793\u17D2\u1792 --"},{"id":15829,"word":"\u17A2\u1793\u17D2\u1792\u17B7\u1780\u17B6"},{"id":15830,"word":"\u17A2\u1793\u17D2\u1792\u17B7\u179B"},{"id":15831,"word":"\u17A2\u1793\u17D2\u1792\u17BC --"},{"id":15832,"word":"\u17A2\u1793\u17D2\u1791\u17BD\u1798"},{"id":15833,"word":"\u17A2\u1793\u17D2\u1792\u17BE\u1798"},{"id":15834,"word":"\u17A2\u1793\u17D2\u1792\u17C4"},{"id":15835,"word":"\u17A2\u1793\u17D2\u1793"},{"id":15836,"word":"\u17A2\u1793\u17D2\u1793 --"},{"id":15837,"word":"\u17A2\u1793\u17D2\u1799\u178F\u17B7\u179A\u17D2\u1790\u17B7\u1799"},{"id":15838,"word":"\u17A2\u1793\u17D2\u1799\u1794\u1791"},{"id":15839,"word":"\u17A2\u1793\u17D2\u179B\u1780\u17CB"},{"id":15840,"word":"\u17A2\u1793\u17D2\u179B\u1784"},{"id":15841,"word":"\u17A2\u1793\u17D2\u179B\u1784\u17CB"},{"id":15842,"word":"\u17A2\u1793\u17D2\u179B\u17B6\u1799"},{"id":15843,"word":"\u17A2\u1793\u17D2\u179B\u17B8\u1784"},{"id":15844,"word":"\u17A2\u1793\u17D2\u179B\u17B9\u1794"},{"id":15845,"word":"\u17A2\u1793\u17D2\u179B\u17BC\u1784"},{"id":15846,"word":"\u17A2\u1793\u17D2\u179B\u17BC\u1784\u1780\u17D2\u1794\u17B6\u179B\u179F\u17D2\u179C\u17B6"},{"id":15847,"word":"\u17A2\u1793\u17D2\u179B\u17BC\u1789"},{"id":15848,"word":"\u17A2\u1793\u17D2\u179B\u17BE"},{"id":15849,"word":"\u17A2\u1793\u17D2\u179B\u17C3"},{"id":15850,"word":"\u17A2\u1793\u17D2\u179C\u1780\u17D2\u1781\u179A\u17C8"},{"id":15851,"word":"\u17A2\u1793\u17D2\u179C\u1799\u179C\u17B6\u1785\u1780"},{"id":15852,"word":"\u17A2\u1793\u17D2\u179C\u17C1\u179F"},{"id":15853,"word":"\u17A2\u1793\u17D2\u179F\u1798"},{"id":15854,"word":"\u17A2\u1794"},{"id":15855,"word":"\u17A2\u1794\u17CB"},{"id":15856,"word":"\u17A2\u1794"},{"id":15857,"word":"\u17A2\u1794 --"},{"id":15858,"word":"\u17A2\u1794\u1785\u17B6\u1799\u1793"},{"id":15859,"word":"\u17A2\u1794\u1785\u17B6\u1799\u17B7\u178F"},{"id":15860,"word":"\u17A2\u1794\u1785\u17B6\u1799\u17B7\u178F\u17B6"},{"id":15861,"word":"\u17A2\u1794\u178E\u17D2\u178E\u1780\u1794\u17D2\u1794\u178A\u17B7\u1794\u1791\u17B6"},{"id":15862,"word":"\u17A2\u1794\u1791\u17C1\u179F"},{"id":15863,"word":"\u17A2\u1794\u1798\u1784\u17D2\u1782\u179B"},{"id":15864,"word":"\u17A2\u1794\u1798\u17B6\u179A"},{"id":15865,"word":"\u17A2\u1794\u1799\u179F"},{"id":15866,"word":"\u17A2\u1794\u179A\u1780\u17B6\u179B"},{"id":15867,"word":"\u17A2\u1794\u179A\u1782\u17C4\u1799\u17B6\u1793"},{"id":15868,"word":"\u17A2\u1794\u179A\u178E\u17D2\u178E\u1787\u17B6\u178F\u17B7"},{"id":15869,"word":"\u17A2\u1794\u179A\u1797\u17B6\u1782"},{"id":15870,"word":"\u17A2\u1794\u179A\u179B\u17C4\u1780"},{"id":15871,"word":"\u17A2\u1794\u179A\u179F\u1798\u17D0\u1799"},{"id":15872,"word":"\u17A2\u1794\u179A\u17B6\u1787\u17D0\u1799"},{"id":15873,"word":"\u17A2\u1794\u179A\u17B6\u1787\u17B7\u178F"},{"id":15874,"word":"\u17A2\u1794\u179A\u17B6\u1792"},{"id":15875,"word":"\u17A2\u1794\u179A\u17B7\u1798\u17B6\u178E"},{"id":15876,"word":"\u17A2\u1794\u179A\u17B7\u1798\u17B6\u178E --"},{"id":15877,"word":"\u17A2\u1794\u179A\u17B7\u1799\u17C4\u179F\u17B6\u1793"},{"id":15878,"word":"\u17A2\u1794\u179A\u17BC\u1794"},{"id":15879,"word":"\u17A2\u1794\u179A\u17BC\u1794\u17B6"},{"id":15880,"word":"\u17A2\u1794\u17CB\u179A\u17C6"},{"id":15881,"word":"\u17A2\u1794\u179B\u1780\u17D2\u1781\u178E\u17CD"},{"id":15882,"word":"\u17A2\u1794\u179B\u17B6\u1797"},{"id":15883,"word":"\u17A2\u1794\u179B\u17B6\u1797\u17B6"},{"id":15884,"word":"\u17A2\u1794\u179B\u17C4\u1780"},{"id":15885,"word":"\u17A2\u1794\u179B\u17C4\u1780\u1793"},{"id":15886,"word":"\u17A2\u1794\u179B\u17C4\u1797"},{"id":15887,"word":"\u17A2\u1794\u179B\u17C4\u1797\u17B6"},{"id":15888,"word":"\u17A2\u1794\u179C\u17B6\u1791"},{"id":15889,"word":"\u17A2\u1794\u179F\u1780\u17D2\u178F\u17B7"},{"id":15890,"word":"\u17A2\u1794\u17A0\u17B6\u179A"},{"id":15891,"word":"\u17A2\u1794\u17A0\u17B6\u179F"},{"id":15892,"word":"\u17A2\u1794\u17B6\u1780\u179A\u178E\u17CD"},{"id":15893,"word":"\u17A2\u1794\u17B6\u1785\u17B8"},{"id":15894,"word":"\u17A2\u1794\u17B6\u1791\u1780"},{"id":15895,"word":"\u17A2\u1794\u17B6\u1799"},{"id":15896,"word":"\u17A2\u1794\u17B6\u1799 --"},{"id":15897,"word":"\u17A2\u1794\u17BB\u1789\u17D2\u1789\u179B\u17B6\u1797"},{"id":15898,"word":"\u17A2\u1794\u17BB\u1789\u17D2\u1789\u17B6\u1797\u17B7 \u179F\u1784\u17D2\u1781\u17B6\u179A"},{"id":15899,"word":"\u17A2\u1794\u17BB\u178F\u17D2\u178F\u1780"},{"id":15900,"word":"\u17A2\u1794\u17BB\u178F\u17D2\u178F\u1780\u17C4"},{"id":15901,"word":"\u17A2\u1794\u17BB\u178F\u17D2\u178F\u17B7\u1780\u17B6"},{"id":15902,"word":"\u17A2\u1794\u17BB\u1793\u1794\u17D2\u1794\u17BB\u1793\u1780\u17D2\u1780\u1798\u17D2\u1798"},{"id":15903,"word":"\u17A2\u1794\u17C1\u1780\u17D2\u1781\u17B6"},{"id":15904,"word":"\u17A2\u1794\u17C1\u178F\u179C\u17B7\u1789\u17D2\u1789\u17B6\u178E"},{"id":15905,"word":"\u17A2\u1794\u17C4\u1782\u178E\u17D2\u178C"},{"id":15906,"word":"\u17A2\u1794\u17D2\u1794"},{"id":15907,"word":"\u17A2\u1794\u17D2\u1794 --"},{"id":15908,"word":"\u17A2\u1794\u17D2\u1794\u1780\u17B6\u179A"},{"id":15909,"word":"\u17A2\u1794\u17D2\u1794\u1785\u17D2\u1785\u1799\u1797\u17B6\u1796"},{"id":15910,"word":"\u17A2\u1794\u17D2\u1794\u178A\u17B7"},{"id":15911,"word":"\u17A2\u1794\u17D2\u1794\u178A\u17B7 --"},{"id":15912,"word":"\u17A2\u1794\u17D2\u1794\u1793\u17B6"},{"id":15913,"word":"\u17A2\u1794\u17D2\u1794\u1793\u17B6 --"},{"id":15914,"word":"\u17A2\u1794\u17D2\u1794\u1798\u17B6\u178E"},{"id":15915,"word":"\u17A2\u1794\u17D2\u1794\u1798\u17B6\u178E --"},{"id":15916,"word":"\u17A2\u1794\u17D2\u1794\u1798\u17B6\u1791"},{"id":15917,"word":"\u17A2\u1794\u17D2\u1794\u1798\u17B6\u1791 --"},{"id":15918,"word":"\u17A2\u1794\u17D2\u1794\u1798\u17C1\u1799\u17D2\u1799"},{"id":15919,"word":"\u17A2\u1794\u17D2\u1794\u179F\u17B6\u1793\u17D2\u178F"},{"id":15920,"word":"\u17A2\u1794\u17D2\u1794\u17B7\u1785\u17D2\u1786"},{"id":15921,"word":"\u17A2\u1794\u17D2\u1794\u17B7\u1785\u17D2\u1786 --"},{"id":15922,"word":"\u17A2\u1794\u17D2\u1794\u17B7\u1785\u17D2\u1786\u17B6"},{"id":15923,"word":"\u17A2\u1794\u17D2\u1794\u17B7\u1785\u17D2\u1786\u17C4"},{"id":15924,"word":"\u17A2\u1794\u17D2\u1794\u17B7\u1799"},{"id":15925,"word":"\u17A2\u1794\u17D2\u1794\u17B7\u1799 --,"},{"id":15926,"word":"\u17A2\u1794\u17D2\u1794\u17C1\u179F\u1780\u17D2\u1781"},{"id":15927,"word":"\u17A2\u1794\u17D2\u1794\u17C1\u179F\u1780\u17D2\u1781 --"},{"id":15928,"word":"\u17A2\u1794\u17D2\u1794\u17C4\u1791\u1780"},{"id":15929,"word":"\u17A2\u1794\u17D2\u1794\u17C4\u1791\u1780 --"},{"id":15930,"word":"\u17A2\u1794\u17D2\u1795\u17C4\u178A\u1793\u179F\u1796\u17D2\u1791"},{"id":15931,"word":"\u17A2\u1794\u17D2\u179A\u1780\u17B6\u179A"},{"id":15932,"word":"\u17A2\u1794\u17D2\u179A\u178F\u17B7 --"},{"id":15933,"word":"\u17A2\u1794\u17D2\u179A\u1798\u17B6\u178E"},{"id":15934,"word":"\u17A2\u1794\u17D2\u179A\u1798\u17B6\u1790"},{"id":15935,"word":"\u17A2\u1794\u17D2\u179A\u17B7\u1799"},{"id":15936,"word":"\u17A2\u1794\u17D2\u179F\u179A"},{"id":15937,"word":"\u17A2\u1794\u17D2\u179F\u179A\u17B6"},{"id":15938,"word":"\u17A2\u1794\u17D2\u179F\u17B6\u1793\u17D2\u178F"},{"id":15939,"word":"\u17A2\u1795\u179B\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":15940,"word":"\u17A2\u1795\u179B\u1794\u17D2\u179A\u1791\u17B6\u1793\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":15941,"word":"\u17A2\u1795\u17B6\u179F\u17BB"},{"id":15942,"word":"\u17A2\u1795\u17B6\u179F\u17BB\u1780"},{"id":15943,"word":"\u17A2\u1795\u17D2\u1791\u1780\u17CB"},{"id":15944,"word":"\u17A2\u1795\u17D2\u1791\u1784\u17CB"},{"id":15945,"word":"\u17A2\u1795\u17D2\u1791\u17B6\u1789"},{"id":15946,"word":"\u17A2\u1795\u17D2\u179F\u17BB\u1780"},{"id":15947,"word":"\u17A2\u1795\u17D2\u179F\u17B6\u1793"},{"id":15948,"word":"\u17A2\u1796\u17D0\u1791\u17D2\u1792"},{"id":15949,"word":"\u17A2\u1796\u1791\u17D2\u1792\u179F\u17B8\u1798\u17B6"},{"id":15950,"word":"\u17A2\u1796\u1796\u17C8"},{"id":15951,"word":"\u17A2\u1796\u1798\u1784\u17D2\u1782\u179B"},{"id":15952,"word":"\u17A2\u1796\u1799\u1796"},{"id":15953,"word":"\u17A2\u1796\u179B"},{"id":15954,"word":"\u17A2\u1796\u179B\u17B6"},{"id":15955,"word":"\u17A2\u1796\u17BB\u1791\u17D2\u1792\u17B7"},{"id":15956,"word":"\u17A2\u17D0\u1796\u17D2\u1791"},{"id":15957,"word":"\u17A2\u1796\u17D2\u179C\u17BB\u1791"},{"id":15958,"word":"\u17A2\u1789\u17D2\u179C\u17C1\u17A0\u17B6\u179A\u17B7\u1780"},{"id":15959,"word":"\u17A2\u1796\u17D2\u179C\u17C4\u17A0\u17B6\u179A\u17B7\u1780\u17B6"},{"id":15960,"word":"\u17A2\u1796\u17D2\u1797"},{"id":15961,"word":"\u17A2\u1796\u17D2\u1797 --"},{"id":15962,"word":"\u17A2\u1796\u17D2\u1797\u1780\u17D2\u1781\u17B6\u1793"},{"id":15963,"word":"\u17A2\u1796\u17D2\u1797\u1780\u17D2\u1781\u17B6\u1793 --"},{"id":15964,"word":"\u17A2\u1796\u17D2\u1797\u1793\u17D2\u178F\u179A"},{"id":15965,"word":"\u17A2\u1796\u17D2\u1797\u1793\u17D2\u178F\u179A --"},{"id":15966,"word":"\u17A2\u1796\u17D2\u1797\u17B6"},{"id":15967,"word":"\u17A2\u1789\u17D2\u1797\u1793"},{"id":15968,"word":"\u17A2\u1789\u17D2\u1797\u179F"},{"id":15969,"word":"\u17A2\u1796\u17D2\u1797\u17BC\u178F"},{"id":15970,"word":"\u17A2\u1796\u17D2\u1797\u17C4\u1780\u17B6\u179F"},{"id":15971,"word":"\u17A2\u1796\u17D2\u1797\u17C4\u1780\u17B6\u179F\u17B7\u1780"},{"id":15972,"word":"\u17A2\u1796\u17D2\u1799\u178F\u17D2\u178F"},{"id":15973,"word":"\u17A2\u1796\u17D2\u1799\u178F\u17D2\u178F --"},{"id":15974,"word":"\u17A2\u1796\u17D2\u1799\u1796"},{"id":15975,"word":"\u17A2\u1796\u17D2\u1799\u1799\u17C8"},{"id":15976,"word":"\u17A2\u1796\u17D2\u1799\u1799\u17B8\u1797\u17B6\u1796"},{"id":15977,"word":"\u17A2\u1796\u17D2\u1799\u17B6\u1780\u178F "},{"id":15978,"word":"\u17A2\u1796\u17D2\u1799\u17B6\u1794\u17B6\u1791"},{"id":15979,"word":"\u17A2\u1796\u17D2\u179A\u17A0\u17D2\u1798\u1785\u179A\u17B7\u1799"},{"id":15980,"word":"\u17A2\u1796\u17D2\u179A\u17A0\u17D2\u1798\u1785\u17B6\u179A\u17B7\u1793\u17B8 "},{"id":15981,"word":"\u17A2\u1796\u17D2\u179A\u17A0\u17D2\u1798\u1785\u17B6\u179A\u17B8"},{"id":15982,"word":"\u17A2\u1797\u1796\u17D2\u179C --"},{"id":15983,"word":"\u17A2\u1797\u17D0\u1796\u17D2\u179C"},{"id":15984,"word":"\u17A2\u1797\u1789\u17D2\u179C"},{"id":15985,"word":"\u17A2\u1797\u1799 --"},{"id":15986,"word":"\u17A2\u1797\u17D0\u1799"},{"id":15987,"word":"\u17A2\u1797\u1799\u17BC --"},{"id":15988,"word":"\u17A2\u1797\u17B6\u1796 "},{"id":15989,"word":"\u17A2\u1797\u17B7"},{"id":15990,"word":"\u17A2\u1797\u17B7 --"},{"id":15991,"word":"\u17A2\u1797\u17B7\u1787\u17D2\u1788\u17B6"},{"id":15992,"word":"\u17A2\u1797\u17B7\u1789\u17D2\u1789\u17B6"},{"id":15993,"word":"\u17A2\u1797\u17B7\u1789\u17D2\u1789\u17B6\u178E"},{"id":15994,"word":"\u17A2\u1797\u17B7\u178E\u17D2\u17A0"},{"id":15995,"word":"\u17A2\u1797\u17B7\u178E\u17D2\u17A0 --"},{"id":15996,"word":"\u17A2\u1797\u17B7\u1791\u17C4\u179F"},{"id":15997,"word":"\u17A2\u1797\u17B7\u1791\u17D2\u179A\u17C4\u17C7"},{"id":15998,"word":"\u17A2\u1797\u17B7\u1792\u1787\u1798\u17A0\u17B6\u179A\u178A\u17D2\u178B\u1782\u17BB\u179A\u17BB"},{"id":15999,"word":"\u17A2\u1797\u17B7\u1792\u1798\u17D2\u1798 "},{"id":16000,"word":"\u17A2\u1797\u17B7\u1792\u17B6\u1793"},{"id":16001,"word":"\u17A2\u1797\u17B7\u1792\u17B6\u1793\u179F\u1796\u17D2\u1791"},{"id":16002,"word":"\u17A2\u1797\u17B7\u1793\u17B7\u179C\u17C1\u179F"},{"id":16003,"word":"\u17A2\u1797\u17B7\u1793\u17B7\u179F\u17D2\u1780\u17D2\u179A\u1798\u178E\u17CD"},{"id":16004,"word":"\u17A2\u1797\u17B7\u1793\u17B8\u17A0\u17B6\u179A"},{"id":16005,"word":"\u17A2\u1797\u17B7\u1793\u17B8\u17A0\u17B6\u179A\u179F\u1798\u17D2\u1794\u1793\u17D2\u1793"},{"id":16006,"word":"\u17A2\u1797\u17B7\u1793\u17C1\u179F\u17D2\u1780\u17D2\u179A\u1798\u17CD"},{"id":16007,"word":"\u17A2\u1797\u17B7\u1793\u17C1\u179F\u17D2\u1780\u17D2\u179A\u1798\u178E\u17CD"},{"id":16008,"word":"\u17A2\u1797\u17B7\u1794\u17B6\u179B"},{"id":16009,"word":"\u17A2\u1797\u17B7\u1794\u17B6\u179B --"},{"id":16010,"word":"\u17A2\u1797\u17B7\u1794\u17D2\u179A\u178E\u17B7\u1794\u17D0\u178F"},{"id":16011,"word":"\u17A2\u1797\u17B7\u1794\u17D2\u179A\u178E\u17B7\u1794\u17D0\u178F\u1793\u17CD "},{"id":16012,"word":"\u17A2\u1797\u17B7\u1794\u17D2\u179A\u17B6\u1799"},{"id":16013,"word":"\u17A2\u1797\u17B7\u1798\u1784\u17D2\u1782\u179B"},{"id":16014,"word":"\u17A2\u1797\u17B7\u1798\u1784\u17D2\u1782\u179B\u17CD"},{"id":16015,"word":"\u17A2\u1797\u17B7\u179A\u178A\u17D2\u178B\u1798\u1793\u17D2\u178F\u17D2\u179A\u17B8"},{"id":16016,"word":"\u17A2\u1797\u17B7\u179A\u1798"},{"id":16017,"word":"\u17A2\u1797\u17B7\u179A\u1798\u17D2\u1799"},{"id":16018,"word":"\u17A2\u1797\u17B7\u179A\u17B6\u1787"},{"id":16019,"word":"\u17A2\u1797\u17B7\u179A\u17B6\u1798"},{"id":16020,"word":"\u17A2\u1797\u17B7\u179A\u17B6\u179F\u17D2\u178F\u17D2\u179A\u1798\u1793\u17D2\u178F\u17D2\u179A\u17B8"},{"id":16021,"word":"\u17A2\u1797\u17B7\u179A\u17BC\u17A0\u17CD"},{"id":16022,"word":"\u17A2\u1797\u17B7\u179A\u17C6"},{"id":16023,"word":"\u17A2\u1797\u17B7\u179B\u1780\u17D2\u1781\u17B7\u178F\u1780\u17B6\u179B"},{"id":16024,"word":"\u17A2\u1797\u17B7\u179C\u178C\u17D2\u178D"},{"id":16025,"word":"\u17A2\u1797\u17B7\u179C\u1793\u17D2\u1791"},{"id":16026,"word":"\u17A2\u1797\u17B7\u179C\u1793\u17D2\u1791\u1793\u17CD"},{"id":16027,"word":"\u17A2\u1797\u17B7\u179F\u1798\u17D0\u1799"},{"id":16028,"word":"\u17A2\u1797\u17B7\u179F\u1798\u17B6\u1785\u17B6\u179A"},{"id":16029,"word":"\u17A2\u1797\u17B7\u179F\u1798\u17B6\u1785\u17B6\u179A\u17B7\u1780\u179C\u178F\u17D2\u178F"},{"id":16030,"word":"\u17A2\u1797\u17B7\u179F\u1798\u17D2\u1796\u17C4\u1792\u17B7"},{"id":16031,"word":"\u17A2\u1797\u17B7\u179F\u17B7\u178F\u17D2\u178F\u179A\u17B6\u1787"},{"id":16032,"word":"\u17A2\u1797\u17B7\u179F\u17C1\u1780"},{"id":16033,"word":"\u17A2\u1797\u17B7\u179F\u17C4\u1792"},{"id":16034,"word":"\u17A2\u1797\u17B7\u179F\u17C4\u1792\u1793\u17CD"},{"id":16035,"word":"\u17A2\u1797\u17BC\u178F"},{"id":16036,"word":"\u17A2\u1797\u17BC\u178F --"},{"id":16037,"word":"\u17A2\u1797\u17C1\u1787\u17D2\u1787\u179A\u17BC\u1794"},{"id":16038,"word":"\u17A2\u1797\u17C1\u1791"},{"id":16039,"word":"\u17A2\u1797\u17D2\u1799\u17B6\u1782\u178F"},{"id":16040,"word":"\u17A2\u1797\u17D2\u1799\u17B6\u1782\u1798"},{"id":16041,"word":"\u17A2\u1797\u17D2\u1799\u17B6\u1782\u1798\u1793\u17B6\u1782\u1798\u1793\u17CD"},{"id":16042,"word":"\u17A2\u17D0\u1797\u17D2\u179A"},{"id":16043,"word":"\u17A2\u1797\u17D2\u179A\u17C6\u179F\u17C8"},{"id":16044,"word":"\u17A2\u1798"},{"id":16045,"word":"\u17A2\u1798\u1782\u1798"},{"id":16046,"word":"\u17A2\u1798\u1782\u17B6\u1784"},{"id":16047,"word":"\u17A2\u1798\u1785\u17D2\u1785\u17B6"},{"id":16048,"word":"\u17A2\u1798\u178F"},{"id":16049,"word":"\u17A2\u1798\u178F --"},{"id":16050,"word":"\u17A2\u1798\u178F\u17D2\u178F\u1789\u17D2\u1789\u17BB\u178F\u17B6"},{"id":16051,"word":"\u17A2\u1798\u178F\u17D2\u178F\u1789\u17D2\u1789\u17BC"},{"id":16052,"word":"\u17A2\u1798\u1793\u17BB\u179F\u17D2\u179F"},{"id":16053,"word":"\u17A2\u1798\u179A"},{"id":16054,"word":"\u17A2\u1798\u179A --"},{"id":16055,"word":"\u17A2\u1798\u179A\u1782\u17C4\u1799\u17B6\u1793"},{"id":16056,"word":"\u17A2\u1798\u179A\u17B6 --"},{"id":16057,"word":"\u17A2\u1798\u179A\u17B6\u179C\u17B7\u1780\u17D2\u1781\u17C1\u1794"},{"id":16058,"word":"\u17A2\u1798\u179A\u17B7\u1793\u17D2\u1791"},{"id":16059,"word":"\u17A2\u1798\u17B6\u178F\u17D2\u1799"},{"id":16060,"word":"\u17A2\u1798\u17B6\u179C\u179F\u17B8"},{"id":16061,"word":"\u17A2\u1798\u17B7\u178A\u17B6"},{"id":16062,"word":"\u17A2\u1798\u17B7\u178F "},{"id":16063,"word":"\u17A2\u1798\u17B7\u178F\u17B6\u1797\u17C8"},{"id":16064,"word":"\u17A2\u1798\u17B7\u178F\u17B6\u1799\u17BB\u179F"},{"id":16065,"word":"\u17A2\u1798\u17B7\u178F\u17D2\u178F"},{"id":16066,"word":"\u17A2\u1798\u17BC\u179B"},{"id":16067,"word":"\u17A2\u1798\u17BC\u179B\u1780\u17C2"},{"id":16068,"word":"\u17A2\u1798\u17C4\u1780\u17D2\u179F"},{"id":16069,"word":"\u17A2\u1798\u17C4\u1780\u17D2\u179F\u17B6"},{"id":16070,"word":"\u17A2\u1798\u17C4\u1783"},{"id":16071,"word":"\u17A2\u1798\u17C4\u1783 --"},{"id":16072,"word":"\u17A2\u1798\u17C4\u17A0\u17C8"},{"id":16073,"word":"\u17A2\u1798\u17D2\u1785\u178F\u17CB"},{"id":16074,"word":"\u17A2\u1798\u17D2\u1785\u17B6\u179F\u17CB"},{"id":16075,"word":"\u17A2\u1798\u17D2\u1793\u17C1\u1789"},{"id":16076,"word":"\u17A2\u1798\u17D2\u1794\u17B6\u1789\u17CB\u1798\u17B7\u1789"},{"id":16077,"word":"\u17A2\u1798\u17D2\u1794\u17B6\u1799"},{"id":16078,"word":"\u17A2\u1798\u17D2\u1794\u17B6\u179B"},{"id":16079,"word":"\u17A2\u1798\u17D2\u1794\u17B6\u179B  --"},{"id":16080,"word":"\u17A2\u1798\u17D2\u1794\u17BC\u179A"},{"id":16081,"word":"\u17A2\u1798\u17D2\u1794\u17C4\u179F"},{"id":16082,"word":"\u17A2\u1798\u17D2\u1796"},{"id":16083,"word":"\u17A2\u1798\u17D2\u1796\u1780\u17B6"},{"id":16084,"word":"\u17A2\u1798\u17D2\u1796\u179A"},{"id":16085,"word":"\u17A2\u1798\u17D2\u1796\u17B6"},{"id":16086,"word":"\u17A2\u1798\u17D2\u1796\u17B6\u179B\u17B6"},{"id":16087,"word":"\u17A2\u1798\u17D2\u1796\u17B7\u179B"},{"id":16088,"word":"\u17A2\u1798\u17D2\u1796\u17B7\u179B\u1791\u17B9\u1780"},{"id":16089,"word":"\u17A2\u1798\u17D2\u1796\u17B7\u179B\u1794\u17D2\u179A\u1780\u17CB\u1795\u17D2\u179B\u17C2"},{"id":16090,"word":"\u17A2\u1798\u17D2\u1796\u17BB"},{"id":16091,"word":"\u17A2\u1798\u17D2\u1796\u17BB --"},{"id":16092,"word":"\u17A2\u1798\u17D2\u1796\u17BB\u17C7"},{"id":16093,"word":"\u17A2\u1798\u17D2\u1797\u17D0\u179F"},{"id":16094,"word":"\u17A2\u1798\u17D2\u1797\u17C4 ! "},{"id":16095,"word":"\u17A2\u1798\u17D2\u1797\u17C4\u1787\u17B7\u1793\u17B8"},{"id":16096,"word":"\u17A2\u1798\u17D2\u1797\u17C4\u1791"},{"id":16097,"word":"\u17A2\u1798\u17D2\u1797\u17C4\u1792\u17B7"},{"id":16098,"word":"\u17A2\u1798\u17D2\u1798\u17B6"},{"id":16099,"word":"\u17A2\u1798\u17D2\u179A"},{"id":16100,"word":"\u17A2\u1798\u17D2\u179A\u179F\u17CB"},{"id":16101,"word":"\u17A2\u1798\u17D2\u179A\u17B6\u1798"},{"id":16102,"word":"\u17A2\u1798\u17D2\u179A\u17B9\u178F"},{"id":16103,"word":"\u17A2\u1799\u1793\u1780\u17B6\u179B"},{"id":16104,"word":"\u17A2\u1799\u1793\u1797\u17B6\u1782"},{"id":16105,"word":"\u17A2\u1799\u179F\u1784\u17D2\u1781\u179B\u17B7\u1780"},{"id":16106,"word":"\u17A2\u1799\u179F\u17D2\u1780\u17B6\u1793\u17D2\u178F"},{"id":16107,"word":"\u17A2\u1799\u179F\u17D2\u1780\u17B6\u179A"},{"id":16108,"word":"\u17A2\u1799\u179F\u17D2\u1780\u17BB\u1798\u17D2\u1797"},{"id":16109,"word":"\u17A2\u1799\u179F\u17D2\u1798\u17D0\u1799"},{"id":16110,"word":"\u17A2\u1799\u17B8\u178A\u17B6"},{"id":16111,"word":"\u17A2\u1799\u17BB\u178F\u17D2\u178F"},{"id":16112,"word":"\u17A2\u1799\u17BB\u178F\u17D2\u178F --"},{"id":16113,"word":"\u17A2\u1799\u17BB\u178F\u17D2\u178F\u17B7\u1792\u1798\u17CC"},{"id":16114,"word":"\u17A2\u1799\u17BB\u1791\u17D2\u1792"},{"id":16115,"word":"\u17A2\u1799\u17BB\u1792\u17D2\u1799\u17B6"},{"id":16116,"word":"\u17A2\u1799\u17C4"},{"id":16117,"word":"\u17A2\u1799\u17C4 --"},{"id":16118,"word":"\u17A2\u1799\u17C4\u1782\u17B7\u1793"},{"id":16119,"word":"\u17A2\u1799\u17C4\u1782\u17B8"},{"id":16120,"word":"\u17A2\u1799\u17C4\u1792"},{"id":16121,"word":"\u17A2\u1799\u17C4\u1792\u17B7\u1793"},{"id":16122,"word":"\u17A2\u1799\u17C4\u1792\u17D2\u1799\u17B6"},{"id":16123,"word":"\u17A2\u1799\u17C4\u1793\u17B7\u179F\u17C4\u1798\u1793\u179F\u17B7\u1780\u17B6\u179A"},{"id":16124,"word":"\u17A2\u1799\u17D2\u1799"},{"id":16125,"word":"\u17A2\u1799\u17D2\u1799 --"},{"id":16126,"word":"\u17A2\u1799\u17D2\u1799\u1780"},{"id":16127,"word":"\u17A2\u1799\u17D2\u1799\u1780 --"},{"id":16128,"word":"\u17A2\u1799\u17D2\u1799\u1780\u17B6"},{"id":16129,"word":"\u17A2\u1799\u17D2\u1799\u1780\u17B6\u179A"},{"id":16130,"word":"\u17A2\u1799\u17D2\u1799\u1780\u17C4"},{"id":16131,"word":"\u17A2\u1799\u17D2\u1799\u17B6"},{"id":16132,"word":"\u17A2\u1799\u17D2\u1799\u17B7\u1780\u17B6"},{"id":16133,"word":"\u17A2\u179A"},{"id":16134,"word":"\u17A2\u179A --"},{"id":16135,"word":"\u17A2\u179A\u1780\u17D2\u1781\u1780\u1798\u17D2\u1798"},{"id":16136,"word":"\u17A2\u179A\u1787\u17BB\u1793"},{"id":16137,"word":"\u17A2\u179A\u1787\u17BC\u1793"},{"id":16138,"word":"\u17A2\u179A\u1789\u17D2\u1789"},{"id":16139,"word":"\u17A2\u179A\u1789\u17D2\u1789 --"},{"id":16140,"word":"\u17A2\u179A\u1789\u17D2\u1789\u17B7\u1780"},{"id":16141,"word":"\u17A2\u179A\u178E\u17B8"},{"id":16142,"word":"\u17A2\u179A\u178E\u17D2\u1799"},{"id":16143,"word":"\u17A2\u179A\u1796\u17B7\u1793\u17D2\u1791"},{"id":16144,"word":"\u17A2\u179A\u179F\u1797\u17B6\u1796"},{"id":16145,"word":"\u17A2\u179A\u179F\u179A\u17BC\u1794"},{"id":16146,"word":"\u17A2\u179A\u17A0\u178F\u17D2\u178F"},{"id":16147,"word":"\u17A2\u179A\u17A0\u1791\u17D2\u1792\u1787"},{"id":16148,"word":"\u17A2\u179A\u17A0\u1793\u17D2\u178F"},{"id":16149,"word":"\u17A2\u179A\u17A0\u1793\u17D2\u178F\u17B6"},{"id":16150,"word":"\u17A2\u179A\u17A0\u17B6"},{"id":16151,"word":"\u17A2\u179A\u17A0\u17C6"},{"id":16152,"word":"\u17A2\u179A\u17B6\u1782"},{"id":16153,"word":"\u17A2\u17B6\u179A\u17B6\u1782\u17B6"},{"id":16154,"word":"\u17A2\u179A\u17B6\u1787\u1780"},{"id":16155,"word":"\u17A2\u179A\u17B7"},{"id":16156,"word":"\u17A2\u179A\u17B7 --"},{"id":16157,"word":"\u17A2\u179A\u17B7\u1799"},{"id":16158,"word":"\u17A2\u179A\u17B7\u1799 --"},{"id":16159,"word":"\u17A2\u179A\u17B7\u1799\u1780"},{"id":16160,"word":"\u17A2\u179A\u17B7\u1799\u1780 --"},{"id":16161,"word":"\u17A2\u179A\u17B7\u1799\u17BB --"},{"id":16162,"word":"\u17A2\u179A\u17BB\u178E"},{"id":16163,"word":"\u17A2\u179A\u17BB\u178E --"},{"id":16164,"word":"\u17A2\u179A\u17BC\u1794"},{"id":16165,"word":"\u17A2\u179A\u17BC\u1794 --"},{"id":16166,"word":"\u17A2\u179A\u17C1 ! "},{"id":16167,"word":"\u17A2\u179A\u17C4\u1782"},{"id":16168,"word":"\u17A2\u179A\u17C4\u1782 --"},{"id":16169,"word":"\u17A2\u1783\u17CC"},{"id":16170,"word":"\u17A2\u1787\u17CC\u17BB\u1793"},{"id":16171,"word":"\u17A2\u1790\u17CC"},{"id":16172,"word":"\u17A2\u179B\u1780\u17D2\u1781\u17B7\u1793\u17B8"},{"id":16173,"word":"\u17A2\u179B\u1780\u17D2\u1781\u17B8"},{"id":16174,"word":"\u17A2\u179B\u1784\u17D2\u1780\u178F"},{"id":16175,"word":"\u17A2\u179B\u1784\u17D2\u1780\u179A\u178E\u17CD"},{"id":16176,"word":"\u17A2\u179B\u1784\u17D2\u1780\u17B6\u179A"},{"id":16177,"word":"\u17A2\u179B\u1784\u17D2\u1780\u17D2\u179A\u17B9\u178F"},{"id":16178,"word":"\u17A2\u179B\u1787\u17D2\u1787\u17B6\u1797\u17B6\u1796"},{"id":16179,"word":"\u17A2\u179B\u1787\u17D2\u1787\u17B7\u178F\u17B6"},{"id":16180,"word":"\u17A2\u179B\u1787\u17D2\u1787\u17B7\u1793\u17B8"},{"id":16181,"word":"\u17A2\u179B\u1787\u17D2\u1787\u17B8"},{"id":16182,"word":"\u17A2\u179B\u1787\u17D2\u1787\u17B8 --"},{"id":16183,"word":"\u17A2\u179B\u179F\u1797\u17B6\u1796"},{"id":16184,"word":"\u17A2\u179B\u17CB\u17A2\u17C2\u1780"},{"id":16185,"word":"\u17A2\u179B\u17B6\u1797"},{"id":16186,"word":"\u17A2\u179B\u17B6\u1797 --"},{"id":16187,"word":"\u17A2\u179B\u17B6\u1797\u17B6 !"},{"id":16188,"word":"\u17A2\u179B\u17B6\u1797\u17C4"},{"id":16189,"word":"\u17A2\u179B\u17B7\u1784\u17D2\u1782"},{"id":16190,"word":"\u17A2\u179B\u17C4\u1797"},{"id":16191,"word":"\u17A2\u179B\u17C4\u1797\u17C4"},{"id":16192,"word":"\u17A2\u179B\u17D2\u1794\u179C\u17B7\u1791\u17D2\u1799"},{"id":16193,"word":"\u17A2\u179B\u17D2\u179B\u17C4 !"},{"id":16194,"word":"\u17A2\u179C\u1780\u178A"},{"id":16195,"word":"\u17A2\u179C\u1780\u17B6\u179F"},{"id":16196,"word":"\u17A2\u179C\u1780\u17BB\u178A\u17B6\u179A"},{"id":16197,"word":"\u17A2\u179C\u1782\u1798\u1793\u17CD"},{"id":16198,"word":"\u17A2\u179C\u1782\u17D2\u1782"},{"id":16199,"word":"\u17A2\u179C\u1782\u17D2\u179A\u17A0\u17C8"},{"id":16200,"word":"\u17A2\u179C\u1782\u17D2\u179A\u17C4\u17C7"},{"id":16201,"word":"\u17A2\u179C\u1785\u179A"},{"id":16202,"word":"\u17A2\u179C\u1787\u17D0\u1799"},{"id":16203,"word":"\u17A2\u179C\u1787\u17B6\u178F"},{"id":16204,"word":"\u17A2\u179C\u1787\u17D2\u1788\u17B6\u1793"},{"id":16205,"word":"\u17A2\u179C\u178F\u17B6\u179A"},{"id":16206,"word":"\u17A2\u179C\u1791\u17B6\u1793"},{"id":16207,"word":"\u17A2\u179C\u1792\u17B6\u1793"},{"id":16208,"word":"\u17A2\u179C\u1793\u17D2\u1791\u17B8\u1799"},{"id":16209,"word":"\u17A2\u179C\u1798\u17B6\u1793"},{"id":16210,"word":"\u17A2\u179C\u1799\u179C\u17C8"},{"id":16211,"word":"\u17A2\u179C\u179A\u17BB\u1791\u17D2\u1792"},{"id":16212,"word":"\u17A2\u179C\u179A\u17BB\u1791\u17D2\u1792\u17B6"},{"id":16213,"word":"\u17A2\u179C\u179B\u17C4\u1780\u1793\u17C8"},{"id":16214,"word":"\u17A2\u179C\u179B\u17C4\u1780\u17B7\u178F\u17C1\u179F\u17D2\u179C\u179A"},{"id":16215,"word":"\u17A2\u179C\u179B\u17C4\u1780\u17C1\u179F\u17D2\u179C\u179A"},{"id":16216,"word":"\u17A2\u179C\u179F\u179A"},{"id":16217,"word":"\u17A2\u179C\u179F\u17B6\u1793"},{"id":16218,"word":"\u17A2\u179C\u179F\u17B6\u1793 --"},{"id":16219,"word":"\u17A2\u179C\u179F\u17B7\u178A\u17D2\u178B"},{"id":16220,"word":"\u17A2\u179C\u179F\u17C1\u1780"},{"id":16221,"word":"\u17A2\u179C\u179F\u17C1\u179F"},{"id":16222,"word":"\u17A2\u179C\u179F\u17D2\u179A\u17D0\u1799"},{"id":16223,"word":"\u17A2\u179C\u17A0\u17B6\u179A"},{"id":16224,"word":"\u17A2\u179C\u17B6\u1785\u17B8"},{"id":16225,"word":"\u17A2\u179C\u17B6\u178A"},{"id":16226,"word":"\u17A2\u179C\u17B6\u179F\u17C2"},{"id":16227,"word":"\u17A2\u179C\u17B7\u1785\u17B8"},{"id":16228,"word":"\u17A2\u179C\u17B7\u1787\u17D2\u1787\u1793\u17D2\u1792\u1780\u17B6\u179A"},{"id":16229,"word":"\u17A2\u179C\u17B7\u1787\u17D2\u1787\u1798\u17B6\u1793"},{"id":16230,"word":"\u17A2\u179C\u17B7\u1787\u17D2\u1787\u17B6"},{"id":16231,"word":"\u17A2\u179C\u17B7\u1789\u17D2\u1789\u17B6\u178E\u1780"},{"id":16232,"word":"\u17A2\u179C\u17B7\u1789\u17D2\u1789\u17BC"},{"id":16233,"word":"\u17A2\u179C\u17B7\u1791\u17D2\u1799\u17B6"},{"id":16234,"word":"\u17A2\u179C\u17B7\u1793\u1799 --"},{"id":16235,"word":"\u17A2\u179C\u17B7\u1793\u17D0\u1799"},{"id":16236,"word":"\u17A2\u179C\u17B7\u179A\u17BB\u1791\u17D2\u1792"},{"id":16237,"word":"\u17A2\u179C\u17B7\u179A\u17BB\u1791\u17D2\u1792 --"},{"id":16238,"word":"\u17A2\u179C\u17B7\u179A\u17BC\u17A1\u17D2\u17A0"},{"id":16239,"word":"\u17A2\u179C\u17B7\u179A\u17C4\u1792"},{"id":16240,"word":"\u17A2\u179C\u17B7\u179A\u17C4\u1792\u1793\u17C8"},{"id":16241,"word":"\u17A2\u179C\u17B7\u179F\u17B6\u179A\u1791"},{"id":16242,"word":"\u17A2\u179C\u17B7\u179F\u17B6\u179A\u1791\u17B6"},{"id":16243,"word":"\u17A2\u179C\u17B7\u179F\u17D2\u179F\u17B6\u179F\u17B7\u1780"},{"id":16244,"word":"\u17A2\u179C\u17B7\u179F\u17D2\u179F\u17B6\u179F\u17B7\u1780\u17B6"},{"id":16245,"word":"\u17A2\u179C\u17B7\u17A0\u17B6"},{"id":16246,"word":"\u17A2\u179C\u17B7\u17A0\u17B7\u1784\u17D2\u179F\u17B6"},{"id":16247,"word":"\u17A2\u179C\u17B8\u1785\u17B8"},{"id":16248,"word":"\u17A2\u179C\u17B8\u178F\u17B7\u1780\u17D2\u1780\u1798"},{"id":16249,"word":"\u17A2\u179F\u17CB"},{"id":16250,"word":"\u17A2\u179F\u17CB --"},{"id":16251,"word":"\u17A2\u179F\u1784\u17D2\u1781\u178F\u1792\u1798\u17CC"},{"id":16252,"word":"\u17A2\u179F\u1784\u17D2\u1781\u178F\u1792\u17B6\u178F\u17BB"},{"id":16253,"word":"\u17A2\u179F\u1784\u17D2\u1781\u17C1\u1799\u17D2\u1799"},{"id":16254,"word":"\u17A2\u179F\u1784\u17D2\u1781\u17C3\u1799"},{"id":16255,"word":"\u17A2\u179F\u1784\u17D2\u17A0\u17B6\u179A\u17B7\u1798 --"},{"id":16256,"word":"\u17A2\u179F\u1784\u17D2\u17A0\u17B6\u179A\u17B7\u1798\u17C8"},{"id":16257,"word":"\u17A2\u179F\u1789\u17D2\u1789\u1780\u1798\u17D2\u1798"},{"id":16258,"word":"\u17A2\u179F\u1789\u17D2\u1789\u1797\u17B6\u1796"},{"id":16259,"word":"\u17A2\u179F\u1789\u17D2\u1789\u17B8"},{"id":16260,"word":"\u17A2\u179F\u178F\u17D2\u1799"},{"id":16261,"word":"\u17A2\u179F\u178F\u17D2\u1799 --"},{"id":16262,"word":"\u17A2\u179F\u1791\u17B7\u179F"},{"id":16263,"word":"\u17A2\u179F\u1791\u17B7\u179F\u1791\u17B6\u1793"},{"id":16264,"word":"\u17A2\u179F\u1791\u17D2\u1792\u1798\u17D2\u1798"},{"id":16265,"word":"\u17A2\u179F\u1793\u17B8"},{"id":16266,"word":"\u17A2\u179F\u1793\u17B8 --"},{"id":16267,"word":"\u17A2\u179F\u1793\u17D2\u178F\u17B7\u179F\u17BB\u1781"},{"id":16268,"word":"\u17A2\u179F\u1794\u17D2\u1794\u17BB\u179A\u179F"},{"id":16269,"word":"\u17A2\u179F\u1794\u17D2\u1794\u17BB\u179A\u17B7\u179F"},{"id":16270,"word":"\u17A2\u179F\u1794\u17D2\u1794\u17BB\u179A\u17B7\u179F --"},{"id":16271,"word":"\u17A2\u179F\u1796\u17D2\u1797\u17B7"},{"id":16272,"word":"\u17A2\u179F\u1796\u17D2\u1797\u17B7 --"},{"id":16273,"word":"\u17A2\u179F\u1798\u17D2\u1797\u17B7\u1793\u17D2\u1793"},{"id":16274,"word":"\u17A2\u179F\u1798\u17D2\u1797\u17B7\u1793\u17D2\u1793 --"},{"id":16275,"word":"\u17A2\u179F\u17CB\u179B\u17C4\u1780"},{"id":16276,"word":"\u17A2\u179F\u17CB\u17A2\u1789"},{"id":16277,"word":"\u17A2\u179F\u17CB\u17A2\u1789\u179B\u17C6\u1782\u17C1\u1789"},{"id":16278,"word":"\u17A2\u179F\u17CB\u17A2\u17D2\u1793\u1780"},{"id":16279,"word":"\u17A2\u179F\u17B6\u1780\u179B\u17D2\u1799\u178F\u17D2\u1790\u179C\u17B6\u1785\u1780"},{"id":16280,"word":"\u17A2\u179F\u17B6\u1792\u17B6\u179A\u178E"},{"id":16281,"word":"\u17A2\u179F\u17B6\u1792\u17B6\u179A\u178E\u17C8"},{"id":16282,"word":"\u17A2\u179F\u17B6\u1792\u17BB"},{"id":16283,"word":"\u17A2\u179F\u17B6\u1792\u17BB --"},{"id":16284,"word":"\u17A2\u179F\u17B6\u179A"},{"id":16285,"word":"\u17A2\u179F\u17B6\u179A --"},{"id":16286,"word":"\u17A2\u179F\u17B7\u179A\u17B7\u1780\u17B6"},{"id":16287,"word":"\u17A2\u179F\u17B7\u179A\u17B8"},{"id":16288,"word":"\u17A2\u179F\u17B8\u178F\u17B7\u179F\u17B6\u179C\u1780"},{"id":16289,"word":"\u17A2\u179F\u17B8\u178F\u17D2\u1799\u17B6\u1793\u17BB\u1796\u17D2\u1799\u1789\u17D2\u1787\u1793\u17C8"},{"id":16290,"word":"\u17A2\u179F\u17BB\u1785\u17B7"},{"id":16291,"word":"\u17A2\u179F\u17BB\u1785\u17B7 --"},{"id":16292,"word":"\u17A2\u179F\u17BB\u1791\u17D2\u1792\u17B7"},{"id":16293,"word":"\u17A2\u179F\u17BB\u1791\u17D2\u1792\u17B7 --"},{"id":16294,"word":"\u17A2\u179F\u17BB\u1793\u17D2\u1791\u179A"},{"id":16295,"word":"\u17A2\u179F\u17BB\u1793\u17D2\u1791\u179A --"},{"id":16296,"word":"\u17A2\u179F\u17BB\u1793\u17D2\u1791\u179A\u17B6"},{"id":16297,"word":"\u17A2\u179F\u17BB\u1797"},{"id":16298,"word":"\u17A2\u179F\u17BB\u1797 --"},{"id":16299,"word":"\u17A2\u179F\u17BB\u1797\u17B6"},{"id":16300,"word":"\u17A2\u179F\u17BB\u179A"},{"id":16301,"word":"\u17A2\u179F\u17BB\u179A --"},{"id":16302,"word":"\u17A2\u179F\u17BB\u179A\u17B7\u1793\u17D2\u1791"},{"id":16303,"word":"\u17A2\u179F\u17BB\u179A\u17B8"},{"id":16304,"word":"\u17A2\u179F\u17BB\u179A\u17C4\u17C7"},{"id":16305,"word":"\u17A2\u179F\u17C1\u1780\u17D2\u1781 --"},{"id":16306,"word":"\u17A2\u179F\u17C1\u1780\u17D2\u1781\u17C8"},{"id":16307,"word":"\u17A2\u179F\u17C1\u179A\u17B7\u1793\u17B8"},{"id":16308,"word":"\u17A2\u179F\u17C1\u179A\u17B8"},{"id":16309,"word":"\u17A2\u179F\u17C1\u179A\u17B8 --"},{"id":16310,"word":"\u17A2\u179F\u17C4\u1780"},{"id":16311,"word":"\u17A2\u179F\u17C4\u1785"},{"id":16312,"word":"\u17A2\u179F\u17C6\u17A0\u17B6\u179A\u17B7\u1798\u17C8"},{"id":16313,"word":"\u17A2\u179F\u17D2\u1785\u17B6\u179A\u17D2\u1799"},{"id":16314,"word":"\u17A2\u179F\u17D2\u178F\u1784\u17D2\u1782\u178F"},{"id":16315,"word":"\u17A2\u179F\u17D2\u178F\u1784\u17D2\u1782\u178F --"},{"id":16316,"word":"\u17A2\u179F\u17D2\u178F\u1784\u17D2\u1782\u1798\u1793\u17CD"},{"id":16317,"word":"\u17A2\u179F\u17D2\u178F\u17B6"},{"id":16318,"word":"\u17A2\u179F\u17D2\u178F\u17B6 --"},{"id":16319,"word":"\u17A2\u179F\u17D2\u1798\u17B7"},{"id":16320,"word":"\u17A2\u179F\u17D2\u1798\u17B7\u1798\u17B6\u1793\u17C7"},{"id":16321,"word":"\u17A2\u179F\u17D2\u179A\u17B8"},{"id":16322,"word":"\u17A2\u179F\u17D2\u179C"},{"id":16323,"word":"\u17A2\u179F\u17D2\u179C --"},{"id":16324,"word":"\u17A2\u179F\u17D2\u179C\u178F\u17D2\u1790\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":16325,"word":"\u17A2\u179F\u17D2\u179C\u1799\u17BB\u1787"},{"id":16326,"word":"\u17A2\u179F\u17D2\u179C\u17B6 --"},{"id":16327,"word":"\u17A2\u179F\u17D2\u179C\u17B6\u1798\u17B7\u1780"},{"id":16328,"word":"\u17A2\u179F\u17D2\u179C\u17B6\u1798\u17B7\u1780\u17B6"},{"id":16329,"word":"\u17A2\u179F\u17D2\u179C\u17B7\u1793"},{"id":16330,"word":"\u17A2\u179F\u17D2\u179C\u17C3\u179A\u17B7\u1793"},{"id":16331,"word":"\u17A2\u179F\u17D2\u179F --"},{"id":16332,"word":"\u17A2\u179F\u17D2\u179F\u178F\u17D2\u1790\u1796\u17D2\u179A\u17B9\u1780\u17D2\u179F"},{"id":16333,"word":"\u17A2\u179F\u17D2\u179F\u1799\u17BB\u1787"},{"id":16334,"word":"\u17A2\u179F\u17D2\u179F\u17B6 --"},{"id":16335,"word":"\u17A2\u179F\u17D2\u179F\u17B6\u1798\u17B7\u1780"},{"id":16336,"word":"\u17A2\u179F\u17D2\u179F\u17B6\u1798\u17B7\u1780\u17B6"},{"id":16337,"word":"\u17A2\u179F\u17D2\u179F\u17B6\u179F\u17C8"},{"id":16338,"word":"\u17A2\u179F\u17D2\u179F\u17B6\u179F\u1794\u17D2\u1794\u179F\u17D2\u179F\u17B6\u179F\u17C8"},{"id":16339,"word":"\u17A2\u179F\u17D2\u179F\u17BB"},{"id":16340,"word":"\u17A2\u179F\u17D2\u179F\u17BB --"},{"id":16341,"word":"\u17A2\u179F\u17D2\u179F\u17BB\u1787"},{"id":16342,"word":"\u17A2\u179F\u17D2\u179F\u17BB\u178F"},{"id":16343,"word":"\u17A2\u179F\u17D2\u179F\u17BB\u1796\u17B6\u17A0\u17CD"},{"id":16344,"word":"\u17A2\u17A0\u1784\u17D2\u1780\u17B6\u179A"},{"id":16345,"word":"\u17A2\u17A0\u1784\u17D2\u1780\u17B6\u179A\u17B7\u1793"},{"id":16346,"word":"\u17A2\u17A0\u1784\u17D2\u1780\u17B6\u179A\u17B7\u1793\u17B8"},{"id":16347,"word":"\u17A2\u17A0\u17A0\u17C8"},{"id":16348,"word":"\u17A2\u17A0\u17B7"},{"id":16349,"word":"\u17A2\u17A0\u17B7 --"},{"id":16350,"word":"\u17A2\u17A0\u17B7\u1784\u17D2\u179F\u17B6 "},{"id":16351,"word":"\u17A2\u17A0\u17B7\u178F"},{"id":16352,"word":"\u17A2\u17A0\u17B7\u178F --"},{"id":16353,"word":"\u17A2\u17A0\u17B7\u1798"},{"id":16354,"word":"\u17A2\u17A0\u17B7\u1798 --"},{"id":16355,"word":"\u17A2\u17A0\u17B7\u179A\u17B7\u1780"},{"id":16356,"word":"\u17A2\u17A0\u17B7\u179A\u17B7\u1780 --"},{"id":16357,"word":"\u17A2\u17A0\u17C1\u178F\u17BB\u1780"},{"id":16358,"word":"\u17A2\u17A0\u17C1\u178F\u17BB\u1780 --"},{"id":16359,"word":"\u17A2\u17A0\u17C1\u179F\u17B6"},{"id":16360,"word":"\u17A2\u17A0\u17C4"},{"id":16361,"word":"\u17A2\u17A0\u17C4\u179A\u178F\u17D2\u178F"},{"id":16362,"word":"\u17A2\u17A0\u17C4\u179F\u17B7\u1780\u1798\u17D2\u1798"},{"id":16363,"word":"\u17A2\u17A0\u17C6\u1780\u17B6\u179A"},{"id":16364,"word":"\u17A2\u17B6"},{"id":16365,"word":"\u17A2\u17B6 !"},{"id":16366,"word":"\u17A2\u17B6\u17CE !"},{"id":16367,"word":"\u17A2\u17B6\u1780\u17CB"},{"id":16368,"word":"\u17A2\u17B6\u1780\u1784\u17D2\u1781\u17B6"},{"id":16369,"word":"\u17A2\u17B6\u1780\u1794\u17D2\u1794"},{"id":16370,"word":"\u17A2\u17B6\u1780\u179A"},{"id":16371,"word":"\u17A2\u17B6\u1780\u179A --"},{"id":16372,"word":"\u17A2\u17B6\u1780\u17B6\u179A"},{"id":16373,"word":"\u17A2\u17B6\u1780\u17B6\u179A\u179F\u17B6\u17A0\u17B6\u179C"},{"id":16374,"word":"\u17A2\u17B6\u1780\u17B6\u179F"},{"id":16375,"word":"\u17A2\u17B6\u1780\u17B6\u179F --"},{"id":16376,"word":"\u17A2\u17B6\u1780\u17B7\u178E\u17D2\u178E"},{"id":16377,"word":"\u17A2\u17B6\u1780\u17B7\u178E\u17D2\u178E --"},{"id":16378,"word":"\u17A2\u17B6\u1780\u17BB\u179B --"},{"id":16379,"word":"\u17A2\u17B6\u1780\u17BC\u179B"},{"id":16380,"word":"\u17A2\u17B6\u1780\u17C4"},{"id":16381,"word":"\u17A2\u17B6\u1780\u17C4\u178A"},{"id":16382,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u1780\u17CB"},{"id":16383,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u1798"},{"id":16384,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u17B6\u178F"},{"id":16385,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u17B8\u178C"},{"id":16386,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u17C4\u1792"},{"id":16387,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u17C4\u1792\u1793"},{"id":16388,"word":"\u17A2\u17B6\u1780\u17D2\u179A\u17C4\u179F"},{"id":16389,"word":"\u17A2\u17B6\u1781\u17D2\u1799\u17B6"},{"id":16390,"word":"\u17A2\u17B6\u1781\u17D2\u1799\u17B6\u178F"},{"id":16391,"word":"\u17A2\u17B6\u1781\u17D2\u1799\u17B6\u1793"},{"id":16392,"word":"\u17A2\u17B6\u1782\u178F\u178A\u17D2\u178B\u17B6\u1793"},{"id":16393,"word":"\u17A2\u17B6\u1782\u178F\u179F\u1789\u17D2\u1789\u17B6"},{"id":16394,"word":"\u17A2\u17B6\u1782\u1793\u17D2\u178F\u17BB"},{"id":16395,"word":"\u17A2\u17B6\u1782\u1793\u17D2\u178F\u17BB\u1780"},{"id":16396,"word":"\u17A2\u17B6\u1782\u1793\u17D2\u178F\u17BB\u1780 --"},{"id":16397,"word":"\u17A2\u17B6\u1782\u1798"},{"id":16398,"word":"\u17A2\u17B6\u1782\u17B6\u179A"},{"id":16399,"word":"\u17A2\u17B6\u1782\u17B6\u179A\u17B7\u1780"},{"id":16400,"word":"\u17A2\u17B6\u1782\u17B6\u179A\u17B7\u1799"},{"id":16401,"word":"\u17A2\u17B6\u1782\u17D2\u1793\u17C1\u1799\u17CD"},{"id":16402,"word":"\u17A2\u17B6\u1783\u17B6\u178F"},{"id":16403,"word":"\u17A2\u17B6\u1783\u17B6\u178F --"},{"id":16404,"word":"\u17A2\u17B6\u1783\u17B6\u178F\u1793\u17C8"},{"id":16405,"word":"\u17A2\u17B6\u1783\u17C4\u179F\u1793"},{"id":16406,"word":"\u17A2\u17B6\u1784"},{"id":16407,"word":"\u17A2\u17B6\u1784\u1781\u17D2\u1793\u17B6\u1784"},{"id":16408,"word":"\u17A2\u17B6\u1785"},{"id":16409,"word":"\u17A2\u17B6\u1785\u1780\u17D2\u178F\u17B8"},{"id":16410,"word":"\u17A2\u17B6\u1785\u1798"},{"id":16411,"word":"\u17A2\u17B6\u1785\u1798\u17CD"},{"id":16412,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1780\u1793\u17D2\u179B\u1784\u17CB"},{"id":16413,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1780\u17BB\u1780"},{"id":16414,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1780\u17D2\u179A\u1785\u1780"},{"id":16415,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1780\u17D2\u179A\u1796\u17BE"},{"id":16416,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1782\u17C4"},{"id":16417,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1785\u17D2\u179A\u1798\u17BB\u17C7"},{"id":16418,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1786\u17D2\u1780\u17C2"},{"id":16419,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1786\u17D2\u1798\u17B6"},{"id":16420,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1786\u17D2\u1796\u17B9\u179F"},{"id":16421,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u178A\u17B8"},{"id":16422,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u178A\u17C2\u1780"},{"id":16423,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u178A\u17C6\u179A\u17B8"},{"id":16424,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u178F\u17D2\u179A\u1785\u17C0\u1780"},{"id":16425,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1792\u17D2\u1798\u17C1\u1789"},{"id":16426,"word":"\u17A2\u17B6\u1785\u1798\u1793"},{"id":16427,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1794\u1793\u17D2\u1791\u17C4\u17C7"},{"id":16428,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1794\u17C6\u178E\u17C7"},{"id":16429,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1795\u17D2\u1780\u17B6\u1799"},{"id":16430,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1795\u17D2\u1785\u17B7\u178F"},{"id":16431,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u1798\u17B6\u1793\u17CB"},{"id":16432,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u179A\u1798\u17B6\u17C6\u1784"},{"id":16433,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u179A\u17BB\u1799"},{"id":16434,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u179B\u17D0\u1780\u17D2\u178F"},{"id":16435,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u179F\u178F\u17D2\u179C"},{"id":16436,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u179F\u17C1\u17C7"},{"id":16437,"word":"\u17A2\u17B6\u1785\u1798\u17CD\u17A2\u178E\u17D2\u178A\u17BE\u1780"},{"id":16438,"word":"\u17A2\u17B6\u1785\u1799"},{"id":16439,"word":"\u17A2\u17B6\u1785\u1799 --"},{"id":16440,"word":"\u17A2\u17B6\u1785\u179A\u17B7\u1799"},{"id":16441,"word":"\u17A2\u17B6\u1785\u179A\u17B7\u1799 --"},{"id":16442,"word":"\u17A2\u17B6\u1785\u17B6\u179A"},{"id":16443,"word":"\u17A2\u17B6\u1785\u17B6\u179A --"},{"id":16444,"word":"\u17A2\u17B6\u1785\u17B6\u179A\u17B6 --"},{"id":16445,"word":"\u17A2\u17B6\u1785\u17B6\u179A\u17B7\u1793\u17B8"},{"id":16446,"word":"\u17A2\u17B6\u1785\u17B6\u179A\u17B8"},{"id":16447,"word":"\u17A2\u17B6\u1785\u17B6\u179A\u17D2\u1799"},{"id":16448,"word":"\u17A2\u17B6\u1785\u17B6\u179A\u17D2\u1799 --"},{"id":16449,"word":"\u17A2\u17B6\u1785\u17B7\u178E\u17D2\u178E"},{"id":16450,"word":"\u17A2\u17B6\u1785\u17B7\u178E\u17D2\u178E --"},{"id":16451,"word":"\u17A2\u17B6\u1787\u17B6\u1793\u17B8\u1799"},{"id":16452,"word":"\u17A2\u17B6\u1787\u17B6\u1793\u17C1\u1799\u17D2\u1799"},{"id":16453,"word":"\u17A2\u17B6\u1787\u17B6\u1793\u17C3\u1799"},{"id":16454,"word":"\u17A2\u17B6\u1787\u17B7"},{"id":16455,"word":"\u17A2\u17B6\u1787\u17B8\u1796 "},{"id":16456,"word":"\u17A2\u17B6\u1787\u17B8\u179C --"},{"id":16457,"word":"\u17A2\u17B6\u1787\u17B8\u179C\u1780"},{"id":16458,"word":"\u17A2\u17B6\u1787\u17B8\u179C\u17B7\u1780\u17B6"},{"id":16459,"word":"\u17A2\u17B6\u1787\u17D2\u1787\u179C\u17C8"},{"id":16460,"word":"\u17A2\u17B6\u1787\u17D2\u1789\u17B6"},{"id":16461,"word":"\u17A2\u17B6\u1787\u17D2\u1789\u17B6 --"},{"id":16462,"word":"\u17A2\u17B6\u178A\u17B6\u1793\u17B6"},{"id":16463,"word":"\u17A2\u17B6\u178C\u1798\u17D2\u1796\u179A"},{"id":16464,"word":"\u17A2\u17B6\u178D\u17D2\u1799\u1785\u179A"},{"id":16465,"word":"\u17A2\u17B6\u178E\u178F\u17D2\u178F\u17B7"},{"id":16466,"word":"\u17A2\u17B6\u178E\u178F\u17D2\u178F\u17B7 --"},{"id":16467,"word":"\u17A2\u17B6\u178E\u17B6"},{"id":16468,"word":"\u17A2\u17B6\u178E\u17B6 --"},{"id":16469,"word":"\u17A2\u17B6\u178E\u17B7\u1780\u1787\u1793"},{"id":16470,"word":"\u17A2\u17B6\u178E\u17B7\u178F"},{"id":16471,"word":"\u17A2\u17B6\u178E\u17C4\u1785"},{"id":16472,"word":"\u17A2\u17B6\u178F\u17CB"},{"id":16473,"word":"\u17A2\u17B6\u178F\u17CB\u178F\u17C2"},{"id":16474,"word":"\u17A2\u17B6\u178F\u17B6\u1794\u17C8"},{"id":16475,"word":"\u17A2\u17B6\u178F\u17B6\u1794\u17B7\u1793\u17B8"},{"id":16476,"word":"\u17A2\u17B6\u178F\u17B6\u1794\u17B8"},{"id":16477,"word":"\u17A2\u17B6\u178F\u17BB\u179A"},{"id":16478,"word":"\u17A2\u17B6\u178F\u17BB\u179A --"},{"id":16479,"word":"\u17A2\u17B6\u178F\u17D2\u1798"},{"id":16480,"word":"\u17A2\u17B6\u178F\u17D2\u1798 --"},{"id":16481,"word":"\u17A2\u17B6\u178F\u17D2\u1798\u17D0\u1793"},{"id":16482,"word":"\u17A2\u17B6\u178F\u17D2\u1798\u17B6"},{"id":16483,"word":"\u17A2\u17B6\u178F\u17D2\u1798\u17B6 --"},{"id":16484,"word":"\u17A2\u17B6\u178F\u17D2\u1798\u17B6\u1792\u17B8\u1793"},{"id":16485,"word":"\u17A2\u17B6\u178F\u17D2\u1798\u17C4\u1794\u1787\u17B8\u179C\u17B7\u1793"},{"id":16486,"word":"\u17A2\u17B6\u178F\u17D2\u1798\u17C4\u1794\u1787\u17B8\u179C\u17B7\u1793\u17B8"},{"id":16487,"word":"\u17A2\u17B6\u1791\u179A"},{"id":16488,"word":"\u17A2\u17B6\u1791\u179A --"},{"id":16489,"word":"\u17A2\u17B6\u1791\u17B6\u17A0\u1793\u179F\u17D2\u1790\u17B6\u1793"},{"id":16490,"word":"\u17A2\u17B6\u1791\u17B7"},{"id":16491,"word":"\u17A2\u17B6\u1791\u17B7 --"},{"id":16492,"word":"\u17A2\u17B6\u1791\u17B7\u1785\u17D2\u1785"},{"id":16493,"word":"\u17A2\u17B6\u1791\u17B7\u178A\u17D2\u178B\u179F\u1796\u17D2\u1791"},{"id":16494,"word":"\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799"},{"id":16495,"word":"\u17A2\u17B6\u1791\u17B8\u1793\u1796 "},{"id":16496,"word":"\u17A2\u17B6\u1791\u17C1\u179F"},{"id":16497,"word":"\u17A2\u17B6\u1791\u17D2\u1799"},{"id":16498,"word":"\u17A2\u17B6\u1791\u17D2\u1799\u17BC\u1793"},{"id":16499,"word":"\u17A2\u17B6\u1792\u17D0\u1798"},{"id":16500,"word":"\u17A2\u17B6\u1792\u1798\u17D2\u1798"},{"id":16501,"word":"\u17A2\u17B6\u1792\u17B6\u179A"},{"id":16502,"word":"\u17A2\u17B6\u1792\u17B7\u1794\u178F\u17C1\u1799\u17D2\u1799"},{"id":16503,"word":"\u17A2\u17B6\u1793"},{"id":16504,"word":"\u17A2\u17B6\u1793"},{"id":16505,"word":"\u17A2\u17B6\u1793\u17CB\u1787\u17D2\u179A\u17B8"},{"id":16506,"word":"\u17A2\u17B6\u1793\u1793\u17D2\u1791"},{"id":16507,"word":"\u17A2\u17B6\u1793\u17B6\u1794\u17B6"},{"id":16508,"word":"\u17A2\u17B6\u1793\u17B6\u1794\u17B6\u178E"},{"id":16509,"word":"\u17A2\u17B6\u1793\u17B6\u1794\u17D2\u179A\u17B6\u178E"},{"id":16510,"word":"\u17A2\u17B6\u1793\u17B6\u17A0\u179A\u17C4\u1782"},{"id":16511,"word":"\u17A2\u17B6\u1793\u17B8\u178F\u1797\u178E\u17D2\u178C"},{"id":16512,"word":"\u17A2\u17B6\u1793\u17B7\u179F\u1784\u17D2\u179F"},{"id":16513,"word":"\u17A2\u17B6\u1793\u17B7\u179F\u1793\u17D2\u1791\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":16514,"word":"\u17A2\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":16515,"word":"\u17A2\u17B6\u1794"},{"id":16516,"word":"\u17A2\u17B6\u1794\u17CB"},{"id":16517,"word":"\u17A2\u17B6\u1794\u17CB --"},{"id":16518,"word":"\u17A2\u17B6\u1794\u17CB\u1785\u17BB\u1793"},{"id":16519,"word":"\u17A2\u17B6\u1794\u178E "},{"id":16520,"word":"\u17A2\u17B6\u1794\u178E --"},{"id":16521,"word":"\u17A2\u17B6\u1794\u178E\u1780"},{"id":16522,"word":"\u17A2\u17B6\u1794\u178E\u17B7\u1780\u17B6"},{"id":16523,"word":"\u17A2\u17B6\u1794\u178F\u17D2\u178F\u17B7"},{"id":16524,"word":"\u17A2\u17B6\u1794\u17D0\u1791"},{"id":16525,"word":"\u17A2\u17B6\u1794\u17CB\u1794\u17C9\u178F\u17D2\u179A\u17B6\u1794\u17CB"},{"id":16526,"word":"\u17A2\u17B6\u1794\u17A1\u17B6\u1794"},{"id":16527,"word":"\u17A2\u17B6\u1794\u17B6\u1793"},{"id":16528,"word":"\u17A2\u17B6\u1794\u17B6\u1799\u17B7\u1780\u179F\u178F\u17D2\u178F"},{"id":16529,"word":"\u17A2\u17B6\u1794\u17BB\u1785\u17D2\u1786\u1793"},{"id":16530,"word":"\u17A2\u17B6\u1794\u17BB\u1785\u17D2\u1786\u1793 --"},{"id":16531,"word":"\u17A2\u17B6\u1794\u17BB\u1785\u17D2\u1786\u17B6"},{"id":16532,"word":"\u17A2\u17B6\u1794\u17C4"},{"id":16533,"word":"\u17A2\u17B6\u1794\u17C4 --"},{"id":16534,"word":"\u17A2\u17B6\u1794\u17C9\u17C4\u1784"},{"id":16535,"word":"\u17A2\u17B6\u1796\u17D0\u1791\u17D2\u1792"},{"id":16536,"word":"\u17A2\u17B6\u1796\u17B6\u1792"},{"id":16537,"word":"\u17A2\u17B6\u1796\u17B6\u1792\u17B7\u1780"},{"id":16538,"word":"\u17A2\u17B6\u1796\u17B6\u1792\u17B7\u1780\u17B6"},{"id":16539,"word":"\u17A2\u17B6\u1796\u17B6\u17A0\u17CD\u1796\u17B7\u1796\u17B6\u17A0\u17CD"},{"id":16540,"word":"\u17A2\u17B6\u1796\u17BB\u1780"},{"id":16541,"word":"\u17A2\u17B6\u1796\u17C0\u179F "},{"id":16542,"word":"\u17A2\u17B6\u1797\u179A\u178E\u17C8"},{"id":16543,"word":"\u17A2\u17B6\u1797\u179F\u17D2\u179F\u179A"},{"id":16544,"word":"\u17A2\u17B6\u1797\u17B6"},{"id":16545,"word":"\u17A2\u17B6\u1797\u17B6\u179F"},{"id":16546,"word":"\u17A2\u17B6\u1797\u17B7\u1792\u1798\u17D2\u1798\u17B7\u1780"},{"id":16547,"word":"\u17A2\u17B6\u1797\u17B7\u1792\u1798\u17D2\u1798\u17B7\u1780\u17B6"},{"id":16548,"word":"\u17A2\u17B6\u1797\u17B7\u179F\u1798\u17B6\u1785\u17B6\u179A\u17B7\u1780"},{"id":16549,"word":"\u17A2\u17B6\u1797\u17B7\u179F\u1798\u17B6\u1785\u17B6\u179A\u17B7\u1780\u17B6"},{"id":16550,"word":"\u17A2\u17B6\u1797\u17C0\u1793"},{"id":16551,"word":"\u17A2\u17B6\u1797\u17C0\u179F"},{"id":16552,"word":"\u17A2\u17B6\u1797\u17C1\u1791"},{"id":16553,"word":"\u17A2\u17B6\u1797\u17C4\u1782\u1785\u17B7\u178F\u17D2\u178F"},{"id":16554,"word":"\u17A2\u17B6\u1798"},{"id":16555,"word":"\u17A2\u17B6\u1798\u1780"},{"id":16556,"word":"\u17A2\u17B6\u1798\u1780 --"},{"id":16557,"word":"\u17A2\u17B6\u1798\u178E\u17B6\u1798"},{"id":16558,"word":"\u17A2\u17B6\u1798\u1793\u17D2\u178F\u1793"},{"id":16559,"word":"\u17A2\u17B6\u1798\u1793\u17D2\u178F\u1793 --"},{"id":16560,"word":"\u17A2\u17B6\u1798\u1799"},{"id":16561,"word":"\u17A2\u17B6\u1798\u179C\u17B6\u178F"},{"id":16562,"word":"\u17A2\u17B6\u1798\u179F\u17BC\u179B"},{"id":16563,"word":"\u17A2\u17B6\u1798\u17B6\u178F\u17B7\u179F\u17B6\u179A"},{"id":16564,"word":"\u17A2\u17B6\u1798\u17B6\u178F\u17D2\u1799"},{"id":16565,"word":"\u17A2\u17B6\u1798\u17C9\u17B6\u179F\u17CB"},{"id":16566,"word":"\u17A2\u17B6\u1798\u17B6\u179F\u1799"},{"id":16567,"word":"\u17A2\u17B6\u1798\u17B6\u179F\u1799\u179A\u17C4\u1782"},{"id":16568,"word":"\u17A2\u17B6\u1798\u17B7\u179F"},{"id":16569,"word":"\u17A2\u17B6\u1798\u17B7\u179F --"},{"id":16570,"word":"\u17A2\u17B6\u1798\u17BB\u1780\u17BB\u179B\u17B7\u178F"},{"id":16571,"word":"\u17A2\u17B6\u1798\u17C1\u178E\u17D2\u178C\u1793"},{"id":16572,"word":"\u17A2\u17B6\u1798\u17C1\u178E\u17D2\u178C\u17B7\u178F"},{"id":16573,"word":"\u17A2\u17B6\u1798\u17C1\u178E\u17D2\u178C\u17B7\u178F--"},{"id":16574,"word":"\u17A2\u17B6\u1798\u17C1\u178E\u17D2\u178C\u17B7\u178F\u179B\u17C1\u1781"},{"id":16575,"word":"\u17A2\u17B6\u1798\u17C9\u17C1\u179A\u17B7\u1780"},{"id":16576,"word":"\u17A2\u17B6\u1798\u17C9\u17C1\u179A\u17B7\u1780\u17D0\u1784"},{"id":16577,"word":"\u17A2\u17B6\u1798\u17C9\u17C1\u179A\u17B7\u1782"},{"id":16578,"word":"\u17A2\u17B6\u1798\u17C4\u1791"},{"id":16579,"word":"\u17A2\u17B6\u1798\u17C4\u1791 --"},{"id":16580,"word":"\u17A2\u17B6\u1799"},{"id":16581,"word":"\u17A2\u17B6\u1799\u17D0\u178F"},{"id":16582,"word":"\u17A2\u17B6\u1799\u178F\u1793\u17C8"},{"id":16583,"word":"\u17A2\u17B6\u1799\u178F\u1793\u17B7\u1794\u17B6\u178F"},{"id":16584,"word":"\u17A2\u17B6\u1799\u179B\u1798\u17D2\u1796\u17B6\u1799"},{"id":16585,"word":"\u17A2\u17B6\u1799\u17B6\u1785\u1793 --"},{"id":16586,"word":"\u17A2\u17B6\u1799\u17B6\u1785\u1793\u17C8"},{"id":16587,"word":"\u17A2\u17B6\u1799\u17C9\u17B6\u178F\u17CB"},{"id":16588,"word":"\u17A2\u17B6\u1799\u17BB"},{"id":16589,"word":"\u17A2\u17B6\u1799\u17BB --"},{"id":16590,"word":"\u17A2\u17B6\u1799\u17BB\u178F\u17D2\u178F\u1780\u17C8"},{"id":16591,"word":"\u17A2\u17B6\u1799\u17BB\u1792"},{"id":16592,"word":"\u17A2\u17B6\u1799\u17BC\u179F"},{"id":16593,"word":"\u17A2\u17B6\u1799\u17C4\u1782"},{"id":16594,"word":"\u17A2\u17B6\u1799\u17C4\u1792\u1793"},{"id":16595,"word":"\u17A2\u17B6\u179A"},{"id":16596,"word":"\u17A2\u17B6\u179A\u1780\u17BC\u178A"},{"id":16597,"word":"\u17A2\u17B6\u179A\u1780\u17D2\u1781"},{"id":16598,"word":"\u17A2\u17B6\u179A\u1780\u17D2\u1781 --"},{"id":16599,"word":"\u17A2\u17B6\u179A\u1780\u17D2\u1781\u17B6"},{"id":16600,"word":"\u17A2\u17B6\u179A\u1780\u17D2\u179F --"},{"id":16601,"word":"\u17A2\u17B6\u179A\u1789\u17D2\u1789"},{"id":16602,"word":"\u17A2\u17B6\u179A\u1789\u17D2\u1789\u1780 --"},{"id":16603,"word":"\u17A2\u17B6\u179A\u178E\u17D2\u1799"},{"id":16604,"word":"\u17A2\u17B6\u179A\u178F\u17B7"},{"id":16605,"word":"\u17A2\u17B6\u179A\u1798\u17D2\u1797"},{"id":16606,"word":"\u17A2\u17B6\u179A\u1798\u17D2\u1797 --"},{"id":16607,"word":"\u17A2\u17B6\u179A\u1798\u17D2\u1798\u178E --"},{"id":16608,"word":"\u17A2\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD"},{"id":16609,"word":"\u17A2\u17B6\u179A\u17B6\u1792\u1780"},{"id":16610,"word":"\u17A2\u17B6\u179A\u17B6\u1792\u1793 --"},{"id":16611,"word":"\u17A2\u17B6\u179A\u17B6\u1792\u1793\u17B6"},{"id":16612,"word":"\u17A2\u17B6\u179A\u17B6\u1798"},{"id":16613,"word":"\u17A2\u17B6\u179A\u17B6\u1798 --"},{"id":16614,"word":"\u17A2\u17B6\u179A\u17B6\u1798\u17B7\u1780"},{"id":16615,"word":"\u17A2\u17B6\u179A\u17B6\u1798\u17B7\u1780\u17B6"},{"id":16616,"word":"\u17A2\u17B6\u179A\u17B6\u179B\u17B7\u1780"},{"id":16617,"word":"\u17A2\u17B6\u179A\u17C9\u17B7\u1785"},{"id":16618,"word":"\u17A2\u17B6\u179A\u17B8\u17A2\u17B6\u179A\u17C9\u1794"},{"id":16619,"word":"\u17A2\u17B6\u179A\u17B9\u179F"},{"id":16620,"word":"\u17A2\u17B6\u179A\u17C9\u17C1\u1785"},{"id":16621,"word":"\u17A2\u17B6\u179A\u17C4\u1782\u17D2\u1799"},{"id":16622,"word":"\u17A2\u17B6\u179A\u17C4\u1785\u1793"},{"id":16623,"word":"\u17A2\u17B6\u179A\u17C4\u1785\u1793-"},{"id":16624,"word":"\u17A2\u17B6\u179A\u17C4\u1791\u1793"},{"id":16625,"word":"\u17A2\u17B6\u179A\u17C4\u1791\u1793-"},{"id":16626,"word":"\u17A2\u17B6\u1783\u17CC"},{"id":16627,"word":"\u17A2\u17B6\u1790\u17CC"},{"id":16628,"word":"\u17A2\u17B6\u179A\u17D2\u1799"},{"id":16629,"word":"\u17A2\u17B6\u179A\u17D2\u1799\u1780"},{"id":16630,"word":"\u17A2\u17B6\u1799\u17CC\u17C1\u1793"},{"id":16631,"word":"\u17A2\u17B6\u179B"},{"id":16632,"word":"\u17A2\u17B6\u179B\u17D0\u1780\u17D2\u1781\u178E\u17CD"},{"id":16633,"word":"\u17A2\u17B6\u179B\u17D0\u1780\u17D2\u179F"},{"id":16634,"word":"\u17A2\u17B6\u179B\u17D0\u1780\u17D2\u179F\u178E\u17CD"},{"id":16635,"word":"\u17A2\u17B6\u179B\u1794\u1793"},{"id":16636,"word":"\u17A2\u17B6\u179B\u1798\u17D2\u1796\u179A"},{"id":16637,"word":"\u17A2\u17B6\u179B\u1798\u17D2\u1796\u17B6\u1799"},{"id":16638,"word":"\u17A2\u17B6\u179B\u1799 --"},{"id":16639,"word":"\u17A2\u17B6\u179B\u17D0\u1799"},{"id":16640,"word":"\u17A2\u17B6\u179B\u17D0\u1799\u178F\u17C2"},{"id":16641,"word":"\u17A2\u17B6\u179B\u17B6\u1794"},{"id":16642,"word":"\u17A2\u17B6\u179B\u17B7\u1784\u17D2\u1782\u1793"},{"id":16643,"word":"\u17A2\u17B6\u179B\u17BB\u179B\u17B7\u1780"},{"id":16644,"word":"\u17A2\u17B6\u179B\u17C4\u1780\u1780\u179F\u17B7\u178E"},{"id":16645,"word":"\u17A2\u17B6\u179C"},{"id":16646,"word":"\u17A2\u17B6\u179C\u1794\u1793"},{"id":16647,"word":"\u17A2\u17B6\u179C\u1794\u1793 --"},{"id":16648,"word":"\u17A2\u17B6\u179C\u179A\u178E"},{"id":16649,"word":"\u17A2\u17B6\u179C\u179A\u178E --"},{"id":16650,"word":"\u17A2\u17B6\u179C\u17B6\u178A"},{"id":16651,"word":"\u17A2\u17B6\u179C\u17B6\u179F"},{"id":16652,"word":"\u17A2\u17B6\u179C\u17B6\u179F\u17B7\u1780"},{"id":16653,"word":"\u17A2\u17B6\u179C\u17B6\u179F\u17B7\u1780 --"},{"id":16654,"word":"\u17A2\u17B6\u179C\u17B6\u179F\u17C2"},{"id":16655,"word":"\u17A2\u17B6\u179C\u17B6\u17A0\u17C8"},{"id":16656,"word":"\u17A2\u17B6\u179C\u17BB\u1792"},{"id":16657,"word":"\u17A2\u17B6\u179C\u17BB\u1792 --"},{"id":16658,"word":"\u17A2\u17B6\u179C\u17BB\u179F\u17C4"},{"id":16659,"word":"\u17A2\u17B6\u179C\u17C9\u17BC\u1780\u17B6\u1785\u17C1\u179A"},{"id":16660,"word":"\u17A2\u17B6\u179C\u17C9\u17BC\u1780\u17B6\u178F\u17CD"},{"id":16661,"word":"\u17A2\u17B6\u179C\u17C1\u179F\u1793\u17C8"},{"id":16662,"word":"\u17A2\u17B6\u179C\u17C1\u179F\u17B7\u1780"},{"id":16663,"word":"\u17A2\u17B6\u179C\u17C1\u179F\u17B7\u1780 --"},{"id":16664,"word":"\u17A2\u17B6\u179F"},{"id":16665,"word":"\u17A2\u17B6\u179F !"},{"id":16666,"word":"\u17A2\u17B6\u179F\u1782\u17D2\u179A\u17B6\u1798"},{"id":16667,"word":"\u17A2\u17B6\u179F\u1784\u17D2\u1780\u17B6"},{"id":16668,"word":"\u17A2\u17B6\u179F\u1793 --"},{"id":16669,"word":"\u17A2\u17B6\u179F\u1793\u17C8"},{"id":16670,"word":"\u17A2\u17B6\u179F\u1793\u17D2\u1791\u17B7"},{"id":16671,"word":"\u17A2\u17B6\u179F\u1793\u17D2\u1793"},{"id":16672,"word":"\u17A2\u17B6\u179F\u1793\u17D2\u1793 --"},{"id":16673,"word":"\u17A2\u17B6\u179F\u1797\u17B7\u179C\u17B6\u1785\u17B6"},{"id":16674,"word":"\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793"},{"id":16675,"word":"\u17A2\u17B6\u179F\u179C"},{"id":16676,"word":"\u17A2\u17B6\u179F\u179C --"},{"id":16677,"word":"\u17A2\u17B6\u179F\u17A2\u17B6\u1797\u17B6\u179F"},{"id":16678,"word":"\u17A2\u17B6\u179F\u17B6"},{"id":16679,"word":"\u17A2\u17B6\u179F\u17B6\u1789\u17CB"},{"id":16680,"word":"\u17A2\u17B6\u179F\u17B6\u178D"},{"id":16681,"word":"\u17A2\u17B6\u179F\u17B6\u178D\u1798\u17B6\u179F"},{"id":16682,"word":"\u17A2\u17B6\u179F\u17B7\u1789\u17D2\u1785\u1793\u1780\u1798\u17D2\u1798"},{"id":16683,"word":"\u17A2\u17B6\u179F\u17B7\u178A\u17D2\u178B"},{"id":16684,"word":"\u17A2\u17B6\u179F\u17B7\u179A\u1796\u17B7\u179F"},{"id":16685,"word":"\u17A2\u17B6\u179F\u17B7\u179A\u17D2\u1796\u17B7\u179F"},{"id":16686,"word":"\u17A2\u17B6\u179F\u17CA\u17B8"},{"id":16687,"word":"\u17A2\u17B6\u179F\u17B8\u1796\u17B7\u179F"},{"id":16688,"word":"\u17A2\u17B6\u179F\u17BC\u179A"},{"id":16689,"word":"\u17A2\u17B6\u179F\u17D2\u1790\u17B6\u1793"},{"id":16690,"word":"\u17A2\u17B6\u179F\u17D2\u1799\u17B6\u1791\u17B7\u1782"},{"id":16691,"word":"\u17A2\u17B6\u179F\u17D2\u179A\u1798"},{"id":16692,"word":"\u17A2\u17B6\u179F\u17D2\u179A\u17D0\u1799"},{"id":16693,"word":"\u17A2\u17B6\u179F\u17D2\u179A\u17B6\u178F"},{"id":16694,"word":"\u17A2\u17B6\u179F\u17D2\u179A\u17BC\u179C"},{"id":16695,"word":"\u17A2\u17B6\u179F\u17D2\u179A\u17BC\u179C --"},{"id":16696,"word":"\u17A2\u17B6\u179F\u17D2\u179C\u17B6\u179F"},{"id":16697,"word":"\u17A2\u17B6\u17A0\u179A\u17D0\u178E"},{"id":16698,"word":"\u17A2\u17B6\u17A0\u17B6\u179A"},{"id":16699,"word":"\u17A2\u17B6\u17A0\u17B6\u179A --"},{"id":16700,"word":"\u17A2\u17B6\u17A0\u17D2\u179C\u17D2\u179A\u17B7\u1780"},{"id":16701,"word":"\u17A2\u17B6\u17A0\u17D2\u179C\u17D2\u179A\u17B7\u1780\u17D0\u1784"},{"id":16702,"word":"\u17A2\u17B6\u17A0\u17D2\u179C\u17D2\u179A\u17B7\u1782"},{"id":16703,"word":"\u17A2\u17B6\u17A1\u17B6\u179A\u17B7\u1780"},{"id":16704,"word":"\u17A2\u17B6\u17A1\u17B6\u179A\u17B7\u1780\u17B6"},{"id":16705,"word":"\u17A2\u17B6\u17A1\u17B6\u17A0\u178E\u178A\u17D2\u178B\u17B6\u1793"},{"id":16706,"word":"\u17A2\u17B6\u17A1\u17C4\u17C7"},{"id":16707,"word":"\u17A2\u17B6\u17A1\u17D2\u17A0\u1780"},{"id":16708,"word":"\u17A2\u17B6\u17C7 !"},{"id":16709,"word":"\u17A2\u17CA\u200C\u17B7\u1780\u17A2\u17CA\u17B6\u1780\u17CB"},{"id":16710,"word":"\u17A5\u1780\u17D2\u179F\u17D2\u179C\u17B6\u1780\u17BB"},{"id":16711,"word":"\u17A5\u1785\u17D2\u1786\u17B6"},{"id":16712,"word":"\u17A5\u1785\u17D2\u1786\u17B6 --"},{"id":16713,"word":"\u17A5\u178A\u17D2\u178B"},{"id":16714,"word":"\u17A5\u178A\u17D2\u178B --"},{"id":16715,"word":"\u17A5\u178A\u17D2\u178B\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD"},{"id":16716,"word":"\u17A5\u178E"},{"id":16717,"word":"\u17A5\u178E --"},{"id":16718,"word":"\u17A5\u178E\u17D2\u178C\u17B6"},{"id":16719,"word":"\u17A5\u178E\u17D2\u178C\u17BB\u179F"},{"id":16720,"word":"\u17A5\u178E\u17D2\u178C\u17BC"},{"id":16721,"word":"\u17A5\u178E\u17D2\u178C\u17BC\u1785\u17B7\u1793"},{"id":16722,"word":"\u17A5\u178E\u17D2\u178C\u17BC\u179F\u17CA\u17B8\u1793"},{"id":16723,"word":"\u17A5\u178E\u17D2\u178C\u17C0"},{"id":16724,"word":"\u17A5\u178F"},{"id":16725,"word":"\u17A5\u178F --"},{"id":16726,"word":"\u17A5\u178F\u17B7\u179C\u17BB\u178F\u17D2\u178F\u1780"},{"id":16727,"word":"\u17A5\u178F\u17B7\u17A0\u17B6\u179F"},{"id":16728,"word":"\u17A5\u178F\u17D2\u1790\u17B6\u1782\u17B6\u179A"},{"id":16729,"word":"\u17A5\u178F\u17D2\u1790\u17B8"},{"id":16730,"word":"\u17A5\u178F\u17D2\u1790\u17B8 --"},{"id":16731,"word":"\u17A5\u1791\u17D2\u1792\u17B6\u1793\u17BB\u1797\u17B6\u1796"},{"id":16732,"word":"\u17A5\u1791\u17D2\u1792\u17B7"},{"id":16733,"word":"\u17A5\u1791\u17D2\u1792\u17B7 --"},{"id":16734,"word":"\u17A5\u1791\u17D2\u1792\u17B7\u1794\u17B6\u1791"},{"id":16735,"word":"\u17A5\u1792\u179B\u17C4\u1780"},{"id":16736,"word":"\u17A5\u1793\u17D2\u1791"},{"id":16737,"word":"\u17A5\u1793\u17D2\u1791 --"},{"id":16738,"word":"\u17A5\u1793\u17D2\u1791\u1785\u17B6\u1794"},{"id":16739,"word":"\u17A5\u1793\u17D2\u1791\u1787\u17B7\u178F"},{"id":16740,"word":"\u17A5\u1793\u17D2\u1791\u1792\u1793\u17BC"},{"id":16741,"word":"\u17A5\u1793\u17D2\u1791\u1793\u17B7\u179B"},{"id":16742,"word":"\u17A5\u1793\u17D2\u1791\u1793\u17C1\u179B"},{"id":16743,"word":"\u17A5\u1793\u17D2\u1791\u1794\u178F\u17D2\u178F"},{"id":16744,"word":"\u17A5\u1793\u17D2\u1791\u179B\u17B6\u17C6"},{"id":16745,"word":"\u17A5\u1793\u17D2\u1791\u179C\u1784\u17D2\u179F"},{"id":16746,"word":"\u17A5\u1793\u17D2\u1791\u179C\u1787\u17B7\u179A\u1785\u17D2\u1786\u1793\u17D2\u1791"},{"id":16747,"word":"\u17A5\u1793\u17D2\u1791\u17B6\u179C\u17BB\u1792"},{"id":16748,"word":"\u17A5\u1793\u17D2\u1791\u17BB"},{"id":16749,"word":"\u17A5\u1793\u17D2\u1791\u17D2\u179A"},{"id":16750,"word":"\u17A5\u1793\u17D2\u1791\u17D2\u179A\u1780\u17B8\u179B"},{"id":16751,"word":"\u17A5\u1793\u17D2\u1791\u17D2\u179A\u1787\u17B7\u178F"},{"id":16752,"word":"\u17A5\u1793\u17D2\u1791\u17D2\u179A\u17B6"},{"id":16753,"word":"\u17A5\u1793\u17D2\u1791\u17D2\u179A\u17B7\u1799"},{"id":16754,"word":"\u17A5\u1793\u17D2\u179A\u17D2\u1791\u17B7\u1799 --"},{"id":16755,"word":"\u17A5\u1793\u17D2\u179A\u17D2\u1791\u17B8"},{"id":16756,"word":"\u17A5\u1793\u17D2\u1792\u1793\u17C8"},{"id":16757,"word":"\u17A2\u17B7\u1798\u17A2\u17C0\u1798"},{"id":16758,"word":"\u17A5\u179A\u17B6"},{"id":16759,"word":"\u17A5\u179A\u17B7\u1799\u17B6"},{"id":16760,"word":"\u17A5\u179A\u17B7\u1799\u17B6\u1794\u1790"},{"id":16761,"word":"\u17A5\u179A\u17B7\u1799\u17B6\u1794\u1790 --"},{"id":16762,"word":"\u17A5\u179A\u17BB\u179C\u17C1\u1791"},{"id":16763,"word":"\u17A5\u179B\u17BC\u179C"},{"id":16764,"word":"\u17A5\u179F"},{"id":16765,"word":"\u17A5\u179F\u17B7"},{"id":16766,"word":"\u17A5\u179F\u17B7 --"},{"id":16767,"word":"\u17A5\u179F\u17B7\u1793\u17D2\u1792\u179A"},{"id":16768,"word":"\u17A5\u179F\u17B8"},{"id":16769,"word":"\u17A5\u179F\u17B8\u1794\u17D2\u179B\u17C2\u1784\u179F\u17B6\u179A"},{"id":16770,"word":"\u17A5\u179F\u17B8\u1795\u17D2\u179F\u17C6\u179F\u17D2\u179A\u17C1\u1785"},{"id":16771,"word":"\u17A5\u179F\u17B8\u1797\u1791\u17D2\u1791 "},{"id":16772,"word":"\u17A5\u179F\u17B8\u1797\u17C1\u179F\u1787\u17D2\u1787"},{"id":16773,"word":"\u17A5\u179F\u17BB\u1780\u17B6\u179A"},{"id":16774,"word":"\u17A5\u179F\u17BC\u179A"},{"id":16775,"word":"\u17A5\u179F\u17D2\u179F\u179A"},{"id":16776,"word":"\u17A5\u179F\u17D2\u179F\u179A --"},{"id":16777,"word":"\u17A5\u179F\u17D2\u179F\u179A\u17B7\u1799"},{"id":16778,"word":"\u17A5\u179F\u17D2\u179F\u179A\u17B7\u1799-"},{"id":16779,"word":"\u17A5\u179F\u17D2\u179F\u17B6"},{"id":16780,"word":"\u17A5\u17A1\u17B6"},{"id":16781,"word":"\u17A5\u17A1\u17BC\u179C"},{"id":16782,"word":"\u17A2\u17CA\u200C\u17B7\u17C7\u17A2\u17CA\u17BB\u17C7"},{"id":16783,"word":"\u17A2\u17B8 ?"},{"id":16784,"word":"\u17A2\u17CA\u200C\u17B8 !"},{"id":16785,"word":"\u17A2\u17CA\u200C\u17B8\u1780\u17A2\u17CA\u17B6\u1780"},{"id":16786,"word":"\u17A2\u17CA\u200C\u17B8\u1785\u17B9\u1784"},{"id":16787,"word":"\u17A2\u17CA\u200C\u17B8\u1785\u17BB\u1784"},{"id":16788,"word":"\u17A2\u17CA\u200C\u17B8\u1785\u17BB\u17C7"},{"id":16789,"word":"\u17A2\u17CA\u200C\u17B8\u1785\u17C1\u17C7"},{"id":16790,"word":"\u17A2\u17CA\u200C\u17B8\u178F\u17BE"},{"id":16791,"word":"\u17A2\u17CA\u200C\u17B8\u1790\u17B6"},{"id":16792,"word":"\u17A2\u17B8\u179C\u17C9\u17B6\u1793\u17CB"},{"id":16793,"word":"\u17A2\u17B8\u179C\u17C9\u17C2"},{"id":16794,"word":"\u17A6\u179F"},{"id":16795,"word":"\u17A6\u179F\u1792\u179A"},{"id":16796,"word":"\u17A6\u179F\u17B6\u1793"},{"id":16797,"word":"\u17A6\u179F\u17BC\u179A"},{"id":16798,"word":"\u17A6\u179F\u17D2\u179C\u179A\u17C8"},{"id":16799,"word":"\u17A2\u17CA\u200C\u17B9\u1780\u1792\u17B9\u1780"},{"id":16800,"word":"\u17A2\u17B9\u1784"},{"id":16801,"word":"\u17A2\u17B9\u1784\u1780\u1784"},{"id":16802,"word":"\u17A2\u17B9\u1798\u17A2\u17C0\u1798"},{"id":16803,"word":"\u17A2\u17CA\u200C\u17B7\u1798"},{"id":16804,"word":"\u17A2\u17CA\u200C\u17B9\u1798"},{"id":16805,"word":"\u17A2\u17CA\u200C\u17B9\u17C7"},{"id":16806,"word":"\u17A2\u17CA\u200C\u17B9\u17C7\u17A2\u17CA\u17C7"},{"id":16807,"word":"\u17A2\u17BA"},{"id":16808,"word":"\u17A2\u17BA\u1784\u1780\u1784"},{"id":16809,"word":"\u17A2\u17BA\u1784\u17A2\u17B6\u1794\u17CB"},{"id":16810,"word":"\u17A2\u17BA\u178F"},{"id":16811,"word":"\u17A2\u17CA\u200C\u17BA\u178F"},{"id":16812,"word":"\u17A2\u17BA\u1794\u17A1\u17BA\u1794"},{"id":16813,"word":"\u17A2\u17BA\u1799"},{"id":16814,"word":"\u17A2\u17BA\u17CE\u1799"},{"id":16815,"word":"\u17A2\u17BA\u179A\u17C9\u17BB\u1794"},{"id":16816,"word":"\u17A2\u17BA\u179A\u17C9\u17BC\u1794\u17D2\u1799\u17B6\u17C6\u1784"},{"id":16817,"word":"\u17A2\u17BA\u17A2\u17B9\u1784"},{"id":16818,"word":"\u17A2\u17BA\u17C7 !"},{"id":16819,"word":"\u17A2\u17BA\u17CE\u17C7 !"},{"id":16820,"word":"\u17A2\u17CA\u200C\u17BA\u17C7 !"},{"id":16821,"word":"\u17A7\u1780"},{"id":16822,"word":"\u17A2\u17BB\u17CE\u1780"},{"id":16823,"word":"\u17A7\u1780\u1789\u17C9\u17B6"},{"id":16824,"word":"\u17A7\u1780\u17A0\u17D2\u179B\u17BD\u1784"},{"id":16825,"word":"\u17A2\u17BB\u1780\u17A1\u17BB\u1780"},{"id":16826,"word":"\u17A7\u1780\u17B6\u179F ! "},{"id":16827,"word":"\u17A7\u1780\u17D2\u1780\u178A\u17D2\u178B"},{"id":16828,"word":"\u17A7\u1780\u17D2\u1780\u178A\u17D2\u178B --"},{"id":16829,"word":"\u17A7\u1780\u17D2\u1780\u178A\u17D2\u178B\u17B7\u179F\u1796\u17D2\u1791"},{"id":16830,"word":"\u17A7\u1780\u17D2\u1780\u17B6\u1794\u17B6\u178F"},{"id":16831,"word":"\u17A7\u1780\u17D2\u179A\u17B7\u178A\u17D2\u178B"},{"id":16832,"word":"\u17A7\u1782\u17D2\u1782\u17A0\u1793\u17B7\u1798\u17B7\u178F\u17D2\u178F"},{"id":16833,"word":"\u17A7\u1782\u17D2\u1783\u17C4\u179F\u1793\u17B6"},{"id":16834,"word":"\u17A2\u17BB\u1784"},{"id":16835,"word":"\u17A2\u17BB\u1784\u1794\u17C9\u17B6\u1784"},{"id":16836,"word":"\u17A2\u17BB\u1784\u1798\u17C9\u17BB\u1784\u17D2\u1782"},{"id":16837,"word":"\u17A2\u17BB\u1784\u17A1\u17BC"},{"id":16838,"word":"\u17A2\u17CA\u17BB\u1784\u17C9\u17B6\u17D7"},{"id":16839,"word":"\u17A2\u17BB\u1785"},{"id":16840,"word":"\u17A2\u17BB\u1785\u17D7"},{"id":16841,"word":"\u17A2\u17BB\u1785\u17A2\u17B6\u179B"},{"id":16842,"word":"\u17A7\u1785\u17D2\u1785"},{"id":16843,"word":"\u17A7\u1785\u17D2\u1785 --"},{"id":16844,"word":"\u17A7\u1785\u17D2\u1785\u17B6\u179A"},{"id":16845,"word":"\u17A7\u1785\u17D2\u1785\u17B6\u179A --"},{"id":16846,"word":"\u17A7\u1785\u17D2\u1785\u17B7\u1793\u1780\u1798\u17D2\u1798"},{"id":16847,"word":"\u17A7\u1785\u17D2\u1786\u17C1\u1791"},{"id":16848,"word":"\u17A7\u1785\u17D2\u1786\u17C1\u1791 --"},{"id":16849,"word":"\u17A2\u17BB\u1787"},{"id":16850,"word":"\u17A2\u17BB\u1787\u17D7 "},{"id":16851,"word":"\u17A2\u17BB\u1787\u17A2\u17B6\u179B"},{"id":16852,"word":"\u17A7\u1787\u17BB"},{"id":16853,"word":"\u17A7\u1787\u17BB --"},{"id":16854,"word":"\u17A7\u1787\u17D2\u1788\u17B6\u1793"},{"id":16855,"word":"\u17A7\u1787\u17D2\u1788\u17B6\u1793 --"},{"id":16856,"word":"\u17A2\u17BB\u1789 !"},{"id":16857,"word":"\u17A7\u178A\u17BB\u1784\u17D2\u1782"},{"id":16858,"word":"\u17A7\u178A\u17D2\u178B\u17B6\u1793"},{"id":16859,"word":"\u17A7\u178A\u17D2\u178B\u17B6\u1793 --"},{"id":16860,"word":"\u17A7\u178E\u17D2\u178E\u17B6"},{"id":16861,"word":"\u17A7\u178E\u17D2\u178E\u17B6 --"},{"id":16862,"word":"\u17A7\u178E\u17D2\u17A0"},{"id":16863,"word":"\u17A7\u178E\u17D2\u17A0 --"},{"id":16864,"word":"\u17A7\u178E\u17D2\u17A0\u17B8\u179F"},{"id":16865,"word":"\u17A2\u17BB\u178F"},{"id":16866,"word":"\u17A2\u17CA\u17BB\u178F"},{"id":16867,"word":"\u17A7\u178F\u17BB"},{"id":16868,"word":"\u17A7\u178F\u17BB --"},{"id":16869,"word":"\u17A7\u178F\u17D2\u178A\u1798"},{"id":16870,"word":"\u17A7\u178F\u17D2\u178A\u1798 --"},{"id":16871,"word":"\u17A7\u178F\u17D2\u178A\u179A"},{"id":16872,"word":"\u17A7\u178F\u17D2\u178A\u179A --"},{"id":16873,"word":"\u17A7\u178F\u17D2\u178A\u179A\u1791\u17B7\u179F"},{"id":16874,"word":"\u17A7\u178F\u17D2\u178A\u179A\u1798\u17B6\u1793\u1787\u17D0\u1799"},{"id":16875,"word":"\u17A7\u178F\u17D2\u178F\u179A\u17B6\u1793\u17BB\u1791\u17B7\u179F"},{"id":16876,"word":"\u17A7\u178F\u17D2\u178F\u179A\u17B7"},{"id":16877,"word":"\u17A7\u178F\u17D2\u178F\u179A\u17B7 --"},{"id":16878,"word":"\u17A7\u178F\u17D2\u178F\u179B"},{"id":16879,"word":"\u17A7\u178F\u17D2\u178F\u17B6\u1793"},{"id":16880,"word":"\u17A7\u178F\u17D2\u178F\u17B6\u1793 --"},{"id":16881,"word":"\u17A7\u178F\u17D2\u178F\u17B6\u179F"},{"id":16882,"word":"\u17A7\u178F\u17D2\u178F\u17B6\u179F --"},{"id":16883,"word":"\u17A7\u178F\u17D2\u178A\u17BB\u1784\u17D2\u1782"},{"id":16884,"word":"\u17A7\u178F\u17D2\u1794\u179B"},{"id":16885,"word":"\u17A7\u178F\u17D2\u1794\u179B --"},{"id":16886,"word":"\u17A7\u178F\u17D2\u1794\u17B6\u178F"},{"id":16887,"word":"\u17A7\u178F\u17D2\u179A\u17B6\u179F\u17C8"},{"id":16888,"word":"\u17A7\u178F\u17D2\u179F\u17B6\u17A0\u17C8"},{"id":16889,"word":"\u17A7\u1791\u1780"},{"id":16890,"word":"\u17A7\u1791\u1780 --"},{"id":16891,"word":"\u17A7\u1791\u1799"},{"id":16892,"word":"\u17A7\u1791\u1799 --"},{"id":16893,"word":"\u17A7\u1791\u179A"},{"id":16894,"word":"\u17A7\u1791\u179A --"},{"id":16895,"word":"\u17A7\u1791\u179A\u17B7\u1799\u17C8"},{"id":16896,"word":"\u17A7\u1791\u17B6\u1793"},{"id":16897,"word":"\u17A7\u1791\u17B6\u1793 --"},{"id":16898,"word":"\u17A7\u1791\u17B6\u17A0\u179A\u178E--"},{"id":16899,"word":"\u17A7\u1791\u17B6\u17A0\u179A\u178E\u17CD"},{"id":16900,"word":"\u17A7\u1791\u17BB\u1798\u17D2\u1796\u179A"},{"id":16901,"word":"\u17A7\u1791\u17C1\u1793"},{"id":16902,"word":"\u17A7\u1791\u17D2\u1791\u17B6\u1793"},{"id":16903,"word":"\u17A7\u1791\u17D2\u1791\u17B6\u1798"},{"id":16904,"word":"\u17A7\u1791\u17D2\u1791\u17B7\u1793"},{"id":16905,"word":"\u17A7\u1791\u17D2\u1791\u17B7\u179F"},{"id":16906,"word":"\u17A7\u1791\u17D2\u1791\u17C1\u179F"},{"id":16907,"word":"\u17A7\u1791\u17D2\u1791\u17C1\u179F --"},{"id":16908,"word":"\u17A7\u1791\u17D2\u1791\u17C1\u179F\u1780"},{"id":16909,"word":"\u17A7\u1791\u17D2\u1791\u17C1\u179F\u17B6 --"},{"id":16910,"word":"\u17A7\u1791\u17D2\u1791\u17C1\u179F\u17B7\u1780\u17B6"},{"id":16911,"word":"\u17A7\u1791\u17D2\u1791\u17C4\u179F\u17B7\u178F"},{"id":16912,"word":"\u17A7\u1791\u17D2\u1792\u1785\u17D2\u1785 "},{"id":16913,"word":"\u17A7\u1791\u17D2\u1792\u1785\u17D2\u1785 --"},{"id":16914,"word":"\u17A7\u1791\u17D2\u1792\u1791\u17C1\u17A0\u17B7\u1780"},{"id":16915,"word":"\u17A7\u1791\u17D2\u1792\u179A\u178E\u17CD"},{"id":16916,"word":"\u17A7\u1791\u17D2\u1799\u17B6\u1793"},{"id":16917,"word":"\u17A7\u1791\u17D2\u1799\u17C4\u1782"},{"id":16918,"word":"\u17A7\u1793\u17D2\u1798\u17B6\u1782\u17CC\u17B6"},{"id":16919,"word":"\u17A7\u1794\u1780\u179A\u178E\u17CD"},{"id":16920,"word":"\u17A7\u1794\u1780\u17B6\u179A"},{"id":16921,"word":"\u17A7\u1794\u1780\u17B6\u179A --"},{"id":16922,"word":"\u17A7\u1794\u1780\u17B6\u179A\u17B7\u178E\u17B8"},{"id":16923,"word":"\u17A7\u1794\u1780\u17B6\u179A\u17B8"},{"id":16924,"word":"\u17A7\u1794\u1780\u17B7\u1785\u17D2\u1785"},{"id":16925,"word":"\u17A7\u1794\u1780\u17D2\u1780\u17B7\u179B\u17C1\u179F"},{"id":16926,"word":"\u17A7\u1794\u1780\u17D2\u179A\u1798"},{"id":16927,"word":"\u17A7\u1794\u1780\u17D2\u179A\u17B9\u178F\u17D2\u1799"},{"id":16928,"word":"\u17A7\u1794\u1780\u17D2\u179A\u17C4\u179F"},{"id":16929,"word":"\u17A7\u1794\u1783\u17B6\u178F"},{"id":16930,"word":"\u17A7\u1794\u1783\u17B6\u178F\u1780"},{"id":16931,"word":"\u17A7\u1794\u1783\u17B6\u178F\u17B7\u1780\u17B6"},{"id":16932,"word":"\u17A7\u1794\u1785\u17B6\u179A"},{"id":16933,"word":"\u17A7\u1794\u1785\u17B6\u179A --"},{"id":16934,"word":"\u17A7\u1794\u1785\u17D2\u1786\u17C1\u1791"},{"id":16935,"word":"\u17A7\u1794\u1785\u17D2\u1786\u17C1\u1791\u1780"},{"id":16936,"word":"\u17A7\u1794\u1785\u17D2\u1786\u17C1\u1791\u1780 --"},{"id":16937,"word":"\u17A2\u17BB\u1794\u1786\u17BA\u1799"},{"id":16938,"word":"\u17A7\u1794\u1787\u17B6\u178F\u17B7\u1785\u17D2\u1786\u1793\u17D2\u1791"},{"id":16939,"word":"\u17A7\u1794\u1787\u17B8\u179C\u17B7\u1780"},{"id":16940,"word":"\u17A7\u1794\u1787\u17B8\u179C\u17B7\u1780\u17B6"},{"id":16941,"word":"\u17A7\u1794\u1787\u17B8\u179C\u17B7\u1793"},{"id":16942,"word":"\u17A7\u1794\u1787\u17B8\u179C\u17B7\u1793\u17B8"},{"id":16943,"word":"\u17A7\u1794\u1787\u17D2\u1788\u17B6"},{"id":16944,"word":"\u17A7\u1794\u1789\u17D2\u1789\u17B6\u179F\u1780\u1790\u17B6"},{"id":16945,"word":"\u17A7\u1794\u178A\u17D2\u178B\u17B6\u1780"},{"id":16946,"word":"\u17A7\u1794\u178A\u17D2\u178B\u17B6\u1793"},{"id":16947,"word":"\u17A7\u1794\u178A\u17D2\u178B\u17B6\u1799\u17B7\u1780\u17B6"},{"id":16948,"word":"\u17A7\u1794\u178C\u17D2\u178D"},{"id":16949,"word":"\u17A7\u1794\u178C\u17D2\u178D --"},{"id":16950,"word":"\u17A7\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797"},{"id":16951,"word":"\u17A7\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u1780"},{"id":16952,"word":"\u17A7\u1794\u178F\u17D2\u1790\u1798\u17D2\u1797\u1780 --"},{"id":16953,"word":"\u17A7\u1794\u1791\u17B7\u179F"},{"id":16954,"word":"\u17A7\u1794\u1791\u17C1\u179F"},{"id":16955,"word":"\u17A7\u1794\u1791\u17D2\u1791\u179C"},{"id":16956,"word":"\u17A7\u1794\u1791\u17D2\u1791\u179C --"},{"id":16957,"word":"\u17A7\u1794\u1791\u17D2\u179A\u1796"},{"id":16958,"word":"\u17A7\u1794\u1791\u17D2\u179C\u17B8\u1794"},{"id":16959,"word":"\u17A7\u1794\u1792\u17B7"},{"id":16960,"word":"\u17A7\u1794\u1792\u17B7 --"},{"id":16961,"word":"\u17A7\u1794\u1792\u17B7\u1780"},{"id":16962,"word":"\u17A7\u1794\u1792\u17B7\u1780\u17B6"},{"id":16963,"word":"\u17A7\u1794\u1793\u17B6\u1799\u1780"},{"id":16964,"word":"\u17A7\u1794\u1793\u17B6\u1799\u17B7\u1780\u17B6"},{"id":16965,"word":"\u17A7\u1794\u1793\u17B6\u17A0\u17C8"},{"id":16966,"word":"\u17A7\u1794\u1793\u17B7\u1792\u17B7"},{"id":16967,"word":"\u17A7\u1794\u1793\u17B7\u1798\u1793\u17D2\u178F\u1793\u17CD"},{"id":16968,"word":"\u17A7\u1794\u1793\u17B7\u179F\u17D0\u1791"},{"id":16969,"word":"\u17A7\u1794\u1793\u17B7\u179F\u17D2\u179F\u1799 --"},{"id":16970,"word":"\u17A7\u1794\u1793\u17B7\u179F\u17D2\u179F\u17D0\u1799"},{"id":16971,"word":"\u17A7\u1794\u1793\u17D2\u1799\u17B6\u179F\u1780\u1790\u17B6"},{"id":16972,"word":"\u17A7\u1794\u1794\u17B6\u178F\u17B7\u1780"},{"id":16973,"word":"\u17A7\u1794\u1794\u17B8\u17A1\u1780\u1780\u1798\u17D2\u1798"},{"id":16974,"word":"\u17A7\u1794\u1797\u17C4\u1782"},{"id":16975,"word":"\u17A7\u1794\u1798\u17B6"},{"id":16976,"word":"\u17A7\u1794\u1798\u17B6\u178F\u17B6"},{"id":16977,"word":"\u17A7\u1794\u1798\u17B6\u1793"},{"id":16978,"word":"\u17A7\u1794\u1798\u17C1\u1799\u17D2\u1799"},{"id":16979,"word":"\u17A7\u1794\u1798\u17C3\u1799"},{"id":16980,"word":"\u17A7\u1794\u1799\u1798\u1798\u1784\u17D2\u1782\u179B"},{"id":16981,"word":"\u17A7\u1794\u1799\u17BB\u179C\u179A\u17B6\u1787"},{"id":16982,"word":"\u17A7\u1794\u1799\u17C4\u1782"},{"id":16983,"word":"\u17A7\u1794\u1799\u17C5\u179C\u179A\u17B6\u1787"},{"id":16984,"word":"\u17A7\u1794\u179A\u17B6\u1787"},{"id":16985,"word":"\u17A7\u1794\u179A\u17B6\u1787\u17D2\u1799"},{"id":16986,"word":"\u17A7\u1794\u179A\u17B7\u1798"},{"id":16987,"word":"\u17A7\u1794\u179A\u17B7\u1798 --"},{"id":16988,"word":"\u17A7\u1794\u179A\u17B7\u1798\u1791\u17B7\u179F"},{"id":16989,"word":"\u17A7\u1794\u179A\u17C4\u1792"},{"id":16990,"word":"\u17A7\u1794\u179A\u17C4\u1792 --"},{"id":16991,"word":"\u17A7\u1794\u179B\u1780\u17D2\u1781\u17B7\u178F"},{"id":16992,"word":"\u17A7\u1794\u179B\u1780\u17D2\u1781\u17B7\u178F --"},{"id":16993,"word":"\u17A7\u1794\u179B\u17B7\u1784\u17D2\u1782"},{"id":16994,"word":"\u17A7\u1794\u179B\u17B7\u1784\u17D2\u1782 --"},{"id":16995,"word":"\u17A7\u1794\u179C\u17B6\u1791"},{"id":16996,"word":"\u17A7\u1794\u179C\u17B6\u1791 --"},{"id":16997,"word":"\u17A7\u1794\u179C\u17B6\u1791\u17B7\u1793\u17B8"},{"id":16998,"word":"\u17A7\u1794\u179C\u17B6\u1791\u17B8"},{"id":16999,"word":"\u17A7\u1794\u179C\u17C1\u179F\u1793\u17CD"},{"id":17000,"word":"\u17A7\u1794\u179F\u1782\u17D2\u1782"},{"id":17001,"word":"\u17A7\u1794\u179F\u1782\u17D2\u1782 --"},{"id":17002,"word":"\u17A7\u1794\u179F\u1798\u17D2\u1794\u17D0\u1791"},{"id":17003,"word":"\u17A7\u1794\u179F\u1798\u17D2\u1794\u1791 --"},{"id":17004,"word":"\u17A7\u1794\u179F\u1798\u17D2\u1794\u1793\u17D2\u1793"},{"id":17005,"word":"\u17A7\u1794\u179F\u1798\u17D2\u1794\u1793\u17D2\u1793\u17B6"},{"id":17006,"word":"\u17A7\u1794\u179F\u17C1\u1793\u17B6\u1794\u178F\u17B8"},{"id":17007,"word":"\u17A7\u1794\u179F\u17D2\u179F\u17D0\u1799"},{"id":17008,"word":"\u17A7\u1794\u17A0\u17B6\u179F"},{"id":17009,"word":"\u17A7\u1794\u17A0\u17B6\u179F --"},{"id":17010,"word":"\u17A7\u1794\u17A0\u17C1\u178F\u17BB"},{"id":17011,"word":"\u17A7\u1794\u17B6\u1791\u179C\u17CD"},{"id":17012,"word":"\u17A7\u1794\u17B6\u1791\u17B6\u1793"},{"id":17013,"word":"\u17A7\u1794\u17B6\u1791\u17B6\u1793 --"},{"id":17014,"word":"\u17A7\u1794\u17B6\u1791\u17B7\u1793\u17D2\u1793\u1780"},{"id":17015,"word":"\u17A7\u1794\u17B6\u1791\u17B7\u179F\u17C1\u179F \u1793\u17B7\u1789\u17D2\u179C\u1793"},{"id":17016,"word":"\u17A7\u1794\u17B6\u1792\u17D2\u1799\u17B6\u1799"},{"id":17017,"word":"\u17A7\u1794\u17B6\u1799"},{"id":17018,"word":"\u17A7\u1794\u17B6\u1799\u17B6\u179F"},{"id":17019,"word":"\u17A7\u1794\u17B6\u179F\u1780"},{"id":17020,"word":"\u17A7\u1794\u17B6\u179F\u1780 --"},{"id":17021,"word":"\u17A7\u1794\u17B6\u17A0\u1793"},{"id":17022,"word":"\u17A7\u1794\u17C1\u1780\u17D2\u1781\u17B6"},{"id":17023,"word":"\u17A7\u1794\u17C1\u1793\u17D2\u1791\u179C\u1787\u17B7\u179A\u1785\u17D2\u1786\u1793\u17D2\u1791"},{"id":17024,"word":"\u17A7\u1794\u17C4\u179F\u1790"},{"id":17025,"word":"\u17A7\u1794\u17C4\u179F\u1790 --"},{"id":17026,"word":"\u17A7\u1794\u17C4\u179F\u1790\u17B6\u1782\u17B6\u179A"},{"id":17027,"word":"\u17A7\u1794\u17C4\u179F\u1790\u17B7\u1780"},{"id":17028,"word":"\u17A7\u1794\u17C4\u179F\u1790\u17B7\u1780 --"},{"id":17029,"word":"\u17A7\u1794\u17D2\u1794\u178F\u17D2\u178F\u17B7"},{"id":17030,"word":"\u17A7\u1794\u17D2\u1794\u178F\u17D2\u178F\u17B7 --"},{"id":17031,"word":"\u17A7\u1794\u17D2\u1794\u178F\u17D2\u178F\u17B7\u1780"},{"id":17032,"word":"\u17A7\u1794\u17D2\u1794\u179B"},{"id":17033,"word":"\u17A7\u1794\u17D2\u1794\u17B6\u178F"},{"id":17034,"word":"\u17A7\u1796\u17D2\u179C\u17C1\u1792"},{"id":17035,"word":"\u17A7\u1797\u178F\u17C4"},{"id":17036,"word":"\u17A7\u1797\u178F\u17C4 --"},{"id":17037,"word":"\u17A7\u1797\u1799"},{"id":17038,"word":"\u17A7\u1797\u1799 --"},{"id":17039,"word":"\u17A7\u1797\u1799\u17C4\u179A\u17B6\u1787"},{"id":17040,"word":"\u17A7\u1797\u1799\u17C4\u179A\u17B6\u1787\u17D2\u1799"},{"id":17041,"word":"\u17A7\u1798\u17B6"},{"id":17042,"word":"\u17A7\u1798\u17D2\u1798\u1784\u17D2\u1782"},{"id":17043,"word":"\u17A7\u1798\u17D2\u1798\u178F\u17D2\u178F\u1780"},{"id":17044,"word":"\u17A7\u1798\u17D2\u1798\u178F\u17D2\u178F\u1780\u17C4"},{"id":17045,"word":"\u17A2\u17CA\u17BB\u1799"},{"id":17046,"word":"\u17A7\u1799\u17D2\u1799\u17B6\u1793"},{"id":17047,"word":"\u17A7\u1799\u17D2\u1799\u17B6\u1798\u1797\u17B6\u1796"},{"id":17048,"word":"\u17A7\u1799\u17D2\u1799\u17C4\u1792\u17B7\u1780"},{"id":17049,"word":"\u17A2\u17BB\u179A"},{"id":17050,"word":"\u17A7\u179A\u1782"},{"id":17051,"word":"\u17A7\u179A\u1784\u17D2\u1782"},{"id":17052,"word":"\u17A7\u179A\u1785\u17D2\u1786\u17D0\u1791"},{"id":17053,"word":"\u17A7\u179A\u17B6"},{"id":17054,"word":"\u17A7\u179A\u17BB\u1794\u178F\u17B8"},{"id":17055,"word":"\u17A7\u179A\u17C9\u17C3"},{"id":17056,"word":"\u17A2\u17BB\u179B"},{"id":17057,"word":"\u17A2\u17CA\u17BB\u179B\u17A2\u17B6\u179B\u17CB"},{"id":17058,"word":"\u17A7\u179B\u17D2\u1780\u17B6\u1794\u17B6\u178F"},{"id":17059,"word":"\u17A7\u179B\u17D2\u179B\u1784\u17D2\u1783\u1793 --"},{"id":17060,"word":"\u17A7\u179B\u17D2\u179B\u1784\u17D2\u1783\u1793\u17C8"},{"id":17061,"word":"\u17A7\u179B\u17D2\u179B\u17C4\u1780\u1793\u17C8"},{"id":17062,"word":"\u17A7\u179F"},{"id":17063,"word":"\u17A7\u179F\u1797"},{"id":17064,"word":"\u17A7\u179F\u17B6"},{"id":17065,"word":"\u17A7\u179F\u17BB\u1780\u17B6\u179A"},{"id":17066,"word":"\u17A7\u179F\u17BB\u1798"},{"id":17067,"word":"\u17A7\u179F\u17D2\u179F\u179C --"},{"id":17068,"word":"\u17A7\u179F\u17D2\u179F\u179C\u17C8"},{"id":17069,"word":"\u17A7\u179F\u17D2\u179F\u17B6\u17A0 --"},{"id":17070,"word":"\u17A7\u179F\u17D2\u179F\u17B6\u17A0\u17C8"},{"id":17071,"word":"\u17A2\u17BB\u17A0\u17D2\u179C\u179F\u17B7\u178F"},{"id":17072,"word":"\u17A7\u17A1\u17B6\u179A"},{"id":17073,"word":"\u17A7\u17A1\u17B6\u179A --"},{"id":17074,"word":"\u17A7\u17A1\u17BB\u179A\u17B6\u1787"},{"id":17075,"word":"\u17A2\u17BB\u17C7 !"},{"id":17076,"word":"\u17A2\u17D2\u17A0\u17BB\u17C7 !"},{"id":17077,"word":"\u17AA"},{"id":17078,"word":"\u17AA\u1787\u17C6"},{"id":17079,"word":"\u17AA\u1787\u17D2\u179A\u17B9\u1784"},{"id":17080,"word":"\u17AA\u178E\u17BB\u179B"},{"id":17081,"word":"\u17AA\u1791\u17B9\u1793"},{"id":17082,"word":"\u17AA\u1796\u17BB\u1780"},{"id":17083,"word":"\u17AA\u1798\u17C9\u17B6\u179B\u17CB"},{"id":17084,"word":"\u17AA\u1798\u17C9\u17C3"},{"id":17085,"word":"\u17AA\u17A1"},{"id":17086,"word":"\u17AA\u17A1\u17B9\u1780"},{"id":17087,"word":"\u17AA\u17A1\u17BB\u1784"},{"id":17088,"word":"\u17AA\u17A1\u17C4\u1780"},{"id":17089,"word":"\u17A2\u17BC! "},{"id":17090,"word":"\u17A2\u17CA\u17BC"},{"id":17091,"word":"\u17A9\u1780\u17B6"},{"id":17092,"word":"\u17A2\u17CA\u17BC\u1784"},{"id":17093,"word":"\u17A2\u17CA\u17BC\u1784\u1796\u17D2\u179A\u1793\u17BC\u1784"},{"id":17094,"word":"\u17A2\u17BC\u1784\u17A1\u17BC\u1784"},{"id":17095,"word":"\u17A2\u17CA\u17BC\u1785"},{"id":17096,"word":"\u17A2\u17BC\u1785\u17D7"},{"id":17097,"word":"\u17A2\u17CA\u17BC\u1789"},{"id":17098,"word":"\u17A9\u178A\u17D2\u178B"},{"id":17099,"word":"\u17A2\u17BC\u178F"},{"id":17100,"word":"\u17A2\u17CA\u17BC\u1791\u17D2\u179A\u17BC"},{"id":17101,"word":"\u17A2\u17BC\u1793"},{"id":17102,"word":"\u17A9\u1793"},{"id":17103,"word":"\u17A2\u17CA\u17BC\u1794\u17C9\u1791\u17D2\u179A\u17BC"},{"id":17104,"word":"\u17A9\u1798 !"},{"id":17105,"word":"\u17A2\u17BC\u1799 !"},{"id":17106,"word":"\u17A2\u17CA\u17BC\u1799 !"},{"id":17107,"word":"\u17A2\u17BC\u179A"},{"id":17108,"word":"\u17A9\u179A\u1796\u17D2\u1799"},{"id":17109,"word":"\u17A9\u179A\u17BB"},{"id":17110,"word":"\u17A2\u17BC\u179F"},{"id":17111,"word":"\u17A9\u179F\u179C\u17D0\u178F"},{"id":17112,"word":"\u17A2\u17BC\u179F\u17D2\u178F\u17D2\u179A\u17B6\u179B\u17B8"},{"id":17113,"word":"\u17A2\u17BC\u179F\u17D2\u178F\u17D2\u179A\u17B6\u179B\u17B8\u1799\u17D0\u1784"},{"id":17114,"word":"\u17A2\u17BC\u179F\u17D2\u1799\u17B6\u1793\u17B8"},{"id":17115,"word":"\u17A2\u17BC\u179F\u17D2\u1799\u17B6\u1793\u17B8\u1799\u17D0\u1784"},{"id":17116,"word":"\u17A2\u17BC\u17C7 !"},{"id":17117,"word":"\u17A2\u17CA\u17BC\u17A2\u179A"},{"id":17118,"word":"\u17A2\u17CA\u17BC\u17A2\u17B6"},{"id":17119,"word":"\u17A2\u17CA\u17BC\u17A2\u17CA\u17B6"},{"id":17120,"word":"\u17A2\u17CA\u17BC\u17A2\u17C2"},{"id":17121,"word":"\u17A2\u17BD"},{"id":17122,"word":"\u17A2\u17BD\u178F"},{"id":17123,"word":"\u17A2\u17BD\u1791\u17B8\u1793\u17BD"},{"id":17124,"word":"\u17A2\u17BD\u1793"},{"id":17125,"word":"\u17A2\u17BD\u179B"},{"id":17126,"word":"\u17A2\u17BD\u179F\u17D7"},{"id":17127,"word":"\u17A2\u17BE"},{"id":17128,"word":"\u17A2\u17BE\u178F"},{"id":17129,"word":"\u17A2\u17BE\u178F\u17A2\u17BE\u1798"},{"id":17130,"word":"\u17A2\u17BE\u1794\u17A1\u17BE\u1794"},{"id":17131,"word":"\u17A2\u17BE\u1796\u17BE"},{"id":17132,"word":"\u17A2\u17BE\u1799"},{"id":17133,"word":"\u17A2\u17C0"},{"id":17134,"word":"\u17A2\u17C0\u1784"},{"id":17135,"word":"\u17A2\u17C0\u1793"},{"id":17136,"word":"\u17A2\u17C0\u1793\u1794\u17D2\u179A\u17C0\u1793"},{"id":17137,"word":"\u17A2\u17C0\u1798"},{"id":17138,"word":"\u17A2\u17C0\u179A\u1798\u1798\u17C0\u179A"},{"id":17139,"word":"\u17A2\u17C0\u179C"},{"id":17140,"word":"\u17A2\u17C0\u179C !"},{"id":17141,"word":"\u17A2\u17C1\u1780"},{"id":17142,"word":"\u17A2\u17C1\u1785\u17A2\u17BC\u1785"},{"id":17143,"word":"\u17A2\u17C1\u1794 !"},{"id":17144,"word":"\u17A2\u17C1\u17C8\u17A2\u17BB"},{"id":17145,"word":"\u17A2\u17C1\u17C7"},{"id":17146,"word":"\u17A2\u17C1\u17C7\u17A2\u17BB\u17C7"},{"id":17147,"word":"\u17AF"},{"id":17148,"word":"\u17A2\u17C2"},{"id":17149,"word":"\u17AF\u1780"},{"id":17150,"word":"\u17AF\u1780 --"},{"id":17151,"word":"\u17AF\u1780"},{"id":17152,"word":"\u17AF\u1780\u178F\u17C4"},{"id":17153,"word":"\u17AF\u1780\u179F\u17C1\u179F\u1793\u17D0\u1799"},{"id":17154,"word":"\u17AF\u1780\u17A2\u1782\u17D2\u1782\u179A\u178A\u17D2\u178B\u1791\u17BC\u178F"},{"id":17155,"word":"\u17AF\u1780\u17A7\u1780\u1789\u17C9\u17B6"},{"id":17156,"word":"\u17AF\u1780\u17B6"},{"id":17157,"word":"\u17AF\u1784"},{"id":17158,"word":"\u17A2\u17C2\u1784\u17A2\u17C4\u1784"},{"id":17159,"word":"\u17AF\u178F\u1791\u1782\u17D2\u1782\u17C8"},{"id":17160,"word":"\u17AF\u178F\u1791\u1782\u17D2\u1782 --"},{"id":17161,"word":"\u17AF\u178F\u17BE"},{"id":17162,"word":"\u17AF\u1790\u17B6"},{"id":17163,"word":"\u17A2\u17CA\u17C2\u1793"},{"id":17164,"word":"\u17A2\u17C2\u1793\u17A2\u1793"},{"id":17165,"word":"\u17A2\u17C2\u1794"},{"id":17166,"word":"\u17A2\u17C2\u1798"},{"id":17167,"word":"\u17A2\u17C2\u1798\u1795\u17D2\u179B\u17C2\u1798"},{"id":17168,"word":"\u17AF\u179A\u17B6\u179C\u17D0\u178E"},{"id":17169,"word":"\u17A2\u17C2\u179B\u17A2\u179B"},{"id":17170,"word":"\u17A2\u17CA\u17C2\u179B\u17A2\u17CA\u179B"},{"id":17171,"word":"\u17AF\u179C\u17C6"},{"id":17172,"word":"\u17A2\u17CA\u17C2\u179F\u1798\u1798\u17C2\u179F"},{"id":17173,"word":"\u17A2\u17C2\u17A2\u1784\u17CB"},{"id":17174,"word":"\u17AF. \u17A7."},{"id":17175,"word":"\u17A2\u17C2\u17A2\u17BB\u1780"},{"id":17176,"word":"\u17B0"},{"id":17177,"word":"\u17A2\u17C3"},{"id":17178,"word":"\u17B0 ! "},{"id":17179,"word":"\u17A2\u17C3 --"},{"id":17180,"word":"\u17B0\u1780 --"},{"id":17181,"word":"\u17B0\u178A\u17CF"},{"id":17182,"word":"\u17A2\u17C3\u179A\u17C9\u17B6"},{"id":17183,"word":"\u17B0\u179A\u17B6\u179C\u17D0\u178E"},{"id":17184,"word":"\u17B0\u179A\u17B6\u179C\u17D0\u178F"},{"id":17185,"word":"\u17B0\u179F\u17BC\u179A"},{"id":17186,"word":"\u17A2\u17C3\u179F\u17BC\u179A"},{"id":17187,"word":"\u17B1 !"},{"id":17188,"word":"\u17A2\u17C4\u17CE !"},{"id":17189,"word":"\u17B1\u1780\u17D0\u179F"},{"id":17190,"word":"\u17B1\u1780\u17B6\u1780"},{"id":17191,"word":"\u17B1\u1780\u17B6\u179F"},{"id":17192,"word":"\u17B1\u1780\u17B6\u179F !"},{"id":17193,"word":"\u17B1\u1780\u17B6\u179F --"},{"id":17194,"word":"\u17B1\u1783"},{"id":17195,"word":"\u17B1\u1784\u17A1\u17C4\u1784"},{"id":17196,"word":"\u17B1\u1784\u17D2\u1780\u17B6"},{"id":17197,"word":"\u17B1\u1784\u17D2\u1780\u17B6\u179A"},{"id":17198,"word":"\u17B1\u1785\u17D2\u1785\u17B6\u179F\u1793\u17CD"},{"id":17199,"word":"\u17B1\u1787"},{"id":17200,"word":"\u17B1\u178A\u17D2\u178B\u1787"},{"id":17201,"word":"\u17B1\u178F"},{"id":17202,"word":"\u17B1\u178F\u17D2\u178F\u1794\u17D2\u1794"},{"id":17203,"word":"\u17B1\u1791\u1780"},{"id":17204,"word":"\u17B1\u1791\u17D2\u1799\u17B6\u1793"},{"id":17205,"word":"\u17B1\u1793"},{"id":17206,"word":"\u17B1\u1794"},{"id":17207,"word":"\u17B1\u1794\u1780\u17D2\u1780\u1798\u17B7\u1780\u17B6\u1796\u17B6\u1792"},{"id":17208,"word":"\u17B1\u1794\u1794\u17B6\u178F\u17B7\u1780"},{"id":17209,"word":"\u17B1\u1794\u1798\u17D2\u1798\u179F\u17C6\u179F\u1793\u17D2\u1791\u1793\u17B6"},{"id":17210,"word":"\u17B1\u1797\u17B6\u179F"},{"id":17211,"word":"\u17B1\u1798 !"},{"id":17212,"word":"\u17B1\u1798\u179F\u178F\u17D2\u178F"},{"id":17213,"word":"\u17B1\u17D2\u1799"},{"id":17214,"word":"\u17B1\u179A\u179F"},{"id":17215,"word":"\u17B1\u179A\u17B6"},{"id":17216,"word":"\u17B1\u179A\u17C9\u17BB\u1794"},{"id":17217,"word":"\u17B1\u179A\u17C9\u17C3"},{"id":17218,"word":"\u17B1\u179C\u17B6\u1791"},{"id":17219,"word":"\u17B1\u179C\u17B6\u1791 --"},{"id":17220,"word":"\u17B1\u179F\u1790"},{"id":17221,"word":"\u17B1\u179F\u1792 --"},{"id":17222,"word":"\u17B1\u179F\u17B6\u1793\u179C\u17B6\u1791"},{"id":17223,"word":"\u17B1\u179F\u17B6\u17A0\u17CD"},{"id":17224,"word":"\u17B1\u179F\u17D2\u178B"},{"id":17225,"word":"\u17B1\u179F\u17D2\u179A\u1796"},{"id":17226,"word":"\u17B1\u17A0\u17B6\u178F"},{"id":17227,"word":"\u17B1\u17A1\u17B6\u179A\u17B7\u1780"},{"id":17228,"word":"\u17B1\u17A1\u17B7\u1782\u179B\u17D2\u179B"},{"id":17229,"word":"\u17B1\u17C7 !"},{"id":17230,"word":"\u17B3 !"},{"id":17231,"word":"\u17B3\u1791\u1780"},{"id":17232,"word":"\u17A2\u17BB\u17C6"},{"id":17233,"word":"\u17A2\u17BB\u17C6\u178F\u17D2\u179A\u17BB\u17C6"},{"id":17234,"word":"\u17A2\u17BB\u17C6\u1791\u17BC\u1780"},{"id":17235,"word":"\u17A2\u17CA\u17C6"},{"id":17236,"word":"\u17A2\u17C6\u178E\u178F\u17CB"},{"id":17237,"word":"\u17A2\u17C6\u178E\u179A"},{"id":17238,"word":"\u17A2\u17C6\u178E\u179F\u17CB"},{"id":17239,"word":"\u17A2\u17C6\u178E\u17B6\u1785"},{"id":17240,"word":"\u17A2\u17C6\u178E\u17B9\u17C7"},{"id":17241,"word":"\u17A2\u17C6\u178E\u17C4\u1799"},{"id":17242,"word":"\u17A2\u17C6\u1793\u17BD\u178F"},{"id":17243,"word":"\u17A2\u17C6\u1794\u17B6\u1789\u17CB\u1798\u17B7\u1789"},{"id":17244,"word":"\u17A2\u17C6\u1794\u17B6\u178F"},{"id":17245,"word":"\u17A2\u17C6\u1794\u17B6\u1799"},{"id":17246,"word":"\u17A2\u17C6\u1794\u17B6\u179B"},{"id":17247,"word":"\u17A2\u17C6\u1794\u17B7\u179B"},{"id":17248,"word":"\u17A2\u17C6\u1794\u17B7\u179B\u1798\u17D2\u1791\u17C1\u179F"},{"id":17249,"word":"\u17A2\u17C6\u1794\u17B9\u17C7"},{"id":17250,"word":"\u17A2\u17C6\u1794\u17BB\u1780"},{"id":17251,"word":"\u17A2\u17C6\u1794\u17BC\u1784"},{"id":17252,"word":"\u17A2\u17C6\u1794\u17BC\u179A"},{"id":17253,"word":"\u17A2\u17C6\u1794\u17BE\u17C7"},{"id":17254,"word":"\u17A2\u17C6\u1794\u17C2\u1784"},{"id":17255,"word":"\u17A2\u17C6\u1794\u17C2\u1784\u1785\u17C1\u17C7"},{"id":17256,"word":"\u17A2\u17C6\u1794\u17C2\u1784\u1790\u17D2\u1784\u17C3"},{"id":17257,"word":"\u17A2\u17C6\u1794\u17C4\u179F"},{"id":17258,"word":"\u17A2\u17C6\u1794\u17C4\u17C7"},{"id":17259,"word":"\u17A2\u17C6\u1794\u17C4\u17C7\u1781\u17D2\u1798\u17C4\u1785"},{"id":17260,"word":"\u17A2\u17C6\u1794\u17C4\u17C7\u1796\u17D2\u179A\u17C7"},{"id":17261,"word":"\u17A2\u17C6\u1794\u17C5\u17A2\u17C6\u1794\u17C2\u1780"},{"id":17262,"word":"\u17A2\u17C6\u1794\u17C9\u17BE\u1780"},{"id":17263,"word":"\u17A2\u17C6\u1794\u17C9\u17C1\u17C7\u17A2\u17C6\u1794\u17C9\u17C4\u17C7"},{"id":17264,"word":"\u17A2\u17C6\u1796\u1780"},{"id":17265,"word":"\u17A2\u17C6\u1796\u17D0\u1793\u17D2\u1792"},{"id":17266,"word":"\u17A2\u17C6\u1796\u179B\u17CB"},{"id":17267,"word":"\u17A2\u17C6\u1796\u17B6\u1785"},{"id":17268,"word":"\u17A2\u17C6\u1796\u17B6\u1793\u17CB"},{"id":17269,"word":"\u17A2\u17C6\u1796\u17B6\u179C"},{"id":17270,"word":"\u17A2\u17C6\u1796\u17B6\u179F"},{"id":17271,"word":"\u17A2\u17C6\u1796\u17B7\u179B\u17A2\u17C6\u1796\u17C2\u1780"},{"id":17272,"word":"\u17A2\u17C6\u1796\u17B8"},{"id":17273,"word":"\u17A2\u17C6\u1796\u17BB\u178F"},{"id":17274,"word":"\u17A2\u17C6\u1796\u17BB\u17C7"},{"id":17275,"word":"\u17A2\u17C6\u1796\u17BE"},{"id":17276,"word":"\u17A2\u17C6\u1796\u17C0\u179A"},{"id":17277,"word":"\u17A2\u17C6\u1796\u17C1\u17C7"},{"id":17278,"word":"\u17A2\u17C6\u1796\u17C2"},{"id":17279,"word":"\u17A2\u17C6\u1796\u17C2\u17C7"},{"id":17280,"word":"\u17A2\u17C6\u1796\u17C5"},{"id":17281,"word":"\u17A2\u17C6\u1796\u17C5\u1796\u17D2\u179A\u17C3"},{"id":17282,"word":"\u17A2\u17C6\u1796\u17C7"},{"id":17283,"word":"\u17A2\u17C6\u1796\u17D2\u179A\u17C6"},{"id":17284,"word":"\u17A2\u17C6\u1796\u17D2\u179A\u17C6\u1794\u17D2\u179A\u17C2\u1780\u17D2\u179A\u17C4\u1799"},{"id":17285,"word":"\u17A2\u17C6\u1798\u17B7\u1789"},{"id":17286,"word":"\u17A2\u17C6\u179B\u17BB\u1784"},{"id":17287,"word":"\u17A2\u17C6\u17A1\u17BB\u1784"},{"id":17288,"word":"\u17A2\u17B6\u17C6"},{"id":17289,"word":"\u17A2\u17B6\u17C6\u1784"},{"id":17290,"word":"\u17A2\u17B6\u17C6\u1784\u1799\u17B8"},{"id":17291,"word":"\u17A2\u17B6\u17C6\u1784\u17A1\u17BC"},{"id":17292,"word":"\u17A2\u17B6\u17C6\u1784\u17A1\u17B6\u17C6\u1784"},{"id":17293,"word":"\u17A2\u17C7 !"},{"id":17294,"word":"\u17A2\u17C7\u17A2\u17B6\u1784"},{"id":17295,"word":"\u17A2\u17D2\u1784\u17C2\u1784"},{"id":17296,"word":"\u17A2\u17D2\u1793\u1780"},{"id":17297,"word":"\u17A2\u17D2\u1793\u1780 --"},{"id":17298,"word":"\u17A2\u17D2\u1793\u1780\u1780\u1793\u17D2\u178A\u17C0\u178F"},{"id":17299,"word":"\u17A2\u17D2\u1793\u1780\u1784\u17B6\u179A"},{"id":17300,"word":"\u17A2\u17D2\u1793\u1780\u178A\u17BC\u1793"},{"id":17301,"word":"\u17A2\u17D2\u1793\u1780\u178F\u17B6"},{"id":17302,"word":"\u17A2\u17D2\u1793\u1780\u1794\u17B6\u1791"},{"id":17303,"word":"\u17A2\u17D2\u1793\u1780\u1794\u17BB\u178E\u17D2\u1799"},{"id":17304,"word":"\u17A2\u17D2\u1793\u1780\u1795\u1784"},{"id":17305,"word":"\u17A2\u17D2\u1793\u1780\u1795\u17D2\u179B\u17BC\u179C"},{"id":17306,"word":"\u17A2\u17D2\u1793\u1780\u1798\u17A0\u17B6"},{"id":17307,"word":"\u17A2\u17D2\u1793\u1780\u1798\u17BD\u1799"},{"id":17308,"word":"\u17A2\u17D2\u1793\u1780\u1799\u17BE\u1784"},{"id":17309,"word":"\u17A2\u17D2\u1793\u1780\u179F\u17B7\u179B\u17D2\u1794\u17CD"},{"id":17310,"word":"\u17A2\u17D2\u179C\u17B8"},{"id":17311,"word":"\u17A2\u17D2\u17A0 !"},{"id":17312,"word":"\u17A2\u17D2\u17A0\u17CA\u17C8 !"},{"id":17313,"word":"\u17A2\u17D2\u17A0\u17B6 !"},{"id":17314,"word":"\u17A2\u17D2\u17A0\u17B6\u17C8 !"},{"id":17315,"word":"\u17A2\u17D2\u17A0\u17B6\u17C7 !"},{"id":17316,"word":"\u17A2\u17D2\u17A0\u17B9\u17C8 !"},{"id":17317,"word":"\u17A2\u17CA\u17D2\u17A0\u200C\u17B9\u17C7 !"},{"id":17318,"word":"\u17A2\u17D2\u17A0\u17BA !"},{"id":17319,"word":"\u17A2\u17CA\u17D2\u17A0\u200C\u17BA !"},{"id":17320,"word":"\u17A2\u17D2\u17A0\u17CA\u200C\u17BA\u17CE\u17C7 !"},{"id":17321,"word":"\u17A2\u17CA\u17D2\u17A0\u17BB\u17C7"},{"id":17322,"word":"\u17A2\u17D2\u17A0\u17BC!"},{"id":17323,"word":"\u17A2\u17D2\u17A0\u17BC\u17C7 !"},{"id":17324,"word":"\u17A2\u17D2\u17A0\u17CA\u17C2\u17C8 !"},{"id":17325,"word":"\u17A2\u17D2\u17A0\u17C2\u1784"},{"id":17326,"word":"\u17A2\u17D2\u17A0\u17CA\u17C3 ?"},{"id":17327,"word":"\u17A2\u17D2\u17A0\u17C4 !"},{"id":17328,"word":"\u17A2\u17D2\u17A0\u17C4\u17C7 !"},{"id":17329,"word":"\u17A2\u17D2\u17A0\u17C7 !"}]');


const $c784a78b2f9488fa$var$LANGUAGE2 = "khmer";
const $c784a78b2f9488fa$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
const $c784a78b2f9488fa$var$bedok = (0, (/*@__PURE__*/$parcel$interopDefault($510aee62d64df3d9$exports)));
class $c784a78b2f9488fa$export$c9278f438ece890c extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.books = new (0, $643ca2f9ceb5ab8e$export$5654cbf08d7911f3)(), this.audio = null, this.transcription = null // ID
        , this.transcript = null // rename to text
        , this.text = null // TODO: later refactor as error message
        , this.editor = document.querySelector("sw-editor"), this.dictionary = document.querySelector("sw-dictionary"), this.maxPage = 0;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-reader");
        this.componentTrace.start();
        this.appendChild((0, $d5973e26da617390$export$2e2bcd8739ae039).content.cloneNode(true));
        this.editButton = this.querySelector("h3");
        this.editIcon = this.editButton.firstElementChild;
        this.admin = this.querySelector("#sw-reader-admin");
        this.khmer = this.querySelector("#sw-reader");
        this.body = this.querySelector("#sw-reader-body");
        this.body1 = this.body.firstElementChild;
        this.body2 = this.body.lastElementChild;
        this.pager = this.querySelector("#sw-reader-pager");
        this.page = this.querySelector("#sw-reader-pager-number");
        this.total = this.querySelector("#sw-reader-pager-total");
        this.increment = this.querySelector("#sw-reader-pager-increment");
        this.decrement = this.querySelector("#sw-reader-pager-decrement");
        this.meta = this.querySelector("#sw-reader-meta");
        this.gemini = this.querySelector("#sw-reader-gemini");
        this.deepseek = this.querySelector("#sw-reader-deepseek");
        this.other = this.querySelector("#sw-reader-other");
        this.google = this.querySelector("#sw-reader-google");
        this.grok = this.querySelector("#sw-reader-grok");
        this.chatgpt = this.querySelector("#sw-reader-chatgpt");
        this.tutor = this.querySelector("#sw-reader-tutor");
        this.quiz = this.querySelector("#sw-reader-quiz");
        this.dict = this.querySelector("#sw-reader-dict");
        this.dict2 = this.querySelector("#sw-reader-dict2");
        this.speak = this.querySelector("#sw-reader-speak");
        this.copy = this.querySelector("#sw-reader-copy");
        this.close = this.querySelector("#sw-reader-close");
        this.close2 = this.querySelector("#sw-reader-close2");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: ()=>{
                if (this.audio) {
                    this.audio.pause();
                    this.speak.textContent = "\uD83D\uDD08";
                }
            //window.location.hash = "#";
            },
            onShow: ()=>{
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-reader",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.khmer, modalOptions, instanceOptions);
    }
    // attribute: lang = khmer or pali
    static get observedAttributes() {
        return [
            "lang"
        ]; // List attributes you want to watch
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "lang") {
            const span = this.querySelector("#sw-reader-title");
            span.textContent = newValue === "khmer" ? $c784a78b2f9488fa$var$strings.khmer3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] : $c784a78b2f9488fa$var$strings.pali3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        }
    }
    async connectedCallback() {
        this.editButton.addEventListener("click", ()=>{
            if (this.transcription && this.heartbank.isAdmin()) {
                this.hide();
                this.editor.show(this.transcription, this.getAttribute("lang"), this.transcript, this);
            }
        });
        //deprecated
        // this.heartbank.addAuthStateListener3(() => {
        //     if (!isApple || this.heartbank.isAdmin())
        //         this.dict2.classList.remove("hidden");
        //     else this.dict2.classList.add("hidden");
        // });
        // for dad
        //this.show2(); // TODO: fix race condition
        //window.addEventListener("hashchange", this.show2.bind(this)); // weird bug: does not update; maybe race condition
        window.addEventListener("keydown", (event)=>{
            switch(event.code){
                case "F1":
                    event.preventDefault(); // stop help from showing
                    this.show2("khmer");
                    break;
                case "F2":
                    event.preventDefault();
                    this.show2("pali");
                    break;
            }
        });
        this.addPagerListeners();
        this.addListeners1();
        this.addListeners2();
        this.addListeners3();
        //this.addSpeakListener();
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    addPagerListeners() {
        this.page.addEventListener("keyup", this.userInput2.bind(this)); // keydown = character not yet detected // keypress is deprecated
        this.page.addEventListener("change", this.processInput.bind(this));
        this.increment.addEventListener("click", (event)=>this.pageTo(true));
        this.decrement.addEventListener("click", (event)=>this.pageTo(false));
    }
    renderPager() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);
        this.page.value = page.toString();
        //this.page.dataset.inputCounterMax = this.getTotal(book).toString();
        this.total.textContent = this.getTotal(book) + " " + $c784a78b2f9488fa$var$strings.total[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        this.maxPage = this.getTotal(book);
    }
    pageTo(direction) {
        const paths = window.location.hash.split("/");
        let book = parseInt(paths[2]);
        let page = parseInt(paths[4]);
        if (direction) page = page === this.getTotal(book) ? 0 : page + 1;
        else page = page === 0 ? this.getTotal(book) : page - 1;
        //window.location.hash = `/book/${book}/page/${page}`;
        window.location.setHash(book, page);
        this.renderPager();
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "page", {
            direction: direction,
            book: book,
            page: page
        });
        this.heartbank.alertAdmin(`reader/pager/${direction ? "left" : "right"}`);
    }
    userInput2(event) {
        this.page.value = (0, $b348546b86779519$export$12f43d294de01a8a)(this.page.value, this.maxPage).toString();
        //console.log(this.page.value);
        if (event.key === "Enter") this.processInput();
    }
    processInput() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(this.page.value);
        //window.location.hash = `/book/${book}/page/${isNaN(page) ? 1 : page}`;
        window.location.setHash(book, isNaN(page) ? 0 : page);
        this.renderPager();
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "page", {
            at: "input",
            book: book,
            page: page
        });
    }
    getTotal(book) {
        return Math.ceil($c784a78b2f9488fa$var$bedok[$c784a78b2f9488fa$var$LANGUAGE2].books[book - 1] / 2) - 1;
    }
    // temp for dad to quickly add
    show2(lang) {
        //await this.heartbank.waitForAuth();
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        //const page = parseInt(paths[4]);
        if (book && this.getAttribute("lang") === lang && this.transcription && this.heartbank.isAdmin()) this.editor.show(this.transcription, lang, this.transcript, this);
    }
    show() {
        this.renderPager();
        this.modal.show();
    }
    hide() {
        this.modal.hide();
    }
    formatText(text, language) {
        return text.replace(/^([^\n]*)\n\n([^\n]*)\n\n([\s\S]*)$/, `<div style="text-align:${language === "khmer" ? "right" : "left"}">$1</div>\n<div style="text-align:center;font-size:1.2em">$2</div>\n$3`).replace(/\n/g, "<br>"); //.replaceAll("\n", "<br>") for modern browser
    }
    render(language, id, date, transcript, text, hasText, audio) {
        this.transcription = id;
        this.transcript = transcript;
        this.text = text;
        if (date || this.heartbank.isAdmin()) {
            //this.body1.innerHTML = date && hasText ? text.replace(/\n/g, "<br>") : transcript ?? text;  // will show empty for english if edited until dad adds // use innerText too?
            this.body1.innerHTML = transcript ? this.formatText(transcript, language) : text;
            this.body2.innerHTML = this.body1.innerHTML;
            this.renderDictionary();
        } else {
            this.body1.innerHTML = $c784a78b2f9488fa$var$strings.transcribe4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.body2.innerHTML = this.body1.innerHTML;
        }
        if (window.location.hash.split("/")[4] === "0") {
            this.body1.classList.add("text-center");
            this.body2.classList.add("text-center");
            this.body1.classList.remove("text-justify");
            this.body2.classList.remove("text-justify");
        } else {
            this.body1.classList.remove("text-center");
            this.body2.classList.remove("text-center");
            this.body1.classList.add("text-justify");
            this.body2.classList.add("text-justify");
        }
        if (audio) {
            this.audio = new Audio();
            this.audio.src = audio;
            this.audio.load();
            this.audio.addEventListener("ended", this.addAudioListener.bind(this));
        } else this.audio = null;
        if (this.transcription && this.heartbank.isAdmin()) {
            this.editButton.classList.add("cursor-pointer");
            this.editIcon.classList.remove("hidden");
            this.admin.classList.replace("hidden", "flex");
        } else {
            this.editButton.classList.remove("cursor-pointer");
            this.editIcon.classList.add("hidden");
            this.admin.classList.replace("flex", "hidden");
        }
        this.speak.disabled = !this.transcription;
        this.dict2.disabled = !this.transcription;
        this.copy.disabled = !this.transcription;
        this.tutor.disabled = !this.transcription;
        this.quiz.disabled = !this.transcription;
        this.body1.classList.remove("hidden");
        this.body2.classList.add("hidden");
    }
    // to prevent adding multiple listeners
    addAudioListener() {
        if (this.audio) {
            this.audio.pause();
            this.speak.textContent = "\uD83D\uDD08"; //strings.speak[LANGUAGE];
        }
    }
    renderDictionary() {
        const collator = new Intl.Collator("km"); // Khmer locale
        (0, (/*@__PURE__*/$parcel$interopDefault($44e2ba6da71a247a$exports))).sort((a, b)=>{
            const lenDiff = b.word.length - a.word.length;
            return lenDiff !== 0 ? lenDiff : collator.compare(a.word, b.word);
        });
        // Initialize BreakIterator for Khmer word segmentation
        const segmenter = new Intl.Segmenter("km", {
            granularity: "word"
        });
        // Get all text nodes in body2
        const walker = document.createTreeWalker(this.body2, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        while(walker.nextNode()){
            const current = walker.currentNode;
            if (current.nodeType === Node.TEXT_NODE && current.textContent?.trim()) textNodes.push(current);
        }
        // Process each text node
        for (const textNode of textNodes){
            const text = textNode.textContent || "";
            if (!text.trim()) continue;
            // Segment text into words using BreakIterator
            const segments = [];
            let pos = 0;
            for (const { segment: segment, index: index } of segmenter.segment(text)){
                const breakPoint = index + segment.length;
                if (segment.trim()) segments.push({
                    text: segment,
                    start: pos,
                    end: breakPoint
                });
                pos = breakPoint;
            }
            // Create a document fragment to hold new nodes
            const frag = document.createDocumentFragment();
            let lastIndex = 0;
            // Check each segment for dictionary terms
            for (const segment of segments){
                // Add text before the segment if needed
                if (lastIndex < segment.start) frag.appendChild(document.createTextNode(text.slice(lastIndex, segment.start)));
                // Check if segment matches a dictionary term
                const term = (0, (/*@__PURE__*/$parcel$interopDefault($44e2ba6da71a247a$exports))).find((t)=>t.word.toLowerCase() === segment.text.toLowerCase());
                if (term) {
                    // Create a range for the matching segment
                    const range = document.createRange();
                    range.setStart(textNode, segment.start);
                    range.setEnd(textNode, segment.end);
                    // Create span element
                    const span = document.createElement("span");
                    span.className = "text-blue-500 cursor-pointer inline-block"; //underline
                    //span.style.display = "inline-block"; // Prevent breaking Khmer text
                    //span.style.cursor = "pointer"; // Indicate clickability
                    span.textContent = segment.text;
                    // Attach click event listener
                    span.onclick = ()=>{
                        this.hide();
                        this.dictionary.show(this);
                        this.dictionary.renderWord(term.word);
                    };
                    // Add span to fragment
                    frag.appendChild(span);
                } else // Add non-matching segment as plain text
                frag.appendChild(document.createTextNode(segment.text));
                lastIndex = segment.end;
            }
            // Add remaining text
            if (lastIndex < text.length) frag.appendChild(document.createTextNode(text.slice(lastIndex)));
            // Replace the original text node
            const parent = textNode.parentNode;
            if (parent) parent.replaceChild(frag, textNode);
        }
    }
    // deprecated: only works on chrome and not safari
    renderDictionary2() {
        const collator = new Intl.Collator("km"); // Khmer locale
        (0, (/*@__PURE__*/$parcel$interopDefault($44e2ba6da71a247a$exports))).sort((a, b)=>{
            const lenDiff = b.word.length - a.word.length;
            return lenDiff !== 0 ? lenDiff : collator.compare(a.word, b.word);
        });
        //let html = this.body1.innerHTML;
        // for (const term of Words) {
        //     const regex = new RegExp(term.word, "gi");
        //     html = html.replace(
        //         regex,
        //         `<span class="text-blue-500 cursor-pointer underline" onclick="">${term.word}</span>`
        //     );
        // }
        //this.body2.innerHTML = html;
        for (const term of (0, (/*@__PURE__*/$parcel$interopDefault($44e2ba6da71a247a$exports)))){
            const regex = new RegExp(term.word, "gi");
            // const regex = isApple
            //     ? new RegExp(`\\b${term.word}\\b`, "gi")
            //     : new RegExp(term.word, "gi");
            const walker = document.createTreeWalker(this.body2, NodeFilter.SHOW_TEXT);
            const textNodes = [];
            while(walker.nextNode()){
                const current = walker.currentNode;
                if (current && current.nodeType === Node.TEXT_NODE && current.textContent) textNodes.push(current);
            }
            for (const textNode of textNodes){
                const text = textNode.textContent;
                const matches = [
                    ...text.matchAll(regex)
                ];
                if (matches.length === 0) continue;
                const frag = document.createDocumentFragment();
                let lastIndex = 0;
                for (const match of matches){
                    const matchText = match[0];
                    const matchIndex = match.index;
                    // Add plain text before match
                    frag.appendChild(document.createTextNode(text.slice(lastIndex, matchIndex)));
                    // Create span element
                    const span = document.createElement("span");
                    span.className = "text-blue-500 underline"; // TODO: later set time out for cursor pointer
                    span.textContent = matchText;
                    // TODO: listen for click event at parent; set id attribute
                    span.onclick = ()=>{
                        this.hide();
                        this.dictionary.show(this);
                        this.dictionary.renderWord(matchText); // TODO: later do renderID?? need to refactor function to handle history
                    };
                    frag.appendChild(span);
                    lastIndex = matchIndex + matchText.length;
                }
                // Add remaining text
                frag.appendChild(document.createTextNode(text.slice(lastIndex)));
                // Replace the original text node
                const parent = textNode.parentNode;
                if (parent) parent.replaceChild(frag, textNode);
            }
        }
    }
    isAudioPlaying() {
        return !this.audio.paused && !this.audio.ended && this.audio.currentTime > 0;
    }
    addListeners1() {
        this.speak.addEventListener("click", async ()=>{
            if (this.audio) {
                if (this.isAudioPlaying()) {
                    this.audio.pause();
                    this.speak.textContent = "\uD83D\uDD08"; //strings.speak[LANGUAGE];
                } else {
                    this.audio.play();
                    this.speak.textContent = "\uD83D\uDD07"; //strings.stop[LANGUAGE];
                }
            } else {
                // let text;
                // try {
                //     text = await navigator.clipboard.readText();
                // } catch {
                //     text = this.transcript || "";
                // }
                const encodedText = encodeURIComponent(this.transcript || ""); //text
                const translateUrl = `https://translate.google.com/?sl=auto&tl=${$c784a78b2f9488fa$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}&text=${encodedText}&op=translate`;
                window.open(translateUrl, "_blank");
            }
        });
        this.dict2.addEventListener("click", ()=>{
            if (this.body2.classList.contains("hidden")) {
                this.body2.classList.remove("hidden");
                this.body1.classList.add("hidden");
            } else {
                this.body2.classList.add("hidden");
                this.body1.classList.remove("hidden");
            }
        });
        this.copy.addEventListener("click", async ()=>{
            if (this.transcript) {
                const paths = window.location.hash.split("/");
                const book = parseInt(paths[2]);
                const page = parseInt(paths[4]); // not used for now
                const basket = this.books.getBasket(book);
                const text = `${$c784a78b2f9488fa$var$strings.baskets3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa][basket]}: ${book.toKhmer((0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa))}\n\n${$c784a78b2f9488fa$var$strings.page[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}: ${this.transcript.replace("<hr>", "")}\n\n${window.location.href}`;
                await navigator.clipboard.writeText(text); // this.body.innerText // copy original khmer text, not english translation
                this.dispatchEvent(new CustomEvent("sw-banner", {
                    bubbles: true,
                    detail: {
                        info: $c784a78b2f9488fa$var$strings.copied2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
                    }
                }));
            } else alert($c784a78b2f9488fa$var$strings.copyError[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        });
        this.tutor.addEventListener("click", async ()=>{
            if (this.transcript) {
                await navigator.clipboard.writeText($c784a78b2f9488fa$var$strings.tutor3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + this.transcript);
                this.dispatchEvent(new CustomEvent("sw-banner", {
                    bubbles: true,
                    detail: {
                        info: $c784a78b2f9488fa$var$strings.tutor2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
                    }
                }));
            }
        });
        this.quiz.addEventListener("click", async ()=>{
            if (this.transcript) {
                await navigator.clipboard.writeText($c784a78b2f9488fa$var$strings.quiz3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa] + this.transcript);
                this.dispatchEvent(new CustomEvent("sw-banner", {
                    bubbles: true,
                    detail: {
                        info: $c784a78b2f9488fa$var$strings.quiz2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
                    }
                }));
            }
        });
        this.dict.addEventListener("click", async ()=>{
            let text;
            try {
                text = await navigator.clipboard.readText();
            } catch  {
                text = this.transcript || "";
            }
            this.hide();
            this.dictionary.show(this);
            this.dictionary.renderWord(text);
        });
        this.close.addEventListener("click", this.hide.bind(this));
        this.close2.addEventListener("click", this.hide.bind(this));
    }
    addListeners2() {
        this.google.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = `https://translate.google.com/?sl=${$c784a78b2f9488fa$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}&tl=en&op=translate`;
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
        this.chatgpt.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = "https://chat.openai.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`; // pro has string length limit
            window.open(baseUrl, "_blank");
        });
        this.grok.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = "https://grok.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
    }
    addListeners3() {
        this.deepseek.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = "https://chat.deepseek.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
        this.gemini.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = "https://gemini.google.com/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
        this.meta.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = "https://www.meta.ai/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
        this.other.addEventListener("click", async ()=>{
            // let text;
            // try {
            //     text = await navigator.clipboard.readText();
            // } catch {
            //     text = this.transcript || "";
            // }
            const baseUrl = "https://huggingface.co/chat/";
            // const encodedPrompt = encodeURIComponent(text);
            // const url = `${baseUrl}?model=gpt-4&prompt=${encodedPrompt}`;
            window.open(baseUrl, "_blank");
        });
    }
    // deprecated
    addSpeakListener() {
        this.speak.addEventListener("click", async ()=>{
            const text = await navigator.clipboard.readText();
            try {
                const response = await fetch(`${(0, $eba1d7d434ec7c0e$export$590b38c2043cf80f)}/textToSpeech?text=${encodeURIComponent(text)}`);
                const data = await response.json();
                if (response.ok) {
                    const audioUrl = URL.createObjectURL(data.blob());
                    const audio = new Audio(audioUrl);
                    audio.play();
                }
            } catch (error) {
                console.error(error.message);
            }
        });
        this.speak.addEventListener("click", async ()=>{
            const synth = window.speechSynthesis;
            if (synth.speaking) {
                synth.cancel();
                this.speak.textContent = $c784a78b2f9488fa$var$strings.speak2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            } else {
                const text = await navigator.clipboard.readText();
                const utterance = new SpeechSynthesisUtterance(text);
                const voices = synth.getVoices();
                const khmerVoice = voices.find((voice)=>voice.lang.startsWith("km"));
                if (khmerVoice) utterance.voice = khmerVoice;
                else console.warn("Khmer voice not found in Web Speech API.");
                synth.speak(utterance);
                this.speak.textContent = $c784a78b2f9488fa$var$strings.stop2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                utterance.onend = (event)=>{
                    this.speak.textContent = $c784a78b2f9488fa$var$strings.speak2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                };
            }
        });
    }
}









var $7644f73fd5ae1eca$export$2e2bcd8739ae039 = (text)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-dict"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <form
                    id="sw-dict-form"
                    class="p-4 md:p-5 flex items-center w-full">
                    <label for="sw-dict-word" class="sr-only"
                        >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).search[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</label
                    >
                    <div class="relative w-full">
                        <div
                            class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg
                                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="orange"
                                viewBox="0 0 512 512">
                                <path
                                    d="M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                            </svg>
                        </div>
                        <input
                            type="text"
                            id="sw-dict-word"
                            onblur2="heartbank.alertAdmin('dictionary/type/', this.value)"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-base rounded-lg outline-none focus:ring-0 focus:border-none focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).dict2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            autocomplete="off" />
                    </div>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).clear[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        id="sw-dict-trash"
                        onclick="heartbank.alertAdmin('dictionary/click/clear')"
                        type="button"
                        class="p-2.5 ms-2 text-sm font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        <svg
                            class="w-4 h-4"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 576 512">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M576 128c0-35.3-28.7-64-64-64L205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).clear[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).speak[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        id="sw-dict-speak"
                        onclick="heartbank.alertAdmin('dictionary/click/speak')"
                        type="button"
                        class="p-2.5 ms-2 text-sm font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        <svg
                            class="w-4 h-4"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 640 512">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352 64 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).speak[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).feedback4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        type="submit"
                        onclick2="heartbank.alertAdmin('dictionary/click/submit')"
                        class="p-2.5 ms-2 text-sm font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        <svg
                            class="w-4 h-4"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 20">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </button>
                </form>
                <!-- Modal body -->
                <div
                    id="sw-dict-definition"
                    class="battambang p-4 md:p-5 space-y-4 text-2xl leading-[2] text-gray-900 dark:text-white"></div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        id="sw-dict-back"
                        onclick="heartbank.alertAdmin('dictionary/click/back')"
                        type="button"
                        class="disabled:bg-gray-500 w-28 disabled:cursor-not-allowed text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).back[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        data-modal-hide="sw-dict"
                        type="button"
                        class="ms-3 text-white w-28 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;








const $dc9b984fc0032cbc$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
const $dc9b984fc0032cbc$var$words = (0, (/*@__PURE__*/$parcel$interopDefault($44e2ba6da71a247a$exports)));
class $dc9b984fc0032cbc$export$38dbeb54cc1b781c extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.SwReader = null;
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-dictionary");
        this.componentTrace.start();
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $7644f73fd5ae1eca$export$2e2bcd8739ae039)(null), this);
        this.dict = this.querySelector("#sw-dict");
        this.definition = this.querySelector("#sw-dict-definition");
        this.form = this.querySelector("#sw-dict-form");
        this.word = this.querySelector("#sw-dict-word");
        this.trash = this.querySelector("#sw-dict-trash");
        this.speak = this.querySelector("#sw-dict-speak");
        this.back = this.querySelector("#sw-dict-back");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: ()=>{
                this.SwReader?.show();
            //window.location.hash = "#";
            },
            onShow: ()=>{
                this.dict.style.zIndex = "70";
                this.word.focus();
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-dict",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.dict, modalOptions, instanceOptions);
    }
    connectedCallback() {
        this.form.addEventListener("submit", (event)=>{
            event.preventDefault();
            this.renderWord(this.word.value);
        });
        this.word.addEventListener("keyup", (event)=>{
            if (event.key !== "Enter") {
                const results = $dc9b984fc0032cbc$var$words.filter((entry)=>entry.word.includes(this.word.value));
                if (this.word.value === "") this.definition.textContent = $dc9b984fc0032cbc$var$strings.search2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                else if (results.length === 0) this.definition.textContent = $dc9b984fc0032cbc$var$strings.search3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
                else {
                    const ol = document.createElement("ol");
                    results.slice(0, 10).forEach((result)=>{
                        const li = document.createElement("li");
                        li.textContent = "\uD83D\uDCD6 " + result.word;
                        li.onclick = ()=>this.renderWord(result.word);
                        ol.appendChild(li);
                    });
                    this.definition.textContent = "";
                    this.definition.appendChild(ol);
                }
            }
        });
        this.trash.addEventListener("click", (event)=>{
            this.definition.textContent = $dc9b984fc0032cbc$var$strings.search2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            this.word.value = "";
            this.word.focus();
        });
        this.speak.addEventListener("click", (event)=>{
            const baseUrl = "https://translate.google.com/";
            const params = new URLSearchParams({
                sl: $dc9b984fc0032cbc$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa],
                tl: "en",
                text: this.word.value,
                op: "translate"
            });
            // const params = new URLSearchParams({
            //     ie: "UTF-8",
            //     tl: "km",
            //     q: this.word.value,
            //     client: "tw-ob"
            // });
            window.open(`${baseUrl}?${params.toString()}`, "_blank");
        });
        this.back.addEventListener("click", (event)=>{
            this.definition.style.opacity = "0.2";
            const history = JSON.parse(localStorage.getItem("history"));
            if (history.length === 1) {
                this.definition.innerHTML = history[0].definition;
                this.word.value = history[0].word;
            } else {
                history.pop();
                const entry = history[history.length - 1];
                this.definition.innerHTML = entry.definition;
                this.word.value = entry.word;
                localStorage.setItem("history", JSON.stringify(history));
            }
            this.addListeners();
            this.back.disabled = history.length == 1;
            this.definition.style.opacity = "1";
            if (history.length === 1) this.back.classList.add("hidden");
            else this.back.classList.remove("hidden");
        });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    show(modal = null) {
        this.SwReader = modal;
        this.modal.show();
    }
    hide() {
        this.modal.hide();
    }
    async renderId(id) {
        this.definition.style.opacity = "0.2";
        const dictionary = await fetch(`https://raw.githubusercontent.com/SiliconWat/khmer.siliconwat.dev/main/id/${id}.json`);
        const entry = await dictionary.json();
        this.definition.innerHTML = entry.definition;
        this.word.value = entry.word;
        this.addListeners();
        this.definition.style.opacity = "1";
        const history = JSON.parse(localStorage.getItem("history"));
        history.push(entry);
        localStorage.setItem("history", JSON.stringify(history));
        this.back.disabled = false;
        this.back.classList.remove("hidden");
        this.heartbank.alertAdmin("dictionary/click/", this.word.value);
    }
    async renderWord(word) {
        this.definition.style.opacity = "0.2";
        if (word === "") {
            this.definition.textContent = $dc9b984fc0032cbc$var$strings.search2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
            setTimeout(()=>this.word.focus(), 500);
        } else try {
            const dictionary = await fetch(`https://raw.githubusercontent.com/SiliconWat/khmer.siliconwat.dev/main/word/${encodeURIComponent(word)}.json`);
            const entry = await dictionary.json();
            this.definition.innerHTML = entry.definition;
            this.addListeners();
            localStorage.setItem("history", JSON.stringify([
                entry
            ]));
        } catch  {
            this.definition.textContent = $dc9b984fc0032cbc$var$strings.search4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        } finally{
            this.word.value = word;
            this.back.disabled = true;
            this.back.classList.add("hidden");
        }
        this.definition.style.opacity = "1";
        this.heartbank.alertAdmin("dictionary/submit/", word);
    }
    // TODO: add listener at parent level instead of onclick
    addListeners() {
        this.definition.querySelectorAll("span[data-word]").forEach((element)=>{
            const span = element;
            span.onclick = ()=>this.renderId(span.dataset.word);
        });
    }
}










const $265776b784f4441b$var$template = document.createElement("template");
$265776b784f4441b$var$template.innerHTML = (0, $eba1d7d434ec7c0e$export$c0bb0b647f701bb5)`
    <sw-home class="hidden py-[72px]"></sw-home>
    <sw-page class="hidden py-[72px] touch-zoom"></sw-page>
    <sw-map class="hidden w-full h-full"></sw-map>
`;
var $265776b784f4441b$export$2e2bcd8739ae039 = $265776b784f4441b$var$template;




//import { MINOR_VERSION } from "../../sw.ts";
const $adcf891bd460add8$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $adcf891bd460add8$export$972fcb480babb1c extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.header = document.querySelector("sw-header"), this.footer = document.querySelector("sw-footer");
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-main");
        this.componentTrace.start();
        this.appendChild((0, $265776b784f4441b$export$2e2bcd8739ae039).content.cloneNode(true));
        this.home = this.querySelector("sw-home");
        this.page = this.querySelector("sw-page");
        this.map = this.querySelector("sw-map");
    }
    connectedCallback() {
        const minor = document.querySelector('meta[name="minor"]');
        // always on bc not sure; maybe can move and do if user cancel update
        minor.getAttribute("content"), localStorage.getItem("updateAvailable");
        setInterval(()=>{
            if (localStorage.getItem("updateAvailable")) this.showUpdatePrompt();
        }, (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) ? 3600000 : 3000); // 1 hour
        navigator.serviceWorker.addEventListener("message", (event)=>{
            if (minor.getAttribute("content") !== event.data.version // MINOR_VERSION doesn't work
            ) {
                if (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) {
                    localStorage.setItem("updateAvailable", event.data.version);
                    this.showUpdatePrompt();
                }
            }
        });
        // window.addEventListener("resize", () => {
        //     this.style.touchAction =
        //         window.visualViewport?.scale !== 1 ? "auto" : "pinch-zoom";
        // });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    // might not be necessary bc browser does it automatically
    //TODO: later use flowbite dialogue? // confirm is cool bc it interrupts the user!
    async showUpdatePrompt() {
        const userResponse = confirm($adcf891bd460add8$var$strings.refresh[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        if (userResponse) {
            document.body.style.visibility = "invisible";
            localStorage.removeItem("updateAvailable");
            await this.unregisterAllServiceWorkers();
            window.location.reload(); //TODO: check bc might be redundant bc browser auto refresh ?
        }
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "update", {
            response: userResponse
        });
    }
    async unregisterAllServiceWorkers() {
        if ("serviceWorker" in navigator) try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (const registration of registrations){
                const success = await registration.unregister();
                if (success) console.warn("Service worker unregistered.");
                else console.error("Failed to unregister the service worker.");
            }
        } catch (error) {
            console.error("Error fetching service worker registrations: ", error);
        }
        else console.warn("Service workers are not supported in this browser.");
    }
    // TODO: show some views on the current page without going to the home page
    homeTo(view) {
        this.header.show();
        this.footer.show();
        switch(view){
            case "#ai":
                this.showHome();
                this.soon();
                break;
            case "#333":
                this.showMap();
                this.soon();
                break;
            case "#heartbank":
                this.showHome();
                break;
            case "#readership":
                this.showMap();
                break;
            case "#share":
                this.showHome(true);
                break;
            default:
                if (this.heartbank.user) this.showMap();
                else this.showHome();
        }
    //window.addEventListener("keydown", this.toggleFullScreen.bind(this));
    }
    showHome(scroll = false) {
        this.header.showHome();
        this.footer.showHome();
        this.home.show();
        this.page.hide();
        this.map.hide();
        this.home.play();
        if (scroll) {
            const target = document.getElementById("scroll-to-here");
            this.home.scrollTo({
                top: target.offsetTop,
                behavior: "smooth"
            });
        } else this.home.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    showMap() {
        this.header.showMap(); // default map view = now
        this.footer.showMap();
        this.home.hide();
        this.page.hide();
        this.map.show();
        this.home.pause();
    }
    // showPage
    pageTo(book, page) {
        this.header.showPage();
        this.footer.showPage();
        //this.header.show();
        //this.footer.show();
        this.page.show();
        this.home.hide();
        this.map.hide();
        this.home.pause();
        this.page.goTo(book, page);
    //window.removeEventListener("keydown", this.toggleFullScreen.bind(this));
    }
    // weird bug in desktop
    toggleFullScreen(event) {
        if (event.code === "Space" || event.key === " ") {
            if (this.header.classList.contains("hidden")) {
                this.header.show();
                this.footer.show();
            } else {
                this.header.hide();
                this.footer.hide();
            }
            // prevent scrolling if needed
            event.preventDefault();
        }
    }
    soon() {
        this.dispatchEvent(new CustomEvent("sw-banner", {
            bubbles: true,
            detail: {
                info: $adcf891bd460add8$var$strings.soon[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
            }
        }));
    }
}










const $13d1334ead617d30$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $13d1334ead617d30$export$79bfef730f2f3bd0 extends HTMLBodyElement {
    constructor(){
        super(), this.bookmarks = new (0, $d181ac6e59b5bb21$export$8c14ec2509ec1ea5)();
        this.componentTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "component");
        this.componentTrace.putAttribute("view", "sw-bedok");
        this.componentTrace.start();
        this.drawer = this.querySelector("#sw-menu-hide");
        this.header = this.querySelector("sw-header");
        this.main = this.querySelector("sw-main");
        this.footer = this.querySelector("sw-footer");
        this.banner = this.querySelector("sw-banner");
        this.alert = this.querySelector("sw-alert");
        this.targetNode = document.documentElement;
        this.observer = new MutationObserver(this.handleMutations.bind(this));
    }
    connectedCallback() {
        this.updateLanguage();
        this.updateView();
        this.addListeners();
        this.startObserving();
        if ("serviceWorker" in navigator) navigator.serviceWorker.addEventListener("message", (event)=>{
            //console.log(event.data);
            if (event.data.action === "deeplink") {
                const { url: url } = event.data;
                window.location.href = url;
            }
        });
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }
    updateLanguage() {
        // const language = localStorage.getItem("language");
        // if (language === null) {
        //     localStorage.setItem("language", "khmer");
        // }
        const major = document.querySelector('meta[name="major"]');
        major.setAttribute("content", (0, $8f13b60c0ee5b277$exports.version).toString());
        const minor = document.querySelector('meta[name="minor"]');
        minor.setAttribute("content", (0, $0469388547a65161$export$12f929bcf20d6190));
        const description = document.querySelector('meta[name="description"]');
        description.setAttribute("content", $13d1334ead617d30$var$strings.hero2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        document.title = $13d1334ead617d30$var$strings.title2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
        document.documentElement.lang = $13d1334ead617d30$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa];
    }
    addListeners() {
        window.addEventListener("popstate", this.updateView.bind(this));
        this.addEventListener("sw-banner", (event)=>{
            const customEvent = event;
            this.banner.showBanner(customEvent.detail.info, customEvent.detail.reload || false);
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "banner", {
                info: customEvent.detail.info,
                reload: customEvent.detail.reload || false
            });
        });
        this.addEventListener("sw-alert", (event)=>{
            const customEvent = event;
            this.alert.showBanner(customEvent.detail.info, customEvent.detail.reload || false);
            (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "alert", {
                info: customEvent.detail.info,
                reload: customEvent.detail.reload || false
            });
        });
    }
    async updateView() {
        const paths = window.location.hash.split("/");
        if (paths[2] !== undefined && paths[4] !== undefined) {
            const book = parseInt(paths[2]);
            const page = parseInt(paths[4]);
            this.drawer.click();
            this.main.pageTo(book, page);
        // window.scrollTo({
        //     top: 0,
        //     behavior: "smooth"
        // });
        } else if (paths[2] !== undefined) {
            const book = parseInt(paths[2]);
            const page = await this.bookmarks.get(book) || 0;
            //window.location.hash = `/book/${book}/page/${page}`;
            window.location.setHash(book, page);
        } else {
            const bookmark = await this.bookmarks.getRecent();
            if (window.location.hash === "#bookmark") {
                if (bookmark) window.location.setHash(bookmark.book, bookmark.page);
                else window.location.setHash(1, 0);
            } else {
                this.drawer.click();
                this.main.homeTo(window.location.hash);
            }
        }
        (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "hash", {
            hash: window.location.hash
        });
    //this.heartbank.alertAdmin("page/visit");
    }
    startObserving() {
        this.observer.observe(this.targetNode, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
    //console.log("Started observing for class changes.");
    }
    stopObserving() {
        this.observer.disconnect();
    //console.warn("Stopped observing for class changes.");
    }
    handleMutations(mutationsList) {
        for (const mutation of mutationsList)if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const paths = window.location.hash.split("/");
            if (paths[2] !== undefined && paths[4] !== undefined) {
                const book = parseInt(paths[2]);
                const page = parseInt(paths[4]);
                this.main.pageTo(book, page);
            }
        }
    }
}







var $4610c7bf321b9dd3$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-code"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-gray-200 rounded-lg shadow-sm dark:bg-gray-500">
                <!-- Modal header -->
                <div class="flex items-start justify-between p-4 md:p-5">
                    <picture
                        onclick="heartbank.alertAdmin('qrcode/click/qr-code')"
                        class="relative ml-[-10%] mb-[-19%] mt-[3%] inline-block w-full">
                        <svg
                            class="block fill-hb"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        <img
                            id="sw-code-qr"
                            alt="qr code"
                            class="absolute w-[43%] ml-[-3%] mt-[3%] top-1/2 left-1/2 -rotate-90 transform -translate-x-1/2 -translate-y-1/2" />
                    </picture>
                    <button
                        title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-code">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <!-- Modal footer -->
                <div class="items-center justify-around p-4 md:p-5">
                    <button
                        id="sw-code-button"
                        onclick="heartbank.alertAdmin('qrcode/click/copy')"
                        type="button"
                        class="w-full text-white bg-theme hover:bg-theme focus:ring-4 focus:outline-none focus:ring-theme font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme dark:focus:ring-theme">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).code2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;








const $a80f6a65a625067d$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $a80f6a65a625067d$export$f02dfeb2e39b5873 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.link = "";
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $4610c7bf321b9dd3$export$2e2bcd8739ae039)(null), this);
        this.code = this.querySelector("#sw-code");
        this.picture = this.querySelector("picture");
        this.img = this.querySelector("#sw-code-qr");
        this.button = this.querySelector("#sw-code-button");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: ()=>{
            //window.location.hash = "#";
            },
            onShow: ()=>{
                this.code.style.zIndex = "70";
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-code",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.code, modalOptions, instanceOptions);
    }
    connectedCallback() {
        this.picture.addEventListener("click", this.copyLink.bind(this));
        this.button.addEventListener("click", this.copyLink.bind(this));
    }
    async copyLink() {
        await navigator.clipboard.writeText(this.link);
        this.dispatchEvent(new CustomEvent("sw-banner", {
            bubbles: true,
            detail: {
                info: $a80f6a65a625067d$var$strings.code[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]
            }
        }));
    }
    //TODO: later distinguish between agent link and profile page; for now just show agent link only
    show(action = "") {
        this.link = (0, $eba1d7d434ec7c0e$export$76f2fb31d8fa450a) + `/?lang=${$a80f6a65a625067d$var$strings.language[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}&origin=${this.heartbank.isRunningAsPWA() ? "pwa" : "web"}#/carnelian/id/${action}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toDataURL(this.link, {
            width: 1000,
            errorCorrectionLevel: "H",
            type: "image/png",
            margin: 0,
            color: {
                dark: "#fff",
                light: "#0000"
            }
        }, (error, url)=>{
            if (error) {
                console.error("Error generating QR Code:", error);
                this.hide();
            } else {
                this.img.src = url;
                this.modal.show();
            }
        });
    }
    hide() {
        this.modal.hide();
    }
}







var $0e629444d0a40950$export$2e2bcd8739ae039 = (user)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
    <div
        id="sw-share"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-2xl font-semibold text-orange-500">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).gift[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </h3>
                    <aside>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).copyall[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}}"
                            onclick="heartbank.alertAdmin('share/copy-all')"
                            id="sw-share-copy-all"
                            class="mr-3">
                            📑
                        </button>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            type="button"
                            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="sw-share">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only"
                                >${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).close[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}</span
                            >
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <div class="col-span-2 p-5 pb-10">
                    <p
                        id="sw-share-page"
                        class="mt-4 mb-1 text-xl text-gray-900 dark:text-white max-h-56 overflow-y-auto overflow-x-hidden"></p>
                    <br />
                    <section class="relative">
                        <textarea
                            id="sw-share-selection"
                            onblur="heartbank.alertAdmin('share/type/', this.value)"
                            rows="4"
                            class="block p-2.5 w-full h-40 text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"></textarea>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            onclick="heartbank.alertAdmin('share/paste')"
                            class="absolute -bottom-8 left-2"
                            type="button"
                            id="sw-share-paste">
                            📋
                        </button>
                        <button
                            title="${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}"
                            onclick="heartbank.alertAdmin('share/clear')"
                            class="absolute -bottom-8 right-2"
                            type="button"
                            id="sw-share-clear">
                            🗑️
                        </button>
                    </section>
                </div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        onclick="heartbank.alertAdmin('share/submit')"
                        id="sw-share-submit"
                        type="button"
                        class="text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select3[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        onclick="heartbank.alertAdmin('share/copy')"
                        id="sw-share-copy"
                        type="button"
                        class="text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select4[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                    <button
                        data-modal-hide="sw-share"
                        class="hidden text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${(0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports))).select5[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;







const $b74a7ec1dc9b3803$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
class $b74a7ec1dc9b3803$export$3691ac06c504c66 extends HTMLElement {
    constructor(){
        super(), this.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)(), this.subtitle = "", this.text = "", this.url = "", this.files = [];
        (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)((0, $0e629444d0a40950$export$2e2bcd8739ae039)(null), this);
        this.share = this.querySelector("#sw-share");
        this.page = this.querySelector("#sw-share-page");
        this.selection = this.querySelector("#sw-share-selection");
        this.submit = this.querySelector("#sw-share-submit");
        this.copy = this.querySelector("#sw-share-copy");
        this.paste = this.querySelector("#sw-share-paste");
        this.clear = this.querySelector("#sw-share-clear");
        this.copyAll = this.querySelector("#sw-share-copy-all");
        const modalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: ()=>{
            //window.location.hash = "#";
            },
            onShow: ()=>{
                this.share.style.zIndex = "70";
            //console.log("modal is shown");
            },
            onToggle: ()=>{
            //console.log("modal has been toggled");
            }
        };
        // instance options object
        const instanceOptions = {
            id: "sw-share",
            override: true
        };
        this.modal = new (0, $e50395cbfc69fa09$export$2e2bcd8739ae039)(this.share, modalOptions, instanceOptions);
    }
    connectedCallback() {
        this.submit.addEventListener("click", async ()=>{
            this.shares(this.subtitle, this.selection.value.trim() ? this.selection.value.trim() + ((0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? "" : "\n") : "", this.url, [] // this.file ? [this.file] : []
            );
        });
        this.copyAll.addEventListener("click", async ()=>{
            await navigator.clipboard.writeText(this.text);
            alert($b74a7ec1dc9b3803$var$strings.select2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        });
        this.copy.addEventListener("click", async ()=>{
            const text = this.selection.value.trim() ? this.selection.value.trim() + "\n\n" + this.url : this.url;
            await navigator.clipboard.writeText(text); // cannot do link first bc werid bug
            alert($b74a7ec1dc9b3803$var$strings.select2[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
        });
        this.paste.addEventListener("click", async ()=>{
            if (confirm($b74a7ec1dc9b3803$var$strings.select7[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) this.selection.value = await navigator.clipboard.readText();
        });
        this.clear.addEventListener("click", ()=>{
            if (confirm($b74a7ec1dc9b3803$var$strings.select6[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa])) this.selection.value = "";
        });
    }
    show(title, text, url, files) {
        this.subtitle = title;
        this.text = title + "\n\n" + text.replace("<hr>", "");
        this.page.innerHTML = title + "<br><br>" + text.replaceAll("\n", "<br>");
        this.url = url;
        this.files = files;
        this.modal.show();
    }
    hide() {
        this.modal.hide();
    }
    async shares(title, text, url, files) {
        const shareData = {
            title: title,
            text: text,
            url: url,
            files: (0, $eba1d7d434ec7c0e$export$5231b1f790f5c149) ? files : [] // for andoid, show file but won't show text or url
        };
        if (navigator.canShare && navigator.canShare(shareData)) try {
            await navigator.share(shareData);
            console.log("Data shared successfully");
        } catch (error) {
            if (error.name === "AbortError" || error.name === "InvalidStateError") console.warn("Sharing was cancelled: ", error);
            else {
                console.error("Error sharing files: ", error);
                alert($b74a7ec1dc9b3803$var$strings.shareError[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
            }
        }
        else alert($b74a7ec1dc9b3803$var$strings.shareError[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]);
    }
}


//import "flowbite"; //TODO: refactor out to import components individually
customElements.define("sw-map", (0, $72bce429f9a506ac$export$5cbcce5f0320f87));
customElements.define("sw-home", (0, $c06dc2a2e0117a65$export$4e7696eb07d1630e));
customElements.define("sw-reader", (0, $c784a78b2f9488fa$export$c9278f438ece890c));
customElements.define("sw-dictionary", (0, $dc9b984fc0032cbc$export$38dbeb54cc1b781c));
customElements.define("sw-main", (0, $adcf891bd460add8$export$972fcb480babb1c));
customElements.define("sw-popup", (0, $87798d7d101b1927$export$66fda3396a23c781));
customElements.define("sw-alert", (0, $baf38953c49a7eef$export$f3ec452615fb1571));
customElements.define("sw-donate", (0, $bcab9eb2e463f54c$export$fb80907d5f96b687));
customElements.define("sw-feedback", (0, $536d7d7d446657e2$export$2c79bf125ef15ed1));
customElements.define("sw-movie", (0, $4499829d9d33c525$export$595d4e8fc120612e));
customElements.define("sw-footer", (0, $329112fc103c3dc3$export$ed61263647200ec7));
customElements.define("sw-share", (0, $b74a7ec1dc9b3803$export$3691ac06c504c66));
customElements.define("sw-code", (0, $a80f6a65a625067d$export$f02dfeb2e39b5873));
customElements.define("sw-banner", (0, $5eca04e5eacb5938$export$71e4acf879c0e3dd));
customElements.define("sw-menu", (0, $4764227dda88382b$export$7ca2f8a6c7ce8f25));
customElements.define("sw-toc", (0, $b77c0c788573c6f1$export$d2ec588b75840eb2));
customElements.define("sw-editor", (0, $41778cbaafe474f6$export$e3fc611701aa4042));
//order is important!!! TODO: refactor move to class like hb apps
customElements.define("sw-header", (0, $731ff9b2771f6dab$export$3135a074e4cf1c06));
customElements.define("sw-page", (0, $b03e5dce378954b0$export$6443b622435b2ace));
customElements.define("sw-bedok", (0, $13d1334ead617d30$export$79bfef730f2f3bd0), {
    extends: "body"
});
(0, $0d15f034d14801d0$export$d0e176862bf869b8)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), {
    membership_tier: "basic"
});
const $b4e14b6b8da86996$var$pageLoadTrace = (0, $5d460bce9481376e$export$357889f174732d38)((0, $9d0840e0f81e5cfa$export$f2d2284f5fec51f8), "sw-bedok");
//pageLoadTrace.putAttribute("view", "sw-bedok");
$b4e14b6b8da86996$var$pageLoadTrace.start();
const $b4e14b6b8da86996$var$strings = (0, (/*@__PURE__*/$parcel$interopDefault($cf95765ca3532985$exports)));
window.heartbank = new (0, $ccee3b3c3507a45f$export$cbd2b34bff1227b0)();
window.vault = (page)=>{
    //const thank = document.querySelector("sw-feedback") as SwFeedback;
    const popup = document.querySelector("sw-popup");
    switch(page){
        case "login":
            //thank.show();
            if (!window.heartbank.user) popup.openVault("login");
            break;
        case "logout":
            if (confirm($b4e14b6b8da86996$var$strings.map19[0, $eba1d7d434ec7c0e$export$a24496dc2b29f9aa]) && window.heartbank.user) popup.openVault("logout");
            break;
        case "humanity":
            if (window.heartbank.user) popup.openVault("humanity"); // humanity/silver
            break;
        case "passkeys":
            if (window.heartbank.user) popup.openVault("lockbox");
            break;
    }
    window.heartbank.alertAdmin("map/profile/click/", page);
};
window.addEventListener("load", ()=>{
    (0, $0d15f034d14801d0$export$5e9eec8001665ac5)((0, $9d0840e0f81e5cfa$export$71a493436f9bccb6), "app_open");
    if (0, $eba1d7d434ec7c0e$export$f15d00aa73aafac4) $b4e14b6b8da86996$var$registerServiceWorker();
//registerServiceWorker(); // for testin
});
document.addEventListener("DOMContentLoaded", ()=>{
    if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
        const script = document.createElement("script");
        script.defer = true;
        script.src = "https://static.cloudflareinsights.com/beacon.min.js";
        script.setAttribute("data-cf-beacon", '{"token": "67c4db43f5f04360be914f2ee3f0137a"}');
        document.head.appendChild(script);
    }
    // const browser = Bowser.getParser(window.navigator.userAgent);
    // const browserName = browser.getBrowserName();
    // const browserVersion = parseFloat(browser.getBrowserVersion() || "0");
    // if (browserName === "Chrome") {
    //     if (browserVersion < 54)
    //         alert(
    //             "Chrome version 54 or above is required. Please upgrade and try again."
    //         );
    // }
    // if (browserName === "Safari") {
    //     if (browserVersion < 10.1)
    //         alert(
    //             "Safari version 10.1 or above is required. Please upgrade and try again."
    //         );
    // }
    // const dictionaries = new Dictionaries();
    // await dictionaries.loadDictionary();
    document.body.style.visibility = "visible";
    $b4e14b6b8da86996$var$pageLoadTrace.incrementMetric("count", 1);
    $b4e14b6b8da86996$var$pageLoadTrace.stop();
});
var $5cccb5591bb3b1ca$exports = {};
$5cccb5591bb3b1ca$exports = new URL("sw.js", import.meta.url).toString();


function $b4e14b6b8da86996$var$registerServiceWorker() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.register($5cccb5591bb3b1ca$exports, {
        scope: "/"
    }).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker) installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") navigator.serviceWorker.controller;
            };
        };
        registration.update(); //force update when new version is available bc pwa home app
        console.log("Service Worker registered with scope: ", registration.scope);
    }).catch((error)=>{
        console.error("Service Worker registration failed: ", error);
    });
}


//# sourceMappingURL=index.3cdbb939.js.map
